(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree41b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree41b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kOgzt", function(module, exports) {
$parcel$export(module.exports, "b64_decode", () => (parcelRequire("77crt")).b64_decode);
$parcel$export(module.exports, "getColorHexValue", () => (parcelRequire("3IaSv")).getColorHexValue);
$parcel$export(module.exports, "getAllCookies", () => (parcelRequire("ceOOn")).getAllCookies);
$parcel$export(module.exports, "elementReady", () => (parcelRequire("a3TA1")).elementReady);
$parcel$export(module.exports, "addWindowResizeEvent", () => (parcelRequire("6oLIz")).addWindowResizeEvent);
$parcel$export(module.exports, "addWindowScrollEvent", () => (parcelRequire("6oLIz")).addWindowScrollEvent);
$parcel$export(module.exports, "getReCAPTCHAResponse", () => (parcelRequire("isKkJ")).getReCAPTCHAResponse);
$parcel$export(module.exports, "slideDown", () => (parcelRequire("h30hJ")).slideDown);
$parcel$export(module.exports, "slideUp", () => (parcelRequire("h30hJ")).slideUp);
$parcel$export(module.exports, "scrollToElement", () => (parcelRequire("jWfAU")).scrollToElement);
$parcel$export(module.exports, "getThemeData", () => (parcelRequire("6sEQA")).getThemeData);
$parcel$export(module.exports, "waitForElement", () => (parcelRequire("hxRak")).waitForElement);
parcelRequire("77crt");
parcelRequire("3IaSv");
parcelRequire("ceOOn");
parcelRequire("a3TA1");
parcelRequire("6oLIz");
parcelRequire("isKkJ");
parcelRequire("h30hJ");
parcelRequire("jWfAU");
parcelRequire("6sEQA");
parcelRequire("hxRak");

});
parcelRegister("77crt", function(module, exports) {

$parcel$export(module.exports, "b64_decode", () => $52e2d69231a1aae4$export$bf9d481ba07b53f9);
const $52e2d69231a1aae4$export$3c2a198a9c1ae5f3 = (string)=>{
    return window.btoa(unescape(encodeURIComponent(string)));
};
const $52e2d69231a1aae4$export$bf9d481ba07b53f9 = (string)=>{
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("3IaSv", function(module, exports) {

$parcel$export(module.exports, "getColorHexValue", () => $2b3deb4eff4b3150$export$be9603b40fb67b4a);

var $b8TNY = parcelRequire("b8TNY");
const $2b3deb4eff4b3150$export$be9603b40fb67b4a = (id, opacity = 1, useTransparency = false)=>{
    const bodyColorValue = getComputedStyle(document.body).getPropertyValue(`--color-body`);
    const baseColorValue = getComputedStyle(document.body).getPropertyValue(`--color-${id}`);
    if (useTransparency) return (0, $b8TNY.default)(baseColorValue).alpha(opacity).hex();
    else return (0, $b8TNY.default)(baseColorValue).mix(bodyColorValue, 1 - opacity).hex();
};

});
parcelRegister("b8TNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $81cbbacd84e74401$export$2e2bcd8739ae039);
// feel free to comment out anything to rollup
// a smaller chroma.js bundle

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("cF22K");
parcelRequire("iygXn");
parcelRequire("QEjK4");
parcelRequire("kytU9");
parcelRequire("kn0Pa");
parcelRequire("hDPZe");
parcelRequire("eDzBg");
parcelRequire("7pAyc");
parcelRequire("kXega");
parcelRequire("8P76D");
parcelRequire("bEZjX");
parcelRequire("jywIV");
parcelRequire("4Zhp6");
parcelRequire("kMTGA");
parcelRequire("dkzY3");
parcelRequire("gac9F");
parcelRequire("fWmFX");
parcelRequire("3s82t");
parcelRequire("75dqB");
parcelRequire("2ISBM");
parcelRequire("52gBS");
parcelRequire("3wKag");

var $8UmTp = parcelRequire("8UmTp");

var $9u72g = parcelRequire("9u72g");

var $hKhjA = parcelRequire("hKhjA");

var $jpCQy = parcelRequire("jpCQy");

var $dvq8W = parcelRequire("dvq8W");

var $eIGWI = parcelRequire("eIGWI");

var $4ZQS0 = parcelRequire("4ZQS0");

var $cgHIr = parcelRequire("cgHIr");

var $5BDZu = parcelRequire("5BDZu");

var $iM4ga = parcelRequire("iM4ga");

var $xkLDw = parcelRequire("xkLDw");

var $iB6ta = parcelRequire("iB6ta");

var $dID0y = parcelRequire("dID0y");

var $lT4NS = parcelRequire("lT4NS");

var $1vtEw = parcelRequire("1vtEw");

var $2LSBy = parcelRequire("2LSBy");

var $6Sny4 = parcelRequire("6Sny4");

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("7hd9c");
parcelRequire("cIiSk");
parcelRequire("kBR14");
parcelRequire("hskHC");
parcelRequire("bmZFS");
parcelRequire("2yZD4");
parcelRequire("fbI2I");
parcelRequire("7Z9E2");
parcelRequire("996dd");
parcelRequire("getAx");
parcelRequire("eSrDz");
parcelRequire("ayOPU");
parcelRequire("i89Hq");
parcelRequire("j6weT");
parcelRequire("35MHU");
Object.assign((0, $gaK1V.default), {
    analyze: $cgHIr.analyze,
    average: $8UmTp.default,
    bezier: $9u72g.default,
    blend: $hKhjA.default,
    brewer: $6Sny4.default,
    Color: $e7KSJ.default,
    colors: $2LSBy.default,
    contrast: $5BDZu.default,
    contrastAPCA: $iM4ga.default,
    cubehelix: $jpCQy.default,
    deltaE: $xkLDw.default,
    distance: $iB6ta.default,
    input: $lT4NS.default,
    interpolate: (0, $dvq8W.default),
    limits: $cgHIr.limits,
    mix: $dvq8W.default,
    random: $eIGWI.default,
    scale: $4ZQS0.default,
    scales: $1vtEw.default,
    valid: $dID0y.default
});
var $81cbbacd84e74401$export$2e2bcd8739ae039 = (0, $gaK1V.default);

});
parcelRegister("gaK1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc61491d55326ff6$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $6QlZc = parcelRequire("6QlZc");
const $bc61491d55326ff6$var$chroma = (...args)=>{
    return new (0, $e7KSJ.default)(...args);
};
$bc61491d55326ff6$var$chroma.version = (0, $6QlZc.version);
var $bc61491d55326ff6$export$2e2bcd8739ae039 = $bc61491d55326ff6$var$chroma;

});
parcelRegister("e7KSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48615e4fc00386b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $7ElX1 = parcelRequire("7ElX1");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");
class $a48615e4fc00386b$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $hMEmV.default)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $7ElX1.default)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $lT4NS.default).sorted) {
                (0, $lT4NS.default).autodetect = (0, $lT4NS.default).autodetect.sort((a, b)=>b.p - a.p);
                (0, $lT4NS.default).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $lT4NS.default).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $lT4NS.default).format[mode]) {
            const rgb = (0, $lT4NS.default).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $8TO5X.default)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $hMEmV.default)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $a48615e4fc00386b$export$2e2bcd8739ae039 = $a48615e4fc00386b$var$Color;

});
parcelRegister("i4gda", function(module, exports) {

$parcel$export(module.exports, "min", () => $0364fc9895a99d2c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $0364fc9895a99d2c$export$8960430cfd85939f);
$parcel$export(module.exports, "rnd2", () => $0364fc9895a99d2c$export$c6d486233e29f7d1);
$parcel$export(module.exports, "rnd3", () => $0364fc9895a99d2c$export$6ed426801b9660b8);
$parcel$export(module.exports, "TWOPI", () => $0364fc9895a99d2c$export$af54f71c879f5ba9);
$parcel$export(module.exports, "PITHIRD", () => $0364fc9895a99d2c$export$e734282486210baf);
$parcel$export(module.exports, "DEG2RAD", () => $0364fc9895a99d2c$export$460c4029b1a54a2e);
$parcel$export(module.exports, "RAD2DEG", () => $0364fc9895a99d2c$export$914076c8150813e5);
$parcel$export(module.exports, "reverse3", () => $0364fc9895a99d2c$export$d0e1128e52417073);
$parcel$export(module.exports, "clip_rgb", () => (parcelRequire("8TO5X")).default);
$parcel$export(module.exports, "limit", () => (parcelRequire("gb2Ug")).default);
$parcel$export(module.exports, "type", () => (parcelRequire("hMEmV")).default);
$parcel$export(module.exports, "unpack", () => (parcelRequire("43ZPL")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("7ElX1")).default);

var $8TO5X = parcelRequire("8TO5X");

var $gb2Ug = parcelRequire("gb2Ug");

var $hMEmV = parcelRequire("hMEmV");

var $43ZPL = parcelRequire("43ZPL");

var $7ElX1 = parcelRequire("7ElX1");
const { PI: $0364fc9895a99d2c$export$6b5c1ceb16d01dc3, min: $0364fc9895a99d2c$export$96ec731ed4dcb222, max: $0364fc9895a99d2c$export$8960430cfd85939f } = Math;
const $0364fc9895a99d2c$export$c6d486233e29f7d1 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$6ed426801b9660b8 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$af54f71c879f5ba9 = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 * 2;
const $0364fc9895a99d2c$export$e734282486210baf = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 3;
const $0364fc9895a99d2c$export$460c4029b1a54a2e = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 180;
const $0364fc9895a99d2c$export$914076c8150813e5 = 180 / $0364fc9895a99d2c$export$6b5c1ceb16d01dc3;
/**
 * Reverse the first three elements of an array
 *
 * @param {any[]} arr
 * @returns {any[]}
 */ function $0364fc9895a99d2c$export$d0e1128e52417073(arr) {
    return [
        ...arr.slice(0, 3).reverse(),
        ...arr.slice(3)
    ];
}

});
parcelRegister("8TO5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $67aa519ab0061f26$export$2e2bcd8739ae039);

var $gb2Ug = parcelRequire("gb2Ug");
var $67aa519ab0061f26$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 1);
    }
    return rgb;
};

});
parcelRegister("gb2Ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6fed995261efd6$export$2e2bcd8739ae039);
const { min: $bc6fed995261efd6$var$min, max: $bc6fed995261efd6$var$max } = Math;
var $bc6fed995261efd6$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return $bc6fed995261efd6$var$min($bc6fed995261efd6$var$max(low, x), high);
};

});


parcelRegister("hMEmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf263bc72046187c$export$2e2bcd8739ae039);
// ported from jQuery's $.type
const $cf263bc72046187c$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$cf263bc72046187c$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $cf263bc72046187c$export$2e2bcd8739ae039(obj) {
    return $cf263bc72046187c$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}

});

parcelRegister("43ZPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f57682b2b3fd0b6$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $2f57682b2b3fd0b6$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $hMEmV.default)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0].slice(0);
};

});

parcelRegister("7ElX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $591d4bdad7401082$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $591d4bdad7401082$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $hMEmV.default)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};

});


parcelRegister("lT4NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef275e9b9623611$export$2e2bcd8739ae039);
var $fef275e9b9623611$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};

});


parcelRegister("6QlZc", function(module, exports) {

$parcel$export(module.exports, "version", () => $4fb8a75d624eee90$export$83d89fbfd8236492);
// this gets updated automatically
const $4fb8a75d624eee90$export$83d89fbfd8236492 = '3.1.2';

});


parcelRegister("cF22K", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2LSBy = parcelRequire("2LSBy");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.name = function() {
    const hex = (0, $eL95G.default)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $2LSBy.default))){
        if ((0, $2LSBy.default)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $lT4NS.default).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $2LSBy.default)[name]) return (0, $2BpKe.default)((0, $2LSBy.default)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $2LSBy.default)[h.toLowerCase()]) return 'named';
    }
});

});
parcelRegister("2LSBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $204a53f04c74292a$export$2e2bcd8739ae039);
/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $204a53f04c74292a$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $204a53f04c74292a$export$2e2bcd8739ae039 = $204a53f04c74292a$var$w3cx11;

});

parcelRegister("2BpKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5301da89c3e9c8$export$2e2bcd8739ae039);
const $1e5301da89c3e9c8$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $1e5301da89c3e9c8$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $1e5301da89c3e9c8$var$hex2rgb = (hex)=>{
    if (hex.match($1e5301da89c3e9c8$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($1e5301da89c3e9c8$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $1e5301da89c3e9c8$export$2e2bcd8739ae039 = $1e5301da89c3e9c8$var$hex2rgb;

});

parcelRegister("eL95G", function(module, exports) {

$parcel$export(module.exports, "default", () => $abec81afd0345325$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");
const { round: $abec81afd0345325$var$round } = Math;
const $abec81afd0345325$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $abec81afd0345325$var$round(r);
    g = $abec81afd0345325$var$round(g);
    b = $abec81afd0345325$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $abec81afd0345325$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $abec81afd0345325$export$2e2bcd8739ae039 = $abec81afd0345325$var$rgb2hex;

});


parcelRegister("iygXn", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $hMEmV.default)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $e7KSJ.default)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};

});

parcelRegister("QEjK4", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.clipped = function() {
    return this._rgb._clipped || false;
};

});

parcelRegister("kytU9", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $8weUB.default).Kn * amount;
    return new (0, $e7KSJ.default)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $e7KSJ.default).prototype.darker = (0, $e7KSJ.default).prototype.darken;
(0, $e7KSJ.default).prototype.brighter = (0, $e7KSJ.default).prototype.brighten;

});
parcelRegister("996dd", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $jenZn = parcelRequire("jenZn");

var $luvnN = parcelRequire("luvnN");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.lab = function() {
    return (0, $luvnN.default)(this._rgb);
};
const $6a89c5f2d5780cd3$export$c83fb8f9027a6338 = (...args)=>new (0, $e7KSJ.default)(...args, 'lab');
Object.assign((0, $gaK1V.default), {
    lab: $6a89c5f2d5780cd3$export$c83fb8f9027a6338,
    getLabWhitePoint: $8weUB.getLabWhitePoint,
    setLabWhitePoint: $8weUB.setLabWhitePoint
});
(0, $lT4NS.default).format.lab = (0, $jenZn.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'lab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'lab';
    }
});

});
parcelRegister("jenZn", function(module, exports) {

$parcel$export(module.exports, "xyz2rgb", () => $e001eed8d7ff32c4$export$22cbacf088b0f5c6);
$parcel$export(module.exports, "default", () => $e001eed8d7ff32c4$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $e001eed8d7ff32c4$var$lab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b] = args;
    const [x, y, z] = $e001eed8d7ff32c4$var$lab2xyz(L, a, b);
    const [r, g, b_] = $e001eed8d7ff32c4$export$22cbacf088b0f5c6(x, y, z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $e001eed8d7ff32c4$var$lab2xyz = (L, a, b)=>{
    const { kE: kE, kK: kK, kKE: kKE, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const fy = (L + 16.0) / 116.0;
    const fx = 0.002 * a + fy;
    const fz = fy - 0.005 * b;
    const fx3 = fx * fx * fx;
    const fz3 = fz * fz * fz;
    const xr = fx3 > kE ? fx3 : (116.0 * fx - 16.0) / kK;
    const yr = L > kKE ? Math.pow((L + 16.0) / 116.0, 3.0) : L / kK;
    const zr = fz3 > kE ? fz3 : (116.0 * fz - 16.0) / kK;
    const x = xr * Xn;
    const y = yr * Yn;
    const z = zr * Zn;
    return [
        x,
        y,
        z
    ];
};
const $e001eed8d7ff32c4$var$compand = (linear)=>{
    /* sRGB */ const sign = Math.sign(linear);
    linear = Math.abs(linear);
    return (linear <= 0.0031308 ? linear * 12.92 : 1.055 * Math.pow(linear, 1.0 / 2.4) - 0.055) * sign;
};
const $e001eed8d7ff32c4$export$22cbacf088b0f5c6 = (x, y, z)=>{
    const { MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, MtxXYZ2RGB: MtxXYZ2RGB, RefWhiteRGB: RefWhiteRGB, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const As = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bs = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cs = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    const Ad = RefWhiteRGB.X * MtxAdaptMa.m00 + RefWhiteRGB.Y * MtxAdaptMa.m10 + RefWhiteRGB.Z * MtxAdaptMa.m20;
    const Bd = RefWhiteRGB.X * MtxAdaptMa.m01 + RefWhiteRGB.Y * MtxAdaptMa.m11 + RefWhiteRGB.Z * MtxAdaptMa.m21;
    const Cd = RefWhiteRGB.X * MtxAdaptMa.m02 + RefWhiteRGB.Y * MtxAdaptMa.m12 + RefWhiteRGB.Z * MtxAdaptMa.m22;
    const X1 = (x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20) * (Ad / As);
    const Y1 = (x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21) * (Bd / Bs);
    const Z1 = (x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22) * (Cd / Cs);
    const X2 = X1 * MtxAdaptMaI.m00 + Y1 * MtxAdaptMaI.m10 + Z1 * MtxAdaptMaI.m20;
    const Y2 = X1 * MtxAdaptMaI.m01 + Y1 * MtxAdaptMaI.m11 + Z1 * MtxAdaptMaI.m21;
    const Z2 = X1 * MtxAdaptMaI.m02 + Y1 * MtxAdaptMaI.m12 + Z1 * MtxAdaptMaI.m22;
    const r = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m00 + Y2 * MtxXYZ2RGB.m10 + Z2 * MtxXYZ2RGB.m20);
    const g = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m01 + Y2 * MtxXYZ2RGB.m11 + Z2 * MtxXYZ2RGB.m21);
    const b = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m02 + Y2 * MtxXYZ2RGB.m12 + Z2 * MtxXYZ2RGB.m22);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
var $e001eed8d7ff32c4$export$2e2bcd8739ae039 = $e001eed8d7ff32c4$var$lab2rgb;

});
parcelRegister("8weUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $633ce119b108995d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setLabWhitePoint", () => $633ce119b108995d$export$23f27f4cae67c045);
$parcel$export(module.exports, "getLabWhitePoint", () => $633ce119b108995d$export$922c3afbcbc31cb3);
const $633ce119b108995d$var$labConstants = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    labWhitePoint: 'd65',
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452,
    kE: 216.0 / 24389.0,
    kKE: 8.0,
    kK: 24389.0 / 27.0,
    RefWhiteRGB: {
        // sRGB
        X: 0.95047,
        Y: 1,
        Z: 1.08883
    },
    MtxRGB2XYZ: {
        m00: 0.4124564390896922,
        m01: 0.21267285140562253,
        m02: 0.0193338955823293,
        m10: 0.357576077643909,
        m11: 0.715152155287818,
        m12: 0.11919202588130297,
        m20: 0.18043748326639894,
        m21: 0.07217499330655958,
        m22: 0.9503040785363679
    },
    MtxXYZ2RGB: {
        m00: 3.2404541621141045,
        m01: -0.9692660305051868,
        m02: 0.055643430959114726,
        m10: -1.5371385127977166,
        m11: 1.8760108454466942,
        m12: -0.2040259135167538,
        m20: -0.498531409556016,
        m21: 0.041556017530349834,
        m22: 1.0572251882231791
    },
    // used in rgb2xyz
    As: 0.9414285350000001,
    Bs: 1.040417467,
    Cs: 1.089532651,
    MtxAdaptMa: {
        m00: 0.8951,
        m01: -0.7502,
        m02: 0.0389,
        m10: 0.2664,
        m11: 1.7135,
        m12: -0.0685,
        m20: -0.1614,
        m21: 0.0367,
        m22: 1.0296
    },
    MtxAdaptMaI: {
        m00: 0.9869929054667123,
        m01: 0.43230526972339456,
        m02: -0.008528664575177328,
        m10: -0.14705425642099013,
        m11: 0.5183602715367776,
        m12: 0.04004282165408487,
        m20: 0.15996265166373125,
        m21: 0.0492912282128556,
        m22: 0.9684866957875502
    }
};
var $633ce119b108995d$export$2e2bcd8739ae039 = $633ce119b108995d$var$labConstants;
// taken from https://de.mathworks.com/help/images/ref/whitepoint.html
const $633ce119b108995d$var$ILLUMINANTS = new Map([
    // ASTM E308-01
    [
        'a',
        [
            1.0985,
            0.35585
        ]
    ],
    // Wyszecki & Stiles, p. 769
    [
        'b',
        [
            1.0985,
            0.35585
        ]
    ],
    // C ASTM E308-01
    [
        'c',
        [
            0.98074,
            1.18232
        ]
    ],
    // D50 (ASTM E308-01)
    [
        'd50',
        [
            0.96422,
            0.82521
        ]
    ],
    // D55 (ASTM E308-01)
    [
        'd55',
        [
            0.95682,
            0.92149
        ]
    ],
    // D65 (ASTM E308-01)
    [
        'd65',
        [
            0.95047,
            1.08883
        ]
    ],
    // E (ASTM E308-01)
    [
        'e',
        [
            1,
            1,
            1
        ]
    ],
    // F2 (ASTM E308-01)
    [
        'f2',
        [
            0.99186,
            0.67393
        ]
    ],
    // F7 (ASTM E308-01)
    [
        'f7',
        [
            0.95041,
            1.08747
        ]
    ],
    // F11 (ASTM E308-01)
    [
        'f11',
        [
            1.00962,
            0.6435
        ]
    ],
    [
        'icc',
        [
            0.96422,
            0.82521
        ]
    ]
]);
function $633ce119b108995d$export$23f27f4cae67c045(name) {
    const ill = $633ce119b108995d$var$ILLUMINANTS.get(String(name).toLowerCase());
    if (!ill) throw new Error('unknown Lab illuminant ' + name);
    $633ce119b108995d$var$labConstants.labWhitePoint = name;
    $633ce119b108995d$var$labConstants.Xn = ill[0];
    $633ce119b108995d$var$labConstants.Zn = ill[1];
}
function $633ce119b108995d$export$922c3afbcbc31cb3() {
    return $633ce119b108995d$var$labConstants.labWhitePoint;
}

});


parcelRegister("luvnN", function(module, exports) {

$parcel$export(module.exports, "rgb2xyz", () => $fa54be4b38a62f7b$export$fca6d690f89f5907);
$parcel$export(module.exports, "default", () => $fa54be4b38a62f7b$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $fa54be4b38a62f7b$var$rgb2lab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [x, y, z] = $fa54be4b38a62f7b$export$fca6d690f89f5907(r, g, b);
    const [L, a, b_] = $fa54be4b38a62f7b$var$xyz2lab(x, y, z);
    return [
        L,
        a,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
function $fa54be4b38a62f7b$var$xyz2lab(x, y, z) {
    const { Xn: Xn, Yn: Yn, Zn: Zn, kE: kE, kK: kK } = (0, $8weUB.default);
    const xr = x / Xn;
    const yr = y / Yn;
    const zr = z / Zn;
    const fx = xr > kE ? Math.pow(xr, 1.0 / 3.0) : (kK * xr + 16.0) / 116.0;
    const fy = yr > kE ? Math.pow(yr, 1.0 / 3.0) : (kK * yr + 16.0) / 116.0;
    const fz = zr > kE ? Math.pow(zr, 1.0 / 3.0) : (kK * zr + 16.0) / 116.0;
    return [
        116.0 * fy - 16.0,
        500.0 * (fx - fy),
        200.0 * (fy - fz)
    ];
}
function $fa54be4b38a62f7b$var$gammaAdjustSRGB(companded) {
    const sign = Math.sign(companded);
    companded = Math.abs(companded);
    const linear = companded <= 0.04045 ? companded / 12.92 : Math.pow((companded + 0.055) / 1.055, 2.4);
    return linear * sign;
}
const $fa54be4b38a62f7b$export$fca6d690f89f5907 = (r, g, b)=>{
    // normalize and gamma adjust
    r = $fa54be4b38a62f7b$var$gammaAdjustSRGB(r / 255);
    g = $fa54be4b38a62f7b$var$gammaAdjustSRGB(g / 255);
    b = $fa54be4b38a62f7b$var$gammaAdjustSRGB(b / 255);
    const { MtxRGB2XYZ: MtxRGB2XYZ, MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, Xn: Xn, Yn: Yn, Zn: Zn, As: As, Bs: Bs, Cs: Cs } = (0, $8weUB.default);
    let x = r * MtxRGB2XYZ.m00 + g * MtxRGB2XYZ.m10 + b * MtxRGB2XYZ.m20;
    let y = r * MtxRGB2XYZ.m01 + g * MtxRGB2XYZ.m11 + b * MtxRGB2XYZ.m21;
    let z = r * MtxRGB2XYZ.m02 + g * MtxRGB2XYZ.m12 + b * MtxRGB2XYZ.m22;
    const Ad = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bd = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cd = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    let X = x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20;
    let Y = x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21;
    let Z = x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22;
    X *= Ad / As;
    Y *= Bd / Bs;
    Z *= Cd / Cs;
    x = X * MtxAdaptMaI.m00 + Y * MtxAdaptMaI.m10 + Z * MtxAdaptMaI.m20;
    y = X * MtxAdaptMaI.m01 + Y * MtxAdaptMaI.m11 + Z * MtxAdaptMaI.m21;
    z = X * MtxAdaptMaI.m02 + Y * MtxAdaptMaI.m12 + Z * MtxAdaptMaI.m22;
    return [
        x,
        y,
        z
    ];
};
var $fa54be4b38a62f7b$export$2e2bcd8739ae039 = $fa54be4b38a62f7b$var$rgb2lab;

});



parcelRegister("kn0Pa", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("hDPZe", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $cd7e67a33d66dde3$var$pow } = Math;
const $cd7e67a33d66dde3$var$EPS = 1e-7;
const $cd7e67a33d66dde3$var$MAX_ITER = 20;
(0, $e7KSJ.default).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $hMEmV.default)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $e7KSJ.default)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $e7KSJ.default)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $cd7e67a33d66dde3$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $cd7e67a33d66dde3$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $e7KSJ.default)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $e7KSJ.default)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $e7KSJ.default)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $cd7e67a33d66dde3$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $cd7e67a33d66dde3$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $cd7e67a33d66dde3$var$luminance_x(r);
    g = $cd7e67a33d66dde3$var$luminance_x(g);
    b = $cd7e67a33d66dde3$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $cd7e67a33d66dde3$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $cd7e67a33d66dde3$var$pow((x + 0.055) / 1.055, 2.4);
};

});

parcelRegister("eDzBg", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.mix = (0, $e7KSJ.default).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, col2, f, ...rest);
};

});
parcelRegister("dvq8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d52731f6acc42df$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $5flPP = parcelRequire("5flPP");
var $9d52731f6acc42df$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $5flPP.default)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $5flPP.default))[0];
    if (!(0, $5flPP.default)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $hMEmV.default)(col1) !== 'object') col1 = new (0, $e7KSJ.default)(col1);
    if ((0, $hMEmV.default)(col2) !== 'object') col2 = new (0, $e7KSJ.default)(col2);
    return (0, $5flPP.default)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};

});
parcelRegister("5flPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1f4a69308124ed$export$2e2bcd8739ae039);
var $3d1f4a69308124ed$export$2e2bcd8739ae039 = {};

});



parcelRegister("7pAyc", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $e7KSJ.default)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};

});

parcelRegister("kXega", function(module, exports) {
parcelRequire("getAx");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $8weUB.default).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $e7KSJ.default)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};

});
parcelRegister("getAx", function(module, exports) {

var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $g4jd5 = parcelRequire("g4jd5");

var $c2Ykn = parcelRequire("c2Ykn");

var $jSfgf = parcelRequire("jSfgf");
(0, $e7KSJ.default).prototype.lch = function() {
    return (0, $jSfgf.default)(this._rgb);
};
(0, $e7KSJ.default).prototype.hcl = function() {
    return (0, $i4gda.reverse3)((0, $jSfgf.default)(this._rgb));
};
const $bd14e7c45dd3e1a2$export$5a21418738164530 = (...args)=>new (0, $e7KSJ.default)(...args, 'lch');
const $bd14e7c45dd3e1a2$export$d0e870ba50062ff1 = (...args)=>new (0, $e7KSJ.default)(...args, 'hcl');
Object.assign((0, $gaK1V.default), {
    lch: $bd14e7c45dd3e1a2$export$5a21418738164530,
    hcl: $bd14e7c45dd3e1a2$export$d0e870ba50062ff1
});
(0, $lT4NS.default).format.lch = (0, $g4jd5.default);
(0, $lT4NS.default).format.hcl = (0, $c2Ykn.default);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $lT4NS.default).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $43ZPL.default)(args, m);
            if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return m;
        }
    }));

});
parcelRegister("g4jd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2bebced39c863d$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $jenZn = parcelRequire("jenZn");
const $bb2bebced39c863d$var$lch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $jenZn.default)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $bb2bebced39c863d$export$2e2bcd8739ae039 = $bb2bebced39c863d$var$lch2rgb;

});
parcelRegister("d6n2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $989db6829fcafd4a$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sin: $989db6829fcafd4a$var$sin, cos: $989db6829fcafd4a$var$cos } = Math;
const $989db6829fcafd4a$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $43ZPL.default)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $i4gda.DEG2RAD);
    return [
        l,
        $989db6829fcafd4a$var$cos(h) * c,
        $989db6829fcafd4a$var$sin(h) * c
    ];
};
var $989db6829fcafd4a$export$2e2bcd8739ae039 = $989db6829fcafd4a$var$lch2lab;

});


parcelRegister("c2Ykn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5477bbf42a48d0$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $g4jd5 = parcelRequire("g4jd5");
const $8c5477bbf42a48d0$var$hcl2rgb = (...args)=>{
    const hcl = (0, $i4gda.reverse3)((0, $43ZPL.default)(args, 'hcl'));
    return (0, $g4jd5.default)(...hcl);
};
var $8c5477bbf42a48d0$export$2e2bcd8739ae039 = $8c5477bbf42a48d0$var$hcl2rgb;

});

parcelRegister("jSfgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77ee5fe83442dbf$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $luvnN = parcelRequire("luvnN");

var $36WLn = parcelRequire("36WLn");
const $e77ee5fe83442dbf$var$rgb2lch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $luvnN.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $e77ee5fe83442dbf$export$2e2bcd8739ae039 = $e77ee5fe83442dbf$var$rgb2lch;

});
parcelRegister("36WLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $243f83c61b0760ca$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sqrt: $243f83c61b0760ca$var$sqrt, atan2: $243f83c61b0760ca$var$atan2, round: $243f83c61b0760ca$var$round } = Math;
const $243f83c61b0760ca$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $43ZPL.default)(args, 'lab');
    const c = $243f83c61b0760ca$var$sqrt(a * a + b * b);
    let h = ($243f83c61b0760ca$var$atan2(b, a) * (0, $i4gda.RAD2DEG) + 360) % 360;
    if ($243f83c61b0760ca$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $243f83c61b0760ca$export$2e2bcd8739ae039 = $243f83c61b0760ca$var$lab2lch;

});




parcelRegister("8P76D", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $hMEmV.default)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $hMEmV.default)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $e7KSJ.default)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("bEZjX", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'white', f, ...rest);
};
(0, $e7KSJ.default).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'black', f, ...rest);
};

});

parcelRegister("jywIV", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const $e3ca93847035084a$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $5flPP.default).rgb = $e3ca93847035084a$var$rgb;
var $e3ca93847035084a$export$2e2bcd8739ae039 = $e3ca93847035084a$var$rgb;

});

parcelRegister("4Zhp6", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const { sqrt: $3a1a5bf678f2834b$var$sqrt, pow: $3a1a5bf678f2834b$var$pow } = Math;
const $3a1a5bf678f2834b$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $e7KSJ.default)($3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(x1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(x2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(y1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(y2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(z1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $5flPP.default).lrgb = $3a1a5bf678f2834b$var$lrgb;
var $3a1a5bf678f2834b$export$2e2bcd8739ae039 = $3a1a5bf678f2834b$var$lrgb;

});

parcelRegister("kMTGA", function(module, exports) {
parcelRequire("996dd");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $f2237c656cb48337$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $5flPP.default).lab = $f2237c656cb48337$var$lab;
var $f2237c656cb48337$export$2e2bcd8739ae039 = $f2237c656cb48337$var$lab;

});

parcelRegister("dkzY3", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $9b490b0c3a354cd6$var$lch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'lch');
};
// register interpolator
(0, $5flPP.default).lch = $9b490b0c3a354cd6$var$lch;
(0, $5flPP.default).hcl = $9b490b0c3a354cd6$var$lch;
var $9b490b0c3a354cd6$export$2e2bcd8739ae039 = $9b490b0c3a354cd6$var$lch;

});
parcelRegister("9mSMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d20aa787a33a4e5$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $6d20aa787a33a4e5$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $e7KSJ.default)([
        lbv,
        sat,
        hue
    ], m) : new (0, $e7KSJ.default)([
        hue,
        sat,
        lbv
    ], m);
};

});


parcelRegister("gac9F", function(module, exports) {
parcelRequire("eSrDz");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $bc4702376fdac141$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $e7KSJ.default)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $5flPP.default).num = $bc4702376fdac141$var$num;
var $bc4702376fdac141$export$2e2bcd8739ae039 = $bc4702376fdac141$var$num;

});
parcelRegister("eSrDz", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2UY7c = parcelRequire("2UY7c");

var $gkdTd = parcelRequire("gkdTd");
(0, $e7KSJ.default).prototype.num = function() {
    return (0, $gkdTd.default)(this._rgb);
};
const $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a = (...args)=>new (0, $e7KSJ.default)(...args, 'num');
Object.assign((0, $gaK1V.default), {
    num: $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a
});
(0, $lT4NS.default).format.num = (0, $2UY7c.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $hMEmV.default)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});

});
parcelRegister("2UY7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ff7154ad573d00$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const $21ff7154ad573d00$var$num2rgb = (num)=>{
    if ((0, $hMEmV.default)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $21ff7154ad573d00$export$2e2bcd8739ae039 = $21ff7154ad573d00$var$num2rgb;

});

parcelRegister("gkdTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2949c4ecd598fe$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $be2949c4ecd598fe$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $be2949c4ecd598fe$export$2e2bcd8739ae039 = $be2949c4ecd598fe$var$rgb2num;

});



parcelRegister("fWmFX", function(module, exports) {
parcelRequire("hskHC");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $b9addcb425bc1f3f$var$hcg = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $5flPP.default).hcg = $b9addcb425bc1f3f$var$hcg;
var $b9addcb425bc1f3f$export$2e2bcd8739ae039 = $b9addcb425bc1f3f$var$hcg;

});
parcelRegister("hskHC", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $lQebz = parcelRequire("lQebz");

var $66Tfa = parcelRequire("66Tfa");
(0, $e7KSJ.default).prototype.hcg = function() {
    return (0, $66Tfa.default)(this._rgb);
};
const $cb551c44f4ef224a$export$e588e1c8c259384c = (...args)=>new (0, $e7KSJ.default)(...args, 'hcg');
(0, $gaK1V.default).hcg = $cb551c44f4ef224a$export$e588e1c8c259384c;
(0, $lT4NS.default).format.hcg = (0, $lQebz.default);
(0, $lT4NS.default).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hcg');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hcg';
    }
});

});
parcelRegister("lQebz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe697541ee37e71b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $fe697541ee37e71b$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $fe697541ee37e71b$var$hcg2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $fe697541ee37e71b$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $fe697541ee37e71b$export$2e2bcd8739ae039 = $fe697541ee37e71b$var$hcg2rgb;

});

parcelRegister("66Tfa", function(module, exports) {

$parcel$export(module.exports, "default", () => $472e27dbd8c4997e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $472e27dbd8c4997e$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $472e27dbd8c4997e$export$2e2bcd8739ae039 = $472e27dbd8c4997e$var$rgb2hcg;

});



parcelRegister("3s82t", function(module, exports) {
parcelRequire("2yZD4");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $283a38fc382f3b9d$var$hsi = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $5flPP.default).hsi = $283a38fc382f3b9d$var$hsi;
var $283a38fc382f3b9d$export$2e2bcd8739ae039 = $283a38fc382f3b9d$var$hsi;

});
parcelRegister("2yZD4", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $l5tcy = parcelRequire("l5tcy");

var $jIBUL = parcelRequire("jIBUL");
(0, $e7KSJ.default).prototype.hsi = function() {
    return (0, $jIBUL.default)(this._rgb);
};
const $1dde90099f253c78$export$ec0e0a10cc3c404a = (...args)=>new (0, $e7KSJ.default)(...args, 'hsi');
(0, $gaK1V.default).hsi = $1dde90099f253c78$export$ec0e0a10cc3c404a;
(0, $lT4NS.default).format.hsi = (0, $l5tcy.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsi');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsi';
    }
});

});
parcelRegister("l5tcy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a0b7662948a353$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { cos: $f5a0b7662948a353$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $f5a0b7662948a353$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $43ZPL.default)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $gb2Ug.default)(i * r * 3);
    g = (0, $gb2Ug.default)(i * g * 3);
    b = (0, $gb2Ug.default)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $f5a0b7662948a353$export$2e2bcd8739ae039 = $f5a0b7662948a353$var$hsi2rgb;

});

parcelRegister("jIBUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5af8966c377d585$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $e5af8966c377d585$var$min, sqrt: $e5af8966c377d585$var$sqrt, acos: $e5af8966c377d585$var$acos } = Math;
const $e5af8966c377d585$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $e5af8966c377d585$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $e5af8966c377d585$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $e5af8966c377d585$var$acos(h);
        if (b > g) h = (0, $i4gda.TWOPI) - h;
        h /= (0, $i4gda.TWOPI);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $e5af8966c377d585$export$2e2bcd8739ae039 = $e5af8966c377d585$var$rgb2hsi;

});



parcelRegister("75dqB", function(module, exports) {
parcelRequire("fbI2I");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $52836a91adc4a3f4$var$hsl = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $5flPP.default).hsl = $52836a91adc4a3f4$var$hsl;
var $52836a91adc4a3f4$export$2e2bcd8739ae039 = $52836a91adc4a3f4$var$hsl;

});
parcelRegister("fbI2I", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $7PGtI = parcelRequire("7PGtI");

var $f9fTr = parcelRequire("f9fTr");
(0, $e7KSJ.default).prototype.hsl = function() {
    return (0, $f9fTr.default)(this._rgb);
};
const $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsl');
(0, $gaK1V.default).hsl = $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8;
(0, $lT4NS.default).format.hsl = (0, $7PGtI.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsl');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsl';
    }
});

});
parcelRegister("7PGtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3e3f1c3bcf972f$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $5b3e3f1c3bcf972f$var$hsl2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            c[0] * 255,
            c[1] * 255,
            c[2] * 255
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $5b3e3f1c3bcf972f$export$2e2bcd8739ae039 = $5b3e3f1c3bcf972f$var$hsl2rgb;

});

parcelRegister("f9fTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0740654f8b78640$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $b0740654f8b78640$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $b0740654f8b78640$export$2e2bcd8739ae039 = $b0740654f8b78640$var$rgb2hsl;

});



parcelRegister("2ISBM", function(module, exports) {
parcelRequire("7Z9E2");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $1fba0cefa8ec10d2$var$hsv = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $5flPP.default).hsv = $1fba0cefa8ec10d2$var$hsv;
var $1fba0cefa8ec10d2$export$2e2bcd8739ae039 = $1fba0cefa8ec10d2$var$hsv;

});
parcelRegister("7Z9E2", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $eNZr2 = parcelRequire("eNZr2");

var $8GFTU = parcelRequire("8GFTU");
(0, $e7KSJ.default).prototype.hsv = function() {
    return (0, $8GFTU.default)(this._rgb);
};
const $5d05b62ca5e0b832$export$a5d7c789f12d2213 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsv');
(0, $gaK1V.default).hsv = $5d05b62ca5e0b832$export$a5d7c789f12d2213;
(0, $lT4NS.default).format.hsv = (0, $eNZr2.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsv');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsv';
    }
});

});
parcelRegister("eNZr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c815df05a1cd8b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $02c815df05a1cd8b$var$floor } = Math;
const $02c815df05a1cd8b$var$hsv2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $02c815df05a1cd8b$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $02c815df05a1cd8b$export$2e2bcd8739ae039 = $02c815df05a1cd8b$var$hsv2rgb;

});

parcelRegister("8GFTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6532bf9b6866bc48$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $6532bf9b6866bc48$var$min, max: $6532bf9b6866bc48$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $6532bf9b6866bc48$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $6532bf9b6866bc48$var$min(r, g, b);
    const max_ = $6532bf9b6866bc48$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $6532bf9b6866bc48$export$2e2bcd8739ae039 = $6532bf9b6866bc48$var$rgb2hsl;

});



parcelRegister("52gBS", function(module, exports) {
parcelRequire("j6weT");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $3aaa060894ca8484$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $5flPP.default).oklab = $3aaa060894ca8484$var$oklab;
var $3aaa060894ca8484$export$2e2bcd8739ae039 = $3aaa060894ca8484$var$oklab;

});
parcelRegister("j6weT", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $5D4bx = parcelRequire("5D4bx");

var $eJb2q = parcelRequire("eJb2q");
(0, $e7KSJ.default).prototype.oklab = function() {
    return (0, $eJb2q.default)(this._rgb);
};
const $de8795def78a20d0$export$b14b17e4e916d621 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklab');
Object.assign((0, $gaK1V.default), {
    oklab: $de8795def78a20d0$export$b14b17e4e916d621
});
(0, $lT4NS.default).format.oklab = (0, $5D4bx.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklab';
    }
});

});
parcelRegister("5D4bx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4193d753772cec6b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $jenZn = parcelRequire("jenZn");
const $4193d753772cec6b$var$oklab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b, ...rest] = args;
    const [X, Y, Z] = $4193d753772cec6b$var$OKLab_to_XYZ([
        L,
        a,
        b
    ]);
    const [r, g, b_] = (0, $jenZn.xyz2rgb)(X, Y, Z);
    return [
        r,
        g,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $4193d753772cec6b$var$OKLab_to_XYZ(OKLab) {
    // Given OKLab, convert to XYZ relative to D65
    var LMStoXYZ = [
        [
            1.2268798758459243,
            -0.5578149944602171,
            0.2813910456659647
        ],
        [
            -0.0405757452148008,
            1.112286803280317,
            -0.0717110580655164
        ],
        [
            -0.0763729366746601,
            -0.4214933324022432,
            1.5869240198367816
        ]
    ];
    var OKLabtoLMS = [
        [
            1.0,
            0.3963377773761749,
            0.2158037573099136
        ],
        [
            1.0,
            -0.1055613458156586,
            -0.0638541728258133
        ],
        [
            1.0,
            -0.0894841775298119,
            -1.2914855480194092
        ]
    ];
    var LMSnl = (0, $iIsar.default)(OKLabtoLMS, OKLab);
    return (0, $iIsar.default)(LMStoXYZ, LMSnl.map((c)=>c ** 3));
}
var $4193d753772cec6b$export$2e2bcd8739ae039 = $4193d753772cec6b$var$oklab2rgb;

});
parcelRegister("iIsar", function(module, exports) {

$parcel$export(module.exports, "default", () => $da022f8598f5340d$export$2e2bcd8739ae039);
// from https://www.w3.org/TR/css-color-4/multiply-matrices.js
function $da022f8598f5340d$export$2e2bcd8739ae039(A, B) {
    let m = A.length;
    if (!Array.isArray(A[0])) // A is vector, convert to [[a, b, c, ...]]
    A = [
        A
    ];
    if (!Array.isArray(B[0])) // B is vector, convert to [[a], [b], [c], ...]]
    B = B.map((x)=>[
            x
        ]);
    let p = B[0].length;
    let B_cols = B[0].map((_, i)=>B.map((x)=>x[i])); // transpose B
    let product = A.map((row)=>B_cols.map((col)=>{
            if (!Array.isArray(row)) return col.reduce((a, c)=>a + c * row, 0);
            return row.reduce((a, c, i)=>a + c * (col[i] || 0), 0);
        }));
    if (m === 1) product = product[0]; // Avoid [[a, b, c, ...]]
    if (p === 1) return product.map((x)=>x[0]); // Avoid [[a], [b], [c], ...]]
    return product;
}

});


parcelRegister("eJb2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8dd493bc48c920$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $luvnN = parcelRequire("luvnN");
const $ab8dd493bc48c920$var$rgb2oklab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const xyz = (0, $luvnN.rgb2xyz)(r, g, b);
    const oklab = $ab8dd493bc48c920$var$XYZ_to_OKLab(xyz);
    return [
        ...oklab,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $ab8dd493bc48c920$var$XYZ_to_OKLab(XYZ) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        [
            0.819022437996703,
            0.3619062600528904,
            -0.1288737815209879
        ],
        [
            0.0329836539323885,
            0.9292868615863434,
            0.0361446663506424
        ],
        [
            0.0481771893596242,
            0.2642395317527308,
            0.6335478284694309
        ]
    ];
    const LMStoOKLab = [
        [
            0.210454268309314,
            0.7936177747023054,
            -0.0040720430116193
        ],
        [
            1.9779985324311684,
            -2.42859224204858,
            0.450593709617411
        ],
        [
            0.0259040424655478,
            0.7827717124575296,
            -0.8086757549230774
        ]
    ];
    const LMS = (0, $iIsar.default)(XYZtoLMS, XYZ);
    // JavaScript Math.cbrt returns a sign-matched cube root
    // beware if porting to other languages
    // especially if tempted to use a general power function
    return (0, $iIsar.default)(LMStoOKLab, LMS.map((c)=>Math.cbrt(c)));
// L in range [0,1]. For use in CSS, multiply by 100 and add a percent
}
var $ab8dd493bc48c920$export$2e2bcd8739ae039 = $ab8dd493bc48c920$var$rgb2oklab;

});



parcelRegister("3wKag", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $29182b9272ebb9ac$var$oklch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $5flPP.default).oklch = $29182b9272ebb9ac$var$oklch;
var $29182b9272ebb9ac$export$2e2bcd8739ae039 = $29182b9272ebb9ac$var$oklch;

});

parcelRegister("8UmTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c54fb1da1f0bdc$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
const { pow: $67c54fb1da1f0bdc$var$pow, sqrt: $67c54fb1da1f0bdc$var$sqrt, PI: $67c54fb1da1f0bdc$var$PI, cos: $67c54fb1da1f0bdc$var$cos, sin: $67c54fb1da1f0bdc$var$sin, atan2: $67c54fb1da1f0bdc$var$atan2 } = Math;
var $67c54fb1da1f0bdc$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (mode === 'lrgb') return $67c54fb1da1f0bdc$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $67c54fb1da1f0bdc$var$PI;
            dx += $67c54fb1da1f0bdc$var$cos(A) * weights[0];
            dy += $67c54fb1da1f0bdc$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $67c54fb1da1f0bdc$var$PI;
                dx += $67c54fb1da1f0bdc$var$cos(A) * weights[ci + 1];
                dy += $67c54fb1da1f0bdc$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $67c54fb1da1f0bdc$var$atan2(dy / cnt[i], dx / cnt[i]) / $67c54fb1da1f0bdc$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $e7KSJ.default)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $67c54fb1da1f0bdc$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $67c54fb1da1f0bdc$var$pow(rgb[0], 2) * f;
        xyz[1] += $67c54fb1da1f0bdc$var$pow(rgb[1], 2) * f;
        xyz[2] += $67c54fb1da1f0bdc$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $67c54fb1da1f0bdc$var$sqrt(xyz[0]);
    xyz[1] = $67c54fb1da1f0bdc$var$sqrt(xyz[1]);
    xyz[2] = $67c54fb1da1f0bdc$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $e7KSJ.default)((0, $8TO5X.default)(xyz));
};

});

parcelRegister("9u72g", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7c5f855046555e$export$2e2bcd8739ae039);
//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("996dd");

var $4ZQS0 = parcelRequire("4ZQS0");
// nth row of the pascal triangle
const $6e7c5f855046555e$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $6e7c5f855046555e$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $6e7c5f855046555e$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $6e7c5f855046555e$export$2e2bcd8739ae039 = (colors)=>{
    const f = $6e7c5f855046555e$var$bezier(colors);
    f.scale = ()=>(0, $4ZQS0.default)(f);
    return f;
};

});
parcelRegister("4ZQS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a35ded86e36da0d$export$2e2bcd8739ae039);
// minimal multi-purpose interface
// @requires utils color analyze

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $3a35ded86e36da0d$var$pow } = Math;
function $3a35ded86e36da0d$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $gaK1V.default)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $hMEmV.default)(colors) === 'string' && (0, $gaK1V.default).brewer && (0, $gaK1V.default).brewer[colors.toLowerCase()]) colors = (0, $gaK1V.default).brewer[colors.toLowerCase()];
        if ((0, $hMEmV.default)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $gaK1V.default)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $3a35ded86e36da0d$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $gb2Ug.default)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $hMEmV.default)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $gaK1V.default).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $hMEmV.default)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $gaK1V.default)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $hMEmV.default)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $gaK1V.default).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $gaK1V.default).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $hMEmV.default)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $3a35ded86e36da0d$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $gaK1V.default)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $gaK1V.default)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $3a35ded86e36da0d$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}

});


parcelRegister("hKhjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb429f3a9f3c855$export$2e2bcd8739ae039);
/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ parcelRequire("ayOPU");

var $gaK1V = parcelRequire("gaK1V");
const $ceb429f3a9f3c855$var$blend = (bottom, top, mode)=>{
    if (!$ceb429f3a9f3c855$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $ceb429f3a9f3c855$var$blend[mode](bottom, top);
};
const $ceb429f3a9f3c855$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $gaK1V.default)(top).rgb();
        const c1 = (0, $gaK1V.default)(bottom).rgb();
        return (0, $gaK1V.default).rgb(f(c0, c1));
    };
const $ceb429f3a9f3c855$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $ceb429f3a9f3c855$var$normal = (a)=>a;
const $ceb429f3a9f3c855$var$multiply = (a, b)=>a * b / 255;
const $ceb429f3a9f3c855$var$darken = (a, b)=>a > b ? b : a;
const $ceb429f3a9f3c855$var$lighten = (a, b)=>a > b ? a : b;
const $ceb429f3a9f3c855$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $ceb429f3a9f3c855$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$ceb429f3a9f3c855$var$blend.normal = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$normal));
$ceb429f3a9f3c855$var$blend.multiply = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$multiply));
$ceb429f3a9f3c855$var$blend.screen = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$screen));
$ceb429f3a9f3c855$var$blend.overlay = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$overlay));
$ceb429f3a9f3c855$var$blend.darken = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$darken));
$ceb429f3a9f3c855$var$blend.lighten = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$lighten));
$ceb429f3a9f3c855$var$blend.dodge = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$dodge));
$ceb429f3a9f3c855$var$blend.burn = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$burn));
var // blend.add = blend_f(each(add));
$ceb429f3a9f3c855$export$2e2bcd8739ae039 = $ceb429f3a9f3c855$var$blend;

});
parcelRegister("ayOPU", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");
const { round: $7b04835af4de31ed$var$round } = Math;
(0, $e7KSJ.default).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($7b04835af4de31ed$var$round);
};
(0, $e7KSJ.default).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $7b04835af4de31ed$var$round(v) : v;
    });
};
const $7b04835af4de31ed$export$8972dc0e6ad9238f = (...args)=>new (0, $e7KSJ.default)(...args, 'rgb');
Object.assign((0, $gaK1V.default), {
    rgb: $7b04835af4de31ed$export$8972dc0e6ad9238f
});
(0, $lT4NS.default).format.rgb = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $lT4NS.default).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'rgba');
        if ((0, $hMEmV.default)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $hMEmV.default)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});

});


parcelRegister("jpCQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e21e7c3c7180c018$export$2e2bcd8739ae039);
// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $gaK1V = parcelRequire("gaK1V");
const { pow: $e21e7c3c7180c018$var$pow, sin: $e21e7c3c7180c018$var$sin, cos: $e21e7c3c7180c018$var$cos } = Math;
function $e21e7c3c7180c018$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $hMEmV.default)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $i4gda.TWOPI) * ((start + 120) / 360 + rotations * fract);
        const l = $e21e7c3c7180c018$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $e21e7c3c7180c018$var$cos(a);
        const sin_a = $e21e7c3c7180c018$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $gaK1V.default)((0, $8TO5X.default)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $hMEmV.default)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $hMEmV.default)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $gaK1V.default).scale(f);
    f.hue(hue);
    return f;
}

});

parcelRegister("eIGWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab767cecc86e20d8$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const $ab767cecc86e20d8$var$digits = '0123456789abcdef';
const { floor: $ab767cecc86e20d8$var$floor, random: $ab767cecc86e20d8$var$random } = Math;
var $ab767cecc86e20d8$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $ab767cecc86e20d8$var$digits.charAt($ab767cecc86e20d8$var$floor($ab767cecc86e20d8$var$random() * 16));
    return new (0, $e7KSJ.default)(code, 'hex');
};

});

parcelRegister("cgHIr", function(module, exports) {

$parcel$export(module.exports, "analyze", () => $8ee8e3ba2352afc1$export$7cbcccfbecde6416);
$parcel$export(module.exports, "limits", () => $8ee8e3ba2352afc1$export$e331ca4ad6a82555);

var $hMEmV = parcelRequire("hMEmV");
const { log: $8ee8e3ba2352afc1$var$log, pow: $8ee8e3ba2352afc1$var$pow, floor: $8ee8e3ba2352afc1$var$floor, abs: $8ee8e3ba2352afc1$var$abs } = Math;
function $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $hMEmV.default)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $hMEmV.default)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$8ee8e3ba2352afc1$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $8ee8e3ba2352afc1$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $hMEmV.default)(data) == 'array') data = $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(min);
        const max_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($8ee8e3ba2352afc1$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $8ee8e3ba2352afc1$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $8ee8e3ba2352afc1$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}

});

parcelRegister("5BDZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $414f6dca23b2a9de$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("hDPZe");
var $414f6dca23b2a9de$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};

});

parcelRegister("iM4ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab003980244b19f$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */ // constants
const $dab003980244b19f$var$W_offset = 0.027;
const $dab003980244b19f$var$P_in = 0.0005;
const $dab003980244b19f$var$P_out = 0.1;
const $dab003980244b19f$var$R_scale = 1.14;
const $dab003980244b19f$var$B_threshold = 0.022;
const $dab003980244b19f$var$B_exp = 1.414;
var $dab003980244b19f$export$2e2bcd8739ae039 = (text, bg)=>{
    // parse input colors
    text = new (0, $e7KSJ.default)(text);
    bg = new (0, $e7KSJ.default)(bg);
    // if text color has alpha, blend against background
    if (text.alpha() < 1) text = (0, $dvq8W.default)(bg, text, text.alpha(), 'rgb');
    const l_text = $dab003980244b19f$var$lum(...text.rgb());
    const l_bg = $dab003980244b19f$var$lum(...bg.rgb());
    // soft clamp black levels
    const Y_text = l_text >= $dab003980244b19f$var$B_threshold ? l_text : l_text + Math.pow($dab003980244b19f$var$B_threshold - l_text, $dab003980244b19f$var$B_exp);
    const Y_bg = l_bg >= $dab003980244b19f$var$B_threshold ? l_bg : l_bg + Math.pow($dab003980244b19f$var$B_threshold - l_bg, $dab003980244b19f$var$B_exp);
    // normal polarity (dark text on light background)
    const S_norm = Math.pow(Y_bg, 0.56) - Math.pow(Y_text, 0.57);
    // reverse polarity (light text on dark background)
    const S_rev = Math.pow(Y_bg, 0.65) - Math.pow(Y_text, 0.62);
    // clamp noise then scale
    const C = Math.abs(Y_bg - Y_text) < $dab003980244b19f$var$P_in ? 0 : Y_text < Y_bg ? S_norm * $dab003980244b19f$var$R_scale : S_rev * $dab003980244b19f$var$R_scale;
    // clamp minimum contrast then offset
    const S_apc = Math.abs(C) < $dab003980244b19f$var$P_out ? 0 : C > 0 ? C - $dab003980244b19f$var$W_offset : C + $dab003980244b19f$var$W_offset;
    // scale to 100
    return S_apc * 100;
};
function $dab003980244b19f$var$lum(r, g, b) {
    return 0.2126729 * Math.pow(r / 255, 2.4) + 0.7151522 * Math.pow(g / 255, 2.4) + 0.072175 * Math.pow(b / 255, 2.4);
}

});

parcelRegister("xkLDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $064331241a6f3932$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const { sqrt: $064331241a6f3932$var$sqrt, pow: $064331241a6f3932$var$pow, min: $064331241a6f3932$var$min, max: $064331241a6f3932$var$max, atan2: $064331241a6f3932$var$atan2, abs: $064331241a6f3932$var$abs, cos: $064331241a6f3932$var$cos, sin: $064331241a6f3932$var$sin, exp: $064331241a6f3932$var$exp, PI: $064331241a6f3932$var$PI } = Math;
function $064331241a6f3932$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $064331241a6f3932$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $064331241a6f3932$var$PI * deg / 360;
    };
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgC, 7) / ($064331241a6f3932$var$pow(avgC, 7) + $064331241a6f3932$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1p, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2p, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($064331241a6f3932$var$atan2(b1, a1p));
    const arctan2 = rad2deg($064331241a6f3932$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $064331241a6f3932$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $064331241a6f3932$var$cos(deg2rad(avgHp - 30)) + 0.24 * $064331241a6f3932$var$cos(deg2rad(2 * avgHp)) + 0.32 * $064331241a6f3932$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $064331241a6f3932$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $064331241a6f3932$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $064331241a6f3932$var$sqrt(C1p * C2p) * $064331241a6f3932$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $064331241a6f3932$var$pow(avgL - 50, 2) / $064331241a6f3932$var$sqrt(20 + $064331241a6f3932$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $064331241a6f3932$var$exp(-$064331241a6f3932$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgCp, 7) / ($064331241a6f3932$var$pow(avgCp, 7) + $064331241a6f3932$var$pow(25, 7)));
    const Rt = -Rc * $064331241a6f3932$var$sin(2 * deg2rad(deltaTheta));
    const result = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(deltaL / (Kl * sl), 2) + $064331241a6f3932$var$pow(deltaCp / (Kc * sc), 2) + $064331241a6f3932$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $064331241a6f3932$var$max(0, $064331241a6f3932$var$min(100, result));
}

});

parcelRegister("iB6ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a0b365443a1f76$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
function $d8a0b365443a1f76$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}

});

parcelRegister("dID0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fcda4939aef1ea4$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $9fcda4939aef1ea4$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $e7KSJ.default)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};

});

parcelRegister("1vtEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $118fb0138dc62de8$export$2e2bcd8739ae039);
// some pre-defined color scales:

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("fbI2I");

var $4ZQS0 = parcelRequire("4ZQS0");
var $118fb0138dc62de8$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $4ZQS0.default)([
            (0, $gaK1V.default).hsl(180, 1, 0.9),
            (0, $gaK1V.default).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $4ZQS0.default)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};

});

parcelRegister("6Sny4", function(module, exports) {

$parcel$export(module.exports, "default", () => $501a0d7a311e121c$export$2e2bcd8739ae039);
/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $501a0d7a311e121c$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
const $501a0d7a311e121c$var$colorbrewerTypes = Object.keys($501a0d7a311e121c$var$colorbrewer);
const $501a0d7a311e121c$var$typeMap = new Map($501a0d7a311e121c$var$colorbrewerTypes.map((key)=>[
        key.toLowerCase(),
        key
    ]));
// use Proxy to allow case-insensitive access to palettes
const $501a0d7a311e121c$var$colorbrewerProxy = typeof Proxy === 'function' ? new Proxy($501a0d7a311e121c$var$colorbrewer, {
    get (target, prop) {
        const lower = prop.toLowerCase();
        if ($501a0d7a311e121c$var$typeMap.has(lower)) return target[$501a0d7a311e121c$var$typeMap.get(lower)];
    },
    getOwnPropertyNames () {
        return Object.getOwnPropertyNames($501a0d7a311e121c$var$colorbrewerTypes);
    }
}) : $501a0d7a311e121c$var$colorbrewer;
var $501a0d7a311e121c$export$2e2bcd8739ae039 = $501a0d7a311e121c$var$colorbrewerProxy;

});

parcelRegister("7hd9c", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $jKxIE = parcelRequire("jKxIE");

var $2o2Lo = parcelRequire("2o2Lo");
(0, $e7KSJ.default).prototype.cmyk = function() {
    return (0, $2o2Lo.default)(this._rgb);
};
const $54c451bcc042ac64$export$358b1a66a3c77756 = (...args)=>new (0, $e7KSJ.default)(...args, 'cmyk');
Object.assign((0, $gaK1V.default), {
    cmyk: $54c451bcc042ac64$export$358b1a66a3c77756
});
(0, $lT4NS.default).format.cmyk = (0, $jKxIE.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'cmyk');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});

});
parcelRegister("jKxIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e60c7822c37b0c25$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $e60c7822c37b0c25$var$cmyk2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $e60c7822c37b0c25$export$2e2bcd8739ae039 = $e60c7822c37b0c25$var$cmyk2rgb;

});

parcelRegister("2o2Lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bcff769908141f5$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { max: $1bcff769908141f5$var$max } = Math;
const $1bcff769908141f5$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $1bcff769908141f5$var$max(r, $1bcff769908141f5$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $1bcff769908141f5$export$2e2bcd8739ae039 = $1bcff769908141f5$var$rgb2cmyk;

});


parcelRegister("cIiSk", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $iwUkC = parcelRequire("iwUkC");

var $lmq0O = parcelRequire("lmq0O");
(0, $e7KSJ.default).prototype.css = function(mode) {
    return (0, $iwUkC.default)(this._rgb, mode);
};
const $94183c5a55123dcc$export$dbf350e5966cf602 = (...args)=>new (0, $e7KSJ.default)(...args, 'css');
(0, $gaK1V.default).css = $94183c5a55123dcc$export$dbf350e5966cf602;
(0, $lT4NS.default).format.css = (0, $lmq0O.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $lmq0O.default).test(h)) return 'css';
    }
});

});
parcelRegister("iwUkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d6e97251c964b7$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");

var $8r7If = parcelRequire("8r7If");

var $f9fTr = parcelRequire("f9fTr");

var $6Sszj = parcelRequire("6Sszj");

var $luvnN = parcelRequire("luvnN");

var $c020c = parcelRequire("c020c");

var $jSfgf = parcelRequire("jSfgf");

var $eJb2q = parcelRequire("eJb2q");

var $5KW7E = parcelRequire("5KW7E");

var $855Nw = parcelRequire("855Nw");

var $a0o1I = parcelRequire("a0o1I");

var $8weUB = parcelRequire("8weUB");
const { round: $d7d6e97251c964b7$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $d7d6e97251c964b7$var$rgb2css = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'rgb';
    if (mode.substr(0, 3) === 'hsl') return (0, $8r7If.default)((0, $f9fTr.default)(rgba), mode);
    if (mode.substr(0, 3) === 'lab') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $6Sszj.default)((0, $luvnN.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 3) === 'lch') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $c020c.default)((0, $jSfgf.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 5) === 'oklab') return (0, $5KW7E.default)((0, $eJb2q.default)(rgba));
    if (mode.substr(0, 5) === 'oklch') return (0, $a0o1I.default)((0, $855Nw.default)(rgba));
    rgba[0] = $d7d6e97251c964b7$var$round(rgba[0]);
    rgba[1] = $d7d6e97251c964b7$var$round(rgba[1]);
    rgba[2] = $d7d6e97251c964b7$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = '/ ' + (rgba.length > 3 ? rgba[3] : 1);
        mode = 'rgba';
    }
    return `${mode.substr(0, 3)}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(' ')})`;
};
var $d7d6e97251c964b7$export$2e2bcd8739ae039 = $d7d6e97251c964b7$var$rgb2css;

});
parcelRegister("8r7If", function(module, exports) {

$parcel$export(module.exports, "default", () => $6246d3ee765f7d54$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $6246d3ee765f7d54$var$hsl2css = (...args)=>{
    const hsla = (0, $43ZPL.default)(args, 'hsla');
    let mode = (0, $7ElX1.default)(args) || 'lsa';
    hsla[0] = (0, $i4gda.rnd2)(hsla[0] || 0) + 'deg';
    hsla[1] = (0, $i4gda.rnd2)(hsla[1] * 100) + '%';
    hsla[2] = (0, $i4gda.rnd2)(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = '/ ' + (hsla.length > 3 ? hsla[3] : 1);
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode.substr(0, 3)}(${hsla.join(' ')})`;
};
var $6246d3ee765f7d54$export$2e2bcd8739ae039 = $6246d3ee765f7d54$var$hsl2css;

});

parcelRegister("6Sszj", function(module, exports) {

$parcel$export(module.exports, "default", () => $501df25942503107$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $501df25942503107$var$lab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    laba[0] = (0, $i4gda.rnd2)(laba[0]) + '%';
    laba[1] = (0, $i4gda.rnd2)(laba[1]);
    laba[2] = (0, $i4gda.rnd2)(laba[2]);
    if (mode === 'laba' || laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `lab(${laba.join(' ')})`;
};
var $501df25942503107$export$2e2bcd8739ae039 = $501df25942503107$var$lab2css;

});

parcelRegister("c020c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc709b6cfda3284$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $8bc709b6cfda3284$var$lch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    lcha[0] = (0, $i4gda.rnd2)(lcha[0]) + '%';
    lcha[1] = (0, $i4gda.rnd2)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (mode === 'lcha' || lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `lch(${lcha.join(' ')})`;
};
var $8bc709b6cfda3284$export$2e2bcd8739ae039 = $8bc709b6cfda3284$var$lch2css;

});

parcelRegister("5KW7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $430e55826084c20e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $430e55826084c20e$var$oklab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    laba[0] = (0, $i4gda.rnd2)(laba[0] * 100) + '%';
    laba[1] = (0, $i4gda.rnd3)(laba[1]);
    laba[2] = (0, $i4gda.rnd3)(laba[2]);
    if (laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `oklab(${laba.join(' ')})`;
};
var $430e55826084c20e$export$2e2bcd8739ae039 = $430e55826084c20e$var$oklab2css;

});

parcelRegister("855Nw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2349b11f40bce3$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $eJb2q = parcelRequire("eJb2q");

var $36WLn = parcelRequire("36WLn");
const $5e2349b11f40bce3$var$rgb2oklch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $eJb2q.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $5e2349b11f40bce3$export$2e2bcd8739ae039 = $5e2349b11f40bce3$var$rgb2oklch;

});

parcelRegister("a0o1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $748c8aa705dcdecb$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $748c8aa705dcdecb$var$oklch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    lcha[0] = (0, $i4gda.rnd2)(lcha[0] * 100) + '%';
    lcha[1] = (0, $i4gda.rnd3)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `oklch(${lcha.join(' ')})`;
};
var $748c8aa705dcdecb$export$2e2bcd8739ae039 = $748c8aa705dcdecb$var$oklch2css;

});


parcelRegister("lmq0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8cfd480aa486045$export$2e2bcd8739ae039);

var $7PGtI = parcelRequire("7PGtI");

var $jenZn = parcelRequire("jenZn");

var $g4jd5 = parcelRequire("g4jd5");

var $5D4bx = parcelRequire("5D4bx");

var $9cCPH = parcelRequire("9cCPH");

var $lT4NS = parcelRequire("lT4NS");

var $gb2Ug = parcelRequire("gb2Ug");

var $8weUB = parcelRequire("8weUB");
const $f8cfd480aa486045$var$INT_OR_PCT = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source;
const $f8cfd480aa486045$var$FLOAT_OR_PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source;
const $f8cfd480aa486045$var$PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source;
const $f8cfd480aa486045$var$RE_S = /\s*/.source;
const $f8cfd480aa486045$var$SEP = /\s+/.source;
const $f8cfd480aa486045$var$COMMA = /\s*,\s*/.source;
const $f8cfd480aa486045$var$ANLGE = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source;
const $f8cfd480aa486045$var$ALPHA = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source;
// e.g. rgb(250 20 0), rgb(100% 50% 20%), rgb(100% 50% 20% / 0.5)
const $f8cfd480aa486045$var$RE_RGB = new RegExp('^rgba?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_RGB_LEGACY = new RegExp('^rgb\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_RGBA_LEGACY = new RegExp('^rgba\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSL = new RegExp('^hsla?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_HSL_LEGACY = new RegExp('^hsl?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSLA_LEGACY = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $f8cfd480aa486045$var$RE_LAB = new RegExp('^lab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_LCH = new RegExp('^lch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLAB = new RegExp('^oklab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLCH = new RegExp('^oklch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const { round: $f8cfd480aa486045$var$round } = Math;
const $f8cfd480aa486045$var$roundRGB = (rgb)=>{
    return rgb.map((v, i)=>i <= 2 ? (0, $gb2Ug.default)($f8cfd480aa486045$var$round(v), 0, 255) : v);
};
const $f8cfd480aa486045$var$percentToAbsolute = (pct, min = 0, max = 100, signed = false)=>{
    if (typeof pct === 'string' && pct.endsWith('%')) {
        pct = parseFloat(pct.substring(0, pct.length - 1)) / 100;
        if (signed) // signed percentages are in the range -100% to 100%
        pct = min + (pct + 1) * 0.5 * (max - min);
        else pct = min + pct * (max - min);
    }
    return +pct;
};
const $f8cfd480aa486045$var$noneToValue = (v, noneValue)=>{
    return v === 'none' ? noneValue : v;
};
const $f8cfd480aa486045$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    if (css === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    let m;
    if ((0, $lT4NS.default).format.named) try {
        return (0, $lT4NS.default).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250 20 0) or rgb(250,20,0)
    if ((m = css.match($f8cfd480aa486045$var$RE_RGB)) || (m = css.match($f8cfd480aa486045$var$RE_RGB_LEGACY))) {
        let rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(rgb[i], 0), 0, 255);
        rgb = $f8cfd480aa486045$var$roundRGB(rgb);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($f8cfd480aa486045$var$RE_RGBA_LEGACY)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute(rgb[i], 0, 255);
        return rgb;
    }
    // hsl(0,100%,50%)
    if ((m = css.match($f8cfd480aa486045$var$RE_HSL)) || (m = css.match($f8cfd480aa486045$var$RE_HSL_LEGACY))) {
        const hsl = m.slice(1, 4);
        hsl[0] = +$f8cfd480aa486045$var$noneToValue(hsl[0].replace('deg', ''), 0);
        hsl[1] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[1], 0), 0, 100) * 0.01;
        hsl[2] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[2], 0), 0, 100) * 0.01;
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $7PGtI.default)(hsl));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($f8cfd480aa486045$var$RE_HSLA_LEGACY)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $7PGtI.default)(hsl);
        for(let i = 0; i < 3; i++)rgb[i] = $f8cfd480aa486045$var$round(rgb[i]);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LAB)) {
        const lab = m.slice(1, 4);
        lab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[0], 0), 0, 100);
        lab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[1], 0), -125, 125, true);
        lab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[2], 0), -125, 125, true);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $jenZn.default)(lab));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LCH)) {
        const lch = m.slice(1, 4);
        lch[0] = $f8cfd480aa486045$var$percentToAbsolute(lch[0], 0, 100);
        lch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lch[1], 0), 0, 150, false);
        lch[2] = +$f8cfd480aa486045$var$noneToValue(lch[2].replace('deg', ''), 0);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $g4jd5.default)(lch));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLAB)) {
        const oklab = m.slice(1, 4);
        oklab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[0], 0), 0, 1);
        oklab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[1], 0), -0.4, 0.4, true);
        oklab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[2], 0), -0.4, 0.4, true);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $5D4bx.default)(oklab));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLCH)) {
        const oklch = m.slice(1, 4);
        oklch[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[0], 0), 0, 1);
        oklch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[1], 0), 0, 0.4, false);
        oklch[2] = +$f8cfd480aa486045$var$noneToValue(oklch[2].replace('deg', ''), 0);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $9cCPH.default)(oklch));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
};
$f8cfd480aa486045$var$css2rgb.test = (s)=>{
    return(// modern
    $f8cfd480aa486045$var$RE_RGB.test(s) || $f8cfd480aa486045$var$RE_HSL.test(s) || $f8cfd480aa486045$var$RE_LAB.test(s) || $f8cfd480aa486045$var$RE_LCH.test(s) || $f8cfd480aa486045$var$RE_OKLAB.test(s) || $f8cfd480aa486045$var$RE_OKLCH.test(s) || // legacy
    $f8cfd480aa486045$var$RE_RGB_LEGACY.test(s) || $f8cfd480aa486045$var$RE_RGBA_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSL_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSLA_LEGACY.test(s) || s === 'transparent');
};
var $f8cfd480aa486045$export$2e2bcd8739ae039 = $f8cfd480aa486045$var$css2rgb;

});
parcelRegister("9cCPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b335b6c71084560$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $5D4bx = parcelRequire("5D4bx");
const $6b335b6c71084560$var$oklch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h, ...rest] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $5D4bx.default)(L, a, b_);
    return [
        r,
        g,
        b,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $6b335b6c71084560$export$2e2bcd8739ae039 = $6b335b6c71084560$var$oklch2rgb;

});



parcelRegister("kBR14", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
(0, $lT4NS.default).format.gl = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
const $f010634c2ba757fa$export$5822a9d0880a5d82 = (...args)=>new (0, $e7KSJ.default)(...args, 'gl');
(0, $gaK1V.default).gl = $f010634c2ba757fa$export$5822a9d0880a5d82;
(0, $e7KSJ.default).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};

});

parcelRegister("bmZFS", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.hex = function(mode) {
    return (0, $eL95G.default)(this._rgb, mode);
};
const $84719710001139ea$export$834dfc94dde4b3d8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hex');
(0, $gaK1V.default).hex = $84719710001139ea$export$834dfc94dde4b3d8;
(0, $lT4NS.default).format.hex = (0, $2BpKe.default);
(0, $lT4NS.default).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});

});

parcelRegister("i89Hq", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $4vyUC = parcelRequire("4vyUC");

var $1X2Gd = parcelRequire("1X2Gd");
(0, $e7KSJ.default).prototype.temp = (0, $e7KSJ.default).prototype.kelvin = (0, $e7KSJ.default).prototype.temperature = function() {
    return (0, $1X2Gd.default)(this._rgb);
};
const $d3307f7157ff91e7$export$8d72b093afd1813e = (...args)=>new (0, $e7KSJ.default)(...args, 'temp');
Object.assign((0, $gaK1V.default), {
    temp: $d3307f7157ff91e7$export$8d72b093afd1813e,
    kelvin: $d3307f7157ff91e7$export$8d72b093afd1813e,
    temperature: $d3307f7157ff91e7$export$8d72b093afd1813e
});
(0, $lT4NS.default).format.temp = (0, $lT4NS.default).format.kelvin = (0, $lT4NS.default).format.temperature = (0, $4vyUC.default);

});
parcelRegister("4vyUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $34852385cec165f3$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $34852385cec165f3$var$log } = Math;
const $34852385cec165f3$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $34852385cec165f3$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $34852385cec165f3$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $34852385cec165f3$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $34852385cec165f3$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $34852385cec165f3$export$2e2bcd8739ae039 = $34852385cec165f3$var$temperature2rgb;

});

parcelRegister("1X2Gd", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bd614d337f08eb$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 
var $4vyUC = parcelRequire("4vyUC");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { round: $16bd614d337f08eb$var$round } = Math;
const $16bd614d337f08eb$var$rgb2temperature = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $4vyUC.default)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $16bd614d337f08eb$var$round(temp);
};
var $16bd614d337f08eb$export$2e2bcd8739ae039 = $16bd614d337f08eb$var$rgb2temperature;

});


parcelRegister("35MHU", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $9cCPH = parcelRequire("9cCPH");

var $855Nw = parcelRequire("855Nw");
(0, $e7KSJ.default).prototype.oklch = function() {
    return (0, $855Nw.default)(this._rgb);
};
const $24079ef8e8403722$export$c21b932a666e3753 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklch');
Object.assign((0, $gaK1V.default), {
    oklch: $24079ef8e8403722$export$c21b932a666e3753
});
(0, $lT4NS.default).format.oklch = (0, $9cCPH.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklch');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklch';
    }
});

});



parcelRegister("ceOOn", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", () => $8e8e34fa89bb9263$export$1191989ae3ee4c15);
const $8e8e34fa89bb9263$export$1191989ae3ee4c15 = ()=>{
    const cookies = document.cookie.split('; ');
    const allCookies = [];
    cookies.forEach((cookie)=>{
        const cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("a3TA1", function(module, exports) {

$parcel$export(module.exports, "elementReady", () => $75354c334d353ce6$export$5a68694636710d38);
const $75354c334d353ce6$export$5a68694636710d38 = (selector)=>new Promise((resolve)=>{
        const el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(()=>{
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach((element)=>{
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });

});

parcelRegister("6oLIz", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", () => $4a89ffbcc8257418$export$5f2cd73bfe4df536);
$parcel$export(module.exports, "addWindowScrollEvent", () => $4a89ffbcc8257418$export$b502183889628ce0);
const $4a89ffbcc8257418$export$5f2cd73bfe4df536 = (callback)=>{
    let timeout;
    window.addEventListener('resize', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
const $4a89ffbcc8257418$export$b502183889628ce0 = (callback)=>{
    let timeout;
    window.addEventListener('scroll', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("isKkJ", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", () => $d70ec861cf7f176b$export$26ae508a4c7ca84d);

var $6sEQA = parcelRequire("6sEQA");
const $d70ec861cf7f176b$export$26ae508a4c7ca84d = async (action)=>{
    try {
        const themeData = await (0, $6sEQA.getThemeData)();
        if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
        if (!themeData.ajax_actions?.recaptcha_verify) throw new Error('Missing AJAX route to verify reCAPTCHA token');
        if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
        return new Promise((resolve, reject)=>{
            if (window.grecaptcha === undefined) {
                console.warn('Google reCAPTCHA is not loaded');
                resolve({
                    success: true,
                    score: 1
                });
            } else grecaptcha.ready(function() {
                grecaptcha.execute(themeData.recaptcha_site_key, {
                    action: action
                }).then(async function(token) {
                    const formData = new FormData();
                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                    // Determine if request is just a test
                    const testParam = 'e2e-test';
                    const url = new URL(window.location);
                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                    // Set reCATPCHA token
                    formData.append('recaptcha_token', token);
                    try {
                        const response = await fetch(themeData.ajax_route, {
                            method: 'POST',
                            body: formData
                        });
                        const json = await response.json();
                        if (json.success) resolve(json);
                        else if (json['error-codes']) {
                            /**
								 * reCATPCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ let errorMessages = [];
                            json['error-codes'].forEach((errorCode)=>{
                                switch(errorCode){
                                    case 'missing-input-secret':
                                        errorMessages.push('The secret parameter is missing.');
                                        break;
                                    case 'invalid-input-secret':
                                        errorMessages.push('The secret parameter is invalid or malformed.');
                                        break;
                                    case 'missing-input-response':
                                        errorMessages.push('The response parameter is missing.');
                                        break;
                                    case 'invalid-input-response':
                                        errorMessages.push('The response parameter is invalid or malformed.');
                                        break;
                                    case 'bad-request':
                                        errorMessages.push('The request is invalid or malformed.');
                                        break;
                                    case 'timeout-or-duplicate':
                                        errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                        break;
                                    default:
                                        errorMessages.push('Unknown reCATPCHA error code');
                                }
                            });
                            throw new Error(`There was an error when trying to verify the user's response by reCATPCHA:\n${errorMessages.join('\n')}`);
                        } else if (json.data) throw new Error(`The request to verify the reCAPTCHA user token failed: ${response.data}`);
                        else throw new Error('Unknown error occurred when trying to verify the reCATPCHA user token');
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        });
    } catch (e) {
        console.error(e);
    }
};

});
parcelRegister("6sEQA", function(module, exports) {

$parcel$export(module.exports, "getThemeData", () => $4b450af9f6d18c72$export$3c72f11fd9e5031f);
const $4b450af9f6d18c72$export$3c72f11fd9e5031f = ()=>{
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        const sessionStorageKey = 'themeData';
        return new Promise((resolve, reject)=>{
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then((res)=>res.json()).then((data)=>{
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch((e)=>reject(e));
        });
    }
};

});


parcelRegister("h30hJ", function(module, exports) {

$parcel$export(module.exports, "slideUp", () => $c692f0128d3d0bc1$export$deed561b1a0ff1ea);
$parcel$export(module.exports, "slideDown", () => $c692f0128d3d0bc1$export$abdd11a06a163232);
const $c692f0128d3d0bc1$export$deed561b1a0ff1ea = (target, duration = 500)=>{
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    window.setTimeout(()=>{
        target.style.display = 'none';
        [
            'height',
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$abdd11a06a163232 = (target, duration = 500)=>{
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    display === 'none' && (display = 'block');
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    [
        'padding-top',
        'padding-bottom',
        'margin-top',
        'margin-bottom'
    ].forEach((prop)=>target.style.removeProperty(prop));
    window.setTimeout(()=>{
        [
            'height',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$715de50cedc228a8 = (target, duration = 500)=>window.getComputedStyle(target).display === 'none' ? $c692f0128d3d0bc1$export$abdd11a06a163232(target, duration) : $c692f0128d3d0bc1$export$deed561b1a0ff1ea(target, duration);

});

parcelRegister("jWfAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83f87d19c5951a4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "scrollToElement", () => $e83f87d19c5951a4$export$2353115f31f4d15);
var $e83f87d19c5951a4$export$2e2bcd8739ae039 = ()=>{
    // ! Important: Wait until page has fully loaded before scrolling (#Chrome bug)
    window.addEventListener('load', ()=>{
        if (window.location.hash) {
            window.scrollTo(0, 0);
            setTimeout(()=>{
                $e83f87d19c5951a4$export$2353115f31f4d15(window.location.hash);
            }, 1);
        }
    });
    document.addEventListener('click', function(e) {
        // loop parent nodes from the target to the delegation node
        for(let target = e.target; target && target != this; target = target.parentNode)if (target.matches('a[href^="#"]:not([href="#"]):not([href="#/"]):not(._brlbs-btn)')) {
            e.preventDefault();
            $e83f87d19c5951a4$export$2353115f31f4d15(target.getAttribute('href'));
            break;
        }
    }, false);
};
const $e83f87d19c5951a4$export$2353115f31f4d15 = (selector)=>{
    const targetEl = document.querySelector(selector);
    if (!targetEl) return;
    // Set initial scroll to an offset to increase headroom
    let scrollOffset = 32;
    // Add header height to offset if necessary
    const headerBar = document.querySelector('header.nav');
    scrollOffset += headerBar?.getBoundingClientRect().height || 0;
    // Add height of WP admin bar for logged in users
    if (document.querySelector('#wpadminbar')) scrollOffset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
    // Start scrolling
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top - scrollOffset);
};

});

parcelRegister("hxRak", function(module, exports) {

$parcel$export(module.exports, "waitForElement", () => $cc5ec25473bb8d84$export$1a1c301579a08d1e);
const $cc5ec25473bb8d84$export$1a1c301579a08d1e = (selector)=>{
    return new Promise((resolve)=>{
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver(()=>{
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});


parcelRegister("79Zf3", function(module, exports) {

$parcel$export(module.exports, "Easing", () => Easing);
$parcel$export(module.exports, "Tween", () => Tween);
$parcel$export(module.exports, "update", () => update);
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var Easing = Object.freeze({
    Linear: Object.freeze({
        None: function(amount) {
            return amount;
        },
        In: function(amount) {
            return amount;
        },
        Out: function(amount) {
            return amount;
        },
        InOut: function(amount) {
            return amount;
        }
    }),
    Quadratic: Object.freeze({
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    }),
    Cubic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    }),
    Quartic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    }),
    Quintic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    }),
    Sinusoidal: Object.freeze({
        In: function(amount) {
            return 1 - Math.sin((1.0 - amount) * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.sin(Math.PI * (0.5 - amount)));
        }
    }),
    Exponential: Object.freeze({
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    }),
    Circular: Object.freeze({
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    }),
    Elastic: Object.freeze({
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    }),
    Back: Object.freeze({
        In: function(amount) {
            var s = 1.70158;
            return amount === 1 ? 1 : amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return amount === 0 ? 0 : --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    }),
    Bounce: Object.freeze({
        In: function(amount) {
            return 1 - Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return Easing.Bounce.In(amount * 2) * 0.5;
            return Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    }),
    generatePow: function(power) {
        if (power === void 0) power = 4;
        power = power < Number.EPSILON ? Number.EPSILON : power;
        power = power > 10000 ? 10000 : power;
        return {
            In: function(amount) {
                return Math.pow(amount, power);
            },
            Out: function(amount) {
                return 1 - Math.pow(1 - amount, power);
            },
            InOut: function(amount) {
                if (amount < 0.5) return Math.pow(amount * 2, power) / 2;
                return (1 - Math.pow(2 - amount * 2, power)) / 2 + 0.5;
            }
        };
    }
});
var now = function() {
    return performance.now();
};
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var Group = /** @class */ function() {
    function Group() {
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function(tween) {
        this._tweens[tween.getId()] = tween;
        this._tweensAddedDuringUpdate[tween.getId()] = tween;
    };
    Group.prototype.remove = function(tween) {
        delete this._tweens[tween.getId()];
        delete this._tweensAddedDuringUpdate[tween.getId()];
    };
    Group.prototype.update = function(time, preserve) {
        if (time === void 0) time = now();
        if (preserve === void 0) preserve = false;
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return false;
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                var autoStart = !preserve;
                if (tween && tween.update(time, autoStart) === false && !preserve) delete this._tweens[tweenIds[i]];
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
        return true;
    };
    return Group;
}();
/**
 *
 */ var Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    Sequence._nextId = 0;
    return Sequence;
}();
var mainGroup = new Group();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var Tween = /** @class */ function() {
    function Tween(_object, _group) {
        if (_group === void 0) _group = mainGroup;
        this._object = _object;
        this._group = _group;
        this._isPaused = false;
        this._pauseStart = 0;
        this._valuesStart = {};
        this._valuesEnd = {};
        this._valuesStartRepeat = {};
        this._duration = 1000;
        this._isDynamic = false;
        this._initialRepeat = 0;
        this._repeat = 0;
        this._yoyo = false;
        this._isPlaying = false;
        this._reversed = false;
        this._delayTime = 0;
        this._startTime = 0;
        this._easingFunction = Easing.Linear.None;
        this._interpolationFunction = Interpolation.Linear;
        // eslint-disable-next-line
        this._chainedTweens = [];
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._id = Sequence.nextId();
        this._isChainStopped = false;
        this._propertiesAreSetUp = false;
        this._goToEnd = false;
    }
    Tween.prototype.getId = function() {
        return this._id;
    };
    Tween.prototype.isPlaying = function() {
        return this._isPlaying;
    };
    Tween.prototype.isPaused = function() {
        return this._isPaused;
    };
    Tween.prototype.getDuration = function() {
        return this._duration;
    };
    Tween.prototype.to = function(target, duration) {
        if (duration === void 0) duration = 1000;
        if (this._isPlaying) throw new Error('Can not call Tween.to() while Tween is already started or paused. Stop the Tween first.');
        this._valuesEnd = target;
        this._propertiesAreSetUp = false;
        this._duration = duration < 0 ? 0 : duration;
        return this;
    };
    Tween.prototype.duration = function(duration) {
        if (duration === void 0) duration = 1000;
        this._duration = duration < 0 ? 0 : duration;
        return this;
    };
    Tween.prototype.dynamic = function(dynamic) {
        if (dynamic === void 0) dynamic = false;
        this._isDynamic = dynamic;
        return this;
    };
    Tween.prototype.start = function(time, overrideStartingValues) {
        if (time === void 0) time = now();
        if (overrideStartingValues === void 0) overrideStartingValues = false;
        if (this._isPlaying) return this;
        // eslint-disable-next-line
        this._group && this._group.add(this);
        this._repeat = this._initialRepeat;
        if (this._reversed) {
            // If we were reversed (f.e. using the yoyo feature) then we need to
            // flip the tween direction back to forward.
            this._reversed = false;
            for(var property in this._valuesStartRepeat){
                this._swapEndStartRepeatValues(property);
                this._valuesStart[property] = this._valuesStartRepeat[property];
            }
        }
        this._isPlaying = true;
        this._isPaused = false;
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._isChainStopped = false;
        this._startTime = time;
        this._startTime += this._delayTime;
        if (!this._propertiesAreSetUp || overrideStartingValues) {
            this._propertiesAreSetUp = true;
            // If dynamic is not enabled, clone the end values instead of using the passed-in end values.
            if (!this._isDynamic) {
                var tmp = {};
                for(var prop in this._valuesEnd)tmp[prop] = this._valuesEnd[prop];
                this._valuesEnd = tmp;
            }
            this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat, overrideStartingValues);
        }
        return this;
    };
    Tween.prototype.startFromCurrentValues = function(time) {
        return this.start(time, true);
    };
    Tween.prototype._setupProperties = function(_object, _valuesStart, _valuesEnd, _valuesStartRepeat, overrideStartingValues) {
        for(var property in _valuesEnd){
            var startValue = _object[property];
            var startValueIsArray = Array.isArray(startValue);
            var propType = startValueIsArray ? 'array' : typeof startValue;
            var isInterpolationList = !startValueIsArray && Array.isArray(_valuesEnd[property]);
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (propType === 'undefined' || propType === 'function') continue;
            // Check if an Array was provided as property value
            if (isInterpolationList) {
                var endValues = _valuesEnd[property];
                if (endValues.length === 0) continue;
                // Handle an array of relative values.
                // Creates a local copy of the Array with the start value at the front
                var temp = [
                    startValue
                ];
                for(var i = 0, l = endValues.length; i < l; i += 1){
                    var value = this._handleRelativeValue(startValue, endValues[i]);
                    if (isNaN(value)) {
                        isInterpolationList = false;
                        console.warn('Found invalid interpolation list. Skipping.');
                        break;
                    }
                    temp.push(value);
                }
                if (isInterpolationList) // if (_valuesStart[property] === undefined) { // handle end values only the first time. NOT NEEDED? setupProperties is now guarded by _propertiesAreSetUp.
                _valuesEnd[property] = temp;
            }
            // handle the deepness of the values
            if ((propType === 'object' || startValueIsArray) && startValue && !isInterpolationList) {
                _valuesStart[property] = startValueIsArray ? [] : {};
                var nestedObject = startValue;
                for(var prop in nestedObject)_valuesStart[property][prop] = nestedObject[prop];
                // TODO? repeat nested values? And yoyo? And array values?
                _valuesStartRepeat[property] = startValueIsArray ? [] : {};
                var endValues = _valuesEnd[property];
                // If dynamic is not enabled, clone the end values instead of using the passed-in end values.
                if (!this._isDynamic) {
                    var tmp = {};
                    for(var prop in endValues)tmp[prop] = endValues[prop];
                    _valuesEnd[property] = endValues = tmp;
                }
                this._setupProperties(nestedObject, _valuesStart[property], endValues, _valuesStartRepeat[property], overrideStartingValues);
            } else {
                // Save the starting value, but only once unless override is requested.
                if (typeof _valuesStart[property] === 'undefined' || overrideStartingValues) _valuesStart[property] = startValue;
                if (!startValueIsArray) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                if (isInterpolationList) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStartRepeat[property] = _valuesEnd[property].slice().reverse();
                else _valuesStartRepeat[property] = _valuesStart[property] || 0;
            }
        }
    };
    Tween.prototype.stop = function() {
        if (!this._isChainStopped) {
            this._isChainStopped = true;
            this.stopChainedTweens();
        }
        if (!this._isPlaying) return this;
        // eslint-disable-next-line
        this._group && this._group.remove(this);
        this._isPlaying = false;
        this._isPaused = false;
        if (this._onStopCallback) this._onStopCallback(this._object);
        return this;
    };
    Tween.prototype.end = function() {
        this._goToEnd = true;
        this.update(Infinity);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (time === void 0) time = now();
        if (this._isPaused || !this._isPlaying) return this;
        this._isPaused = true;
        this._pauseStart = time;
        // eslint-disable-next-line
        this._group && this._group.remove(this);
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (time === void 0) time = now();
        if (!this._isPaused || !this._isPlaying) return this;
        this._isPaused = false;
        this._startTime += time - this._pauseStart;
        this._pauseStart = 0;
        // eslint-disable-next-line
        this._group && this._group.add(this);
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)this._chainedTweens[i].stop();
        return this;
    };
    Tween.prototype.group = function(group) {
        if (group === void 0) group = mainGroup;
        this._group = group;
        return this;
    };
    Tween.prototype.delay = function(amount) {
        if (amount === void 0) amount = 0;
        this._delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        if (times === void 0) times = 0;
        this._initialRepeat = times;
        this._repeat = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this._repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        if (yoyo === void 0) yoyo = false;
        this._yoyo = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easingFunction) {
        if (easingFunction === void 0) easingFunction = Easing.Linear.None;
        this._easingFunction = easingFunction;
        return this;
    };
    Tween.prototype.interpolation = function(interpolationFunction) {
        if (interpolationFunction === void 0) interpolationFunction = Interpolation.Linear;
        this._interpolationFunction = interpolationFunction;
        return this;
    };
    // eslint-disable-next-line
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this._onStartCallback = callback;
        return this;
    };
    Tween.prototype.onEveryStart = function(callback) {
        this._onEveryStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this._onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this._onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this._onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this._onStopCallback = callback;
        return this;
    };
    /**
     * @returns true if the tween is still playing after the update, false
     * otherwise (calling update on a paused tween still returns true because
     * it is still playing, just paused).
     */ Tween.prototype.update = function(time, autoStart) {
        var _this = this;
        var _a;
        if (time === void 0) time = now();
        if (autoStart === void 0) autoStart = true;
        if (this._isPaused) return true;
        var property;
        var endTime = this._startTime + this._duration;
        if (!this._goToEnd && !this._isPlaying) {
            if (time > endTime) return false;
            if (autoStart) this.start(time, true);
        }
        this._goToEnd = false;
        if (time < this._startTime) return true;
        if (this._onStartCallbackFired === false) {
            if (this._onStartCallback) this._onStartCallback(this._object);
            this._onStartCallbackFired = true;
        }
        if (this._onEveryStartCallbackFired === false) {
            if (this._onEveryStartCallback) this._onEveryStartCallback(this._object);
            this._onEveryStartCallbackFired = true;
        }
        var elapsedTime = time - this._startTime;
        var durationAndDelay = this._duration + ((_a = this._repeatDelayTime) !== null && _a !== void 0 ? _a : this._delayTime);
        var totalTime = this._duration + this._repeat * durationAndDelay;
        var calculateElapsedPortion = function() {
            if (_this._duration === 0) return 1;
            if (elapsedTime > totalTime) return 1;
            var timesRepeated = Math.trunc(elapsedTime / durationAndDelay);
            var timeIntoCurrentRepeat = elapsedTime - timesRepeated * durationAndDelay;
            // TODO use %?
            // const timeIntoCurrentRepeat = elapsedTime % durationAndDelay
            var portion = Math.min(timeIntoCurrentRepeat / _this._duration, 1);
            if (portion === 0 && elapsedTime === _this._duration) return 1;
            return portion;
        };
        var elapsed = calculateElapsedPortion();
        var value = this._easingFunction(elapsed);
        // properties transformations
        this._updateProperties(this._object, this._valuesStart, this._valuesEnd, value);
        if (this._onUpdateCallback) this._onUpdateCallback(this._object, elapsed);
        if (this._duration === 0 || elapsedTime >= this._duration) {
            if (this._repeat > 0) {
                var completeCount = Math.min(Math.trunc((elapsedTime - this._duration) / durationAndDelay) + 1, this._repeat);
                if (isFinite(this._repeat)) this._repeat -= completeCount;
                // Reassign starting values, restart by making startTime = now
                for(property in this._valuesStartRepeat){
                    if (!this._yoyo && typeof this._valuesEnd[property] === 'string') this._valuesStartRepeat[property] = // eslint-disable-next-line
                    // @ts-ignore FIXME?
                    this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
                    if (this._yoyo) this._swapEndStartRepeatValues(property);
                    this._valuesStart[property] = this._valuesStartRepeat[property];
                }
                if (this._yoyo) this._reversed = !this._reversed;
                this._startTime += durationAndDelay * completeCount;
                if (this._onRepeatCallback) this._onRepeatCallback(this._object);
                this._onEveryStartCallbackFired = false;
                return true;
            } else {
                if (this._onCompleteCallback) this._onCompleteCallback(this._object);
                for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this._chainedTweens[i].start(this._startTime + this._duration, false);
                this._isPlaying = false;
                return false;
            }
        }
        return true;
    };
    Tween.prototype._updateProperties = function(_object, _valuesStart, _valuesEnd, value) {
        for(var property in _valuesEnd){
            // Don't update properties that do not exist in the source object
            if (_valuesStart[property] === undefined) continue;
            var start = _valuesStart[property] || 0;
            var end = _valuesEnd[property];
            var startIsArray = Array.isArray(_object[property]);
            var endIsArray = Array.isArray(end);
            var isInterpolationList = !startIsArray && endIsArray;
            if (isInterpolationList) _object[property] = this._interpolationFunction(end, value);
            else if (typeof end === 'object' && end) // eslint-disable-next-line
            // @ts-ignore FIXME?
            this._updateProperties(_object[property], start, end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                end = this._handleRelativeValue(start, end);
                // Protect against non numeric properties.
                if (typeof end === 'number') // eslint-disable-next-line
                // @ts-ignore FIXME?
                _object[property] = start + (end - start) * value;
            }
        }
    };
    Tween.prototype._handleRelativeValue = function(start, end) {
        if (typeof end !== 'string') return end;
        if (end.charAt(0) === '+' || end.charAt(0) === '-') return start + parseFloat(end);
        return parseFloat(end);
    };
    Tween.prototype._swapEndStartRepeatValues = function(property) {
        var tmp = this._valuesStartRepeat[property];
        var endValue = this._valuesEnd[property];
        if (typeof endValue === 'string') this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(endValue);
        else this._valuesStartRepeat[property] = this._valuesEnd[property];
        this._valuesEnd[property] = tmp;
    };
    return Tween;
}();
var VERSION = '23.1.3';
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var nextId = Sequence.nextId;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tweens.
 */ var TWEEN = mainGroup;
// This is the best way to export things in a way that's compatible with both ES
// Modules and CommonJS, without build hacks, and so as not to break the
// existing API.
// https://github.com/rollup/rollup/issues/1961#issuecomment-423037881
var getAll = TWEEN.getAll.bind(TWEEN);
var removeAll = TWEEN.removeAll.bind(TWEEN);
var add = TWEEN.add.bind(TWEEN);
var remove = TWEEN.remove.bind(TWEEN);
var update = TWEEN.update.bind(TWEEN);
var exports = {
    Easing: Easing,
    Group: Group,
    Interpolation: Interpolation,
    now: now,
    Sequence: Sequence,
    nextId: nextId,
    Tween: Tween,
    VERSION: VERSION,
    getAll: getAll,
    removeAll: removeAll,
    add: add,
    remove: remove,
    update: update
};

});

parcelRegister("ZZsCE", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $iQ3ws = parcelRequire("iQ3ws");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $iQ3ws.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $iQ3ws.default)(Rgb, rgb, (0, $iQ3ws.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $iQ3ws.default)(Hsl, hsl, (0, $iQ3ws.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("iQ3ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $db6fd0cf5803d845$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $db6fd0cf5803d845$export$8b58be045bf06082);
function $db6fd0cf5803d845$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $db6fd0cf5803d845$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("bvJM2", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "toArray", () => toArray);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_setDefaults", () => _setDefaults);
$parcel$export(module.exports, "_removeLinkedListItem", () => _removeLinkedListItem);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "Timeline", () => Timeline);
$parcel$export(module.exports, "Tween", () => Tween);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "clamp", () => clamp);
$parcel$export(module.exports, "selector", () => selector);
$parcel$export(module.exports, "shuffle", () => shuffle);
$parcel$export(module.exports, "distribute", () => distribute);
$parcel$export(module.exports, "_roundModifier", () => _roundModifier);
$parcel$export(module.exports, "snap", () => snap);
$parcel$export(module.exports, "random", () => random);
$parcel$export(module.exports, "pipe", () => pipe);
$parcel$export(module.exports, "unitize", () => unitize);
$parcel$export(module.exports, "normalize", () => normalize);
$parcel$export(module.exports, "mapRange", () => mapRange);
$parcel$export(module.exports, "wrap", () => wrap);
$parcel$export(module.exports, "wrapYoyo", () => wrapYoyo);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "interpolate", () => interpolate);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "splitColor", () => splitColor);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "Animation", () => Animation);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
$parcel$export(module.exports, "Power0", () => Power0);
$parcel$export(module.exports, "Power1", () => Power1);
$parcel$export(module.exports, "Power2", () => Power2);
$parcel$export(module.exports, "Power3", () => Power3);
$parcel$export(module.exports, "Power4", () => Power4);
$parcel$export(module.exports, "Linear", () => Linear);
$parcel$export(module.exports, "Quad", () => Quad);
$parcel$export(module.exports, "Cubic", () => Cubic);
$parcel$export(module.exports, "Quart", () => Quart);
$parcel$export(module.exports, "Quint", () => Quint);
$parcel$export(module.exports, "Strong", () => Strong);
$parcel$export(module.exports, "Elastic", () => Elastic);
$parcel$export(module.exports, "Back", () => Back);
$parcel$export(module.exports, "SteppedEase", () => SteppedEase);
$parcel$export(module.exports, "Bounce", () => Bounce);
$parcel$export(module.exports, "Sine", () => Sine);
$parcel$export(module.exports, "Expo", () => Expo);
$parcel$export(module.exports, "Circ", () => Circ);
$parcel$export(module.exports, "TweenMax", () => Tween);
$parcel$export(module.exports, "TweenLite", () => Tween);
$parcel$export(module.exports, "TimelineMax", () => Timeline);
$parcel$export(module.exports, "TimelineLite", () => Timeline);
$parcel$export(module.exports, "default", () => gsap);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.13.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $8725869b83961a04$export$3545e07a80636437 = '168';
const $8725869b83961a04$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $8725869b83961a04$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $8725869b83961a04$export$3237e1f2c1ea1f44 = 0;
const $8725869b83961a04$export$b9a7b4fc5cb15f9b = 1;
const $8725869b83961a04$export$b8058bcc7037d3f3 = 2;
const $8725869b83961a04$export$f24be24dcddeac0d = 3;
const $8725869b83961a04$export$346307dbae2b7447 = 0;
const $8725869b83961a04$export$5813f879eee7cd88 = 1;
const $8725869b83961a04$export$a47c4b43a1be34f0 = 2;
const $8725869b83961a04$export$896ae1ade6c829c4 = 3;
const $8725869b83961a04$export$2ede184fc2998901 = 0;
const $8725869b83961a04$export$d9f0486e75b5ace = 1;
const $8725869b83961a04$export$3b296b6f144d5b03 = 2;
const $8725869b83961a04$export$63b8d6b580fc65ba = 0;
const $8725869b83961a04$export$5b29a26d96ee6af0 = 1;
const $8725869b83961a04$export$777d8f9551c2216b = 2;
const $8725869b83961a04$export$cdfa06f868e2e467 = 3;
const $8725869b83961a04$export$4138e1c684b46a20 = 4;
const $8725869b83961a04$export$eda4864c68df1fa2 = 5;
const $8725869b83961a04$export$20183a0484ce21a0 = 100;
const $8725869b83961a04$export$73e0df5177988548 = 101;
const $8725869b83961a04$export$28e582859cbec660 = 102;
const $8725869b83961a04$export$c8c1508da8d0600c = 103;
const $8725869b83961a04$export$99948c02fb51055f = 104;
const $8725869b83961a04$export$2110f05edf778d3d = 200;
const $8725869b83961a04$export$8805bad65e24940e = 201;
const $8725869b83961a04$export$7fbe15b28d28cf52 = 202;
const $8725869b83961a04$export$947829af9f2c17f6 = 203;
const $8725869b83961a04$export$d5773124e86cf28c = 204;
const $8725869b83961a04$export$11d468cc7f19e971 = 205;
const $8725869b83961a04$export$a78aed1ca2a87192 = 206;
const $8725869b83961a04$export$5d0fe17fd8773bac = 207;
const $8725869b83961a04$export$ef5f2dd8ffac5574 = 208;
const $8725869b83961a04$export$56b85b2686ab16 = 209;
const $8725869b83961a04$export$c05e2a1fc8609506 = 210;
const $8725869b83961a04$export$7dd8f434fd59075 = 211;
const $8725869b83961a04$export$99c8d898a9afbcee = 212;
const $8725869b83961a04$export$310cd2be38d13b56 = 213;
const $8725869b83961a04$export$db77b8fbcf45dbf4 = 214;
const $8725869b83961a04$export$69025ce147cee220 = 0;
const $8725869b83961a04$export$7182eb52ea3b3f04 = 1;
const $8725869b83961a04$export$eedccec66ab7ebe = 2;
const $8725869b83961a04$export$296f78a0b892f81a = 3;
const $8725869b83961a04$export$a60d398fc7b7590e = 4;
const $8725869b83961a04$export$7d7234c1240a1fc4 = 5;
const $8725869b83961a04$export$c5e2c52991f30937 = 6;
const $8725869b83961a04$export$2f843afa843d8916 = 7;
const $8725869b83961a04$export$e50ac29801f1774d = 0;
const $8725869b83961a04$export$9f9d94f963c85479 = 1;
const $8725869b83961a04$export$e641dc52bc3494aa = 2;
const $8725869b83961a04$export$9fcb6b4294603b2 = 0;
const $8725869b83961a04$export$98f52c2a46c598ca = 1;
const $8725869b83961a04$export$74b25e54b3bcd548 = 2;
const $8725869b83961a04$export$932b3dd283d4a366 = 3;
const $8725869b83961a04$export$a0d98fe6d7e4af64 = 4;
const $8725869b83961a04$export$2c7b09c1e9abfb5e = 5;
const $8725869b83961a04$export$212d53a513a325b2 = 6;
const $8725869b83961a04$export$f2863e1668a8e317 = 7;
const $8725869b83961a04$export$2595a3798997538 = 'attached';
const $8725869b83961a04$export$d7e7dc2e114517a0 = 'detached';
const $8725869b83961a04$export$1beec6768cbb3d2d = 300;
const $8725869b83961a04$export$8759762a6477f2c4 = 301;
const $8725869b83961a04$export$dc59f8aed047f61d = 302;
const $8725869b83961a04$export$d64030b316d3b087 = 303;
const $8725869b83961a04$export$ee99d97d46898098 = 304;
const $8725869b83961a04$export$dbf3e70ff37af79 = 306;
const $8725869b83961a04$export$533346c8e8dac0f5 = 1000;
const $8725869b83961a04$export$9d9334239a5a5e06 = 1001;
const $8725869b83961a04$export$c7e7c00b14f51a4f = 1002;
const $8725869b83961a04$export$727aa5ec3fe39bf0 = 1003;
const $8725869b83961a04$export$d129e38cf6feaa8c = 1004;
const $8725869b83961a04$export$14a4936464a36496 = 1004;
const $8725869b83961a04$export$d2327c1afe5bfdf2 = 1005;
const $8725869b83961a04$export$cbc5b7f5647595d8 = 1005;
const $8725869b83961a04$export$8a72f490b25c56c8 = 1006;
const $8725869b83961a04$export$19a719f377145a13 = 1007;
const $8725869b83961a04$export$dbe96bee3fe9dbf0 = 1007;
const $8725869b83961a04$export$5d8599b6a933fb1b = 1008;
const $8725869b83961a04$export$90d80f1e3506775f = 1008;
const $8725869b83961a04$export$2e8ce08d3f6f5e10 = 1009;
const $8725869b83961a04$export$545fce0311a9796a = 1010;
const $8725869b83961a04$export$88572337f312435f = 1011;
const $8725869b83961a04$export$c63dc51868b06a9d = 1012;
const $8725869b83961a04$export$5c612977753abe2 = 1013;
const $8725869b83961a04$export$c3c7fc4518ebba96 = 1014;
const $8725869b83961a04$export$f6d331659b644596 = 1015;
const $8725869b83961a04$export$2697304443f382bc = 1016;
const $8725869b83961a04$export$b3969b01faf587f2 = 1017;
const $8725869b83961a04$export$18886f8ae33e90de = 1018;
const $8725869b83961a04$export$6c8ea339bfab1301 = 1020;
const $8725869b83961a04$export$5a4c329b7e2092d3 = 35902;
const $8725869b83961a04$export$988473390501ed4b = 1021;
const $8725869b83961a04$export$7c67423a5ee6f5eb = 1022;
const $8725869b83961a04$export$3f8bb04b555a363c = 1023;
const $8725869b83961a04$export$cc09ccbf6d1ed449 = 1024;
const $8725869b83961a04$export$9053a81c4a69c289 = 1025;
const $8725869b83961a04$export$c1b6b5136be58045 = 1026;
const $8725869b83961a04$export$1e113ac2d0905829 = 1027;
const $8725869b83961a04$export$4e041a7967d15c4b = 1028;
const $8725869b83961a04$export$aa92e870a709d190 = 1029;
const $8725869b83961a04$export$6cdf0b461c7ce8a0 = 1030;
const $8725869b83961a04$export$1ba1c45f9f77d4d7 = 1031;
const $8725869b83961a04$export$d1fd40c11bfa798e = 1032;
const $8725869b83961a04$export$c200e7d26f592f21 = 1033;
const $8725869b83961a04$export$21d1799c6d552fc0 = 33776;
const $8725869b83961a04$export$afa304c3e981b668 = 33777;
const $8725869b83961a04$export$d2a1a68024a3e56c = 33778;
const $8725869b83961a04$export$9a79c424327dacf9 = 33779;
const $8725869b83961a04$export$19ada9bbb1af3573 = 35840;
const $8725869b83961a04$export$d0f0355bb3d948e4 = 35841;
const $8725869b83961a04$export$b82296714358084c = 35842;
const $8725869b83961a04$export$b71692456c47b6c3 = 35843;
const $8725869b83961a04$export$6ab91af2d757aee7 = 36196;
const $8725869b83961a04$export$7800993ef8106a6a = 37492;
const $8725869b83961a04$export$23ed8300a860e7d8 = 37496;
const $8725869b83961a04$export$dc5570b4a2b92d48 = 37808;
const $8725869b83961a04$export$68880cd325f8b2fb = 37809;
const $8725869b83961a04$export$7d2c0be323373d95 = 37810;
const $8725869b83961a04$export$22b52da301fc3a3e = 37811;
const $8725869b83961a04$export$c009e2cb4a66485e = 37812;
const $8725869b83961a04$export$118fff5afa255b63 = 37813;
const $8725869b83961a04$export$120713c829ae0667 = 37814;
const $8725869b83961a04$export$c79eeabbf53313e9 = 37815;
const $8725869b83961a04$export$443cf6567cdd6424 = 37816;
const $8725869b83961a04$export$6573984fc9840780 = 37817;
const $8725869b83961a04$export$e7aee563f30091de = 37818;
const $8725869b83961a04$export$2eb8634622ddeab7 = 37819;
const $8725869b83961a04$export$202b1ce7b5d25742 = 37820;
const $8725869b83961a04$export$18ab77abd087e467 = 37821;
const $8725869b83961a04$export$ce40b115e188bc81 = 36492;
const $8725869b83961a04$export$d279c5c4bac5121e = 36494;
const $8725869b83961a04$export$cde52d17225fdbd3 = 36495;
const $8725869b83961a04$export$b1688df4c4c21670 = 36283;
const $8725869b83961a04$export$fc15e5d8261eed58 = 36284;
const $8725869b83961a04$export$d220f6ade8463a0f = 36285;
const $8725869b83961a04$export$768646d09dc1b6ef = 36286;
const $8725869b83961a04$export$d62fdc9d1b1cccad = 2200;
const $8725869b83961a04$export$dfaf4422ce096e29 = 2201;
const $8725869b83961a04$export$f8f6f2041b78e210 = 2202;
const $8725869b83961a04$export$995b32462a65e855 = 2300;
const $8725869b83961a04$export$30fac1aace31cf4d = 2301;
const $8725869b83961a04$export$198b11ff4c72bb30 = 2302;
const $8725869b83961a04$export$7f795934b84ab523 = 2400;
const $8725869b83961a04$export$24a4ccb5099273b5 = 2401;
const $8725869b83961a04$export$8e8c3ecdcd8e1fee = 2402;
const $8725869b83961a04$export$bcfbbdcf8de7f8cd = 2500;
const $8725869b83961a04$export$d875e029ef558d3 = 2501;
const $8725869b83961a04$export$4c28c87c2dc84758 = 0;
const $8725869b83961a04$export$b23a071aa286eb29 = 1;
const $8725869b83961a04$export$f0d8293634f88842 = 2;
const $8725869b83961a04$export$deeb383078690b50 = 3200;
const $8725869b83961a04$export$8f910f4c4f73df11 = 3201;
const $8725869b83961a04$export$be2e2ddbc3983173 = 3202;
const $8725869b83961a04$export$1a54198784742f80 = 3203;
const $8725869b83961a04$export$2852a58ebdac27b8 = 0;
const $8725869b83961a04$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $8725869b83961a04$export$bfcb490c2dd3db51 = '';
const $8725869b83961a04$export$561f394b24edfcaa = 'srgb';
const $8725869b83961a04$export$42429b3acfb233a4 = 'srgb-linear';
const $8725869b83961a04$export$626af19ae879bdf6 = 'display-p3';
const $8725869b83961a04$export$c0dc1bc7e964761 = 'display-p3-linear';
const $8725869b83961a04$export$f197347d588c1b4a = 'linear';
const $8725869b83961a04$export$8d0a61916cc26abb = 'srgb';
const $8725869b83961a04$export$ce9118f9eaae3bb2 = 'rec709';
const $8725869b83961a04$export$ef371755dbe7f98a = 'p3';
const $8725869b83961a04$export$69433f11f42d5527 = 0;
const $8725869b83961a04$export$9f542ae4b5baca34 = 7680;
const $8725869b83961a04$export$8a4f28336ef203d3 = 7681;
const $8725869b83961a04$export$2928c0231297c036 = 7682;
const $8725869b83961a04$export$c0e9611c8a15f9a8 = 7683;
const $8725869b83961a04$export$9c2c08927385dcc4 = 34055;
const $8725869b83961a04$export$7c74ea00fa1315e6 = 34056;
const $8725869b83961a04$export$22e2e5726612443 = 5386;
const $8725869b83961a04$export$1343870698229224 = 512;
const $8725869b83961a04$export$8e1d8ed281997fa6 = 513;
const $8725869b83961a04$export$55648a1cde8329a7 = 514;
const $8725869b83961a04$export$2dff107857e6aca2 = 515;
const $8725869b83961a04$export$6f93765ab2f451a2 = 516;
const $8725869b83961a04$export$6f3fb2d2440f2b76 = 517;
const $8725869b83961a04$export$4119cf7b4c98fd5a = 518;
const $8725869b83961a04$export$14cf96713ddd97a8 = 519;
const $8725869b83961a04$export$d9e2d19a747baaab = 512;
const $8725869b83961a04$export$36bcf49c713b3eb7 = 513;
const $8725869b83961a04$export$66f28d946fc6a0d5 = 514;
const $8725869b83961a04$export$64eea11eb407ddf1 = 515;
const $8725869b83961a04$export$155af022118f3a38 = 516;
const $8725869b83961a04$export$67ab95dde6bed156 = 517;
const $8725869b83961a04$export$1cdcb70d53d65f61 = 518;
const $8725869b83961a04$export$187b73a3e352c145 = 519;
const $8725869b83961a04$export$763e8360f4d7f77d = 35044;
const $8725869b83961a04$export$8505d14ac8546ca = 35048;
const $8725869b83961a04$export$721e63549e51d81e = 35040;
const $8725869b83961a04$export$415731dc4f48e299 = 35045;
const $8725869b83961a04$export$9e809946455f13bc = 35049;
const $8725869b83961a04$export$2ed9499a35b5f832 = 35041;
const $8725869b83961a04$export$32ab2503ea19469a = 35046;
const $8725869b83961a04$export$ab4022c2c3f86315 = 35050;
const $8725869b83961a04$export$ba7f1db36a76a970 = 35042;
const $8725869b83961a04$export$43600cc67fabd9f = '100';
const $8725869b83961a04$export$f63012db5506e7dd = '300 es';
const $8725869b83961a04$export$5a0e9190d10875d3 = 2000;
const $8725869b83961a04$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $8725869b83961a04$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $8725869b83961a04$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $8725869b83961a04$var$_seed = 1234567;
const $8725869b83961a04$var$DEG2RAD = Math.PI / 180;
const $8725869b83961a04$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $8725869b83961a04$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $8725869b83961a04$var$_lut[d0 & 0xff] + $8725869b83961a04$var$_lut[d0 >> 8 & 0xff] + $8725869b83961a04$var$_lut[d0 >> 16 & 0xff] + $8725869b83961a04$var$_lut[d0 >> 24 & 0xff] + '-' + $8725869b83961a04$var$_lut[d1 & 0xff] + $8725869b83961a04$var$_lut[d1 >> 8 & 0xff] + '-' + $8725869b83961a04$var$_lut[d1 >> 16 & 0x0f | 0x40] + $8725869b83961a04$var$_lut[d1 >> 24 & 0xff] + '-' + $8725869b83961a04$var$_lut[d2 & 0x3f | 0x80] + $8725869b83961a04$var$_lut[d2 >> 8 & 0xff] + '-' + $8725869b83961a04$var$_lut[d2 >> 16 & 0xff] + $8725869b83961a04$var$_lut[d2 >> 24 & 0xff] + $8725869b83961a04$var$_lut[d3 & 0xff] + $8725869b83961a04$var$_lut[d3 >> 8 & 0xff] + $8725869b83961a04$var$_lut[d3 >> 16 & 0xff] + $8725869b83961a04$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $8725869b83961a04$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $8725869b83961a04$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $8725869b83961a04$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $8725869b83961a04$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $8725869b83961a04$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $8725869b83961a04$var$damp(x, y, lambda, dt) {
    return $8725869b83961a04$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $8725869b83961a04$var$pingpong(x, length = 1) {
    return length - Math.abs($8725869b83961a04$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $8725869b83961a04$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $8725869b83961a04$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $8725869b83961a04$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $8725869b83961a04$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $8725869b83961a04$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $8725869b83961a04$var$seededRandom(s) {
    if (s !== undefined) $8725869b83961a04$var$_seed = s;
    // Mulberry32 generator
    let t = $8725869b83961a04$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $8725869b83961a04$var$degToRad(degrees) {
    return degrees * $8725869b83961a04$var$DEG2RAD;
}
function $8725869b83961a04$var$radToDeg(radians) {
    return radians * $8725869b83961a04$var$RAD2DEG;
}
function $8725869b83961a04$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $8725869b83961a04$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $8725869b83961a04$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $8725869b83961a04$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $8725869b83961a04$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $8725869b83961a04$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $8725869b83961a04$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $8725869b83961a04$var$DEG2RAD,
    RAD2DEG: $8725869b83961a04$var$RAD2DEG,
    generateUUID: $8725869b83961a04$var$generateUUID,
    clamp: $8725869b83961a04$var$clamp,
    euclideanModulo: $8725869b83961a04$var$euclideanModulo,
    mapLinear: $8725869b83961a04$var$mapLinear,
    inverseLerp: $8725869b83961a04$var$inverseLerp,
    lerp: $8725869b83961a04$var$lerp,
    damp: $8725869b83961a04$var$damp,
    pingpong: $8725869b83961a04$var$pingpong,
    smoothstep: $8725869b83961a04$var$smoothstep,
    smootherstep: $8725869b83961a04$var$smootherstep,
    randInt: $8725869b83961a04$var$randInt,
    randFloat: $8725869b83961a04$var$randFloat,
    randFloatSpread: $8725869b83961a04$var$randFloatSpread,
    seededRandom: $8725869b83961a04$var$seededRandom,
    degToRad: $8725869b83961a04$var$degToRad,
    radToDeg: $8725869b83961a04$var$radToDeg,
    isPowerOfTwo: $8725869b83961a04$var$isPowerOfTwo,
    ceilPowerOfTwo: $8725869b83961a04$var$ceilPowerOfTwo,
    floorPowerOfTwo: $8725869b83961a04$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $8725869b83961a04$var$setQuaternionFromProperEuler,
    normalize: $8725869b83961a04$var$normalize,
    denormalize: $8725869b83961a04$var$denormalize
};
class $8725869b83961a04$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $8725869b83961a04$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($8725869b83961a04$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $8725869b83961a04$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $8725869b83961a04$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($8725869b83961a04$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($8725869b83961a04$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($8725869b83961a04$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $8725869b83961a04$var$_m3 = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918();
function $8725869b83961a04$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $8725869b83961a04$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $8725869b83961a04$var$getTypedArray(type, buffer) {
    return new $8725869b83961a04$var$TYPED_ARRAYS[type](buffer);
}
function $8725869b83961a04$var$createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $8725869b83961a04$export$1033a2df66368859() {
    const canvas = $8725869b83961a04$var$createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $8725869b83961a04$var$_cache = {};
function $8725869b83961a04$var$warnOnce(message) {
    if (message in $8725869b83961a04$var$_cache) return;
    $8725869b83961a04$var$_cache[message] = true;
    console.warn(message);
}
function $8725869b83961a04$var$probeAsync(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $8725869b83961a04$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918().set(0.8224621, 0.177538, 0.0, 0.0331941, 0.9668058, 0.0, 0.0170827, 0.0723974, 0.9105199);
const $8725869b83961a04$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918().set(1.2249401, -0.2249404, 0.0, -0.0420569, 1.0420571, 0.0, -0.0196376, -0.0786361, 1.0982735);
/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */ const $8725869b83961a04$var$COLOR_SPACES = {
    [$8725869b83961a04$export$42429b3acfb233a4]: {
        transfer: $8725869b83961a04$export$f197347d588c1b4a,
        primaries: $8725869b83961a04$export$ce9118f9eaae3bb2,
        luminanceCoefficients: [
            0.2126,
            0.7152,
            0.0722
        ],
        toReference: (color)=>color,
        fromReference: (color)=>color
    },
    [$8725869b83961a04$export$561f394b24edfcaa]: {
        transfer: $8725869b83961a04$export$8d0a61916cc26abb,
        primaries: $8725869b83961a04$export$ce9118f9eaae3bb2,
        luminanceCoefficients: [
            0.2126,
            0.7152,
            0.0722
        ],
        toReference: (color)=>color.convertSRGBToLinear(),
        fromReference: (color)=>color.convertLinearToSRGB()
    },
    [$8725869b83961a04$export$c0dc1bc7e964761]: {
        transfer: $8725869b83961a04$export$f197347d588c1b4a,
        primaries: $8725869b83961a04$export$ef371755dbe7f98a,
        luminanceCoefficients: [
            0.2289,
            0.6917,
            0.0793
        ],
        toReference: (color)=>color.applyMatrix3($8725869b83961a04$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($8725869b83961a04$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3)
    },
    [$8725869b83961a04$export$626af19ae879bdf6]: {
        transfer: $8725869b83961a04$export$8d0a61916cc26abb,
        primaries: $8725869b83961a04$export$ef371755dbe7f98a,
        luminanceCoefficients: [
            0.2289,
            0.6917,
            0.0793
        ],
        toReference: (color)=>color.convertSRGBToLinear().applyMatrix3($8725869b83961a04$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($8725869b83961a04$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB()
    }
};
const $8725869b83961a04$var$SUPPORTED_WORKING_COLOR_SPACES = new Set([
    $8725869b83961a04$export$42429b3acfb233a4,
    $8725869b83961a04$export$c0dc1bc7e964761
]);
const $8725869b83961a04$export$5e6fd513f44698c = {
    enabled: true,
    _workingColorSpace: $8725869b83961a04$export$42429b3acfb233a4,
    get workingColorSpace () {
        return this._workingColorSpace;
    },
    set workingColorSpace (colorSpace){
        if (!$8725869b83961a04$var$SUPPORTED_WORKING_COLOR_SPACES.has(colorSpace)) throw new Error(`Unsupported working color space, "${colorSpace}".`);
        this._workingColorSpace = colorSpace;
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToReference = $8725869b83961a04$var$COLOR_SPACES[sourceColorSpace].toReference;
        const targetFromReference = $8725869b83961a04$var$COLOR_SPACES[targetColorSpace].fromReference;
        return targetFromReference(sourceToReference(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this._workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this._workingColorSpace);
    },
    getPrimaries: function(colorSpace1) {
        return $8725869b83961a04$var$COLOR_SPACES[colorSpace1].primaries;
    },
    getTransfer: function(colorSpace1) {
        if (colorSpace1 === $8725869b83961a04$export$bfcb490c2dd3db51) return $8725869b83961a04$export$f197347d588c1b4a;
        return $8725869b83961a04$var$COLOR_SPACES[colorSpace1].transfer;
    },
    getLuminanceCoefficients: function(target, colorSpace1 = this._workingColorSpace) {
        return target.fromArray($8725869b83961a04$var$COLOR_SPACES[colorSpace1].luminanceCoefficients);
    }
};
function $8725869b83961a04$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $8725869b83961a04$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $8725869b83961a04$var$_canvas;
class $8725869b83961a04$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($8725869b83961a04$var$_canvas === undefined) $8725869b83961a04$var$_canvas = $8725869b83961a04$var$createElementNS('canvas');
            $8725869b83961a04$var$_canvas.width = image.width;
            $8725869b83961a04$var$_canvas.height = image.height;
            const context = $8725869b83961a04$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $8725869b83961a04$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $8725869b83961a04$var$createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $8725869b83961a04$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($8725869b83961a04$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $8725869b83961a04$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $8725869b83961a04$var$_sourceId = 0;
class $8725869b83961a04$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $8725869b83961a04$var$_sourceId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($8725869b83961a04$var$serializeImage(data[i].image));
                else url.push($8725869b83961a04$var$serializeImage(data[i]));
            } else // texture
            url = $8725869b83961a04$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $8725869b83961a04$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $8725869b83961a04$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $8725869b83961a04$var$_textureId = 0;
class $8725869b83961a04$export$5431306cf43de24a extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(image = $8725869b83961a04$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $8725869b83961a04$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $8725869b83961a04$export$9d9334239a5a5e06, wrapT = $8725869b83961a04$export$9d9334239a5a5e06, magFilter = $8725869b83961a04$export$8a72f490b25c56c8, minFilter = $8725869b83961a04$export$5d8599b6a933fb1b, format = $8725869b83961a04$export$3f8bb04b555a363c, type = $8725869b83961a04$export$2e8ce08d3f6f5e10, anisotropy = $8725869b83961a04$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $8725869b83961a04$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $8725869b83961a04$var$_textureId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = '';
        this.source = new $8725869b83961a04$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $8725869b83961a04$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.center = new $8725869b83961a04$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $8725869b83961a04$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        this.colorSpace = colorSpace1;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $8725869b83961a04$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $8725869b83961a04$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $8725869b83961a04$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $8725869b83961a04$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $8725869b83961a04$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $8725869b83961a04$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $8725869b83961a04$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
$8725869b83961a04$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$8725869b83961a04$export$5431306cf43de24a.DEFAULT_MAPPING = $8725869b83961a04$export$1beec6768cbb3d2d;
$8725869b83961a04$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $8725869b83961a04$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $8725869b83961a04$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $8725869b83961a04$export$efcb1f8bf367cbfb extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $8725869b83961a04$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new $8725869b83961a04$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $8725869b83961a04$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $8725869b83961a04$export$3c052beb2e51e23f extends $8725869b83961a04$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $8725869b83961a04$export$dfac6c8e811406a3 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.wrapR = $8725869b83961a04$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $8725869b83961a04$export$c77a02c11ed180c7 extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $8725869b83961a04$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $8725869b83961a04$export$d7a3086320f856db extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.wrapR = $8725869b83961a04$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $8725869b83961a04$export$7ee06591009639df extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $8725869b83961a04$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $8725869b83961a04$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($8725869b83961a04$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // sets this quaternion to a uniform random unit quaternnion
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $8725869b83961a04$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $8725869b83961a04$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($8725869b83961a04$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($8725869b83961a04$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $8725869b83961a04$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($8725869b83961a04$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($8725869b83961a04$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($8725869b83961a04$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $8725869b83961a04$var$_vector$c = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion$4 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
class $8725869b83961a04$export$6f7d5a9418ab2aa3 {
    constructor(min = new $8725869b83961a04$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $8725869b83961a04$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($8725869b83961a04$var$_vector$b.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($8725869b83961a04$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $8725869b83961a04$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $8725869b83961a04$var$_vector$b);
                else $8725869b83961a04$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $8725869b83961a04$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($8725869b83961a04$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $8725869b83961a04$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $8725869b83961a04$var$_box$4.copy(geometry.boundingBox);
                }
                $8725869b83961a04$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($8725869b83961a04$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $8725869b83961a04$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $8725869b83961a04$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($8725869b83961a04$var$_center);
        $8725869b83961a04$var$_extents.subVectors(this.max, $8725869b83961a04$var$_center);
        // translate triangle to aabb origin
        $8725869b83961a04$var$_v0$3.subVectors(triangle.a, $8725869b83961a04$var$_center);
        $8725869b83961a04$var$_v1$7.subVectors(triangle.b, $8725869b83961a04$var$_center);
        $8725869b83961a04$var$_v2$4.subVectors(triangle.c, $8725869b83961a04$var$_center);
        // compute edge vectors for triangle
        $8725869b83961a04$var$_f0.subVectors($8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v0$3);
        $8725869b83961a04$var$_f1.subVectors($8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_v1$7);
        $8725869b83961a04$var$_f2.subVectors($8725869b83961a04$var$_v0$3, $8725869b83961a04$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$8725869b83961a04$var$_f0.z,
            $8725869b83961a04$var$_f0.y,
            0,
            -$8725869b83961a04$var$_f1.z,
            $8725869b83961a04$var$_f1.y,
            0,
            -$8725869b83961a04$var$_f2.z,
            $8725869b83961a04$var$_f2.y,
            $8725869b83961a04$var$_f0.z,
            0,
            -$8725869b83961a04$var$_f0.x,
            $8725869b83961a04$var$_f1.z,
            0,
            -$8725869b83961a04$var$_f1.x,
            $8725869b83961a04$var$_f2.z,
            0,
            -$8725869b83961a04$var$_f2.x,
            -$8725869b83961a04$var$_f0.y,
            $8725869b83961a04$var$_f0.x,
            0,
            -$8725869b83961a04$var$_f1.y,
            $8725869b83961a04$var$_f1.x,
            0,
            -$8725869b83961a04$var$_f2.y,
            $8725869b83961a04$var$_f2.x,
            0
        ];
        if (!$8725869b83961a04$var$satForAxes(axes, $8725869b83961a04$var$_v0$3, $8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$8725869b83961a04$var$satForAxes(axes, $8725869b83961a04$var$_v0$3, $8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $8725869b83961a04$var$_triangleNormal.crossVectors($8725869b83961a04$var$_f0, $8725869b83961a04$var$_f1);
        axes = [
            $8725869b83961a04$var$_triangleNormal.x,
            $8725869b83961a04$var$_triangleNormal.y,
            $8725869b83961a04$var$_triangleNormal.z
        ];
        return $8725869b83961a04$var$satForAxes(axes, $8725869b83961a04$var$_v0$3, $8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $8725869b83961a04$var$_vector$b).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($8725869b83961a04$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $8725869b83961a04$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $8725869b83961a04$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $8725869b83961a04$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $8725869b83961a04$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $8725869b83961a04$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $8725869b83961a04$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $8725869b83961a04$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $8725869b83961a04$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($8725869b83961a04$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $8725869b83961a04$var$_points = [
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699()
];
const $8725869b83961a04$var$_vector$b = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_box$4 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $8725869b83961a04$var$_v0$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v1$7 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$4 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
// triangle edge vectors
const $8725869b83961a04$var$_f0 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_f1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_f2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_center = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_extents = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_triangleNormal = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_testAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
function $8725869b83961a04$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $8725869b83961a04$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($8725869b83961a04$var$_testAxis.x) + extents.y * Math.abs($8725869b83961a04$var$_testAxis.y) + extents.z * Math.abs($8725869b83961a04$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($8725869b83961a04$var$_testAxis);
        const p1 = v1.dot($8725869b83961a04$var$_testAxis);
        const p2 = v2.dot($8725869b83961a04$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $8725869b83961a04$var$_box$3 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_v1$6 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$805e8b72413ccaba {
    constructor(center = new $8725869b83961a04$export$64b5c384219d3699(), radius = -1){
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $8725869b83961a04$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $8725869b83961a04$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $8725869b83961a04$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($8725869b83961a04$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $8725869b83961a04$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($8725869b83961a04$var$_v1$6.copy(sphere.center).add($8725869b83961a04$var$_v2$3));
            this.expandByPoint($8725869b83961a04$var$_v1$6.copy(sphere.center).sub($8725869b83961a04$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_vector$a = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_segCenter = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_segDir = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_diff = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_edge1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_edge2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normal$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$a186db52eed6d40e {
    constructor(origin = new $8725869b83961a04$export$64b5c384219d3699(), direction = new $8725869b83961a04$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $8725869b83961a04$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $8725869b83961a04$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $8725869b83961a04$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $8725869b83961a04$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $8725869b83961a04$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $8725869b83961a04$var$_segDir.copy(v1).sub(v0).normalize();
        $8725869b83961a04$var$_diff.copy(this.origin).sub($8725869b83961a04$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($8725869b83961a04$var$_segDir);
        const b0 = $8725869b83961a04$var$_diff.dot(this.direction);
        const b1 = -$8725869b83961a04$var$_diff.dot($8725869b83961a04$var$_segDir);
        const c = $8725869b83961a04$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($8725869b83961a04$var$_segCenter).addScaledVector($8725869b83961a04$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $8725869b83961a04$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $8725869b83961a04$var$_vector$a.dot(this.direction);
        const d2 = $8725869b83961a04$var$_vector$a.dot($8725869b83961a04$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $8725869b83961a04$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $8725869b83961a04$var$_edge1.subVectors(b, a);
        $8725869b83961a04$var$_edge2.subVectors(c, a);
        $8725869b83961a04$var$_normal$1.crossVectors($8725869b83961a04$var$_edge1, $8725869b83961a04$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($8725869b83961a04$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $8725869b83961a04$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($8725869b83961a04$var$_edge2.crossVectors($8725869b83961a04$var$_diff, $8725869b83961a04$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($8725869b83961a04$var$_edge1.cross($8725869b83961a04$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $8725869b83961a04$var$_diff.dot($8725869b83961a04$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $8725869b83961a04$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $8725869b83961a04$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $8725869b83961a04$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $8725869b83961a04$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $8725869b83961a04$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $8725869b83961a04$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($8725869b83961a04$var$_zero, q, $8725869b83961a04$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $8725869b83961a04$var$_z.subVectors(eye, target);
        if ($8725869b83961a04$var$_z.lengthSq() === 0) // eye and target are in the same position
        $8725869b83961a04$var$_z.z = 1;
        $8725869b83961a04$var$_z.normalize();
        $8725869b83961a04$var$_x.crossVectors(up, $8725869b83961a04$var$_z);
        if ($8725869b83961a04$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $8725869b83961a04$var$_z.x += 0.0001;
            else $8725869b83961a04$var$_z.z += 0.0001;
            $8725869b83961a04$var$_z.normalize();
            $8725869b83961a04$var$_x.crossVectors(up, $8725869b83961a04$var$_z);
        }
        $8725869b83961a04$var$_x.normalize();
        $8725869b83961a04$var$_y.crossVectors($8725869b83961a04$var$_z, $8725869b83961a04$var$_x);
        te[0] = $8725869b83961a04$var$_x.x;
        te[4] = $8725869b83961a04$var$_y.x;
        te[8] = $8725869b83961a04$var$_z.x;
        te[1] = $8725869b83961a04$var$_x.y;
        te[5] = $8725869b83961a04$var$_y.y;
        te[9] = $8725869b83961a04$var$_z.y;
        te[2] = $8725869b83961a04$var$_x.z;
        te[6] = $8725869b83961a04$var$_y.z;
        te[10] = $8725869b83961a04$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $8725869b83961a04$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $8725869b83961a04$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $8725869b83961a04$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $8725869b83961a04$var$_m1$4.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $8725869b83961a04$var$_m1$4.elements[0] *= invSX;
        $8725869b83961a04$var$_m1$4.elements[1] *= invSX;
        $8725869b83961a04$var$_m1$4.elements[2] *= invSX;
        $8725869b83961a04$var$_m1$4.elements[4] *= invSY;
        $8725869b83961a04$var$_m1$4.elements[5] *= invSY;
        $8725869b83961a04$var$_m1$4.elements[6] *= invSY;
        $8725869b83961a04$var$_m1$4.elements[8] *= invSZ;
        $8725869b83961a04$var$_m1$4.elements[9] *= invSZ;
        $8725869b83961a04$var$_m1$4.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($8725869b83961a04$var$_m1$4);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $8725869b83961a04$var$_v1$5 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_m1$4 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_zero = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 0, 0);
const $8725869b83961a04$var$_one = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1);
const $8725869b83961a04$var$_x = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_y = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_z = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_matrix$2 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_quaternion$3 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
class $8725869b83961a04$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $8725869b83961a04$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($8725869b83961a04$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$8725869b83961a04$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($8725869b83961a04$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$8725869b83961a04$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($8725869b83961a04$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$8725869b83961a04$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $8725869b83961a04$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($8725869b83961a04$var$_matrix$2, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $8725869b83961a04$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($8725869b83961a04$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$8725869b83961a04$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
class $8725869b83961a04$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $8725869b83961a04$var$_object3DId = 0;
const $8725869b83961a04$var$_v1$4 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_q1 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_m1$3 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_target = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_position$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_scale$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion$2 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_xAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 0, 0);
const $8725869b83961a04$var$_yAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0);
const $8725869b83961a04$var$_zAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1);
const $8725869b83961a04$var$_addedEvent = {
    type: 'added'
};
const $8725869b83961a04$var$_removedEvent = {
    type: 'removed'
};
const $8725869b83961a04$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
const $8725869b83961a04$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
class $8725869b83961a04$export$e4dd07dff30cc924 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $8725869b83961a04$var$_object3DId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $8725869b83961a04$export$64b5c384219d3699();
        const rotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        const quaternion = new $8725869b83961a04$export$23d6a54f0bbc85a3();
        const scale = new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $8725869b83961a04$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $8725869b83961a04$export$8ff26dafa08918()
            }
        });
        this.matrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.matrixWorld = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldAutoUpdate = $8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $8725869b83961a04$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $8725869b83961a04$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($8725869b83961a04$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $8725869b83961a04$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($8725869b83961a04$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($8725869b83961a04$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($8725869b83961a04$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($8725869b83961a04$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $8725869b83961a04$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($8725869b83961a04$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($8725869b83961a04$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($8725869b83961a04$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($8725869b83961a04$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($8725869b83961a04$var$_m1$3.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $8725869b83961a04$var$_target.copy(x);
        else $8725869b83961a04$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $8725869b83961a04$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $8725869b83961a04$var$_m1$3.lookAt($8725869b83961a04$var$_position$3, $8725869b83961a04$var$_target, this.up);
        else $8725869b83961a04$var$_m1$3.lookAt($8725869b83961a04$var$_target, $8725869b83961a04$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($8725869b83961a04$var$_m1$3);
        if (parent) {
            $8725869b83961a04$var$_m1$3.extractRotation(parent.matrixWorld);
            $8725869b83961a04$var$_q1.setFromRotationMatrix($8725869b83961a04$var$_m1$3);
            this.quaternion.premultiply($8725869b83961a04$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($8725869b83961a04$var$_addedEvent);
            $8725869b83961a04$var$_childaddedEvent.child = object;
            this.dispatchEvent($8725869b83961a04$var$_childaddedEvent);
            $8725869b83961a04$var$_childaddedEvent.child = null;
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($8725869b83961a04$var$_removedEvent);
            $8725869b83961a04$var$_childremovedEvent.child = object;
            this.dispatchEvent($8725869b83961a04$var$_childremovedEvent);
            $8725869b83961a04$var$_childremovedEvent.child = null;
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $8725869b83961a04$var$_m1$3.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $8725869b83961a04$var$_m1$3.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($8725869b83961a04$var$_m1$3);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($8725869b83961a04$var$_addedEvent);
        $8725869b83961a04$var$_childaddedEvent.child = object;
        this.dispatchEvent($8725869b83961a04$var$_childaddedEvent);
        $8725869b83961a04$var$_childaddedEvent.child = null;
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($8725869b83961a04$var$_position$3, target, $8725869b83961a04$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($8725869b83961a04$var$_position$3, $8725869b83961a04$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0);
$8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $8725869b83961a04$var$_v0$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v1$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v3$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vab = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vac = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vbc = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vap = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vbp = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vcp = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$5a465592bfe74b48 {
    constructor(a = new $8725869b83961a04$export$64b5c384219d3699(), b = new $8725869b83961a04$export$64b5c384219d3699(), c = new $8725869b83961a04$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $8725869b83961a04$var$_v0$2.subVectors(a, b);
        target.cross($8725869b83961a04$var$_v0$2);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $8725869b83961a04$var$_v0$2.subVectors(c, a);
        $8725869b83961a04$var$_v1$3.subVectors(b, a);
        $8725869b83961a04$var$_v2$2.subVectors(point, a);
        const dot00 = $8725869b83961a04$var$_v0$2.dot($8725869b83961a04$var$_v0$2);
        const dot01 = $8725869b83961a04$var$_v0$2.dot($8725869b83961a04$var$_v1$3);
        const dot02 = $8725869b83961a04$var$_v0$2.dot($8725869b83961a04$var$_v2$2);
        const dot11 = $8725869b83961a04$var$_v1$3.dot($8725869b83961a04$var$_v1$3);
        const dot12 = $8725869b83961a04$var$_v1$3.dot($8725869b83961a04$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $8725869b83961a04$var$_v3$2) === null) return false;
        return $8725869b83961a04$var$_v3$2.x >= 0 && $8725869b83961a04$var$_v3$2.y >= 0 && $8725869b83961a04$var$_v3$2.x + $8725869b83961a04$var$_v3$2.y <= 1;
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $8725869b83961a04$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $8725869b83961a04$var$_v3$2.x);
        target.addScaledVector(v2, $8725869b83961a04$var$_v3$2.y);
        target.addScaledVector(v3, $8725869b83961a04$var$_v3$2.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $8725869b83961a04$var$_v0$2.subVectors(c, b);
        $8725869b83961a04$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $8725869b83961a04$var$_v0$2.cross($8725869b83961a04$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $8725869b83961a04$var$_v0$2.subVectors(this.c, this.b);
        $8725869b83961a04$var$_v1$3.subVectors(this.a, this.b);
        return $8725869b83961a04$var$_v0$2.cross($8725869b83961a04$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $8725869b83961a04$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $8725869b83961a04$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $8725869b83961a04$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $8725869b83961a04$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $8725869b83961a04$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $8725869b83961a04$var$_vab.subVectors(b, a);
        $8725869b83961a04$var$_vac.subVectors(c, a);
        $8725869b83961a04$var$_vap.subVectors(p, a);
        const d1 = $8725869b83961a04$var$_vab.dot($8725869b83961a04$var$_vap);
        const d2 = $8725869b83961a04$var$_vac.dot($8725869b83961a04$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $8725869b83961a04$var$_vbp.subVectors(p, b);
        const d3 = $8725869b83961a04$var$_vab.dot($8725869b83961a04$var$_vbp);
        const d4 = $8725869b83961a04$var$_vac.dot($8725869b83961a04$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($8725869b83961a04$var$_vab, v);
        }
        $8725869b83961a04$var$_vcp.subVectors(p, c);
        const d5 = $8725869b83961a04$var$_vab.dot($8725869b83961a04$var$_vcp);
        const d6 = $8725869b83961a04$var$_vac.dot($8725869b83961a04$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($8725869b83961a04$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $8725869b83961a04$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($8725869b83961a04$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($8725869b83961a04$var$_vab, v).addScaledVector($8725869b83961a04$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $8725869b83961a04$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $8725869b83961a04$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $8725869b83961a04$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $8725869b83961a04$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $8725869b83961a04$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $8725869b83961a04$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $8725869b83961a04$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $8725869b83961a04$var$euclideanModulo(h, 1);
        s = $8725869b83961a04$var$clamp(s, 0, 1);
        l = $8725869b83961a04$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $8725869b83961a04$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $8725869b83961a04$var$hue2rgb(q, p, h);
            this.b = $8725869b83961a04$var$hue2rgb(q, p, h - 1 / 3);
        }
        $8725869b83961a04$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        // color keywords
        const hex = $8725869b83961a04$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $8725869b83961a04$var$SRGBToLinear(color.r);
        this.g = $8725869b83961a04$var$SRGBToLinear(color.g);
        this.b = $8725869b83961a04$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $8725869b83961a04$var$LinearToSRGB(color.r);
        this.g = $8725869b83961a04$var$LinearToSRGB(color.g);
        this.b = $8725869b83961a04$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        return Math.round($8725869b83961a04$var$clamp($8725869b83961a04$var$_color.r * 255, 0, 255)) * 65536 + Math.round($8725869b83961a04$var$clamp($8725869b83961a04$var$_color.g * 255, 0, 255)) * 256 + Math.round($8725869b83961a04$var$clamp($8725869b83961a04$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        const r = $8725869b83961a04$var$_color.r, g = $8725869b83961a04$var$_color.g, b = $8725869b83961a04$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        target.r = $8725869b83961a04$var$_color.r;
        target.g = $8725869b83961a04$var$_color.g;
        target.b = $8725869b83961a04$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        const r = $8725869b83961a04$var$_color.r, g = $8725869b83961a04$var$_color.g, b = $8725869b83961a04$var$_color.b;
        if (colorSpace1 !== $8725869b83961a04$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($8725869b83961a04$var$_hslA);
        return this.setHSL($8725869b83961a04$var$_hslA.h + h, $8725869b83961a04$var$_hslA.s + s, $8725869b83961a04$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($8725869b83961a04$var$_hslA);
        color.getHSL($8725869b83961a04$var$_hslB);
        const h = $8725869b83961a04$var$lerp($8725869b83961a04$var$_hslA.h, $8725869b83961a04$var$_hslB.h, alpha);
        const s = $8725869b83961a04$var$lerp($8725869b83961a04$var$_hslA.s, $8725869b83961a04$var$_hslB.s, alpha);
        const l = $8725869b83961a04$var$lerp($8725869b83961a04$var$_hslA.l, $8725869b83961a04$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $8725869b83961a04$var$_color = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
$8725869b83961a04$export$892596cec99bc70e.NAMES = $8725869b83961a04$var$_colorKeywords;
let $8725869b83961a04$var$_materialId = 0;
class $8725869b83961a04$export$a2d8b23205c25948 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $8725869b83961a04$var$_materialId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.blending = $8725869b83961a04$export$5b29a26d96ee6af0;
        this.side = $8725869b83961a04$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $8725869b83961a04$export$d5773124e86cf28c;
        this.blendDst = $8725869b83961a04$export$11d468cc7f19e971;
        this.blendEquation = $8725869b83961a04$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new $8725869b83961a04$export$892596cec99bc70e(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = $8725869b83961a04$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $8725869b83961a04$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $8725869b83961a04$export$9f542ae4b5baca34;
        this.stencilZFail = $8725869b83961a04$export$9f542ae4b5baca34;
        this.stencilZPass = $8725869b83961a04$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $8725869b83961a04$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $8725869b83961a04$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $8725869b83961a04$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $8725869b83961a04$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $8725869b83961a04$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $8725869b83961a04$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $8725869b83961a04$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $8725869b83961a04$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $8725869b83961a04$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $8725869b83961a04$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn('Material: onBuild() has been removed.'); // @deprecated, r166
    }
}
class $8725869b83961a04$export$55cbcc9b622fe1f5 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        this.combine = $8725869b83961a04$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $8725869b83961a04$var$_tables = /*@__PURE__*/ $8725869b83961a04$var$_generateTables();
function $8725869b83961a04$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $8725869b83961a04$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $8725869b83961a04$var$clamp(val, -65504, 65504);
    $8725869b83961a04$var$_tables.floatView[0] = val;
    const f = $8725869b83961a04$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $8725869b83961a04$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $8725869b83961a04$var$_tables.shiftTable[e]);
}
// float16 to float32
function $8725869b83961a04$var$fromHalfFloat(val) {
    const m = val >> 10;
    $8725869b83961a04$var$_tables.uint32View[0] = $8725869b83961a04$var$_tables.mantissaTable[$8725869b83961a04$var$_tables.offsetTable[m] + (val & 0x3ff)] + $8725869b83961a04$var$_tables.exponentTable[m];
    return $8725869b83961a04$var$_tables.floatView[0];
}
const $8725869b83961a04$export$11ce8b759162cc80 = {
    toHalfFloat: $8725869b83961a04$var$toHalfFloat,
    fromHalfFloat: $8725869b83961a04$var$fromHalfFloat
};
const $8725869b83961a04$var$_vector$9 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vector2$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
class $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $8725869b83961a04$export$763e8360f4d7f77d;
        this._updateRange = {
            offset: 0,
            count: -1
        };
        this.updateRanges = [];
        this.gpuType = $8725869b83961a04$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    get updateRange() {
        $8725869b83961a04$var$warnOnce('THREE.BufferAttribute: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.'); // @deprecated, r159
        return this._updateRange;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector2$1.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $8725869b83961a04$var$_vector2$1.x, $8725869b83961a04$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$9.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$9.x, $8725869b83961a04$var$_vector$9.y, $8725869b83961a04$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$9.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$9.x, $8725869b83961a04$var$_vector$9.y, $8725869b83961a04$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$9.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$9.x, $8725869b83961a04$var$_vector$9.y, $8725869b83961a04$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$9.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$9.x, $8725869b83961a04$var$_vector$9.y, $8725869b83961a04$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $8725869b83961a04$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $8725869b83961a04$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $8725869b83961a04$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $8725869b83961a04$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $8725869b83961a04$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $8725869b83961a04$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $8725869b83961a04$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $8725869b83961a04$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $8725869b83961a04$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $8725869b83961a04$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
            w = $8725869b83961a04$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $8725869b83961a04$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
//
class $8725869b83961a04$export$f9ff2d6a20248cbf extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$cacc90cf35d11cdd extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$baaa85a1a812c157 extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$2b755a102ccdcefe extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$640a853f68025f2e extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$46b369aed2968a0a extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$7eb8c9fa25cd5bd6 extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$dbd3698c64958d69 extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $8725869b83961a04$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $8725869b83961a04$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $8725869b83961a04$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $8725869b83961a04$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $8725869b83961a04$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $8725869b83961a04$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $8725869b83961a04$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $8725869b83961a04$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $8725869b83961a04$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $8725869b83961a04$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $8725869b83961a04$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $8725869b83961a04$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
        }
        this.array[index + 0] = $8725869b83961a04$var$toHalfFloat(x);
        this.array[index + 1] = $8725869b83961a04$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
        }
        this.array[index + 0] = $8725869b83961a04$var$toHalfFloat(x);
        this.array[index + 1] = $8725869b83961a04$var$toHalfFloat(y);
        this.array[index + 2] = $8725869b83961a04$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
            w = $8725869b83961a04$var$normalize(w, this.array);
        }
        this.array[index + 0] = $8725869b83961a04$var$toHalfFloat(x);
        this.array[index + 1] = $8725869b83961a04$var$toHalfFloat(y);
        this.array[index + 2] = $8725869b83961a04$var$toHalfFloat(z);
        this.array[index + 3] = $8725869b83961a04$var$toHalfFloat(w);
        return this;
    }
}
class $8725869b83961a04$export$cbe7a62641830ebd extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $8725869b83961a04$var$_id$2 = 0;
const $8725869b83961a04$var$_m1$2 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_obj = /*@__PURE__*/ new $8725869b83961a04$export$e4dd07dff30cc924();
const $8725869b83961a04$var$_offset = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_box$2 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_boxMorphTargets = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_vector$8 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$b7be63a67df8959 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $8725869b83961a04$var$_id$2++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($8725869b83961a04$var$arrayNeedsUint32(index) ? $8725869b83961a04$export$7eb8c9fa25cd5bd6 : $8725869b83961a04$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $8725869b83961a04$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $8725869b83961a04$var$_m1$2.makeRotationFromQuaternion(q);
        this.applyMatrix4($8725869b83961a04$var$_m1$2);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $8725869b83961a04$var$_m1$2.makeRotationX(angle);
        this.applyMatrix4($8725869b83961a04$var$_m1$2);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $8725869b83961a04$var$_m1$2.makeRotationY(angle);
        this.applyMatrix4($8725869b83961a04$var$_m1$2);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $8725869b83961a04$var$_m1$2.makeRotationZ(angle);
        this.applyMatrix4($8725869b83961a04$var$_m1$2);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $8725869b83961a04$var$_m1$2.makeTranslation(x, y, z);
        this.applyMatrix4($8725869b83961a04$var$_m1$2);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $8725869b83961a04$var$_m1$2.makeScale(x, y, z);
        this.applyMatrix4($8725869b83961a04$var$_m1$2);
        return this;
    }
    lookAt(vector) {
        $8725869b83961a04$var$_obj.lookAt(vector);
        $8725869b83961a04$var$_obj.updateMatrix();
        this.applyMatrix4($8725869b83961a04$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($8725869b83961a04$var$_offset).negate();
        this.translate($8725869b83961a04$var$_offset.x, $8725869b83961a04$var$_offset.y, $8725869b83961a04$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $8725869b83961a04$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $8725869b83961a04$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $8725869b83961a04$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $8725869b83961a04$var$_vector$8.addVectors(this.boundingBox.min, $8725869b83961a04$var$_box$2.min);
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_vector$8);
                    $8725869b83961a04$var$_vector$8.addVectors(this.boundingBox.max, $8725869b83961a04$var$_box$2.max);
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_box$2.min);
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $8725869b83961a04$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $8725869b83961a04$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $8725869b83961a04$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $8725869b83961a04$var$_vector$8.addVectors($8725869b83961a04$var$_box$2.min, $8725869b83961a04$var$_boxMorphTargets.min);
                    $8725869b83961a04$var$_box$2.expandByPoint($8725869b83961a04$var$_vector$8);
                    $8725869b83961a04$var$_vector$8.addVectors($8725869b83961a04$var$_box$2.max, $8725869b83961a04$var$_boxMorphTargets.max);
                    $8725869b83961a04$var$_box$2.expandByPoint($8725869b83961a04$var$_vector$8);
                } else {
                    $8725869b83961a04$var$_box$2.expandByPoint($8725869b83961a04$var$_boxMorphTargets.min);
                    $8725869b83961a04$var$_box$2.expandByPoint($8725869b83961a04$var$_boxMorphTargets.max);
                }
            }
            $8725869b83961a04$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $8725869b83961a04$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($8725869b83961a04$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $8725869b83961a04$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $8725869b83961a04$var$_offset.fromBufferAttribute(position, j);
                        $8725869b83961a04$var$_vector$8.add($8725869b83961a04$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($8725869b83961a04$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $8725869b83961a04$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $8725869b83961a04$export$64b5c384219d3699();
            tan2[i] = new $8725869b83961a04$export$64b5c384219d3699();
        }
        const vA = new $8725869b83961a04$export$64b5c384219d3699(), vB = new $8725869b83961a04$export$64b5c384219d3699(), vC = new $8725869b83961a04$export$64b5c384219d3699(), uvA = new $8725869b83961a04$export$c977b3e384af9ae1(), uvB = new $8725869b83961a04$export$c977b3e384af9ae1(), uvC = new $8725869b83961a04$export$c977b3e384af9ae1(), sdir = new $8725869b83961a04$export$64b5c384219d3699(), tdir = new $8725869b83961a04$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $8725869b83961a04$export$64b5c384219d3699(), tmp2 = new $8725869b83961a04$export$64b5c384219d3699();
        const n = new $8725869b83961a04$export$64b5c384219d3699(), n2 = new $8725869b83961a04$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $8725869b83961a04$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $8725869b83961a04$export$64b5c384219d3699(), pB = new $8725869b83961a04$export$64b5c384219d3699(), pC = new $8725869b83961a04$export$64b5c384219d3699();
            const nA = new $8725869b83961a04$export$64b5c384219d3699(), nB = new $8725869b83961a04$export$64b5c384219d3699(), nC = new $8725869b83961a04$export$64b5c384219d3699();
            const cb = new $8725869b83961a04$export$64b5c384219d3699(), ab = new $8725869b83961a04$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $8725869b83961a04$var$_vector$8.fromBufferAttribute(normals, i);
            $8725869b83961a04$var$_vector$8.normalize();
            normals.setXYZ(i, $8725869b83961a04$var$_vector$8.x, $8725869b83961a04$var$_vector$8.y, $8725869b83961a04$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $8725869b83961a04$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $8725869b83961a04$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $8725869b83961a04$var$_inverseMatrix$3 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray$3 = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
const $8725869b83961a04$var$_sphere$6 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_sphereHitAt = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vA$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vB$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vC$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_tempA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_morphA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_uvA$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvB$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvC$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_normalA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normalB = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normalC = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_intersectionPoint = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_intersectionPointWorld = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$e176487c05830cc5 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(geometry = new $8725869b83961a04$export$b7be63a67df8959(), material = new $8725869b83961a04$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $8725869b83961a04$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $8725869b83961a04$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $8725869b83961a04$var$_morphA.addScaledVector($8725869b83961a04$var$_tempA, influence);
                else $8725869b83961a04$var$_morphA.addScaledVector($8725869b83961a04$var$_tempA.sub(target), influence);
            }
            target.add($8725869b83961a04$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$6.copy(geometry.boundingSphere);
        $8725869b83961a04$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $8725869b83961a04$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($8725869b83961a04$var$_sphere$6.containsPoint($8725869b83961a04$var$_ray$3.origin) === false) {
            if ($8725869b83961a04$var$_ray$3.intersectSphere($8725869b83961a04$var$_sphere$6, $8725869b83961a04$var$_sphereHitAt) === null) return;
            if ($8725869b83961a04$var$_ray$3.origin.distanceToSquared($8725869b83961a04$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $8725869b83961a04$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray$3.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($8725869b83961a04$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $8725869b83961a04$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $8725869b83961a04$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $8725869b83961a04$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $8725869b83961a04$var$_intersectionPointWorld.copy(point);
    $8725869b83961a04$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($8725869b83961a04$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $8725869b83961a04$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $8725869b83961a04$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $8725869b83961a04$var$_vA$1);
    object.getVertexPosition(b, $8725869b83961a04$var$_vB$1);
    object.getVertexPosition(c, $8725869b83961a04$var$_vC$1);
    const intersection = $8725869b83961a04$var$checkIntersection$1(object, material, raycaster, ray, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $8725869b83961a04$var$_uvA$1.fromBufferAttribute(uv, a);
            $8725869b83961a04$var$_uvB$1.fromBufferAttribute(uv, b);
            $8725869b83961a04$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectionPoint, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_uvA$1, $8725869b83961a04$var$_uvB$1, $8725869b83961a04$var$_uvC$1, new $8725869b83961a04$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $8725869b83961a04$var$_uvA$1.fromBufferAttribute(uv1, a);
            $8725869b83961a04$var$_uvB$1.fromBufferAttribute(uv1, b);
            $8725869b83961a04$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectionPoint, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_uvA$1, $8725869b83961a04$var$_uvB$1, $8725869b83961a04$var$_uvC$1, new $8725869b83961a04$export$c977b3e384af9ae1());
        }
        if (normal) {
            $8725869b83961a04$var$_normalA.fromBufferAttribute(normal, a);
            $8725869b83961a04$var$_normalB.fromBufferAttribute(normal, b);
            $8725869b83961a04$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectionPoint, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_normalA, $8725869b83961a04$var$_normalB, $8725869b83961a04$var$_normalC, new $8725869b83961a04$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $8725869b83961a04$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $8725869b83961a04$export$5a465592bfe74b48.getNormal($8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $8725869b83961a04$export$33e43285f7406bd5 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $8725869b83961a04$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $8725869b83961a04$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $8725869b83961a04$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $8725869b83961a04$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $8725869b83961a04$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $8725869b83961a04$var$getUnlitUniformColorSpace(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $8725869b83961a04$export$d8ecdf8615bfea69 = {
    clone: $8725869b83961a04$var$cloneUniforms,
    merge: $8725869b83961a04$var$mergeUniforms
};
var $8725869b83961a04$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $8725869b83961a04$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $8725869b83961a04$export$83c7d75d550a8b0d extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $8725869b83961a04$var$default_vertex;
        this.fragmentShader = $8725869b83961a04$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $8725869b83961a04$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $8725869b83961a04$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $8725869b83961a04$export$79f141de891a5fed extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_v3$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_minTarget = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_maxTarget = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
class $8725869b83961a04$export$74e4ae24825f68d7 extends $8725869b83961a04$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $8725869b83961a04$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($8725869b83961a04$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $8725869b83961a04$var$RAD2DEG * 2 * Math.atan(Math.tan($8725869b83961a04$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $8725869b83961a04$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($8725869b83961a04$var$_v3$1.x, $8725869b83961a04$var$_v3$1.y).multiplyScalar(-distance / $8725869b83961a04$var$_v3$1.z);
        $8725869b83961a04$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($8725869b83961a04$var$_v3$1.x, $8725869b83961a04$var$_v3$1.y).multiplyScalar(-distance / $8725869b83961a04$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $8725869b83961a04$var$_minTarget, $8725869b83961a04$var$_maxTarget);
        return target.subVectors($8725869b83961a04$var$_maxTarget, $8725869b83961a04$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($8725869b83961a04$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $8725869b83961a04$var$fov = -90; // negative fov is not an error
const $8725869b83961a04$var$aspect = 1;
class $8725869b83961a04$export$d0cdd0bd804995de extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $8725869b83961a04$export$ee2e5a18258a4049 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $8725869b83961a04$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $8725869b83961a04$export$ac386671d651941e extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $8725869b83961a04$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $8725869b83961a04$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $8725869b83961a04$export$33e43285f7406bd5(5, 5, 5);
        const material = new $8725869b83961a04$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $8725869b83961a04$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $8725869b83961a04$export$d9f0486e75b5ace,
            blending: $8725869b83961a04$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $8725869b83961a04$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $8725869b83961a04$export$5d8599b6a933fb1b) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
        const camera = new $8725869b83961a04$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $8725869b83961a04$var$_vector1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vector2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normalMatrix = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918();
class $8725869b83961a04$export$7ff5ac152ef991b0 {
    constructor(normal = new $8725869b83961a04$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $8725869b83961a04$var$_vector1.subVectors(c, b).cross($8725869b83961a04$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($8725869b83961a04$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $8725869b83961a04$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($8725869b83961a04$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_sphere$5 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_vector$7 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$35efe6f4c85463d2 {
    constructor(p0 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p1 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p2 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p3 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p4 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p5 = new $8725869b83961a04$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $8725869b83961a04$var$_sphere$5.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $8725869b83961a04$var$_sphere$5.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($8725869b83961a04$var$_sphere$5);
    }
    intersectsSprite(sprite) {
        $8725869b83961a04$var$_sphere$5.center.set(0, 0, 0);
        $8725869b83961a04$var$_sphere$5.radius = 0.7071067811865476;
        $8725869b83961a04$var$_sphere$5.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($8725869b83961a04$var$_sphere$5);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $8725869b83961a04$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $8725869b83961a04$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $8725869b83961a04$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($8725869b83961a04$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $8725869b83961a04$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $8725869b83961a04$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute._updateRange; // @deprecated, r159
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1 && updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        if (updateRanges.length !== 0) {
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        // @deprecated, r159
        if (updateRange.count !== -1) {
            gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $8725869b83961a04$export$967d831af31f69ce extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $8725869b83961a04$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $8725869b83961a04$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $8725869b83961a04$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $8725869b83961a04$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $8725869b83961a04$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $8725869b83961a04$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $8725869b83961a04$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $8725869b83961a04$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $8725869b83961a04$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $8725869b83961a04$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $8725869b83961a04$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $8725869b83961a04$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $8725869b83961a04$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $8725869b83961a04$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $8725869b83961a04$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $8725869b83961a04$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $8725869b83961a04$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $8725869b83961a04$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $8725869b83961a04$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $8725869b83961a04$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $8725869b83961a04$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $8725869b83961a04$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $8725869b83961a04$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $8725869b83961a04$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $8725869b83961a04$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $8725869b83961a04$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $8725869b83961a04$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $8725869b83961a04$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $8725869b83961a04$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $8725869b83961a04$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $8725869b83961a04$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $8725869b83961a04$var$colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n\tvec3( 0.8224621, 0.177538, 0.0 ),\n\tvec3( 0.0331941, 0.9668058, 0.0 ),\n\tvec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.2249401, - 0.2249404, 0.0 ),\n\tvec3( - 0.0420569, 1.0420571, 0.0 ),\n\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $8725869b83961a04$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $8725869b83961a04$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $8725869b83961a04$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $8725869b83961a04$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $8725869b83961a04$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $8725869b83961a04$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $8725869b83961a04$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $8725869b83961a04$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $8725869b83961a04$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $8725869b83961a04$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $8725869b83961a04$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $8725869b83961a04$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $8725869b83961a04$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $8725869b83961a04$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $8725869b83961a04$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $8725869b83961a04$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $8725869b83961a04$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $8725869b83961a04$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $8725869b83961a04$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $8725869b83961a04$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $8725869b83961a04$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $8725869b83961a04$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $8725869b83961a04$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $8725869b83961a04$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $8725869b83961a04$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $8725869b83961a04$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $8725869b83961a04$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $8725869b83961a04$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $8725869b83961a04$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $8725869b83961a04$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $8725869b83961a04$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $8725869b83961a04$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $8725869b83961a04$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $8725869b83961a04$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $8725869b83961a04$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $8725869b83961a04$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $8725869b83961a04$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $8725869b83961a04$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $8725869b83961a04$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $8725869b83961a04$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $8725869b83961a04$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $8725869b83961a04$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $8725869b83961a04$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $8725869b83961a04$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $8725869b83961a04$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $8725869b83961a04$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $8725869b83961a04$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $8725869b83961a04$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $8725869b83961a04$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $8725869b83961a04$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $8725869b83961a04$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $8725869b83961a04$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $8725869b83961a04$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $8725869b83961a04$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $8725869b83961a04$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $8725869b83961a04$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $8725869b83961a04$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $8725869b83961a04$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $8725869b83961a04$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $8725869b83961a04$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $8725869b83961a04$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $8725869b83961a04$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $8725869b83961a04$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $8725869b83961a04$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $8725869b83961a04$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $8725869b83961a04$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $8725869b83961a04$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $8725869b83961a04$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $8725869b83961a04$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $8725869b83961a04$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $8725869b83961a04$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t\n\t\t#else\n\t\t\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $8725869b83961a04$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $8725869b83961a04$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $8725869b83961a04$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $8725869b83961a04$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $8725869b83961a04$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $8725869b83961a04$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8725869b83961a04$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $8725869b83961a04$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8725869b83961a04$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $8725869b83961a04$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8725869b83961a04$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $8725869b83961a04$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $8725869b83961a04$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $8725869b83961a04$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $8725869b83961a04$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $8725869b83961a04$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8725869b83961a04$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $8725869b83961a04$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $8725869b83961a04$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $8725869b83961a04$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $8725869b83961a04$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $8725869b83961a04$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $8725869b83961a04$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $8725869b83961a04$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $8725869b83961a04$export$955f9f2e84c43c8b = {
    alphahash_fragment: $8725869b83961a04$var$alphahash_fragment,
    alphahash_pars_fragment: $8725869b83961a04$var$alphahash_pars_fragment,
    alphamap_fragment: $8725869b83961a04$var$alphamap_fragment,
    alphamap_pars_fragment: $8725869b83961a04$var$alphamap_pars_fragment,
    alphatest_fragment: $8725869b83961a04$var$alphatest_fragment,
    alphatest_pars_fragment: $8725869b83961a04$var$alphatest_pars_fragment,
    aomap_fragment: $8725869b83961a04$var$aomap_fragment,
    aomap_pars_fragment: $8725869b83961a04$var$aomap_pars_fragment,
    batching_pars_vertex: $8725869b83961a04$var$batching_pars_vertex,
    batching_vertex: $8725869b83961a04$var$batching_vertex,
    begin_vertex: $8725869b83961a04$var$begin_vertex,
    beginnormal_vertex: $8725869b83961a04$var$beginnormal_vertex,
    bsdfs: $8725869b83961a04$var$bsdfs,
    iridescence_fragment: $8725869b83961a04$var$iridescence_fragment,
    bumpmap_pars_fragment: $8725869b83961a04$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $8725869b83961a04$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $8725869b83961a04$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $8725869b83961a04$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $8725869b83961a04$var$clipping_planes_vertex,
    color_fragment: $8725869b83961a04$var$color_fragment,
    color_pars_fragment: $8725869b83961a04$var$color_pars_fragment,
    color_pars_vertex: $8725869b83961a04$var$color_pars_vertex,
    color_vertex: $8725869b83961a04$var$color_vertex,
    common: $8725869b83961a04$var$common,
    cube_uv_reflection_fragment: $8725869b83961a04$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $8725869b83961a04$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $8725869b83961a04$var$displacementmap_pars_vertex,
    displacementmap_vertex: $8725869b83961a04$var$displacementmap_vertex,
    emissivemap_fragment: $8725869b83961a04$var$emissivemap_fragment,
    emissivemap_pars_fragment: $8725869b83961a04$var$emissivemap_pars_fragment,
    colorspace_fragment: $8725869b83961a04$var$colorspace_fragment,
    colorspace_pars_fragment: $8725869b83961a04$var$colorspace_pars_fragment,
    envmap_fragment: $8725869b83961a04$var$envmap_fragment,
    envmap_common_pars_fragment: $8725869b83961a04$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $8725869b83961a04$var$envmap_pars_fragment,
    envmap_pars_vertex: $8725869b83961a04$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $8725869b83961a04$var$envmap_physical_pars_fragment,
    envmap_vertex: $8725869b83961a04$var$envmap_vertex,
    fog_vertex: $8725869b83961a04$var$fog_vertex,
    fog_pars_vertex: $8725869b83961a04$var$fog_pars_vertex,
    fog_fragment: $8725869b83961a04$var$fog_fragment,
    fog_pars_fragment: $8725869b83961a04$var$fog_pars_fragment,
    gradientmap_pars_fragment: $8725869b83961a04$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $8725869b83961a04$var$lightmap_pars_fragment,
    lights_lambert_fragment: $8725869b83961a04$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $8725869b83961a04$var$lights_lambert_pars_fragment,
    lights_pars_begin: $8725869b83961a04$var$lights_pars_begin,
    lights_toon_fragment: $8725869b83961a04$var$lights_toon_fragment,
    lights_toon_pars_fragment: $8725869b83961a04$var$lights_toon_pars_fragment,
    lights_phong_fragment: $8725869b83961a04$var$lights_phong_fragment,
    lights_phong_pars_fragment: $8725869b83961a04$var$lights_phong_pars_fragment,
    lights_physical_fragment: $8725869b83961a04$var$lights_physical_fragment,
    lights_physical_pars_fragment: $8725869b83961a04$var$lights_physical_pars_fragment,
    lights_fragment_begin: $8725869b83961a04$var$lights_fragment_begin,
    lights_fragment_maps: $8725869b83961a04$var$lights_fragment_maps,
    lights_fragment_end: $8725869b83961a04$var$lights_fragment_end,
    logdepthbuf_fragment: $8725869b83961a04$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $8725869b83961a04$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $8725869b83961a04$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $8725869b83961a04$var$logdepthbuf_vertex,
    map_fragment: $8725869b83961a04$var$map_fragment,
    map_pars_fragment: $8725869b83961a04$var$map_pars_fragment,
    map_particle_fragment: $8725869b83961a04$var$map_particle_fragment,
    map_particle_pars_fragment: $8725869b83961a04$var$map_particle_pars_fragment,
    metalnessmap_fragment: $8725869b83961a04$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $8725869b83961a04$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $8725869b83961a04$var$morphinstance_vertex,
    morphcolor_vertex: $8725869b83961a04$var$morphcolor_vertex,
    morphnormal_vertex: $8725869b83961a04$var$morphnormal_vertex,
    morphtarget_pars_vertex: $8725869b83961a04$var$morphtarget_pars_vertex,
    morphtarget_vertex: $8725869b83961a04$var$morphtarget_vertex,
    normal_fragment_begin: $8725869b83961a04$var$normal_fragment_begin,
    normal_fragment_maps: $8725869b83961a04$var$normal_fragment_maps,
    normal_pars_fragment: $8725869b83961a04$var$normal_pars_fragment,
    normal_pars_vertex: $8725869b83961a04$var$normal_pars_vertex,
    normal_vertex: $8725869b83961a04$var$normal_vertex,
    normalmap_pars_fragment: $8725869b83961a04$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $8725869b83961a04$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $8725869b83961a04$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $8725869b83961a04$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $8725869b83961a04$var$iridescence_pars_fragment,
    opaque_fragment: $8725869b83961a04$var$opaque_fragment,
    packing: $8725869b83961a04$var$packing,
    premultiplied_alpha_fragment: $8725869b83961a04$var$premultiplied_alpha_fragment,
    project_vertex: $8725869b83961a04$var$project_vertex,
    dithering_fragment: $8725869b83961a04$var$dithering_fragment,
    dithering_pars_fragment: $8725869b83961a04$var$dithering_pars_fragment,
    roughnessmap_fragment: $8725869b83961a04$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $8725869b83961a04$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $8725869b83961a04$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $8725869b83961a04$var$shadowmap_pars_vertex,
    shadowmap_vertex: $8725869b83961a04$var$shadowmap_vertex,
    shadowmask_pars_fragment: $8725869b83961a04$var$shadowmask_pars_fragment,
    skinbase_vertex: $8725869b83961a04$var$skinbase_vertex,
    skinning_pars_vertex: $8725869b83961a04$var$skinning_pars_vertex,
    skinning_vertex: $8725869b83961a04$var$skinning_vertex,
    skinnormal_vertex: $8725869b83961a04$var$skinnormal_vertex,
    specularmap_fragment: $8725869b83961a04$var$specularmap_fragment,
    specularmap_pars_fragment: $8725869b83961a04$var$specularmap_pars_fragment,
    tonemapping_fragment: $8725869b83961a04$var$tonemapping_fragment,
    tonemapping_pars_fragment: $8725869b83961a04$var$tonemapping_pars_fragment,
    transmission_fragment: $8725869b83961a04$var$transmission_fragment,
    transmission_pars_fragment: $8725869b83961a04$var$transmission_pars_fragment,
    uv_pars_fragment: $8725869b83961a04$var$uv_pars_fragment,
    uv_pars_vertex: $8725869b83961a04$var$uv_pars_vertex,
    uv_vertex: $8725869b83961a04$var$uv_vertex,
    worldpos_vertex: $8725869b83961a04$var$worldpos_vertex,
    background_vert: $8725869b83961a04$var$vertex$h,
    background_frag: $8725869b83961a04$var$fragment$h,
    backgroundCube_vert: $8725869b83961a04$var$vertex$g,
    backgroundCube_frag: $8725869b83961a04$var$fragment$g,
    cube_vert: $8725869b83961a04$var$vertex$f,
    cube_frag: $8725869b83961a04$var$fragment$f,
    depth_vert: $8725869b83961a04$var$vertex$e,
    depth_frag: $8725869b83961a04$var$fragment$e,
    distanceRGBA_vert: $8725869b83961a04$var$vertex$d,
    distanceRGBA_frag: $8725869b83961a04$var$fragment$d,
    equirect_vert: $8725869b83961a04$var$vertex$c,
    equirect_frag: $8725869b83961a04$var$fragment$c,
    linedashed_vert: $8725869b83961a04$var$vertex$b,
    linedashed_frag: $8725869b83961a04$var$fragment$b,
    meshbasic_vert: $8725869b83961a04$var$vertex$a,
    meshbasic_frag: $8725869b83961a04$var$fragment$a,
    meshlambert_vert: $8725869b83961a04$var$vertex$9,
    meshlambert_frag: $8725869b83961a04$var$fragment$9,
    meshmatcap_vert: $8725869b83961a04$var$vertex$8,
    meshmatcap_frag: $8725869b83961a04$var$fragment$8,
    meshnormal_vert: $8725869b83961a04$var$vertex$7,
    meshnormal_frag: $8725869b83961a04$var$fragment$7,
    meshphong_vert: $8725869b83961a04$var$vertex$6,
    meshphong_frag: $8725869b83961a04$var$fragment$6,
    meshphysical_vert: $8725869b83961a04$var$vertex$5,
    meshphysical_frag: $8725869b83961a04$var$fragment$5,
    meshtoon_vert: $8725869b83961a04$var$vertex$4,
    meshtoon_frag: $8725869b83961a04$var$fragment$4,
    points_vert: $8725869b83961a04$var$vertex$3,
    points_frag: $8725869b83961a04$var$fragment$3,
    shadow_vert: $8725869b83961a04$var$vertex$2,
    shadow_frag: $8725869b83961a04$var$fragment$2,
    sprite_vert: $8725869b83961a04$var$vertex$1,
    sprite_frag: $8725869b83961a04$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $8725869b83961a04$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $8725869b83961a04$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.specularmap,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.fog
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.specularmap,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.specularmap,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.roughnessmap,
            $8725869b83961a04$export$6643083551874bf5.metalnessmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.gradientmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.points,
            $8725869b83961a04$export$6643083551874bf5.fog
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.sprite,
            $8725869b83961a04$export$6643083551874bf5.fog
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.lights,
            $8725869b83961a04$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.shadow_frag
    }
};
$8725869b83961a04$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
        $8725869b83961a04$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_frag
};
const $8725869b83961a04$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $8725869b83961a04$var$_e1$1 = /*@__PURE__*/ new $8725869b83961a04$export$d93cc409a0768c5f();
const $8725869b83961a04$var$_m1$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
function $8725869b83961a04$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === $8725869b83961a04$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$33e43285f7406bd5(1, 1, 1), new $8725869b83961a04$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $8725869b83961a04$var$cloneUniforms($8725869b83961a04$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $8725869b83961a04$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $8725869b83961a04$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $8725869b83961a04$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $8725869b83961a04$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $8725869b83961a04$var$_e1$1.x *= -1;
            $8725869b83961a04$var$_e1$1.y *= -1;
            $8725869b83961a04$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $8725869b83961a04$var$_e1$1.y *= -1;
                $8725869b83961a04$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($8725869b83961a04$var$_m1$1.makeRotationFromEuler($8725869b83961a04$var$_e1$1));
            boxMesh.material.toneMapped = $8725869b83961a04$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $8725869b83961a04$export$8d0a61916cc26abb;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$967d831af31f69ce(2, 2), new $8725869b83961a04$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $8725869b83961a04$var$cloneUniforms($8725869b83961a04$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $8725869b83961a04$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $8725869b83961a04$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $8725869b83961a04$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = $8725869b83961a04$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $8725869b83961a04$export$8d0a61916cc26abb;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($8725869b83961a04$var$_rgb, $8725869b83961a04$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($8725869b83961a04$var$_rgb.r, $8725869b83961a04$var$_rgb.g, $8725869b83961a04$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList
    };
}
function $8725869b83961a04$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $8725869b83961a04$export$5c612977753abe2;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $8725869b83961a04$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            for(let i = 0; i < primcount.length; i++)info.update(elementCount, mode, primcount[i]);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $8725869b83961a04$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== $8725869b83961a04$export$3f8bb04b555a363c && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === $8725869b83961a04$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== $8725869b83961a04$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== $8725869b83961a04$export$f6d331659b644596 && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $8725869b83961a04$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $8725869b83961a04$export$7ff5ac152ef991b0(), viewNormalMatrix = new $8725869b83961a04$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $8725869b83961a04$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $8725869b83961a04$export$d64030b316d3b087) texture.mapping = $8725869b83961a04$export$8759762a6477f2c4;
        else if (mapping === $8725869b83961a04$export$ee99d97d46898098) texture.mapping = $8725869b83961a04$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === $8725869b83961a04$export$d64030b316d3b087 || mapping === $8725869b83961a04$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $8725869b83961a04$export$ac386671d651941e(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $8725869b83961a04$export$9ebf355ee4ed261b extends $8725869b83961a04$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $8725869b83961a04$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $8725869b83961a04$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $8725869b83961a04$var$MAX_SAMPLES = 20;
const $8725869b83961a04$var$_flatCamera = /*@__PURE__*/ new $8725869b83961a04$export$9ebf355ee4ed261b();
const $8725869b83961a04$var$_clearColor = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
let $8725869b83961a04$var$_oldTarget = null;
let $8725869b83961a04$var$_oldActiveCubeFace = 0;
let $8725869b83961a04$var$_oldActiveMipmapLevel = 0;
let $8725869b83961a04$var$_oldXrEnabled = false;
// Golden Ratio
const $8725869b83961a04$var$PHI = (1 + Math.sqrt(5)) / 2;
const $8725869b83961a04$var$INV_PHI = 1 / $8725869b83961a04$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $8725869b83961a04$var$_axisDirections = [
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-$8725869b83961a04$var$PHI, $8725869b83961a04$var$INV_PHI, 0),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699($8725869b83961a04$var$PHI, $8725869b83961a04$var$INV_PHI, 0),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-$8725869b83961a04$var$INV_PHI, 0, $8725869b83961a04$var$PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699($8725869b83961a04$var$INV_PHI, 0, $8725869b83961a04$var$PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, $8725869b83961a04$var$PHI, -$8725869b83961a04$var$INV_PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, $8725869b83961a04$var$PHI, $8725869b83961a04$var$INV_PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $8725869b83961a04$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $8725869b83961a04$var$_oldTarget = this._renderer.getRenderTarget();
        $8725869b83961a04$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $8725869b83961a04$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $8725869b83961a04$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $8725869b83961a04$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $8725869b83961a04$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($8725869b83961a04$var$_oldTarget, $8725869b83961a04$var$_oldActiveCubeFace, $8725869b83961a04$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $8725869b83961a04$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $8725869b83961a04$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $8725869b83961a04$export$8759762a6477f2c4 || texture.mapping === $8725869b83961a04$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $8725869b83961a04$var$_oldTarget = this._renderer.getRenderTarget();
        $8725869b83961a04$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $8725869b83961a04$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $8725869b83961a04$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $8725869b83961a04$export$8a72f490b25c56c8,
            minFilter: $8725869b83961a04$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $8725869b83961a04$export$2697304443f382bc,
            format: $8725869b83961a04$export$3f8bb04b555a363c,
            colorSpace: $8725869b83961a04$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $8725869b83961a04$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $8725869b83961a04$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $8725869b83961a04$var$_createPlanes(_lodMax));
            this._blurMaterial = $8725869b83961a04$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $8725869b83961a04$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $8725869b83961a04$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $8725869b83961a04$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($8725869b83961a04$var$_clearColor);
        renderer.toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $8725869b83961a04$export$55cbcc9b622fe1f5({
            name: 'PMREM.Background',
            side: $8725869b83961a04$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($8725869b83961a04$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $8725869b83961a04$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $8725869b83961a04$export$8759762a6477f2c4 || texture.mapping === $8725869b83961a04$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $8725869b83961a04$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $8725869b83961a04$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $8725869b83961a04$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $8725869b83961a04$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $8725869b83961a04$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $8725869b83961a04$var$_axisDirections[(n - i - 1) % $8725869b83961a04$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $8725869b83961a04$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $8725869b83961a04$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $8725869b83961a04$var$MAX_SAMPLES;
        if (samples > $8725869b83961a04$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$8725869b83961a04$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $8725869b83961a04$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $8725869b83961a04$var$LOD_MIN ? lodOut - _lodMax + $8725869b83961a04$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $8725869b83961a04$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $8725869b83961a04$var$_flatCamera);
    }
}
function $8725869b83961a04$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $8725869b83961a04$var$LOD_MIN + 1 + $8725869b83961a04$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $8725869b83961a04$var$LOD_MIN) sigma = $8725869b83961a04$var$EXTRA_LOD_SIGMA[i - lodMax + $8725869b83961a04$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $8725869b83961a04$export$b7be63a67df8959();
        planes.setAttribute('position', new $8725869b83961a04$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $8725869b83961a04$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $8725869b83961a04$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $8725869b83961a04$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $8725869b83961a04$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $8725869b83961a04$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $8725869b83961a04$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $8725869b83961a04$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $8725869b83961a04$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($8725869b83961a04$var$MAX_SAMPLES);
    const poleAxis = new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $8725869b83961a04$export$83c7d75d550a8b0d({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $8725869b83961a04$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $8725869b83961a04$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $8725869b83961a04$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $8725869b83961a04$var$_getEquirectMaterial() {
    return new $8725869b83961a04$export$83c7d75d550a8b0d({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $8725869b83961a04$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $8725869b83961a04$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $8725869b83961a04$var$_getCubemapMaterial() {
    return new $8725869b83961a04$export$83c7d75d550a8b0d({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $8725869b83961a04$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $8725869b83961a04$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $8725869b83961a04$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $8725869b83961a04$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $8725869b83961a04$export$d64030b316d3b087 || mapping === $8725869b83961a04$export$ee99d97d46898098;
            const isCubeMap = mapping === $8725869b83961a04$export$8759762a6477f2c4 || mapping === $8725869b83961a04$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $8725869b83961a04$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $8725869b83961a04$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $8725869b83961a04$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) $8725869b83961a04$var$warnOnce('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $8725869b83961a04$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($8725869b83961a04$var$arrayNeedsUint32(indices) ? $8725869b83961a04$export$7eb8c9fa25cd5bd6 : $8725869b83961a04$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $8725869b83961a04$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            for(let i = 0; i < primcount.length; i++)info.update(elementCount, mode, primcount[i]);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $8725869b83961a04$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $8725869b83961a04$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new $8725869b83961a04$export$fa7daccca11cdbe3();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new $8725869b83961a04$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
            texture.type = $8725869b83961a04$export$f6d331659b644596;
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new $8725869b83961a04$export$c977b3e384af9ae1(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $8725869b83961a04$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $8725869b83961a04$export$fc830aa069cc8c2f extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = $8725869b83961a04$export$c1b6b5136be58045){
        if (format !== $8725869b83961a04$export$c1b6b5136be58045 && format !== $8725869b83961a04$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $8725869b83961a04$export$c1b6b5136be58045) type = $8725869b83961a04$export$c3c7fc4518ebba96;
        if (type === undefined && format === $8725869b83961a04$export$1e113ac2d0905829) type = $8725869b83961a04$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $8725869b83961a04$var$emptyTexture = /*@__PURE__*/ new $8725869b83961a04$export$5431306cf43de24a();
const $8725869b83961a04$var$emptyShadowTexture = /*@__PURE__*/ new $8725869b83961a04$export$fc830aa069cc8c2f(1, 1);
const $8725869b83961a04$var$emptyArrayTexture = /*@__PURE__*/ new $8725869b83961a04$export$dfac6c8e811406a3();
const $8725869b83961a04$var$empty3dTexture = /*@__PURE__*/ new $8725869b83961a04$export$d7a3086320f856db();
const $8725869b83961a04$var$emptyCubeTexture = /*@__PURE__*/ new $8725869b83961a04$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $8725869b83961a04$var$arrayCacheF32 = [];
const $8725869b83961a04$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $8725869b83961a04$var$mat4array = new Float32Array(16);
const $8725869b83961a04$var$mat3array = new Float32Array(9);
const $8725869b83961a04$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $8725869b83961a04$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $8725869b83961a04$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $8725869b83961a04$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $8725869b83961a04$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $8725869b83961a04$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $8725869b83961a04$var$allocTexUnits(textures, n) {
    let r = $8725869b83961a04$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $8725869b83961a04$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $8725869b83961a04$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $8725869b83961a04$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $8725869b83961a04$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $8725869b83961a04$var$copyArray(cache, v);
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, elements)) return;
        $8725869b83961a04$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $8725869b83961a04$var$mat2array);
        $8725869b83961a04$var$copyArray(cache, elements);
    }
}
function $8725869b83961a04$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $8725869b83961a04$var$copyArray(cache, v);
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, elements)) return;
        $8725869b83961a04$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $8725869b83961a04$var$mat3array);
        $8725869b83961a04$var$copyArray(cache, elements);
    }
}
function $8725869b83961a04$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $8725869b83961a04$var$copyArray(cache, v);
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, elements)) return;
        $8725869b83961a04$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $8725869b83961a04$var$mat4array);
        $8725869b83961a04$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $8725869b83961a04$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $8725869b83961a04$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $8725869b83961a04$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $8725869b83961a04$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $8725869b83961a04$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $8725869b83961a04$var$emptyShadowTexture.compareFunction = $8725869b83961a04$export$64eea11eb407ddf1; // #28670
        emptyTexture2D = $8725869b83961a04$var$emptyShadowTexture;
    } else emptyTexture2D = $8725869b83961a04$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $8725869b83961a04$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $8725869b83961a04$var$empty3dTexture, unit);
}
function $8725869b83961a04$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $8725869b83961a04$var$emptyCubeTexture, unit);
}
function $8725869b83961a04$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $8725869b83961a04$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $8725869b83961a04$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $8725869b83961a04$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $8725869b83961a04$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $8725869b83961a04$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $8725869b83961a04$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $8725869b83961a04$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $8725869b83961a04$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $8725869b83961a04$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $8725869b83961a04$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $8725869b83961a04$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $8725869b83961a04$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $8725869b83961a04$var$setValueV4i; // _VEC4
        case 0x1405:
            return $8725869b83961a04$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $8725869b83961a04$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $8725869b83961a04$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $8725869b83961a04$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $8725869b83961a04$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $8725869b83961a04$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $8725869b83961a04$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $8725869b83961a04$var$setValueT2DArray1;
    }
}
// Array of scalars
function $8725869b83961a04$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $8725869b83961a04$var$setValueV2fArray(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $8725869b83961a04$var$setValueV3fArray(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $8725869b83961a04$var$setValueV4fArray(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $8725869b83961a04$var$setValueM2Array(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $8725869b83961a04$var$setValueM3Array(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $8725869b83961a04$var$setValueM4Array(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $8725869b83961a04$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $8725869b83961a04$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $8725869b83961a04$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $8725869b83961a04$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $8725869b83961a04$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $8725869b83961a04$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $8725869b83961a04$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $8725869b83961a04$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $8725869b83961a04$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $8725869b83961a04$var$emptyTexture, units[i]);
}
function $8725869b83961a04$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $8725869b83961a04$var$empty3dTexture, units[i]);
}
function $8725869b83961a04$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $8725869b83961a04$var$emptyCubeTexture, units[i]);
}
function $8725869b83961a04$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $8725869b83961a04$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $8725869b83961a04$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $8725869b83961a04$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $8725869b83961a04$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $8725869b83961a04$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $8725869b83961a04$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $8725869b83961a04$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $8725869b83961a04$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $8725869b83961a04$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $8725869b83961a04$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $8725869b83961a04$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $8725869b83961a04$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $8725869b83961a04$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $8725869b83961a04$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $8725869b83961a04$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $8725869b83961a04$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $8725869b83961a04$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $8725869b83961a04$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $8725869b83961a04$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $8725869b83961a04$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $8725869b83961a04$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $8725869b83961a04$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $8725869b83961a04$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $8725869b83961a04$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $8725869b83961a04$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $8725869b83961a04$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $8725869b83961a04$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $8725869b83961a04$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $8725869b83961a04$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $8725869b83961a04$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $8725869b83961a04$var$RePathPart.exec(path), matchEnd = $8725869b83961a04$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $8725869b83961a04$var$addUniform(container, subscript === undefined ? new $8725869b83961a04$var$SingleUniform(id, activeInfo, addr) : new $8725869b83961a04$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $8725869b83961a04$var$StructuredUniform(id);
                $8725869b83961a04$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $8725869b83961a04$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $8725869b83961a04$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $8725869b83961a04$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $8725869b83961a04$var$COMPLETION_STATUS_KHR = 0x91B1;
let $8725869b83961a04$var$programIdCount = 0;
function $8725869b83961a04$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
function $8725869b83961a04$var$getEncodingComponents(colorSpace1) {
    const workingPrimaries = $8725869b83961a04$export$5e6fd513f44698c.getPrimaries($8725869b83961a04$export$5e6fd513f44698c.workingColorSpace);
    const encodingPrimaries = $8725869b83961a04$export$5e6fd513f44698c.getPrimaries(colorSpace1);
    let gamutMapping;
    if (workingPrimaries === encodingPrimaries) gamutMapping = '';
    else if (workingPrimaries === $8725869b83961a04$export$ef371755dbe7f98a && encodingPrimaries === $8725869b83961a04$export$ce9118f9eaae3bb2) gamutMapping = 'LinearDisplayP3ToLinearSRGB';
    else if (workingPrimaries === $8725869b83961a04$export$ce9118f9eaae3bb2 && encodingPrimaries === $8725869b83961a04$export$ef371755dbe7f98a) gamutMapping = 'LinearSRGBToLinearDisplayP3';
    switch(colorSpace1){
        case $8725869b83961a04$export$42429b3acfb233a4:
        case $8725869b83961a04$export$c0dc1bc7e964761:
            return [
                gamutMapping,
                'LinearTransferOETF'
            ];
        case $8725869b83961a04$export$561f394b24edfcaa:
        case $8725869b83961a04$export$626af19ae879bdf6:
            return [
                gamutMapping,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space:', colorSpace1);
            return [
                gamutMapping,
                'LinearTransferOETF'
            ];
    }
}
function $8725869b83961a04$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $8725869b83961a04$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $8725869b83961a04$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $8725869b83961a04$var$getEncodingComponents(colorSpace1);
    return `vec4 ${functionName}( vec4 value ) { return ${components[0]}( ${components[1]}( value ) ); }`;
}
function $8725869b83961a04$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $8725869b83961a04$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $8725869b83961a04$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $8725869b83961a04$export$932b3dd283d4a366:
            toneMappingName = 'Cineon';
            break;
        case $8725869b83961a04$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $8725869b83961a04$export$212d53a513a325b2:
            toneMappingName = 'AgX';
            break;
        case $8725869b83961a04$export$f2863e1668a8e317:
            toneMappingName = 'Neutral';
            break;
        case $8725869b83961a04$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $8725869b83961a04$var$_v0$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
function $8725869b83961a04$var$getLuminanceFunction() {
    $8725869b83961a04$export$5e6fd513f44698c.getLuminanceCoefficients($8725869b83961a04$var$_v0$1);
    const r = $8725869b83961a04$var$_v0$1.x.toFixed(4);
    const g = $8725869b83961a04$var$_v0$1.y.toFixed(4);
    const b = $8725869b83961a04$var$_v0$1.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $8725869b83961a04$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($8725869b83961a04$var$filterEmptyLine).join('\n');
}
function $8725869b83961a04$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $8725869b83961a04$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $8725869b83961a04$var$filterEmptyLine(string) {
    return string !== '';
}
function $8725869b83961a04$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $8725869b83961a04$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $8725869b83961a04$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $8725869b83961a04$var$resolveIncludes(string) {
    return string.replace($8725869b83961a04$var$includePattern, $8725869b83961a04$var$includeReplacer);
}
const $8725869b83961a04$var$shaderChunkMap = new Map();
function $8725869b83961a04$var$includeReplacer(match, include) {
    let string = $8725869b83961a04$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $8725869b83961a04$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $8725869b83961a04$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $8725869b83961a04$var$resolveIncludes(string);
}
// Unroll Loops
const $8725869b83961a04$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $8725869b83961a04$var$unrollLoops(string) {
    return string.replace($8725869b83961a04$var$unrollLoopPattern, $8725869b83961a04$var$loopReplacer);
}
function $8725869b83961a04$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $8725869b83961a04$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $8725869b83961a04$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $8725869b83961a04$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $8725869b83961a04$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $8725869b83961a04$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $8725869b83961a04$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $8725869b83961a04$export$8759762a6477f2c4:
        case $8725869b83961a04$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $8725869b83961a04$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $8725869b83961a04$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $8725869b83961a04$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $8725869b83961a04$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $8725869b83961a04$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $8725869b83961a04$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $8725869b83961a04$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $8725869b83961a04$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $8725869b83961a04$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $8725869b83961a04$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $8725869b83961a04$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $8725869b83961a04$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $8725869b83961a04$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $8725869b83961a04$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $8725869b83961a04$var$generateVertexExtensions(parameters);
    const customDefines = $8725869b83961a04$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($8725869b83961a04$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($8725869b83961a04$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $8725869b83961a04$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($8725869b83961a04$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $8725869b83961a04$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $8725869b83961a04$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $8725869b83961a04$export$9fcb6b4294603b2 ? $8725869b83961a04$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $8725869b83961a04$export$9fcb6b4294603b2 ? $8725869b83961a04$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $8725869b83961a04$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $8725869b83961a04$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $8725869b83961a04$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($8725869b83961a04$var$filterEmptyLine).join('\n');
    }
    vertexShader = $8725869b83961a04$var$resolveIncludes(vertexShader);
    vertexShader = $8725869b83961a04$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $8725869b83961a04$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $8725869b83961a04$var$resolveIncludes(fragmentShader);
    fragmentShader = $8725869b83961a04$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $8725869b83961a04$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $8725869b83961a04$var$unrollLoops(vertexShader);
    fragmentShader = $8725869b83961a04$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $8725869b83961a04$export$f63012db5506e7dd ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === $8725869b83961a04$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $8725869b83961a04$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $8725869b83961a04$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $8725869b83961a04$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $8725869b83961a04$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $8725869b83961a04$var$WebGLUniforms(gl, program);
        cachedAttributes = $8725869b83961a04$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $8725869b83961a04$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $8725869b83961a04$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $8725869b83961a04$var$_id$1 = 0;
class $8725869b83961a04$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $8725869b83961a04$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $8725869b83961a04$var$WebGLShaderStage {
    constructor(code){
        this.id = $8725869b83961a04$var$_id$1++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $8725869b83961a04$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $8725869b83961a04$export$89312ce47c0ca777();
    const _customShaders = new $8725869b83961a04$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $8725869b83961a04$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $8725869b83961a04$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $8725869b83961a04$export$42429b3acfb233a4,
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $8725869b83961a04$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $8725869b83961a04$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $8725869b83961a04$export$5b29a26d96ee6af0 && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && $8725869b83961a04$export$5e6fd513f44698c.getTransfer(material.map.colorSpace) === $8725869b83961a04$export$8d0a61916cc26abb,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $8725869b83961a04$export$3b296b6f144d5b03,
            flipSided: material.side === $8725869b83961a04$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.doubleSided) _programLayers.enable(10);
        if (parameters.flipSided) _programLayers.enable(11);
        if (parameters.useDepthPacking) _programLayers.enable(12);
        if (parameters.dithering) _programLayers.enable(13);
        if (parameters.transmission) _programLayers.enable(14);
        if (parameters.sheen) _programLayers.enable(15);
        if (parameters.opaque) _programLayers.enable(16);
        if (parameters.pointsUvs) _programLayers.enable(17);
        if (parameters.decodeVideoTexture) _programLayers.enable(18);
        if (parameters.alphaToCoverage) _programLayers.enable(19);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $8725869b83961a04$export$bee4a7d47f8f5014[shaderID];
            uniforms = $8725869b83961a04$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $8725869b83961a04$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $8725869b83961a04$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $8725869b83961a04$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $8725869b83961a04$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $8725869b83961a04$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $8725869b83961a04$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $8725869b83961a04$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $8725869b83961a04$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $8725869b83961a04$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $8725869b83961a04$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $8725869b83961a04$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $8725869b83961a04$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $8725869b83961a04$export$64b5c384219d3699(),
                        color: new $8725869b83961a04$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $8725869b83961a04$export$64b5c384219d3699(),
                        direction: new $8725869b83961a04$export$64b5c384219d3699(),
                        color: new $8725869b83961a04$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $8725869b83961a04$export$64b5c384219d3699(),
                        color: new $8725869b83961a04$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $8725869b83961a04$export$64b5c384219d3699(),
                        skyColor: new $8725869b83961a04$export$892596cec99bc70e(),
                        groundColor: new $8725869b83961a04$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $8725869b83961a04$export$892596cec99bc70e(),
                        position: new $8725869b83961a04$export$64b5c384219d3699(),
                        halfWidth: new $8725869b83961a04$export$64b5c384219d3699(),
                        halfHeight: new $8725869b83961a04$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $8725869b83961a04$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $8725869b83961a04$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $8725869b83961a04$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $8725869b83961a04$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $8725869b83961a04$var$nextVersion = 0;
function $8725869b83961a04$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $8725869b83961a04$var$WebGLLights(extensions) {
    const cache = new $8725869b83961a04$var$UniformsCache();
    const shadowCache = $8725869b83961a04$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $8725869b83961a04$export$64b5c384219d3699());
    const vector3 = new $8725869b83961a04$export$64b5c384219d3699();
    const matrix4 = new $8725869b83961a04$export$2ae72fc923e5eb5();
    const matrix42 = new $8725869b83961a04$export$2ae72fc923e5eb5();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($8725869b83961a04$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $8725869b83961a04$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $8725869b83961a04$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $8725869b83961a04$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $8725869b83961a04$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $8725869b83961a04$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $8725869b83961a04$var$WebGLRenderState(extensions) {
    const lights = new $8725869b83961a04$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $8725869b83961a04$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $8725869b83961a04$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $8725869b83961a04$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $8725869b83961a04$export$2698c22ec13825db extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $8725869b83961a04$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $8725869b83961a04$export$33e187ed002f2a19 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $8725869b83961a04$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $8725869b83961a04$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $8725869b83961a04$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new $8725869b83961a04$export$35efe6f4c85463d2();
    const _shadowMapSize = new $8725869b83961a04$export$c977b3e384af9ae1(), _viewportSize = new $8725869b83961a04$export$c977b3e384af9ae1(), _viewport = new $8725869b83961a04$export$fa7daccca11cdbe3(), _depthMaterial = new $8725869b83961a04$export$2698c22ec13825db({
        depthPacking: $8725869b83961a04$export$8f910f4c4f73df11
    }), _distanceMaterial = new $8725869b83961a04$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [$8725869b83961a04$export$2ede184fc2998901]: $8725869b83961a04$export$d9f0486e75b5ace,
        [$8725869b83961a04$export$d9f0486e75b5ace]: $8725869b83961a04$export$2ede184fc2998901,
        [$8725869b83961a04$export$3b296b6f144d5b03]: $8725869b83961a04$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $8725869b83961a04$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $8725869b83961a04$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $8725869b83961a04$var$vertex,
        fragmentShader: $8725869b83961a04$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $8725869b83961a04$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $8725869b83961a04$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $8725869b83961a04$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $8725869b83961a04$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending($8725869b83961a04$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $8725869b83961a04$export$896ae1ade6c829c4 && this.type === $8725869b83961a04$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $8725869b83961a04$export$896ae1ade6c829c4 && this.type !== $8725869b83961a04$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $8725869b83961a04$export$896ae1ade6c829c4 ? {
                    minFilter: $8725869b83961a04$export$727aa5ec3fe39bf0,
                    magFilter: $8725869b83961a04$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $8725869b83961a04$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $8725869b83961a04$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $8725869b83961a04$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $8725869b83961a04$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $8725869b83961a04$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
function $8725869b83961a04$var$WebGLState(gl) {
    function ColorBuffer() {
        let locked = false;
        const color = new $8725869b83961a04$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $8725869b83961a04$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $8725869b83961a04$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $8725869b83961a04$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $8725869b83961a04$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $8725869b83961a04$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $8725869b83961a04$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $8725869b83961a04$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $8725869b83961a04$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new $8725869b83961a04$export$892596cec99bc70e(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $8725869b83961a04$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $8725869b83961a04$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($8725869b83961a04$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($8725869b83961a04$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($8725869b83961a04$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$8725869b83961a04$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$8725869b83961a04$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$8725869b83961a04$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[$8725869b83961a04$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[$8725869b83961a04$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [$8725869b83961a04$export$2110f05edf778d3d]: gl.ZERO,
        [$8725869b83961a04$export$8805bad65e24940e]: gl.ONE,
        [$8725869b83961a04$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$8725869b83961a04$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$8725869b83961a04$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$8725869b83961a04$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$8725869b83961a04$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$8725869b83961a04$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$8725869b83961a04$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$8725869b83961a04$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$8725869b83961a04$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA,
        [$8725869b83961a04$export$7dd8f434fd59075]: gl.CONSTANT_COLOR,
        [$8725869b83961a04$export$99c8d898a9afbcee]: gl.ONE_MINUS_CONSTANT_COLOR,
        [$8725869b83961a04$export$310cd2be38d13b56]: gl.CONSTANT_ALPHA,
        [$8725869b83961a04$export$db77b8fbcf45dbf4]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === $8725869b83961a04$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $8725869b83961a04$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $8725869b83961a04$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $8725869b83961a04$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $8725869b83961a04$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $8725869b83961a04$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $8725869b83961a04$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $8725869b83961a04$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $8725869b83961a04$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $8725869b83961a04$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $8725869b83961a04$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $8725869b83961a04$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $8725869b83961a04$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $8725869b83961a04$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $8725869b83961a04$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $8725869b83961a04$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $8725869b83961a04$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($8725869b83961a04$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $8725869b83961a04$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $8725869b83961a04$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $8725869b83961a04$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new $8725869b83961a04$export$892596cec99bc70e(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $8725869b83961a04$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
function $8725869b83961a04$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
function $8725869b83961a04$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Given the width, height, format, and type of a texture. Determines how many
 * bytes must be used to represent the texture.
 */ function $8725869b83961a04$var$getByteLength(width, height, format, type) {
    const typeByteLength = $8725869b83961a04$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $8725869b83961a04$export$988473390501ed4b:
            return width * height;
        case $8725869b83961a04$export$cc09ccbf6d1ed449:
            return width * height;
        case $8725869b83961a04$export$9053a81c4a69c289:
            return width * height * 2;
        case $8725869b83961a04$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $8725869b83961a04$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $8725869b83961a04$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $8725869b83961a04$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $8725869b83961a04$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $8725869b83961a04$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $8725869b83961a04$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $8725869b83961a04$export$21d1799c6d552fc0:
        case $8725869b83961a04$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $8725869b83961a04$export$d2a1a68024a3e56c:
        case $8725869b83961a04$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $8725869b83961a04$export$d0f0355bb3d948e4:
        case $8725869b83961a04$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $8725869b83961a04$export$19ada9bbb1af3573:
        case $8725869b83961a04$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $8725869b83961a04$export$6ab91af2d757aee7:
        case $8725869b83961a04$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $8725869b83961a04$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $8725869b83961a04$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $8725869b83961a04$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $8725869b83961a04$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $8725869b83961a04$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $8725869b83961a04$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $8725869b83961a04$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $8725869b83961a04$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $8725869b83961a04$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $8725869b83961a04$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $8725869b83961a04$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $8725869b83961a04$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $8725869b83961a04$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $8725869b83961a04$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $8725869b83961a04$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $8725869b83961a04$export$ce40b115e188bc81:
        case $8725869b83961a04$export$d279c5c4bac5121e:
        case $8725869b83961a04$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $8725869b83961a04$export$b1688df4c4c21670:
        case $8725869b83961a04$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $8725869b83961a04$export$d220f6ade8463a0f:
        case $8725869b83961a04$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $8725869b83961a04$var$getTextureTypeByteLength(type) {
    switch(type){
        case $8725869b83961a04$export$2e8ce08d3f6f5e10:
        case $8725869b83961a04$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $8725869b83961a04$export$c63dc51868b06a9d:
        case $8725869b83961a04$export$88572337f312435f:
        case $8725869b83961a04$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $8725869b83961a04$export$b3969b01faf587f2:
        case $8725869b83961a04$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $8725869b83961a04$export$c3c7fc4518ebba96:
        case $8725869b83961a04$export$5c612977753abe2:
        case $8725869b83961a04$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $8725869b83961a04$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
const $8725869b83961a04$export$ec276d39f33d4b7 = {
    contain: $8725869b83961a04$var$contain,
    cover: $8725869b83961a04$var$cover,
    fill: $8725869b83961a04$var$fill,
    getByteLength: $8725869b83961a04$var$getByteLength
};
function $8725869b83961a04$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new $8725869b83961a04$export$c977b3e384af9ae1();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $8725869b83961a04$var$createElementNS('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps && texture.minFilter !== $8725869b83961a04$export$727aa5ec3fe39bf0 && texture.minFilter !== $8725869b83961a04$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? $8725869b83961a04$export$f197347d588c1b4a : $8725869b83961a04$export$5e6fd513f44698c.getTransfer(colorSpace1);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === $8725869b83961a04$export$8d0a61916cc26abb ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === $8725869b83961a04$export$c3c7fc4518ebba96 || depthType === $8725869b83961a04$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === $8725869b83961a04$export$f6d331659b644596) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === $8725869b83961a04$export$c63dc51868b06a9d) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === $8725869b83961a04$export$c3c7fc4518ebba96 || depthType === $8725869b83961a04$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === $8725869b83961a04$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === $8725869b83961a04$export$c63dc51868b06a9d) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== $8725869b83961a04$export$727aa5ec3fe39bf0 && texture.minFilter !== $8725869b83961a04$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$8725869b83961a04$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$8725869b83961a04$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$8725869b83961a04$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$8725869b83961a04$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$8725869b83961a04$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$8725869b83961a04$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$8725869b83961a04$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$8725869b83961a04$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$8725869b83961a04$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$8725869b83961a04$export$d9e2d19a747baaab]: _gl.NEVER,
        [$8725869b83961a04$export$187b73a3e352c145]: _gl.ALWAYS,
        [$8725869b83961a04$export$36bcf49c713b3eb7]: _gl.LESS,
        [$8725869b83961a04$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$8725869b83961a04$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$8725869b83961a04$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$8725869b83961a04$export$155af022118f3a38]: _gl.GREATER,
        [$8725869b83961a04$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === $8725869b83961a04$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === $8725869b83961a04$export$8a72f490b25c56c8 || texture.magFilter === $8725869b83961a04$export$19a719f377145a13 || texture.magFilter === $8725869b83961a04$export$d2327c1afe5bfdf2 || texture.magFilter === $8725869b83961a04$export$5d8599b6a933fb1b || texture.minFilter === $8725869b83961a04$export$8a72f490b25c56c8 || texture.minFilter === $8725869b83961a04$export$19a719f377145a13 || texture.minFilter === $8725869b83961a04$export$d2327c1afe5bfdf2 || texture.minFilter === $8725869b83961a04$export$5d8599b6a933fb1b)) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === $8725869b83961a04$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $8725869b83961a04$export$d2327c1afe5bfdf2 && texture.minFilter !== $8725869b83961a04$export$5d8599b6a933fb1b) return;
            if (texture.type === $8725869b83961a04$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $8725869b83961a04$export$5e6fd513f44698c.getPrimaries($8725869b83961a04$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $8725869b83961a04$export$bfcb490c2dd3db51 ? null : $8725869b83961a04$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $8725869b83961a04$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === $8725869b83961a04$export$1e113ac2d0905829, texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $8725869b83961a04$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = $8725869b83961a04$var$getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData, 0, 0);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $8725869b83961a04$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = $8725869b83961a04$var$getByteLength(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $8725869b83961a04$export$5e6fd513f44698c.getPrimaries($8725869b83961a04$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $8725869b83961a04$export$bfcb490c2dd3db51 ? null : $8725869b83961a04$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $8725869b83961a04$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $8725869b83961a04$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $8725869b83961a04$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $8725869b83961a04$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace1 !== $8725869b83961a04$export$42429b3acfb233a4 && colorSpace1 !== $8725869b83961a04$export$bfcb490c2dd3db51) {
            // sRGB
            if ($8725869b83961a04$export$5e6fd513f44698c.getTransfer(colorSpace1) === $8725869b83961a04$export$8d0a61916cc26abb) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== $8725869b83961a04$export$3f8bb04b555a363c || type !== $8725869b83961a04$export$2e8ce08d3f6f5e10) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace1);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $8725869b83961a04$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace1 = $8725869b83961a04$export$bfcb490c2dd3db51) {
        let extension;
        const transfer = $8725869b83961a04$export$5e6fd513f44698c.getTransfer(colorSpace1);
        if (p === $8725869b83961a04$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $8725869b83961a04$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $8725869b83961a04$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $8725869b83961a04$export$5a4c329b7e2092d3) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === $8725869b83961a04$export$545fce0311a9796a) return gl.BYTE;
        if (p === $8725869b83961a04$export$88572337f312435f) return gl.SHORT;
        if (p === $8725869b83961a04$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $8725869b83961a04$export$5c612977753abe2) return gl.INT;
        if (p === $8725869b83961a04$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $8725869b83961a04$export$f6d331659b644596) return gl.FLOAT;
        if (p === $8725869b83961a04$export$2697304443f382bc) return gl.HALF_FLOAT;
        if (p === $8725869b83961a04$export$988473390501ed4b) return gl.ALPHA;
        if (p === $8725869b83961a04$export$7c67423a5ee6f5eb) return gl.RGB;
        if (p === $8725869b83961a04$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $8725869b83961a04$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $8725869b83961a04$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $8725869b83961a04$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $8725869b83961a04$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === $8725869b83961a04$export$4e041a7967d15c4b) return gl.RED;
        if (p === $8725869b83961a04$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $8725869b83961a04$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $8725869b83961a04$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $8725869b83961a04$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $8725869b83961a04$export$21d1799c6d552fc0 || p === $8725869b83961a04$export$afa304c3e981b668 || p === $8725869b83961a04$export$d2a1a68024a3e56c || p === $8725869b83961a04$export$9a79c424327dacf9) {
            if (transfer === $8725869b83961a04$export$8d0a61916cc26abb) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === $8725869b83961a04$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $8725869b83961a04$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === $8725869b83961a04$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $8725869b83961a04$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $8725869b83961a04$export$19ada9bbb1af3573 || p === $8725869b83961a04$export$d0f0355bb3d948e4 || p === $8725869b83961a04$export$b82296714358084c || p === $8725869b83961a04$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $8725869b83961a04$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $8725869b83961a04$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $8725869b83961a04$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $8725869b83961a04$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === $8725869b83961a04$export$6ab91af2d757aee7 || p === $8725869b83961a04$export$7800993ef8106a6a || p === $8725869b83961a04$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $8725869b83961a04$export$6ab91af2d757aee7 || p === $8725869b83961a04$export$7800993ef8106a6a) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $8725869b83961a04$export$23ed8300a860e7d8) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $8725869b83961a04$export$dc5570b4a2b92d48 || p === $8725869b83961a04$export$68880cd325f8b2fb || p === $8725869b83961a04$export$7d2c0be323373d95 || p === $8725869b83961a04$export$22b52da301fc3a3e || p === $8725869b83961a04$export$c009e2cb4a66485e || p === $8725869b83961a04$export$118fff5afa255b63 || p === $8725869b83961a04$export$120713c829ae0667 || p === $8725869b83961a04$export$c79eeabbf53313e9 || p === $8725869b83961a04$export$443cf6567cdd6424 || p === $8725869b83961a04$export$6573984fc9840780 || p === $8725869b83961a04$export$e7aee563f30091de || p === $8725869b83961a04$export$2eb8634622ddeab7 || p === $8725869b83961a04$export$202b1ce7b5d25742 || p === $8725869b83961a04$export$18ab77abd087e467) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === $8725869b83961a04$export$dc5570b4a2b92d48) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $8725869b83961a04$export$68880cd325f8b2fb) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $8725869b83961a04$export$7d2c0be323373d95) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $8725869b83961a04$export$22b52da301fc3a3e) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $8725869b83961a04$export$c009e2cb4a66485e) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $8725869b83961a04$export$118fff5afa255b63) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $8725869b83961a04$export$120713c829ae0667) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $8725869b83961a04$export$c79eeabbf53313e9) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $8725869b83961a04$export$443cf6567cdd6424) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $8725869b83961a04$export$6573984fc9840780) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $8725869b83961a04$export$e7aee563f30091de) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $8725869b83961a04$export$2eb8634622ddeab7) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $8725869b83961a04$export$202b1ce7b5d25742) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $8725869b83961a04$export$18ab77abd087e467) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $8725869b83961a04$export$ce40b115e188bc81 || p === $8725869b83961a04$export$d279c5c4bac5121e || p === $8725869b83961a04$export$cde52d17225fdbd3) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === $8725869b83961a04$export$ce40b115e188bc81) return transfer === $8725869b83961a04$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === $8725869b83961a04$export$d279c5c4bac5121e) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === $8725869b83961a04$export$cde52d17225fdbd3) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === $8725869b83961a04$export$b1688df4c4c21670 || p === $8725869b83961a04$export$fc15e5d8261eed58 || p === $8725869b83961a04$export$d220f6ade8463a0f || p === $8725869b83961a04$export$768646d09dc1b6ef) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === $8725869b83961a04$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $8725869b83961a04$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $8725869b83961a04$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $8725869b83961a04$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $8725869b83961a04$export$6c8ea339bfab1301) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $8725869b83961a04$export$56b937d9e5581166 extends $8725869b83961a04$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $8725869b83961a04$export$eb2fcfdbd7ba97d4 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
const $8725869b83961a04$var$_moveEvent = {
    type: 'move'
};
class $8725869b83961a04$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $8725869b83961a04$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $8725869b83961a04$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $8725869b83961a04$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $8725869b83961a04$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($8725869b83961a04$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
const $8725869b83961a04$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $8725869b83961a04$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class $8725869b83961a04$var$WebXRDepthSensing {
    constructor(){
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
    }
    init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new $8725869b83961a04$export$5431306cf43de24a();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear != renderState.depthNear || depthData.depthFar != renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new $8725869b83961a04$export$83c7d75d550a8b0d({
                    vertexShader: $8725869b83961a04$var$_occlusion_vertex,
                    fragmentShader: $8725869b83961a04$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$967d831af31f69ce(20, 20), material);
            }
        }
        return this.mesh;
    }
    reset() {
        this.texture = null;
        this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $8725869b83961a04$var$WebXRManager extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $8725869b83961a04$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new $8725869b83961a04$export$c977b3e384af9ae1();
        let currentPixelRatio = null;
        //
        const cameraL = new $8725869b83961a04$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const cameraR = new $8725869b83961a04$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $8725869b83961a04$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $8725869b83961a04$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $8725869b83961a04$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $8725869b83961a04$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                if (session.renderState.layers === undefined) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new $8725869b83961a04$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $8725869b83961a04$export$3f8bb04b555a363c,
                        type: $8725869b83961a04$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $8725869b83961a04$export$1e113ac2d0905829 : $8725869b83961a04$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $8725869b83961a04$export$6c8ea339bfab1301 : $8725869b83961a04$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new $8725869b83961a04$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $8725869b83961a04$export$3f8bb04b555a363c,
                        type: $8725869b83961a04$export$2e8ce08d3f6f5e10,
                        depthTexture: new $8725869b83961a04$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $8725869b83961a04$export$64b5c384219d3699();
        const cameraRPos = new $8725869b83961a04$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $8725869b83961a04$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $8725869b83961a04$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                if (enabledFeatures && enabledFeatures.includes('depth-sensing')) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $8725869b83961a04$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $8725869b83961a04$var$_e1 = /*@__PURE__*/ new $8725869b83961a04$export$d93cc409a0768c5f();
const $8725869b83961a04$var$_m1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
function $8725869b83961a04$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $8725869b83961a04$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $8725869b83961a04$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $8725869b83961a04$var$_e1.x *= -1;
            $8725869b83961a04$var$_e1.y *= -1;
            $8725869b83961a04$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $8725869b83961a04$var$_e1.y *= -1;
                $8725869b83961a04$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($8725869b83961a04$var$_m1.makeRotationFromEuler($8725869b83961a04$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $8725869b83961a04$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $8725869b83961a04$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $8725869b83961a04$export$1033a2df66368859(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = $8725869b83961a04$export$561f394b24edfcaa;
        // tone mapping
        this.toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const _currentScissor = new $8725869b83961a04$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $8725869b83961a04$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _projScreenMatrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        const _vector3 = new $8725869b83961a04$export$64b5c384219d3699();
        const _vector4 = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${$8725869b83961a04$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $8725869b83961a04$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $8725869b83961a04$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $8725869b83961a04$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $8725869b83961a04$var$WebGLState(_gl);
            info = new $8725869b83961a04$var$WebGLInfo(_gl);
            properties = new $8725869b83961a04$var$WebGLProperties();
            textures = new $8725869b83961a04$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $8725869b83961a04$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $8725869b83961a04$var$WebGLCubeUVMaps(_this);
            attributes = new $8725869b83961a04$var$WebGLAttributes(_gl);
            bindingStates = new $8725869b83961a04$var$WebGLBindingStates(_gl, attributes);
            geometries = new $8725869b83961a04$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $8725869b83961a04$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $8725869b83961a04$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $8725869b83961a04$var$WebGLClipping(properties);
            programCache = new $8725869b83961a04$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $8725869b83961a04$var$WebGLMaterials(_this, properties);
            renderLists = new $8725869b83961a04$var$WebGLRenderLists();
            renderStates = new $8725869b83961a04$var$WebGLRenderStates(extensions);
            background = new $8725869b83961a04$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $8725869b83961a04$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $8725869b83961a04$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $8725869b83961a04$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $8725869b83961a04$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $8725869b83961a04$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $8725869b83961a04$export$c200e7d26f592f21 || targetFormat === $8725869b83961a04$export$1ba1c45f9f77d4d7 || targetFormat === $8725869b83961a04$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $8725869b83961a04$export$2e8ce08d3f6f5e10 || targetType === $8725869b83961a04$export$c3c7fc4518ebba96 || targetType === $8725869b83961a04$export$c63dc51868b06a9d || targetType === $8725869b83961a04$export$6c8ea339bfab1301 || targetType === $8725869b83961a04$export$b3969b01faf587f2 || targetType === $8725869b83961a04$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === $8725869b83961a04$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $8725869b83961a04$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $8725869b83961a04$export$2ede184fc2998901;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $8725869b83961a04$export$3b296b6f144d5b03;
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $8725869b83961a04$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new $8725869b83961a04$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? $8725869b83961a04$export$2697304443f382bc : $8725869b83961a04$export$2e8ce08d3f6f5e10,
                minFilter: $8725869b83961a04$export$5d8599b6a933fb1b,
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z, activeViewport.w);
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === $8725869b83961a04$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = $8725869b83961a04$export$d9f0486e75b5ace;
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $8725869b83961a04$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $8725869b83961a04$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $8725869b83961a04$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $8725869b83961a04$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $8725869b83961a04$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $8725869b83961a04$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $8725869b83961a04$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $8725869b83961a04$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                        const glBuffer = _gl.createBuffer();
                        _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                        _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                        _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                        _gl.flush();
                        // check if the commands have finished every 8 ms
                        const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                        await $8725869b83961a04$var$probeAsync(_gl, sync, 4);
                        try {
                            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                            _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                        } finally{
                            _gl.deleteBuffer(glBuffer);
                            _gl.deleteSync(sync);
                        }
                        return buffer;
                    }
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            // support previous signature with position first
            if (texture.isTexture !== true) {
                // @deprecated, r165
                $8725869b83961a04$var$warnOnce('WebGLRenderer: copyFramebufferToTexture function signature has changed.');
                position = arguments[0] || null;
                texture = arguments[1];
            }
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with dstPosition first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $8725869b83961a04$var$warnOnce('WebGLRenderer: copyTextureToTexture function signature has changed.');
                dstPosition = arguments[0] || null;
                srcTexture = arguments[1];
                dstTexture = arguments[2];
                level = arguments[3] || 0;
                srcRegion = null;
            }
            let width, height, minX, minY;
            let dstX, dstY;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
            } else {
                width = srcTexture.image.width;
                height = srcTexture.image.height;
                minX = 0;
                minY = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
            } else {
                dstX = 0;
                dstY = 0;
            }
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, image.width, image.height, glFormat, image.data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with source box first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $8725869b83961a04$var$warnOnce('WebGLRenderer: copyTextureToTexture3D function signature has changed.');
                srcRegion = arguments[0] || null;
                dstPosition = arguments[1] || null;
                srcTexture = arguments[2];
                dstTexture = arguments[3];
                level = arguments[4] || 0;
            }
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.max.z - srcRegion.min.z;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.min.z;
            } else {
                width = image.width;
                height = image.height;
                depth = image.depth;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
            else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
            else _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $8725869b83961a04$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace1) {
        this._outputColorSpace = colorSpace1;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = colorSpace1 === $8725869b83961a04$export$626af19ae879bdf6 ? 'display-p3' : 'srgb';
        gl.unpackColorSpace = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace === $8725869b83961a04$export$c0dc1bc7e964761 ? 'display-p3' : 'srgb';
    }
}
class $8725869b83961a04$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $8725869b83961a04$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $8725869b83961a04$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $8725869b83961a04$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $8725869b83961a04$export$38af1803e3442a7f extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.backgroundRotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        this.environmentIntensity = 1;
        this.environmentRotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
class $8725869b83961a04$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $8725869b83961a04$export$763e8360f4d7f77d;
        this._updateRange = {
            offset: 0,
            count: -1
        };
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $8725869b83961a04$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    get updateRange() {
        $8725869b83961a04$var$warnOnce('THREE.InterleavedBuffer: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.'); // @deprecated, r159
        return this._updateRange;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $8725869b83961a04$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $8725869b83961a04$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $8725869b83961a04$var$_vector$6 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $8725869b83961a04$var$_vector$6.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$6.x, $8725869b83961a04$var$_vector$6.y, $8725869b83961a04$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$6.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$6.x, $8725869b83961a04$var$_vector$6.y, $8725869b83961a04$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$6.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$6.x, $8725869b83961a04$var$_vector$6.y, $8725869b83961a04$var$_vector$6.z);
        }
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $8725869b83961a04$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $8725869b83961a04$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $8725869b83961a04$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $8725869b83961a04$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $8725869b83961a04$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $8725869b83961a04$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $8725869b83961a04$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $8725869b83961a04$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $8725869b83961a04$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $8725869b83961a04$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
            w = $8725869b83961a04$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $8725869b83961a04$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $8725869b83961a04$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $8725869b83961a04$export$5ec7dd1c6994bf8e extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $8725869b83961a04$var$_geometry;
const $8725869b83961a04$var$_intersectPoint = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_worldScale = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_mvPosition = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_alignedPosition = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_rotatedPosition = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_viewWorldMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_vA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vB = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vC = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_uvA = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvB = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvC = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
class $8725869b83961a04$export$3075603db8e6204c extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(material = new $8725869b83961a04$export$5ec7dd1c6994bf8e()){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($8725869b83961a04$var$_geometry === undefined) {
            $8725869b83961a04$var$_geometry = new $8725869b83961a04$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $8725869b83961a04$export$3d5cd879f108f53f(float32Array, 5);
            $8725869b83961a04$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $8725869b83961a04$var$_geometry.setAttribute('position', new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $8725869b83961a04$var$_geometry.setAttribute('uv', new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $8725869b83961a04$var$_geometry;
        this.material = material;
        this.center = new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $8725869b83961a04$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $8725869b83961a04$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $8725869b83961a04$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $8725869b83961a04$var$_worldScale.multiplyScalar(-$8725869b83961a04$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vA.set(-0.5, -0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
        $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vB.set(0.5, -0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
        $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vC.set(0.5, 0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
        $8725869b83961a04$var$_uvA.set(0, 0);
        $8725869b83961a04$var$_uvB.set(1, 0);
        $8725869b83961a04$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($8725869b83961a04$var$_vA, $8725869b83961a04$var$_vB, $8725869b83961a04$var$_vC, false, $8725869b83961a04$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vB.set(-0.5, 0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
            $8725869b83961a04$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($8725869b83961a04$var$_vA, $8725869b83961a04$var$_vC, $8725869b83961a04$var$_vB, false, $8725869b83961a04$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($8725869b83961a04$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $8725869b83961a04$var$_intersectPoint.clone(),
            uv: $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectPoint, $8725869b83961a04$var$_vA, $8725869b83961a04$var$_vB, $8725869b83961a04$var$_vC, $8725869b83961a04$var$_uvA, $8725869b83961a04$var$_uvB, $8725869b83961a04$var$_uvC, new $8725869b83961a04$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $8725869b83961a04$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $8725869b83961a04$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $8725869b83961a04$var$_rotatedPosition.x = cos * $8725869b83961a04$var$_alignedPosition.x - sin * $8725869b83961a04$var$_alignedPosition.y;
        $8725869b83961a04$var$_rotatedPosition.y = sin * $8725869b83961a04$var$_alignedPosition.x + cos * $8725869b83961a04$var$_alignedPosition.y;
    } else $8725869b83961a04$var$_rotatedPosition.copy($8725869b83961a04$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $8725869b83961a04$var$_rotatedPosition.x;
    vertexPosition.y += $8725869b83961a04$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($8725869b83961a04$var$_viewWorldMatrix);
}
const $8725869b83961a04$var$_v1$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$112e7237be0c5f30 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $8725869b83961a04$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($8725869b83961a04$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $8725869b83961a04$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $8725869b83961a04$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $8725869b83961a04$var$_v1$2.distanceTo($8725869b83961a04$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $8725869b83961a04$var$_basePosition = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_skinIndex = /*@__PURE__*/ new $8725869b83961a04$export$fa7daccca11cdbe3();
const $8725869b83961a04$var$_skinWeight = /*@__PURE__*/ new $8725869b83961a04$export$fa7daccca11cdbe3();
const $8725869b83961a04$var$_vector3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_matrix4 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_vertex = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_sphere$4 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_inverseMatrix$2 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray$2 = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
class $8725869b83961a04$export$b303577035157ecf extends $8725869b83961a04$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = $8725869b83961a04$export$2595a3798997538;
        this.bindMatrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $8725869b83961a04$var$_vertex);
            this.boundingBox.expandByPoint($8725869b83961a04$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $8725869b83961a04$var$_vertex);
            this.boundingSphere.expandByPoint($8725869b83961a04$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$4.copy(this.boundingSphere);
        $8725869b83961a04$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere$4) === false) return;
        // convert ray to local space of skinned mesh
        $8725869b83961a04$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray$2.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($8725869b83961a04$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $8725869b83961a04$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $8725869b83961a04$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $8725869b83961a04$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $8725869b83961a04$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $8725869b83961a04$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $8725869b83961a04$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $8725869b83961a04$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $8725869b83961a04$var$_skinIndex.getComponent(i);
                $8725869b83961a04$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($8725869b83961a04$var$_vector3.copy($8725869b83961a04$var$_basePosition).applyMatrix4($8725869b83961a04$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
}
class $8725869b83961a04$export$b127726e56765aa4 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $8725869b83961a04$export$b691f601014eabe1 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0, minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $8725869b83961a04$var$_offsetMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_identityMatrix$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
class $8725869b83961a04$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $8725869b83961a04$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $8725869b83961a04$var$_identityMatrix$1;
            $8725869b83961a04$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $8725869b83961a04$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $8725869b83961a04$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $8725869b83961a04$export$b691f601014eabe1(boneMatrices, size, size, $8725869b83961a04$export$3f8bb04b555a363c, $8725869b83961a04$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $8725869b83961a04$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $8725869b83961a04$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $8725869b83961a04$export$32ea87a8b54d744a extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $8725869b83961a04$var$_instanceLocalMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_instanceWorldMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_instanceIntersects = [];
const $8725869b83961a04$var$_box3 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_identity = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_mesh$1 = /*@__PURE__*/ new $8725869b83961a04$export$e176487c05830cc5();
const $8725869b83961a04$var$_sphere$3 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
class $8725869b83961a04$export$f3c979c331175ad7 extends $8725869b83961a04$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.morphTexture = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $8725869b83961a04$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $8725869b83961a04$var$_instanceLocalMatrix);
            $8725869b83961a04$var$_box3.copy(geometry.boundingBox).applyMatrix4($8725869b83961a04$var$_instanceLocalMatrix);
            this.boundingBox.union($8725869b83961a04$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $8725869b83961a04$var$_instanceLocalMatrix);
            $8725869b83961a04$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4($8725869b83961a04$var$_instanceLocalMatrix);
            this.boundingSphere.union($8725869b83961a04$var$_sphere$3);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $8725869b83961a04$var$_mesh$1.geometry = this.geometry;
        $8725869b83961a04$var$_mesh$1.material = this.material;
        if ($8725869b83961a04$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$3.copy(this.boundingSphere);
        $8725869b83961a04$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere$3) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $8725869b83961a04$var$_instanceLocalMatrix);
            $8725869b83961a04$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $8725869b83961a04$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $8725869b83961a04$var$_mesh$1.matrixWorld = $8725869b83961a04$var$_instanceWorldMatrix;
            $8725869b83961a04$var$_mesh$1.raycast(raycaster, $8725869b83961a04$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $8725869b83961a04$var$_instanceIntersects.length; i < l; i++){
                const intersect = $8725869b83961a04$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $8725869b83961a04$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $8725869b83961a04$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $8725869b83961a04$export$4e041a7967d15c4b, $8725869b83961a04$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
        return this;
    }
}
function $8725869b83961a04$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $8725869b83961a04$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $8725869b83961a04$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(drawRange, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = drawRange.start;
        item.count = drawRange.count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $8725869b83961a04$var$_matrix$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_invMatrixWorld = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_identityMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_whiteColor = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1);
const $8725869b83961a04$var$_projScreenMatrix$2 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_frustum = /*@__PURE__*/ new $8725869b83961a04$export$35efe6f4c85463d2();
const $8725869b83961a04$var$_box$1 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_sphere$2 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_vector$5 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_forward = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_temp = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_renderList = /*@__PURE__*/ new $8725869b83961a04$var$MultiDrawRenderList();
const $8725869b83961a04$var$_mesh = /*@__PURE__*/ new $8725869b83961a04$export$e176487c05830cc5();
const $8725869b83961a04$var$_batchIntersects = [];
// @TODO: SkinnedMesh support?
// @TODO: geometry.groups support?
// @TODO: geometry.drawRange support?
// @TODO: geometry.morphAttributes support?
// @TODO: Support uniform parameter per geometry
// @TODO: Add an "optimize" function to pack geometry and remove data gaps
// copies data from attribute "src" into "target" starting at "targetOffset"
function $8725869b83961a04$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
class $8725869b83961a04$export$6e01c5ee52ed8f7b extends $8725869b83961a04$export$e176487c05830cc5 {
    get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $8725869b83961a04$export$b7be63a67df8959(), material);
        this.isBatchedMesh = true;
        this.perObjectFrustumCulled = true;
        this.sortObjects = true;
        this.boundingBox = null;
        this.boundingSphere = null;
        this.customSort = null;
        // stores visible, active, and geometry id per object
        this._drawInfo = [];
        // geometry information
        this._drawRanges = [];
        this._reservedRanges = [];
        this._bounds = [];
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        this._geometryInitialized = false;
        this._geometryCount = 0;
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        this._visibilityChanged = true;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $8725869b83961a04$export$b691f601014eabe1(matricesArray, size, size, $8725869b83961a04$export$3f8bb04b555a363c, $8725869b83961a04$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $8725869b83961a04$export$b691f601014eabe1(indirectArray, size, size, $8725869b83961a04$export$aa92e870a709d190, $8725869b83961a04$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $8725869b83961a04$export$b691f601014eabe1(colorsArray, size, size, $8725869b83961a04$export$3f8bb04b555a363c, $8725869b83961a04$export$f6d331659b644596);
        colorsTexture.colorSpace = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $8725869b83961a04$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $8725869b83961a04$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const drawInfo = this._drawInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (drawInfo[i].active === false) continue;
            const geometryId = drawInfo[i].geometryIndex;
            this.getMatrixAt(i, $8725869b83961a04$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $8725869b83961a04$var$_box$1).applyMatrix4($8725869b83961a04$var$_matrix$1);
            boundingBox.union($8725869b83961a04$var$_box$1);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const drawInfo = this._drawInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (drawInfo[i].active === false) continue;
            const geometryId = drawInfo[i].geometryIndex;
            this.getMatrixAt(i, $8725869b83961a04$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $8725869b83961a04$var$_sphere$2).applyMatrix4($8725869b83961a04$var$_matrix$1);
            boundingSphere.union($8725869b83961a04$var$_sphere$2);
        }
    }
    addInstance(geometryId) {
        // ensure we're not over geometry
        if (this._drawInfo.length >= this._maxInstanceCount) throw new Error('BatchedMesh: Maximum item count reached.');
        this._drawInfo.push({
            visible: true,
            active: true,
            geometryIndex: geometryId
        });
        // initialize the matrix
        const drawId = this._drawInfo.length - 1;
        const matricesTexture = this._matricesTexture;
        const matricesArray = matricesTexture.image.data;
        $8725869b83961a04$var$_identityMatrix.toArray(matricesArray, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $8725869b83961a04$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        return drawId;
    }
    addGeometry(geometry, vertexCount = -1, indexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        // ensure we're not over geometry
        if (this._drawInfo.length >= this._maxInstanceCount) throw new Error('BatchedMesh: Maximum item count reached.');
        // get the necessary range fo the geometry
        const reservedRange = {
            vertexStart: -1,
            vertexCount: -1,
            indexStart: -1,
            indexCount: -1
        };
        let lastRange = null;
        const reservedRanges = this._reservedRanges;
        const drawRanges = this._drawRanges;
        const bounds = this._bounds;
        if (this._geometryCount !== 0) lastRange = reservedRanges[reservedRanges.length - 1];
        if (vertexCount === -1) reservedRange.vertexCount = geometry.getAttribute('position').count;
        else reservedRange.vertexCount = vertexCount;
        if (lastRange === null) reservedRange.vertexStart = 0;
        else reservedRange.vertexStart = lastRange.vertexStart + lastRange.vertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            if (indexCount === -1) reservedRange.indexCount = index.count;
            else reservedRange.indexCount = indexCount;
            if (lastRange === null) reservedRange.indexStart = 0;
            else reservedRange.indexStart = lastRange.indexStart + lastRange.indexCount;
        }
        if (reservedRange.indexStart !== -1 && reservedRange.indexStart + reservedRange.indexCount > this._maxIndexCount || reservedRange.vertexStart + reservedRange.vertexCount > this._maxVertexCount) throw new Error('BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        const geometryId = this._geometryCount;
        this._geometryCount++;
        // add the reserved range and draw range objects
        reservedRanges.push(reservedRange);
        drawRanges.push({
            start: hasIndex ? reservedRange.indexStart : reservedRange.vertexStart,
            count: -1
        });
        bounds.push({
            boxInitialized: false,
            box: new $8725869b83961a04$export$6f7d5a9418ab2aa3(),
            sphereInitialized: false,
            sphere: new $8725869b83961a04$export$805e8b72413ccaba()
        });
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        return geometryId;
    }
    setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const reservedRange = this._reservedRanges[geometryId];
        if (hasIndex && srcIndex.count > reservedRange.indexCount || geometry.attributes.position.count > reservedRange.vertexCount) throw new Error('BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry over
        const vertexStart = reservedRange.vertexStart;
        const vertexCount = reservedRange.vertexCount;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $8725869b83961a04$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = vertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, vertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = reservedRange.indexStart;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedRange.indexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, reservedRange.indexCount);
        }
        // store the bounding boxes
        const bound = this._bounds[geometryId];
        if (geometry.boundingBox !== null) {
            bound.box.copy(geometry.boundingBox);
            bound.boxInitialized = true;
        } else bound.boxInitialized = false;
        if (geometry.boundingSphere !== null) {
            bound.sphere.copy(geometry.boundingSphere);
            bound.sphereInitialized = true;
        } else bound.sphereInitialized = false;
        // set drawRange count
        const drawRange = this._drawRanges[geometryId];
        const posAttr = geometry.getAttribute('position');
        drawRange.count = hasIndex ? srcIndex.count : posAttr.count;
        this._visibilityChanged = true;
        return geometryId;
    }
    /*
	deleteGeometry( geometryId ) {

		// TODO: delete geometry and associated instances

	}
	*/ /*
	deleteInstance( instanceId ) {

		// Note: User needs to call optimize() afterward to pack the data.

		const drawInfo = this._drawInfo;
		if ( instanceId >= drawInfo.length || drawInfo[ instanceId ].active === false ) {

			return this;

		}

		drawInfo[ instanceId ].active = false;
		this._visibilityChanged = true;

		return this;

	}
	*/ // get bounding box and compute it if it doesn't exist
    getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const bound = this._bounds[geometryId];
        const box = bound.box;
        const geometry = this.geometry;
        if (bound.boxInitialized === false) {
            box.makeEmpty();
            const index = geometry.index;
            const position = geometry.attributes.position;
            const drawRange = this._drawRanges[geometryId];
            for(let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($8725869b83961a04$var$_vector$5.fromBufferAttribute(position, iv));
            }
            bound.boxInitialized = true;
        }
        target.copy(box);
        return target;
    }
    // get bounding sphere and compute it if it doesn't exist
    getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const bound = this._bounds[geometryId];
        const sphere = bound.sphere;
        const geometry = this.geometry;
        if (bound.sphereInitialized === false) {
            sphere.makeEmpty();
            this.getBoundingBoxAt(geometryId, $8725869b83961a04$var$_box$1);
            $8725869b83961a04$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            const drawRange = this._drawRanges[geometryId];
            let maxRadiusSq = 0;
            for(let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $8725869b83961a04$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($8725869b83961a04$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            bound.sphereInitialized = true;
        }
        target.copy(sphere);
        return target;
    }
    setMatrixAt(instanceId, matrix) {
        // @TODO: Map geometryId to index of the arrays because
        //        optimize() can make geometryId mismatch the index
        const drawInfo = this._drawInfo;
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return this;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    getMatrixAt(instanceId, matrix) {
        const drawInfo = this._drawInfo;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return null;
        return matrix.fromArray(matricesArray, instanceId * 16);
    }
    setColorAt(instanceId, color) {
        if (this._colorsTexture === null) this._initColorsTexture();
        // @TODO: Map id to index of the arrays because
        //        optimize() can make id mismatch the index
        const colorsTexture = this._colorsTexture;
        const colorsArray = this._colorsTexture.image.data;
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return this;
        color.toArray(colorsArray, instanceId * 4);
        colorsTexture.needsUpdate = true;
        return this;
    }
    getColorAt(instanceId, color) {
        const colorsArray = this._colorsTexture.image.data;
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return null;
        return color.fromArray(colorsArray, instanceId * 4);
    }
    setVisibleAt(instanceId, value) {
        // if the geometry is out of range, not active, or visibility state
        // does not change then return early
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false || drawInfo[instanceId].visible === value) return this;
        drawInfo[instanceId].visible = value;
        this._visibilityChanged = true;
        return this;
    }
    getVisibleAt(instanceId) {
        // return early if the geometry is out of range or not active
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return false;
        return drawInfo[instanceId].visible;
    }
    raycast(raycaster, intersects) {
        const drawInfo = this._drawInfo;
        const drawRanges = this._drawRanges;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $8725869b83961a04$var$_mesh.material = this.material;
        $8725869b83961a04$var$_mesh.geometry.index = batchGeometry.index;
        $8725869b83961a04$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($8725869b83961a04$var$_mesh.geometry.boundingBox === null) $8725869b83961a04$var$_mesh.geometry.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        if ($8725869b83961a04$var$_mesh.geometry.boundingSphere === null) $8725869b83961a04$var$_mesh.geometry.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (!drawInfo[i].visible || !drawInfo[i].active) continue;
            const geometryId = drawInfo[i].geometryIndex;
            const drawRange = drawRanges[geometryId];
            $8725869b83961a04$var$_mesh.geometry.setDrawRange(drawRange.start, drawRange.count);
            // ge the intersects
            this.getMatrixAt(i, $8725869b83961a04$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $8725869b83961a04$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $8725869b83961a04$var$_mesh.geometry.boundingSphere);
            $8725869b83961a04$var$_mesh.raycast(raycaster, $8725869b83961a04$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $8725869b83961a04$var$_batchIntersects.length; j < l; j++){
                const intersect = $8725869b83961a04$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $8725869b83961a04$var$_batchIntersects.length = 0;
        }
        $8725869b83961a04$var$_mesh.material = null;
        $8725869b83961a04$var$_mesh.geometry.index = null;
        $8725869b83961a04$var$_mesh.geometry.attributes = {};
        $8725869b83961a04$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._drawRanges = source._drawRanges.map((range)=>({
                ...range
            }));
        this._reservedRanges = source._reservedRanges.map((range)=>({
                ...range
            }));
        this._drawInfo = source._drawInfo.map((inf)=>({
                ...inf
            }));
        this._bounds = source._bounds.map((bound)=>({
                boxInitialized: bound.boxInitialized,
                box: bound.box.clone(),
                sphereInitialized: bound.sphereInitialized,
                sphere: bound.sphere.clone()
            }));
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._geometryCount = source._geometryCount;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
        return this;
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const drawInfo = this._drawInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const drawRanges = this._drawRanges;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled) {
            $8725869b83961a04$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $8725869b83961a04$var$_frustum.setFromProjectionMatrix($8725869b83961a04$var$_projScreenMatrix$2, renderer.coordinateSystem);
        }
        let count = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $8725869b83961a04$var$_invMatrixWorld.copy(this.matrixWorld).invert();
            $8725869b83961a04$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($8725869b83961a04$var$_invMatrixWorld);
            $8725869b83961a04$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($8725869b83961a04$var$_invMatrixWorld);
            for(let i = 0, l = drawInfo.length; i < l; i++)if (drawInfo[i].visible && drawInfo[i].active) {
                const geometryId = drawInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $8725869b83961a04$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $8725869b83961a04$var$_sphere$2).applyMatrix4($8725869b83961a04$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !$8725869b83961a04$var$_frustum.intersectsSphere($8725869b83961a04$var$_sphere$2);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const z = $8725869b83961a04$var$_temp.subVectors($8725869b83961a04$var$_sphere$2.center, $8725869b83961a04$var$_vector$5).dot($8725869b83961a04$var$_forward);
                    $8725869b83961a04$var$_renderList.push(drawRanges[geometryId], z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $8725869b83961a04$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $8725869b83961a04$var$sortTransparent : $8725869b83961a04$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[count] = item.start * bytesPerElement;
                multiDrawCounts[count] = item.count;
                indirectArray[count] = item.index;
                count++;
            }
            $8725869b83961a04$var$_renderList.reset();
        } else {
            for(let i = 0, l = drawInfo.length; i < l; i++)if (drawInfo[i].visible && drawInfo[i].active) {
                const geometryId = drawInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $8725869b83961a04$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $8725869b83961a04$var$_sphere$2).applyMatrix4($8725869b83961a04$var$_matrix$1);
                    culled = !$8725869b83961a04$var$_frustum.intersectsSphere($8725869b83961a04$var$_sphere$2);
                }
                if (!culled) {
                    const range = drawRanges[geometryId];
                    multiDrawStarts[count] = range.start * bytesPerElement;
                    multiDrawCounts[count] = range.count;
                    indirectArray[count] = i;
                    count++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = count;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
class $8725869b83961a04$export$fbaaa33907730a0c extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $8725869b83961a04$var$_vStart = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vEnd = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_inverseMatrix$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray$1 = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
const $8725869b83961a04$var$_sphere$1 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_intersectPointOnRay = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_intersectPointOnSegment = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$17d680238e50603e extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(geometry = new $8725869b83961a04$export$b7be63a67df8959(), material = new $8725869b83961a04$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $8725869b83961a04$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $8725869b83961a04$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $8725869b83961a04$var$_vStart.distanceTo($8725869b83961a04$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $8725869b83961a04$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$1.copy(geometry.boundingSphere);
        $8725869b83961a04$var$_sphere$1.applyMatrix4(matrixWorld);
        $8725869b83961a04$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere$1) === false) return;
        //
        $8725869b83961a04$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray$1.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $8725869b83961a04$var$checkIntersection(this, raycaster, $8725869b83961a04$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $8725869b83961a04$var$checkIntersection(this, raycaster, $8725869b83961a04$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $8725869b83961a04$var$checkIntersection(this, raycaster, $8725869b83961a04$var$_ray$1, localThresholdSq, i, i + 1);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $8725869b83961a04$var$checkIntersection(this, raycaster, $8725869b83961a04$var$_ray$1, localThresholdSq, end - 1, start);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $8725869b83961a04$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b) {
    const positionAttribute = object.geometry.attributes.position;
    $8725869b83961a04$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $8725869b83961a04$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($8725869b83961a04$var$_vStart, $8725869b83961a04$var$_vEnd, $8725869b83961a04$var$_intersectPointOnRay, $8725869b83961a04$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $8725869b83961a04$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($8725869b83961a04$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $8725869b83961a04$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: a,
        face: null,
        faceIndex: null,
        object: object
    };
}
const $8725869b83961a04$var$_start = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_end = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$ff1ed10fedfdd604 extends $8725869b83961a04$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $8725869b83961a04$var$_start.fromBufferAttribute(positionAttribute, i);
                $8725869b83961a04$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $8725869b83961a04$var$_start.distanceTo($8725869b83961a04$var$_end);
            }
            geometry.setAttribute('lineDistance', new $8725869b83961a04$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $8725869b83961a04$export$f85a24d745e4f17d extends $8725869b83961a04$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $8725869b83961a04$export$a178c45366ce5d6b extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $8725869b83961a04$var$_inverseMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
const $8725869b83961a04$var$_sphere = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_position$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$1c787534cb11aa3e extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(geometry = new $8725869b83961a04$export$b7be63a67df8959(), material = new $8725869b83961a04$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $8725869b83961a04$var$_sphere.copy(geometry.boundingSphere);
        $8725869b83961a04$var$_sphere.applyMatrix4(matrixWorld);
        $8725869b83961a04$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere) === false) return;
        //
        $8725869b83961a04$var$_inverseMatrix.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $8725869b83961a04$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $8725869b83961a04$var$testPoint($8725869b83961a04$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $8725869b83961a04$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $8725869b83961a04$var$testPoint($8725869b83961a04$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $8725869b83961a04$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $8725869b83961a04$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $8725869b83961a04$export$64b5c384219d3699();
        $8725869b83961a04$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $8725869b83961a04$export$6e09d1edf8d5a25c extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $8725869b83961a04$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $8725869b83961a04$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $8725869b83961a04$export$9270d786f73ce6fe extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $8725869b83961a04$export$3466bac9141a5cc4 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $8725869b83961a04$export$5fe6b8e34b274fcb extends $8725869b83961a04$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $8725869b83961a04$export$9d9334239a5a5e06;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $8725869b83961a04$export$d80173634de65bff extends $8725869b83961a04$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $8725869b83961a04$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $8725869b83961a04$export$f7189e49152d1c13 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $8725869b83961a04$export$c977b3e384af9ae1() : new $8725869b83961a04$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $8725869b83961a04$export$64b5c384219d3699();
        const mat = new $8725869b83961a04$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $8725869b83961a04$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $8725869b83961a04$export$64b5c384219d3699();
        binormals[0] = new $8725869b83961a04$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($8725869b83961a04$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($8725869b83961a04$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $8725869b83961a04$export$3f87a931616cde04 extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $8725869b83961a04$export$b1eedc9aab6300e8 extends $8725869b83961a04$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $8725869b83961a04$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $8725869b83961a04$var$tmp = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$px = /*@__PURE__*/ new $8725869b83961a04$var$CubicPoly();
const $8725869b83961a04$var$py = /*@__PURE__*/ new $8725869b83961a04$var$CubicPoly();
const $8725869b83961a04$var$pz = /*@__PURE__*/ new $8725869b83961a04$var$CubicPoly();
class $8725869b83961a04$export$b9146b27c24b744c extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $8725869b83961a04$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $8725869b83961a04$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $8725869b83961a04$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $8725869b83961a04$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $8725869b83961a04$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $8725869b83961a04$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $8725869b83961a04$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $8725869b83961a04$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $8725869b83961a04$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $8725869b83961a04$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($8725869b83961a04$var$px.calc(weight), $8725869b83961a04$var$py.calc(weight), $8725869b83961a04$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $8725869b83961a04$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $8725869b83961a04$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $8725869b83961a04$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $8725869b83961a04$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $8725869b83961a04$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $8725869b83961a04$var$QuadraticBezier(t, p0, p1, p2) {
    return $8725869b83961a04$var$QuadraticBezierP0(t, p0) + $8725869b83961a04$var$QuadraticBezierP1(t, p1) + $8725869b83961a04$var$QuadraticBezierP2(t, p2);
}
//
function $8725869b83961a04$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $8725869b83961a04$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $8725869b83961a04$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $8725869b83961a04$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $8725869b83961a04$var$CubicBezier(t, p0, p1, p2, p3) {
    return $8725869b83961a04$var$CubicBezierP0(t, p0) + $8725869b83961a04$var$CubicBezierP1(t, p1) + $8725869b83961a04$var$CubicBezierP2(t, p2) + $8725869b83961a04$var$CubicBezierP3(t, p3);
}
class $8725869b83961a04$export$e36650d36468bb39 extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$c977b3e384af9ae1(), v1 = new $8725869b83961a04$export$c977b3e384af9ae1(), v2 = new $8725869b83961a04$export$c977b3e384af9ae1(), v3 = new $8725869b83961a04$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($8725869b83961a04$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $8725869b83961a04$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $8725869b83961a04$export$13d5f1c9525f246c extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$64b5c384219d3699(), v1 = new $8725869b83961a04$export$64b5c384219d3699(), v2 = new $8725869b83961a04$export$64b5c384219d3699(), v3 = new $8725869b83961a04$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($8725869b83961a04$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $8725869b83961a04$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $8725869b83961a04$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $8725869b83961a04$export$ab2e07e76531a47e extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $8725869b83961a04$export$c977b3e384af9ae1(), v2 = new $8725869b83961a04$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$1fdfd9d9cf487600 extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $8725869b83961a04$export$64b5c384219d3699(), v2 = new $8725869b83961a04$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$5938c4ee491a43ad extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$c977b3e384af9ae1(), v1 = new $8725869b83961a04$export$c977b3e384af9ae1(), v2 = new $8725869b83961a04$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($8725869b83961a04$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $8725869b83961a04$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$bf3f4c7e459f90fc extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$64b5c384219d3699(), v1 = new $8725869b83961a04$export$64b5c384219d3699(), v2 = new $8725869b83961a04$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($8725869b83961a04$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $8725869b83961a04$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $8725869b83961a04$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$d3bdd77da77afc1b extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($8725869b83961a04$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $8725869b83961a04$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $8725869b83961a04$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $8725869b83961a04$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $8725869b83961a04$export$b9146b27c24b744c,
    CubicBezierCurve: $8725869b83961a04$export$e36650d36468bb39,
    CubicBezierCurve3: $8725869b83961a04$export$13d5f1c9525f246c,
    EllipseCurve: $8725869b83961a04$export$3f87a931616cde04,
    LineCurve: $8725869b83961a04$export$ab2e07e76531a47e,
    LineCurve3: $8725869b83961a04$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $8725869b83961a04$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $8725869b83961a04$export$bf3f4c7e459f90fc,
    SplineCurve: $8725869b83961a04$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $8725869b83961a04$export$4aaf9b66af1bbf2c extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $8725869b83961a04$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $8725869b83961a04$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $8725869b83961a04$export$4b2950bdac9b6ee9 extends $8725869b83961a04$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $8725869b83961a04$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $8725869b83961a04$export$ab2e07e76531a47e(this.currentPoint.clone(), new $8725869b83961a04$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $8725869b83961a04$export$5938c4ee491a43ad(this.currentPoint.clone(), new $8725869b83961a04$export$c977b3e384af9ae1(aCPx, aCPy), new $8725869b83961a04$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $8725869b83961a04$export$e36650d36468bb39(this.currentPoint.clone(), new $8725869b83961a04$export$c977b3e384af9ae1(aCP1x, aCP1y), new $8725869b83961a04$export$c977b3e384af9ae1(aCP2x, aCP2y), new $8725869b83961a04$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $8725869b83961a04$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $8725869b83961a04$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $8725869b83961a04$export$6d839803fcd1882c extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(points = [
        new $8725869b83961a04$export$c977b3e384af9ae1(0, -0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0),
        new $8725869b83961a04$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $8725869b83961a04$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const curNormal = new $8725869b83961a04$export$64b5c384219d3699();
        const prevNormal = new $8725869b83961a04$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $8725869b83961a04$export$41680e8551036033 extends $8725869b83961a04$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $8725869b83961a04$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $8725869b83961a04$export$d5c0e8d607467193 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$68f745719dbe5198 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $8725869b83961a04$export$64b5c384219d3699();
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$a7a48974f285c9b3 extends $8725869b83961a04$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$60e57a7d3f20ff65 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $8725869b83961a04$export$64b5c384219d3699();
            const b = new $8725869b83961a04$export$64b5c384219d3699();
            const c = new $8725869b83961a04$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $8725869b83961a04$export$64b5c384219d3699();
            const b = new $8725869b83961a04$export$64b5c384219d3699();
            const c = new $8725869b83961a04$export$64b5c384219d3699();
            const centroid = new $8725869b83961a04$export$64b5c384219d3699();
            const uvA = new $8725869b83961a04$export$c977b3e384af9ae1();
            const uvB = new $8725869b83961a04$export$c977b3e384af9ae1();
            const uvC = new $8725869b83961a04$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $8725869b83961a04$export$c0babfeb8708fc9c extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $8725869b83961a04$var$_v0 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v1$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normal = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_triangle = /*@__PURE__*/ new $8725869b83961a04$export$5a465592bfe74b48();
class $8725869b83961a04$export$4730b1542707547f extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($8725869b83961a04$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $8725869b83961a04$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $8725869b83961a04$var$_triangle.getNormal($8725869b83961a04$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $8725869b83961a04$var$_triangle[vertKeys[j]];
                    const v1 = $8725869b83961a04$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($8725869b83961a04$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $8725869b83961a04$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $8725869b83961a04$var$_v0.fromBufferAttribute(positionAttr, index0);
                $8725869b83961a04$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($8725869b83961a04$var$_v0.x, $8725869b83961a04$var$_v0.y, $8725869b83961a04$var$_v0.z);
                vertices.push($8725869b83961a04$var$_v1$1.x, $8725869b83961a04$var$_v1$1.y, $8725869b83961a04$var$_v1$1.z);
            }
            this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $8725869b83961a04$export$6428a7f2611ef1fa extends $8725869b83961a04$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $8725869b83961a04$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $8725869b83961a04$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $8725869b83961a04$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $8725869b83961a04$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $8725869b83961a04$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $8725869b83961a04$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $8725869b83961a04$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $8725869b83961a04$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $8725869b83961a04$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $8725869b83961a04$var$equals(last, last.next)) {
        $8725869b83961a04$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $8725869b83961a04$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($8725869b83961a04$var$equals(p, p.next) || $8725869b83961a04$var$area(p.prev, p, p.next) === 0)) {
            $8725869b83961a04$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $8725869b83961a04$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $8725869b83961a04$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $8725869b83961a04$var$isEarHashed(ear, minX, minY, invSize) : $8725869b83961a04$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $8725869b83961a04$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $8725869b83961a04$var$earcutLinked($8725869b83961a04$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $8725869b83961a04$var$cureLocalIntersections($8725869b83961a04$var$filterPoints(ear), triangles, dim);
                $8725869b83961a04$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $8725869b83961a04$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $8725869b83961a04$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($8725869b83961a04$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $8725869b83961a04$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $8725869b83961a04$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($8725869b83961a04$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $8725869b83961a04$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $8725869b83961a04$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $8725869b83961a04$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $8725869b83961a04$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $8725869b83961a04$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $8725869b83961a04$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $8725869b83961a04$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$8725869b83961a04$var$equals(a, b) && $8725869b83961a04$var$intersects(a, p, p.next, b) && $8725869b83961a04$var$locallyInside(a, b) && $8725869b83961a04$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $8725869b83961a04$var$removeNode(p);
            $8725869b83961a04$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $8725869b83961a04$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $8725869b83961a04$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $8725869b83961a04$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $8725869b83961a04$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $8725869b83961a04$var$filterPoints(a, a.next);
                c = $8725869b83961a04$var$filterPoints(c, c.next);
                // run earcut on each half
                $8725869b83961a04$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $8725869b83961a04$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $8725869b83961a04$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $8725869b83961a04$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($8725869b83961a04$var$getLeftmost(list));
    }
    queue.sort($8725869b83961a04$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $8725869b83961a04$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $8725869b83961a04$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $8725869b83961a04$var$eliminateHole(hole, outerNode) {
    const bridge = $8725869b83961a04$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $8725869b83961a04$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $8725869b83961a04$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $8725869b83961a04$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $8725869b83961a04$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $8725869b83961a04$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($8725869b83961a04$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $8725869b83961a04$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $8725869b83961a04$var$sectorContainsSector(m, p) {
    return $8725869b83961a04$var$area(m.prev, m, p.prev) < 0 && $8725869b83961a04$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $8725869b83961a04$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $8725869b83961a04$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $8725869b83961a04$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $8725869b83961a04$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $8725869b83961a04$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $8725869b83961a04$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $8725869b83961a04$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$8725869b83961a04$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($8725869b83961a04$var$locallyInside(a, b) && $8725869b83961a04$var$locallyInside(b, a) && $8725869b83961a04$var$middleInside(a, b) && // locally visible
    ($8725869b83961a04$var$area(a.prev, a, b.prev) || $8725869b83961a04$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $8725869b83961a04$var$equals(a, b) && $8725869b83961a04$var$area(a.prev, a, a.next) > 0 && $8725869b83961a04$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $8725869b83961a04$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $8725869b83961a04$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $8725869b83961a04$var$intersects(p1, q1, p2, q2) {
    const o1 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p1, q1, p2));
    const o2 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p1, q1, q2));
    const o3 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p2, q2, p1));
    const o4 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $8725869b83961a04$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $8725869b83961a04$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $8725869b83961a04$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $8725869b83961a04$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $8725869b83961a04$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $8725869b83961a04$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $8725869b83961a04$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $8725869b83961a04$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $8725869b83961a04$var$locallyInside(a, b) {
    return $8725869b83961a04$var$area(a.prev, a, a.next) < 0 ? $8725869b83961a04$var$area(a, b, a.next) >= 0 && $8725869b83961a04$var$area(a, a.prev, b) >= 0 : $8725869b83961a04$var$area(a, b, a.prev) < 0 || $8725869b83961a04$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $8725869b83961a04$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $8725869b83961a04$var$splitPolygon(a, b) {
    const a2 = new $8725869b83961a04$var$Node(a.i, a.x, a.y), b2 = new $8725869b83961a04$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $8725869b83961a04$var$insertNode(i, x, y, last) {
    const p = new $8725869b83961a04$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $8725869b83961a04$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $8725869b83961a04$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $8725869b83961a04$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $8725869b83961a04$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $8725869b83961a04$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $8725869b83961a04$var$removeDupEndPts(contour);
        $8725869b83961a04$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($8725869b83961a04$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $8725869b83961a04$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $8725869b83961a04$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $8725869b83961a04$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $8725869b83961a04$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $8725869b83961a04$export$598697a1efa63ca7 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(shapes = new $8725869b83961a04$export$6428a7f2611ef1fa([
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(-0.5, 0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(-0.5, -0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $8725869b83961a04$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $8725869b83961a04$export$64b5c384219d3699();
                normal = new $8725869b83961a04$export$64b5c384219d3699();
                position2 = new $8725869b83961a04$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $8725869b83961a04$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $8725869b83961a04$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $8725869b83961a04$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $8725869b83961a04$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $8725869b83961a04$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $8725869b83961a04$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $8725869b83961a04$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $8725869b83961a04$export$c977b3e384af9ae1(a_x, a_y),
            new $8725869b83961a04$export$c977b3e384af9ae1(b_x, b_y),
            new $8725869b83961a04$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $8725869b83961a04$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $8725869b83961a04$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $8725869b83961a04$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $8725869b83961a04$export$9567cc828c9535da extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $8725869b83961a04$export$1954e2b809fe361e extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $8725869b83961a04$export$68cb731f50f614af extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$57a29a1c803e9065 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(shapes = new $8725869b83961a04$export$6428a7f2611ef1fa([
        new $8725869b83961a04$export$c977b3e384af9ae1(0, 0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(-0.5, -0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $8725869b83961a04$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $8725869b83961a04$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $8725869b83961a04$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $8725869b83961a04$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $8725869b83961a04$export$1b417fc3b307a251 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$fb3f7adc68bd6e02 extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $8725869b83961a04$export$a2312a2a1fa56495 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $8725869b83961a04$export$64b5c384219d3699();
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $8725869b83961a04$export$77e9bfadfb9ab8c8 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const P1 = new $8725869b83961a04$export$64b5c384219d3699();
        const P2 = new $8725869b83961a04$export$64b5c384219d3699();
        const B = new $8725869b83961a04$export$64b5c384219d3699();
        const T = new $8725869b83961a04$export$64b5c384219d3699();
        const N = new $8725869b83961a04$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $8725869b83961a04$export$7897d9d48904490c extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(path = new $8725869b83961a04$export$bf3f4c7e459f90fc(new $8725869b83961a04$export$64b5c384219d3699(-1, -1, 0), new $8725869b83961a04$export$64b5c384219d3699(-1, 1, 0), new $8725869b83961a04$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        let P = new $8725869b83961a04$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $8725869b83961a04$export$7897d9d48904490c(new $8725869b83961a04$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $8725869b83961a04$export$4b739da06d24892b extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $8725869b83961a04$export$64b5c384219d3699();
            const end = new $8725869b83961a04$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($8725869b83961a04$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($8725869b83961a04$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $8725869b83961a04$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $8725869b83961a04$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $8725869b83961a04$export$33e43285f7406bd5,
    CapsuleGeometry: $8725869b83961a04$export$41680e8551036033,
    CircleGeometry: $8725869b83961a04$export$d5c0e8d607467193,
    ConeGeometry: $8725869b83961a04$export$a7a48974f285c9b3,
    CylinderGeometry: $8725869b83961a04$export$68f745719dbe5198,
    DodecahedronGeometry: $8725869b83961a04$export$c0babfeb8708fc9c,
    EdgesGeometry: $8725869b83961a04$export$4730b1542707547f,
    ExtrudeGeometry: $8725869b83961a04$export$598697a1efa63ca7,
    IcosahedronGeometry: $8725869b83961a04$export$9567cc828c9535da,
    LatheGeometry: $8725869b83961a04$export$6d839803fcd1882c,
    OctahedronGeometry: $8725869b83961a04$export$1954e2b809fe361e,
    PlaneGeometry: $8725869b83961a04$export$967d831af31f69ce,
    PolyhedronGeometry: $8725869b83961a04$export$60e57a7d3f20ff65,
    RingGeometry: $8725869b83961a04$export$68cb731f50f614af,
    ShapeGeometry: $8725869b83961a04$export$57a29a1c803e9065,
    SphereGeometry: $8725869b83961a04$export$1b417fc3b307a251,
    TetrahedronGeometry: $8725869b83961a04$export$fb3f7adc68bd6e02,
    TorusGeometry: $8725869b83961a04$export$a2312a2a1fa56495,
    TorusKnotGeometry: $8725869b83961a04$export$77e9bfadfb9ab8c8,
    TubeGeometry: $8725869b83961a04$export$7897d9d48904490c,
    WireframeGeometry: $8725869b83961a04$export$4b739da06d24892b
});
class $8725869b83961a04$export$e8564da406055a3 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$21c421a2e1df9d22 extends $8725869b83961a04$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $8725869b83961a04$export$f2980790215acccd extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.type = 'MeshStandardMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$28d04986c4269c9f extends $8725869b83961a04$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $8725869b83961a04$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $8725869b83961a04$export$24c72f71cbaf0678 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $8725869b83961a04$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        this.combine = $8725869b83961a04$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$df893cf97e765622 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$bfe8c0a091f41ae7 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $8725869b83961a04$export$5023a9a8114806b8 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        this.combine = $8725869b83961a04$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$6f5fef6235ec12ee extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$327886a3efaeaebe extends $8725869b83961a04$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $8725869b83961a04$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $8725869b83961a04$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $8725869b83961a04$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $8725869b83961a04$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $8725869b83961a04$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $8725869b83961a04$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $8725869b83961a04$var$convertArray(times, track.times.constructor);
        track.values = $8725869b83961a04$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $8725869b83961a04$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $8725869b83961a04$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $8725869b83961a04$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $8725869b83961a04$export$d875e029ef558d3;
    return targetClip;
}
const $8725869b83961a04$export$7ee8caa573e71ad1 = {
    convertArray: $8725869b83961a04$var$convertArray,
    isTypedArray: $8725869b83961a04$var$isTypedArray,
    getKeyframeOrder: $8725869b83961a04$var$getKeyframeOrder,
    sortedArray: $8725869b83961a04$var$sortedArray,
    flattenJSON: $8725869b83961a04$var$flattenJSON,
    subclip: $8725869b83961a04$var$subclip,
    makeClipAdditive: $8725869b83961a04$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $8725869b83961a04$export$3646682e7a3959 extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $8725869b83961a04$export$7f795934b84ab523,
            endingEnd: $8725869b83961a04$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $8725869b83961a04$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $8725869b83961a04$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $8725869b83961a04$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $8725869b83961a04$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $8725869b83961a04$export$a8e6009059f51e1a extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $8725869b83961a04$export$fb9758ef7ef8d5cc extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $8725869b83961a04$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $8725869b83961a04$var$convertArray(times, this.TimeBufferType);
        this.values = $8725869b83961a04$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $8725869b83961a04$var$convertArray(track.times, Array),
                'values': $8725869b83961a04$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $8725869b83961a04$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $8725869b83961a04$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $8725869b83961a04$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $8725869b83961a04$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $8725869b83961a04$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $8725869b83961a04$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $8725869b83961a04$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $8725869b83961a04$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $8725869b83961a04$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($8725869b83961a04$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $8725869b83961a04$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$8725869b83961a04$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$8725869b83961a04$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$8725869b83961a04$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $8725869b83961a04$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $8725869b83961a04$export$d3a344b98cf0b775 extends $8725869b83961a04$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$8725869b83961a04$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$8725869b83961a04$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$8725869b83961a04$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $8725869b83961a04$export$995b32462a65e855;
$8725869b83961a04$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$8725869b83961a04$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $8725869b83961a04$export$83444c5d885347d8 extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $8725869b83961a04$export$d45f0d1a4d9a9314 extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $8725869b83961a04$export$2db1cfb7923d931e extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$8725869b83961a04$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $8725869b83961a04$export$b8043f12b5aafbd7 extends $8725869b83961a04$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $8725869b83961a04$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$8725869b83961a04$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$8725869b83961a04$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $8725869b83961a04$export$6ce41d4f3a8df9cd extends $8725869b83961a04$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $8725869b83961a04$export$995b32462a65e855;
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $8725869b83961a04$export$5ce2dcb4cc9f2bff extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $8725869b83961a04$export$d942c706bf23829c {
    constructor(name = '', duration = -1, tracks = [], blendMode = $8725869b83961a04$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $8725869b83961a04$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($8725869b83961a04$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($8725869b83961a04$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $8725869b83961a04$var$getKeyframeOrder(times);
            times = $8725869b83961a04$var$sortedArray(times, 1, order);
            values = $8725869b83961a04$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $8725869b83961a04$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $8725869b83961a04$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $8725869b83961a04$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($8725869b83961a04$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($8725869b83961a04$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($8725869b83961a04$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $8725869b83961a04$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $8725869b83961a04$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $8725869b83961a04$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $8725869b83961a04$export$83444c5d885347d8;
        case 'quaternion':
            return $8725869b83961a04$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $8725869b83961a04$export$d3a344b98cf0b775;
        case 'string':
            return $8725869b83961a04$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $8725869b83961a04$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $8725869b83961a04$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $8725869b83961a04$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $8725869b83961a04$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $8725869b83961a04$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $8725869b83961a04$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $8725869b83961a04$export$99cc795e99919eed();
class $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $8725869b83961a04$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$8725869b83961a04$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $8725869b83961a04$var$loading = {};
class $8725869b83961a04$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $8725869b83961a04$export$98435a25b5cf7b2b extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $8725869b83961a04$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($8725869b83961a04$var$loading[url] !== undefined) {
            $8725869b83961a04$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $8725869b83961a04$var$loading[url] = [];
        $8725869b83961a04$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $8725869b83961a04$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $8725869b83961a04$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $8725869b83961a04$export$94affb487e701bf2.add(url, data);
            const callbacks = $8725869b83961a04$var$loading[url];
            delete $8725869b83961a04$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $8725869b83961a04$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $8725869b83961a04$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $8725869b83961a04$export$29711c7e14f61db extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $8725869b83961a04$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $8725869b83961a04$export$bd73ce947a280350 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $8725869b83961a04$export$3466bac9141a5cc4();
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $8725869b83961a04$export$8905ce1c7a2464a1 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $8725869b83961a04$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $8725869b83961a04$var$createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            $8725869b83961a04$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $8725869b83961a04$export$2ec114afc2cf6308 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $8725869b83961a04$export$ee2e5a18258a4049();
        texture.colorSpace = $8725869b83961a04$export$561f394b24edfcaa;
        const loader = new $8725869b83961a04$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $8725869b83961a04$export$792d8a18f2c55855 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $8725869b83961a04$export$b691f601014eabe1();
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $8725869b83961a04$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $8725869b83961a04$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $8725869b83961a04$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $8725869b83961a04$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $8725869b83961a04$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $8725869b83961a04$export$fd1bfc71f64c538c extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $8725869b83961a04$export$5431306cf43de24a();
        const loader = new $8725869b83961a04$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $8725869b83961a04$export$6ecadb6ed240d696 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $8725869b83961a04$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
class $8725869b83961a04$export$8d474f55edbb9624 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $8725869b83961a04$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $8725869b83961a04$var$_projScreenMatrix$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_lightPositionWorld$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_lookTarget$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $8725869b83961a04$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $8725869b83961a04$export$35efe6f4c85463d2();
        this._frameExtents = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $8725869b83961a04$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($8725869b83961a04$var$_lightPositionWorld$1);
        $8725869b83961a04$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($8725869b83961a04$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $8725869b83961a04$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($8725869b83961a04$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($8725869b83961a04$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $8725869b83961a04$var$SpotLightShadow extends $8725869b83961a04$var$LightShadow {
    constructor(){
        super(new $8725869b83961a04$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $8725869b83961a04$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $8725869b83961a04$export$81495cbb73897362 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $8725869b83961a04$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $8725869b83961a04$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $8725869b83961a04$var$_projScreenMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_lightPositionWorld = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_lookTarget = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$var$PointLightShadow extends $8725869b83961a04$var$LightShadow {
    constructor(){
        super(new $8725869b83961a04$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $8725869b83961a04$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $8725869b83961a04$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $8725869b83961a04$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $8725869b83961a04$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $8725869b83961a04$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $8725869b83961a04$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $8725869b83961a04$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $8725869b83961a04$export$64b5c384219d3699(1, 0, 0),
            new $8725869b83961a04$export$64b5c384219d3699(-1, 0, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, -1),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $8725869b83961a04$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($8725869b83961a04$var$_lightPositionWorld);
        $8725869b83961a04$var$_lookTarget.copy(camera.position);
        $8725869b83961a04$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($8725869b83961a04$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$8725869b83961a04$var$_lightPositionWorld.x, -$8725869b83961a04$var$_lightPositionWorld.y, -$8725869b83961a04$var$_lightPositionWorld.z);
        $8725869b83961a04$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($8725869b83961a04$var$_projScreenMatrix);
    }
}
class $8725869b83961a04$export$4c9c1cb3f0b6f455 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $8725869b83961a04$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $8725869b83961a04$var$DirectionalLightShadow extends $8725869b83961a04$var$LightShadow {
    constructor(){
        super(new $8725869b83961a04$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $8725869b83961a04$export$3fea33cc9972c868 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $8725869b83961a04$export$e4dd07dff30cc924();
        this.shadow = new $8725869b83961a04$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $8725869b83961a04$export$af279bfef9ec2c96 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $8725869b83961a04$export$61db2d908bbd2429 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $8725869b83961a04$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $8725869b83961a04$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $8725869b83961a04$export$e7ef036e309b38d2 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(sh = new $8725869b83961a04$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $8725869b83961a04$export$3bd6d323353dcf96 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = $8725869b83961a04$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $8725869b83961a04$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $8725869b83961a04$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $8725869b83961a04$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $8725869b83961a04$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $8725869b83961a04$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $8725869b83961a04$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $8725869b83961a04$export$e8564da406055a3,
            SpriteMaterial: $8725869b83961a04$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $8725869b83961a04$export$21c421a2e1df9d22,
            ShaderMaterial: $8725869b83961a04$export$83c7d75d550a8b0d,
            PointsMaterial: $8725869b83961a04$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $8725869b83961a04$export$28d04986c4269c9f,
            MeshStandardMaterial: $8725869b83961a04$export$f2980790215acccd,
            MeshPhongMaterial: $8725869b83961a04$export$24c72f71cbaf0678,
            MeshToonMaterial: $8725869b83961a04$export$df893cf97e765622,
            MeshNormalMaterial: $8725869b83961a04$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $8725869b83961a04$export$5023a9a8114806b8,
            MeshDepthMaterial: $8725869b83961a04$export$2698c22ec13825db,
            MeshDistanceMaterial: $8725869b83961a04$export$33e187ed002f2a19,
            MeshBasicMaterial: $8725869b83961a04$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $8725869b83961a04$export$6f5fef6235ec12ee,
            LineDashedMaterial: $8725869b83961a04$export$327886a3efaeaebe,
            LineBasicMaterial: $8725869b83961a04$export$fbaaa33907730a0c,
            Material: $8725869b83961a04$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $8725869b83961a04$export$b5d2dc08d867e41a {
    static decodeText(array) {
        console.warn('THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.');
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $8725869b83961a04$export$231f009cbe414146 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $8725869b83961a04$export$dc275bb96327833a extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $8725869b83961a04$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $8725869b83961a04$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $8725869b83961a04$export$231f009cbe414146() : new $8725869b83961a04$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $8725869b83961a04$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $8725869b83961a04$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $8725869b83961a04$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $8725869b83961a04$export$32ea87a8b54d744a : $8725869b83961a04$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $8725869b83961a04$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $8725869b83961a04$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $8725869b83961a04$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $8725869b83961a04$export$40110c8505c5ad19 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $8725869b83961a04$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $8725869b83961a04$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $8725869b83961a04$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $8725869b83961a04$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $8725869b83961a04$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $8725869b83961a04$var$Geometries) geometry = $8725869b83961a04$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $8725869b83961a04$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $8725869b83961a04$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $8725869b83961a04$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $8725869b83961a04$export$99cc795e99919eed(onLoad);
            loader = new $8725869b83961a04$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $8725869b83961a04$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $8725869b83961a04$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $8725869b83961a04$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $8725869b83961a04$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $8725869b83961a04$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $8725869b83961a04$export$b691f601014eabe1();
                else texture = new $8725869b83961a04$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $8725869b83961a04$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $8725869b83961a04$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $8725869b83961a04$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $8725869b83961a04$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $8725869b83961a04$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $8725869b83961a04$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $8725869b83961a04$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $8725869b83961a04$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $8725869b83961a04$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $8725869b83961a04$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $8725869b83961a04$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $8725869b83961a04$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $8725869b83961a04$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $8725869b83961a04$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $8725869b83961a04$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $8725869b83961a04$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $8725869b83961a04$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $8725869b83961a04$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $8725869b83961a04$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $8725869b83961a04$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $8725869b83961a04$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $8725869b83961a04$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._visibility = data.visibility;
                object._active = data.active;
                object._bounds = data.bounds.map((bound)=>{
                    const box = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
                    box.min.fromArray(bound.boxMin);
                    box.max.fromArray(bound.boxMax);
                    const sphere = new $8725869b83961a04$export$805e8b72413ccaba();
                    sphere.radius = bound.sphereRadius;
                    sphere.center.fromArray(bound.sphereCenter);
                    return {
                        boxInitialized: bound.boxInitialized,
                        box: box,
                        sphereInitialized: bound.sphereInitialized,
                        sphere: sphere
                    };
                });
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._geometryCount = data.geometryCount;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                break;
            case 'LOD':
                object = new $8725869b83961a04$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $8725869b83961a04$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $8725869b83961a04$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $8725869b83961a04$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $8725869b83961a04$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $8725869b83961a04$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $8725869b83961a04$export$b127726e56765aa4();
                break;
            default:
                object = new $8725869b83961a04$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $8725869b83961a04$export$e4dd07dff30cc924();
            }
        });
    }
}
const $8725869b83961a04$var$TEXTURE_MAPPING = {
    UVMapping: $8725869b83961a04$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $8725869b83961a04$export$8759762a6477f2c4,
    CubeRefractionMapping: $8725869b83961a04$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $8725869b83961a04$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $8725869b83961a04$export$ee99d97d46898098,
    CubeUVReflectionMapping: $8725869b83961a04$export$dbf3e70ff37af79
};
const $8725869b83961a04$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $8725869b83961a04$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $8725869b83961a04$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $8725869b83961a04$export$c7e7c00b14f51a4f
};
const $8725869b83961a04$var$TEXTURE_FILTER = {
    NearestFilter: $8725869b83961a04$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $8725869b83961a04$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $8725869b83961a04$export$d2327c1afe5bfdf2,
    LinearFilter: $8725869b83961a04$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $8725869b83961a04$export$19a719f377145a13,
    LinearMipmapLinearFilter: $8725869b83961a04$export$5d8599b6a933fb1b
};
class $8725869b83961a04$export$52286b55c4a9b51f extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $8725869b83961a04$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                }).catch((e)=>{
                    if (onError) onError(e);
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $8725869b83961a04$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $8725869b83961a04$export$94affb487e701bf2.remove(url);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $8725869b83961a04$export$94affb487e701bf2.add(url, promise);
        scope.manager.itemStart(url);
    }
}
let $8725869b83961a04$var$_context;
class $8725869b83961a04$export$fcbc63750ec2a81f {
    static getContext() {
        if ($8725869b83961a04$var$_context === undefined) $8725869b83961a04$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $8725869b83961a04$var$_context;
    }
    static setContext(value) {
        $8725869b83961a04$var$_context = value;
    }
}
class $8725869b83961a04$export$d8d5fccfbf47714e extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $8725869b83961a04$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $8725869b83961a04$var$_eyeRight = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_eyeLeft = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_projectionMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
class $8725869b83961a04$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $8725869b83961a04$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $8725869b83961a04$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $8725869b83961a04$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($8725869b83961a04$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $8725869b83961a04$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $8725869b83961a04$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $8725869b83961a04$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $8725869b83961a04$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($8725869b83961a04$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $8725869b83961a04$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $8725869b83961a04$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($8725869b83961a04$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($8725869b83961a04$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($8725869b83961a04$var$_eyeRight);
    }
}
class $8725869b83961a04$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $8725869b83961a04$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $8725869b83961a04$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $8725869b83961a04$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const $8725869b83961a04$var$_position$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion$1 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_scale$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_orientation$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$8a1b810c6fde8951 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $8725869b83961a04$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $8725869b83961a04$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($8725869b83961a04$var$_position$1, $8725869b83961a04$var$_quaternion$1, $8725869b83961a04$var$_scale$1);
        $8725869b83961a04$var$_orientation$1.set(0, 0, -1).applyQuaternion($8725869b83961a04$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($8725869b83961a04$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($8725869b83961a04$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($8725869b83961a04$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($8725869b83961a04$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($8725869b83961a04$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($8725869b83961a04$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($8725869b83961a04$var$_position$1.x, $8725869b83961a04$var$_position$1.y, $8725869b83961a04$var$_position$1.z);
            listener.setOrientation($8725869b83961a04$var$_orientation$1.x, $8725869b83961a04$var$_orientation$1.y, $8725869b83961a04$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $8725869b83961a04$export$153755f98d9861de extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $8725869b83961a04$var$_position = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_scale = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_orientation = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$4b3e397ef1832507 extends $8725869b83961a04$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($8725869b83961a04$var$_position, $8725869b83961a04$var$_quaternion, $8725869b83961a04$var$_scale);
        $8725869b83961a04$var$_orientation.set(0, 0, 1).applyQuaternion($8725869b83961a04$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($8725869b83961a04$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($8725869b83961a04$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($8725869b83961a04$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($8725869b83961a04$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($8725869b83961a04$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($8725869b83961a04$var$_orientation.z, endTime);
        } else {
            panner.setPosition($8725869b83961a04$var$_position.x, $8725869b83961a04$var$_position.y, $8725869b83961a04$var$_position.z);
            panner.setOrientation($8725869b83961a04$var$_orientation.x, $8725869b83961a04$var$_orientation.y, $8725869b83961a04$var$_orientation.z);
        }
    }
}
class $8725869b83961a04$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $8725869b83961a04$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $8725869b83961a04$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $8725869b83961a04$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $8725869b83961a04$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $8725869b83961a04$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $8725869b83961a04$var$_reservedRe = new RegExp('[' + $8725869b83961a04$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $8725869b83961a04$var$_wordChar = '[^' + $8725869b83961a04$var$_RESERVED_CHARS_RE + ']';
const $8725869b83961a04$var$_wordCharOrDot = '[^' + $8725869b83961a04$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $8725869b83961a04$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $8725869b83961a04$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $8725869b83961a04$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $8725869b83961a04$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $8725869b83961a04$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $8725869b83961a04$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $8725869b83961a04$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $8725869b83961a04$var$_wordChar);
const $8725869b83961a04$var$_trackRe = new RegExp("^" + $8725869b83961a04$var$_directoryRe + $8725869b83961a04$var$_nodeRe + $8725869b83961a04$var$_objectRe + $8725869b83961a04$var$_propertyRe + '$');
const $8725869b83961a04$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $8725869b83961a04$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $8725869b83961a04$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $8725869b83961a04$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $8725869b83961a04$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $8725869b83961a04$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $8725869b83961a04$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $8725869b83961a04$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($8725869b83961a04$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $8725869b83961a04$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($8725869b83961a04$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $8725869b83961a04$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$8725869b83961a04$export$7bf70fcf9f891893.Composite = $8725869b83961a04$var$Composite;
$8725869b83961a04$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$8725869b83961a04$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$8725869b83961a04$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_direct,
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_array,
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$8725869b83961a04$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_direct,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_array,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $8725869b83961a04$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $8725869b83961a04$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $8725869b83961a04$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $8725869b83961a04$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $8725869b83961a04$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $8725869b83961a04$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $8725869b83961a04$export$7f795934b84ab523,
            endingEnd: $8725869b83961a04$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $8725869b83961a04$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $8725869b83961a04$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $8725869b83961a04$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $8725869b83961a04$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $8725869b83961a04$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $8725869b83961a04$export$24a4ccb5099273b5;
            settings.endingEnd = $8725869b83961a04$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $8725869b83961a04$export$24a4ccb5099273b5 : $8725869b83961a04$export$7f795934b84ab523;
            else settings.endingStart = $8725869b83961a04$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $8725869b83961a04$export$24a4ccb5099273b5 : $8725869b83961a04$export$7f795934b84ab523;
            else settings.endingEnd = $8725869b83961a04$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $8725869b83961a04$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $8725869b83961a04$export$fbd77e5aefaa0102 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $8725869b83961a04$export$dfe0af1ca1acb78a($8725869b83961a04$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $8725869b83961a04$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $8725869b83961a04$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $8725869b83961a04$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $8725869b83961a04$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $8725869b83961a04$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $8725869b83961a04$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $8725869b83961a04$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $8725869b83961a04$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $8725869b83961a04$var$_id = 0;
class $8725869b83961a04$export$c412d5ffe1f79209 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $8725869b83961a04$var$_id++
        });
        this.name = '';
        this.usage = $8725869b83961a04$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $8725869b83961a04$export$25ec0e1af1389358 extends $8725869b83961a04$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $8725869b83961a04$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
const $8725869b83961a04$var$_matrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
class $8725869b83961a04$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $8725869b83961a04$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $8725869b83961a04$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    setFromXRController(controller) {
        $8725869b83961a04$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($8725869b83961a04$var$_matrix);
        return this;
    }
    intersectObject(object, recursive = true, intersects = []) {
        $8725869b83961a04$var$intersect(object, this, intersects, recursive);
        intersects.sort($8725869b83961a04$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$8725869b83961a04$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($8725869b83961a04$var$ascSort);
        return intersects;
    }
}
function $8725869b83961a04$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $8725869b83961a04$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$8725869b83961a04$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */ class $8725869b83961a04$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($8725869b83961a04$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $8725869b83961a04$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $8725869b83961a04$export$cbcc6560bf79fb38 {
    constructor(n11, n12, n21, n22){
        $8725869b83961a04$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $8725869b83961a04$var$_vector$4 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
class $8725869b83961a04$export$60f553fa130f08b0 {
    constructor(min = new $8725869b83961a04$export$c977b3e384af9ae1(Infinity, Infinity), max = new $8725869b83961a04$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $8725869b83961a04$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $8725869b83961a04$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $8725869b83961a04$var$_startP = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_startEnd = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$e0ba6359f1954fd3 {
    constructor(start = new $8725869b83961a04$export$64b5c384219d3699(), end = new $8725869b83961a04$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $8725869b83961a04$var$_startP.subVectors(point, this.start);
        $8725869b83961a04$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $8725869b83961a04$var$_startEnd.dot($8725869b83961a04$var$_startEnd);
        const startEnd_startP = $8725869b83961a04$var$_startEnd.dot($8725869b83961a04$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $8725869b83961a04$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_vector$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$4b14638ffdd81e68 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(positions, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $8725869b83961a04$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $8725869b83961a04$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($8725869b83961a04$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $8725869b83961a04$var$_vector$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_boneMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_matrixWorldInv = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
class $8725869b83961a04$export$5277df3c9e732259 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $8725869b83961a04$var$getBoneList(object);
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $8725869b83961a04$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $8725869b83961a04$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $8725869b83961a04$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $8725869b83961a04$var$_boneMatrix.multiplyMatrices($8725869b83961a04$var$_matrixWorldInv, bone.matrixWorld);
                $8725869b83961a04$var$_vector$2.setFromMatrixPosition($8725869b83961a04$var$_boneMatrix);
                position.setXYZ(j, $8725869b83961a04$var$_vector$2.x, $8725869b83961a04$var$_vector$2.y, $8725869b83961a04$var$_vector$2.z);
                $8725869b83961a04$var$_boneMatrix.multiplyMatrices($8725869b83961a04$var$_matrixWorldInv, bone.parent.matrixWorld);
                $8725869b83961a04$var$_vector$2.setFromMatrixPosition($8725869b83961a04$var$_boneMatrix);
                position.setXYZ(j + 1, $8725869b83961a04$var$_vector$2.x, $8725869b83961a04$var$_vector$2.y, $8725869b83961a04$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $8725869b83961a04$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $8725869b83961a04$var$getBoneList(object.children[i]));
    return boneList;
}
class $8725869b83961a04$export$9a9291685b9e4023 extends $8725869b83961a04$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $8725869b83961a04$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $8725869b83961a04$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $8725869b83961a04$var$_vector$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_color1 = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
const $8725869b83961a04$var$_color2 = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
class $8725869b83961a04$export$8dca15f13f4f8172 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $8725869b83961a04$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $8725869b83961a04$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $8725869b83961a04$export$8dea267bd6bde117(colors, 3));
        this.add(new $8725869b83961a04$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $8725869b83961a04$var$_color1.copy(this.light.color);
            $8725869b83961a04$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $8725869b83961a04$var$_color1 : $8725869b83961a04$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($8725869b83961a04$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $8725869b83961a04$export$3875d39926561055 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $8725869b83961a04$export$892596cec99bc70e(color1);
        color2 = new $8725869b83961a04$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$361430a10f533cd3 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $8725869b83961a04$export$892596cec99bc70e(color1);
        color2 = new $8725869b83961a04$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $8725869b83961a04$var$_v1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$f8e434dc14203e7d extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $8725869b83961a04$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $8725869b83961a04$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $8725869b83961a04$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $8725869b83961a04$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $8725869b83961a04$var$_v3.subVectors($8725869b83961a04$var$_v2, $8725869b83961a04$var$_v1);
        this.lightPlane.lookAt($8725869b83961a04$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($8725869b83961a04$var$_v2);
        this.targetLine.scale.z = $8725869b83961a04$var$_v3.length();
    }
}
const $8725869b83961a04$var$_vector = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_camera = /*@__PURE__*/ new $8725869b83961a04$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $8725869b83961a04$export$ed8e93f853cd795 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $8725869b83961a04$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $8725869b83961a04$export$892596cec99bc70e(0xff0000);
        const colorUp = new $8725869b83961a04$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        const colorCross = new $8725869b83961a04$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $8725869b83961a04$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $8725869b83961a04$var$setPoint('c', pointMap, geometry, $8725869b83961a04$var$_camera, 0, 0, -1);
        $8725869b83961a04$var$setPoint('t', pointMap, geometry, $8725869b83961a04$var$_camera, 0, 0, 1);
        // near
        $8725869b83961a04$var$setPoint('n1', pointMap, geometry, $8725869b83961a04$var$_camera, -w, -h, -1);
        $8725869b83961a04$var$setPoint('n2', pointMap, geometry, $8725869b83961a04$var$_camera, w, -h, -1);
        $8725869b83961a04$var$setPoint('n3', pointMap, geometry, $8725869b83961a04$var$_camera, -w, h, -1);
        $8725869b83961a04$var$setPoint('n4', pointMap, geometry, $8725869b83961a04$var$_camera, w, h, -1);
        // far
        $8725869b83961a04$var$setPoint('f1', pointMap, geometry, $8725869b83961a04$var$_camera, -w, -h, 1);
        $8725869b83961a04$var$setPoint('f2', pointMap, geometry, $8725869b83961a04$var$_camera, w, -h, 1);
        $8725869b83961a04$var$setPoint('f3', pointMap, geometry, $8725869b83961a04$var$_camera, -w, h, 1);
        $8725869b83961a04$var$setPoint('f4', pointMap, geometry, $8725869b83961a04$var$_camera, w, h, 1);
        // up
        $8725869b83961a04$var$setPoint('u1', pointMap, geometry, $8725869b83961a04$var$_camera, w * 0.7, h * 1.1, -1);
        $8725869b83961a04$var$setPoint('u2', pointMap, geometry, $8725869b83961a04$var$_camera, -w * 0.7, h * 1.1, -1);
        $8725869b83961a04$var$setPoint('u3', pointMap, geometry, $8725869b83961a04$var$_camera, 0, h * 2, -1);
        // cross
        $8725869b83961a04$var$setPoint('cf1', pointMap, geometry, $8725869b83961a04$var$_camera, -w, 0, 1);
        $8725869b83961a04$var$setPoint('cf2', pointMap, geometry, $8725869b83961a04$var$_camera, w, 0, 1);
        $8725869b83961a04$var$setPoint('cf3', pointMap, geometry, $8725869b83961a04$var$_camera, 0, -h, 1);
        $8725869b83961a04$var$setPoint('cf4', pointMap, geometry, $8725869b83961a04$var$_camera, 0, h, 1);
        $8725869b83961a04$var$setPoint('cn1', pointMap, geometry, $8725869b83961a04$var$_camera, -w, 0, -1);
        $8725869b83961a04$var$setPoint('cn2', pointMap, geometry, $8725869b83961a04$var$_camera, w, 0, -1);
        $8725869b83961a04$var$setPoint('cn3', pointMap, geometry, $8725869b83961a04$var$_camera, 0, -h, -1);
        $8725869b83961a04$var$setPoint('cn4', pointMap, geometry, $8725869b83961a04$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $8725869b83961a04$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $8725869b83961a04$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $8725869b83961a04$var$_vector.x, $8725869b83961a04$var$_vector.y, $8725869b83961a04$var$_vector.z);
    }
}
const $8725869b83961a04$var$_box = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
class $8725869b83961a04$export$38a664cc862a6a9d extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setIndex(new $8725869b83961a04$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $8725869b83961a04$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $8725869b83961a04$var$_box.setFromObject(this.object);
        if ($8725869b83961a04$var$_box.isEmpty()) return;
        const min = $8725869b83961a04$var$_box.min;
        const max = $8725869b83961a04$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$ce39f4bb96c9a290 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setIndex(new $8725869b83961a04$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$a34fe8156c66e5d7 extends $8725869b83961a04$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $8725869b83961a04$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $8725869b83961a04$export$e176487c05830cc5(geometry2, new $8725869b83961a04$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $8725869b83961a04$var$_axis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
let $8725869b83961a04$var$_lineGeometry, $8725869b83961a04$var$_coneGeometry;
class $8725869b83961a04$export$a3008e7bd8d2cbe7 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1), origin = new $8725869b83961a04$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($8725869b83961a04$var$_lineGeometry === undefined) {
            $8725869b83961a04$var$_lineGeometry = new $8725869b83961a04$export$b7be63a67df8959();
            $8725869b83961a04$var$_lineGeometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $8725869b83961a04$var$_coneGeometry = new $8725869b83961a04$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $8725869b83961a04$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $8725869b83961a04$export$17d680238e50603e($8725869b83961a04$var$_lineGeometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $8725869b83961a04$export$e176487c05830cc5($8725869b83961a04$var$_coneGeometry, new $8725869b83961a04$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $8725869b83961a04$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($8725869b83961a04$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $8725869b83961a04$export$6c8303f35b8578fd extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute('position', new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $8725869b83961a04$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $8725869b83961a04$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $8725869b83961a04$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $8725869b83961a04$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $8725869b83961a04$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $8725869b83961a04$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $8725869b83961a04$export$c7c44baae9d9f25f extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(object, domElement){
        super();
        this.object = object;
        this.domElement = domElement;
        this.enabled = true;
        this.state = -1;
        this.keys = {};
        this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        this.touches = {
            ONE: null,
            TWO: null
        };
    }
    connect() {}
    disconnect() {}
    dispose() {}
    update() {}
}
class $8725869b83961a04$export$bd934554fb721730 extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        console.warn('THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.');
        super(width, height, {
            ...options,
            count: count
        });
        this.isWebGLMultipleRenderTargets = true;
    }
    get texture() {
        return this.textures;
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $8725869b83961a04$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $8725869b83961a04$export$3545e07a80636437;
}



// OrbitControls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $f791a92fc305fc59$var$_changeEvent = {
    type: 'change'
};
const $f791a92fc305fc59$var$_startEvent = {
    type: 'start'
};
const $f791a92fc305fc59$var$_endEvent = {
    type: 'end'
};
const $f791a92fc305fc59$var$_ray = new (0, $8725869b83961a04$export$a186db52eed6d40e)();
const $f791a92fc305fc59$var$_plane = new (0, $8725869b83961a04$export$7ff5ac152ef991b0)();
const $f791a92fc305fc59$var$_TILT_LIMIT = Math.cos(70 * (0, $8725869b83961a04$export$6a7ef315a0d1ef07).DEG2RAD);
const $f791a92fc305fc59$var$_v = new (0, $8725869b83961a04$export$64b5c384219d3699)();
const $f791a92fc305fc59$var$_twoPI = 2 * Math.PI;
const $f791a92fc305fc59$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
};
const $f791a92fc305fc59$var$_EPS = 0.000001;
class $f791a92fc305fc59$export$8ff7788029dfdf52 extends (0, $8725869b83961a04$export$c7c44baae9d9f25f) {
    constructor(object, domElement = null){
        super(object, domElement);
        this.state = $f791a92fc305fc59$var$_STATE.NONE;
        // Set to false to disable this control
        this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        // Sets the 3D cursor (similar to Blender), from which the maxTargetRadius takes effect
        this.cursor = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // Limit camera target within a spherical area around the cursor
        this.minTargetRadius = 0;
        this.maxTargetRadius = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        this.zoomToCursor = false;
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        this.keys = {
            LEFT: 'ArrowLeft',
            UP: 'ArrowUp',
            RIGHT: 'ArrowRight',
            BOTTOM: 'ArrowDown'
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $8725869b83961a04$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $8725869b83961a04$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $8725869b83961a04$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $8725869b83961a04$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $8725869b83961a04$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        // internals
        this._lastPosition = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._lastQuaternion = new (0, $8725869b83961a04$export$23d6a54f0bbc85a3)();
        this._lastTargetPosition = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        // so camera.up is the orbit axis
        this._quat = new (0, $8725869b83961a04$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $8725869b83961a04$export$64b5c384219d3699)(0, 1, 0));
        this._quatInverse = this._quat.clone().invert();
        // current position in spherical coordinates
        this._spherical = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
        this._sphericalDelta = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
        this._scale = 1;
        this._panOffset = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._rotateStart = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._rotateEnd = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._rotateDelta = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._panStart = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._panEnd = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._panDelta = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._dollyStart = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._dollyEnd = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._dollyDelta = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._dollyDirection = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._mouse = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._performCursorZoom = false;
        this._pointers = [];
        this._pointerPositions = {};
        this._controlActive = false;
        // event listeners
        this._onPointerMove = $f791a92fc305fc59$var$onPointerMove.bind(this);
        this._onPointerDown = $f791a92fc305fc59$var$onPointerDown.bind(this);
        this._onPointerUp = $f791a92fc305fc59$var$onPointerUp.bind(this);
        this._onContextMenu = $f791a92fc305fc59$var$onContextMenu.bind(this);
        this._onMouseWheel = $f791a92fc305fc59$var$onMouseWheel.bind(this);
        this._onKeyDown = $f791a92fc305fc59$var$onKeyDown.bind(this);
        this._onTouchStart = $f791a92fc305fc59$var$onTouchStart.bind(this);
        this._onTouchMove = $f791a92fc305fc59$var$onTouchMove.bind(this);
        this._onMouseDown = $f791a92fc305fc59$var$onMouseDown.bind(this);
        this._onMouseMove = $f791a92fc305fc59$var$onMouseMove.bind(this);
        this._interceptControlDown = $f791a92fc305fc59$var$interceptControlDown.bind(this);
        this._interceptControlUp = $f791a92fc305fc59$var$interceptControlUp.bind(this);
        //
        if (this.domElement !== null) this.connect();
        this.update();
    }
    connect() {
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointercancel', this._onPointerUp);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: false
        });
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keydown', this._interceptControlDown, {
            passive: true,
            capture: true
        });
        this.domElement.style.touchAction = 'none'; // disable touch scroll
    }
    disconnect() {
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerUp);
        this.domElement.removeEventListener('wheel', this._onMouseWheel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.stopListenToKeyEvents();
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keydown', this._interceptControlDown, {
            capture: true
        });
        this.domElement.style.touchAction = 'auto';
    }
    dispose() {
        this.disconnect();
    }
    getPolarAngle() {
        return this._spherical.phi;
    }
    getAzimuthalAngle() {
        return this._spherical.theta;
    }
    getDistance() {
        return this.object.position.distanceTo(this.target);
    }
    listenToKeyEvents(domElement) {
        domElement.addEventListener('keydown', this._onKeyDown);
        this._domElementKeyEvents = domElement;
    }
    stopListenToKeyEvents() {
        if (this._domElementKeyEvents !== null) {
            this._domElementKeyEvents.removeEventListener('keydown', this._onKeyDown);
            this._domElementKeyEvents = null;
        }
    }
    saveState() {
        this.target0.copy(this.target);
        this.position0.copy(this.object.position);
        this.zoom0 = this.object.zoom;
    }
    reset() {
        this.target.copy(this.target0);
        this.object.position.copy(this.position0);
        this.object.zoom = this.zoom0;
        this.object.updateProjectionMatrix();
        this.dispatchEvent($f791a92fc305fc59$var$_changeEvent);
        this.update();
        this.state = $f791a92fc305fc59$var$_STATE.NONE;
    }
    update(deltaTime = null) {
        const position = this.object.position;
        $f791a92fc305fc59$var$_v.copy(position).sub(this.target);
        // rotate offset to "y-axis-is-up" space
        $f791a92fc305fc59$var$_v.applyQuaternion(this._quat);
        // angle from z-axis around y-axis
        this._spherical.setFromVector3($f791a92fc305fc59$var$_v);
        if (this.autoRotate && this.state === $f791a92fc305fc59$var$_STATE.NONE) this._rotateLeft(this._getAutoRotationAngle(deltaTime));
        if (this.enableDamping) {
            this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
            this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
        } else {
            this._spherical.theta += this._sphericalDelta.theta;
            this._spherical.phi += this._sphericalDelta.phi;
        }
        // restrict theta to be between desired limits
        let min = this.minAzimuthAngle;
        let max = this.maxAzimuthAngle;
        if (isFinite(min) && isFinite(max)) {
            if (min < -Math.PI) min += $f791a92fc305fc59$var$_twoPI;
            else if (min > Math.PI) min -= $f791a92fc305fc59$var$_twoPI;
            if (max < -Math.PI) max += $f791a92fc305fc59$var$_twoPI;
            else if (max > Math.PI) max -= $f791a92fc305fc59$var$_twoPI;
            if (min <= max) this._spherical.theta = Math.max(min, Math.min(max, this._spherical.theta));
            else this._spherical.theta = this._spherical.theta > (min + max) / 2 ? Math.max(min, this._spherical.theta) : Math.min(max, this._spherical.theta);
        }
        // restrict phi to be between desired limits
        this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
        this._spherical.makeSafe();
        // move target to panned location
        if (this.enableDamping === true) this.target.addScaledVector(this._panOffset, this.dampingFactor);
        else this.target.add(this._panOffset);
        // Limit the target distance from the cursor to create a sphere around the center of interest
        this.target.sub(this.cursor);
        this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
        this.target.add(this.cursor);
        let zoomChanged = false;
        // adjust the camera position based on zoom only if we're not zooming to the cursor or if it's an ortho camera
        // we adjust zoom later in these cases
        if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) this._spherical.radius = this._clampDistance(this._spherical.radius);
        else {
            const prevRadius = this._spherical.radius;
            this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
            zoomChanged = prevRadius != this._spherical.radius;
        }
        $f791a92fc305fc59$var$_v.setFromSpherical(this._spherical);
        // rotate offset back to "camera-up-vector-is-up" space
        $f791a92fc305fc59$var$_v.applyQuaternion(this._quatInverse);
        position.copy(this.target).add($f791a92fc305fc59$var$_v);
        this.object.lookAt(this.target);
        if (this.enableDamping === true) {
            this._sphericalDelta.theta *= 1 - this.dampingFactor;
            this._sphericalDelta.phi *= 1 - this.dampingFactor;
            this._panOffset.multiplyScalar(1 - this.dampingFactor);
        } else {
            this._sphericalDelta.set(0, 0, 0);
            this._panOffset.set(0, 0, 0);
        }
        // adjust camera position
        if (this.zoomToCursor && this._performCursorZoom) {
            let newRadius = null;
            if (this.object.isPerspectiveCamera) {
                // move the camera down the pointer ray
                // this method avoids floating point error
                const prevRadius = $f791a92fc305fc59$var$_v.length();
                newRadius = this._clampDistance(prevRadius * this._scale);
                const radiusDelta = prevRadius - newRadius;
                this.object.position.addScaledVector(this._dollyDirection, radiusDelta);
                this.object.updateMatrixWorld();
                zoomChanged = !!radiusDelta;
            } else if (this.object.isOrthographicCamera) {
                // adjust the ortho camera position based on zoom changes
                const mouseBefore = new (0, $8725869b83961a04$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseBefore.unproject(this.object);
                const prevZoom = this.object.zoom;
                this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
                this.object.updateProjectionMatrix();
                zoomChanged = prevZoom !== this.object.zoom;
                const mouseAfter = new (0, $8725869b83961a04$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseAfter.unproject(this.object);
                this.object.position.sub(mouseAfter).add(mouseBefore);
                this.object.updateMatrixWorld();
                newRadius = $f791a92fc305fc59$var$_v.length();
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.');
                this.zoomToCursor = false;
            }
            // handle the placement of the target
            if (newRadius !== null) {
                if (this.screenSpacePanning) // position the orbit target in front of the new camera position
                this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(newRadius).add(this.object.position);
                else {
                    // get the ray and translation plane to compute target
                    $f791a92fc305fc59$var$_ray.origin.copy(this.object.position);
                    $f791a92fc305fc59$var$_ray.direction.set(0, 0, -1).transformDirection(this.object.matrix);
                    // if the camera is 20 degrees above the horizon then don't adjust the focus target to avoid
                    // extremely large values
                    if (Math.abs(this.object.up.dot($f791a92fc305fc59$var$_ray.direction)) < $f791a92fc305fc59$var$_TILT_LIMIT) this.object.lookAt(this.target);
                    else {
                        $f791a92fc305fc59$var$_plane.setFromNormalAndCoplanarPoint(this.object.up, this.target);
                        $f791a92fc305fc59$var$_ray.intersectPlane($f791a92fc305fc59$var$_plane, this.target);
                    }
                }
            }
        } else if (this.object.isOrthographicCamera) {
            const prevZoom = this.object.zoom;
            this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
            if (prevZoom !== this.object.zoom) {
                this.object.updateProjectionMatrix();
                zoomChanged = true;
            }
        }
        this._scale = 1;
        this._performCursorZoom = false;
        // update condition is:
        // min(camera displacement, camera rotation in radians)^2 > EPS
        // using small-angle approximation cos(x/2) = 1 - x^2 / 8
        if (zoomChanged || this._lastPosition.distanceToSquared(this.object.position) > $f791a92fc305fc59$var$_EPS || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > $f791a92fc305fc59$var$_EPS || this._lastTargetPosition.distanceToSquared(this.target) > $f791a92fc305fc59$var$_EPS) {
            this.dispatchEvent($f791a92fc305fc59$var$_changeEvent);
            this._lastPosition.copy(this.object.position);
            this._lastQuaternion.copy(this.object.quaternion);
            this._lastTargetPosition.copy(this.target);
            return true;
        }
        return false;
    }
    _getAutoRotationAngle(deltaTime) {
        if (deltaTime !== null) return $f791a92fc305fc59$var$_twoPI / 60 * this.autoRotateSpeed * deltaTime;
        else return $f791a92fc305fc59$var$_twoPI / 60 / 60 * this.autoRotateSpeed;
    }
    _getZoomScale(delta) {
        const normalizedDelta = Math.abs(delta * 0.01);
        return Math.pow(0.95, this.zoomSpeed * normalizedDelta);
    }
    _rotateLeft(angle) {
        this._sphericalDelta.theta -= angle;
    }
    _rotateUp(angle) {
        this._sphericalDelta.phi -= angle;
    }
    _panLeft(distance, objectMatrix) {
        $f791a92fc305fc59$var$_v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
        $f791a92fc305fc59$var$_v.multiplyScalar(-distance);
        this._panOffset.add($f791a92fc305fc59$var$_v);
    }
    _panUp(distance, objectMatrix) {
        if (this.screenSpacePanning === true) $f791a92fc305fc59$var$_v.setFromMatrixColumn(objectMatrix, 1);
        else {
            $f791a92fc305fc59$var$_v.setFromMatrixColumn(objectMatrix, 0);
            $f791a92fc305fc59$var$_v.crossVectors(this.object.up, $f791a92fc305fc59$var$_v);
        }
        $f791a92fc305fc59$var$_v.multiplyScalar(distance);
        this._panOffset.add($f791a92fc305fc59$var$_v);
    }
    // deltaX and deltaY are in pixels; right and down are positive
    _pan(deltaX, deltaY) {
        const element = this.domElement;
        if (this.object.isPerspectiveCamera) {
            // perspective
            const position = this.object.position;
            $f791a92fc305fc59$var$_v.copy(position).sub(this.target);
            let targetDistance = $f791a92fc305fc59$var$_v.length();
            // half of the fov is center to top of screen
            targetDistance *= Math.tan(this.object.fov / 2 * Math.PI / 180.0);
            // we use only clientHeight here so aspect ratio does not distort speed
            this._panLeft(2 * deltaX * targetDistance / element.clientHeight, this.object.matrix);
            this._panUp(2 * deltaY * targetDistance / element.clientHeight, this.object.matrix);
        } else if (this.object.isOrthographicCamera) {
            // orthographic
            this._panLeft(deltaX * (this.object.right - this.object.left) / this.object.zoom / element.clientWidth, this.object.matrix);
            this._panUp(deltaY * (this.object.top - this.object.bottom) / this.object.zoom / element.clientHeight, this.object.matrix);
        } else {
            // camera neither orthographic nor perspective
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
            this.enablePan = false;
        }
    }
    _dollyOut(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale /= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _dollyIn(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale *= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _updateZoomParameters(x, y) {
        if (!this.zoomToCursor) return;
        this._performCursorZoom = true;
        const rect = this.domElement.getBoundingClientRect();
        const dx = x - rect.left;
        const dy = y - rect.top;
        const w = rect.width;
        const h = rect.height;
        this._mouse.x = dx / w * 2 - 1;
        this._mouse.y = -(dy / h) * 2 + 1;
        this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
    }
    _clampDistance(dist) {
        return Math.max(this.minDistance, Math.min(this.maxDistance, dist));
    }
    //
    // event callbacks - update the object state
    //
    _handleMouseDownRotate(event) {
        this._rotateStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownDolly(event) {
        this._updateZoomParameters(event.clientX, event.clientX);
        this._dollyStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownPan(event) {
        this._panStart.set(event.clientX, event.clientY);
    }
    _handleMouseMoveRotate(event) {
        this._rotateEnd.set(event.clientX, event.clientY);
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($f791a92fc305fc59$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($f791a92fc305fc59$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
        this.update();
    }
    _handleMouseMoveDolly(event) {
        this._dollyEnd.set(event.clientX, event.clientY);
        this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
        if (this._dollyDelta.y > 0) this._dollyOut(this._getZoomScale(this._dollyDelta.y));
        else if (this._dollyDelta.y < 0) this._dollyIn(this._getZoomScale(this._dollyDelta.y));
        this._dollyStart.copy(this._dollyEnd);
        this.update();
    }
    _handleMouseMovePan(event) {
        this._panEnd.set(event.clientX, event.clientY);
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
        this.update();
    }
    _handleMouseWheel(event) {
        this._updateZoomParameters(event.clientX, event.clientY);
        if (event.deltaY < 0) this._dollyIn(this._getZoomScale(event.deltaY));
        else if (event.deltaY > 0) this._dollyOut(this._getZoomScale(event.deltaY));
        this.update();
    }
    _handleKeyDown(event) {
        let needsUpdate = false;
        switch(event.code){
            case this.keys.UP:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateUp($f791a92fc305fc59$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(0, this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.BOTTOM:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateUp(-$f791a92fc305fc59$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(0, -this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.LEFT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateLeft($f791a92fc305fc59$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
            case this.keys.RIGHT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateLeft(-$f791a92fc305fc59$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(-this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
        }
        if (needsUpdate) {
            // prevent the browser from scrolling on cursor keys
            event.preventDefault();
            this.update();
        }
    }
    _handleTouchStartRotate(event) {
        if (this._pointers.length === 1) this._rotateStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateStart.set(x, y);
        }
    }
    _handleTouchStartPan(event) {
        if (this._pointers.length === 1) this._panStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panStart.set(x, y);
        }
    }
    _handleTouchStartDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyStart.set(0, distance);
    }
    _handleTouchStartDollyPan(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enablePan) this._handleTouchStartPan(event);
    }
    _handleTouchStartDollyRotate(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enableRotate) this._handleTouchStartRotate(event);
    }
    _handleTouchMoveRotate(event) {
        if (this._pointers.length == 1) this._rotateEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateEnd.set(x, y);
        }
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($f791a92fc305fc59$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($f791a92fc305fc59$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
    }
    _handleTouchMovePan(event) {
        if (this._pointers.length === 1) this._panEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panEnd.set(x, y);
        }
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
    }
    _handleTouchMoveDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyEnd.set(0, distance);
        this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed));
        this._dollyOut(this._dollyDelta.y);
        this._dollyStart.copy(this._dollyEnd);
        const centerX = (event.pageX + position.x) * 0.5;
        const centerY = (event.pageY + position.y) * 0.5;
        this._updateZoomParameters(centerX, centerY);
    }
    _handleTouchMoveDollyPan(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enablePan) this._handleTouchMovePan(event);
    }
    _handleTouchMoveDollyRotate(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enableRotate) this._handleTouchMoveRotate(event);
    }
    // pointers
    _addPointer(event) {
        this._pointers.push(event.pointerId);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i] == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _isTrackingPointer(event) {
        for(let i = 0; i < this._pointers.length; i++){
            if (this._pointers[i] == event.pointerId) return true;
        }
        return false;
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointerId = event.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointerId];
    }
    //
    _customWheelEvent(event) {
        const mode = event.deltaMode;
        // minimal wheel event altered to meet delta-zoom demand
        const newEvent = {
            clientX: event.clientX,
            clientY: event.clientY,
            deltaY: event.deltaY
        };
        switch(mode){
            case 1:
                newEvent.deltaY *= 16;
                break;
            case 2:
                newEvent.deltaY *= 100;
                break;
        }
        // detect if event was triggered by pinching
        if (event.ctrlKey && !this._controlActive) newEvent.deltaY *= 10;
        return newEvent;
    }
}
function $f791a92fc305fc59$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerup', this._onPointerUp);
    }
    //
    if (this._isTrackingPointer(event)) return;
    //
    this._addPointer(event);
    if (event.pointerType === 'touch') this._onTouchStart(event);
    else this._onMouseDown(event);
}
function $f791a92fc305fc59$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $f791a92fc305fc59$var$onPointerUp(event) {
    this._removePointer(event);
    switch(this._pointers.length){
        case 0:
            this.domElement.releasePointerCapture(event.pointerId);
            this.domElement.removeEventListener('pointermove', this._onPointerMove);
            this.domElement.removeEventListener('pointerup', this._onPointerUp);
            this.dispatchEvent($f791a92fc305fc59$var$_endEvent);
            this.state = $f791a92fc305fc59$var$_STATE.NONE;
            break;
        case 1:
            const pointerId = this._pointers[0];
            const position = this._pointerPositions[pointerId];
            // minimal placeholder event - allows state correction on pointer-up
            this._onTouchStart({
                pointerId: pointerId,
                pageX: position.x,
                pageY: position.y
            });
            break;
    }
}
function $f791a92fc305fc59$var$onMouseDown(event) {
    let mouseAction;
    switch(event.button){
        case 0:
            mouseAction = this.mouseButtons.LEFT;
            break;
        case 1:
            mouseAction = this.mouseButtons.MIDDLE;
            break;
        case 2:
            mouseAction = this.mouseButtons.RIGHT;
            break;
        default:
            mouseAction = -1;
    }
    switch(mouseAction){
        case (0, $8725869b83961a04$export$7177b3e430c2d7ca).DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseDownDolly(event);
            this.state = $f791a92fc305fc59$var$_STATE.DOLLY;
            break;
        case (0, $8725869b83961a04$export$7177b3e430c2d7ca).ROTATE:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $f791a92fc305fc59$var$_STATE.PAN;
            } else {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $f791a92fc305fc59$var$_STATE.ROTATE;
            }
            break;
        case (0, $8725869b83961a04$export$7177b3e430c2d7ca).PAN:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $f791a92fc305fc59$var$_STATE.ROTATE;
            } else {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $f791a92fc305fc59$var$_STATE.PAN;
            }
            break;
        default:
            this.state = $f791a92fc305fc59$var$_STATE.NONE;
    }
    if (this.state !== $f791a92fc305fc59$var$_STATE.NONE) this.dispatchEvent($f791a92fc305fc59$var$_startEvent);
}
function $f791a92fc305fc59$var$onMouseMove(event) {
    switch(this.state){
        case $f791a92fc305fc59$var$_STATE.ROTATE:
            if (this.enableRotate === false) return;
            this._handleMouseMoveRotate(event);
            break;
        case $f791a92fc305fc59$var$_STATE.DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseMoveDolly(event);
            break;
        case $f791a92fc305fc59$var$_STATE.PAN:
            if (this.enablePan === false) return;
            this._handleMouseMovePan(event);
            break;
    }
}
function $f791a92fc305fc59$var$onMouseWheel(event) {
    if (this.enabled === false || this.enableZoom === false || this.state !== $f791a92fc305fc59$var$_STATE.NONE) return;
    event.preventDefault();
    this.dispatchEvent($f791a92fc305fc59$var$_startEvent);
    this._handleMouseWheel(this._customWheelEvent(event));
    this.dispatchEvent($f791a92fc305fc59$var$_endEvent);
}
function $f791a92fc305fc59$var$onKeyDown(event) {
    if (this.enabled === false || this.enablePan === false) return;
    this._handleKeyDown(event);
}
function $f791a92fc305fc59$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            switch(this.touches.ONE){
                case (0, $8725869b83961a04$export$d46bd3ead7cc759b).ROTATE:
                    if (this.enableRotate === false) return;
                    this._handleTouchStartRotate(event);
                    this.state = $f791a92fc305fc59$var$_STATE.TOUCH_ROTATE;
                    break;
                case (0, $8725869b83961a04$export$d46bd3ead7cc759b).PAN:
                    if (this.enablePan === false) return;
                    this._handleTouchStartPan(event);
                    this.state = $f791a92fc305fc59$var$_STATE.TOUCH_PAN;
                    break;
                default:
                    this.state = $f791a92fc305fc59$var$_STATE.NONE;
            }
            break;
        case 2:
            switch(this.touches.TWO){
                case (0, $8725869b83961a04$export$d46bd3ead7cc759b).DOLLY_PAN:
                    if (this.enableZoom === false && this.enablePan === false) return;
                    this._handleTouchStartDollyPan(event);
                    this.state = $f791a92fc305fc59$var$_STATE.TOUCH_DOLLY_PAN;
                    break;
                case (0, $8725869b83961a04$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                    if (this.enableZoom === false && this.enableRotate === false) return;
                    this._handleTouchStartDollyRotate(event);
                    this.state = $f791a92fc305fc59$var$_STATE.TOUCH_DOLLY_ROTATE;
                    break;
                default:
                    this.state = $f791a92fc305fc59$var$_STATE.NONE;
            }
            break;
        default:
            this.state = $f791a92fc305fc59$var$_STATE.NONE;
    }
    if (this.state !== $f791a92fc305fc59$var$_STATE.NONE) this.dispatchEvent($f791a92fc305fc59$var$_startEvent);
}
function $f791a92fc305fc59$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this.state){
        case $f791a92fc305fc59$var$_STATE.TOUCH_ROTATE:
            if (this.enableRotate === false) return;
            this._handleTouchMoveRotate(event);
            this.update();
            break;
        case $f791a92fc305fc59$var$_STATE.TOUCH_PAN:
            if (this.enablePan === false) return;
            this._handleTouchMovePan(event);
            this.update();
            break;
        case $f791a92fc305fc59$var$_STATE.TOUCH_DOLLY_PAN:
            if (this.enableZoom === false && this.enablePan === false) return;
            this._handleTouchMoveDollyPan(event);
            this.update();
            break;
        case $f791a92fc305fc59$var$_STATE.TOUCH_DOLLY_ROTATE:
            if (this.enableZoom === false && this.enableRotate === false) return;
            this._handleTouchMoveDollyRotate(event);
            this.update();
            break;
        default:
            this.state = $f791a92fc305fc59$var$_STATE.NONE;
    }
}
function $f791a92fc305fc59$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $f791a92fc305fc59$var$interceptControlDown(event) {
    if (event.key === 'Control') {
        this._controlActive = true;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}
function $f791a92fc305fc59$var$interceptControlUp(event) {
    if (event.key === 'Control') {
        this._controlActive = false;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}



class $5859463f2a625df8$export$936f75e6792bf2dc extends (0, $8725869b83961a04$export$e4dd07dff30cc924) {
    constructor(element = document.createElement('div')){
        super();
        this.isCSS2DObject = true;
        this.element = element;
        this.element.style.position = 'absolute';
        this.element.style.userSelect = 'none';
        this.element.setAttribute('draggable', false);
        this.center = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(0.5, 0.5); // ( 0, 0 ) is the lower left; ( 1, 1 ) is the top right
        this.addEventListener('removed', function() {
            this.traverse(function(object) {
                if (object.element instanceof Element && object.element.parentNode !== null) object.element.parentNode.removeChild(object.element);
            });
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.element = source.element.cloneNode(true);
        this.center = source.center;
        return this;
    }
}
//
const $5859463f2a625df8$var$_vector = new (0, $8725869b83961a04$export$64b5c384219d3699)();
const $5859463f2a625df8$var$_viewMatrix = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
const $5859463f2a625df8$var$_viewProjectionMatrix = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
const $5859463f2a625df8$var$_a = new (0, $8725869b83961a04$export$64b5c384219d3699)();
const $5859463f2a625df8$var$_b = new (0, $8725869b83961a04$export$64b5c384219d3699)();
class $5859463f2a625df8$export$508520281a983506 {
    constructor(parameters = {}){
        const _this = this;
        let _width, _height;
        let _widthHalf, _heightHalf;
        const cache = {
            objects: new WeakMap()
        };
        const domElement = parameters.element !== undefined ? parameters.element : document.createElement('div');
        domElement.style.overflow = 'hidden';
        this.domElement = domElement;
        this.getSize = function() {
            return {
                width: _width,
                height: _height
            };
        };
        this.render = function(scene, camera) {
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            $5859463f2a625df8$var$_viewMatrix.copy(camera.matrixWorldInverse);
            $5859463f2a625df8$var$_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, $5859463f2a625df8$var$_viewMatrix);
            renderObject(scene, scene, camera);
            zOrder(scene);
        };
        this.setSize = function(width, height) {
            _width = width;
            _height = height;
            _widthHalf = _width / 2;
            _heightHalf = _height / 2;
            domElement.style.width = width + 'px';
            domElement.style.height = height + 'px';
        };
        function hideObject(object) {
            if (object.isCSS2DObject) object.element.style.display = 'none';
            for(let i = 0, l = object.children.length; i < l; i++)hideObject(object.children[i]);
        }
        function renderObject(object, scene, camera) {
            if (object.visible === false) {
                hideObject(object);
                return;
            }
            if (object.isCSS2DObject) {
                $5859463f2a625df8$var$_vector.setFromMatrixPosition(object.matrixWorld);
                $5859463f2a625df8$var$_vector.applyMatrix4($5859463f2a625df8$var$_viewProjectionMatrix);
                const visible = $5859463f2a625df8$var$_vector.z >= -1 && $5859463f2a625df8$var$_vector.z <= 1 && object.layers.test(camera.layers) === true;
                const element = object.element;
                element.style.display = visible === true ? '' : 'none';
                if (visible === true) {
                    object.onBeforeRender(_this, scene, camera);
                    element.style.transform = 'translate(' + -100 * object.center.x + '%,' + -100 * object.center.y + '%)' + 'translate(' + ($5859463f2a625df8$var$_vector.x * _widthHalf + _widthHalf) + 'px,' + (-$5859463f2a625df8$var$_vector.y * _heightHalf + _heightHalf) + 'px)';
                    if (element.parentNode !== domElement) domElement.appendChild(element);
                    object.onAfterRender(_this, scene, camera);
                }
                const objectData = {
                    distanceToCameraSquared: getDistanceToSquared(camera, object)
                };
                cache.objects.set(object, objectData);
            }
            for(let i = 0, l = object.children.length; i < l; i++)renderObject(object.children[i], scene, camera);
        }
        function getDistanceToSquared(object1, object2) {
            $5859463f2a625df8$var$_a.setFromMatrixPosition(object1.matrixWorld);
            $5859463f2a625df8$var$_b.setFromMatrixPosition(object2.matrixWorld);
            return $5859463f2a625df8$var$_a.distanceToSquared($5859463f2a625df8$var$_b);
        }
        function filterAndFlatten(scene) {
            const result = [];
            scene.traverseVisible(function(object) {
                if (object.isCSS2DObject) result.push(object);
            });
            return result;
        }
        function zOrder(scene) {
            const sorted = filterAndFlatten(scene).sort(function(a, b) {
                if (a.renderOrder !== b.renderOrder) return b.renderOrder - a.renderOrder;
                const distanceA = cache.objects.get(a).distanceToCameraSquared;
                const distanceB = cache.objects.get(b).distanceToCameraSquared;
                return distanceA - distanceB;
            });
            const zMax = sorted.length;
            for(let i = 0, l = sorted.length; i < l; i++)sorted[i].element.style.zIndex = zMax - i;
        }
    }
}


const $08f376d8b3812e53$export$545019fcfa826f08 = {
    window: {
        width: 700,
        height: 700
    },
    camera: {
        radius: 210
    },
    globe: {
        radius: 100
    },
    marker: {
        size: 30
    }
};


parcelRequire("kOgzt");
var $3IaSv = parcelRequire("3IaSv");


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $861d85464379e5ed$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $861d85464379e5ed$export$2e2bcd8739ae039 = $861d85464379e5ed$var$isObject;


/** Detect free variable `global` from Node.js. */ var $946b943250849329$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $946b943250849329$export$2e2bcd8739ae039 = $946b943250849329$var$freeGlobal;


/** Detect free variable `self`. */ var $7d88d81eb82f261a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7d88d81eb82f261a$var$root = (0, $946b943250849329$export$2e2bcd8739ae039) || $7d88d81eb82f261a$var$freeSelf || Function('return this')();
var $7d88d81eb82f261a$export$2e2bcd8739ae039 = $7d88d81eb82f261a$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $5026f600b2697d0a$var$now = function() {
    return (0, $7d88d81eb82f261a$export$2e2bcd8739ae039).Date.now();
};
var $5026f600b2697d0a$export$2e2bcd8739ae039 = $5026f600b2697d0a$var$now;


/** Used to match a single whitespace character. */ var $cd4c1c8a622a87af$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $cd4c1c8a622a87af$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $cd4c1c8a622a87af$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $cd4c1c8a622a87af$export$2e2bcd8739ae039 = $cd4c1c8a622a87af$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $4a37e5aaaaee7f43$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $4a37e5aaaaee7f43$var$baseTrim(string) {
    return string ? string.slice(0, (0, $cd4c1c8a622a87af$export$2e2bcd8739ae039)(string) + 1).replace($4a37e5aaaaee7f43$var$reTrimStart, '') : string;
}
var $4a37e5aaaaee7f43$export$2e2bcd8739ae039 = $4a37e5aaaaee7f43$var$baseTrim;




/** Built-in value references. */ var $4b1937481569dabd$var$Symbol = (0, $7d88d81eb82f261a$export$2e2bcd8739ae039).Symbol;
var $4b1937481569dabd$export$2e2bcd8739ae039 = $4b1937481569dabd$var$Symbol;



/** Used for built-in method references. */ var $cfd9dcb1af6e945c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cfd9dcb1af6e945c$var$hasOwnProperty = $cfd9dcb1af6e945c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cfd9dcb1af6e945c$var$nativeObjectToString = $cfd9dcb1af6e945c$var$objectProto.toString;
/** Built-in value references. */ var $cfd9dcb1af6e945c$var$symToStringTag = (0, $4b1937481569dabd$export$2e2bcd8739ae039) ? (0, $4b1937481569dabd$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $cfd9dcb1af6e945c$var$getRawTag(value) {
    var isOwn = $cfd9dcb1af6e945c$var$hasOwnProperty.call(value, $cfd9dcb1af6e945c$var$symToStringTag), tag = value[$cfd9dcb1af6e945c$var$symToStringTag];
    try {
        value[$cfd9dcb1af6e945c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $cfd9dcb1af6e945c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$cfd9dcb1af6e945c$var$symToStringTag] = tag;
        else delete value[$cfd9dcb1af6e945c$var$symToStringTag];
    }
    return result;
}
var $cfd9dcb1af6e945c$export$2e2bcd8739ae039 = $cfd9dcb1af6e945c$var$getRawTag;


/** Used for built-in method references. */ var $e5815448047ae578$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e5815448047ae578$var$nativeObjectToString = $e5815448047ae578$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e5815448047ae578$var$objectToString(value) {
    return $e5815448047ae578$var$nativeObjectToString.call(value);
}
var $e5815448047ae578$export$2e2bcd8739ae039 = $e5815448047ae578$var$objectToString;


/** `Object#toString` result references. */ var $3500d27f561e364e$var$nullTag = '[object Null]', $3500d27f561e364e$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $3500d27f561e364e$var$symToStringTag = (0, $4b1937481569dabd$export$2e2bcd8739ae039) ? (0, $4b1937481569dabd$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3500d27f561e364e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3500d27f561e364e$var$undefinedTag : $3500d27f561e364e$var$nullTag;
    return $3500d27f561e364e$var$symToStringTag && $3500d27f561e364e$var$symToStringTag in Object(value) ? (0, $cfd9dcb1af6e945c$export$2e2bcd8739ae039)(value) : (0, $e5815448047ae578$export$2e2bcd8739ae039)(value);
}
var $3500d27f561e364e$export$2e2bcd8739ae039 = $3500d27f561e364e$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $05c97b4d1d1744ea$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $05c97b4d1d1744ea$export$2e2bcd8739ae039 = $05c97b4d1d1744ea$var$isObjectLike;


/** `Object#toString` result references. */ var $33b7900109148f79$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $33b7900109148f79$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $05c97b4d1d1744ea$export$2e2bcd8739ae039)(value) && (0, $3500d27f561e364e$export$2e2bcd8739ae039)(value) == $33b7900109148f79$var$symbolTag;
}
var $33b7900109148f79$export$2e2bcd8739ae039 = $33b7900109148f79$var$isSymbol;


/** Used as references for various `Number` constants. */ var $4577620f61caf1ac$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $4577620f61caf1ac$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4577620f61caf1ac$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4577620f61caf1ac$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4577620f61caf1ac$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4577620f61caf1ac$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $33b7900109148f79$export$2e2bcd8739ae039)(value)) return $4577620f61caf1ac$var$NAN;
    if ((0, $861d85464379e5ed$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $861d85464379e5ed$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $4a37e5aaaaee7f43$export$2e2bcd8739ae039)(value);
    var isBinary = $4577620f61caf1ac$var$reIsBinary.test(value);
    return isBinary || $4577620f61caf1ac$var$reIsOctal.test(value) ? $4577620f61caf1ac$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4577620f61caf1ac$var$reIsBadHex.test(value) ? $4577620f61caf1ac$var$NAN : +value;
}
var $4577620f61caf1ac$export$2e2bcd8739ae039 = $4577620f61caf1ac$var$toNumber;


/** Error message constants. */ var $ed2db8ff2086cf24$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ed2db8ff2086cf24$var$nativeMax = Math.max, $ed2db8ff2086cf24$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ed2db8ff2086cf24$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ed2db8ff2086cf24$var$FUNC_ERROR_TEXT);
    wait = (0, $4577620f61caf1ac$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $861d85464379e5ed$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ed2db8ff2086cf24$var$nativeMax((0, $4577620f61caf1ac$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ed2db8ff2086cf24$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $5026f600b2697d0a$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $5026f600b2697d0a$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $5026f600b2697d0a$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $ed2db8ff2086cf24$export$2e2bcd8739ae039 = $ed2db8ff2086cf24$var$debounce;


function $48722fc3e2bb2376$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $48722fc3e2bb2376$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $48722fc3e2bb2376$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $48722fc3e2bb2376$var$_createClass(e, r, t) {
    return Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $48722fc3e2bb2376$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $48722fc3e2bb2376$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $48722fc3e2bb2376$var$_slicedToArray(r, e) {
    return $48722fc3e2bb2376$var$_arrayWithHoles(r) || $48722fc3e2bb2376$var$_iterableToArrayLimit(r, e) || $48722fc3e2bb2376$var$_unsupportedIterableToArray(r, e) || $48722fc3e2bb2376$var$_nonIterableRest();
}
function $48722fc3e2bb2376$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $48722fc3e2bb2376$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $48722fc3e2bb2376$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $48722fc3e2bb2376$var$Prop = /*#__PURE__*/ $48722fc3e2bb2376$var$_createClass(function Prop(name, _ref) {
    var _ref$default = _ref["default"], defaultVal = _ref$default === void 0 ? null : _ref$default, _ref$triggerUpdate = _ref.triggerUpdate, triggerUpdate = _ref$triggerUpdate === void 0 ? true : _ref$triggerUpdate, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? function(newVal, state) {} : _ref$onChange;
    $48722fc3e2bb2376$var$_classCallCheck(this, Prop);
    this.name = name;
    this.defaultVal = defaultVal;
    this.triggerUpdate = triggerUpdate;
    this.onChange = onChange;
});
function $48722fc3e2bb2376$export$2e2bcd8739ae039(_ref2) {
    var _ref2$stateInit = _ref2.stateInit, stateInit = _ref2$stateInit === void 0 ? function() {
        return {};
    } : _ref2$stateInit, _ref2$props = _ref2.props, rawProps = _ref2$props === void 0 ? {} : _ref2$props, _ref2$methods = _ref2.methods, methods = _ref2$methods === void 0 ? {} : _ref2$methods, _ref2$aliases = _ref2.aliases, aliases = _ref2$aliases === void 0 ? {} : _ref2$aliases, _ref2$init = _ref2.init, initFn = _ref2$init === void 0 ? function() {} : _ref2$init, _ref2$update = _ref2.update, updateFn = _ref2$update === void 0 ? function() {} : _ref2$update;
    // Parse props into Prop instances
    var props = Object.keys(rawProps).map(function(propName) {
        return new $48722fc3e2bb2376$var$Prop(propName, rawProps[propName]);
    });
    return function KapsuleComp() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var classMode = !!(this instanceof KapsuleComp ? this.constructor : void 0);
        var nodeElement = classMode ? args.shift() : undefined;
        var _args$ = args[0], options = _args$ === void 0 ? {} : _args$;
        // Holds component state
        var state = Object.assign({}, stateInit instanceof Function ? stateInit(options) : stateInit, // Support plain objects for backwards compatibility
        {
            initialised: false
        });
        // keeps track of which props triggered an update
        var changedProps = {};
        // Component constructor
        function comp(nodeElement) {
            initStatic(nodeElement, options);
            digest();
            return comp;
        }
        var initStatic = function initStatic(nodeElement, options) {
            initFn.call(comp, nodeElement, state, options);
            state.initialised = true;
        };
        var digest = (0, $ed2db8ff2086cf24$export$2e2bcd8739ae039)(function() {
            if (!state.initialised) return;
            updateFn.call(comp, state, changedProps);
            changedProps = {};
        }, 1);
        // Getter/setter methods
        props.forEach(function(prop) {
            comp[prop.name] = getSetProp(prop);
            function getSetProp(_ref3) {
                var prop = _ref3.name, _ref3$triggerUpdate = _ref3.triggerUpdate, redigest = _ref3$triggerUpdate === void 0 ? false : _ref3$triggerUpdate, _ref3$onChange = _ref3.onChange, onChange = _ref3$onChange === void 0 ? function(newVal, state) {} : _ref3$onChange, _ref3$defaultVal = _ref3.defaultVal, defaultVal = _ref3$defaultVal === void 0 ? null : _ref3$defaultVal;
                return function(_) {
                    var curVal = state[prop];
                    if (!arguments.length) return curVal;
                     // Getter mode
                    var val = _ === undefined ? defaultVal : _; // pick default if value passed is undefined
                    state[prop] = val;
                    onChange.call(comp, val, state, curVal);
                    // track changed props
                    !changedProps.hasOwnProperty(prop) && (changedProps[prop] = curVal);
                    if (redigest) digest();
                    return comp;
                };
            }
        });
        // Other methods
        Object.keys(methods).forEach(function(methodName) {
            comp[methodName] = function() {
                var _methods$methodName;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return (_methods$methodName = methods[methodName]).call.apply(_methods$methodName, [
                    comp,
                    state
                ].concat(args));
            };
        });
        // Link aliases
        Object.entries(aliases).forEach(function(_ref4) {
            var _ref5 = $48722fc3e2bb2376$var$_slicedToArray(_ref4, 2), alias = _ref5[0], target = _ref5[1];
            return comp[alias] = comp[target];
        });
        // Reset all component props to their default value
        comp.resetProps = function() {
            props.forEach(function(prop) {
                comp[prop.name](prop.defaultVal);
            });
            return comp;
        };
        //
        comp.resetProps(); // Apply all prop defaults
        state._rerender = digest; // Expose digest method
        classMode && nodeElement && comp(nodeElement);
        return comp;
    };
}



var $79Zf3 = parcelRequire("79Zf3");

function $01e890dabde89b47$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $01e890dabde89b47$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $01e890dabde89b47$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $01e890dabde89b47$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $01e890dabde89b47$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $01e890dabde89b47$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $01e890dabde89b47$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $01e890dabde89b47$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $01e890dabde89b47$var$equals(last, last.next)) {
        $01e890dabde89b47$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $01e890dabde89b47$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($01e890dabde89b47$var$equals(p, p.next) || $01e890dabde89b47$var$area(p.prev, p, p.next) === 0)) {
            $01e890dabde89b47$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $01e890dabde89b47$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $01e890dabde89b47$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $01e890dabde89b47$var$isEarHashed(ear, minX, minY, invSize) : $01e890dabde89b47$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $01e890dabde89b47$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $01e890dabde89b47$var$earcutLinked($01e890dabde89b47$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $01e890dabde89b47$var$cureLocalIntersections($01e890dabde89b47$var$filterPoints(ear), triangles);
                $01e890dabde89b47$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $01e890dabde89b47$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $01e890dabde89b47$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($01e890dabde89b47$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $01e890dabde89b47$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $01e890dabde89b47$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $01e890dabde89b47$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($01e890dabde89b47$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $01e890dabde89b47$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $01e890dabde89b47$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $01e890dabde89b47$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $01e890dabde89b47$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $01e890dabde89b47$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $01e890dabde89b47$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $01e890dabde89b47$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $01e890dabde89b47$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $01e890dabde89b47$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $01e890dabde89b47$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $01e890dabde89b47$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$01e890dabde89b47$var$equals(a, b) && $01e890dabde89b47$var$intersects(a, p, p.next, b) && $01e890dabde89b47$var$locallyInside(a, b) && $01e890dabde89b47$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $01e890dabde89b47$var$removeNode(p);
            $01e890dabde89b47$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $01e890dabde89b47$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $01e890dabde89b47$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $01e890dabde89b47$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $01e890dabde89b47$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $01e890dabde89b47$var$filterPoints(a, a.next);
                c = $01e890dabde89b47$var$filterPoints(c, c.next);
                // run earcut on each half
                $01e890dabde89b47$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $01e890dabde89b47$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $01e890dabde89b47$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $01e890dabde89b47$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($01e890dabde89b47$var$getLeftmost(list));
    }
    queue.sort($01e890dabde89b47$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $01e890dabde89b47$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $01e890dabde89b47$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $01e890dabde89b47$var$eliminateHole(hole, outerNode) {
    const bridge = $01e890dabde89b47$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $01e890dabde89b47$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $01e890dabde89b47$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $01e890dabde89b47$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $01e890dabde89b47$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($01e890dabde89b47$var$equals(hole, p)) return p;
    do {
        if ($01e890dabde89b47$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $01e890dabde89b47$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($01e890dabde89b47$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $01e890dabde89b47$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $01e890dabde89b47$var$sectorContainsSector(m, p) {
    return $01e890dabde89b47$var$area(m.prev, m, p.prev) < 0 && $01e890dabde89b47$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $01e890dabde89b47$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $01e890dabde89b47$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $01e890dabde89b47$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $01e890dabde89b47$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $01e890dabde89b47$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $01e890dabde89b47$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $01e890dabde89b47$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $01e890dabde89b47$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $01e890dabde89b47$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $01e890dabde89b47$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$01e890dabde89b47$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($01e890dabde89b47$var$locallyInside(a, b) && $01e890dabde89b47$var$locallyInside(b, a) && $01e890dabde89b47$var$middleInside(a, b) && // locally visible
    ($01e890dabde89b47$var$area(a.prev, a, b.prev) || $01e890dabde89b47$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $01e890dabde89b47$var$equals(a, b) && $01e890dabde89b47$var$area(a.prev, a, a.next) > 0 && $01e890dabde89b47$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $01e890dabde89b47$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $01e890dabde89b47$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $01e890dabde89b47$var$intersects(p1, q1, p2, q2) {
    const o1 = $01e890dabde89b47$var$sign($01e890dabde89b47$var$area(p1, q1, p2));
    const o2 = $01e890dabde89b47$var$sign($01e890dabde89b47$var$area(p1, q1, q2));
    const o3 = $01e890dabde89b47$var$sign($01e890dabde89b47$var$area(p2, q2, p1));
    const o4 = $01e890dabde89b47$var$sign($01e890dabde89b47$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $01e890dabde89b47$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $01e890dabde89b47$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $01e890dabde89b47$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $01e890dabde89b47$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $01e890dabde89b47$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $01e890dabde89b47$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $01e890dabde89b47$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $01e890dabde89b47$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $01e890dabde89b47$var$locallyInside(a, b) {
    return $01e890dabde89b47$var$area(a.prev, a, a.next) < 0 ? $01e890dabde89b47$var$area(a, b, a.next) >= 0 && $01e890dabde89b47$var$area(a, a.prev, b) >= 0 : $01e890dabde89b47$var$area(a, b, a.prev) < 0 || $01e890dabde89b47$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $01e890dabde89b47$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $01e890dabde89b47$var$splitPolygon(a, b) {
    const a2 = $01e890dabde89b47$var$createNode(a.i, a.x, a.y), b2 = $01e890dabde89b47$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $01e890dabde89b47$var$insertNode(i, x, y, last) {
    const p = $01e890dabde89b47$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $01e890dabde89b47$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $01e890dabde89b47$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $01e890dabde89b47$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($01e890dabde89b47$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($01e890dabde89b47$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $01e890dabde89b47$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $01e890dabde89b47$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}


// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
function $4e93c82174f0b7ce$export$2e2bcd8739ae039() {
    return new $4e93c82174f0b7ce$var$Adder;
}
function $4e93c82174f0b7ce$var$Adder() {
    this.reset();
}
$4e93c82174f0b7ce$var$Adder.prototype = {
    constructor: $4e93c82174f0b7ce$var$Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        $4e93c82174f0b7ce$var$add($4e93c82174f0b7ce$var$temp, y, this.t);
        $4e93c82174f0b7ce$var$add(this, $4e93c82174f0b7ce$var$temp.s, this.s);
        if (this.s) this.t += $4e93c82174f0b7ce$var$temp.t;
        else this.s = $4e93c82174f0b7ce$var$temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var $4e93c82174f0b7ce$var$temp = new $4e93c82174f0b7ce$var$Adder;
function $4e93c82174f0b7ce$var$add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}


var $57fa69a7e776893c$export$6c421550c66a327d = 1e-6;
var $57fa69a7e776893c$export$92c06fba281fe81b = 1e-12;
var $57fa69a7e776893c$export$18c7bea995a110f = Math.PI;
var $57fa69a7e776893c$export$e51408a300e8929a = $57fa69a7e776893c$export$18c7bea995a110f / 2;
var $57fa69a7e776893c$export$c39a5cba78ea0fc2 = $57fa69a7e776893c$export$18c7bea995a110f / 4;
var $57fa69a7e776893c$export$a4b4b4d4d776fe92 = $57fa69a7e776893c$export$18c7bea995a110f * 2;
var $57fa69a7e776893c$export$41fc368e1a942b97 = 180 / $57fa69a7e776893c$export$18c7bea995a110f;
var $57fa69a7e776893c$export$8449e153fbd325fc = $57fa69a7e776893c$export$18c7bea995a110f / 180;
var $57fa69a7e776893c$export$2335f513bbd82c6d = Math.abs;
var $57fa69a7e776893c$export$628dc4eed22b0fbd = Math.atan;
var $57fa69a7e776893c$export$b8b770ee6a0d9760 = Math.atan2;
var $57fa69a7e776893c$export$50d414a77b60d802 = Math.cos;
var $57fa69a7e776893c$export$803ce6b71a0a94b2 = Math.ceil;
var $57fa69a7e776893c$export$b310ec824aaee37f = Math.exp;
var $57fa69a7e776893c$export$a3fe094919f356fd = Math.floor;
var $57fa69a7e776893c$export$bef1f36f5486a6a3 = Math.log;
var $57fa69a7e776893c$export$9c297f60e22e3389 = Math.pow;
var $57fa69a7e776893c$export$5de3937cb4b592ed = Math.sin;
var $57fa69a7e776893c$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $57fa69a7e776893c$export$eba8049fb5020b81 = Math.sqrt;
var $57fa69a7e776893c$export$fcdd3b0b3246a325 = Math.tan;
function $57fa69a7e776893c$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $57fa69a7e776893c$export$18c7bea995a110f : Math.acos(x);
}
function $57fa69a7e776893c$export$41726bdb1fc63f(x) {
    return x > 1 ? $57fa69a7e776893c$export$e51408a300e8929a : x < -1 ? -$57fa69a7e776893c$export$e51408a300e8929a : Math.asin(x);
}
function $57fa69a7e776893c$export$e808712c2966e662(x) {
    return (x = $57fa69a7e776893c$export$5de3937cb4b592ed(x / 2)) * x;
}


function $b28aa413bde10d03$export$2e2bcd8739ae039() {}


function $a9c4f90c46b9891b$var$streamGeometry(geometry, stream) {
    if (geometry && $a9c4f90c46b9891b$var$streamGeometryType.hasOwnProperty(geometry.type)) $a9c4f90c46b9891b$var$streamGeometryType[geometry.type](geometry, stream);
}
var $a9c4f90c46b9891b$var$streamObjectType = {
    Feature: function(object, stream) {
        $a9c4f90c46b9891b$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamGeometry(features[i].geometry, stream);
    }
};
var $a9c4f90c46b9891b$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $a9c4f90c46b9891b$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $a9c4f90c46b9891b$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamGeometry(geometries[i], stream);
    }
};
function $a9c4f90c46b9891b$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $a9c4f90c46b9891b$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$a9c4f90c46b9891b$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $a9c4f90c46b9891b$export$2e2bcd8739ae039(object, stream) {
    if (object && $a9c4f90c46b9891b$var$streamObjectType.hasOwnProperty(object.type)) $a9c4f90c46b9891b$var$streamObjectType[object.type](object, stream);
    else $a9c4f90c46b9891b$var$streamGeometry(object, stream);
}


var $90031fd84727d8f8$export$bf8f994332070c7f = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)();
var $90031fd84727d8f8$var$areaSum = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)(), $90031fd84727d8f8$var$lambda00, $90031fd84727d8f8$var$phi00, $90031fd84727d8f8$var$lambda0, $90031fd84727d8f8$var$cosPhi0, $90031fd84727d8f8$var$sinPhi0;
var $90031fd84727d8f8$export$cb67cfa750ae69dc = {
    point: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineStart: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    polygonStart: function() {
        $90031fd84727d8f8$export$bf8f994332070c7f.reset();
        $90031fd84727d8f8$export$cb67cfa750ae69dc.lineStart = $90031fd84727d8f8$var$areaRingStart;
        $90031fd84727d8f8$export$cb67cfa750ae69dc.lineEnd = $90031fd84727d8f8$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$90031fd84727d8f8$export$bf8f994332070c7f;
        $90031fd84727d8f8$var$areaSum.add(areaRing < 0 ? (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $b28aa413bde10d03$export$2e2bcd8739ae039);
    },
    sphere: function() {
        $90031fd84727d8f8$var$areaSum.add((0, $57fa69a7e776893c$export$a4b4b4d4d776fe92));
    }
};
function $90031fd84727d8f8$var$areaRingStart() {
    $90031fd84727d8f8$export$cb67cfa750ae69dc.point = $90031fd84727d8f8$var$areaPointFirst;
}
function $90031fd84727d8f8$var$areaRingEnd() {
    $90031fd84727d8f8$var$areaPoint($90031fd84727d8f8$var$lambda00, $90031fd84727d8f8$var$phi00);
}
function $90031fd84727d8f8$var$areaPointFirst(lambda, phi) {
    $90031fd84727d8f8$export$cb67cfa750ae69dc.point = $90031fd84727d8f8$var$areaPoint;
    $90031fd84727d8f8$var$lambda00 = lambda, $90031fd84727d8f8$var$phi00 = phi;
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    $90031fd84727d8f8$var$lambda0 = lambda, $90031fd84727d8f8$var$cosPhi0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi = phi / 2 + (0, $57fa69a7e776893c$export$c39a5cba78ea0fc2)), $90031fd84727d8f8$var$sinPhi0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi);
}
function $90031fd84727d8f8$var$areaPoint(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    phi = phi / 2 + (0, $57fa69a7e776893c$export$c39a5cba78ea0fc2); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $90031fd84727d8f8$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi), sinPhi = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), k = $90031fd84727d8f8$var$sinPhi0 * sinPhi, u = $90031fd84727d8f8$var$cosPhi0 * cosPhi + k * (0, $57fa69a7e776893c$export$50d414a77b60d802)(adLambda), v = k * sdLambda * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(adLambda);
    $90031fd84727d8f8$export$bf8f994332070c7f.add((0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(v, u));
    // Advance the previous points.
    $90031fd84727d8f8$var$lambda0 = lambda, $90031fd84727d8f8$var$cosPhi0 = cosPhi, $90031fd84727d8f8$var$sinPhi0 = sinPhi;
}
function $90031fd84727d8f8$export$2e2bcd8739ae039(object) {
    $90031fd84727d8f8$var$areaSum.reset();
    (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, $90031fd84727d8f8$export$cb67cfa750ae69dc);
    return $90031fd84727d8f8$var$areaSum * 2;
}





function $8f5c680d84651994$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $57fa69a7e776893c$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $8f5c680d84651994$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda),
        (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi)
    ];
}
function $8f5c680d84651994$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $8f5c680d84651994$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $8f5c680d84651994$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $8f5c680d84651994$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $8f5c680d84651994$export$6789498aec2cb34b(d) {
    var l = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}




var $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$phi0, $47339db63dfc5d6d$var$lambda1, $47339db63dfc5d6d$var$phi1, $47339db63dfc5d6d$var$lambda2, $47339db63dfc5d6d$var$lambda00, $47339db63dfc5d6d$var$phi00, $47339db63dfc5d6d$var$p0, $47339db63dfc5d6d$var$deltaSum = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)(), $47339db63dfc5d6d$var$ranges, $47339db63dfc5d6d$var$range;
var $47339db63dfc5d6d$var$boundsStream = {
    point: $47339db63dfc5d6d$var$boundsPoint,
    lineStart: $47339db63dfc5d6d$var$boundsLineStart,
    lineEnd: $47339db63dfc5d6d$var$boundsLineEnd,
    polygonStart: function() {
        $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$boundsRingPoint;
        $47339db63dfc5d6d$var$boundsStream.lineStart = $47339db63dfc5d6d$var$boundsRingStart;
        $47339db63dfc5d6d$var$boundsStream.lineEnd = $47339db63dfc5d6d$var$boundsRingEnd;
        $47339db63dfc5d6d$var$deltaSum.reset();
        (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).polygonStart();
    },
    polygonEnd: function() {
        (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).polygonEnd();
        $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$boundsPoint;
        $47339db63dfc5d6d$var$boundsStream.lineStart = $47339db63dfc5d6d$var$boundsLineStart;
        $47339db63dfc5d6d$var$boundsStream.lineEnd = $47339db63dfc5d6d$var$boundsLineEnd;
        if ((0, $90031fd84727d8f8$export$bf8f994332070c7f) < 0) $47339db63dfc5d6d$var$lambda0 = -($47339db63dfc5d6d$var$lambda1 = 180), $47339db63dfc5d6d$var$phi0 = -($47339db63dfc5d6d$var$phi1 = 90);
        else if ($47339db63dfc5d6d$var$deltaSum > (0, $57fa69a7e776893c$export$6c421550c66a327d)) $47339db63dfc5d6d$var$phi1 = 90;
        else if ($47339db63dfc5d6d$var$deltaSum < -(0, $57fa69a7e776893c$export$6c421550c66a327d)) $47339db63dfc5d6d$var$phi0 = -90;
        $47339db63dfc5d6d$var$range[0] = $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$range[1] = $47339db63dfc5d6d$var$lambda1;
    }
};
function $47339db63dfc5d6d$var$boundsPoint(lambda, phi) {
    $47339db63dfc5d6d$var$ranges.push($47339db63dfc5d6d$var$range = [
        $47339db63dfc5d6d$var$lambda0 = lambda,
        $47339db63dfc5d6d$var$lambda1 = lambda
    ]);
    if (phi < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phi;
    if (phi > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phi;
}
function $47339db63dfc5d6d$var$linePoint(lambda, phi) {
    var p = (0, $8f5c680d84651994$export$6e6697ef026a96)([
        lambda * (0, $57fa69a7e776893c$export$8449e153fbd325fc),
        phi * (0, $57fa69a7e776893c$export$8449e153fbd325fc)
    ]);
    if ($47339db63dfc5d6d$var$p0) {
        var normal = (0, $8f5c680d84651994$export$4763f5351b14293f)($47339db63dfc5d6d$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $8f5c680d84651994$export$4763f5351b14293f)(equatorial, normal);
        (0, $8f5c680d84651994$export$6789498aec2cb34b)(inflection);
        inflection = (0, $8f5c680d84651994$export$12f9ad44fe773943)(inflection);
        var delta = lambda - $47339db63dfc5d6d$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $57fa69a7e776893c$export$41fc368e1a942b97) * sign, phii, antimeridian = (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(delta) > 180;
        if (antimeridian ^ (sign * $47339db63dfc5d6d$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $57fa69a7e776893c$export$41fc368e1a942b97);
            if (phii > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $47339db63dfc5d6d$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $57fa69a7e776893c$export$41fc368e1a942b97);
            if (phii < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phii;
        } else {
            if (phi < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phi;
            if (phi > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $47339db63dfc5d6d$var$lambda2) {
                if ($47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, lambda) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda1 = lambda;
            } else if ($47339db63dfc5d6d$var$angle(lambda, $47339db63dfc5d6d$var$lambda1) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda0 = lambda;
        } else if ($47339db63dfc5d6d$var$lambda1 >= $47339db63dfc5d6d$var$lambda0) {
            if (lambda < $47339db63dfc5d6d$var$lambda0) $47339db63dfc5d6d$var$lambda0 = lambda;
            if (lambda > $47339db63dfc5d6d$var$lambda1) $47339db63dfc5d6d$var$lambda1 = lambda;
        } else {
            if (lambda > $47339db63dfc5d6d$var$lambda2) {
                if ($47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, lambda) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda1 = lambda;
            } else if ($47339db63dfc5d6d$var$angle(lambda, $47339db63dfc5d6d$var$lambda1) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda0 = lambda;
        }
    } else $47339db63dfc5d6d$var$ranges.push($47339db63dfc5d6d$var$range = [
        $47339db63dfc5d6d$var$lambda0 = lambda,
        $47339db63dfc5d6d$var$lambda1 = lambda
    ]);
    if (phi < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phi;
    if (phi > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phi;
    $47339db63dfc5d6d$var$p0 = p, $47339db63dfc5d6d$var$lambda2 = lambda;
}
function $47339db63dfc5d6d$var$boundsLineStart() {
    $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$linePoint;
}
function $47339db63dfc5d6d$var$boundsLineEnd() {
    $47339db63dfc5d6d$var$range[0] = $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$range[1] = $47339db63dfc5d6d$var$lambda1;
    $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$boundsPoint;
    $47339db63dfc5d6d$var$p0 = null;
}
function $47339db63dfc5d6d$var$boundsRingPoint(lambda, phi) {
    if ($47339db63dfc5d6d$var$p0) {
        var delta = lambda - $47339db63dfc5d6d$var$lambda2;
        $47339db63dfc5d6d$var$deltaSum.add((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $47339db63dfc5d6d$var$lambda00 = lambda, $47339db63dfc5d6d$var$phi00 = phi;
    (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).point(lambda, phi);
    $47339db63dfc5d6d$var$linePoint(lambda, phi);
}
function $47339db63dfc5d6d$var$boundsRingStart() {
    (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).lineStart();
}
function $47339db63dfc5d6d$var$boundsRingEnd() {
    $47339db63dfc5d6d$var$boundsRingPoint($47339db63dfc5d6d$var$lambda00, $47339db63dfc5d6d$var$phi00);
    (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).lineEnd();
    if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)($47339db63dfc5d6d$var$deltaSum) > (0, $57fa69a7e776893c$export$6c421550c66a327d)) $47339db63dfc5d6d$var$lambda0 = -($47339db63dfc5d6d$var$lambda1 = 180);
    $47339db63dfc5d6d$var$range[0] = $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$range[1] = $47339db63dfc5d6d$var$lambda1;
    $47339db63dfc5d6d$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $47339db63dfc5d6d$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $47339db63dfc5d6d$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $47339db63dfc5d6d$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $47339db63dfc5d6d$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $47339db63dfc5d6d$var$phi1 = $47339db63dfc5d6d$var$lambda1 = -($47339db63dfc5d6d$var$lambda0 = $47339db63dfc5d6d$var$phi0 = Infinity);
    $47339db63dfc5d6d$var$ranges = [];
    (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(feature, $47339db63dfc5d6d$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $47339db63dfc5d6d$var$ranges.length) {
        $47339db63dfc5d6d$var$ranges.sort($47339db63dfc5d6d$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $47339db63dfc5d6d$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $47339db63dfc5d6d$var$ranges[i];
            if ($47339db63dfc5d6d$var$rangeContains(a, b[0]) || $47339db63dfc5d6d$var$rangeContains(a, b[1])) {
                if ($47339db63dfc5d6d$var$angle(a[0], b[1]) > $47339db63dfc5d6d$var$angle(a[0], a[1])) a[1] = b[1];
                if ($47339db63dfc5d6d$var$angle(b[0], a[1]) > $47339db63dfc5d6d$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $47339db63dfc5d6d$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $47339db63dfc5d6d$var$lambda0 = b[0], $47339db63dfc5d6d$var$lambda1 = a[1];
        }
    }
    $47339db63dfc5d6d$var$ranges = $47339db63dfc5d6d$var$range = null;
    return $47339db63dfc5d6d$var$lambda0 === Infinity || $47339db63dfc5d6d$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $47339db63dfc5d6d$var$lambda0,
            $47339db63dfc5d6d$var$phi0
        ],
        [
            $47339db63dfc5d6d$var$lambda1,
            $47339db63dfc5d6d$var$phi1
        ]
    ];
}





var $29779f9da47b6057$var$W0, $29779f9da47b6057$var$W1, $29779f9da47b6057$var$X0, $29779f9da47b6057$var$Y0, $29779f9da47b6057$var$Z0, $29779f9da47b6057$var$X1, $29779f9da47b6057$var$Y1, $29779f9da47b6057$var$Z1, $29779f9da47b6057$var$X2, $29779f9da47b6057$var$Y2, $29779f9da47b6057$var$Z2, $29779f9da47b6057$var$lambda00, $29779f9da47b6057$var$phi00, $29779f9da47b6057$var$x0, $29779f9da47b6057$var$y0, $29779f9da47b6057$var$z0; // previous point
var $29779f9da47b6057$var$centroidStream = {
    sphere: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    point: $29779f9da47b6057$var$centroidPoint,
    lineStart: $29779f9da47b6057$var$centroidLineStart,
    lineEnd: $29779f9da47b6057$var$centroidLineEnd,
    polygonStart: function() {
        $29779f9da47b6057$var$centroidStream.lineStart = $29779f9da47b6057$var$centroidRingStart;
        $29779f9da47b6057$var$centroidStream.lineEnd = $29779f9da47b6057$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $29779f9da47b6057$var$centroidStream.lineStart = $29779f9da47b6057$var$centroidLineStart;
        $29779f9da47b6057$var$centroidStream.lineEnd = $29779f9da47b6057$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $29779f9da47b6057$var$centroidPoint(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    var cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi);
    $29779f9da47b6057$var$centroidPointCartesian(cosPhi * (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda), cosPhi * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda), (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi));
}
function $29779f9da47b6057$var$centroidPointCartesian(x, y, z) {
    ++$29779f9da47b6057$var$W0;
    $29779f9da47b6057$var$X0 += (x - $29779f9da47b6057$var$X0) / $29779f9da47b6057$var$W0;
    $29779f9da47b6057$var$Y0 += (y - $29779f9da47b6057$var$Y0) / $29779f9da47b6057$var$W0;
    $29779f9da47b6057$var$Z0 += (z - $29779f9da47b6057$var$Z0) / $29779f9da47b6057$var$W0;
}
function $29779f9da47b6057$var$centroidLineStart() {
    $29779f9da47b6057$var$centroidStream.point = $29779f9da47b6057$var$centroidLinePointFirst;
}
function $29779f9da47b6057$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    var cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi);
    $29779f9da47b6057$var$x0 = cosPhi * (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda);
    $29779f9da47b6057$var$y0 = cosPhi * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda);
    $29779f9da47b6057$var$z0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi);
    $29779f9da47b6057$var$centroidStream.point = $29779f9da47b6057$var$centroidLinePoint;
    $29779f9da47b6057$var$centroidPointCartesian($29779f9da47b6057$var$x0, $29779f9da47b6057$var$y0, $29779f9da47b6057$var$z0);
}
function $29779f9da47b6057$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    var cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi), x = cosPhi * (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda), z = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), w = (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)((0, $57fa69a7e776893c$export$eba8049fb5020b81)((w = $29779f9da47b6057$var$y0 * z - $29779f9da47b6057$var$z0 * y) * w + (w = $29779f9da47b6057$var$z0 * x - $29779f9da47b6057$var$x0 * z) * w + (w = $29779f9da47b6057$var$x0 * y - $29779f9da47b6057$var$y0 * x) * w), $29779f9da47b6057$var$x0 * x + $29779f9da47b6057$var$y0 * y + $29779f9da47b6057$var$z0 * z);
    $29779f9da47b6057$var$W1 += w;
    $29779f9da47b6057$var$X1 += w * ($29779f9da47b6057$var$x0 + ($29779f9da47b6057$var$x0 = x));
    $29779f9da47b6057$var$Y1 += w * ($29779f9da47b6057$var$y0 + ($29779f9da47b6057$var$y0 = y));
    $29779f9da47b6057$var$Z1 += w * ($29779f9da47b6057$var$z0 + ($29779f9da47b6057$var$z0 = z));
    $29779f9da47b6057$var$centroidPointCartesian($29779f9da47b6057$var$x0, $29779f9da47b6057$var$y0, $29779f9da47b6057$var$z0);
}
function $29779f9da47b6057$var$centroidLineEnd() {
    $29779f9da47b6057$var$centroidStream.point = $29779f9da47b6057$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $29779f9da47b6057$var$centroidRingStart() {
    $29779f9da47b6057$var$centroidStream.point = $29779f9da47b6057$var$centroidRingPointFirst;
}
function $29779f9da47b6057$var$centroidRingEnd() {
    $29779f9da47b6057$var$centroidRingPoint($29779f9da47b6057$var$lambda00, $29779f9da47b6057$var$phi00);
    $29779f9da47b6057$var$centroidStream.point = $29779f9da47b6057$var$centroidPoint;
}
function $29779f9da47b6057$var$centroidRingPointFirst(lambda, phi) {
    $29779f9da47b6057$var$lambda00 = lambda, $29779f9da47b6057$var$phi00 = phi;
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    $29779f9da47b6057$var$centroidStream.point = $29779f9da47b6057$var$centroidRingPoint;
    var cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi);
    $29779f9da47b6057$var$x0 = cosPhi * (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda);
    $29779f9da47b6057$var$y0 = cosPhi * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda);
    $29779f9da47b6057$var$z0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi);
    $29779f9da47b6057$var$centroidPointCartesian($29779f9da47b6057$var$x0, $29779f9da47b6057$var$y0, $29779f9da47b6057$var$z0);
}
function $29779f9da47b6057$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    var cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi), x = cosPhi * (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda), z = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), cx = $29779f9da47b6057$var$y0 * z - $29779f9da47b6057$var$z0 * y, cy = $29779f9da47b6057$var$z0 * x - $29779f9da47b6057$var$x0 * z, cz = $29779f9da47b6057$var$x0 * y - $29779f9da47b6057$var$y0 * x, m = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(cx * cx + cy * cy + cz * cz), w = (0, $57fa69a7e776893c$export$41726bdb1fc63f)(m), v = m && -w / m; // area weight multiplier
    $29779f9da47b6057$var$X2 += v * cx;
    $29779f9da47b6057$var$Y2 += v * cy;
    $29779f9da47b6057$var$Z2 += v * cz;
    $29779f9da47b6057$var$W1 += w;
    $29779f9da47b6057$var$X1 += w * ($29779f9da47b6057$var$x0 + ($29779f9da47b6057$var$x0 = x));
    $29779f9da47b6057$var$Y1 += w * ($29779f9da47b6057$var$y0 + ($29779f9da47b6057$var$y0 = y));
    $29779f9da47b6057$var$Z1 += w * ($29779f9da47b6057$var$z0 + ($29779f9da47b6057$var$z0 = z));
    $29779f9da47b6057$var$centroidPointCartesian($29779f9da47b6057$var$x0, $29779f9da47b6057$var$y0, $29779f9da47b6057$var$z0);
}
function $29779f9da47b6057$export$2e2bcd8739ae039(object) {
    $29779f9da47b6057$var$W0 = $29779f9da47b6057$var$W1 = $29779f9da47b6057$var$X0 = $29779f9da47b6057$var$Y0 = $29779f9da47b6057$var$Z0 = $29779f9da47b6057$var$X1 = $29779f9da47b6057$var$Y1 = $29779f9da47b6057$var$Z1 = $29779f9da47b6057$var$X2 = $29779f9da47b6057$var$Y2 = $29779f9da47b6057$var$Z2 = 0;
    (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, $29779f9da47b6057$var$centroidStream);
    var x = $29779f9da47b6057$var$X2, y = $29779f9da47b6057$var$Y2, z = $29779f9da47b6057$var$Z2, m = x * x + y * y + z * z;
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $57fa69a7e776893c$export$92c06fba281fe81b)) {
        x = $29779f9da47b6057$var$X1, y = $29779f9da47b6057$var$Y1, z = $29779f9da47b6057$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($29779f9da47b6057$var$W1 < (0, $57fa69a7e776893c$export$6c421550c66a327d)) x = $29779f9da47b6057$var$X0, y = $29779f9da47b6057$var$Y0, z = $29779f9da47b6057$var$Z0;
        m = x * x + y * y + z * z;
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $57fa69a7e776893c$export$92c06fba281fe81b)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(y, x) * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
        (0, $57fa69a7e776893c$export$41726bdb1fc63f)(z / (0, $57fa69a7e776893c$export$eba8049fb5020b81)(m)) * (0, $57fa69a7e776893c$export$41fc368e1a942b97)
    ];
}



function $01231a0c3b0e63df$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $a70f03bd57e4100b$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $cabb4367cc339c5f$var$rotationIdentity(lambda, phi) {
    return [
        lambda > (0, $57fa69a7e776893c$export$18c7bea995a110f) ? lambda - (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) : lambda < -(0, $57fa69a7e776893c$export$18c7bea995a110f) ? lambda + (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) : lambda,
        phi
    ];
}
$cabb4367cc339c5f$var$rotationIdentity.invert = $cabb4367cc339c5f$var$rotationIdentity;
function $cabb4367cc339c5f$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $a70f03bd57e4100b$export$2e2bcd8739ae039)($cabb4367cc339c5f$var$rotationLambda(deltaLambda), $cabb4367cc339c5f$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $cabb4367cc339c5f$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $cabb4367cc339c5f$var$rotationPhiGamma(deltaPhi, deltaGamma) : $cabb4367cc339c5f$var$rotationIdentity;
}
function $cabb4367cc339c5f$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $57fa69a7e776893c$export$18c7bea995a110f) ? lambda - (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) : lambda < -(0, $57fa69a7e776893c$export$18c7bea995a110f) ? lambda + (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) : lambda,
            phi
        ];
    };
}
function $cabb4367cc339c5f$var$rotationLambda(deltaLambda) {
    var rotation = $cabb4367cc339c5f$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $cabb4367cc339c5f$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $cabb4367cc339c5f$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $57fa69a7e776893c$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi), x = (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $57fa69a7e776893c$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi), x = (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $57fa69a7e776893c$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $cabb4367cc339c5f$export$2e2bcd8739ae039(rotate) {
    rotate = $cabb4367cc339c5f$export$a2ba89726971a90f(rotate[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), rotate[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $57fa69a7e776893c$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), coordinates[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $57fa69a7e776893c$export$41fc368e1a942b97), coordinates[1] *= (0, $57fa69a7e776893c$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), coordinates[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $57fa69a7e776893c$export$41fc368e1a942b97), coordinates[1] *= (0, $57fa69a7e776893c$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $e1f4ff990d6dc3b9$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $57fa69a7e776893c$export$50d414a77b60d802)(radius), sinRadius = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $e1f4ff990d6dc3b9$var$circleRadius(cosRadius, t0);
        t1 = $e1f4ff990d6dc3b9$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $8f5c680d84651994$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $57fa69a7e776893c$export$50d414a77b60d802)(t),
            -sinRadius * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $e1f4ff990d6dc3b9$var$circleRadius(cosRadius, point) {
    point = (0, $8f5c680d84651994$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $8f5c680d84651994$export$6789498aec2cb34b)(point);
    var radius = (0, $57fa69a7e776893c$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) - (0, $57fa69a7e776893c$export$6c421550c66a327d)) % (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92);
}
function $e1f4ff990d6dc3b9$export$2e2bcd8739ae039() {
    var center = (0, $01231a0c3b0e63df$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $01231a0c3b0e63df$export$2e2bcd8739ae039)(90), precision = (0, $01231a0c3b0e63df$export$2e2bcd8739ae039)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $57fa69a7e776893c$export$41fc368e1a942b97), x[1] *= (0, $57fa69a7e776893c$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $57fa69a7e776893c$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $57fa69a7e776893c$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $cabb4367cc339c5f$export$a2ba89726971a90f)(-c[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), -c[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), 0).invert;
        $e1f4ff990d6dc3b9$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $01231a0c3b0e63df$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $01231a0c3b0e63df$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $01231a0c3b0e63df$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}




function $ac6011926adf2566$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y) {
            line.push([
                x,
                y
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}


function $b24ee62b0b663046$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}



function $b4b49d647379bbd5$export$2e2bcd8739ae039(a, b) {
    return (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $57fa69a7e776893c$export$6c421550c66a327d) && (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $57fa69a7e776893c$export$6c421550c66a327d);
}


function $469a8f9f3658012b$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $469a8f9f3658012b$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        // If the first and last points of a segment are coincident, then treat as a
        // closed ring. TODO if all rings are closed, then the winding order of the
        // exterior ring should be checked.
        if ((0, $b4b49d647379bbd5$export$2e2bcd8739ae039)(p0, p1)) {
            stream.lineStart();
            for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
            stream.lineEnd();
            return;
        }
        subject.push(x = new $469a8f9f3658012b$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $469a8f9f3658012b$var$Intersection(p0, null, x, false));
        subject.push(x = new $469a8f9f3658012b$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $469a8f9f3658012b$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $469a8f9f3658012b$var$link(subject);
    $469a8f9f3658012b$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $469a8f9f3658012b$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}


function $a637b42241d00963$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $2a76de3914d63990$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $2a76de3914d63990$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $2a76de3914d63990$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $a637b42241d00963$export$2e2bcd8739ae039)(f(d), x);
    };
}


var $f073fb8802f6a1f5$var$ascendingBisect = (0, $2a76de3914d63990$export$2e2bcd8739ae039)((0, $a637b42241d00963$export$2e2bcd8739ae039));
var $f073fb8802f6a1f5$export$4d945ad3ad5751b0 = $f073fb8802f6a1f5$var$ascendingBisect.right;
var $f073fb8802f6a1f5$export$df7d25c84ebd12a5 = $f073fb8802f6a1f5$var$ascendingBisect.left;
var $f073fb8802f6a1f5$export$2e2bcd8739ae039 = $f073fb8802f6a1f5$export$4d945ad3ad5751b0;




function $31988c8aa68a6955$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $31988c8aa68a6955$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $31988c8aa68a6955$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}


function $4dae230799b5f259$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $31988c8aa68a6955$export$a04cb3fe8b81dd);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}


function $9668c234fddc7f0c$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $b621a5a11020ed4f$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}


function $a66b4823b485b0d4$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $b621a5a11020ed4f$export$2e2bcd8739ae039)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $b621a5a11020ed4f$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}


function $4141a7180413f6f7$export$2e2bcd8739ae039(array, f) {
    var v = (0, $a66b4823b485b0d4$export$2e2bcd8739ae039)(array, f);
    return v ? Math.sqrt(v) : v;
}


function $ef085f926875ebfd$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


var $216c6d70fd6183c0$var$array = Array.prototype;
var $216c6d70fd6183c0$export$58adb3bec8346d0f = $216c6d70fd6183c0$var$array.slice;
var $216c6d70fd6183c0$export$871de8747c9eaa88 = $216c6d70fd6183c0$var$array.map;



function $01ba6c41e9e9e133$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $d4aec01aea07d3c1$export$2e2bcd8739ae039(x) {
    return x;
}


function $d6985f2b5a1aa626$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


var $487dd0f9cbab3b32$var$e10 = Math.sqrt(50), $487dd0f9cbab3b32$var$e5 = Math.sqrt(10), $487dd0f9cbab3b32$var$e2 = Math.sqrt(2);
function $487dd0f9cbab3b32$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $487dd0f9cbab3b32$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $487dd0f9cbab3b32$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $487dd0f9cbab3b32$var$e10 ? 10 : error >= $487dd0f9cbab3b32$var$e5 ? 5 : error >= $487dd0f9cbab3b32$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $487dd0f9cbab3b32$var$e10 ? 10 : error >= $487dd0f9cbab3b32$var$e5 ? 5 : error >= $487dd0f9cbab3b32$var$e2 ? 2 : 1);
}
function $487dd0f9cbab3b32$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $487dd0f9cbab3b32$var$e10) step1 *= 10;
    else if (error >= $487dd0f9cbab3b32$var$e5) step1 *= 5;
    else if (error >= $487dd0f9cbab3b32$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $26e3fe1f2046d711$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}


function $ed95c1fa0d6eb1d5$export$2e2bcd8739ae039() {
    var value = (0, $d4aec01aea07d3c1$export$2e2bcd8739ae039), domain = (0, $ef085f926875ebfd$export$2e2bcd8739ae039), threshold = (0, $26e3fe1f2046d711$export$2e2bcd8739ae039);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $487dd0f9cbab3b32$export$81087d9b915d4ede)(x0, x1, tz);
            tz = (0, $d6985f2b5a1aa626$export$2e2bcd8739ae039)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $f073fb8802f6a1f5$export$2e2bcd8739ae039)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $01ba6c41e9e9e133$export$2e2bcd8739ae039)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $01ba6c41e9e9e133$export$2e2bcd8739ae039)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $01ba6c41e9e9e133$export$2e2bcd8739ae039)((0, $216c6d70fd6183c0$export$58adb3bec8346d0f).call(_)) : (0, $01ba6c41e9e9e133$export$2e2bcd8739ae039)(_), histogram) : threshold;
    };
    return histogram;
}






function $e981ebee257371cb$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $b621a5a11020ed4f$export$2e2bcd8739ae039);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}


function $a44e36e834f5e991$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $216c6d70fd6183c0$export$871de8747c9eaa88).call(values, (0, $b621a5a11020ed4f$export$2e2bcd8739ae039)).sort((0, $a637b42241d00963$export$2e2bcd8739ae039));
    return Math.ceil((max - min) / (2 * ((0, $e981ebee257371cb$export$2e2bcd8739ae039)(values, 0.75) - (0, $e981ebee257371cb$export$2e2bcd8739ae039)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}



function $e62b618ead3306d5$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $4141a7180413f6f7$export$2e2bcd8739ae039)(values) * Math.pow(values.length, -1 / 3)));
}



function $15b11d3f8c621b55$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}



function $f3d4701f0d8dc1f7$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $b621a5a11020ed4f$export$2e2bcd8739ae039)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $b621a5a11020ed4f$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}





function $70faaf0635b57a93$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $b621a5a11020ed4f$export$2e2bcd8739ae039)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $b621a5a11020ed4f$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $e981ebee257371cb$export$2e2bcd8739ae039)(numbers.sort((0, $a637b42241d00963$export$2e2bcd8739ae039)), 0.5);
}


function $cb98976747d597ae$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}


function $7c8b97da4c209fd2$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}



function $3fe4365e08c541b5$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}





function $ff85298a68fdfe2c$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $a637b42241d00963$export$2e2bcd8739ae039);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}


function $072f326684c606da$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}


function $417b216552794fc0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}




function $0de5234a098b8b0c$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $7c8b97da4c209fd2$export$2e2bcd8739ae039)(matrix, $0de5234a098b8b0c$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $0de5234a098b8b0c$var$length(d) {
    return d.length;
}




function $c5c7314067d46985$export$2e2bcd8739ae039() {
    return (0, $0de5234a098b8b0c$export$2e2bcd8739ae039)(arguments);
}




var $760d301b8ecb929a$var$clipMax = 1e9, $760d301b8ecb929a$var$clipMin = -$760d301b8ecb929a$var$clipMax;
function $760d301b8ecb929a$export$8948798bfea5de4f(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(p[0] - x0) < (0, $57fa69a7e776893c$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(p[0] - x1) < (0, $57fa69a7e776893c$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(p[1] - y0) < (0, $57fa69a7e776893c$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $ac6011926adf2566$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $cb98976747d597ae$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $469a8f9f3658012b$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($760d301b8ecb929a$var$clipMin, Math.min($760d301b8ecb929a$var$clipMax, x_)),
                    y_ = Math.max($760d301b8ecb929a$var$clipMin, Math.min($760d301b8ecb929a$var$clipMax, y_))
                ], b = [
                    x = Math.max($760d301b8ecb929a$var$clipMin, Math.min($760d301b8ecb929a$var$clipMax, x)),
                    y = Math.max($760d301b8ecb929a$var$clipMin, Math.min($760d301b8ecb929a$var$clipMax, y))
                ];
                if ((0, $b24ee62b0b663046$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}
function $760d301b8ecb929a$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = $760d301b8ecb929a$export$8948798bfea5de4f(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}





var $49235c8634d4c0ec$var$sum = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)();
function $49235c8634d4c0ec$export$2e2bcd8739ae039(polygon, point) {
    var lambda = point[0], phi = point[1], normal = [
        (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda),
        -(0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    $49235c8634d4c0ec$var$sum.reset();
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = point0[0], phi0 = point0[1] / 2 + (0, $57fa69a7e776893c$export$c39a5cba78ea0fc2), sinPhi0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = point1[0], phi1 = point1[1] / 2 + (0, $57fa69a7e776893c$export$c39a5cba78ea0fc2), sinPhi1 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $57fa69a7e776893c$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            $49235c8634d4c0ec$var$sum.add((0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(k * sign * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $57fa69a7e776893c$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $8f5c680d84651994$export$4763f5351b14293f)((0, $8f5c680d84651994$export$6e6697ef026a96)(point0), (0, $8f5c680d84651994$export$6e6697ef026a96)(point1));
                (0, $8f5c680d84651994$export$6789498aec2cb34b)(arc);
                var intersection = (0, $8f5c680d84651994$export$4763f5351b14293f)(normal, arc);
                (0, $8f5c680d84651994$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $57fa69a7e776893c$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $57fa69a7e776893c$export$6c421550c66a327d) || angle < (0, $57fa69a7e776893c$export$6c421550c66a327d) && $49235c8634d4c0ec$var$sum < -(0, $57fa69a7e776893c$export$6c421550c66a327d)) ^ winding & 1;
}






var $eecc246cf8c96db4$var$lengthSum = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)(), $eecc246cf8c96db4$var$lambda0, $eecc246cf8c96db4$var$sinPhi0, $eecc246cf8c96db4$var$cosPhi0;
var $eecc246cf8c96db4$var$lengthStream = {
    sphere: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    point: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineStart: $eecc246cf8c96db4$var$lengthLineStart,
    lineEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    polygonStart: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    polygonEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039)
};
function $eecc246cf8c96db4$var$lengthLineStart() {
    $eecc246cf8c96db4$var$lengthStream.point = $eecc246cf8c96db4$var$lengthPointFirst;
    $eecc246cf8c96db4$var$lengthStream.lineEnd = $eecc246cf8c96db4$var$lengthLineEnd;
}
function $eecc246cf8c96db4$var$lengthLineEnd() {
    $eecc246cf8c96db4$var$lengthStream.point = $eecc246cf8c96db4$var$lengthStream.lineEnd = (0, $b28aa413bde10d03$export$2e2bcd8739ae039);
}
function $eecc246cf8c96db4$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    $eecc246cf8c96db4$var$lambda0 = lambda, $eecc246cf8c96db4$var$sinPhi0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), $eecc246cf8c96db4$var$cosPhi0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi);
    $eecc246cf8c96db4$var$lengthStream.point = $eecc246cf8c96db4$var$lengthPoint;
}
function $eecc246cf8c96db4$var$lengthPoint(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    var sinPhi = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi), delta = (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(lambda - $eecc246cf8c96db4$var$lambda0), cosDelta = (0, $57fa69a7e776893c$export$50d414a77b60d802)(delta), sinDelta = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(delta), x = cosPhi * sinDelta, y = $eecc246cf8c96db4$var$cosPhi0 * sinPhi - $eecc246cf8c96db4$var$sinPhi0 * cosPhi * cosDelta, z = $eecc246cf8c96db4$var$sinPhi0 * sinPhi + $eecc246cf8c96db4$var$cosPhi0 * cosPhi * cosDelta;
    $eecc246cf8c96db4$var$lengthSum.add((0, $57fa69a7e776893c$export$b8b770ee6a0d9760)((0, $57fa69a7e776893c$export$eba8049fb5020b81)(x * x + y * y), z));
    $eecc246cf8c96db4$var$lambda0 = lambda, $eecc246cf8c96db4$var$sinPhi0 = sinPhi, $eecc246cf8c96db4$var$cosPhi0 = cosPhi;
}
function $eecc246cf8c96db4$export$2e2bcd8739ae039(object) {
    $eecc246cf8c96db4$var$lengthSum.reset();
    (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, $eecc246cf8c96db4$var$lengthStream);
    return +$eecc246cf8c96db4$var$lengthSum;
}


var $6c415952b39ab5fa$var$coordinates = [
    null,
    null
], $6c415952b39ab5fa$var$object = {
    type: "LineString",
    coordinates: $6c415952b39ab5fa$var$coordinates
};
function $6c415952b39ab5fa$export$2e2bcd8739ae039(a, b) {
    $6c415952b39ab5fa$var$coordinates[0] = a;
    $6c415952b39ab5fa$var$coordinates[1] = b;
    return (0, $eecc246cf8c96db4$export$2e2bcd8739ae039)($6c415952b39ab5fa$var$object);
}



var $6e5a5e162e462412$var$containsObjectType = {
    Feature: function(object, point) {
        return $6e5a5e162e462412$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($6e5a5e162e462412$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $6e5a5e162e462412$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $6e5a5e162e462412$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($6e5a5e162e462412$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $6e5a5e162e462412$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($6e5a5e162e462412$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $6e5a5e162e462412$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($6e5a5e162e462412$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($6e5a5e162e462412$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $6e5a5e162e462412$var$containsGeometry(geometry, point) {
    return geometry && $6e5a5e162e462412$var$containsGeometryType.hasOwnProperty(geometry.type) ? $6e5a5e162e462412$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $6e5a5e162e462412$var$containsPoint(coordinates, point) {
    return (0, $6c415952b39ab5fa$export$2e2bcd8739ae039)(coordinates, point) === 0;
}
function $6e5a5e162e462412$var$containsLine(coordinates, point) {
    var ab = (0, $6c415952b39ab5fa$export$2e2bcd8739ae039)(coordinates[0], coordinates[1]), ao = (0, $6c415952b39ab5fa$export$2e2bcd8739ae039)(coordinates[0], point), ob = (0, $6c415952b39ab5fa$export$2e2bcd8739ae039)(point, coordinates[1]);
    return ao + ob <= ab + (0, $57fa69a7e776893c$export$6c421550c66a327d);
}
function $6e5a5e162e462412$var$containsPolygon(coordinates, point) {
    return !!(0, $49235c8634d4c0ec$export$2e2bcd8739ae039)(coordinates.map($6e5a5e162e462412$var$ringRadians), $6e5a5e162e462412$var$pointRadians(point));
}
function $6e5a5e162e462412$var$ringRadians(ring) {
    return ring = ring.map($6e5a5e162e462412$var$pointRadians), ring.pop(), ring;
}
function $6e5a5e162e462412$var$pointRadians(point) {
    return [
        point[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc),
        point[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc)
    ];
}
function $6e5a5e162e462412$export$2e2bcd8739ae039(object, point) {
    return (object && $6e5a5e162e462412$var$containsObjectType.hasOwnProperty(object.type) ? $6e5a5e162e462412$var$containsObjectType[object.type] : $6e5a5e162e462412$var$containsGeometry)(object, point);
}





function $bac87777285f7edb$var$graticuleX(y0, y1, dy) {
    var y = (0, $d6985f2b5a1aa626$export$2e2bcd8739ae039)(y0, y1 - (0, $57fa69a7e776893c$export$6c421550c66a327d), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $bac87777285f7edb$var$graticuleY(x0, x1, dx) {
    var x = (0, $d6985f2b5a1aa626$export$2e2bcd8739ae039)(x0, x1 - (0, $57fa69a7e776893c$export$6c421550c66a327d), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $bac87777285f7edb$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $d6985f2b5a1aa626$export$2e2bcd8739ae039)((0, $57fa69a7e776893c$export$803ce6b71a0a94b2)(X0 / DX) * DX, X1, DX).map(X).concat((0, $d6985f2b5a1aa626$export$2e2bcd8739ae039)((0, $57fa69a7e776893c$export$803ce6b71a0a94b2)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $d6985f2b5a1aa626$export$2e2bcd8739ae039)((0, $57fa69a7e776893c$export$803ce6b71a0a94b2)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(x % DX) > (0, $57fa69a7e776893c$export$6c421550c66a327d);
        }).map(x)).concat((0, $d6985f2b5a1aa626$export$2e2bcd8739ae039)((0, $57fa69a7e776893c$export$803ce6b71a0a94b2)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(y % DY) > (0, $57fa69a7e776893c$export$6c421550c66a327d);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $bac87777285f7edb$var$graticuleX(y0, y1, 90);
        y = $bac87777285f7edb$var$graticuleY(x0, x1, precision);
        X = $bac87777285f7edb$var$graticuleX(Y0, Y1, 90);
        Y = $bac87777285f7edb$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $57fa69a7e776893c$export$6c421550c66a327d)
        ],
        [
            180,
            90 - (0, $57fa69a7e776893c$export$6c421550c66a327d)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $57fa69a7e776893c$export$6c421550c66a327d)
        ],
        [
            180,
            80 + (0, $57fa69a7e776893c$export$6c421550c66a327d)
        ]
    ]);
}
function $bac87777285f7edb$export$b8db4e9403a5b6f1() {
    return $bac87777285f7edb$export$2e2bcd8739ae039()();
}



function $40adbe455568c340$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), y0 = a[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), x1 = b[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), y1 = b[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), cy0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(y0), sy0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y0), cy1 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(y1), sy1 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y1), kx0 = cy0 * (0, $57fa69a7e776893c$export$50d414a77b60d802)(x0), ky0 = cy0 * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(x0), kx1 = cy1 * (0, $57fa69a7e776893c$export$50d414a77b60d802)(x1), ky1 = cy1 * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(x1), d = 2 * (0, $57fa69a7e776893c$export$41726bdb1fc63f)((0, $57fa69a7e776893c$export$eba8049fb5020b81)((0, $57fa69a7e776893c$export$e808712c2966e662)(y1 - y0) + cy0 * cy1 * (0, $57fa69a7e776893c$export$e808712c2966e662)(x1 - x0))), k = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(d);
    var interpolate = d ? function(t) {
        var B = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(t *= d) / k, A = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(y, x) * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(z, (0, $57fa69a7e776893c$export$eba8049fb5020b81)(x * x + y * y)) * (0, $57fa69a7e776893c$export$41fc368e1a942b97)
        ];
    } : function() {
        return [
            x0 * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
            y0 * (0, $57fa69a7e776893c$export$41fc368e1a942b97)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}



function $12ca6452a9242546$export$2e2bcd8739ae039(x) {
    return x;
}






var $5df02d2f69cce112$var$areaSum = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)(), $5df02d2f69cce112$var$areaRingSum = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)(), $5df02d2f69cce112$var$x00, $5df02d2f69cce112$var$y00, $5df02d2f69cce112$var$x0, $5df02d2f69cce112$var$y0;
var $5df02d2f69cce112$var$areaStream = {
    point: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineStart: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    polygonStart: function() {
        $5df02d2f69cce112$var$areaStream.lineStart = $5df02d2f69cce112$var$areaRingStart;
        $5df02d2f69cce112$var$areaStream.lineEnd = $5df02d2f69cce112$var$areaRingEnd;
    },
    polygonEnd: function() {
        $5df02d2f69cce112$var$areaStream.lineStart = $5df02d2f69cce112$var$areaStream.lineEnd = $5df02d2f69cce112$var$areaStream.point = (0, $b28aa413bde10d03$export$2e2bcd8739ae039);
        $5df02d2f69cce112$var$areaSum.add((0, $57fa69a7e776893c$export$2335f513bbd82c6d)($5df02d2f69cce112$var$areaRingSum));
        $5df02d2f69cce112$var$areaRingSum.reset();
    },
    result: function() {
        var area = $5df02d2f69cce112$var$areaSum / 2;
        $5df02d2f69cce112$var$areaSum.reset();
        return area;
    }
};
function $5df02d2f69cce112$var$areaRingStart() {
    $5df02d2f69cce112$var$areaStream.point = $5df02d2f69cce112$var$areaPointFirst;
}
function $5df02d2f69cce112$var$areaPointFirst(x, y) {
    $5df02d2f69cce112$var$areaStream.point = $5df02d2f69cce112$var$areaPoint;
    $5df02d2f69cce112$var$x00 = $5df02d2f69cce112$var$x0 = x, $5df02d2f69cce112$var$y00 = $5df02d2f69cce112$var$y0 = y;
}
function $5df02d2f69cce112$var$areaPoint(x, y) {
    $5df02d2f69cce112$var$areaRingSum.add($5df02d2f69cce112$var$y0 * x - $5df02d2f69cce112$var$x0 * y);
    $5df02d2f69cce112$var$x0 = x, $5df02d2f69cce112$var$y0 = y;
}
function $5df02d2f69cce112$var$areaRingEnd() {
    $5df02d2f69cce112$var$areaPoint($5df02d2f69cce112$var$x00, $5df02d2f69cce112$var$y00);
}
var $5df02d2f69cce112$export$2e2bcd8739ae039 = $5df02d2f69cce112$var$areaStream;



var $d0d3ed45b07b0be3$var$x0 = Infinity, $d0d3ed45b07b0be3$var$y0 = $d0d3ed45b07b0be3$var$x0, $d0d3ed45b07b0be3$var$x1 = -$d0d3ed45b07b0be3$var$x0, $d0d3ed45b07b0be3$var$y1 = $d0d3ed45b07b0be3$var$x1;
var $d0d3ed45b07b0be3$var$boundsStream = {
    point: $d0d3ed45b07b0be3$var$boundsPoint,
    lineStart: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    polygonStart: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    polygonEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $d0d3ed45b07b0be3$var$x0,
                $d0d3ed45b07b0be3$var$y0
            ],
            [
                $d0d3ed45b07b0be3$var$x1,
                $d0d3ed45b07b0be3$var$y1
            ]
        ];
        $d0d3ed45b07b0be3$var$x1 = $d0d3ed45b07b0be3$var$y1 = -($d0d3ed45b07b0be3$var$y0 = $d0d3ed45b07b0be3$var$x0 = Infinity);
        return bounds;
    }
};
function $d0d3ed45b07b0be3$var$boundsPoint(x, y) {
    if (x < $d0d3ed45b07b0be3$var$x0) $d0d3ed45b07b0be3$var$x0 = x;
    if (x > $d0d3ed45b07b0be3$var$x1) $d0d3ed45b07b0be3$var$x1 = x;
    if (y < $d0d3ed45b07b0be3$var$y0) $d0d3ed45b07b0be3$var$y0 = y;
    if (y > $d0d3ed45b07b0be3$var$y1) $d0d3ed45b07b0be3$var$y1 = y;
}
var $d0d3ed45b07b0be3$export$2e2bcd8739ae039 = $d0d3ed45b07b0be3$var$boundsStream;



// TODO Enforce positive area for exterior, negative area for interior?
var $df73b5500e7eacc3$var$X0 = 0, $df73b5500e7eacc3$var$Y0 = 0, $df73b5500e7eacc3$var$Z0 = 0, $df73b5500e7eacc3$var$X1 = 0, $df73b5500e7eacc3$var$Y1 = 0, $df73b5500e7eacc3$var$Z1 = 0, $df73b5500e7eacc3$var$X2 = 0, $df73b5500e7eacc3$var$Y2 = 0, $df73b5500e7eacc3$var$Z2 = 0, $df73b5500e7eacc3$var$x00, $df73b5500e7eacc3$var$y00, $df73b5500e7eacc3$var$x0, $df73b5500e7eacc3$var$y0;
var $df73b5500e7eacc3$var$centroidStream = {
    point: $df73b5500e7eacc3$var$centroidPoint,
    lineStart: $df73b5500e7eacc3$var$centroidLineStart,
    lineEnd: $df73b5500e7eacc3$var$centroidLineEnd,
    polygonStart: function() {
        $df73b5500e7eacc3$var$centroidStream.lineStart = $df73b5500e7eacc3$var$centroidRingStart;
        $df73b5500e7eacc3$var$centroidStream.lineEnd = $df73b5500e7eacc3$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $df73b5500e7eacc3$var$centroidStream.point = $df73b5500e7eacc3$var$centroidPoint;
        $df73b5500e7eacc3$var$centroidStream.lineStart = $df73b5500e7eacc3$var$centroidLineStart;
        $df73b5500e7eacc3$var$centroidStream.lineEnd = $df73b5500e7eacc3$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $df73b5500e7eacc3$var$Z2 ? [
            $df73b5500e7eacc3$var$X2 / $df73b5500e7eacc3$var$Z2,
            $df73b5500e7eacc3$var$Y2 / $df73b5500e7eacc3$var$Z2
        ] : $df73b5500e7eacc3$var$Z1 ? [
            $df73b5500e7eacc3$var$X1 / $df73b5500e7eacc3$var$Z1,
            $df73b5500e7eacc3$var$Y1 / $df73b5500e7eacc3$var$Z1
        ] : $df73b5500e7eacc3$var$Z0 ? [
            $df73b5500e7eacc3$var$X0 / $df73b5500e7eacc3$var$Z0,
            $df73b5500e7eacc3$var$Y0 / $df73b5500e7eacc3$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $df73b5500e7eacc3$var$X0 = $df73b5500e7eacc3$var$Y0 = $df73b5500e7eacc3$var$Z0 = $df73b5500e7eacc3$var$X1 = $df73b5500e7eacc3$var$Y1 = $df73b5500e7eacc3$var$Z1 = $df73b5500e7eacc3$var$X2 = $df73b5500e7eacc3$var$Y2 = $df73b5500e7eacc3$var$Z2 = 0;
        return centroid;
    }
};
function $df73b5500e7eacc3$var$centroidPoint(x, y) {
    $df73b5500e7eacc3$var$X0 += x;
    $df73b5500e7eacc3$var$Y0 += y;
    ++$df73b5500e7eacc3$var$Z0;
}
function $df73b5500e7eacc3$var$centroidLineStart() {
    $df73b5500e7eacc3$var$centroidStream.point = $df73b5500e7eacc3$var$centroidPointFirstLine;
}
function $df73b5500e7eacc3$var$centroidPointFirstLine(x, y) {
    $df73b5500e7eacc3$var$centroidStream.point = $df73b5500e7eacc3$var$centroidPointLine;
    $df73b5500e7eacc3$var$centroidPoint($df73b5500e7eacc3$var$x0 = x, $df73b5500e7eacc3$var$y0 = y);
}
function $df73b5500e7eacc3$var$centroidPointLine(x, y) {
    var dx = x - $df73b5500e7eacc3$var$x0, dy = y - $df73b5500e7eacc3$var$y0, z = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $df73b5500e7eacc3$var$X1 += z * ($df73b5500e7eacc3$var$x0 + x) / 2;
    $df73b5500e7eacc3$var$Y1 += z * ($df73b5500e7eacc3$var$y0 + y) / 2;
    $df73b5500e7eacc3$var$Z1 += z;
    $df73b5500e7eacc3$var$centroidPoint($df73b5500e7eacc3$var$x0 = x, $df73b5500e7eacc3$var$y0 = y);
}
function $df73b5500e7eacc3$var$centroidLineEnd() {
    $df73b5500e7eacc3$var$centroidStream.point = $df73b5500e7eacc3$var$centroidPoint;
}
function $df73b5500e7eacc3$var$centroidRingStart() {
    $df73b5500e7eacc3$var$centroidStream.point = $df73b5500e7eacc3$var$centroidPointFirstRing;
}
function $df73b5500e7eacc3$var$centroidRingEnd() {
    $df73b5500e7eacc3$var$centroidPointRing($df73b5500e7eacc3$var$x00, $df73b5500e7eacc3$var$y00);
}
function $df73b5500e7eacc3$var$centroidPointFirstRing(x, y) {
    $df73b5500e7eacc3$var$centroidStream.point = $df73b5500e7eacc3$var$centroidPointRing;
    $df73b5500e7eacc3$var$centroidPoint($df73b5500e7eacc3$var$x00 = $df73b5500e7eacc3$var$x0 = x, $df73b5500e7eacc3$var$y00 = $df73b5500e7eacc3$var$y0 = y);
}
function $df73b5500e7eacc3$var$centroidPointRing(x, y) {
    var dx = x - $df73b5500e7eacc3$var$x0, dy = y - $df73b5500e7eacc3$var$y0, z = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $df73b5500e7eacc3$var$X1 += z * ($df73b5500e7eacc3$var$x0 + x) / 2;
    $df73b5500e7eacc3$var$Y1 += z * ($df73b5500e7eacc3$var$y0 + y) / 2;
    $df73b5500e7eacc3$var$Z1 += z;
    z = $df73b5500e7eacc3$var$y0 * x - $df73b5500e7eacc3$var$x0 * y;
    $df73b5500e7eacc3$var$X2 += z * ($df73b5500e7eacc3$var$x0 + x);
    $df73b5500e7eacc3$var$Y2 += z * ($df73b5500e7eacc3$var$y0 + y);
    $df73b5500e7eacc3$var$Z2 += z * 3;
    $df73b5500e7eacc3$var$centroidPoint($df73b5500e7eacc3$var$x0 = x, $df73b5500e7eacc3$var$y0 = y);
}
var $df73b5500e7eacc3$export$2e2bcd8739ae039 = $df73b5500e7eacc3$var$centroidStream;




function $85c4323c793ebcf2$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$85c4323c793ebcf2$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $b28aa413bde10d03$export$2e2bcd8739ae039)
};





var $c9fc6c8cc8776d8d$var$lengthSum = (0, $4e93c82174f0b7ce$export$2e2bcd8739ae039)(), $c9fc6c8cc8776d8d$var$lengthRing, $c9fc6c8cc8776d8d$var$x00, $c9fc6c8cc8776d8d$var$y00, $c9fc6c8cc8776d8d$var$x0, $c9fc6c8cc8776d8d$var$y0;
var $c9fc6c8cc8776d8d$var$lengthStream = {
    point: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineStart: function() {
        $c9fc6c8cc8776d8d$var$lengthStream.point = $c9fc6c8cc8776d8d$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($c9fc6c8cc8776d8d$var$lengthRing) $c9fc6c8cc8776d8d$var$lengthPoint($c9fc6c8cc8776d8d$var$x00, $c9fc6c8cc8776d8d$var$y00);
        $c9fc6c8cc8776d8d$var$lengthStream.point = (0, $b28aa413bde10d03$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $c9fc6c8cc8776d8d$var$lengthRing = true;
    },
    polygonEnd: function() {
        $c9fc6c8cc8776d8d$var$lengthRing = null;
    },
    result: function() {
        var length = +$c9fc6c8cc8776d8d$var$lengthSum;
        $c9fc6c8cc8776d8d$var$lengthSum.reset();
        return length;
    }
};
function $c9fc6c8cc8776d8d$var$lengthPointFirst(x, y) {
    $c9fc6c8cc8776d8d$var$lengthStream.point = $c9fc6c8cc8776d8d$var$lengthPoint;
    $c9fc6c8cc8776d8d$var$x00 = $c9fc6c8cc8776d8d$var$x0 = x, $c9fc6c8cc8776d8d$var$y00 = $c9fc6c8cc8776d8d$var$y0 = y;
}
function $c9fc6c8cc8776d8d$var$lengthPoint(x, y) {
    $c9fc6c8cc8776d8d$var$x0 -= x, $c9fc6c8cc8776d8d$var$y0 -= y;
    $c9fc6c8cc8776d8d$var$lengthSum.add((0, $57fa69a7e776893c$export$eba8049fb5020b81)($c9fc6c8cc8776d8d$var$x0 * $c9fc6c8cc8776d8d$var$x0 + $c9fc6c8cc8776d8d$var$y0 * $c9fc6c8cc8776d8d$var$y0));
    $c9fc6c8cc8776d8d$var$x0 = x, $c9fc6c8cc8776d8d$var$y0 = y;
}
var $c9fc6c8cc8776d8d$export$2e2bcd8739ae039 = $c9fc6c8cc8776d8d$var$lengthStream;


function $bcdac7a19792d2c9$export$2e2bcd8739ae039() {
    this._string = [];
}
$bcdac7a19792d2c9$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $bcdac7a19792d2c9$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $bcdac7a19792d2c9$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $bcdac7a19792d2c9$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}


function $6bf13192c901061f$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, projectionStream((0, $5df02d2f69cce112$export$2e2bcd8739ae039)));
        return (0, $5df02d2f69cce112$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, projectionStream((0, $c9fc6c8cc8776d8d$export$2e2bcd8739ae039)));
        return (0, $c9fc6c8cc8776d8d$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, projectionStream((0, $d0d3ed45b07b0be3$export$2e2bcd8739ae039)));
        return (0, $d0d3ed45b07b0be3$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, projectionStream((0, $df73b5500e7eacc3$export$2e2bcd8739ae039)));
        return (0, $df73b5500e7eacc3$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $12ca6452a9242546$export$2e2bcd8739ae039) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $bcdac7a19792d2c9$export$2e2bcd8739ae039)) : new (0, $85c4323c793ebcf2$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}









function $c5e32e4d8549d1ba$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(rotate, sink) {
        var line = clipLine(sink), rotatedStart = rotate.invert(start[0], start[1]), ringBuffer = (0, $ac6011926adf2566$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $cb98976747d597ae$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $49235c8634d4c0ec$export$2e2bcd8739ae039)(polygon, rotatedStart);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $469a8f9f3658012b$export$2e2bcd8739ae039)(segments, $c5e32e4d8549d1ba$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            var point = rotate(lambda, phi);
            if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            var point = rotate(lambda, phi);
            line.point(point[0], point[1]);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            var point = rotate(lambda, phi);
            ringSink.point(point[0], point[1]);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($c5e32e4d8549d1ba$var$validSegment));
        }
        return clip;
    };
}
function $c5e32e4d8549d1ba$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $c5e32e4d8549d1ba$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $57fa69a7e776893c$export$e51408a300e8929a) - (0, $57fa69a7e776893c$export$6c421550c66a327d) : (0, $57fa69a7e776893c$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $57fa69a7e776893c$export$e51408a300e8929a) - (0, $57fa69a7e776893c$export$6c421550c66a327d) : (0, $57fa69a7e776893c$export$e51408a300e8929a) - b[1]);
}



var $86910d36118c8f11$export$2e2bcd8739ae039 = (0, $c5e32e4d8549d1ba$export$2e2bcd8739ae039)(function() {
    return true;
}, $86910d36118c8f11$var$clipAntimeridianLine, $86910d36118c8f11$var$clipAntimeridianInterpolate, [
    -(0, $57fa69a7e776893c$export$18c7bea995a110f),
    -(0, $57fa69a7e776893c$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $86910d36118c8f11$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $57fa69a7e776893c$export$18c7bea995a110f) : -(0, $57fa69a7e776893c$export$18c7bea995a110f), delta = (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(delta - (0, $57fa69a7e776893c$export$18c7bea995a110f)) < (0, $57fa69a7e776893c$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $57fa69a7e776893c$export$e51408a300e8929a) : -(0, $57fa69a7e776893c$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $57fa69a7e776893c$export$18c7bea995a110f)) {
                if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $57fa69a7e776893c$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $57fa69a7e776893c$export$6c421550c66a327d); // handle degeneracies
                if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $57fa69a7e776893c$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $57fa69a7e776893c$export$6c421550c66a327d);
                phi0 = $86910d36118c8f11$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $86910d36118c8f11$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $57fa69a7e776893c$export$6c421550c66a327d) ? (0, $57fa69a7e776893c$export$628dc4eed22b0fbd)(((0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi1)) * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda1) - (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi0)) * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $86910d36118c8f11$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $57fa69a7e776893c$export$e51408a300e8929a);
        stream.point(-(0, $57fa69a7e776893c$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $57fa69a7e776893c$export$18c7bea995a110f), phi);
        stream.point((0, $57fa69a7e776893c$export$18c7bea995a110f), 0);
        stream.point((0, $57fa69a7e776893c$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $57fa69a7e776893c$export$18c7bea995a110f), -phi);
        stream.point(-(0, $57fa69a7e776893c$export$18c7bea995a110f), 0);
        stream.point(-(0, $57fa69a7e776893c$export$18c7bea995a110f), phi);
    } else if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $57fa69a7e776893c$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $57fa69a7e776893c$export$18c7bea995a110f) : -(0, $57fa69a7e776893c$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}







function $96cd47fc397b0c50$export$2e2bcd8739ae039(radius, delta) {
    var cr = (0, $57fa69a7e776893c$export$50d414a77b60d802)(radius), smallRadius = cr > 0, notHemisphere = (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(cr) > (0, $57fa69a7e776893c$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $e1f4ff990d6dc3b9$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda) * (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $57fa69a7e776893c$export$18c7bea995a110f) : -(0, $57fa69a7e776893c$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                // Handle degeneracies.
                // TODO ignore if not clipping polygons.
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $b4b49d647379bbd5$export$2e2bcd8739ae039)(point0, point2) || (0, $b4b49d647379bbd5$export$2e2bcd8739ae039)(point1, point2)) {
                        point1[0] += (0, $57fa69a7e776893c$export$6c421550c66a327d);
                        point1[1] += (0, $57fa69a7e776893c$export$6c421550c66a327d);
                        v = visible(point1[0], point1[1]);
                    }
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1]);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                        }
                    }
                }
                if (v && (!point0 || !(0, $b4b49d647379bbd5$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $8f5c680d84651994$export$6e6697ef026a96)(a), pb = (0, $8f5c680d84651994$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $8f5c680d84651994$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $8f5c680d84651994$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $8f5c680d84651994$export$4763f5351b14293f)(n1, n2), A = (0, $8f5c680d84651994$export$52d0ee3fc868d452)(n1, c1), B = (0, $8f5c680d84651994$export$52d0ee3fc868d452)(n2, c2);
        (0, $8f5c680d84651994$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $8f5c680d84651994$export$2ef80f51436a9de9)(A, u), uu = (0, $8f5c680d84651994$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $8f5c680d84651994$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(t2), q = (0, $8f5c680d84651994$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $8f5c680d84651994$export$e62eba72fc898eae)(q, A);
        q = (0, $8f5c680d84651994$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(delta - (0, $57fa69a7e776893c$export$18c7bea995a110f)) < (0, $57fa69a7e776893c$export$6c421550c66a327d), meridian = polar || delta < (0, $57fa69a7e776893c$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $57fa69a7e776893c$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $57fa69a7e776893c$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $8f5c680d84651994$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $8f5c680d84651994$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $8f5c680d84651994$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $57fa69a7e776893c$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $c5e32e4d8549d1ba$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $57fa69a7e776893c$export$18c7bea995a110f),
        radius - (0, $57fa69a7e776893c$export$18c7bea995a110f)
    ]);
}







function $4d93b99739cfac8a$export$2e2bcd8739ae039(methods) {
    return {
        stream: $4d93b99739cfac8a$export$6b468dcfb64c653c(methods)
    };
}
function $4d93b99739cfac8a$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $4d93b99739cfac8a$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $4d93b99739cfac8a$var$TransformStream() {}
$4d93b99739cfac8a$var$TransformStream.prototype = {
    constructor: $4d93b99739cfac8a$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};




function $07313ceef512d765$export$e450184041869e7f(projection, extent, object) {
    var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, projection.stream((0, $d0d3ed45b07b0be3$export$2e2bcd8739ae039)));
    var b = (0, $d0d3ed45b07b0be3$export$2e2bcd8739ae039).result(), k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    if (clip != null) projection.clipExtent(clip);
    return projection.scale(k * 150).translate([
        x,
        y
    ]);
}
function $07313ceef512d765$export$33a367fa1728c3ba(projection, size, object) {
    return $07313ceef512d765$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}





var $9bc706961357efff$var$maxDepth = 16, $9bc706961357efff$var$cosMinDistance = (0, $57fa69a7e776893c$export$50d414a77b60d802)(30 * (0, $57fa69a7e776893c$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $9bc706961357efff$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $9bc706961357efff$var$resample(project, delta2) : $9bc706961357efff$var$resampleNone(project);
}
function $9bc706961357efff$var$resampleNone(project) {
    return (0, $4d93b99739cfac8a$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $9bc706961357efff$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $57fa69a7e776893c$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $57fa69a7e776893c$export$2335f513bbd82c6d)((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(c) - 1) < (0, $57fa69a7e776893c$export$6c421550c66a327d) || (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $57fa69a7e776893c$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $57fa69a7e776893c$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $9bc706961357efff$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $8f5c680d84651994$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $9bc706961357efff$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $9bc706961357efff$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $3cb2b98c53793e3a$var$transformRadians = (0, $4d93b99739cfac8a$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $57fa69a7e776893c$export$8449e153fbd325fc), y * (0, $57fa69a7e776893c$export$8449e153fbd325fc));
    }
});
function $3cb2b98c53793e3a$export$2e2bcd8739ae039(project) {
    return $3cb2b98c53793e3a$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $3cb2b98c53793e3a$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, dx, dy, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, theta = null, preclip = (0, $86910d36118c8f11$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $12ca6452a9242546$export$2e2bcd8739ae039), delta2 = 0.5, projectResample = (0, $9bc706961357efff$export$2e2bcd8739ae039)(projectTransform, delta2), cache, cacheStream;
    function projection(point) {
        point = projectRotate(point[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), point[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc));
        return [
            point[0] * k + dx,
            dy - point[1] * k
        ];
    }
    function invert(point) {
        point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
        return point && [
            point[0] * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
            point[1] * (0, $57fa69a7e776893c$export$41fc368e1a942b97)
        ];
    }
    function projectTransform(x, y) {
        return x = project(x, y), [
            x[0] * k + dx,
            dy - x[1] * k
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $3cb2b98c53793e3a$var$transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $96cd47fc397b0c50$export$2e2bcd8739ae039)(theta = _ * (0, $57fa69a7e776893c$export$8449e153fbd325fc), 6 * (0, $57fa69a7e776893c$export$8449e153fbd325fc)) : (theta = null, $86910d36118c8f11$export$2e2bcd8739ae039), reset()) : theta * (0, $57fa69a7e776893c$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $12ca6452a9242546$export$2e2bcd8739ae039) : (0, $760d301b8ecb929a$export$8948798bfea5de4f)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $57fa69a7e776893c$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
            phi * (0, $57fa69a7e776893c$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $57fa69a7e776893c$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $57fa69a7e776893c$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $57fa69a7e776893c$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
            deltaPhi * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
            deltaGamma * (0, $57fa69a7e776893c$export$41fc368e1a942b97)
        ];
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $9bc706961357efff$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $57fa69a7e776893c$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $07313ceef512d765$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $07313ceef512d765$export$33a367fa1728c3ba)(projection, size, object);
    };
    function recenter() {
        projectRotate = (0, $a70f03bd57e4100b$export$2e2bcd8739ae039)(rotate = (0, $cabb4367cc339c5f$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma), project);
        var center = project(lambda, phi);
        dx = x - center[0] * k;
        dy = y + center[1] * k;
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $b6111e893c5dd660$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $57fa69a7e776893c$export$18c7bea995a110f) / 3, m = (0, $3cb2b98c53793e3a$export$155d5a6fa6fddeba)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi1 = _[1] * (0, $57fa69a7e776893c$export$8449e153fbd325fc)) : [
            phi0 * (0, $57fa69a7e776893c$export$41fc368e1a942b97),
            phi1 * (0, $57fa69a7e776893c$export$41fc368e1a942b97)
        ];
    };
    return p;
}



function $ebeb9ed3ac4da2a8$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $57fa69a7e776893c$export$41726bdb1fc63f)(y * cosPhi0)
        ];
    };
    return forward;
}


function $4214fa9cddb7d75d$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y0), n = (sy0 + (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(n) < (0, $57fa69a7e776893c$export$6c421550c66a327d)) return (0, $ebeb9ed3ac4da2a8$export$ae68c6db8b65046a)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(c) / n;
    function project(x, y) {
        var r = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(c - 2 * n * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y)) / n;
        return [
            r * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(x *= n),
            r0 - r * (0, $57fa69a7e776893c$export$50d414a77b60d802)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y;
        return [
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(x, (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(r0y)) / n * (0, $57fa69a7e776893c$export$c5552dfdbc7cec71)(r0y),
            (0, $57fa69a7e776893c$export$41726bdb1fc63f)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $4214fa9cddb7d75d$export$2e2bcd8739ae039() {
    return (0, $b6111e893c5dd660$export$228272587c4d24d8)($4214fa9cddb7d75d$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}


function $43e62e4a407e2128$export$2e2bcd8739ae039() {
    return (0, $4214fa9cddb7d75d$export$2e2bcd8739ae039)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}






// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $fc64eec7f38dc477$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $fc64eec7f38dc477$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $43e62e4a407e2128$export$2e2bcd8739ae039)(), lower48Point, alaska = (0, $4214fa9cddb7d75d$export$2e2bcd8739ae039)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $4214fa9cddb7d75d$export$2e2bcd8739ae039)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $fc64eec7f38dc477$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $57fa69a7e776893c$export$6c421550c66a327d),
                y + 0.120 * k + (0, $57fa69a7e776893c$export$6c421550c66a327d)
            ],
            [
                x - 0.214 * k - (0, $57fa69a7e776893c$export$6c421550c66a327d),
                y + 0.234 * k - (0, $57fa69a7e776893c$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $57fa69a7e776893c$export$6c421550c66a327d),
                y + 0.166 * k + (0, $57fa69a7e776893c$export$6c421550c66a327d)
            ],
            [
                x - 0.115 * k - (0, $57fa69a7e776893c$export$6c421550c66a327d),
                y + 0.234 * k - (0, $57fa69a7e776893c$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $07313ceef512d765$export$e450184041869e7f)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $07313ceef512d765$export$33a367fa1728c3ba)(albersUsa, size, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}




function $d7ae000335878ef3$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $57fa69a7e776893c$export$50d414a77b60d802)(x), cy = (0, $57fa69a7e776893c$export$50d414a77b60d802)(y), k = scale(cx * cy);
        return [
            k * cy * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(x),
            k * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $d7ae000335878ef3$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(c), cc = (0, $57fa69a7e776893c$export$50d414a77b60d802)(c);
        return [
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $57fa69a7e776893c$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



var $dbcfb2f195dd1063$export$5e11f94fc4a8d2c6 = (0, $d7ae000335878ef3$export$f1211ac1bdb0796)(function(cxcy) {
    return (0, $57fa69a7e776893c$export$eba8049fb5020b81)(2 / (1 + cxcy));
});
$dbcfb2f195dd1063$export$5e11f94fc4a8d2c6.invert = (0, $d7ae000335878ef3$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $57fa69a7e776893c$export$41726bdb1fc63f)(z / 2);
});
function $dbcfb2f195dd1063$export$2e2bcd8739ae039() {
    return (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)($dbcfb2f195dd1063$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}





var $895836f6c9585cde$export$b94a4d6aa3dd25c = (0, $d7ae000335878ef3$export$f1211ac1bdb0796)(function(c) {
    return (c = (0, $57fa69a7e776893c$export$fd6306be3fde5b04)(c)) && c / (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(c);
});
$895836f6c9585cde$export$b94a4d6aa3dd25c.invert = (0, $d7ae000335878ef3$export$3cee429f13e44eac)(function(z) {
    return z;
});
function $895836f6c9585cde$export$2e2bcd8739ae039() {
    return (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)($895836f6c9585cde$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}







function $6c03466204bdfe07$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $57fa69a7e776893c$export$bef1f36f5486a6a3)((0, $57fa69a7e776893c$export$fcdd3b0b3246a325)(((0, $57fa69a7e776893c$export$e51408a300e8929a) + phi) / 2))
    ];
}
$6c03466204bdfe07$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $57fa69a7e776893c$export$628dc4eed22b0fbd)((0, $57fa69a7e776893c$export$b310ec824aaee37f)(y)) - (0, $57fa69a7e776893c$export$e51408a300e8929a)
    ];
};
function $6c03466204bdfe07$export$2e2bcd8739ae039() {
    return $6c03466204bdfe07$export$44b9b66a01f2127b($6c03466204bdfe07$export$94ff8a57e9b91cc3).scale(961 / (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92));
}
function $6c03466204bdfe07$export$44b9b66a01f2127b(project) {
    var m = (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $57fa69a7e776893c$export$18c7bea995a110f) * scale(), t = m((0, $cabb4367cc339c5f$export$2e2bcd8739ae039)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $6c03466204bdfe07$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}


function $ca270277e69b6c5d$var$tany(y) {
    return (0, $57fa69a7e776893c$export$fcdd3b0b3246a325)(((0, $57fa69a7e776893c$export$e51408a300e8929a) + y) / 2);
}
function $ca270277e69b6c5d$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y0) : (0, $57fa69a7e776893c$export$bef1f36f5486a6a3)(cy0 / (0, $57fa69a7e776893c$export$50d414a77b60d802)(y1)) / (0, $57fa69a7e776893c$export$bef1f36f5486a6a3)($ca270277e69b6c5d$var$tany(y1) / $ca270277e69b6c5d$var$tany(y0)), f = cy0 * (0, $57fa69a7e776893c$export$9c297f60e22e3389)($ca270277e69b6c5d$var$tany(y0), n) / n;
    if (!n) return 0, $6c03466204bdfe07$export$94ff8a57e9b91cc3;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $57fa69a7e776893c$export$e51408a300e8929a) + (0, $57fa69a7e776893c$export$6c421550c66a327d)) y = -(0, $57fa69a7e776893c$export$e51408a300e8929a) + (0, $57fa69a7e776893c$export$6c421550c66a327d);
        } else if (y > (0, $57fa69a7e776893c$export$e51408a300e8929a) - (0, $57fa69a7e776893c$export$6c421550c66a327d)) y = (0, $57fa69a7e776893c$export$e51408a300e8929a) - (0, $57fa69a7e776893c$export$6c421550c66a327d);
        var r = f / (0, $57fa69a7e776893c$export$9c297f60e22e3389)($ca270277e69b6c5d$var$tany(y), n);
        return [
            r * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(n * x),
            f - r * (0, $57fa69a7e776893c$export$50d414a77b60d802)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $57fa69a7e776893c$export$c5552dfdbc7cec71)(n) * (0, $57fa69a7e776893c$export$eba8049fb5020b81)(x * x + fy * fy);
        return [
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(x, (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(fy)) / n * (0, $57fa69a7e776893c$export$c5552dfdbc7cec71)(fy),
            2 * (0, $57fa69a7e776893c$export$628dc4eed22b0fbd)((0, $57fa69a7e776893c$export$9c297f60e22e3389)(f / r, 1 / n)) - (0, $57fa69a7e776893c$export$e51408a300e8929a)
        ];
    };
    return project;
}
function $ca270277e69b6c5d$export$2e2bcd8739ae039() {
    return (0, $b6111e893c5dd660$export$228272587c4d24d8)($ca270277e69b6c5d$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}






function $962521d28309cf0c$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$962521d28309cf0c$export$f5fee52180f2f058.invert = $962521d28309cf0c$export$f5fee52180f2f058;
function $962521d28309cf0c$export$2e2bcd8739ae039() {
    return (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)($962521d28309cf0c$export$f5fee52180f2f058).scale(152.63);
}


function $8a712fb3a33d1b05$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y0) : (cy0 - (0, $57fa69a7e776893c$export$50d414a77b60d802)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(n) < (0, $57fa69a7e776893c$export$6c421550c66a327d)) return 0, $962521d28309cf0c$export$f5fee52180f2f058;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(nx),
            g - gy * (0, $57fa69a7e776893c$export$50d414a77b60d802)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y;
        return [
            (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(x, (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(gy)) / n * (0, $57fa69a7e776893c$export$c5552dfdbc7cec71)(gy),
            g - (0, $57fa69a7e776893c$export$c5552dfdbc7cec71)(n) * (0, $57fa69a7e776893c$export$eba8049fb5020b81)(x * x + gy * gy)
        ];
    };
    return project;
}
function $8a712fb3a33d1b05$export$2e2bcd8739ae039() {
    return (0, $b6111e893c5dd660$export$228272587c4d24d8)($8a712fb3a33d1b05$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}






function $1ff2264882a9b66c$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $57fa69a7e776893c$export$50d414a77b60d802)(y), k = (0, $57fa69a7e776893c$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(x) / k,
        (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y) / k
    ];
}
$1ff2264882a9b66c$export$dc8c6ddfc8b22c85.invert = (0, $d7ae000335878ef3$export$3cee429f13e44eac)((0, $57fa69a7e776893c$export$628dc4eed22b0fbd));
function $1ff2264882a9b66c$export$2e2bcd8739ae039() {
    return (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)($1ff2264882a9b66c$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}






function $6919f9466b058ca2$var$scaleTranslate(kx, ky, tx, ty) {
    return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? (0, $12ca6452a9242546$export$2e2bcd8739ae039) : (0, $4d93b99739cfac8a$export$6b468dcfb64c653c)({
        point: function(x, y) {
            this.stream.point(x * kx + tx, y * ky + ty);
        }
    });
}
function $6919f9466b058ca2$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = (0, $12ca6452a9242546$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, clip = (0, $12ca6452a9242546$export$2e2bcd8739ae039), cache, cacheStream, projection;
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return projection = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
        },
        clipExtent: function(_) {
            return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, $12ca6452a9242546$export$2e2bcd8739ae039) : (0, $760d301b8ecb929a$export$8948798bfea5de4f)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        },
        scale: function(_) {
            return arguments.length ? (transform = $6919f9466b058ca2$var$scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
        },
        translate: function(_) {
            return arguments.length ? (transform = $6919f9466b058ca2$var$scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [
                tx,
                ty
            ];
        },
        reflectX: function(_) {
            return arguments.length ? (transform = $6919f9466b058ca2$var$scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
        },
        reflectY: function(_) {
            return arguments.length ? (transform = $6919f9466b058ca2$var$scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
        },
        fitExtent: function(extent, object) {
            return (0, $07313ceef512d765$export$e450184041869e7f)(projection, extent, object);
        },
        fitSize: function(size, object) {
            return (0, $07313ceef512d765$export$33a367fa1728c3ba)(projection, size, object);
        }
    };
}






function $6ac0ba80e849e60e$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$6ac0ba80e849e60e$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(delta) > (0, $57fa69a7e776893c$export$6c421550c66a327d) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $6ac0ba80e849e60e$export$2e2bcd8739ae039() {
    return (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)($6ac0ba80e849e60e$export$acb6def22fe878e6).scale(175.295);
}





function $6b35474bfaf5d80f$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $57fa69a7e776893c$export$50d414a77b60d802)(y) * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(x),
        (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y)
    ];
}
$6b35474bfaf5d80f$export$1cd9c2eb846182a.invert = (0, $d7ae000335878ef3$export$3cee429f13e44eac)((0, $57fa69a7e776893c$export$41726bdb1fc63f));
function $6b35474bfaf5d80f$export$2e2bcd8739ae039() {
    return (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)($6b35474bfaf5d80f$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $57fa69a7e776893c$export$6c421550c66a327d));
}





function $e22c252e98887f94$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $57fa69a7e776893c$export$50d414a77b60d802)(y), k = 1 + (0, $57fa69a7e776893c$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(x) / k,
        (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(y) / k
    ];
}
$e22c252e98887f94$export$f9ccbb0dcb3dcd2b.invert = (0, $d7ae000335878ef3$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $57fa69a7e776893c$export$628dc4eed22b0fbd)(z);
});
function $e22c252e98887f94$export$2e2bcd8739ae039() {
    return (0, $3cb2b98c53793e3a$export$2e2bcd8739ae039)($e22c252e98887f94$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}




function $c6c89d9e06f183e7$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $57fa69a7e776893c$export$bef1f36f5486a6a3)((0, $57fa69a7e776893c$export$fcdd3b0b3246a325)(((0, $57fa69a7e776893c$export$e51408a300e8929a) + phi) / 2)),
        -lambda
    ];
}
$c6c89d9e06f183e7$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $57fa69a7e776893c$export$628dc4eed22b0fbd)((0, $57fa69a7e776893c$export$b310ec824aaee37f)(x)) - (0, $57fa69a7e776893c$export$e51408a300e8929a)
    ];
};
function $c6c89d9e06f183e7$export$2e2bcd8739ae039() {
    var m = (0, $6c03466204bdfe07$export$44b9b66a01f2127b)($c6c89d9e06f183e7$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}







function $cedac001b685292d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $cedac001b685292d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $cedac001b685292d$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $cedac001b685292d$var$_callSuper(t, o, e) {
    return o = $cedac001b685292d$var$_getPrototypeOf(o), $cedac001b685292d$var$_possibleConstructorReturn(t, $cedac001b685292d$var$_isNativeReflectConstruct() ? Reflect.construct(o, [], $cedac001b685292d$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $cedac001b685292d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $cedac001b685292d$var$_createClass(e, r, t) {
    return Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $cedac001b685292d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cedac001b685292d$var$_unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = !0, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cedac001b685292d$var$_getPrototypeOf(t) {
    return $cedac001b685292d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cedac001b685292d$var$_getPrototypeOf(t);
}
function $cedac001b685292d$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $cedac001b685292d$var$_setPrototypeOf(t, e);
}
function $cedac001b685292d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cedac001b685292d$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $cedac001b685292d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $cedac001b685292d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cedac001b685292d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $cedac001b685292d$var$_assertThisInitialized(t);
}
function $cedac001b685292d$var$_setPrototypeOf(t, e) {
    return $cedac001b685292d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $cedac001b685292d$var$_setPrototypeOf(t, e);
}
function $cedac001b685292d$var$_slicedToArray(r, e) {
    return $cedac001b685292d$var$_arrayWithHoles(r) || $cedac001b685292d$var$_iterableToArrayLimit(r, e) || $cedac001b685292d$var$_unsupportedIterableToArray(r, e) || $cedac001b685292d$var$_nonIterableRest();
}
function $cedac001b685292d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cedac001b685292d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cedac001b685292d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $cedac001b685292d$var$interpolateLine = function interpolateLine() {
    var lineCoords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var maxDegDistance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var result = [];
    var prevPnt = null;
    lineCoords.forEach(function(pnt) {
        if (prevPnt) {
            var dist = (0, $6c415952b39ab5fa$export$2e2bcd8739ae039)(pnt, prevPnt) * 180 / Math.PI;
            if (dist > maxDegDistance) {
                var interpol = (0, $40adbe455568c340$export$2e2bcd8739ae039)(prevPnt, pnt);
                var tStep = 1 / Math.ceil(dist / maxDegDistance);
                var t = tStep;
                while(t < 1){
                    result.push(interpol(t));
                    t += tStep;
                }
            }
        }
        result.push(prevPnt = pnt);
    });
    return result;
};
var $cedac001b685292d$var$THREE = typeof window !== 'undefined' && window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959),
    Float32BufferAttribute: (0, $8725869b83961a04$export$cbe7a62641830ebd)
};
// support both modes for backwards threejs compatibility
var $cedac001b685292d$var$setAttributeFn = new $cedac001b685292d$var$THREE.BufferGeometry().setAttribute ? 'setAttribute' : 'addAttribute';
var $cedac001b685292d$export$8ed86786cce60ba8 = /*#__PURE__*/ function(_THREE$BufferGeometry) {
    function GeoJsonGeometry(geoJson) {
        var _this;
        var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var resolution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
        $cedac001b685292d$var$_classCallCheck(this, GeoJsonGeometry);
        _this = $cedac001b685292d$var$_callSuper(this, GeoJsonGeometry);
        _this.type = 'GeoJsonGeometry';
        _this.parameters = {
            geoJson: geoJson,
            radius: radius,
            resolution: resolution
        };
        // process various geometry types
        var groups = (({
            Point: genPoint,
            MultiPoint: genMultiPoint,
            LineString: genLineString,
            MultiLineString: genMultiLineString,
            Polygon: genPolygon,
            MultiPolygon: genMultiPolygon
        })[geoJson.type] || function() {
            return [];
        })(geoJson.coordinates, radius);
        // concat groups
        var indices = [], vertices = [];
        var groupCnt = 0;
        groups.forEach(function(newG) {
            var prevIndCnt = indices.length;
            $cedac001b685292d$var$concatGroup({
                indices: indices,
                vertices: vertices
            }, newG);
            _this.addGroup(prevIndCnt, indices.length - prevIndCnt, groupCnt++);
        });
        // build geometry
        indices.length && _this.setIndex(indices);
        vertices.length && _this[$cedac001b685292d$var$setAttributeFn]('position', new $cedac001b685292d$var$THREE.Float32BufferAttribute(vertices, 3));
        //
        function genPoint(coords, r) {
            var vertices = $cedac001b685292d$var$polar2Cartesian(coords[1], coords[0], r);
            var indices = [];
            return [
                {
                    vertices: vertices,
                    indices: indices
                }
            ];
        }
        function genMultiPoint(coords, r) {
            var result = {
                vertices: [],
                indices: []
            };
            coords.map(function(c) {
                return genPoint(c, r);
            }).forEach(function(_ref) {
                var _ref2 = $cedac001b685292d$var$_slicedToArray(_ref, 1), newPnt = _ref2[0];
                $cedac001b685292d$var$concatGroup(result, newPnt);
            });
            return [
                result
            ];
        }
        function genLineString(coords, r) {
            var coords3d = $cedac001b685292d$var$interpolateLine(coords, resolution).map(function(_ref3) {
                var _ref4 = $cedac001b685292d$var$_slicedToArray(_ref3, 2), lng = _ref4[0], lat = _ref4[1];
                return $cedac001b685292d$var$polar2Cartesian(lat, lng, r);
            });
            var _earcutFlatten = (0, $01e890dabde89b47$export$bffa455ba8c619a6)([
                coords3d
            ]), vertices = _earcutFlatten.vertices;
            var numPoints = Math.round(vertices.length / 3);
            var indices = [];
            for(var vIdx = 1; vIdx < numPoints; vIdx++)indices.push(vIdx - 1, vIdx);
            return [
                {
                    vertices: vertices,
                    indices: indices
                }
            ];
        }
        function genMultiLineString(coords, r) {
            var result = {
                vertices: [],
                indices: []
            };
            coords.map(function(c) {
                return genLineString(c, r);
            }).forEach(function(_ref5) {
                var _ref6 = $cedac001b685292d$var$_slicedToArray(_ref5, 1), newLine = _ref6[0];
                $cedac001b685292d$var$concatGroup(result, newLine);
            });
            return [
                result
            ];
        }
        function genPolygon(coords, r) {
            var coords3d = coords.map(function(coordsSegment) {
                return $cedac001b685292d$var$interpolateLine(coordsSegment, resolution).map(function(_ref7) {
                    var _ref8 = $cedac001b685292d$var$_slicedToArray(_ref7, 2), lng = _ref8[0], lat = _ref8[1];
                    return $cedac001b685292d$var$polar2Cartesian(lat, lng, r);
                });
            });
            // Each point generates 3 vertice items (x,y,z).
            var _earcutFlatten2 = (0, $01e890dabde89b47$export$bffa455ba8c619a6)(coords3d), vertices = _earcutFlatten2.vertices, holes = _earcutFlatten2.holes;
            var firstHoleIdx = holes[0] || Infinity;
            var outerVertices = vertices.slice(0, firstHoleIdx * 3);
            var holeVertices = vertices.slice(firstHoleIdx * 3);
            var holesIdx = new Set(holes);
            var numPoints = Math.round(vertices.length / 3);
            var outerIndices = [], holeIndices = [];
            for(var vIdx = 1; vIdx < numPoints; vIdx++)if (!holesIdx.has(vIdx)) {
                if (vIdx < firstHoleIdx) outerIndices.push(vIdx - 1, vIdx);
                else holeIndices.push(vIdx - 1 - firstHoleIdx, vIdx - firstHoleIdx);
            }
            var groups = [
                {
                    indices: outerIndices,
                    vertices: outerVertices
                }
            ];
            if (holes.length) groups.push({
                indices: holeIndices,
                vertices: holeVertices
            });
            return groups;
        }
        function genMultiPolygon(coords, r) {
            var outer = {
                vertices: [],
                indices: []
            };
            var holes = {
                vertices: [],
                indices: []
            };
            coords.map(function(c) {
                return genPolygon(c, r);
            }).forEach(function(_ref9) {
                var _ref10 = $cedac001b685292d$var$_slicedToArray(_ref9, 2), newOuter = _ref10[0], newHoles = _ref10[1];
                $cedac001b685292d$var$concatGroup(outer, newOuter);
                newHoles && $cedac001b685292d$var$concatGroup(holes, newHoles);
            });
            var groups = [
                outer
            ];
            holes.vertices.length && groups.push(holes);
            return groups;
        }
        return _this;
    }
    $cedac001b685292d$var$_inherits(GeoJsonGeometry, _THREE$BufferGeometry);
    return $cedac001b685292d$var$_createClass(GeoJsonGeometry);
}($cedac001b685292d$var$THREE.BufferGeometry); //
function $cedac001b685292d$var$concatGroup(main, extra) {
    var prevVertCnt = Math.round(main.vertices.length / 3);
    $cedac001b685292d$var$concatArr(main.vertices, extra.vertices);
    $cedac001b685292d$var$concatArr(main.indices, extra.indices.map(function(ind) {
        return ind + prevVertCnt;
    }));
}
function $cedac001b685292d$var$concatArr(target, src) {
    var _iterator = $cedac001b685292d$var$_createForOfIteratorHelper(src), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var e = _step.value;
            target.push(e);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $cedac001b685292d$var$polar2Cartesian(lat, lng) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var phi = (90 - lat) * Math.PI / 180;
    var theta = (90 - lng) * Math.PI / 180;
    return [
        r * Math.sin(phi) * Math.cos(theta),
        // x
        r * Math.cos(phi),
        // y
        r * Math.sin(phi) * Math.sin(theta) // z
    ];
}


// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $41e7b15057bcdd2e$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $41e7b15057bcdd2e$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $41e7b15057bcdd2e$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $41e7b15057bcdd2e$export$5a6391da70c130da(values, valueof) {
    const adder = new $41e7b15057bcdd2e$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}


var $f95be9d8e9f4056e$export$6c421550c66a327d = 1e-6;
var $f95be9d8e9f4056e$export$92c06fba281fe81b = 1e-12;
var $f95be9d8e9f4056e$export$18c7bea995a110f = Math.PI;
var $f95be9d8e9f4056e$export$e51408a300e8929a = $f95be9d8e9f4056e$export$18c7bea995a110f / 2;
var $f95be9d8e9f4056e$export$c39a5cba78ea0fc2 = $f95be9d8e9f4056e$export$18c7bea995a110f / 4;
var $f95be9d8e9f4056e$export$a4b4b4d4d776fe92 = $f95be9d8e9f4056e$export$18c7bea995a110f * 2;
var $f95be9d8e9f4056e$export$41fc368e1a942b97 = 180 / $f95be9d8e9f4056e$export$18c7bea995a110f;
var $f95be9d8e9f4056e$export$8449e153fbd325fc = $f95be9d8e9f4056e$export$18c7bea995a110f / 180;
var $f95be9d8e9f4056e$export$2335f513bbd82c6d = Math.abs;
var $f95be9d8e9f4056e$export$628dc4eed22b0fbd = Math.atan;
var $f95be9d8e9f4056e$export$b8b770ee6a0d9760 = Math.atan2;
var $f95be9d8e9f4056e$export$50d414a77b60d802 = Math.cos;
var $f95be9d8e9f4056e$export$803ce6b71a0a94b2 = Math.ceil;
var $f95be9d8e9f4056e$export$b310ec824aaee37f = Math.exp;
var $f95be9d8e9f4056e$export$a3fe094919f356fd = Math.floor;
var $f95be9d8e9f4056e$export$f95c7888b62f8e9a = Math.hypot;
var $f95be9d8e9f4056e$export$bef1f36f5486a6a3 = Math.log;
var $f95be9d8e9f4056e$export$9c297f60e22e3389 = Math.pow;
var $f95be9d8e9f4056e$export$5de3937cb4b592ed = Math.sin;
var $f95be9d8e9f4056e$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $f95be9d8e9f4056e$export$eba8049fb5020b81 = Math.sqrt;
var $f95be9d8e9f4056e$export$fcdd3b0b3246a325 = Math.tan;
function $f95be9d8e9f4056e$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f95be9d8e9f4056e$export$18c7bea995a110f : Math.acos(x);
}
function $f95be9d8e9f4056e$export$41726bdb1fc63f(x) {
    return x > 1 ? $f95be9d8e9f4056e$export$e51408a300e8929a : x < -1 ? -$f95be9d8e9f4056e$export$e51408a300e8929a : Math.asin(x);
}
function $f95be9d8e9f4056e$export$e808712c2966e662(x) {
    return (x = $f95be9d8e9f4056e$export$5de3937cb4b592ed(x / 2)) * x;
}


function $149c77c4fa99d09a$export$2e2bcd8739ae039() {}


function $853251797c79c8fb$var$streamGeometry(geometry, stream) {
    if (geometry && $853251797c79c8fb$var$streamGeometryType.hasOwnProperty(geometry.type)) $853251797c79c8fb$var$streamGeometryType[geometry.type](geometry, stream);
}
var $853251797c79c8fb$var$streamObjectType = {
    Feature: function(object, stream) {
        $853251797c79c8fb$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$853251797c79c8fb$var$streamGeometry(features[i].geometry, stream);
    }
};
var $853251797c79c8fb$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $853251797c79c8fb$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$853251797c79c8fb$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $853251797c79c8fb$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$853251797c79c8fb$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$853251797c79c8fb$var$streamGeometry(geometries[i], stream);
    }
};
function $853251797c79c8fb$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $853251797c79c8fb$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$853251797c79c8fb$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $853251797c79c8fb$export$2e2bcd8739ae039(object, stream) {
    if (object && $853251797c79c8fb$var$streamObjectType.hasOwnProperty(object.type)) $853251797c79c8fb$var$streamObjectType[object.type](object, stream);
    else $853251797c79c8fb$var$streamGeometry(object, stream);
}


var $ce0b5e593512f75c$var$lengthSum, $ce0b5e593512f75c$var$lambda0, $ce0b5e593512f75c$var$sinPhi0, $ce0b5e593512f75c$var$cosPhi0;
var $ce0b5e593512f75c$var$lengthStream = {
    sphere: (0, $149c77c4fa99d09a$export$2e2bcd8739ae039),
    point: (0, $149c77c4fa99d09a$export$2e2bcd8739ae039),
    lineStart: $ce0b5e593512f75c$var$lengthLineStart,
    lineEnd: (0, $149c77c4fa99d09a$export$2e2bcd8739ae039),
    polygonStart: (0, $149c77c4fa99d09a$export$2e2bcd8739ae039),
    polygonEnd: (0, $149c77c4fa99d09a$export$2e2bcd8739ae039)
};
function $ce0b5e593512f75c$var$lengthLineStart() {
    $ce0b5e593512f75c$var$lengthStream.point = $ce0b5e593512f75c$var$lengthPointFirst;
    $ce0b5e593512f75c$var$lengthStream.lineEnd = $ce0b5e593512f75c$var$lengthLineEnd;
}
function $ce0b5e593512f75c$var$lengthLineEnd() {
    $ce0b5e593512f75c$var$lengthStream.point = $ce0b5e593512f75c$var$lengthStream.lineEnd = (0, $149c77c4fa99d09a$export$2e2bcd8739ae039);
}
function $ce0b5e593512f75c$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $f95be9d8e9f4056e$export$8449e153fbd325fc), phi *= (0, $f95be9d8e9f4056e$export$8449e153fbd325fc);
    $ce0b5e593512f75c$var$lambda0 = lambda, $ce0b5e593512f75c$var$sinPhi0 = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(phi), $ce0b5e593512f75c$var$cosPhi0 = (0, $f95be9d8e9f4056e$export$50d414a77b60d802)(phi);
    $ce0b5e593512f75c$var$lengthStream.point = $ce0b5e593512f75c$var$lengthPoint;
}
function $ce0b5e593512f75c$var$lengthPoint(lambda, phi) {
    lambda *= (0, $f95be9d8e9f4056e$export$8449e153fbd325fc), phi *= (0, $f95be9d8e9f4056e$export$8449e153fbd325fc);
    var sinPhi = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(phi), cosPhi = (0, $f95be9d8e9f4056e$export$50d414a77b60d802)(phi), delta = (0, $f95be9d8e9f4056e$export$2335f513bbd82c6d)(lambda - $ce0b5e593512f75c$var$lambda0), cosDelta = (0, $f95be9d8e9f4056e$export$50d414a77b60d802)(delta), sinDelta = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(delta), x = cosPhi * sinDelta, y = $ce0b5e593512f75c$var$cosPhi0 * sinPhi - $ce0b5e593512f75c$var$sinPhi0 * cosPhi * cosDelta, z = $ce0b5e593512f75c$var$sinPhi0 * sinPhi + $ce0b5e593512f75c$var$cosPhi0 * cosPhi * cosDelta;
    $ce0b5e593512f75c$var$lengthSum.add((0, $f95be9d8e9f4056e$export$b8b770ee6a0d9760)((0, $f95be9d8e9f4056e$export$eba8049fb5020b81)(x * x + y * y), z));
    $ce0b5e593512f75c$var$lambda0 = lambda, $ce0b5e593512f75c$var$sinPhi0 = sinPhi, $ce0b5e593512f75c$var$cosPhi0 = cosPhi;
}
function $ce0b5e593512f75c$export$2e2bcd8739ae039(object) {
    $ce0b5e593512f75c$var$lengthSum = new (0, $41e7b15057bcdd2e$export$bda7ba77fb86c375)();
    (0, $853251797c79c8fb$export$2e2bcd8739ae039)(object, $ce0b5e593512f75c$var$lengthStream);
    return +$ce0b5e593512f75c$var$lengthSum;
}


var $e4a47e5a43a9d541$var$coordinates = [
    null,
    null
], $e4a47e5a43a9d541$var$object = {
    type: "LineString",
    coordinates: $e4a47e5a43a9d541$var$coordinates
};
function $e4a47e5a43a9d541$export$2e2bcd8739ae039(a, b) {
    $e4a47e5a43a9d541$var$coordinates[0] = a;
    $e4a47e5a43a9d541$var$coordinates[1] = b;
    return (0, $ce0b5e593512f75c$export$2e2bcd8739ae039)($e4a47e5a43a9d541$var$object);
}

function $3dec0b7226763c56$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}



function $56659a7819bc6155$var$graticuleX(y0, y1, dy) {
    var y = (0, $3dec0b7226763c56$export$2e2bcd8739ae039)(y0, y1 - (0, $f95be9d8e9f4056e$export$6c421550c66a327d), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $56659a7819bc6155$var$graticuleY(x0, x1, dx) {
    var x = (0, $3dec0b7226763c56$export$2e2bcd8739ae039)(x0, x1 - (0, $f95be9d8e9f4056e$export$6c421550c66a327d), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $56659a7819bc6155$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $3dec0b7226763c56$export$2e2bcd8739ae039)((0, $f95be9d8e9f4056e$export$803ce6b71a0a94b2)(X0 / DX) * DX, X1, DX).map(X).concat((0, $3dec0b7226763c56$export$2e2bcd8739ae039)((0, $f95be9d8e9f4056e$export$803ce6b71a0a94b2)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $3dec0b7226763c56$export$2e2bcd8739ae039)((0, $f95be9d8e9f4056e$export$803ce6b71a0a94b2)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $f95be9d8e9f4056e$export$2335f513bbd82c6d)(x % DX) > (0, $f95be9d8e9f4056e$export$6c421550c66a327d);
        }).map(x)).concat((0, $3dec0b7226763c56$export$2e2bcd8739ae039)((0, $f95be9d8e9f4056e$export$803ce6b71a0a94b2)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $f95be9d8e9f4056e$export$2335f513bbd82c6d)(y % DY) > (0, $f95be9d8e9f4056e$export$6c421550c66a327d);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $56659a7819bc6155$var$graticuleX(y0, y1, 90);
        y = $56659a7819bc6155$var$graticuleY(x0, x1, precision);
        X = $56659a7819bc6155$var$graticuleX(Y0, Y1, 90);
        Y = $56659a7819bc6155$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $f95be9d8e9f4056e$export$6c421550c66a327d)
        ],
        [
            180,
            90 - (0, $f95be9d8e9f4056e$export$6c421550c66a327d)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $f95be9d8e9f4056e$export$6c421550c66a327d)
        ],
        [
            180,
            80 + (0, $f95be9d8e9f4056e$export$6c421550c66a327d)
        ]
    ]);
}
function $56659a7819bc6155$export$b8db4e9403a5b6f1() {
    return $56659a7819bc6155$export$2e2bcd8739ae039()();
}


function $8bc8a132388147d0$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $f95be9d8e9f4056e$export$8449e153fbd325fc), y0 = a[1] * (0, $f95be9d8e9f4056e$export$8449e153fbd325fc), x1 = b[0] * (0, $f95be9d8e9f4056e$export$8449e153fbd325fc), y1 = b[1] * (0, $f95be9d8e9f4056e$export$8449e153fbd325fc), cy0 = (0, $f95be9d8e9f4056e$export$50d414a77b60d802)(y0), sy0 = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(y0), cy1 = (0, $f95be9d8e9f4056e$export$50d414a77b60d802)(y1), sy1 = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(y1), kx0 = cy0 * (0, $f95be9d8e9f4056e$export$50d414a77b60d802)(x0), ky0 = cy0 * (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(x0), kx1 = cy1 * (0, $f95be9d8e9f4056e$export$50d414a77b60d802)(x1), ky1 = cy1 * (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(x1), d = 2 * (0, $f95be9d8e9f4056e$export$41726bdb1fc63f)((0, $f95be9d8e9f4056e$export$eba8049fb5020b81)((0, $f95be9d8e9f4056e$export$e808712c2966e662)(y1 - y0) + cy0 * cy1 * (0, $f95be9d8e9f4056e$export$e808712c2966e662)(x1 - x0))), k = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(d);
    var interpolate = d ? function(t) {
        var B = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(t *= d) / k, A = (0, $f95be9d8e9f4056e$export$5de3937cb4b592ed)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $f95be9d8e9f4056e$export$b8b770ee6a0d9760)(y, x) * (0, $f95be9d8e9f4056e$export$41fc368e1a942b97),
            (0, $f95be9d8e9f4056e$export$b8b770ee6a0d9760)(z, (0, $f95be9d8e9f4056e$export$eba8049fb5020b81)(x * x + y * y)) * (0, $f95be9d8e9f4056e$export$41fc368e1a942b97)
        ];
    } : function() {
        return [
            x0 * (0, $f95be9d8e9f4056e$export$41fc368e1a942b97),
            y0 * (0, $f95be9d8e9f4056e$export$41fc368e1a942b97)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}


var $e5162ea5560088cd$exports = {};

$parcel$export($e5162ea5560088cd$exports, "computeMikkTSpaceTangents", () => $e5162ea5560088cd$export$676e3e70c930f774);
$parcel$export($e5162ea5560088cd$exports, "mergeGeometries", () => $e5162ea5560088cd$export$f06f69b3bf41d25c);
$parcel$export($e5162ea5560088cd$exports, "mergeAttributes", () => $e5162ea5560088cd$export$9f98db6234c4bd78);
$parcel$export($e5162ea5560088cd$exports, "deepCloneAttribute", () => $e5162ea5560088cd$export$4848639a9adff548);
$parcel$export($e5162ea5560088cd$exports, "deinterleaveAttribute", () => $e5162ea5560088cd$export$4b7aa2f2134b7e19);
$parcel$export($e5162ea5560088cd$exports, "interleaveAttributes", () => $e5162ea5560088cd$export$308f9509e428a845);
$parcel$export($e5162ea5560088cd$exports, "deinterleaveGeometry", () => $e5162ea5560088cd$export$e7413b17bfaaa80b);
$parcel$export($e5162ea5560088cd$exports, "estimateBytesUsed", () => $e5162ea5560088cd$export$35bee7999e19754d);
$parcel$export($e5162ea5560088cd$exports, "mergeVertices", () => $e5162ea5560088cd$export$e36bb98c4c944f9);
$parcel$export($e5162ea5560088cd$exports, "toTrianglesDrawMode", () => $e5162ea5560088cd$export$5492ca6e5c0c7aa0);
$parcel$export($e5162ea5560088cd$exports, "computeMorphedAttributes", () => $e5162ea5560088cd$export$29e54e2e4ab904e7);
$parcel$export($e5162ea5560088cd$exports, "mergeGroups", () => $e5162ea5560088cd$export$8babbf41197098b1);
$parcel$export($e5162ea5560088cd$exports, "toCreasedNormals", () => $e5162ea5560088cd$export$b525764477fc001f);

function $e5162ea5560088cd$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error('BufferGeometryUtils: Initialized MikkTSpace library required.');
    if (!geometry.hasAttribute('position') || !geometry.hasAttribute('normal') || !geometry.hasAttribute('uv')) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute('tangent', new (0, $8725869b83961a04$export$8dea267bd6bde117)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $e5162ea5560088cd$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $8725869b83961a04$export$b7be63a67df8959)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.');
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.');
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.');
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute');
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $e5162ea5560088cd$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' attribute.');
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $e5162ea5560088cd$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' morphAttribute.');
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $e5162ea5560088cd$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.');
            return null;
        }
        arrayLength += attribute.count * itemSize;
    }
    const array = new TypedArray(arrayLength);
    const result = new (0, $8725869b83961a04$export$8dea267bd6bde117)(array, itemSize, normalized);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            const tupleOffset = offset / itemSize;
            for(let j = 0, l = attribute.count; j < l; j++)for(let c = 0; c < itemSize; c++){
                const value = attribute.getComponent(j, c);
                result.setComponent(j + tupleOffset, c, value);
            }
        } else array.set(attribute.array, offset);
        offset += attribute.count * itemSize;
    }
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
function $e5162ea5560088cd$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $e5162ea5560088cd$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $8725869b83961a04$export$32ea87a8b54d744a)().copy(attribute);
    return new (0, $8725869b83961a04$export$8dea267bd6bde117)().copy(attribute);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $e5162ea5560088cd$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('AttributeBuffers of different types cannot be interleaved');
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $8725869b83961a04$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $8725869b83961a04$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $e5162ea5560088cd$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $8725869b83961a04$export$32ea87a8b54d744a)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $8725869b83961a04$export$8dea267bd6bde117)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $e5162ea5560088cd$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $e5162ea5560088cd$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $e5162ea5560088cd$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {BufferGeometry} geometry
 * @return {number}
 */ function $e5162ea5560088cd$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */ function $e5162ea5560088cd$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute('position');
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new attr.constructor(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttributes = geometry.morphAttributes[name];
        if (morphAttributes) {
            if (!tmpMorphAttributes[name]) tmpMorphAttributes[name] = [];
            morphAttributes.forEach((morphAttr, i)=>{
                const array = new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize);
                tmpMorphAttributes[name][i] = new morphAttr.constructor(array, morphAttr.itemSize, morphAttr.normalized);
            });
        }
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const halfTolerance = tolerance * 0.5;
    const exponent = Math.log10(1 / tolerance);
    const hashMultiplier = Math.pow(10, exponent);
    const hashAdditive = halfTolerance * hashMultiplier;
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = '';
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * hashMultiplier + hashAdditive)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttributes = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newArray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newArray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttributes) for(let m = 0, ml = morphAttributes.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttributes[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new tmpAttribute.constructor(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new tmpMorphAttribute.constructor(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */ function $e5162ea5560088cd$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $8725869b83961a04$export$4c28c87c2dc84758)) {
        console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
        return geometry;
    }
    if (drawMode === (0, $8725869b83961a04$export$f0d8293634f88842) || drawMode === (0, $8725869b83961a04$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute('position');
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $8725869b83961a04$export$f0d8293634f88842)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $e5162ea5560088cd$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _vB = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _vC = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _tempA = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _tempB = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _tempC = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _morphA = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _morphB = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _morphC = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $8725869b83961a04$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $8725869b83961a04$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $e5162ea5560088cd$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn('THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.');
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute('position');
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */ function $e5162ea5560088cd$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vectors
    const verts = [
        new (0, $8725869b83961a04$export$64b5c384219d3699)(),
        new (0, $8725869b83961a04$export$64b5c384219d3699)(),
        new (0, $8725869b83961a04$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const tempVec2 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const tempNorm = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    // BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
    // and returns the original geometry
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $8725869b83961a04$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $8725869b83961a04$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute('normal', normAttr);
    return resultGeometry;
}


var $e9cd866e7e5aa38e$export$2e2bcd8739ae039 = function(p) {
    return typeof p === 'function' ? p // fn
     : typeof p === 'string' ? function(obj) {
        return obj[p];
    } // property name
     : function(obj) {
        return p;
    };
}; // constant



var $ZZsCE = parcelRequire("ZZsCE");
var $fa90ed4ba7c7f833$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $fa90ed4ba7c7f833$exports = factory();
})($fa90ed4ba7c7f833$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


function $e4a0f5c492f23e14$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e4a0f5c492f23e14$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e4a0f5c492f23e14$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e4a0f5c492f23e14$var$_arrayLikeToArray(r);
}
function $e4a0f5c492f23e14$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e4a0f5c492f23e14$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e4a0f5c492f23e14$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e4a0f5c492f23e14$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e4a0f5c492f23e14$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e4a0f5c492f23e14$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e4a0f5c492f23e14$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $e4a0f5c492f23e14$var$_slicedToArray(r, e) {
    return $e4a0f5c492f23e14$var$_arrayWithHoles(r) || $e4a0f5c492f23e14$var$_iterableToArrayLimit(r, e) || $e4a0f5c492f23e14$var$_unsupportedIterableToArray(r, e) || $e4a0f5c492f23e14$var$_nonIterableRest();
}
function $e4a0f5c492f23e14$var$_toConsumableArray(r) {
    return $e4a0f5c492f23e14$var$_arrayWithoutHoles(r) || $e4a0f5c492f23e14$var$_iterableToArray(r) || $e4a0f5c492f23e14$var$_unsupportedIterableToArray(r) || $e4a0f5c492f23e14$var$_nonIterableSpread();
}
function $e4a0f5c492f23e14$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $e4a0f5c492f23e14$var$_toPropertyKey(t) {
    var i = $e4a0f5c492f23e14$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e4a0f5c492f23e14$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e4a0f5c492f23e14$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e4a0f5c492f23e14$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $e4a0f5c492f23e14$export$2e2bcd8739ae039 = function() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var keyAccessors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var multiItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var flattenKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var keys = (keyAccessors instanceof Array ? keyAccessors.length ? keyAccessors : [
        undefined
    ] : [
        keyAccessors
    ]).map(function(key) {
        return {
            keyAccessor: key,
            isProp: !(key instanceof Function)
        };
    });
    var indexedResult = list.reduce(function(res, item) {
        var iterObj = res;
        var itemVal = item;
        keys.forEach(function(_ref, idx) {
            var keyAccessor = _ref.keyAccessor, isProp = _ref.isProp;
            var key;
            if (isProp) {
                var _itemVal = itemVal, propVal = _itemVal[keyAccessor], rest = $e4a0f5c492f23e14$var$_objectWithoutProperties(_itemVal, [
                    keyAccessor
                ].map($e4a0f5c492f23e14$var$_toPropertyKey));
                key = propVal;
                itemVal = rest;
            } else key = keyAccessor(itemVal, idx);
            if (idx + 1 < keys.length) {
                if (!iterObj.hasOwnProperty(key)) iterObj[key] = {};
                iterObj = iterObj[key];
            } else // Leaf key
            if (multiItem) {
                if (!iterObj.hasOwnProperty(key)) iterObj[key] = [];
                iterObj[key].push(itemVal);
            } else iterObj[key] = itemVal;
        });
        return res;
    }, {});
    if (multiItem instanceof Function) // Reduce leaf multiple values
    (function reduce(node) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        if (level === keys.length) Object.keys(node).forEach(function(k) {
            return node[k] = multiItem(node[k]);
        });
        else Object.values(node).forEach(function(child) {
            return reduce(child, level + 1);
        });
    })(indexedResult); // IIFE
    var result = indexedResult;
    if (flattenKeys) {
        // flatten into array
        result = [];
        (function flatten(node) {
            var accKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            if (accKeys.length === keys.length) result.push({
                keys: accKeys,
                vals: node
            });
            else Object.entries(node).forEach(function(_ref2) {
                var _ref3 = $e4a0f5c492f23e14$var$_slicedToArray(_ref2, 2), key = _ref3[0], val = _ref3[1];
                return flatten(val, [].concat($e4a0f5c492f23e14$var$_toConsumableArray(accKeys), [
                    key
                ]));
            });
        })(indexedResult); //IIFE
        if (keyAccessors instanceof Array && keyAccessors.length === 0 && result.length === 1) // clear keys if there's no key accessors (single result)
        result[0].keys = [];
    }
    return result;
};


function $c33e1c293c0cad30$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c33e1c293c0cad30$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $c33e1c293c0cad30$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $c33e1c293c0cad30$var$_arrayLikeToArray(r);
}
function $c33e1c293c0cad30$var$_defineProperty(e, r, t) {
    return (r = $c33e1c293c0cad30$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c33e1c293c0cad30$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $c33e1c293c0cad30$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c33e1c293c0cad30$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c33e1c293c0cad30$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c33e1c293c0cad30$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c33e1c293c0cad30$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c33e1c293c0cad30$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c33e1c293c0cad30$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c33e1c293c0cad30$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c33e1c293c0cad30$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c33e1c293c0cad30$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c33e1c293c0cad30$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $c33e1c293c0cad30$var$_slicedToArray(r, e) {
    return $c33e1c293c0cad30$var$_arrayWithHoles(r) || $c33e1c293c0cad30$var$_iterableToArrayLimit(r, e) || $c33e1c293c0cad30$var$_unsupportedIterableToArray(r, e) || $c33e1c293c0cad30$var$_nonIterableRest();
}
function $c33e1c293c0cad30$var$_toConsumableArray(r) {
    return $c33e1c293c0cad30$var$_arrayWithoutHoles(r) || $c33e1c293c0cad30$var$_iterableToArray(r) || $c33e1c293c0cad30$var$_unsupportedIterableToArray(r) || $c33e1c293c0cad30$var$_nonIterableSpread();
}
function $c33e1c293c0cad30$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c33e1c293c0cad30$var$_toPropertyKey(t) {
    var i = $c33e1c293c0cad30$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c33e1c293c0cad30$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c33e1c293c0cad30$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c33e1c293c0cad30$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $c33e1c293c0cad30$var$_excluded = [
    "createObj",
    "updateObj",
    "exitObj",
    "objBindAttr",
    "dataBindAttr"
];
function $c33e1c293c0cad30$var$diffArrays(prev, next, idAccessor) {
    var result = {
        enter: [],
        update: [],
        exit: []
    };
    if (!idAccessor) {
        // use object references for comparison
        var prevSet = new Set(prev);
        var nextSet = new Set(next);
        new Set([].concat($c33e1c293c0cad30$var$_toConsumableArray(prevSet), $c33e1c293c0cad30$var$_toConsumableArray(nextSet))).forEach(function(item) {
            var type = !prevSet.has(item) ? 'enter' : !nextSet.has(item) ? 'exit' : 'update';
            result[type].push(type === 'update' ? [
                item,
                item
            ] : item);
        });
    } else {
        // compare by id (duplicate keys are ignored)
        var prevById = (0, $e4a0f5c492f23e14$export$2e2bcd8739ae039)(prev, idAccessor, false);
        var nextById = (0, $e4a0f5c492f23e14$export$2e2bcd8739ae039)(next, idAccessor, false);
        var byId = Object.assign({}, prevById, nextById);
        Object.entries(byId).forEach(function(_ref) {
            var _ref2 = $c33e1c293c0cad30$var$_slicedToArray(_ref, 2), id = _ref2[0], item = _ref2[1];
            var type = !prevById.hasOwnProperty(id) ? 'enter' : !nextById.hasOwnProperty(id) ? 'exit' : 'update';
            result[type].push(type === 'update' ? [
                prevById[id],
                nextById[id]
            ] : item);
        });
    }
    return result;
}
function $c33e1c293c0cad30$var$dataBindDiff(data, existingObjs, _ref3) {
    var _ref3$objBindAttr = _ref3.objBindAttr, objBindAttr = _ref3$objBindAttr === void 0 ? '__obj' : _ref3$objBindAttr, _ref3$dataBindAttr = _ref3.dataBindAttr, dataBindAttr = _ref3$dataBindAttr === void 0 ? '__data' : _ref3$dataBindAttr, idAccessor = _ref3.idAccessor, _ref3$purge = _ref3.purge, purge = _ref3$purge === void 0 ? false : _ref3$purge;
    var isObjValid = function isObjValid(obj) {
        return obj.hasOwnProperty(dataBindAttr);
    };
    var removeObjs = existingObjs.filter(function(obj) {
        return !isObjValid(obj);
    });
    var prevD = existingObjs.filter(isObjValid).map(function(obj) {
        return obj[dataBindAttr];
    });
    var nextD = data;
    var diff = purge ? {
        enter: nextD,
        exit: prevD,
        update: []
    } // don't diff data in purge mode
     : $c33e1c293c0cad30$var$diffArrays(prevD, nextD, idAccessor);
    diff.update = diff.update.map(function(_ref4) {
        var _ref5 = $c33e1c293c0cad30$var$_slicedToArray(_ref4, 2), prevD = _ref5[0], nextD = _ref5[1];
        if (prevD !== nextD) {
            // transfer obj to new data point (if different)
            nextD[objBindAttr] = prevD[objBindAttr];
            nextD[objBindAttr][dataBindAttr] = nextD;
        }
        return nextD;
    });
    diff.exit = diff.exit.concat(removeObjs.map(function(obj) {
        return $c33e1c293c0cad30$var$_defineProperty({}, objBindAttr, obj);
    }));
    return diff;
}
function $c33e1c293c0cad30$export$2e2bcd8739ae039(data, existingObjs, // list
appendObj, // item => {...} function
removeObj, _ref7) {
    var _ref7$createObj = _ref7.createObj, createObj = _ref7$createObj === void 0 ? function(d) {
        return {};
    } : _ref7$createObj, _ref7$updateObj = _ref7.updateObj, updateObj = _ref7$updateObj === void 0 ? function(obj, d) {} : _ref7$updateObj, _ref7$exitObj = _ref7.exitObj, exitObj = _ref7$exitObj === void 0 ? function(obj) {} : _ref7$exitObj, _ref7$objBindAttr = _ref7.objBindAttr, objBindAttr = _ref7$objBindAttr === void 0 ? '__obj' : _ref7$objBindAttr, _ref7$dataBindAttr = _ref7.dataBindAttr, dataBindAttr = _ref7$dataBindAttr === void 0 ? '__data' : _ref7$dataBindAttr, dataDiffOptions = $c33e1c293c0cad30$var$_objectWithoutProperties(_ref7, $c33e1c293c0cad30$var$_excluded);
    var _dataBindDiff = $c33e1c293c0cad30$var$dataBindDiff(data, existingObjs, $c33e1c293c0cad30$var$_objectSpread2({
        objBindAttr: objBindAttr,
        dataBindAttr: dataBindAttr
    }, dataDiffOptions)), enter = _dataBindDiff.enter, update = _dataBindDiff.update, exit = _dataBindDiff.exit;
    // Remove exiting points
    exit.forEach(function(d) {
        var obj = d[objBindAttr];
        delete d[objBindAttr]; // unbind obj
        exitObj(obj);
        removeObj(obj);
    });
    var newObjs = createObjs(enter);
    var pointsData = [].concat($c33e1c293c0cad30$var$_toConsumableArray(enter), $c33e1c293c0cad30$var$_toConsumableArray(update));
    updateObjs(pointsData);
    // Add new points
    newObjs.forEach(appendObj);
    //
    function createObjs(data) {
        var newObjs = [];
        data.forEach(function(d) {
            var obj = createObj(d);
            if (obj) {
                obj[dataBindAttr] = d;
                d[objBindAttr] = obj;
                newObjs.push(obj);
            }
        });
        return newObjs;
    }
    function updateObjs(data) {
        data.forEach(function(d) {
            var obj = d[objBindAttr];
            if (obj) {
                obj[dataBindAttr] = d;
                updateObj(obj, d);
            }
        });
    }
}


var $f1564f6f90ed2410$exports = {};
!function(e, t) {
    $f1564f6f90ed2410$exports = t();
}($f1564f6f90ed2410$exports, function() {
    return function(e) {
        function t(n) {
            if (i[n]) return i[n].exports;
            var r = i[n] = {
                exports: {},
                id: n,
                loaded: !1
            };
            return e[n].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
        }
        var i = {};
        return t.m = e, t.c = i, t.p = "", t(0);
    }([
        function(e, t, i) {
            "use strict";
            var n = i(1), r = function() {
                function e(e, t, i) {
                    void 0 === e && (e = NaN), void 0 === t && (t = NaN), void 0 === i && (i = !1), this._minFPS = t, this._maxFPS = e, this._timeScale = 1, this._currentTick = 0, this._currentTime = 0, this._tickDeltaTime = 0, this._isRunning = !1, this._maxInterval = isNaN(this._minFPS) ? NaN : 1e3 / this._minFPS, this._minInterval = isNaN(this._maxFPS) ? NaN : 1e3 / this._maxFPS, this._onResume = new n.default, this._onPause = new n.default, this._onTick = new n.default, this._onTickOncePerFrame = new n.default, i || this.resume();
                }
                return e.prototype.updateOnce = function(e) {
                    e(this.currentTimeSeconds, this.tickDeltaTimeSeconds, this.currentTick);
                }, e.prototype.resume = function() {
                    this._isRunning || (this._isRunning = !0, this._lastTimeUpdated = this.getTimer(), this._onResume.dispatch(), this.animateOnce());
                }, e.prototype.pause = function() {
                    this._isRunning && (this._isRunning = !1, this._onPause.dispatch(), window.cancelAnimationFrame(this._animationFrameHandle));
                }, e.prototype.dispose = function() {
                    this.pause(), this._onResume.removeAll(), this._onPause.removeAll(), this._onTick.removeAll();
                }, Object.defineProperty(e.prototype, "currentTick", {
                    get: function() {
                        return this._currentTick;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "currentTimeSeconds", {
                    get: function() {
                        return this._currentTime / 1e3;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "tickDeltaTimeSeconds", {
                    get: function() {
                        return this._tickDeltaTime / 1e3;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "timeScale", {
                    get: function() {
                        return this._timeScale;
                    },
                    set: function(e) {
                        this._timeScale !== e && (this._timeScale = e);
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "onResume", {
                    get: function() {
                        return this._onResume;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "onPause", {
                    get: function() {
                        return this._onPause;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "onTick", {
                    get: function() {
                        return this._onTick;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "onTickOncePerFrame", {
                    get: function() {
                        return this._onTickOncePerFrame;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "isRunning", {
                    get: function() {
                        return this._isRunning;
                    },
                    enumerable: !0,
                    configurable: !0
                }), e.prototype.animateOnce = function() {
                    var e = this;
                    this._animationFrameHandle = window.requestAnimationFrame(function() {
                        return e.onFrame();
                    });
                }, e.prototype.onFrame = function() {
                    if (this._now = this.getTimer(), this._frameDeltaTime = this._now - this._lastTimeUpdated, isNaN(this._minInterval) || this._frameDeltaTime >= this._minInterval) {
                        if (isNaN(this._maxInterval)) this.update(this._frameDeltaTime * this._timeScale, !0), this._lastTimeUpdated = this._now;
                        else for(this._interval = Math.min(this._frameDeltaTime, this._maxInterval); this._now >= this._lastTimeUpdated + this._interval;)this.update(this._interval * this._timeScale, this._now <= this._lastTimeUpdated + 2 * this._maxInterval), this._lastTimeUpdated += this._interval;
                    }
                    this._isRunning && this.animateOnce();
                }, e.prototype.update = function(e, t) {
                    void 0 === t && (t = !0), this._currentTick++, this._currentTime += e, this._tickDeltaTime = e, this._onTick.dispatch(this.currentTimeSeconds, this.tickDeltaTimeSeconds, this.currentTick), t && this._onTickOncePerFrame.dispatch(this.currentTimeSeconds, this.tickDeltaTimeSeconds, this.currentTick);
                }, e.prototype.getTimer = function() {
                    return Date.now();
                }, e;
            }();
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = r;
        },
        function(e, t, i) {
            !function(t, i) {
                e.exports = i();
            }(this, function() {
                return function(e) {
                    function t(n) {
                        if (i[n]) return i[n].exports;
                        var r = i[n] = {
                            exports: {},
                            id: n,
                            loaded: !1
                        };
                        return e[n].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
                    }
                    var i = {};
                    return t.m = e, t.c = i, t.p = "", t(0);
                }([
                    function(e, t) {
                        "use strict";
                        var i = function() {
                            function e() {
                                this.functions = [];
                            }
                            return e.prototype.add = function(e) {
                                return this.functions.indexOf(e) === -1 && (this.functions.push(e), !0);
                            }, e.prototype.remove = function(e) {
                                var t = this.functions.indexOf(e);
                                return t > -1 && (this.functions.splice(t, 1), !0);
                            }, e.prototype.removeAll = function() {
                                return this.functions.length > 0 && (this.functions.length = 0, !0);
                            }, e.prototype.dispatch = function() {
                                for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                                var i = this.functions.concat();
                                i.forEach(function(t) {
                                    t.apply(void 0, e);
                                });
                            }, Object.defineProperty(e.prototype, "numItems", {
                                get: function() {
                                    return this.functions.length;
                                },
                                enumerable: !0,
                                configurable: !0
                            }), e;
                        }();
                        Object.defineProperty(t, "__esModule", {
                            value: !0
                        }), t.default = i;
                    }
                ]);
            });
        }
    ]);
});


const $c368bdf1fd166891$var$e10 = Math.sqrt(50), $c368bdf1fd166891$var$e5 = Math.sqrt(10), $c368bdf1fd166891$var$e2 = Math.sqrt(2);
function $c368bdf1fd166891$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $c368bdf1fd166891$var$e10 ? 10 : error >= $c368bdf1fd166891$var$e5 ? 5 : error >= $c368bdf1fd166891$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $c368bdf1fd166891$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $c368bdf1fd166891$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $c368bdf1fd166891$var$tickSpec(stop, start, count) : $c368bdf1fd166891$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $c368bdf1fd166891$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $c368bdf1fd166891$var$tickSpec(start, stop, count)[2];
}
function $c368bdf1fd166891$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $c368bdf1fd166891$export$bc64d00cc98e7e95(stop, start, count) : $c368bdf1fd166891$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $abf433b3ea7a0ce5$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $5880a1d8b1bfdf58$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $5256938d8ff2cf89$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $abf433b3ea7a0ce5$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $abf433b3ea7a0ce5$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $abf433b3ea7a0ce5$export$2e2bcd8739ae039) || f === (0, $5880a1d8b1bfdf58$export$2e2bcd8739ae039) ? f : $5256938d8ff2cf89$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $5256938d8ff2cf89$var$zero() {
    return 0;
}


function $32e266e847710aed$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $32e266e847710aed$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $d7643dcd552ca1f2$var$ascendingBisect = (0, $5256938d8ff2cf89$export$2e2bcd8739ae039)((0, $abf433b3ea7a0ce5$export$2e2bcd8739ae039));
const $d7643dcd552ca1f2$export$4d945ad3ad5751b0 = $d7643dcd552ca1f2$var$ascendingBisect.right;
const $d7643dcd552ca1f2$export$df7d25c84ebd12a5 = $d7643dcd552ca1f2$var$ascendingBisect.left;
const $d7643dcd552ca1f2$export$c1cb828b1117c77b = (0, $5256938d8ff2cf89$export$2e2bcd8739ae039)((0, $32e266e847710aed$export$2e2bcd8739ae039)).center;
var $d7643dcd552ca1f2$export$2e2bcd8739ae039 = $d7643dcd552ca1f2$export$4d945ad3ad5751b0;



var $ZZsCE = parcelRequire("ZZsCE");

var $ZZsCE = parcelRequire("ZZsCE");
function $7c5a7a436d430561$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $7c5a7a436d430561$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $7c5a7a436d430561$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $f690fc6c8f4df12e$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $7c5a7a436d430561$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $e720846900c66f77$export$2e2bcd8739ae039 = (x)=>()=>x;


function $68d531bbbcd157d0$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $68d531bbbcd157d0$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $68d531bbbcd157d0$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $68d531bbbcd157d0$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $e720846900c66f77$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $68d531bbbcd157d0$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $68d531bbbcd157d0$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $68d531bbbcd157d0$var$exponential(a, b, y) : (0, $e720846900c66f77$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $68d531bbbcd157d0$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $68d531bbbcd157d0$var$linear(a, d) : (0, $e720846900c66f77$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $54aa1131439c34b2$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $68d531bbbcd157d0$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $ZZsCE.rgb)(start)).r, (end = (0, $ZZsCE.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $68d531bbbcd157d0$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $54aa1131439c34b2$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $ZZsCE.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $54aa1131439c34b2$export$2c0e28f2e2852d3f = $54aa1131439c34b2$var$rgbSpline((0, $7c5a7a436d430561$export$2e2bcd8739ae039));
var $54aa1131439c34b2$export$53d5214f625ccd4c = $54aa1131439c34b2$var$rgbSpline((0, $f690fc6c8f4df12e$export$2e2bcd8739ae039));



function $06d00f48f396bc31$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $06d00f48f396bc31$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $6c3a685d30ea04b4$export$2e2bcd8739ae039(a, b) {
    return ((0, $06d00f48f396bc31$export$5cd576d1827d40c8)(b) ? (0, $06d00f48f396bc31$export$2e2bcd8739ae039) : $6c3a685d30ea04b4$export$15d09067c6a5ee49)(a, b);
}
function $6c3a685d30ea04b4$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $96df76c8de2b205a$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $923dea0e605b861f$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $ab4c12d5ed9360a6$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $dea0e9d99cd1fbd4$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $96df76c8de2b205a$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $6fc818795e138e13$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6fc818795e138e13$var$reB = new RegExp($6fc818795e138e13$var$reA.source, "g");
function $6fc818795e138e13$var$zero(b) {
    return function() {
        return b;
    };
}
function $6fc818795e138e13$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6fc818795e138e13$export$2e2bcd8739ae039(a, b) {
    var bi = $6fc818795e138e13$var$reA.lastIndex = $6fc818795e138e13$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $6fc818795e138e13$var$reA.exec(a)) && (bm = $6fc818795e138e13$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $ab4c12d5ed9360a6$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $6fc818795e138e13$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6fc818795e138e13$var$one(q[0].x) : $6fc818795e138e13$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $96df76c8de2b205a$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $e720846900c66f77$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $ab4c12d5ed9360a6$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $ZZsCE.default)(b)) ? (b = c, $54aa1131439c34b2$export$2e2bcd8739ae039) : (0, $6fc818795e138e13$export$2e2bcd8739ae039) : b instanceof (0, $ZZsCE.default) ? (0, $54aa1131439c34b2$export$2e2bcd8739ae039) : b instanceof Date ? (0, $923dea0e605b861f$export$2e2bcd8739ae039) : (0, $06d00f48f396bc31$export$5cd576d1827d40c8)(b) ? (0, $06d00f48f396bc31$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $6c3a685d30ea04b4$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $dea0e9d99cd1fbd4$export$2e2bcd8739ae039) : (0, $ab4c12d5ed9360a6$export$2e2bcd8739ae039))(a, b);
}

function $3b46599b74abf368$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $a1c2844097a77ddb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $3eb1a031b646933f$export$2e2bcd8739ae039(x) {
    return +x;
}


var $6fbd9c8a19e1941d$var$unit = [
    0,
    1
];
function $6fbd9c8a19e1941d$export$f0954fd7d5368655(x) {
    return x;
}
function $6fbd9c8a19e1941d$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $a1c2844097a77ddb$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $6fbd9c8a19e1941d$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $6fbd9c8a19e1941d$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $6fbd9c8a19e1941d$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $6fbd9c8a19e1941d$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $6fbd9c8a19e1941d$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $6fbd9c8a19e1941d$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $d7643dcd552ca1f2$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $6fbd9c8a19e1941d$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $6fbd9c8a19e1941d$export$6b468dcfb64c653c() {
    var domain = $6fbd9c8a19e1941d$var$unit, range = $6fbd9c8a19e1941d$var$unit, interpolate = (0, $96df76c8de2b205a$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $6fbd9c8a19e1941d$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $6fbd9c8a19e1941d$export$f0954fd7d5368655) clamp = $6fbd9c8a19e1941d$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $6fbd9c8a19e1941d$var$polymap : $6fbd9c8a19e1941d$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $ab4c12d5ed9360a6$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $3eb1a031b646933f$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $3b46599b74abf368$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $6fbd9c8a19e1941d$export$f0954fd7d5368655, rescale()) : clamp !== $6fbd9c8a19e1941d$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $6fbd9c8a19e1941d$export$2e2bcd8739ae039() {
    return $6fbd9c8a19e1941d$export$6b468dcfb64c653c()($6fbd9c8a19e1941d$export$f0954fd7d5368655, $6fbd9c8a19e1941d$export$f0954fd7d5368655);
}


function $1a53497c6f360861$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $1a53497c6f360861$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}



function $2bd7b1fbd3c84fae$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $2bd7b1fbd3c84fae$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $23e404dbfccb4b13$export$2e2bcd8739ae039(x) {
    return x = (0, $2bd7b1fbd3c84fae$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $0a53f1da204b7017$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $de33f18d2f9b9b28$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $b41092c33ac864e4$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $b41092c33ac864e4$export$2e2bcd8739ae039(specifier) {
    if (!(match = $b41092c33ac864e4$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $b41092c33ac864e4$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$b41092c33ac864e4$export$2e2bcd8739ae039.prototype = $b41092c33ac864e4$export$963aac351db36ed4.prototype; // instanceof
function $b41092c33ac864e4$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$b41092c33ac864e4$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $3c4869130b71849a$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $80a8859f8d44f6f7$export$6863724d9a42263;
function $80a8859f8d44f6f7$export$2e2bcd8739ae039(x, p) {
    var d = (0, $2bd7b1fbd3c84fae$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($80a8859f8d44f6f7$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $2bd7b1fbd3c84fae$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $466e83306ede1b44$export$2e2bcd8739ae039(x, p) {
    var d = (0, $2bd7b1fbd3c84fae$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $94738abc407c45fb$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $2bd7b1fbd3c84fae$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $466e83306ede1b44$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $466e83306ede1b44$export$2e2bcd8739ae039),
    "s": (0, $80a8859f8d44f6f7$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $7bb7108eade53b19$export$2e2bcd8739ae039(x) {
    return x;
}


var $2cc26b17a208f2b1$var$map = Array.prototype.map, $2cc26b17a208f2b1$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $2cc26b17a208f2b1$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $7bb7108eade53b19$export$2e2bcd8739ae039) : (0, $0a53f1da204b7017$export$2e2bcd8739ae039)($2cc26b17a208f2b1$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $7bb7108eade53b19$export$2e2bcd8739ae039) : (0, $de33f18d2f9b9b28$export$2e2bcd8739ae039)($2cc26b17a208f2b1$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $b41092c33ac864e4$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $94738abc407c45fb$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $94738abc407c45fb$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $3c4869130b71849a$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $2cc26b17a208f2b1$var$prefixes[8 + (0, $80a8859f8d44f6f7$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $b41092c33ac864e4$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $23e404dbfccb4b13$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $2cc26b17a208f2b1$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $81a22718a0107cb8$var$locale;
var $81a22718a0107cb8$export$d9468344d3651243;
var $81a22718a0107cb8$export$8d85692a469dde6f;
$81a22718a0107cb8$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $81a22718a0107cb8$export$2e2bcd8739ae039(definition) {
    $81a22718a0107cb8$var$locale = (0, $2cc26b17a208f2b1$export$2e2bcd8739ae039)(definition);
    $81a22718a0107cb8$export$d9468344d3651243 = $81a22718a0107cb8$var$locale.format;
    $81a22718a0107cb8$export$8d85692a469dde6f = $81a22718a0107cb8$var$locale.formatPrefix;
    return $81a22718a0107cb8$var$locale;
}


function $59482a746772a232$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $23e404dbfccb4b13$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $311fe57d51d857b2$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $23e404dbfccb4b13$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $23e404dbfccb4b13$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $4b2a4e41acd3da6d$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $23e404dbfccb4b13$export$2e2bcd8739ae039)(max) - (0, $23e404dbfccb4b13$export$2e2bcd8739ae039)(step)) + 1;
}


function $c2ef51053ee7e44b$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $c368bdf1fd166891$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $b41092c33ac864e4$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $311fe57d51d857b2$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $81a22718a0107cb8$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $4b2a4e41acd3da6d$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $59482a746772a232$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $81a22718a0107cb8$export$d9468344d3651243)(specifier);
}


function $050f6c6fd36ea5ca$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $c368bdf1fd166891$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $c2ef51053ee7e44b$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $c368bdf1fd166891$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $050f6c6fd36ea5ca$export$2e2bcd8739ae039() {
    var scale = (0, $6fbd9c8a19e1941d$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $6fbd9c8a19e1941d$export$784d13d8ee351f07)(scale, $050f6c6fd36ea5ca$export$2e2bcd8739ae039());
    };
    (0, $1a53497c6f360861$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $050f6c6fd36ea5ca$export$16a5d4b4a61a274d(scale);
}




function $624bc327dc53eb9b$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $624bc327dc53eb9b$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $624bc327dc53eb9b$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $624bc327dc53eb9b$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $624bc327dc53eb9b$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $624bc327dc53eb9b$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $624bc327dc53eb9b$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $624bc327dc53eb9b$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $624bc327dc53eb9b$var$equals(last, last.next)) {
        $624bc327dc53eb9b$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $624bc327dc53eb9b$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($624bc327dc53eb9b$var$equals(p, p.next) || $624bc327dc53eb9b$var$area(p.prev, p, p.next) === 0)) {
            $624bc327dc53eb9b$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $624bc327dc53eb9b$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $624bc327dc53eb9b$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $624bc327dc53eb9b$var$isEarHashed(ear, minX, minY, invSize) : $624bc327dc53eb9b$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $624bc327dc53eb9b$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $624bc327dc53eb9b$var$earcutLinked($624bc327dc53eb9b$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $624bc327dc53eb9b$var$cureLocalIntersections($624bc327dc53eb9b$var$filterPoints(ear), triangles);
                $624bc327dc53eb9b$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $624bc327dc53eb9b$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $624bc327dc53eb9b$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($624bc327dc53eb9b$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $624bc327dc53eb9b$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $624bc327dc53eb9b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $624bc327dc53eb9b$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($624bc327dc53eb9b$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $624bc327dc53eb9b$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $624bc327dc53eb9b$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $624bc327dc53eb9b$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $624bc327dc53eb9b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $624bc327dc53eb9b$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $624bc327dc53eb9b$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $624bc327dc53eb9b$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $624bc327dc53eb9b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $624bc327dc53eb9b$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $624bc327dc53eb9b$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $624bc327dc53eb9b$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$624bc327dc53eb9b$var$equals(a, b) && $624bc327dc53eb9b$var$intersects(a, p, p.next, b) && $624bc327dc53eb9b$var$locallyInside(a, b) && $624bc327dc53eb9b$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $624bc327dc53eb9b$var$removeNode(p);
            $624bc327dc53eb9b$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $624bc327dc53eb9b$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $624bc327dc53eb9b$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $624bc327dc53eb9b$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $624bc327dc53eb9b$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $624bc327dc53eb9b$var$filterPoints(a, a.next);
                c = $624bc327dc53eb9b$var$filterPoints(c, c.next);
                // run earcut on each half
                $624bc327dc53eb9b$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $624bc327dc53eb9b$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $624bc327dc53eb9b$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $624bc327dc53eb9b$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($624bc327dc53eb9b$var$getLeftmost(list));
    }
    queue.sort($624bc327dc53eb9b$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $624bc327dc53eb9b$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $624bc327dc53eb9b$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $624bc327dc53eb9b$var$eliminateHole(hole, outerNode) {
    const bridge = $624bc327dc53eb9b$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $624bc327dc53eb9b$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $624bc327dc53eb9b$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $624bc327dc53eb9b$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $624bc327dc53eb9b$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($624bc327dc53eb9b$var$equals(hole, p)) return p;
    do {
        if ($624bc327dc53eb9b$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $624bc327dc53eb9b$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($624bc327dc53eb9b$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $624bc327dc53eb9b$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $624bc327dc53eb9b$var$sectorContainsSector(m, p) {
    return $624bc327dc53eb9b$var$area(m.prev, m, p.prev) < 0 && $624bc327dc53eb9b$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $624bc327dc53eb9b$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $624bc327dc53eb9b$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $624bc327dc53eb9b$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $624bc327dc53eb9b$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $624bc327dc53eb9b$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $624bc327dc53eb9b$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $624bc327dc53eb9b$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $624bc327dc53eb9b$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $624bc327dc53eb9b$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $624bc327dc53eb9b$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$624bc327dc53eb9b$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($624bc327dc53eb9b$var$locallyInside(a, b) && $624bc327dc53eb9b$var$locallyInside(b, a) && $624bc327dc53eb9b$var$middleInside(a, b) && // locally visible
    ($624bc327dc53eb9b$var$area(a.prev, a, b.prev) || $624bc327dc53eb9b$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $624bc327dc53eb9b$var$equals(a, b) && $624bc327dc53eb9b$var$area(a.prev, a, a.next) > 0 && $624bc327dc53eb9b$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $624bc327dc53eb9b$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $624bc327dc53eb9b$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $624bc327dc53eb9b$var$intersects(p1, q1, p2, q2) {
    const o1 = $624bc327dc53eb9b$var$sign($624bc327dc53eb9b$var$area(p1, q1, p2));
    const o2 = $624bc327dc53eb9b$var$sign($624bc327dc53eb9b$var$area(p1, q1, q2));
    const o3 = $624bc327dc53eb9b$var$sign($624bc327dc53eb9b$var$area(p2, q2, p1));
    const o4 = $624bc327dc53eb9b$var$sign($624bc327dc53eb9b$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $624bc327dc53eb9b$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $624bc327dc53eb9b$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $624bc327dc53eb9b$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $624bc327dc53eb9b$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $624bc327dc53eb9b$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $624bc327dc53eb9b$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $624bc327dc53eb9b$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $624bc327dc53eb9b$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $624bc327dc53eb9b$var$locallyInside(a, b) {
    return $624bc327dc53eb9b$var$area(a.prev, a, a.next) < 0 ? $624bc327dc53eb9b$var$area(a, b, a.next) >= 0 && $624bc327dc53eb9b$var$area(a, a.prev, b) >= 0 : $624bc327dc53eb9b$var$area(a, b, a.prev) < 0 || $624bc327dc53eb9b$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $624bc327dc53eb9b$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $624bc327dc53eb9b$var$splitPolygon(a, b) {
    const a2 = $624bc327dc53eb9b$var$createNode(a.i, a.x, a.y), b2 = $624bc327dc53eb9b$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $624bc327dc53eb9b$var$insertNode(i, x, y, last) {
    const p = $624bc327dc53eb9b$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $624bc327dc53eb9b$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $624bc327dc53eb9b$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $624bc327dc53eb9b$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($624bc327dc53eb9b$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($624bc327dc53eb9b$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $624bc327dc53eb9b$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $624bc327dc53eb9b$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}


const $cd8c7db27df393a9$export$6c421550c66a327d = 1.1102230246251565e-16;
const $cd8c7db27df393a9$export$8cfde575cbd41e40 = 134217729;
const $cd8c7db27df393a9$export$a4103c3ab16b06d7 = (3 + 8 * $cd8c7db27df393a9$export$6c421550c66a327d) * $cd8c7db27df393a9$export$6c421550c66a327d;
function $cd8c7db27df393a9$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $cd8c7db27df393a9$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $cd8c7db27df393a9$export$8a63f25cc62965f1($cd8c7db27df393a9$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $cd8c7db27df393a9$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $cd8c7db27df393a9$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $cd8c7db27df393a9$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $cd8c7db27df393a9$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $cd8c7db27df393a9$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $cd8c7db27df393a9$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $cd8c7db27df393a9$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}


const $8256862f22a4cb47$var$ccwerrboundA = (3 + 16 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $8256862f22a4cb47$var$ccwerrboundB = (2 + 12 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $8256862f22a4cb47$var$ccwerrboundC = (9 + 64 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $8256862f22a4cb47$var$B = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8256862f22a4cb47$var$C1 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $8256862f22a4cb47$var$C2 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(12);
const $8256862f22a4cb47$var$D = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(16);
const $8256862f22a4cb47$var$u = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
function $8256862f22a4cb47$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $8256862f22a4cb47$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $8256862f22a4cb47$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $8256862f22a4cb47$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $8256862f22a4cb47$var$B[3] = u3;
    let det = (0, $cd8c7db27df393a9$export$9f3a0795ca2cc944)(4, $8256862f22a4cb47$var$B);
    let errbound = $8256862f22a4cb47$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $8256862f22a4cb47$var$ccwerrboundC * detsum + (0, $cd8c7db27df393a9$export$a4103c3ab16b06d7) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $8256862f22a4cb47$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $8256862f22a4cb47$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $8256862f22a4cb47$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $8256862f22a4cb47$var$u[3] = u3;
    const C1len = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(4, $8256862f22a4cb47$var$B, 4, $8256862f22a4cb47$var$u, $8256862f22a4cb47$var$C1);
    s1 = acx * bcytail;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $8256862f22a4cb47$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $8256862f22a4cb47$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $8256862f22a4cb47$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $8256862f22a4cb47$var$u[3] = u3;
    const C2len = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(C1len, $8256862f22a4cb47$var$C1, 4, $8256862f22a4cb47$var$u, $8256862f22a4cb47$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $8256862f22a4cb47$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $8256862f22a4cb47$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $8256862f22a4cb47$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $8256862f22a4cb47$var$u[3] = u3;
    const Dlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(C2len, $8256862f22a4cb47$var$C2, 4, $8256862f22a4cb47$var$u, $8256862f22a4cb47$var$D);
    return $8256862f22a4cb47$var$D[Dlen - 1];
}
function $8256862f22a4cb47$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $8256862f22a4cb47$var$ccwerrboundA * detsum) return det;
    return -$8256862f22a4cb47$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $8256862f22a4cb47$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}



const $8ce45fbd8065aecc$var$o3derrboundA = (7 + 56 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $8ce45fbd8065aecc$var$o3derrboundB = (3 + 28 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $8ce45fbd8065aecc$var$o3derrboundC = (26 + 288 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $8ce45fbd8065aecc$var$bc = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$ca = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$ab = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$at_b = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$at_c = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$bt_c = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$bt_a = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$ct_a = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$ct_b = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$bct = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $8ce45fbd8065aecc$var$cat = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $8ce45fbd8065aecc$var$abt = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $8ce45fbd8065aecc$var$u = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $8ce45fbd8065aecc$var$_8 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $8ce45fbd8065aecc$var$_8b = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $8ce45fbd8065aecc$var$_16 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $8ce45fbd8065aecc$var$_12 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(12);
let $8ce45fbd8065aecc$var$fin = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(192);
let $8ce45fbd8065aecc$var$fin2 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(192);
function $8ce45fbd8065aecc$var$finadd(finlen, alen, a) {
    finlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(finlen, $8ce45fbd8065aecc$var$fin, alen, a, $8ce45fbd8065aecc$var$fin2);
    const tmp = $8ce45fbd8065aecc$var$fin;
    $8ce45fbd8065aecc$var$fin = $8ce45fbd8065aecc$var$fin2;
    $8ce45fbd8065aecc$var$fin2 = tmp;
    return finlen;
}
function $8ce45fbd8065aecc$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $8ce45fbd8065aecc$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $8ce45fbd8065aecc$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $8ce45fbd8065aecc$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $8ce45fbd8065aecc$var$u[2] = _k - (u3 - _j);
    $8ce45fbd8065aecc$var$u[3] = u3;
    finlen = $8ce45fbd8065aecc$var$finadd(finlen, 4, $8ce45fbd8065aecc$var$u);
    if (z !== 0) {
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $8ce45fbd8065aecc$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $8ce45fbd8065aecc$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $8ce45fbd8065aecc$var$u[2] = _k - (u3 - _j);
        $8ce45fbd8065aecc$var$u[3] = u3;
        finlen = $8ce45fbd8065aecc$var$finadd(finlen, 4, $8ce45fbd8065aecc$var$u);
    }
    return finlen;
}
function $8ce45fbd8065aecc$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $8ce45fbd8065aecc$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $8ce45fbd8065aecc$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $8ce45fbd8065aecc$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $8ce45fbd8065aecc$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $8ce45fbd8065aecc$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $8ce45fbd8065aecc$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $8ce45fbd8065aecc$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $8ce45fbd8065aecc$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $8ce45fbd8065aecc$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $8ce45fbd8065aecc$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $8ce45fbd8065aecc$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $8ce45fbd8065aecc$var$ab[3] = u3;
    finlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $8ce45fbd8065aecc$var$bc, adz, $8ce45fbd8065aecc$var$_8), $8ce45fbd8065aecc$var$_8, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $8ce45fbd8065aecc$var$ca, bdz, $8ce45fbd8065aecc$var$_8b), $8ce45fbd8065aecc$var$_8b, $8ce45fbd8065aecc$var$_16), $8ce45fbd8065aecc$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $8ce45fbd8065aecc$var$ab, cdz, $8ce45fbd8065aecc$var$_8), $8ce45fbd8065aecc$var$_8, $8ce45fbd8065aecc$var$fin);
    let det = (0, $cd8c7db27df393a9$export$9f3a0795ca2cc944)(finlen, $8ce45fbd8065aecc$var$fin);
    let errbound = $8ce45fbd8065aecc$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $8ce45fbd8065aecc$var$o3derrboundC * permanent + (0, $cd8c7db27df393a9$export$a4103c3ab16b06d7) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $8ce45fbd8065aecc$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $8ce45fbd8065aecc$var$at_b, $8ce45fbd8065aecc$var$at_c);
    const bt_len = $8ce45fbd8065aecc$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $8ce45fbd8065aecc$var$bt_c, $8ce45fbd8065aecc$var$bt_a);
    const ct_len = $8ce45fbd8065aecc$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $8ce45fbd8065aecc$var$ct_a, $8ce45fbd8065aecc$var$ct_b);
    const bctlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(bt_len, $8ce45fbd8065aecc$var$bt_c, ct_len, $8ce45fbd8065aecc$var$ct_b, $8ce45fbd8065aecc$var$bct);
    finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bctlen, $8ce45fbd8065aecc$var$bct, adz, $8ce45fbd8065aecc$var$_16), $8ce45fbd8065aecc$var$_16);
    const catlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(ct_len, $8ce45fbd8065aecc$var$ct_a, at_len, $8ce45fbd8065aecc$var$at_c, $8ce45fbd8065aecc$var$cat);
    finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(catlen, $8ce45fbd8065aecc$var$cat, bdz, $8ce45fbd8065aecc$var$_16), $8ce45fbd8065aecc$var$_16);
    const abtlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(at_len, $8ce45fbd8065aecc$var$at_b, bt_len, $8ce45fbd8065aecc$var$bt_a, $8ce45fbd8065aecc$var$abt);
    finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(abtlen, $8ce45fbd8065aecc$var$abt, cdz, $8ce45fbd8065aecc$var$_16), $8ce45fbd8065aecc$var$_16);
    if (adztail !== 0) {
        finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $8ce45fbd8065aecc$var$bc, adztail, $8ce45fbd8065aecc$var$_12), $8ce45fbd8065aecc$var$_12);
        finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bctlen, $8ce45fbd8065aecc$var$bct, adztail, $8ce45fbd8065aecc$var$_16), $8ce45fbd8065aecc$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $8ce45fbd8065aecc$var$ca, bdztail, $8ce45fbd8065aecc$var$_12), $8ce45fbd8065aecc$var$_12);
        finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(catlen, $8ce45fbd8065aecc$var$cat, bdztail, $8ce45fbd8065aecc$var$_16), $8ce45fbd8065aecc$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $8ce45fbd8065aecc$var$ab, cdztail, $8ce45fbd8065aecc$var$_12), $8ce45fbd8065aecc$var$_12);
        finlen = $8ce45fbd8065aecc$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(abtlen, $8ce45fbd8065aecc$var$abt, cdztail, $8ce45fbd8065aecc$var$_16), $8ce45fbd8065aecc$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $8ce45fbd8065aecc$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $8ce45fbd8065aecc$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $8ce45fbd8065aecc$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $8ce45fbd8065aecc$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $8ce45fbd8065aecc$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $8ce45fbd8065aecc$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $8ce45fbd8065aecc$var$fin[finlen - 1];
}
function $8ce45fbd8065aecc$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $8ce45fbd8065aecc$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $8ce45fbd8065aecc$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $8ce45fbd8065aecc$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}



const $e1acf1d879b46aa3$var$iccerrboundA = (10 + 96 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $e1acf1d879b46aa3$var$iccerrboundB = (4 + 48 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $e1acf1d879b46aa3$var$iccerrboundC = (44 + 576 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $e1acf1d879b46aa3$var$bc = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$ca = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$ab = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$aa = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$bb = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$cc = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$u = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$v = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$axtbc = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$aytbc = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$bxtca = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$bytca = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$cxtab = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$cytab = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$abt = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$bct = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$cat = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$abtt = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$bctt = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$catt = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $e1acf1d879b46aa3$var$_8 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $e1acf1d879b46aa3$var$_16 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(16);
const $e1acf1d879b46aa3$var$_16b = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(16);
const $e1acf1d879b46aa3$var$_16c = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(16);
const $e1acf1d879b46aa3$var$_32 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(32);
const $e1acf1d879b46aa3$var$_32b = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(32);
const $e1acf1d879b46aa3$var$_48 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(48);
const $e1acf1d879b46aa3$var$_64 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(64);
let $e1acf1d879b46aa3$var$fin = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
let $e1acf1d879b46aa3$var$fin2 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
function $e1acf1d879b46aa3$var$finadd(finlen, a, alen) {
    finlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(finlen, $e1acf1d879b46aa3$var$fin, a, alen, $e1acf1d879b46aa3$var$fin2);
    const tmp = $e1acf1d879b46aa3$var$fin;
    $e1acf1d879b46aa3$var$fin = $e1acf1d879b46aa3$var$fin2;
    $e1acf1d879b46aa3$var$fin2 = tmp;
    return finlen;
}
function $e1acf1d879b46aa3$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $e1acf1d879b46aa3$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $e1acf1d879b46aa3$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $e1acf1d879b46aa3$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $e1acf1d879b46aa3$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $e1acf1d879b46aa3$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $e1acf1d879b46aa3$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $e1acf1d879b46aa3$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $e1acf1d879b46aa3$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $e1acf1d879b46aa3$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $e1acf1d879b46aa3$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $e1acf1d879b46aa3$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $e1acf1d879b46aa3$var$ab[3] = u3;
    finlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bc, adx, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, adx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bc, ady, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, ady, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ca, bdx, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, bdx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ca, bdy, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, bdy, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, $e1acf1d879b46aa3$var$_32b), $e1acf1d879b46aa3$var$_32b, $e1acf1d879b46aa3$var$_64), $e1acf1d879b46aa3$var$_64, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ab, cdx, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, cdx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ab, cdy, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, cdy, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$fin);
    let det = (0, $cd8c7db27df393a9$export$9f3a0795ca2cc944)(finlen, $e1acf1d879b46aa3$var$fin);
    let errbound = $e1acf1d879b46aa3$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $e1acf1d879b46aa3$var$iccerrboundC * permanent + (0, $cd8c7db27df393a9$export$a4103c3ab16b06d7) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $e1acf1d879b46aa3$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $e1acf1d879b46aa3$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $e1acf1d879b46aa3$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $e1acf1d879b46aa3$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $e1acf1d879b46aa3$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $e1acf1d879b46aa3$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $e1acf1d879b46aa3$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $e1acf1d879b46aa3$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $e1acf1d879b46aa3$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $e1acf1d879b46aa3$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $e1acf1d879b46aa3$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $e1acf1d879b46aa3$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bc, adxtail, $e1acf1d879b46aa3$var$axtbc);
        finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(axtbclen, $e1acf1d879b46aa3$var$axtbc, 2 * adx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$cc, adxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, bdy, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bb, adxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, -cdy, $e1acf1d879b46aa3$var$_16c), $e1acf1d879b46aa3$var$_16c, $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bc, adytail, $e1acf1d879b46aa3$var$aytbc);
        finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(aytbclen, $e1acf1d879b46aa3$var$aytbc, 2 * ady, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bb, adytail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, cdx, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$cc, adytail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, -bdx, $e1acf1d879b46aa3$var$_16c), $e1acf1d879b46aa3$var$_16c, $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ca, bdxtail, $e1acf1d879b46aa3$var$bxtca);
        finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bxtcalen, $e1acf1d879b46aa3$var$bxtca, 2 * bdx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$aa, bdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, cdy, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$cc, bdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, -ady, $e1acf1d879b46aa3$var$_16c), $e1acf1d879b46aa3$var$_16c, $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ca, bdytail, $e1acf1d879b46aa3$var$bytca);
        finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bytcalen, $e1acf1d879b46aa3$var$bytca, 2 * bdy, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$cc, bdytail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, adx, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$aa, bdytail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, -cdx, $e1acf1d879b46aa3$var$_16c), $e1acf1d879b46aa3$var$_16c, $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ab, cdxtail, $e1acf1d879b46aa3$var$cxtab);
        finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(cxtablen, $e1acf1d879b46aa3$var$cxtab, 2 * cdx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bb, cdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, ady, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$aa, cdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, -bdy, $e1acf1d879b46aa3$var$_16c), $e1acf1d879b46aa3$var$_16c, $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$ab, cdytail, $e1acf1d879b46aa3$var$cytab);
        finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(cytablen, $e1acf1d879b46aa3$var$cytab, 2 * cdy, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$aa, cdytail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, bdx, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bb, cdytail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, -adx, $e1acf1d879b46aa3$var$_16c), $e1acf1d879b46aa3$var$_16c, $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $e1acf1d879b46aa3$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $e1acf1d879b46aa3$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $e1acf1d879b46aa3$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $e1acf1d879b46aa3$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$v[3] = u3;
            bctlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(4, $e1acf1d879b46aa3$var$u, 4, $e1acf1d879b46aa3$var$v, $e1acf1d879b46aa3$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $e1acf1d879b46aa3$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $e1acf1d879b46aa3$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $e1acf1d879b46aa3$var$bct[0] = 0;
            bctlen = 1;
            $e1acf1d879b46aa3$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bctlen, $e1acf1d879b46aa3$var$bct, adxtail, $e1acf1d879b46aa3$var$_16c);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(axtbclen, $e1acf1d879b46aa3$var$axtbc, adxtail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, 2 * adx, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
            const len2 = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bcttlen, $e1acf1d879b46aa3$var$bctt, adxtail, $e1acf1d879b46aa3$var$_8);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, 2 * adx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, adxtail, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, adxtail, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_32b, $e1acf1d879b46aa3$var$_64), $e1acf1d879b46aa3$var$_64);
            if (bdytail !== 0) finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$cc, adxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, bdytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16);
            if (cdytail !== 0) finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bb, -adxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, cdytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bctlen, $e1acf1d879b46aa3$var$bct, adytail, $e1acf1d879b46aa3$var$_16c);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(aytbclen, $e1acf1d879b46aa3$var$aytbc, adytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, 2 * ady, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
            const len2 = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bcttlen, $e1acf1d879b46aa3$var$bctt, adytail, $e1acf1d879b46aa3$var$_8);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, 2 * ady, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, adytail, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, adytail, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_32b, $e1acf1d879b46aa3$var$_64), $e1acf1d879b46aa3$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $e1acf1d879b46aa3$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $e1acf1d879b46aa3$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $e1acf1d879b46aa3$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $e1acf1d879b46aa3$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$v[3] = u3;
            catlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(4, $e1acf1d879b46aa3$var$u, 4, $e1acf1d879b46aa3$var$v, $e1acf1d879b46aa3$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $e1acf1d879b46aa3$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $e1acf1d879b46aa3$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $e1acf1d879b46aa3$var$cat[0] = 0;
            catlen = 1;
            $e1acf1d879b46aa3$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(catlen, $e1acf1d879b46aa3$var$cat, bdxtail, $e1acf1d879b46aa3$var$_16c);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bxtcalen, $e1acf1d879b46aa3$var$bxtca, bdxtail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, 2 * bdx, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
            const len2 = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(cattlen, $e1acf1d879b46aa3$var$catt, bdxtail, $e1acf1d879b46aa3$var$_8);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, 2 * bdx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, bdxtail, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, bdxtail, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_32b, $e1acf1d879b46aa3$var$_64), $e1acf1d879b46aa3$var$_64);
            if (cdytail !== 0) finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$aa, bdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, cdytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16);
            if (adytail !== 0) finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$cc, -bdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, adytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(catlen, $e1acf1d879b46aa3$var$cat, bdytail, $e1acf1d879b46aa3$var$_16c);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(bytcalen, $e1acf1d879b46aa3$var$bytca, bdytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, 2 * bdy, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
            const len2 = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(cattlen, $e1acf1d879b46aa3$var$catt, bdytail, $e1acf1d879b46aa3$var$_8);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, 2 * bdy, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, bdytail, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, bdytail, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_32b, $e1acf1d879b46aa3$var$_64), $e1acf1d879b46aa3$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $e1acf1d879b46aa3$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $e1acf1d879b46aa3$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $e1acf1d879b46aa3$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $e1acf1d879b46aa3$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$v[3] = u3;
            abtlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(4, $e1acf1d879b46aa3$var$u, 4, $e1acf1d879b46aa3$var$v, $e1acf1d879b46aa3$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $e1acf1d879b46aa3$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $e1acf1d879b46aa3$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $e1acf1d879b46aa3$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $e1acf1d879b46aa3$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $e1acf1d879b46aa3$var$abt[0] = 0;
            abtlen = 1;
            $e1acf1d879b46aa3$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(abtlen, $e1acf1d879b46aa3$var$abt, cdxtail, $e1acf1d879b46aa3$var$_16c);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(cxtablen, $e1acf1d879b46aa3$var$cxtab, cdxtail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, 2 * cdx, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
            const len2 = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(abttlen, $e1acf1d879b46aa3$var$abtt, cdxtail, $e1acf1d879b46aa3$var$_8);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, 2 * cdx, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, cdxtail, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, cdxtail, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_32b, $e1acf1d879b46aa3$var$_64), $e1acf1d879b46aa3$var$_64);
            if (adytail !== 0) finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$bb, cdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, adytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16);
            if (bdytail !== 0) finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, $e1acf1d879b46aa3$var$aa, -cdxtail, $e1acf1d879b46aa3$var$_8), $e1acf1d879b46aa3$var$_8, bdytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(abtlen, $e1acf1d879b46aa3$var$abt, cdytail, $e1acf1d879b46aa3$var$_16c);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(cytablen, $e1acf1d879b46aa3$var$cytab, cdytail, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, 2 * cdy, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_48), $e1acf1d879b46aa3$var$_48);
            const len2 = (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(abttlen, $e1acf1d879b46aa3$var$abtt, cdytail, $e1acf1d879b46aa3$var$_8);
            finlen = $e1acf1d879b46aa3$var$finadd(finlen, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, 2 * cdy, $e1acf1d879b46aa3$var$_16), $e1acf1d879b46aa3$var$_16, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len2, $e1acf1d879b46aa3$var$_8, cdytail, $e1acf1d879b46aa3$var$_16b), $e1acf1d879b46aa3$var$_16b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $e1acf1d879b46aa3$var$_16c, cdytail, $e1acf1d879b46aa3$var$_32), $e1acf1d879b46aa3$var$_32, $e1acf1d879b46aa3$var$_32b, $e1acf1d879b46aa3$var$_64), $e1acf1d879b46aa3$var$_64);
        }
    }
    return $e1acf1d879b46aa3$var$fin[finlen - 1];
}
function $e1acf1d879b46aa3$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $e1acf1d879b46aa3$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $e1acf1d879b46aa3$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $e1acf1d879b46aa3$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}



const $497b1b14513d5a3b$var$isperrboundA = (16 + 224 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $497b1b14513d5a3b$var$isperrboundB = (5 + 72 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $497b1b14513d5a3b$var$isperrboundC = (71 + 1408 * (0, $cd8c7db27df393a9$export$6c421550c66a327d)) * (0, $cd8c7db27df393a9$export$6c421550c66a327d) * (0, $cd8c7db27df393a9$export$6c421550c66a327d);
const $497b1b14513d5a3b$var$ab = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$bc = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$cd = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$de = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$ea = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$ac = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$bd = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$ce = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$da = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$eb = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(4);
const $497b1b14513d5a3b$var$abc = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$bcd = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$cde = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$dea = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$eab = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$abd = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$bce = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$cda = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$deb = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$eac = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$adet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
const $497b1b14513d5a3b$var$bdet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
const $497b1b14513d5a3b$var$cdet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
const $497b1b14513d5a3b$var$ddet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
const $497b1b14513d5a3b$var$edet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
const $497b1b14513d5a3b$var$abdet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(2304);
const $497b1b14513d5a3b$var$cddet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(2304);
const $497b1b14513d5a3b$var$cdedet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(3456);
const $497b1b14513d5a3b$var$deter = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(5760);
const $497b1b14513d5a3b$var$_8 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $497b1b14513d5a3b$var$_8b = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $497b1b14513d5a3b$var$_8c = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(8);
const $497b1b14513d5a3b$var$_16 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(16);
const $497b1b14513d5a3b$var$_24 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(24);
const $497b1b14513d5a3b$var$_48 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(48);
const $497b1b14513d5a3b$var$_48b = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(48);
const $497b1b14513d5a3b$var$_96 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(96);
const $497b1b14513d5a3b$var$_192 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(192);
const $497b1b14513d5a3b$var$_384x = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(384);
const $497b1b14513d5a3b$var$_384y = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(384);
const $497b1b14513d5a3b$var$_384z = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(384);
const $497b1b14513d5a3b$var$_768 = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(768);
function $497b1b14513d5a3b$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, a, az, $497b1b14513d5a3b$var$_8), $497b1b14513d5a3b$var$_8, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, b, bz, $497b1b14513d5a3b$var$_8b), $497b1b14513d5a3b$var$_8b, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)(4, c, cz, $497b1b14513d5a3b$var$_8c), $497b1b14513d5a3b$var$_8c, $497b1b14513d5a3b$var$_16, out);
}
function $497b1b14513d5a3b$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(alen, a, blen, b, $497b1b14513d5a3b$var$_48), $497b1b14513d5a3b$var$_48, (0, $cd8c7db27df393a9$export$aef51622e549b8b0)((0, $cd8c7db27df393a9$export$8a63f25cc62965f1)(clen, c, dlen, d, $497b1b14513d5a3b$var$_48b), $497b1b14513d5a3b$var$_48b), $497b1b14513d5a3b$var$_48b, $497b1b14513d5a3b$var$_96);
    return (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $497b1b14513d5a3b$var$_96, x, $497b1b14513d5a3b$var$_192), $497b1b14513d5a3b$var$_192, x, $497b1b14513d5a3b$var$_384x), $497b1b14513d5a3b$var$_384x, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $497b1b14513d5a3b$var$_96, y, $497b1b14513d5a3b$var$_192), $497b1b14513d5a3b$var$_192, y, $497b1b14513d5a3b$var$_384y), $497b1b14513d5a3b$var$_384y, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $497b1b14513d5a3b$var$_96, z, $497b1b14513d5a3b$var$_192), $497b1b14513d5a3b$var$_192, z, $497b1b14513d5a3b$var$_384z), $497b1b14513d5a3b$var$_384z, $497b1b14513d5a3b$var$_768, out);
}
function $497b1b14513d5a3b$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $497b1b14513d5a3b$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$eb[3] = u3;
    const abclen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$ab, $497b1b14513d5a3b$var$bc, $497b1b14513d5a3b$var$ac, cz, az, -bz, $497b1b14513d5a3b$var$abc);
    const bcdlen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$bc, $497b1b14513d5a3b$var$cd, $497b1b14513d5a3b$var$bd, dz, bz, -cz, $497b1b14513d5a3b$var$bcd);
    const cdelen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$cd, $497b1b14513d5a3b$var$de, $497b1b14513d5a3b$var$ce, ez, cz, -dz, $497b1b14513d5a3b$var$cde);
    const dealen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$de, $497b1b14513d5a3b$var$ea, $497b1b14513d5a3b$var$da, az, dz, -ez, $497b1b14513d5a3b$var$dea);
    const eablen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$ea, $497b1b14513d5a3b$var$ab, $497b1b14513d5a3b$var$eb, bz, ez, -az, $497b1b14513d5a3b$var$eab);
    const abdlen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$ab, $497b1b14513d5a3b$var$bd, $497b1b14513d5a3b$var$da, dz, az, bz, $497b1b14513d5a3b$var$abd);
    const bcelen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$bc, $497b1b14513d5a3b$var$ce, $497b1b14513d5a3b$var$eb, ez, bz, cz, $497b1b14513d5a3b$var$bce);
    const cdalen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$cd, $497b1b14513d5a3b$var$da, $497b1b14513d5a3b$var$ac, az, cz, dz, $497b1b14513d5a3b$var$cda);
    const deblen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$de, $497b1b14513d5a3b$var$eb, $497b1b14513d5a3b$var$bd, bz, dz, ez, $497b1b14513d5a3b$var$deb);
    const eaclen = $497b1b14513d5a3b$var$sum_three_scale($497b1b14513d5a3b$var$ea, $497b1b14513d5a3b$var$ac, $497b1b14513d5a3b$var$ce, cz, ez, az, $497b1b14513d5a3b$var$eac);
    const deterlen = (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)($497b1b14513d5a3b$var$liftexact(cdelen, $497b1b14513d5a3b$var$cde, bcelen, $497b1b14513d5a3b$var$bce, deblen, $497b1b14513d5a3b$var$deb, bcdlen, $497b1b14513d5a3b$var$bcd, ax, ay, az, $497b1b14513d5a3b$var$adet), $497b1b14513d5a3b$var$adet, $497b1b14513d5a3b$var$liftexact(dealen, $497b1b14513d5a3b$var$dea, cdalen, $497b1b14513d5a3b$var$cda, eaclen, $497b1b14513d5a3b$var$eac, cdelen, $497b1b14513d5a3b$var$cde, bx, by, bz, $497b1b14513d5a3b$var$bdet), $497b1b14513d5a3b$var$bdet, (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)($497b1b14513d5a3b$var$liftexact(eablen, $497b1b14513d5a3b$var$eab, deblen, $497b1b14513d5a3b$var$deb, abdlen, $497b1b14513d5a3b$var$abd, dealen, $497b1b14513d5a3b$var$dea, cx, cy, cz, $497b1b14513d5a3b$var$cdet), $497b1b14513d5a3b$var$cdet, $497b1b14513d5a3b$var$liftexact(abclen, $497b1b14513d5a3b$var$abc, eaclen, $497b1b14513d5a3b$var$eac, bcelen, $497b1b14513d5a3b$var$bce, eablen, $497b1b14513d5a3b$var$eab, dx, dy, dz, $497b1b14513d5a3b$var$ddet), $497b1b14513d5a3b$var$ddet, $497b1b14513d5a3b$var$liftexact(bcdlen, $497b1b14513d5a3b$var$bcd, abdlen, $497b1b14513d5a3b$var$abd, cdalen, $497b1b14513d5a3b$var$cda, abclen, $497b1b14513d5a3b$var$abc, ex, ey, ez, $497b1b14513d5a3b$var$edet), $497b1b14513d5a3b$var$edet, $497b1b14513d5a3b$var$cddet, $497b1b14513d5a3b$var$cdedet), $497b1b14513d5a3b$var$cdedet, $497b1b14513d5a3b$var$abdet, $497b1b14513d5a3b$var$deter);
    return $497b1b14513d5a3b$var$deter[deterlen - 1];
}
const $497b1b14513d5a3b$var$xdet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(96);
const $497b1b14513d5a3b$var$ydet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(96);
const $497b1b14513d5a3b$var$zdet = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(96);
const $497b1b14513d5a3b$var$fin = (0, $cd8c7db27df393a9$export$202e0172ed3c7be0)(1152);
function $497b1b14513d5a3b$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $497b1b14513d5a3b$var$sum_three_scale(a, b, c, az, bz, cz, $497b1b14513d5a3b$var$_24);
    return (0, $cd8c7db27df393a9$export$195a93e4bd4d876f)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $497b1b14513d5a3b$var$_24, x, $497b1b14513d5a3b$var$_48), $497b1b14513d5a3b$var$_48, x, $497b1b14513d5a3b$var$xdet), $497b1b14513d5a3b$var$xdet, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $497b1b14513d5a3b$var$_24, y, $497b1b14513d5a3b$var$_48), $497b1b14513d5a3b$var$_48, y, $497b1b14513d5a3b$var$ydet), $497b1b14513d5a3b$var$ydet, (0, $cd8c7db27df393a9$export$dcdf75081b88279d)((0, $cd8c7db27df393a9$export$dcdf75081b88279d)(len, $497b1b14513d5a3b$var$_24, z, $497b1b14513d5a3b$var$_48), $497b1b14513d5a3b$var$_48, z, $497b1b14513d5a3b$var$zdet), $497b1b14513d5a3b$var$zdet, $497b1b14513d5a3b$var$_192, out);
}
function $497b1b14513d5a3b$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $497b1b14513d5a3b$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $497b1b14513d5a3b$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $497b1b14513d5a3b$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $497b1b14513d5a3b$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $497b1b14513d5a3b$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $cd8c7db27df393a9$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $497b1b14513d5a3b$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $497b1b14513d5a3b$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $497b1b14513d5a3b$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $497b1b14513d5a3b$var$bd[3] = bd3;
    const finlen = (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$aef51622e549b8b0)($497b1b14513d5a3b$var$liftadapt($497b1b14513d5a3b$var$bc, $497b1b14513d5a3b$var$cd, $497b1b14513d5a3b$var$bd, dez, bez, -cez, aex, aey, aez, $497b1b14513d5a3b$var$adet), $497b1b14513d5a3b$var$adet), $497b1b14513d5a3b$var$adet, $497b1b14513d5a3b$var$liftadapt($497b1b14513d5a3b$var$cd, $497b1b14513d5a3b$var$da, $497b1b14513d5a3b$var$ac, aez, cez, dez, bex, bey, bez, $497b1b14513d5a3b$var$bdet), $497b1b14513d5a3b$var$bdet, $497b1b14513d5a3b$var$abdet), $497b1b14513d5a3b$var$abdet, (0, $cd8c7db27df393a9$export$8a63f25cc62965f1)((0, $cd8c7db27df393a9$export$aef51622e549b8b0)($497b1b14513d5a3b$var$liftadapt($497b1b14513d5a3b$var$da, $497b1b14513d5a3b$var$ab, $497b1b14513d5a3b$var$bd, bez, dez, aez, cex, cey, cez, $497b1b14513d5a3b$var$cdet), $497b1b14513d5a3b$var$cdet), $497b1b14513d5a3b$var$cdet, $497b1b14513d5a3b$var$liftadapt($497b1b14513d5a3b$var$ab, $497b1b14513d5a3b$var$bc, $497b1b14513d5a3b$var$ac, cez, aez, -bez, dex, dey, dez, $497b1b14513d5a3b$var$ddet), $497b1b14513d5a3b$var$ddet, $497b1b14513d5a3b$var$cddet), $497b1b14513d5a3b$var$cddet, $497b1b14513d5a3b$var$fin);
    let det = (0, $cd8c7db27df393a9$export$9f3a0795ca2cc944)(finlen, $497b1b14513d5a3b$var$fin);
    let errbound = $497b1b14513d5a3b$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $497b1b14513d5a3b$var$isperrboundC * permanent + (0, $cd8c7db27df393a9$export$a4103c3ab16b06d7) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $497b1b14513d5a3b$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $497b1b14513d5a3b$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = $497b1b14513d5a3b$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$497b1b14513d5a3b$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $497b1b14513d5a3b$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}




const $7910d402b5fcb5cd$var$EPSILON = Math.pow(2, -52);
const $7910d402b5fcb5cd$var$EDGE_STACK = new Uint32Array(512);
class $7910d402b5fcb5cd$export$2e2bcd8739ae039 {
    static from(points, getX = $7910d402b5fcb5cd$var$defaultGetX, getY = $7910d402b5fcb5cd$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $7910d402b5fcb5cd$export$2e2bcd8739ae039(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0, minDist = Infinity; i < n; i++){
            const d = $7910d402b5fcb5cd$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        // find the point closest to the seed
        for(let i = 0, minDist = Infinity; i < n; i++){
            if (i === i0) continue;
            const d = $7910d402b5fcb5cd$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $7910d402b5fcb5cd$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $7910d402b5fcb5cd$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                const d = this._dists[id];
                if (d > d0) {
                    hull[j++] = id;
                    d0 = d;
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, $8256862f22a4cb47$export$bbb923599a46a7d8)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $7910d402b5fcb5cd$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $7910d402b5fcb5cd$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $7910d402b5fcb5cd$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $7910d402b5fcb5cd$var$EPSILON && Math.abs(y - yp) <= $7910d402b5fcb5cd$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, $8256862f22a4cb47$export$bbb923599a46a7d8)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, $8256862f22a4cb47$export$bbb923599a46a7d8)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, $8256862f22a4cb47$export$bbb923599a46a7d8)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($7910d402b5fcb5cd$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $7910d402b5fcb5cd$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $7910d402b5fcb5cd$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $7910d402b5fcb5cd$var$EDGE_STACK.length) $7910d402b5fcb5cd$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $7910d402b5fcb5cd$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $7910d402b5fcb5cd$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $7910d402b5fcb5cd$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function $7910d402b5fcb5cd$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $7910d402b5fcb5cd$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $7910d402b5fcb5cd$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $7910d402b5fcb5cd$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $7910d402b5fcb5cd$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $7910d402b5fcb5cd$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $7910d402b5fcb5cd$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $7910d402b5fcb5cd$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $7910d402b5fcb5cd$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $7910d402b5fcb5cd$var$quicksort(ids, dists, i, right);
            $7910d402b5fcb5cd$var$quicksort(ids, dists, left, j - 1);
        } else {
            $7910d402b5fcb5cd$var$quicksort(ids, dists, left, j - 1);
            $7910d402b5fcb5cd$var$quicksort(ids, dists, i, right);
        }
    }
}
function $7910d402b5fcb5cd$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $7910d402b5fcb5cd$var$defaultGetX(p) {
    return p[0];
}
function $7910d402b5fcb5cd$var$defaultGetY(p) {
    return p[1];
}


// index.ts
const $e3a5595367bfa77e$export$6c421550c66a327d = 1.1102230246251565e-16;
const $e3a5595367bfa77e$export$8cfde575cbd41e40 = 134217729;
const $e3a5595367bfa77e$export$a4103c3ab16b06d7 = (3 + 8 * $e3a5595367bfa77e$export$6c421550c66a327d) * $e3a5595367bfa77e$export$6c421550c66a327d;
function $e3a5595367bfa77e$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $e3a5595367bfa77e$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $e3a5595367bfa77e$export$8a63f25cc62965f1($e3a5595367bfa77e$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $e3a5595367bfa77e$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $e3a5595367bfa77e$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $e3a5595367bfa77e$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $e3a5595367bfa77e$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $e3a5595367bfa77e$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $e3a5595367bfa77e$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $e3a5595367bfa77e$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}


const $9cf2b8a967370fc2$var$ccwerrboundA = (3 + 16 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $9cf2b8a967370fc2$var$ccwerrboundB = (2 + 12 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $9cf2b8a967370fc2$var$ccwerrboundC = (9 + 64 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $9cf2b8a967370fc2$var$B = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $9cf2b8a967370fc2$var$C1 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $9cf2b8a967370fc2$var$C2 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(12);
const $9cf2b8a967370fc2$var$D = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(16);
const $9cf2b8a967370fc2$var$u = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
function $9cf2b8a967370fc2$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $9cf2b8a967370fc2$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $9cf2b8a967370fc2$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $9cf2b8a967370fc2$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $9cf2b8a967370fc2$var$B[3] = u3;
    let det = (0, $e3a5595367bfa77e$export$9f3a0795ca2cc944)(4, $9cf2b8a967370fc2$var$B);
    let errbound = $9cf2b8a967370fc2$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $9cf2b8a967370fc2$var$ccwerrboundC * detsum + (0, $e3a5595367bfa77e$export$a4103c3ab16b06d7) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $9cf2b8a967370fc2$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $9cf2b8a967370fc2$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $9cf2b8a967370fc2$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $9cf2b8a967370fc2$var$u[3] = u3;
    const C1len = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(4, $9cf2b8a967370fc2$var$B, 4, $9cf2b8a967370fc2$var$u, $9cf2b8a967370fc2$var$C1);
    s1 = acx * bcytail;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $9cf2b8a967370fc2$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $9cf2b8a967370fc2$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $9cf2b8a967370fc2$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $9cf2b8a967370fc2$var$u[3] = u3;
    const C2len = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(C1len, $9cf2b8a967370fc2$var$C1, 4, $9cf2b8a967370fc2$var$u, $9cf2b8a967370fc2$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $9cf2b8a967370fc2$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $9cf2b8a967370fc2$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $9cf2b8a967370fc2$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $9cf2b8a967370fc2$var$u[3] = u3;
    const Dlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(C2len, $9cf2b8a967370fc2$var$C2, 4, $9cf2b8a967370fc2$var$u, $9cf2b8a967370fc2$var$D);
    return $9cf2b8a967370fc2$var$D[Dlen - 1];
}
function $9cf2b8a967370fc2$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $9cf2b8a967370fc2$var$ccwerrboundA * detsum) return det;
    return -$9cf2b8a967370fc2$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $9cf2b8a967370fc2$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}



const $184c435afbe03074$var$o3derrboundA = (7 + 56 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $184c435afbe03074$var$o3derrboundB = (3 + 28 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $184c435afbe03074$var$o3derrboundC = (26 + 288 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $184c435afbe03074$var$bc = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$ca = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$ab = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$at_b = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$at_c = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$bt_c = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$bt_a = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$ct_a = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$ct_b = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$bct = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $184c435afbe03074$var$cat = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $184c435afbe03074$var$abt = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $184c435afbe03074$var$u = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $184c435afbe03074$var$_8 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $184c435afbe03074$var$_8b = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $184c435afbe03074$var$_16 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $184c435afbe03074$var$_12 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(12);
let $184c435afbe03074$var$fin = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(192);
let $184c435afbe03074$var$fin2 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(192);
function $184c435afbe03074$var$finadd(finlen, alen, a) {
    finlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(finlen, $184c435afbe03074$var$fin, alen, a, $184c435afbe03074$var$fin2);
    const tmp = $184c435afbe03074$var$fin;
    $184c435afbe03074$var$fin = $184c435afbe03074$var$fin2;
    $184c435afbe03074$var$fin2 = tmp;
    return finlen;
}
function $184c435afbe03074$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $184c435afbe03074$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $184c435afbe03074$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $184c435afbe03074$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $184c435afbe03074$var$u[2] = _k - (u3 - _j);
    $184c435afbe03074$var$u[3] = u3;
    finlen = $184c435afbe03074$var$finadd(finlen, 4, $184c435afbe03074$var$u);
    if (z !== 0) {
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $184c435afbe03074$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $184c435afbe03074$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $184c435afbe03074$var$u[2] = _k - (u3 - _j);
        $184c435afbe03074$var$u[3] = u3;
        finlen = $184c435afbe03074$var$finadd(finlen, 4, $184c435afbe03074$var$u);
    }
    return finlen;
}
function $184c435afbe03074$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $184c435afbe03074$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $184c435afbe03074$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $184c435afbe03074$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $184c435afbe03074$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $184c435afbe03074$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $184c435afbe03074$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $184c435afbe03074$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $184c435afbe03074$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $184c435afbe03074$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $184c435afbe03074$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $184c435afbe03074$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $184c435afbe03074$var$ab[3] = u3;
    finlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $184c435afbe03074$var$bc, adz, $184c435afbe03074$var$_8), $184c435afbe03074$var$_8, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $184c435afbe03074$var$ca, bdz, $184c435afbe03074$var$_8b), $184c435afbe03074$var$_8b, $184c435afbe03074$var$_16), $184c435afbe03074$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $184c435afbe03074$var$ab, cdz, $184c435afbe03074$var$_8), $184c435afbe03074$var$_8, $184c435afbe03074$var$fin);
    let det = (0, $e3a5595367bfa77e$export$9f3a0795ca2cc944)(finlen, $184c435afbe03074$var$fin);
    let errbound = $184c435afbe03074$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $184c435afbe03074$var$o3derrboundC * permanent + (0, $e3a5595367bfa77e$export$a4103c3ab16b06d7) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $184c435afbe03074$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $184c435afbe03074$var$at_b, $184c435afbe03074$var$at_c);
    const bt_len = $184c435afbe03074$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $184c435afbe03074$var$bt_c, $184c435afbe03074$var$bt_a);
    const ct_len = $184c435afbe03074$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $184c435afbe03074$var$ct_a, $184c435afbe03074$var$ct_b);
    const bctlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(bt_len, $184c435afbe03074$var$bt_c, ct_len, $184c435afbe03074$var$ct_b, $184c435afbe03074$var$bct);
    finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bctlen, $184c435afbe03074$var$bct, adz, $184c435afbe03074$var$_16), $184c435afbe03074$var$_16);
    const catlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(ct_len, $184c435afbe03074$var$ct_a, at_len, $184c435afbe03074$var$at_c, $184c435afbe03074$var$cat);
    finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(catlen, $184c435afbe03074$var$cat, bdz, $184c435afbe03074$var$_16), $184c435afbe03074$var$_16);
    const abtlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(at_len, $184c435afbe03074$var$at_b, bt_len, $184c435afbe03074$var$bt_a, $184c435afbe03074$var$abt);
    finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(abtlen, $184c435afbe03074$var$abt, cdz, $184c435afbe03074$var$_16), $184c435afbe03074$var$_16);
    if (adztail !== 0) {
        finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $184c435afbe03074$var$bc, adztail, $184c435afbe03074$var$_12), $184c435afbe03074$var$_12);
        finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bctlen, $184c435afbe03074$var$bct, adztail, $184c435afbe03074$var$_16), $184c435afbe03074$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $184c435afbe03074$var$ca, bdztail, $184c435afbe03074$var$_12), $184c435afbe03074$var$_12);
        finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(catlen, $184c435afbe03074$var$cat, bdztail, $184c435afbe03074$var$_16), $184c435afbe03074$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $184c435afbe03074$var$ab, cdztail, $184c435afbe03074$var$_12), $184c435afbe03074$var$_12);
        finlen = $184c435afbe03074$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(abtlen, $184c435afbe03074$var$abt, cdztail, $184c435afbe03074$var$_16), $184c435afbe03074$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $184c435afbe03074$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $184c435afbe03074$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $184c435afbe03074$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $184c435afbe03074$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $184c435afbe03074$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $184c435afbe03074$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $184c435afbe03074$var$fin[finlen - 1];
}
function $184c435afbe03074$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $184c435afbe03074$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $184c435afbe03074$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $184c435afbe03074$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}



const $748acccf4da8a531$var$iccerrboundA = (10 + 96 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $748acccf4da8a531$var$iccerrboundB = (4 + 48 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $748acccf4da8a531$var$iccerrboundC = (44 + 576 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $748acccf4da8a531$var$bc = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$ca = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$ab = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$aa = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$bb = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$cc = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$u = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$v = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$axtbc = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$aytbc = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$bxtca = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$bytca = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$cxtab = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$cytab = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$abt = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$bct = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$cat = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$abtt = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$bctt = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$catt = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $748acccf4da8a531$var$_8 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $748acccf4da8a531$var$_16 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(16);
const $748acccf4da8a531$var$_16b = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(16);
const $748acccf4da8a531$var$_16c = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(16);
const $748acccf4da8a531$var$_32 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(32);
const $748acccf4da8a531$var$_32b = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(32);
const $748acccf4da8a531$var$_48 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(48);
const $748acccf4da8a531$var$_64 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(64);
let $748acccf4da8a531$var$fin = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
let $748acccf4da8a531$var$fin2 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
function $748acccf4da8a531$var$finadd(finlen, a, alen) {
    finlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(finlen, $748acccf4da8a531$var$fin, a, alen, $748acccf4da8a531$var$fin2);
    const tmp = $748acccf4da8a531$var$fin;
    $748acccf4da8a531$var$fin = $748acccf4da8a531$var$fin2;
    $748acccf4da8a531$var$fin2 = tmp;
    return finlen;
}
function $748acccf4da8a531$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $748acccf4da8a531$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $748acccf4da8a531$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $748acccf4da8a531$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $748acccf4da8a531$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $748acccf4da8a531$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $748acccf4da8a531$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $748acccf4da8a531$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $748acccf4da8a531$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $748acccf4da8a531$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $748acccf4da8a531$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $748acccf4da8a531$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $748acccf4da8a531$var$ab[3] = u3;
    finlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bc, adx, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, adx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bc, ady, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, ady, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ca, bdx, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, bdx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ca, bdy, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, bdy, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, $748acccf4da8a531$var$_32b), $748acccf4da8a531$var$_32b, $748acccf4da8a531$var$_64), $748acccf4da8a531$var$_64, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ab, cdx, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, cdx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ab, cdy, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, cdy, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$fin);
    let det = (0, $e3a5595367bfa77e$export$9f3a0795ca2cc944)(finlen, $748acccf4da8a531$var$fin);
    let errbound = $748acccf4da8a531$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $748acccf4da8a531$var$iccerrboundC * permanent + (0, $e3a5595367bfa77e$export$a4103c3ab16b06d7) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $748acccf4da8a531$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $748acccf4da8a531$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $748acccf4da8a531$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $748acccf4da8a531$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $748acccf4da8a531$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $748acccf4da8a531$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $748acccf4da8a531$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $748acccf4da8a531$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $748acccf4da8a531$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $748acccf4da8a531$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $748acccf4da8a531$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $748acccf4da8a531$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bc, adxtail, $748acccf4da8a531$var$axtbc);
        finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(axtbclen, $748acccf4da8a531$var$axtbc, 2 * adx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$cc, adxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, bdy, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bb, adxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, -cdy, $748acccf4da8a531$var$_16c), $748acccf4da8a531$var$_16c, $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bc, adytail, $748acccf4da8a531$var$aytbc);
        finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(aytbclen, $748acccf4da8a531$var$aytbc, 2 * ady, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bb, adytail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, cdx, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$cc, adytail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, -bdx, $748acccf4da8a531$var$_16c), $748acccf4da8a531$var$_16c, $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ca, bdxtail, $748acccf4da8a531$var$bxtca);
        finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bxtcalen, $748acccf4da8a531$var$bxtca, 2 * bdx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$aa, bdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, cdy, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$cc, bdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, -ady, $748acccf4da8a531$var$_16c), $748acccf4da8a531$var$_16c, $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ca, bdytail, $748acccf4da8a531$var$bytca);
        finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bytcalen, $748acccf4da8a531$var$bytca, 2 * bdy, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$cc, bdytail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, adx, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$aa, bdytail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, -cdx, $748acccf4da8a531$var$_16c), $748acccf4da8a531$var$_16c, $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ab, cdxtail, $748acccf4da8a531$var$cxtab);
        finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(cxtablen, $748acccf4da8a531$var$cxtab, 2 * cdx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bb, cdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, ady, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$aa, cdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, -bdy, $748acccf4da8a531$var$_16c), $748acccf4da8a531$var$_16c, $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$ab, cdytail, $748acccf4da8a531$var$cytab);
        finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(cytablen, $748acccf4da8a531$var$cytab, 2 * cdy, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$aa, cdytail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, bdx, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bb, cdytail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, -adx, $748acccf4da8a531$var$_16c), $748acccf4da8a531$var$_16c, $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $748acccf4da8a531$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $748acccf4da8a531$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $748acccf4da8a531$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $748acccf4da8a531$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$v[3] = u3;
            bctlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(4, $748acccf4da8a531$var$u, 4, $748acccf4da8a531$var$v, $748acccf4da8a531$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $748acccf4da8a531$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $748acccf4da8a531$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $748acccf4da8a531$var$bct[0] = 0;
            bctlen = 1;
            $748acccf4da8a531$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bctlen, $748acccf4da8a531$var$bct, adxtail, $748acccf4da8a531$var$_16c);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(axtbclen, $748acccf4da8a531$var$axtbc, adxtail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, 2 * adx, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
            const len2 = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bcttlen, $748acccf4da8a531$var$bctt, adxtail, $748acccf4da8a531$var$_8);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, 2 * adx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, adxtail, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, adxtail, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_32b, $748acccf4da8a531$var$_64), $748acccf4da8a531$var$_64);
            if (bdytail !== 0) finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$cc, adxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, bdytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16);
            if (cdytail !== 0) finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bb, -adxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, cdytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bctlen, $748acccf4da8a531$var$bct, adytail, $748acccf4da8a531$var$_16c);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(aytbclen, $748acccf4da8a531$var$aytbc, adytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, 2 * ady, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
            const len2 = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bcttlen, $748acccf4da8a531$var$bctt, adytail, $748acccf4da8a531$var$_8);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, 2 * ady, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, adytail, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, adytail, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_32b, $748acccf4da8a531$var$_64), $748acccf4da8a531$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $748acccf4da8a531$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $748acccf4da8a531$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $748acccf4da8a531$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $748acccf4da8a531$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$v[3] = u3;
            catlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(4, $748acccf4da8a531$var$u, 4, $748acccf4da8a531$var$v, $748acccf4da8a531$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $748acccf4da8a531$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $748acccf4da8a531$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $748acccf4da8a531$var$cat[0] = 0;
            catlen = 1;
            $748acccf4da8a531$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(catlen, $748acccf4da8a531$var$cat, bdxtail, $748acccf4da8a531$var$_16c);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bxtcalen, $748acccf4da8a531$var$bxtca, bdxtail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, 2 * bdx, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
            const len2 = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(cattlen, $748acccf4da8a531$var$catt, bdxtail, $748acccf4da8a531$var$_8);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, 2 * bdx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, bdxtail, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, bdxtail, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_32b, $748acccf4da8a531$var$_64), $748acccf4da8a531$var$_64);
            if (cdytail !== 0) finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$aa, bdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, cdytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16);
            if (adytail !== 0) finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$cc, -bdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, adytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(catlen, $748acccf4da8a531$var$cat, bdytail, $748acccf4da8a531$var$_16c);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(bytcalen, $748acccf4da8a531$var$bytca, bdytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, 2 * bdy, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
            const len2 = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(cattlen, $748acccf4da8a531$var$catt, bdytail, $748acccf4da8a531$var$_8);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, 2 * bdy, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, bdytail, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, bdytail, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_32b, $748acccf4da8a531$var$_64), $748acccf4da8a531$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $748acccf4da8a531$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $748acccf4da8a531$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $748acccf4da8a531$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $748acccf4da8a531$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$v[3] = u3;
            abtlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(4, $748acccf4da8a531$var$u, 4, $748acccf4da8a531$var$v, $748acccf4da8a531$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $748acccf4da8a531$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $748acccf4da8a531$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $748acccf4da8a531$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $748acccf4da8a531$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $748acccf4da8a531$var$abt[0] = 0;
            abtlen = 1;
            $748acccf4da8a531$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(abtlen, $748acccf4da8a531$var$abt, cdxtail, $748acccf4da8a531$var$_16c);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(cxtablen, $748acccf4da8a531$var$cxtab, cdxtail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, 2 * cdx, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
            const len2 = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(abttlen, $748acccf4da8a531$var$abtt, cdxtail, $748acccf4da8a531$var$_8);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, 2 * cdx, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, cdxtail, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, cdxtail, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_32b, $748acccf4da8a531$var$_64), $748acccf4da8a531$var$_64);
            if (adytail !== 0) finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$bb, cdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, adytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16);
            if (bdytail !== 0) finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, $748acccf4da8a531$var$aa, -cdxtail, $748acccf4da8a531$var$_8), $748acccf4da8a531$var$_8, bdytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(abtlen, $748acccf4da8a531$var$abt, cdytail, $748acccf4da8a531$var$_16c);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(cytablen, $748acccf4da8a531$var$cytab, cdytail, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, 2 * cdy, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_48), $748acccf4da8a531$var$_48);
            const len2 = (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(abttlen, $748acccf4da8a531$var$abtt, cdytail, $748acccf4da8a531$var$_8);
            finlen = $748acccf4da8a531$var$finadd(finlen, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, 2 * cdy, $748acccf4da8a531$var$_16), $748acccf4da8a531$var$_16, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len2, $748acccf4da8a531$var$_8, cdytail, $748acccf4da8a531$var$_16b), $748acccf4da8a531$var$_16b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $748acccf4da8a531$var$_16c, cdytail, $748acccf4da8a531$var$_32), $748acccf4da8a531$var$_32, $748acccf4da8a531$var$_32b, $748acccf4da8a531$var$_64), $748acccf4da8a531$var$_64);
        }
    }
    return $748acccf4da8a531$var$fin[finlen - 1];
}
function $748acccf4da8a531$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $748acccf4da8a531$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $748acccf4da8a531$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $748acccf4da8a531$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}



const $47fce13e7edc4823$var$isperrboundA = (16 + 224 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $47fce13e7edc4823$var$isperrboundB = (5 + 72 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $47fce13e7edc4823$var$isperrboundC = (71 + 1408 * (0, $e3a5595367bfa77e$export$6c421550c66a327d)) * (0, $e3a5595367bfa77e$export$6c421550c66a327d) * (0, $e3a5595367bfa77e$export$6c421550c66a327d);
const $47fce13e7edc4823$var$ab = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$bc = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$cd = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$de = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$ea = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$ac = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$bd = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$ce = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$da = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$eb = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(4);
const $47fce13e7edc4823$var$abc = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$bcd = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$cde = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$dea = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$eab = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$abd = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$bce = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$cda = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$deb = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$eac = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$adet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
const $47fce13e7edc4823$var$bdet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
const $47fce13e7edc4823$var$cdet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
const $47fce13e7edc4823$var$ddet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
const $47fce13e7edc4823$var$edet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
const $47fce13e7edc4823$var$abdet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(2304);
const $47fce13e7edc4823$var$cddet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(2304);
const $47fce13e7edc4823$var$cdedet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(3456);
const $47fce13e7edc4823$var$deter = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(5760);
const $47fce13e7edc4823$var$_8 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $47fce13e7edc4823$var$_8b = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $47fce13e7edc4823$var$_8c = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(8);
const $47fce13e7edc4823$var$_16 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(16);
const $47fce13e7edc4823$var$_24 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(24);
const $47fce13e7edc4823$var$_48 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(48);
const $47fce13e7edc4823$var$_48b = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(48);
const $47fce13e7edc4823$var$_96 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(96);
const $47fce13e7edc4823$var$_192 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(192);
const $47fce13e7edc4823$var$_384x = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(384);
const $47fce13e7edc4823$var$_384y = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(384);
const $47fce13e7edc4823$var$_384z = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(384);
const $47fce13e7edc4823$var$_768 = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(768);
function $47fce13e7edc4823$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, a, az, $47fce13e7edc4823$var$_8), $47fce13e7edc4823$var$_8, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, b, bz, $47fce13e7edc4823$var$_8b), $47fce13e7edc4823$var$_8b, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)(4, c, cz, $47fce13e7edc4823$var$_8c), $47fce13e7edc4823$var$_8c, $47fce13e7edc4823$var$_16, out);
}
function $47fce13e7edc4823$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(alen, a, blen, b, $47fce13e7edc4823$var$_48), $47fce13e7edc4823$var$_48, (0, $e3a5595367bfa77e$export$aef51622e549b8b0)((0, $e3a5595367bfa77e$export$8a63f25cc62965f1)(clen, c, dlen, d, $47fce13e7edc4823$var$_48b), $47fce13e7edc4823$var$_48b), $47fce13e7edc4823$var$_48b, $47fce13e7edc4823$var$_96);
    return (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $47fce13e7edc4823$var$_96, x, $47fce13e7edc4823$var$_192), $47fce13e7edc4823$var$_192, x, $47fce13e7edc4823$var$_384x), $47fce13e7edc4823$var$_384x, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $47fce13e7edc4823$var$_96, y, $47fce13e7edc4823$var$_192), $47fce13e7edc4823$var$_192, y, $47fce13e7edc4823$var$_384y), $47fce13e7edc4823$var$_384y, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $47fce13e7edc4823$var$_96, z, $47fce13e7edc4823$var$_192), $47fce13e7edc4823$var$_192, z, $47fce13e7edc4823$var$_384z), $47fce13e7edc4823$var$_384z, $47fce13e7edc4823$var$_768, out);
}
function $47fce13e7edc4823$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $47fce13e7edc4823$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$eb[3] = u3;
    const abclen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$ab, $47fce13e7edc4823$var$bc, $47fce13e7edc4823$var$ac, cz, az, -bz, $47fce13e7edc4823$var$abc);
    const bcdlen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$bc, $47fce13e7edc4823$var$cd, $47fce13e7edc4823$var$bd, dz, bz, -cz, $47fce13e7edc4823$var$bcd);
    const cdelen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$cd, $47fce13e7edc4823$var$de, $47fce13e7edc4823$var$ce, ez, cz, -dz, $47fce13e7edc4823$var$cde);
    const dealen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$de, $47fce13e7edc4823$var$ea, $47fce13e7edc4823$var$da, az, dz, -ez, $47fce13e7edc4823$var$dea);
    const eablen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$ea, $47fce13e7edc4823$var$ab, $47fce13e7edc4823$var$eb, bz, ez, -az, $47fce13e7edc4823$var$eab);
    const abdlen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$ab, $47fce13e7edc4823$var$bd, $47fce13e7edc4823$var$da, dz, az, bz, $47fce13e7edc4823$var$abd);
    const bcelen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$bc, $47fce13e7edc4823$var$ce, $47fce13e7edc4823$var$eb, ez, bz, cz, $47fce13e7edc4823$var$bce);
    const cdalen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$cd, $47fce13e7edc4823$var$da, $47fce13e7edc4823$var$ac, az, cz, dz, $47fce13e7edc4823$var$cda);
    const deblen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$de, $47fce13e7edc4823$var$eb, $47fce13e7edc4823$var$bd, bz, dz, ez, $47fce13e7edc4823$var$deb);
    const eaclen = $47fce13e7edc4823$var$sum_three_scale($47fce13e7edc4823$var$ea, $47fce13e7edc4823$var$ac, $47fce13e7edc4823$var$ce, cz, ez, az, $47fce13e7edc4823$var$eac);
    const deterlen = (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)($47fce13e7edc4823$var$liftexact(cdelen, $47fce13e7edc4823$var$cde, bcelen, $47fce13e7edc4823$var$bce, deblen, $47fce13e7edc4823$var$deb, bcdlen, $47fce13e7edc4823$var$bcd, ax, ay, az, $47fce13e7edc4823$var$adet), $47fce13e7edc4823$var$adet, $47fce13e7edc4823$var$liftexact(dealen, $47fce13e7edc4823$var$dea, cdalen, $47fce13e7edc4823$var$cda, eaclen, $47fce13e7edc4823$var$eac, cdelen, $47fce13e7edc4823$var$cde, bx, by, bz, $47fce13e7edc4823$var$bdet), $47fce13e7edc4823$var$bdet, (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)($47fce13e7edc4823$var$liftexact(eablen, $47fce13e7edc4823$var$eab, deblen, $47fce13e7edc4823$var$deb, abdlen, $47fce13e7edc4823$var$abd, dealen, $47fce13e7edc4823$var$dea, cx, cy, cz, $47fce13e7edc4823$var$cdet), $47fce13e7edc4823$var$cdet, $47fce13e7edc4823$var$liftexact(abclen, $47fce13e7edc4823$var$abc, eaclen, $47fce13e7edc4823$var$eac, bcelen, $47fce13e7edc4823$var$bce, eablen, $47fce13e7edc4823$var$eab, dx, dy, dz, $47fce13e7edc4823$var$ddet), $47fce13e7edc4823$var$ddet, $47fce13e7edc4823$var$liftexact(bcdlen, $47fce13e7edc4823$var$bcd, abdlen, $47fce13e7edc4823$var$abd, cdalen, $47fce13e7edc4823$var$cda, abclen, $47fce13e7edc4823$var$abc, ex, ey, ez, $47fce13e7edc4823$var$edet), $47fce13e7edc4823$var$edet, $47fce13e7edc4823$var$cddet, $47fce13e7edc4823$var$cdedet), $47fce13e7edc4823$var$cdedet, $47fce13e7edc4823$var$abdet, $47fce13e7edc4823$var$deter);
    return $47fce13e7edc4823$var$deter[deterlen - 1];
}
const $47fce13e7edc4823$var$xdet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(96);
const $47fce13e7edc4823$var$ydet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(96);
const $47fce13e7edc4823$var$zdet = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(96);
const $47fce13e7edc4823$var$fin = (0, $e3a5595367bfa77e$export$202e0172ed3c7be0)(1152);
function $47fce13e7edc4823$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $47fce13e7edc4823$var$sum_three_scale(a, b, c, az, bz, cz, $47fce13e7edc4823$var$_24);
    return (0, $e3a5595367bfa77e$export$195a93e4bd4d876f)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $47fce13e7edc4823$var$_24, x, $47fce13e7edc4823$var$_48), $47fce13e7edc4823$var$_48, x, $47fce13e7edc4823$var$xdet), $47fce13e7edc4823$var$xdet, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $47fce13e7edc4823$var$_24, y, $47fce13e7edc4823$var$_48), $47fce13e7edc4823$var$_48, y, $47fce13e7edc4823$var$ydet), $47fce13e7edc4823$var$ydet, (0, $e3a5595367bfa77e$export$dcdf75081b88279d)((0, $e3a5595367bfa77e$export$dcdf75081b88279d)(len, $47fce13e7edc4823$var$_24, z, $47fce13e7edc4823$var$_48), $47fce13e7edc4823$var$_48, z, $47fce13e7edc4823$var$zdet), $47fce13e7edc4823$var$zdet, $47fce13e7edc4823$var$_192, out);
}
function $47fce13e7edc4823$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $47fce13e7edc4823$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $47fce13e7edc4823$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $47fce13e7edc4823$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $47fce13e7edc4823$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $47fce13e7edc4823$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $e3a5595367bfa77e$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $47fce13e7edc4823$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $47fce13e7edc4823$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $47fce13e7edc4823$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $47fce13e7edc4823$var$bd[3] = bd3;
    const finlen = (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$aef51622e549b8b0)($47fce13e7edc4823$var$liftadapt($47fce13e7edc4823$var$bc, $47fce13e7edc4823$var$cd, $47fce13e7edc4823$var$bd, dez, bez, -cez, aex, aey, aez, $47fce13e7edc4823$var$adet), $47fce13e7edc4823$var$adet), $47fce13e7edc4823$var$adet, $47fce13e7edc4823$var$liftadapt($47fce13e7edc4823$var$cd, $47fce13e7edc4823$var$da, $47fce13e7edc4823$var$ac, aez, cez, dez, bex, bey, bez, $47fce13e7edc4823$var$bdet), $47fce13e7edc4823$var$bdet, $47fce13e7edc4823$var$abdet), $47fce13e7edc4823$var$abdet, (0, $e3a5595367bfa77e$export$8a63f25cc62965f1)((0, $e3a5595367bfa77e$export$aef51622e549b8b0)($47fce13e7edc4823$var$liftadapt($47fce13e7edc4823$var$da, $47fce13e7edc4823$var$ab, $47fce13e7edc4823$var$bd, bez, dez, aez, cex, cey, cez, $47fce13e7edc4823$var$cdet), $47fce13e7edc4823$var$cdet), $47fce13e7edc4823$var$cdet, $47fce13e7edc4823$var$liftadapt($47fce13e7edc4823$var$ab, $47fce13e7edc4823$var$bc, $47fce13e7edc4823$var$ac, cez, aez, -bez, dex, dey, dez, $47fce13e7edc4823$var$ddet), $47fce13e7edc4823$var$ddet, $47fce13e7edc4823$var$cddet), $47fce13e7edc4823$var$cddet, $47fce13e7edc4823$var$fin);
    let det = (0, $e3a5595367bfa77e$export$9f3a0795ca2cc944)(finlen, $47fce13e7edc4823$var$fin);
    let errbound = $47fce13e7edc4823$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $47fce13e7edc4823$var$isperrboundC * permanent + (0, $e3a5595367bfa77e$export$a4103c3ab16b06d7) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $47fce13e7edc4823$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $47fce13e7edc4823$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = $47fce13e7edc4823$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$47fce13e7edc4823$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $47fce13e7edc4823$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}




function $34005ece7b7eff14$export$2e2bcd8739ae039(p, polygon) {
    var i;
    var ii;
    var k = 0;
    var f;
    var u1;
    var v1;
    var u2;
    var v2;
    var currentP;
    var nextP;
    var x = p[0];
    var y = p[1];
    var numContours = polygon.length;
    for(i = 0; i < numContours; i++){
        ii = 0;
        var contour = polygon[i];
        var contourLen = contour.length - 1;
        currentP = contour[0];
        if (currentP[0] !== contour[contourLen][0] && currentP[1] !== contour[contourLen][1]) throw new Error('First and last coordinates in a ring must be the same');
        u1 = currentP[0] - x;
        v1 = currentP[1] - y;
        for(ii; ii < contourLen; ii++){
            nextP = contour[ii + 1];
            u2 = nextP[0] - x;
            v2 = nextP[1] - y;
            if (v1 === 0 && v2 === 0) {
                if (u2 <= 0 && u1 >= 0 || u1 <= 0 && u2 >= 0) return 0;
            } else if (v2 >= 0 && v1 <= 0 || v2 <= 0 && v1 >= 0) {
                f = (0, $9cf2b8a967370fc2$export$bbb923599a46a7d8)(u1, u2, v1, v2, 0, 0);
                if (f === 0) return 0;
                if (f > 0 && v2 > 0 && v1 <= 0 || f < 0 && v2 <= 0 && v1 > 0) k++;
            }
            currentP = nextP;
            v1 = v2;
            u1 = u2;
        }
    }
    if (k % 2 === 0) return false;
    return true;
}


// index.ts
// index.ts
var $10df5bd8be2dab96$export$e3a1ee0e9945697f = 63710088e-1;
var $10df5bd8be2dab96$export$f929e47acbed771a = {
    centimeters: $10df5bd8be2dab96$export$e3a1ee0e9945697f * 100,
    centimetres: $10df5bd8be2dab96$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $10df5bd8be2dab96$export$e3a1ee0e9945697f * 3.28084,
    inches: $10df5bd8be2dab96$export$e3a1ee0e9945697f * 39.37,
    kilometers: $10df5bd8be2dab96$export$e3a1ee0e9945697f / 1e3,
    kilometres: $10df5bd8be2dab96$export$e3a1ee0e9945697f / 1e3,
    meters: $10df5bd8be2dab96$export$e3a1ee0e9945697f,
    metres: $10df5bd8be2dab96$export$e3a1ee0e9945697f,
    miles: $10df5bd8be2dab96$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $10df5bd8be2dab96$export$e3a1ee0e9945697f * 1e3,
    millimetres: $10df5bd8be2dab96$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $10df5bd8be2dab96$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $10df5bd8be2dab96$export$e3a1ee0e9945697f * 1.0936
};
var $10df5bd8be2dab96$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $10df5bd8be2dab96$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $10df5bd8be2dab96$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $10df5bd8be2dab96$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $10df5bd8be2dab96$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $10df5bd8be2dab96$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $10df5bd8be2dab96$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $10df5bd8be2dab96$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $10df5bd8be2dab96$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$10df5bd8be2dab96$export$7e4aa119212bc614(coordinates[0]) || !$10df5bd8be2dab96$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options);
}
function $10df5bd8be2dab96$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $10df5bd8be2dab96$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $10df5bd8be2dab96$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $10df5bd8be2dab96$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options);
}
function $10df5bd8be2dab96$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $10df5bd8be2dab96$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $10df5bd8be2dab96$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $10df5bd8be2dab96$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options);
}
function $10df5bd8be2dab96$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $10df5bd8be2dab96$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $10df5bd8be2dab96$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $10df5bd8be2dab96$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $10df5bd8be2dab96$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options);
}
function $10df5bd8be2dab96$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options);
}
function $10df5bd8be2dab96$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options);
}
function $10df5bd8be2dab96$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $10df5bd8be2dab96$export$ced6ed16dfd6a264(geom, properties, options);
}
function $10df5bd8be2dab96$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $10df5bd8be2dab96$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $10df5bd8be2dab96$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $10df5bd8be2dab96$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $10df5bd8be2dab96$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $10df5bd8be2dab96$export$c7a138e00a89bd01(distance, units) {
    return $10df5bd8be2dab96$export$c41dd2a8460d3196($10df5bd8be2dab96$export$a2280f7debae8f10(distance, units));
}
function $10df5bd8be2dab96$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $10df5bd8be2dab96$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function $10df5bd8be2dab96$export$c41dd2a8460d3196(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function $10df5bd8be2dab96$export$c9fcf1a7df975d78(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function $10df5bd8be2dab96$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $10df5bd8be2dab96$export$f234631d6a2eedf8($10df5bd8be2dab96$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $10df5bd8be2dab96$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $10df5bd8be2dab96$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $10df5bd8be2dab96$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $10df5bd8be2dab96$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $10df5bd8be2dab96$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $10df5bd8be2dab96$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$10df5bd8be2dab96$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $10df5bd8be2dab96$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


function $0d91db41cdc2b935$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return [
            ...coord.geometry.coordinates
        ];
        if (coord.type === "Point") return [
            ...coord.coordinates
        ];
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return [
        ...coord
    ];
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $0d91db41cdc2b935$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $0d91db41cdc2b935$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $10df5bd8be2dab96$export$7e4aa119212bc614)(coordinates[0]) && (0, $10df5bd8be2dab96$export$7e4aa119212bc614)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $0d91db41cdc2b935$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $0d91db41cdc2b935$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $0d91db41cdc2b935$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $0d91db41cdc2b935$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for (const feature of featureCollection.features){
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $0d91db41cdc2b935$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $0d91db41cdc2b935$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}


function $1c3c864bea0fedaa$export$ae7424f794b3544b(point, polygon, options = {}) {
    if (!point) throw new Error("point is required");
    if (!polygon) throw new Error("polygon is required");
    const pt = (0, $0d91db41cdc2b935$export$b4663c6e64a770bc)(point);
    const geom = (0, $0d91db41cdc2b935$export$b8f320eb9549c8fd)(polygon);
    const type = geom.type;
    const bbox = polygon.bbox;
    let polys = geom.coordinates;
    if (bbox && $1c3c864bea0fedaa$var$inBBox(pt, bbox) === false) return false;
    if (type === "Polygon") polys = [
        polys
    ];
    let result = false;
    for(var i = 0; i < polys.length; ++i){
        const polyResult = (0, $34005ece7b7eff14$export$2e2bcd8739ae039)(pt, polys[i]);
        if (polyResult === 0) return options.ignoreBoundary ? false : true;
        else if (polyResult) result = true;
    }
    return result;
}
function $1c3c864bea0fedaa$var$inBBox(pt, bbox) {
    return bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1];
}
var $1c3c864bea0fedaa$export$2e2bcd8739ae039 = $1c3c864bea0fedaa$export$ae7424f794b3544b;



// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $a916e9dbe534c36f$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $a916e9dbe534c36f$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $a916e9dbe534c36f$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $a916e9dbe534c36f$export$5a6391da70c130da(values, valueof) {
    const adder = new $a916e9dbe534c36f$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}


var $2c2d81b59d3d41e6$export$6c421550c66a327d = 1e-6;
var $2c2d81b59d3d41e6$export$92c06fba281fe81b = 1e-12;
var $2c2d81b59d3d41e6$export$18c7bea995a110f = Math.PI;
var $2c2d81b59d3d41e6$export$e51408a300e8929a = $2c2d81b59d3d41e6$export$18c7bea995a110f / 2;
var $2c2d81b59d3d41e6$export$c39a5cba78ea0fc2 = $2c2d81b59d3d41e6$export$18c7bea995a110f / 4;
var $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92 = $2c2d81b59d3d41e6$export$18c7bea995a110f * 2;
var $2c2d81b59d3d41e6$export$41fc368e1a942b97 = 180 / $2c2d81b59d3d41e6$export$18c7bea995a110f;
var $2c2d81b59d3d41e6$export$8449e153fbd325fc = $2c2d81b59d3d41e6$export$18c7bea995a110f / 180;
var $2c2d81b59d3d41e6$export$2335f513bbd82c6d = Math.abs;
var $2c2d81b59d3d41e6$export$628dc4eed22b0fbd = Math.atan;
var $2c2d81b59d3d41e6$export$b8b770ee6a0d9760 = Math.atan2;
var $2c2d81b59d3d41e6$export$50d414a77b60d802 = Math.cos;
var $2c2d81b59d3d41e6$export$803ce6b71a0a94b2 = Math.ceil;
var $2c2d81b59d3d41e6$export$b310ec824aaee37f = Math.exp;
var $2c2d81b59d3d41e6$export$a3fe094919f356fd = Math.floor;
var $2c2d81b59d3d41e6$export$f95c7888b62f8e9a = Math.hypot;
var $2c2d81b59d3d41e6$export$bef1f36f5486a6a3 = Math.log;
var $2c2d81b59d3d41e6$export$9c297f60e22e3389 = Math.pow;
var $2c2d81b59d3d41e6$export$5de3937cb4b592ed = Math.sin;
var $2c2d81b59d3d41e6$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $2c2d81b59d3d41e6$export$eba8049fb5020b81 = Math.sqrt;
var $2c2d81b59d3d41e6$export$fcdd3b0b3246a325 = Math.tan;
function $2c2d81b59d3d41e6$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $2c2d81b59d3d41e6$export$18c7bea995a110f : Math.acos(x);
}
function $2c2d81b59d3d41e6$export$41726bdb1fc63f(x) {
    return x > 1 ? $2c2d81b59d3d41e6$export$e51408a300e8929a : x < -1 ? -$2c2d81b59d3d41e6$export$e51408a300e8929a : Math.asin(x);
}
function $2c2d81b59d3d41e6$export$e808712c2966e662(x) {
    return (x = $2c2d81b59d3d41e6$export$5de3937cb4b592ed(x / 2)) * x;
}


function $9ea986972f46f1fc$export$2e2bcd8739ae039() {}


function $a5b0d016e8689c48$var$streamGeometry(geometry, stream) {
    if (geometry && $a5b0d016e8689c48$var$streamGeometryType.hasOwnProperty(geometry.type)) $a5b0d016e8689c48$var$streamGeometryType[geometry.type](geometry, stream);
}
var $a5b0d016e8689c48$var$streamObjectType = {
    Feature: function(object, stream) {
        $a5b0d016e8689c48$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$a5b0d016e8689c48$var$streamGeometry(features[i].geometry, stream);
    }
};
var $a5b0d016e8689c48$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $a5b0d016e8689c48$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$a5b0d016e8689c48$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $a5b0d016e8689c48$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$a5b0d016e8689c48$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$a5b0d016e8689c48$var$streamGeometry(geometries[i], stream);
    }
};
function $a5b0d016e8689c48$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $a5b0d016e8689c48$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$a5b0d016e8689c48$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $a5b0d016e8689c48$export$2e2bcd8739ae039(object, stream) {
    if (object && $a5b0d016e8689c48$var$streamObjectType.hasOwnProperty(object.type)) $a5b0d016e8689c48$var$streamObjectType[object.type](object, stream);
    else $a5b0d016e8689c48$var$streamGeometry(object, stream);
}


var $27eb59e3d76f1581$var$W0, $27eb59e3d76f1581$var$W1, $27eb59e3d76f1581$var$X0, $27eb59e3d76f1581$var$Y0, $27eb59e3d76f1581$var$Z0, $27eb59e3d76f1581$var$X1, $27eb59e3d76f1581$var$Y1, $27eb59e3d76f1581$var$Z1, $27eb59e3d76f1581$var$X2, $27eb59e3d76f1581$var$Y2, $27eb59e3d76f1581$var$Z2, $27eb59e3d76f1581$var$lambda00, $27eb59e3d76f1581$var$phi00, $27eb59e3d76f1581$var$x0, $27eb59e3d76f1581$var$y0, $27eb59e3d76f1581$var$z0; // previous point
var $27eb59e3d76f1581$var$centroidStream = {
    sphere: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    point: $27eb59e3d76f1581$var$centroidPoint,
    lineStart: $27eb59e3d76f1581$var$centroidLineStart,
    lineEnd: $27eb59e3d76f1581$var$centroidLineEnd,
    polygonStart: function() {
        $27eb59e3d76f1581$var$centroidStream.lineStart = $27eb59e3d76f1581$var$centroidRingStart;
        $27eb59e3d76f1581$var$centroidStream.lineEnd = $27eb59e3d76f1581$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $27eb59e3d76f1581$var$centroidStream.lineStart = $27eb59e3d76f1581$var$centroidLineStart;
        $27eb59e3d76f1581$var$centroidStream.lineEnd = $27eb59e3d76f1581$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $27eb59e3d76f1581$var$centroidPoint(lambda, phi) {
    lambda *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
    var cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi);
    $27eb59e3d76f1581$var$centroidPointCartesian(cosPhi * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda), cosPhi * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda), (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi));
}
function $27eb59e3d76f1581$var$centroidPointCartesian(x, y, z) {
    ++$27eb59e3d76f1581$var$W0;
    $27eb59e3d76f1581$var$X0 += (x - $27eb59e3d76f1581$var$X0) / $27eb59e3d76f1581$var$W0;
    $27eb59e3d76f1581$var$Y0 += (y - $27eb59e3d76f1581$var$Y0) / $27eb59e3d76f1581$var$W0;
    $27eb59e3d76f1581$var$Z0 += (z - $27eb59e3d76f1581$var$Z0) / $27eb59e3d76f1581$var$W0;
}
function $27eb59e3d76f1581$var$centroidLineStart() {
    $27eb59e3d76f1581$var$centroidStream.point = $27eb59e3d76f1581$var$centroidLinePointFirst;
}
function $27eb59e3d76f1581$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
    var cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi);
    $27eb59e3d76f1581$var$x0 = cosPhi * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda);
    $27eb59e3d76f1581$var$y0 = cosPhi * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda);
    $27eb59e3d76f1581$var$z0 = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi);
    $27eb59e3d76f1581$var$centroidStream.point = $27eb59e3d76f1581$var$centroidLinePoint;
    $27eb59e3d76f1581$var$centroidPointCartesian($27eb59e3d76f1581$var$x0, $27eb59e3d76f1581$var$y0, $27eb59e3d76f1581$var$z0);
}
function $27eb59e3d76f1581$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
    var cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi), x = cosPhi * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda), z = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi), w = (0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)((0, $2c2d81b59d3d41e6$export$eba8049fb5020b81)((w = $27eb59e3d76f1581$var$y0 * z - $27eb59e3d76f1581$var$z0 * y) * w + (w = $27eb59e3d76f1581$var$z0 * x - $27eb59e3d76f1581$var$x0 * z) * w + (w = $27eb59e3d76f1581$var$x0 * y - $27eb59e3d76f1581$var$y0 * x) * w), $27eb59e3d76f1581$var$x0 * x + $27eb59e3d76f1581$var$y0 * y + $27eb59e3d76f1581$var$z0 * z);
    $27eb59e3d76f1581$var$W1 += w;
    $27eb59e3d76f1581$var$X1 += w * ($27eb59e3d76f1581$var$x0 + ($27eb59e3d76f1581$var$x0 = x));
    $27eb59e3d76f1581$var$Y1 += w * ($27eb59e3d76f1581$var$y0 + ($27eb59e3d76f1581$var$y0 = y));
    $27eb59e3d76f1581$var$Z1 += w * ($27eb59e3d76f1581$var$z0 + ($27eb59e3d76f1581$var$z0 = z));
    $27eb59e3d76f1581$var$centroidPointCartesian($27eb59e3d76f1581$var$x0, $27eb59e3d76f1581$var$y0, $27eb59e3d76f1581$var$z0);
}
function $27eb59e3d76f1581$var$centroidLineEnd() {
    $27eb59e3d76f1581$var$centroidStream.point = $27eb59e3d76f1581$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $27eb59e3d76f1581$var$centroidRingStart() {
    $27eb59e3d76f1581$var$centroidStream.point = $27eb59e3d76f1581$var$centroidRingPointFirst;
}
function $27eb59e3d76f1581$var$centroidRingEnd() {
    $27eb59e3d76f1581$var$centroidRingPoint($27eb59e3d76f1581$var$lambda00, $27eb59e3d76f1581$var$phi00);
    $27eb59e3d76f1581$var$centroidStream.point = $27eb59e3d76f1581$var$centroidPoint;
}
function $27eb59e3d76f1581$var$centroidRingPointFirst(lambda, phi) {
    $27eb59e3d76f1581$var$lambda00 = lambda, $27eb59e3d76f1581$var$phi00 = phi;
    lambda *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
    $27eb59e3d76f1581$var$centroidStream.point = $27eb59e3d76f1581$var$centroidRingPoint;
    var cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi);
    $27eb59e3d76f1581$var$x0 = cosPhi * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda);
    $27eb59e3d76f1581$var$y0 = cosPhi * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda);
    $27eb59e3d76f1581$var$z0 = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi);
    $27eb59e3d76f1581$var$centroidPointCartesian($27eb59e3d76f1581$var$x0, $27eb59e3d76f1581$var$y0, $27eb59e3d76f1581$var$z0);
}
function $27eb59e3d76f1581$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
    var cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi), x = cosPhi * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda), z = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi), cx = $27eb59e3d76f1581$var$y0 * z - $27eb59e3d76f1581$var$z0 * y, cy = $27eb59e3d76f1581$var$z0 * x - $27eb59e3d76f1581$var$x0 * z, cz = $27eb59e3d76f1581$var$x0 * y - $27eb59e3d76f1581$var$y0 * x, m = (0, $2c2d81b59d3d41e6$export$f95c7888b62f8e9a)(cx, cy, cz), w = (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(m), v = m && -w / m; // area weight multiplier
    $27eb59e3d76f1581$var$X2.add(v * cx);
    $27eb59e3d76f1581$var$Y2.add(v * cy);
    $27eb59e3d76f1581$var$Z2.add(v * cz);
    $27eb59e3d76f1581$var$W1 += w;
    $27eb59e3d76f1581$var$X1 += w * ($27eb59e3d76f1581$var$x0 + ($27eb59e3d76f1581$var$x0 = x));
    $27eb59e3d76f1581$var$Y1 += w * ($27eb59e3d76f1581$var$y0 + ($27eb59e3d76f1581$var$y0 = y));
    $27eb59e3d76f1581$var$Z1 += w * ($27eb59e3d76f1581$var$z0 + ($27eb59e3d76f1581$var$z0 = z));
    $27eb59e3d76f1581$var$centroidPointCartesian($27eb59e3d76f1581$var$x0, $27eb59e3d76f1581$var$y0, $27eb59e3d76f1581$var$z0);
}
function $27eb59e3d76f1581$export$2e2bcd8739ae039(object) {
    $27eb59e3d76f1581$var$W0 = $27eb59e3d76f1581$var$W1 = $27eb59e3d76f1581$var$X0 = $27eb59e3d76f1581$var$Y0 = $27eb59e3d76f1581$var$Z0 = $27eb59e3d76f1581$var$X1 = $27eb59e3d76f1581$var$Y1 = $27eb59e3d76f1581$var$Z1 = 0;
    $27eb59e3d76f1581$var$X2 = new (0, $a916e9dbe534c36f$export$bda7ba77fb86c375)();
    $27eb59e3d76f1581$var$Y2 = new (0, $a916e9dbe534c36f$export$bda7ba77fb86c375)();
    $27eb59e3d76f1581$var$Z2 = new (0, $a916e9dbe534c36f$export$bda7ba77fb86c375)();
    (0, $a5b0d016e8689c48$export$2e2bcd8739ae039)(object, $27eb59e3d76f1581$var$centroidStream);
    var x = +$27eb59e3d76f1581$var$X2, y = +$27eb59e3d76f1581$var$Y2, z = +$27eb59e3d76f1581$var$Z2, m = (0, $2c2d81b59d3d41e6$export$f95c7888b62f8e9a)(x, y, z);
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $2c2d81b59d3d41e6$export$92c06fba281fe81b)) {
        x = $27eb59e3d76f1581$var$X1, y = $27eb59e3d76f1581$var$Y1, z = $27eb59e3d76f1581$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($27eb59e3d76f1581$var$W1 < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d)) x = $27eb59e3d76f1581$var$X0, y = $27eb59e3d76f1581$var$Y0, z = $27eb59e3d76f1581$var$Z0;
        m = (0, $2c2d81b59d3d41e6$export$f95c7888b62f8e9a)(x, y, z);
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $2c2d81b59d3d41e6$export$92c06fba281fe81b)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)(y, x) * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97),
        (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(z / m) * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97)
    ];
}





var $13ef798b6a16933d$var$lengthSum, $13ef798b6a16933d$var$lambda0, $13ef798b6a16933d$var$sinPhi0, $13ef798b6a16933d$var$cosPhi0;
var $13ef798b6a16933d$var$lengthStream = {
    sphere: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    point: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    lineStart: $13ef798b6a16933d$var$lengthLineStart,
    lineEnd: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    polygonStart: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    polygonEnd: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039)
};
function $13ef798b6a16933d$var$lengthLineStart() {
    $13ef798b6a16933d$var$lengthStream.point = $13ef798b6a16933d$var$lengthPointFirst;
    $13ef798b6a16933d$var$lengthStream.lineEnd = $13ef798b6a16933d$var$lengthLineEnd;
}
function $13ef798b6a16933d$var$lengthLineEnd() {
    $13ef798b6a16933d$var$lengthStream.point = $13ef798b6a16933d$var$lengthStream.lineEnd = (0, $9ea986972f46f1fc$export$2e2bcd8739ae039);
}
function $13ef798b6a16933d$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
    $13ef798b6a16933d$var$lambda0 = lambda, $13ef798b6a16933d$var$sinPhi0 = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi), $13ef798b6a16933d$var$cosPhi0 = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi);
    $13ef798b6a16933d$var$lengthStream.point = $13ef798b6a16933d$var$lengthPoint;
}
function $13ef798b6a16933d$var$lengthPoint(lambda, phi) {
    lambda *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi *= (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
    var sinPhi = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi), cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi), delta = (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(lambda - $13ef798b6a16933d$var$lambda0), cosDelta = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(delta), sinDelta = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(delta), x = cosPhi * sinDelta, y = $13ef798b6a16933d$var$cosPhi0 * sinPhi - $13ef798b6a16933d$var$sinPhi0 * cosPhi * cosDelta, z = $13ef798b6a16933d$var$sinPhi0 * sinPhi + $13ef798b6a16933d$var$cosPhi0 * cosPhi * cosDelta;
    $13ef798b6a16933d$var$lengthSum.add((0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)((0, $2c2d81b59d3d41e6$export$eba8049fb5020b81)(x * x + y * y), z));
    $13ef798b6a16933d$var$lambda0 = lambda, $13ef798b6a16933d$var$sinPhi0 = sinPhi, $13ef798b6a16933d$var$cosPhi0 = cosPhi;
}
function $13ef798b6a16933d$export$2e2bcd8739ae039(object) {
    $13ef798b6a16933d$var$lengthSum = new (0, $a916e9dbe534c36f$export$bda7ba77fb86c375)();
    (0, $a5b0d016e8689c48$export$2e2bcd8739ae039)(object, $13ef798b6a16933d$var$lengthStream);
    return +$13ef798b6a16933d$var$lengthSum;
}


var $8447f76aa79ffbe2$var$coordinates = [
    null,
    null
], $8447f76aa79ffbe2$var$object = {
    type: "LineString",
    coordinates: $8447f76aa79ffbe2$var$coordinates
};
function $8447f76aa79ffbe2$export$2e2bcd8739ae039(a, b) {
    $8447f76aa79ffbe2$var$coordinates[0] = a;
    $8447f76aa79ffbe2$var$coordinates[1] = b;
    return (0, $13ef798b6a16933d$export$2e2bcd8739ae039)($8447f76aa79ffbe2$var$object);
}



const $3ff4c258c072845b$var$epsilon = 1e-6;
class $3ff4c258c072845b$export$2e2bcd8739ae039 {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $3ff4c258c072845b$var$epsilon || Math.abs(this._y1 - y0) > $3ff4c258c072845b$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}


class $faec48d3859f255b$export$2e2bcd8739ae039 {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}




class $3d2bc80fc251edd6$export$2e2bcd8739ae039 {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $3ff4c258c072845b$export$2e2bcd8739ae039) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $3ff4c258c072845b$export$2e2bcd8739ae039) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $3ff4c258c072845b$export$2e2bcd8739ae039) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $faec48d3859f255b$export$2e2bcd8739ae039);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}


const $d0f7a2297bbeda8e$var$tau = 2 * Math.PI, $d0f7a2297bbeda8e$var$pow = Math.pow;
function $d0f7a2297bbeda8e$var$pointX(p) {
    return p[0];
}
function $d0f7a2297bbeda8e$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $d0f7a2297bbeda8e$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $d0f7a2297bbeda8e$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $d0f7a2297bbeda8e$export$2e2bcd8739ae039 {
    static from(points, fx = $d0f7a2297bbeda8e$var$pointX, fy = $d0f7a2297bbeda8e$var$pointY, that) {
        return new $d0f7a2297bbeda8e$export$2e2bcd8739ae039("length" in points ? $d0f7a2297bbeda8e$var$flatArray(points, fx, fy, that) : Float64Array.from($d0f7a2297bbeda8e$var$flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, $7910d402b5fcb5cd$export$2e2bcd8739ae039)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $d0f7a2297bbeda8e$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $d0f7a2297bbeda8e$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $7910d402b5fcb5cd$export$2e2bcd8739ae039)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, $3d2bc80fc251edd6$export$2e2bcd8739ae039)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $d0f7a2297bbeda8e$var$pow(x - points[i * 2], 2) + $d0f7a2297bbeda8e$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $d0f7a2297bbeda8e$var$pow(x - points[t * 2], 2) + $d0f7a2297bbeda8e$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($d0f7a2297bbeda8e$var$pow(x - points[e * 2], 2) + $d0f7a2297bbeda8e$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $3ff4c258c072845b$export$2e2bcd8739ae039) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, $3ff4c258c072845b$export$2e2bcd8739ae039) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $d0f7a2297bbeda8e$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $3ff4c258c072845b$export$2e2bcd8739ae039) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $faec48d3859f255b$export$2e2bcd8739ae039);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $3ff4c258c072845b$export$2e2bcd8739ae039) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $faec48d3859f255b$export$2e2bcd8739ae039);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
function $d0f7a2297bbeda8e$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $d0f7a2297bbeda8e$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}


function $62e04a4280667748$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $3400b0527e946541$var$rotationIdentity(lambda, phi) {
    if ((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(lambda) > (0, $2c2d81b59d3d41e6$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92)) * (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92);
    return [
        lambda,
        phi
    ];
}
$3400b0527e946541$var$rotationIdentity.invert = $3400b0527e946541$var$rotationIdentity;
function $3400b0527e946541$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $62e04a4280667748$export$2e2bcd8739ae039)($3400b0527e946541$var$rotationLambda(deltaLambda), $3400b0527e946541$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $3400b0527e946541$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $3400b0527e946541$var$rotationPhiGamma(deltaPhi, deltaGamma) : $3400b0527e946541$var$rotationIdentity;
}
function $3400b0527e946541$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(lambda) > (0, $2c2d81b59d3d41e6$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92)) * (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92);
        return [
            lambda,
            phi
        ];
    };
}
function $3400b0527e946541$var$rotationLambda(deltaLambda) {
    var rotation = $3400b0527e946541$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $3400b0527e946541$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $3400b0527e946541$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi), x = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi), x = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $3400b0527e946541$export$2e2bcd8739ae039(rotate) {
    rotate = $3400b0527e946541$export$a2ba89726971a90f(rotate[0] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), rotate[1] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), coordinates[1] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97), coordinates[1] *= (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), coordinates[1] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97), coordinates[1] *= (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}



function $21ac6cb5480bca56$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(x), cy = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(x),
            k * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $21ac6cb5480bca56$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $2c2d81b59d3d41e6$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(c), cc = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(c);
        return [
            (0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



function $e8499f81c3724dcf$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}



function $7cf0a2091217b712$export$2e2bcd8739ae039(a, b) {
    return (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) && (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d);
}



function $9bea7eaa2c50248b$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $9bea7eaa2c50248b$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $7cf0a2091217b712$export$2e2bcd8739ae039)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $2c2d81b59d3d41e6$export$6c421550c66a327d);
        }
        subject.push(x = new $9bea7eaa2c50248b$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $9bea7eaa2c50248b$var$Intersection(p0, null, x, false));
        subject.push(x = new $9bea7eaa2c50248b$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $9bea7eaa2c50248b$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $9bea7eaa2c50248b$var$link(subject);
    $9bea7eaa2c50248b$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $9bea7eaa2c50248b$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}





function $b3c8e2c1c815555c$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $b3c8e2c1c815555c$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda),
        (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi)
    ];
}
function $b3c8e2c1c815555c$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $b3c8e2c1c815555c$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $b3c8e2c1c815555c$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $b3c8e2c1c815555c$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $b3c8e2c1c815555c$export$6789498aec2cb34b(d) {
    var l = (0, $2c2d81b59d3d41e6$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}



function $c00f80377c230391$var$longitude(point) {
    return (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(point[0]) <= (0, $2c2d81b59d3d41e6$export$18c7bea995a110f) ? point[0] : (0, $2c2d81b59d3d41e6$export$c5552dfdbc7cec71)(point[0]) * (((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(point[0]) + (0, $2c2d81b59d3d41e6$export$18c7bea995a110f)) % (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92) - (0, $2c2d81b59d3d41e6$export$18c7bea995a110f));
}
function $c00f80377c230391$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $c00f80377c230391$var$longitude(point), phi = point[1], sinPhi = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi), normal = [
        (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda),
        -(0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $a916e9dbe534c36f$export$bda7ba77fb86c375)();
    if (sinPhi === 1) phi = (0, $2c2d81b59d3d41e6$export$e51408a300e8929a) + (0, $2c2d81b59d3d41e6$export$6c421550c66a327d);
    else if (sinPhi === -1) phi = -(0, $2c2d81b59d3d41e6$export$e51408a300e8929a) - (0, $2c2d81b59d3d41e6$export$6c421550c66a327d);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $c00f80377c230391$var$longitude(point0), phi0 = point0[1] / 2 + (0, $2c2d81b59d3d41e6$export$c39a5cba78ea0fc2), sinPhi0 = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $c00f80377c230391$var$longitude(point1), phi1 = point1[1] / 2 + (0, $2c2d81b59d3d41e6$export$c39a5cba78ea0fc2), sinPhi1 = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $2c2d81b59d3d41e6$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            sum.add((0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)(k * sign * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $b3c8e2c1c815555c$export$4763f5351b14293f)((0, $b3c8e2c1c815555c$export$6e6697ef026a96)(point0), (0, $b3c8e2c1c815555c$export$6e6697ef026a96)(point1));
                (0, $b3c8e2c1c815555c$export$6789498aec2cb34b)(arc);
                var intersection = (0, $b3c8e2c1c815555c$export$4763f5351b14293f)(normal, arc);
                (0, $b3c8e2c1c815555c$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $2c2d81b59d3d41e6$export$6c421550c66a327d) || angle < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) && sum < -(0, $2c2d81b59d3d41e6$export$92c06fba281fe81b)) ^ winding & 1;
}


function* $2a8d01f2bcac61dd$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $2a8d01f2bcac61dd$export$2e2bcd8739ae039(arrays) {
    return Array.from($2a8d01f2bcac61dd$var$flatten(arrays));
}


function $c6312f748d8a5185$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $e8499f81c3724dcf$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $2a8d01f2bcac61dd$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $c00f80377c230391$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $9bea7eaa2c50248b$export$2e2bcd8739ae039)(segments, $c6312f748d8a5185$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($c6312f748d8a5185$var$validSegment));
        }
        return clip;
    };
}
function $c6312f748d8a5185$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $c6312f748d8a5185$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $2c2d81b59d3d41e6$export$e51408a300e8929a) - (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) : (0, $2c2d81b59d3d41e6$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $2c2d81b59d3d41e6$export$e51408a300e8929a) - (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) : (0, $2c2d81b59d3d41e6$export$e51408a300e8929a) - b[1]);
}



var $45cf2f54444c80e6$export$2e2bcd8739ae039 = (0, $c6312f748d8a5185$export$2e2bcd8739ae039)(function() {
    return true;
}, $45cf2f54444c80e6$var$clipAntimeridianLine, $45cf2f54444c80e6$var$clipAntimeridianInterpolate, [
    -(0, $2c2d81b59d3d41e6$export$18c7bea995a110f),
    -(0, $2c2d81b59d3d41e6$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $45cf2f54444c80e6$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $2c2d81b59d3d41e6$export$18c7bea995a110f) : -(0, $2c2d81b59d3d41e6$export$18c7bea995a110f), delta = (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(delta - (0, $2c2d81b59d3d41e6$export$18c7bea995a110f)) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $2c2d81b59d3d41e6$export$e51408a300e8929a) : -(0, $2c2d81b59d3d41e6$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $2c2d81b59d3d41e6$export$18c7bea995a110f)) {
                if ((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $2c2d81b59d3d41e6$export$6c421550c66a327d); // handle degeneracies
                if ((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $2c2d81b59d3d41e6$export$6c421550c66a327d);
                phi0 = $45cf2f54444c80e6$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $45cf2f54444c80e6$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) ? (0, $2c2d81b59d3d41e6$export$628dc4eed22b0fbd)(((0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi1)) * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda1) - (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi0)) * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $45cf2f54444c80e6$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $2c2d81b59d3d41e6$export$e51408a300e8929a);
        stream.point(-(0, $2c2d81b59d3d41e6$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $2c2d81b59d3d41e6$export$18c7bea995a110f), phi);
        stream.point((0, $2c2d81b59d3d41e6$export$18c7bea995a110f), 0);
        stream.point((0, $2c2d81b59d3d41e6$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $2c2d81b59d3d41e6$export$18c7bea995a110f), -phi);
        stream.point(-(0, $2c2d81b59d3d41e6$export$18c7bea995a110f), 0);
        stream.point(-(0, $2c2d81b59d3d41e6$export$18c7bea995a110f), phi);
    } else if ((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $2c2d81b59d3d41e6$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $2c2d81b59d3d41e6$export$18c7bea995a110f) : -(0, $2c2d81b59d3d41e6$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}




function $78e6cf816fb43404$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}




function $db9cad39a07783e1$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(radius), sinRadius = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $db9cad39a07783e1$var$circleRadius(cosRadius, t0);
        t1 = $db9cad39a07783e1$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $b3c8e2c1c815555c$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(t),
            -sinRadius * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $db9cad39a07783e1$var$circleRadius(cosRadius, point) {
    point = (0, $b3c8e2c1c815555c$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $b3c8e2c1c815555c$export$6789498aec2cb34b)(point);
    var radius = (0, $2c2d81b59d3d41e6$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92) - (0, $2c2d81b59d3d41e6$export$6c421550c66a327d)) % (0, $2c2d81b59d3d41e6$export$a4b4b4d4d776fe92);
}
function $db9cad39a07783e1$export$2e2bcd8739ae039() {
    var center = (0, $78e6cf816fb43404$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $78e6cf816fb43404$export$2e2bcd8739ae039)(90), precision = (0, $78e6cf816fb43404$export$2e2bcd8739ae039)(2), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97), x[1] *= (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $3400b0527e946541$export$a2ba89726971a90f)(-c[0] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), -c[1] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), 0).invert;
        $db9cad39a07783e1$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $78e6cf816fb43404$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $78e6cf816fb43404$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $78e6cf816fb43404$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}





function $784d019615a074cd$export$2e2bcd8739ae039(radius) {
    var cr = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(radius), delta = 2 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(cr) > (0, $2c2d81b59d3d41e6$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $db9cad39a07783e1$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(lambda) * (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $2c2d81b59d3d41e6$export$18c7bea995a110f) : -(0, $2c2d81b59d3d41e6$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $7cf0a2091217b712$export$2e2bcd8739ae039)(point0, point2) || (0, $7cf0a2091217b712$export$2e2bcd8739ae039)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $7cf0a2091217b712$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $b3c8e2c1c815555c$export$6e6697ef026a96)(a), pb = (0, $b3c8e2c1c815555c$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $b3c8e2c1c815555c$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $b3c8e2c1c815555c$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $b3c8e2c1c815555c$export$4763f5351b14293f)(n1, n2), A = (0, $b3c8e2c1c815555c$export$52d0ee3fc868d452)(n1, c1), B = (0, $b3c8e2c1c815555c$export$52d0ee3fc868d452)(n2, c2);
        (0, $b3c8e2c1c815555c$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $b3c8e2c1c815555c$export$2ef80f51436a9de9)(A, u), uu = (0, $b3c8e2c1c815555c$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $b3c8e2c1c815555c$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $2c2d81b59d3d41e6$export$eba8049fb5020b81)(t2), q = (0, $b3c8e2c1c815555c$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $b3c8e2c1c815555c$export$e62eba72fc898eae)(q, A);
        q = (0, $b3c8e2c1c815555c$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(delta - (0, $2c2d81b59d3d41e6$export$18c7bea995a110f)) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d), meridian = polar || delta < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $2c2d81b59d3d41e6$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $b3c8e2c1c815555c$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $b3c8e2c1c815555c$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $b3c8e2c1c815555c$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $2c2d81b59d3d41e6$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $c6312f748d8a5185$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $2c2d81b59d3d41e6$export$18c7bea995a110f),
        radius - (0, $2c2d81b59d3d41e6$export$18c7bea995a110f)
    ]);
}




function $d0fac01e60e29d85$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $49568a303259f899$var$clipMax = 1e9, $49568a303259f899$var$clipMin = -$49568a303259f899$var$clipMax;
function $49568a303259f899$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(p[0] - x0) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(p[0] - x1) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(p[1] - y0) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $e8499f81c3724dcf$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $2a8d01f2bcac61dd$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $9bea7eaa2c50248b$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($49568a303259f899$var$clipMin, Math.min($49568a303259f899$var$clipMax, x_)),
                    y_ = Math.max($49568a303259f899$var$clipMin, Math.min($49568a303259f899$var$clipMax, y_))
                ], b = [
                    x = Math.max($49568a303259f899$var$clipMin, Math.min($49568a303259f899$var$clipMax, x)),
                    y = Math.max($49568a303259f899$var$clipMin, Math.min($49568a303259f899$var$clipMax, y))
                ];
                if ((0, $d0fac01e60e29d85$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}



var $53e6eda28d462143$export$2e2bcd8739ae039 = (x)=>x;




function $1fefa959eee0dc1a$export$2e2bcd8739ae039(methods) {
    return {
        stream: $1fefa959eee0dc1a$export$6b468dcfb64c653c(methods)
    };
}
function $1fefa959eee0dc1a$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $1fefa959eee0dc1a$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $1fefa959eee0dc1a$var$TransformStream() {}
$1fefa959eee0dc1a$var$TransformStream.prototype = {
    constructor: $1fefa959eee0dc1a$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};




var $bcc097b0cce5acac$var$x0 = Infinity, $bcc097b0cce5acac$var$y0 = $bcc097b0cce5acac$var$x0, $bcc097b0cce5acac$var$x1 = -$bcc097b0cce5acac$var$x0, $bcc097b0cce5acac$var$y1 = $bcc097b0cce5acac$var$x1;
var $bcc097b0cce5acac$var$boundsStream = {
    point: $bcc097b0cce5acac$var$boundsPoint,
    lineStart: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    lineEnd: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    polygonStart: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    polygonEnd: (0, $9ea986972f46f1fc$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $bcc097b0cce5acac$var$x0,
                $bcc097b0cce5acac$var$y0
            ],
            [
                $bcc097b0cce5acac$var$x1,
                $bcc097b0cce5acac$var$y1
            ]
        ];
        $bcc097b0cce5acac$var$x1 = $bcc097b0cce5acac$var$y1 = -($bcc097b0cce5acac$var$y0 = $bcc097b0cce5acac$var$x0 = Infinity);
        return bounds;
    }
};
function $bcc097b0cce5acac$var$boundsPoint(x, y) {
    if (x < $bcc097b0cce5acac$var$x0) $bcc097b0cce5acac$var$x0 = x;
    if (x > $bcc097b0cce5acac$var$x1) $bcc097b0cce5acac$var$x1 = x;
    if (y < $bcc097b0cce5acac$var$y0) $bcc097b0cce5acac$var$y0 = y;
    if (y > $bcc097b0cce5acac$var$y1) $bcc097b0cce5acac$var$y1 = y;
}
var $bcc097b0cce5acac$export$2e2bcd8739ae039 = $bcc097b0cce5acac$var$boundsStream;


function $18f09e668227dc82$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $a5b0d016e8689c48$export$2e2bcd8739ae039)(object, projection.stream((0, $bcc097b0cce5acac$export$2e2bcd8739ae039)));
    fitBounds((0, $bcc097b0cce5acac$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $18f09e668227dc82$export$e450184041869e7f(projection, extent, object) {
    return $18f09e668227dc82$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $18f09e668227dc82$export$33a367fa1728c3ba(projection, size, object) {
    return $18f09e668227dc82$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $18f09e668227dc82$export$7d8f2192ef31c5a7(projection, width, object) {
    return $18f09e668227dc82$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $18f09e668227dc82$export$7069bab0d2ced675(projection, height, object) {
    return $18f09e668227dc82$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $ccb50c11c0972904$var$maxDepth = 16, $ccb50c11c0972904$var$cosMinDistance = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(30 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $ccb50c11c0972904$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $ccb50c11c0972904$var$resample(project, delta2) : $ccb50c11c0972904$var$resampleNone(project);
}
function $ccb50c11c0972904$var$resampleNone(project) {
    return (0, $1fefa959eee0dc1a$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $ccb50c11c0972904$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $2c2d81b59d3d41e6$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $2c2d81b59d3d41e6$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)((0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(c) - 1) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) || (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $2c2d81b59d3d41e6$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $2c2d81b59d3d41e6$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $2c2d81b59d3d41e6$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $ccb50c11c0972904$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $b3c8e2c1c815555c$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $ccb50c11c0972904$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $ccb50c11c0972904$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $295697a4be6bd1ed$var$transformRadians = (0, $1fefa959eee0dc1a$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), y * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc));
    }
});
function $295697a4be6bd1ed$var$transformRotate(rotate) {
    return (0, $1fefa959eee0dc1a$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $295697a4be6bd1ed$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $295697a4be6bd1ed$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $295697a4be6bd1ed$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(alpha), sinAlpha = (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $295697a4be6bd1ed$export$2e2bcd8739ae039(project) {
    return $295697a4be6bd1ed$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $295697a4be6bd1ed$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $45cf2f54444c80e6$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $53e6eda28d462143$export$2e2bcd8739ae039), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), point[1] * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97),
            point[1] * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $295697a4be6bd1ed$var$transformRadians($295697a4be6bd1ed$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $784d019615a074cd$export$2e2bcd8739ae039)(theta = _ * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc)) : (theta = null, $45cf2f54444c80e6$export$2e2bcd8739ae039), reset()) : theta * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $53e6eda28d462143$export$2e2bcd8739ae039) : (0, $49568a303259f899$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97),
            phi * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97),
            deltaPhi * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97),
            deltaGamma * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $2c2d81b59d3d41e6$export$8449e153fbd325fc), recenter()) : alpha * (0, $2c2d81b59d3d41e6$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $ccb50c11c0972904$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $2c2d81b59d3d41e6$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $18f09e668227dc82$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $18f09e668227dc82$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $18f09e668227dc82$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $18f09e668227dc82$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        var center = $295697a4be6bd1ed$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $295697a4be6bd1ed$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $3400b0527e946541$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $62e04a4280667748$export$2e2bcd8739ae039)(project, transform);
        projectRotateTransform = (0, $62e04a4280667748$export$2e2bcd8739ae039)(rotate, projectTransform);
        projectResample = (0, $ccb50c11c0972904$export$2e2bcd8739ae039)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $37d689b62072efdc$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(y), k = 1 + (0, $2c2d81b59d3d41e6$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(x) / k,
        (0, $2c2d81b59d3d41e6$export$5de3937cb4b592ed)(y) / k
    ];
}
$37d689b62072efdc$export$f9ccbb0dcb3dcd2b.invert = (0, $21ac6cb5480bca56$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $2c2d81b59d3d41e6$export$628dc4eed22b0fbd)(z);
});
function $37d689b62072efdc$export$2e2bcd8739ae039() {
    return (0, $295697a4be6bd1ed$export$2e2bcd8739ae039)($37d689b62072efdc$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}


function $f31a0e8239a263c2$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


const $3b25528c55ca0a21$export$6c421550c66a327d = 1e-6;
const $3b25528c55ca0a21$export$92c06fba281fe81b = 1e-12;
const $3b25528c55ca0a21$export$18c7bea995a110f = Math.PI;
const $3b25528c55ca0a21$export$e51408a300e8929a = $3b25528c55ca0a21$export$18c7bea995a110f / 2;
const $3b25528c55ca0a21$export$c39a5cba78ea0fc2 = $3b25528c55ca0a21$export$18c7bea995a110f / 4;
const $3b25528c55ca0a21$export$a4b4b4d4d776fe92 = $3b25528c55ca0a21$export$18c7bea995a110f * 2;
const $3b25528c55ca0a21$export$41fc368e1a942b97 = 180 / $3b25528c55ca0a21$export$18c7bea995a110f;
const $3b25528c55ca0a21$export$8449e153fbd325fc = $3b25528c55ca0a21$export$18c7bea995a110f / 180;
const $3b25528c55ca0a21$export$2335f513bbd82c6d = Math.abs;
const $3b25528c55ca0a21$export$628dc4eed22b0fbd = Math.atan;
const $3b25528c55ca0a21$export$b8b770ee6a0d9760 = Math.atan2;
const $3b25528c55ca0a21$export$50d414a77b60d802 = Math.cos;
const $3b25528c55ca0a21$export$803ce6b71a0a94b2 = Math.ceil;
const $3b25528c55ca0a21$export$b310ec824aaee37f = Math.exp;
const $3b25528c55ca0a21$export$a3fe094919f356fd = Math.floor;
const $3b25528c55ca0a21$export$bef1f36f5486a6a3 = Math.log;
const $3b25528c55ca0a21$export$8960430cfd85939f = Math.max;
const $3b25528c55ca0a21$export$96ec731ed4dcb222 = Math.min;
const $3b25528c55ca0a21$export$9c297f60e22e3389 = Math.pow;
const $3b25528c55ca0a21$export$5de3937cb4b592ed = Math.sin;
const $3b25528c55ca0a21$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
const $3b25528c55ca0a21$export$eba8049fb5020b81 = Math.sqrt;
const $3b25528c55ca0a21$export$fcdd3b0b3246a325 = Math.tan;
function $3b25528c55ca0a21$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $3b25528c55ca0a21$export$18c7bea995a110f : Math.acos(x);
}
function $3b25528c55ca0a21$export$41726bdb1fc63f(x) {
    return x > 1 ? $3b25528c55ca0a21$export$e51408a300e8929a : x < -1 ? -$3b25528c55ca0a21$export$e51408a300e8929a : Math.asin(x);
}
function $3b25528c55ca0a21$export$e808712c2966e662(x) {
    return (x = $3b25528c55ca0a21$export$5de3937cb4b592ed(x / 2)) * x;
}



function $87c6939dd7acdb1a$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $3b25528c55ca0a21$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $3b25528c55ca0a21$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $87c6939dd7acdb1a$export$6e6697ef026a96(spherical) {
    const lambda = spherical[0], phi = spherical[1], cosPhi = (0, $3b25528c55ca0a21$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $3b25528c55ca0a21$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $3b25528c55ca0a21$export$5de3937cb4b592ed)(lambda),
        (0, $3b25528c55ca0a21$export$5de3937cb4b592ed)(phi)
    ];
}
function $87c6939dd7acdb1a$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $87c6939dd7acdb1a$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $87c6939dd7acdb1a$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $87c6939dd7acdb1a$export$e0c54c5106b22406(a, b) {
    return [
        a[0] + b[0],
        a[1] + b[1],
        a[2] + b[2]
    ];
}
function $87c6939dd7acdb1a$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $87c6939dd7acdb1a$export$6789498aec2cb34b(d) {
    var l = (0, $3b25528c55ca0a21$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}
function $87c6939dd7acdb1a$export$fb68528fa506b5e(d) {
    var l = (0, $3b25528c55ca0a21$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    return [
        d[0] / l,
        d[1] / l,
        d[2] / l
    ];
}


// Converts 3D Cartesian to spherical coordinates (degrees).
function $7e83fa560dbbcf8c$var$spherical(cartesian) {
    return [
        (0, $3b25528c55ca0a21$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]) * (0, $3b25528c55ca0a21$export$41fc368e1a942b97),
        (0, $3b25528c55ca0a21$export$41726bdb1fc63f)((0, $3b25528c55ca0a21$export$8960430cfd85939f)(-1, (0, $3b25528c55ca0a21$export$96ec731ed4dcb222)(1, cartesian[2]))) * (0, $3b25528c55ca0a21$export$41fc368e1a942b97)
    ];
}
// Converts spherical coordinates (degrees) to 3D Cartesian.
function $7e83fa560dbbcf8c$var$cartesian(coordinates) {
    const lambda = coordinates[0] * (0, $3b25528c55ca0a21$export$8449e153fbd325fc), phi = coordinates[1] * (0, $3b25528c55ca0a21$export$8449e153fbd325fc), cosphi = (0, $3b25528c55ca0a21$export$50d414a77b60d802)(phi);
    return [
        cosphi * (0, $3b25528c55ca0a21$export$50d414a77b60d802)(lambda),
        cosphi * (0, $3b25528c55ca0a21$export$5de3937cb4b592ed)(lambda),
        (0, $3b25528c55ca0a21$export$5de3937cb4b592ed)(phi)
    ];
}
function $7e83fa560dbbcf8c$export$890a3b4ee4d8a938(triangle) {
    triangle = triangle.map((p)=>$7e83fa560dbbcf8c$var$cartesian(p));
    return (0, $87c6939dd7acdb1a$export$2ef80f51436a9de9)(triangle[0], (0, $87c6939dd7acdb1a$export$4763f5351b14293f)(triangle[2], triangle[1]));
}
function $7e83fa560dbbcf8c$export$7109abfeeaac371b(points) {
    const delaunay = $7e83fa560dbbcf8c$var$geo_delaunay_from(points), triangles = $7e83fa560dbbcf8c$var$geo_triangles(delaunay), edges = $7e83fa560dbbcf8c$var$geo_edges(triangles, points), neighbors = $7e83fa560dbbcf8c$var$geo_neighbors(triangles, points.length), find = $7e83fa560dbbcf8c$var$geo_find(neighbors, points), // Voronoi ; could take a center function as an argument
    circumcenters = $7e83fa560dbbcf8c$var$geo_circumcenters(triangles, points), { polygons: polygons, centers: centers } = $7e83fa560dbbcf8c$var$geo_polygons(circumcenters, triangles, points), mesh = $7e83fa560dbbcf8c$var$geo_mesh(polygons), hull = $7e83fa560dbbcf8c$var$geo_hull(triangles, points), // Urquhart ; returns a function that takes a distance array as argument.
    urquhart = $7e83fa560dbbcf8c$var$geo_urquhart(edges, triangles);
    return {
        delaunay: delaunay,
        edges: edges,
        triangles: triangles,
        centers: centers,
        neighbors: neighbors,
        polygons: polygons,
        mesh: mesh,
        hull: hull,
        urquhart: urquhart,
        find: find
    };
}
function $7e83fa560dbbcf8c$var$geo_find(neighbors, points) {
    function distance2(a, b) {
        let x = a[0] - b[0], y = a[1] - b[1], z = a[2] - b[2];
        return x * x + y * y + z * z;
    }
    return function find(x, y, next) {
        if (next === undefined) next = 0;
        let cell, dist, found = next;
        const xyz = $7e83fa560dbbcf8c$var$cartesian([
            x,
            y
        ]);
        do {
            cell = next;
            next = null;
            dist = distance2(xyz, $7e83fa560dbbcf8c$var$cartesian(points[cell]));
            neighbors[cell].forEach((i)=>{
                let ndist = distance2(xyz, $7e83fa560dbbcf8c$var$cartesian(points[i]));
                if (ndist < dist) {
                    dist = ndist;
                    next = i;
                    found = i;
                    return;
                }
            });
        }while (next !== null);
        return found;
    };
}
function $7e83fa560dbbcf8c$var$geo_delaunay_from(points) {
    if (points.length < 2) return {};
    // find a valid point to send to infinity
    let pivot = 0;
    while(isNaN(points[pivot][0] + points[pivot][1]) && pivot++ < points.length);
    const r = (0, $3400b0527e946541$export$2e2bcd8739ae039)(points[pivot]), projection = (0, $37d689b62072efdc$export$2e2bcd8739ae039)().translate([
        0,
        0
    ]).scale(1).rotate(r.invert([
        180,
        0
    ]));
    points = points.map(projection);
    const zeros = [];
    let max2 = 1;
    for(let i = 0, n = points.length; i < n; i++){
        let m = points[i][0] ** 2 + points[i][1] ** 2;
        if (!isFinite(m) || m > 1e32) zeros.push(i);
        else if (m > max2) max2 = m;
    }
    const FAR = 1e6 * (0, $3b25528c55ca0a21$export$eba8049fb5020b81)(max2);
    zeros.forEach((i)=>points[i] = [
            FAR,
            0
        ]);
    // Add infinite horizon points
    points.push([
        0,
        FAR
    ]);
    points.push([
        -FAR,
        0
    ]);
    points.push([
        0,
        -FAR
    ]);
    const delaunay = (0, $d0f7a2297bbeda8e$export$2e2bcd8739ae039).from(points);
    delaunay.projection = projection;
    // clean up the triangulation
    const { triangles: triangles, halfedges: halfedges, inedges: inedges } = delaunay;
    const degenerate = [];
    for(let i = 0, l = halfedges.length; i < l; i++){
        if (halfedges[i] < 0) {
            const j = i % 3 == 2 ? i - 2 : i + 1;
            const k = i % 3 == 0 ? i + 2 : i - 1;
            const a = halfedges[j];
            const b = halfedges[k];
            halfedges[a] = b;
            halfedges[b] = a;
            halfedges[j] = halfedges[k] = -1;
            triangles[i] = triangles[j] = triangles[k] = pivot;
            inedges[triangles[a]] = a % 3 == 0 ? a + 2 : a - 1;
            inedges[triangles[b]] = b % 3 == 0 ? b + 2 : b - 1;
            degenerate.push(Math.min(i, j, k));
            i += 2 - i % 3;
        } else if (triangles[i] > points.length - 3 - 1) triangles[i] = pivot;
    }
    // there should always be 4 degenerate triangles
    // console.warn(degenerate);
    return delaunay;
}
function $7e83fa560dbbcf8c$var$geo_edges(triangles, points) {
    const _index = new Set();
    if (points.length === 2) return [
        [
            0,
            1
        ]
    ];
    triangles.forEach((tri)=>{
        if (tri[0] === tri[1]) return;
        if ($7e83fa560dbbcf8c$export$890a3b4ee4d8a938(tri.map((i)=>points[i])) < 0) return;
        for(let i = 0, j; i < 3; i++){
            j = (i + 1) % 3;
            _index.add((0, $f31a0e8239a263c2$export$2e2bcd8739ae039)([
                tri[i],
                tri[j]
            ]).join("-"));
        }
    });
    return Array.from(_index, (d)=>d.split("-").map(Number));
}
function $7e83fa560dbbcf8c$var$geo_triangles(delaunay) {
    const { triangles: triangles } = delaunay;
    if (!triangles) return [];
    const geo_triangles = [];
    for(let i = 0, n = triangles.length / 3; i < n; i++){
        const a = triangles[3 * i], b = triangles[3 * i + 1], c = triangles[3 * i + 2];
        if (a !== b && b !== c) geo_triangles.push([
            a,
            c,
            b
        ]);
    }
    return geo_triangles;
}
function $7e83fa560dbbcf8c$var$geo_circumcenters(triangles, points) {
    // if (!use_centroids) {
    return triangles.map((tri)=>{
        const c = tri.map((i)=>points[i]).map($7e83fa560dbbcf8c$var$cartesian), V = (0, $87c6939dd7acdb1a$export$e0c54c5106b22406)((0, $87c6939dd7acdb1a$export$e0c54c5106b22406)((0, $87c6939dd7acdb1a$export$4763f5351b14293f)(c[1], c[0]), (0, $87c6939dd7acdb1a$export$4763f5351b14293f)(c[2], c[1])), (0, $87c6939dd7acdb1a$export$4763f5351b14293f)(c[0], c[2]));
        return $7e83fa560dbbcf8c$var$spherical((0, $87c6939dd7acdb1a$export$fb68528fa506b5e)(V));
    });
/*} else {
    return triangles.map(tri => {
      return d3.geoCentroid({
        type: "MultiPoint",
        coordinates: tri.map(i => points[i])
      });
    });
  }*/ }
function $7e83fa560dbbcf8c$var$geo_neighbors(triangles, npoints) {
    const neighbors = [];
    triangles.forEach((tri)=>{
        for(let j = 0; j < 3; j++){
            const a = tri[j], b = tri[(j + 1) % 3];
            neighbors[a] = neighbors[a] || [];
            neighbors[a].push(b);
        }
    });
    // degenerate cases
    if (triangles.length === 0) {
        if (npoints === 2) neighbors[0] = [
            1
        ], neighbors[1] = [
            0
        ];
        else if (npoints === 1) neighbors[0] = [];
    }
    return neighbors;
}
function $7e83fa560dbbcf8c$var$geo_polygons(circumcenters, triangles, points) {
    const polygons = [];
    const centers = circumcenters.slice();
    if (triangles.length === 0) {
        if (points.length < 2) return {
            polygons: polygons,
            centers: centers
        };
        if (points.length === 2) {
            // two hemispheres
            const a = $7e83fa560dbbcf8c$var$cartesian(points[0]), b = $7e83fa560dbbcf8c$var$cartesian(points[1]), m = (0, $87c6939dd7acdb1a$export$fb68528fa506b5e)((0, $87c6939dd7acdb1a$export$e0c54c5106b22406)(a, b)), d = (0, $87c6939dd7acdb1a$export$fb68528fa506b5e)((0, $87c6939dd7acdb1a$export$4763f5351b14293f)(a, b)), c = (0, $87c6939dd7acdb1a$export$4763f5351b14293f)(m, d);
            const poly = [
                m,
                (0, $87c6939dd7acdb1a$export$4763f5351b14293f)(m, c),
                (0, $87c6939dd7acdb1a$export$4763f5351b14293f)((0, $87c6939dd7acdb1a$export$4763f5351b14293f)(m, c), c),
                (0, $87c6939dd7acdb1a$export$4763f5351b14293f)((0, $87c6939dd7acdb1a$export$4763f5351b14293f)((0, $87c6939dd7acdb1a$export$4763f5351b14293f)(m, c), c), c)
            ].map($7e83fa560dbbcf8c$var$spherical).map(supplement);
            return polygons.push(poly), polygons.push(poly.slice().reverse()), {
                polygons: polygons,
                centers: centers
            };
        }
    }
    triangles.forEach((tri, t)=>{
        for(let j = 0; j < 3; j++){
            const a = tri[j], b = tri[(j + 1) % 3], c = tri[(j + 2) % 3];
            polygons[a] = polygons[a] || [];
            polygons[a].push([
                b,
                c,
                t,
                [
                    a,
                    b,
                    c
                ]
            ]);
        }
    });
    // reorder each polygon
    const reordered = polygons.map((poly)=>{
        const p = [
            poly[0][2]
        ]; // t
        let k = poly[0][1]; // k = c
        for(let i = 1; i < poly.length; i++){
            // look for b = k
            for(let j = 0; j < poly.length; j++)if (poly[j][0] == k) {
                k = poly[j][1];
                p.push(poly[j][2]);
                break;
            }
        }
        if (p.length > 2) return p;
        else if (p.length == 2) {
            const R0 = $7e83fa560dbbcf8c$var$o_midpoint(points[poly[0][3][0]], points[poly[0][3][1]], centers[p[0]]), R1 = $7e83fa560dbbcf8c$var$o_midpoint(points[poly[0][3][2]], points[poly[0][3][0]], centers[p[0]]);
            const i0 = supplement(R0), i1 = supplement(R1);
            return [
                p[0],
                i1,
                p[1],
                i0
            ];
        }
    });
    function supplement(point) {
        let f = -1;
        centers.slice(triangles.length, Infinity).forEach((p, i)=>{
            if (p[0] === point[0] && p[1] === point[1]) f = i + triangles.length;
        });
        if (f < 0) f = centers.length, centers.push(point);
        return f;
    }
    return {
        polygons: reordered,
        centers: centers
    };
}
function $7e83fa560dbbcf8c$var$o_midpoint(a, b, c) {
    a = $7e83fa560dbbcf8c$var$cartesian(a);
    b = $7e83fa560dbbcf8c$var$cartesian(b);
    c = $7e83fa560dbbcf8c$var$cartesian(c);
    const s = (0, $3b25528c55ca0a21$export$c5552dfdbc7cec71)((0, $87c6939dd7acdb1a$export$2ef80f51436a9de9)((0, $87c6939dd7acdb1a$export$4763f5351b14293f)(b, a), c));
    return $7e83fa560dbbcf8c$var$spherical((0, $87c6939dd7acdb1a$export$fb68528fa506b5e)((0, $87c6939dd7acdb1a$export$e0c54c5106b22406)(a, b)).map((d)=>s * d));
}
function $7e83fa560dbbcf8c$var$geo_mesh(polygons) {
    const mesh = [];
    polygons.forEach((poly)=>{
        if (!poly) return;
        let p = poly[poly.length - 1];
        for (let q of poly){
            if (q > p) mesh.push([
                p,
                q
            ]);
            p = q;
        }
    });
    return mesh;
}
function $7e83fa560dbbcf8c$var$geo_urquhart(edges, triangles) {
    return function(distances) {
        const _lengths = new Map(), _urquhart = new Map();
        edges.forEach((edge, i)=>{
            const u = edge.join("-");
            _lengths.set(u, distances[i]);
            _urquhart.set(u, true);
        });
        triangles.forEach((tri)=>{
            let l = 0, remove = -1;
            for(let j = 0; j < 3; j++){
                let u = (0, $f31a0e8239a263c2$export$2e2bcd8739ae039)([
                    tri[j],
                    tri[(j + 1) % 3]
                ]).join("-");
                if (_lengths.get(u) > l) {
                    l = _lengths.get(u);
                    remove = u;
                }
            }
            _urquhart.set(remove, false);
        });
        return edges.map((edge)=>_urquhart.get(edge.join("-")));
    };
}
function $7e83fa560dbbcf8c$var$geo_hull(triangles, points) {
    const _hull = new Set(), hull = [];
    triangles.map((tri)=>{
        if ($7e83fa560dbbcf8c$export$890a3b4ee4d8a938(tri.map((i)=>points[i > points.length ? 0 : i])) > 1e-12) return;
        for(let i = 0; i < 3; i++){
            let e = [
                tri[i],
                tri[(i + 1) % 3]
            ], code = `${e[0]}-${e[1]}`;
            if (_hull.has(code)) _hull.delete(code);
            else _hull.add(`${e[1]}-${e[0]}`);
        }
    });
    const _index = new Map();
    let start;
    _hull.forEach((e)=>{
        e = e.split("-").map(Number);
        _index.set(e[0], e[1]);
        start = e[0];
    });
    if (start === undefined) return hull;
    let next = start;
    do {
        hull.push(next);
        let n = _index.get(next);
        _index.set(next, -1);
        next = n;
    }while (next > -1 && next !== start);
    return hull;
}


function $10f6c26d929ba665$export$45beb76691a736bf(data) {
    const v = function(data) {
        v.delaunay = null;
        v._data = data;
        if (typeof v._data === "object" && v._data.type === "FeatureCollection") v._data = v._data.features;
        if (typeof v._data === "object") {
            const temp = v._data.map((d)=>[
                    v._vx(d),
                    v._vy(d),
                    d
                ]).filter((d)=>isFinite(d[0] + d[1]));
            v.points = temp.map((d)=>[
                    d[0],
                    d[1]
                ]);
            v.valid = temp.map((d)=>d[2]);
            v.delaunay = (0, $7e83fa560dbbcf8c$export$7109abfeeaac371b)(v.points);
        }
        return v;
    };
    v._vx = function(d) {
        if (typeof d == "object" && "type" in d) return (0, $27eb59e3d76f1581$export$2e2bcd8739ae039)(d)[0];
        if (0 in d) return d[0];
    };
    v._vy = function(d) {
        if (typeof d == "object" && "type" in d) return (0, $27eb59e3d76f1581$export$2e2bcd8739ae039)(d)[1];
        if (1 in d) return d[1];
    };
    v.x = function(f) {
        if (!f) return v._vx;
        v._vx = f;
        return v;
    };
    v.y = function(f) {
        if (!f) return v._vy;
        v._vy = f;
        return v;
    };
    v.polygons = function(data) {
        if (data !== undefined) v(data);
        if (!v.delaunay) return false;
        const coll = {
            type: "FeatureCollection",
            features: []
        };
        if (v.valid.length === 0) return coll;
        v.delaunay.polygons.forEach((poly, i)=>coll.features.push({
                type: "Feature",
                geometry: !poly ? null : {
                    type: "Polygon",
                    coordinates: [
                        [
                            ...poly,
                            poly[0]
                        ].map((i)=>v.delaunay.centers[i])
                    ]
                },
                properties: {
                    site: v.valid[i],
                    sitecoordinates: v.points[i],
                    neighbours: v.delaunay.neighbors[i]
                }
            }));
        if (v.valid.length === 1) coll.features.push({
            type: "Feature",
            geometry: {
                type: "Sphere"
            },
            properties: {
                site: v.valid[0],
                sitecoordinates: v.points[0],
                neighbours: []
            }
        });
        return coll;
    };
    v.triangles = function(data) {
        if (data !== undefined) v(data);
        if (!v.delaunay) return false;
        return {
            type: "FeatureCollection",
            features: v.delaunay.triangles.map((tri, index)=>{
                tri = tri.map((i)=>v.points[i]);
                tri.center = v.delaunay.centers[index];
                return tri;
            }).filter((tri)=>(0, $7e83fa560dbbcf8c$export$890a3b4ee4d8a938)(tri) > 0).map((tri)=>({
                    type: "Feature",
                    properties: {
                        circumcenter: tri.center
                    },
                    geometry: {
                        type: "Polygon",
                        coordinates: [
                            [
                                ...tri,
                                tri[0]
                            ]
                        ]
                    }
                }))
        };
    };
    v.links = function(data) {
        if (data !== undefined) v(data);
        if (!v.delaunay) return false;
        const _distances = v.delaunay.edges.map((e)=>(0, $8447f76aa79ffbe2$export$2e2bcd8739ae039)(v.points[e[0]], v.points[e[1]])), _urquart = v.delaunay.urquhart(_distances);
        return {
            type: "FeatureCollection",
            features: v.delaunay.edges.map((e, i)=>({
                    type: "Feature",
                    properties: {
                        source: v.valid[e[0]],
                        target: v.valid[e[1]],
                        length: _distances[i],
                        urquhart: !!_urquart[i]
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: [
                            v.points[e[0]],
                            v.points[e[1]]
                        ]
                    }
                }))
        };
    };
    v.mesh = function(data) {
        if (data !== undefined) v(data);
        if (!v.delaunay) return false;
        return {
            type: "MultiLineString",
            coordinates: v.delaunay.edges.map((e)=>[
                    v.points[e[0]],
                    v.points[e[1]]
                ])
        };
    };
    v.cellMesh = function(data) {
        if (data !== undefined) v(data);
        if (!v.delaunay) return false;
        const { centers: centers, polygons: polygons } = v.delaunay;
        const coordinates = [];
        for (const p of polygons){
            if (!p) continue;
            for(let n = p.length, p0 = p[n - 1], p1 = p[0], i = 0; i < n; p0 = p1, p1 = p[++i])if (p1 > p0) coordinates.push([
                centers[p0],
                centers[p1]
            ]);
        }
        return {
            type: "MultiLineString",
            coordinates: coordinates
        };
    };
    v._found = undefined;
    v.find = function(x, y, radius) {
        v._found = v.delaunay.find(x, y, v._found);
        if (!radius || (0, $8447f76aa79ffbe2$export$2e2bcd8739ae039)([
            x,
            y
        ], v.points[v._found]) < radius) return v._found;
    };
    v.hull = function(data) {
        if (data !== undefined) v(data);
        const hull = v.delaunay.hull, points = v.points;
        return hull.length === 0 ? null : {
            type: "Polygon",
            coordinates: [
                [
                    ...hull.map((i)=>points[i]),
                    points[hull[0]]
                ]
            ]
        };
    };
    return data ? v(data) : v;
}



function $aa8bf899fc620c38$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $aa8bf899fc620c38$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $aa8bf899fc620c38$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $aa8bf899fc620c38$var$_arrayLikeToArray(r);
}
function $aa8bf899fc620c38$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $aa8bf899fc620c38$var$_callSuper(t, o, e) {
    return o = $aa8bf899fc620c38$var$_getPrototypeOf(o), $aa8bf899fc620c38$var$_possibleConstructorReturn(t, $aa8bf899fc620c38$var$_isNativeReflectConstruct() ? Reflect.construct(o, [], $aa8bf899fc620c38$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $aa8bf899fc620c38$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $aa8bf899fc620c38$var$_createClass(e, r, t) {
    return Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $aa8bf899fc620c38$var$_getPrototypeOf(t) {
    return $aa8bf899fc620c38$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $aa8bf899fc620c38$var$_getPrototypeOf(t);
}
function $aa8bf899fc620c38$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aa8bf899fc620c38$var$_setPrototypeOf(t, e);
}
function $aa8bf899fc620c38$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($aa8bf899fc620c38$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $aa8bf899fc620c38$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $aa8bf899fc620c38$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $aa8bf899fc620c38$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aa8bf899fc620c38$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aa8bf899fc620c38$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $aa8bf899fc620c38$var$_assertThisInitialized(t);
}
function $aa8bf899fc620c38$var$_setPrototypeOf(t, e) {
    return $aa8bf899fc620c38$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $aa8bf899fc620c38$var$_setPrototypeOf(t, e);
}
function $aa8bf899fc620c38$var$_slicedToArray(r, e) {
    return $aa8bf899fc620c38$var$_arrayWithHoles(r) || $aa8bf899fc620c38$var$_iterableToArrayLimit(r, e) || $aa8bf899fc620c38$var$_unsupportedIterableToArray(r, e) || $aa8bf899fc620c38$var$_nonIterableRest();
}
function $aa8bf899fc620c38$var$_toConsumableArray(r) {
    return $aa8bf899fc620c38$var$_arrayWithoutHoles(r) || $aa8bf899fc620c38$var$_iterableToArray(r) || $aa8bf899fc620c38$var$_unsupportedIterableToArray(r) || $aa8bf899fc620c38$var$_nonIterableSpread();
}
function $aa8bf899fc620c38$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $aa8bf899fc620c38$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $aa8bf899fc620c38$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $aa8bf899fc620c38$var$geoPolygonTriangulate(polygon) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$resolution = _ref.resolution, resolution = _ref$resolution === void 0 ? Infinity : _ref$resolution;
    var contour = $aa8bf899fc620c38$var$interpolateContourPoints(polygon, resolution);
    var edgePoints = (0, $cb98976747d597ae$export$2e2bcd8739ae039)(contour);
    var innerPoints = $aa8bf899fc620c38$var$getInnerGeoPoints(polygon, resolution);
    var points = [].concat($aa8bf899fc620c38$var$_toConsumableArray(edgePoints), $aa8bf899fc620c38$var$_toConsumableArray(innerPoints));
    var boundariesGeojson = {
        type: 'Polygon',
        coordinates: polygon
    };
    var _geoBounds = (0, $47339db63dfc5d6d$export$2e2bcd8739ae039)(boundariesGeojson), _geoBounds2 = $aa8bf899fc620c38$var$_slicedToArray(_geoBounds, 2), _geoBounds2$ = $aa8bf899fc620c38$var$_slicedToArray(_geoBounds2[0], 2), minLng = _geoBounds2$[0], minLat = _geoBounds2$[1], _geoBounds2$2 = $aa8bf899fc620c38$var$_slicedToArray(_geoBounds2[1], 2), maxLng = _geoBounds2$2[0], maxLat = _geoBounds2$2[1];
    var crossesPoleOrAntimeridian = minLng > maxLng // crosses antimeridian
     || maxLat >= 89 // crosses north pole
     || minLat <= -89; // crosses south pole
    var indices = [];
    if (crossesPoleOrAntimeridian) {
        // Use d3-geo-voronoi. Slowest, but most accurate for polygons that cross poles or anti-meridian
        var vt = (0, $10f6c26d929ba665$export$45beb76691a736bf)(points).triangles(); // geoDelaunay generates more triangles than needed
        var pntMap = new Map(points.map(function(_ref2, idx) {
            var _ref3 = $aa8bf899fc620c38$var$_slicedToArray(_ref2, 2), lng = _ref3[0], lat = _ref3[1];
            return [
                "".concat(lng, "-").concat(lat),
                idx
            ];
        }));
        vt.features.forEach(function(f) {
            var _indices;
            var triangle = f.geometry.coordinates[0].slice(0, 3).reverse(); // reverse wound to match earcut
            var inds = [];
            triangle.forEach(function(_ref4) {
                var _ref5 = $aa8bf899fc620c38$var$_slicedToArray(_ref4, 2), lng = _ref5[0], lat = _ref5[1];
                var k = "".concat(lng, "-").concat(lat);
                pntMap.has(k) && inds.push(pntMap.get(k));
            });
            if (inds.length !== 3) return; // triangle malfunction
            // exclude edge triangles outside polygon perimeter or through holes
            if (inds.some(function(ind) {
                return ind < edgePoints.length;
            })) {
                var triangleCentroid = f.properties.circumcenter;
                if (!$aa8bf899fc620c38$var$pointInside(triangleCentroid, boundariesGeojson, crossesPoleOrAntimeridian)) return;
            }
            (_indices = indices).push.apply(_indices, inds);
        });
    } else if (!innerPoints.length) {
        // earcut triangulation slightly more performing if it's only using the polygon perimeter
        var _earcutFlatten = (0, $624bc327dc53eb9b$export$bffa455ba8c619a6)(contour), vertices = _earcutFlatten.vertices, _earcutFlatten$holes = _earcutFlatten.holes, holes = _earcutFlatten$holes === void 0 ? [] : _earcutFlatten$holes;
        indices = (0, $624bc327dc53eb9b$export$2e2bcd8739ae039)(vertices, holes, 2);
    } else {
        // use delaunator
        var delaunay = (0, $7910d402b5fcb5cd$export$2e2bcd8739ae039).from(points);
        var _loop = function _loop(i) {
            var _indices2;
            var inds = [
                2,
                1,
                0
            ].map(function(idx) {
                return delaunay.triangles[i + idx];
            }); // reverse wound to have same orientation as earcut
            var triangle = inds.map(function(indice) {
                return points[indice];
            });
            // exclude edge triangles outside polygon perimeter or through holes
            if (inds.some(function(ind) {
                return ind < edgePoints.length;
            })) {
                var triangleCentroid = [
                    0,
                    1
                ].map(function(coordIdx) {
                    return (0, $f3d4701f0d8dc1f7$export$2e2bcd8739ae039)(triangle, function(p) {
                        return p[coordIdx];
                    });
                });
                if (!$aa8bf899fc620c38$var$pointInside(triangleCentroid, boundariesGeojson, crossesPoleOrAntimeridian)) return 1; // continue
            }
            (_indices2 = indices).push.apply(_indices2, $aa8bf899fc620c38$var$_toConsumableArray(inds));
        };
        for(var i = 0, len = delaunay.triangles.length; i < len; i += 3){
            if (_loop(i)) continue;
        }
    }
    // calc uvs
    var lngUvScale = (0, $050f6c6fd36ea5ca$export$2e2bcd8739ae039)((0, $ef085f926875ebfd$export$2e2bcd8739ae039)(points, function(d) {
        return d[0];
    }), [
        0,
        1
    ]);
    var latUvScale = (0, $050f6c6fd36ea5ca$export$2e2bcd8739ae039)((0, $ef085f926875ebfd$export$2e2bcd8739ae039)(points, function(d) {
        return d[1];
    }), [
        0,
        1
    ]);
    var uvs = points.map(function(_ref6) {
        var _ref7 = $aa8bf899fc620c38$var$_slicedToArray(_ref6, 2), lng = _ref7[0], lat = _ref7[1];
        return [
            lngUvScale(lng),
            latUvScale(lat)
        ];
    });
    var triangles = {
        points: points,
        indices: indices,
        uvs: uvs
    };
    return {
        contour: contour,
        triangles: triangles
    };
}
function $aa8bf899fc620c38$var$interpolateContourPoints(polygon, maxDistance) {
    // add interpolated points for segments that are further apart than the max distance
    return polygon.map(function(coords) {
        var pnts = [];
        var prevPnt;
        coords.forEach(function(pnt) {
            if (prevPnt) {
                var dist = (0, $6c415952b39ab5fa$export$2e2bcd8739ae039)(pnt, prevPnt) * 180 / Math.PI;
                if (dist > maxDistance) {
                    var interpol = (0, $40adbe455568c340$export$2e2bcd8739ae039)(prevPnt, pnt);
                    var tStep = 1 / Math.ceil(dist / maxDistance);
                    var t = tStep;
                    while(t < 1){
                        pnts.push(interpol(t));
                        t += tStep;
                    }
                }
            }
            pnts.push(prevPnt = pnt);
        });
        return pnts;
    });
}
function $aa8bf899fc620c38$var$getInnerGeoPoints(polygon, maxDistance) {
    var boundariesGeojson = {
        type: 'Polygon',
        coordinates: polygon
    };
    var _geoBounds3 = (0, $47339db63dfc5d6d$export$2e2bcd8739ae039)(boundariesGeojson), _geoBounds4 = $aa8bf899fc620c38$var$_slicedToArray(_geoBounds3, 2), _geoBounds4$ = $aa8bf899fc620c38$var$_slicedToArray(_geoBounds4[0], 2), minLng = _geoBounds4$[0], minLat = _geoBounds4$[1], _geoBounds4$2 = $aa8bf899fc620c38$var$_slicedToArray(_geoBounds4[1], 2), maxLng = _geoBounds4$2[0], maxLat = _geoBounds4$2[1];
    // polygon smaller than maxDistance -> no inner points
    if (Math.min(Math.abs(maxLng - minLng), Math.abs(maxLat - minLat)) < maxDistance) return [];
    var crossesPoleOrAntimeridian = minLng > maxLng || maxLat >= 89 || minLat <= -89;
    return $aa8bf899fc620c38$var$getGeoSpiralGrid(maxDistance, {
        minLng: minLng,
        maxLng: maxLng,
        minLat: minLat,
        maxLat: maxLat
    }).filter(function(pnt) {
        return $aa8bf899fc620c38$var$pointInside(pnt, boundariesGeojson, crossesPoleOrAntimeridian);
    });
}
function $aa8bf899fc620c38$var$getGeoSpiralGrid(distanceBetweenPoints) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, minLng = _ref8.minLng, maxLng = _ref8.maxLng, minLat = _ref8.minLat, maxLat = _ref8.maxLat;
    var numPoints = Math.round(Math.pow(360 / distanceBetweenPoints, 2) / Math.PI);
    // https://observablehq.com/@mbostock/spherical-fibonacci-lattice
    var phi = (1 + Math.sqrt(5)) / 2; // golden ratio
    var getPntLng = function getPntLng(idx) {
        return idx / phi * 360 % 360 - 180;
    };
    var getPntLat = function getPntLat(idx) {
        return Math.acos(2 * idx / numPoints - 1) / Math.PI * 180 - 90;
    };
    var getPntIdx = function getPntIdx(lat) {
        return numPoints * (Math.cos((lat + 90) * Math.PI / 180) + 1) / 2;
    };
    var pntIdxRange = [
        maxLat !== undefined ? Math.ceil(getPntIdx(maxLat)) : 0,
        minLat !== undefined ? Math.floor(getPntIdx(minLat)) : numPoints - 1
    ];
    var isLngInRange = minLng === undefined && maxLng === undefined ? function() {
        return true;
    } : minLng === undefined ? function(lng) {
        return lng <= maxLng;
    } : maxLng === undefined ? function(lng) {
        return lng >= minLng;
    } : maxLng >= minLng ? function(lng) {
        return lng >= minLng && lng <= maxLng;
    } : function(lng) {
        return lng >= minLng || lng <= maxLng;
    }; // for ranges that cross the anti-meridian
    var pnts = [];
    for(var i = pntIdxRange[0]; i <= pntIdxRange[1]; i++){
        var lng = getPntLng(i);
        isLngInRange(lng) && pnts.push([
            lng,
            getPntLat(i)
        ]);
    }
    return pnts;
}
function $aa8bf899fc620c38$var$pointInside(pnt, polygon) {
    var crossesPoleOrAntimeridian = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // turf method is more performing but malfunctions if polygon includes a pole (lat = 90 | -90) or crosses the antimeridian (lng = 180 | -180)
    return crossesPoleOrAntimeridian ? (0, $6e5a5e162e462412$export$2e2bcd8739ae039)(polygon, pnt) : (0, $1c3c864bea0fedaa$export$2e2bcd8739ae039)(pnt, polygon);
}
var $aa8bf899fc620c38$var$THREE = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959),
    Float32BufferAttribute: (0, $8725869b83961a04$export$cbe7a62641830ebd)
};
// support both modes for backwards threejs compatibility
var $aa8bf899fc620c38$var$setAttributeFn = new $aa8bf899fc620c38$var$THREE.BufferGeometry().setAttribute ? 'setAttribute' : 'addAttribute';
var $aa8bf899fc620c38$export$d1a95d7c8ca56306 = /*#__PURE__*/ function(_THREE$BufferGeometry) {
    function ConicPolygonBufferGeometry(polygonGeoJson, startHeight, endHeight, closedBottom, closedTop, includeSides, curvatureResolution) {
        var _this;
        $aa8bf899fc620c38$var$_classCallCheck(this, ConicPolygonBufferGeometry);
        _this = $aa8bf899fc620c38$var$_callSuper(this, ConicPolygonBufferGeometry);
        _this.type = 'ConicPolygonBufferGeometry';
        _this.parameters = {
            polygonGeoJson: polygonGeoJson,
            startHeight: startHeight,
            endHeight: endHeight,
            closedBottom: closedBottom,
            closedTop: closedTop,
            includeSides: includeSides,
            curvatureResolution: curvatureResolution
        };
        // defaults
        startHeight = startHeight || 0;
        endHeight = endHeight || 1;
        closedBottom = closedBottom !== undefined ? closedBottom : true;
        closedTop = closedTop !== undefined ? closedTop : true;
        includeSides = includeSides !== undefined ? includeSides : true;
        curvatureResolution = curvatureResolution || 5; // in angular degrees
        // pre-calculate contour, triangulation and UV maps
        var _geoPolygonTriangulat = $aa8bf899fc620c38$var$geoPolygonTriangulate(polygonGeoJson, {
            resolution: curvatureResolution
        }), contour = _geoPolygonTriangulat.contour, triangles = _geoPolygonTriangulat.triangles;
        var flatUvs = (0, $cb98976747d597ae$export$2e2bcd8739ae039)(triangles.uvs);
        var vertices = [];
        var uvs = [];
        var indices = [];
        var groupCnt = 0; // add groups to apply different materials to torso / caps
        var addGroup = function addGroup(groupData) {
            var prevVertCnt = Math.round(vertices.length / 3);
            var prevIndCnt = indices.length;
            vertices = vertices.concat(groupData.vertices);
            uvs = uvs.concat(groupData.uvs);
            indices = indices.concat(!prevVertCnt ? groupData.indices : groupData.indices.map(function(ind) {
                return ind + prevVertCnt;
            }));
            _this.addGroup(prevIndCnt, indices.length - prevIndCnt, groupCnt++);
        };
        includeSides && addGroup(generateTorso());
        closedBottom && addGroup(generateCap(startHeight, false));
        closedTop && addGroup(generateCap(endHeight, true));
        // build geometry
        _this.setIndex(indices);
        _this[$aa8bf899fc620c38$var$setAttributeFn]('position', new $aa8bf899fc620c38$var$THREE.Float32BufferAttribute(vertices, 3));
        _this[$aa8bf899fc620c38$var$setAttributeFn]('uv', new $aa8bf899fc620c38$var$THREE.Float32BufferAttribute(uvs, 2));
        // auto-calculate normals
        _this.computeVertexNormals();
        //
        function generateVertices(polygon, altitude) {
            var coords3d = polygon.map(function(coords) {
                return coords.map(function(_ref) {
                    var _ref2 = $aa8bf899fc620c38$var$_slicedToArray(_ref, 2), lng = _ref2[0], lat = _ref2[1];
                    return $aa8bf899fc620c38$var$polar2Cartesian(lat, lng, altitude);
                });
            });
            // returns { vertices, holes, coordinates }. Each point generates 3 vertice items (x,y,z).
            return (0, $624bc327dc53eb9b$export$bffa455ba8c619a6)(coords3d);
        }
        function generateTorso() {
            var _generateVertices = generateVertices(contour, startHeight), bottomVerts = _generateVertices.vertices, holes = _generateVertices.holes;
            var _generateVertices2 = generateVertices(contour, endHeight), topVerts = _generateVertices2.vertices;
            var vertices = (0, $cb98976747d597ae$export$2e2bcd8739ae039)([
                topVerts,
                bottomVerts
            ]);
            var numPoints = Math.round(topVerts.length / 3);
            var holesIdx = new Set(holes);
            var lastHoleIdx = 0;
            var indices = [];
            for(var v0Idx = 0; v0Idx < numPoints; v0Idx++){
                var v1Idx = v0Idx + 1; // next point
                if (v1Idx === numPoints) v1Idx = lastHoleIdx; // close final loop
                else if (holesIdx.has(v1Idx)) {
                    var holeIdx = v1Idx;
                    v1Idx = lastHoleIdx; // close hole loop
                    lastHoleIdx = holeIdx;
                }
                // Each pair of coords generates two triangles (faces)
                indices.push(v0Idx, v0Idx + numPoints, v1Idx + numPoints);
                indices.push(v1Idx + numPoints, v1Idx, v0Idx);
            }
            var uvs = []; // wrap texture around perimeter (u), with v=1 on top
            for(var v = 1; v >= 0; v--)for(var i = 0; i < numPoints; i += 1)uvs.push(i / (numPoints - 1), v);
            return {
                indices: indices,
                vertices: vertices,
                uvs: uvs
            };
        }
        function generateCap(radius) {
            var isTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return {
                // need to reverse-wind the bottom triangles to make them face outwards
                indices: isTop ? triangles.indices : triangles.indices.slice().reverse(),
                vertices: generateVertices([
                    triangles.points
                ], radius).vertices,
                uvs: flatUvs
            };
        }
        return _this;
    }
    $aa8bf899fc620c38$var$_inherits(ConicPolygonBufferGeometry, _THREE$BufferGeometry);
    return $aa8bf899fc620c38$var$_createClass(ConicPolygonBufferGeometry);
}($aa8bf899fc620c38$var$THREE.BufferGeometry); //
function $aa8bf899fc620c38$var$polar2Cartesian(lat, lng) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var phi = (90 - lat) * Math.PI / 180;
    var theta = (90 - lng) * Math.PI / 180;
    return [
        r * Math.sin(phi) * Math.cos(theta),
        // x
        r * Math.cos(phi),
        // y
        r * Math.sin(phi) * Math.sin(theta) // z
    ];
}



// @ts-nocheck
var $e3286925688328aa$var$libh3 = function(libh3) {
    libh3 = libh3 || {};
    var Module = typeof libh3 !== "undefined" ? libh3 : {};
    var moduleOverrides = {};
    var key;
    for(key in Module)if (Module.hasOwnProperty(key)) moduleOverrides[key] = Module[key];
    var arguments_ = [];
    var scriptDirectory = "";
    function locateFile(path) {
        if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
        return scriptDirectory + path;
    }
    var readAsync;
    if (typeof document !== "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
    if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf("/") + 1);
    else scriptDirectory = "";
    readAsync = function readAsync(url, onload, onerror) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "arraybuffer";
        xhr.onload = function xhr_onload() {
            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                onload(xhr.response);
                return;
            }
            var data = tryParseAsDataURI(url);
            if (data) {
                onload(data.buffer);
                return;
            }
            onerror();
        };
        xhr.onerror = onerror;
        xhr.send(null);
    };
    var out = Module["print"] || console.log.bind(console);
    var err = Module["printErr"] || console.warn.bind(console);
    for(key in moduleOverrides)if (moduleOverrides.hasOwnProperty(key)) Module[key] = moduleOverrides[key];
    moduleOverrides = null;
    if (Module["arguments"]) arguments_ = Module["arguments"];
    var tempRet0 = 0;
    var setTempRet0 = function(value) {
        tempRet0 = value;
    };
    var getTempRet0 = function() {
        return tempRet0;
    };
    var GLOBAL_BASE = 8;
    function setValue(ptr, value, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                HEAP8[ptr >> 0] = value;
                break;
            case "i8":
                HEAP8[ptr >> 0] = value;
                break;
            case "i16":
                HEAP16[ptr >> 1] = value;
                break;
            case "i32":
                HEAP32[ptr >> 2] = value;
                break;
            case "i64":
                tempI64 = [
                    value >>> 0,
                    (tempDouble = value, +Math_abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math_min(+Math_floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];
                break;
            case "float":
                HEAPF32[ptr >> 2] = value;
                break;
            case "double":
                HEAPF64[ptr >> 3] = value;
                break;
            default:
                abort("invalid type for setValue: " + type);
        }
    }
    function getValue(ptr, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                return HEAP8[ptr >> 0];
            case "i8":
                return HEAP8[ptr >> 0];
            case "i16":
                return HEAP16[ptr >> 1];
            case "i32":
                return HEAP32[ptr >> 2];
            case "i64":
                return HEAP32[ptr >> 2];
            case "float":
                return HEAPF32[ptr >> 2];
            case "double":
                return HEAPF64[ptr >> 3];
            default:
                abort("invalid type for getValue: " + type);
        }
        return null;
    }
    var ABORT = false;
    function assert(condition, text) {
        if (!condition) abort("Assertion failed: " + text);
    }
    function getCFunc(ident) {
        var func = Module["_" + ident];
        assert(func, "Cannot call unknown function " + ident + ", make sure it is exported");
        return func;
    }
    function ccall(ident, returnType, argTypes, args, opts) {
        var toC = {
            "string": function(str) {
                var ret = 0;
                if (str !== null && str !== undefined && str !== 0) {
                    var len = (str.length << 2) + 1;
                    ret = stackAlloc(len);
                    stringToUTF8(str, ret, len);
                }
                return ret;
            },
            "array": function(arr) {
                var ret = stackAlloc(arr.length);
                writeArrayToMemory(arr, ret);
                return ret;
            }
        };
        function convertReturnValue(ret) {
            if (returnType === "string") return UTF8ToString(ret);
            if (returnType === "boolean") return Boolean(ret);
            return ret;
        }
        var func = getCFunc(ident);
        var cArgs = [];
        var stack = 0;
        if (args) for(var i = 0; i < args.length; i++){
            var converter = toC[argTypes[i]];
            if (converter) {
                if (stack === 0) stack = stackSave();
                cArgs[i] = converter(args[i]);
            } else cArgs[i] = args[i];
        }
        var ret = func.apply(null, cArgs);
        ret = convertReturnValue(ret);
        if (stack !== 0) stackRestore(stack);
        return ret;
    }
    function cwrap(ident, returnType, argTypes, opts) {
        argTypes = argTypes || [];
        var numericArgs = argTypes.every(function(type) {
            return type === "number";
        });
        var numericRet = returnType !== "string";
        if (numericRet && numericArgs && !opts) return getCFunc(ident);
        return function() {
            return ccall(ident, returnType, argTypes, arguments, opts);
        };
    }
    var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : undefined;
    function UTF8ArrayToString(u8Array, idx, maxBytesToRead) {
        var endIdx = idx + maxBytesToRead;
        var endPtr = idx;
        while(u8Array[endPtr] && !(endPtr >= endIdx))++endPtr;
        if (endPtr - idx > 16 && u8Array.subarray && UTF8Decoder) return UTF8Decoder.decode(u8Array.subarray(idx, endPtr));
        else {
            var str = "";
            while(idx < endPtr){
                var u0 = u8Array[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = u8Array[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = u8Array[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | u8Array[idx++] & 63;
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
        }
        return str;
    }
    function UTF8ToString(ptr, maxBytesToRead) {
        return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
    }
    function stringToUTF8Array(str, outU8Array, outIdx, maxBytesToWrite) {
        if (!(maxBytesToWrite > 0)) return 0;
        var startIdx = outIdx;
        var endIdx = outIdx + maxBytesToWrite - 1;
        for(var i = 0; i < str.length; ++i){
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
                var u1 = str.charCodeAt(++i);
                u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
                if (outIdx >= endIdx) break;
                outU8Array[outIdx++] = u;
            } else if (u <= 2047) {
                if (outIdx + 1 >= endIdx) break;
                outU8Array[outIdx++] = 192 | u >> 6;
                outU8Array[outIdx++] = 128 | u & 63;
            } else if (u <= 65535) {
                if (outIdx + 2 >= endIdx) break;
                outU8Array[outIdx++] = 224 | u >> 12;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            } else {
                if (outIdx + 3 >= endIdx) break;
                outU8Array[outIdx++] = 240 | u >> 18;
                outU8Array[outIdx++] = 128 | u >> 12 & 63;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            }
        }
        outU8Array[outIdx] = 0;
        return outIdx - startIdx;
    }
    function stringToUTF8(str, outPtr, maxBytesToWrite) {
        return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
    }
    var UTF16Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : undefined;
    function writeArrayToMemory(array, buffer) {
        HEAP8.set(array, buffer);
    }
    function alignUp(x, multiple) {
        if (x % multiple > 0) x += multiple - x % multiple;
        return x;
    }
    var buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
    function updateGlobalBufferAndViews(buf) {
        buffer = buf;
        Module["HEAP8"] = HEAP8 = new Int8Array(buf);
        Module["HEAP16"] = HEAP16 = new Int16Array(buf);
        Module["HEAP32"] = HEAP32 = new Int32Array(buf);
        Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
        Module["HEAPU16"] = HEAPU16 = new Uint16Array(buf);
        Module["HEAPU32"] = HEAPU32 = new Uint32Array(buf);
        Module["HEAPF32"] = HEAPF32 = new Float32Array(buf);
        Module["HEAPF64"] = HEAPF64 = new Float64Array(buf);
    }
    var DYNAMIC_BASE = 5271520, DYNAMICTOP_PTR = 28608;
    var INITIAL_TOTAL_MEMORY = Module["TOTAL_MEMORY"] || 33554432;
    if (Module["buffer"]) buffer = Module["buffer"];
    else buffer = new ArrayBuffer(INITIAL_TOTAL_MEMORY);
    INITIAL_TOTAL_MEMORY = buffer.byteLength;
    updateGlobalBufferAndViews(buffer);
    HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;
    function callRuntimeCallbacks(callbacks) {
        while(callbacks.length > 0){
            var callback = callbacks.shift();
            if (typeof callback == "function") {
                callback();
                continue;
            }
            var func = callback.func;
            if (typeof func === "number") {
                if (callback.arg === undefined) Module["dynCall_v"](func);
                else Module["dynCall_vi"](func, callback.arg);
            } else func(callback.arg === undefined ? null : callback.arg);
        }
    }
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATMAIN__ = [];
    var __ATPOSTRUN__ = [];
    function preRun() {
        if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [
                Module["preRun"]
            ];
            while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
        }
        callRuntimeCallbacks(__ATPRERUN__);
    }
    function initRuntime() {
        callRuntimeCallbacks(__ATINIT__);
    }
    function preMain() {
        callRuntimeCallbacks(__ATMAIN__);
    }
    function postRun() {
        if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [
                Module["postRun"]
            ];
            while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
        }
        callRuntimeCallbacks(__ATPOSTRUN__);
    }
    function addOnPreRun(cb) {
        __ATPRERUN__.unshift(cb);
    }
    function addOnPostRun(cb) {
        __ATPOSTRUN__.unshift(cb);
    }
    var Math_abs = Math.abs;
    var Math_ceil = Math.ceil;
    var Math_floor = Math.floor;
    var Math_min = Math.min;
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;
    function addRunDependency(id) {
        runDependencies++;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
    }
    function removeRunDependency(id) {
        runDependencies--;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
                clearInterval(runDependencyWatcher);
                runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
                var callback = dependenciesFulfilled;
                dependenciesFulfilled = null;
                callback();
            }
        }
    }
    Module["preloadedImages"] = {};
    Module["preloadedAudios"] = {};
    var memoryInitializer = null;
    var dataURIPrefix = "data:application/octet-stream;base64,";
    function isDataURI(filename) {
        return String.prototype.startsWith ? filename.startsWith(dataURIPrefix) : filename.indexOf(dataURIPrefix) === 0;
    }
    var tempDouble;
    var tempI64;
    memoryInitializer = "data:application/octet-stream;base64,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";
    var tempDoublePtr = 28624;
    function demangle(func) {
        return func;
    }
    function demangleAll(text) {
        var regex = /\b__Z[\w\d_]+/g;
        return text.replace(regex, function(x) {
            var y = demangle(x);
            return x === y ? x : y + " [" + x + "]";
        });
    }
    function jsStackTrace() {
        var err = new Error();
        if (!err.stack) {
            try {
                throw new Error(0);
            } catch (e) {
                err = e;
            }
            if (!err.stack) return "(no stack trace available)";
        }
        return err.stack.toString();
    }
    function stackTrace() {
        var js = jsStackTrace();
        if (Module["extraStackTrace"]) js += "\n" + Module["extraStackTrace"]();
        return demangleAll(js);
    }
    function ___assert_fail(condition, filename, line, func) {
        abort("Assertion failed: " + UTF8ToString(condition) + ", at: " + [
            filename ? UTF8ToString(filename) : "unknown filename",
            line,
            func ? UTF8ToString(func) : "unknown function"
        ]);
    }
    function _emscripten_get_heap_size() {
        return HEAP8.length;
    }
    function _emscripten_memcpy_big(dest, src, num) {
        HEAPU8.set(HEAPU8.subarray(src, src + num), dest);
    }
    function ___setErrNo(value) {
        if (Module["___errno_location"]) HEAP32[Module["___errno_location"]() >> 2] = value;
        return value;
    }
    function abortOnCannotGrowMemory(requestedSize) {
        abort("OOM");
    }
    function emscripten_realloc_buffer(size) {
        try {
            var newBuffer = new ArrayBuffer(size);
            if (newBuffer.byteLength != size) return;
            new Int8Array(newBuffer).set(HEAP8);
            _emscripten_replace_memory(newBuffer);
            updateGlobalBufferAndViews(newBuffer);
            return 1;
        } catch (e) {}
    }
    function _emscripten_resize_heap(requestedSize) {
        var oldSize = _emscripten_get_heap_size();
        var PAGE_MULTIPLE = 16777216;
        var LIMIT = 2147483648 - PAGE_MULTIPLE;
        if (requestedSize > LIMIT) return false;
        var MIN_TOTAL_MEMORY = 16777216;
        var newSize = Math.max(oldSize, MIN_TOTAL_MEMORY);
        while(newSize < requestedSize)if (newSize <= 536870912) newSize = alignUp(2 * newSize, PAGE_MULTIPLE);
        else newSize = Math.min(alignUp((3 * newSize + 2147483648) / 4, PAGE_MULTIPLE), LIMIT);
        var replacement = emscripten_realloc_buffer(newSize);
        if (!replacement) return false;
        return true;
    }
    var decodeBase64 = typeof atob === "function" ? atob : function(input) {
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        do {
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 !== 64) output = output + String.fromCharCode(chr2);
            if (enc4 !== 64) output = output + String.fromCharCode(chr3);
        }while (i < input.length);
        return output;
    };
    function intArrayFromBase64(s) {
        try {
            var decoded = decodeBase64(s);
            var bytes = new Uint8Array(decoded.length);
            for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
            return bytes;
        } catch (_) {
            throw new Error("Converting base64 string to bytes failed.");
        }
    }
    function tryParseAsDataURI(filename) {
        if (!isDataURI(filename)) return;
        return intArrayFromBase64(filename.slice(dataURIPrefix.length));
    }
    var asmGlobalArg = {
        "Math": Math,
        "Int8Array": Int8Array,
        "Int32Array": Int32Array,
        "Uint8Array": Uint8Array,
        "Float32Array": Float32Array,
        "Float64Array": Float64Array
    };
    var asmLibraryArg = {
        "a": abort,
        "b": setTempRet0,
        "c": getTempRet0,
        "d": ___assert_fail,
        "e": ___setErrNo,
        "f": _emscripten_get_heap_size,
        "g": _emscripten_memcpy_big,
        "h": _emscripten_resize_heap,
        "i": abortOnCannotGrowMemory,
        "j": demangle,
        "k": demangleAll,
        "l": emscripten_realloc_buffer,
        "m": jsStackTrace,
        "n": stackTrace,
        "o": tempDoublePtr,
        "p": DYNAMICTOP_PTR
    }; // EMSCRIPTEN_START_ASM
    var asm = /** @suppress {uselessCode} */ function(global, env, buffer) {
        "almost asm";
        var a = new global.Int8Array(buffer), b = new global.Int32Array(buffer), c = new global.Uint8Array(buffer), d = new global.Float32Array(buffer), e = new global.Float64Array(buffer), f = env.o | 0, g = env.p | 0, p = global.Math.floor, q = global.Math.abs, r = global.Math.sqrt, s = global.Math.pow, t = global.Math.cos, u = global.Math.sin, v = global.Math.tan, w = global.Math.acos, x = global.Math.asin, y = global.Math.atan, z = global.Math.atan2, A = global.Math.ceil, B = global.Math.imul, C = global.Math.min, D = global.Math.max, E = global.Math.clz32, G = env.b, H = env.c, I = env.d, J = env.e, K = env.f, L = env.g, M = env.h, N = env.i, T = 28640;
        function W(newBuffer) {
            a = new Int8Array(newBuffer);
            c = new Uint8Array(newBuffer);
            b = new Int32Array(newBuffer);
            d = new Float32Array(newBuffer);
            e = new Float64Array(newBuffer);
            buffer = newBuffer;
            return true;
        }
        // EMSCRIPTEN_START_FUNCS
        function X(a) {
            a = a | 0;
            var b = 0;
            b = T;
            T = T + a | 0;
            T = T + 15 & -16;
            return b | 0;
        }
        function Y() {
            return T | 0;
        }
        function Z(a) {
            a = a | 0;
            T = a;
        }
        function _(a, b) {
            a = a | 0;
            b = b | 0;
            T = a;
        }
        function $(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0;
            if ((a | 0) < 0) {
                c = 2;
                return c | 0;
            }
            if ((a | 0) > 13780509) {
                c = sc(15, c) | 0;
                return c | 0;
            } else {
                d = ((a | 0) < 0) << 31 >> 31;
                f = Kd(a | 0, d | 0, 3, 0) | 0;
                e = H() | 0;
                d = Ed(a | 0, d | 0, 1, 0) | 0;
                d = Kd(f | 0, e | 0, d | 0, H() | 0) | 0;
                d = Ed(d | 0, H() | 0, 1, 0) | 0;
                a = H() | 0;
                b[c >> 2] = d;
                b[c + 4 >> 2] = a;
                c = 0;
                return c | 0;
            }
            return 0;
        }
        function aa(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            return ba(a, b, c, d, 0) | 0;
        }
        function ba(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0;
            j = T;
            T = T + 16 | 0;
            h = j;
            if (!(ca(a, c, d, e, f) | 0)) {
                e = 0;
                T = j;
                return e | 0;
            }
            do if ((d | 0) >= 0) {
                if ((d | 0) > 13780509) {
                    g = sc(15, h) | 0;
                    if (g | 0) break;
                    i = h;
                    h = b[i >> 2] | 0;
                    i = b[i + 4 >> 2] | 0;
                } else {
                    g = ((d | 0) < 0) << 31 >> 31;
                    k = Kd(d | 0, g | 0, 3, 0) | 0;
                    i = H() | 0;
                    g = Ed(d | 0, g | 0, 1, 0) | 0;
                    g = Kd(k | 0, i | 0, g | 0, H() | 0) | 0;
                    g = Ed(g | 0, H() | 0, 1, 0) | 0;
                    i = H() | 0;
                    b[h >> 2] = g;
                    b[h + 4 >> 2] = i;
                    h = g;
                }
                Vd(e | 0, 0, h << 3 | 0);
                if (f | 0) {
                    Vd(f | 0, 0, h << 2 | 0);
                    g = da(a, c, d, e, f, h, i, 0) | 0;
                    break;
                }
                g = Dd(h, 4) | 0;
                if (!g) g = 13;
                else {
                    k = da(a, c, d, e, g, h, i, 0) | 0;
                    Cd(g);
                    g = k;
                }
            } else g = 2;
            while (0);
            k = g;
            T = j;
            return k | 0;
        }
        function ca(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0;
            q = T;
            T = T + 16 | 0;
            o = q;
            p = q + 8 | 0;
            n = o;
            b[n >> 2] = a;
            b[n + 4 >> 2] = c;
            if ((d | 0) < 0) {
                p = 2;
                T = q;
                return p | 0;
            }
            g = e;
            b[g >> 2] = a;
            b[g + 4 >> 2] = c;
            g = (f | 0) != 0;
            if (g) b[f >> 2] = 0;
            if (Fb(a, c) | 0) {
                p = 9;
                T = q;
                return p | 0;
            }
            b[p >> 2] = 0;
            a: do if ((d | 0) >= 1) {
                if (g) {
                    l = 1;
                    k = 0;
                    m = 0;
                    n = 1;
                    g = a;
                    while(true){
                        if (!(k | m)) {
                            g = ea(g, c, 4, p, o) | 0;
                            if (g | 0) break a;
                            c = o;
                            g = b[c >> 2] | 0;
                            c = b[c + 4 >> 2] | 0;
                            if (Fb(g, c) | 0) {
                                g = 9;
                                break a;
                            }
                        }
                        g = ea(g, c, b[26800 + (m << 2) >> 2] | 0, p, o) | 0;
                        if (g | 0) break a;
                        c = o;
                        g = b[c >> 2] | 0;
                        c = b[c + 4 >> 2] | 0;
                        a = e + (l << 3) | 0;
                        b[a >> 2] = g;
                        b[a + 4 >> 2] = c;
                        b[f + (l << 2) >> 2] = n;
                        a = k + 1 | 0;
                        h = (a | 0) == (n | 0);
                        i = m + 1 | 0;
                        j = (i | 0) == 6;
                        if (Fb(g, c) | 0) {
                            g = 9;
                            break a;
                        }
                        n = n + (j & h & 1) | 0;
                        if ((n | 0) > (d | 0)) {
                            g = 0;
                            break;
                        } else {
                            l = l + 1 | 0;
                            k = h ? 0 : a;
                            m = h ? j ? 0 : i : m;
                        }
                    }
                } else {
                    l = 1;
                    k = 0;
                    m = 0;
                    n = 1;
                    g = a;
                    while(true){
                        if (!(k | m)) {
                            g = ea(g, c, 4, p, o) | 0;
                            if (g | 0) break a;
                            c = o;
                            g = b[c >> 2] | 0;
                            c = b[c + 4 >> 2] | 0;
                            if (Fb(g, c) | 0) {
                                g = 9;
                                break a;
                            }
                        }
                        g = ea(g, c, b[26800 + (m << 2) >> 2] | 0, p, o) | 0;
                        if (g | 0) break a;
                        c = o;
                        g = b[c >> 2] | 0;
                        c = b[c + 4 >> 2] | 0;
                        a = e + (l << 3) | 0;
                        b[a >> 2] = g;
                        b[a + 4 >> 2] = c;
                        a = k + 1 | 0;
                        h = (a | 0) == (n | 0);
                        i = m + 1 | 0;
                        j = (i | 0) == 6;
                        if (Fb(g, c) | 0) {
                            g = 9;
                            break a;
                        }
                        n = n + (j & h & 1) | 0;
                        if ((n | 0) > (d | 0)) {
                            g = 0;
                            break;
                        } else {
                            l = l + 1 | 0;
                            k = h ? 0 : a;
                            m = h ? j ? 0 : i : m;
                        }
                    }
                }
            } else g = 0;
            while (0);
            p = g;
            T = q;
            return p | 0;
        }
        function da(a, c, d, e, f, g, h, i) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
            q = T;
            T = T + 16 | 0;
            o = q + 8 | 0;
            p = q;
            j = Md(a | 0, c | 0, g | 0, h | 0) | 0;
            l = H() | 0;
            m = e + (j << 3) | 0;
            r = m;
            s = b[r >> 2] | 0;
            r = b[r + 4 >> 2] | 0;
            k = (s | 0) == (a | 0) & (r | 0) == (c | 0);
            if (!((s | 0) == 0 & (r | 0) == 0 | k)) do {
                j = Ed(j | 0, l | 0, 1, 0) | 0;
                j = Ld(j | 0, H() | 0, g | 0, h | 0) | 0;
                l = H() | 0;
                m = e + (j << 3) | 0;
                s = m;
                r = b[s >> 2] | 0;
                s = b[s + 4 >> 2] | 0;
                k = (r | 0) == (a | 0) & (s | 0) == (c | 0);
            }while (!((r | 0) == 0 & (s | 0) == 0 | k));
            j = f + (j << 2) | 0;
            if (k ? (b[j >> 2] | 0) <= (i | 0) : 0) {
                s = 0;
                T = q;
                return s | 0;
            }
            s = m;
            b[s >> 2] = a;
            b[s + 4 >> 2] = c;
            b[j >> 2] = i;
            if ((i | 0) >= (d | 0)) {
                s = 0;
                T = q;
                return s | 0;
            }
            k = i + 1 | 0;
            b[o >> 2] = 0;
            j = ea(a, c, 2, o, p) | 0;
            switch(j | 0){
                case 9:
                    n = 9;
                    break;
                case 0:
                    j = p;
                    j = da(b[j >> 2] | 0, b[j + 4 >> 2] | 0, d, e, f, g, h, k) | 0;
                    if (!j) n = 9;
                    break;
                default:
            }
            a: do if ((n | 0) == 9) {
                b[o >> 2] = 0;
                j = ea(a, c, 3, o, p) | 0;
                switch(j | 0){
                    case 9:
                        break;
                    case 0:
                        j = p;
                        j = da(b[j >> 2] | 0, b[j + 4 >> 2] | 0, d, e, f, g, h, k) | 0;
                        if (j | 0) break a;
                        break;
                    default:
                        break a;
                }
                b[o >> 2] = 0;
                j = ea(a, c, 1, o, p) | 0;
                switch(j | 0){
                    case 9:
                        break;
                    case 0:
                        j = p;
                        j = da(b[j >> 2] | 0, b[j + 4 >> 2] | 0, d, e, f, g, h, k) | 0;
                        if (j | 0) break a;
                        break;
                    default:
                        break a;
                }
                b[o >> 2] = 0;
                j = ea(a, c, 5, o, p) | 0;
                switch(j | 0){
                    case 9:
                        break;
                    case 0:
                        j = p;
                        j = da(b[j >> 2] | 0, b[j + 4 >> 2] | 0, d, e, f, g, h, k) | 0;
                        if (j | 0) break a;
                        break;
                    default:
                        break a;
                }
                b[o >> 2] = 0;
                j = ea(a, c, 4, o, p) | 0;
                switch(j | 0){
                    case 9:
                        break;
                    case 0:
                        j = p;
                        j = da(b[j >> 2] | 0, b[j + 4 >> 2] | 0, d, e, f, g, h, k) | 0;
                        if (j | 0) break a;
                        break;
                    default:
                        break a;
                }
                b[o >> 2] = 0;
                j = ea(a, c, 6, o, p) | 0;
                switch(j | 0){
                    case 9:
                        break;
                    case 0:
                        j = p;
                        j = da(b[j >> 2] | 0, b[j + 4 >> 2] | 0, d, e, f, g, h, k) | 0;
                        if (j | 0) break a;
                        break;
                    default:
                        break a;
                }
                s = 0;
                T = q;
                return s | 0;
            }
            while (0);
            s = j;
            T = q;
            return s | 0;
        }
        function ea(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            if (d >>> 0 > 6) {
                f = 1;
                return f | 0;
            }
            m = (b[e >> 2] | 0) % 6 | 0;
            b[e >> 2] = m;
            if ((m | 0) > 0) {
                g = 0;
                do {
                    d = Za(d) | 0;
                    g = g + 1 | 0;
                }while ((g | 0) < (b[e >> 2] | 0));
            }
            m = Od(a | 0, c | 0, 45) | 0;
            H();
            l = m & 127;
            if (l >>> 0 > 121) {
                f = 5;
                return f | 0;
            }
            j = Nb(a, c) | 0;
            g = Od(a | 0, c | 0, 52) | 0;
            H();
            g = g & 15;
            a: do if (!g) k = 8;
            else {
                while(true){
                    h = (15 - g | 0) * 3 | 0;
                    i = Od(a | 0, c | 0, h | 0) | 0;
                    H();
                    i = i & 7;
                    if ((i | 0) == 7) {
                        c = 5;
                        break;
                    }
                    p = (Tb(g) | 0) == 0;
                    g = g + -1 | 0;
                    n = Pd(7, 0, h | 0) | 0;
                    c = c & ~(H() | 0);
                    o = Pd(b[(p ? 432 : 16) + (i * 28 | 0) + (d << 2) >> 2] | 0, 0, h | 0) | 0;
                    h = H() | 0;
                    d = b[(p ? 640 : 224) + (i * 28 | 0) + (d << 2) >> 2] | 0;
                    a = o | a & ~n;
                    c = h | c;
                    if (!d) {
                        d = 0;
                        break a;
                    }
                    if (!g) {
                        k = 8;
                        break a;
                    }
                }
                return c | 0;
            }
            while (0);
            if ((k | 0) == 8) {
                p = b[848 + (l * 28 | 0) + (d << 2) >> 2] | 0;
                o = Pd(p | 0, 0, 45) | 0;
                a = o | a;
                c = H() | 0 | c & -1040385;
                d = b[4272 + (l * 28 | 0) + (d << 2) >> 2] | 0;
                if ((p & 127 | 0) == 127) {
                    p = Pd(b[848 + (l * 28 | 0) + 20 >> 2] | 0, 0, 45) | 0;
                    c = H() | 0 | c & -1040385;
                    d = b[4272 + (l * 28 | 0) + 20 >> 2] | 0;
                    a = Pb(p | a, c) | 0;
                    c = H() | 0;
                    b[e >> 2] = (b[e >> 2] | 0) + 1;
                }
            }
            i = Od(a | 0, c | 0, 45) | 0;
            H();
            i = i & 127;
            b: do {
                if (!(ma(i) | 0)) {
                    if ((d | 0) > 0) {
                        g = 0;
                        do {
                            a = Pb(a, c) | 0;
                            c = H() | 0;
                            g = g + 1 | 0;
                        }while ((g | 0) != (d | 0));
                    }
                } else {
                    c: do if ((Nb(a, c) | 0) == 1) {
                        if ((l | 0) != (i | 0)) {
                            if (sa(i, b[7696 + (l * 28 | 0) >> 2] | 0) | 0) {
                                a = Rb(a, c) | 0;
                                h = 1;
                                c = H() | 0;
                                break;
                            } else I(27795, 26864, 436, 26872);
                        }
                        switch(j | 0){
                            case 3:
                                a = Pb(a, c) | 0;
                                c = H() | 0;
                                b[e >> 2] = (b[e >> 2] | 0) + 1;
                                h = 0;
                                break c;
                            case 5:
                                a = Rb(a, c) | 0;
                                c = H() | 0;
                                b[e >> 2] = (b[e >> 2] | 0) + 5;
                                h = 0;
                                break c;
                            case 0:
                                p = 9;
                                return p | 0;
                            default:
                                p = 1;
                                return p | 0;
                        }
                    } else h = 0;
                    while (0);
                    if ((d | 0) > 0) {
                        g = 0;
                        do {
                            a = Ob(a, c) | 0;
                            c = H() | 0;
                            g = g + 1 | 0;
                        }while ((g | 0) != (d | 0));
                    }
                    if ((l | 0) != (i | 0)) {
                        if (!(na(i) | 0)) {
                            if ((h | 0) != 0 | (Nb(a, c) | 0) != 5) break;
                            b[e >> 2] = (b[e >> 2] | 0) + 1;
                            break;
                        }
                        switch(m & 127){
                            case 8:
                            case 118:
                                break b;
                            default:
                        }
                        if ((Nb(a, c) | 0) != 3) b[e >> 2] = (b[e >> 2] | 0) + 1;
                    }
                }
            }while (0);
            b[e >> 2] = ((b[e >> 2] | 0) + d | 0) % 6 | 0;
            p = f;
            b[p >> 2] = a;
            b[p + 4 >> 2] = c;
            p = 0;
            return p | 0;
        }
        function fa(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            i = T;
            T = T + 16 | 0;
            g = i;
            h = i + 8 | 0;
            f = (Fb(a, c) | 0) == 0;
            f = f ? 1 : 2;
            while(true){
                b[h >> 2] = 0;
                k = (ea(a, c, f, h, g) | 0) == 0;
                j = g;
                if (k & ((b[j >> 2] | 0) == (d | 0) ? (b[j + 4 >> 2] | 0) == (e | 0) : 0)) {
                    a = 4;
                    break;
                }
                f = f + 1 | 0;
                if (f >>> 0 >= 7) {
                    f = 7;
                    a = 4;
                    break;
                }
            }
            if ((a | 0) == 4) {
                T = i;
                return f | 0;
            }
            return 0;
        }
        function ga(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            p = T;
            T = T + 16 | 0;
            n = p;
            o = p + 8 | 0;
            m = n;
            b[m >> 2] = a;
            b[m + 4 >> 2] = c;
            if (!d) {
                o = e;
                b[o >> 2] = a;
                b[o + 4 >> 2] = c;
                o = 0;
                T = p;
                return o | 0;
            }
            b[o >> 2] = 0;
            a: do if (!(Fb(a, c) | 0)) {
                g = (d | 0) > 0;
                if (g) {
                    f = 0;
                    m = a;
                    do {
                        a = ea(m, c, 4, o, n) | 0;
                        if (a | 0) break a;
                        c = n;
                        m = b[c >> 2] | 0;
                        c = b[c + 4 >> 2] | 0;
                        f = f + 1 | 0;
                        if (Fb(m, c) | 0) {
                            a = 9;
                            break a;
                        }
                    }while ((f | 0) < (d | 0));
                    l = e;
                    b[l >> 2] = m;
                    b[l + 4 >> 2] = c;
                    l = d + -1 | 0;
                    if (g) {
                        k = 0;
                        a = 1;
                        do {
                            f = 26800 + (k << 2) | 0;
                            if ((k | 0) == 5) {
                                h = b[f >> 2] | 0;
                                g = 0;
                                f = a;
                                while(true){
                                    a = n;
                                    a = ea(b[a >> 2] | 0, b[a + 4 >> 2] | 0, h, o, n) | 0;
                                    if (a | 0) break a;
                                    if ((g | 0) != (l | 0)) {
                                        j = n;
                                        i = b[j >> 2] | 0;
                                        j = b[j + 4 >> 2] | 0;
                                        a = e + (f << 3) | 0;
                                        b[a >> 2] = i;
                                        b[a + 4 >> 2] = j;
                                        if (!(Fb(i, j) | 0)) a = f + 1 | 0;
                                        else {
                                            a = 9;
                                            break a;
                                        }
                                    } else a = f;
                                    g = g + 1 | 0;
                                    if ((g | 0) >= (d | 0)) break;
                                    else f = a;
                                }
                            } else {
                                h = n;
                                j = b[f >> 2] | 0;
                                i = 0;
                                f = a;
                                g = b[h >> 2] | 0;
                                h = b[h + 4 >> 2] | 0;
                                while(true){
                                    a = ea(g, h, j, o, n) | 0;
                                    if (a | 0) break a;
                                    h = n;
                                    g = b[h >> 2] | 0;
                                    h = b[h + 4 >> 2] | 0;
                                    a = e + (f << 3) | 0;
                                    b[a >> 2] = g;
                                    b[a + 4 >> 2] = h;
                                    a = f + 1 | 0;
                                    if (Fb(g, h) | 0) {
                                        a = 9;
                                        break a;
                                    }
                                    i = i + 1 | 0;
                                    if ((i | 0) >= (d | 0)) break;
                                    else f = a;
                                }
                            }
                            k = k + 1 | 0;
                        }while (k >>> 0 < 6);
                        a = n;
                        h = m;
                        f = b[a >> 2] | 0;
                        g = c;
                        a = b[a + 4 >> 2] | 0;
                    } else {
                        h = m;
                        f = m;
                        g = c;
                        a = c;
                    }
                } else {
                    h = e;
                    b[h >> 2] = a;
                    b[h + 4 >> 2] = c;
                    h = a;
                    f = a;
                    g = c;
                    a = c;
                }
                a = (h | 0) == (f | 0) & (g | 0) == (a | 0) ? 0 : 9;
            } else a = 9;
            while (0);
            o = a;
            T = p;
            return o | 0;
        }
        function ha(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            i = T;
            T = T + 48 | 0;
            f = i + 16 | 0;
            g = i + 8 | 0;
            h = i;
            d = Vc(d) | 0;
            if (d | 0) {
                h = d;
                T = i;
                return h | 0;
            }
            k = a;
            j = b[k + 4 >> 2] | 0;
            d = g;
            b[d >> 2] = b[k >> 2];
            b[d + 4 >> 2] = j;
            Uc(g, f);
            d = Fa(f, c, h) | 0;
            if (!d) {
                c = b[g >> 2] | 0;
                g = b[a + 8 >> 2] | 0;
                if ((g | 0) > 0) {
                    f = b[a + 12 >> 2] | 0;
                    d = 0;
                    do {
                        c = (b[f + (d << 3) >> 2] | 0) + c | 0;
                        d = d + 1 | 0;
                    }while ((d | 0) < (g | 0));
                }
                d = h;
                f = b[d >> 2] | 0;
                d = b[d + 4 >> 2] | 0;
                g = ((c | 0) < 0) << 31 >> 31;
                if ((d | 0) < (g | 0) | (d | 0) == (g | 0) & f >>> 0 < c >>> 0) {
                    d = h;
                    b[d >> 2] = c;
                    b[d + 4 >> 2] = g;
                    d = g;
                } else c = f;
                j = Ed(c | 0, d | 0, 12, 0) | 0;
                k = H() | 0;
                d = h;
                b[d >> 2] = j;
                b[d + 4 >> 2] = k;
                d = e;
                b[d >> 2] = j;
                b[d + 4 >> 2] = k;
                d = 0;
            }
            k = d;
            T = i;
            return k | 0;
        }
        function ia(a, c, d, f, g, h, i) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, I = 0, J = 0.0, K = 0.0, L = 0.0, M = 0.0;
            I = T;
            T = T + 64 | 0;
            D = I + 48 | 0;
            E = I + 32 | 0;
            F = I + 24 | 0;
            x = I + 8 | 0;
            y = I;
            k = b[a >> 2] | 0;
            if ((k | 0) <= 0) {
                G = 0;
                T = I;
                return G | 0;
            }
            z = a + 4 | 0;
            A = D + 8 | 0;
            B = E + 8 | 0;
            C = x + 8 | 0;
            j = 0;
            v = 0;
            while(true){
                l = b[z >> 2] | 0;
                u = l + (v << 4) | 0;
                b[D >> 2] = b[u >> 2];
                b[D + 4 >> 2] = b[u + 4 >> 2];
                b[D + 8 >> 2] = b[u + 8 >> 2];
                b[D + 12 >> 2] = b[u + 12 >> 2];
                if ((v | 0) == (k + -1 | 0)) {
                    b[E >> 2] = b[l >> 2];
                    b[E + 4 >> 2] = b[l + 4 >> 2];
                    b[E + 8 >> 2] = b[l + 8 >> 2];
                    b[E + 12 >> 2] = b[l + 12 >> 2];
                } else {
                    u = l + (v + 1 << 4) | 0;
                    b[E >> 2] = b[u >> 2];
                    b[E + 4 >> 2] = b[u + 4 >> 2];
                    b[E + 8 >> 2] = b[u + 8 >> 2];
                    b[E + 12 >> 2] = b[u + 12 >> 2];
                }
                k = Ga(D, E, f, F) | 0;
                a: do if (!k) {
                    k = F;
                    l = b[k >> 2] | 0;
                    k = b[k + 4 >> 2] | 0;
                    if ((k | 0) > 0 | (k | 0) == 0 & l >>> 0 > 0) {
                        t = 0;
                        u = 0;
                        b: while(true){
                            K = 1.0 / (+(l >>> 0) + 4294967296.0 * +(k | 0));
                            M = +e[D >> 3];
                            k = Fd(l | 0, k | 0, t | 0, u | 0) | 0;
                            L = +(k >>> 0) + 4294967296.0 * +(H() | 0);
                            J = +(t >>> 0) + 4294967296.0 * +(u | 0);
                            e[x >> 3] = K * (M * L) + K * (+e[E >> 3] * J);
                            e[C >> 3] = K * (+e[A >> 3] * L) + K * (+e[B >> 3] * J);
                            k = Ub(x, f, y) | 0;
                            if (k | 0) {
                                j = k;
                                break;
                            }
                            s = y;
                            r = b[s >> 2] | 0;
                            s = b[s + 4 >> 2] | 0;
                            o = Md(r | 0, s | 0, c | 0, d | 0) | 0;
                            m = H() | 0;
                            k = i + (o << 3) | 0;
                            n = k;
                            l = b[n >> 2] | 0;
                            n = b[n + 4 >> 2] | 0;
                            c: do if ((l | 0) == 0 & (n | 0) == 0) {
                                w = k;
                                G = 16;
                            } else {
                                p = 0;
                                q = 0;
                                while(true){
                                    if ((p | 0) > (d | 0) | (p | 0) == (d | 0) & q >>> 0 > c >>> 0) {
                                        j = 1;
                                        break b;
                                    }
                                    if ((l | 0) == (r | 0) & (n | 0) == (s | 0)) break c;
                                    k = Ed(o | 0, m | 0, 1, 0) | 0;
                                    o = Ld(k | 0, H() | 0, c | 0, d | 0) | 0;
                                    m = H() | 0;
                                    q = Ed(q | 0, p | 0, 1, 0) | 0;
                                    p = H() | 0;
                                    k = i + (o << 3) | 0;
                                    n = k;
                                    l = b[n >> 2] | 0;
                                    n = b[n + 4 >> 2] | 0;
                                    if ((l | 0) == 0 & (n | 0) == 0) {
                                        w = k;
                                        G = 16;
                                        break;
                                    }
                                }
                            }
                            while (0);
                            if ((G | 0) == 16 ? (G = 0, !((r | 0) == 0 & (s | 0) == 0)) : 0) {
                                q = w;
                                b[q >> 2] = r;
                                b[q + 4 >> 2] = s;
                                q = h + (b[g >> 2] << 3) | 0;
                                b[q >> 2] = r;
                                b[q + 4 >> 2] = s;
                                q = g;
                                q = Ed(b[q >> 2] | 0, b[q + 4 >> 2] | 0, 1, 0) | 0;
                                r = H() | 0;
                                s = g;
                                b[s >> 2] = q;
                                b[s + 4 >> 2] = r;
                            }
                            t = Ed(t | 0, u | 0, 1, 0) | 0;
                            u = H() | 0;
                            k = F;
                            l = b[k >> 2] | 0;
                            k = b[k + 4 >> 2] | 0;
                            if (!((k | 0) > (u | 0) | (k | 0) == (u | 0) & l >>> 0 > t >>> 0)) {
                                l = 1;
                                break a;
                            }
                        }
                        l = 0;
                    } else l = 1;
                } else {
                    l = 0;
                    j = k;
                }
                while (0);
                v = v + 1 | 0;
                if (!l) {
                    G = 21;
                    break;
                }
                k = b[a >> 2] | 0;
                if ((v | 0) >= (k | 0)) {
                    j = 0;
                    G = 21;
                    break;
                }
            }
            if ((G | 0) == 21) {
                T = I;
                return j | 0;
            }
            return 0;
        }
        function ja(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, I = 0, J = 0, K = 0;
            K = T;
            T = T + 112 | 0;
            F = K + 80 | 0;
            j = K + 72 | 0;
            G = K;
            I = K + 56 | 0;
            f = Vc(d) | 0;
            if (f | 0) {
                J = f;
                T = K;
                return J | 0;
            }
            k = a + 8 | 0;
            J = Bd((b[k >> 2] << 5) + 32 | 0) | 0;
            if (!J) {
                J = 13;
                T = K;
                return J | 0;
            }
            Wc(a, J);
            f = Vc(d) | 0;
            if (!f) {
                D = a;
                E = b[D + 4 >> 2] | 0;
                f = j;
                b[f >> 2] = b[D >> 2];
                b[f + 4 >> 2] = E;
                Uc(j, F);
                f = Fa(F, c, G) | 0;
                if (!f) {
                    f = b[j >> 2] | 0;
                    g = b[k >> 2] | 0;
                    if ((g | 0) > 0) {
                        h = b[a + 12 >> 2] | 0;
                        d = 0;
                        do {
                            f = (b[h + (d << 3) >> 2] | 0) + f | 0;
                            d = d + 1 | 0;
                        }while ((d | 0) != (g | 0));
                        d = f;
                    } else d = f;
                    f = G;
                    g = b[f >> 2] | 0;
                    f = b[f + 4 >> 2] | 0;
                    h = ((d | 0) < 0) << 31 >> 31;
                    if ((f | 0) < (h | 0) | (f | 0) == (h | 0) & g >>> 0 < d >>> 0) {
                        f = G;
                        b[f >> 2] = d;
                        b[f + 4 >> 2] = h;
                        f = h;
                    } else d = g;
                    D = Ed(d | 0, f | 0, 12, 0) | 0;
                    E = H() | 0;
                    f = G;
                    b[f >> 2] = D;
                    b[f + 4 >> 2] = E;
                    f = 0;
                } else {
                    D = 0;
                    E = 0;
                }
                if (!f) {
                    d = Dd(D, 8) | 0;
                    if (!d) {
                        Cd(J);
                        J = 13;
                        T = K;
                        return J | 0;
                    }
                    i = Dd(D, 8) | 0;
                    if (!i) {
                        Cd(J);
                        Cd(d);
                        J = 13;
                        T = K;
                        return J | 0;
                    }
                    B = F;
                    b[B >> 2] = 0;
                    b[B + 4 >> 2] = 0;
                    B = a;
                    C = b[B + 4 >> 2] | 0;
                    f = j;
                    b[f >> 2] = b[B >> 2];
                    b[f + 4 >> 2] = C;
                    f = ia(j, D, E, c, F, d, i) | 0;
                    a: do if (!f) {
                        b: do if ((b[k >> 2] | 0) > 0) {
                            h = a + 12 | 0;
                            g = 0;
                            while(true){
                                f = ia((b[h >> 2] | 0) + (g << 3) | 0, D, E, c, F, d, i) | 0;
                                g = g + 1 | 0;
                                if (f | 0) break;
                                if ((g | 0) >= (b[k >> 2] | 0)) break b;
                            }
                            Cd(d);
                            Cd(i);
                            Cd(J);
                            break a;
                        }
                        while (0);
                        if ((E | 0) > 0 | (E | 0) == 0 & D >>> 0 > 0) Vd(i | 0, 0, D << 3 | 0);
                        C = F;
                        B = b[C + 4 >> 2] | 0;
                        c: do if ((B | 0) > 0 | (B | 0) == 0 & (b[C >> 2] | 0) >>> 0 > 0) {
                            y = d;
                            z = i;
                            A = d;
                            B = i;
                            C = d;
                            f = d;
                            v = d;
                            w = i;
                            x = i;
                            d = i;
                            d: while(true){
                                r = 0;
                                s = 0;
                                t = 0;
                                u = 0;
                                g = 0;
                                h = 0;
                                while(true){
                                    i = G;
                                    j = i + 56 | 0;
                                    do {
                                        b[i >> 2] = 0;
                                        i = i + 4 | 0;
                                    }while ((i | 0) < (j | 0));
                                    c = y + (r << 3) | 0;
                                    k = b[c >> 2] | 0;
                                    c = b[c + 4 >> 2] | 0;
                                    if (ca(k, c, 1, G, 0) | 0) {
                                        i = G;
                                        j = i + 56 | 0;
                                        do {
                                            b[i >> 2] = 0;
                                            i = i + 4 | 0;
                                        }while ((i | 0) < (j | 0));
                                        i = Dd(7, 4) | 0;
                                        if (i | 0) {
                                            da(k, c, 1, G, i, 7, 0, 0);
                                            Cd(i);
                                        }
                                    }
                                    q = 0;
                                    while(true){
                                        p = G + (q << 3) | 0;
                                        o = b[p >> 2] | 0;
                                        p = b[p + 4 >> 2] | 0;
                                        e: do if ((o | 0) == 0 & (p | 0) == 0) {
                                            i = g;
                                            j = h;
                                        } else {
                                            l = Md(o | 0, p | 0, D | 0, E | 0) | 0;
                                            k = H() | 0;
                                            i = e + (l << 3) | 0;
                                            c = i;
                                            j = b[c >> 2] | 0;
                                            c = b[c + 4 >> 2] | 0;
                                            if (!((j | 0) == 0 & (c | 0) == 0)) {
                                                m = 0;
                                                n = 0;
                                                do {
                                                    if ((m | 0) > (E | 0) | (m | 0) == (E | 0) & n >>> 0 > D >>> 0) break d;
                                                    if ((j | 0) == (o | 0) & (c | 0) == (p | 0)) {
                                                        i = g;
                                                        j = h;
                                                        break e;
                                                    }
                                                    i = Ed(l | 0, k | 0, 1, 0) | 0;
                                                    l = Ld(i | 0, H() | 0, D | 0, E | 0) | 0;
                                                    k = H() | 0;
                                                    n = Ed(n | 0, m | 0, 1, 0) | 0;
                                                    m = H() | 0;
                                                    i = e + (l << 3) | 0;
                                                    c = i;
                                                    j = b[c >> 2] | 0;
                                                    c = b[c + 4 >> 2] | 0;
                                                }while (!((j | 0) == 0 & (c | 0) == 0));
                                            }
                                            if ((o | 0) == 0 & (p | 0) == 0) {
                                                i = g;
                                                j = h;
                                                break;
                                            }
                                            Xb(o, p, I);
                                            if (Xc(a, J, I) | 0) {
                                                n = Ed(g | 0, h | 0, 1, 0) | 0;
                                                h = H() | 0;
                                                m = i;
                                                b[m >> 2] = o;
                                                b[m + 4 >> 2] = p;
                                                g = z + (g << 3) | 0;
                                                b[g >> 2] = o;
                                                b[g + 4 >> 2] = p;
                                                g = n;
                                            }
                                            i = g;
                                            j = h;
                                        }
                                        while (0);
                                        q = q + 1 | 0;
                                        if (q >>> 0 >= 7) break;
                                        else {
                                            g = i;
                                            h = j;
                                        }
                                    }
                                    r = Ed(r | 0, s | 0, 1, 0) | 0;
                                    s = H() | 0;
                                    t = Ed(t | 0, u | 0, 1, 0) | 0;
                                    u = H() | 0;
                                    h = F;
                                    g = b[h >> 2] | 0;
                                    h = b[h + 4 >> 2] | 0;
                                    if (!((u | 0) < (h | 0) | (u | 0) == (h | 0) & t >>> 0 < g >>> 0)) break;
                                    else {
                                        g = i;
                                        h = j;
                                    }
                                }
                                if ((h | 0) > 0 | (h | 0) == 0 & g >>> 0 > 0) {
                                    g = 0;
                                    h = 0;
                                    do {
                                        u = y + (g << 3) | 0;
                                        b[u >> 2] = 0;
                                        b[u + 4 >> 2] = 0;
                                        g = Ed(g | 0, h | 0, 1, 0) | 0;
                                        h = H() | 0;
                                        u = F;
                                        t = b[u + 4 >> 2] | 0;
                                    }while ((h | 0) < (t | 0) | ((h | 0) == (t | 0) ? g >>> 0 < (b[u >> 2] | 0) >>> 0 : 0));
                                }
                                u = F;
                                b[u >> 2] = i;
                                b[u + 4 >> 2] = j;
                                if ((j | 0) > 0 | (j | 0) == 0 & i >>> 0 > 0) {
                                    q = d;
                                    r = x;
                                    s = C;
                                    t = w;
                                    u = z;
                                    d = v;
                                    x = f;
                                    w = A;
                                    v = q;
                                    f = r;
                                    C = B;
                                    B = s;
                                    A = t;
                                    z = y;
                                    y = u;
                                } else break c;
                            }
                            Cd(A);
                            Cd(B);
                            Cd(J);
                            f = 1;
                            break a;
                        } else f = i;
                        while (0);
                        Cd(J);
                        Cd(d);
                        Cd(f);
                        f = 0;
                    } else {
                        Cd(d);
                        Cd(i);
                        Cd(J);
                    }
                    while (0);
                    J = f;
                    T = K;
                    return J | 0;
                }
            }
            Cd(J);
            J = f;
            T = K;
            return J | 0;
        }
        function ka(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            l = T;
            T = T + 176 | 0;
            j = l;
            if ((c | 0) < 1) {
                sd(d, 0, 0);
                k = 0;
                T = l;
                return k | 0;
            }
            i = a;
            i = Od(b[i >> 2] | 0, b[i + 4 >> 2] | 0, 52) | 0;
            H();
            sd(d, (c | 0) > 6 ? c : 6, i & 15);
            i = 0;
            while(true){
                e = a + (i << 3) | 0;
                e = Yb(b[e >> 2] | 0, b[e + 4 >> 2] | 0, j) | 0;
                if (e | 0) break;
                e = b[j >> 2] | 0;
                if ((e | 0) > 0) {
                    h = 0;
                    do {
                        g = j + 8 + (h << 4) | 0;
                        h = h + 1 | 0;
                        e = j + 8 + (((h | 0) % (e | 0) | 0) << 4) | 0;
                        f = xd(d, e, g) | 0;
                        if (!f) wd(d, g, e);
                        else vd(d, f);
                        e = b[j >> 2] | 0;
                    }while ((h | 0) < (e | 0));
                }
                i = i + 1 | 0;
                if ((i | 0) >= (c | 0)) {
                    e = 0;
                    k = 13;
                    break;
                }
            }
            if ((k | 0) == 13) {
                T = l;
                return e | 0;
            }
            td(d);
            k = e;
            T = l;
            return k | 0;
        }
        function la(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            g = T;
            T = T + 32 | 0;
            e = g;
            f = g + 16 | 0;
            a = ka(a, c, f) | 0;
            if (a | 0) {
                d = a;
                T = g;
                return d | 0;
            }
            b[d >> 2] = 0;
            b[d + 4 >> 2] = 0;
            b[d + 8 >> 2] = 0;
            a = ud(f) | 0;
            if (a | 0) do {
                c = Ac(d) | 0;
                do {
                    Bc(c, a);
                    h = a + 16 | 0;
                    b[e >> 2] = b[h >> 2];
                    b[e + 4 >> 2] = b[h + 4 >> 2];
                    b[e + 8 >> 2] = b[h + 8 >> 2];
                    b[e + 12 >> 2] = b[h + 12 >> 2];
                    vd(f, a);
                    a = yd(f, e) | 0;
                }while ((a | 0) != 0);
                a = ud(f) | 0;
            }while ((a | 0) != 0);
            td(f);
            a = Dc(d) | 0;
            if (!a) {
                h = 0;
                T = g;
                return h | 0;
            }
            Cc(d);
            h = a;
            T = g;
            return h | 0;
        }
        function ma(a) {
            a = a | 0;
            if (a >>> 0 > 121) {
                a = 0;
                return a | 0;
            }
            a = b[7696 + (a * 28 | 0) + 16 >> 2] | 0;
            return a | 0;
        }
        function na(a) {
            a = a | 0;
            return (a | 0) == 4 | (a | 0) == 117 | 0;
        }
        function oa(a) {
            a = a | 0;
            return b[11120 + ((b[a >> 2] | 0) * 216 | 0) + ((b[a + 4 >> 2] | 0) * 72 | 0) + ((b[a + 8 >> 2] | 0) * 24 | 0) + (b[a + 12 >> 2] << 3) >> 2] | 0;
        }
        function pa(a) {
            a = a | 0;
            return b[11120 + ((b[a >> 2] | 0) * 216 | 0) + ((b[a + 4 >> 2] | 0) * 72 | 0) + ((b[a + 8 >> 2] | 0) * 24 | 0) + (b[a + 12 >> 2] << 3) + 4 >> 2] | 0;
        }
        function qa(a, c) {
            a = a | 0;
            c = c | 0;
            a = 7696 + (a * 28 | 0) | 0;
            b[c >> 2] = b[a >> 2];
            b[c + 4 >> 2] = b[a + 4 >> 2];
            b[c + 8 >> 2] = b[a + 8 >> 2];
            b[c + 12 >> 2] = b[a + 12 >> 2];
            return;
        }
        function ra(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            if (c >>> 0 > 20) {
                c = -1;
                return c | 0;
            }
            do if ((b[11120 + (c * 216 | 0) >> 2] | 0) != (a | 0)) {
                if ((b[11120 + (c * 216 | 0) + 8 >> 2] | 0) != (a | 0)) {
                    if ((b[11120 + (c * 216 | 0) + 16 >> 2] | 0) != (a | 0)) {
                        if ((b[11120 + (c * 216 | 0) + 24 >> 2] | 0) != (a | 0)) {
                            if ((b[11120 + (c * 216 | 0) + 32 >> 2] | 0) != (a | 0)) {
                                if ((b[11120 + (c * 216 | 0) + 40 >> 2] | 0) != (a | 0)) {
                                    if ((b[11120 + (c * 216 | 0) + 48 >> 2] | 0) != (a | 0)) {
                                        if ((b[11120 + (c * 216 | 0) + 56 >> 2] | 0) != (a | 0)) {
                                            if ((b[11120 + (c * 216 | 0) + 64 >> 2] | 0) != (a | 0)) {
                                                if ((b[11120 + (c * 216 | 0) + 72 >> 2] | 0) != (a | 0)) {
                                                    if ((b[11120 + (c * 216 | 0) + 80 >> 2] | 0) != (a | 0)) {
                                                        if ((b[11120 + (c * 216 | 0) + 88 >> 2] | 0) != (a | 0)) {
                                                            if ((b[11120 + (c * 216 | 0) + 96 >> 2] | 0) != (a | 0)) {
                                                                if ((b[11120 + (c * 216 | 0) + 104 >> 2] | 0) != (a | 0)) {
                                                                    if ((b[11120 + (c * 216 | 0) + 112 >> 2] | 0) != (a | 0)) {
                                                                        if ((b[11120 + (c * 216 | 0) + 120 >> 2] | 0) != (a | 0)) {
                                                                            if ((b[11120 + (c * 216 | 0) + 128 >> 2] | 0) != (a | 0)) {
                                                                                if ((b[11120 + (c * 216 | 0) + 136 >> 2] | 0) == (a | 0)) {
                                                                                    a = 2;
                                                                                    d = 1;
                                                                                    e = 2;
                                                                                } else {
                                                                                    if ((b[11120 + (c * 216 | 0) + 144 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 152 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 160 >> 2] | 0) == (a | 0)) {
                                                                                        a = 0;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 168 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 176 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 184 >> 2] | 0) == (a | 0)) {
                                                                                        a = 1;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 192 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 0;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 200 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 1;
                                                                                        break;
                                                                                    }
                                                                                    if ((b[11120 + (c * 216 | 0) + 208 >> 2] | 0) == (a | 0)) {
                                                                                        a = 2;
                                                                                        d = 2;
                                                                                        e = 2;
                                                                                        break;
                                                                                    } else a = -1;
                                                                                    return a | 0;
                                                                                }
                                                                            } else {
                                                                                a = 2;
                                                                                d = 1;
                                                                                e = 1;
                                                                            }
                                                                        } else {
                                                                            a = 2;
                                                                            d = 1;
                                                                            e = 0;
                                                                        }
                                                                    } else {
                                                                        a = 1;
                                                                        d = 1;
                                                                        e = 2;
                                                                    }
                                                                } else {
                                                                    a = 1;
                                                                    d = 1;
                                                                    e = 1;
                                                                }
                                                            } else {
                                                                a = 1;
                                                                d = 1;
                                                                e = 0;
                                                            }
                                                        } else {
                                                            a = 0;
                                                            d = 1;
                                                            e = 2;
                                                        }
                                                    } else {
                                                        a = 0;
                                                        d = 1;
                                                        e = 1;
                                                    }
                                                } else {
                                                    a = 0;
                                                    d = 1;
                                                    e = 0;
                                                }
                                            } else {
                                                a = 2;
                                                d = 0;
                                                e = 2;
                                            }
                                        } else {
                                            a = 2;
                                            d = 0;
                                            e = 1;
                                        }
                                    } else {
                                        a = 2;
                                        d = 0;
                                        e = 0;
                                    }
                                } else {
                                    a = 1;
                                    d = 0;
                                    e = 2;
                                }
                            } else {
                                a = 1;
                                d = 0;
                                e = 1;
                            }
                        } else {
                            a = 1;
                            d = 0;
                            e = 0;
                        }
                    } else {
                        a = 0;
                        d = 0;
                        e = 2;
                    }
                } else {
                    a = 0;
                    d = 0;
                    e = 1;
                }
            } else {
                a = 0;
                d = 0;
                e = 0;
            }
            while (0);
            c = b[11120 + (c * 216 | 0) + (d * 72 | 0) + (a * 24 | 0) + (e << 3) + 4 >> 2] | 0;
            return c | 0;
        }
        function sa(a, c) {
            a = a | 0;
            c = c | 0;
            if ((b[7696 + (a * 28 | 0) + 20 >> 2] | 0) == (c | 0)) {
                c = 1;
                return c | 0;
            }
            c = (b[7696 + (a * 28 | 0) + 24 >> 2] | 0) == (c | 0);
            return c | 0;
        }
        function ta(a, c) {
            a = a | 0;
            c = c | 0;
            return b[848 + (a * 28 | 0) + (c << 2) >> 2] | 0;
        }
        function ua(a, c) {
            a = a | 0;
            c = c | 0;
            if ((b[848 + (a * 28 | 0) >> 2] | 0) == (c | 0)) {
                c = 0;
                return c | 0;
            }
            if ((b[848 + (a * 28 | 0) + 4 >> 2] | 0) == (c | 0)) {
                c = 1;
                return c | 0;
            }
            if ((b[848 + (a * 28 | 0) + 8 >> 2] | 0) == (c | 0)) {
                c = 2;
                return c | 0;
            }
            if ((b[848 + (a * 28 | 0) + 12 >> 2] | 0) == (c | 0)) {
                c = 3;
                return c | 0;
            }
            if ((b[848 + (a * 28 | 0) + 16 >> 2] | 0) == (c | 0)) {
                c = 4;
                return c | 0;
            }
            if ((b[848 + (a * 28 | 0) + 20 >> 2] | 0) == (c | 0)) {
                c = 5;
                return c | 0;
            } else return ((b[848 + (a * 28 | 0) + 24 >> 2] | 0) == (c | 0) ? 6 : 7) | 0;
            return 0;
        }
        function va() {
            return 122;
        }
        function wa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            c = 0;
            do {
                Pd(c | 0, 0, 45);
                e = H() | 134225919;
                d = a + (c << 3) | 0;
                b[d >> 2] = -1;
                b[d + 4 >> 2] = e;
                c = c + 1 | 0;
            }while ((c | 0) != 122);
            return 0;
        }
        function xa(a) {
            a = a | 0;
            var b = 0.0, c = 0.0, d = 0.0;
            d = +e[a + 16 >> 3];
            c = +e[a + 24 >> 3];
            b = d - c;
            return +(d < c ? b + 6.283185307179586 : b);
        }
        function ya(a) {
            a = a | 0;
            return +e[a + 16 >> 3] < +e[a + 24 >> 3] | 0;
        }
        function za(a) {
            a = a | 0;
            return +(+e[a >> 3] - +e[a + 8 >> 3]);
        }
        function Aa(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            c = +e[b >> 3];
            if (!(c >= +e[a + 8 >> 3])) {
                b = 0;
                return b | 0;
            }
            if (!(c <= +e[a >> 3])) {
                b = 0;
                return b | 0;
            }
            d = +e[a + 16 >> 3];
            c = +e[a + 24 >> 3];
            f = +e[b + 8 >> 3];
            b = f >= c;
            a = f <= d & 1;
            if (d < c) {
                if (b) a = 1;
            } else if (!b) a = 0;
            b = (a | 0) != 0;
            return b | 0;
        }
        function Ba(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, f = 0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            if (+e[a >> 3] < +e[b + 8 >> 3]) {
                d = 0;
                return d | 0;
            }
            if (+e[a + 8 >> 3] > +e[b >> 3]) {
                d = 0;
                return d | 0;
            }
            g = +e[a + 16 >> 3];
            c = a + 24 | 0;
            l = +e[c >> 3];
            h = g < l;
            d = b + 16 | 0;
            k = +e[d >> 3];
            f = b + 24 | 0;
            j = +e[f >> 3];
            i = k < j;
            b = l - k < j - g;
            a = h ? i | b ? 1 : 2 : 0;
            b = i ? h ? 1 : b ? 2 : 1 : 0;
            g = +ic(g, a);
            if (g < +ic(+e[f >> 3], b)) {
                i = 0;
                return i | 0;
            }
            l = +ic(+e[c >> 3], a);
            if (l > +ic(+e[d >> 3], b)) {
                i = 0;
                return i | 0;
            }
            i = 1;
            return i | 0;
        }
        function Ca(a, c, d, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0, h = 0.0, i = 0.0, j = 0.0, k = 0.0;
            h = +e[a + 16 >> 3];
            k = +e[a + 24 >> 3];
            a = h < k;
            j = +e[c + 16 >> 3];
            i = +e[c + 24 >> 3];
            g = j < i;
            c = k - j < i - h;
            b[d >> 2] = a ? g | c ? 1 : 2 : 0;
            b[f >> 2] = g ? a ? 1 : c ? 2 : 1 : 0;
            return;
        }
        function Da(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, f = 0, g = 0.0, h = 0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            if (+e[a >> 3] < +e[b >> 3]) {
                d = 0;
                return d | 0;
            }
            if (+e[a + 8 >> 3] > +e[b + 8 >> 3]) {
                d = 0;
                return d | 0;
            }
            d = a + 16 | 0;
            j = +e[d >> 3];
            g = +e[a + 24 >> 3];
            h = j < g;
            c = b + 16 | 0;
            l = +e[c >> 3];
            f = b + 24 | 0;
            k = +e[f >> 3];
            i = l < k;
            b = g - l < k - j;
            a = h ? i | b ? 1 : 2 : 0;
            b = i ? h ? 1 : b ? 2 : 1 : 0;
            g = +ic(g, a);
            if (!(g <= +ic(+e[f >> 3], b))) {
                i = 0;
                return i | 0;
            }
            l = +ic(+e[d >> 3], a);
            i = l >= +ic(+e[c >> 3], b);
            return i | 0;
        }
        function Ea(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0.0, i = 0.0, j = 0.0;
            g = T;
            T = T + 176 | 0;
            f = g;
            b[f >> 2] = 4;
            j = +e[c >> 3];
            e[f + 8 >> 3] = j;
            h = +e[c + 16 >> 3];
            e[f + 16 >> 3] = h;
            e[f + 24 >> 3] = j;
            j = +e[c + 24 >> 3];
            e[f + 32 >> 3] = j;
            i = +e[c + 8 >> 3];
            e[f + 40 >> 3] = i;
            e[f + 48 >> 3] = j;
            e[f + 56 >> 3] = i;
            e[f + 64 >> 3] = h;
            c = f + 72 | 0;
            d = c + 96 | 0;
            do {
                b[c >> 2] = 0;
                c = c + 4 | 0;
            }while ((c | 0) < (d | 0));
            Ud(a | 0, f | 0, 168);
            T = g;
            return;
        }
        function Fa(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0, l = 0, m = 0, n = 0, o = 0, r = 0, s = 0, t = 0, u = 0.0, v = 0.0;
            t = T;
            T = T + 288 | 0;
            n = t + 264 | 0;
            o = t + 96 | 0;
            m = t;
            k = m;
            l = k + 96 | 0;
            do {
                b[k >> 2] = 0;
                k = k + 4 | 0;
            }while ((k | 0) < (l | 0));
            c = ac(c, m) | 0;
            if (c | 0) {
                s = c;
                T = t;
                return s | 0;
            }
            l = m;
            m = b[l >> 2] | 0;
            l = b[l + 4 >> 2] | 0;
            Xb(m, l, n);
            Yb(m, l, o);
            j = +kc(n, o + 8 | 0);
            e[n >> 3] = +e[a >> 3];
            l = n + 8 | 0;
            e[l >> 3] = +e[a + 16 >> 3];
            e[o >> 3] = +e[a + 8 >> 3];
            m = o + 8 | 0;
            e[m >> 3] = +e[a + 24 >> 3];
            h = +kc(n, o);
            v = +e[l >> 3] - +e[m >> 3];
            i = +q(+v);
            u = +e[n >> 3] - +e[o >> 3];
            g = +q(+u);
            if (!(v == 0.0 | u == 0.0) ? (v = +Rd(+i, +g), v = +A(+(h * h / +Sd(+(v / +Sd(+i, +g)), 3.0) / (j * (j * 2.59807621135) * .8))), e[f >> 3] = v, r = ~~v >>> 0, s = +q(v) >= 1.0 ? v > 0.0 ? ~~+C(+p(v / 4294967296.0), 4294967295.0) >>> 0 : ~~+A((v - +(~~v >>> 0)) / 4294967296.0) >>> 0 : 0, !((b[f + 4 >> 2] & 2146435072 | 0) == 2146435072)) : 0) {
                o = (r | 0) == 0 & (s | 0) == 0;
                c = d;
                b[c >> 2] = o ? 1 : r;
                b[c + 4 >> 2] = o ? 0 : s;
                c = 0;
            } else c = 1;
            s = c;
            T = t;
            return s | 0;
        }
        function Ga(a, c, d, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0.0;
            m = T;
            T = T + 288 | 0;
            j = m + 264 | 0;
            k = m + 96 | 0;
            l = m;
            h = l;
            i = h + 96 | 0;
            do {
                b[h >> 2] = 0;
                h = h + 4 | 0;
            }while ((h | 0) < (i | 0));
            d = ac(d, l) | 0;
            if (d | 0) {
                g = d;
                T = m;
                return g | 0;
            }
            d = l;
            h = b[d >> 2] | 0;
            d = b[d + 4 >> 2] | 0;
            Xb(h, d, j);
            Yb(h, d, k);
            n = +kc(j, k + 8 | 0);
            n = +A(+(+kc(a, c) / (n * 2.0)));
            e[f >> 3] = n;
            d = ~~n >>> 0;
            h = +q(n) >= 1.0 ? n > 0.0 ? ~~+C(+p(n / 4294967296.0), 4294967295.0) >>> 0 : ~~+A((n - +(~~n >>> 0)) / 4294967296.0) >>> 0 : 0;
            if ((b[f + 4 >> 2] & 2146435072 | 0) == 2146435072) {
                g = 1;
                T = m;
                return g | 0;
            }
            l = (d | 0) == 0 & (h | 0) == 0;
            b[g >> 2] = l ? 1 : d;
            b[g + 4 >> 2] = l ? 0 : h;
            g = 0;
            T = m;
            return g | 0;
        }
        function Ha(a, b) {
            a = a | 0;
            b = +b;
            var c = 0, d = 0.0, f = 0.0, g = 0, h = 0.0, i = 0, j = 0.0, k = 0.0, l = 0.0;
            g = a + 16 | 0;
            h = +e[g >> 3];
            c = a + 24 | 0;
            f = +e[c >> 3];
            d = h - f;
            d = h < f ? d + 6.283185307179586 : d;
            k = +e[a >> 3];
            i = a + 8 | 0;
            j = +e[i >> 3];
            l = k - j;
            d = (d * b - d) * .5;
            b = (l * b - l) * .5;
            k = k + b;
            e[a >> 3] = k > 1.5707963267948966 ? 1.5707963267948966 : k;
            b = j - b;
            e[i >> 3] = b < -1.5707963267948966 ? -1.5707963267948966 : b;
            b = h + d;
            b = b > 3.141592653589793 ? b + -6.283185307179586 : b;
            e[g >> 3] = b < -3.141592653589793 ? b + 6.283185307179586 : b;
            b = f - d;
            b = b > 3.141592653589793 ? b + -6.283185307179586 : b;
            e[c >> 3] = b < -3.141592653589793 ? b + 6.283185307179586 : b;
            return;
        }
        function Ia(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            b[a >> 2] = c;
            b[a + 4 >> 2] = d;
            b[a + 8 >> 2] = e;
            return;
        }
        function Ja(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0, n = 0, o = 0.0;
            n = c + 8 | 0;
            b[n >> 2] = 0;
            k = +e[a >> 3];
            i = +q(+k);
            l = +e[a + 8 >> 3];
            j = +q(+l) * 1.1547005383792515;
            i = i + j * .5;
            d = ~~i;
            a = ~~j;
            i = i - +(d | 0);
            j = j - +(a | 0);
            do if (i < .5) {
                if (i < .3333333333333333) {
                    b[c >> 2] = d;
                    if (j < (i + 1.0) * .5) {
                        b[c + 4 >> 2] = a;
                        break;
                    } else {
                        a = a + 1 | 0;
                        b[c + 4 >> 2] = a;
                        break;
                    }
                } else {
                    o = 1.0 - i;
                    a = (!(j < o) & 1) + a | 0;
                    b[c + 4 >> 2] = a;
                    if (o <= j & j < i * 2.0) {
                        d = d + 1 | 0;
                        b[c >> 2] = d;
                        break;
                    } else {
                        b[c >> 2] = d;
                        break;
                    }
                }
            } else {
                if (!(i < .6666666666666666)) {
                    d = d + 1 | 0;
                    b[c >> 2] = d;
                    if (j < i * .5) {
                        b[c + 4 >> 2] = a;
                        break;
                    } else {
                        a = a + 1 | 0;
                        b[c + 4 >> 2] = a;
                        break;
                    }
                }
                if (j < 1.0 - i) {
                    b[c + 4 >> 2] = a;
                    if (i * 2.0 + -1 < j) {
                        b[c >> 2] = d;
                        break;
                    }
                } else {
                    a = a + 1 | 0;
                    b[c + 4 >> 2] = a;
                }
                d = d + 1 | 0;
                b[c >> 2] = d;
            }
            while (0);
            do if (k < 0.0) {
                if (!(a & 1)) {
                    m = (a | 0) / 2 | 0;
                    m = Fd(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, m | 0, ((m | 0) < 0) << 31 >> 31 | 0) | 0;
                    d = ~~(+(d | 0) - (+(m >>> 0) + 4294967296.0 * +(H() | 0)) * 2.0);
                    b[c >> 2] = d;
                    break;
                } else {
                    m = (a + 1 | 0) / 2 | 0;
                    m = Fd(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, m | 0, ((m | 0) < 0) << 31 >> 31 | 0) | 0;
                    d = ~~(+(d | 0) - ((+(m >>> 0) + 4294967296.0 * +(H() | 0)) * 2.0 + 1.0));
                    b[c >> 2] = d;
                    break;
                }
            }
            while (0);
            m = c + 4 | 0;
            if (l < 0.0) {
                d = d - ((a << 1 | 1) / 2 | 0) | 0;
                b[c >> 2] = d;
                a = 0 - a | 0;
                b[m >> 2] = a;
            }
            f = a - d | 0;
            if ((d | 0) < 0) {
                g = 0 - d | 0;
                b[m >> 2] = f;
                b[n >> 2] = g;
                b[c >> 2] = 0;
                a = f;
                d = 0;
            } else g = 0;
            if ((a | 0) < 0) {
                d = d - a | 0;
                b[c >> 2] = d;
                g = g - a | 0;
                b[n >> 2] = g;
                b[m >> 2] = 0;
                a = 0;
            }
            h = d - g | 0;
            f = a - g | 0;
            if ((g | 0) < 0) {
                b[c >> 2] = h;
                b[m >> 2] = f;
                b[n >> 2] = 0;
                a = f;
                d = h;
                g = 0;
            }
            f = (a | 0) < (d | 0) ? a : d;
            f = (g | 0) < (f | 0) ? g : f;
            if ((f | 0) <= 0) return;
            b[c >> 2] = d - f;
            b[m >> 2] = a - f;
            b[n >> 2] = g - f;
            return;
        }
        function Ka(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            if ((c | 0) < 0) {
                d = d - c | 0;
                b[h >> 2] = d;
                g = a + 8 | 0;
                b[g >> 2] = (b[g >> 2] | 0) - c;
                b[a >> 2] = 0;
                c = 0;
            }
            if ((d | 0) < 0) {
                c = c - d | 0;
                b[a >> 2] = c;
                g = a + 8 | 0;
                f = (b[g >> 2] | 0) - d | 0;
                b[g >> 2] = f;
                b[h >> 2] = 0;
                d = 0;
            } else {
                f = a + 8 | 0;
                g = f;
                f = b[f >> 2] | 0;
            }
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[a >> 2] = c;
                d = d - f | 0;
                b[h >> 2] = d;
                b[g >> 2] = 0;
                f = 0;
            }
            e = (d | 0) < (c | 0) ? d : c;
            e = (f | 0) < (e | 0) ? f : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = c - e;
            b[h >> 2] = d - e;
            b[g >> 2] = f - e;
            return;
        }
        function La(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0;
            f = b[a + 8 >> 2] | 0;
            d = +((b[a + 4 >> 2] | 0) - f | 0);
            e[c >> 3] = +((b[a >> 2] | 0) - f | 0) - d * .5;
            e[c + 8 >> 3] = d * .8660254037844386;
            return;
        }
        function Ma(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            b[d >> 2] = (b[c >> 2] | 0) + (b[a >> 2] | 0);
            b[d + 4 >> 2] = (b[c + 4 >> 2] | 0) + (b[a + 4 >> 2] | 0);
            b[d + 8 >> 2] = (b[c + 8 >> 2] | 0) + (b[a + 8 >> 2] | 0);
            return;
        }
        function Na(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            b[d >> 2] = (b[a >> 2] | 0) - (b[c >> 2] | 0);
            b[d + 4 >> 2] = (b[a + 4 >> 2] | 0) - (b[c + 4 >> 2] | 0);
            b[d + 8 >> 2] = (b[a + 8 >> 2] | 0) - (b[c + 8 >> 2] | 0);
            return;
        }
        function Oa(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = B(b[a >> 2] | 0, c) | 0;
            b[a >> 2] = d;
            d = a + 4 | 0;
            e = B(b[d >> 2] | 0, c) | 0;
            b[d >> 2] = e;
            a = a + 8 | 0;
            c = B(b[a >> 2] | 0, c) | 0;
            b[a >> 2] = c;
            return;
        }
        function Pa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = b[a >> 2] | 0;
            i = (h | 0) < 0;
            e = (b[a + 4 >> 2] | 0) - (i ? h : 0) | 0;
            g = (e | 0) < 0;
            f = (g ? 0 - e | 0 : 0) + ((b[a + 8 >> 2] | 0) - (i ? h : 0)) | 0;
            d = (f | 0) < 0;
            a = d ? 0 : f;
            c = (g ? 0 : e) - (d ? f : 0) | 0;
            f = (i ? 0 : h) - (g ? e : 0) - (d ? f : 0) | 0;
            d = (c | 0) < (f | 0) ? c : f;
            d = (a | 0) < (d | 0) ? a : d;
            e = (d | 0) > 0;
            a = a - (e ? d : 0) | 0;
            c = c - (e ? d : 0) | 0;
            a: do switch(f - (e ? d : 0) | 0){
                case 0:
                    switch(c | 0){
                        case 0:
                            i = (a | 0) == 0 ? 0 : (a | 0) == 1 ? 1 : 7;
                            return i | 0;
                        case 1:
                            i = (a | 0) == 0 ? 2 : (a | 0) == 1 ? 3 : 7;
                            return i | 0;
                        default:
                            break a;
                    }
                case 1:
                    switch(c | 0){
                        case 0:
                            i = (a | 0) == 0 ? 4 : (a | 0) == 1 ? 5 : 7;
                            return i | 0;
                        case 1:
                            if (!a) a = 6;
                            else break a;
                            return a | 0;
                        default:
                            break a;
                    }
                default:
            }
            while (0);
            i = 7;
            return i | 0;
        }
        function Qa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            j = a + 8 | 0;
            h = b[j >> 2] | 0;
            i = (b[a >> 2] | 0) - h | 0;
            k = a + 4 | 0;
            h = (b[k >> 2] | 0) - h | 0;
            if (i >>> 0 > 715827881 | h >>> 0 > 715827881) {
                e = (i | 0) > 0;
                f = 2147483647 - i | 0;
                g = -2147483648 - i | 0;
                if (e ? (f | 0) < (i | 0) : (g | 0) > (i | 0)) {
                    k = 1;
                    return k | 0;
                }
                d = i << 1;
                if (e ? (2147483647 - d | 0) < (i | 0) : (-2147483648 - d | 0) > (i | 0)) {
                    k = 1;
                    return k | 0;
                }
                if ((h | 0) > 0 ? (2147483647 - h | 0) < (h | 0) : (-2147483648 - h | 0) > (h | 0)) {
                    k = 1;
                    return k | 0;
                }
                c = i * 3 | 0;
                d = h << 1;
                if ((e ? (f | 0) < (d | 0) : (g | 0) > (d | 0)) ? 1 : (i | 0) > -1 ? (c | -2147483648) >= (h | 0) : (c ^ -2147483648 | 0) < (h | 0)) {
                    k = 1;
                    return k | 0;
                }
            } else {
                d = h << 1;
                c = i * 3 | 0;
            }
            e = Ad(+(c - h | 0) * .14285714285714285) | 0;
            b[a >> 2] = e;
            f = Ad(+(d + i | 0) * .14285714285714285) | 0;
            b[k >> 2] = f;
            b[j >> 2] = 0;
            d = (f | 0) < (e | 0);
            c = d ? e : f;
            d = d ? f : e;
            if ((d | 0) < 0) {
                if ((d | 0) == -2147483648 ? 1 : (c | 0) > 0 ? (2147483647 - c | 0) < (d | 0) : (-2147483648 - c | 0) > (d | 0)) I(27795, 26892, 354, 26903);
                if ((c | 0) > -1 ? (c | -2147483648) >= (d | 0) : (c ^ -2147483648 | 0) < (d | 0)) I(27795, 26892, 354, 26903);
            }
            c = f - e | 0;
            if ((e | 0) < 0) {
                d = 0 - e | 0;
                b[k >> 2] = c;
                b[j >> 2] = d;
                b[a >> 2] = 0;
                e = 0;
            } else {
                c = f;
                d = 0;
            }
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[j >> 2] = d;
                b[k >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[k >> 2] = f;
                b[j >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) {
                k = 0;
                return k | 0;
            }
            b[a >> 2] = f - e;
            b[k >> 2] = c - e;
            b[j >> 2] = d - e;
            k = 0;
            return k | 0;
        }
        function Ra(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            h = a + 8 | 0;
            f = b[h >> 2] | 0;
            g = (b[a >> 2] | 0) - f | 0;
            i = a + 4 | 0;
            f = (b[i >> 2] | 0) - f | 0;
            if (g >>> 0 > 715827881 | f >>> 0 > 715827881) {
                d = (g | 0) > 0;
                if (d ? (2147483647 - g | 0) < (g | 0) : (-2147483648 - g | 0) > (g | 0)) {
                    i = 1;
                    return i | 0;
                }
                c = g << 1;
                e = (f | 0) > 0;
                if (e ? (2147483647 - f | 0) < (f | 0) : (-2147483648 - f | 0) > (f | 0)) {
                    i = 1;
                    return i | 0;
                }
                j = f << 1;
                if (e ? (2147483647 - j | 0) < (f | 0) : (-2147483648 - j | 0) > (f | 0)) {
                    j = 1;
                    return j | 0;
                }
                if (d ? (2147483647 - c | 0) < (f | 0) : (-2147483648 - c | 0) > (f | 0)) {
                    j = 1;
                    return j | 0;
                }
                d = f * 3 | 0;
                if ((f | 0) > -1 ? (d | -2147483648) >= (g | 0) : (d ^ -2147483648 | 0) < (g | 0)) {
                    j = 1;
                    return j | 0;
                }
            } else {
                d = f * 3 | 0;
                c = g << 1;
            }
            e = Ad(+(c + f | 0) * .14285714285714285) | 0;
            b[a >> 2] = e;
            f = Ad(+(d - g | 0) * .14285714285714285) | 0;
            b[i >> 2] = f;
            b[h >> 2] = 0;
            d = (f | 0) < (e | 0);
            c = d ? e : f;
            d = d ? f : e;
            if ((d | 0) < 0) {
                if ((d | 0) == -2147483648 ? 1 : (c | 0) > 0 ? (2147483647 - c | 0) < (d | 0) : (-2147483648 - c | 0) > (d | 0)) I(27795, 26892, 402, 26917);
                if ((c | 0) > -1 ? (c | -2147483648) >= (d | 0) : (c ^ -2147483648 | 0) < (d | 0)) I(27795, 26892, 402, 26917);
            }
            c = f - e | 0;
            if ((e | 0) < 0) {
                d = 0 - e | 0;
                b[i >> 2] = c;
                b[h >> 2] = d;
                b[a >> 2] = 0;
                e = 0;
            } else {
                c = f;
                d = 0;
            }
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) {
                j = 0;
                return j | 0;
            }
            b[a >> 2] = f - e;
            b[i >> 2] = c - e;
            b[h >> 2] = d - e;
            j = 0;
            return j | 0;
        }
        function Sa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = a + 8 | 0;
            d = b[h >> 2] | 0;
            c = (b[a >> 2] | 0) - d | 0;
            i = a + 4 | 0;
            d = (b[i >> 2] | 0) - d | 0;
            e = Ad(+((c * 3 | 0) - d | 0) * .14285714285714285) | 0;
            b[a >> 2] = e;
            c = Ad(+((d << 1) + c | 0) * .14285714285714285) | 0;
            b[i >> 2] = c;
            b[h >> 2] = 0;
            d = c - e | 0;
            if ((e | 0) < 0) {
                g = 0 - e | 0;
                b[i >> 2] = d;
                b[h >> 2] = g;
                b[a >> 2] = 0;
                c = d;
                e = 0;
                d = g;
            } else d = 0;
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = f - e;
            b[i >> 2] = c - e;
            b[h >> 2] = d - e;
            return;
        }
        function Ta(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = a + 8 | 0;
            d = b[h >> 2] | 0;
            c = (b[a >> 2] | 0) - d | 0;
            i = a + 4 | 0;
            d = (b[i >> 2] | 0) - d | 0;
            e = Ad(+((c << 1) + d | 0) * .14285714285714285) | 0;
            b[a >> 2] = e;
            c = Ad(+((d * 3 | 0) - c | 0) * .14285714285714285) | 0;
            b[i >> 2] = c;
            b[h >> 2] = 0;
            d = c - e | 0;
            if ((e | 0) < 0) {
                g = 0 - e | 0;
                b[i >> 2] = d;
                b[h >> 2] = g;
                b[a >> 2] = 0;
                c = d;
                e = 0;
                d = g;
            } else d = 0;
            if ((c | 0) < 0) {
                e = e - c | 0;
                b[a >> 2] = e;
                d = d - c | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                c = 0;
            }
            g = e - d | 0;
            f = c - d | 0;
            if ((d | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                c = f;
                f = g;
                d = 0;
            } else f = e;
            e = (c | 0) < (f | 0) ? c : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) return;
            b[a >> 2] = f - e;
            b[i >> 2] = c - e;
            b[h >> 2] = d - e;
            return;
        }
        function Ua(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            i = a + 8 | 0;
            e = b[i >> 2] | 0;
            f = d + (c * 3 | 0) | 0;
            b[a >> 2] = f;
            d = e + (d * 3 | 0) | 0;
            b[h >> 2] = d;
            c = (e * 3 | 0) + c | 0;
            b[i >> 2] = c;
            e = d - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = e;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                d = e;
                e = 0;
            } else e = f;
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Va(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = (c * 3 | 0) + f | 0;
            f = d + (f * 3 | 0) | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = (d * 3 | 0) + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                f = 0;
            } else d = e;
            if ((d | 0) < 0) {
                f = f - d | 0;
                b[a >> 2] = f;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = f - c | 0;
            e = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = e;
                b[i >> 2] = 0;
                f = g;
                c = 0;
            } else e = d;
            d = (e | 0) < (f | 0) ? e : f;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = f - d;
            b[h >> 2] = e - d;
            b[i >> 2] = c - d;
            return;
        }
        function Wa(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            if ((c + -1 | 0) >>> 0 >= 6) return;
            f = (b[15440 + (c * 12 | 0) >> 2] | 0) + (b[a >> 2] | 0) | 0;
            b[a >> 2] = f;
            i = a + 4 | 0;
            e = (b[15440 + (c * 12 | 0) + 4 >> 2] | 0) + (b[i >> 2] | 0) | 0;
            b[i >> 2] = e;
            h = a + 8 | 0;
            c = (b[15440 + (c * 12 | 0) + 8 >> 2] | 0) + (b[h >> 2] | 0) | 0;
            b[h >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[i >> 2] = d;
                b[h >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[h >> 2] = c;
                b[i >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[i >> 2] = f;
                b[h >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[i >> 2] = f - d;
            b[h >> 2] = c - d;
            return;
        }
        function Xa(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = c + f | 0;
            f = d + f | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = d + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Ya(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            e = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            f = e + c | 0;
            b[a >> 2] = f;
            e = d + e | 0;
            b[h >> 2] = e;
            c = d + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                e = 0;
            } else {
                d = e;
                e = f;
            }
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function Za(a) {
            a = a | 0;
            switch(a | 0){
                case 1:
                    a = 5;
                    break;
                case 5:
                    a = 4;
                    break;
                case 4:
                    a = 6;
                    break;
                case 6:
                    a = 2;
                    break;
                case 2:
                    a = 3;
                    break;
                case 3:
                    a = 1;
                    break;
                default:
            }
            return a | 0;
        }
        function _a(a) {
            a = a | 0;
            switch(a | 0){
                case 1:
                    a = 3;
                    break;
                case 3:
                    a = 2;
                    break;
                case 2:
                    a = 6;
                    break;
                case 6:
                    a = 4;
                    break;
                case 4:
                    a = 5;
                    break;
                case 5:
                    a = 1;
                    break;
                default:
            }
            return a | 0;
        }
        function $a(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            c = b[a >> 2] | 0;
            h = a + 4 | 0;
            d = b[h >> 2] | 0;
            i = a + 8 | 0;
            e = b[i >> 2] | 0;
            f = d + (c << 1) | 0;
            b[a >> 2] = f;
            d = e + (d << 1) | 0;
            b[h >> 2] = d;
            c = (e << 1) + c | 0;
            b[i >> 2] = c;
            e = d - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = e;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                d = e;
                e = 0;
            } else e = f;
            if ((d | 0) < 0) {
                e = e - d | 0;
                b[a >> 2] = e;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = e - c | 0;
            f = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                e = g;
                c = 0;
            } else f = d;
            d = (f | 0) < (e | 0) ? f : e;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = e - d;
            b[h >> 2] = f - d;
            b[i >> 2] = c - d;
            return;
        }
        function ab(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            f = b[a >> 2] | 0;
            h = a + 4 | 0;
            c = b[h >> 2] | 0;
            i = a + 8 | 0;
            d = b[i >> 2] | 0;
            e = (c << 1) + f | 0;
            f = d + (f << 1) | 0;
            b[a >> 2] = f;
            b[h >> 2] = e;
            c = (d << 1) + c | 0;
            b[i >> 2] = c;
            d = e - f | 0;
            if ((f | 0) < 0) {
                c = c - f | 0;
                b[h >> 2] = d;
                b[i >> 2] = c;
                b[a >> 2] = 0;
                f = 0;
            } else d = e;
            if ((d | 0) < 0) {
                f = f - d | 0;
                b[a >> 2] = f;
                c = c - d | 0;
                b[i >> 2] = c;
                b[h >> 2] = 0;
                d = 0;
            }
            g = f - c | 0;
            e = d - c | 0;
            if ((c | 0) < 0) {
                b[a >> 2] = g;
                b[h >> 2] = e;
                b[i >> 2] = 0;
                f = g;
                c = 0;
            } else e = d;
            d = (e | 0) < (f | 0) ? e : f;
            d = (c | 0) < (d | 0) ? c : d;
            if ((d | 0) <= 0) return;
            b[a >> 2] = f - d;
            b[h >> 2] = e - d;
            b[i >> 2] = c - d;
            return;
        }
        function bb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = (b[a >> 2] | 0) - (b[c >> 2] | 0) | 0;
            i = (h | 0) < 0;
            e = (b[a + 4 >> 2] | 0) - (b[c + 4 >> 2] | 0) - (i ? h : 0) | 0;
            g = (e | 0) < 0;
            f = (i ? 0 - h | 0 : 0) + (b[a + 8 >> 2] | 0) - (b[c + 8 >> 2] | 0) + (g ? 0 - e | 0 : 0) | 0;
            a = (f | 0) < 0;
            c = a ? 0 : f;
            d = (g ? 0 : e) - (a ? f : 0) | 0;
            f = (i ? 0 : h) - (g ? e : 0) - (a ? f : 0) | 0;
            a = (d | 0) < (f | 0) ? d : f;
            a = (c | 0) < (a | 0) ? c : a;
            e = (a | 0) > 0;
            c = c - (e ? a : 0) | 0;
            d = d - (e ? a : 0) | 0;
            a = f - (e ? a : 0) | 0;
            a = (a | 0) > -1 ? a : 0 - a | 0;
            d = (d | 0) > -1 ? d : 0 - d | 0;
            c = (c | 0) > -1 ? c : 0 - c | 0;
            c = (d | 0) > (c | 0) ? d : c;
            return ((a | 0) > (c | 0) ? a : c) | 0;
        }
        function cb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            d = b[a + 8 >> 2] | 0;
            b[c >> 2] = (b[a >> 2] | 0) - d;
            b[c + 4 >> 2] = (b[a + 4 >> 2] | 0) - d;
            return;
        }
        function db(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            e = b[a >> 2] | 0;
            b[c >> 2] = e;
            f = b[a + 4 >> 2] | 0;
            h = c + 4 | 0;
            b[h >> 2] = f;
            i = c + 8 | 0;
            b[i >> 2] = 0;
            d = (f | 0) < (e | 0);
            a = d ? e : f;
            d = d ? f : e;
            if ((d | 0) < 0) {
                if ((d | 0) == -2147483648 ? 1 : (a | 0) > 0 ? (2147483647 - a | 0) < (d | 0) : (-2147483648 - a | 0) > (d | 0)) {
                    c = 1;
                    return c | 0;
                }
                if ((a | 0) > -1 ? (a | -2147483648) >= (d | 0) : (a ^ -2147483648 | 0) < (d | 0)) {
                    c = 1;
                    return c | 0;
                }
            }
            a = f - e | 0;
            if ((e | 0) < 0) {
                d = 0 - e | 0;
                b[h >> 2] = a;
                b[i >> 2] = d;
                b[c >> 2] = 0;
                e = 0;
            } else {
                a = f;
                d = 0;
            }
            if ((a | 0) < 0) {
                e = e - a | 0;
                b[c >> 2] = e;
                d = d - a | 0;
                b[i >> 2] = d;
                b[h >> 2] = 0;
                a = 0;
            }
            g = e - d | 0;
            f = a - d | 0;
            if ((d | 0) < 0) {
                b[c >> 2] = g;
                b[h >> 2] = f;
                b[i >> 2] = 0;
                a = f;
                f = g;
                d = 0;
            } else f = e;
            e = (a | 0) < (f | 0) ? a : f;
            e = (d | 0) < (e | 0) ? d : e;
            if ((e | 0) <= 0) {
                c = 0;
                return c | 0;
            }
            b[c >> 2] = f - e;
            b[h >> 2] = a - e;
            b[i >> 2] = d - e;
            c = 0;
            return c | 0;
        }
        function eb(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0;
            c = a + 8 | 0;
            f = b[c >> 2] | 0;
            d = f - (b[a >> 2] | 0) | 0;
            b[a >> 2] = d;
            e = a + 4 | 0;
            a = (b[e >> 2] | 0) - f | 0;
            b[e >> 2] = a;
            b[c >> 2] = 0 - (a + d);
            return;
        }
        function fb(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            d = b[a >> 2] | 0;
            c = 0 - d | 0;
            b[a >> 2] = c;
            h = a + 8 | 0;
            b[h >> 2] = 0;
            i = a + 4 | 0;
            e = b[i >> 2] | 0;
            f = e + d | 0;
            if ((d | 0) > 0) {
                b[i >> 2] = f;
                b[h >> 2] = d;
                b[a >> 2] = 0;
                c = 0;
                e = f;
            } else d = 0;
            if ((e | 0) < 0) {
                g = c - e | 0;
                b[a >> 2] = g;
                d = d - e | 0;
                b[h >> 2] = d;
                b[i >> 2] = 0;
                f = g - d | 0;
                c = 0 - d | 0;
                if ((d | 0) < 0) {
                    b[a >> 2] = f;
                    b[i >> 2] = c;
                    b[h >> 2] = 0;
                    e = c;
                    d = 0;
                } else {
                    e = 0;
                    f = g;
                }
            } else f = c;
            c = (e | 0) < (f | 0) ? e : f;
            c = (d | 0) < (c | 0) ? d : c;
            if ((c | 0) <= 0) return;
            b[a >> 2] = f - c;
            b[i >> 2] = e - c;
            b[h >> 2] = d - c;
            return;
        }
        function gb(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            m = T;
            T = T + 64 | 0;
            l = m;
            i = m + 56 | 0;
            if (!(true & (c & 2013265920 | 0) == 134217728 & (true & (e & 2013265920 | 0) == 134217728))) {
                f = 5;
                T = m;
                return f | 0;
            }
            if ((a | 0) == (d | 0) & (c | 0) == (e | 0)) {
                b[f >> 2] = 0;
                f = 0;
                T = m;
                return f | 0;
            }
            h = Od(a | 0, c | 0, 52) | 0;
            H();
            h = h & 15;
            k = Od(d | 0, e | 0, 52) | 0;
            H();
            if ((h | 0) != (k & 15 | 0)) {
                f = 12;
                T = m;
                return f | 0;
            }
            g = h + -1 | 0;
            if (h >>> 0 > 1) {
                Db(a, c, g, l);
                Db(d, e, g, i);
                k = l;
                j = b[k >> 2] | 0;
                k = b[k + 4 >> 2] | 0;
                a: do if ((j | 0) == (b[i >> 2] | 0) ? (k | 0) == (b[i + 4 >> 2] | 0) : 0) {
                    h = (h ^ 15) * 3 | 0;
                    g = Od(a | 0, c | 0, h | 0) | 0;
                    H();
                    g = g & 7;
                    h = Od(d | 0, e | 0, h | 0) | 0;
                    H();
                    h = h & 7;
                    do if (!((g | 0) == 0 | (h | 0) == 0)) {
                        if ((g | 0) == 7) g = 5;
                        else {
                            if ((g | 0) == 1 | (h | 0) == 1 ? Fb(j, k) | 0 : 0) {
                                g = 5;
                                break;
                            }
                            if ((b[15536 + (g << 2) >> 2] | 0) != (h | 0) ? (b[15568 + (g << 2) >> 2] | 0) != (h | 0) : 0) break a;
                            b[f >> 2] = 1;
                            g = 0;
                        }
                    } else {
                        b[f >> 2] = 1;
                        g = 0;
                    }
                    while (0);
                    f = g;
                    T = m;
                    return f | 0;
                }
                while (0);
            }
            g = l;
            h = g + 56 | 0;
            do {
                b[g >> 2] = 0;
                g = g + 4 | 0;
            }while ((g | 0) < (h | 0));
            aa(a, c, 1, l);
            c = l;
            if (((((!((b[c >> 2] | 0) == (d | 0) ? (b[c + 4 >> 2] | 0) == (e | 0) : 0) ? (c = l + 8 | 0, !((b[c >> 2] | 0) == (d | 0) ? (b[c + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (c = l + 16 | 0, !((b[c >> 2] | 0) == (d | 0) ? (b[c + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (c = l + 24 | 0, !((b[c >> 2] | 0) == (d | 0) ? (b[c + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (c = l + 32 | 0, !((b[c >> 2] | 0) == (d | 0) ? (b[c + 4 >> 2] | 0) == (e | 0) : 0)) : 0) ? (c = l + 40 | 0, !((b[c >> 2] | 0) == (d | 0) ? (b[c + 4 >> 2] | 0) == (e | 0) : 0)) : 0) {
                g = l + 48 | 0;
                g = ((b[g >> 2] | 0) == (d | 0) ? (b[g + 4 >> 2] | 0) == (e | 0) : 0) & 1;
            } else g = 1;
            b[f >> 2] = g;
            f = 0;
            T = m;
            return f | 0;
        }
        function hb(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            d = fa(a, c, d, e) | 0;
            if ((d | 0) == 7) {
                f = 11;
                return f | 0;
            }
            e = Pd(d | 0, 0, 56) | 0;
            c = c & -2130706433 | (H() | 0) | 268435456;
            b[f >> 2] = a | e;
            b[f + 4 >> 2] = c;
            f = 0;
            return f | 0;
        }
        function ib(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            if (!(true & (c & 2013265920 | 0) == 268435456)) {
                d = 6;
                return d | 0;
            }
            b[d >> 2] = a;
            b[d + 4 >> 2] = c & -2130706433 | 134217728;
            d = 0;
            return d | 0;
        }
        function jb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            f = T;
            T = T + 16 | 0;
            e = f;
            b[e >> 2] = 0;
            if (!(true & (c & 2013265920 | 0) == 268435456)) {
                e = 6;
                T = f;
                return e | 0;
            }
            g = Od(a | 0, c | 0, 56) | 0;
            H();
            e = ea(a, c & -2130706433 | 134217728, g & 7, e, d) | 0;
            T = f;
            return e | 0;
        }
        function kb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            c = Od(a | 0, b | 0, 56) | 0;
            H();
            switch(c & 7){
                case 0:
                case 7:
                    c = 0;
                    return c | 0;
                default:
            }
            c = b & -2130706433 | 134217728;
            if (!(true & (b & 2013265920 | 0) == 268435456)) {
                c = 0;
                return c | 0;
            }
            if (true & (b & 117440512 | 0) == 16777216 & (Fb(a, c) | 0) != 0) {
                c = 0;
                return c | 0;
            }
            c = Bb(a, c) | 0;
            return c | 0;
        }
        function lb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            f = T;
            T = T + 16 | 0;
            e = f;
            if (!(true & (c & 2013265920 | 0) == 268435456)) {
                e = 6;
                T = f;
                return e | 0;
            }
            g = c & -2130706433 | 134217728;
            h = d;
            b[h >> 2] = a;
            b[h + 4 >> 2] = g;
            b[e >> 2] = 0;
            c = Od(a | 0, c | 0, 56) | 0;
            H();
            e = ea(a, g, c & 7, e, d + 8 | 0) | 0;
            T = f;
            return e | 0;
        }
        function mb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            f = (Fb(a, c) | 0) == 0;
            c = c & -2130706433;
            e = d;
            b[e >> 2] = f ? a : 0;
            b[e + 4 >> 2] = f ? c | 285212672 : 0;
            e = d + 8 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 301989888;
            e = d + 16 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 318767104;
            e = d + 24 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 335544320;
            e = d + 32 | 0;
            b[e >> 2] = a;
            b[e + 4 >> 2] = c | 352321536;
            d = d + 40 | 0;
            b[d >> 2] = a;
            b[d + 4 >> 2] = c | 369098752;
            return 0;
        }
        function nb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            h = T;
            T = T + 16 | 0;
            f = h;
            g = c & -2130706433 | 134217728;
            if (!(true & (c & 2013265920 | 0) == 268435456)) {
                g = 6;
                T = h;
                return g | 0;
            }
            e = Od(a | 0, c | 0, 56) | 0;
            H();
            e = md(a, g, e & 7) | 0;
            if ((e | 0) == -1) {
                b[d >> 2] = 0;
                g = 6;
                T = h;
                return g | 0;
            }
            if (Wb(a, g, f) | 0) I(27795, 26932, 282, 26947);
            c = Od(a | 0, c | 0, 52) | 0;
            H();
            c = c & 15;
            if (!(Fb(a, g) | 0)) xb(f, c, e, 2, d);
            else tb(f, c, e, 2, d);
            g = 0;
            T = h;
            return g | 0;
        }
        function ob(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = T;
            T = T + 16 | 0;
            e = d;
            pb(a, b, c, e);
            Ja(e, c + 4 | 0);
            T = d;
            return;
        }
        function pb(a, c, d, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0.0, h = 0.0, i = 0.0, j = 0, k = 0;
            j = T;
            T = T + 16 | 0;
            k = j;
            qb(a, d, k);
            h = +w(+(1.0 - +e[k >> 3] * .5));
            if (h < 1.0e-16) {
                b[f >> 2] = 0;
                b[f + 4 >> 2] = 0;
                b[f + 8 >> 2] = 0;
                b[f + 12 >> 2] = 0;
                T = j;
                return;
            }
            k = b[d >> 2] | 0;
            g = +e[15920 + (k * 24 | 0) >> 3];
            g = +gc(g - +gc(+mc(15600 + (k << 4) | 0, a)));
            if (!(Tb(c) | 0)) i = g;
            else i = +gc(g + -0.3334731722518321);
            g = +v(+h) * 2.618033988749896;
            if ((c | 0) > 0) {
                a = 0;
                do {
                    g = g * 2.6457513110645907;
                    a = a + 1 | 0;
                }while ((a | 0) != (c | 0));
            }
            h = +t(+i) * g;
            e[f >> 3] = h;
            i = +u(+i) * g;
            e[f + 8 >> 3] = i;
            T = j;
            return;
        }
        function qb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0, h = 0;
            h = T;
            T = T + 32 | 0;
            g = h;
            ld(a, g);
            b[c >> 2] = 0;
            e[d >> 3] = 5.0;
            f = +kd(16400, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 0;
                e[d >> 3] = f;
            }
            f = +kd(16424, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 1;
                e[d >> 3] = f;
            }
            f = +kd(16448, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 2;
                e[d >> 3] = f;
            }
            f = +kd(16472, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 3;
                e[d >> 3] = f;
            }
            f = +kd(16496, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 4;
                e[d >> 3] = f;
            }
            f = +kd(16520, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 5;
                e[d >> 3] = f;
            }
            f = +kd(16544, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 6;
                e[d >> 3] = f;
            }
            f = +kd(16568, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 7;
                e[d >> 3] = f;
            }
            f = +kd(16592, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 8;
                e[d >> 3] = f;
            }
            f = +kd(16616, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 9;
                e[d >> 3] = f;
            }
            f = +kd(16640, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 10;
                e[d >> 3] = f;
            }
            f = +kd(16664, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 11;
                e[d >> 3] = f;
            }
            f = +kd(16688, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 12;
                e[d >> 3] = f;
            }
            f = +kd(16712, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 13;
                e[d >> 3] = f;
            }
            f = +kd(16736, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 14;
                e[d >> 3] = f;
            }
            f = +kd(16760, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 15;
                e[d >> 3] = f;
            }
            f = +kd(16784, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 16;
                e[d >> 3] = f;
            }
            f = +kd(16808, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 17;
                e[d >> 3] = f;
            }
            f = +kd(16832, g);
            if (f < +e[d >> 3]) {
                b[c >> 2] = 18;
                e[d >> 3] = f;
            }
            f = +kd(16856, g);
            if (!(f < +e[d >> 3])) {
                T = h;
                return;
            }
            b[c >> 2] = 19;
            e[d >> 3] = f;
            T = h;
            return;
        }
        function rb(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0.0, i = 0.0, j = 0.0;
            h = +hd(a);
            if (h < 1.0e-16) {
                c = 15600 + (c << 4) | 0;
                b[g >> 2] = b[c >> 2];
                b[g + 4 >> 2] = b[c + 4 >> 2];
                b[g + 8 >> 2] = b[c + 8 >> 2];
                b[g + 12 >> 2] = b[c + 12 >> 2];
                return;
            }
            i = +z(+ +e[a + 8 >> 3], + +e[a >> 3]);
            if ((d | 0) > 0) {
                a = 0;
                do {
                    h = h * .37796447300922725;
                    a = a + 1 | 0;
                }while ((a | 0) != (d | 0));
            }
            j = h * .3333333333333333;
            if (!f) {
                h = +y(+(h * .381966011250105));
                if (Tb(d) | 0) i = +gc(i + .3334731722518321);
            } else {
                d = (Tb(d) | 0) == 0;
                h = +y(+((d ? j : j * .37796447300922725) * .381966011250105));
            }
            nc(15600 + (c << 4) | 0, +gc(+e[15920 + (c * 24 | 0) >> 3] - i), h, g);
            return;
        }
        function sb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = T;
            T = T + 16 | 0;
            f = e;
            La(a + 4 | 0, f);
            rb(f, b[a >> 2] | 0, c, 0, d);
            T = e;
            return;
        }
        function tb(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0.0, J = 0.0;
            G = T;
            T = T + 272 | 0;
            h = G + 256 | 0;
            u = G + 240 | 0;
            D = G;
            E = G + 224 | 0;
            F = G + 208 | 0;
            v = G + 176 | 0;
            w = G + 160 | 0;
            x = G + 192 | 0;
            y = G + 144 | 0;
            z = G + 128 | 0;
            A = G + 112 | 0;
            B = G + 96 | 0;
            C = G + 80 | 0;
            b[h >> 2] = c;
            b[u >> 2] = b[a >> 2];
            b[u + 4 >> 2] = b[a + 4 >> 2];
            b[u + 8 >> 2] = b[a + 8 >> 2];
            b[u + 12 >> 2] = b[a + 12 >> 2];
            ub(u, h, D);
            b[g >> 2] = 0;
            u = f + d + ((f | 0) == 5 & 1) | 0;
            if ((u | 0) <= (d | 0)) {
                T = G;
                return;
            }
            k = b[h >> 2] | 0;
            l = E + 4 | 0;
            m = v + 4 | 0;
            n = d + 5 | 0;
            o = 16880 + (k << 2) | 0;
            p = 16960 + (k << 2) | 0;
            q = z + 8 | 0;
            r = A + 8 | 0;
            s = B + 8 | 0;
            t = F + 4 | 0;
            j = d;
            a: while(true){
                i = D + (((j | 0) % 5 | 0) << 4) | 0;
                b[F >> 2] = b[i >> 2];
                b[F + 4 >> 2] = b[i + 4 >> 2];
                b[F + 8 >> 2] = b[i + 8 >> 2];
                b[F + 12 >> 2] = b[i + 12 >> 2];
                do ;
                while ((vb(F, k, 0, 1) | 0) == 2);
                if ((j | 0) > (d | 0) & (Tb(c) | 0) != 0) {
                    b[v >> 2] = b[F >> 2];
                    b[v + 4 >> 2] = b[F + 4 >> 2];
                    b[v + 8 >> 2] = b[F + 8 >> 2];
                    b[v + 12 >> 2] = b[F + 12 >> 2];
                    La(l, w);
                    f = b[v >> 2] | 0;
                    h = b[17040 + (f * 80 | 0) + (b[E >> 2] << 2) >> 2] | 0;
                    b[v >> 2] = b[18640 + (f * 80 | 0) + (h * 20 | 0) >> 2];
                    i = b[18640 + (f * 80 | 0) + (h * 20 | 0) + 16 >> 2] | 0;
                    if ((i | 0) > 0) {
                        a = 0;
                        do {
                            Xa(m);
                            a = a + 1 | 0;
                        }while ((a | 0) < (i | 0));
                    }
                    i = 18640 + (f * 80 | 0) + (h * 20 | 0) + 4 | 0;
                    b[x >> 2] = b[i >> 2];
                    b[x + 4 >> 2] = b[i + 4 >> 2];
                    b[x + 8 >> 2] = b[i + 8 >> 2];
                    Oa(x, (b[o >> 2] | 0) * 3 | 0);
                    Ma(m, x, m);
                    Ka(m);
                    La(m, y);
                    H = +(b[p >> 2] | 0);
                    e[z >> 3] = H * 3.0;
                    e[q >> 3] = 0.0;
                    J = H * -1.5;
                    e[A >> 3] = J;
                    e[r >> 3] = H * 2.598076211353316;
                    e[B >> 3] = J;
                    e[s >> 3] = H * -2.598076211353316;
                    switch(b[17040 + ((b[v >> 2] | 0) * 80 | 0) + (b[F >> 2] << 2) >> 2] | 0){
                        case 1:
                            a = A;
                            f = z;
                            break;
                        case 3:
                            a = B;
                            f = A;
                            break;
                        case 2:
                            a = z;
                            f = B;
                            break;
                        default:
                            a = 12;
                            break a;
                    }
                    id(w, y, f, a, C);
                    rb(C, b[v >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                if ((j | 0) < (n | 0)) {
                    La(t, v);
                    rb(v, b[F >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                b[E >> 2] = b[F >> 2];
                b[E + 4 >> 2] = b[F + 4 >> 2];
                b[E + 8 >> 2] = b[F + 8 >> 2];
                b[E + 12 >> 2] = b[F + 12 >> 2];
                j = j + 1 | 0;
                if ((j | 0) >= (u | 0)) {
                    a = 3;
                    break;
                }
            }
            if ((a | 0) == 3) {
                T = G;
                return;
            } else if ((a | 0) == 12) I(26970, 27017, 572, 27027);
        }
        function ub(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = T;
            T = T + 128 | 0;
            e = j + 64 | 0;
            f = j;
            g = e;
            h = 20240;
            i = g + 60 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            g = f;
            h = 20304;
            i = g + 60 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            i = (Tb(b[c >> 2] | 0) | 0) == 0;
            e = i ? e : f;
            f = a + 4 | 0;
            $a(f);
            ab(f);
            if (Tb(b[c >> 2] | 0) | 0) {
                Va(f);
                b[c >> 2] = (b[c >> 2] | 0) + 1;
            }
            b[d >> 2] = b[a >> 2];
            c = d + 4 | 0;
            Ma(f, e, c);
            Ka(c);
            b[d + 16 >> 2] = b[a >> 2];
            c = d + 20 | 0;
            Ma(f, e + 12 | 0, c);
            Ka(c);
            b[d + 32 >> 2] = b[a >> 2];
            c = d + 36 | 0;
            Ma(f, e + 24 | 0, c);
            Ka(c);
            b[d + 48 >> 2] = b[a >> 2];
            c = d + 52 | 0;
            Ma(f, e + 36 | 0, c);
            Ka(c);
            b[d + 64 >> 2] = b[a >> 2];
            d = d + 68 | 0;
            Ma(f, e + 48 | 0, d);
            Ka(d);
            T = j;
            return;
        }
        function vb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            p = T;
            T = T + 32 | 0;
            n = p + 12 | 0;
            i = p;
            o = a + 4 | 0;
            m = b[16960 + (c << 2) >> 2] | 0;
            l = (e | 0) != 0;
            m = l ? m * 3 | 0 : m;
            f = b[o >> 2] | 0;
            k = a + 8 | 0;
            h = b[k >> 2] | 0;
            if (l) {
                g = a + 12 | 0;
                e = b[g >> 2] | 0;
                f = h + f + e | 0;
                if ((f | 0) == (m | 0)) {
                    o = 1;
                    T = p;
                    return o | 0;
                } else j = g;
            } else {
                j = a + 12 | 0;
                e = b[j >> 2] | 0;
                f = h + f + e | 0;
            }
            if ((f | 0) <= (m | 0)) {
                o = 0;
                T = p;
                return o | 0;
            }
            do if ((e | 0) > 0) {
                e = b[a >> 2] | 0;
                if ((h | 0) > 0) {
                    g = 18640 + (e * 80 | 0) + 60 | 0;
                    e = a;
                    break;
                }
                e = 18640 + (e * 80 | 0) + 40 | 0;
                if (!d) {
                    g = e;
                    e = a;
                } else {
                    Ia(n, m, 0, 0);
                    Na(o, n, i);
                    Ya(i);
                    Ma(i, n, o);
                    g = e;
                    e = a;
                }
            } else {
                g = 18640 + ((b[a >> 2] | 0) * 80 | 0) + 20 | 0;
                e = a;
            }
            while (0);
            b[e >> 2] = b[g >> 2];
            f = g + 16 | 0;
            if ((b[f >> 2] | 0) > 0) {
                e = 0;
                do {
                    Xa(o);
                    e = e + 1 | 0;
                }while ((e | 0) < (b[f >> 2] | 0));
            }
            a = g + 4 | 0;
            b[n >> 2] = b[a >> 2];
            b[n + 4 >> 2] = b[a + 4 >> 2];
            b[n + 8 >> 2] = b[a + 8 >> 2];
            c = b[16880 + (c << 2) >> 2] | 0;
            Oa(n, l ? c * 3 | 0 : c);
            Ma(o, n, o);
            Ka(o);
            if (l) e = ((b[k >> 2] | 0) + (b[o >> 2] | 0) + (b[j >> 2] | 0) | 0) == (m | 0) ? 1 : 2;
            else e = 2;
            o = e;
            T = p;
            return o | 0;
        }
        function wb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            do c = vb(a, b, 0, 1) | 0;
            while ((c | 0) == 2);
            return c | 0;
        }
        function xb(a, c, d, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0.0, D = 0.0;
            B = T;
            T = T + 240 | 0;
            h = B + 224 | 0;
            x = B + 208 | 0;
            y = B;
            z = B + 192 | 0;
            A = B + 176 | 0;
            s = B + 160 | 0;
            t = B + 144 | 0;
            u = B + 128 | 0;
            v = B + 112 | 0;
            w = B + 96 | 0;
            b[h >> 2] = c;
            b[x >> 2] = b[a >> 2];
            b[x + 4 >> 2] = b[a + 4 >> 2];
            b[x + 8 >> 2] = b[a + 8 >> 2];
            b[x + 12 >> 2] = b[a + 12 >> 2];
            yb(x, h, y);
            b[g >> 2] = 0;
            r = f + d + ((f | 0) == 6 & 1) | 0;
            if ((r | 0) <= (d | 0)) {
                T = B;
                return;
            }
            k = b[h >> 2] | 0;
            l = d + 6 | 0;
            m = 16960 + (k << 2) | 0;
            n = t + 8 | 0;
            o = u + 8 | 0;
            p = v + 8 | 0;
            q = z + 4 | 0;
            i = 0;
            j = d;
            f = -1;
            a: while(true){
                h = (j | 0) % 6 | 0;
                a = y + (h << 4) | 0;
                b[z >> 2] = b[a >> 2];
                b[z + 4 >> 2] = b[a + 4 >> 2];
                b[z + 8 >> 2] = b[a + 8 >> 2];
                b[z + 12 >> 2] = b[a + 12 >> 2];
                a = i;
                i = vb(z, k, 0, 1) | 0;
                if ((j | 0) > (d | 0) & (Tb(c) | 0) != 0 ? (a | 0) != 1 ? (b[z >> 2] | 0) != (f | 0) : 0 : 0) {
                    La(y + (((h + 5 | 0) % 6 | 0) << 4) + 4 | 0, A);
                    La(y + (h << 4) + 4 | 0, s);
                    C = +(b[m >> 2] | 0);
                    e[t >> 3] = C * 3.0;
                    e[n >> 3] = 0.0;
                    D = C * -1.5;
                    e[u >> 3] = D;
                    e[o >> 3] = C * 2.598076211353316;
                    e[v >> 3] = D;
                    e[p >> 3] = C * -2.598076211353316;
                    h = b[x >> 2] | 0;
                    switch(b[17040 + (h * 80 | 0) + (((f | 0) == (h | 0) ? b[z >> 2] | 0 : f) << 2) >> 2] | 0){
                        case 1:
                            a = u;
                            f = t;
                            break;
                        case 3:
                            a = v;
                            f = u;
                            break;
                        case 2:
                            a = t;
                            f = v;
                            break;
                        default:
                            a = 8;
                            break a;
                    }
                    id(A, s, f, a, w);
                    if (!(jd(A, w) | 0) ? !(jd(s, w) | 0) : 0) {
                        rb(w, b[x >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                        b[g >> 2] = (b[g >> 2] | 0) + 1;
                    }
                }
                if ((j | 0) < (l | 0)) {
                    La(q, A);
                    rb(A, b[z >> 2] | 0, k, 1, g + 8 + (b[g >> 2] << 4) | 0);
                    b[g >> 2] = (b[g >> 2] | 0) + 1;
                }
                j = j + 1 | 0;
                if ((j | 0) >= (r | 0)) {
                    a = 3;
                    break;
                } else f = b[z >> 2] | 0;
            }
            if ((a | 0) == 3) {
                T = B;
                return;
            } else if ((a | 0) == 8) I(27054, 27017, 737, 27099);
        }
        function yb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = T;
            T = T + 160 | 0;
            e = j + 80 | 0;
            f = j;
            g = e;
            h = 20368;
            i = g + 72 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            g = f;
            h = 20448;
            i = g + 72 | 0;
            do {
                b[g >> 2] = b[h >> 2];
                g = g + 4 | 0;
                h = h + 4 | 0;
            }while ((g | 0) < (i | 0));
            i = (Tb(b[c >> 2] | 0) | 0) == 0;
            e = i ? e : f;
            f = a + 4 | 0;
            $a(f);
            ab(f);
            if (Tb(b[c >> 2] | 0) | 0) {
                Va(f);
                b[c >> 2] = (b[c >> 2] | 0) + 1;
            }
            b[d >> 2] = b[a >> 2];
            c = d + 4 | 0;
            Ma(f, e, c);
            Ka(c);
            b[d + 16 >> 2] = b[a >> 2];
            c = d + 20 | 0;
            Ma(f, e + 12 | 0, c);
            Ka(c);
            b[d + 32 >> 2] = b[a >> 2];
            c = d + 36 | 0;
            Ma(f, e + 24 | 0, c);
            Ka(c);
            b[d + 48 >> 2] = b[a >> 2];
            c = d + 52 | 0;
            Ma(f, e + 36 | 0, c);
            Ka(c);
            b[d + 64 >> 2] = b[a >> 2];
            c = d + 68 | 0;
            Ma(f, e + 48 | 0, c);
            Ka(c);
            b[d + 80 >> 2] = b[a >> 2];
            d = d + 84 | 0;
            Ma(f, e + 60 | 0, d);
            Ka(d);
            T = j;
            return;
        }
        function zb(a, b) {
            a = a | 0;
            b = b | 0;
            b = Od(a | 0, b | 0, 52) | 0;
            H();
            return b & 15 | 0;
        }
        function Ab(a, b) {
            a = a | 0;
            b = b | 0;
            b = Od(a | 0, b | 0, 45) | 0;
            H();
            return b & 127 | 0;
        }
        function Bb(b, c) {
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            if (!(true & (c & -16777216 | 0) == 134217728)) {
                b = 0;
                return b | 0;
            }
            e = Od(b | 0, c | 0, 52) | 0;
            H();
            e = e & 15;
            d = Od(b | 0, c | 0, 45) | 0;
            H();
            d = d & 127;
            if (d >>> 0 > 121) {
                b = 0;
                return b | 0;
            }
            h = (e ^ 15) * 3 | 0;
            f = Od(b | 0, c | 0, h | 0) | 0;
            h = Pd(f | 0, H() | 0, h | 0) | 0;
            f = H() | 0;
            g = Fd(-1227133514, -1171, h | 0, f | 0) | 0;
            if (!((h & 613566756 & g | 0) == 0 & (f & 4681 & (H() | 0) | 0) == 0)) {
                h = 0;
                return h | 0;
            }
            h = (e * 3 | 0) + 19 | 0;
            g = Pd(~b | 0, ~c | 0, h | 0) | 0;
            h = Od(g | 0, H() | 0, h | 0) | 0;
            if (!((e | 0) == 15 | (h | 0) == 0 & (H() | 0) == 0)) {
                h = 0;
                return h | 0;
            }
            if (!(a[20528 + d >> 0] | 0)) {
                h = 1;
                return h | 0;
            }
            c = c & 8191;
            if ((b | 0) == 0 & (c | 0) == 0) {
                h = 1;
                return h | 0;
            } else {
                h = Qd(b | 0, c | 0, 0) | 0;
                H();
                return ((63 - h | 0) % 3 | 0) != 0 | 0;
            }
            return 0;
        }
        function Cb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            f = Pd(c | 0, 0, 52) | 0;
            g = H() | 0;
            d = Pd(d | 0, 0, 45) | 0;
            d = g | (H() | 0) | 134225919;
            if ((c | 0) < 1) {
                g = -1;
                e = d;
                c = a;
                b[c >> 2] = g;
                a = a + 4 | 0;
                b[a >> 2] = e;
                return;
            }
            g = 1;
            f = -1;
            while(true){
                h = (15 - g | 0) * 3 | 0;
                i = Pd(7, 0, h | 0) | 0;
                d = d & ~(H() | 0);
                h = Pd(e | 0, 0, h | 0) | 0;
                f = f & ~i | h;
                d = d | (H() | 0);
                if ((g | 0) == (c | 0)) break;
                else g = g + 1 | 0;
            }
            i = a;
            h = i;
            b[h >> 2] = f;
            i = i + 4 | 0;
            b[i >> 2] = d;
            return;
        }
        function Db(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = Od(a | 0, c | 0, 52) | 0;
            H();
            g = g & 15;
            if (d >>> 0 > 15) {
                e = 4;
                return e | 0;
            }
            if ((g | 0) < (d | 0)) {
                e = 12;
                return e | 0;
            }
            if ((g | 0) == (d | 0)) {
                b[e >> 2] = a;
                b[e + 4 >> 2] = c;
                e = 0;
                return e | 0;
            }
            f = Pd(d | 0, 0, 52) | 0;
            f = f | a;
            a = H() | 0 | c & -15728641;
            if ((g | 0) > (d | 0)) do {
                c = Pd(7, 0, (14 - d | 0) * 3 | 0) | 0;
                d = d + 1 | 0;
                f = c | f;
                a = H() | 0 | a;
            }while ((d | 0) < (g | 0));
            b[e >> 2] = f;
            b[e + 4 >> 2] = a;
            e = 0;
            return e | 0;
        }
        function Eb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0;
            g = Od(a | 0, c | 0, 52) | 0;
            H();
            g = g & 15;
            if (!((d | 0) < 16 & (g | 0) <= (d | 0))) {
                e = 4;
                return e | 0;
            }
            f = d - g | 0;
            d = Od(a | 0, c | 0, 45) | 0;
            H();
            a: do if (!(ma(d & 127) | 0)) {
                d = Mc(7, 0, f, ((f | 0) < 0) << 31 >> 31) | 0;
                f = H() | 0;
            } else {
                b: do if (g | 0) {
                    d = 1;
                    while(true){
                        h = Pd(7, 0, (15 - d | 0) * 3 | 0) | 0;
                        if (!((h & a | 0) == 0 & ((H() | 0) & c | 0) == 0)) break;
                        if (d >>> 0 < g >>> 0) d = d + 1 | 0;
                        else break b;
                    }
                    d = Mc(7, 0, f, ((f | 0) < 0) << 31 >> 31) | 0;
                    f = H() | 0;
                    break a;
                }
                while (0);
                d = Mc(7, 0, f, ((f | 0) < 0) << 31 >> 31) | 0;
                d = Kd(d | 0, H() | 0, 5, 0) | 0;
                d = Ed(d | 0, H() | 0, -5, -1) | 0;
                d = Id(d | 0, H() | 0, 6, 0) | 0;
                d = Ed(d | 0, H() | 0, 1, 0) | 0;
                f = H() | 0;
            }
            while (0);
            h = e;
            b[h >> 2] = d;
            b[h + 4 >> 2] = f;
            h = 0;
            return h | 0;
        }
        function Fb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            e = Od(a | 0, b | 0, 45) | 0;
            H();
            if (!(ma(e & 127) | 0)) {
                e = 0;
                return e | 0;
            }
            e = Od(a | 0, b | 0, 52) | 0;
            H();
            e = e & 15;
            a: do if (!e) c = 0;
            else {
                d = 1;
                while(true){
                    c = Od(a | 0, b | 0, (15 - d | 0) * 3 | 0) | 0;
                    H();
                    c = c & 7;
                    if (c | 0) break a;
                    if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                    else {
                        c = 0;
                        break;
                    }
                }
            }
            while (0);
            e = (c | 0) == 0 & 1;
            return e | 0;
        }
        function Gb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = T;
            T = T + 16 | 0;
            g = h;
            dc(g, a, c, d);
            c = g;
            a = b[c >> 2] | 0;
            c = b[c + 4 >> 2] | 0;
            if ((a | 0) == 0 & (c | 0) == 0) {
                T = h;
                return 0;
            }
            f = 0;
            d = 0;
            do {
                i = e + (f << 3) | 0;
                b[i >> 2] = a;
                b[i + 4 >> 2] = c;
                f = Ed(f | 0, d | 0, 1, 0) | 0;
                d = H() | 0;
                fc(g);
                i = g;
                a = b[i >> 2] | 0;
                c = b[i + 4 >> 2] | 0;
            }while (!((a | 0) == 0 & (c | 0) == 0));
            T = h;
            return 0;
        }
        function Hb(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((d | 0) < (c | 0)) {
                c = b;
                d = a;
                G(c | 0);
                return d | 0;
            }
            c = Pd(-1, -1, ((d - c | 0) * 3 | 0) + 3 | 0) | 0;
            d = Pd(~c | 0, ~(H() | 0) | 0, (15 - d | 0) * 3 | 0) | 0;
            c = ~(H() | 0) & b;
            d = ~d & a;
            G(c | 0);
            return d | 0;
        }
        function Ib(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            f = Od(a | 0, c | 0, 52) | 0;
            H();
            f = f & 15;
            if (!((d | 0) < 16 & (f | 0) <= (d | 0))) {
                e = 4;
                return e | 0;
            }
            if ((f | 0) < (d | 0)) {
                f = Pd(-1, -1, ((d + -1 - f | 0) * 3 | 0) + 3 | 0) | 0;
                f = Pd(~f | 0, ~(H() | 0) | 0, (15 - d | 0) * 3 | 0) | 0;
                c = ~(H() | 0) & c;
                a = ~f & a;
            }
            f = Pd(d | 0, 0, 52) | 0;
            d = c & -15728641 | (H() | 0);
            b[e >> 2] = a | f;
            b[e + 4 >> 2] = d;
            e = 0;
            return e | 0;
        }
        function Jb(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0;
            if ((d | 0) == 0 & (e | 0) == 0) {
                E = 0;
                return E | 0;
            }
            f = a;
            g = b[f >> 2] | 0;
            f = b[f + 4 >> 2] | 0;
            if (true & (f & 15728640 | 0) == 0) {
                if (!((e | 0) > 0 | (e | 0) == 0 & d >>> 0 > 0)) {
                    E = 0;
                    return E | 0;
                }
                E = c;
                b[E >> 2] = g;
                b[E + 4 >> 2] = f;
                if ((d | 0) == 1 & (e | 0) == 0) {
                    E = 0;
                    return E | 0;
                }
                f = 1;
                g = 0;
                do {
                    C = a + (f << 3) | 0;
                    D = b[C + 4 >> 2] | 0;
                    E = c + (f << 3) | 0;
                    b[E >> 2] = b[C >> 2];
                    b[E + 4 >> 2] = D;
                    f = Ed(f | 0, g | 0, 1, 0) | 0;
                    g = H() | 0;
                }while ((g | 0) < (e | 0) | (g | 0) == (e | 0) & f >>> 0 < d >>> 0);
                f = 0;
                return f | 0;
            }
            B = d << 3;
            D = Bd(B) | 0;
            if (!D) {
                E = 13;
                return E | 0;
            }
            Ud(D | 0, a | 0, B | 0);
            C = Dd(d, 8) | 0;
            if (!C) {
                Cd(D);
                E = 13;
                return E | 0;
            }
            a: while(true){
                f = D;
                k = b[f >> 2] | 0;
                f = b[f + 4 >> 2] | 0;
                z = Od(k | 0, f | 0, 52) | 0;
                H();
                z = z & 15;
                A = z + -1 | 0;
                y = (z | 0) != 0;
                x = (e | 0) > 0 | (e | 0) == 0 & d >>> 0 > 0;
                b: do if (y & x) {
                    t = Pd(A | 0, 0, 52) | 0;
                    u = H() | 0;
                    if (A >>> 0 > 15) {
                        if (!((k | 0) == 0 & (f | 0) == 0)) {
                            E = 16;
                            break a;
                        }
                        g = 0;
                        a = 0;
                        while(true){
                            g = Ed(g | 0, a | 0, 1, 0) | 0;
                            a = H() | 0;
                            if (!((a | 0) < (e | 0) | (a | 0) == (e | 0) & g >>> 0 < d >>> 0)) break b;
                            h = D + (g << 3) | 0;
                            w = b[h >> 2] | 0;
                            h = b[h + 4 >> 2] | 0;
                            if (!((w | 0) == 0 & (h | 0) == 0)) {
                                f = h;
                                E = 16;
                                break a;
                            }
                        }
                    }
                    i = k;
                    a = f;
                    g = 0;
                    h = 0;
                    while(true){
                        if (!((i | 0) == 0 & (a | 0) == 0)) {
                            if (!(true & (a & 117440512 | 0) == 0)) {
                                E = 21;
                                break a;
                            }
                            l = Od(i | 0, a | 0, 52) | 0;
                            H();
                            l = l & 15;
                            if ((l | 0) < (A | 0)) {
                                f = 12;
                                E = 27;
                                break a;
                            }
                            if ((l | 0) != (A | 0)) {
                                i = i | t;
                                a = a & -15728641 | u;
                                if (l >>> 0 >= z >>> 0) {
                                    j = A;
                                    do {
                                        w = Pd(7, 0, (14 - j | 0) * 3 | 0) | 0;
                                        j = j + 1 | 0;
                                        i = w | i;
                                        a = H() | 0 | a;
                                    }while (j >>> 0 < l >>> 0);
                                }
                            }
                            n = Md(i | 0, a | 0, d | 0, e | 0) | 0;
                            o = H() | 0;
                            j = C + (n << 3) | 0;
                            l = j;
                            m = b[l >> 2] | 0;
                            l = b[l + 4 >> 2] | 0;
                            if (!((m | 0) == 0 & (l | 0) == 0)) {
                                r = 0;
                                s = 0;
                                do {
                                    if ((r | 0) > (e | 0) | (r | 0) == (e | 0) & s >>> 0 > d >>> 0) {
                                        E = 31;
                                        break a;
                                    }
                                    if ((m | 0) == (i | 0) & (l & -117440513 | 0) == (a | 0)) {
                                        p = Od(m | 0, l | 0, 56) | 0;
                                        H();
                                        p = p & 7;
                                        q = p + 1 | 0;
                                        w = Od(m | 0, l | 0, 45) | 0;
                                        H();
                                        c: do if (!(ma(w & 127) | 0)) l = 7;
                                        else {
                                            m = Od(m | 0, l | 0, 52) | 0;
                                            H();
                                            m = m & 15;
                                            if (!m) {
                                                l = 6;
                                                break;
                                            }
                                            l = 1;
                                            while(true){
                                                w = Pd(7, 0, (15 - l | 0) * 3 | 0) | 0;
                                                if (!((w & i | 0) == 0 & ((H() | 0) & a | 0) == 0)) {
                                                    l = 7;
                                                    break c;
                                                }
                                                if (l >>> 0 < m >>> 0) l = l + 1 | 0;
                                                else {
                                                    l = 6;
                                                    break;
                                                }
                                            }
                                        }
                                        while (0);
                                        if ((p + 2 | 0) >>> 0 > l >>> 0) {
                                            E = 41;
                                            break a;
                                        }
                                        w = Pd(q | 0, 0, 56) | 0;
                                        a = H() | 0 | a & -117440513;
                                        v = j;
                                        b[v >> 2] = 0;
                                        b[v + 4 >> 2] = 0;
                                        i = w | i;
                                    } else {
                                        n = Ed(n | 0, o | 0, 1, 0) | 0;
                                        n = Ld(n | 0, H() | 0, d | 0, e | 0) | 0;
                                        o = H() | 0;
                                    }
                                    s = Ed(s | 0, r | 0, 1, 0) | 0;
                                    r = H() | 0;
                                    j = C + (n << 3) | 0;
                                    l = j;
                                    m = b[l >> 2] | 0;
                                    l = b[l + 4 >> 2] | 0;
                                }while (!((m | 0) == 0 & (l | 0) == 0));
                            }
                            w = j;
                            b[w >> 2] = i;
                            b[w + 4 >> 2] = a;
                        }
                        g = Ed(g | 0, h | 0, 1, 0) | 0;
                        h = H() | 0;
                        if (!((h | 0) < (e | 0) | (h | 0) == (e | 0) & g >>> 0 < d >>> 0)) break b;
                        a = D + (g << 3) | 0;
                        i = b[a >> 2] | 0;
                        a = b[a + 4 >> 2] | 0;
                    }
                }
                while (0);
                w = Ed(d | 0, e | 0, 5, 0) | 0;
                v = H() | 0;
                if (v >>> 0 < 0 | (v | 0) == 0 & w >>> 0 < 11) {
                    E = 85;
                    break;
                }
                w = Id(d | 0, e | 0, 6, 0) | 0;
                H();
                w = Dd(w, 8) | 0;
                if (!w) {
                    E = 48;
                    break;
                }
                do if (x) {
                    q = 0;
                    a = 0;
                    p = 0;
                    r = 0;
                    while(true){
                        l = C + (q << 3) | 0;
                        h = l;
                        g = b[h >> 2] | 0;
                        h = b[h + 4 >> 2] | 0;
                        if (!((g | 0) == 0 & (h | 0) == 0)) {
                            m = Od(g | 0, h | 0, 56) | 0;
                            H();
                            m = m & 7;
                            i = m + 1 | 0;
                            n = h & -117440513;
                            v = Od(g | 0, h | 0, 45) | 0;
                            H();
                            d: do if (ma(v & 127) | 0) {
                                o = Od(g | 0, h | 0, 52) | 0;
                                H();
                                o = o & 15;
                                if (o | 0) {
                                    j = 1;
                                    while(true){
                                        v = Pd(7, 0, (15 - j | 0) * 3 | 0) | 0;
                                        if (!((g & v | 0) == 0 & (n & (H() | 0) | 0) == 0)) break d;
                                        if (j >>> 0 < o >>> 0) j = j + 1 | 0;
                                        else break;
                                    }
                                }
                                h = Pd(i | 0, 0, 56) | 0;
                                g = h | g;
                                h = H() | 0 | n;
                                i = l;
                                b[i >> 2] = g;
                                b[i + 4 >> 2] = h;
                                i = m + 2 | 0;
                            }
                            while (0);
                            if ((i | 0) == 7) {
                                v = w + (a << 3) | 0;
                                b[v >> 2] = g;
                                b[v + 4 >> 2] = h & -117440513;
                                a = Ed(a | 0, p | 0, 1, 0) | 0;
                                v = H() | 0;
                            } else v = p;
                        } else v = p;
                        q = Ed(q | 0, r | 0, 1, 0) | 0;
                        r = H() | 0;
                        if (!((r | 0) < (e | 0) | (r | 0) == (e | 0) & q >>> 0 < d >>> 0)) break;
                        else p = v;
                    }
                    if (x) {
                        s = A >>> 0 > 15;
                        t = Pd(A | 0, 0, 52) | 0;
                        u = H() | 0;
                        if (!y) {
                            g = 0;
                            j = 0;
                            i = 0;
                            h = 0;
                            while(true){
                                if (!((k | 0) == 0 & (f | 0) == 0)) {
                                    A = c + (g << 3) | 0;
                                    b[A >> 2] = k;
                                    b[A + 4 >> 2] = f;
                                    g = Ed(g | 0, j | 0, 1, 0) | 0;
                                    j = H() | 0;
                                }
                                i = Ed(i | 0, h | 0, 1, 0) | 0;
                                h = H() | 0;
                                if (!((h | 0) < (e | 0) | (h | 0) == (e | 0) & i >>> 0 < d >>> 0)) break;
                                f = D + (i << 3) | 0;
                                k = b[f >> 2] | 0;
                                f = b[f + 4 >> 2] | 0;
                            }
                            f = v;
                            break;
                        }
                        g = 0;
                        j = 0;
                        h = 0;
                        i = 0;
                        while(true){
                            do if (!((k | 0) == 0 & (f | 0) == 0)) {
                                o = Od(k | 0, f | 0, 52) | 0;
                                H();
                                o = o & 15;
                                if (s | (o | 0) < (A | 0)) {
                                    E = 80;
                                    break a;
                                }
                                if ((o | 0) != (A | 0)) {
                                    l = k | t;
                                    m = f & -15728641 | u;
                                    if (o >>> 0 >= z >>> 0) {
                                        n = A;
                                        do {
                                            y = Pd(7, 0, (14 - n | 0) * 3 | 0) | 0;
                                            n = n + 1 | 0;
                                            l = y | l;
                                            m = H() | 0 | m;
                                        }while (n >>> 0 < o >>> 0);
                                    }
                                } else {
                                    l = k;
                                    m = f;
                                }
                                p = Md(l | 0, m | 0, d | 0, e | 0) | 0;
                                n = 0;
                                o = 0;
                                r = H() | 0;
                                do {
                                    if ((n | 0) > (e | 0) | (n | 0) == (e | 0) & o >>> 0 > d >>> 0) {
                                        E = 81;
                                        break a;
                                    }
                                    y = C + (p << 3) | 0;
                                    q = b[y + 4 >> 2] | 0;
                                    if ((q & -117440513 | 0) == (m | 0) ? (b[y >> 2] | 0) == (l | 0) : 0) {
                                        E = 65;
                                        break;
                                    }
                                    y = Ed(p | 0, r | 0, 1, 0) | 0;
                                    p = Ld(y | 0, H() | 0, d | 0, e | 0) | 0;
                                    r = H() | 0;
                                    o = Ed(o | 0, n | 0, 1, 0) | 0;
                                    n = H() | 0;
                                    y = C + (p << 3) | 0;
                                }while (!((b[y >> 2] | 0) == (l | 0) ? (b[y + 4 >> 2] | 0) == (m | 0) : 0));
                                if ((E | 0) == 65 ? (E = 0, true & (q & 117440512 | 0) == 100663296) : 0) break;
                                y = c + (g << 3) | 0;
                                b[y >> 2] = k;
                                b[y + 4 >> 2] = f;
                                g = Ed(g | 0, j | 0, 1, 0) | 0;
                                j = H() | 0;
                            }
                            while (0);
                            h = Ed(h | 0, i | 0, 1, 0) | 0;
                            i = H() | 0;
                            if (!((i | 0) < (e | 0) | (i | 0) == (e | 0) & h >>> 0 < d >>> 0)) break;
                            f = D + (h << 3) | 0;
                            k = b[f >> 2] | 0;
                            f = b[f + 4 >> 2] | 0;
                        }
                        f = v;
                    } else {
                        g = 0;
                        f = v;
                    }
                } else {
                    g = 0;
                    a = 0;
                    f = 0;
                }
                while (0);
                Vd(C | 0, 0, B | 0);
                Ud(D | 0, w | 0, a << 3 | 0);
                Cd(w);
                if ((a | 0) == 0 & (f | 0) == 0) {
                    E = 89;
                    break;
                } else {
                    c = c + (g << 3) | 0;
                    e = f;
                    d = a;
                }
            }
            if ((E | 0) == 16) {
                if (true & (f & 117440512 | 0) == 0) {
                    f = 4;
                    E = 27;
                } else E = 21;
            } else if ((E | 0) == 31) I(27795, 27122, 529, 27132);
            else if ((E | 0) == 41) {
                Cd(D);
                Cd(C);
                E = 10;
                return E | 0;
            } else if ((E | 0) == 48) {
                Cd(D);
                Cd(C);
                E = 13;
                return E | 0;
            } else if ((E | 0) == 80) I(27795, 27122, 620, 27132);
            else if ((E | 0) == 81) I(27795, 27122, 632, 27132);
            else if ((E | 0) == 85) {
                Ud(c | 0, D | 0, d << 3 | 0);
                E = 89;
            }
            if ((E | 0) == 21) {
                Cd(D);
                Cd(C);
                E = 5;
                return E | 0;
            } else if ((E | 0) == 27) {
                Cd(D);
                Cd(C);
                E = f;
                return E | 0;
            } else if ((E | 0) == 89) {
                Cd(D);
                Cd(C);
                E = 0;
                return E | 0;
            }
            return 0;
        }
        function Kb(a, c, d, e, f, g, h) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0;
            q = T;
            T = T + 16 | 0;
            p = q;
            if (!((d | 0) > 0 | (d | 0) == 0 & c >>> 0 > 0)) {
                p = 0;
                T = q;
                return p | 0;
            }
            if ((h | 0) >= 16) {
                p = 12;
                T = q;
                return p | 0;
            }
            n = 0;
            o = 0;
            m = 0;
            i = 0;
            a: while(true){
                k = a + (n << 3) | 0;
                j = b[k >> 2] | 0;
                k = b[k + 4 >> 2] | 0;
                l = Od(j | 0, k | 0, 52) | 0;
                H();
                if ((l & 15 | 0) > (h | 0)) {
                    i = 12;
                    j = 11;
                    break;
                }
                dc(p, j, k, h);
                l = p;
                k = b[l >> 2] | 0;
                l = b[l + 4 >> 2] | 0;
                if ((k | 0) == 0 & (l | 0) == 0) j = m;
                else {
                    j = m;
                    do {
                        if (!((i | 0) < (g | 0) | (i | 0) == (g | 0) & j >>> 0 < f >>> 0)) {
                            j = 10;
                            break a;
                        }
                        m = e + (j << 3) | 0;
                        b[m >> 2] = k;
                        b[m + 4 >> 2] = l;
                        j = Ed(j | 0, i | 0, 1, 0) | 0;
                        i = H() | 0;
                        fc(p);
                        m = p;
                        k = b[m >> 2] | 0;
                        l = b[m + 4 >> 2] | 0;
                    }while (!((k | 0) == 0 & (l | 0) == 0));
                }
                n = Ed(n | 0, o | 0, 1, 0) | 0;
                o = H() | 0;
                if (!((o | 0) < (d | 0) | (o | 0) == (d | 0) & n >>> 0 < c >>> 0)) {
                    i = 0;
                    j = 11;
                    break;
                } else m = j;
            }
            if ((j | 0) == 10) {
                p = 14;
                T = q;
                return p | 0;
            } else if ((j | 0) == 11) {
                T = q;
                return i | 0;
            }
            return 0;
        }
        function Lb(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0;
            n = T;
            T = T + 16 | 0;
            m = n;
            a: do if ((d | 0) > 0 | (d | 0) == 0 & c >>> 0 > 0) {
                k = 0;
                h = 0;
                g = 0;
                l = 0;
                while(true){
                    j = a + (k << 3) | 0;
                    i = b[j >> 2] | 0;
                    j = b[j + 4 >> 2] | 0;
                    if (!((i | 0) == 0 & (j | 0) == 0)) {
                        j = (Eb(i, j, e, m) | 0) == 0;
                        i = m;
                        h = Ed(b[i >> 2] | 0, b[i + 4 >> 2] | 0, h | 0, g | 0) | 0;
                        g = H() | 0;
                        if (!j) {
                            g = 12;
                            break;
                        }
                    }
                    k = Ed(k | 0, l | 0, 1, 0) | 0;
                    l = H() | 0;
                    if (!((l | 0) < (d | 0) | (l | 0) == (d | 0) & k >>> 0 < c >>> 0)) break a;
                }
                T = n;
                return g | 0;
            } else {
                h = 0;
                g = 0;
            }
            while (0);
            b[f >> 2] = h;
            b[f + 4 >> 2] = g;
            f = 0;
            T = n;
            return f | 0;
        }
        function Mb(a, b) {
            a = a | 0;
            b = b | 0;
            b = Od(a | 0, b | 0, 52) | 0;
            H();
            return b & 1 | 0;
        }
        function Nb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0;
            e = Od(a | 0, b | 0, 52) | 0;
            H();
            e = e & 15;
            if (!e) {
                e = 0;
                return e | 0;
            }
            d = 1;
            while(true){
                c = Od(a | 0, b | 0, (15 - d | 0) * 3 | 0) | 0;
                H();
                c = c & 7;
                if (c | 0) {
                    d = 5;
                    break;
                }
                if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                else {
                    c = 0;
                    d = 5;
                    break;
                }
            }
            if ((d | 0) == 5) return c | 0;
            return 0;
        }
        function Ob(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            i = Od(a | 0, b | 0, 52) | 0;
            H();
            i = i & 15;
            if (!i) {
                h = b;
                i = a;
                G(h | 0);
                return i | 0;
            }
            h = 1;
            c = 0;
            while(true){
                f = (15 - h | 0) * 3 | 0;
                d = Pd(7, 0, f | 0) | 0;
                e = H() | 0;
                g = Od(a | 0, b | 0, f | 0) | 0;
                H();
                f = Pd(Za(g & 7) | 0, 0, f | 0) | 0;
                g = H() | 0;
                a = f | a & ~d;
                b = g | b & ~e;
                a: do if (!c) {
                    if (!((f & d | 0) == 0 & (g & e | 0) == 0)) {
                        d = Od(a | 0, b | 0, 52) | 0;
                        H();
                        d = d & 15;
                        if (!d) c = 1;
                        else {
                            c = 1;
                            b: while(true){
                                g = Od(a | 0, b | 0, (15 - c | 0) * 3 | 0) | 0;
                                H();
                                switch(g & 7){
                                    case 1:
                                        break b;
                                    case 0:
                                        break;
                                    default:
                                        c = 1;
                                        break a;
                                }
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break a;
                                }
                            }
                            c = 1;
                            while(true){
                                g = (15 - c | 0) * 3 | 0;
                                e = Od(a | 0, b | 0, g | 0) | 0;
                                H();
                                f = Pd(7, 0, g | 0) | 0;
                                b = b & ~(H() | 0);
                                g = Pd(Za(e & 7) | 0, 0, g | 0) | 0;
                                a = a & ~f | g;
                                b = b | (H() | 0);
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break;
                                }
                            }
                        }
                    } else c = 0;
                }
                while (0);
                if (h >>> 0 < i >>> 0) h = h + 1 | 0;
                else break;
            }
            G(b | 0);
            return a | 0;
        }
        function Pb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0;
            d = Od(a | 0, b | 0, 52) | 0;
            H();
            d = d & 15;
            if (!d) {
                c = b;
                d = a;
                G(c | 0);
                return d | 0;
            }
            c = 1;
            while(true){
                f = (15 - c | 0) * 3 | 0;
                g = Od(a | 0, b | 0, f | 0) | 0;
                H();
                e = Pd(7, 0, f | 0) | 0;
                b = b & ~(H() | 0);
                f = Pd(Za(g & 7) | 0, 0, f | 0) | 0;
                a = f | a & ~e;
                b = H() | 0 | b;
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else break;
            }
            G(b | 0);
            return a | 0;
        }
        function Qb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            i = Od(a | 0, b | 0, 52) | 0;
            H();
            i = i & 15;
            if (!i) {
                h = b;
                i = a;
                G(h | 0);
                return i | 0;
            }
            h = 1;
            c = 0;
            while(true){
                f = (15 - h | 0) * 3 | 0;
                d = Pd(7, 0, f | 0) | 0;
                e = H() | 0;
                g = Od(a | 0, b | 0, f | 0) | 0;
                H();
                f = Pd(_a(g & 7) | 0, 0, f | 0) | 0;
                g = H() | 0;
                a = f | a & ~d;
                b = g | b & ~e;
                a: do if (!c) {
                    if (!((f & d | 0) == 0 & (g & e | 0) == 0)) {
                        d = Od(a | 0, b | 0, 52) | 0;
                        H();
                        d = d & 15;
                        if (!d) c = 1;
                        else {
                            c = 1;
                            b: while(true){
                                g = Od(a | 0, b | 0, (15 - c | 0) * 3 | 0) | 0;
                                H();
                                switch(g & 7){
                                    case 1:
                                        break b;
                                    case 0:
                                        break;
                                    default:
                                        c = 1;
                                        break a;
                                }
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break a;
                                }
                            }
                            c = 1;
                            while(true){
                                e = (15 - c | 0) * 3 | 0;
                                f = Pd(7, 0, e | 0) | 0;
                                g = b & ~(H() | 0);
                                b = Od(a | 0, b | 0, e | 0) | 0;
                                H();
                                b = Pd(_a(b & 7) | 0, 0, e | 0) | 0;
                                a = a & ~f | b;
                                b = g | (H() | 0);
                                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                                else {
                                    c = 1;
                                    break;
                                }
                            }
                        }
                    } else c = 0;
                }
                while (0);
                if (h >>> 0 < i >>> 0) h = h + 1 | 0;
                else break;
            }
            G(b | 0);
            return a | 0;
        }
        function Rb(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0;
            d = Od(a | 0, b | 0, 52) | 0;
            H();
            d = d & 15;
            if (!d) {
                c = b;
                d = a;
                G(c | 0);
                return d | 0;
            }
            c = 1;
            while(true){
                g = (15 - c | 0) * 3 | 0;
                f = Pd(7, 0, g | 0) | 0;
                e = b & ~(H() | 0);
                b = Od(a | 0, b | 0, g | 0) | 0;
                H();
                b = Pd(_a(b & 7) | 0, 0, g | 0) | 0;
                a = b | a & ~f;
                b = H() | 0 | e;
                if (c >>> 0 < d >>> 0) c = c + 1 | 0;
                else break;
            }
            G(b | 0);
            return a | 0;
        }
        function Sb(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            j = T;
            T = T + 64 | 0;
            i = j + 40 | 0;
            e = j + 24 | 0;
            f = j + 12 | 0;
            g = j;
            Pd(c | 0, 0, 52);
            d = H() | 134225919;
            if (!c) {
                if ((b[a + 4 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    G(h | 0);
                    T = j;
                    return i | 0;
                }
                if ((b[a + 8 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    G(h | 0);
                    T = j;
                    return i | 0;
                }
                if ((b[a + 12 >> 2] | 0) > 2) {
                    h = 0;
                    i = 0;
                    G(h | 0);
                    T = j;
                    return i | 0;
                }
                Pd(oa(a) | 0, 0, 45);
                h = H() | 0 | d;
                i = -1;
                G(h | 0);
                T = j;
                return i | 0;
            }
            b[i >> 2] = b[a >> 2];
            b[i + 4 >> 2] = b[a + 4 >> 2];
            b[i + 8 >> 2] = b[a + 8 >> 2];
            b[i + 12 >> 2] = b[a + 12 >> 2];
            h = i + 4 | 0;
            if ((c | 0) > 0) {
                a = -1;
                while(true){
                    b[e >> 2] = b[h >> 2];
                    b[e + 4 >> 2] = b[h + 4 >> 2];
                    b[e + 8 >> 2] = b[h + 8 >> 2];
                    if (!(c & 1)) {
                        Ta(h);
                        b[f >> 2] = b[h >> 2];
                        b[f + 4 >> 2] = b[h + 4 >> 2];
                        b[f + 8 >> 2] = b[h + 8 >> 2];
                        Va(f);
                    } else {
                        Sa(h);
                        b[f >> 2] = b[h >> 2];
                        b[f + 4 >> 2] = b[h + 4 >> 2];
                        b[f + 8 >> 2] = b[h + 8 >> 2];
                        Ua(f);
                    }
                    Na(e, f, g);
                    Ka(g);
                    l = (15 - c | 0) * 3 | 0;
                    k = Pd(7, 0, l | 0) | 0;
                    d = d & ~(H() | 0);
                    l = Pd(Pa(g) | 0, 0, l | 0) | 0;
                    a = l | a & ~k;
                    d = H() | 0 | d;
                    if ((c | 0) > 1) c = c + -1 | 0;
                    else break;
                }
            } else a = -1;
            a: do if (((b[h >> 2] | 0) <= 2 ? (b[i + 8 >> 2] | 0) <= 2 : 0) ? (b[i + 12 >> 2] | 0) <= 2 : 0) {
                e = oa(i) | 0;
                c = Pd(e | 0, 0, 45) | 0;
                c = c | a;
                a = H() | 0 | d & -1040385;
                g = pa(i) | 0;
                if (!(ma(e) | 0)) {
                    if ((g | 0) <= 0) break;
                    f = 0;
                    while(true){
                        e = Od(c | 0, a | 0, 52) | 0;
                        H();
                        e = e & 15;
                        if (e) {
                            d = 1;
                            while(true){
                                l = (15 - d | 0) * 3 | 0;
                                i = Od(c | 0, a | 0, l | 0) | 0;
                                H();
                                k = Pd(7, 0, l | 0) | 0;
                                a = a & ~(H() | 0);
                                l = Pd(Za(i & 7) | 0, 0, l | 0) | 0;
                                c = c & ~k | l;
                                a = a | (H() | 0);
                                if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                                else break;
                            }
                        }
                        f = f + 1 | 0;
                        if ((f | 0) == (g | 0)) break a;
                    }
                }
                f = Od(c | 0, a | 0, 52) | 0;
                H();
                f = f & 15;
                b: do if (f) {
                    d = 1;
                    c: while(true){
                        l = Od(c | 0, a | 0, (15 - d | 0) * 3 | 0) | 0;
                        H();
                        switch(l & 7){
                            case 1:
                                break c;
                            case 0:
                                break;
                            default:
                                break b;
                        }
                        if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                        else break b;
                    }
                    if (sa(e, b[i >> 2] | 0) | 0) {
                        d = 1;
                        while(true){
                            i = (15 - d | 0) * 3 | 0;
                            k = Pd(7, 0, i | 0) | 0;
                            l = a & ~(H() | 0);
                            a = Od(c | 0, a | 0, i | 0) | 0;
                            H();
                            a = Pd(_a(a & 7) | 0, 0, i | 0) | 0;
                            c = c & ~k | a;
                            a = l | (H() | 0);
                            if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                            else break;
                        }
                    } else {
                        d = 1;
                        while(true){
                            l = (15 - d | 0) * 3 | 0;
                            i = Od(c | 0, a | 0, l | 0) | 0;
                            H();
                            k = Pd(7, 0, l | 0) | 0;
                            a = a & ~(H() | 0);
                            l = Pd(Za(i & 7) | 0, 0, l | 0) | 0;
                            c = c & ~k | l;
                            a = a | (H() | 0);
                            if (d >>> 0 < f >>> 0) d = d + 1 | 0;
                            else break;
                        }
                    }
                }
                while (0);
                if ((g | 0) > 0) {
                    d = 0;
                    do {
                        c = Ob(c, a) | 0;
                        a = H() | 0;
                        d = d + 1 | 0;
                    }while ((d | 0) != (g | 0));
                }
            } else {
                c = 0;
                a = 0;
            }
            while (0);
            k = a;
            l = c;
            G(k | 0);
            T = j;
            return l | 0;
        }
        function Tb(a) {
            a = a | 0;
            return (a | 0) % 2 | 0;
        }
        function Ub(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            f = T;
            T = T + 16 | 0;
            e = f;
            if (c >>> 0 > 15) {
                e = 4;
                T = f;
                return e | 0;
            }
            if ((b[a + 4 >> 2] & 2146435072 | 0) == 2146435072) {
                e = 3;
                T = f;
                return e | 0;
            }
            if ((b[a + 8 + 4 >> 2] & 2146435072 | 0) == 2146435072) {
                e = 3;
                T = f;
                return e | 0;
            }
            ob(a, c, e);
            c = Sb(e, c) | 0;
            e = H() | 0;
            b[d >> 2] = c;
            b[d + 4 >> 2] = e;
            if ((c | 0) == 0 & (e | 0) == 0) I(27795, 27122, 959, 27145);
            e = 0;
            T = f;
            return e | 0;
        }
        function Vb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            f = d + 4 | 0;
            g = Od(a | 0, c | 0, 52) | 0;
            H();
            g = g & 15;
            h = Od(a | 0, c | 0, 45) | 0;
            H();
            e = (g | 0) == 0;
            if (!(ma(h & 127) | 0)) {
                if (e) {
                    h = 0;
                    return h | 0;
                }
                if ((b[f >> 2] | 0) == 0 ? (b[d + 8 >> 2] | 0) == 0 : 0) e = (b[d + 12 >> 2] | 0) != 0 & 1;
                else e = 1;
            } else if (e) {
                h = 1;
                return h | 0;
            } else e = 1;
            d = 1;
            while(true){
                if (!(d & 1)) Va(f);
                else Ua(f);
                h = Od(a | 0, c | 0, (15 - d | 0) * 3 | 0) | 0;
                H();
                Wa(f, h & 7);
                if (d >>> 0 < g >>> 0) d = d + 1 | 0;
                else break;
            }
            return e | 0;
        }
        function Wb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            l = T;
            T = T + 16 | 0;
            j = l;
            k = Od(a | 0, c | 0, 45) | 0;
            H();
            k = k & 127;
            if (k >>> 0 > 121) {
                b[d >> 2] = 0;
                b[d + 4 >> 2] = 0;
                b[d + 8 >> 2] = 0;
                b[d + 12 >> 2] = 0;
                k = 5;
                T = l;
                return k | 0;
            }
            a: do if ((ma(k) | 0) != 0 ? (g = Od(a | 0, c | 0, 52) | 0, H(), g = g & 15, (g | 0) != 0) : 0) {
                e = 1;
                b: while(true){
                    i = Od(a | 0, c | 0, (15 - e | 0) * 3 | 0) | 0;
                    H();
                    switch(i & 7){
                        case 5:
                            break b;
                        case 0:
                            break;
                        default:
                            e = c;
                            break a;
                    }
                    if (e >>> 0 < g >>> 0) e = e + 1 | 0;
                    else {
                        e = c;
                        break a;
                    }
                }
                f = 1;
                e = c;
                while(true){
                    c = (15 - f | 0) * 3 | 0;
                    h = Pd(7, 0, c | 0) | 0;
                    i = e & ~(H() | 0);
                    e = Od(a | 0, e | 0, c | 0) | 0;
                    H();
                    e = Pd(_a(e & 7) | 0, 0, c | 0) | 0;
                    a = a & ~h | e;
                    e = i | (H() | 0);
                    if (f >>> 0 < g >>> 0) f = f + 1 | 0;
                    else break;
                }
            } else e = c;
            while (0);
            i = 7696 + (k * 28 | 0) | 0;
            b[d >> 2] = b[i >> 2];
            b[d + 4 >> 2] = b[i + 4 >> 2];
            b[d + 8 >> 2] = b[i + 8 >> 2];
            b[d + 12 >> 2] = b[i + 12 >> 2];
            if (!(Vb(a, e, d) | 0)) {
                k = 0;
                T = l;
                return k | 0;
            }
            h = d + 4 | 0;
            b[j >> 2] = b[h >> 2];
            b[j + 4 >> 2] = b[h + 4 >> 2];
            b[j + 8 >> 2] = b[h + 8 >> 2];
            g = Od(a | 0, e | 0, 52) | 0;
            H();
            i = g & 15;
            if (!(g & 1)) g = i;
            else {
                Va(h);
                g = i + 1 | 0;
            }
            if (!(ma(k) | 0)) e = 0;
            else {
                c: do if (!i) e = 0;
                else {
                    c = 1;
                    while(true){
                        f = Od(a | 0, e | 0, (15 - c | 0) * 3 | 0) | 0;
                        H();
                        f = f & 7;
                        if (f | 0) {
                            e = f;
                            break c;
                        }
                        if (c >>> 0 < i >>> 0) c = c + 1 | 0;
                        else {
                            e = 0;
                            break;
                        }
                    }
                }
                while (0);
                e = (e | 0) == 4 & 1;
            }
            if (!(vb(d, g, e, 0) | 0)) {
                if ((g | 0) != (i | 0)) {
                    b[h >> 2] = b[j >> 2];
                    b[h + 4 >> 2] = b[j + 4 >> 2];
                    b[h + 8 >> 2] = b[j + 8 >> 2];
                }
            } else {
                if (ma(k) | 0) {
                    do ;
                    while ((vb(d, g, 0, 0) | 0) != 0);
                }
                if ((g | 0) != (i | 0)) Ta(h);
            }
            k = 0;
            T = l;
            return k | 0;
        }
        function Xb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0;
            f = T;
            T = T + 16 | 0;
            d = f;
            e = Wb(a, b, d) | 0;
            if (e | 0) {
                T = f;
                return e | 0;
            }
            e = Od(a | 0, b | 0, 52) | 0;
            H();
            sb(d, e & 15, c);
            e = 0;
            T = f;
            return e | 0;
        }
        function Yb(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            g = T;
            T = T + 16 | 0;
            f = g;
            d = Wb(a, b, f) | 0;
            if (d | 0) {
                f = d;
                T = g;
                return f | 0;
            }
            d = Od(a | 0, b | 0, 45) | 0;
            H();
            d = (ma(d & 127) | 0) == 0;
            e = Od(a | 0, b | 0, 52) | 0;
            H();
            e = e & 15;
            a: do if (!d) {
                if (e | 0) {
                    d = 1;
                    while(true){
                        h = Pd(7, 0, (15 - d | 0) * 3 | 0) | 0;
                        if (!((h & a | 0) == 0 & ((H() | 0) & b | 0) == 0)) break a;
                        if (d >>> 0 < e >>> 0) d = d + 1 | 0;
                        else break;
                    }
                }
                tb(f, e, 0, 5, c);
                h = 0;
                T = g;
                return h | 0;
            }
            while (0);
            xb(f, e, 0, 6, c);
            h = 0;
            T = g;
            return h | 0;
        }
        function Zb(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            f = Od(a | 0, c | 0, 45) | 0;
            H();
            if (!(ma(f & 127) | 0)) {
                f = 2;
                b[d >> 2] = f;
                return 0;
            }
            f = Od(a | 0, c | 0, 52) | 0;
            H();
            f = f & 15;
            if (!f) {
                f = 5;
                b[d >> 2] = f;
                return 0;
            }
            e = 1;
            while(true){
                g = Pd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                if (!((g & a | 0) == 0 & ((H() | 0) & c | 0) == 0)) {
                    e = 2;
                    a = 6;
                    break;
                }
                if (e >>> 0 < f >>> 0) e = e + 1 | 0;
                else {
                    e = 5;
                    a = 6;
                    break;
                }
            }
            if ((a | 0) == 6) {
                b[d >> 2] = e;
                return 0;
            }
            return 0;
        }
        function _b(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            m = T;
            T = T + 128 | 0;
            k = m + 112 | 0;
            g = m + 96 | 0;
            l = m;
            f = Od(a | 0, c | 0, 52) | 0;
            H();
            i = f & 15;
            b[k >> 2] = i;
            h = Od(a | 0, c | 0, 45) | 0;
            H();
            h = h & 127;
            a: do if (ma(h) | 0) {
                if (i | 0) {
                    e = 1;
                    while(true){
                        j = Pd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        if (!((j & a | 0) == 0 & ((H() | 0) & c | 0) == 0)) {
                            f = 0;
                            break a;
                        }
                        if (e >>> 0 < i >>> 0) e = e + 1 | 0;
                        else break;
                    }
                }
                if (!(f & 1)) {
                    j = Pd(i + 1 | 0, 0, 52) | 0;
                    l = H() | 0 | c & -15728641;
                    k = Pd(7, 0, (14 - i | 0) * 3 | 0) | 0;
                    l = _b((j | a) & ~k, l & ~(H() | 0), d) | 0;
                    T = m;
                    return l | 0;
                } else f = 1;
            } else f = 0;
            while (0);
            e = Wb(a, c, g) | 0;
            if (!e) {
                if (f) {
                    ub(g, k, l);
                    j = 5;
                } else {
                    yb(g, k, l);
                    j = 6;
                }
                b: do if (ma(h) | 0) {
                    if (!i) a = 5;
                    else {
                        e = 1;
                        while(true){
                            h = Pd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                            if (!((h & a | 0) == 0 & ((H() | 0) & c | 0) == 0)) {
                                a = 2;
                                break b;
                            }
                            if (e >>> 0 < i >>> 0) e = e + 1 | 0;
                            else {
                                a = 5;
                                break;
                            }
                        }
                    }
                } else a = 2;
                while (0);
                Vd(d | 0, -1, a << 2 | 0);
                c: do if (f) {
                    g = 0;
                    while(true){
                        h = l + (g << 4) | 0;
                        wb(h, b[k >> 2] | 0);
                        h = b[h >> 2] | 0;
                        i = b[d >> 2] | 0;
                        if ((i | 0) == -1 | (i | 0) == (h | 0)) e = d;
                        else {
                            f = 0;
                            do {
                                f = f + 1 | 0;
                                if (f >>> 0 >= a >>> 0) {
                                    e = 1;
                                    break c;
                                }
                                e = d + (f << 2) | 0;
                                i = b[e >> 2] | 0;
                            }while (!((i | 0) == -1 | (i | 0) == (h | 0)));
                        }
                        b[e >> 2] = h;
                        g = g + 1 | 0;
                        if (g >>> 0 >= j >>> 0) {
                            e = 0;
                            break;
                        }
                    }
                } else {
                    g = 0;
                    while(true){
                        h = l + (g << 4) | 0;
                        vb(h, b[k >> 2] | 0, 0, 1);
                        h = b[h >> 2] | 0;
                        i = b[d >> 2] | 0;
                        if ((i | 0) == -1 | (i | 0) == (h | 0)) e = d;
                        else {
                            f = 0;
                            do {
                                f = f + 1 | 0;
                                if (f >>> 0 >= a >>> 0) {
                                    e = 1;
                                    break c;
                                }
                                e = d + (f << 2) | 0;
                                i = b[e >> 2] | 0;
                            }while (!((i | 0) == -1 | (i | 0) == (h | 0)));
                        }
                        b[e >> 2] = h;
                        g = g + 1 | 0;
                        if (g >>> 0 >= j >>> 0) {
                            e = 0;
                            break;
                        }
                    }
                }
                while (0);
            }
            l = e;
            T = m;
            return l | 0;
        }
        function $b() {
            return 12;
        }
        function ac(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            if (a >>> 0 > 15) {
                i = 4;
                return i | 0;
            }
            Pd(a | 0, 0, 52);
            i = H() | 134225919;
            if (!a) {
                d = 0;
                e = 0;
                do {
                    if (ma(e) | 0) {
                        Pd(e | 0, 0, 45);
                        h = i | (H() | 0);
                        a = c + (d << 3) | 0;
                        b[a >> 2] = -1;
                        b[a + 4 >> 2] = h;
                        d = d + 1 | 0;
                    }
                    e = e + 1 | 0;
                }while ((e | 0) != 122);
                d = 0;
                return d | 0;
            }
            d = 0;
            h = 0;
            do {
                if (ma(h) | 0) {
                    Pd(h | 0, 0, 45);
                    e = 1;
                    f = -1;
                    g = i | (H() | 0);
                    while(true){
                        j = Pd(7, 0, (15 - e | 0) * 3 | 0) | 0;
                        f = f & ~j;
                        g = g & ~(H() | 0);
                        if ((e | 0) == (a | 0)) break;
                        else e = e + 1 | 0;
                    }
                    j = c + (d << 3) | 0;
                    b[j >> 2] = f;
                    b[j + 4 >> 2] = g;
                    d = d + 1 | 0;
                }
                h = h + 1 | 0;
            }while ((h | 0) != 122);
            d = 0;
            return d | 0;
        }
        function bc(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
            t = T;
            T = T + 16 | 0;
            r = t;
            s = Od(a | 0, c | 0, 52) | 0;
            H();
            s = s & 15;
            if (d >>> 0 > 15) {
                s = 4;
                T = t;
                return s | 0;
            }
            if ((s | 0) < (d | 0)) {
                s = 12;
                T = t;
                return s | 0;
            }
            if ((s | 0) != (d | 0)) {
                g = Pd(d | 0, 0, 52) | 0;
                g = g | a;
                i = H() | 0 | c & -15728641;
                if ((s | 0) > (d | 0)) {
                    j = d;
                    do {
                        q = Pd(7, 0, (14 - j | 0) * 3 | 0) | 0;
                        j = j + 1 | 0;
                        g = q | g;
                        i = H() | 0 | i;
                    }while ((j | 0) < (s | 0));
                    q = g;
                } else q = g;
            } else {
                q = a;
                i = c;
            }
            p = Od(q | 0, i | 0, 45) | 0;
            H();
            a: do if (ma(p & 127) | 0) {
                j = Od(q | 0, i | 0, 52) | 0;
                H();
                j = j & 15;
                if (j | 0) {
                    g = 1;
                    while(true){
                        p = Pd(7, 0, (15 - g | 0) * 3 | 0) | 0;
                        if (!((p & q | 0) == 0 & ((H() | 0) & i | 0) == 0)) {
                            k = 33;
                            break a;
                        }
                        if (g >>> 0 < j >>> 0) g = g + 1 | 0;
                        else break;
                    }
                }
                p = e;
                b[p >> 2] = 0;
                b[p + 4 >> 2] = 0;
                if ((s | 0) > (d | 0)) {
                    p = c & -15728641;
                    o = s;
                    while(true){
                        n = o;
                        o = o + -1 | 0;
                        if (o >>> 0 > 15 | (s | 0) < (o | 0)) {
                            k = 19;
                            break;
                        }
                        if ((s | 0) != (o | 0)) {
                            g = Pd(o | 0, 0, 52) | 0;
                            g = g | a;
                            j = H() | 0 | p;
                            if ((s | 0) < (n | 0)) m = g;
                            else {
                                k = o;
                                do {
                                    m = Pd(7, 0, (14 - k | 0) * 3 | 0) | 0;
                                    k = k + 1 | 0;
                                    g = m | g;
                                    j = H() | 0 | j;
                                }while ((k | 0) < (s | 0));
                                m = g;
                            }
                        } else {
                            m = a;
                            j = c;
                        }
                        l = Od(m | 0, j | 0, 45) | 0;
                        H();
                        if (!(ma(l & 127) | 0)) g = 0;
                        else {
                            l = Od(m | 0, j | 0, 52) | 0;
                            H();
                            l = l & 15;
                            b: do if (!l) g = 0;
                            else {
                                k = 1;
                                while(true){
                                    g = Od(m | 0, j | 0, (15 - k | 0) * 3 | 0) | 0;
                                    H();
                                    g = g & 7;
                                    if (g | 0) break b;
                                    if (k >>> 0 < l >>> 0) k = k + 1 | 0;
                                    else {
                                        g = 0;
                                        break;
                                    }
                                }
                            }
                            while (0);
                            g = (g | 0) == 0 & 1;
                        }
                        j = Od(a | 0, c | 0, (15 - n | 0) * 3 | 0) | 0;
                        H();
                        j = j & 7;
                        if ((j | 0) == 7) {
                            f = 5;
                            k = 42;
                            break;
                        }
                        g = (g | 0) != 0;
                        if ((j | 0) == 1 & g) {
                            f = 5;
                            k = 42;
                            break;
                        }
                        m = j + (((j | 0) != 0 & g) << 31 >> 31) | 0;
                        if (m | 0) {
                            k = s - n | 0;
                            k = Mc(7, 0, k, ((k | 0) < 0) << 31 >> 31) | 0;
                            l = H() | 0;
                            if (g) {
                                g = Kd(k | 0, l | 0, 5, 0) | 0;
                                g = Ed(g | 0, H() | 0, -5, -1) | 0;
                                g = Id(g | 0, H() | 0, 6, 0) | 0;
                                g = Ed(g | 0, H() | 0, 1, 0) | 0;
                                j = H() | 0;
                            } else {
                                g = k;
                                j = l;
                            }
                            n = m + -1 | 0;
                            n = Kd(k | 0, l | 0, n | 0, ((n | 0) < 0) << 31 >> 31 | 0) | 0;
                            n = Ed(g | 0, j | 0, n | 0, H() | 0) | 0;
                            m = H() | 0;
                            l = e;
                            l = Ed(n | 0, m | 0, b[l >> 2] | 0, b[l + 4 >> 2] | 0) | 0;
                            m = H() | 0;
                            n = e;
                            b[n >> 2] = l;
                            b[n + 4 >> 2] = m;
                        }
                        if ((o | 0) <= (d | 0)) {
                            k = 37;
                            break;
                        }
                    }
                    if ((k | 0) == 19) I(27795, 27122, 1276, 27158);
                    else if ((k | 0) == 37) {
                        h = e;
                        f = b[h + 4 >> 2] | 0;
                        h = b[h >> 2] | 0;
                        break;
                    } else if ((k | 0) == 42) {
                        T = t;
                        return f | 0;
                    }
                } else {
                    f = 0;
                    h = 0;
                }
            } else k = 33;
            while (0);
            c: do if ((k | 0) == 33) {
                p = e;
                b[p >> 2] = 0;
                b[p + 4 >> 2] = 0;
                if ((s | 0) > (d | 0)) {
                    g = s;
                    while(true){
                        f = Od(a | 0, c | 0, (15 - g | 0) * 3 | 0) | 0;
                        H();
                        f = f & 7;
                        if ((f | 0) == 7) {
                            f = 5;
                            break;
                        }
                        h = s - g | 0;
                        h = Mc(7, 0, h, ((h | 0) < 0) << 31 >> 31) | 0;
                        f = Kd(h | 0, H() | 0, f | 0, 0) | 0;
                        h = H() | 0;
                        p = e;
                        h = Ed(b[p >> 2] | 0, b[p + 4 >> 2] | 0, f | 0, h | 0) | 0;
                        f = H() | 0;
                        p = e;
                        b[p >> 2] = h;
                        b[p + 4 >> 2] = f;
                        g = g + -1 | 0;
                        if ((g | 0) <= (d | 0)) break c;
                    }
                    T = t;
                    return f | 0;
                } else {
                    f = 0;
                    h = 0;
                }
            }
            while (0);
            if (Eb(q, i, s, r) | 0) I(27795, 27122, 1236, 27173);
            s = r;
            r = b[s + 4 >> 2] | 0;
            if (((f | 0) > -1 | (f | 0) == -1 & h >>> 0 > 4294967295) & ((r | 0) > (f | 0) | ((r | 0) == (f | 0) ? (b[s >> 2] | 0) >>> 0 > h >>> 0 : 0))) {
                s = 0;
                T = t;
                return s | 0;
            } else I(27795, 27122, 1316, 27158);
            return 0;
        }
        function cc(a, c, d, e, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0;
            m = T;
            T = T + 16 | 0;
            h = m;
            if (f >>> 0 > 15) {
                g = 4;
                T = m;
                return g | 0;
            }
            i = Od(d | 0, e | 0, 52) | 0;
            H();
            i = i & 15;
            if ((i | 0) > (f | 0)) {
                g = 12;
                T = m;
                return g | 0;
            }
            if (Eb(d, e, f, h) | 0) I(27795, 27122, 1236, 27173);
            l = h;
            k = b[l + 4 >> 2] | 0;
            if (!(((c | 0) > -1 | (c | 0) == -1 & a >>> 0 > 4294967295) & ((k | 0) > (c | 0) | ((k | 0) == (c | 0) ? (b[l >> 2] | 0) >>> 0 > a >>> 0 : 0)))) {
                g = 2;
                T = m;
                return g | 0;
            }
            l = f - i | 0;
            f = Pd(f | 0, 0, 52) | 0;
            j = H() | 0 | e & -15728641;
            k = g;
            b[k >> 2] = f | d;
            b[k + 4 >> 2] = j;
            k = Od(d | 0, e | 0, 45) | 0;
            H();
            a: do if (ma(k & 127) | 0) {
                if (i | 0) {
                    h = 1;
                    while(true){
                        k = Pd(7, 0, (15 - h | 0) * 3 | 0) | 0;
                        if (!((k & d | 0) == 0 & ((H() | 0) & e | 0) == 0)) break a;
                        if (h >>> 0 < i >>> 0) h = h + 1 | 0;
                        else break;
                    }
                }
                if ((l | 0) < 1) {
                    g = 0;
                    T = m;
                    return g | 0;
                }
                k = i ^ 15;
                e = -1;
                j = 1;
                h = 1;
                while(true){
                    i = l - j | 0;
                    i = Mc(7, 0, i, ((i | 0) < 0) << 31 >> 31) | 0;
                    d = H() | 0;
                    do if (h) {
                        h = Kd(i | 0, d | 0, 5, 0) | 0;
                        h = Ed(h | 0, H() | 0, -5, -1) | 0;
                        h = Id(h | 0, H() | 0, 6, 0) | 0;
                        f = H() | 0;
                        if ((c | 0) > (f | 0) | (c | 0) == (f | 0) & a >>> 0 > h >>> 0) {
                            c = Ed(a | 0, c | 0, -1, -1) | 0;
                            c = Fd(c | 0, H() | 0, h | 0, f | 0) | 0;
                            h = H() | 0;
                            n = g;
                            p = b[n >> 2] | 0;
                            n = b[n + 4 >> 2] | 0;
                            q = (k + e | 0) * 3 | 0;
                            o = Pd(7, 0, q | 0) | 0;
                            n = n & ~(H() | 0);
                            e = Id(c | 0, h | 0, i | 0, d | 0) | 0;
                            a = H() | 0;
                            f = Ed(e | 0, a | 0, 2, 0) | 0;
                            q = Pd(f | 0, H() | 0, q | 0) | 0;
                            n = H() | 0 | n;
                            f = g;
                            b[f >> 2] = q | p & ~o;
                            b[f + 4 >> 2] = n;
                            a = Kd(e | 0, a | 0, i | 0, d | 0) | 0;
                            a = Fd(c | 0, h | 0, a | 0, H() | 0) | 0;
                            h = 0;
                            c = H() | 0;
                            break;
                        } else {
                            q = g;
                            o = b[q >> 2] | 0;
                            q = b[q + 4 >> 2] | 0;
                            p = Pd(7, 0, (k + e | 0) * 3 | 0) | 0;
                            q = q & ~(H() | 0);
                            h = g;
                            b[h >> 2] = o & ~p;
                            b[h + 4 >> 2] = q;
                            h = 1;
                            break;
                        }
                    } else {
                        o = g;
                        f = b[o >> 2] | 0;
                        o = b[o + 4 >> 2] | 0;
                        e = (k + e | 0) * 3 | 0;
                        n = Pd(7, 0, e | 0) | 0;
                        o = o & ~(H() | 0);
                        q = Id(a | 0, c | 0, i | 0, d | 0) | 0;
                        h = H() | 0;
                        e = Pd(q | 0, h | 0, e | 0) | 0;
                        o = H() | 0 | o;
                        p = g;
                        b[p >> 2] = e | f & ~n;
                        b[p + 4 >> 2] = o;
                        h = Kd(q | 0, h | 0, i | 0, d | 0) | 0;
                        a = Fd(a | 0, c | 0, h | 0, H() | 0) | 0;
                        h = 0;
                        c = H() | 0;
                    }
                    while (0);
                    if ((l | 0) > (j | 0)) {
                        e = ~j;
                        j = j + 1 | 0;
                    } else {
                        c = 0;
                        break;
                    }
                }
                T = m;
                return c | 0;
            }
            while (0);
            if ((l | 0) < 1) {
                q = 0;
                T = m;
                return q | 0;
            }
            f = i ^ 15;
            h = 1;
            while(true){
                p = l - h | 0;
                p = Mc(7, 0, p, ((p | 0) < 0) << 31 >> 31) | 0;
                q = H() | 0;
                j = g;
                d = b[j >> 2] | 0;
                j = b[j + 4 >> 2] | 0;
                i = (f - h | 0) * 3 | 0;
                e = Pd(7, 0, i | 0) | 0;
                j = j & ~(H() | 0);
                n = Id(a | 0, c | 0, p | 0, q | 0) | 0;
                o = H() | 0;
                i = Pd(n | 0, o | 0, i | 0) | 0;
                j = H() | 0 | j;
                k = g;
                b[k >> 2] = i | d & ~e;
                b[k + 4 >> 2] = j;
                q = Kd(n | 0, o | 0, p | 0, q | 0) | 0;
                a = Fd(a | 0, c | 0, q | 0, H() | 0) | 0;
                c = H() | 0;
                if ((l | 0) <= (h | 0)) {
                    c = 0;
                    break;
                } else h = h + 1 | 0;
            }
            T = m;
            return c | 0;
        }
        function dc(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0;
            f = Od(c | 0, d | 0, 52) | 0;
            H();
            f = f & 15;
            if ((c | 0) == 0 & (d | 0) == 0 | ((e | 0) > 15 | (f | 0) > (e | 0))) {
                g = -1;
                c = -1;
                d = 0;
                f = 0;
            } else {
                c = Hb(c, d, f + 1 | 0, e) | 0;
                h = (H() | 0) & -15728641;
                d = Pd(e | 0, 0, 52) | 0;
                d = c | d;
                h = h | (H() | 0);
                c = (Fb(d, h) | 0) == 0;
                g = f;
                c = c ? -1 : e;
                f = h;
            }
            h = a;
            b[h >> 2] = d;
            b[h + 4 >> 2] = f;
            b[a + 8 >> 2] = g;
            b[a + 12 >> 2] = c;
            return;
        }
        function ec(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            f = Od(a | 0, c | 0, 52) | 0;
            H();
            f = f & 15;
            g = e + 8 | 0;
            b[g >> 2] = f;
            if ((a | 0) == 0 & (c | 0) == 0 | ((d | 0) > 15 | (f | 0) > (d | 0))) {
                d = e;
                b[d >> 2] = 0;
                b[d + 4 >> 2] = 0;
                b[g >> 2] = -1;
                b[e + 12 >> 2] = -1;
                return;
            }
            a = Hb(a, c, f + 1 | 0, d) | 0;
            g = (H() | 0) & -15728641;
            f = Pd(d | 0, 0, 52) | 0;
            f = a | f;
            g = g | (H() | 0);
            a = e;
            b[a >> 2] = f;
            b[a + 4 >> 2] = g;
            a = e + 12 | 0;
            if (!(Fb(f, g) | 0)) {
                b[a >> 2] = -1;
                return;
            } else {
                b[a >> 2] = d;
                return;
            }
        }
        function fc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            d = a;
            c = b[d >> 2] | 0;
            d = b[d + 4 >> 2] | 0;
            if ((c | 0) == 0 & (d | 0) == 0) return;
            e = Od(c | 0, d | 0, 52) | 0;
            H();
            e = e & 15;
            i = Pd(1, 0, (e ^ 15) * 3 | 0) | 0;
            c = Ed(i | 0, H() | 0, c | 0, d | 0) | 0;
            d = H() | 0;
            i = a;
            b[i >> 2] = c;
            b[i + 4 >> 2] = d;
            i = a + 8 | 0;
            h = b[i >> 2] | 0;
            if ((e | 0) < (h | 0)) return;
            j = a + 12 | 0;
            g = e;
            while(true){
                if ((g | 0) == (h | 0)) {
                    e = 5;
                    break;
                }
                k = (g | 0) == (b[j >> 2] | 0);
                f = (15 - g | 0) * 3 | 0;
                e = Od(c | 0, d | 0, f | 0) | 0;
                H();
                e = e & 7;
                if (k & ((e | 0) == 1 & true)) {
                    e = 7;
                    break;
                }
                if (!((e | 0) == 7 & true)) {
                    e = 10;
                    break;
                }
                k = Pd(1, 0, f | 0) | 0;
                c = Ed(c | 0, d | 0, k | 0, H() | 0) | 0;
                d = H() | 0;
                k = a;
                b[k >> 2] = c;
                b[k + 4 >> 2] = d;
                if ((g | 0) > (h | 0)) g = g + -1 | 0;
                else {
                    e = 10;
                    break;
                }
            }
            if ((e | 0) == 5) {
                k = a;
                b[k >> 2] = 0;
                b[k + 4 >> 2] = 0;
                b[i >> 2] = -1;
                b[j >> 2] = -1;
                return;
            } else if ((e | 0) == 7) {
                h = Pd(1, 0, f | 0) | 0;
                h = Ed(c | 0, d | 0, h | 0, H() | 0) | 0;
                i = H() | 0;
                k = a;
                b[k >> 2] = h;
                b[k + 4 >> 2] = i;
                b[j >> 2] = g + -1;
                return;
            } else if ((e | 0) == 10) return;
        }
        function gc(a) {
            a = +a;
            var b = 0.0;
            b = a < 0.0 ? a + 6.283185307179586 : a;
            return +(!(a >= 6.283185307179586) ? b : b + -6.283185307179586);
        }
        function hc(a, b) {
            a = a | 0;
            b = b | 0;
            if (!(+q(+(+e[a >> 3] - +e[b >> 3])) < 1.7453292519943298e-11)) {
                b = 0;
                return b | 0;
            }
            b = +q(+(+e[a + 8 >> 3] - +e[b + 8 >> 3])) < 1.7453292519943298e-11;
            return b | 0;
        }
        function ic(a, b) {
            a = +a;
            b = b | 0;
            switch(b | 0){
                case 1:
                    a = a < 0.0 ? a + 6.283185307179586 : a;
                    break;
                case 2:
                    a = a > 0.0 ? a + -6.283185307179586 : a;
                    break;
                default:
            }
            return +a;
        }
        function jc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 2.0);
        }
        function kc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 12742.01436183695);
        }
        function lc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0;
            f = +e[b >> 3];
            d = +e[a >> 3];
            g = +u(+((f - d) * .5));
            c = +u(+((+e[b + 8 >> 3] - +e[a + 8 >> 3]) * .5));
            c = g * g + c * (+t(+f) * +t(+d) * c);
            return +(+z(+ +r(+c), + +r(+(1.0 - c))) * 12742014.36183695);
        }
        function mc(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0, g = 0.0, h = 0.0;
            g = +e[b >> 3];
            d = +t(+g);
            f = +e[b + 8 >> 3] - +e[a + 8 >> 3];
            h = d * +u(+f);
            c = +e[a >> 3];
            return + +z(+h, +(+u(+g) * +t(+c) - +t(+f) * (d * +u(+c))));
        }
        function nc(a, c, d, f) {
            a = a | 0;
            c = +c;
            d = +d;
            f = f | 0;
            var g = 0, h = 0.0, i = 0.0, j = 0.0;
            if (d < 1.0e-16) {
                b[f >> 2] = b[a >> 2];
                b[f + 4 >> 2] = b[a + 4 >> 2];
                b[f + 8 >> 2] = b[a + 8 >> 2];
                b[f + 12 >> 2] = b[a + 12 >> 2];
                return;
            }
            h = c < 0.0 ? c + 6.283185307179586 : c;
            h = !(c >= 6.283185307179586) ? h : h + -6.283185307179586;
            do if (h < 1.0e-16) {
                c = +e[a >> 3] + d;
                e[f >> 3] = c;
                g = f;
            } else {
                g = +q(+(h + -3.141592653589793)) < 1.0e-16;
                c = +e[a >> 3];
                if (g) {
                    c = c - d;
                    e[f >> 3] = c;
                    g = f;
                    break;
                }
                i = +t(+d);
                d = +u(+d);
                c = i * +u(+c) + +t(+h) * (d * +t(+c));
                c = c > 1.0 ? 1.0 : c;
                c = +x(+(c < -1 ? -1 : c));
                e[f >> 3] = c;
                if (+q(+(c + -1.5707963267948966)) < 1.0e-16) {
                    e[f >> 3] = 1.5707963267948966;
                    e[f + 8 >> 3] = 0.0;
                    return;
                }
                if (+q(+(c + 1.5707963267948966)) < 1.0e-16) {
                    e[f >> 3] = -1.5707963267948966;
                    e[f + 8 >> 3] = 0.0;
                    return;
                }
                j = 1.0 / +t(+c);
                h = d * +u(+h) * j;
                d = +e[a >> 3];
                c = j * ((i - +u(+c) * +u(+d)) / +t(+d));
                i = h > 1.0 ? 1.0 : h;
                c = c > 1.0 ? 1.0 : c;
                c = +e[a + 8 >> 3] + +z(+(i < -1 ? -1 : i), +(c < -1 ? -1 : c));
                if (c > 3.141592653589793) do c = c + -6.283185307179586;
                while (c > 3.141592653589793);
                if (c < -3.141592653589793) do c = c + 6.283185307179586;
                while (c < -3.141592653589793);
                e[f + 8 >> 3] = c;
                return;
            }
            while (0);
            if (+q(+(c + -1.5707963267948966)) < 1.0e-16) {
                e[g >> 3] = 1.5707963267948966;
                e[f + 8 >> 3] = 0.0;
                return;
            }
            if (+q(+(c + 1.5707963267948966)) < 1.0e-16) {
                e[g >> 3] = -1.5707963267948966;
                e[f + 8 >> 3] = 0.0;
                return;
            }
            c = +e[a + 8 >> 3];
            if (c > 3.141592653589793) do c = c + -6.283185307179586;
            while (c > 3.141592653589793);
            if (c < -3.141592653589793) do c = c + 6.283185307179586;
            while (c < -3.141592653589793);
            e[f + 8 >> 3] = c;
            return;
        }
        function oc(a, b) {
            a = a | 0;
            b = b | 0;
            if (a >>> 0 > 15) {
                b = 4;
                return b | 0;
            }
            e[b >> 3] = +e[20656 + (a << 3) >> 3];
            b = 0;
            return b | 0;
        }
        function pc(a, b) {
            a = a | 0;
            b = b | 0;
            if (a >>> 0 > 15) {
                b = 4;
                return b | 0;
            }
            e[b >> 3] = +e[20784 + (a << 3) >> 3];
            b = 0;
            return b | 0;
        }
        function qc(a, b) {
            a = a | 0;
            b = b | 0;
            if (a >>> 0 > 15) {
                b = 4;
                return b | 0;
            }
            e[b >> 3] = +e[20912 + (a << 3) >> 3];
            b = 0;
            return b | 0;
        }
        function rc(a, b) {
            a = a | 0;
            b = b | 0;
            if (a >>> 0 > 15) {
                b = 4;
                return b | 0;
            }
            e[b >> 3] = +e[21040 + (a << 3) >> 3];
            b = 0;
            return b | 0;
        }
        function sc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            if (a >>> 0 > 15) {
                c = 4;
                return c | 0;
            }
            d = Mc(7, 0, a, ((a | 0) < 0) << 31 >> 31) | 0;
            d = Kd(d | 0, H() | 0, 120, 0) | 0;
            a = H() | 0;
            b[c >> 2] = d | 2;
            b[c + 4 >> 2] = a;
            c = 0;
            return c | 0;
        }
        function tc(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0;
            n = +e[b >> 3];
            l = +e[a >> 3];
            j = +u(+((n - l) * .5));
            g = +e[b + 8 >> 3];
            k = +e[a + 8 >> 3];
            h = +u(+((g - k) * .5));
            i = +t(+l);
            m = +t(+n);
            h = j * j + h * (m * i * h);
            h = +z(+ +r(+h), + +r(+(1.0 - h))) * 2.0;
            j = +e[c >> 3];
            n = +u(+((j - n) * .5));
            d = +e[c + 8 >> 3];
            g = +u(+((d - g) * .5));
            f = +t(+j);
            g = n * n + g * (m * f * g);
            g = +z(+ +r(+g), + +r(+(1.0 - g))) * 2.0;
            j = +u(+((l - j) * .5));
            d = +u(+((k - d) * .5));
            d = j * j + d * (i * f * d);
            d = +z(+ +r(+d), + +r(+(1.0 - d))) * 2.0;
            f = (h + g + d) * .5;
            return +(+y(+ +r(+(+v(+(f * .5)) * +v(+((f - h) * .5)) * +v(+((f - g) * .5)) * +v(+((f - d) * .5))))) * 4.0);
        }
        function uc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0, h = 0, i = 0, j = 0;
            j = T;
            T = T + 192 | 0;
            h = j + 168 | 0;
            i = j;
            g = Xb(a, c, h) | 0;
            if (g | 0) {
                d = g;
                T = j;
                return d | 0;
            }
            if (Yb(a, c, i) | 0) I(27795, 27190, 415, 27199);
            c = b[i >> 2] | 0;
            if ((c | 0) > 0) {
                f = +tc(i + 8 | 0, i + 8 + (((c | 0) != 1 & 1) << 4) | 0, h) + 0.0;
                if ((c | 0) != 1) {
                    a = 1;
                    do {
                        g = a;
                        a = a + 1 | 0;
                        f = f + +tc(i + 8 + (g << 4) | 0, i + 8 + (((a | 0) % (c | 0) | 0) << 4) | 0, h);
                    }while ((a | 0) < (c | 0));
                }
            } else f = 0.0;
            e[d >> 3] = f;
            d = 0;
            T = j;
            return d | 0;
        }
        function vc(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            a = uc(a, b, c) | 0;
            if (a | 0) return a | 0;
            e[c >> 3] = +e[c >> 3] * 40589732.49931477;
            return a | 0;
        }
        function wc(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            a = uc(a, b, c) | 0;
            if (a | 0) return a | 0;
            e[c >> 3] = +e[c >> 3] * 40589732499314.77;
            return a | 0;
        }
        function xc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0, j = 0, k = 0.0, l = 0.0, m = 0.0;
            j = T;
            T = T + 176 | 0;
            i = j;
            a = nb(a, c, i) | 0;
            if (a | 0) {
                i = a;
                T = j;
                return i | 0;
            }
            e[d >> 3] = 0.0;
            a = b[i >> 2] | 0;
            if ((a | 0) <= 1) {
                i = 0;
                T = j;
                return i | 0;
            }
            c = a + -1 | 0;
            a = 0;
            f = +e[i + 8 >> 3];
            g = +e[i + 16 >> 3];
            h = 0.0;
            do {
                a = a + 1 | 0;
                l = f;
                f = +e[i + 8 + (a << 4) >> 3];
                m = +u(+((f - l) * .5));
                k = g;
                g = +e[i + 8 + (a << 4) + 8 >> 3];
                k = +u(+((g - k) * .5));
                k = m * m + k * (+t(+f) * +t(+l) * k);
                h = h + +z(+ +r(+k), + +r(+(1.0 - k))) * 2.0;
            }while ((a | 0) < (c | 0));
            e[d >> 3] = h;
            i = 0;
            T = j;
            return i | 0;
        }
        function yc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0, j = 0, k = 0.0, l = 0.0, m = 0.0;
            j = T;
            T = T + 176 | 0;
            i = j;
            a = nb(a, c, i) | 0;
            if (a | 0) {
                i = a;
                h = +e[d >> 3];
                h = h * 6371.007180918475;
                e[d >> 3] = h;
                T = j;
                return i | 0;
            }
            e[d >> 3] = 0.0;
            a = b[i >> 2] | 0;
            if ((a | 0) <= 1) {
                i = 0;
                h = 0.0;
                h = h * 6371.007180918475;
                e[d >> 3] = h;
                T = j;
                return i | 0;
            }
            c = a + -1 | 0;
            a = 0;
            f = +e[i + 8 >> 3];
            g = +e[i + 16 >> 3];
            h = 0.0;
            do {
                a = a + 1 | 0;
                l = f;
                f = +e[i + 8 + (a << 4) >> 3];
                m = +u(+((f - l) * .5));
                k = g;
                g = +e[i + 8 + (a << 4) + 8 >> 3];
                k = +u(+((g - k) * .5));
                k = m * m + k * (+t(+l) * +t(+f) * k);
                h = h + +z(+ +r(+k), + +r(+(1.0 - k))) * 2.0;
            }while ((a | 0) != (c | 0));
            e[d >> 3] = h;
            i = 0;
            m = h;
            m = m * 6371.007180918475;
            e[d >> 3] = m;
            T = j;
            return i | 0;
        }
        function zc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0, j = 0, k = 0.0, l = 0.0, m = 0.0;
            j = T;
            T = T + 176 | 0;
            i = j;
            a = nb(a, c, i) | 0;
            if (a | 0) {
                i = a;
                h = +e[d >> 3];
                h = h * 6371.007180918475;
                h = h * 1.0e3;
                e[d >> 3] = h;
                T = j;
                return i | 0;
            }
            e[d >> 3] = 0.0;
            a = b[i >> 2] | 0;
            if ((a | 0) <= 1) {
                i = 0;
                h = 0.0;
                h = h * 6371.007180918475;
                h = h * 1.0e3;
                e[d >> 3] = h;
                T = j;
                return i | 0;
            }
            c = a + -1 | 0;
            a = 0;
            f = +e[i + 8 >> 3];
            g = +e[i + 16 >> 3];
            h = 0.0;
            do {
                a = a + 1 | 0;
                l = f;
                f = +e[i + 8 + (a << 4) >> 3];
                m = +u(+((f - l) * .5));
                k = g;
                g = +e[i + 8 + (a << 4) + 8 >> 3];
                k = +u(+((g - k) * .5));
                k = m * m + k * (+t(+l) * +t(+f) * k);
                h = h + +z(+ +r(+k), + +r(+(1.0 - k))) * 2.0;
            }while ((a | 0) != (c | 0));
            e[d >> 3] = h;
            i = 0;
            m = h;
            m = m * 6371.007180918475;
            m = m * 1.0e3;
            e[d >> 3] = m;
            T = j;
            return i | 0;
        }
        function Ac(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            c = Dd(1, 12) | 0;
            if (!c) I(27280, 27235, 49, 27293);
            d = a + 4 | 0;
            e = b[d >> 2] | 0;
            if (e | 0) {
                e = e + 8 | 0;
                b[e >> 2] = c;
                b[d >> 2] = c;
                return c | 0;
            }
            if (b[a >> 2] | 0) I(27310, 27235, 61, 27333);
            e = a;
            b[e >> 2] = c;
            b[d >> 2] = c;
            return c | 0;
        }
        function Bc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0;
            e = Bd(24) | 0;
            if (!e) I(27347, 27235, 78, 27361);
            b[e >> 2] = b[c >> 2];
            b[e + 4 >> 2] = b[c + 4 >> 2];
            b[e + 8 >> 2] = b[c + 8 >> 2];
            b[e + 12 >> 2] = b[c + 12 >> 2];
            b[e + 16 >> 2] = 0;
            c = a + 4 | 0;
            d = b[c >> 2] | 0;
            if (d | 0) {
                b[d + 16 >> 2] = e;
                b[c >> 2] = e;
                return e | 0;
            }
            if (b[a >> 2] | 0) I(27376, 27235, 82, 27361);
            b[a >> 2] = e;
            b[c >> 2] = e;
            return e | 0;
        }
        function Cc(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0;
            if (!a) return;
            e = 1;
            while(true){
                c = b[a >> 2] | 0;
                if (c | 0) do {
                    d = b[c >> 2] | 0;
                    if (d | 0) do {
                        f = d;
                        d = b[d + 16 >> 2] | 0;
                        Cd(f);
                    }while ((d | 0) != 0);
                    f = c;
                    c = b[c + 8 >> 2] | 0;
                    Cd(f);
                }while ((c | 0) != 0);
                c = a;
                a = b[a + 8 >> 2] | 0;
                if (!e) Cd(c);
                if (!a) break;
                else e = 0;
            }
            return;
        }
        function Dc(a) {
            a = a | 0;
            var c = 0, d = 0, f = 0, g = 0, h = 0.0, i = 0, j = 0.0, k = 0.0, l = 0, m = 0, n = 0, o = 0, p = 0, r = 0, s = 0.0, t = 0.0, u = 0.0, v = 0.0, w = 0.0, x = 0.0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0, J = 0, K = 0;
            g = a + 8 | 0;
            if (b[g >> 2] | 0) {
                K = 1;
                return K | 0;
            }
            f = b[a >> 2] | 0;
            if (!f) {
                K = 0;
                return K | 0;
            }
            c = f;
            d = 0;
            do {
                d = d + 1 | 0;
                c = b[c + 8 >> 2] | 0;
            }while ((c | 0) != 0);
            if (d >>> 0 < 2) {
                K = 0;
                return K | 0;
            }
            H = Bd(d << 2) | 0;
            if (!H) I(27396, 27235, 317, 27415);
            G = Bd(d << 5) | 0;
            if (!G) I(27437, 27235, 321, 27415);
            b[a >> 2] = 0;
            z = a + 4 | 0;
            b[z >> 2] = 0;
            b[g >> 2] = 0;
            d = 0;
            F = 0;
            y = 0;
            n = 0;
            a: while(true){
                m = b[f >> 2] | 0;
                if (m) {
                    h = 0.0;
                    i = m;
                    do {
                        k = +e[i + 8 >> 3];
                        c = i;
                        i = b[i + 16 >> 2] | 0;
                        l = (i | 0) == 0;
                        g = l ? m : i;
                        j = +e[g + 8 >> 3];
                        if (+q(+(k - j)) > 3.141592653589793) {
                            K = 14;
                            break;
                        }
                        h = h + (j - k) * (+e[c >> 3] + +e[g >> 3]);
                    }while (!l);
                    if ((K | 0) == 14) {
                        K = 0;
                        h = 0.0;
                        c = m;
                        do {
                            x = +e[c + 8 >> 3];
                            E = c + 16 | 0;
                            D = b[E >> 2] | 0;
                            D = (D | 0) == 0 ? m : D;
                            w = +e[D + 8 >> 3];
                            h = h + (+e[c >> 3] + +e[D >> 3]) * ((w < 0.0 ? w + 6.283185307179586 : w) - (x < 0.0 ? x + 6.283185307179586 : x));
                            c = b[((c | 0) == 0 ? f : E) >> 2] | 0;
                        }while ((c | 0) != 0);
                    }
                    if (h > 0.0) {
                        b[H + (F << 2) >> 2] = f;
                        F = F + 1 | 0;
                        g = y;
                        c = n;
                    } else K = 19;
                } else K = 19;
                if ((K | 0) == 19) {
                    K = 0;
                    do if (!d) {
                        if (!n) {
                            if (!(b[a >> 2] | 0)) {
                                g = z;
                                i = a;
                                c = f;
                                d = a;
                                break;
                            } else {
                                K = 27;
                                break a;
                            }
                        } else {
                            g = z;
                            i = n + 8 | 0;
                            c = f;
                            d = a;
                            break;
                        }
                    } else {
                        c = d + 8 | 0;
                        if (b[c >> 2] | 0) {
                            K = 21;
                            break a;
                        }
                        d = Dd(1, 12) | 0;
                        if (!d) {
                            K = 23;
                            break a;
                        }
                        b[c >> 2] = d;
                        g = d + 4 | 0;
                        i = d;
                        c = n;
                    }
                    while (0);
                    b[i >> 2] = f;
                    b[g >> 2] = f;
                    i = G + (y << 5) | 0;
                    l = b[f >> 2] | 0;
                    if (l) {
                        m = G + (y << 5) + 8 | 0;
                        e[m >> 3] = 1797693134862315708145274.0e284;
                        n = G + (y << 5) + 24 | 0;
                        e[n >> 3] = 1797693134862315708145274.0e284;
                        e[i >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        o = G + (y << 5) + 16 | 0;
                        e[o >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        u = 1797693134862315708145274.0e284;
                        v = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        g = 0;
                        p = l;
                        k = 1797693134862315708145274.0e284;
                        s = 1797693134862315708145274.0e284;
                        t = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        j = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        while(true){
                            h = +e[p >> 3];
                            x = +e[p + 8 >> 3];
                            p = b[p + 16 >> 2] | 0;
                            r = (p | 0) == 0;
                            w = +e[(r ? l : p) + 8 >> 3];
                            if (h < k) {
                                e[m >> 3] = h;
                                k = h;
                            }
                            if (x < s) {
                                e[n >> 3] = x;
                                s = x;
                            }
                            if (h > t) e[i >> 3] = h;
                            else h = t;
                            if (x > j) {
                                e[o >> 3] = x;
                                j = x;
                            }
                            u = x > 0.0 & x < u ? x : u;
                            v = x < 0.0 & x > v ? x : v;
                            g = g | +q(+(x - w)) > 3.141592653589793;
                            if (r) break;
                            else t = h;
                        }
                        if (g) {
                            e[o >> 3] = v;
                            e[n >> 3] = u;
                        }
                    } else {
                        b[i >> 2] = 0;
                        b[i + 4 >> 2] = 0;
                        b[i + 8 >> 2] = 0;
                        b[i + 12 >> 2] = 0;
                        b[i + 16 >> 2] = 0;
                        b[i + 20 >> 2] = 0;
                        b[i + 24 >> 2] = 0;
                        b[i + 28 >> 2] = 0;
                    }
                    g = y + 1 | 0;
                }
                E = f + 8 | 0;
                f = b[E >> 2] | 0;
                b[E >> 2] = 0;
                if (!f) {
                    K = 45;
                    break;
                } else {
                    y = g;
                    n = c;
                }
            }
            if ((K | 0) == 21) I(27213, 27235, 35, 27247);
            else if ((K | 0) == 23) I(27267, 27235, 37, 27247);
            else if ((K | 0) == 27) I(27310, 27235, 61, 27333);
            else if ((K | 0) == 45) {
                b: do if ((F | 0) > 0) {
                    E = (g | 0) == 0;
                    C = g << 2;
                    D = (a | 0) == 0;
                    B = 0;
                    c = 0;
                    while(true){
                        A = b[H + (B << 2) >> 2] | 0;
                        if (!E) {
                            y = Bd(C) | 0;
                            if (!y) {
                                K = 50;
                                break;
                            }
                            z = Bd(C) | 0;
                            if (!z) {
                                K = 52;
                                break;
                            }
                            c: do if (!D) {
                                g = 0;
                                d = 0;
                                i = a;
                                while(true){
                                    f = G + (g << 5) | 0;
                                    if (Ec(b[i >> 2] | 0, f, b[A >> 2] | 0) | 0) {
                                        b[y + (d << 2) >> 2] = i;
                                        b[z + (d << 2) >> 2] = f;
                                        r = d + 1 | 0;
                                    } else r = d;
                                    i = b[i + 8 >> 2] | 0;
                                    if (!i) break;
                                    else {
                                        g = g + 1 | 0;
                                        d = r;
                                    }
                                }
                                if ((r | 0) > 0) {
                                    f = b[y >> 2] | 0;
                                    if ((r | 0) == 1) d = f;
                                    else {
                                        o = 0;
                                        p = -1;
                                        d = f;
                                        n = f;
                                        while(true){
                                            l = b[n >> 2] | 0;
                                            f = 0;
                                            i = 0;
                                            while(true){
                                                g = b[b[y + (i << 2) >> 2] >> 2] | 0;
                                                if ((g | 0) == (l | 0)) m = f;
                                                else m = f + ((Ec(g, b[z + (i << 2) >> 2] | 0, b[l >> 2] | 0) | 0) & 1) | 0;
                                                i = i + 1 | 0;
                                                if ((i | 0) == (r | 0)) break;
                                                else f = m;
                                            }
                                            g = (m | 0) > (p | 0);
                                            d = g ? n : d;
                                            f = o + 1 | 0;
                                            if ((f | 0) == (r | 0)) break c;
                                            o = f;
                                            p = g ? m : p;
                                            n = b[y + (f << 2) >> 2] | 0;
                                        }
                                    }
                                } else d = 0;
                            } else d = 0;
                            while (0);
                            Cd(y);
                            Cd(z);
                            if (d) {
                                g = d + 4 | 0;
                                f = b[g >> 2] | 0;
                                if (!f) {
                                    if (b[d >> 2] | 0) {
                                        K = 70;
                                        break;
                                    }
                                } else d = f + 8 | 0;
                                b[d >> 2] = A;
                                b[g >> 2] = A;
                            } else K = 73;
                        } else K = 73;
                        if ((K | 0) == 73) {
                            K = 0;
                            c = b[A >> 2] | 0;
                            if (c | 0) do {
                                z = c;
                                c = b[c + 16 >> 2] | 0;
                                Cd(z);
                            }while ((c | 0) != 0);
                            Cd(A);
                            c = 1;
                        }
                        B = B + 1 | 0;
                        if ((B | 0) >= (F | 0)) {
                            J = c;
                            break b;
                        }
                    }
                    if ((K | 0) == 50) I(27452, 27235, 249, 27471);
                    else if ((K | 0) == 52) I(27490, 27235, 252, 27471);
                    else if ((K | 0) == 70) I(27310, 27235, 61, 27333);
                } else J = 0;
                while (0);
                Cd(H);
                Cd(G);
                K = J;
                return K | 0;
            }
            return 0;
        }
        function Ec(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0;
            if (!(Aa(c, d) | 0)) {
                a = 0;
                return a | 0;
            }
            c = ya(c) | 0;
            f = +e[d >> 3];
            g = +e[d + 8 >> 3];
            g = c & g < 0.0 ? g + 6.283185307179586 : g;
            a = b[a >> 2] | 0;
            if (!a) {
                a = 0;
                return a | 0;
            }
            if (c) {
                c = 0;
                l = g;
                d = a;
                a: while(true){
                    while(true){
                        i = +e[d >> 3];
                        g = +e[d + 8 >> 3];
                        d = d + 16 | 0;
                        m = b[d >> 2] | 0;
                        m = (m | 0) == 0 ? a : m;
                        h = +e[m >> 3];
                        j = +e[m + 8 >> 3];
                        if (i > h) {
                            k = i;
                            i = j;
                        } else {
                            k = h;
                            h = i;
                            i = g;
                            g = j;
                        }
                        f = f == h | f == k ? f + 2.220446049250313e-16 : f;
                        if (!(f < h | f > k)) break;
                        d = b[d >> 2] | 0;
                        if (!d) {
                            d = 22;
                            break a;
                        }
                    }
                    j = i < 0.0 ? i + 6.283185307179586 : i;
                    i = g < 0.0 ? g + 6.283185307179586 : g;
                    l = j == l | i == l ? l + -0.0000000000000002220446049250313 : l;
                    k = j + (i - j) * ((f - h) / (k - h));
                    if ((k < 0.0 ? k + 6.283185307179586 : k) > l) c = c ^ 1;
                    d = b[d >> 2] | 0;
                    if (!d) {
                        d = 22;
                        break;
                    }
                }
                if ((d | 0) == 22) return c | 0;
            } else {
                c = 0;
                l = g;
                d = a;
                b: while(true){
                    while(true){
                        i = +e[d >> 3];
                        g = +e[d + 8 >> 3];
                        d = d + 16 | 0;
                        m = b[d >> 2] | 0;
                        m = (m | 0) == 0 ? a : m;
                        h = +e[m >> 3];
                        j = +e[m + 8 >> 3];
                        if (i > h) {
                            k = i;
                            i = j;
                        } else {
                            k = h;
                            h = i;
                            i = g;
                            g = j;
                        }
                        f = f == h | f == k ? f + 2.220446049250313e-16 : f;
                        if (!(f < h | f > k)) break;
                        d = b[d >> 2] | 0;
                        if (!d) {
                            d = 22;
                            break b;
                        }
                    }
                    l = i == l | g == l ? l + -0.0000000000000002220446049250313 : l;
                    if (i + (g - i) * ((f - h) / (k - h)) > l) c = c ^ 1;
                    d = b[d >> 2] | 0;
                    if (!d) {
                        d = 22;
                        break;
                    }
                }
                if ((d | 0) == 22) return c | 0;
            }
            return 0;
        }
        function Fc(c, d, e, f, g) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0;
            u = T;
            T = T + 32 | 0;
            t = u + 16 | 0;
            s = u;
            h = Od(c | 0, d | 0, 52) | 0;
            H();
            h = h & 15;
            p = Od(e | 0, f | 0, 52) | 0;
            H();
            if ((h | 0) != (p & 15 | 0)) {
                t = 12;
                T = u;
                return t | 0;
            }
            l = Od(c | 0, d | 0, 45) | 0;
            H();
            l = l & 127;
            m = Od(e | 0, f | 0, 45) | 0;
            H();
            m = m & 127;
            if (l >>> 0 > 121 | m >>> 0 > 121) {
                t = 5;
                T = u;
                return t | 0;
            }
            p = (l | 0) != (m | 0);
            if (p) {
                j = ua(l, m) | 0;
                if ((j | 0) == 7) {
                    t = 1;
                    T = u;
                    return t | 0;
                }
                k = ua(m, l) | 0;
                if ((k | 0) == 7) I(27514, 27538, 161, 27548);
                else {
                    q = j;
                    i = k;
                }
            } else {
                q = 0;
                i = 0;
            }
            n = ma(l) | 0;
            o = ma(m) | 0;
            b[t >> 2] = 0;
            b[t + 4 >> 2] = 0;
            b[t + 8 >> 2] = 0;
            b[t + 12 >> 2] = 0;
            do if (!q) {
                Vb(e, f, t);
                if ((n | 0) != 0 & (o | 0) != 0) {
                    if ((m | 0) != (l | 0)) I(27621, 27538, 261, 27548);
                    i = Nb(c, d) | 0;
                    h = Nb(e, f) | 0;
                    if (!((i | 0) == 7 | (h | 0) == 7)) {
                        if (!(a[22e3 + (i * 7 | 0) + h >> 0] | 0)) {
                            i = b[21168 + (i * 28 | 0) + (h << 2) >> 2] | 0;
                            if ((i | 0) > 0) {
                                j = t + 4 | 0;
                                h = 0;
                                do {
                                    Ya(j);
                                    h = h + 1 | 0;
                                }while ((h | 0) != (i | 0));
                                r = 51;
                            } else r = 51;
                        } else h = 1;
                    } else h = 5;
                } else r = 51;
            } else {
                m = b[4272 + (l * 28 | 0) + (q << 2) >> 2] | 0;
                j = (m | 0) > 0;
                if (!o) {
                    if (j) {
                        l = 0;
                        k = e;
                        j = f;
                        do {
                            k = Rb(k, j) | 0;
                            j = H() | 0;
                            i = _a(i) | 0;
                            l = l + 1 | 0;
                        }while ((l | 0) != (m | 0));
                        m = i;
                        l = k;
                        k = j;
                    } else {
                        m = i;
                        l = e;
                        k = f;
                    }
                } else if (j) {
                    l = 0;
                    k = e;
                    j = f;
                    do {
                        k = Qb(k, j) | 0;
                        j = H() | 0;
                        i = _a(i) | 0;
                        if ((i | 0) == 1) i = _a(1) | 0;
                        l = l + 1 | 0;
                    }while ((l | 0) != (m | 0));
                    m = i;
                    l = k;
                    k = j;
                } else {
                    m = i;
                    l = e;
                    k = f;
                }
                Vb(l, k, t);
                if (!p) I(27563, 27538, 191, 27548);
                j = (n | 0) != 0;
                i = (o | 0) != 0;
                if (j & i) I(27590, 27538, 192, 27548);
                if (!j) {
                    if (i) {
                        i = Nb(l, k) | 0;
                        if ((i | 0) == 7) {
                            h = 5;
                            break;
                        }
                        if (a[22e3 + (i * 7 | 0) + m >> 0] | 0) {
                            h = 1;
                            break;
                        }
                        l = 0;
                        k = b[21168 + (m * 28 | 0) + (i << 2) >> 2] | 0;
                    } else {
                        l = 0;
                        k = 0;
                    }
                } else {
                    i = Nb(c, d) | 0;
                    if ((i | 0) == 7) {
                        h = 5;
                        break;
                    }
                    if (a[22e3 + (i * 7 | 0) + q >> 0] | 0) {
                        h = 1;
                        break;
                    }
                    k = b[21168 + (i * 28 | 0) + (q << 2) >> 2] | 0;
                    l = k;
                }
                if ((l | k | 0) < 0) h = 5;
                else {
                    if ((k | 0) > 0) {
                        j = t + 4 | 0;
                        i = 0;
                        do {
                            Ya(j);
                            i = i + 1 | 0;
                        }while ((i | 0) != (k | 0));
                    }
                    b[s >> 2] = 0;
                    b[s + 4 >> 2] = 0;
                    b[s + 8 >> 2] = 0;
                    Wa(s, q);
                    if (h | 0) while(true){
                        if (!(Tb(h) | 0)) Va(s);
                        else Ua(s);
                        if ((h | 0) > 1) h = h + -1 | 0;
                        else break;
                    }
                    if ((l | 0) > 0) {
                        h = 0;
                        do {
                            Ya(s);
                            h = h + 1 | 0;
                        }while ((h | 0) != (l | 0));
                    }
                    r = t + 4 | 0;
                    Ma(r, s, r);
                    Ka(r);
                    r = 51;
                }
            }
            while (0);
            if ((r | 0) == 51) {
                h = t + 4 | 0;
                b[g >> 2] = b[h >> 2];
                b[g + 4 >> 2] = b[h + 4 >> 2];
                b[g + 8 >> 2] = b[h + 8 >> 2];
                h = 0;
            }
            t = h;
            T = u;
            return t | 0;
        }
        function Gc(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0;
            q = T;
            T = T + 48 | 0;
            k = q + 36 | 0;
            h = q + 24 | 0;
            i = q + 12 | 0;
            j = q;
            f = Od(a | 0, c | 0, 52) | 0;
            H();
            f = f & 15;
            n = Od(a | 0, c | 0, 45) | 0;
            H();
            n = n & 127;
            if (n >>> 0 > 121) {
                e = 5;
                T = q;
                return e | 0;
            }
            l = ma(n) | 0;
            Pd(f | 0, 0, 52);
            r = H() | 134225919;
            g = e;
            b[g >> 2] = -1;
            b[g + 4 >> 2] = r;
            if (!f) {
                f = Pa(d) | 0;
                if ((f | 0) == 7) {
                    r = 1;
                    T = q;
                    return r | 0;
                }
                f = ta(n, f) | 0;
                if ((f | 0) == 127) {
                    r = 1;
                    T = q;
                    return r | 0;
                }
                o = Pd(f | 0, 0, 45) | 0;
                p = H() | 0;
                n = e;
                p = b[n + 4 >> 2] & -1040385 | p;
                r = e;
                b[r >> 2] = b[n >> 2] | o;
                b[r + 4 >> 2] = p;
                r = 0;
                T = q;
                return r | 0;
            }
            b[k >> 2] = b[d >> 2];
            b[k + 4 >> 2] = b[d + 4 >> 2];
            b[k + 8 >> 2] = b[d + 8 >> 2];
            d = f;
            while(true){
                g = d;
                d = d + -1 | 0;
                b[h >> 2] = b[k >> 2];
                b[h + 4 >> 2] = b[k + 4 >> 2];
                b[h + 8 >> 2] = b[k + 8 >> 2];
                if (!(Tb(g) | 0)) {
                    f = Ra(k) | 0;
                    if (f | 0) {
                        d = 13;
                        break;
                    }
                    b[i >> 2] = b[k >> 2];
                    b[i + 4 >> 2] = b[k + 4 >> 2];
                    b[i + 8 >> 2] = b[k + 8 >> 2];
                    Va(i);
                } else {
                    f = Qa(k) | 0;
                    if (f | 0) {
                        d = 13;
                        break;
                    }
                    b[i >> 2] = b[k >> 2];
                    b[i + 4 >> 2] = b[k + 4 >> 2];
                    b[i + 8 >> 2] = b[k + 8 >> 2];
                    Ua(i);
                }
                Na(h, i, j);
                Ka(j);
                f = e;
                t = b[f >> 2] | 0;
                f = b[f + 4 >> 2] | 0;
                u = (15 - g | 0) * 3 | 0;
                s = Pd(7, 0, u | 0) | 0;
                f = f & ~(H() | 0);
                u = Pd(Pa(j) | 0, 0, u | 0) | 0;
                f = H() | 0 | f;
                r = e;
                b[r >> 2] = u | t & ~s;
                b[r + 4 >> 2] = f;
                if ((g | 0) <= 1) {
                    d = 14;
                    break;
                }
            }
            a: do {
                if ((d | 0) != 13) {
                    if ((d | 0) == 14) {
                        if (((b[k >> 2] | 0) <= 1 ? (b[k + 4 >> 2] | 0) <= 1 : 0) ? (b[k + 8 >> 2] | 0) <= 1 : 0) {
                            d = Pa(k) | 0;
                            f = ta(n, d) | 0;
                            if ((f | 0) == 127) j = 0;
                            else j = ma(f) | 0;
                            b: do if (!d) {
                                if ((l | 0) != 0 & (j | 0) != 0) {
                                    d = Nb(a, c) | 0;
                                    g = e;
                                    g = Nb(b[g >> 2] | 0, b[g + 4 >> 2] | 0) | 0;
                                    if ((d | 0) == 7 | (g | 0) == 7) {
                                        f = 5;
                                        break a;
                                    }
                                    g = b[21376 + (d * 28 | 0) + (g << 2) >> 2] | 0;
                                    if ((g | 0) < 0) {
                                        f = 5;
                                        break a;
                                    }
                                    if (!g) d = 59;
                                    else {
                                        i = e;
                                        d = 0;
                                        h = b[i >> 2] | 0;
                                        i = b[i + 4 >> 2] | 0;
                                        do {
                                            h = Pb(h, i) | 0;
                                            i = H() | 0;
                                            u = e;
                                            b[u >> 2] = h;
                                            b[u + 4 >> 2] = i;
                                            d = d + 1 | 0;
                                        }while ((d | 0) < (g | 0));
                                        d = 58;
                                    }
                                } else d = 58;
                            } else {
                                if (l) {
                                    f = Nb(a, c) | 0;
                                    if ((f | 0) == 7) {
                                        f = 5;
                                        break a;
                                    }
                                    g = b[21376 + (f * 28 | 0) + (d << 2) >> 2] | 0;
                                    if ((g | 0) > 0) {
                                        f = d;
                                        d = 0;
                                        do {
                                            f = Za(f) | 0;
                                            d = d + 1 | 0;
                                        }while ((d | 0) != (g | 0));
                                    } else f = d;
                                    if ((f | 0) == 1) {
                                        f = 9;
                                        break a;
                                    }
                                    d = ta(n, f) | 0;
                                    if ((d | 0) == 127) I(27648, 27538, 411, 27678);
                                    if (!(ma(d) | 0)) {
                                        p = d;
                                        o = g;
                                        m = f;
                                    } else I(27693, 27538, 412, 27678);
                                } else {
                                    p = f;
                                    o = 0;
                                    m = d;
                                }
                                i = b[4272 + (n * 28 | 0) + (m << 2) >> 2] | 0;
                                if ((i | 0) <= -1) I(27724, 27538, 419, 27678);
                                if (!j) {
                                    if ((o | 0) < 0) {
                                        f = 5;
                                        break a;
                                    }
                                    if (o | 0) {
                                        g = e;
                                        f = 0;
                                        d = b[g >> 2] | 0;
                                        g = b[g + 4 >> 2] | 0;
                                        do {
                                            d = Pb(d, g) | 0;
                                            g = H() | 0;
                                            u = e;
                                            b[u >> 2] = d;
                                            b[u + 4 >> 2] = g;
                                            f = f + 1 | 0;
                                        }while ((f | 0) < (o | 0));
                                    }
                                    if ((i | 0) <= 0) {
                                        f = p;
                                        d = 58;
                                        break;
                                    }
                                    g = e;
                                    f = 0;
                                    d = b[g >> 2] | 0;
                                    g = b[g + 4 >> 2] | 0;
                                    while(true){
                                        d = Pb(d, g) | 0;
                                        g = H() | 0;
                                        u = e;
                                        b[u >> 2] = d;
                                        b[u + 4 >> 2] = g;
                                        f = f + 1 | 0;
                                        if ((f | 0) == (i | 0)) {
                                            f = p;
                                            d = 58;
                                            break b;
                                        }
                                    }
                                }
                                h = ua(p, n) | 0;
                                if ((h | 0) == 7) I(27514, 27538, 428, 27678);
                                f = e;
                                d = b[f >> 2] | 0;
                                f = b[f + 4 >> 2] | 0;
                                if ((i | 0) > 0) {
                                    g = 0;
                                    do {
                                        d = Pb(d, f) | 0;
                                        f = H() | 0;
                                        u = e;
                                        b[u >> 2] = d;
                                        b[u + 4 >> 2] = f;
                                        g = g + 1 | 0;
                                    }while ((g | 0) != (i | 0));
                                }
                                f = Nb(d, f) | 0;
                                if ((f | 0) == 7) I(27795, 27538, 440, 27678);
                                d = na(p) | 0;
                                d = b[(d ? 21792 : 21584) + (h * 28 | 0) + (f << 2) >> 2] | 0;
                                if ((d | 0) < 0) I(27795, 27538, 454, 27678);
                                if (!d) {
                                    f = p;
                                    d = 58;
                                } else {
                                    h = e;
                                    f = 0;
                                    g = b[h >> 2] | 0;
                                    h = b[h + 4 >> 2] | 0;
                                    do {
                                        g = Ob(g, h) | 0;
                                        h = H() | 0;
                                        u = e;
                                        b[u >> 2] = g;
                                        b[u + 4 >> 2] = h;
                                        f = f + 1 | 0;
                                    }while ((f | 0) < (d | 0));
                                    f = p;
                                    d = 58;
                                }
                            }
                            while (0);
                            if ((d | 0) == 58) {
                                if (j) d = 59;
                            }
                            if ((d | 0) == 59) {
                                u = e;
                                if ((Nb(b[u >> 2] | 0, b[u + 4 >> 2] | 0) | 0) == 1) {
                                    f = 9;
                                    break;
                                }
                            }
                            u = e;
                            s = b[u >> 2] | 0;
                            u = b[u + 4 >> 2] & -1040385;
                            t = Pd(f | 0, 0, 45) | 0;
                            u = u | (H() | 0);
                            f = e;
                            b[f >> 2] = s | t;
                            b[f + 4 >> 2] = u;
                            f = 0;
                        } else f = 1;
                    }
                }
            }while (0);
            u = f;
            T = q;
            return u | 0;
        }
        function Hc(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0;
            h = T;
            T = T + 16 | 0;
            g = h;
            if (!e) {
                a = Fc(a, b, c, d, g) | 0;
                if (!a) {
                    cb(g, f);
                    a = 0;
                }
            } else a = 15;
            T = h;
            return a | 0;
        }
        function Ic(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = T;
            T = T + 16 | 0;
            f = g;
            if (!d) {
                c = db(c, f) | 0;
                if (!c) c = Gc(a, b, f, e) | 0;
            } else c = 15;
            T = g;
            return c | 0;
        }
        function Jc(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0;
            j = T;
            T = T + 32 | 0;
            h = j + 12 | 0;
            i = j;
            g = Fc(a, c, a, c, h) | 0;
            if (g | 0) {
                i = g;
                T = j;
                return i | 0;
            }
            a = Fc(a, c, d, e, i) | 0;
            if (a | 0) {
                i = a;
                T = j;
                return i | 0;
            }
            h = bb(h, i) | 0;
            i = f;
            b[i >> 2] = h;
            b[i + 4 >> 2] = ((h | 0) < 0) << 31 >> 31;
            i = 0;
            T = j;
            return i | 0;
        }
        function Kc(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0;
            j = T;
            T = T + 32 | 0;
            h = j + 12 | 0;
            i = j;
            g = Fc(a, c, a, c, h) | 0;
            if (!g) {
                g = Fc(a, c, d, e, i) | 0;
                if (!g) {
                    e = bb(h, i) | 0;
                    e = Ed(e | 0, ((e | 0) < 0) << 31 >> 31 | 0, 1, 0) | 0;
                    h = H() | 0;
                    i = f;
                    b[i >> 2] = e;
                    b[i + 4 >> 2] = h;
                    i = 0;
                    T = j;
                    return i | 0;
                }
            }
            i = g;
            T = j;
            return i | 0;
        }
        function Lc(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0.0, j = 0.0, k = 0, l = 0.0, m = 0, n = 0, o = 0, p = 0, r = 0.0, s = 0, t = 0.0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0.0;
            z = T;
            T = T + 48 | 0;
            x = z + 24 | 0;
            h = z + 12 | 0;
            y = z;
            g = Fc(a, c, a, c, x) | 0;
            if (!g) {
                g = Fc(a, c, d, e, h) | 0;
                if (!g) {
                    v = bb(x, h) | 0;
                    w = ((v | 0) < 0) << 31 >> 31;
                    b[x >> 2] = 0;
                    b[x + 4 >> 2] = 0;
                    b[x + 8 >> 2] = 0;
                    b[h >> 2] = 0;
                    b[h + 4 >> 2] = 0;
                    b[h + 8 >> 2] = 0;
                    if (Fc(a, c, a, c, x) | 0) I(27795, 27538, 692, 27747);
                    if (Fc(a, c, d, e, h) | 0) I(27795, 27538, 697, 27747);
                    eb(x);
                    eb(h);
                    l = (v | 0) == 0 ? 0.0 : 1.0 / +(v | 0);
                    d = b[x >> 2] | 0;
                    r = l * +((b[h >> 2] | 0) - d | 0);
                    s = x + 4 | 0;
                    e = b[s >> 2] | 0;
                    t = l * +((b[h + 4 >> 2] | 0) - e | 0);
                    u = x + 8 | 0;
                    g = b[u >> 2] | 0;
                    l = l * +((b[h + 8 >> 2] | 0) - g | 0);
                    b[y >> 2] = d;
                    m = y + 4 | 0;
                    b[m >> 2] = e;
                    n = y + 8 | 0;
                    b[n >> 2] = g;
                    a: do if ((v | 0) < 0) g = 0;
                    else {
                        o = 0;
                        p = 0;
                        while(true){
                            j = +(p >>> 0) + 4294967296.0 * +(o | 0);
                            A = r * j + +(d | 0);
                            i = t * j + +(e | 0);
                            j = l * j + +(g | 0);
                            d = ~~+Td(+A);
                            h = ~~+Td(+i);
                            g = ~~+Td(+j);
                            A = +q(+(+(d | 0) - A));
                            i = +q(+(+(h | 0) - i));
                            j = +q(+(+(g | 0) - j));
                            do if (!(A > i & A > j)) {
                                k = 0 - d | 0;
                                if (i > j) {
                                    e = k - g | 0;
                                    break;
                                } else {
                                    e = h;
                                    g = k - h | 0;
                                    break;
                                }
                            } else {
                                d = 0 - (h + g) | 0;
                                e = h;
                            }
                            while (0);
                            b[y >> 2] = d;
                            b[m >> 2] = e;
                            b[n >> 2] = g;
                            fb(y);
                            g = Gc(a, c, y, f + (p << 3) | 0) | 0;
                            if (g | 0) break a;
                            if (!((o | 0) < (w | 0) | (o | 0) == (w | 0) & p >>> 0 < v >>> 0)) {
                                g = 0;
                                break a;
                            }
                            d = Ed(p | 0, o | 0, 1, 0) | 0;
                            e = H() | 0;
                            o = e;
                            p = d;
                            d = b[x >> 2] | 0;
                            e = b[s >> 2] | 0;
                            g = b[u >> 2] | 0;
                        }
                    }
                    while (0);
                    y = g;
                    T = z;
                    return y | 0;
                }
            }
            y = g;
            T = z;
            return y | 0;
        }
        function Mc(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            if ((c | 0) == 0 & (d | 0) == 0) {
                e = 0;
                f = 1;
                G(e | 0);
                return f | 0;
            }
            f = a;
            e = b;
            a = 1;
            b = 0;
            do {
                g = (c & 1 | 0) == 0 & true;
                a = Kd((g ? 1 : f) | 0, (g ? 0 : e) | 0, a | 0, b | 0) | 0;
                b = H() | 0;
                c = Nd(c | 0, d | 0, 1) | 0;
                d = H() | 0;
                f = Kd(f | 0, e | 0, f | 0, e | 0) | 0;
                e = H() | 0;
            }while (!((c | 0) == 0 & (d | 0) == 0));
            G(b | 0);
            return a | 0;
        }
        function Nc(a, c, d, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0.0, l = 0.0, m = 0.0;
            j = T;
            T = T + 16 | 0;
            h = j;
            i = Od(a | 0, c | 0, 52) | 0;
            H();
            i = i & 15;
            do if (!i) {
                g = Od(a | 0, c | 0, 45) | 0;
                H();
                g = g & 127;
                if (g >>> 0 > 121) {
                    i = 5;
                    T = j;
                    return i | 0;
                } else {
                    h = 22064 + (g << 5) | 0;
                    b[d >> 2] = b[h >> 2];
                    b[d + 4 >> 2] = b[h + 4 >> 2];
                    b[d + 8 >> 2] = b[h + 8 >> 2];
                    b[d + 12 >> 2] = b[h + 12 >> 2];
                    b[d + 16 >> 2] = b[h + 16 >> 2];
                    b[d + 20 >> 2] = b[h + 20 >> 2];
                    b[d + 24 >> 2] = b[h + 24 >> 2];
                    b[d + 28 >> 2] = b[h + 28 >> 2];
                    break;
                }
            } else {
                g = Xb(a, c, h) | 0;
                if (!g) {
                    l = +e[h >> 3];
                    k = 1.0 / +t(+l);
                    m = +e[25968 + (i << 3) >> 3];
                    e[d >> 3] = l + m;
                    e[d + 8 >> 3] = l - m;
                    l = +e[h + 8 >> 3];
                    k = m * k;
                    e[d + 16 >> 3] = k + l;
                    e[d + 24 >> 3] = l - k;
                    break;
                }
                i = g;
                T = j;
                return i | 0;
            }
            while (0);
            Ha(d, f ? 1.4 : 1.1);
            f = 26096 + (i << 3) | 0;
            if ((b[f >> 2] | 0) == (a | 0) ? (b[f + 4 >> 2] | 0) == (c | 0) : 0) e[d >> 3] = 1.5707963267948966;
            i = 26224 + (i << 3) | 0;
            if ((b[i >> 2] | 0) == (a | 0) ? (b[i + 4 >> 2] | 0) == (c | 0) : 0) e[d + 8 >> 3] = -1.5707963267948966;
            if (!(+e[d >> 3] == 1.5707963267948966) ? !(+e[d + 8 >> 3] == -1.5707963267948966) : 0) {
                i = 0;
                T = j;
                return i | 0;
            }
            e[d + 16 >> 3] = 3.141592653589793;
            e[d + 24 >> 3] = -3.141592653589793;
            i = 0;
            T = j;
            return i | 0;
        }
        function Oc(c, d, e, f) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            l = T;
            T = T + 48 | 0;
            i = l + 32 | 0;
            h = l + 40 | 0;
            j = l;
            Cb(i, 0, 0, 0);
            k = b[i >> 2] | 0;
            i = b[i + 4 >> 2] | 0;
            do if (e >>> 0 <= 15) {
                g = Vc(f) | 0;
                if (g | 0) {
                    f = j;
                    b[f >> 2] = 0;
                    b[f + 4 >> 2] = 0;
                    b[j + 8 >> 2] = g;
                    b[j + 12 >> 2] = -1;
                    f = j + 16 | 0;
                    k = j + 29 | 0;
                    b[f >> 2] = 0;
                    b[f + 4 >> 2] = 0;
                    b[f + 8 >> 2] = 0;
                    a[f + 12 >> 0] = 0;
                    a[k >> 0] = a[h >> 0] | 0;
                    a[k + 1 >> 0] = a[h + 1 >> 0] | 0;
                    a[k + 2 >> 0] = a[h + 2 >> 0] | 0;
                    break;
                }
                g = Dd((b[d + 8 >> 2] | 0) + 1 | 0, 32) | 0;
                if (!g) {
                    f = j;
                    b[f >> 2] = 0;
                    b[f + 4 >> 2] = 0;
                    b[j + 8 >> 2] = 13;
                    b[j + 12 >> 2] = -1;
                    f = j + 16 | 0;
                    k = j + 29 | 0;
                    b[f >> 2] = 0;
                    b[f + 4 >> 2] = 0;
                    b[f + 8 >> 2] = 0;
                    a[f + 12 >> 0] = 0;
                    a[k >> 0] = a[h >> 0] | 0;
                    a[k + 1 >> 0] = a[h + 1 >> 0] | 0;
                    a[k + 2 >> 0] = a[h + 2 >> 0] | 0;
                    break;
                } else {
                    Wc(d, g);
                    m = j;
                    b[m >> 2] = k;
                    b[m + 4 >> 2] = i;
                    b[j + 8 >> 2] = 0;
                    b[j + 12 >> 2] = e;
                    b[j + 16 >> 2] = f;
                    b[j + 20 >> 2] = d;
                    b[j + 24 >> 2] = g;
                    a[j + 28 >> 0] = 0;
                    k = j + 29 | 0;
                    a[k >> 0] = a[h >> 0] | 0;
                    a[k + 1 >> 0] = a[h + 1 >> 0] | 0;
                    a[k + 2 >> 0] = a[h + 2 >> 0] | 0;
                    break;
                }
            } else {
                k = j;
                b[k >> 2] = 0;
                b[k + 4 >> 2] = 0;
                b[j + 8 >> 2] = 4;
                b[j + 12 >> 2] = -1;
                k = j + 16 | 0;
                m = j + 29 | 0;
                b[k >> 2] = 0;
                b[k + 4 >> 2] = 0;
                b[k + 8 >> 2] = 0;
                a[k + 12 >> 0] = 0;
                a[m >> 0] = a[h >> 0] | 0;
                a[m + 1 >> 0] = a[h + 1 >> 0] | 0;
                a[m + 2 >> 0] = a[h + 2 >> 0] | 0;
            }
            while (0);
            Pc(j);
            b[c >> 2] = b[j >> 2];
            b[c + 4 >> 2] = b[j + 4 >> 2];
            b[c + 8 >> 2] = b[j + 8 >> 2];
            b[c + 12 >> 2] = b[j + 12 >> 2];
            b[c + 16 >> 2] = b[j + 16 >> 2];
            b[c + 20 >> 2] = b[j + 20 >> 2];
            b[c + 24 >> 2] = b[j + 24 >> 2];
            b[c + 28 >> 2] = b[j + 28 >> 2];
            T = l;
            return;
        }
        function Pc(c) {
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0;
            w = T;
            T = T + 336 | 0;
            p = w + 168 | 0;
            q = w;
            f = c;
            e = b[f >> 2] | 0;
            f = b[f + 4 >> 2] | 0;
            if ((e | 0) == 0 & (f | 0) == 0) {
                T = w;
                return;
            }
            d = c + 28 | 0;
            if (!(a[d >> 0] | 0)) a[d >> 0] = 1;
            else {
                e = Qc(e, f) | 0;
                f = H() | 0;
            }
            v = c + 20 | 0;
            if (!(b[b[v >> 2] >> 2] | 0)) {
                d = c + 24 | 0;
                e = b[d >> 2] | 0;
                if (e | 0) Cd(e);
                u = c;
                b[u >> 2] = 0;
                b[u + 4 >> 2] = 0;
                b[c + 8 >> 2] = 0;
                b[v >> 2] = 0;
                b[c + 12 >> 2] = -1;
                b[c + 16 >> 2] = 0;
                b[d >> 2] = 0;
                T = w;
                return;
            }
            u = c + 16 | 0;
            d = b[u >> 2] | 0;
            g = d & 15;
            a: do if (!((e | 0) == 0 & (f | 0) == 0)) {
                r = c + 12 | 0;
                n = (g | 0) == 3;
                m = d & 255;
                k = (g | 1) == 3;
                o = c + 24 | 0;
                l = (g + -1 | 0) >>> 0 < 3;
                i = (g | 2) == 3;
                j = q + 8 | 0;
                b: while(true){
                    h = Od(e | 0, f | 0, 52) | 0;
                    H();
                    h = h & 15;
                    if ((h | 0) == (b[r >> 2] | 0)) {
                        switch(m & 15){
                            case 0:
                            case 2:
                            case 3:
                                g = Xb(e, f, p) | 0;
                                if (g | 0) {
                                    s = 15;
                                    break b;
                                }
                                if (Xc(b[v >> 2] | 0, b[o >> 2] | 0, p) | 0) {
                                    s = 19;
                                    break b;
                                }
                                break;
                            default:
                        }
                        if (k ? (g = b[(b[v >> 2] | 0) + 4 >> 2] | 0, b[p >> 2] = b[g >> 2], b[p + 4 >> 2] = b[g + 4 >> 2], b[p + 8 >> 2] = b[g + 8 >> 2], b[p + 12 >> 2] = b[g + 12 >> 2], Aa(26832, p) | 0) : 0) {
                            if (Ub(b[(b[v >> 2] | 0) + 4 >> 2] | 0, h, q) | 0) {
                                s = 25;
                                break;
                            }
                            g = q;
                            if ((b[g >> 2] | 0) == (e | 0) ? (b[g + 4 >> 2] | 0) == (f | 0) : 0) {
                                s = 29;
                                break;
                            }
                        }
                        if (l) {
                            g = Yb(e, f, p) | 0;
                            if (g | 0) {
                                s = 32;
                                break;
                            }
                            if (Nc(e, f, q, 0) | 0) {
                                s = 36;
                                break;
                            }
                            if (i ? Yc(b[v >> 2] | 0, b[o >> 2] | 0, p, q) | 0 : 0) {
                                s = 42;
                                break;
                            }
                            if (k ? _c(b[v >> 2] | 0, b[o >> 2] | 0, p, q) | 0 : 0) {
                                s = 42;
                                break;
                            }
                        }
                        if (n) {
                            d = Nc(e, f, p, 1) | 0;
                            g = b[o >> 2] | 0;
                            if (d | 0) {
                                s = 45;
                                break;
                            }
                            if (Ba(g, p) | 0) {
                                Ea(q, p);
                                if (Da(p, b[o >> 2] | 0) | 0) {
                                    s = 53;
                                    break;
                                }
                                if (Xc(b[v >> 2] | 0, b[o >> 2] | 0, j) | 0) {
                                    s = 53;
                                    break;
                                }
                                if (_c(b[v >> 2] | 0, b[o >> 2] | 0, q, p) | 0) {
                                    s = 53;
                                    break;
                                }
                            }
                        }
                    }
                    do if ((h | 0) < (b[r >> 2] | 0)) {
                        d = Nc(e, f, p, 1) | 0;
                        g = b[o >> 2] | 0;
                        if (d | 0) {
                            s = 58;
                            break b;
                        }
                        if (!(Ba(g, p) | 0)) {
                            s = 73;
                            break;
                        }
                        if (Da(b[o >> 2] | 0, p) | 0 ? (Ea(q, p), Yc(b[v >> 2] | 0, b[o >> 2] | 0, q, p) | 0) : 0) {
                            s = 65;
                            break b;
                        }
                        e = Ib(e, f, h + 1 | 0, q) | 0;
                        if (e | 0) {
                            s = 67;
                            break b;
                        }
                        f = q;
                        e = b[f >> 2] | 0;
                        f = b[f + 4 >> 2] | 0;
                    } else s = 73;
                    while (0);
                    if ((s | 0) == 73) {
                        s = 0;
                        e = Qc(e, f) | 0;
                        f = H() | 0;
                    }
                    if ((e | 0) == 0 & (f | 0) == 0) {
                        t = o;
                        break a;
                    }
                }
                switch(s | 0){
                    case 15:
                        d = b[o >> 2] | 0;
                        if (d | 0) Cd(d);
                        s = c;
                        b[s >> 2] = 0;
                        b[s + 4 >> 2] = 0;
                        b[v >> 2] = 0;
                        b[r >> 2] = -1;
                        b[u >> 2] = 0;
                        b[o >> 2] = 0;
                        b[c + 8 >> 2] = g;
                        s = 20;
                        break;
                    case 19:
                        b[c >> 2] = e;
                        b[c + 4 >> 2] = f;
                        s = 20;
                        break;
                    case 25:
                        I(27795, 27761, 470, 27772);
                        break;
                    case 29:
                        b[c >> 2] = e;
                        b[c + 4 >> 2] = f;
                        T = w;
                        return;
                    case 32:
                        d = b[o >> 2] | 0;
                        if (d | 0) Cd(d);
                        t = c;
                        b[t >> 2] = 0;
                        b[t + 4 >> 2] = 0;
                        b[v >> 2] = 0;
                        b[r >> 2] = -1;
                        b[u >> 2] = 0;
                        b[o >> 2] = 0;
                        b[c + 8 >> 2] = g;
                        T = w;
                        return;
                    case 36:
                        I(27795, 27761, 493, 27772);
                        break;
                    case 42:
                        b[c >> 2] = e;
                        b[c + 4 >> 2] = f;
                        T = w;
                        return;
                    case 45:
                        if (g | 0) Cd(g);
                        s = c;
                        b[s >> 2] = 0;
                        b[s + 4 >> 2] = 0;
                        b[v >> 2] = 0;
                        b[r >> 2] = -1;
                        b[u >> 2] = 0;
                        b[o >> 2] = 0;
                        b[c + 8 >> 2] = d;
                        s = 55;
                        break;
                    case 53:
                        b[c >> 2] = e;
                        b[c + 4 >> 2] = f;
                        s = 55;
                        break;
                    case 58:
                        if (g | 0) Cd(g);
                        s = c;
                        b[s >> 2] = 0;
                        b[s + 4 >> 2] = 0;
                        b[v >> 2] = 0;
                        b[r >> 2] = -1;
                        b[u >> 2] = 0;
                        b[o >> 2] = 0;
                        b[c + 8 >> 2] = d;
                        s = 71;
                        break;
                    case 65:
                        b[c >> 2] = e;
                        b[c + 4 >> 2] = f;
                        s = 71;
                        break;
                    case 67:
                        d = b[o >> 2] | 0;
                        if (d | 0) Cd(d);
                        t = c;
                        b[t >> 2] = 0;
                        b[t + 4 >> 2] = 0;
                        b[v >> 2] = 0;
                        b[r >> 2] = -1;
                        b[u >> 2] = 0;
                        b[o >> 2] = 0;
                        b[c + 8 >> 2] = e;
                        T = w;
                        return;
                }
                if ((s | 0) == 20) {
                    T = w;
                    return;
                } else if ((s | 0) == 55) {
                    T = w;
                    return;
                } else if ((s | 0) == 71) {
                    T = w;
                    return;
                }
            } else t = c + 24 | 0;
            while (0);
            d = b[t >> 2] | 0;
            if (d | 0) Cd(d);
            s = c;
            b[s >> 2] = 0;
            b[s + 4 >> 2] = 0;
            b[c + 8 >> 2] = 0;
            b[v >> 2] = 0;
            b[c + 12 >> 2] = -1;
            b[u >> 2] = 0;
            b[t >> 2] = 0;
            T = w;
            return;
        }
        function Qc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0;
            m = T;
            T = T + 16 | 0;
            l = m;
            e = Od(a | 0, c | 0, 52) | 0;
            H();
            e = e & 15;
            d = Od(a | 0, c | 0, 45) | 0;
            H();
            do if (e) {
                while(true){
                    d = Pd(e + 4095 | 0, 0, 52) | 0;
                    f = H() | 0 | c & -15728641;
                    g = (15 - e | 0) * 3 | 0;
                    h = Pd(7, 0, g | 0) | 0;
                    i = H() | 0;
                    d = d | a | h;
                    f = f | i;
                    j = Od(a | 0, c | 0, g | 0) | 0;
                    H();
                    j = j & 7;
                    e = e + -1 | 0;
                    if (j >>> 0 < 6) break;
                    if (!e) {
                        k = 4;
                        break;
                    } else {
                        c = f;
                        a = d;
                    }
                }
                if ((k | 0) == 4) {
                    d = Od(d | 0, f | 0, 45) | 0;
                    H();
                    break;
                }
                l = (j | 0) == 0 & (Fb(d, f) | 0) != 0;
                l = Pd((l ? 2 : 1) + j | 0, 0, g | 0) | 0;
                k = H() | 0 | c & ~i;
                l = l | a & ~h;
                G(k | 0);
                T = m;
                return l | 0;
            }
            while (0);
            d = d & 127;
            if (d >>> 0 > 120) {
                k = 0;
                l = 0;
                G(k | 0);
                T = m;
                return l | 0;
            }
            Cb(l, 0, d + 1 | 0, 0);
            k = b[l + 4 >> 2] | 0;
            l = b[l >> 2] | 0;
            G(k | 0);
            T = m;
            return l | 0;
        }
        function Rc(a, c, d, e, f, g) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0;
            r = T;
            T = T + 160 | 0;
            m = r + 80 | 0;
            i = r + 64 | 0;
            n = r + 112 | 0;
            q = r;
            Oc(m, a, c, d);
            k = m;
            dc(i, b[k >> 2] | 0, b[k + 4 >> 2] | 0, c);
            k = i;
            j = b[k >> 2] | 0;
            k = b[k + 4 >> 2] | 0;
            h = b[m + 8 >> 2] | 0;
            o = n + 4 | 0;
            b[o >> 2] = b[m >> 2];
            b[o + 4 >> 2] = b[m + 4 >> 2];
            b[o + 8 >> 2] = b[m + 8 >> 2];
            b[o + 12 >> 2] = b[m + 12 >> 2];
            b[o + 16 >> 2] = b[m + 16 >> 2];
            b[o + 20 >> 2] = b[m + 20 >> 2];
            b[o + 24 >> 2] = b[m + 24 >> 2];
            b[o + 28 >> 2] = b[m + 28 >> 2];
            o = q;
            b[o >> 2] = j;
            b[o + 4 >> 2] = k;
            o = q + 8 | 0;
            b[o >> 2] = h;
            a = q + 12 | 0;
            c = n;
            d = a + 36 | 0;
            do {
                b[a >> 2] = b[c >> 2];
                a = a + 4 | 0;
                c = c + 4 | 0;
            }while ((a | 0) < (d | 0));
            n = q + 48 | 0;
            b[n >> 2] = b[i >> 2];
            b[n + 4 >> 2] = b[i + 4 >> 2];
            b[n + 8 >> 2] = b[i + 8 >> 2];
            b[n + 12 >> 2] = b[i + 12 >> 2];
            if ((j | 0) == 0 & (k | 0) == 0) {
                q = h;
                T = r;
                return q | 0;
            }
            d = q + 16 | 0;
            l = q + 24 | 0;
            m = q + 28 | 0;
            h = 0;
            i = 0;
            c = j;
            a = k;
            do {
                if (!((h | 0) < (f | 0) | (h | 0) == (f | 0) & i >>> 0 < e >>> 0)) {
                    p = 4;
                    break;
                }
                k = i;
                i = Ed(i | 0, h | 0, 1, 0) | 0;
                h = H() | 0;
                k = g + (k << 3) | 0;
                b[k >> 2] = c;
                b[k + 4 >> 2] = a;
                fc(n);
                a = n;
                c = b[a >> 2] | 0;
                a = b[a + 4 >> 2] | 0;
                if ((c | 0) == 0 & (a | 0) == 0) {
                    Pc(d);
                    c = d;
                    a = b[c >> 2] | 0;
                    c = b[c + 4 >> 2] | 0;
                    if ((a | 0) == 0 & (c | 0) == 0) {
                        p = 10;
                        break;
                    }
                    ec(a, c, b[m >> 2] | 0, n);
                    a = n;
                    c = b[a >> 2] | 0;
                    a = b[a + 4 >> 2] | 0;
                }
                k = q;
                b[k >> 2] = c;
                b[k + 4 >> 2] = a;
            }while (!((c | 0) == 0 & (a | 0) == 0));
            if ((p | 0) == 4) {
                a = q + 40 | 0;
                c = b[a >> 2] | 0;
                if (c | 0) Cd(c);
                p = q + 16 | 0;
                b[p >> 2] = 0;
                b[p + 4 >> 2] = 0;
                b[l >> 2] = 0;
                b[q + 36 >> 2] = 0;
                b[m >> 2] = -1;
                b[q + 32 >> 2] = 0;
                b[a >> 2] = 0;
                ec(0, 0, 0, n);
                b[q >> 2] = 0;
                b[q + 4 >> 2] = 0;
                b[o >> 2] = 0;
                q = 14;
                T = r;
                return q | 0;
            } else if ((p | 0) == 10) {
                b[q >> 2] = 0;
                b[q + 4 >> 2] = 0;
                b[o >> 2] = b[l >> 2];
            }
            q = b[o >> 2] | 0;
            T = r;
            return q | 0;
        }
        function Sc(c, d, f, g) {
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0.0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0.0, r = 0;
            o = T;
            T = T + 48 | 0;
            l = o + 32 | 0;
            k = o + 40 | 0;
            m = o;
            if (!(b[c >> 2] | 0)) {
                n = g;
                b[n >> 2] = 0;
                b[n + 4 >> 2] = 0;
                n = 0;
                T = o;
                return n | 0;
            }
            Cb(l, 0, 0, 0);
            j = l;
            h = b[j >> 2] | 0;
            j = b[j + 4 >> 2] | 0;
            do if (d >>> 0 > 15) {
                n = m;
                b[n >> 2] = 0;
                b[n + 4 >> 2] = 0;
                b[m + 8 >> 2] = 4;
                b[m + 12 >> 2] = -1;
                n = m + 16 | 0;
                f = m + 29 | 0;
                b[n >> 2] = 0;
                b[n + 4 >> 2] = 0;
                b[n + 8 >> 2] = 0;
                a[n + 12 >> 0] = 0;
                a[f >> 0] = a[k >> 0] | 0;
                a[f + 1 >> 0] = a[k + 1 >> 0] | 0;
                a[f + 2 >> 0] = a[k + 2 >> 0] | 0;
                f = 4;
                n = 9;
            } else {
                f = Vc(f) | 0;
                if (f | 0) {
                    l = m;
                    b[l >> 2] = 0;
                    b[l + 4 >> 2] = 0;
                    b[m + 8 >> 2] = f;
                    b[m + 12 >> 2] = -1;
                    l = m + 16 | 0;
                    n = m + 29 | 0;
                    b[l >> 2] = 0;
                    b[l + 4 >> 2] = 0;
                    b[l + 8 >> 2] = 0;
                    a[l + 12 >> 0] = 0;
                    a[n >> 0] = a[k >> 0] | 0;
                    a[n + 1 >> 0] = a[k + 1 >> 0] | 0;
                    a[n + 2 >> 0] = a[k + 2 >> 0] | 0;
                    n = 9;
                    break;
                }
                f = Dd((b[c + 8 >> 2] | 0) + 1 | 0, 32) | 0;
                if (!f) {
                    n = m;
                    b[n >> 2] = 0;
                    b[n + 4 >> 2] = 0;
                    b[m + 8 >> 2] = 13;
                    b[m + 12 >> 2] = -1;
                    n = m + 16 | 0;
                    f = m + 29 | 0;
                    b[n >> 2] = 0;
                    b[n + 4 >> 2] = 0;
                    b[n + 8 >> 2] = 0;
                    a[n + 12 >> 0] = 0;
                    a[f >> 0] = a[k >> 0] | 0;
                    a[f + 1 >> 0] = a[k + 1 >> 0] | 0;
                    a[f + 2 >> 0] = a[k + 2 >> 0] | 0;
                    f = 13;
                    n = 9;
                    break;
                }
                Wc(c, f);
                r = m;
                b[r >> 2] = h;
                b[r + 4 >> 2] = j;
                j = m + 8 | 0;
                b[j >> 2] = 0;
                b[m + 12 >> 2] = d;
                b[m + 20 >> 2] = c;
                b[m + 24 >> 2] = f;
                a[m + 28 >> 0] = 0;
                h = m + 29 | 0;
                a[h >> 0] = a[k >> 0] | 0;
                a[h + 1 >> 0] = a[k + 1 >> 0] | 0;
                a[h + 2 >> 0] = a[k + 2 >> 0] | 0;
                b[m + 16 >> 2] = 3;
                p = +za(f);
                p = p * +xa(f);
                i = +q(+ +e[f >> 3]);
                i = p / +t(+ +Sd(+i, + +q(+ +e[f + 8 >> 3]))) * 40589732.49931477;
                h = m + 12 | 0;
                f = b[h >> 2] | 0;
                a: {
                    if ((f | 0) > 0) do {
                        oc(f + -1 | 0, l);
                        if (!(i / +e[l >> 3] > 10.0)) break a;
                        r = b[h >> 2] | 0;
                        f = r + -1 | 0;
                        b[h >> 2] = f;
                    }while ((r | 0) > 1);
                }
                Pc(m);
                h = g;
                b[h >> 2] = 0;
                b[h + 4 >> 2] = 0;
                h = m;
                f = b[h >> 2] | 0;
                h = b[h + 4 >> 2] | 0;
                if (!((f | 0) == 0 & (h | 0) == 0)) do {
                    Eb(f, h, d, l);
                    k = l;
                    c = g;
                    k = Ed(b[c >> 2] | 0, b[c + 4 >> 2] | 0, b[k >> 2] | 0, b[k + 4 >> 2] | 0) | 0;
                    c = H() | 0;
                    r = g;
                    b[r >> 2] = k;
                    b[r + 4 >> 2] = c;
                    Pc(m);
                    r = m;
                    f = b[r >> 2] | 0;
                    h = b[r + 4 >> 2] | 0;
                }while (!((f | 0) == 0 & (h | 0) == 0));
                f = b[j >> 2] | 0;
            }
            while (0);
            r = f;
            T = o;
            return r | 0;
        }
        function Tc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0, m = 0.0, n = 0, o = 0;
            if (!(Aa(c, d) | 0)) {
                o = 0;
                return o | 0;
            }
            c = ya(c) | 0;
            f = +e[d >> 3];
            g = +e[d + 8 >> 3];
            g = c & g < 0.0 ? g + 6.283185307179586 : g;
            o = b[a >> 2] | 0;
            if ((o | 0) <= 0) {
                o = 0;
                return o | 0;
            }
            n = b[a + 4 >> 2] | 0;
            if (c) {
                c = 0;
                m = g;
                d = -1;
                a = 0;
                a: while(true){
                    l = a;
                    while(true){
                        i = +e[n + (l << 4) >> 3];
                        g = +e[n + (l << 4) + 8 >> 3];
                        a = (d + 2 | 0) % (o | 0) | 0;
                        h = +e[n + (a << 4) >> 3];
                        j = +e[n + (a << 4) + 8 >> 3];
                        if (i > h) {
                            k = i;
                            i = j;
                        } else {
                            k = h;
                            h = i;
                            i = g;
                            g = j;
                        }
                        f = f == h | f == k ? f + 2.220446049250313e-16 : f;
                        if (!(f < h | f > k)) break;
                        d = l + 1 | 0;
                        if ((d | 0) >= (o | 0)) {
                            d = 22;
                            break a;
                        } else {
                            a = l;
                            l = d;
                            d = a;
                        }
                    }
                    j = i < 0.0 ? i + 6.283185307179586 : i;
                    i = g < 0.0 ? g + 6.283185307179586 : g;
                    m = j == m | i == m ? m + -0.0000000000000002220446049250313 : m;
                    k = j + (i - j) * ((f - h) / (k - h));
                    if ((k < 0.0 ? k + 6.283185307179586 : k) > m) c = c ^ 1;
                    a = l + 1 | 0;
                    if ((a | 0) >= (o | 0)) {
                        d = 22;
                        break;
                    } else d = l;
                }
                if ((d | 0) == 22) return c | 0;
            } else {
                c = 0;
                m = g;
                d = -1;
                a = 0;
                b: while(true){
                    l = a;
                    while(true){
                        i = +e[n + (l << 4) >> 3];
                        g = +e[n + (l << 4) + 8 >> 3];
                        a = (d + 2 | 0) % (o | 0) | 0;
                        h = +e[n + (a << 4) >> 3];
                        j = +e[n + (a << 4) + 8 >> 3];
                        if (i > h) {
                            k = i;
                            i = j;
                        } else {
                            k = h;
                            h = i;
                            i = g;
                            g = j;
                        }
                        f = f == h | f == k ? f + 2.220446049250313e-16 : f;
                        if (!(f < h | f > k)) break;
                        d = l + 1 | 0;
                        if ((d | 0) >= (o | 0)) {
                            d = 22;
                            break b;
                        } else {
                            a = l;
                            l = d;
                            d = a;
                        }
                    }
                    m = i == m | g == m ? m + -0.0000000000000002220446049250313 : m;
                    if (i + (g - i) * ((f - h) / (k - h)) > m) c = c ^ 1;
                    a = l + 1 | 0;
                    if ((a | 0) >= (o | 0)) {
                        d = 22;
                        break;
                    } else d = l;
                }
                if ((d | 0) == 22) return c | 0;
            }
            return 0;
        }
        function Uc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0.0, f = 0.0, g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0, o = 0, p = 0, r = 0, s = 0, t = 0, u = 0, v = 0;
            r = b[a >> 2] | 0;
            if (!r) {
                b[c >> 2] = 0;
                b[c + 4 >> 2] = 0;
                b[c + 8 >> 2] = 0;
                b[c + 12 >> 2] = 0;
                b[c + 16 >> 2] = 0;
                b[c + 20 >> 2] = 0;
                b[c + 24 >> 2] = 0;
                b[c + 28 >> 2] = 0;
                return;
            }
            s = c + 8 | 0;
            e[s >> 3] = 1797693134862315708145274.0e284;
            t = c + 24 | 0;
            e[t >> 3] = 1797693134862315708145274.0e284;
            e[c >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            u = c + 16 | 0;
            e[u >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            if ((r | 0) <= 0) return;
            o = b[a + 4 >> 2] | 0;
            l = 1797693134862315708145274.0e284;
            m = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            n = 0;
            a = -1;
            h = 1797693134862315708145274.0e284;
            i = 1797693134862315708145274.0e284;
            k = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            f = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
            p = 0;
            while(true){
                d = +e[o + (p << 4) >> 3];
                j = +e[o + (p << 4) + 8 >> 3];
                a = a + 2 | 0;
                g = +e[o + (((a | 0) == (r | 0) ? 0 : a) << 4) + 8 >> 3];
                if (d < h) {
                    e[s >> 3] = d;
                    h = d;
                }
                if (j < i) {
                    e[t >> 3] = j;
                    i = j;
                }
                if (d > k) e[c >> 3] = d;
                else d = k;
                if (j > f) {
                    e[u >> 3] = j;
                    f = j;
                }
                l = j > 0.0 & j < l ? j : l;
                m = j < 0.0 & j > m ? j : m;
                n = n | +q(+(j - g)) > 3.141592653589793;
                a = p + 1 | 0;
                if ((a | 0) == (r | 0)) break;
                else {
                    v = p;
                    k = d;
                    p = a;
                    a = v;
                }
            }
            if (!n) return;
            e[u >> 3] = m;
            e[t >> 3] = l;
            return;
        }
        function Vc(a) {
            a = a | 0;
            return (a >>> 0 < 4 ? 0 : 15) | 0;
        }
        function Wc(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0, o = 0.0, p = 0.0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0;
            r = b[a >> 2] | 0;
            if (r) {
                s = c + 8 | 0;
                e[s >> 3] = 1797693134862315708145274.0e284;
                t = c + 24 | 0;
                e[t >> 3] = 1797693134862315708145274.0e284;
                e[c >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                u = c + 16 | 0;
                e[u >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                if ((r | 0) > 0) {
                    g = b[a + 4 >> 2] | 0;
                    o = 1797693134862315708145274.0e284;
                    p = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    f = 0;
                    d = -1;
                    k = 1797693134862315708145274.0e284;
                    l = 1797693134862315708145274.0e284;
                    n = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    i = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    v = 0;
                    while(true){
                        h = +e[g + (v << 4) >> 3];
                        m = +e[g + (v << 4) + 8 >> 3];
                        z = d + 2 | 0;
                        j = +e[g + (((z | 0) == (r | 0) ? 0 : z) << 4) + 8 >> 3];
                        if (h < k) {
                            e[s >> 3] = h;
                            k = h;
                        }
                        if (m < l) {
                            e[t >> 3] = m;
                            l = m;
                        }
                        if (h > n) e[c >> 3] = h;
                        else h = n;
                        if (m > i) {
                            e[u >> 3] = m;
                            i = m;
                        }
                        o = m > 0.0 & m < o ? m : o;
                        p = m < 0.0 & m > p ? m : p;
                        f = f | +q(+(m - j)) > 3.141592653589793;
                        d = v + 1 | 0;
                        if ((d | 0) == (r | 0)) break;
                        else {
                            z = v;
                            n = h;
                            v = d;
                            d = z;
                        }
                    }
                    if (f) {
                        e[u >> 3] = p;
                        e[t >> 3] = o;
                    }
                }
            } else {
                b[c >> 2] = 0;
                b[c + 4 >> 2] = 0;
                b[c + 8 >> 2] = 0;
                b[c + 12 >> 2] = 0;
                b[c + 16 >> 2] = 0;
                b[c + 20 >> 2] = 0;
                b[c + 24 >> 2] = 0;
                b[c + 28 >> 2] = 0;
            }
            z = a + 8 | 0;
            d = b[z >> 2] | 0;
            if ((d | 0) <= 0) return;
            y = a + 12 | 0;
            x = 0;
            do {
                g = b[y >> 2] | 0;
                f = x;
                x = x + 1 | 0;
                t = c + (x << 5) | 0;
                u = b[g + (f << 3) >> 2] | 0;
                if (u) {
                    v = c + (x << 5) + 8 | 0;
                    e[v >> 3] = 1797693134862315708145274.0e284;
                    a = c + (x << 5) + 24 | 0;
                    e[a >> 3] = 1797693134862315708145274.0e284;
                    e[t >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    w = c + (x << 5) + 16 | 0;
                    e[w >> 3] = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                    if ((u | 0) > 0) {
                        r = b[g + (f << 3) + 4 >> 2] | 0;
                        o = 1797693134862315708145274.0e284;
                        p = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        g = 0;
                        f = -1;
                        s = 0;
                        k = 1797693134862315708145274.0e284;
                        l = 1797693134862315708145274.0e284;
                        m = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        i = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
                        while(true){
                            h = +e[r + (s << 4) >> 3];
                            n = +e[r + (s << 4) + 8 >> 3];
                            f = f + 2 | 0;
                            j = +e[r + (((f | 0) == (u | 0) ? 0 : f) << 4) + 8 >> 3];
                            if (h < k) {
                                e[v >> 3] = h;
                                k = h;
                            }
                            if (n < l) {
                                e[a >> 3] = n;
                                l = n;
                            }
                            if (h > m) e[t >> 3] = h;
                            else h = m;
                            if (n > i) {
                                e[w >> 3] = n;
                                i = n;
                            }
                            o = n > 0.0 & n < o ? n : o;
                            p = n < 0.0 & n > p ? n : p;
                            g = g | +q(+(n - j)) > 3.141592653589793;
                            f = s + 1 | 0;
                            if ((f | 0) == (u | 0)) break;
                            else {
                                A = s;
                                s = f;
                                m = h;
                                f = A;
                            }
                        }
                        if (g) {
                            e[w >> 3] = p;
                            e[a >> 3] = o;
                        }
                    }
                } else {
                    b[t >> 2] = 0;
                    b[t + 4 >> 2] = 0;
                    b[t + 8 >> 2] = 0;
                    b[t + 12 >> 2] = 0;
                    b[t + 16 >> 2] = 0;
                    b[t + 20 >> 2] = 0;
                    b[t + 24 >> 2] = 0;
                    b[t + 28 >> 2] = 0;
                    d = b[z >> 2] | 0;
                }
            }while ((x | 0) < (d | 0));
            return;
        }
        function Xc(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            if (!(Tc(a, c, d) | 0)) {
                f = 0;
                return f | 0;
            }
            f = a + 8 | 0;
            if ((b[f >> 2] | 0) <= 0) {
                f = 1;
                return f | 0;
            }
            e = a + 12 | 0;
            a = 0;
            while(true){
                g = a;
                a = a + 1 | 0;
                if (Tc((b[e >> 2] | 0) + (g << 3) | 0, c + (a << 5) | 0, d) | 0) {
                    a = 0;
                    e = 6;
                    break;
                }
                if ((a | 0) >= (b[f >> 2] | 0)) {
                    a = 1;
                    e = 6;
                    break;
                }
            }
            if ((e | 0) == 6) return a | 0;
            return 0;
        }
        function Yc(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0;
            k = T;
            T = T + 16 | 0;
            i = k;
            h = d + 8 | 0;
            if (!(Tc(a, c, h) | 0)) {
                j = 0;
                T = k;
                return j | 0;
            }
            j = a + 8 | 0;
            a: do if ((b[j >> 2] | 0) > 0) {
                g = a + 12 | 0;
                f = 0;
                while(true){
                    l = f;
                    f = f + 1 | 0;
                    if (Tc((b[g >> 2] | 0) + (l << 3) | 0, c + (f << 5) | 0, h) | 0) {
                        f = 0;
                        break;
                    }
                    if ((f | 0) >= (b[j >> 2] | 0)) break a;
                }
                T = k;
                return f | 0;
            }
            while (0);
            if (Zc(a, c, d, e) | 0) {
                l = 0;
                T = k;
                return l | 0;
            }
            b[i >> 2] = b[d >> 2];
            b[i + 4 >> 2] = h;
            f = b[j >> 2] | 0;
            b: do if ((f | 0) > 0) {
                a = a + 12 | 0;
                h = 0;
                g = f;
                while(true){
                    f = b[a >> 2] | 0;
                    if ((b[f + (h << 3) >> 2] | 0) > 0) {
                        if (Tc(i, e, b[f + (h << 3) + 4 >> 2] | 0) | 0) {
                            f = 0;
                            break b;
                        }
                        f = h + 1 | 0;
                        if (Zc((b[a >> 2] | 0) + (h << 3) | 0, c + (f << 5) | 0, d, e) | 0) {
                            f = 0;
                            break b;
                        }
                        g = b[j >> 2] | 0;
                    } else f = h + 1 | 0;
                    if ((f | 0) < (g | 0)) h = f;
                    else {
                        f = 1;
                        break;
                    }
                }
            } else f = 1;
            while (0);
            l = f;
            T = k;
            return l | 0;
        }
        function Zc(a, c, d, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0, o = 0.0, p = 0.0, q = 0.0, r = 0.0, s = 0.0, t = 0.0, u = 0, v = 0, w = 0.0, x = 0.0, y = 0, z = 0, A = 0;
            y = T;
            T = T + 176 | 0;
            u = y + 172 | 0;
            g = y + 168 | 0;
            v = y;
            if (!(Ba(c, f) | 0)) {
                a = 0;
                T = y;
                return a | 0;
            }
            Ca(c, f, u, g);
            Ud(v | 0, d | 0, 168);
            if ((b[d >> 2] | 0) > 0) {
                c = 0;
                do {
                    z = v + 8 + (c << 4) + 8 | 0;
                    t = +ic(+e[z >> 3], b[g >> 2] | 0);
                    e[z >> 3] = t;
                    c = c + 1 | 0;
                }while ((c | 0) < (b[d >> 2] | 0));
            }
            r = +e[f >> 3];
            s = +e[f + 8 >> 3];
            t = +ic(+e[f + 16 >> 3], b[g >> 2] | 0);
            p = +ic(+e[f + 24 >> 3], b[g >> 2] | 0);
            a: do if ((b[a >> 2] | 0) > 0) {
                f = a + 4 | 0;
                g = b[v >> 2] | 0;
                if ((g | 0) <= 0) {
                    c = 0;
                    while(true){
                        c = c + 1 | 0;
                        if ((c | 0) >= (b[a >> 2] | 0)) {
                            c = 0;
                            break a;
                        }
                    }
                }
                d = 0;
                while(true){
                    c = b[f >> 2] | 0;
                    o = +e[c + (d << 4) >> 3];
                    q = +ic(+e[c + (d << 4) + 8 >> 3], b[u >> 2] | 0);
                    c = b[f >> 2] | 0;
                    d = d + 1 | 0;
                    z = (d | 0) % (b[a >> 2] | 0) | 0;
                    h = +e[c + (z << 4) >> 3];
                    i = +ic(+e[c + (z << 4) + 8 >> 3], b[u >> 2] | 0);
                    if (((!(o >= r) | !(h >= r) ? !(o <= s) | !(h <= s) : 0) ? !(q <= p) | !(i <= p) : 0) ? !(q >= t) | !(i >= t) : 0) {
                        n = h - o;
                        l = i - q;
                        c = 0;
                        do {
                            A = c;
                            c = c + 1 | 0;
                            z = (c | 0) == (g | 0) ? 0 : c;
                            h = +e[v + 8 + (A << 4) + 8 >> 3];
                            i = +e[v + 8 + (z << 4) + 8 >> 3] - h;
                            j = +e[v + 8 + (A << 4) >> 3];
                            k = +e[v + 8 + (z << 4) >> 3] - j;
                            m = n * i - l * k;
                            if ((m != 0.0 ? (w = q - h, x = o - j, k = (w * k - i * x) / m, !(k < 0.0 | k > 1.0)) : 0) ? (m = (n * w - l * x) / m, m >= 0.0 & m <= 1.0) : 0) {
                                c = 1;
                                break a;
                            }
                        }while ((c | 0) < (g | 0));
                    }
                    if ((d | 0) >= (b[a >> 2] | 0)) {
                        c = 0;
                        break;
                    }
                }
            } else c = 0;
            while (0);
            A = c;
            T = y;
            return A | 0;
        }
        function _c(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0;
            if (Zc(a, c, d, e) | 0) {
                g = 1;
                return g | 0;
            }
            g = a + 8 | 0;
            if ((b[g >> 2] | 0) <= 0) {
                g = 0;
                return g | 0;
            }
            f = a + 12 | 0;
            a = 0;
            while(true){
                h = a;
                a = a + 1 | 0;
                if (Zc((b[f >> 2] | 0) + (h << 3) | 0, c + (a << 5) | 0, d, e) | 0) {
                    a = 1;
                    f = 6;
                    break;
                }
                if ((a | 0) >= (b[g >> 2] | 0)) {
                    a = 0;
                    f = 6;
                    break;
                }
            }
            if ((f | 0) == 6) return a | 0;
            return 0;
        }
        function $c() {
            return 8;
        }
        function ad() {
            return 16;
        }
        function bd() {
            return 168;
        }
        function cd() {
            return 8;
        }
        function dd() {
            return 16;
        }
        function ed() {
            return 12;
        }
        function fd() {
            return 8;
        }
        function gd(a) {
            a = a | 0;
            return +(+((b[a >> 2] | 0) >>> 0) + 4294967296.0 * +(b[a + 4 >> 2] | 0));
        }
        function hd(a) {
            a = a | 0;
            var b = 0.0, c = 0.0;
            c = +e[a >> 3];
            b = +e[a + 8 >> 3];
            return + +r(+(c * c + b * b));
        }
        function id(a, b, c, d, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            var g = 0.0, h = 0.0, i = 0.0, j = 0.0, k = 0.0, l = 0.0, m = 0.0, n = 0.0;
            k = +e[a >> 3];
            j = +e[b >> 3] - k;
            i = +e[a + 8 >> 3];
            h = +e[b + 8 >> 3] - i;
            m = +e[c >> 3];
            g = +e[d >> 3] - m;
            n = +e[c + 8 >> 3];
            l = +e[d + 8 >> 3] - n;
            g = (g * (i - n) - (k - m) * l) / (j * l - h * g);
            e[f >> 3] = k + j * g;
            e[f + 8 >> 3] = i + h * g;
            return;
        }
        function jd(a, b) {
            a = a | 0;
            b = b | 0;
            if (!(+q(+(+e[a >> 3] - +e[b >> 3])) < 1.1920928955078125e-07)) {
                b = 0;
                return b | 0;
            }
            b = +q(+(+e[a + 8 >> 3] - +e[b + 8 >> 3])) < 1.1920928955078125e-07;
            return b | 0;
        }
        function kd(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            f = +e[a >> 3] - +e[b >> 3];
            d = +e[a + 8 >> 3] - +e[b + 8 >> 3];
            c = +e[a + 16 >> 3] - +e[b + 16 >> 3];
            return +(f * f + d * d + c * c);
        }
        function ld(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0.0, d = 0.0, f = 0.0;
            c = +e[a >> 3];
            d = +t(+c);
            c = +u(+c);
            e[b + 16 >> 3] = c;
            c = +e[a + 8 >> 3];
            f = d * +t(+c);
            e[b >> 3] = f;
            c = d * +u(+c);
            e[b + 8 >> 3] = c;
            return;
        }
        function md(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = T;
            T = T + 16 | 0;
            f = g;
            e = Fb(a, c) | 0;
            if ((d + -1 | 0) >>> 0 > 5) {
                f = -1;
                T = g;
                return f | 0;
            }
            e = (e | 0) != 0;
            if ((d | 0) == 1 & e) {
                f = -1;
                T = g;
                return f | 0;
            }
            do if (!(nd(a, c, f) | 0)) {
                if (e) {
                    e = ((b[26352 + (d << 2) >> 2] | 0) + 5 - (b[f >> 2] | 0) | 0) % 5 | 0;
                    break;
                } else {
                    e = ((b[26384 + (d << 2) >> 2] | 0) + 6 - (b[f >> 2] | 0) | 0) % 6 | 0;
                    break;
                }
            } else e = -1;
            while (0);
            f = e;
            T = g;
            return f | 0;
        }
        function nd(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            k = T;
            T = T + 32 | 0;
            h = k + 16 | 0;
            i = k;
            e = Wb(a, c, h) | 0;
            if (e | 0) {
                d = e;
                T = k;
                return d | 0;
            }
            g = Ab(a, c) | 0;
            j = Nb(a, c) | 0;
            qa(g, i);
            e = ra(g, b[h >> 2] | 0) | 0;
            a: do if (ma(g) | 0) {
                do switch(g | 0){
                    case 4:
                        a = 0;
                        break;
                    case 14:
                        a = 1;
                        break;
                    case 24:
                        a = 2;
                        break;
                    case 38:
                        a = 3;
                        break;
                    case 49:
                        a = 4;
                        break;
                    case 58:
                        a = 5;
                        break;
                    case 63:
                        a = 6;
                        break;
                    case 72:
                        a = 7;
                        break;
                    case 83:
                        a = 8;
                        break;
                    case 97:
                        a = 9;
                        break;
                    case 107:
                        a = 10;
                        break;
                    case 117:
                        a = 11;
                        break;
                    default:
                        e = 1;
                        break a;
                }
                while (0);
                f = b[26416 + (a * 24 | 0) + 8 >> 2] | 0;
                c = b[26416 + (a * 24 | 0) + 16 >> 2] | 0;
                a = b[h >> 2] | 0;
                if ((a | 0) != (b[i >> 2] | 0)) {
                    i = na(g) | 0;
                    a = b[h >> 2] | 0;
                    if (i | (a | 0) == (c | 0)) e = (e + 1 | 0) % 6 | 0;
                }
                if ((j | 0) == 3 & (a | 0) == (c | 0)) {
                    e = (e + 5 | 0) % 6 | 0;
                    f = 22;
                    break;
                }
                if ((j | 0) == 5 & (a | 0) == (f | 0)) {
                    e = (e + 1 | 0) % 6 | 0;
                    f = 22;
                } else f = 22;
            } else f = 22;
            while (0);
            if ((f | 0) == 22) {
                b[d >> 2] = e;
                e = 0;
            }
            d = e;
            T = k;
            return d | 0;
        }
        function od(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0;
            u = T;
            T = T + 32 | 0;
            t = u + 24 | 0;
            r = u + 20 | 0;
            p = u + 8 | 0;
            o = u + 16 | 0;
            n = u;
            j = (Fb(a, c) | 0) == 0;
            j = j ? 6 : 5;
            l = Od(a | 0, c | 0, 52) | 0;
            H();
            l = l & 15;
            if (j >>> 0 <= d >>> 0) {
                e = 2;
                T = u;
                return e | 0;
            }
            m = (l | 0) == 0;
            if (!m ? (q = Pd(7, 0, (l ^ 15) * 3 | 0) | 0, (q & a | 0) == 0 & ((H() | 0) & c | 0) == 0) : 0) f = d;
            else g = 4;
            a: do if ((g | 0) == 4) {
                f = (Fb(a, c) | 0) != 0;
                if (((f ? 4 : 5) | 0) < (d | 0)) {
                    e = 1;
                    T = u;
                    return e | 0;
                }
                if (nd(a, c, t) | 0) {
                    e = 1;
                    T = u;
                    return e | 0;
                }
                g = (b[t >> 2] | 0) + d | 0;
                if (f) f = 26704 + (((g | 0) % 5 | 0) << 2) | 0;
                else f = 26736 + (((g | 0) % 6 | 0) << 2) | 0;
                q = b[f >> 2] | 0;
                if ((q | 0) == 7) {
                    e = 1;
                    T = u;
                    return e | 0;
                }
                b[r >> 2] = 0;
                f = ea(a, c, q, r, p) | 0;
                do if (!f) {
                    i = p;
                    k = b[i >> 2] | 0;
                    i = b[i + 4 >> 2] | 0;
                    h = i >>> 0 < c >>> 0 | (i | 0) == (c | 0) & k >>> 0 < a >>> 0;
                    g = h ? k : a;
                    h = h ? i : c;
                    if (!m ? (m = Pd(7, 0, (l ^ 15) * 3 | 0) | 0, (k & m | 0) == 0 & (i & (H() | 0) | 0) == 0) : 0) f = d;
                    else {
                        i = (d + -1 + j | 0) % (j | 0) | 0;
                        f = Fb(a, c) | 0;
                        if ((i | 0) < 0) I(27795, 27797, 246, 27806);
                        j = (f | 0) != 0;
                        if (((j ? 4 : 5) | 0) < (i | 0)) I(27795, 27797, 246, 27806);
                        if (nd(a, c, t) | 0) I(27795, 27797, 246, 27806);
                        f = (b[t >> 2] | 0) + i | 0;
                        if (j) f = 26704 + (((f | 0) % 5 | 0) << 2) | 0;
                        else f = 26736 + (((f | 0) % 6 | 0) << 2) | 0;
                        i = b[f >> 2] | 0;
                        if ((i | 0) == 7) I(27795, 27797, 246, 27806);
                        b[o >> 2] = 0;
                        f = ea(a, c, i, o, n) | 0;
                        if (f | 0) break;
                        k = n;
                        j = b[k >> 2] | 0;
                        k = b[k + 4 >> 2] | 0;
                        do if (k >>> 0 < h >>> 0 | (k | 0) == (h | 0) & j >>> 0 < g >>> 0) {
                            if (!(Fb(j, k) | 0)) g = b[26800 + ((((b[o >> 2] | 0) + (b[26768 + (i << 2) >> 2] | 0) | 0) % 6 | 0) << 2) >> 2] | 0;
                            else g = fa(j, k, a, c) | 0;
                            f = Fb(j, k) | 0;
                            if ((g + -1 | 0) >>> 0 > 5) {
                                f = -1;
                                g = j;
                                h = k;
                                break;
                            }
                            f = (f | 0) != 0;
                            if ((g | 0) == 1 & f) {
                                f = -1;
                                g = j;
                                h = k;
                                break;
                            }
                            do if (!(nd(j, k, t) | 0)) {
                                if (f) {
                                    f = ((b[26352 + (g << 2) >> 2] | 0) + 5 - (b[t >> 2] | 0) | 0) % 5 | 0;
                                    break;
                                } else {
                                    f = ((b[26384 + (g << 2) >> 2] | 0) + 6 - (b[t >> 2] | 0) | 0) % 6 | 0;
                                    break;
                                }
                            } else f = -1;
                            while (0);
                            g = j;
                            h = k;
                        } else f = d;
                        while (0);
                        i = p;
                        k = b[i >> 2] | 0;
                        i = b[i + 4 >> 2] | 0;
                    }
                    if ((g | 0) == (k | 0) & (h | 0) == (i | 0)) {
                        j = (Fb(k, i) | 0) != 0;
                        if (j) a = fa(k, i, a, c) | 0;
                        else a = b[26800 + ((((b[r >> 2] | 0) + (b[26768 + (q << 2) >> 2] | 0) | 0) % 6 | 0) << 2) >> 2] | 0;
                        f = Fb(k, i) | 0;
                        if ((a + -1 | 0) >>> 0 <= 5 ? (s = (f | 0) != 0, !((a | 0) == 1 & s)) : 0) {
                            do if (!(nd(k, i, t) | 0)) {
                                if (s) {
                                    f = ((b[26352 + (a << 2) >> 2] | 0) + 5 - (b[t >> 2] | 0) | 0) % 5 | 0;
                                    break;
                                } else {
                                    f = ((b[26384 + (a << 2) >> 2] | 0) + 6 - (b[t >> 2] | 0) | 0) % 6 | 0;
                                    break;
                                }
                            } else f = -1;
                            while (0);
                        } else f = -1;
                        f = f + 1 | 0;
                        f = (f | 0) == 6 | j & (f | 0) == 5 ? 0 : f;
                    }
                    c = h;
                    a = g;
                    break a;
                }
                while (0);
                e = f;
                T = u;
                return e | 0;
            }
            while (0);
            s = Pd(f | 0, 0, 56) | 0;
            t = H() | 0 | c & -2130706433 | 536870912;
            b[e >> 2] = s | a;
            b[e + 4 >> 2] = t;
            e = 0;
            T = u;
            return e | 0;
        }
        function pd(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = (Fb(a, c) | 0) == 0;
            e = od(a, c, 0, d) | 0;
            f = (e | 0) == 0;
            if (g) {
                if (!f) {
                    g = e;
                    return g | 0;
                }
                e = od(a, c, 1, d + 8 | 0) | 0;
                if (e | 0) {
                    g = e;
                    return g | 0;
                }
                e = od(a, c, 2, d + 16 | 0) | 0;
                if (e | 0) {
                    g = e;
                    return g | 0;
                }
                e = od(a, c, 3, d + 24 | 0) | 0;
                if (e | 0) {
                    g = e;
                    return g | 0;
                }
                e = od(a, c, 4, d + 32 | 0) | 0;
                if (!e) return od(a, c, 5, d + 40 | 0) | 0;
                else {
                    g = e;
                    return g | 0;
                }
            }
            if (!f) {
                g = e;
                return g | 0;
            }
            e = od(a, c, 1, d + 8 | 0) | 0;
            if (e | 0) {
                g = e;
                return g | 0;
            }
            e = od(a, c, 2, d + 16 | 0) | 0;
            if (e | 0) {
                g = e;
                return g | 0;
            }
            e = od(a, c, 3, d + 24 | 0) | 0;
            if (e | 0) {
                g = e;
                return g | 0;
            }
            e = od(a, c, 4, d + 32 | 0) | 0;
            if (e | 0) {
                g = e;
                return g | 0;
            }
            g = d + 40 | 0;
            b[g >> 2] = 0;
            b[g + 4 >> 2] = 0;
            g = 0;
            return g | 0;
        }
        function qd(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = T;
            T = T + 192 | 0;
            f = j;
            g = j + 168 | 0;
            h = Od(a | 0, c | 0, 56) | 0;
            H();
            h = h & 7;
            i = c & -2130706433 | 134217728;
            e = Wb(a, i, g) | 0;
            if (e | 0) {
                i = e;
                T = j;
                return i | 0;
            }
            c = Od(a | 0, c | 0, 52) | 0;
            H();
            c = c & 15;
            if (!(Fb(a, i) | 0)) xb(g, c, h, 1, f);
            else tb(g, c, h, 1, f);
            i = f + 8 | 0;
            b[d >> 2] = b[i >> 2];
            b[d + 4 >> 2] = b[i + 4 >> 2];
            b[d + 8 >> 2] = b[i + 8 >> 2];
            b[d + 12 >> 2] = b[i + 12 >> 2];
            i = 0;
            T = j;
            return i | 0;
        }
        function rd(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0, g = 0;
            f = T;
            T = T + 16 | 0;
            d = f;
            if (!(true & (c & 2013265920 | 0) == 536870912)) {
                e = 0;
                T = f;
                return e | 0;
            }
            e = c & -2130706433 | 134217728;
            if (!(Bb(a, e) | 0)) {
                e = 0;
                T = f;
                return e | 0;
            }
            g = Od(a | 0, c | 0, 56) | 0;
            H();
            g = (od(a, e, g & 7, d) | 0) == 0;
            e = d;
            e = g & ((b[e >> 2] | 0) == (a | 0) ? (b[e + 4 >> 2] | 0) == (c | 0) : 0) & 1;
            T = f;
            return e | 0;
        }
        function sd(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            if ((c | 0) > 0) {
                e = Dd(c, 4) | 0;
                b[a >> 2] = e;
                if (!e) I(27819, 27842, 40, 27856);
            } else b[a >> 2] = 0;
            b[a + 4 >> 2] = c;
            b[a + 8 >> 2] = 0;
            b[a + 12 >> 2] = d;
            return;
        }
        function td(a) {
            a = a | 0;
            var c = 0, d = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            g = a + 4 | 0;
            h = a + 12 | 0;
            i = a + 8 | 0;
            a: while(true){
                d = b[g >> 2] | 0;
                c = 0;
                while(true){
                    if ((c | 0) >= (d | 0)) break a;
                    f = b[a >> 2] | 0;
                    j = b[f + (c << 2) >> 2] | 0;
                    if (!j) c = c + 1 | 0;
                    else break;
                }
                c = f + (~~(+q(+(+s(10.0, + +(15 - (b[h >> 2] | 0) | 0)) * (+e[j >> 3] + +e[j + 8 >> 3]))) % +(d | 0)) >>> 0 << 2) | 0;
                d = b[c >> 2] | 0;
                b: do if (d | 0) {
                    f = j + 32 | 0;
                    if ((d | 0) == (j | 0)) b[c >> 2] = b[f >> 2];
                    else {
                        d = d + 32 | 0;
                        c = b[d >> 2] | 0;
                        if (!c) break;
                        while(true){
                            if ((c | 0) == (j | 0)) break;
                            d = c + 32 | 0;
                            c = b[d >> 2] | 0;
                            if (!c) break b;
                        }
                        b[d >> 2] = b[f >> 2];
                    }
                    Cd(j);
                    b[i >> 2] = (b[i >> 2] | 0) + -1;
                }
                while (0);
            }
            Cd(b[a >> 2] | 0);
            return;
        }
        function ud(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            e = b[a + 4 >> 2] | 0;
            d = 0;
            while(true){
                if ((d | 0) >= (e | 0)) {
                    c = 0;
                    d = 4;
                    break;
                }
                c = b[(b[a >> 2] | 0) + (d << 2) >> 2] | 0;
                if (!c) d = d + 1 | 0;
                else {
                    d = 4;
                    break;
                }
            }
            if ((d | 0) == 4) return c | 0;
            return 0;
        }
        function vd(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0, f = 0, g = 0, h = 0;
            d = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            d = (b[a >> 2] | 0) + (d << 2) | 0;
            f = b[d >> 2] | 0;
            if (!f) {
                h = 1;
                return h | 0;
            }
            h = c + 32 | 0;
            do if ((f | 0) != (c | 0)) {
                d = b[f + 32 >> 2] | 0;
                if (!d) {
                    h = 1;
                    return h | 0;
                }
                g = d;
                while(true){
                    if ((g | 0) == (c | 0)) {
                        g = 8;
                        break;
                    }
                    d = b[g + 32 >> 2] | 0;
                    if (!d) {
                        d = 1;
                        g = 10;
                        break;
                    } else {
                        f = g;
                        g = d;
                    }
                }
                if ((g | 0) == 8) {
                    b[f + 32 >> 2] = b[h >> 2];
                    break;
                } else if ((g | 0) == 10) return d | 0;
            } else b[d >> 2] = b[h >> 2];
            while (0);
            Cd(c);
            h = a + 8 | 0;
            b[h >> 2] = (b[h >> 2] | 0) + -1;
            h = 0;
            return h | 0;
        }
        function wd(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = Bd(40) | 0;
            if (!h) I(27872, 27842, 98, 27885);
            b[h >> 2] = b[c >> 2];
            b[h + 4 >> 2] = b[c + 4 >> 2];
            b[h + 8 >> 2] = b[c + 8 >> 2];
            b[h + 12 >> 2] = b[c + 12 >> 2];
            g = h + 16 | 0;
            b[g >> 2] = b[d >> 2];
            b[g + 4 >> 2] = b[d + 4 >> 2];
            b[g + 8 >> 2] = b[d + 8 >> 2];
            b[g + 12 >> 2] = b[d + 12 >> 2];
            b[h + 32 >> 2] = 0;
            g = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            g = (b[a >> 2] | 0) + (g << 2) | 0;
            f = b[g >> 2] | 0;
            do if (!f) b[g >> 2] = h;
            else {
                while(true){
                    if (hc(f, c) | 0 ? hc(f + 16 | 0, d) | 0 : 0) break;
                    g = b[f + 32 >> 2] | 0;
                    f = (g | 0) == 0 ? f : g;
                    if (!(b[f + 32 >> 2] | 0)) {
                        i = 10;
                        break;
                    }
                }
                if ((i | 0) == 10) {
                    b[f + 32 >> 2] = h;
                    break;
                }
                Cd(h);
                i = f;
                return i | 0;
            }
            while (0);
            i = a + 8 | 0;
            b[i >> 2] = (b[i >> 2] | 0) + 1;
            i = h;
            return i | 0;
        }
        function xd(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var f = 0, g = 0;
            g = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            g = b[(b[a >> 2] | 0) + (g << 2) >> 2] | 0;
            if (!g) {
                d = 0;
                return d | 0;
            }
            if (!d) {
                a = g;
                while(true){
                    if (hc(a, c) | 0) {
                        f = 10;
                        break;
                    }
                    a = b[a + 32 >> 2] | 0;
                    if (!a) {
                        a = 0;
                        f = 10;
                        break;
                    }
                }
                if ((f | 0) == 10) return a | 0;
            }
            a = g;
            while(true){
                if (hc(a, c) | 0 ? hc(a + 16 | 0, d) | 0 : 0) {
                    f = 10;
                    break;
                }
                a = b[a + 32 >> 2] | 0;
                if (!a) {
                    a = 0;
                    f = 10;
                    break;
                }
            }
            if ((f | 0) == 10) return a | 0;
            return 0;
        }
        function yd(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            d = ~~(+q(+(+s(10.0, + +(15 - (b[a + 12 >> 2] | 0) | 0)) * (+e[c >> 3] + +e[c + 8 >> 3]))) % +(b[a + 4 >> 2] | 0)) >>> 0;
            a = b[(b[a >> 2] | 0) + (d << 2) >> 2] | 0;
            if (!a) {
                d = 0;
                return d | 0;
            }
            while(true){
                if (hc(a, c) | 0) {
                    c = 5;
                    break;
                }
                a = b[a + 32 >> 2] | 0;
                if (!a) {
                    a = 0;
                    c = 5;
                    break;
                }
            }
            if ((c | 0) == 5) return a | 0;
            return 0;
        }
        function zd() {
            return 27904;
        }
        function Ad(a) {
            a = +a;
            return ~~+Wd(+a) | 0;
        }
        function Bd(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0;
            w = T;
            T = T + 16 | 0;
            n = w;
            do {
                if (a >>> 0 < 245) {
                    k = a >>> 0 < 11 ? 16 : a + 11 & -8;
                    a = k >>> 3;
                    m = b[6977] | 0;
                    d = m >>> a;
                    if (d & 3 | 0) {
                        c = (d & 1 ^ 1) + a | 0;
                        a = 27948 + (c << 1 << 2) | 0;
                        d = a + 8 | 0;
                        e = b[d >> 2] | 0;
                        f = e + 8 | 0;
                        g = b[f >> 2] | 0;
                        if ((g | 0) == (a | 0)) b[6977] = m & ~(1 << c);
                        else {
                            b[g + 12 >> 2] = a;
                            b[d >> 2] = g;
                        }
                        v = c << 3;
                        b[e + 4 >> 2] = v | 3;
                        v = e + v + 4 | 0;
                        b[v >> 2] = b[v >> 2] | 1;
                        v = f;
                        T = w;
                        return v | 0;
                    }
                    l = b[6979] | 0;
                    if (k >>> 0 > l >>> 0) {
                        if (d | 0) {
                            c = 2 << a;
                            c = d << a & (c | 0 - c);
                            c = (c & 0 - c) + -1 | 0;
                            i = c >>> 12 & 16;
                            c = c >>> i;
                            d = c >>> 5 & 8;
                            c = c >>> d;
                            g = c >>> 2 & 4;
                            c = c >>> g;
                            a = c >>> 1 & 2;
                            c = c >>> a;
                            e = c >>> 1 & 1;
                            e = (d | i | g | a | e) + (c >>> e) | 0;
                            c = 27948 + (e << 1 << 2) | 0;
                            a = c + 8 | 0;
                            g = b[a >> 2] | 0;
                            i = g + 8 | 0;
                            d = b[i >> 2] | 0;
                            if ((d | 0) == (c | 0)) {
                                a = m & ~(1 << e);
                                b[6977] = a;
                            } else {
                                b[d + 12 >> 2] = c;
                                b[a >> 2] = d;
                                a = m;
                            }
                            v = e << 3;
                            h = v - k | 0;
                            b[g + 4 >> 2] = k | 3;
                            f = g + k | 0;
                            b[f + 4 >> 2] = h | 1;
                            b[g + v >> 2] = h;
                            if (l | 0) {
                                e = b[6982] | 0;
                                c = l >>> 3;
                                d = 27948 + (c << 1 << 2) | 0;
                                c = 1 << c;
                                if (!(a & c)) {
                                    b[6977] = a | c;
                                    c = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    c = b[a >> 2] | 0;
                                }
                                b[a >> 2] = e;
                                b[c + 12 >> 2] = e;
                                b[e + 8 >> 2] = c;
                                b[e + 12 >> 2] = d;
                            }
                            b[6979] = h;
                            b[6982] = f;
                            v = i;
                            T = w;
                            return v | 0;
                        }
                        g = b[6978] | 0;
                        if (g) {
                            d = (g & 0 - g) + -1 | 0;
                            f = d >>> 12 & 16;
                            d = d >>> f;
                            e = d >>> 5 & 8;
                            d = d >>> e;
                            h = d >>> 2 & 4;
                            d = d >>> h;
                            i = d >>> 1 & 2;
                            d = d >>> i;
                            j = d >>> 1 & 1;
                            j = b[28212 + ((e | f | h | i | j) + (d >>> j) << 2) >> 2] | 0;
                            d = j;
                            i = j;
                            j = (b[j + 4 >> 2] & -8) - k | 0;
                            while(true){
                                a = b[d + 16 >> 2] | 0;
                                if (!a) {
                                    a = b[d + 20 >> 2] | 0;
                                    if (!a) break;
                                }
                                h = (b[a + 4 >> 2] & -8) - k | 0;
                                f = h >>> 0 < j >>> 0;
                                d = a;
                                i = f ? a : i;
                                j = f ? h : j;
                            }
                            h = i + k | 0;
                            if (h >>> 0 > i >>> 0) {
                                f = b[i + 24 >> 2] | 0;
                                c = b[i + 12 >> 2] | 0;
                                do if ((c | 0) == (i | 0)) {
                                    a = i + 20 | 0;
                                    c = b[a >> 2] | 0;
                                    if (!c) {
                                        a = i + 16 | 0;
                                        c = b[a >> 2] | 0;
                                        if (!c) {
                                            d = 0;
                                            break;
                                        }
                                    }
                                    while(true){
                                        e = c + 20 | 0;
                                        d = b[e >> 2] | 0;
                                        if (!d) {
                                            e = c + 16 | 0;
                                            d = b[e >> 2] | 0;
                                            if (!d) break;
                                            else {
                                                c = d;
                                                a = e;
                                            }
                                        } else {
                                            c = d;
                                            a = e;
                                        }
                                    }
                                    b[a >> 2] = 0;
                                    d = c;
                                } else {
                                    d = b[i + 8 >> 2] | 0;
                                    b[d + 12 >> 2] = c;
                                    b[c + 8 >> 2] = d;
                                    d = c;
                                }
                                while (0);
                                do if (f | 0) {
                                    c = b[i + 28 >> 2] | 0;
                                    a = 28212 + (c << 2) | 0;
                                    if ((i | 0) == (b[a >> 2] | 0)) {
                                        b[a >> 2] = d;
                                        if (!d) {
                                            b[6978] = g & ~(1 << c);
                                            break;
                                        }
                                    } else {
                                        v = f + 16 | 0;
                                        b[((b[v >> 2] | 0) == (i | 0) ? v : f + 20 | 0) >> 2] = d;
                                        if (!d) break;
                                    }
                                    b[d + 24 >> 2] = f;
                                    c = b[i + 16 >> 2] | 0;
                                    if (c | 0) {
                                        b[d + 16 >> 2] = c;
                                        b[c + 24 >> 2] = d;
                                    }
                                    c = b[i + 20 >> 2] | 0;
                                    if (c | 0) {
                                        b[d + 20 >> 2] = c;
                                        b[c + 24 >> 2] = d;
                                    }
                                }
                                while (0);
                                if (j >>> 0 < 16) {
                                    v = j + k | 0;
                                    b[i + 4 >> 2] = v | 3;
                                    v = i + v + 4 | 0;
                                    b[v >> 2] = b[v >> 2] | 1;
                                } else {
                                    b[i + 4 >> 2] = k | 3;
                                    b[h + 4 >> 2] = j | 1;
                                    b[h + j >> 2] = j;
                                    if (l | 0) {
                                        e = b[6982] | 0;
                                        c = l >>> 3;
                                        d = 27948 + (c << 1 << 2) | 0;
                                        c = 1 << c;
                                        if (!(c & m)) {
                                            b[6977] = c | m;
                                            c = d;
                                            a = d + 8 | 0;
                                        } else {
                                            a = d + 8 | 0;
                                            c = b[a >> 2] | 0;
                                        }
                                        b[a >> 2] = e;
                                        b[c + 12 >> 2] = e;
                                        b[e + 8 >> 2] = c;
                                        b[e + 12 >> 2] = d;
                                    }
                                    b[6979] = j;
                                    b[6982] = h;
                                }
                                v = i + 8 | 0;
                                T = w;
                                return v | 0;
                            } else m = k;
                        } else m = k;
                    } else m = k;
                } else if (a >>> 0 <= 4294967231) {
                    a = a + 11 | 0;
                    k = a & -8;
                    e = b[6978] | 0;
                    if (e) {
                        f = 0 - k | 0;
                        a = a >>> 8;
                        if (a) {
                            if (k >>> 0 > 16777215) j = 31;
                            else {
                                m = (a + 1048320 | 0) >>> 16 & 8;
                                q = a << m;
                                i = (q + 520192 | 0) >>> 16 & 4;
                                q = q << i;
                                j = (q + 245760 | 0) >>> 16 & 2;
                                j = 14 - (i | m | j) + (q << j >>> 15) | 0;
                                j = k >>> (j + 7 | 0) & 1 | j << 1;
                            }
                        } else j = 0;
                        d = b[28212 + (j << 2) >> 2] | 0;
                        a: do if (!d) {
                            d = 0;
                            a = 0;
                            q = 61;
                        } else {
                            a = 0;
                            i = k << ((j | 0) == 31 ? 0 : 25 - (j >>> 1) | 0);
                            g = 0;
                            while(true){
                                h = (b[d + 4 >> 2] & -8) - k | 0;
                                if (h >>> 0 < f >>> 0) {
                                    if (!h) {
                                        a = d;
                                        f = 0;
                                        q = 65;
                                        break a;
                                    } else {
                                        a = d;
                                        f = h;
                                    }
                                }
                                q = b[d + 20 >> 2] | 0;
                                d = b[d + 16 + (i >>> 31 << 2) >> 2] | 0;
                                g = (q | 0) == 0 | (q | 0) == (d | 0) ? g : q;
                                if (!d) {
                                    d = g;
                                    q = 61;
                                    break;
                                } else i = i << 1;
                            }
                        }
                        while (0);
                        if ((q | 0) == 61) {
                            if ((d | 0) == 0 & (a | 0) == 0) {
                                a = 2 << j;
                                a = (a | 0 - a) & e;
                                if (!a) {
                                    m = k;
                                    break;
                                }
                                m = (a & 0 - a) + -1 | 0;
                                h = m >>> 12 & 16;
                                m = m >>> h;
                                g = m >>> 5 & 8;
                                m = m >>> g;
                                i = m >>> 2 & 4;
                                m = m >>> i;
                                j = m >>> 1 & 2;
                                m = m >>> j;
                                d = m >>> 1 & 1;
                                a = 0;
                                d = b[28212 + ((g | h | i | j | d) + (m >>> d) << 2) >> 2] | 0;
                            }
                            if (!d) {
                                i = a;
                                h = f;
                            } else q = 65;
                        }
                        if ((q | 0) == 65) {
                            g = d;
                            while(true){
                                m = (b[g + 4 >> 2] & -8) - k | 0;
                                d = m >>> 0 < f >>> 0;
                                f = d ? m : f;
                                a = d ? g : a;
                                d = b[g + 16 >> 2] | 0;
                                if (!d) d = b[g + 20 >> 2] | 0;
                                if (!d) {
                                    i = a;
                                    h = f;
                                    break;
                                } else g = d;
                            }
                        }
                        if (((i | 0) != 0 ? h >>> 0 < ((b[6979] | 0) - k | 0) >>> 0 : 0) ? (l = i + k | 0, l >>> 0 > i >>> 0) : 0) {
                            g = b[i + 24 >> 2] | 0;
                            c = b[i + 12 >> 2] | 0;
                            do if ((c | 0) == (i | 0)) {
                                a = i + 20 | 0;
                                c = b[a >> 2] | 0;
                                if (!c) {
                                    a = i + 16 | 0;
                                    c = b[a >> 2] | 0;
                                    if (!c) {
                                        c = 0;
                                        break;
                                    }
                                }
                                while(true){
                                    f = c + 20 | 0;
                                    d = b[f >> 2] | 0;
                                    if (!d) {
                                        f = c + 16 | 0;
                                        d = b[f >> 2] | 0;
                                        if (!d) break;
                                        else {
                                            c = d;
                                            a = f;
                                        }
                                    } else {
                                        c = d;
                                        a = f;
                                    }
                                }
                                b[a >> 2] = 0;
                            } else {
                                v = b[i + 8 >> 2] | 0;
                                b[v + 12 >> 2] = c;
                                b[c + 8 >> 2] = v;
                            }
                            while (0);
                            do if (g) {
                                a = b[i + 28 >> 2] | 0;
                                d = 28212 + (a << 2) | 0;
                                if ((i | 0) == (b[d >> 2] | 0)) {
                                    b[d >> 2] = c;
                                    if (!c) {
                                        e = e & ~(1 << a);
                                        b[6978] = e;
                                        break;
                                    }
                                } else {
                                    v = g + 16 | 0;
                                    b[((b[v >> 2] | 0) == (i | 0) ? v : g + 20 | 0) >> 2] = c;
                                    if (!c) break;
                                }
                                b[c + 24 >> 2] = g;
                                a = b[i + 16 >> 2] | 0;
                                if (a | 0) {
                                    b[c + 16 >> 2] = a;
                                    b[a + 24 >> 2] = c;
                                }
                                a = b[i + 20 >> 2] | 0;
                                if (a) {
                                    b[c + 20 >> 2] = a;
                                    b[a + 24 >> 2] = c;
                                }
                            }
                            while (0);
                            b: do if (h >>> 0 < 16) {
                                v = h + k | 0;
                                b[i + 4 >> 2] = v | 3;
                                v = i + v + 4 | 0;
                                b[v >> 2] = b[v >> 2] | 1;
                            } else {
                                b[i + 4 >> 2] = k | 3;
                                b[l + 4 >> 2] = h | 1;
                                b[l + h >> 2] = h;
                                c = h >>> 3;
                                if (h >>> 0 < 256) {
                                    d = 27948 + (c << 1 << 2) | 0;
                                    a = b[6977] | 0;
                                    c = 1 << c;
                                    if (!(a & c)) {
                                        b[6977] = a | c;
                                        c = d;
                                        a = d + 8 | 0;
                                    } else {
                                        a = d + 8 | 0;
                                        c = b[a >> 2] | 0;
                                    }
                                    b[a >> 2] = l;
                                    b[c + 12 >> 2] = l;
                                    b[l + 8 >> 2] = c;
                                    b[l + 12 >> 2] = d;
                                    break;
                                }
                                c = h >>> 8;
                                if (c) {
                                    if (h >>> 0 > 16777215) d = 31;
                                    else {
                                        u = (c + 1048320 | 0) >>> 16 & 8;
                                        v = c << u;
                                        t = (v + 520192 | 0) >>> 16 & 4;
                                        v = v << t;
                                        d = (v + 245760 | 0) >>> 16 & 2;
                                        d = 14 - (t | u | d) + (v << d >>> 15) | 0;
                                        d = h >>> (d + 7 | 0) & 1 | d << 1;
                                    }
                                } else d = 0;
                                c = 28212 + (d << 2) | 0;
                                b[l + 28 >> 2] = d;
                                a = l + 16 | 0;
                                b[a + 4 >> 2] = 0;
                                b[a >> 2] = 0;
                                a = 1 << d;
                                if (!(e & a)) {
                                    b[6978] = e | a;
                                    b[c >> 2] = l;
                                    b[l + 24 >> 2] = c;
                                    b[l + 12 >> 2] = l;
                                    b[l + 8 >> 2] = l;
                                    break;
                                }
                                c = b[c >> 2] | 0;
                                c: do if ((b[c + 4 >> 2] & -8 | 0) != (h | 0)) {
                                    e = h << ((d | 0) == 31 ? 0 : 25 - (d >>> 1) | 0);
                                    while(true){
                                        d = c + 16 + (e >>> 31 << 2) | 0;
                                        a = b[d >> 2] | 0;
                                        if (!a) break;
                                        if ((b[a + 4 >> 2] & -8 | 0) == (h | 0)) {
                                            c = a;
                                            break c;
                                        } else {
                                            e = e << 1;
                                            c = a;
                                        }
                                    }
                                    b[d >> 2] = l;
                                    b[l + 24 >> 2] = c;
                                    b[l + 12 >> 2] = l;
                                    b[l + 8 >> 2] = l;
                                    break b;
                                }
                                while (0);
                                u = c + 8 | 0;
                                v = b[u >> 2] | 0;
                                b[v + 12 >> 2] = l;
                                b[u >> 2] = l;
                                b[l + 8 >> 2] = v;
                                b[l + 12 >> 2] = c;
                                b[l + 24 >> 2] = 0;
                            }
                            while (0);
                            v = i + 8 | 0;
                            T = w;
                            return v | 0;
                        } else m = k;
                    } else m = k;
                } else m = -1;
            }while (0);
            d = b[6979] | 0;
            if (d >>> 0 >= m >>> 0) {
                c = d - m | 0;
                a = b[6982] | 0;
                if (c >>> 0 > 15) {
                    v = a + m | 0;
                    b[6982] = v;
                    b[6979] = c;
                    b[v + 4 >> 2] = c | 1;
                    b[a + d >> 2] = c;
                    b[a + 4 >> 2] = m | 3;
                } else {
                    b[6979] = 0;
                    b[6982] = 0;
                    b[a + 4 >> 2] = d | 3;
                    v = a + d + 4 | 0;
                    b[v >> 2] = b[v >> 2] | 1;
                }
                v = a + 8 | 0;
                T = w;
                return v | 0;
            }
            h = b[6980] | 0;
            if (h >>> 0 > m >>> 0) {
                t = h - m | 0;
                b[6980] = t;
                v = b[6983] | 0;
                u = v + m | 0;
                b[6983] = u;
                b[u + 4 >> 2] = t | 1;
                b[v + 4 >> 2] = m | 3;
                v = v + 8 | 0;
                T = w;
                return v | 0;
            }
            if (!(b[7095] | 0)) {
                b[7097] = 4096;
                b[7096] = 4096;
                b[7098] = -1;
                b[7099] = -1;
                b[7100] = 0;
                b[7088] = 0;
                b[7095] = n & -16 ^ 1431655768;
                a = 4096;
            } else a = b[7097] | 0;
            i = m + 48 | 0;
            j = m + 47 | 0;
            g = a + j | 0;
            f = 0 - a | 0;
            k = g & f;
            if (k >>> 0 <= m >>> 0) {
                v = 0;
                T = w;
                return v | 0;
            }
            a = b[7087] | 0;
            if (a | 0 ? (l = b[7085] | 0, n = l + k | 0, n >>> 0 <= l >>> 0 | n >>> 0 > a >>> 0) : 0) {
                v = 0;
                T = w;
                return v | 0;
            }
            d: do if (!(b[7088] & 4)) {
                d = b[6983] | 0;
                e: do if (d) {
                    e = 28356;
                    while(true){
                        n = b[e >> 2] | 0;
                        if (n >>> 0 <= d >>> 0 ? (n + (b[e + 4 >> 2] | 0) | 0) >>> 0 > d >>> 0 : 0) break;
                        a = b[e + 8 >> 2] | 0;
                        if (!a) {
                            q = 128;
                            break e;
                        } else e = a;
                    }
                    c = g - h & f;
                    if (c >>> 0 < 2147483647) {
                        a = Xd(c | 0) | 0;
                        if ((a | 0) == ((b[e >> 2] | 0) + (b[e + 4 >> 2] | 0) | 0)) {
                            if ((a | 0) != -1) {
                                h = c;
                                g = a;
                                q = 145;
                                break d;
                            }
                        } else {
                            e = a;
                            q = 136;
                        }
                    } else c = 0;
                } else q = 128;
                while (0);
                do if ((q | 0) == 128) {
                    d = Xd(0) | 0;
                    if ((d | 0) != -1 ? (c = d, o = b[7096] | 0, p = o + -1 | 0, c = ((p & c | 0) == 0 ? 0 : (p + c & 0 - o) - c | 0) + k | 0, o = b[7085] | 0, p = c + o | 0, c >>> 0 > m >>> 0 & c >>> 0 < 2147483647) : 0) {
                        n = b[7087] | 0;
                        if (n | 0 ? p >>> 0 <= o >>> 0 | p >>> 0 > n >>> 0 : 0) {
                            c = 0;
                            break;
                        }
                        a = Xd(c | 0) | 0;
                        if ((a | 0) == (d | 0)) {
                            h = c;
                            g = d;
                            q = 145;
                            break d;
                        } else {
                            e = a;
                            q = 136;
                        }
                    } else c = 0;
                }
                while (0);
                do if ((q | 0) == 136) {
                    d = 0 - c | 0;
                    if (!(i >>> 0 > c >>> 0 & (c >>> 0 < 2147483647 & (e | 0) != -1))) {
                        if ((e | 0) == -1) {
                            c = 0;
                            break;
                        } else {
                            h = c;
                            g = e;
                            q = 145;
                            break d;
                        }
                    }
                    a = b[7097] | 0;
                    a = j - c + a & 0 - a;
                    if (a >>> 0 >= 2147483647) {
                        h = c;
                        g = e;
                        q = 145;
                        break d;
                    }
                    if ((Xd(a | 0) | 0) == -1) {
                        Xd(d | 0);
                        c = 0;
                        break;
                    } else {
                        h = a + c | 0;
                        g = e;
                        q = 145;
                        break d;
                    }
                }
                while (0);
                b[7088] = b[7088] | 4;
                q = 143;
            } else {
                c = 0;
                q = 143;
            }
            while (0);
            if (((q | 0) == 143 ? k >>> 0 < 2147483647 : 0) ? (t = Xd(k | 0) | 0, p = Xd(0) | 0, r = p - t | 0, s = r >>> 0 > (m + 40 | 0) >>> 0, !((t | 0) == -1 | s ^ 1 | t >>> 0 < p >>> 0 & ((t | 0) != -1 & (p | 0) != -1) ^ 1)) : 0) {
                h = s ? r : c;
                g = t;
                q = 145;
            }
            if ((q | 0) == 145) {
                c = (b[7085] | 0) + h | 0;
                b[7085] = c;
                if (c >>> 0 > (b[7086] | 0) >>> 0) b[7086] = c;
                j = b[6983] | 0;
                f: do if (j) {
                    c = 28356;
                    while(true){
                        a = b[c >> 2] | 0;
                        d = b[c + 4 >> 2] | 0;
                        if ((g | 0) == (a + d | 0)) {
                            q = 154;
                            break;
                        }
                        e = b[c + 8 >> 2] | 0;
                        if (!e) break;
                        else c = e;
                    }
                    if (((q | 0) == 154 ? (u = c + 4 | 0, (b[c + 12 >> 2] & 8 | 0) == 0) : 0) ? g >>> 0 > j >>> 0 & a >>> 0 <= j >>> 0 : 0) {
                        b[u >> 2] = d + h;
                        v = (b[6980] | 0) + h | 0;
                        t = j + 8 | 0;
                        t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                        u = j + t | 0;
                        t = v - t | 0;
                        b[6983] = u;
                        b[6980] = t;
                        b[u + 4 >> 2] = t | 1;
                        b[j + v + 4 >> 2] = 40;
                        b[6984] = b[7099];
                        break;
                    }
                    if (g >>> 0 < (b[6981] | 0) >>> 0) b[6981] = g;
                    d = g + h | 0;
                    c = 28356;
                    while(true){
                        if ((b[c >> 2] | 0) == (d | 0)) {
                            q = 162;
                            break;
                        }
                        a = b[c + 8 >> 2] | 0;
                        if (!a) break;
                        else c = a;
                    }
                    if ((q | 0) == 162 ? (b[c + 12 >> 2] & 8 | 0) == 0 : 0) {
                        b[c >> 2] = g;
                        l = c + 4 | 0;
                        b[l >> 2] = (b[l >> 2] | 0) + h;
                        l = g + 8 | 0;
                        l = g + ((l & 7 | 0) == 0 ? 0 : 0 - l & 7) | 0;
                        c = d + 8 | 0;
                        c = d + ((c & 7 | 0) == 0 ? 0 : 0 - c & 7) | 0;
                        k = l + m | 0;
                        i = c - l - m | 0;
                        b[l + 4 >> 2] = m | 3;
                        g: do if ((j | 0) == (c | 0)) {
                            v = (b[6980] | 0) + i | 0;
                            b[6980] = v;
                            b[6983] = k;
                            b[k + 4 >> 2] = v | 1;
                        } else {
                            if ((b[6982] | 0) == (c | 0)) {
                                v = (b[6979] | 0) + i | 0;
                                b[6979] = v;
                                b[6982] = k;
                                b[k + 4 >> 2] = v | 1;
                                b[k + v >> 2] = v;
                                break;
                            }
                            a = b[c + 4 >> 2] | 0;
                            if ((a & 3 | 0) == 1) {
                                h = a & -8;
                                e = a >>> 3;
                                h: do if (a >>> 0 < 256) {
                                    a = b[c + 8 >> 2] | 0;
                                    d = b[c + 12 >> 2] | 0;
                                    if ((d | 0) == (a | 0)) {
                                        b[6977] = b[6977] & ~(1 << e);
                                        break;
                                    } else {
                                        b[a + 12 >> 2] = d;
                                        b[d + 8 >> 2] = a;
                                        break;
                                    }
                                } else {
                                    g = b[c + 24 >> 2] | 0;
                                    a = b[c + 12 >> 2] | 0;
                                    do if ((a | 0) == (c | 0)) {
                                        d = c + 16 | 0;
                                        e = d + 4 | 0;
                                        a = b[e >> 2] | 0;
                                        if (!a) {
                                            a = b[d >> 2] | 0;
                                            if (!a) {
                                                a = 0;
                                                break;
                                            }
                                        } else d = e;
                                        while(true){
                                            f = a + 20 | 0;
                                            e = b[f >> 2] | 0;
                                            if (!e) {
                                                f = a + 16 | 0;
                                                e = b[f >> 2] | 0;
                                                if (!e) break;
                                                else {
                                                    a = e;
                                                    d = f;
                                                }
                                            } else {
                                                a = e;
                                                d = f;
                                            }
                                        }
                                        b[d >> 2] = 0;
                                    } else {
                                        v = b[c + 8 >> 2] | 0;
                                        b[v + 12 >> 2] = a;
                                        b[a + 8 >> 2] = v;
                                    }
                                    while (0);
                                    if (!g) break;
                                    d = b[c + 28 >> 2] | 0;
                                    e = 28212 + (d << 2) | 0;
                                    do if ((b[e >> 2] | 0) != (c | 0)) {
                                        v = g + 16 | 0;
                                        b[((b[v >> 2] | 0) == (c | 0) ? v : g + 20 | 0) >> 2] = a;
                                        if (!a) break h;
                                    } else {
                                        b[e >> 2] = a;
                                        if (a | 0) break;
                                        b[6978] = b[6978] & ~(1 << d);
                                        break h;
                                    }
                                    while (0);
                                    b[a + 24 >> 2] = g;
                                    d = c + 16 | 0;
                                    e = b[d >> 2] | 0;
                                    if (e | 0) {
                                        b[a + 16 >> 2] = e;
                                        b[e + 24 >> 2] = a;
                                    }
                                    d = b[d + 4 >> 2] | 0;
                                    if (!d) break;
                                    b[a + 20 >> 2] = d;
                                    b[d + 24 >> 2] = a;
                                }
                                while (0);
                                c = c + h | 0;
                                f = h + i | 0;
                            } else f = i;
                            c = c + 4 | 0;
                            b[c >> 2] = b[c >> 2] & -2;
                            b[k + 4 >> 2] = f | 1;
                            b[k + f >> 2] = f;
                            c = f >>> 3;
                            if (f >>> 0 < 256) {
                                d = 27948 + (c << 1 << 2) | 0;
                                a = b[6977] | 0;
                                c = 1 << c;
                                if (!(a & c)) {
                                    b[6977] = a | c;
                                    c = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    c = b[a >> 2] | 0;
                                }
                                b[a >> 2] = k;
                                b[c + 12 >> 2] = k;
                                b[k + 8 >> 2] = c;
                                b[k + 12 >> 2] = d;
                                break;
                            }
                            c = f >>> 8;
                            do if (!c) e = 0;
                            else {
                                if (f >>> 0 > 16777215) {
                                    e = 31;
                                    break;
                                }
                                u = (c + 1048320 | 0) >>> 16 & 8;
                                v = c << u;
                                t = (v + 520192 | 0) >>> 16 & 4;
                                v = v << t;
                                e = (v + 245760 | 0) >>> 16 & 2;
                                e = 14 - (t | u | e) + (v << e >>> 15) | 0;
                                e = f >>> (e + 7 | 0) & 1 | e << 1;
                            }
                            while (0);
                            c = 28212 + (e << 2) | 0;
                            b[k + 28 >> 2] = e;
                            a = k + 16 | 0;
                            b[a + 4 >> 2] = 0;
                            b[a >> 2] = 0;
                            a = b[6978] | 0;
                            d = 1 << e;
                            if (!(a & d)) {
                                b[6978] = a | d;
                                b[c >> 2] = k;
                                b[k + 24 >> 2] = c;
                                b[k + 12 >> 2] = k;
                                b[k + 8 >> 2] = k;
                                break;
                            }
                            c = b[c >> 2] | 0;
                            i: do if ((b[c + 4 >> 2] & -8 | 0) != (f | 0)) {
                                e = f << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                                while(true){
                                    d = c + 16 + (e >>> 31 << 2) | 0;
                                    a = b[d >> 2] | 0;
                                    if (!a) break;
                                    if ((b[a + 4 >> 2] & -8 | 0) == (f | 0)) {
                                        c = a;
                                        break i;
                                    } else {
                                        e = e << 1;
                                        c = a;
                                    }
                                }
                                b[d >> 2] = k;
                                b[k + 24 >> 2] = c;
                                b[k + 12 >> 2] = k;
                                b[k + 8 >> 2] = k;
                                break g;
                            }
                            while (0);
                            u = c + 8 | 0;
                            v = b[u >> 2] | 0;
                            b[v + 12 >> 2] = k;
                            b[u >> 2] = k;
                            b[k + 8 >> 2] = v;
                            b[k + 12 >> 2] = c;
                            b[k + 24 >> 2] = 0;
                        }
                        while (0);
                        v = l + 8 | 0;
                        T = w;
                        return v | 0;
                    }
                    c = 28356;
                    while(true){
                        a = b[c >> 2] | 0;
                        if (a >>> 0 <= j >>> 0 ? (v = a + (b[c + 4 >> 2] | 0) | 0, v >>> 0 > j >>> 0) : 0) break;
                        c = b[c + 8 >> 2] | 0;
                    }
                    f = v + -47 | 0;
                    a = f + 8 | 0;
                    a = f + ((a & 7 | 0) == 0 ? 0 : 0 - a & 7) | 0;
                    f = j + 16 | 0;
                    a = a >>> 0 < f >>> 0 ? j : a;
                    c = a + 8 | 0;
                    d = h + -40 | 0;
                    t = g + 8 | 0;
                    t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                    u = g + t | 0;
                    t = d - t | 0;
                    b[6983] = u;
                    b[6980] = t;
                    b[u + 4 >> 2] = t | 1;
                    b[g + d + 4 >> 2] = 40;
                    b[6984] = b[7099];
                    d = a + 4 | 0;
                    b[d >> 2] = 27;
                    b[c >> 2] = b[7089];
                    b[c + 4 >> 2] = b[7090];
                    b[c + 8 >> 2] = b[7091];
                    b[c + 12 >> 2] = b[7092];
                    b[7089] = g;
                    b[7090] = h;
                    b[7092] = 0;
                    b[7091] = c;
                    c = a + 24 | 0;
                    do {
                        u = c;
                        c = c + 4 | 0;
                        b[c >> 2] = 7;
                    }while ((u + 8 | 0) >>> 0 < v >>> 0);
                    if ((a | 0) != (j | 0)) {
                        g = a - j | 0;
                        b[d >> 2] = b[d >> 2] & -2;
                        b[j + 4 >> 2] = g | 1;
                        b[a >> 2] = g;
                        c = g >>> 3;
                        if (g >>> 0 < 256) {
                            d = 27948 + (c << 1 << 2) | 0;
                            a = b[6977] | 0;
                            c = 1 << c;
                            if (!(a & c)) {
                                b[6977] = a | c;
                                c = d;
                                a = d + 8 | 0;
                            } else {
                                a = d + 8 | 0;
                                c = b[a >> 2] | 0;
                            }
                            b[a >> 2] = j;
                            b[c + 12 >> 2] = j;
                            b[j + 8 >> 2] = c;
                            b[j + 12 >> 2] = d;
                            break;
                        }
                        c = g >>> 8;
                        if (c) {
                            if (g >>> 0 > 16777215) e = 31;
                            else {
                                u = (c + 1048320 | 0) >>> 16 & 8;
                                v = c << u;
                                t = (v + 520192 | 0) >>> 16 & 4;
                                v = v << t;
                                e = (v + 245760 | 0) >>> 16 & 2;
                                e = 14 - (t | u | e) + (v << e >>> 15) | 0;
                                e = g >>> (e + 7 | 0) & 1 | e << 1;
                            }
                        } else e = 0;
                        d = 28212 + (e << 2) | 0;
                        b[j + 28 >> 2] = e;
                        b[j + 20 >> 2] = 0;
                        b[f >> 2] = 0;
                        c = b[6978] | 0;
                        a = 1 << e;
                        if (!(c & a)) {
                            b[6978] = c | a;
                            b[d >> 2] = j;
                            b[j + 24 >> 2] = d;
                            b[j + 12 >> 2] = j;
                            b[j + 8 >> 2] = j;
                            break;
                        }
                        c = b[d >> 2] | 0;
                        j: do if ((b[c + 4 >> 2] & -8 | 0) != (g | 0)) {
                            e = g << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                            while(true){
                                d = c + 16 + (e >>> 31 << 2) | 0;
                                a = b[d >> 2] | 0;
                                if (!a) break;
                                if ((b[a + 4 >> 2] & -8 | 0) == (g | 0)) {
                                    c = a;
                                    break j;
                                } else {
                                    e = e << 1;
                                    c = a;
                                }
                            }
                            b[d >> 2] = j;
                            b[j + 24 >> 2] = c;
                            b[j + 12 >> 2] = j;
                            b[j + 8 >> 2] = j;
                            break f;
                        }
                        while (0);
                        u = c + 8 | 0;
                        v = b[u >> 2] | 0;
                        b[v + 12 >> 2] = j;
                        b[u >> 2] = j;
                        b[j + 8 >> 2] = v;
                        b[j + 12 >> 2] = c;
                        b[j + 24 >> 2] = 0;
                    }
                } else {
                    v = b[6981] | 0;
                    if ((v | 0) == 0 | g >>> 0 < v >>> 0) b[6981] = g;
                    b[7089] = g;
                    b[7090] = h;
                    b[7092] = 0;
                    b[6986] = b[7095];
                    b[6985] = -1;
                    b[6990] = 27948;
                    b[6989] = 27948;
                    b[6992] = 27956;
                    b[6991] = 27956;
                    b[6994] = 27964;
                    b[6993] = 27964;
                    b[6996] = 27972;
                    b[6995] = 27972;
                    b[6998] = 27980;
                    b[6997] = 27980;
                    b[7e3] = 27988;
                    b[6999] = 27988;
                    b[7002] = 27996;
                    b[7001] = 27996;
                    b[7004] = 28004;
                    b[7003] = 28004;
                    b[7006] = 28012;
                    b[7005] = 28012;
                    b[7008] = 28020;
                    b[7007] = 28020;
                    b[7010] = 28028;
                    b[7009] = 28028;
                    b[7012] = 28036;
                    b[7011] = 28036;
                    b[7014] = 28044;
                    b[7013] = 28044;
                    b[7016] = 28052;
                    b[7015] = 28052;
                    b[7018] = 28060;
                    b[7017] = 28060;
                    b[7020] = 28068;
                    b[7019] = 28068;
                    b[7022] = 28076;
                    b[7021] = 28076;
                    b[7024] = 28084;
                    b[7023] = 28084;
                    b[7026] = 28092;
                    b[7025] = 28092;
                    b[7028] = 28100;
                    b[7027] = 28100;
                    b[7030] = 28108;
                    b[7029] = 28108;
                    b[7032] = 28116;
                    b[7031] = 28116;
                    b[7034] = 28124;
                    b[7033] = 28124;
                    b[7036] = 28132;
                    b[7035] = 28132;
                    b[7038] = 28140;
                    b[7037] = 28140;
                    b[7040] = 28148;
                    b[7039] = 28148;
                    b[7042] = 28156;
                    b[7041] = 28156;
                    b[7044] = 28164;
                    b[7043] = 28164;
                    b[7046] = 28172;
                    b[7045] = 28172;
                    b[7048] = 28180;
                    b[7047] = 28180;
                    b[7050] = 28188;
                    b[7049] = 28188;
                    b[7052] = 28196;
                    b[7051] = 28196;
                    v = h + -40 | 0;
                    t = g + 8 | 0;
                    t = (t & 7 | 0) == 0 ? 0 : 0 - t & 7;
                    u = g + t | 0;
                    t = v - t | 0;
                    b[6983] = u;
                    b[6980] = t;
                    b[u + 4 >> 2] = t | 1;
                    b[g + v + 4 >> 2] = 40;
                    b[6984] = b[7099];
                }
                while (0);
                c = b[6980] | 0;
                if (c >>> 0 > m >>> 0) {
                    t = c - m | 0;
                    b[6980] = t;
                    v = b[6983] | 0;
                    u = v + m | 0;
                    b[6983] = u;
                    b[u + 4 >> 2] = t | 1;
                    b[v + 4 >> 2] = m | 3;
                    v = v + 8 | 0;
                    T = w;
                    return v | 0;
                }
            }
            v = zd() | 0;
            b[v >> 2] = 12;
            v = 0;
            T = w;
            return v | 0;
        }
        function Cd(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            if (!a) return;
            d = a + -8 | 0;
            f = b[6981] | 0;
            a = b[a + -4 >> 2] | 0;
            c = a & -8;
            j = d + c | 0;
            do if (!(a & 1)) {
                e = b[d >> 2] | 0;
                if (!(a & 3)) return;
                h = d + (0 - e) | 0;
                g = e + c | 0;
                if (h >>> 0 < f >>> 0) return;
                if ((b[6982] | 0) == (h | 0)) {
                    a = j + 4 | 0;
                    c = b[a >> 2] | 0;
                    if ((c & 3 | 0) != 3) {
                        i = h;
                        c = g;
                        break;
                    }
                    b[6979] = g;
                    b[a >> 2] = c & -2;
                    b[h + 4 >> 2] = g | 1;
                    b[h + g >> 2] = g;
                    return;
                }
                d = e >>> 3;
                if (e >>> 0 < 256) {
                    a = b[h + 8 >> 2] | 0;
                    c = b[h + 12 >> 2] | 0;
                    if ((c | 0) == (a | 0)) {
                        b[6977] = b[6977] & ~(1 << d);
                        i = h;
                        c = g;
                        break;
                    } else {
                        b[a + 12 >> 2] = c;
                        b[c + 8 >> 2] = a;
                        i = h;
                        c = g;
                        break;
                    }
                }
                f = b[h + 24 >> 2] | 0;
                a = b[h + 12 >> 2] | 0;
                do if ((a | 0) == (h | 0)) {
                    c = h + 16 | 0;
                    d = c + 4 | 0;
                    a = b[d >> 2] | 0;
                    if (!a) {
                        a = b[c >> 2] | 0;
                        if (!a) {
                            a = 0;
                            break;
                        }
                    } else c = d;
                    while(true){
                        e = a + 20 | 0;
                        d = b[e >> 2] | 0;
                        if (!d) {
                            e = a + 16 | 0;
                            d = b[e >> 2] | 0;
                            if (!d) break;
                            else {
                                a = d;
                                c = e;
                            }
                        } else {
                            a = d;
                            c = e;
                        }
                    }
                    b[c >> 2] = 0;
                } else {
                    i = b[h + 8 >> 2] | 0;
                    b[i + 12 >> 2] = a;
                    b[a + 8 >> 2] = i;
                }
                while (0);
                if (f) {
                    c = b[h + 28 >> 2] | 0;
                    d = 28212 + (c << 2) | 0;
                    if ((b[d >> 2] | 0) == (h | 0)) {
                        b[d >> 2] = a;
                        if (!a) {
                            b[6978] = b[6978] & ~(1 << c);
                            i = h;
                            c = g;
                            break;
                        }
                    } else {
                        i = f + 16 | 0;
                        b[((b[i >> 2] | 0) == (h | 0) ? i : f + 20 | 0) >> 2] = a;
                        if (!a) {
                            i = h;
                            c = g;
                            break;
                        }
                    }
                    b[a + 24 >> 2] = f;
                    c = h + 16 | 0;
                    d = b[c >> 2] | 0;
                    if (d | 0) {
                        b[a + 16 >> 2] = d;
                        b[d + 24 >> 2] = a;
                    }
                    c = b[c + 4 >> 2] | 0;
                    if (c) {
                        b[a + 20 >> 2] = c;
                        b[c + 24 >> 2] = a;
                        i = h;
                        c = g;
                    } else {
                        i = h;
                        c = g;
                    }
                } else {
                    i = h;
                    c = g;
                }
            } else {
                i = d;
                h = d;
            }
            while (0);
            if (h >>> 0 >= j >>> 0) return;
            a = j + 4 | 0;
            e = b[a >> 2] | 0;
            if (!(e & 1)) return;
            if (!(e & 2)) {
                if ((b[6983] | 0) == (j | 0)) {
                    j = (b[6980] | 0) + c | 0;
                    b[6980] = j;
                    b[6983] = i;
                    b[i + 4 >> 2] = j | 1;
                    if ((i | 0) != (b[6982] | 0)) return;
                    b[6982] = 0;
                    b[6979] = 0;
                    return;
                }
                if ((b[6982] | 0) == (j | 0)) {
                    j = (b[6979] | 0) + c | 0;
                    b[6979] = j;
                    b[6982] = h;
                    b[i + 4 >> 2] = j | 1;
                    b[h + j >> 2] = j;
                    return;
                }
                f = (e & -8) + c | 0;
                d = e >>> 3;
                do if (e >>> 0 < 256) {
                    c = b[j + 8 >> 2] | 0;
                    a = b[j + 12 >> 2] | 0;
                    if ((a | 0) == (c | 0)) {
                        b[6977] = b[6977] & ~(1 << d);
                        break;
                    } else {
                        b[c + 12 >> 2] = a;
                        b[a + 8 >> 2] = c;
                        break;
                    }
                } else {
                    g = b[j + 24 >> 2] | 0;
                    a = b[j + 12 >> 2] | 0;
                    do if ((a | 0) == (j | 0)) {
                        c = j + 16 | 0;
                        d = c + 4 | 0;
                        a = b[d >> 2] | 0;
                        if (!a) {
                            a = b[c >> 2] | 0;
                            if (!a) {
                                d = 0;
                                break;
                            }
                        } else c = d;
                        while(true){
                            e = a + 20 | 0;
                            d = b[e >> 2] | 0;
                            if (!d) {
                                e = a + 16 | 0;
                                d = b[e >> 2] | 0;
                                if (!d) break;
                                else {
                                    a = d;
                                    c = e;
                                }
                            } else {
                                a = d;
                                c = e;
                            }
                        }
                        b[c >> 2] = 0;
                        d = a;
                    } else {
                        d = b[j + 8 >> 2] | 0;
                        b[d + 12 >> 2] = a;
                        b[a + 8 >> 2] = d;
                        d = a;
                    }
                    while (0);
                    if (g | 0) {
                        a = b[j + 28 >> 2] | 0;
                        c = 28212 + (a << 2) | 0;
                        if ((b[c >> 2] | 0) == (j | 0)) {
                            b[c >> 2] = d;
                            if (!d) {
                                b[6978] = b[6978] & ~(1 << a);
                                break;
                            }
                        } else {
                            e = g + 16 | 0;
                            b[((b[e >> 2] | 0) == (j | 0) ? e : g + 20 | 0) >> 2] = d;
                            if (!d) break;
                        }
                        b[d + 24 >> 2] = g;
                        a = j + 16 | 0;
                        c = b[a >> 2] | 0;
                        if (c | 0) {
                            b[d + 16 >> 2] = c;
                            b[c + 24 >> 2] = d;
                        }
                        a = b[a + 4 >> 2] | 0;
                        if (a | 0) {
                            b[d + 20 >> 2] = a;
                            b[a + 24 >> 2] = d;
                        }
                    }
                }
                while (0);
                b[i + 4 >> 2] = f | 1;
                b[h + f >> 2] = f;
                if ((i | 0) == (b[6982] | 0)) {
                    b[6979] = f;
                    return;
                }
            } else {
                b[a >> 2] = e & -2;
                b[i + 4 >> 2] = c | 1;
                b[h + c >> 2] = c;
                f = c;
            }
            a = f >>> 3;
            if (f >>> 0 < 256) {
                d = 27948 + (a << 1 << 2) | 0;
                c = b[6977] | 0;
                a = 1 << a;
                if (!(c & a)) {
                    b[6977] = c | a;
                    a = d;
                    c = d + 8 | 0;
                } else {
                    c = d + 8 | 0;
                    a = b[c >> 2] | 0;
                }
                b[c >> 2] = i;
                b[a + 12 >> 2] = i;
                b[i + 8 >> 2] = a;
                b[i + 12 >> 2] = d;
                return;
            }
            a = f >>> 8;
            if (a) {
                if (f >>> 0 > 16777215) e = 31;
                else {
                    h = (a + 1048320 | 0) >>> 16 & 8;
                    j = a << h;
                    g = (j + 520192 | 0) >>> 16 & 4;
                    j = j << g;
                    e = (j + 245760 | 0) >>> 16 & 2;
                    e = 14 - (g | h | e) + (j << e >>> 15) | 0;
                    e = f >>> (e + 7 | 0) & 1 | e << 1;
                }
            } else e = 0;
            a = 28212 + (e << 2) | 0;
            b[i + 28 >> 2] = e;
            b[i + 20 >> 2] = 0;
            b[i + 16 >> 2] = 0;
            c = b[6978] | 0;
            d = 1 << e;
            a: do if (!(c & d)) {
                b[6978] = c | d;
                b[a >> 2] = i;
                b[i + 24 >> 2] = a;
                b[i + 12 >> 2] = i;
                b[i + 8 >> 2] = i;
            } else {
                a = b[a >> 2] | 0;
                b: do if ((b[a + 4 >> 2] & -8 | 0) != (f | 0)) {
                    e = f << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                    while(true){
                        d = a + 16 + (e >>> 31 << 2) | 0;
                        c = b[d >> 2] | 0;
                        if (!c) break;
                        if ((b[c + 4 >> 2] & -8 | 0) == (f | 0)) {
                            a = c;
                            break b;
                        } else {
                            e = e << 1;
                            a = c;
                        }
                    }
                    b[d >> 2] = i;
                    b[i + 24 >> 2] = a;
                    b[i + 12 >> 2] = i;
                    b[i + 8 >> 2] = i;
                    break a;
                }
                while (0);
                h = a + 8 | 0;
                j = b[h >> 2] | 0;
                b[j + 12 >> 2] = i;
                b[h >> 2] = i;
                b[i + 8 >> 2] = j;
                b[i + 12 >> 2] = a;
                b[i + 24 >> 2] = 0;
            }
            while (0);
            j = (b[6985] | 0) + -1 | 0;
            b[6985] = j;
            if (j | 0) return;
            a = 28364;
            while(true){
                a = b[a >> 2] | 0;
                if (!a) break;
                else a = a + 8 | 0;
            }
            b[6985] = -1;
            return;
        }
        function Dd(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0;
            if (a) {
                d = B(c, a) | 0;
                if ((c | a) >>> 0 > 65535) d = ((d >>> 0) / (a >>> 0) | 0) == (c | 0) ? d : -1;
            } else d = 0;
            a = Bd(d) | 0;
            if (!a) return a | 0;
            if (!(b[a + -4 >> 2] & 3)) return a | 0;
            Vd(a | 0, 0, d | 0);
            return a | 0;
        }
        function Ed(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            c = a + c >>> 0;
            return (G(b + d + (c >>> 0 < a >>> 0 | 0) >>> 0 | 0), c | 0) | 0;
        }
        function Fd(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            d = b - d - (c >>> 0 > a >>> 0 | 0) >>> 0;
            return (G(d | 0), a - c >>> 0 | 0) | 0;
        }
        function Gd(a) {
            a = a | 0;
            return (a ? 31 - (E(a ^ a - 1) | 0) | 0 : 32) | 0;
        }
        function Hd(a, c, d, e, f) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            l = a;
            j = c;
            k = j;
            h = d;
            n = e;
            i = n;
            if (!k) {
                g = (f | 0) != 0;
                if (!i) {
                    if (g) {
                        b[f >> 2] = (l >>> 0) % (h >>> 0);
                        b[f + 4 >> 2] = 0;
                    }
                    n = 0;
                    f = (l >>> 0) / (h >>> 0) >>> 0;
                    return (G(n | 0), f) | 0;
                } else {
                    if (!g) {
                        n = 0;
                        f = 0;
                        return (G(n | 0), f) | 0;
                    }
                    b[f >> 2] = a | 0;
                    b[f + 4 >> 2] = c & 0;
                    n = 0;
                    f = 0;
                    return (G(n | 0), f) | 0;
                }
            }
            g = (i | 0) == 0;
            do if (h) {
                if (!g) {
                    g = (E(i | 0) | 0) - (E(k | 0) | 0) | 0;
                    if (g >>> 0 <= 31) {
                        m = g + 1 | 0;
                        i = 31 - g | 0;
                        c = g - 31 >> 31;
                        h = m;
                        a = l >>> (m >>> 0) & c | k << i;
                        c = k >>> (m >>> 0) & c;
                        g = 0;
                        i = l << i;
                        break;
                    }
                    if (!f) {
                        n = 0;
                        f = 0;
                        return (G(n | 0), f) | 0;
                    }
                    b[f >> 2] = a | 0;
                    b[f + 4 >> 2] = j | c & 0;
                    n = 0;
                    f = 0;
                    return (G(n | 0), f) | 0;
                }
                g = h - 1 | 0;
                if (g & h | 0) {
                    i = (E(h | 0) | 0) + 33 - (E(k | 0) | 0) | 0;
                    p = 64 - i | 0;
                    m = 32 - i | 0;
                    j = m >> 31;
                    o = i - 32 | 0;
                    c = o >> 31;
                    h = i;
                    a = m - 1 >> 31 & k >>> (o >>> 0) | (k << m | l >>> (i >>> 0)) & c;
                    c = c & k >>> (i >>> 0);
                    g = l << p & j;
                    i = (k << p | l >>> (o >>> 0)) & j | l << m & i - 33 >> 31;
                    break;
                }
                if (f | 0) {
                    b[f >> 2] = g & l;
                    b[f + 4 >> 2] = 0;
                }
                if ((h | 0) == 1) {
                    o = j | c & 0;
                    p = a | 0;
                    return (G(o | 0), p) | 0;
                } else {
                    p = Gd(h | 0) | 0;
                    o = k >>> (p >>> 0) | 0;
                    p = k << 32 - p | l >>> (p >>> 0) | 0;
                    return (G(o | 0), p) | 0;
                }
            } else {
                if (g) {
                    if (f | 0) {
                        b[f >> 2] = (k >>> 0) % (h >>> 0);
                        b[f + 4 >> 2] = 0;
                    }
                    o = 0;
                    p = (k >>> 0) / (h >>> 0) >>> 0;
                    return (G(o | 0), p) | 0;
                }
                if (!l) {
                    if (f | 0) {
                        b[f >> 2] = 0;
                        b[f + 4 >> 2] = (k >>> 0) % (i >>> 0);
                    }
                    o = 0;
                    p = (k >>> 0) / (i >>> 0) >>> 0;
                    return (G(o | 0), p) | 0;
                }
                g = i - 1 | 0;
                if (!(g & i)) {
                    if (f | 0) {
                        b[f >> 2] = a | 0;
                        b[f + 4 >> 2] = g & k | c & 0;
                    }
                    o = 0;
                    p = k >>> ((Gd(i | 0) | 0) >>> 0);
                    return (G(o | 0), p) | 0;
                }
                g = (E(i | 0) | 0) - (E(k | 0) | 0) | 0;
                if (g >>> 0 <= 30) {
                    c = g + 1 | 0;
                    i = 31 - g | 0;
                    h = c;
                    a = k << i | l >>> (c >>> 0);
                    c = k >>> (c >>> 0);
                    g = 0;
                    i = l << i;
                    break;
                }
                if (!f) {
                    o = 0;
                    p = 0;
                    return (G(o | 0), p) | 0;
                }
                b[f >> 2] = a | 0;
                b[f + 4 >> 2] = j | c & 0;
                o = 0;
                p = 0;
                return (G(o | 0), p) | 0;
            }
            while (0);
            if (!h) {
                k = i;
                j = 0;
                i = 0;
            } else {
                m = d | 0;
                l = n | e & 0;
                k = Ed(m | 0, l | 0, -1, -1) | 0;
                d = H() | 0;
                j = i;
                i = 0;
                do {
                    e = j;
                    j = g >>> 31 | j << 1;
                    g = i | g << 1;
                    e = a << 1 | e >>> 31 | 0;
                    n = a >>> 31 | c << 1 | 0;
                    Fd(k | 0, d | 0, e | 0, n | 0);
                    p = H() | 0;
                    o = p >> 31 | ((p | 0) < 0 ? -1 : 0) << 1;
                    i = o & 1;
                    a = Fd(e | 0, n | 0, o & m | 0, (((p | 0) < 0 ? -1 : 0) >> 31 | ((p | 0) < 0 ? -1 : 0) << 1) & l | 0) | 0;
                    c = H() | 0;
                    h = h - 1 | 0;
                }while ((h | 0) != 0);
                k = j;
                j = 0;
            }
            h = 0;
            if (f | 0) {
                b[f >> 2] = a;
                b[f + 4 >> 2] = c;
            }
            o = (g | 0) >>> 31 | (k | h) << 1 | (h << 1 | g >>> 31) & 0 | j;
            p = (g << 1 | 0) & -2 | i;
            return (G(o | 0), p) | 0;
        }
        function Id(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = b >> 31 | ((b | 0) < 0 ? -1 : 0) << 1;
            i = ((b | 0) < 0 ? -1 : 0) >> 31 | ((b | 0) < 0 ? -1 : 0) << 1;
            f = d >> 31 | ((d | 0) < 0 ? -1 : 0) << 1;
            e = ((d | 0) < 0 ? -1 : 0) >> 31 | ((d | 0) < 0 ? -1 : 0) << 1;
            h = Fd(j ^ a | 0, i ^ b | 0, j | 0, i | 0) | 0;
            g = H() | 0;
            a = f ^ j;
            b = e ^ i;
            return Fd((Hd(h, g, Fd(f ^ c | 0, e ^ d | 0, f | 0, e | 0) | 0, H() | 0, 0) | 0) ^ a | 0, (H() | 0) ^ b | 0, a | 0, b | 0) | 0;
        }
        function Jd(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0, e = 0, f = 0;
            f = a & 65535;
            e = b & 65535;
            c = B(e, f) | 0;
            d = a >>> 16;
            a = (c >>> 16) + (B(e, d) | 0) | 0;
            e = b >>> 16;
            b = B(e, f) | 0;
            return (G((a >>> 16) + (B(e, d) | 0) + (((a & 65535) + b | 0) >>> 16) | 0), a + b << 16 | c & 65535 | 0) | 0;
        }
        function Kd(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = a;
            f = c;
            c = Jd(e, f) | 0;
            a = H() | 0;
            return (G((B(b, f) | 0) + (B(d, e) | 0) + a | a & 0 | 0), c | 0) | 0;
        }
        function Ld(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            f = T;
            T = T + 16 | 0;
            i = f | 0;
            h = c >> 31 | ((c | 0) < 0 ? -1 : 0) << 1;
            g = ((c | 0) < 0 ? -1 : 0) >> 31 | ((c | 0) < 0 ? -1 : 0) << 1;
            k = e >> 31 | ((e | 0) < 0 ? -1 : 0) << 1;
            j = ((e | 0) < 0 ? -1 : 0) >> 31 | ((e | 0) < 0 ? -1 : 0) << 1;
            a = Fd(h ^ a | 0, g ^ c | 0, h | 0, g | 0) | 0;
            c = H() | 0;
            Hd(a, c, Fd(k ^ d | 0, j ^ e | 0, k | 0, j | 0) | 0, H() | 0, i);
            e = Fd(b[i >> 2] ^ h | 0, b[i + 4 >> 2] ^ g | 0, h | 0, g | 0) | 0;
            d = H() | 0;
            T = f;
            return (G(d | 0), e) | 0;
        }
        function Md(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = T;
            T = T + 16 | 0;
            f = g | 0;
            Hd(a, c, d, e, f);
            T = g;
            return (G(b[f + 4 >> 2] | 0), b[f >> 2] | 0) | 0;
        }
        function Nd(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                G(b >> c | 0);
                return a >>> c | (b & (1 << c) - 1) << 32 - c;
            }
            G(((b | 0) < 0 ? -1 : 0) | 0);
            return b >> c - 32 | 0;
        }
        function Od(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                G(b >>> c | 0);
                return a >>> c | (b & (1 << c) - 1) << 32 - c;
            }
            G(0);
            return b >>> c - 32 | 0;
        }
        function Pd(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                G(b << c | (a & (1 << c) - 1 << 32 - c) >>> 32 - c | 0);
                return a << c;
            }
            G(a << c - 32 | 0);
            return 0;
        }
        function Qd(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            b = E(b) | 0;
            if ((b | 0) == 32) b = b + (E(a) | 0) | 0;
            G(0);
            return b | 0;
        }
        function Rd(a, b) {
            a = +a;
            b = +b;
            if (a != a) return +b;
            if (b != b) return +a;
            return +D(+a, +b);
        }
        function Sd(a, b) {
            a = +a;
            b = +b;
            if (a != a) return +b;
            if (b != b) return +a;
            return +C(+a, +b);
        }
        function Td(a) {
            a = +a;
            return a >= 0.0 ? +p(a + .5) : +A(a - .5);
        }
        function Ud(c, d, e) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0;
            if ((e | 0) >= 8192) {
                L(c | 0, d | 0, e | 0);
                return c | 0;
            }
            h = c | 0;
            g = c + e | 0;
            if ((c & 3) == (d & 3)) {
                while(c & 3){
                    if (!e) return h | 0;
                    a[c >> 0] = a[d >> 0] | 0;
                    c = c + 1 | 0;
                    d = d + 1 | 0;
                    e = e - 1 | 0;
                }
                e = g & -4 | 0;
                f = e - 64 | 0;
                while((c | 0) <= (f | 0)){
                    b[c >> 2] = b[d >> 2];
                    b[c + 4 >> 2] = b[d + 4 >> 2];
                    b[c + 8 >> 2] = b[d + 8 >> 2];
                    b[c + 12 >> 2] = b[d + 12 >> 2];
                    b[c + 16 >> 2] = b[d + 16 >> 2];
                    b[c + 20 >> 2] = b[d + 20 >> 2];
                    b[c + 24 >> 2] = b[d + 24 >> 2];
                    b[c + 28 >> 2] = b[d + 28 >> 2];
                    b[c + 32 >> 2] = b[d + 32 >> 2];
                    b[c + 36 >> 2] = b[d + 36 >> 2];
                    b[c + 40 >> 2] = b[d + 40 >> 2];
                    b[c + 44 >> 2] = b[d + 44 >> 2];
                    b[c + 48 >> 2] = b[d + 48 >> 2];
                    b[c + 52 >> 2] = b[d + 52 >> 2];
                    b[c + 56 >> 2] = b[d + 56 >> 2];
                    b[c + 60 >> 2] = b[d + 60 >> 2];
                    c = c + 64 | 0;
                    d = d + 64 | 0;
                }
                while((c | 0) < (e | 0)){
                    b[c >> 2] = b[d >> 2];
                    c = c + 4 | 0;
                    d = d + 4 | 0;
                }
            } else {
                e = g - 4 | 0;
                while((c | 0) < (e | 0)){
                    a[c >> 0] = a[d >> 0] | 0;
                    a[c + 1 >> 0] = a[d + 1 >> 0] | 0;
                    a[c + 2 >> 0] = a[d + 2 >> 0] | 0;
                    a[c + 3 >> 0] = a[d + 3 >> 0] | 0;
                    c = c + 4 | 0;
                    d = d + 4 | 0;
                }
            }
            while((c | 0) < (g | 0)){
                a[c >> 0] = a[d >> 0] | 0;
                c = c + 1 | 0;
                d = d + 1 | 0;
            }
            return h | 0;
        }
        function Vd(c, d, e) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = c + e | 0;
            d = d & 255;
            if ((e | 0) >= 67) {
                while(c & 3){
                    a[c >> 0] = d;
                    c = c + 1 | 0;
                }
                f = h & -4 | 0;
                i = d | d << 8 | d << 16 | d << 24;
                g = f - 64 | 0;
                while((c | 0) <= (g | 0)){
                    b[c >> 2] = i;
                    b[c + 4 >> 2] = i;
                    b[c + 8 >> 2] = i;
                    b[c + 12 >> 2] = i;
                    b[c + 16 >> 2] = i;
                    b[c + 20 >> 2] = i;
                    b[c + 24 >> 2] = i;
                    b[c + 28 >> 2] = i;
                    b[c + 32 >> 2] = i;
                    b[c + 36 >> 2] = i;
                    b[c + 40 >> 2] = i;
                    b[c + 44 >> 2] = i;
                    b[c + 48 >> 2] = i;
                    b[c + 52 >> 2] = i;
                    b[c + 56 >> 2] = i;
                    b[c + 60 >> 2] = i;
                    c = c + 64 | 0;
                }
                while((c | 0) < (f | 0)){
                    b[c >> 2] = i;
                    c = c + 4 | 0;
                }
            }
            while((c | 0) < (h | 0)){
                a[c >> 0] = d;
                c = c + 1 | 0;
            }
            return h - e | 0;
        }
        function Wd(a) {
            a = +a;
            return a >= 0.0 ? +p(a + .5) : +A(a - .5);
        }
        function Xd(a) {
            a = a | 0;
            var c = 0, d = 0, e = 0;
            e = K() | 0;
            d = b[g >> 2] | 0;
            c = d + a | 0;
            if ((a | 0) > 0 & (c | 0) < (d | 0) | (c | 0) < 0) {
                N(c | 0);
                J(12);
                return -1;
            }
            if ((c | 0) > (e | 0)) {
                if (!(M(c | 0) | 0)) {
                    J(12);
                    return -1;
                }
            }
            b[g >> 2] = c;
            return d | 0;
        }
        // EMSCRIPTEN_END_FUNCS
        return {
            ___divdi3: Id,
            ___muldi3: Kd,
            ___remdi3: Ld,
            ___uremdi3: Md,
            _areNeighborCells: gb,
            _bitshift64Ashr: Nd,
            _bitshift64Lshr: Od,
            _bitshift64Shl: Pd,
            _calloc: Dd,
            _cellAreaKm2: vc,
            _cellAreaM2: wc,
            _cellAreaRads2: uc,
            _cellToBoundary: Yb,
            _cellToCenterChild: Ib,
            _cellToChildPos: bc,
            _cellToChildren: Gb,
            _cellToChildrenSize: Eb,
            _cellToLatLng: Xb,
            _cellToLocalIj: Hc,
            _cellToParent: Db,
            _cellToVertex: od,
            _cellToVertexes: pd,
            _cellsToDirectedEdge: hb,
            _cellsToLinkedMultiPolygon: la,
            _childPosToCell: cc,
            _compactCells: Jb,
            _destroyLinkedMultiPolygon: Cc,
            _directedEdgeToBoundary: nb,
            _directedEdgeToCells: lb,
            _edgeLengthKm: yc,
            _edgeLengthM: zc,
            _edgeLengthRads: xc,
            _emscripten_replace_memory: W,
            _free: Cd,
            _getBaseCellNumber: Ab,
            _getDirectedEdgeDestination: jb,
            _getDirectedEdgeOrigin: ib,
            _getHexagonAreaAvgKm2: oc,
            _getHexagonAreaAvgM2: pc,
            _getHexagonEdgeLengthAvgKm: qc,
            _getHexagonEdgeLengthAvgM: rc,
            _getIcosahedronFaces: _b,
            _getNumCells: sc,
            _getPentagons: ac,
            _getRes0Cells: wa,
            _getResolution: zb,
            _greatCircleDistanceKm: kc,
            _greatCircleDistanceM: lc,
            _greatCircleDistanceRads: jc,
            _gridDisk: aa,
            _gridDiskDistances: ba,
            _gridDistance: Jc,
            _gridPathCells: Lc,
            _gridPathCellsSize: Kc,
            _gridRingUnsafe: ga,
            _i64Add: Ed,
            _i64Subtract: Fd,
            _isPentagon: Fb,
            _isResClassIII: Mb,
            _isValidCell: Bb,
            _isValidDirectedEdge: kb,
            _isValidVertex: rd,
            _latLngToCell: Ub,
            _llvm_ctlz_i64: Qd,
            _llvm_maxnum_f64: Rd,
            _llvm_minnum_f64: Sd,
            _llvm_round_f64: Td,
            _localIjToCell: Ic,
            _malloc: Bd,
            _maxFaceCount: Zb,
            _maxGridDiskSize: $,
            _maxPolygonToCellsSize: ha,
            _maxPolygonToCellsSizeExperimental: Sc,
            _memcpy: Ud,
            _memset: Vd,
            _originToDirectedEdges: mb,
            _pentagonCount: $b,
            _polygonToCells: ja,
            _polygonToCellsExperimental: Rc,
            _readInt64AsDoubleFromPointer: gd,
            _res0CellCount: va,
            _round: Wd,
            _sbrk: Xd,
            _sizeOfCellBoundary: bd,
            _sizeOfCoordIJ: fd,
            _sizeOfGeoLoop: cd,
            _sizeOfGeoPolygon: dd,
            _sizeOfH3Index: $c,
            _sizeOfLatLng: ad,
            _sizeOfLinkedGeoPolygon: ed,
            _uncompactCells: Kb,
            _uncompactCellsSize: Lb,
            _vertexToLatLng: qd,
            establishStackSpace: _,
            stackAlloc: X,
            stackRestore: Z,
            stackSave: Y
        };
    }(asmGlobalArg, asmLibraryArg, buffer);
    var ___divdi3 = Module["___divdi3"] = asm["___divdi3"];
    var ___muldi3 = Module["___muldi3"] = asm["___muldi3"];
    var ___remdi3 = Module["___remdi3"] = asm["___remdi3"];
    var ___uremdi3 = Module["___uremdi3"] = asm["___uremdi3"];
    var _areNeighborCells = Module["_areNeighborCells"] = asm["_areNeighborCells"];
    var _bitshift64Ashr = Module["_bitshift64Ashr"] = asm["_bitshift64Ashr"];
    var _bitshift64Lshr = Module["_bitshift64Lshr"] = asm["_bitshift64Lshr"];
    var _bitshift64Shl = Module["_bitshift64Shl"] = asm["_bitshift64Shl"];
    var _calloc = Module["_calloc"] = asm["_calloc"];
    var _cellAreaKm2 = Module["_cellAreaKm2"] = asm["_cellAreaKm2"];
    var _cellAreaM2 = Module["_cellAreaM2"] = asm["_cellAreaM2"];
    var _cellAreaRads2 = Module["_cellAreaRads2"] = asm["_cellAreaRads2"];
    var _cellToBoundary = Module["_cellToBoundary"] = asm["_cellToBoundary"];
    var _cellToCenterChild = Module["_cellToCenterChild"] = asm["_cellToCenterChild"];
    var _cellToChildPos = Module["_cellToChildPos"] = asm["_cellToChildPos"];
    var _cellToChildren = Module["_cellToChildren"] = asm["_cellToChildren"];
    var _cellToChildrenSize = Module["_cellToChildrenSize"] = asm["_cellToChildrenSize"];
    var _cellToLatLng = Module["_cellToLatLng"] = asm["_cellToLatLng"];
    var _cellToLocalIj = Module["_cellToLocalIj"] = asm["_cellToLocalIj"];
    var _cellToParent = Module["_cellToParent"] = asm["_cellToParent"];
    var _cellToVertex = Module["_cellToVertex"] = asm["_cellToVertex"];
    var _cellToVertexes = Module["_cellToVertexes"] = asm["_cellToVertexes"];
    var _cellsToDirectedEdge = Module["_cellsToDirectedEdge"] = asm["_cellsToDirectedEdge"];
    var _cellsToLinkedMultiPolygon = Module["_cellsToLinkedMultiPolygon"] = asm["_cellsToLinkedMultiPolygon"];
    var _childPosToCell = Module["_childPosToCell"] = asm["_childPosToCell"];
    var _compactCells = Module["_compactCells"] = asm["_compactCells"];
    var _destroyLinkedMultiPolygon = Module["_destroyLinkedMultiPolygon"] = asm["_destroyLinkedMultiPolygon"];
    var _directedEdgeToBoundary = Module["_directedEdgeToBoundary"] = asm["_directedEdgeToBoundary"];
    var _directedEdgeToCells = Module["_directedEdgeToCells"] = asm["_directedEdgeToCells"];
    var _edgeLengthKm = Module["_edgeLengthKm"] = asm["_edgeLengthKm"];
    var _edgeLengthM = Module["_edgeLengthM"] = asm["_edgeLengthM"];
    var _edgeLengthRads = Module["_edgeLengthRads"] = asm["_edgeLengthRads"];
    var _emscripten_replace_memory = Module["_emscripten_replace_memory"] = asm["_emscripten_replace_memory"];
    var _free = Module["_free"] = asm["_free"];
    var _getBaseCellNumber = Module["_getBaseCellNumber"] = asm["_getBaseCellNumber"];
    var _getDirectedEdgeDestination = Module["_getDirectedEdgeDestination"] = asm["_getDirectedEdgeDestination"];
    var _getDirectedEdgeOrigin = Module["_getDirectedEdgeOrigin"] = asm["_getDirectedEdgeOrigin"];
    var _getHexagonAreaAvgKm2 = Module["_getHexagonAreaAvgKm2"] = asm["_getHexagonAreaAvgKm2"];
    var _getHexagonAreaAvgM2 = Module["_getHexagonAreaAvgM2"] = asm["_getHexagonAreaAvgM2"];
    var _getHexagonEdgeLengthAvgKm = Module["_getHexagonEdgeLengthAvgKm"] = asm["_getHexagonEdgeLengthAvgKm"];
    var _getHexagonEdgeLengthAvgM = Module["_getHexagonEdgeLengthAvgM"] = asm["_getHexagonEdgeLengthAvgM"];
    var _getIcosahedronFaces = Module["_getIcosahedronFaces"] = asm["_getIcosahedronFaces"];
    var _getNumCells = Module["_getNumCells"] = asm["_getNumCells"];
    var _getPentagons = Module["_getPentagons"] = asm["_getPentagons"];
    var _getRes0Cells = Module["_getRes0Cells"] = asm["_getRes0Cells"];
    var _getResolution = Module["_getResolution"] = asm["_getResolution"];
    var _greatCircleDistanceKm = Module["_greatCircleDistanceKm"] = asm["_greatCircleDistanceKm"];
    var _greatCircleDistanceM = Module["_greatCircleDistanceM"] = asm["_greatCircleDistanceM"];
    var _greatCircleDistanceRads = Module["_greatCircleDistanceRads"] = asm["_greatCircleDistanceRads"];
    var _gridDisk = Module["_gridDisk"] = asm["_gridDisk"];
    var _gridDiskDistances = Module["_gridDiskDistances"] = asm["_gridDiskDistances"];
    var _gridDistance = Module["_gridDistance"] = asm["_gridDistance"];
    var _gridPathCells = Module["_gridPathCells"] = asm["_gridPathCells"];
    var _gridPathCellsSize = Module["_gridPathCellsSize"] = asm["_gridPathCellsSize"];
    var _gridRingUnsafe = Module["_gridRingUnsafe"] = asm["_gridRingUnsafe"];
    var _i64Add = Module["_i64Add"] = asm["_i64Add"];
    var _i64Subtract = Module["_i64Subtract"] = asm["_i64Subtract"];
    var _isPentagon = Module["_isPentagon"] = asm["_isPentagon"];
    var _isResClassIII = Module["_isResClassIII"] = asm["_isResClassIII"];
    var _isValidCell = Module["_isValidCell"] = asm["_isValidCell"];
    var _isValidDirectedEdge = Module["_isValidDirectedEdge"] = asm["_isValidDirectedEdge"];
    var _isValidVertex = Module["_isValidVertex"] = asm["_isValidVertex"];
    var _latLngToCell = Module["_latLngToCell"] = asm["_latLngToCell"];
    var _llvm_ctlz_i64 = Module["_llvm_ctlz_i64"] = asm["_llvm_ctlz_i64"];
    var _llvm_maxnum_f64 = Module["_llvm_maxnum_f64"] = asm["_llvm_maxnum_f64"];
    var _llvm_minnum_f64 = Module["_llvm_minnum_f64"] = asm["_llvm_minnum_f64"];
    var _llvm_round_f64 = Module["_llvm_round_f64"] = asm["_llvm_round_f64"];
    var _localIjToCell = Module["_localIjToCell"] = asm["_localIjToCell"];
    var _malloc = Module["_malloc"] = asm["_malloc"];
    var _maxFaceCount = Module["_maxFaceCount"] = asm["_maxFaceCount"];
    var _maxGridDiskSize = Module["_maxGridDiskSize"] = asm["_maxGridDiskSize"];
    var _maxPolygonToCellsSize = Module["_maxPolygonToCellsSize"] = asm["_maxPolygonToCellsSize"];
    var _maxPolygonToCellsSizeExperimental = Module["_maxPolygonToCellsSizeExperimental"] = asm["_maxPolygonToCellsSizeExperimental"];
    var _memcpy = Module["_memcpy"] = asm["_memcpy"];
    var _memset = Module["_memset"] = asm["_memset"];
    var _originToDirectedEdges = Module["_originToDirectedEdges"] = asm["_originToDirectedEdges"];
    var _pentagonCount = Module["_pentagonCount"] = asm["_pentagonCount"];
    var _polygonToCells = Module["_polygonToCells"] = asm["_polygonToCells"];
    var _polygonToCellsExperimental = Module["_polygonToCellsExperimental"] = asm["_polygonToCellsExperimental"];
    var _readInt64AsDoubleFromPointer = Module["_readInt64AsDoubleFromPointer"] = asm["_readInt64AsDoubleFromPointer"];
    var _res0CellCount = Module["_res0CellCount"] = asm["_res0CellCount"];
    var _round = Module["_round"] = asm["_round"];
    var _sbrk = Module["_sbrk"] = asm["_sbrk"];
    var _sizeOfCellBoundary = Module["_sizeOfCellBoundary"] = asm["_sizeOfCellBoundary"];
    var _sizeOfCoordIJ = Module["_sizeOfCoordIJ"] = asm["_sizeOfCoordIJ"];
    var _sizeOfGeoLoop = Module["_sizeOfGeoLoop"] = asm["_sizeOfGeoLoop"];
    var _sizeOfGeoPolygon = Module["_sizeOfGeoPolygon"] = asm["_sizeOfGeoPolygon"];
    var _sizeOfH3Index = Module["_sizeOfH3Index"] = asm["_sizeOfH3Index"];
    var _sizeOfLatLng = Module["_sizeOfLatLng"] = asm["_sizeOfLatLng"];
    var _sizeOfLinkedGeoPolygon = Module["_sizeOfLinkedGeoPolygon"] = asm["_sizeOfLinkedGeoPolygon"];
    var _uncompactCells = Module["_uncompactCells"] = asm["_uncompactCells"];
    var _uncompactCellsSize = Module["_uncompactCellsSize"] = asm["_uncompactCellsSize"];
    var _vertexToLatLng = Module["_vertexToLatLng"] = asm["_vertexToLatLng"];
    var establishStackSpace = Module["establishStackSpace"] = asm["establishStackSpace"];
    var stackAlloc = Module["stackAlloc"] = asm["stackAlloc"];
    var stackRestore = Module["stackRestore"] = asm["stackRestore"];
    var stackSave = Module["stackSave"] = asm["stackSave"];
    Module["asm"] = asm;
    Module["cwrap"] = cwrap;
    Module["setValue"] = setValue;
    Module["getValue"] = getValue;
    if (memoryInitializer) {
        if (!isDataURI(memoryInitializer)) memoryInitializer = locateFile(memoryInitializer);
        addRunDependency("memory initializer");
        var applyMemoryInitializer = function(data) {
            if (data.byteLength) data = new Uint8Array(data);
            HEAPU8.set(data, GLOBAL_BASE);
            if (Module["memoryInitializerRequest"]) delete Module["memoryInitializerRequest"].response;
            removeRunDependency("memory initializer");
        };
        var doBrowserLoad = function() {
            readAsync(memoryInitializer, applyMemoryInitializer, function() {
                throw "could not load memory initializer " + memoryInitializer;
            });
        };
        var memoryInitializerBytes = tryParseAsDataURI(memoryInitializer);
        if (memoryInitializerBytes) applyMemoryInitializer(memoryInitializerBytes.buffer);
        else if (Module["memoryInitializerRequest"]) {
            var useRequest = function() {
                var request = Module["memoryInitializerRequest"];
                var response = request.response;
                if (request.status !== 200 && request.status !== 0) {
                    var data = tryParseAsDataURI(Module["memoryInitializerRequestURL"]);
                    if (data) response = data.buffer;
                    else {
                        console.warn("a problem seems to have happened with Module.memoryInitializerRequest, status: " + request.status + ", retrying " + memoryInitializer);
                        doBrowserLoad();
                        return;
                    }
                }
                applyMemoryInitializer(response);
            };
            if (Module["memoryInitializerRequest"].response) setTimeout(useRequest, 0);
            else Module["memoryInitializerRequest"].addEventListener("load", useRequest);
        } else doBrowserLoad();
    }
    var calledRun;
    dependenciesFulfilled = function runCaller() {
        if (!calledRun) run();
        if (!calledRun) dependenciesFulfilled = runCaller;
    };
    function run(args) {
        args = args || arguments_;
        if (runDependencies > 0) return;
        preRun();
        if (runDependencies > 0) return;
        function doRun() {
            if (calledRun) return;
            calledRun = true;
            if (ABORT) return;
            initRuntime();
            preMain();
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            postRun();
        }
        if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
                setTimeout(function() {
                    Module["setStatus"]("");
                }, 1);
                doRun();
            }, 1);
        } else doRun();
    }
    Module["run"] = run;
    function abort(what) {
        if (Module["onAbort"]) Module["onAbort"](what);
        what += "";
        out(what);
        err(what);
        ABORT = true;
        throw "abort(" + what + "). Build with -s ASSERTIONS=1 for more info.";
    }
    Module["abort"] = abort;
    if (Module["preInit"]) {
        if (typeof Module["preInit"] == "function") Module["preInit"] = [
            Module["preInit"]
        ];
        while(Module["preInit"].length > 0)Module["preInit"].pop()();
    }
    run();
    return libh3;
}(typeof $e3286925688328aa$var$libh3 === 'object' ? $e3286925688328aa$var$libh3 : {});
/*
 * Copyright 2018-2019, 2022 Uber Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Define the C bindings for the h3 library
// Add some aliases to make the function definitions more intelligible
var $e3286925688328aa$var$NUMBER = 'number';
var $e3286925688328aa$var$H3_ERROR = $e3286925688328aa$var$NUMBER;
var $e3286925688328aa$var$BOOLEAN = $e3286925688328aa$var$NUMBER;
var $e3286925688328aa$var$H3_LOWER = $e3286925688328aa$var$NUMBER;
var $e3286925688328aa$var$H3_UPPER = $e3286925688328aa$var$NUMBER;
var $e3286925688328aa$var$RESOLUTION = $e3286925688328aa$var$NUMBER;
var $e3286925688328aa$var$POINTER = $e3286925688328aa$var$NUMBER;
// Define the bindings to functions in the C lib. Functions are defined as
// [name, return type, [arg types]]. You must run `npm run build-emscripten`
// before new functions added here will be available.
/** @type {([string, string] | [string, string | null, string[]])[]} */ var $e3286925688328aa$var$BINDINGS = [
    // The size functions are inserted via build/sizes.h
    [
        'sizeOfH3Index',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'sizeOfLatLng',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'sizeOfCellBoundary',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'sizeOfGeoLoop',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'sizeOfGeoPolygon',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'sizeOfLinkedGeoPolygon',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'sizeOfCoordIJ',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'readInt64AsDoubleFromPointer',
        $e3286925688328aa$var$NUMBER
    ],
    // The remaining functions are defined in the core lib in h3Api.h
    [
        'isValidCell',
        $e3286925688328aa$var$BOOLEAN,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER
        ]
    ],
    [
        'latLngToCell',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToLatLng',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToBoundary',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'maxGridDiskSize',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'gridDisk',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'gridDiskDistances',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'gridRingUnsafe',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'maxPolygonToCellsSize',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'polygonToCells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'maxPolygonToCellsSizeExperimental',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'polygonToCellsExperimental',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellsToLinkedMultiPolygon',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'destroyLinkedMultiPolygon',
        null,
        [
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'compactCells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$NUMBER
        ]
    ],
    [
        'uncompactCells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$RESOLUTION
        ]
    ],
    [
        'uncompactCellsSize',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'isPentagon',
        $e3286925688328aa$var$BOOLEAN,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER
        ]
    ],
    [
        'isResClassIII',
        $e3286925688328aa$var$BOOLEAN,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER
        ]
    ],
    [
        'getBaseCellNumber',
        $e3286925688328aa$var$NUMBER,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER
        ]
    ],
    [
        'getResolution',
        $e3286925688328aa$var$NUMBER,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER
        ]
    ],
    [
        'maxFaceCount',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getIcosahedronFaces',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToParent',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToChildren',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToCenterChild',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToChildrenSize',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToChildPos',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'childPosToCell',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'areNeighborCells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellsToDirectedEdge',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getDirectedEdgeOrigin',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getDirectedEdgeDestination',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'isValidDirectedEdge',
        $e3286925688328aa$var$BOOLEAN,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER
        ]
    ],
    [
        'directedEdgeToCells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'originToDirectedEdges',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'directedEdgeToBoundary',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'gridDistance',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'gridPathCells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'gridPathCellsSize',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToLocalIj',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'localIjToCell',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getHexagonAreaAvgM2',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getHexagonAreaAvgKm2',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getHexagonEdgeLengthAvgM',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getHexagonEdgeLengthAvgKm',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'greatCircleDistanceM',
        $e3286925688328aa$var$NUMBER,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'greatCircleDistanceKm',
        $e3286925688328aa$var$NUMBER,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'greatCircleDistanceRads',
        $e3286925688328aa$var$NUMBER,
        [
            $e3286925688328aa$var$POINTER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellAreaM2',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellAreaKm2',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellAreaRads2',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'edgeLengthM',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'edgeLengthKm',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'edgeLengthRads',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getNumCells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$RESOLUTION,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'getRes0Cells',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'res0CellCount',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'getPentagons',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'pentagonCount',
        $e3286925688328aa$var$NUMBER
    ],
    [
        'cellToVertex',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$NUMBER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'cellToVertexes',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'vertexToLatLng',
        $e3286925688328aa$var$H3_ERROR,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER,
            $e3286925688328aa$var$POINTER
        ]
    ],
    [
        'isValidVertex',
        $e3286925688328aa$var$BOOLEAN,
        [
            $e3286925688328aa$var$H3_LOWER,
            $e3286925688328aa$var$H3_UPPER
        ]
    ]
];
/*
 * Copyright 2018-2019, 2022 Uber Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Error codes from the code library, aliased here for legibility
var $e3286925688328aa$var$E_SUCCESS = 0;
var $e3286925688328aa$var$E_FAILED = 1;
var $e3286925688328aa$var$E_DOMAIN = 2;
var $e3286925688328aa$var$E_LATLNG_DOMAIN = 3;
var $e3286925688328aa$var$E_RES_DOMAIN = 4;
var $e3286925688328aa$var$E_CELL_INVALID = 5;
var $e3286925688328aa$var$E_DIR_EDGE_INVALID = 6;
var $e3286925688328aa$var$E_UNDIR_EDGE_INVALID = 7;
var $e3286925688328aa$var$E_VERTEX_INVALID = 8;
var $e3286925688328aa$var$E_PENTAGON = 9;
var $e3286925688328aa$var$E_DUPLICATE_INPUT = 10;
var $e3286925688328aa$var$E_NOT_NEIGHBORS = 11;
var $e3286925688328aa$var$E_RES_MISMATCH = 12;
var $e3286925688328aa$var$E_MEMORY_ALLOC = 13;
var $e3286925688328aa$var$E_MEMORY_BOUNDS = 14;
var $e3286925688328aa$var$E_OPTION_INVALID = 15;
/**
 * Error messages corresponding to the core library error codes. See
 * https://h3geo.org/docs/library/errors#table-of-error-codes
 * @private
 */ var $e3286925688328aa$var$H3_ERROR_MSGS = {};
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_SUCCESS] = 'Success';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_FAILED] = 'The operation failed but a more specific error is not available';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_DOMAIN] = 'Argument was outside of acceptable range';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_LATLNG_DOMAIN] = 'Latitude or longitude arguments were outside of acceptable range';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_RES_DOMAIN] = 'Resolution argument was outside of acceptable range';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_CELL_INVALID] = 'Cell argument was not valid';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_DIR_EDGE_INVALID] = 'Directed edge argument was not valid';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_UNDIR_EDGE_INVALID] = 'Undirected edge argument was not valid';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_VERTEX_INVALID] = 'Vertex argument was not valid';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_PENTAGON] = 'Pentagon distortion was encountered';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_DUPLICATE_INPUT] = 'Duplicate input';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_NOT_NEIGHBORS] = 'Cell arguments were not neighbors';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_RES_MISMATCH] = 'Cell arguments had incompatible resolutions';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_MEMORY_ALLOC] = 'Memory allocation failed';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_MEMORY_BOUNDS] = 'Bounds of provided memory were insufficient';
$e3286925688328aa$var$H3_ERROR_MSGS[$e3286925688328aa$var$E_OPTION_INVALID] = 'Mode or flags argument was not valid';
// Error codes for JS errors thrown in the bindings
var $e3286925688328aa$var$E_UNKNOWN_UNIT = 1000;
var $e3286925688328aa$var$E_ARRAY_LENGTH = 1001;
var $e3286925688328aa$var$E_NULL_INDEX = 1002;
/**
 * Error messages for errors thrown in the binding code. These don't strictly
 * need error codes, but it's simpler to treat all of the errors consistently
 * @private
 */ var $e3286925688328aa$var$JS_ERROR_MESSAGES = {};
$e3286925688328aa$var$JS_ERROR_MESSAGES[$e3286925688328aa$var$E_UNKNOWN_UNIT] = 'Unknown unit';
$e3286925688328aa$var$JS_ERROR_MESSAGES[$e3286925688328aa$var$E_ARRAY_LENGTH] = 'Array length out of bounds';
$e3286925688328aa$var$JS_ERROR_MESSAGES[$e3286925688328aa$var$E_NULL_INDEX] = 'Got unexpected null value for H3 index';
var $e3286925688328aa$var$UNKNOWN_ERROR_MSG = 'Unknown error';
/**
 * Create an error with an attached code
 * @private
 * @param {Record<number, string>} messages  Map of code-to-messages to use
 * @param {number} errCode                   Numeric error code
 * @param {{value: unknown} | {}} [meta]     Metadata with value to associate with the error
 */ function $e3286925688328aa$var$createError(messages, errCode, meta) {
    // The error value may be "undefined", so check if the argument was provided
    var hasValue = meta && 'value' in meta;
    // Throw a custom error type with the code attached
    var err = new Error((messages[errCode] || $e3286925688328aa$var$UNKNOWN_ERROR_MSG) + " (code: " + errCode + (hasValue ? ", value: " + meta.value : '') + ")");
    // @ts-expect-error - TS doesn't like extending Error
    err.code = errCode;
    return err;
}
/**
 * Custom error for H3Error codes
 * @private
 * @param {number} errCode     Error code from the H3 library
 * @param {unknown} [value]    Value to associate with the error, if any
 * @returns {Error}
 */ function $e3286925688328aa$var$H3LibraryError(errCode, value) {
    // The error value may be "undefined", so check if the argument was provided
    var meta = arguments.length === 2 ? {
        value: value
    } : {};
    return $e3286925688328aa$var$createError($e3286925688328aa$var$H3_ERROR_MSGS, errCode, meta);
}
/**
 * Custom errors thrown from the JS bindings.
 * @private
 * @param {number} errCode     Error code from the H3 library
 * @param {unknown} [value]    Value to associate with the error, if any
 * @returns {Error}
 */ function $e3286925688328aa$var$JSBindingError(errCode, value) {
    // The error value may be "undefined", so check if the argument was provided
    var meta = arguments.length === 2 ? {
        value: value
    } : {};
    return $e3286925688328aa$var$createError($e3286925688328aa$var$JS_ERROR_MESSAGES, errCode, meta);
}
/**
 * Throw a JavaScript error if the C library return code is an error
 * @private
 * @param {number} errCode     Error code from the H3 library
 * @throws {Error} Error if err is not E_SUCCESS (0)
 */ function $e3286925688328aa$var$throwIfError(errCode) {
    if (errCode !== 0) throw $e3286925688328aa$var$H3LibraryError(errCode);
}
/*
 * Copyright 2018-2019, 2022 Uber Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map of C-defined functions
 * @type {any}
 * @private
 */ var $e3286925688328aa$var$H3 = {};
// Create the bound functions themselves
$e3286925688328aa$var$BINDINGS.forEach(function bind(def) {
    $e3286925688328aa$var$H3[def[0]] = $e3286925688328aa$var$libh3.cwrap.apply($e3286925688328aa$var$libh3, def);
});
// Alias the hexidecimal base for legibility
var $e3286925688328aa$var$BASE_16 = 16;
// Alias unused bits for legibility
var $e3286925688328aa$var$UNUSED_UPPER_32_BITS = 0;
// ----------------------------------------------------------------------------
// Byte size imports
var $e3286925688328aa$var$SZ_INT = 4;
var $e3286925688328aa$var$SZ_PTR = 4;
var $e3286925688328aa$var$SZ_DBL = 8;
var $e3286925688328aa$var$SZ_INT64 = 8;
var $e3286925688328aa$var$SZ_H3INDEX = $e3286925688328aa$var$H3.sizeOfH3Index();
var $e3286925688328aa$var$SZ_LATLNG = $e3286925688328aa$var$H3.sizeOfLatLng();
var $e3286925688328aa$var$SZ_CELLBOUNDARY = $e3286925688328aa$var$H3.sizeOfCellBoundary();
var $e3286925688328aa$var$SZ_GEOPOLYGON = $e3286925688328aa$var$H3.sizeOfGeoPolygon();
var $e3286925688328aa$var$SZ_GEOLOOP = $e3286925688328aa$var$H3.sizeOfGeoLoop();
var $e3286925688328aa$var$SZ_LINKED_GEOPOLYGON = $e3286925688328aa$var$H3.sizeOfLinkedGeoPolygon();
var $e3286925688328aa$var$SZ_COORDIJ = $e3286925688328aa$var$H3.sizeOfCoordIJ();
// ----------------------------------------------------------------------------
// Custom types
/**
 * 64-bit hexidecimal string representation of an H3 index
 * @static
 * @typedef {string} H3Index
 */ /**
 * 64-bit hexidecimal string representation of an H3 index,
 * or two 32-bit integers in little endian order in an array.
 * @static
 * @typedef {string | number[]} H3IndexInput
 */ /**
 * Coordinates as an `{i, j}` pair
 * @static
 * @typedef CoordIJ
 * @property {number} i
 * @property {number} j
 */ /**
 * Custom JS Error instance with an attached error code. Error codes come from the
 * core H3 library and can be found [in the H3 docs](https://h3geo.org/docs/library/errors#table-of-error-codes).
 * @static
 * @typedef H3Error
 * @property {string} message
 * @property {number} code
 */ /**
 * Pair of lat,lng coordinates (or lng,lat if GeoJSON output is specified)
 * @static
 * @typedef {number[]} CoordPair
 */ /**
 * Pair of lower,upper 32-bit ints representing a 64-bit value
 * @static
 * @typedef {number[]} SplitLong
 */ // ----------------------------------------------------------------------------
// Unit constants
/**
 * Length/Area units
 * @static
 * @property {string} m
 * @property {string} m2
 * @property {string} km
 * @property {string} km2
 * @property {string} rads
 * @property {string} rads2
 */ var $e3286925688328aa$export$a037d132965e1c9f = {
    m: 'm',
    m2: 'm2',
    km: 'km',
    km2: 'km2',
    rads: 'rads',
    rads2: 'rads2'
};
// ----------------------------------------------------------------------------
// Flags
/**
 * Mode flags for polygonToCells
 * @static
 * @property {string} containmentCenter
 * @property {string} containmentFull
 * @property {string} containmentOverlapping
 * @property {string} containmentOverlappingBbox
 */ var $e3286925688328aa$export$4517bc96aab26df9 = {
    containmentCenter: 'containmentCenter',
    containmentFull: 'containmentFull',
    containmentOverlapping: 'containmentOverlapping',
    containmentOverlappingBbox: 'containmentOverlappingBbox'
};
// ----------------------------------------------------------------------------
// Utilities and helpers
/**
 * @private
 * @param {string} flags Value from POLYGON_TO_CELLS_FLAGS
 * @returns {number} Flag value
 * @throws {H3Error} If invalid
 */ function $e3286925688328aa$var$polygonToCellsFlagsToNumber(flags) {
    switch(flags){
        case $e3286925688328aa$export$4517bc96aab26df9.containmentCenter:
            return 0;
        case $e3286925688328aa$export$4517bc96aab26df9.containmentFull:
            return 1;
        case $e3286925688328aa$export$4517bc96aab26df9.containmentOverlapping:
            return 2;
        case $e3286925688328aa$export$4517bc96aab26df9.containmentOverlappingBbox:
            return 3;
        default:
            throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_OPTION_INVALID, flags);
    }
}
/**
 * Validate a resolution, throwing an error if invalid
 * @private
 * @param  {unknown} res Value to validate
 * @return {number}      Valid res
 * @throws {H3Error}     If invalid
 */ function $e3286925688328aa$var$validateRes(res) {
    if (typeof res !== 'number' || res < 0 || res > 15 || Math.floor(res) !== res) throw $e3286925688328aa$var$H3LibraryError($e3286925688328aa$var$E_RES_DOMAIN, res);
    return res;
}
/**
 * Assert H3 index output, throwing an error if null
 * @private
 * @param {H3Index | null} h3Index    Index to validate
 * @return {H3Index}
 * @throws {H3Error}     If invalid
 */ function $e3286925688328aa$var$validateH3Index(h3Index) {
    if (!h3Index) throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_NULL_INDEX);
    return h3Index;
}
var $e3286925688328aa$var$MAX_JS_ARRAY_LENGTH = Math.pow(2, 32) - 1;
/**
 * Validate an array length. JS will throw its own error if you try
 * to create an array larger than 2^32 - 1, but validating beforehand
 * allows us to exit early before we try to process large amounts
 * of data that won't even fit in an output array
 * @private
 * @param  {number} length  Length to validate
 * @return {number}         Valid array length
 * @throws {H3Error}        If invalid
 */ function $e3286925688328aa$var$validateArrayLength(length) {
    if (length > $e3286925688328aa$var$MAX_JS_ARRAY_LENGTH) throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_ARRAY_LENGTH, length);
    return length;
}
var $e3286925688328aa$var$INVALID_HEXIDECIMAL_CHAR = /[^0-9a-fA-F]/;
/**
 * Convert an H3 index (64-bit hexidecimal string) into a "split long" - a pair of 32-bit ints
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {SplitLong}             A two-element array with 32 lower bits and 32 upper bits
 */ function $e3286925688328aa$export$746fb3599c285d6a(h3Index) {
    if (Array.isArray(h3Index) && h3Index.length === 2 && Number.isInteger(h3Index[0]) && Number.isInteger(h3Index[1])) return h3Index;
    if (typeof h3Index !== 'string' || $e3286925688328aa$var$INVALID_HEXIDECIMAL_CHAR.test(h3Index)) return [
        0,
        0
    ];
    var upper = parseInt(h3Index.substring(0, h3Index.length - 8), $e3286925688328aa$var$BASE_16);
    var lower = parseInt(h3Index.substring(h3Index.length - 8), $e3286925688328aa$var$BASE_16);
    return [
        lower,
        upper
    ];
}
/**
 * Convert a 32-bit int to a hexdecimal string
 * @private
 * @param  {number} num  Integer to convert
 * @return {H3Index}     Hexidecimal string
 */ function $e3286925688328aa$var$hexFrom32Bit(num) {
    if (num >= 0) return num.toString($e3286925688328aa$var$BASE_16);
    // Handle negative numbers
    num = num & 0x7fffffff;
    var tempStr = $e3286925688328aa$var$zeroPad(8, num.toString($e3286925688328aa$var$BASE_16));
    var topNum = (parseInt(tempStr[0], $e3286925688328aa$var$BASE_16) + 8).toString($e3286925688328aa$var$BASE_16);
    tempStr = topNum + tempStr.substring(1);
    return tempStr;
}
/**
 * Get a H3 index string from a split long (pair of 32-bit ints)
 * @param  {number} lower Lower 32 bits
 * @param  {number} upper Upper 32 bits
 * @return {H3Index}       H3 index
 */ function $e3286925688328aa$export$d274cc238a912f5f(lower, upper) {
    return $e3286925688328aa$var$hexFrom32Bit(upper) + $e3286925688328aa$var$zeroPad(8, $e3286925688328aa$var$hexFrom32Bit(lower));
}
/**
 * Zero-pad a string to a given length
 * @private
 * @param  {number} fullLen Target length
 * @param  {string} numStr  String to zero-pad
 * @return {string}         Zero-padded string
 */ function $e3286925688328aa$var$zeroPad(fullLen, numStr) {
    var numZeroes = fullLen - numStr.length;
    var outStr = '';
    for(var i = 0; i < numZeroes; i++)outStr += '0';
    outStr = outStr + numStr;
    return outStr;
}
// One more than the max size of an unsigned 32-bit int.
// Dividing by this number is equivalent to num >>> 32
var $e3286925688328aa$var$UPPER_BIT_DIVISOR = Math.pow(2, 32);
/**
 * Convert a JS double-precision floating point number to a split long
 * @private
 * @param  {number} num  Number to convert
 * @return {SplitLong}     A two-element array with 32 lower bits and 32 upper bits
 */ function $e3286925688328aa$var$numberToSplitLong(num) {
    if (typeof num !== 'number') return [
        0,
        0
    ];
    return [
        num | 0,
        num / $e3286925688328aa$var$UPPER_BIT_DIVISOR | 0
    ];
}
/**
 * Populate a C-appropriate GeoLoop struct from a polygon array
 * @private
 * @param  {number[][]} polygonArray  Polygon, as an array of coordinate pairs
 * @param  {number}  geoLoop          C pointer to a GeoLoop struct
 * @param  {boolean} isGeoJson        Whether coordinates are in [lng, lat] order per GeoJSON spec
 * @return {number}                   C pointer to populated GeoLoop struct
 */ function $e3286925688328aa$var$polygonArrayToGeoLoop(polygonArray, geoLoop, isGeoJson) {
    var numVerts = polygonArray.length;
    var geoCoordArray = $e3286925688328aa$var$libh3._calloc(numVerts, $e3286925688328aa$var$SZ_LATLNG);
    // Support [lng, lat] pairs if GeoJSON is specified
    var latIndex = isGeoJson ? 1 : 0;
    var lngIndex = isGeoJson ? 0 : 1;
    for(var i = 0; i < numVerts * 2; i += 2)$e3286925688328aa$var$libh3.HEAPF64.set([
        polygonArray[i / 2][latIndex],
        polygonArray[i / 2][lngIndex]
    ].map($e3286925688328aa$export$18f2af2888c1a46b), geoCoordArray / $e3286925688328aa$var$SZ_DBL + i);
    $e3286925688328aa$var$libh3.HEAPU32.set([
        numVerts,
        geoCoordArray
    ], geoLoop / $e3286925688328aa$var$SZ_INT);
    return geoLoop;
}
/**
 * Create a C-appropriate GeoPolygon struct from an array of polygons
 * @private
 * @param  {number[][][]} coordinates Array of polygons, each an array of coordinate pairs
 * @param  {boolean} isGeoJson        Whether coordinates are in [lng, lat] order per GeoJSON spec
 * @return {number}                   C pointer to populated GeoPolygon struct
 */ function $e3286925688328aa$var$coordinatesToGeoPolygon(coordinates, isGeoJson) {
    // Any loops beyond the first loop are holes
    var numHoles = coordinates.length - 1;
    var geoPolygon = $e3286925688328aa$var$libh3._calloc($e3286925688328aa$var$SZ_GEOPOLYGON);
    // Byte positions within the struct
    var geoLoopOffset = 0;
    var numHolesOffset = geoLoopOffset + $e3286925688328aa$var$SZ_GEOLOOP;
    var holesOffset = numHolesOffset + $e3286925688328aa$var$SZ_INT;
    // geoLoop is first part of struct
    $e3286925688328aa$var$polygonArrayToGeoLoop(coordinates[0], geoPolygon + geoLoopOffset, isGeoJson);
    var holes;
    if (numHoles > 0) {
        holes = $e3286925688328aa$var$libh3._calloc(numHoles, $e3286925688328aa$var$SZ_GEOLOOP);
        for(var i = 0; i < numHoles; i++)$e3286925688328aa$var$polygonArrayToGeoLoop(coordinates[i + 1], holes + $e3286925688328aa$var$SZ_GEOLOOP * i, isGeoJson);
    }
    $e3286925688328aa$var$libh3.setValue(geoPolygon + numHolesOffset, numHoles, 'i32');
    $e3286925688328aa$var$libh3.setValue(geoPolygon + holesOffset, holes, 'i32');
    return geoPolygon;
}
/**
 * Free memory allocated for a GeoPolygon struct. It is an error to access the struct
 * after passing it to this method.
 * @private
 * @param {number} geoPolygon     C pointer to GeoPolygon struct
 * @return {void}
 */ function $e3286925688328aa$var$destroyGeoPolygon(geoPolygon) {
    // Byte positions within the struct
    var geoLoopOffset = 0;
    var numHolesOffset = geoLoopOffset + $e3286925688328aa$var$SZ_GEOLOOP;
    var holesOffset = numHolesOffset + $e3286925688328aa$var$SZ_INT;
    // Offset of the geoLoop vertex array pointer within the GeoLoop struct
    var geoLoopArrayOffset = $e3286925688328aa$var$SZ_INT;
    // Free the outer vertex array
    $e3286925688328aa$var$libh3._free($e3286925688328aa$var$libh3.getValue(geoPolygon + geoLoopOffset + geoLoopArrayOffset, 'i8*'));
    // Free the vertex array for the holes, if any
    var numHoles = $e3286925688328aa$var$libh3.getValue(geoPolygon + numHolesOffset, 'i32');
    if (numHoles > 0) {
        var holes = $e3286925688328aa$var$libh3.getValue(geoPolygon + holesOffset, 'i32');
        for(var i = 0; i < numHoles; i++)$e3286925688328aa$var$libh3._free($e3286925688328aa$var$libh3.getValue(holes + $e3286925688328aa$var$SZ_GEOLOOP * i + geoLoopArrayOffset, 'i8*'));
        $e3286925688328aa$var$libh3._free(holes);
    }
    $e3286925688328aa$var$libh3._free(geoPolygon);
}
/**
 * Read an H3 index from a pointer to C memory.
 * @private
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of H3 indexes, in case we're
 *                            reading an array
 * @return {H3Index | null}   H3 index, or null if index was invalid
 */ function $e3286925688328aa$var$readH3IndexFromPointer(cAddress, offset) {
    if (offset === void 0) offset = 0;
    var lower = $e3286925688328aa$var$libh3.getValue(cAddress + $e3286925688328aa$var$SZ_H3INDEX * offset, 'i32');
    var upper = $e3286925688328aa$var$libh3.getValue(cAddress + $e3286925688328aa$var$SZ_H3INDEX * offset + $e3286925688328aa$var$SZ_INT, 'i32');
    // The lower bits are allowed to be 0s, but if the upper bits are 0
    // this represents an invalid H3 index
    return upper ? $e3286925688328aa$export$d274cc238a912f5f(lower, upper) : null;
}
/**
 * Read a boolean (32 bit) from a pointer to C memory.
 * @private
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of booleans, in case we're
 *                            reading an array
 * @return {Boolean} Boolean value
 */ function $e3286925688328aa$var$readBooleanFromPointer(cAddress, offset) {
    if (offset === void 0) offset = 0;
    var val = $e3286925688328aa$var$libh3.getValue(cAddress + $e3286925688328aa$var$SZ_INT * offset, 'i32');
    return Boolean(val);
}
/**
 * Read a double from a pointer to C memory.
 * @private
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of doubles, in case we're
 *                            reading an array
 * @return {number} Double value
 */ function $e3286925688328aa$var$readDoubleFromPointer(cAddress, offset) {
    if (offset === void 0) offset = 0;
    return $e3286925688328aa$var$libh3.getValue(cAddress + $e3286925688328aa$var$SZ_DBL * offset, 'double');
}
/**
 * Read a 64-bit int from a pointer to C memory into a JS 64-bit float.
 * Note that this may lose precision if larger than MAX_SAFE_INTEGER
 * @private
 * @param  {number} cAddress  Pointer to allocated C memory
 * @return {number} Double value
 */ function $e3286925688328aa$var$readInt64AsDoubleFromPointer(cAddress) {
    return $e3286925688328aa$var$H3.readInt64AsDoubleFromPointer(cAddress);
}
/**
 * Store an H3 index in C memory. Primarily used as an efficient way to
 * write sets of hexagons.
 * @private
 * @param  {H3IndexInput} h3Index  H3 index to store
 * @param  {number} cAddress  Pointer to allocated C memory
 * @param {number} offset     Offset, in number of H3 indexes from beginning
 *                            of the current array
 */ function $e3286925688328aa$var$storeH3Index(h3Index, cAddress, offset) {
    // HEAPU32 is a typed array projection on the index space
    // as unsigned 32-bit integers. This means the index needs
    // to be divided by SZ_INT (4) to access correctly. Also,
    // the H3 index is 64 bits, so we skip by twos as we're writing
    // to 32-bit integers in the proper order.
    $e3286925688328aa$var$libh3.HEAPU32.set($e3286925688328aa$export$746fb3599c285d6a(h3Index), cAddress / $e3286925688328aa$var$SZ_INT + 2 * offset);
}
/**
 * Read an array of 64-bit H3 indexes from C and convert to a JS array of
 * H3 index strings
 * @private
 * @param  {number} cAddress    Pointer to C ouput array
 * @param  {number} maxCount    Max number of hexagons in array. Hexagons with
 *                              the value 0 will be skipped, so this isn't
 *                              necessarily the length of the output array.
 * @return {H3Index[]}          Array of H3 indexes
 */ function $e3286925688328aa$var$readArrayOfH3Indexes(cAddress, maxCount) {
    var out = [];
    for(var i = 0; i < maxCount; i++){
        var h3Index = $e3286925688328aa$var$readH3IndexFromPointer(cAddress, i);
        if (h3Index !== null) out.push(h3Index);
    }
    return out;
}
/**
 * Store an array of H3 index strings as a C array of 64-bit integers.
 * @private
 * @param  {number} cAddress    Pointer to C input array
 * @param  {H3IndexInput[]} hexagons H3 indexes to pass to the C lib
 */ function $e3286925688328aa$var$storeArrayOfH3Indexes(cAddress, hexagons) {
    // Assuming the cAddress points to an already appropriately
    // allocated space
    var count = hexagons.length;
    for(var i = 0; i < count; i++)$e3286925688328aa$var$storeH3Index(hexagons[i], cAddress, i);
}
/**
 * Populate a C-appropriate LatLng struct from a [lat, lng] array
 * @private
 * @param {number} lat     Coordinate latitude
 * @param {number} lng     Coordinate longitude
 * @return {number}        C pointer to populated LatLng struct
 */ function $e3286925688328aa$var$storeLatLng(lat, lng) {
    var geoCoord = $e3286925688328aa$var$libh3._calloc(1, $e3286925688328aa$var$SZ_LATLNG);
    $e3286925688328aa$var$libh3.HEAPF64.set([
        lat,
        lng
    ].map($e3286925688328aa$export$18f2af2888c1a46b), geoCoord / $e3286925688328aa$var$SZ_DBL);
    return geoCoord;
}
/**
 * Read a single lat or lng value
 * @private
 * @param  {number} cAddress Pointer to C value
 * @return {number}
 */ function $e3286925688328aa$var$readSingleCoord(cAddress) {
    return $e3286925688328aa$export$3eb27537c08caf0f($e3286925688328aa$var$libh3.getValue(cAddress, 'double'));
}
/**
 * Read a LatLng from C and return a [lat, lng] pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {CoordPair}          [lat, lng] pair
 */ function $e3286925688328aa$var$readLatLng(cAddress) {
    return [
        $e3286925688328aa$var$readSingleCoord(cAddress),
        $e3286925688328aa$var$readSingleCoord(cAddress + $e3286925688328aa$var$SZ_DBL)
    ];
}
/**
 * Read a LatLng from C and return a GeoJSON-style [lng, lat] pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {CoordPair}          [lng, lat] pair
 */ function $e3286925688328aa$var$readLatLngGeoJson(cAddress) {
    return [
        $e3286925688328aa$var$readSingleCoord(cAddress + $e3286925688328aa$var$SZ_DBL),
        $e3286925688328aa$var$readSingleCoord(cAddress)
    ];
}
/**
 * Read the CellBoundary structure into a list of geo coordinate pairs
 * @private
 * @param {number}  cellBoundary       C pointer to CellBoundary struct
 * @param {boolean} [geoJsonCoords]    Whether to provide GeoJSON coordinate order: [lng, lat]
 * @param {boolean} [closedLoop]       Whether to close the loop
 * @return {CoordPair[]}               Array of geo coordinate pairs
 */ function $e3286925688328aa$var$readCellBoundary(cellBoundary, geoJsonCoords, closedLoop) {
    var numVerts = $e3286925688328aa$var$libh3.getValue(cellBoundary, 'i32');
    // Note that though numVerts is an int, the coordinate doubles have to be
    // aligned to 8 bytes, hence the 8-byte offset here
    var vertsPos = cellBoundary + $e3286925688328aa$var$SZ_DBL;
    var out = [];
    // Support [lng, lat] pairs if GeoJSON is specified
    var readCoord = geoJsonCoords ? $e3286925688328aa$var$readLatLngGeoJson : $e3286925688328aa$var$readLatLng;
    for(var i = 0; i < numVerts * 2; i += 2)out.push(readCoord(vertsPos + $e3286925688328aa$var$SZ_DBL * i));
    if (closedLoop) // Close loop if GeoJSON is specified
    out.push(out[0]);
    return out;
}
/**
 * Read the LinkedGeoPolygon structure into a nested array of MultiPolygon coordinates
 * @private
 * @param {number}  polygon           C pointer to LinkedGeoPolygon struct
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat], closed loops
 * @return {CoordPair[][][]}          MultiPolygon-style output.
 */ function $e3286925688328aa$var$readMultiPolygon(polygon, formatAsGeoJson) {
    var output = [];
    var readCoord = formatAsGeoJson ? $e3286925688328aa$var$readLatLngGeoJson : $e3286925688328aa$var$readLatLng;
    var loops;
    var loop;
    var coords;
    var coord;
    // Loop through the linked structure, building the output
    while(polygon){
        output.push(loops = []);
        // Follow ->first pointer
        loop = $e3286925688328aa$var$libh3.getValue(polygon, 'i8*');
        while(loop){
            loops.push(coords = []);
            // Follow ->first pointer
            coord = $e3286925688328aa$var$libh3.getValue(loop, 'i8*');
            while(coord){
                coords.push(readCoord(coord));
                // Follow ->next pointer
                coord = $e3286925688328aa$var$libh3.getValue(coord + $e3286925688328aa$var$SZ_DBL * 2, 'i8*');
            }
            if (formatAsGeoJson) // Close loop if GeoJSON is requested
            coords.push(coords[0]);
            // Follow ->next pointer
            loop = $e3286925688328aa$var$libh3.getValue(loop + $e3286925688328aa$var$SZ_PTR * 2, 'i8*');
        }
        // Follow ->next pointer
        polygon = $e3286925688328aa$var$libh3.getValue(polygon + $e3286925688328aa$var$SZ_PTR * 2, 'i8*');
    }
    return output;
}
/**
 * Read a CoordIJ from C and return an {i, j} pair.
 * @private
 * @param  {number} cAddress    Pointer to C struct
 * @return {CoordIJ}            {i, j} pair
 */ function $e3286925688328aa$var$readCoordIJ(cAddress) {
    return {
        i: $e3286925688328aa$var$libh3.getValue(cAddress, 'i32'),
        j: $e3286925688328aa$var$libh3.getValue(cAddress + $e3286925688328aa$var$SZ_INT, 'i32')
    };
}
/**
 * Store an {i, j} pair to a C CoordIJ struct.
 * @private
 * @param  {number} cAddress    Pointer to C memory
 * @param {CoordIJ} ij          {i,j} pair to store
 * @return {void}
 */ function $e3286925688328aa$var$storeCoordIJ(cAddress, ref) {
    var i = ref.i;
    var j = ref.j;
    $e3286925688328aa$var$libh3.setValue(cAddress, i, 'i32');
    $e3286925688328aa$var$libh3.setValue(cAddress + $e3286925688328aa$var$SZ_INT, j, 'i32');
}
/**
 * Read an array of positive integers array from C. Negative
 * values are considered invalid and ignored in output.
 * @private
 * @param  {number} cAddress    Pointer to C array
 * @param  {number} count       Length of C array
 * @return {number[]}           Javascript integer array
 */ function $e3286925688328aa$var$readArrayOfPositiveIntegers(cAddress, count) {
    var out = [];
    for(var i = 0; i < count; i++){
        var int = $e3286925688328aa$var$libh3.getValue(cAddress + $e3286925688328aa$var$SZ_INT * i, 'i32');
        if (int >= 0) out.push(int);
    }
    return out;
}
// ----------------------------------------------------------------------------
// Public API functions: Core
/**
 * Whether a given string represents a valid H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          Whether the index is valid
 */ function $e3286925688328aa$export$c33478630c163b35(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($e3286925688328aa$var$H3.isValidCell(lower, upper));
}
/**
 * Whether the given H3 index is a pentagon
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          isPentagon
 */ function $e3286925688328aa$export$c5b495eb3343f6f3(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($e3286925688328aa$var$H3.isPentagon(lower, upper));
}
/**
 * Whether the given H3 index is in a Class III resolution (rotated versus
 * the icosahedron and subject to shape distortion adding extra points on
 * icosahedron edges, making them not true hexagons).
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to check
 * @return {boolean}          isResClassIII
 */ function $e3286925688328aa$export$6b9a5658a9c0975a(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($e3286925688328aa$var$H3.isResClassIII(lower, upper));
}
/**
 * Get the number of the base cell for a given H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get the base cell for
 * @return {number}           Index of the base cell (0-121)
 */ function $e3286925688328aa$export$236b8d6f66b6eb04(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return $e3286925688328aa$var$H3.getBaseCellNumber(lower, upper);
}
/**
 * Get the indices of all icosahedron faces intersected by a given H3 index
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get faces for
 * @return {number[]}              Indices (0-19) of all intersected faces
 * @throws {H3Error}               If input is invalid
 */ function $e3286925688328aa$export$13a8d2826d74e08f(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.maxFaceCount(lower, upper, countPtr));
        var count = $e3286925688328aa$var$libh3.getValue(countPtr, 'i32');
        var faces = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT * count);
        try {
            $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getIcosahedronFaces(lower, upper, faces));
            return $e3286925688328aa$var$readArrayOfPositiveIntegers(faces, count);
        } finally{
            $e3286925688328aa$var$libh3._free(faces);
        }
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
    }
}
/**
 * Returns the resolution of an H3 index
 * @static
 * @param  {H3IndexInput} h3Index H3 index to get resolution
 * @return {number}          The number (0-15) resolution, or -1 if invalid
 */ function $e3286925688328aa$export$709fa427476941ba(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    if (!$e3286925688328aa$var$H3.isValidCell(lower, upper)) // Compatability with stated API
    return -1;
    return $e3286925688328aa$var$H3.getResolution(lower, upper);
}
/**
 * Get the hexagon containing a lat,lon point
 * @static
 * @param  {number} lat Latitude of point
 * @param  {number} lng Longtitude of point
 * @param  {number} res Resolution of hexagons to return
 * @return {H3Index}    H3 index
 * @throws {H3Error}    If input is invalid
 */ function $e3286925688328aa$export$6dd797caa6c57c8a(lat, lng, res) {
    var latLng = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_LATLNG);
    // Slightly more efficient way to set the memory
    $e3286925688328aa$var$libh3.HEAPF64.set([
        lat,
        lng
    ].map($e3286925688328aa$export$18f2af2888c1a46b), latLng / $e3286925688328aa$var$SZ_DBL);
    // Read value as a split long
    var h3Index = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.latLngToCell(latLng, res, h3Index));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(h3Index));
    } finally{
        $e3286925688328aa$var$libh3._free(h3Index);
        $e3286925688328aa$var$libh3._free(latLng);
    }
}
/**
 * Get the lat,lon center of a given hexagon
 * @static
 * @param  {H3IndexInput} h3Index  H3 index
 * @return {CoordPair}             Point as a [lat, lng] pair
 * @throws {H3Error}               If input is invalid
 */ function $e3286925688328aa$export$2ed8e7796c5b7719(h3Index) {
    var latLng = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_LATLNG);
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToLatLng(lower, upper, latLng));
        return $e3286925688328aa$var$readLatLng(latLng);
    } finally{
        $e3286925688328aa$var$libh3._free(latLng);
    }
}
/**
 * Get the vertices of a given hexagon (or pentagon), as an array of [lat, lng]
 * points. For pentagons and hexagons on the edge of an icosahedron face, this
 * function may return up to 10 vertices.
 * @static
 * @param  {H3IndexInput} h3Index          H3 index
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat], closed loops
 * @return {CoordPair[]}              Array of [lat, lng] pairs
 * @throws {H3Error}                  If input is invalid
 */ function $e3286925688328aa$export$95a0f8735a48a896(h3Index, formatAsGeoJson) {
    var cellBoundary = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_CELLBOUNDARY);
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToBoundary(lower, upper, cellBoundary));
        return $e3286925688328aa$var$readCellBoundary(cellBoundary, formatAsGeoJson, formatAsGeoJson);
    } finally{
        $e3286925688328aa$var$libh3._free(cellBoundary);
    }
}
// ----------------------------------------------------------------------------
// Public API functions: Algorithms
/**
 * Get the parent of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get parent for
 * @param  {number} res       Resolution of hexagon to return
 * @return {H3Index}          H3 index of parent, or null for invalid input
 * @throws {H3Error}          If input is invalid
 */ function $e3286925688328aa$export$6d5d3d3fdb7a30f6(h3Index, res) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var parent = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToParent(lower, upper, res, parent));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(parent));
    } finally{
        $e3286925688328aa$var$libh3._free(parent);
    }
}
/**
 * Get the children/descendents of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get children for
 * @param  {number} res       Resolution of hexagons to return
 * @return {H3Index[]}        H3 indexes of children, or empty array for invalid input
 * @throws {H3Error}          If resolution is invalid or output is too large for JS
 */ function $e3286925688328aa$export$e9ba8741b7dccfa1(h3Index, res) {
    // Bad input in this case can potentially result in high computation volume
    // using the current C algorithm. Validate and return an empty array on failure.
    if (!$e3286925688328aa$export$c33478630c163b35(h3Index)) return [];
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var count = $e3286925688328aa$var$validateArrayLength($e3286925688328aa$export$89118f8f9af228ad(h3Index, res));
    var hexagons = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToChildren(lower, upper, res, hexagons));
        return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
    } finally{
        $e3286925688328aa$var$libh3._free(hexagons);
    }
}
/**
 * Get the number of children for a cell at a given resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get child count for
 * @param  {number} res            Child resolution
 * @return {number}                Number of children at res for the given cell
 * @throws {H3Error}               If cell or parentRes are invalid
 */ function $e3286925688328aa$export$89118f8f9af228ad(h3Index, res) {
    if (!$e3286925688328aa$export$c33478630c163b35(h3Index)) throw $e3286925688328aa$var$H3LibraryError($e3286925688328aa$var$E_CELL_INVALID);
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToChildrenSize(lower, upper, res, countPtr));
        return $e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr);
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
    }
}
/**
 * Get the center child of the given hexagon at a particular resolution
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get center child for
 * @param  {number} res       Resolution of cell to return
 * @return {H3Index}          H3 index of child, or null for invalid input
 * @throws {H3Error}          If resolution is invalid
 */ function $e3286925688328aa$export$938d4500484f5586(h3Index, res) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var centerChild = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToCenterChild(lower, upper, res, centerChild));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(centerChild));
    } finally{
        $e3286925688328aa$var$libh3._free(centerChild);
    }
}
/**
 * Get the position of the cell within an ordered list of all children of the
 * cell's parent at the specified resolution.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index to get child pos for
 * @param  {number} parentRes      Resolution of reference parent
 * @return {number}                Position of child within parent at parentRes
 * @throws {H3Error}               If cell or parentRes are invalid
 */ function $e3286925688328aa$export$530b80a71fab15ae(h3Index, parentRes) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var childPos = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToChildPos(lower, upper, parentRes, childPos));
        return $e3286925688328aa$var$readInt64AsDoubleFromPointer(childPos);
    } finally{
        $e3286925688328aa$var$libh3._free(childPos);
    }
}
/**
 * Get the child cell at a given position within an ordered list of all children
 * at the specified resolution
 * @static
 * @param  {number} childPos       Position of the child cell to get
 * @param  {H3IndexInput} h3Index  H3 index of the parent cell
 * @param  {number} childRes       Resolution of child cell to return
 * @return {H3Index}          H3 index of child
 * @throws {H3Error}          If input is invalid
 */ function $e3286925688328aa$export$b090bde16e52a102(childPos, h3Index, childRes) {
    var ref = $e3286925688328aa$var$numberToSplitLong(childPos);
    var cpLower = ref[0];
    var cpUpper = ref[1];
    var ref$1 = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref$1[0];
    var upper = ref$1[1];
    var child = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.childPosToCell(cpLower, cpUpper, lower, upper, childRes, child));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(child));
    } finally{
        $e3286925688328aa$var$libh3._free(child);
    }
}
/**
 * Get all hexagons in a k-ring around a given center. The order of the hexagons is undefined.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of k-ring
 * @return {H3Index[]}        H3 indexes for all hexagons in ring
 * @throws {H3Error}          If input is invalid or output is too large for JS
 */ function $e3286925688328aa$export$2fd1f4b24caabe65(h3Index, ringSize) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.maxGridDiskSize(ringSize, countPtr));
        var count = $e3286925688328aa$var$validateArrayLength($e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr));
        var hexagons = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
        try {
            $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.gridDisk(lower, upper, ringSize, hexagons));
            return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
        } finally{
            $e3286925688328aa$var$libh3._free(hexagons);
        }
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
    }
}
/**
 * Get all hexagons in a k-ring around a given center, in an array of arrays
 * ordered by distance from the origin. The order of the hexagons within each ring is undefined.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of k-ring
 * @return {H3Index[][]}      Array of arrays with H3 indexes for all hexagons each ring
 * @throws {H3Error}          If input is invalid or output is too large for JS
 */ function $e3286925688328aa$export$856787d0ac29690b(h3Index, ringSize) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.maxGridDiskSize(ringSize, countPtr));
        var count = $e3286925688328aa$var$validateArrayLength($e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr));
        var kRings = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
        var distances = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_INT);
        try {
            $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.gridDiskDistances(lower, upper, ringSize, kRings, distances));
            /**
       * An array of empty arrays to hold the output
       * @type {string[][]}
       * @private
       */ var out = [];
            for(var i = 0; i < ringSize + 1; i++)out.push([]);
            // Read the array of hexagons, putting them into the appropriate rings
            for(var i$1 = 0; i$1 < count; i$1++){
                var cell = $e3286925688328aa$var$readH3IndexFromPointer(kRings, i$1);
                var index = $e3286925688328aa$var$libh3.getValue(distances + $e3286925688328aa$var$SZ_INT * i$1, 'i32');
                // eslint-disable-next-line max-depth
                if (cell !== null) out[index].push(cell);
            }
            return out;
        } finally{
            $e3286925688328aa$var$libh3._free(kRings);
            $e3286925688328aa$var$libh3._free(distances);
        }
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
    }
}
/**
 * Get all hexagons in a hollow hexagonal ring centered at origin with sides of a given length.
 * Unlike gridDisk, this function will throw an error if there is a pentagon anywhere in the ring.
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of center hexagon
 * @param  {number} ringSize  Radius of ring
 * @return {H3Index[]}        H3 indexes for all hexagons in ring
 * @throws {Error}            If the algorithm could not calculate the ring
 * @throws {H3Error}          If input is invalid
 */ function $e3286925688328aa$export$3937f3248b114ad7(h3Index, ringSize) {
    var maxCount = ringSize === 0 ? 1 : 6 * ringSize;
    var hexagons = $e3286925688328aa$var$libh3._calloc(maxCount, $e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.gridRingUnsafe.apply($e3286925688328aa$var$H3, $e3286925688328aa$export$746fb3599c285d6a(h3Index).concat([
            ringSize
        ], [
            hexagons
        ])));
        return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, maxCount);
    } finally{
        $e3286925688328aa$var$libh3._free(hexagons);
    }
}
/**
 * Get all hexagons with centers contained in a given polygon. The polygon
 * is specified with GeoJson semantics as an array of loops. Each loop is
 * an array of [lat, lng] pairs (or [lng, lat] if isGeoJson is specified).
 * The first loop is the perimeter of the polygon, and subsequent loops are
 * expected to be holes.
 * @static
 * @param  {number[][] | number[][][]} coordinates
 *                                  Array of loops, or a single loop
 * @param  {number} res             Resolution of hexagons to return
 * @param  {boolean} [isGeoJson]    Whether to expect GeoJson-style [lng, lat]
 *                                  pairs instead of [lat, lng]
 * @return {H3Index[]}              H3 indexes for all hexagons in polygon
 * @throws {H3Error}                If input is invalid or output is too large for JS
 */ function $e3286925688328aa$export$169c20284a281646(coordinates, res, isGeoJson) {
    $e3286925688328aa$var$validateRes(res);
    isGeoJson = Boolean(isGeoJson);
    // Guard against empty input
    if (coordinates.length === 0 || coordinates[0].length === 0) return [];
    // Wrap to expected format if a single loop is provided
    var polygon = typeof coordinates[0][0] === 'number' ? [
        coordinates
    ] : coordinates;
    var geoPolygon = $e3286925688328aa$var$coordinatesToGeoPolygon(// @ts-expect-error - There's no way to convince TS that polygon is now number[][][]
    polygon, isGeoJson);
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.maxPolygonToCellsSize(geoPolygon, res, 0, countPtr));
        var count = $e3286925688328aa$var$validateArrayLength($e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr));
        var hexagons = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
        try {
            $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.polygonToCells(geoPolygon, res, 0, hexagons));
            return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
        } finally{
            $e3286925688328aa$var$libh3._free(hexagons);
        }
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
        $e3286925688328aa$var$destroyGeoPolygon(geoPolygon);
    }
}
/**
 * Get all hexagons with centers contained in a given polygon. The polygon
 * is specified with GeoJson semantics as an array of loops. Each loop is
 * an array of [lat, lng] pairs (or [lng, lat] if isGeoJson is specified).
 * The first loop is the perimeter of the polygon, and subsequent loops are
 * expected to be holes.
 * @static
 * @param  {number[][] | number[][][]} coordinates
 *                                  Array of loops, or a single loop
 * @param  {number} res             Resolution of hexagons to return
 * @param  {string} flags           Value from POLYGON_TO_CELLS_FLAGS
 * @param  {boolean} [isGeoJson]    Whether to expect GeoJson-style [lng, lat]
 *                                  pairs instead of [lat, lng]
 * @return {H3Index[]}              H3 indexes for all hexagons in polygon
 * @throws {H3Error}                If input is invalid or output is too large for JS
 */ function $e3286925688328aa$export$b5b390c7866bbc6b(coordinates, res, flags, isGeoJson) {
    $e3286925688328aa$var$validateRes(res);
    isGeoJson = Boolean(isGeoJson);
    var flagsInt = $e3286925688328aa$var$polygonToCellsFlagsToNumber(flags);
    // Guard against empty input
    if (coordinates.length === 0 || coordinates[0].length === 0) return [];
    // Wrap to expected format if a single loop is provided
    var polygon = typeof coordinates[0][0] === 'number' ? [
        coordinates
    ] : coordinates;
    var geoPolygon = $e3286925688328aa$var$coordinatesToGeoPolygon(// @ts-expect-error - There's no way to convince TS that polygon is now number[][][]
    polygon, isGeoJson);
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.maxPolygonToCellsSizeExperimental(geoPolygon, res, flagsInt, countPtr));
        var count = $e3286925688328aa$var$validateArrayLength($e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr));
        var hexagons = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
        try {
            $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.polygonToCellsExperimental(geoPolygon, res, flagsInt, count, $e3286925688328aa$var$UNUSED_UPPER_32_BITS, hexagons));
            return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
        } finally{
            $e3286925688328aa$var$libh3._free(hexagons);
        }
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
        $e3286925688328aa$var$destroyGeoPolygon(geoPolygon);
    }
}
/**
 * Get the outlines of a set of H3 hexagons, returned in GeoJSON MultiPolygon
 * format (an array of polygons, each with an array of loops, each an array of
 * coordinates). Coordinates are returned as [lat, lng] pairs unless GeoJSON
 * is requested.
 *
 * It is the responsibility of the caller to ensure that all hexagons in the
 * set have the same resolution and that the set contains no duplicates. Behavior
 * is undefined if duplicates or multiple resolutions are present, and the
 * algorithm may produce unexpected or invalid polygons.
 *
 * @static
 * @param {H3IndexInput[]} h3Indexes  H3 indexes to get outlines for
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat], closed loops
 * @return {CoordPair[][][]}          MultiPolygon-style output.
 * @throws {H3Error}                  If input is invalid
 */ function $e3286925688328aa$export$cc0a8a1576bbfa35(h3Indexes, formatAsGeoJson) {
    // Early exit on empty input
    if (!h3Indexes || !h3Indexes.length) return [];
    // Set up input set
    var indexCount = h3Indexes.length;
    var set = $e3286925688328aa$var$libh3._calloc(indexCount, $e3286925688328aa$var$SZ_H3INDEX);
    $e3286925688328aa$var$storeArrayOfH3Indexes(set, h3Indexes);
    // Allocate memory for output linked polygon
    var polygon = $e3286925688328aa$var$libh3._calloc($e3286925688328aa$var$SZ_LINKED_GEOPOLYGON);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellsToLinkedMultiPolygon(set, indexCount, polygon));
        return $e3286925688328aa$var$readMultiPolygon(polygon, formatAsGeoJson);
    } finally{
        // Clean up
        $e3286925688328aa$var$H3.destroyLinkedMultiPolygon(polygon);
        $e3286925688328aa$var$libh3._free(polygon);
        $e3286925688328aa$var$libh3._free(set);
    }
}
/**
 * Compact a set of hexagons of the same resolution into a set of hexagons across
 * multiple levels that represents the same area.
 * @static
 * @param  {H3IndexInput[]} h3Set H3 indexes to compact
 * @return {H3Index[]}       Compacted H3 indexes
 * @throws {H3Error}         If the input is invalid (e.g. duplicate hexagons)
 */ function $e3286925688328aa$export$ee9ca32a1e229971(h3Set) {
    if (!h3Set || !h3Set.length) return [];
    // Set up input set
    var count = h3Set.length;
    var set = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
    $e3286925688328aa$var$storeArrayOfH3Indexes(set, h3Set);
    // Allocate memory for compacted hexagons, worst-case is no compaction
    var compactedSet = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.compactCells(set, compactedSet, count, $e3286925688328aa$var$UNUSED_UPPER_32_BITS));
        return $e3286925688328aa$var$readArrayOfH3Indexes(compactedSet, count);
    } finally{
        $e3286925688328aa$var$libh3._free(set);
        $e3286925688328aa$var$libh3._free(compactedSet);
    }
}
/**
 * Uncompact a compacted set of hexagons to hexagons of the same resolution
 * @static
 * @param  {H3IndexInput[]} compactedSet H3 indexes to uncompact
 * @param  {number}    res          The resolution to uncompact to
 * @return {H3Index[]}              The uncompacted H3 indexes
 * @throws {H3Error}                If the input is invalid (e.g. invalid resolution)
 */ function $e3286925688328aa$export$a9da1b97308bdeab(compactedSet, res) {
    $e3286925688328aa$var$validateRes(res);
    if (!compactedSet || !compactedSet.length) return [];
    // Set up input set
    var count = compactedSet.length;
    var set = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
    $e3286925688328aa$var$storeArrayOfH3Indexes(set, compactedSet);
    // Estimate how many hexagons we need (always overestimates if in error)
    var uncompactCellSizePtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.uncompactCellsSize(set, count, $e3286925688328aa$var$UNUSED_UPPER_32_BITS, res, uncompactCellSizePtr));
        var uncompactCellSize = $e3286925688328aa$var$validateArrayLength($e3286925688328aa$var$readInt64AsDoubleFromPointer(uncompactCellSizePtr));
        // Allocate memory for uncompacted hexagons
        var uncompactedSet = $e3286925688328aa$var$libh3._calloc(uncompactCellSize, $e3286925688328aa$var$SZ_H3INDEX);
        try {
            $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.uncompactCells(set, count, $e3286925688328aa$var$UNUSED_UPPER_32_BITS, uncompactedSet, uncompactCellSize, $e3286925688328aa$var$UNUSED_UPPER_32_BITS, res));
            return $e3286925688328aa$var$readArrayOfH3Indexes(uncompactedSet, uncompactCellSize);
        } finally{
            $e3286925688328aa$var$libh3._free(set);
            $e3286925688328aa$var$libh3._free(uncompactedSet);
        }
    } finally{
        $e3286925688328aa$var$libh3._free(uncompactCellSizePtr);
    }
}
// ----------------------------------------------------------------------------
// Public API functions: Directed edges
/**
 * Whether two H3 indexes are neighbors (share an edge)
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {boolean}             Whether the hexagons share an edge
 * @throws {H3Error}             If the input is invalid
 */ function $e3286925688328aa$export$ac86d91f8ad9347c(origin, destination) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $e3286925688328aa$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    var out = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.areNeighborCells(oLower, oUpper, dLower, dUpper, out));
        return $e3286925688328aa$var$readBooleanFromPointer(out);
    } finally{
        $e3286925688328aa$var$libh3._free(out);
    }
}
/**
 * Get an H3 index representing a unidirectional edge for a given origin and destination
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {H3Index}             H3 index of the edge, or null if no edge is shared
 * @throws {H3Error}             If the input is invalid
 */ function $e3286925688328aa$export$8d39f8da2c1c5c18(origin, destination) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $e3286925688328aa$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    var h3Index = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellsToDirectedEdge(oLower, oUpper, dLower, dUpper, h3Index));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(h3Index));
    } finally{
        $e3286925688328aa$var$libh3._free(h3Index);
    }
}
/**
 * Get the origin hexagon from an H3 index representing a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index}           H3 index of the edge origin
 * @throws {H3Error}           If the input is invalid
 */ function $e3286925688328aa$export$3ea8c95e1f56247a(edgeIndex) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    var h3Index = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getDirectedEdgeOrigin(lower, upper, h3Index));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(h3Index));
    } finally{
        $e3286925688328aa$var$libh3._free(h3Index);
    }
}
/**
 * Get the destination hexagon from an H3 index representing a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index}           H3 index of the edge destination
 * @throws {H3Error}           If the input is invalid
 */ function $e3286925688328aa$export$2e7afa8365b002e9(edgeIndex) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    var h3Index = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getDirectedEdgeDestination(lower, upper, h3Index));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(h3Index));
    } finally{
        $e3286925688328aa$var$libh3._free(h3Index);
    }
}
/**
 * Whether the input is a valid unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {boolean}           Whether the index is valid
 */ function $e3286925688328aa$export$6a98939d6926fca1(edgeIndex) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($e3286925688328aa$var$H3.isValidDirectedEdge(lower, upper));
}
/**
 * Get the [origin, destination] pair represented by a unidirectional edge
 * @static
 * @param  {H3IndexInput} edgeIndex H3 index of the edge
 * @return {H3Index[]}         [origin, destination] pair as H3 indexes
 * @throws {H3Error}           If the input is invalid
 */ function $e3286925688328aa$export$6e7b0ab2911942b7(edgeIndex) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    var count = 2;
    var hexagons = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.directedEdgeToCells(lower, upper, hexagons));
        return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
    } finally{
        $e3286925688328aa$var$libh3._free(hexagons);
    }
}
/**
 * Get all of the unidirectional edges with the given H3 index as the origin (i.e. an edge to
 * every neighbor)
 * @static
 * @param  {H3IndexInput} h3Index   H3 index of the origin hexagon
 * @return {H3Index[]}         List of unidirectional edges
 * @throws {H3Error}           If the input is invalid
 */ function $e3286925688328aa$export$6f1be22cafbae8a1(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var count = 6;
    var edges = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.originToDirectedEdges(lower, upper, edges));
        return $e3286925688328aa$var$readArrayOfH3Indexes(edges, count);
    } finally{
        $e3286925688328aa$var$libh3._free(edges);
    }
}
/**
 * Get the vertices of a given edge as an array of [lat, lng] points. Note that for edges that
 * cross the edge of an icosahedron face, this may return 3 coordinates.
 * @static
 * @param  {H3IndexInput} edgeIndex        H3 index of the edge
 * @param {boolean} [formatAsGeoJson] Whether to provide GeoJSON output: [lng, lat]
 * @return {CoordPair[]}              Array of geo coordinate pairs
 * @throws {H3Error}                  If the input is invalid
 */ function $e3286925688328aa$export$7ac37cc62fb459e9(edgeIndex, formatAsGeoJson) {
    var cellBoundary = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_CELLBOUNDARY);
    var ref = $e3286925688328aa$export$746fb3599c285d6a(edgeIndex);
    var lower = ref[0];
    var upper = ref[1];
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.directedEdgeToBoundary(lower, upper, cellBoundary));
        return $e3286925688328aa$var$readCellBoundary(cellBoundary, formatAsGeoJson);
    } finally{
        $e3286925688328aa$var$libh3._free(cellBoundary);
    }
}
/**
 * Get the grid distance between two hex indexes. This function may fail
 * to find the distance between two indexes if they are very far apart or
 * on opposite sides of a pentagon.
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {number}          Distance between hexagons
 * @throws {H3Error}         If input is invalid or the distance could not be calculated
 */ function $e3286925688328aa$export$c42bc9224d1de89(origin, destination) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $e3286925688328aa$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.gridDistance(oLower, oUpper, dLower, dUpper, countPtr));
        return $e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr);
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
    }
}
/**
 * Given two H3 indexes, return the line of indexes between them (inclusive).
 *
 * This function may fail to find the line between two indexes, for
 * example if they are very far apart. It may also fail when finding
 * distances for indexes on opposite sides of a pentagon.
 *
 * Notes:
 *
 *  - The specific output of this function should not be considered stable
 *    across library versions. The only guarantees the library provides are
 *    that the line length will be `h3Distance(start, end) + 1` and that
 *    every index in the line will be a neighbor of the preceding index.
 *  - Lines are drawn in grid space, and may not correspond exactly to either
 *    Cartesian lines or great arcs.
 *
 * @static
 * @param  {H3IndexInput} origin      Origin hexagon index
 * @param  {H3IndexInput} destination Destination hexagon index
 * @return {H3Index[]}           H3 indexes connecting origin and destination
 * @throws {H3Error}             If input is invalid or the line cannot be calculated
 */ function $e3286925688328aa$export$c6ba7bfdca2bd8d3(origin, destination) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(origin);
    var oLower = ref[0];
    var oUpper = ref[1];
    var ref$1 = $e3286925688328aa$export$746fb3599c285d6a(destination);
    var dLower = ref$1[0];
    var dUpper = ref$1[1];
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.gridPathCellsSize(oLower, oUpper, dLower, dUpper, countPtr));
        var count = $e3286925688328aa$var$validateArrayLength($e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr));
        var hexagons = $e3286925688328aa$var$libh3._calloc(count, $e3286925688328aa$var$SZ_H3INDEX);
        try {
            $e3286925688328aa$var$H3.gridPathCells(oLower, oUpper, dLower, dUpper, hexagons);
            return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
        } finally{
            $e3286925688328aa$var$libh3._free(hexagons);
        }
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
    }
}
var $e3286925688328aa$var$LOCAL_IJ_DEFAULT_MODE = 0;
/**
 * Produces IJ coordinates for an H3 index anchored by an origin.
 *
 * - The coordinate space used by this function may have deleted
 * regions or warping due to pentagonal distortion.
 * - Coordinates are only comparable if they come from the same
 * origin index.
 * - Failure may occur if the index is too far away from the origin
 * or if the index is on the other side of a pentagon.
 * - This function is experimental, and its output is not guaranteed
 * to be compatible across different versions of H3.
 * @static
 * @param  {H3IndexInput} origin      Origin H3 index
 * @param  {H3IndexInput} destination H3 index for which to find relative coordinates
 * @return {CoordIJ}             Coordinates as an `{i, j}` pair
 * @throws {H3Error}             If the IJ coordinates cannot be calculated
 */ function $e3286925688328aa$export$6dc6f58e4821bb4a(origin, destination) {
    var ij = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_COORDIJ);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToLocalIj.apply($e3286925688328aa$var$H3, $e3286925688328aa$export$746fb3599c285d6a(origin).concat($e3286925688328aa$export$746fb3599c285d6a(destination), [
            $e3286925688328aa$var$LOCAL_IJ_DEFAULT_MODE
        ], [
            ij
        ])));
        return $e3286925688328aa$var$readCoordIJ(ij);
    } finally{
        $e3286925688328aa$var$libh3._free(ij);
    }
}
/**
 * Produces an H3 index for IJ coordinates anchored by an origin.
 *
 * - The coordinate space used by this function may have deleted
 * regions or warping due to pentagonal distortion.
 * - Coordinates are only comparable if they come from the same
 * origin index.
 * - Failure may occur if the index is too far away from the origin
 * or if the index is on the other side of a pentagon.
 * - This function is experimental, and its output is not guaranteed
 * to be compatible across different versions of H3.
 * @static
 * @param  {H3IndexInput} origin     Origin H3 index
 * @param  {CoordIJ} coords     Coordinates as an `{i, j}` pair
 * @return {H3Index}            H3 index at the relative coordinates
 * @throws {H3Error}            If the H3 index cannot be calculated
 */ function $e3286925688328aa$export$d6a02dbf99f8edf4(origin, coords) {
    // Validate input coords
    if (!coords || typeof coords.i !== 'number' || typeof coords.j !== 'number') throw new Error('Coordinates must be provided as an {i, j} object');
    // Allocate memory for the CoordIJ struct and an H3 index to hold the return value
    var ij = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_COORDIJ);
    var out = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    $e3286925688328aa$var$storeCoordIJ(ij, coords);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.localIjToCell.apply($e3286925688328aa$var$H3, $e3286925688328aa$export$746fb3599c285d6a(origin).concat([
            ij
        ], [
            $e3286925688328aa$var$LOCAL_IJ_DEFAULT_MODE
        ], [
            out
        ])));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(out));
    } finally{
        $e3286925688328aa$var$libh3._free(ij);
        $e3286925688328aa$var$libh3._free(out);
    }
}
// ----------------------------------------------------------------------------
// Public API functions: Distance/area utilities
/**
 * Great circle distance between two geo points. This is not specific to H3,
 * but is implemented in the library and provided here as a convenience.
 * @static
 * @param  {number[]} latLng1 Origin coordinate as [lat, lng]
 * @param  {number[]} latLng2 Destination coordinate as [lat, lng]
 * @param  {string}   unit    Distance unit (either UNITS.m, UNITS.km, or UNITS.rads)
 * @return {number}           Great circle distance
 * @throws {H3Error}          If the unit is invalid
 */ function $e3286925688328aa$export$44c8942e65e8751d(latLng1, latLng2, unit) {
    var coord1 = $e3286925688328aa$var$storeLatLng(latLng1[0], latLng1[1]);
    var coord2 = $e3286925688328aa$var$storeLatLng(latLng2[0], latLng2[1]);
    var result;
    switch(unit){
        case $e3286925688328aa$export$a037d132965e1c9f.m:
            result = $e3286925688328aa$var$H3.greatCircleDistanceM(coord1, coord2);
            break;
        case $e3286925688328aa$export$a037d132965e1c9f.km:
            result = $e3286925688328aa$var$H3.greatCircleDistanceKm(coord1, coord2);
            break;
        case $e3286925688328aa$export$a037d132965e1c9f.rads:
            result = $e3286925688328aa$var$H3.greatCircleDistanceRads(coord1, coord2);
            break;
        default:
            result = null;
    }
    $e3286925688328aa$var$libh3._free(coord1);
    $e3286925688328aa$var$libh3._free(coord2);
    if (result === null) throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_UNKNOWN_UNIT, unit);
    return result;
}
/**
 * Exact area of a given cell
 * @static
 * @param  {H3IndexInput} h3Index  H3 index of the hexagon to measure
 * @param  {string}  unit     Distance unit (either UNITS.m2, UNITS.km2, or UNITS.rads2)
 * @return {number}           Cell area
 * @throws {H3Error}          If the input is invalid
 */ function $e3286925688328aa$export$dd1eba531ccc01d(h3Index, unit) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var out = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_DBL);
    try {
        switch(unit){
            case $e3286925688328aa$export$a037d132965e1c9f.m2:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellAreaM2(lower, upper, out));
                break;
            case $e3286925688328aa$export$a037d132965e1c9f.km2:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellAreaKm2(lower, upper, out));
                break;
            case $e3286925688328aa$export$a037d132965e1c9f.rads2:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellAreaRads2(lower, upper, out));
                break;
            default:
                throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_UNKNOWN_UNIT, unit);
        }
        return $e3286925688328aa$var$readDoubleFromPointer(out);
    } finally{
        $e3286925688328aa$var$libh3._free(out);
    }
}
/**
 * Calculate length of a given unidirectional edge
 * @static
 * @param  {H3IndexInput} edge     H3 index of the edge to measure
 * @param  {string}  unit     Distance unit (either UNITS.m, UNITS.km, or UNITS.rads)
 * @return {number}           Cell area
 * @throws {H3Error}          If the input is invalid
 */ function $e3286925688328aa$export$f9bb3d14d246c386(edge, unit) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(edge);
    var lower = ref[0];
    var upper = ref[1];
    var out = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_DBL);
    try {
        switch(unit){
            case $e3286925688328aa$export$a037d132965e1c9f.m:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.edgeLengthM(lower, upper, out));
                break;
            case $e3286925688328aa$export$a037d132965e1c9f.km:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.edgeLengthKm(lower, upper, out));
                break;
            case $e3286925688328aa$export$a037d132965e1c9f.rads:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.edgeLengthRads(lower, upper, out));
                break;
            default:
                throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_UNKNOWN_UNIT, unit);
        }
        return $e3286925688328aa$var$readDoubleFromPointer(out);
    } finally{
        $e3286925688328aa$var$libh3._free(out);
    }
}
/**
 * Average hexagon area at a given resolution
 * @static
 * @param  {number} res  Hexagon resolution
 * @param  {string} unit Area unit (either UNITS.m2, UNITS.km2, or UNITS.rads2)
 * @return {number}      Average area
 * @throws {H3Error}     If the input is invalid
 */ function $e3286925688328aa$export$9247787f433682cb(res, unit) {
    $e3286925688328aa$var$validateRes(res);
    var out = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_DBL);
    try {
        switch(unit){
            case $e3286925688328aa$export$a037d132965e1c9f.m2:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getHexagonAreaAvgM2(res, out));
                break;
            case $e3286925688328aa$export$a037d132965e1c9f.km2:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getHexagonAreaAvgKm2(res, out));
                break;
            default:
                throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_UNKNOWN_UNIT, unit);
        }
        return $e3286925688328aa$var$readDoubleFromPointer(out);
    } finally{
        $e3286925688328aa$var$libh3._free(out);
    }
}
/**
 * Average hexagon edge length at a given resolution
 * @static
 * @param  {number} res  Hexagon resolution
 * @param  {string} unit Distance unit (either UNITS.m, UNITS.km, or UNITS.rads)
 * @return {number}      Average edge length
 * @throws {H3Error}     If the input is invalid
 */ function $e3286925688328aa$export$63063d1421d0a0a(res, unit) {
    $e3286925688328aa$var$validateRes(res);
    var out = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_DBL);
    try {
        switch(unit){
            case $e3286925688328aa$export$a037d132965e1c9f.m:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getHexagonEdgeLengthAvgM(res, out));
                break;
            case $e3286925688328aa$export$a037d132965e1c9f.km:
                $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getHexagonEdgeLengthAvgKm(res, out));
                break;
            default:
                throw $e3286925688328aa$var$JSBindingError($e3286925688328aa$var$E_UNKNOWN_UNIT, unit);
        }
        return $e3286925688328aa$var$readDoubleFromPointer(out);
    } finally{
        $e3286925688328aa$var$libh3._free(out);
    }
}
// ----------------------------------------------------------------------------
// Public API functions: Vertex mode
/**
 * Find the index for a vertex of a cell.
 * @static
 * @param {H3IndexInput} h3Index     Cell to find the vertex for
 * @param {number} vertexNum         Number (index) of the vertex to calculate
 * @return {H3Index}     Vertex index
 * @throws {H3Error}     If the input is invalid
 */ function $e3286925688328aa$export$7e1cd0b5ed5e8953(h3Index, vertexNum) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var vertexIndex = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToVertex(lower, upper, vertexNum, vertexIndex));
        return $e3286925688328aa$var$validateH3Index($e3286925688328aa$var$readH3IndexFromPointer(vertexIndex));
    } finally{
        $e3286925688328aa$var$libh3._free(vertexIndex);
    }
}
/**
 * Find the indexes for all vertexes of a cell.
 * @static
 * @param {H3IndexInput} h3Index     Cell to find all vertexes for
 * @return {H3Index[]}   All vertex indexes of this cell
 * @throws {H3Error}     If the input is invalid
 */ function $e3286925688328aa$export$e38cb70303aa6b5f(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    var maxNumVertexes = 6;
    var vertexIndexes = $e3286925688328aa$var$libh3._calloc(maxNumVertexes, $e3286925688328aa$var$SZ_H3INDEX);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.cellToVertexes(lower, upper, vertexIndexes));
        return $e3286925688328aa$var$readArrayOfH3Indexes(vertexIndexes, maxNumVertexes);
    } finally{
        $e3286925688328aa$var$libh3._free(vertexIndexes);
    }
}
/**
 * Get the lat, lng of a given vertex
 * @static
 * @param {H3IndexInput} h3Index A vertex index
 * @returns {CoordPair}          Latitude, longitude coordinates of the vertex
 * @throws {H3Error}             If the input is invalid
 */ function $e3286925688328aa$export$b6fa9aaf00e71740(h3Index) {
    var latlng = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_LATLNG);
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.vertexToLatLng(lower, upper, latlng));
        return $e3286925688328aa$var$readLatLng(latlng);
    } finally{
        $e3286925688328aa$var$libh3._free(latlng);
    }
}
/**
 * Returns true if the input is a valid vertex index.
 * @static
 * @param {H3IndexInput} h3Index An index to test for being a vertex index
 * @returns {boolean} True if the index represents a vertex
 */ function $e3286925688328aa$export$e5afe9785d1c1ee(h3Index) {
    var ref = $e3286925688328aa$export$746fb3599c285d6a(h3Index);
    var lower = ref[0];
    var upper = ref[1];
    return Boolean($e3286925688328aa$var$H3.isValidVertex(lower, upper));
}
// ----------------------------------------------------------------------------
// Public informational utilities
/**
 * The total count of hexagons in the world at a given resolution. Note that above
 * resolution 8 the exact count cannot be represented in a JavaScript 32-bit number,
 * so consumers should use caution when applying further operations to the output.
 * @static
 * @param  {number} res  Hexagon resolution
 * @return {number}      Count
 * @throws {H3Error}     If the resolution is invalid
 */ function $e3286925688328aa$export$e5c4fe2e72216e08(res) {
    $e3286925688328aa$var$validateRes(res);
    var countPtr = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_INT64);
    try {
        // Get number as a long value
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getNumCells(res, countPtr));
        return $e3286925688328aa$var$readInt64AsDoubleFromPointer(countPtr);
    } finally{
        $e3286925688328aa$var$libh3._free(countPtr);
    }
}
/**
 * Get all H3 indexes at resolution 0. As every index at every resolution > 0 is
 * the descendant of a res 0 index, this can be used with h3ToChildren to iterate
 * over H3 indexes at any resolution.
 * @static
 * @return {H3Index[]}  All H3 indexes at res 0
 */ function $e3286925688328aa$export$69d974f3c9662e49() {
    var count = $e3286925688328aa$var$H3.res0CellCount();
    var hexagons = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX * count);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getRes0Cells(hexagons));
        return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
    } finally{
        $e3286925688328aa$var$libh3._free(hexagons);
    }
}
/**
 * Get the twelve pentagon indexes at a given resolution.
 * @static
 * @param  {number} res  Hexagon resolution
 * @return {H3Index[]}   All H3 pentagon indexes at res
 * @throws {H3Error}     If the resolution is invalid
 */ function $e3286925688328aa$export$171cd0ab89ca3dff(res) {
    $e3286925688328aa$var$validateRes(res);
    var count = $e3286925688328aa$var$H3.pentagonCount();
    var hexagons = $e3286925688328aa$var$libh3._malloc($e3286925688328aa$var$SZ_H3INDEX * count);
    try {
        $e3286925688328aa$var$throwIfError($e3286925688328aa$var$H3.getPentagons(res, hexagons));
        return $e3286925688328aa$var$readArrayOfH3Indexes(hexagons, count);
    } finally{
        $e3286925688328aa$var$libh3._free(hexagons);
    }
}
/**
 * Convert degrees to radians
 * @static
 * @param  {number} deg Value in degrees
 * @return {number}     Value in radians
 */ function $e3286925688328aa$export$18f2af2888c1a46b(deg) {
    return deg * Math.PI / 180;
}
/**
 * Convert radians to degrees
 * @static
 * @param  {number} rad Value in radians
 * @return {number}     Value in degrees
 */ function $e3286925688328aa$export$3eb27537c08caf0f(rad) {
    return rad * 180 / Math.PI;
}


function $4bf51ca10359b13b$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}


function $36c0f220e5dacaad$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

function $85750a69174e5177$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}


var $fe57fe65e0e8a0a1$exports = {};
/**
 * Represents octree data structure
 *
 * https://en.wikipedia.org/wiki/Octree
 */ var $101052e52ac64f3d$exports = {};
$101052e52ac64f3d$exports = $101052e52ac64f3d$var$Bounds3;
function $101052e52ac64f3d$var$Bounds3(x, y, z, half) {
    this.x = typeof x === 'number' ? x : 0;
    this.y = typeof y === 'number' ? y : 0;
    this.z = typeof z === 'number' ? z : 0;
    this.half = typeof half === 'number' ? half : 0;
}
$101052e52ac64f3d$var$Bounds3.prototype.contains = function contains(x, y, z) {
    var half = this.half;
    return this.x - half <= x && x < this.x + half && this.y - half <= y && y < this.y + half && this.z - half <= z && z < this.z + half;
};


var $aebadfab3f17b9b7$exports = {};

var $aebadfab3f17b9b7$var$MAX_ITEMS = 4;
$aebadfab3f17b9b7$exports = $aebadfab3f17b9b7$var$TreeNode;
function $aebadfab3f17b9b7$var$TreeNode(bounds) {
    this.bounds = bounds;
    this.q0 = null;
    this.q1 = null;
    this.q2 = null;
    this.q3 = null;
    this.q4 = null;
    this.q5 = null;
    this.q6 = null;
    this.q7 = null;
    this.items = null;
}
$aebadfab3f17b9b7$var$TreeNode.prototype.subdivide = function subdivide() {
    var bounds = this.bounds;
    var quarter = bounds.half / 2;
    this.q0 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x - quarter, bounds.y - quarter, bounds.z - quarter, quarter));
    this.q1 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x + quarter, bounds.y - quarter, bounds.z - quarter, quarter));
    this.q2 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x - quarter, bounds.y + quarter, bounds.z - quarter, quarter));
    this.q3 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x + quarter, bounds.y + quarter, bounds.z - quarter, quarter));
    this.q4 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x - quarter, bounds.y - quarter, bounds.z + quarter, quarter));
    this.q5 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x + quarter, bounds.y - quarter, bounds.z + quarter, quarter));
    this.q6 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x - quarter, bounds.y + quarter, bounds.z + quarter, quarter));
    this.q7 = new $aebadfab3f17b9b7$var$TreeNode(new $101052e52ac64f3d$exports(bounds.x + quarter, bounds.y + quarter, bounds.z + quarter, quarter));
};
$aebadfab3f17b9b7$var$TreeNode.prototype.insert = function insert(idx, array, depth) {
    var isLeaf = this.q0 === null;
    if (isLeaf) {
        // TODO: this memory could be recycled to avoid GC
        if (this.items === null) this.items = [
            idx
        ];
        else this.items.push(idx);
        if (this.items.length >= $aebadfab3f17b9b7$var$MAX_ITEMS && depth < 16) {
            this.subdivide();
            for(var i = 0; i < this.items.length; ++i)this.insert(this.items[i], array, depth + 1);
            this.items = null;
        }
    } else {
        var x = array[idx], y = array[idx + 1], z = array[idx + 2];
        var bounds = this.bounds;
        var quadIdx = 0; // assume NW
        if (x > bounds.x) quadIdx += 1; // nope, we are in E part
        if (y > bounds.y) quadIdx += 2; // Somewhere south.
        if (z > bounds.z) quadIdx += 4; // Somewhere far
        var child = $aebadfab3f17b9b7$var$getChild(this, quadIdx);
        child.insert(idx, array, depth + 1);
    }
};
$aebadfab3f17b9b7$var$TreeNode.prototype.query = function queryBounds(results, sourceArray, intersects, preciseCheck) {
    if (!intersects(this.bounds)) return;
    var items = this.items;
    var needsCheck = typeof preciseCheck === 'function';
    if (items) for(var i = 0; i < items.length; ++i){
        var idx = items[i];
        if (needsCheck) {
            if (preciseCheck(sourceArray[idx], sourceArray[idx + 1], sourceArray[idx + 2])) results.push(idx);
        } else results.push(idx);
    }
    if (!this.q0) return;
    this.q0.query(results, sourceArray, intersects, preciseCheck);
    this.q1.query(results, sourceArray, intersects, preciseCheck);
    this.q2.query(results, sourceArray, intersects, preciseCheck);
    this.q3.query(results, sourceArray, intersects, preciseCheck);
    this.q4.query(results, sourceArray, intersects, preciseCheck);
    this.q5.query(results, sourceArray, intersects, preciseCheck);
    this.q6.query(results, sourceArray, intersects, preciseCheck);
    this.q7.query(results, sourceArray, intersects, preciseCheck);
};
function $aebadfab3f17b9b7$var$getChild(node, idx) {
    if (idx === 0) return node.q0;
    if (idx === 1) return node.q1;
    if (idx === 2) return node.q2;
    if (idx === 3) return node.q3;
    if (idx === 4) return node.q4;
    if (idx === 5) return node.q5;
    if (idx === 6) return node.q6;
    if (idx === 7) return node.q7;
}


var $fe57fe65e0e8a0a1$var$EmptyRegion = new $101052e52ac64f3d$exports();
var $9cf481b4a5d4bc15$exports = {};
$9cf481b4a5d4bc15$exports = $9cf481b4a5d4bc15$var$asyncFor;
/**
 * Iterates over array in async manner. This function attempts to maximize
 * number of elements visited within single event loop cycle, while at the
 * same time tries to not exceed a time threshold allowed to stay within
 * event loop.
 *
 * @param {Array} array which needs to be iterated. Array-like objects are OK too.
 * @param {VisitCalback} visitCallback called for every element within for loop.
 * @param {DoneCallback} doneCallback called when iterator has reached end of array.
 * @param {Object=} options - additional configuration:
 * @param {number} [options.step=1] - default iteration step
 * @param {number} [options.maxTimeMS=8] - maximum time (in milliseconds) which
 *   iterator should spend within single event loop.
 * @param {number} [options.probeElements=5000] - how many elements should iterator
 *   visit to measure its iteration speed.
 */ function $9cf481b4a5d4bc15$var$asyncFor(array, visitCallback, doneCallback, options) {
    var start = 0;
    var elapsed = 0;
    options = options || {};
    var step = options.step || 1;
    var maxTimeMS = options.maxTimeMS || 8;
    var pointsPerLoopCycle = options.probeElements || 5000;
    // we should never block main thread for too long...
    setTimeout(processSubset, 0);
    function processSubset() {
        var finish = Math.min(array.length, start + pointsPerLoopCycle);
        var i = start;
        var timeStart = new Date();
        for(i = start; i < finish; i += step)visitCallback(array[i], i, array);
        if (i < array.length) {
            elapsed += new Date() - timeStart;
            start = i;
            pointsPerLoopCycle = Math.round(start * maxTimeMS / elapsed);
            setTimeout(processSubset, 0);
        } else doneCallback(array);
    }
}


$fe57fe65e0e8a0a1$exports = $fe57fe65e0e8a0a1$var$createTree;
function $fe57fe65e0e8a0a1$var$createTree(options) {
    options = options || {};
    var noPoints = [];
    var root;
    var originalArray;
    var api = {
        /**
     * Initializes tree asynchronously. Very useful when you have millions
     * of points and do not want to block rendering thread for too long.
     *
     * @param {number[]} points array of points for which we are building the
     * tree. Flat sequence of (x, y, z) coordinates. Array length should be
     * multiple of 3.
     *
     * @param {Function=} doneCallback called when tree is initialized. The
     * callback will be called with single argument which represent current
     * tree.
     */ initAsync: initAsync,
        /**
     * Synchronous version of `initAsync()`. Should only be used for small
     * trees (less than 50-70k of points).
     *
     * @param {number[]} points array of points for which we are building the
     * tree. Flat sequence of (x, y, z) coordinates. Array length should be
     * multiple of 3.
     */ init: init,
        /**
     * Gets bounds of the root node. Bounds are represented by center of the
     * node (x, y, z) and `half` attribute - distance from the center to an
     * edge of the root node.
     */ bounds: getBounds,
        /**
     * Fires a ray from `rayOrigin` into `rayDirection` and collects all points
     * that lie in the octants intersected by the ray.
     *
     * This method implements An Efficient Parametric Algorithm for Octree Traversal
     * described in http://wscg.zcu.cz/wscg2000/Papers_2000/X31.pdf
     *
     * @param {Vector3} rayOrigin x,y,z coordinates where ray starts
     * @param {Vector3} rayDirection normalized x,y,z direction where ray shoots.
     * @param {number+} near minimum distance from the ray origin. 0 by default.
     * @param {number+} far maximum length of the ray. POSITIVE_INFINITY by default
     *
     * @return {Array} of indices in the source array. Each index represnts a start
     * of the x,y,z triplet of a point, that lies in the intersected octant.
     */ intersectRay: intersectRay,
        /**
     * Once you have collected points from the octants intersected by a ray
     * (`intersectRay()` method), it may be worth to query points from the surrouning
     * area.
     */ intersectSphere: intersectSphere,
        /**
     * Gets root node of the tree
     */ getRoot: getRoot
    };
    return api;
    function getRoot() {
        return root;
    }
    function intersectSphere(cx, cy, cz, r) {
        if (!root) // Most likely we are not initialized yet
        return noPoints;
        var indices = [];
        var r2 = r * r;
        root.query(indices, originalArray, intersectCheck, preciseCheck);
        return indices;
        // http://stackoverflow.com/questions/4578967/cube-sphere-intersection-test
        function intersectCheck(candidate) {
            var dist = r2;
            var half = candidate.half;
            if (cx < candidate.x - half) dist -= sqr(cx - (candidate.x - half));
            else if (cx > candidate.x + half) dist -= sqr(cx - (candidate.x + half));
            if (cy < candidate.y - half) dist -= sqr(cy - (candidate.y - half));
            else if (cy > candidate.y + half) dist -= sqr(cy - (candidate.y + half));
            if (cz < candidate.z - half) dist -= sqr(cz - (candidate.z - half));
            else if (cz > candidate.z + half) dist -= sqr(cz - (candidate.z + half));
            return dist > 0;
        }
        function preciseCheck(x, y, z) {
            return sqr(x - cx) + sqr(y - cy) + sqr(z - cz) < r2;
        }
    }
    function sqr(x) {
        return x * x;
    }
    function intersectRay(rayOrigin, rayDirection, near, far) {
        if (!root) // Most likely we are not initialized yet
        return noPoints;
        if (near === undefined) near = 0;
        if (far === undefined) far = Number.POSITIVE_INFINITY;
        // we save as squar, to avoid expensive sqrt() operation
        near *= near;
        far *= far;
        var indices = [];
        root.query(indices, originalArray, intersectCheck, farEnough);
        return indices.sort(byDistanceToCamera);
        function intersectCheck(candidate) {
            // using http://wscg.zcu.cz/wscg2000/Papers_2000/X31.pdf
            var half = candidate.half;
            var t1 = (candidate.x - half - rayOrigin.x) / rayDirection.x, t2 = (candidate.x + half - rayOrigin.x) / rayDirection.x, t3 = (candidate.y + half - rayOrigin.y) / rayDirection.y, t4 = (candidate.y - half - rayOrigin.y) / rayDirection.y, t5 = (candidate.z - half - rayOrigin.z) / rayDirection.z, t6 = (candidate.z + half - rayOrigin.z) / rayDirection.z, tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)), Math.max(t5, t6)), tmin;
            if (tmax < 0) return false;
            tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)), Math.min(t5, t6));
            return tmin <= tmax && tmin <= far;
        }
        function farEnough(x, y, z) {
            var dist = (x - rayOrigin.x) * (x - rayOrigin.x) + (y - rayOrigin.y) * (y - rayOrigin.y) + (z - rayOrigin.z) * (z - rayOrigin.z);
            return near <= dist && dist <= far;
        }
        function byDistanceToCamera(idx0, idx1) {
            var x0 = rayOrigin[idx0];
            var y0 = rayOrigin[idx0 + 1];
            var z0 = rayOrigin[idx0 + 2];
            var dist0 = (x0 - rayOrigin.x) * (x0 - rayOrigin.x) + (y0 - rayOrigin.y) * (y0 - rayOrigin.y) + (z0 - rayOrigin.z) * (z0 - rayOrigin.z);
            var x1 = rayOrigin[idx1];
            var y1 = rayOrigin[idx1 + 1];
            var z1 = rayOrigin[idx1 + 2];
            var dist1 = (x1 - rayOrigin.x) * (x1 - rayOrigin.x) + (y1 - rayOrigin.y) * (y1 - rayOrigin.y) + (z1 - rayOrigin.z) * (z1 - rayOrigin.z);
            return dist0 - dist1;
        }
    }
    function init(points) {
        verifyPointsInvariant(points);
        originalArray = points;
        root = createRootNode(points);
        for(var i = 0; i < points.length; i += 3)root.insert(i, originalArray, 0);
    }
    function initAsync(points, doneCallback) {
        verifyPointsInvariant(points);
        var tempRoot = createRootNode(points);
        $9cf481b4a5d4bc15$exports(points, insertToRoot, doneInternal, {
            step: 3
        });
        function insertToRoot(element, i) {
            tempRoot.insert(i, points, 0);
        }
        function doneInternal() {
            originalArray = points;
            root = tempRoot;
            if (typeof doneCallback === 'function') doneCallback(api);
        }
    }
    function verifyPointsInvariant(points) {
        if (!points) throw new Error('Points array is required for quadtree to work');
        if (typeof points.length !== 'number') throw new Error('Points should be array-like object');
        if (points.length % 3 !== 0) throw new Error('Points array should consist of series of x,y,z coordinates and be multiple of 3');
    }
    function getBounds() {
        if (!root) return $fe57fe65e0e8a0a1$var$EmptyRegion;
        return root.bounds;
    }
    function createRootNode(points) {
        // Edge case deserves empty region:
        if (points.length === 0) {
            var empty = new $101052e52ac64f3d$exports();
            return new $aebadfab3f17b9b7$exports(empty);
        }
        // Otherwise let's figure out how big should be the root region
        var minX = Number.POSITIVE_INFINITY;
        var minY = Number.POSITIVE_INFINITY;
        var minZ = Number.POSITIVE_INFINITY;
        var maxX = Number.NEGATIVE_INFINITY;
        var maxY = Number.NEGATIVE_INFINITY;
        var maxZ = Number.NEGATIVE_INFINITY;
        for(var i = 0; i < points.length; i += 3){
            var x = points[i], y = points[i + 1], z = points[i + 2];
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
            if (z < minZ) minZ = z;
            if (z > maxZ) maxZ = z;
        }
        // Make bounds square:
        var side = Math.max(Math.max(maxX - minX, maxY - minY), maxZ - minZ);
        // since we need to have both sides inside the area, let's artificially
        // grow the root region:
        side += 2;
        minX -= 1;
        minY -= 1;
        minZ -= 1;
        var half = side / 2;
        var bounds = new $101052e52ac64f3d$exports(minX + half, minY + half, minZ + half, half);
        return new $aebadfab3f17b9b7$exports(bounds);
    }
}



const $83768f2837205906$var$THREE$2 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Box3: $8725869b83961a04$export$6f7d5a9418ab2aa3,
    BufferGeometry: $8725869b83961a04$export$b7be63a67df8959,
    Float32BufferAttribute: $8725869b83961a04$export$cbe7a62641830ebd,
    InstancedBufferGeometry: $8725869b83961a04$export$231f009cbe414146,
    InstancedInterleavedBuffer: $8725869b83961a04$export$25ec0e1af1389358,
    InterleavedBufferAttribute: $8725869b83961a04$export$920b6d07334599c7,
    Sphere: $8725869b83961a04$export$805e8b72413ccaba,
    Vector3: $8725869b83961a04$export$64b5c384219d3699,
    WireframeGeometry: $8725869b83961a04$export$4b739da06d24892b
};
// support multiple method names for backwards threejs compatibility
var $83768f2837205906$var$setAttributeFn$1 = new $83768f2837205906$var$THREE$2.BufferGeometry().setAttribute ? 'setAttribute' : 'addAttribute';
const $83768f2837205906$var$_box$1 = new $83768f2837205906$var$THREE$2.Box3();
const $83768f2837205906$var$_vector = new $83768f2837205906$var$THREE$2.Vector3();
class $83768f2837205906$export$5b1256aa5274bf8 extends $83768f2837205906$var$THREE$2.InstancedBufferGeometry {
    constructor(){
        super();
        this.type = 'LineSegmentsGeometry';
        const positions = [
            -1,
            2,
            0,
            1,
            2,
            0,
            -1,
            1,
            0,
            1,
            1,
            0,
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const uvs = [
            -1,
            2,
            1,
            2,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -2,
            1,
            -2
        ];
        const index = [
            0,
            2,
            1,
            2,
            3,
            1,
            2,
            4,
            3,
            4,
            5,
            3,
            4,
            6,
            5,
            6,
            7,
            5
        ];
        this.setIndex(index);
        this[$83768f2837205906$var$setAttributeFn$1]('position', new $83768f2837205906$var$THREE$2.Float32BufferAttribute(positions, 3));
        this[$83768f2837205906$var$setAttributeFn$1]('uv', new $83768f2837205906$var$THREE$2.Float32BufferAttribute(uvs, 2));
    }
    applyMatrix4(matrix) {
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined) {
            start.applyMatrix4(matrix);
            end.applyMatrix4(matrix);
            start.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    setPositions(array) {
        let lineSegments;
        if (array instanceof Float32Array) lineSegments = array;
        else if (Array.isArray(array)) lineSegments = new Float32Array(array);
        const instanceBuffer = new $83768f2837205906$var$THREE$2.InstancedInterleavedBuffer(lineSegments, 6, 1); // xyz, xyz
        this[$83768f2837205906$var$setAttributeFn$1]('instanceStart', new $83768f2837205906$var$THREE$2.InterleavedBufferAttribute(instanceBuffer, 3, 0)); // xyz
        this[$83768f2837205906$var$setAttributeFn$1]('instanceEnd', new $83768f2837205906$var$THREE$2.InterleavedBufferAttribute(instanceBuffer, 3, 3)); // xyz
        //
        this.computeBoundingBox();
        this.computeBoundingSphere();
        return this;
    }
    setColors(array) {
        let colors;
        if (array instanceof Float32Array) colors = array;
        else if (Array.isArray(array)) colors = new Float32Array(array);
        const instanceColorBuffer = new $83768f2837205906$var$THREE$2.InstancedInterleavedBuffer(colors, 6, 1); // rgb, rgb
        this[$83768f2837205906$var$setAttributeFn$1]('instanceColorStart', new $83768f2837205906$var$THREE$2.InterleavedBufferAttribute(instanceColorBuffer, 3, 0)); // rgb
        this[$83768f2837205906$var$setAttributeFn$1]('instanceColorEnd', new $83768f2837205906$var$THREE$2.InterleavedBufferAttribute(instanceColorBuffer, 3, 3)); // rgb
        return this;
    }
    fromWireframeGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromEdgesGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromMesh(mesh) {
        this.fromWireframeGeometry(new $83768f2837205906$var$THREE$2.WireframeGeometry(mesh.geometry)); // set colors, maybe
        return this;
    }
    fromLineSegments(lineSegments) {
        const geometry = lineSegments.geometry;
        if (geometry.isGeometry) {
            console.error('LineSegmentsGeometry no longer supports Geometry. Use THREE.BufferGeometry instead.');
            return;
        } else if (geometry.isBufferGeometry) this.setPositions(geometry.attributes.position.array); // assumes non-indexed
         // set colors, maybe
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $83768f2837205906$var$THREE$2.Box3();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            this.boundingBox.setFromBufferAttribute(start);
            $83768f2837205906$var$_box$1.setFromBufferAttribute(end);
            this.boundingBox.union($83768f2837205906$var$_box$1);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $83768f2837205906$var$THREE$2.Sphere();
        if (this.boundingBox === null) this.computeBoundingBox();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            const center = this.boundingSphere.center;
            this.boundingBox.getCenter(center);
            let maxRadiusSq = 0;
            for(let i = 0, il = start.count; i < il; i++){
                $83768f2837205906$var$_vector.fromBufferAttribute(start, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($83768f2837205906$var$_vector));
                $83768f2837205906$var$_vector.fromBufferAttribute(end, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($83768f2837205906$var$_vector));
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.', this);
        }
    }
    toJSON() {}
    applyMatrix(matrix) {
        console.warn('THREE.LineSegmentsGeometry: applyMatrix() has been renamed to applyMatrix4().');
        return this.applyMatrix4(matrix);
    }
}
$83768f2837205906$export$5b1256aa5274bf8.prototype.isLineSegmentsGeometry = true;
/**
 * parameters = {
 *  color: <hex>,
 *  linewidth: <float>,
 *  dashed: <boolean>,
 *  dashScale: <float>,
 *  dashSize: <float>,
 *  dashOffset: <float>,
 *  gapSize: <float>,
 *  resolution: <Vector2>, // to be set by renderer
 * }
 */ const $83768f2837205906$var$THREE$1 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    ShaderLib: $8725869b83961a04$export$bee4a7d47f8f5014,
    ShaderMaterial: $8725869b83961a04$export$83c7d75d550a8b0d,
    UniformsLib: $8725869b83961a04$export$6643083551874bf5,
    UniformsUtils: $8725869b83961a04$export$d8ecdf8615bfea69,
    Vector2: $8725869b83961a04$export$c977b3e384af9ae1
};
$83768f2837205906$var$THREE$1.UniformsLib.line = {
    worldUnits: {
        value: 1
    },
    linewidth: {
        value: 1
    },
    resolution: {
        value: new $83768f2837205906$var$THREE$1.Vector2(1, 1)
    },
    dashScale: {
        value: 1
    },
    dashSize: {
        value: 1
    },
    dashOffset: {
        value: 0
    },
    gapSize: {
        value: 1
    } // todo FIX - maybe change to totalSize
};
$83768f2837205906$var$THREE$1.ShaderLib['line'] = {
    uniforms: $83768f2837205906$var$THREE$1.UniformsUtils.merge([
        $83768f2837205906$var$THREE$1.UniformsLib.common,
        $83768f2837205906$var$THREE$1.UniformsLib.fog,
        $83768f2837205906$var$THREE$1.UniformsLib.line
    ]),
    vertexShader: /* glsl */ `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		varying vec2 vUv;
		varying vec4 worldPos;
		varying vec3 worldStart;
		varying vec3 worldEnd;

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;

			#endif

			float aspect = resolution.x / resolution.y;

			vUv = uv;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			worldStart = start.xyz;
			worldEnd = end.xyz;

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				// get the offset direction as perpendicular to the view vector
				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 offset;
				if ( position.y < 0.5 ) {

					offset = normalize( cross( start.xyz, worldDir ) );

				} else {

					offset = normalize( cross( end.xyz, worldDir ) );

				}

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				float forwardOffset = dot( worldDir, vec3( 0.0, 0.0, 1.0 ) );

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// extend the line bounds to encompass  endcaps
					start.xyz += - worldDir * linewidth * 0.5;
					end.xyz += worldDir * linewidth * 0.5;

					// shift the position of the quad so it hugs the forward edge of the line
					offset.xy -= dir * forwardOffset;
					offset.z += 0.5;

				#endif

				// endcaps
				if ( position.y > 1.0 || position.y < 0.0 ) {

					offset.xy += dir * 2.0 * forwardOffset;

				}

				// adjust for linewidth
				offset *= linewidth * 0.5;

				// set the world position
				worldPos = ( position.y < 0.5 ) ? start : end;
				worldPos.xyz += offset;

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segements overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

			vec2 offset = vec2( dir.y, - dir.x );
			// undo aspect ratio adjustment
			dir.x /= aspect;
			offset.x /= aspect;

			// sign flip
			if ( position.x < 0.0 ) offset *= - 1.0;

			// endcaps
			if ( position.y < 0.0 ) {

				offset += - dir;

			} else if ( position.y > 1.0 ) {

				offset += dir;

			}

			// adjust for linewidth
			offset *= linewidth;

			// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
			offset /= resolution.y;

			// select end
			vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

			// back to clip space
			offset *= clip.w;

			clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`,
    fragmentShader: /* glsl */ `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;
		varying vec4 worldPos;
		varying vec3 worldStart;
		varying vec3 worldEnd;

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		varying vec2 vUv;

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

			#endif

			#else

				#ifdef ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

			if ( abs( vUv.y ) > 1.0 ) {

				float a = vUv.x;
				float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
				float len2 = a * a + b * b;

				if ( len2 > 1.0 ) discard;

			}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <colorspace_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		`
};
class $83768f2837205906$export$d19cd1378966f3d3 extends $83768f2837205906$var$THREE$1.ShaderMaterial {
    constructor(parameters){
        super({
            type: 'LineMaterial',
            uniforms: $83768f2837205906$var$THREE$1.UniformsUtils.clone($83768f2837205906$var$THREE$1.ShaderLib['line'].uniforms),
            vertexShader: $83768f2837205906$var$THREE$1.ShaderLib['line'].vertexShader,
            fragmentShader: $83768f2837205906$var$THREE$1.ShaderLib['line'].fragmentShader,
            clipping: true // required for clipping support
        });
        Object.defineProperties(this, {
            color: {
                enumerable: true,
                get: function() {
                    return this.uniforms.diffuse.value;
                },
                set: function(value) {
                    this.uniforms.diffuse.value = value;
                }
            },
            worldUnits: {
                enumerable: true,
                get: function() {
                    return 'WORLD_UNITS' in this.defines;
                },
                set: function(value) {
                    if (value === true) this.defines.WORLD_UNITS = '';
                    else delete this.defines.WORLD_UNITS;
                }
            },
            linewidth: {
                enumerable: true,
                get: function() {
                    return this.uniforms.linewidth.value;
                },
                set: function(value) {
                    this.uniforms.linewidth.value = value;
                }
            },
            dashed: {
                enumerable: true,
                get: function() {
                    return Boolean('USE_DASH' in this.defines);
                },
                set (value) {
                    if (Boolean(value) !== Boolean('USE_DASH' in this.defines)) this.needsUpdate = true;
                    if (value === true) this.defines.USE_DASH = '';
                    else delete this.defines.USE_DASH;
                }
            },
            dashScale: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashScale.value;
                },
                set: function(value) {
                    this.uniforms.dashScale.value = value;
                }
            },
            dashSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashSize.value;
                },
                set: function(value) {
                    this.uniforms.dashSize.value = value;
                }
            },
            dashOffset: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashOffset.value;
                },
                set: function(value) {
                    this.uniforms.dashOffset.value = value;
                }
            },
            gapSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.gapSize.value;
                },
                set: function(value) {
                    this.uniforms.gapSize.value = value;
                }
            },
            opacity: {
                enumerable: true,
                get: function() {
                    return this.uniforms.opacity.value;
                },
                set: function(value) {
                    this.uniforms.opacity.value = value;
                }
            },
            resolution: {
                enumerable: true,
                get: function() {
                    return this.uniforms.resolution.value;
                },
                set: function(value) {
                    this.uniforms.resolution.value.copy(value);
                }
            },
            alphaToCoverage: {
                enumerable: true,
                get: function() {
                    return Boolean('ALPHA_TO_COVERAGE' in this.defines);
                },
                set: function(value) {
                    if (Boolean(value) !== Boolean('ALPHA_TO_COVERAGE' in this.defines)) this.needsUpdate = true;
                    if (value === true) {
                        this.defines.ALPHA_TO_COVERAGE = '';
                        this.extensions.derivatives = true;
                    } else {
                        delete this.defines.ALPHA_TO_COVERAGE;
                        this.extensions.derivatives = false;
                    }
                }
            }
        });
        this.setValues(parameters);
    }
}
$83768f2837205906$export$d19cd1378966f3d3.prototype.isLineMaterial = true;
const $83768f2837205906$var$THREE = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Box3: $8725869b83961a04$export$6f7d5a9418ab2aa3,
    BufferGeometry: $8725869b83961a04$export$b7be63a67df8959,
    InstancedInterleavedBuffer: $8725869b83961a04$export$25ec0e1af1389358,
    InterleavedBufferAttribute: $8725869b83961a04$export$920b6d07334599c7,
    Line3: $8725869b83961a04$export$e0ba6359f1954fd3,
    MathUtils: $8725869b83961a04$export$6a7ef315a0d1ef07,
    Matrix4: $8725869b83961a04$export$2ae72fc923e5eb5,
    Mesh: $8725869b83961a04$export$e176487c05830cc5,
    Sphere: $8725869b83961a04$export$805e8b72413ccaba,
    Vector3: $8725869b83961a04$export$64b5c384219d3699,
    Vector4: $8725869b83961a04$export$fa7daccca11cdbe3
};
// support both modes for backwards threejs compatibility
var $83768f2837205906$var$setAttributeFn = new $83768f2837205906$var$THREE.BufferGeometry().setAttribute ? 'setAttribute' : 'addAttribute';
const $83768f2837205906$var$_start = new $83768f2837205906$var$THREE.Vector3();
const $83768f2837205906$var$_end = new $83768f2837205906$var$THREE.Vector3();
const $83768f2837205906$var$_start4 = new $83768f2837205906$var$THREE.Vector4();
const $83768f2837205906$var$_end4 = new $83768f2837205906$var$THREE.Vector4();
const $83768f2837205906$var$_ssOrigin = new $83768f2837205906$var$THREE.Vector4();
const $83768f2837205906$var$_ssOrigin3 = new $83768f2837205906$var$THREE.Vector3();
const $83768f2837205906$var$_mvMatrix = new $83768f2837205906$var$THREE.Matrix4();
const $83768f2837205906$var$_line = new $83768f2837205906$var$THREE.Line3();
const $83768f2837205906$var$_closestPoint = new $83768f2837205906$var$THREE.Vector3();
const $83768f2837205906$var$_box = new $83768f2837205906$var$THREE.Box3();
const $83768f2837205906$var$_sphere = new $83768f2837205906$var$THREE.Sphere();
const $83768f2837205906$var$_clipToWorldVector = new $83768f2837205906$var$THREE.Vector4();
class $83768f2837205906$export$6eda8f258bdba8c5 extends $83768f2837205906$var$THREE.Mesh {
    constructor(geometry = new $83768f2837205906$export$5b1256aa5274bf8(), material = new $83768f2837205906$export$d19cd1378966f3d3({
        color: Math.random() * 0xffffff
    })){
        super(geometry, material);
        this.type = 'LineSegments2';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        const instanceStart = geometry.attributes.instanceStart;
        const instanceEnd = geometry.attributes.instanceEnd;
        const lineDistances = new Float32Array(2 * instanceStart.count);
        for(let i = 0, j = 0, l = instanceStart.count; i < l; i++, j += 2){
            $83768f2837205906$var$_start.fromBufferAttribute(instanceStart, i);
            $83768f2837205906$var$_end.fromBufferAttribute(instanceEnd, i);
            lineDistances[j] = j === 0 ? 0 : lineDistances[j - 1];
            lineDistances[j + 1] = lineDistances[j] + $83768f2837205906$var$_start.distanceTo($83768f2837205906$var$_end);
        }
        const instanceDistanceBuffer = new $83768f2837205906$var$THREE.InstancedInterleavedBuffer(lineDistances, 2, 1); // d0, d1
        geometry[$83768f2837205906$var$setAttributeFn]('instanceDistanceStart', new $83768f2837205906$var$THREE.InterleavedBufferAttribute(instanceDistanceBuffer, 1, 0)); // d0
        geometry[$83768f2837205906$var$setAttributeFn]('instanceDistanceEnd', new $83768f2837205906$var$THREE.InterleavedBufferAttribute(instanceDistanceBuffer, 1, 1)); // d1
        return this;
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2.');
        const threshold = raycaster.params.Line2 !== undefined ? raycaster.params.Line2.threshold || 0 : 0;
        const ray = raycaster.ray;
        const camera = raycaster.camera;
        const projectionMatrix = camera.projectionMatrix;
        const matrixWorld = this.matrixWorld;
        const geometry = this.geometry;
        const material = this.material;
        const resolution = material.resolution;
        const lineWidth = material.linewidth + threshold;
        const instanceStart = geometry.attributes.instanceStart;
        const instanceEnd = geometry.attributes.instanceEnd; // camera forward is negative
        const near = -camera.near; // clip space is [ - 1, 1 ] so multiply by two to get the full
        // width in clip space
        const ssMaxWidth = 2.0 * Math.max(lineWidth / resolution.width, lineWidth / resolution.height); //
        // check if we intersect the sphere bounds
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $83768f2837205906$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(matrixWorld);
        const distanceToSphere = Math.max(camera.near, $83768f2837205906$var$_sphere.distanceToPoint(ray.origin)); // get the w component to scale the world space line width
        $83768f2837205906$var$_clipToWorldVector.set(0, 0, -distanceToSphere, 1.0).applyMatrix4(camera.projectionMatrix);
        $83768f2837205906$var$_clipToWorldVector.multiplyScalar(1.0 / $83768f2837205906$var$_clipToWorldVector.w);
        $83768f2837205906$var$_clipToWorldVector.applyMatrix4(camera.projectionMatrixInverse); // increase the sphere bounds by the worst case line screen space width
        const sphereMargin = Math.abs(ssMaxWidth / $83768f2837205906$var$_clipToWorldVector.w) * 0.5;
        $83768f2837205906$var$_sphere.radius += sphereMargin;
        if (raycaster.ray.intersectsSphere($83768f2837205906$var$_sphere) === false) return;
         //
        // check if we intersect the box bounds
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        $83768f2837205906$var$_box.copy(geometry.boundingBox).applyMatrix4(matrixWorld);
        const distanceToBox = Math.max(camera.near, $83768f2837205906$var$_box.distanceToPoint(ray.origin)); // get the w component to scale the world space line width
        $83768f2837205906$var$_clipToWorldVector.set(0, 0, -distanceToBox, 1.0).applyMatrix4(camera.projectionMatrix);
        $83768f2837205906$var$_clipToWorldVector.multiplyScalar(1.0 / $83768f2837205906$var$_clipToWorldVector.w);
        $83768f2837205906$var$_clipToWorldVector.applyMatrix4(camera.projectionMatrixInverse); // increase the sphere bounds by the worst case line screen space width
        const boxMargin = Math.abs(ssMaxWidth / $83768f2837205906$var$_clipToWorldVector.w) * 0.5;
        $83768f2837205906$var$_box.max.x += boxMargin;
        $83768f2837205906$var$_box.max.y += boxMargin;
        $83768f2837205906$var$_box.max.z += boxMargin;
        $83768f2837205906$var$_box.min.x -= boxMargin;
        $83768f2837205906$var$_box.min.y -= boxMargin;
        $83768f2837205906$var$_box.min.z -= boxMargin;
        if (raycaster.ray.intersectsBox($83768f2837205906$var$_box) === false) return;
         //
        // pick a point 1 unit out along the ray to avoid the ray origin
        // sitting at the camera origin which will cause "w" to be 0 when
        // applying the projection matrix.
        ray.at(1, $83768f2837205906$var$_ssOrigin); // ndc space [ - 1.0, 1.0 ]
        $83768f2837205906$var$_ssOrigin.w = 1;
        $83768f2837205906$var$_ssOrigin.applyMatrix4(camera.matrixWorldInverse);
        $83768f2837205906$var$_ssOrigin.applyMatrix4(projectionMatrix);
        $83768f2837205906$var$_ssOrigin.multiplyScalar(1 / $83768f2837205906$var$_ssOrigin.w); // screen space
        $83768f2837205906$var$_ssOrigin.x *= resolution.x / 2;
        $83768f2837205906$var$_ssOrigin.y *= resolution.y / 2;
        $83768f2837205906$var$_ssOrigin.z = 0;
        $83768f2837205906$var$_ssOrigin3.copy($83768f2837205906$var$_ssOrigin);
        $83768f2837205906$var$_mvMatrix.multiplyMatrices(camera.matrixWorldInverse, matrixWorld);
        for(let i = 0, l = instanceStart.count; i < l; i++){
            $83768f2837205906$var$_start4.fromBufferAttribute(instanceStart, i);
            $83768f2837205906$var$_end4.fromBufferAttribute(instanceEnd, i);
            $83768f2837205906$var$_start4.w = 1;
            $83768f2837205906$var$_end4.w = 1; // camera space
            $83768f2837205906$var$_start4.applyMatrix4($83768f2837205906$var$_mvMatrix);
            $83768f2837205906$var$_end4.applyMatrix4($83768f2837205906$var$_mvMatrix); // skip the segment if it's entirely behind the camera
            var isBehindCameraNear = $83768f2837205906$var$_start4.z > near && $83768f2837205906$var$_end4.z > near;
            if (isBehindCameraNear) continue;
             // trim the segment if it extends behind camera near
            if ($83768f2837205906$var$_start4.z > near) {
                const deltaDist = $83768f2837205906$var$_start4.z - $83768f2837205906$var$_end4.z;
                const t = ($83768f2837205906$var$_start4.z - near) / deltaDist;
                $83768f2837205906$var$_start4.lerp($83768f2837205906$var$_end4, t);
            } else if ($83768f2837205906$var$_end4.z > near) {
                const deltaDist = $83768f2837205906$var$_end4.z - $83768f2837205906$var$_start4.z;
                const t = ($83768f2837205906$var$_end4.z - near) / deltaDist;
                $83768f2837205906$var$_end4.lerp($83768f2837205906$var$_start4, t);
            } // clip space
            $83768f2837205906$var$_start4.applyMatrix4(projectionMatrix);
            $83768f2837205906$var$_end4.applyMatrix4(projectionMatrix); // ndc space [ - 1.0, 1.0 ]
            $83768f2837205906$var$_start4.multiplyScalar(1 / $83768f2837205906$var$_start4.w);
            $83768f2837205906$var$_end4.multiplyScalar(1 / $83768f2837205906$var$_end4.w); // screen space
            $83768f2837205906$var$_start4.x *= resolution.x / 2;
            $83768f2837205906$var$_start4.y *= resolution.y / 2;
            $83768f2837205906$var$_end4.x *= resolution.x / 2;
            $83768f2837205906$var$_end4.y *= resolution.y / 2; // create 2d segment
            $83768f2837205906$var$_line.start.copy($83768f2837205906$var$_start4);
            $83768f2837205906$var$_line.start.z = 0;
            $83768f2837205906$var$_line.end.copy($83768f2837205906$var$_end4);
            $83768f2837205906$var$_line.end.z = 0; // get closest point on ray to segment
            const param = $83768f2837205906$var$_line.closestPointToPointParameter($83768f2837205906$var$_ssOrigin3, true);
            $83768f2837205906$var$_line.at(param, $83768f2837205906$var$_closestPoint); // check if the intersection point is within clip space
            const zPos = $83768f2837205906$var$THREE.MathUtils.lerp($83768f2837205906$var$_start4.z, $83768f2837205906$var$_end4.z, param);
            const isInClipSpace = zPos >= -1 && zPos <= 1;
            const isInside = $83768f2837205906$var$_ssOrigin3.distanceTo($83768f2837205906$var$_closestPoint) < lineWidth * 0.5;
            if (isInClipSpace && isInside) {
                $83768f2837205906$var$_line.start.fromBufferAttribute(instanceStart, i);
                $83768f2837205906$var$_line.end.fromBufferAttribute(instanceEnd, i);
                $83768f2837205906$var$_line.start.applyMatrix4(matrixWorld);
                $83768f2837205906$var$_line.end.applyMatrix4(matrixWorld);
                const pointOnLine = new $83768f2837205906$var$THREE.Vector3();
                const point = new $83768f2837205906$var$THREE.Vector3();
                ray.distanceSqToSegment($83768f2837205906$var$_line.start, $83768f2837205906$var$_line.end, point, pointOnLine);
                intersects.push({
                    point: point,
                    pointOnLine: pointOnLine,
                    distance: ray.origin.distanceTo(point),
                    object: this,
                    face: null,
                    faceIndex: i,
                    uv: null,
                    uv2: null
                });
            }
        }
    }
}
$83768f2837205906$export$6eda8f258bdba8c5.prototype.LineSegments2 = true;
class $83768f2837205906$export$dcc17b59d0a74bb5 extends $83768f2837205906$export$5b1256aa5274bf8 {
    constructor(){
        super();
        this.type = 'LineGeometry';
    }
    setPositions(array) {
        // converts [ x1, y1, z1,  x2, y2, z2, ... ] to pairs format
        var length = array.length - 3;
        var points = new Float32Array(2 * length);
        for(var i = 0; i < length; i += 3){
            points[2 * i] = array[i];
            points[2 * i + 1] = array[i + 1];
            points[2 * i + 2] = array[i + 2];
            points[2 * i + 3] = array[i + 3];
            points[2 * i + 4] = array[i + 4];
            points[2 * i + 5] = array[i + 5];
        }
        super.setPositions(points);
        return this;
    }
    setColors(array) {
        // converts [ r1, g1, b1,  r2, g2, b2, ... ] to pairs format
        var length = array.length - 3;
        var colors = new Float32Array(2 * length);
        for(var i = 0; i < length; i += 3){
            colors[2 * i] = array[i];
            colors[2 * i + 1] = array[i + 1];
            colors[2 * i + 2] = array[i + 2];
            colors[2 * i + 3] = array[i + 3];
            colors[2 * i + 4] = array[i + 4];
            colors[2 * i + 5] = array[i + 5];
        }
        super.setColors(colors);
        return this;
    }
    fromLine(line) {
        var geometry = line.geometry;
        if (geometry.isGeometry) {
            console.error('THREE.LineGeometry no longer supports Geometry. Use THREE.BufferGeometry instead.');
            return;
        } else if (geometry.isBufferGeometry) this.setPositions(geometry.attributes.position.array); // assumes non-indexed
         // set colors, maybe
        return this;
    }
}
$83768f2837205906$export$dcc17b59d0a74bb5.prototype.isLineGeometry = true;
class $83768f2837205906$export$4e6fcde58d84e955 extends $83768f2837205906$export$6eda8f258bdba8c5 {
    constructor(geometry = new $83768f2837205906$export$dcc17b59d0a74bb5(), material = new $83768f2837205906$export$d19cd1378966f3d3({
        color: Math.random() * 0xffffff
    })){
        super(geometry, material);
        this.type = 'Line2';
    }
}
$83768f2837205906$export$4e6fcde58d84e955.prototype.isLine2 = true;



/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  depth: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ 
class $a795479bd51c0a0c$export$684b774b4473ba5f extends (0, $8725869b83961a04$export$598697a1efa63ca7) {
    constructor(text, parameters = {}){
        const font = parameters.font;
        if (font === undefined) super(); // generate default extrude geometry
        else {
            const shapes = font.generateShapes(text, parameters.size);
            // translate parameters to ExtrudeGeometry API
            if (parameters.depth === undefined && parameters.height !== undefined) console.warn('THREE.TextGeometry: .height is now depreciated. Please use .depth instead'); // @deprecated, r163
            parameters.depth = parameters.depth !== undefined ? parameters.depth : parameters.height !== undefined ? parameters.height : 50;
            // defaults
            if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
            if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
            if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
            super(shapes, parameters);
        }
        this.type = 'TextGeometry';
    }
}



class $7d168f0c1ba5badf$export$812303d6cad736b3 extends (0, $8725869b83961a04$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new (0, $8725869b83961a04$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            const font = scope.parse(JSON.parse(text));
            if (onLoad) onLoad(font);
        }, onProgress, onError);
    }
    parse(json) {
        return new $7d168f0c1ba5badf$export$89abf52a030e56ee(json);
    }
}
//
class $7d168f0c1ba5badf$export$89abf52a030e56ee {
    constructor(data){
        this.isFont = true;
        this.type = 'Font';
        this.data = data;
    }
    generateShapes(text, size = 100) {
        const shapes = [];
        const paths = $7d168f0c1ba5badf$var$createPaths(text, size, this.data);
        for(let p = 0, pl = paths.length; p < pl; p++)shapes.push(...paths[p].toShapes());
        return shapes;
    }
}
function $7d168f0c1ba5badf$var$createPaths(text, size, data) {
    const chars = Array.from(text);
    const scale = size / data.resolution;
    const line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
    const paths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === '\n') {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = $7d168f0c1ba5badf$var$createPath(char, scale, offsetX, offsetY, data);
            offsetX += ret.offsetX;
            paths.push(ret.path);
        }
    }
    return paths;
}
function $7d168f0c1ba5badf$var$createPath(char, scale, offsetX, offsetY, data) {
    const glyph = data.glyphs[char] || data.glyphs['?'];
    if (!glyph) {
        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + '.');
        return;
    }
    const path = new (0, $8725869b83961a04$export$148534a3c727230b)();
    let x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
    if (glyph.o) {
        const outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case 'm':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.moveTo(x, y);
                    break;
                case 'l':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.lineTo(x, y);
                    break;
                case 'q':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                    break;
                case 'b':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;
                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                    break;
            }
        }
    }
    return {
        offsetX: glyph.ha * scale,
        path: path
    };
}



function $f12076c7962eab60$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f12076c7962eab60$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $f12076c7962eab60$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $f12076c7962eab60$var$_arrayLikeToArray(r);
}
function $f12076c7962eab60$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $f12076c7962eab60$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $f12076c7962eab60$var$_callSuper(t, o, e) {
    return o = $f12076c7962eab60$var$_getPrototypeOf(o), $f12076c7962eab60$var$_possibleConstructorReturn(t, $f12076c7962eab60$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f12076c7962eab60$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f12076c7962eab60$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $f12076c7962eab60$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $f12076c7962eab60$var$_classPrivateFieldGet2(s, a) {
    return s.get($f12076c7962eab60$var$_assertClassBrand(s, a));
}
function $f12076c7962eab60$var$_classPrivateFieldInitSpec(e, t, a) {
    $f12076c7962eab60$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $f12076c7962eab60$var$_classPrivateFieldSet2(s, a, r) {
    return s.set($f12076c7962eab60$var$_assertClassBrand(s, a), r), r;
}
function $f12076c7962eab60$var$_classPrivateMethodInitSpec(e, a) {
    $f12076c7962eab60$var$_checkPrivateRedeclaration(e, a), a.add(e);
}
function $f12076c7962eab60$var$_construct(t, e, r) {
    if ($f12076c7962eab60$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return p;
}
function $f12076c7962eab60$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f12076c7962eab60$var$_toPropertyKey(o.key), o);
    }
}
function $f12076c7962eab60$var$_createClass(e, r, t) {
    return r && $f12076c7962eab60$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $f12076c7962eab60$var$_defineProperty(e, r, t) {
    return (r = $f12076c7962eab60$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f12076c7962eab60$var$_getPrototypeOf(t) {
    return $f12076c7962eab60$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $f12076c7962eab60$var$_getPrototypeOf(t);
}
function $f12076c7962eab60$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $f12076c7962eab60$var$_setPrototypeOf(t, e);
}
function $f12076c7962eab60$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f12076c7962eab60$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $f12076c7962eab60$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $f12076c7962eab60$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f12076c7962eab60$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f12076c7962eab60$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f12076c7962eab60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f12076c7962eab60$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f12076c7962eab60$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f12076c7962eab60$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f12076c7962eab60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f12076c7962eab60$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f12076c7962eab60$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f12076c7962eab60$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $f12076c7962eab60$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $f12076c7962eab60$var$_assertThisInitialized(t);
}
function $f12076c7962eab60$var$_setPrototypeOf(t, e) {
    return $f12076c7962eab60$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f12076c7962eab60$var$_setPrototypeOf(t, e);
}
function $f12076c7962eab60$var$_slicedToArray(r, e) {
    return $f12076c7962eab60$var$_arrayWithHoles(r) || $f12076c7962eab60$var$_iterableToArrayLimit(r, e) || $f12076c7962eab60$var$_unsupportedIterableToArray(r, e) || $f12076c7962eab60$var$_nonIterableRest();
}
function $f12076c7962eab60$var$_toConsumableArray(r) {
    return $f12076c7962eab60$var$_arrayWithoutHoles(r) || $f12076c7962eab60$var$_iterableToArray(r) || $f12076c7962eab60$var$_unsupportedIterableToArray(r) || $f12076c7962eab60$var$_nonIterableSpread();
}
function $f12076c7962eab60$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f12076c7962eab60$var$_toPropertyKey(t) {
    var i = $f12076c7962eab60$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f12076c7962eab60$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f12076c7962eab60$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f12076c7962eab60$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $f12076c7962eab60$var$materialDispose = function materialDispose(material) {
    if (material instanceof Array) material.forEach(materialDispose);
    else {
        if (material.map) material.map.dispose();
        material.dispose();
    }
};
var $f12076c7962eab60$var$deallocate = function deallocate(obj) {
    if (obj.geometry) obj.geometry.dispose();
    if (obj.material) $f12076c7962eab60$var$materialDispose(obj.material);
    if (obj.texture) obj.texture.dispose();
    if (obj.children) obj.children.forEach(deallocate);
};
var $f12076c7962eab60$var$emptyObject = function emptyObject(obj) {
    if (obj && obj.children) while(obj.children.length){
        var childObj = obj.children[0];
        obj.remove(childObj);
        $f12076c7962eab60$var$deallocate(childObj);
    }
};
function $f12076c7962eab60$var$linkKapsule(kapsulePropName, kapsuleType) {
    var dummyK = new kapsuleType(); // To extract defaults
    return {
        linkProp: function linkProp(prop) {
            // link property config
            return {
                "default": dummyK[prop](),
                onChange: function onChange(v, state) {
                    state[kapsulePropName][prop](v);
                },
                triggerUpdate: false
            };
        },
        linkMethod: function linkMethod(method) {
            // link method pass-through
            return function(state) {
                var kapsuleInstance = state[kapsulePropName];
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var returnVal = kapsuleInstance[method].apply(kapsuleInstance, args);
                return returnVal === kapsuleInstance ? this // chain based on the parent object, not the inner kapsule
                 : returnVal;
            };
        }
    };
}
var $f12076c7962eab60$var$GLOBE_RADIUS = 100;
function $f12076c7962eab60$var$getGlobeRadius() {
    return $f12076c7962eab60$var$GLOBE_RADIUS;
}
function $f12076c7962eab60$var$polar2Cartesian(lat, lng) {
    var relAltitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var phi = (90 - lat) * Math.PI / 180;
    var theta = (90 - lng) * Math.PI / 180;
    var r = $f12076c7962eab60$var$GLOBE_RADIUS * (1 + relAltitude);
    return {
        x: r * Math.sin(phi) * Math.cos(theta),
        y: r * Math.cos(phi),
        z: r * Math.sin(phi) * Math.sin(theta)
    };
}
function $f12076c7962eab60$var$cartesian2Polar(_ref) {
    var x = _ref.x, y = _ref.y, z = _ref.z;
    var r = Math.sqrt(x * x + y * y + z * z);
    var phi = Math.acos(y / r);
    var theta = Math.atan2(z, x);
    return {
        lat: 90 - phi * 180 / Math.PI,
        lng: 90 - theta * 180 / Math.PI - (theta < -Math.PI / 2 ? 360 : 0),
        // keep within [-180, 180] boundaries
        altitude: r / $f12076c7962eab60$var$GLOBE_RADIUS - 1
    };
}
function $f12076c7962eab60$var$deg2Rad$1(deg) {
    return deg * Math.PI / 180;
}
var $f12076c7962eab60$var$THREE$h = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BackSide: (0, $8725869b83961a04$export$d9f0486e75b5ace),
    BufferAttribute: (0, $8725869b83961a04$export$8dea267bd6bde117),
    Color: (0, $8725869b83961a04$export$892596cec99bc70e),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    ShaderMaterial: (0, $8725869b83961a04$export$83c7d75d550a8b0d)
};
var $f12076c7962eab60$var$fragmentShader = "\nuniform vec3 color;\nuniform float coefficient;\nuniform float power;\nvarying vec3 vVertexNormal;\nvarying vec3 vVertexWorldPosition;\nvoid main() {\n  vec3 worldCameraToVertex = vVertexWorldPosition - cameraPosition;\n  vec3 viewCameraToVertex\t= (viewMatrix * vec4(worldCameraToVertex, 0.0)).xyz;\n  viewCameraToVertex = normalize(viewCameraToVertex);\n  float intensity\t= pow(\n    coefficient + dot(vVertexNormal, viewCameraToVertex),\n    power\n  );\n  gl_FragColor = vec4(color, intensity);\n}";
var $f12076c7962eab60$var$vertexShader = "\nvarying vec3 vVertexWorldPosition;\nvarying vec3 vVertexNormal;\nvoid main() {\n  vVertexNormal\t= normalize(normalMatrix * normal);\n  vVertexWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;\n  gl_Position\t= projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n";
var $f12076c7962eab60$var$defaultOptions = {
    backside: true,
    coefficient: 0.5,
    color: 'gold',
    size: 2,
    power: 1
};
// Based off: http://stemkoski.blogspot.fr/2013/07/shaders-in-threejs-glow-and-halo.html
function $f12076c7962eab60$var$createGlowMaterial(coefficient, color, power) {
    return new $f12076c7962eab60$var$THREE$h.ShaderMaterial({
        depthWrite: false,
        fragmentShader: $f12076c7962eab60$var$fragmentShader,
        transparent: true,
        uniforms: {
            coefficient: {
                value: coefficient
            },
            color: {
                value: new $f12076c7962eab60$var$THREE$h.Color(color)
            },
            power: {
                value: power
            }
        },
        vertexShader: $f12076c7962eab60$var$vertexShader
    });
}
function $f12076c7962eab60$var$createGlowGeometry(geometry, size) {
    // expect BufferGeometry
    var glowGeometry = geometry.clone();
    // Resize vertex positions according to normals
    var position = new Float32Array(geometry.attributes.position.count * 3);
    for(var idx = 0, len = position.length; idx < len; idx++){
        var normal = geometry.attributes.normal.array[idx];
        var curPos = geometry.attributes.position.array[idx];
        position[idx] = curPos + normal * size;
    }
    glowGeometry.setAttribute('position', new $f12076c7962eab60$var$THREE$h.BufferAttribute(position, 3));
    return glowGeometry;
}
function $f12076c7962eab60$var$createGlowMesh(geometry) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f12076c7962eab60$var$defaultOptions;
    var backside = options.backside, coefficient = options.coefficient, color = options.color, size = options.size, power = options.power;
    var glowGeometry = $f12076c7962eab60$var$createGlowGeometry(geometry, size);
    var glowMaterial = $f12076c7962eab60$var$createGlowMaterial(coefficient, color, power);
    if (backside) glowMaterial.side = $f12076c7962eab60$var$THREE$h.BackSide;
    return new $f12076c7962eab60$var$THREE$h.Mesh(glowGeometry, glowMaterial);
}
var $f12076c7962eab60$var$THREE$g = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Color: (0, $8725869b83961a04$export$892596cec99bc70e),
    LineBasicMaterial: (0, $8725869b83961a04$export$fbaaa33907730a0c),
    LineSegments: (0, $8725869b83961a04$export$ff1ed10fedfdd604),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshPhongMaterial: (0, $8725869b83961a04$export$24c72f71cbaf0678),
    SphereGeometry: (0, $8725869b83961a04$export$1b417fc3b307a251),
    SRGBColorSpace: (0, $8725869b83961a04$export$561f394b24edfcaa),
    TextureLoader: (0, $8725869b83961a04$export$fd1bfc71f64c538c)
};
//
var $f12076c7962eab60$var$GlobeLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        globeImageUrl: {},
        bumpImageUrl: {},
        showGlobe: {
            "default": true,
            onChange: function onChange(showGlobe, state) {
                state.globeObj.visible = !!showGlobe;
            },
            triggerUpdate: false
        },
        showGraticules: {
            "default": false,
            onChange: function onChange(showGraticules, state) {
                state.graticulesObj.visible = !!showGraticules;
            },
            triggerUpdate: false
        },
        showAtmosphere: {
            "default": true,
            onChange: function onChange(showAtmosphere, state) {
                state.atmosphereObj && (state.atmosphereObj.visible = !!showAtmosphere);
            },
            triggerUpdate: false
        },
        atmosphereColor: {
            "default": 'lightskyblue'
        },
        atmosphereAltitude: {
            "default": 0.15
        },
        onReady: {
            "default": function _default() {},
            triggerUpdate: false
        }
    },
    methods: {
        globeMaterial: function globeMaterial(state, _globeMaterial) {
            if (_globeMaterial !== undefined) {
                state.globeObj.material = _globeMaterial || state.defaultGlobeMaterial;
                return this;
            }
            return state.globeObj.material;
        },
        _destructor: function _destructor(state) {
            $f12076c7962eab60$var$emptyObject(state.globeObj);
            $f12076c7962eab60$var$emptyObject(state.graticulesObj);
        }
    },
    stateInit: function stateInit() {
        // create globe
        var globeGeometry = new $f12076c7962eab60$var$THREE$g.SphereGeometry($f12076c7962eab60$var$GLOBE_RADIUS, 75, 75);
        var defaultGlobeMaterial = new $f12076c7962eab60$var$THREE$g.MeshPhongMaterial({
            color: 0x000000
        });
        var globeObj = new $f12076c7962eab60$var$THREE$g.Mesh(globeGeometry, defaultGlobeMaterial);
        globeObj.rotation.y = -Math.PI / 2; // face prime meridian along Z axis
        globeObj.__globeObjType = 'globe'; // Add object type
        // create graticules
        var graticulesObj = new $f12076c7962eab60$var$THREE$g.LineSegments(new (0, $cedac001b685292d$export$8ed86786cce60ba8)((0, $56659a7819bc6155$export$b8db4e9403a5b6f1)(), $f12076c7962eab60$var$GLOBE_RADIUS, 2), new $f12076c7962eab60$var$THREE$g.LineBasicMaterial({
            color: 'lightgrey',
            transparent: true,
            opacity: 0.1
        }));
        return {
            globeObj: globeObj,
            graticulesObj: graticulesObj,
            defaultGlobeMaterial: defaultGlobeMaterial
        };
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
        state.scene.add(state.globeObj); // add globe
        state.scene.add(state.graticulesObj); // add graticules
        state.ready = false;
    },
    update: function update(state, changedProps) {
        var globeMaterial = state.globeObj.material;
        if (changedProps.hasOwnProperty('globeImageUrl')) {
            if (!state.globeImageUrl) // Black globe if no image
            !globeMaterial.color && (globeMaterial.color = new $f12076c7962eab60$var$THREE$g.Color(0x000000));
            else new $f12076c7962eab60$var$THREE$g.TextureLoader().load(state.globeImageUrl, function(texture) {
                texture.colorSpace = $f12076c7962eab60$var$THREE$g.SRGBColorSpace;
                globeMaterial.map = texture;
                globeMaterial.color = null;
                globeMaterial.needsUpdate = true;
                // ready when first globe image finishes loading (asynchronously to allow 1 frame to load texture)
                !state.ready && (state.ready = true) && setTimeout(state.onReady);
            });
        }
        if (changedProps.hasOwnProperty('bumpImageUrl')) {
            if (!state.bumpImageUrl) {
                globeMaterial.bumpMap = null;
                globeMaterial.needsUpdate = true;
            } else state.bumpImageUrl && new $f12076c7962eab60$var$THREE$g.TextureLoader().load(state.bumpImageUrl, function(texture) {
                globeMaterial.bumpMap = texture;
                globeMaterial.needsUpdate = true;
            });
        }
        if (changedProps.hasOwnProperty('atmosphereColor') || changedProps.hasOwnProperty('atmosphereAltitude')) {
            if (state.atmosphereObj) {
                // recycle previous atmosphere object
                state.scene.remove(state.atmosphereObj);
                $f12076c7962eab60$var$emptyObject(state.atmosphereObj);
            }
            if (state.atmosphereColor && state.atmosphereAltitude) {
                var obj = state.atmosphereObj = $f12076c7962eab60$var$createGlowMesh(state.globeObj.geometry, {
                    backside: true,
                    color: state.atmosphereColor,
                    size: $f12076c7962eab60$var$GLOBE_RADIUS * state.atmosphereAltitude,
                    power: 3.5,
                    // dispersion
                    coefficient: 0.1
                });
                obj.visible = !!state.showAtmosphere;
                obj.__globeObjType = 'atmosphere'; // Add object type
                state.scene.add(obj);
            }
        }
        if (!state.ready && !state.globeImageUrl) {
            // ready immediately if there's no globe image
            state.ready = true;
            state.onReady();
        }
    }
});
var $f12076c7962eab60$var$colorStr2Hex = function colorStr2Hex(str) {
    return isNaN(str) ? parseInt((0, (/*@__PURE__*/$parcel$interopDefault($fa90ed4ba7c7f833$exports)))(str).toHex(), 16) : str;
};
var $f12076c7962eab60$var$colorAlpha = function colorAlpha(str) {
    return str && isNaN(str) ? (0, $ZZsCE.default)(str).opacity : 1;
};
var $f12076c7962eab60$var$color2ShaderArr = function color2ShaderArr(str) {
    var includeAlpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var sRGBColorSpace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var color;
    var alpha = 1;
    var rgbaMatch = /^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.eE+-]+)\s*\)$/.exec(str.trim().toLowerCase());
    if (rgbaMatch) {
        var _rgbaMatch$slice = rgbaMatch.slice(1), _rgbaMatch$slice2 = $f12076c7962eab60$var$_slicedToArray(_rgbaMatch$slice, 4), r = _rgbaMatch$slice2[0], g = _rgbaMatch$slice2[1], b = _rgbaMatch$slice2[2], a = _rgbaMatch$slice2[3];
        color = new (0, $8725869b83961a04$export$892596cec99bc70e)("rgb(".concat(+r, ",").concat(+g, ",").concat(+b, ")"));
        alpha = Math.min(+a, 1);
    } else color = new (0, $8725869b83961a04$export$892596cec99bc70e)(str);
    sRGBColorSpace && color.convertLinearToSRGB(); // vertexColors expects linear, but shaders expect sRGB
    var rgbArr = color.toArray();
    return includeAlpha ? [].concat($f12076c7962eab60$var$_toConsumableArray(rgbArr), [
        alpha
    ]) : rgbArr;
};
function $f12076c7962eab60$var$setMaterialOpacity(material, opacity, depthWrite) {
    material.opacity = opacity;
    material.transparent = opacity < 1;
    material.depthWrite = opacity >= 1; // depthWrite=false recommended for transparent materials, to prevent transparency issues https://discourse.threejs.org/t/threejs-and-the-transparent-problem/11553/31
    return material;
}
var $f12076c7962eab60$var$THREE$f = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Float32BufferAttribute: (0, $8725869b83961a04$export$cbe7a62641830ebd)
};
function $f12076c7962eab60$var$array2BufferAttr(data, itemSize) {
    var BufferAttributeClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f12076c7962eab60$var$THREE$f.Float32BufferAttribute;
    var ba = new BufferAttributeClass(data.length * itemSize, itemSize);
    itemSize === 1 ? data.forEach(function(val, idx) {
        return ba.setX(idx, val);
    }) : data.forEach(function(val, idx) {
        return ba.set(val, idx * itemSize);
    });
    return ba;
}
function $f12076c7962eab60$var$bufferAttr2Array(ba) {
    var itemSize = ba.itemSize;
    var res = [];
    for(var i = 0; i < ba.count; i++)res.push(ba.array.slice(i * itemSize, (i + 1) * itemSize));
    return res;
}
function $f12076c7962eab60$var$threeDigest(data, scene) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {}, _ref$removeDelay = _ref.removeDelay, removeDelay = _ref$removeDelay === void 0 ? 0 : _ref$removeDelay;
    return (0, $c33e1c293c0cad30$export$2e2bcd8739ae039)(data, scene.children, function(obj) {
        return scene.add(obj);
    }, function(obj) {
        var removeFn = function removeFn() {
            scene.remove(obj);
            $f12076c7962eab60$var$emptyObject(obj);
            obj && obj.hasOwnProperty('__data') && delete obj.__data.__currentTargetD;
        };
        removeDelay ? setTimeout(removeFn, removeDelay) : removeFn();
    }, $f12076c7962eab60$var$_objectSpread2({
        objBindAttr: '__threeObj'
    }, options));
}
var $f12076c7962eab60$var$THREE$e = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959),
    Color: (0, $8725869b83961a04$export$892596cec99bc70e),
    CylinderGeometry: (0, $8725869b83961a04$export$68f745719dbe5198),
    Matrix4: (0, $8725869b83961a04$export$2ae72fc923e5eb5),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $8725869b83961a04$export$5023a9a8114806b8),
    Object3D: (0, $8725869b83961a04$export$e4dd07dff30cc924),
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
};
var $f12076c7962eab60$var$bfg$2 = Object.assign({}, $e5162ea5560088cd$exports);
var $f12076c7962eab60$var$BufferGeometryUtils$2 = $f12076c7962eab60$var$bfg$2.BufferGeometryUtils || $f12076c7962eab60$var$bfg$2;
//
var $f12076c7962eab60$var$PointsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        pointsData: {
            "default": []
        },
        pointLat: {
            "default": 'lat'
        },
        pointLng: {
            "default": 'lng'
        },
        pointColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        pointAltitude: {
            "default": 0.1
        },
        // in units of globe radius
        pointRadius: {
            "default": 0.25
        },
        // in deg
        pointResolution: {
            "default": 12,
            triggerUpdate: false
        },
        // how many slice segments in the cylinder's circumference
        pointsMerge: {
            "default": false
        },
        // boolean. Whether to merge all points into a single mesh for rendering performance
        pointsTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        } // ms
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state) {
        // Data accessors
        var latAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pointLat);
        var lngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pointLng);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pointAltitude);
        var radiusAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pointRadius);
        var colorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pointColor);
        // shared geometry
        var pointGeometry = new $f12076c7962eab60$var$THREE$e.CylinderGeometry(1, 1, 1, state.pointResolution);
        pointGeometry.applyMatrix4(new $f12076c7962eab60$var$THREE$e.Matrix4().makeRotationX(Math.PI / 2));
        pointGeometry.applyMatrix4(new $f12076c7962eab60$var$THREE$e.Matrix4().makeTranslation(0, 0, -0.5));
        var pxPerDeg = 2 * Math.PI * $f12076c7962eab60$var$GLOBE_RADIUS / 360;
        var pointMaterials = {}; // indexed by color
        var scene = state.pointsMerge ? new $f12076c7962eab60$var$THREE$e.Object3D() : state.scene; // use fake scene if merging points
        $f12076c7962eab60$var$threeDigest(state.pointsData, scene, {
            createObj: createObj,
            updateObj: updateObj
        });
        if (state.pointsMerge) {
            // merge points into a single mesh
            var pointsGeometry = !state.pointsData.length ? new $f12076c7962eab60$var$THREE$e.BufferGeometry() : ($f12076c7962eab60$var$BufferGeometryUtils$2.mergeGeometries || $f12076c7962eab60$var$BufferGeometryUtils$2.mergeBufferGeometries)(state.pointsData.map(function(d) {
                var obj = d.__threeObj;
                d.__threeObj = undefined; // unbind merged points
                var geom = obj.geometry.clone();
                // apply mesh world transform to vertices
                obj.updateMatrix();
                geom.applyMatrix4(obj.matrix);
                // color vertices
                var color = $f12076c7962eab60$var$color2ShaderArr(colorAccessor(d));
                geom.setAttribute('color', $f12076c7962eab60$var$array2BufferAttr($f12076c7962eab60$var$_toConsumableArray(new Array(geom.getAttribute('position').count)).map(function() {
                    return color;
                }), 4));
                return geom;
            }));
            var points = new $f12076c7962eab60$var$THREE$e.Mesh(pointsGeometry, new $f12076c7962eab60$var$THREE$e.MeshLambertMaterial({
                color: 0xffffff,
                transparent: true,
                vertexColors: true
            }));
            points.__globeObjType = 'points'; // Add object type
            points.__data = state.pointsData; // Attach obj data
            $f12076c7962eab60$var$emptyObject(state.scene);
            state.scene.add(points);
        }
        //
        function createObj() {
            var obj = new $f12076c7962eab60$var$THREE$e.Mesh(pointGeometry);
            obj.__globeObjType = 'point'; // Add object type
            return obj;
        }
        function updateObj(obj, d) {
            var applyUpdate = function applyUpdate(td) {
                var _obj$__currentTargetD = obj.__currentTargetD = td, r = _obj$__currentTargetD.r, alt = _obj$__currentTargetD.alt, lat = _obj$__currentTargetD.lat, lng = _obj$__currentTargetD.lng;
                // position cylinder ground
                Object.assign(obj.position, $f12076c7962eab60$var$polar2Cartesian(lat, lng));
                // orientate outwards
                var globeCenter = state.pointsMerge ? new $f12076c7962eab60$var$THREE$e.Vector3(0, 0, 0) : state.scene.localToWorld(new $f12076c7962eab60$var$THREE$e.Vector3(0, 0, 0)); // translate from local to world coords
                obj.lookAt(globeCenter);
                // scale radius and altitude
                obj.scale.x = obj.scale.y = Math.min(30, r) * pxPerDeg;
                obj.scale.z = Math.max(alt * $f12076c7962eab60$var$GLOBE_RADIUS, 0.1); // avoid non-invertible matrix
            };
            var targetD = {
                alt: +altitudeAccessor(d),
                r: +radiusAccessor(d),
                lat: +latAccessor(d),
                lng: +lngAccessor(d)
            };
            var currentTargetD = obj.__currentTargetD || Object.assign({}, targetD, {
                alt: -0.001
            });
            if (Object.keys(targetD).some(function(k) {
                return currentTargetD[k] !== targetD[k];
            })) {
                if (state.pointsMerge || !state.pointsTransitionDuration || state.pointsTransitionDuration < 0) // set final position
                applyUpdate(targetD);
                else // animate
                new $79Zf3.Tween(currentTargetD).to(targetD, state.pointsTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
            }
            if (!state.pointsMerge) {
                // Update materials on individual points
                var color = colorAccessor(d);
                var opacity = color ? $f12076c7962eab60$var$colorAlpha(color) : 0;
                var showCyl = !!opacity;
                obj.visible = showCyl;
                if (showCyl) {
                    if (!pointMaterials.hasOwnProperty(color)) pointMaterials[color] = new $f12076c7962eab60$var$THREE$e.MeshLambertMaterial({
                        color: $f12076c7962eab60$var$colorStr2Hex(color),
                        transparent: opacity < 1,
                        opacity: opacity
                    });
                    obj.material = pointMaterials[color];
                }
            }
        }
    }
});
var $f12076c7962eab60$var$_excluded = [
    "stroke"
];
var $f12076c7962eab60$var$THREE$d = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959),
    CubicBezierCurve3: (0, $8725869b83961a04$export$13d5f1c9525f246c),
    Curve: (0, $8725869b83961a04$export$b0e83c3ef8d2db1),
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4),
    Line: (0, $8725869b83961a04$export$17d680238e50603e),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    NormalBlending: (0, $8725869b83961a04$export$5b29a26d96ee6af0),
    QuadraticBezierCurve3: (0, $8725869b83961a04$export$bf3f4c7e459f90fc),
    ShaderMaterial: (0, $8725869b83961a04$export$83c7d75d550a8b0d),
    TubeGeometry: (0, $8725869b83961a04$export$7897d9d48904490c),
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
};
var $f12076c7962eab60$var$FrameTicker$2 = (0, (/*@__PURE__*/$parcel$interopDefault($f1564f6f90ed2410$exports)))["default"] || (0, (/*@__PURE__*/$parcel$interopDefault($f1564f6f90ed2410$exports)));
//
var $f12076c7962eab60$var$gradientShaders$1 = {
    uniforms: {
        // dash param defaults, all relative to full length
        dashOffset: {
            value: 0
        },
        dashSize: {
            value: 1
        },
        gapSize: {
            value: 0
        },
        dashTranslate: {
            value: 0
        } // used for animating the dash
    },
    vertexShader: "\n    uniform float dashTranslate; \n\n    attribute vec4 vertexColor;\n    varying vec4 vColor;\n    \n    attribute float vertexRelDistance;\n    varying float vRelDistance;\n\n    void main() {\n      // pass through colors and distances\n      vColor = vertexColor;\n      vRelDistance = vertexRelDistance + dashTranslate;\n      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n    }\n  ",
    fragmentShader: "\n    uniform float dashOffset; \n    uniform float dashSize;\n    uniform float gapSize; \n    \n    varying vec4 vColor;\n    varying float vRelDistance;\n    \n    void main() {\n      // ignore pixels in the gap\n      if (vRelDistance < dashOffset) discard;\n      if (mod(vRelDistance - dashOffset, dashSize + gapSize) > dashSize) discard;\n    \n      // set px color: [r, g, b, a], interpolated between vertices \n      gl_FragColor = vColor; \n    }\n  "
};
var $f12076c7962eab60$var$ArcsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        arcsData: {
            "default": []
        },
        arcStartLat: {
            "default": 'startLat'
        },
        arcStartLng: {
            "default": 'startLng'
        },
        arcEndLat: {
            "default": 'endLat'
        },
        arcEndLng: {
            "default": 'endLng'
        },
        arcColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        // single color, array of colors or color interpolation fn
        arcAltitude: {},
        // in units of globe radius
        arcAltitudeAutoScale: {
            "default": 0.5
        },
        // scale altitude proportional to great-arc distance between the two points
        arcStroke: {},
        // in deg
        arcCurveResolution: {
            "default": 64,
            triggerUpdate: false
        },
        // how many straight segments in the curve
        arcCircularResolution: {
            "default": 6,
            triggerUpdate: false
        },
        // how many slice segments in the tube's circumference
        arcDashLength: {
            "default": 1
        },
        // in units of line length
        arcDashGap: {
            "default": 0
        },
        arcDashInitialGap: {
            "default": 0
        },
        arcDashAnimateTime: {
            "default": 0
        },
        // ms
        arcsTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        } // ms
    },
    methods: {
        pauseAnimation: function pauseAnimation(state) {
            var _state$ticker;
            (_state$ticker = state.ticker) === null || _state$ticker === void 0 || _state$ticker.pause();
        },
        resumeAnimation: function resumeAnimation(state) {
            var _state$ticker2;
            (_state$ticker2 = state.ticker) === null || _state$ticker2 === void 0 || _state$ticker2.resume();
        },
        _destructor: function _destructor(state) {
            var _state$ticker3;
            (_state$ticker3 = state.ticker) === null || _state$ticker3 === void 0 || _state$ticker3.dispose();
        }
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
        // Kick-off dash animations
        state.ticker = new $f12076c7962eab60$var$FrameTicker$2();
        state.ticker.onTick.add(function(_, timeDelta) {
            state.arcsData.filter(function(d) {
                return d.__threeObj && d.__threeObj.children.length && d.__threeObj.children[0].material && d.__threeObj.children[0].__dashAnimateStep;
            }).forEach(function(d) {
                var obj = d.__threeObj.children[0];
                var step = obj.__dashAnimateStep * timeDelta;
                var curTranslate = obj.material.uniforms.dashTranslate.value % 1e9; // reset after 1B loops
                obj.material.uniforms.dashTranslate.value = curTranslate + step;
            });
        });
    },
    update: function update(state) {
        // Data accessors
        var startLatAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcStartLat);
        var startLngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcStartLng);
        var endLatAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcEndLat);
        var endLngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcEndLng);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcAltitude);
        var altitudeAutoScaleAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcAltitudeAutoScale);
        var strokeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcStroke);
        var colorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcColor);
        var dashLengthAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcDashLength);
        var dashGapAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcDashGap);
        var dashInitialGapAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcDashInitialGap);
        var dashAnimateTimeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.arcDashAnimateTime);
        var sharedMaterial = new $f12076c7962eab60$var$THREE$d.ShaderMaterial($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2({}, $f12076c7962eab60$var$gradientShaders$1), {}, {
            transparent: true,
            blending: $f12076c7962eab60$var$THREE$d.NormalBlending
        }));
        $f12076c7962eab60$var$threeDigest(state.arcsData, state.scene, {
            createObj: function createObj() {
                var obj = new $f12076c7962eab60$var$THREE$d.Group(); // populated in updateObj
                obj.__globeObjType = 'arc'; // Add object type
                return obj;
            },
            updateObj: function updateObj(group, arc) {
                var stroke = strokeAccessor(arc);
                var useTube = stroke !== null && stroke !== undefined;
                if (!group.children.length || useTube !== (group.children[0].type === 'Mesh')) {
                    // create or swap object types
                    $f12076c7962eab60$var$emptyObject(group);
                    var _obj = useTube ? new $f12076c7962eab60$var$THREE$d.Mesh() : new $f12076c7962eab60$var$THREE$d.Line(new $f12076c7962eab60$var$THREE$d.BufferGeometry());
                    _obj.material = sharedMaterial.clone(); // Separate material instance per object to have dedicated uniforms (but shared shaders)
                    group.add(_obj);
                }
                var obj = group.children[0];
                // set dash uniforms
                Object.assign(obj.material.uniforms, {
                    dashSize: {
                        value: dashLengthAccessor(arc)
                    },
                    gapSize: {
                        value: dashGapAccessor(arc)
                    },
                    dashOffset: {
                        value: dashInitialGapAccessor(arc)
                    }
                });
                // set dash animation step
                var dashAnimateTime = dashAnimateTimeAccessor(arc);
                obj.__dashAnimateStep = dashAnimateTime > 0 ? 1000 / dashAnimateTime : 0; // per second
                // calculate vertex colors (to create gradient)
                var vertexColorArray = calcColorVertexArray(colorAccessor(arc), // single, array of colors or interpolator
                state.arcCurveResolution, // numSegments
                useTube ? state.arcCircularResolution + 1 : 1 // num vertices per segment
                );
                // calculate vertex relative distances (for dashed lines)
                var vertexRelDistanceArray = calcVertexRelDistances(state.arcCurveResolution, // numSegments
                useTube ? state.arcCircularResolution + 1 : 1, // num vertices per segment
                true // run from end to start, to animate in the correct direction
                );
                obj.geometry.setAttribute('vertexColor', vertexColorArray);
                obj.geometry.setAttribute('vertexRelDistance', vertexRelDistanceArray);
                var applyUpdate = function applyUpdate(td) {
                    var _arc$__currentTargetD = arc.__currentTargetD = td, stroke = _arc$__currentTargetD.stroke, curveD = $f12076c7962eab60$var$_objectWithoutProperties(_arc$__currentTargetD, $f12076c7962eab60$var$_excluded);
                    var curve = calcCurve(curveD);
                    if (useTube) {
                        obj.geometry && obj.geometry.dispose();
                        obj.geometry = new $f12076c7962eab60$var$THREE$d.TubeGeometry(curve, state.arcCurveResolution, stroke / 2, state.arcCircularResolution);
                        obj.geometry.setAttribute('vertexColor', vertexColorArray);
                        obj.geometry.setAttribute('vertexRelDistance', vertexRelDistanceArray);
                    } else obj.geometry.setFromPoints(curve.getPoints(state.arcCurveResolution));
                };
                var targetD = {
                    stroke: stroke,
                    alt: altitudeAccessor(arc),
                    altAutoScale: +altitudeAutoScaleAccessor(arc),
                    startLat: +startLatAccessor(arc),
                    startLng: +startLngAccessor(arc),
                    endLat: +endLatAccessor(arc),
                    endLng: +endLngAccessor(arc)
                };
                var currentTargetD = arc.__currentTargetD || Object.assign({}, targetD, {
                    altAutoScale: -0.001
                });
                if (Object.keys(targetD).some(function(k) {
                    return currentTargetD[k] !== targetD[k];
                })) {
                    if (!state.arcsTransitionDuration || state.arcsTransitionDuration < 0) // set final position
                    applyUpdate(targetD);
                    else // animate
                    new $79Zf3.Tween(currentTargetD).to(targetD, state.arcsTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
                }
            }
        });
        //
        function calcCurve(_ref) {
            var alt = _ref.alt, altAutoScale = _ref.altAutoScale, startLat = _ref.startLat, startLng = _ref.startLng, endLat = _ref.endLat, endLng = _ref.endLng;
            var getVec = function getVec(_ref2) {
                var _ref3 = $f12076c7962eab60$var$_slicedToArray(_ref2, 3), lng = _ref3[0], lat = _ref3[1], alt = _ref3[2];
                var _polar2Cartesian = $f12076c7962eab60$var$polar2Cartesian(lat, lng, alt), x = _polar2Cartesian.x, y = _polar2Cartesian.y, z = _polar2Cartesian.z;
                return new $f12076c7962eab60$var$THREE$d.Vector3(x, y, z);
            };
            //calculate curve
            var startPnt = [
                startLng,
                startLat
            ];
            var endPnt = [
                endLng,
                endLat
            ];
            var altitude = alt;
            (altitude === null || altitude === undefined) && // by default set altitude proportional to the great-arc distance
            (altitude = (0, $e4a47e5a43a9d541$export$2e2bcd8739ae039)(startPnt, endPnt) / 2 * altAutoScale);
            if (altitude) {
                var interpolate = (0, $8bc8a132388147d0$export$2e2bcd8739ae039)(startPnt, endPnt);
                var _map = [
                    0.25,
                    0.75
                ].map(function(t) {
                    return [].concat($f12076c7962eab60$var$_toConsumableArray(interpolate(t)), [
                        altitude * 1.5
                    ]);
                }), _map2 = $f12076c7962eab60$var$_slicedToArray(_map, 2), m1Pnt = _map2[0], m2Pnt = _map2[1];
                var curve = $f12076c7962eab60$var$_construct($f12076c7962eab60$var$THREE$d.CubicBezierCurve3, $f12076c7962eab60$var$_toConsumableArray([
                    startPnt,
                    m1Pnt,
                    m2Pnt,
                    endPnt
                ].map(getVec)));
                //const mPnt = [...interpolate(0.5), altitude * 2];
                //curve = new THREE.QuadraticBezierCurve3(...[startPnt, mPnt, endPnt].map(getVec));
                return curve;
            } else {
                // ground line
                var _alt = 0.001; // slightly above the ground to prevent occlusion
                return calcSphereArc.apply(void 0, $f12076c7962eab60$var$_toConsumableArray([
                    [].concat(startPnt, [
                        _alt
                    ]),
                    [].concat(endPnt, [
                        _alt
                    ])
                ].map(getVec)));
            }
            //
            function calcSphereArc(startVec, endVec) {
                var angle = startVec.angleTo(endVec);
                var getGreatCirclePoint = angle === 0 ? function() {
                    return startVec.clone();
                } // points exactly overlap
                 : function(t) {
                    return new $f12076c7962eab60$var$THREE$d.Vector3().addVectors(startVec.clone().multiplyScalar(Math.sin((1 - t) * angle)), endVec.clone().multiplyScalar(Math.sin(t * angle))).divideScalar(Math.sin(angle));
                };
                var sphereArc = new $f12076c7962eab60$var$THREE$d.Curve();
                sphereArc.getPoint = getGreatCirclePoint;
                return sphereArc;
            }
        }
        function calcColorVertexArray(colors, numSegments) {
            var numVerticesPerSegment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
            var numVerticesGroup = numSegments + 1; // one between every two segments and two at the ends
            var getVertexColor;
            if (colors instanceof Array || colors instanceof Function) {
                var colorInterpolator = colors instanceof Array ? (0, $050f6c6fd36ea5ca$export$2e2bcd8739ae039)() // array of colors, interpolate at each step
                .domain(colors.map(function(_, idx) {
                    return idx / (colors.length - 1);
                })) // same number of stops as colors
                .range(colors) : colors; // already interpolator fn
                getVertexColor = function getVertexColor(t) {
                    return $f12076c7962eab60$var$color2ShaderArr(colorInterpolator(t), true, true);
                };
            } else {
                // single color, use constant
                var vertexColor = $f12076c7962eab60$var$color2ShaderArr(colors, true, true);
                getVertexColor = function getVertexColor() {
                    return vertexColor;
                };
            }
            var vertexColors = [];
            for(var v = 0, l = numVerticesGroup; v < l; v++){
                var _vertexColor = getVertexColor(v / (l - 1));
                for(var s = 0; s < numVerticesPerSegment; s++)vertexColors.push(_vertexColor);
            }
            return $f12076c7962eab60$var$array2BufferAttr(vertexColors, 4);
        }
        function calcVertexRelDistances(numSegments) {
            var numVerticesPerSegment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var invert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var numVerticesGroup = numSegments + 1; // one between every two segments and two at the ends
            var vertexDistances = [];
            for(var v = 0, l = numVerticesGroup; v < l; v++){
                var relDistance = v / (l - 1);
                for(var s = 0; s < numVerticesPerSegment; s++)vertexDistances.push(relDistance);
            }
            invert && vertexDistances.reverse();
            return $f12076c7962eab60$var$array2BufferAttr(vertexDistances, 1);
        }
    }
});
var $f12076c7962eab60$var$THREE$c = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959),
    Color: (0, $8725869b83961a04$export$892596cec99bc70e),
    DoubleSide: (0, $8725869b83961a04$export$3b296b6f144d5b03),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $8725869b83961a04$export$5023a9a8114806b8),
    Object3D: (0, $8725869b83961a04$export$e4dd07dff30cc924)
};
var $f12076c7962eab60$var$bfg$1 = Object.assign({}, $e5162ea5560088cd$exports);
var $f12076c7962eab60$var$BufferGeometryUtils$1 = $f12076c7962eab60$var$bfg$1.BufferGeometryUtils || $f12076c7962eab60$var$bfg$1;
//
var $f12076c7962eab60$var$HexBinLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        hexBinPointsData: {
            "default": []
        },
        hexBinPointLat: {
            "default": 'lat'
        },
        hexBinPointLng: {
            "default": 'lng'
        },
        hexBinPointWeight: {
            "default": 1
        },
        hexBinResolution: {
            "default": 4
        },
        // 0-15. Level 0 partitions the earth in 122 (mostly) hexagonal cells. Each subsequent level sub-divides the previous in roughly 7 hexagons.
        hexMargin: {
            "default": 0.2
        },
        // in fraction of diameter
        hexTopCurvatureResolution: {
            "default": 5
        },
        // in angular degrees
        hexTopColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        hexSideColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        hexAltitude: {
            "default": function _default(_ref) {
                var sumWeight = _ref.sumWeight;
                return sumWeight * 0.01;
            }
        },
        // in units of globe radius
        hexBinMerge: {
            "default": false
        },
        // boolean. Whether to merge all hex geometries into a single mesh for rendering performance
        hexTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        } // ms
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state) {
        // Accessors
        var latAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexBinPointLat);
        var lngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexBinPointLng);
        var weightAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexBinPointWeight);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexAltitude);
        var topColorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexTopColor);
        var sideColorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexSideColor);
        var marginAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexMargin);
        var byH3Idx = (0, $e4a0f5c492f23e14$export$2e2bcd8739ae039)(state.hexBinPointsData.map(function(d) {
            return $f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2({}, d), {}, {
                h3Idx: (0, $e3286925688328aa$export$6dd797caa6c57c8a)(latAccessor(d), lngAccessor(d), state.hexBinResolution)
            });
        }), 'h3Idx');
        var hexBins = Object.entries(byH3Idx).map(function(_ref2) {
            var _ref3 = $f12076c7962eab60$var$_slicedToArray(_ref2, 2), h3Idx = _ref3[0], points = _ref3[1];
            return {
                h3Idx: h3Idx,
                points: points,
                sumWeight: points.reduce(function(agg, d) {
                    return agg + +weightAccessor(d);
                }, 0)
            };
        });
        var hexMaterials = {}; // indexed by color
        var scene = state.hexBinMerge ? new $f12076c7962eab60$var$THREE$c.Object3D() : state.scene; // use fake scene if merging hex points
        $f12076c7962eab60$var$threeDigest(hexBins, scene, {
            createObj: createObj,
            updateObj: updateObj,
            idAccessor: function idAccessor(d) {
                return d.h3Idx;
            }
        });
        if (state.hexBinMerge) {
            // merge points into a single mesh
            var hexPointsGeometry = !hexBins.length ? new $f12076c7962eab60$var$THREE$c.BufferGeometry() : ($f12076c7962eab60$var$BufferGeometryUtils$1.mergeGeometries || $f12076c7962eab60$var$BufferGeometryUtils$1.mergeBufferGeometries)(hexBins.map(function(d) {
                var obj = d.__threeObj;
                d.__threeObj = undefined; // unbind merged points
                // use non-indexed geometry so that groups can be colored separately, otherwise different groups share vertices
                var geom = obj.geometry.toNonIndexed();
                // apply mesh world transform to vertices
                obj.updateMatrix();
                geom.applyMatrix4(obj.matrix);
                // color vertices
                var topColor = $f12076c7962eab60$var$color2ShaderArr(topColorAccessor(d));
                var sideColor = $f12076c7962eab60$var$color2ShaderArr(sideColorAccessor(d));
                var nVertices = geom.getAttribute('position').count;
                var topFaceIdx = geom.groups[0].count; // starting vertex index of top group
                geom.setAttribute('color', $f12076c7962eab60$var$array2BufferAttr($f12076c7962eab60$var$_toConsumableArray(new Array(nVertices)).map(function(_, idx) {
                    return idx >= topFaceIdx ? topColor : sideColor;
                }), 4));
                return geom;
            }));
            var hexPoints = new $f12076c7962eab60$var$THREE$c.Mesh(hexPointsGeometry, new $f12076c7962eab60$var$THREE$c.MeshLambertMaterial({
                color: 0xffffff,
                transparent: true,
                vertexColors: true,
                side: $f12076c7962eab60$var$THREE$c.DoubleSide
            }));
            hexPoints.__globeObjType = 'hexBinPoints'; // Add object type
            hexPoints.__data = hexBins; // Attach obj data
            $f12076c7962eab60$var$emptyObject(state.scene);
            state.scene.add(hexPoints);
        }
        //
        function createObj(d) {
            var obj = new $f12076c7962eab60$var$THREE$c.Mesh();
            obj.__hexCenter = (0, $e3286925688328aa$export$2ed8e7796c5b7719)(d.h3Idx);
            obj.__hexGeoJson = (0, $e3286925688328aa$export$95a0f8735a48a896)(d.h3Idx, true).reverse(); // correct polygon winding
            // stitch longitudes at the anti-meridian
            var centerLng = obj.__hexCenter[1];
            obj.__hexGeoJson.forEach(function(d) {
                var edgeLng = d[0];
                if (Math.abs(centerLng - edgeLng) > 170) // normalize large lng distances
                d[0] += centerLng > edgeLng ? 360 : -360;
            });
            obj.__globeObjType = 'hexbin'; // Add object type
            return obj;
        }
        function updateObj(obj, d) {
            // compute new geojson with relative margin
            var relNum = function relNum(st, end, rat) {
                return st - (st - end) * rat;
            };
            var margin = Math.max(0, Math.min(1, +marginAccessor(d)));
            var _obj$__hexCenter = $f12076c7962eab60$var$_slicedToArray(obj.__hexCenter, 2), clat = _obj$__hexCenter[0], clng = _obj$__hexCenter[1];
            var geoJson = margin === 0 ? obj.__hexGeoJson : obj.__hexGeoJson.map(function(_ref4) {
                var _ref5 = $f12076c7962eab60$var$_slicedToArray(_ref4, 2), elng = _ref5[0], elat = _ref5[1];
                return [
                    [
                        elng,
                        clng
                    ],
                    [
                        elat,
                        clat
                    ]
                ].map(function(_ref6) {
                    var _ref7 = $f12076c7962eab60$var$_slicedToArray(_ref6, 2), st = _ref7[0], end = _ref7[1];
                    return relNum(st, end, margin);
                });
            });
            var topCurvatureResolution = state.hexTopCurvatureResolution;
            obj.geometry && obj.geometry.dispose();
            obj.geometry = new (0, $aa8bf899fc620c38$export$d1a95d7c8ca56306)([
                geoJson
            ], 0, $f12076c7962eab60$var$GLOBE_RADIUS, false, true, true, topCurvatureResolution);
            var targetD = {
                alt: +altitudeAccessor(d)
            };
            var applyUpdate = function applyUpdate(td) {
                var _obj$__currentTargetD = obj.__currentTargetD = td, alt = _obj$__currentTargetD.alt;
                obj.scale.x = obj.scale.y = obj.scale.z = 1 + alt; // scale according to altitude
            };
            var currentTargetD = obj.__currentTargetD || Object.assign({}, targetD, {
                alt: -0.001
            });
            if (Object.keys(targetD).some(function(k) {
                return currentTargetD[k] !== targetD[k];
            })) {
                if (state.hexBinMerge || !state.hexTransitionDuration || state.hexTransitionDuration < 0) // set final position
                applyUpdate(targetD);
                else // animate
                new $79Zf3.Tween(currentTargetD).to(targetD, state.hexTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
            }
            if (!state.hexBinMerge) {
                // Update materials on individual hex points
                var sideColor = sideColorAccessor(d);
                var topColor = topColorAccessor(d);
                [
                    sideColor,
                    topColor
                ].forEach(function(color) {
                    if (!hexMaterials.hasOwnProperty(color)) {
                        var opacity = $f12076c7962eab60$var$colorAlpha(color);
                        hexMaterials[color] = new $f12076c7962eab60$var$THREE$c.MeshLambertMaterial({
                            color: $f12076c7962eab60$var$colorStr2Hex(color),
                            transparent: opacity < 1,
                            opacity: opacity,
                            side: $f12076c7962eab60$var$THREE$c.DoubleSide
                        });
                    }
                });
                obj.material = [
                    sideColor,
                    topColor
                ].map(function(color) {
                    return hexMaterials[color];
                });
            }
        }
    }
});
var $f12076c7962eab60$var$sq = function sq(x) {
    return x * x;
};
function $f12076c7962eab60$var$geoDistance(a, b) {
    // on sphere surface, in radians
    var sqrt = Math.sqrt;
    var cos = Math.cos;
    var toRad = function toRad(x) {
        return x * Math.PI / 180;
    };
    var hav = function hav(x) {
        return $f12076c7962eab60$var$sq(Math.sin(x / 2));
    };
    var latA = toRad(a[1]);
    var latB = toRad(b[1]);
    var lngA = toRad(a[0]);
    var lngB = toRad(b[0]);
    // Haversine formula
    return 2 * Math.asin(sqrt(hav(latB - latA) + cos(latA) * cos(latB) * hav(lngB - lngA)));
}
var $f12076c7962eab60$var$sqrt2PI = Math.sqrt(2 * Math.PI);
function $f12076c7962eab60$var$gaussianKernel(x, bw) {
    return Math.exp(-$f12076c7962eab60$var$sq(x / bw) / 2) / (bw * $f12076c7962eab60$var$sqrt2PI);
}
var $f12076c7962eab60$var$getGeoKDE = function getGeoKDE(_ref) {
    var _ref2 = $f12076c7962eab60$var$_slicedToArray(_ref, 2), lng = _ref2[0], lat = _ref2[1];
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref3$lngAccessor = _ref3.lngAccessor, lngAccessor = _ref3$lngAccessor === void 0 ? function(d) {
        return d[0];
    } : _ref3$lngAccessor, _ref3$latAccessor = _ref3.latAccessor, latAccessor = _ref3$latAccessor === void 0 ? function(d) {
        return d[1];
    } : _ref3$latAccessor, _ref3$weightAccessor = _ref3.weightAccessor, weightAccessor = _ref3$weightAccessor === void 0 ? function() {
        return 1;
    } : _ref3$weightAccessor, bandwidth = _ref3.bandwidth;
    var pnt = [
        lng,
        lat
    ];
    var bwRad = bandwidth * Math.PI / 180;
    return (0, $85750a69174e5177$export$2e2bcd8739ae039)(data.map(function(d) {
        var weight = weightAccessor(d);
        if (!weight) return 0;
        var dist = $f12076c7962eab60$var$geoDistance(pnt, [
            lngAccessor(d),
            latAccessor(d)
        ]);
        return $f12076c7962eab60$var$gaussianKernel(dist, bwRad) * weight;
    }));
};
var $f12076c7962eab60$var$THREE$b = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $8725869b83961a04$export$5023a9a8114806b8),
    SphereGeometry: (0, $8725869b83961a04$export$1b417fc3b307a251)
};
//
var $f12076c7962eab60$var$RES_BW_FACTOR = 3.5; // divider of bandwidth to use in geometry resolution
var $f12076c7962eab60$var$MIN_RESOLUTION = 0.1; // degrees
var $f12076c7962eab60$var$BW_RADIUS_INFLUENCE = 3.5; // multiplier of bandwidth to use in octree for max radius of point influence
var $f12076c7962eab60$var$_PointsOctree_brand = /*#__PURE__*/ new WeakSet();
var $f12076c7962eab60$var$_points = /*#__PURE__*/ new WeakMap();
var $f12076c7962eab60$var$_pntOctree = /*#__PURE__*/ new WeakMap();
var $f12076c7962eab60$var$_distance = /*#__PURE__*/ new WeakMap();
var $f12076c7962eab60$var$PointsOctree = /*#__PURE__*/ function() {
    function PointsOctree(points, neighborhoodAngularDistance) {
        $f12076c7962eab60$var$_classCallCheck(this, PointsOctree);
        $f12076c7962eab60$var$_classPrivateMethodInitSpec(this, $f12076c7962eab60$var$_PointsOctree_brand);
        $f12076c7962eab60$var$_classPrivateFieldInitSpec(this, $f12076c7962eab60$var$_points, void 0);
        $f12076c7962eab60$var$_classPrivateFieldInitSpec(this, $f12076c7962eab60$var$_pntOctree, void 0);
        $f12076c7962eab60$var$_classPrivateFieldInitSpec(this, $f12076c7962eab60$var$_distance, void 0);
        $f12076c7962eab60$var$_classPrivateFieldSet2($f12076c7962eab60$var$_points, this, points);
        $f12076c7962eab60$var$_classPrivateFieldSet2($f12076c7962eab60$var$_pntOctree, this, (0, (/*@__PURE__*/$parcel$interopDefault($fe57fe65e0e8a0a1$exports)))());
        $f12076c7962eab60$var$_classPrivateFieldGet2($f12076c7962eab60$var$_pntOctree, this).init(points.map(function(d) {
            return [
                d.x,
                d.y,
                d.z
            ];
        }).flat());
        $f12076c7962eab60$var$_classPrivateFieldSet2($f12076c7962eab60$var$_distance, this, $f12076c7962eab60$var$_assertClassBrand($f12076c7962eab60$var$_PointsOctree_brand, this, $f12076c7962eab60$var$_getDistance).call(this, $f12076c7962eab60$var$polar2Cartesian(0, 0), $f12076c7962eab60$var$polar2Cartesian(0, Math.min(180, neighborhoodAngularDistance))));
    }
    return $f12076c7962eab60$var$_createClass(PointsOctree, [
        {
            key: "getNearPoints",
            value: function getNearPoints(x, y, z) {
                var _this = this;
                return $f12076c7962eab60$var$_classPrivateFieldGet2($f12076c7962eab60$var$_pntOctree, this).intersectSphere(x, y, z, $f12076c7962eab60$var$_classPrivateFieldGet2($f12076c7962eab60$var$_distance, this)).map(function(idx) {
                    return $f12076c7962eab60$var$_classPrivateFieldGet2($f12076c7962eab60$var$_points, _this)[idx / 3];
                });
            }
        }
    ]);
}();
function $f12076c7962eab60$var$_getDistance(a, b) {
    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2) + Math.pow(a.z - b.z, 2));
}
var $f12076c7962eab60$var$defaultColorInterpolator = function defaultColorInterpolator(t) {
    var c = (0, $ZZsCE.default)((0, $4bf51ca10359b13b$export$2e2bcd8739ae039)(t)); // turbo, inferno
    c.opacity = Math.cbrt(t);
    return c.formatRgb();
};
var $f12076c7962eab60$var$HeatmapsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        heatmapsData: {
            "default": []
        },
        heatmapPoints: {
            "default": function _default(pnts) {
                return pnts;
            }
        },
        heatmapPointLat: {
            "default": function _default(d) {
                return d[0];
            }
        },
        heatmapPointLng: {
            "default": function _default(d) {
                return d[1];
            }
        },
        heatmapPointWeight: {
            "default": 1
        },
        heatmapBandwidth: {
            "default": 4
        },
        // Gaussian kernel bandwidth, in angular degrees
        heatmapColorFn: {
            "default": function _default() {
                return $f12076c7962eab60$var$defaultColorInterpolator;
            }
        },
        heatmapColorSaturation: {
            "default": 1.5
        },
        // multiplier for color scale max
        heatmapBaseAltitude: {
            "default": 0.01
        },
        // in units of globe radius
        heatmapTopAltitude: {},
        // in units of globe radius
        heatmapsTransitionDuration: {
            "default": 0,
            triggerUpdate: false
        } // ms
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state) {
        // Accessors
        var pointsAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapPoints);
        var latPntAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapPointLat);
        var lngPntAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapPointLng);
        var weightPntAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapPointWeight);
        var bandwidthAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapBandwidth);
        var colorFnAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapColorFn);
        var saturationAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapColorSaturation);
        var baseAltitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapBaseAltitude);
        var topAltitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.heatmapTopAltitude);
        $f12076c7962eab60$var$threeDigest(state.heatmapsData, state.scene, {
            createObj: function createObj(d) {
                var obj = new $f12076c7962eab60$var$THREE$b.Mesh(new $f12076c7962eab60$var$THREE$b.SphereGeometry($f12076c7962eab60$var$GLOBE_RADIUS), new $f12076c7962eab60$var$THREE$b.MeshLambertMaterial({
                    vertexColors: true,
                    transparent: true
                }));
                obj.__globeObjType = 'heatmap'; // Add object type
                return obj;
            },
            updateObj: function updateObj(obj, d) {
                // Accessors
                var bandwidth = bandwidthAccessor(d);
                var colorFn = colorFnAccessor(d);
                var saturation = saturationAccessor(d);
                var baseAlt = baseAltitudeAccessor(d);
                var topAlt = topAltitudeAccessor(d);
                var pnts = pointsAccessor(d).map(function(pnt) {
                    var lat = latPntAccessor(pnt);
                    var lng = lngPntAccessor(pnt);
                    var _polar2Cartesian = $f12076c7962eab60$var$polar2Cartesian(lat, lng), x = _polar2Cartesian.x, y = _polar2Cartesian.y, z = _polar2Cartesian.z;
                    return {
                        x: x,
                        y: y,
                        z: z,
                        lat: lat,
                        lng: lng,
                        weight: weightPntAccessor(pnt)
                    };
                });
                // Check resolution
                var resolution = Math.max($f12076c7962eab60$var$MIN_RESOLUTION, bandwidth / $f12076c7962eab60$var$RES_BW_FACTOR);
                var equatorNumSegments = Math.ceil(360 / (resolution || -1));
                if (obj.geometry.parameters.widthSegments !== equatorNumSegments) {
                    obj.geometry.dispose();
                    obj.geometry = new $f12076c7962eab60$var$THREE$b.SphereGeometry($f12076c7962eab60$var$GLOBE_RADIUS, equatorNumSegments, equatorNumSegments / 2);
                }
                // Get vertex polar coordinates
                var vertexCoords = $f12076c7962eab60$var$bufferAttr2Array(obj.geometry.getAttribute('position'));
                var vertexGeoCoords = vertexCoords.map(function(_ref) {
                    var _ref2 = $f12076c7962eab60$var$_slicedToArray(_ref, 3), x = _ref2[0], y = _ref2[1], z = _ref2[2];
                    var _cartesian2Polar = $f12076c7962eab60$var$cartesian2Polar({
                        x: x,
                        y: y,
                        z: z
                    }), lng = _cartesian2Polar.lng, lat = _cartesian2Polar.lat;
                    return [
                        lng,
                        lat
                    ];
                });
                // Compute KDE
                var pntsOctree = new $f12076c7962eab60$var$PointsOctree(pnts, bandwidth * $f12076c7962eab60$var$BW_RADIUS_INFLUENCE);
                var kdeVals = vertexGeoCoords.map(function(vxCoords, idx) {
                    var _vertexCoords$idx = $f12076c7962eab60$var$_slicedToArray(vertexCoords[idx], 3), x = _vertexCoords$idx[0], y = _vertexCoords$idx[1], z = _vertexCoords$idx[2];
                    return $f12076c7962eab60$var$getGeoKDE(vxCoords, pntsOctree.getNearPoints(x, y, z), {
                        latAccessor: function latAccessor(d) {
                            return d.lat;
                        },
                        lngAccessor: function lngAccessor(d) {
                            return d.lng;
                        },
                        weightAccessor: function weightAccessor(d) {
                            return d.weight;
                        },
                        bandwidth: bandwidth
                    });
                });
                // Animations
                var applyUpdate = function applyUpdate(td) {
                    var _obj$__currentTargetD = obj.__currentTargetD = td, kdeVals = _obj$__currentTargetD.kdeVals, topAlt = _obj$__currentTargetD.topAlt, saturation = _obj$__currentTargetD.saturation;
                    var maxVal = (0, $36c0f220e5dacaad$export$2e2bcd8739ae039)(kdeVals.map(Math.abs)) || 1e-15;
                    // Set vertex colors
                    obj.geometry.setAttribute('color', $f12076c7962eab60$var$array2BufferAttr(// normalization between [0, saturation]
                    kdeVals.map(function(val) {
                        return $f12076c7962eab60$var$color2ShaderArr(colorFn(val / maxVal * saturation));
                    }), 4));
                    // Set altitudes
                    var altScale = (0, $050f6c6fd36ea5ca$export$2e2bcd8739ae039)([
                        0,
                        maxVal
                    ], [
                        baseAlt,
                        topAlt || baseAlt
                    ]);
                    obj.geometry.setAttribute('position', $f12076c7962eab60$var$array2BufferAttr(kdeVals.map(function(val, idx) {
                        var _vertexGeoCoords$idx = $f12076c7962eab60$var$_slicedToArray(vertexGeoCoords[idx], 2), lng = _vertexGeoCoords$idx[0], lat = _vertexGeoCoords$idx[1];
                        var alt = altScale(Math.abs(val));
                        var p = $f12076c7962eab60$var$polar2Cartesian(lat, lng, alt);
                        return [
                            p.x,
                            p.y,
                            p.z
                        ];
                    }), 3));
                };
                var targetD = {
                    kdeVals: kdeVals,
                    topAlt: topAlt,
                    saturation: saturation
                };
                var currentTargetD = obj.__currentTargetD || Object.assign({}, targetD, {
                    kdeVals: kdeVals.map(function() {
                        return 0;
                    }),
                    topAlt: !topAlt ? topAlt : baseAlt,
                    saturation: 0.5
                });
                // do not interpolate between different length arrays
                currentTargetD.kdeVals.length !== kdeVals.length && (currentTargetD.kdeVals = kdeVals.slice());
                if (Object.keys(targetD).some(function(k) {
                    return currentTargetD[k] !== targetD[k];
                })) {
                    if (!state.heatmapsTransitionDuration || state.heatmapsTransitionDuration < 0) // set final position
                    applyUpdate(targetD);
                    else // animate
                    new $79Zf3.Tween(currentTargetD).to(targetD, state.heatmapsTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
                }
            }
        });
    }
});
var $f12076c7962eab60$var$THREE$a = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    DoubleSide: (0, $8725869b83961a04$export$3b296b6f144d5b03),
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4),
    LineBasicMaterial: (0, $8725869b83961a04$export$fbaaa33907730a0c),
    LineSegments: (0, $8725869b83961a04$export$ff1ed10fedfdd604),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshBasicMaterial: (0, $8725869b83961a04$export$55cbcc9b622fe1f5)
};
//
var $f12076c7962eab60$var$PolygonsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        polygonsData: {
            "default": []
        },
        polygonGeoJsonGeometry: {
            "default": 'geometry'
        },
        polygonSideColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        polygonSideMaterial: {},
        polygonCapColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        polygonCapMaterial: {},
        polygonStrokeColor: {},
        polygonAltitude: {
            "default": 0.01
        },
        // in units of globe radius
        polygonCapCurvatureResolution: {
            "default": 5
        },
        // in angular degrees
        polygonsTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        } // ms
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state) {
        // Data accessors
        var geoJsonAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonGeoJsonGeometry);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonAltitude);
        var capCurvatureResolutionAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonCapCurvatureResolution);
        var capColorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonCapColor);
        var capMaterialAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonCapMaterial);
        var sideColorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonSideColor);
        var sideMaterialAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonSideMaterial);
        var strokeColorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.polygonStrokeColor);
        var singlePolygons = [];
        state.polygonsData.forEach(function(polygon) {
            var objAttrs = {
                data: polygon,
                capColor: capColorAccessor(polygon),
                capMaterial: capMaterialAccessor(polygon),
                sideColor: sideColorAccessor(polygon),
                sideMaterial: sideMaterialAccessor(polygon),
                strokeColor: strokeColorAccessor(polygon),
                altitude: +altitudeAccessor(polygon),
                capCurvatureResolution: +capCurvatureResolutionAccessor(polygon)
            };
            var geoJson = geoJsonAccessor(polygon);
            var geoId = polygon.__id || "".concat(Math.round(Math.random() * 1e9)); // generate and stamp polygon ids to keep track in digest
            polygon.__id = geoId;
            if (geoJson.type === 'Polygon') singlePolygons.push($f12076c7962eab60$var$_objectSpread2({
                id: "".concat(geoId, "_0"),
                coords: geoJson.coordinates
            }, objAttrs));
            else if (geoJson.type === 'MultiPolygon') singlePolygons.push.apply(singlePolygons, $f12076c7962eab60$var$_toConsumableArray(geoJson.coordinates.map(function(coords, idx) {
                return $f12076c7962eab60$var$_objectSpread2({
                    id: "".concat(geoId, "_").concat(idx),
                    coords: coords
                }, objAttrs);
            })));
            else console.warn("Unsupported GeoJson geometry type: ".concat(geoJson.type, ". Skipping geometry..."));
        });
        $f12076c7962eab60$var$threeDigest(singlePolygons, state.scene, {
            idAccessor: function idAccessor(d) {
                return d.id;
            },
            createObj: function createObj() {
                var obj = new $f12076c7962eab60$var$THREE$a.Group();
                obj.__defaultSideMaterial = new $f12076c7962eab60$var$THREE$a.MeshBasicMaterial({
                    side: $f12076c7962eab60$var$THREE$a.DoubleSide,
                    depthWrite: true
                });
                obj.__defaultCapMaterial = new $f12076c7962eab60$var$THREE$a.MeshBasicMaterial({
                    side: $f12076c7962eab60$var$THREE$a.DoubleSide,
                    depthWrite: true
                });
                // conic geometry
                obj.add(new $f12076c7962eab60$var$THREE$a.Mesh(undefined, [
                    obj.__defaultSideMaterial,
                    // side material
                    obj.__defaultCapMaterial // cap material
                ]));
                // polygon stroke
                obj.add(new $f12076c7962eab60$var$THREE$a.LineSegments(undefined, new $f12076c7962eab60$var$THREE$a.LineBasicMaterial()));
                obj.__globeObjType = 'polygon'; // Add object type
                return obj;
            },
            updateObj: function updateObj(obj, _ref) {
                var coords = _ref.coords, capColor = _ref.capColor, capMaterial = _ref.capMaterial, sideColor = _ref.sideColor, sideMaterial = _ref.sideMaterial, strokeColor = _ref.strokeColor, altitude = _ref.altitude, capCurvatureResolution = _ref.capCurvatureResolution;
                var _obj$children = $f12076c7962eab60$var$_slicedToArray(obj.children, 2), conicObj = _obj$children[0], strokeObj = _obj$children[1];
                // hide stroke if no color set
                var addStroke = !!strokeColor;
                strokeObj.visible = addStroke;
                // regenerate geometries if needed
                if (!$f12076c7962eab60$var$objMatch(conicObj.geometry.parameters || {}, {
                    polygonGeoJson: coords,
                    curvatureResolution: capCurvatureResolution
                })) {
                    conicObj.geometry && conicObj.geometry.dispose();
                    conicObj.geometry = new (0, $aa8bf899fc620c38$export$d1a95d7c8ca56306)(coords, 0, $f12076c7962eab60$var$GLOBE_RADIUS, false, true, true, capCurvatureResolution);
                }
                if (addStroke && (!strokeObj.geometry.parameters || strokeObj.geometry.parameters.geoJson.coordinates !== coords || strokeObj.geometry.parameters.resolution !== capCurvatureResolution)) {
                    strokeObj.geometry && strokeObj.geometry.dispose();
                    strokeObj.geometry = new (0, $cedac001b685292d$export$8ed86786cce60ba8)({
                        type: 'Polygon',
                        coordinates: coords
                    }, $f12076c7962eab60$var$GLOBE_RADIUS, capCurvatureResolution);
                }
                // replace side/cap materials if defined
                conicObj.material[0] = sideMaterial || obj.__defaultSideMaterial;
                conicObj.material[1] = capMaterial || obj.__defaultCapMaterial;
                // update default material colors
                [
                    !sideMaterial && sideColor,
                    !capMaterial && capColor
                ].forEach(function(color, materialIdx) {
                    if (!color) return; // skip custom materials
                    // conic object
                    var material = conicObj.material[materialIdx];
                    var opacity = $f12076c7962eab60$var$colorAlpha(color);
                    material.color.set($f12076c7962eab60$var$colorStr2Hex(color));
                    material.transparent = opacity < 1;
                    material.opacity = opacity;
                });
                if (addStroke) {
                    // stroke object
                    var material = strokeObj.material;
                    var opacity = $f12076c7962eab60$var$colorAlpha(strokeColor);
                    material.color.set($f12076c7962eab60$var$colorStr2Hex(strokeColor));
                    material.transparent = opacity < 1;
                    material.opacity = opacity;
                }
                var targetD = {
                    alt: altitude
                };
                var applyUpdate = function applyUpdate(td) {
                    var _obj$__currentTargetD = obj.__currentTargetD = td, alt = _obj$__currentTargetD.alt;
                    conicObj.scale.x = conicObj.scale.y = conicObj.scale.z = 1 + alt;
                    addStroke && (strokeObj.scale.x = strokeObj.scale.y = strokeObj.scale.z = 1 + alt + 1e-4); // stroke slightly above the conic mesh
                };
                var currentTargetD = obj.__currentTargetD || Object.assign({}, targetD, {
                    alt: -0.001
                });
                if (Object.keys(targetD).some(function(k) {
                    return currentTargetD[k] !== targetD[k];
                })) {
                    if (!state.polygonsTransitionDuration || state.polygonsTransitionDuration < 0 || currentTargetD.alt === targetD.alt) // set final position
                    applyUpdate(targetD);
                    else // animate
                    new $79Zf3.Tween(currentTargetD).to(targetD, state.polygonsTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
                }
            }
        });
    }
});
function $f12076c7962eab60$var$objMatch(obj, attrs) {
    var compFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {
        return function(a, b) {
            return a === b;
        };
    };
    return Object.entries(attrs).every(function(_ref2) {
        var _ref3 = $f12076c7962eab60$var$_slicedToArray(_ref2, 2), k = _ref3[0], v = _ref3[1];
        return obj.hasOwnProperty(k) && compFn(k)(obj[k], v);
    });
}
var $f12076c7962eab60$var$THREE$9 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959),
    CircleGeometry: (0, $8725869b83961a04$export$d5c0e8d607467193),
    DoubleSide: (0, $8725869b83961a04$export$3b296b6f144d5b03),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $8725869b83961a04$export$5023a9a8114806b8),
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
};
var $f12076c7962eab60$var$bfg = Object.assign({}, $e5162ea5560088cd$exports);
var $f12076c7962eab60$var$BufferGeometryUtils = $f12076c7962eab60$var$bfg.BufferGeometryUtils || $f12076c7962eab60$var$bfg;
//
var $f12076c7962eab60$var$HexedPolygonsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        hexPolygonsData: {
            "default": []
        },
        hexPolygonGeoJsonGeometry: {
            "default": 'geometry'
        },
        hexPolygonColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        hexPolygonAltitude: {
            "default": 0.001
        },
        // in units of globe radius
        hexPolygonResolution: {
            "default": 3
        },
        // 0-15. Level 0 partitions the earth in 122 (mostly) hexagonal cells. Each subsequent level sub-divides the previous in roughly 7 hexagons.
        hexPolygonMargin: {
            "default": 0.2
        },
        // in fraction of hex diameter
        hexPolygonUseDots: {
            "default": false
        },
        // if points should be circular instead of hexagonal
        hexPolygonCurvatureResolution: {
            "default": 5
        },
        // in angular degrees, only relevant for hex tops
        hexPolygonDotResolution: {
            "default": 12
        },
        // how many slice segments in the dot circle's circumference
        hexPolygonsTransitionDuration: {
            "default": 0,
            triggerUpdate: false
        } // ms
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state) {
        // Accessors
        var geoJsonAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonGeoJsonGeometry);
        var colorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonColor);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonAltitude);
        var resolutionAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonResolution);
        var marginAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonMargin);
        var useDotsAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonUseDots);
        var curvatureResolutionAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonCurvatureResolution);
        var dotResolutionAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.hexPolygonDotResolution);
        $f12076c7962eab60$var$threeDigest(state.hexPolygonsData, state.scene, {
            createObj: function createObj(d) {
                var obj = new $f12076c7962eab60$var$THREE$9.Mesh(undefined, new $f12076c7962eab60$var$THREE$9.MeshLambertMaterial({
                    side: $f12076c7962eab60$var$THREE$9.DoubleSide
                }));
                obj.__globeObjType = 'hexPolygon'; // Add object type
                return obj;
            },
            updateObj: function updateObj(obj, d) {
                var geoJson = geoJsonAccessor(d);
                var h3Res = resolutionAccessor(d);
                var alt = altitudeAccessor(d);
                var margin = Math.max(0, Math.min(1, +marginAccessor(d)));
                var useDots = useDotsAccessor(d);
                var curvatureResolution = curvatureResolutionAccessor(d);
                var dotResolution = dotResolutionAccessor(d);
                // update material
                var color = colorAccessor(d);
                var opacity = $f12076c7962eab60$var$colorAlpha(color);
                obj.material.color.set($f12076c7962eab60$var$colorStr2Hex(color));
                obj.material.transparent = opacity < 1;
                obj.material.opacity = opacity;
                var targetD = {
                    alt: alt,
                    margin: margin,
                    curvatureResolution: curvatureResolution
                };
                var memD = {
                    geoJson: geoJson,
                    h3Res: h3Res
                };
                var currentTargetD = obj.__currentTargetD || Object.assign({}, targetD, {
                    alt: -0.001
                });
                var currentMemD = obj.__currentMemD || memD;
                if (Object.keys(targetD).some(function(k) {
                    return currentTargetD[k] !== targetD[k];
                }) || Object.keys(memD).some(function(k) {
                    return currentMemD[k] !== memD[k];
                })) {
                    obj.__currentMemD = memD;
                    var h3Idxs = [];
                    if (geoJson.type === 'Polygon') (0, $e3286925688328aa$export$169c20284a281646)(geoJson.coordinates, h3Res, true).forEach(function(idx) {
                        return h3Idxs.push(idx);
                    });
                    else if (geoJson.type === 'MultiPolygon') geoJson.coordinates.forEach(function(coords) {
                        return (0, $e3286925688328aa$export$169c20284a281646)(coords, h3Res, true).forEach(function(idx) {
                            return h3Idxs.push(idx);
                        });
                    });
                    else console.warn("Unsupported GeoJson geometry type: ".concat(geoJson.type, ". Skipping geometry..."));
                    var hexBins = h3Idxs.map(function(h3Idx) {
                        var hexCenter = (0, $e3286925688328aa$export$2ed8e7796c5b7719)(h3Idx);
                        var hexGeoJson = (0, $e3286925688328aa$export$95a0f8735a48a896)(h3Idx, true).reverse(); // correct polygon winding
                        // stitch longitudes at the anti-meridian
                        var centerLng = hexCenter[1];
                        hexGeoJson.forEach(function(d) {
                            var edgeLng = d[0];
                            if (Math.abs(centerLng - edgeLng) > 170) // normalize large lng distances
                            d[0] += centerLng > edgeLng ? 360 : -360;
                        });
                        return {
                            h3Idx: h3Idx,
                            hexCenter: hexCenter,
                            hexGeoJson: hexGeoJson
                        };
                    });
                    var applyUpdate = function applyUpdate(td) {
                        var _obj$__currentTargetD = obj.__currentTargetD = td, alt = _obj$__currentTargetD.alt, margin = _obj$__currentTargetD.margin, curvatureResolution = _obj$__currentTargetD.curvatureResolution;
                        obj.geometry && obj.geometry.dispose();
                        obj.geometry = !hexBins.length ? new $f12076c7962eab60$var$THREE$9.BufferGeometry() : ($f12076c7962eab60$var$BufferGeometryUtils.mergeGeometries || $f12076c7962eab60$var$BufferGeometryUtils.mergeBufferGeometries)(hexBins.map(function(h) {
                            var _h$hexCenter = $f12076c7962eab60$var$_slicedToArray(h.hexCenter, 2), clat = _h$hexCenter[0], clng = _h$hexCenter[1];
                            if (useDots) {
                                var centerPos = $f12076c7962eab60$var$polar2Cartesian(clat, clng, alt);
                                var edgePos = $f12076c7962eab60$var$polar2Cartesian(h.hexGeoJson[0][1], h.hexGeoJson[0][0], alt);
                                var r = 0.85 * (1 - margin) * new $f12076c7962eab60$var$THREE$9.Vector3(centerPos.x, centerPos.y, centerPos.z).distanceTo(new $f12076c7962eab60$var$THREE$9.Vector3(edgePos.x, edgePos.y, edgePos.z));
                                var geometry = new (0, $8725869b83961a04$export$d5c0e8d607467193)(r, dotResolution);
                                geometry.rotateX($f12076c7962eab60$var$deg2Rad$1(-clat));
                                geometry.rotateY($f12076c7962eab60$var$deg2Rad$1(clng));
                                geometry.translate(centerPos.x, centerPos.y, centerPos.z);
                                return geometry;
                            } else {
                                var relNum = function relNum(st, end, rat) {
                                    return st - (st - end) * rat;
                                };
                                // compute new geojson with relative margin
                                var _geoJson = margin === 0 ? h.hexGeoJson : h.hexGeoJson.map(function(_ref) {
                                    var _ref2 = $f12076c7962eab60$var$_slicedToArray(_ref, 2), elng = _ref2[0], elat = _ref2[1];
                                    return [
                                        [
                                            elng,
                                            clng
                                        ],
                                        [
                                            elat,
                                            clat
                                        ]
                                    ].map(function(_ref3) {
                                        var _ref4 = $f12076c7962eab60$var$_slicedToArray(_ref3, 2), st = _ref4[0], end = _ref4[1];
                                        return relNum(st, end, margin);
                                    });
                                });
                                return new (0, $aa8bf899fc620c38$export$d1a95d7c8ca56306)([
                                    _geoJson
                                ], $f12076c7962eab60$var$GLOBE_RADIUS, $f12076c7962eab60$var$GLOBE_RADIUS * (1 + alt), false, true, false, curvatureResolution);
                            }
                        }));
                    };
                    if (!state.hexPolygonsTransitionDuration || state.hexPolygonsTransitionDuration < 0) // set final position
                    applyUpdate(targetD);
                    else // animate
                    new $79Zf3.Tween(currentTargetD).to(targetD, state.hexPolygonsTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
                }
            }
        });
    }
});
var $f12076c7962eab60$var$THREE$8 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
};
function $f12076c7962eab60$var$interpolateVectors(fromPnts, toPnts) {
    var extendArr = function extendArr(arr, length) {
        var repeatItem = arr[arr.length - 1];
        return [].concat($f12076c7962eab60$var$_toConsumableArray(arr), $f12076c7962eab60$var$_toConsumableArray($f12076c7962eab60$var$_toConsumableArray(new Array(length - arr.length)).map(function() {
            return repeatItem;
        })));
    };
    var arrLength = Math.max(fromPnts.length, toPnts.length);
    var interpolator = (0, $6c3a685d30ea04b4$export$2e2bcd8739ae039).apply(void 0, $f12076c7962eab60$var$_toConsumableArray([
        fromPnts,
        toPnts
    ].map(function(pnts) {
        return pnts.map(function(_ref) {
            var x = _ref.x, y = _ref.y, z = _ref.z;
            return [
                x,
                y,
                z
            ];
        });
    }).map(function(arr) {
        return extendArr(arr, arrLength);
    })));
    return function(k) {
        return k === 0 ? fromPnts : k === 1 ? toPnts : interpolator(k).map(function(_ref2) {
            var _ref3 = $f12076c7962eab60$var$_slicedToArray(_ref2, 3), x = _ref3[0], y = _ref3[1], z = _ref3[2];
            return new $f12076c7962eab60$var$THREE$8.Vector3(x, y, z);
        });
    };
}
var $f12076c7962eab60$var$THREE$7 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959),
    Color: (0, $8725869b83961a04$export$892596cec99bc70e),
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4),
    Line: (0, $8725869b83961a04$export$17d680238e50603e),
    NormalBlending: (0, $8725869b83961a04$export$5b29a26d96ee6af0),
    ShaderMaterial: (0, $8725869b83961a04$export$83c7d75d550a8b0d),
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
};
var $f12076c7962eab60$var$FrameTicker$1 = (0, (/*@__PURE__*/$parcel$interopDefault($f1564f6f90ed2410$exports)))["default"] || (0, (/*@__PURE__*/$parcel$interopDefault($f1564f6f90ed2410$exports)));
//
var $f12076c7962eab60$var$gradientShaders = {
    uniforms: {
        // dash param defaults, all relative to full length
        dashOffset: {
            value: 0
        },
        dashSize: {
            value: 1
        },
        gapSize: {
            value: 0
        },
        dashTranslate: {
            value: 0
        } // used for animating the dash
    },
    vertexShader: "\n    uniform float dashTranslate;\n\n    attribute vec4 vertexColor;\n    varying vec4 vColor;\n\n    attribute float vertexRelDistance;\n    varying float vRelDistance;\n\n    void main() {\n      // pass through colors and distances\n      vColor = vertexColor;\n      vRelDistance = vertexRelDistance + dashTranslate;\n      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n    }\n  ",
    fragmentShader: "\n    uniform float dashOffset;\n    uniform float dashSize;\n    uniform float gapSize;\n\n    varying vec4 vColor;\n    varying float vRelDistance;\n\n    void main() {\n      // ignore pixels in the gap\n      if (vRelDistance < dashOffset) discard;\n      if (mod(vRelDistance - dashOffset, dashSize + gapSize) > dashSize) discard;\n\n      // set px color: [r, g, b, a], interpolated between vertices\n      gl_FragColor = vColor;\n    }\n  "
};
var $f12076c7962eab60$var$PathsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        pathsData: {
            "default": []
        },
        pathPoints: {
            "default": function _default(pnts) {
                return pnts;
            }
        },
        pathPointLat: {
            "default": function _default(arr) {
                return arr[0];
            }
        },
        pathPointLng: {
            "default": function _default(arr) {
                return arr[1];
            }
        },
        pathPointAlt: {
            "default": 1e-3
        },
        pathResolution: {
            "default": 2
        },
        // in deg
        pathColor: {
            "default": function _default() {
                return '#ffffaa';
            }
        },
        // single color, array of colors or color interpolation fn
        pathStroke: {},
        // in deg
        pathDashLength: {
            "default": 1
        },
        // in units of line length
        pathDashGap: {
            "default": 0
        },
        pathDashInitialGap: {
            "default": 0
        },
        pathDashAnimateTime: {
            "default": 0
        },
        // ms
        pathTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        },
        // ms
        rendererSize: {} // necessary to set correct fatline proportions
    },
    methods: {
        pauseAnimation: function pauseAnimation(state) {
            var _state$ticker;
            (_state$ticker = state.ticker) === null || _state$ticker === void 0 || _state$ticker.pause();
        },
        resumeAnimation: function resumeAnimation(state) {
            var _state$ticker2;
            (_state$ticker2 = state.ticker) === null || _state$ticker2 === void 0 || _state$ticker2.resume();
        },
        _destructor: function _destructor(state) {
            var _state$ticker3;
            (_state$ticker3 = state.ticker) === null || _state$ticker3 === void 0 || _state$ticker3.dispose();
        }
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
        // Kick-off dash animations
        state.ticker = new $f12076c7962eab60$var$FrameTicker$1();
        state.ticker.onTick.add(function(_, timeDelta) {
            state.pathsData.filter(function(d) {
                return d.__threeObj && d.__threeObj.children.length && d.__threeObj.children[0].material && d.__threeObj.children[0].__dashAnimateStep;
            }).forEach(function(d) {
                var obj = d.__threeObj.children[0];
                var step = obj.__dashAnimateStep * timeDelta;
                if (obj.type === 'Line') {
                    var curTranslate = obj.material.uniforms.dashTranslate.value % 1e9; // reset after 1B loops
                    obj.material.uniforms.dashTranslate.value = curTranslate + step;
                } else if (obj.type === 'Line2') {
                    // fatline
                    var offset = obj.material.dashOffset - step;
                    var dashLength = obj.material.dashSize + obj.material.gapSize;
                    while(offset <= -dashLength)offset += dashLength; // cycle within dash length
                    obj.material.dashOffset = offset;
                }
            });
        });
    },
    update: function update(state) {
        // Data accessors
        var pointsAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathPoints);
        var pointLatAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathPointLat);
        var pointLngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathPointLng);
        var pointAltAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathPointAlt);
        var strokeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathStroke);
        var colorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathColor);
        var dashLengthAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathDashLength);
        var dashGapAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathDashGap);
        var dashInitialGapAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathDashInitialGap);
        var dashAnimateTimeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.pathDashAnimateTime);
        var sharedShaderMaterial = new $f12076c7962eab60$var$THREE$7.ShaderMaterial($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2({}, $f12076c7962eab60$var$gradientShaders), {}, {
            transparent: true,
            blending: $f12076c7962eab60$var$THREE$7.NormalBlending
        }));
        $f12076c7962eab60$var$threeDigest(state.pathsData, state.scene, {
            createObj: function createObj() {
                var obj = new $f12076c7962eab60$var$THREE$7.Group(); // populated in updateObj
                obj.__globeObjType = 'path'; // Add object type
                return obj;
            },
            updateObj: function updateObj(group, path) {
                var stroke = strokeAccessor(path);
                var useFatLine = stroke !== null && stroke !== undefined;
                if (!group.children.length || useFatLine === (group.children[0].type === 'Line')) {
                    // create or swap object types
                    $f12076c7962eab60$var$emptyObject(group);
                    var _obj = useFatLine ? new (0, $83768f2837205906$export$4e6fcde58d84e955)(new (0, $83768f2837205906$export$dcc17b59d0a74bb5)(), new (0, $83768f2837205906$export$d19cd1378966f3d3)()) : new $f12076c7962eab60$var$THREE$7.Line(new $f12076c7962eab60$var$THREE$7.BufferGeometry(), sharedShaderMaterial.clone() // Separate material instance per object to have dedicated uniforms (but shared shaders)
                    );
                    group.add(_obj);
                }
                var obj = group.children[0];
                var points = calcPath(pointsAccessor(path), pointLatAccessor, pointLngAccessor, pointAltAccessor, state.pathResolution);
                // set dash animation step
                var dashAnimateTime = dashAnimateTimeAccessor(path);
                obj.__dashAnimateStep = dashAnimateTime > 0 ? 1000 / dashAnimateTime : 0; // per second
                if (!useFatLine) {
                    // set dash uniforms
                    Object.assign(obj.material.uniforms, {
                        dashSize: {
                            value: dashLengthAccessor(path)
                        },
                        gapSize: {
                            value: dashGapAccessor(path)
                        },
                        dashOffset: {
                            value: dashInitialGapAccessor(path)
                        }
                    });
                    // calculate vertex colors (to create gradient)
                    var vertexColorArray = calcColorVertexArray(colorAccessor(path), // single, array of colors or interpolator
                    points.length // numSegments
                    );
                    // calculate vertex relative distances (for dashed lines)
                    var vertexRelDistanceArray = calcVertexRelDistances(points.length, // numSegments
                    1, // num vertices per segment
                    true // run from end to start, to animate in the correct direction
                    );
                    obj.geometry.setAttribute('vertexColor', vertexColorArray);
                    obj.geometry.setAttribute('vertexRelDistance', vertexRelDistanceArray);
                } else {
                    // fat lines
                    obj.material.resolution = state.rendererSize;
                    // set dash styling
                    var dashLength = dashLengthAccessor(path);
                    var dashGap = dashGapAccessor(path);
                    var dashInitialGap = dashInitialGapAccessor(path);
                    obj.material.dashed = dashGap > 0;
                    // temp hack to activate line dashes
                    obj.material.dashed ? obj.material.defines.USE_DASH = "" : delete obj.material.defines.USE_DASH;
                    if (obj.material.dashed) {
                        obj.material.dashScale = 1 / calcLineDistance(points); // dash sizes relative to full line length
                        obj.material.dashSize = dashLength;
                        obj.material.gapSize = dashGap;
                        obj.material.dashOffset = -dashInitialGap;
                    }
                    // set line colors
                    var colors = colorAccessor(path);
                    if (colors instanceof Array) {
                        // calculate vertex colors (to create gradient)
                        var _vertexColorArray = calcColorVertexArray(colorAccessor(path), // single, array of colors or interpolator
                        points.length - 1, // numSegments
                        1, // num vertices per segment
                        false);
                        obj.geometry.setColors(_vertexColorArray.array);
                        obj.material.vertexColors = true;
                    } else {
                        // single color
                        var color = colors;
                        var opacity = $f12076c7962eab60$var$colorAlpha(color);
                        obj.material.color = new $f12076c7962eab60$var$THREE$7.Color($f12076c7962eab60$var$colorStr2Hex(color));
                        obj.material.transparent = opacity < 1;
                        obj.material.opacity = opacity;
                        obj.material.vertexColors = false;
                    }
                    obj.material.needsUpdate = true;
                }
                // animate from start to finish by default
                var pointsInterpolator = $f12076c7962eab60$var$interpolateVectors(path.__currentTargetD && path.__currentTargetD.points || [
                    points[0]
                ], points);
                var applyUpdate = function applyUpdate(td) {
                    var _path$__currentTarget = path.__currentTargetD = td, stroke = _path$__currentTarget.stroke, interpolK = _path$__currentTarget.interpolK;
                    var kPoints = path.__currentTargetD.points = pointsInterpolator(interpolK);
                    if (useFatLine) {
                        var _ref;
                        obj.geometry.setPositions((_ref = []).concat.apply(_ref, $f12076c7962eab60$var$_toConsumableArray(kPoints.map(function(_ref2) {
                            var x = _ref2.x, y = _ref2.y, z = _ref2.z;
                            return [
                                x,
                                y,
                                z
                            ];
                        }))));
                        obj.material.linewidth = stroke;
                        // necessary for dashed lines
                        obj.material.dashed && obj.computeLineDistances();
                    } else {
                        obj.geometry.setFromPoints(kPoints);
                        obj.geometry.computeBoundingSphere();
                    }
                };
                var targetD = {
                    stroke: stroke,
                    interpolK: 1
                };
                var currentTargetD = Object.assign({}, path.__currentTargetD || targetD, {
                    interpolK: 0
                });
                if (Object.keys(targetD).some(function(k) {
                    return currentTargetD[k] !== targetD[k];
                })) {
                    if (!state.pathTransitionDuration || state.pathTransitionDuration < 0) // set final position
                    applyUpdate(targetD);
                    else // animate
                    new $79Zf3.Tween(currentTargetD).to(targetD, state.pathTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
                }
            }
        });
        //
        function calcLineDistance(pnts) {
            var totalDist = 0;
            var prevPnt;
            pnts.forEach(function(pnt) {
                prevPnt && (totalDist += prevPnt.distanceTo(pnt));
                prevPnt = pnt;
            });
            return totalDist;
        }
        function calcPath(points, latAccessor, lngAccessor, altAccessor, angularResolution) {
            var getInterpolatedVals = function getInterpolatedVals(start, end, numPnts) {
                var result = [];
                for(var i = 1; i <= numPnts; i++)result.push(start + (end - start) * i / (numPnts + 1));
                return result;
            };
            var interpolateLine = function interpolateLine() {
                var lineCoords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var maxDegDistance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                var result = [];
                var prevPnt = null;
                lineCoords.forEach(function(pnt) {
                    if (prevPnt) {
                        // cross the anti-meridian if that's the closest distance between points
                        while(Math.abs(prevPnt[1] - pnt[1]) > 180)prevPnt[1] += 360 * (prevPnt[1] < pnt[1] ? 1 : -1);
                        var dist = Math.sqrt(Math.pow(pnt[0] - prevPnt[0], 2) + Math.pow(pnt[1] - prevPnt[1], 2));
                        if (dist > maxDegDistance) {
                            var numAdditionalPnts = Math.floor(dist / maxDegDistance);
                            var lats = getInterpolatedVals(prevPnt[0], pnt[0], numAdditionalPnts);
                            var lngs = getInterpolatedVals(prevPnt[1], pnt[1], numAdditionalPnts);
                            var alts = getInterpolatedVals(prevPnt[2], pnt[2], numAdditionalPnts);
                            for(var i = 0, len = lats.length; i < len; i++)result.push([
                                lats[i],
                                lngs[i],
                                alts[i]
                            ]);
                        }
                    }
                    result.push(prevPnt = pnt);
                });
                return result;
            };
            var getVec = function getVec(_ref3) {
                var _ref4 = $f12076c7962eab60$var$_slicedToArray(_ref3, 3), lat = _ref4[0], lng = _ref4[1], alt = _ref4[2];
                var _polar2Cartesian = $f12076c7962eab60$var$polar2Cartesian(lat, lng, alt), x = _polar2Cartesian.x, y = _polar2Cartesian.y, z = _polar2Cartesian.z;
                return new $f12076c7962eab60$var$THREE$7.Vector3(x, y, z);
            };
            return interpolateLine(points.map(function(pnt) {
                return [
                    latAccessor(pnt),
                    lngAccessor(pnt),
                    altAccessor(pnt)
                ];
            }), angularResolution).map(getVec);
        }
        function calcColorVertexArray(colors, numSegments) {
            var numVerticesPerSegment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
            var includeAlpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            var numVerticesGroup = numSegments + 1; // one between every two segments and two at the ends
            var getVertexColor;
            if (colors instanceof Array || colors instanceof Function) {
                var colorInterpolator = colors instanceof Array ? (0, $050f6c6fd36ea5ca$export$2e2bcd8739ae039)() // array of colors, interpolate at each step
                .domain(colors.map(function(_, idx) {
                    return idx / (colors.length - 1);
                })) // same number of stops as colors
                .range(colors) : colors; // already interpolator fn
                getVertexColor = function getVertexColor(t) {
                    return $f12076c7962eab60$var$color2ShaderArr(colorInterpolator(t), includeAlpha, true);
                };
            } else {
                // single color, use constant
                var vertexColor = $f12076c7962eab60$var$color2ShaderArr(colors, includeAlpha, true);
                getVertexColor = function getVertexColor() {
                    return vertexColor;
                };
            }
            var vertexColors = [];
            for(var v = 0, l = numVerticesGroup; v < l; v++){
                var _vertexColor = getVertexColor(v / (l - 1));
                for(var s = 0; s < numVerticesPerSegment; s++)vertexColors.push(_vertexColor);
            }
            return $f12076c7962eab60$var$array2BufferAttr(vertexColors, includeAlpha ? 4 : 3);
        }
        function calcVertexRelDistances(numSegments) {
            var numVerticesPerSegment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var invert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var numVerticesGroup = numSegments + 1; // one between every two segments and two at the ends
            var vertexDistances = [];
            for(var v = 0, l = numVerticesGroup; v < l; v++){
                var relDistance = v / (l - 1);
                for(var s = 0; s < numVerticesPerSegment; s++)vertexDistances.push(relDistance);
            }
            invert && vertexDistances.reverse();
            return $f12076c7962eab60$var$array2BufferAttr(vertexDistances, 1);
        }
    }
});
var $f12076c7962eab60$var$THREE$6 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Euler: (0, $8725869b83961a04$export$d93cc409a0768c5f),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $8725869b83961a04$export$5023a9a8114806b8),
    SphereGeometry: (0, $8725869b83961a04$export$1b417fc3b307a251)
};
//
var $f12076c7962eab60$var$TilesLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        tilesData: {
            "default": []
        },
        tileLat: {
            "default": 'lat'
        },
        // tile centroid
        tileLng: {
            "default": 'lng'
        },
        tileAltitude: {
            "default": 0.01
        },
        // in units of globe radius
        tileWidth: {
            "default": 1
        },
        // in lng degrees
        tileHeight: {
            "default": 1
        },
        // in lat degrees
        tileUseGlobeProjection: {
            "default": true
        },
        // whether to size tiles relative to the globe coordinate system, or independently
        tileMaterial: {
            "default": function _default() {
                return new $f12076c7962eab60$var$THREE$6.MeshLambertMaterial({
                    color: '#ffbb88',
                    opacity: 0.4,
                    transparent: true
                });
            }
        },
        tileCurvatureResolution: {
            "default": 5
        },
        // in angular degrees
        tilesTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        } // ms
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state) {
        // Data accessors
        var latAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileLat);
        var lngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileLng);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileAltitude);
        var widthAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileWidth);
        var heightAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileHeight);
        var useGlobeProjectionAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileUseGlobeProjection);
        var materialAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileMaterial);
        var curvatureResolutionAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.tileCurvatureResolution);
        $f12076c7962eab60$var$threeDigest(state.tilesData, state.scene, {
            createObj: function createObj() {
                var obj = new $f12076c7962eab60$var$THREE$6.Mesh();
                obj.__globeObjType = 'tile'; // Add object type
                return obj;
            },
            updateObj: function updateObj(obj, d) {
                obj.material = materialAccessor(d); // set material
                var useGlobeProjection = useGlobeProjectionAccessor(d);
                var curvatureResolution = curvatureResolutionAccessor(d);
                // animations
                var applyPosition = function applyPosition(td) {
                    var _obj$__currentTargetD = obj.__currentTargetD = td, lat = _obj$__currentTargetD.lat, lng = _obj$__currentTargetD.lng, alt = _obj$__currentTargetD.alt, width = _obj$__currentTargetD.width, height = _obj$__currentTargetD.height;
                    var rotLng = $f12076c7962eab60$var$deg2Rad(lng);
                    var rotLat = $f12076c7962eab60$var$deg2Rad(-lat);
                    obj.geometry && obj.geometry.dispose();
                    obj.geometry = new $f12076c7962eab60$var$THREE$6.SphereGeometry($f12076c7962eab60$var$GLOBE_RADIUS * (1 + alt), Math.ceil(width / (curvatureResolution || -1)), Math.ceil(height / (curvatureResolution || -1)), $f12076c7962eab60$var$deg2Rad(90 - width / 2) + (useGlobeProjection ? rotLng : 0), $f12076c7962eab60$var$deg2Rad(width), $f12076c7962eab60$var$deg2Rad(90 - height / 2) + (useGlobeProjection ? rotLat : 0), $f12076c7962eab60$var$deg2Rad(height));
                    if (!useGlobeProjection) // rotate obj instead. order matters, rotate longitudinally first.
                    obj.setRotationFromEuler(new $f12076c7962eab60$var$THREE$6.Euler(rotLat, rotLng, 0, 'YXZ'));
                };
                var targetD = {
                    lat: +latAccessor(d),
                    lng: +lngAccessor(d),
                    alt: +altitudeAccessor(d),
                    width: +widthAccessor(d),
                    height: +heightAccessor(d)
                };
                var currentTargetD = obj.__currentTargetD || Object.assign({}, targetD, {
                    width: 0,
                    height: 0
                });
                if (Object.keys(targetD).some(function(k) {
                    return currentTargetD[k] !== targetD[k];
                })) {
                    if (!state.tilesTransitionDuration || state.tilesTransitionDuration < 0) // set final position
                    applyPosition(targetD);
                    else // animate
                    new $79Zf3.Tween(currentTargetD).to(targetD, state.tilesTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyPosition).start();
                }
            }
        });
    }
});
var $f12076c7962eab60$var$deg2Rad = function deg2Rad(deg) {
    return deg * Math.PI / 180;
};
var $f12076c7962eab60$var$glyphs = {
    "0": {
        x_min: 73,
        x_max: 715,
        ha: 792,
        o: "m 394 -29 q 153 129 242 -29 q 73 479 73 272 q 152 829 73 687 q 394 989 241 989 q 634 829 545 989 q 715 479 715 684 q 635 129 715 270 q 394 -29 546 -29 m 394 89 q 546 211 489 89 q 598 479 598 322 q 548 748 598 640 q 394 871 491 871 q 241 748 298 871 q 190 479 190 637 q 239 211 190 319 q 394 89 296 89 "
    },
    "1": {
        x_min: 215.671875,
        x_max: 574,
        ha: 792,
        o: "m 574 0 l 442 0 l 442 697 l 215 697 l 215 796 q 386 833 330 796 q 475 986 447 875 l 574 986 l 574 0 "
    },
    "2": {
        x_min: 59,
        x_max: 731,
        ha: 792,
        o: "m 731 0 l 59 0 q 197 314 59 188 q 457 487 199 315 q 598 691 598 580 q 543 819 598 772 q 411 867 488 867 q 272 811 328 867 q 209 630 209 747 l 81 630 q 182 901 81 805 q 408 986 271 986 q 629 909 536 986 q 731 694 731 826 q 613 449 731 541 q 378 316 495 383 q 201 122 235 234 l 731 122 l 731 0 "
    },
    "3": {
        x_min: 54,
        x_max: 737,
        ha: 792,
        o: "m 737 284 q 635 55 737 141 q 399 -25 541 -25 q 156 52 248 -25 q 54 308 54 140 l 185 308 q 245 147 185 202 q 395 96 302 96 q 539 140 484 96 q 602 280 602 190 q 510 429 602 390 q 324 454 451 454 l 324 565 q 487 584 441 565 q 565 719 565 617 q 515 835 565 791 q 395 879 466 879 q 255 824 307 879 q 203 661 203 769 l 78 661 q 166 909 78 822 q 387 992 250 992 q 603 921 513 992 q 701 723 701 844 q 669 607 701 656 q 578 524 637 558 q 696 434 655 499 q 737 284 737 369 "
    },
    "4": {
        x_min: 48,
        x_max: 742.453125,
        ha: 792,
        o: "m 742 243 l 602 243 l 602 0 l 476 0 l 476 243 l 48 243 l 48 368 l 476 958 l 602 958 l 602 354 l 742 354 l 742 243 m 476 354 l 476 792 l 162 354 l 476 354 "
    },
    "5": {
        x_min: 54.171875,
        x_max: 738,
        ha: 792,
        o: "m 738 314 q 626 60 738 153 q 382 -23 526 -23 q 155 47 248 -23 q 54 256 54 125 l 183 256 q 259 132 204 174 q 382 91 314 91 q 533 149 471 91 q 602 314 602 213 q 538 469 602 411 q 386 528 475 528 q 284 506 332 528 q 197 439 237 484 l 81 439 l 159 958 l 684 958 l 684 840 l 254 840 l 214 579 q 306 627 258 612 q 407 643 354 643 q 636 552 540 643 q 738 314 738 457 "
    },
    "6": {
        x_min: 53,
        x_max: 739,
        ha: 792,
        o: "m 739 312 q 633 62 739 162 q 400 -31 534 -31 q 162 78 257 -31 q 53 439 53 206 q 178 859 53 712 q 441 986 284 986 q 643 912 559 986 q 732 713 732 833 l 601 713 q 544 830 594 786 q 426 875 494 875 q 268 793 331 875 q 193 517 193 697 q 301 597 240 570 q 427 624 362 624 q 643 540 552 624 q 739 312 739 451 m 603 298 q 540 461 603 400 q 404 516 484 516 q 268 461 323 516 q 207 300 207 401 q 269 137 207 198 q 405 83 325 83 q 541 137 486 83 q 603 298 603 197 "
    },
    "7": {
        x_min: 58.71875,
        x_max: 730.953125,
        ha: 792,
        o: "m 730 839 q 469 448 560 641 q 335 0 378 255 l 192 0 q 328 441 235 252 q 593 830 421 630 l 58 830 l 58 958 l 730 958 l 730 839 "
    },
    "8": {
        x_min: 55,
        x_max: 736,
        ha: 792,
        o: "m 571 527 q 694 424 652 491 q 736 280 736 358 q 648 71 736 158 q 395 -26 551 -26 q 142 69 238 -26 q 55 279 55 157 q 96 425 55 359 q 220 527 138 491 q 120 615 153 562 q 88 726 88 668 q 171 904 88 827 q 395 986 261 986 q 618 905 529 986 q 702 727 702 830 q 670 616 702 667 q 571 527 638 565 m 394 565 q 519 610 475 565 q 563 717 563 655 q 521 823 563 781 q 392 872 474 872 q 265 824 312 872 q 224 720 224 783 q 265 613 224 656 q 394 565 312 565 m 395 91 q 545 150 488 91 q 597 280 597 204 q 546 408 597 355 q 395 465 492 465 q 244 408 299 465 q 194 280 194 356 q 244 150 194 203 q 395 91 299 91 "
    },
    "9": {
        x_min: 53,
        x_max: 739,
        ha: 792,
        o: "m 739 524 q 619 94 739 241 q 362 -32 516 -32 q 150 47 242 -32 q 59 244 59 126 l 191 244 q 246 129 191 176 q 373 82 301 82 q 526 161 466 82 q 597 440 597 255 q 363 334 501 334 q 130 432 216 334 q 53 650 53 521 q 134 880 53 786 q 383 986 226 986 q 659 841 566 986 q 739 524 739 719 m 388 449 q 535 514 480 449 q 585 658 585 573 q 535 805 585 744 q 388 873 480 873 q 242 809 294 873 q 191 658 191 745 q 239 514 191 572 q 388 449 292 449 "
    },
    "\u03BF": {
        x_min: 0,
        x_max: 712,
        ha: 815,
        o: "m 356 -25 q 96 88 192 -25 q 0 368 0 201 q 92 642 0 533 q 356 761 192 761 q 617 644 517 761 q 712 368 712 533 q 619 91 712 201 q 356 -25 520 -25 m 356 85 q 527 175 465 85 q 583 369 583 255 q 528 562 583 484 q 356 651 466 651 q 189 560 250 651 q 135 369 135 481 q 187 177 135 257 q 356 85 250 85 "
    },
    S: {
        x_min: 0,
        x_max: 788,
        ha: 890,
        o: "m 788 291 q 662 54 788 144 q 397 -26 550 -26 q 116 68 226 -26 q 0 337 0 168 l 131 337 q 200 152 131 220 q 384 85 269 85 q 557 129 479 85 q 650 270 650 183 q 490 429 650 379 q 194 513 341 470 q 33 739 33 584 q 142 964 33 881 q 388 1041 242 1041 q 644 957 543 1041 q 756 716 756 867 l 625 716 q 561 874 625 816 q 395 933 497 933 q 243 891 309 933 q 164 759 164 841 q 325 609 164 656 q 625 526 475 568 q 788 291 788 454 "
    },
    "\xa6": {
        x_min: 343,
        x_max: 449,
        ha: 792,
        o: "m 449 462 l 343 462 l 343 986 l 449 986 l 449 462 m 449 -242 l 343 -242 l 343 280 l 449 280 l 449 -242 "
    },
    "/": {
        x_min: 183.25,
        x_max: 608.328125,
        ha: 792,
        o: "m 608 1041 l 266 -129 l 183 -129 l 520 1041 l 608 1041 "
    },
    "\u03A4": {
        x_min: -0.4375,
        x_max: 777.453125,
        ha: 839,
        o: "m 777 893 l 458 893 l 458 0 l 319 0 l 319 892 l 0 892 l 0 1013 l 777 1013 l 777 893 "
    },
    y: {
        x_min: 0,
        x_max: 684.78125,
        ha: 771,
        o: "m 684 738 l 388 -83 q 311 -216 356 -167 q 173 -279 252 -279 q 97 -266 133 -279 l 97 -149 q 132 -155 109 -151 q 168 -160 155 -160 q 240 -114 213 -160 q 274 -26 248 -98 l 0 738 l 137 737 l 341 139 l 548 737 l 684 738 "
    },
    "\u03A0": {
        x_min: 0,
        x_max: 803,
        ha: 917,
        o: "m 803 0 l 667 0 l 667 886 l 140 886 l 140 0 l 0 0 l 0 1012 l 803 1012 l 803 0 "
    },
    "\u0390": {
        x_min: -111,
        x_max: 339,
        ha: 361,
        o: "m 339 800 l 229 800 l 229 925 l 339 925 l 339 800 m -1 800 l -111 800 l -111 925 l -1 925 l -1 800 m 284 3 q 233 -10 258 -5 q 182 -15 207 -15 q 85 26 119 -15 q 42 200 42 79 l 42 737 l 167 737 l 168 215 q 172 141 168 157 q 226 101 183 101 q 248 103 239 101 q 284 112 257 104 l 284 3 m 302 1040 l 113 819 l 30 819 l 165 1040 l 302 1040 "
    },
    g: {
        x_min: 0,
        x_max: 686,
        ha: 838,
        o: "m 686 34 q 586 -213 686 -121 q 331 -306 487 -306 q 131 -252 216 -306 q 31 -84 31 -190 l 155 -84 q 228 -174 166 -138 q 345 -207 284 -207 q 514 -109 454 -207 q 564 89 564 -27 q 461 6 521 36 q 335 -23 401 -23 q 88 100 184 -23 q 0 370 0 215 q 87 634 0 522 q 330 758 183 758 q 457 728 398 758 q 564 644 515 699 l 564 737 l 686 737 l 686 34 m 582 367 q 529 560 582 481 q 358 652 468 652 q 189 561 250 652 q 135 369 135 482 q 189 176 135 255 q 361 85 251 85 q 529 176 468 85 q 582 367 582 255 "
    },
    "\xb2": {
        x_min: 0,
        x_max: 442,
        ha: 539,
        o: "m 442 383 l 0 383 q 91 566 0 492 q 260 668 176 617 q 354 798 354 727 q 315 875 354 845 q 227 905 277 905 q 136 869 173 905 q 99 761 99 833 l 14 761 q 82 922 14 864 q 232 974 141 974 q 379 926 316 974 q 442 797 442 878 q 351 635 442 704 q 183 539 321 611 q 92 455 92 491 l 442 455 l 442 383 "
    },
    "\u2013": {
        x_min: 0,
        x_max: 705.5625,
        ha: 803,
        o: "m 705 334 l 0 334 l 0 410 l 705 410 l 705 334 "
    },
    "\u039A": {
        x_min: 0,
        x_max: 819.5625,
        ha: 893,
        o: "m 819 0 l 650 0 l 294 509 l 139 356 l 139 0 l 0 0 l 0 1013 l 139 1013 l 139 526 l 626 1013 l 809 1013 l 395 600 l 819 0 "
    },
    "\u0192": {
        x_min: -46.265625,
        x_max: 392,
        ha: 513,
        o: "m 392 651 l 259 651 l 79 -279 l -46 -278 l 134 651 l 14 651 l 14 751 l 135 751 q 151 948 135 900 q 304 1041 185 1041 q 334 1040 319 1041 q 392 1034 348 1039 l 392 922 q 337 931 360 931 q 271 883 287 931 q 260 793 260 853 l 260 751 l 392 751 l 392 651 "
    },
    e: {
        x_min: 0,
        x_max: 714,
        ha: 813,
        o: "m 714 326 l 140 326 q 200 157 140 227 q 359 87 260 87 q 488 130 431 87 q 561 245 545 174 l 697 245 q 577 48 670 123 q 358 -26 484 -26 q 97 85 195 -26 q 0 363 0 197 q 94 642 0 529 q 358 765 195 765 q 626 627 529 765 q 714 326 714 503 m 576 429 q 507 583 564 522 q 355 650 445 650 q 206 583 266 650 q 140 429 152 522 l 576 429 "
    },
    "\u03CC": {
        x_min: 0,
        x_max: 712,
        ha: 815,
        o: "m 356 -25 q 94 91 194 -25 q 0 368 0 202 q 92 642 0 533 q 356 761 192 761 q 617 644 517 761 q 712 368 712 533 q 619 91 712 201 q 356 -25 520 -25 m 356 85 q 527 175 465 85 q 583 369 583 255 q 528 562 583 484 q 356 651 466 651 q 189 560 250 651 q 135 369 135 481 q 187 177 135 257 q 356 85 250 85 m 576 1040 l 387 819 l 303 819 l 438 1040 l 576 1040 "
    },
    J: {
        x_min: 0,
        x_max: 588,
        ha: 699,
        o: "m 588 279 q 287 -26 588 -26 q 58 73 126 -26 q 0 327 0 158 l 133 327 q 160 172 133 227 q 288 96 198 96 q 426 171 391 96 q 449 336 449 219 l 449 1013 l 588 1013 l 588 279 "
    },
    "\xbb": {
        x_min: -1,
        x_max: 503,
        ha: 601,
        o: "m 503 302 l 280 136 l 281 256 l 429 373 l 281 486 l 280 608 l 503 440 l 503 302 m 221 302 l 0 136 l 0 255 l 145 372 l 0 486 l -1 608 l 221 440 l 221 302 "
    },
    "\xa9": {
        x_min: -3,
        x_max: 1008,
        ha: 1106,
        o: "m 502 -7 q 123 151 263 -7 q -3 501 -3 294 q 123 851 -3 706 q 502 1011 263 1011 q 881 851 739 1011 q 1008 501 1008 708 q 883 151 1008 292 q 502 -7 744 -7 m 502 60 q 830 197 709 60 q 940 501 940 322 q 831 805 940 681 q 502 944 709 944 q 174 805 296 944 q 65 501 65 680 q 173 197 65 320 q 502 60 294 60 m 741 394 q 661 246 731 302 q 496 190 591 190 q 294 285 369 190 q 228 497 228 370 q 295 714 228 625 q 499 813 370 813 q 656 762 588 813 q 733 625 724 711 l 634 625 q 589 704 629 673 q 498 735 550 735 q 377 666 421 735 q 334 504 334 597 q 374 340 334 408 q 490 272 415 272 q 589 304 549 272 q 638 394 628 337 l 741 394 "
    },
    "\u03CE": {
        x_min: 0,
        x_max: 922,
        ha: 1030,
        o: "m 687 1040 l 498 819 l 415 819 l 549 1040 l 687 1040 m 922 339 q 856 97 922 203 q 650 -26 780 -26 q 538 9 587 -26 q 461 103 489 44 q 387 12 436 46 q 277 -22 339 -22 q 69 97 147 -22 q 0 338 0 202 q 45 551 0 444 q 161 737 84 643 l 302 737 q 175 552 219 647 q 124 336 124 446 q 155 179 124 248 q 275 88 197 88 q 375 163 341 88 q 400 294 400 219 l 400 572 l 524 572 l 524 294 q 561 135 524 192 q 643 88 591 88 q 762 182 719 88 q 797 341 797 257 q 745 555 797 450 q 619 737 705 637 l 760 737 q 874 551 835 640 q 922 339 922 444 "
    },
    "^": {
        x_min: 193.0625,
        x_max: 598.609375,
        ha: 792,
        o: "m 598 772 l 515 772 l 395 931 l 277 772 l 193 772 l 326 1013 l 462 1013 l 598 772 "
    },
    "\xab": {
        x_min: 0,
        x_max: 507.203125,
        ha: 604,
        o: "m 506 136 l 284 302 l 284 440 l 506 608 l 507 485 l 360 371 l 506 255 l 506 136 m 222 136 l 0 302 l 0 440 l 222 608 l 221 486 l 73 373 l 222 256 l 222 136 "
    },
    D: {
        x_min: 0,
        x_max: 828,
        ha: 935,
        o: "m 389 1013 q 714 867 593 1013 q 828 521 828 729 q 712 161 828 309 q 382 0 587 0 l 0 0 l 0 1013 l 389 1013 m 376 124 q 607 247 523 124 q 681 510 681 355 q 607 771 681 662 q 376 896 522 896 l 139 896 l 139 124 l 376 124 "
    },
    "\u2219": {
        x_min: 0,
        x_max: 142,
        ha: 239,
        o: "m 142 585 l 0 585 l 0 738 l 142 738 l 142 585 "
    },
    "\xff": {
        x_min: 0,
        x_max: 47,
        ha: 125,
        o: "m 47 3 q 37 -7 47 -7 q 28 0 30 -7 q 39 -4 32 -4 q 45 3 45 -1 l 37 0 q 28 9 28 0 q 39 19 28 19 l 47 16 l 47 19 l 47 3 m 37 1 q 44 8 44 1 q 37 16 44 16 q 30 8 30 16 q 37 1 30 1 m 26 1 l 23 22 l 14 0 l 3 22 l 3 3 l 0 25 l 13 1 l 22 25 l 26 1 "
    },
    w: {
        x_min: 0,
        x_max: 1009.71875,
        ha: 1100,
        o: "m 1009 738 l 783 0 l 658 0 l 501 567 l 345 0 l 222 0 l 0 738 l 130 738 l 284 174 l 432 737 l 576 738 l 721 173 l 881 737 l 1009 738 "
    },
    $: {
        x_min: 0,
        x_max: 700,
        ha: 793,
        o: "m 664 717 l 542 717 q 490 825 531 785 q 381 872 450 865 l 381 551 q 620 446 540 522 q 700 241 700 370 q 618 45 700 116 q 381 -25 536 -25 l 381 -152 l 307 -152 l 307 -25 q 81 62 162 -25 q 0 297 0 149 l 124 297 q 169 146 124 204 q 307 81 215 89 l 307 441 q 80 536 148 469 q 13 725 13 603 q 96 910 13 839 q 307 982 180 982 l 307 1077 l 381 1077 l 381 982 q 574 917 494 982 q 664 717 664 845 m 307 565 l 307 872 q 187 831 233 872 q 142 724 142 791 q 180 618 142 656 q 307 565 218 580 m 381 76 q 562 237 562 96 q 517 361 562 313 q 381 423 472 409 l 381 76 "
    },
    "\\": {
        x_min: -0.015625,
        x_max: 425.0625,
        ha: 522,
        o: "m 425 -129 l 337 -129 l 0 1041 l 83 1041 l 425 -129 "
    },
    "\xb5": {
        x_min: 0,
        x_max: 697.21875,
        ha: 747,
        o: "m 697 -4 q 629 -14 658 -14 q 498 97 513 -14 q 422 9 470 41 q 313 -23 374 -23 q 207 4 258 -23 q 119 81 156 32 l 119 -278 l 0 -278 l 0 738 l 124 738 l 124 343 q 165 173 124 246 q 308 83 216 83 q 452 178 402 83 q 493 359 493 255 l 493 738 l 617 738 l 617 214 q 623 136 617 160 q 673 92 637 92 q 697 96 684 92 l 697 -4 "
    },
    "\u0399": {
        x_min: 42,
        x_max: 181,
        ha: 297,
        o: "m 181 0 l 42 0 l 42 1013 l 181 1013 l 181 0 "
    },
    "\u038E": {
        x_min: 0,
        x_max: 1144.5,
        ha: 1214,
        o: "m 1144 1012 l 807 416 l 807 0 l 667 0 l 667 416 l 325 1012 l 465 1012 l 736 533 l 1004 1012 l 1144 1012 m 277 1040 l 83 799 l 0 799 l 140 1040 l 277 1040 "
    },
    "\u2019": {
        x_min: 0,
        x_max: 139,
        ha: 236,
        o: "m 139 851 q 102 737 139 784 q 0 669 65 690 l 0 734 q 59 787 42 741 q 72 873 72 821 l 0 873 l 0 1013 l 139 1013 l 139 851 "
    },
    "\u039D": {
        x_min: 0,
        x_max: 801,
        ha: 915,
        o: "m 801 0 l 651 0 l 131 822 l 131 0 l 0 0 l 0 1013 l 151 1013 l 670 191 l 670 1013 l 801 1013 l 801 0 "
    },
    "-": {
        x_min: 8.71875,
        x_max: 350.390625,
        ha: 478,
        o: "m 350 317 l 8 317 l 8 428 l 350 428 l 350 317 "
    },
    Q: {
        x_min: 0,
        x_max: 968,
        ha: 1072,
        o: "m 954 5 l 887 -79 l 744 35 q 622 -11 687 2 q 483 -26 556 -26 q 127 130 262 -26 q 0 504 0 279 q 127 880 0 728 q 484 1041 262 1041 q 841 884 708 1041 q 968 507 968 735 q 933 293 968 398 q 832 104 899 188 l 954 5 m 723 191 q 802 330 777 248 q 828 499 828 412 q 744 790 828 673 q 483 922 650 922 q 228 791 322 922 q 142 505 142 673 q 227 221 142 337 q 487 91 323 91 q 632 123 566 91 l 520 215 l 587 301 l 723 191 "
    },
    "\u03C2": {
        x_min: 1,
        x_max: 676.28125,
        ha: 740,
        o: "m 676 460 l 551 460 q 498 595 542 546 q 365 651 448 651 q 199 578 263 651 q 136 401 136 505 q 266 178 136 241 q 508 106 387 142 q 640 -50 640 62 q 625 -158 640 -105 q 583 -278 611 -211 l 465 -278 q 498 -182 490 -211 q 515 -80 515 -126 q 381 12 515 -15 q 134 91 197 51 q 1 388 1 179 q 100 651 1 542 q 354 761 199 761 q 587 680 498 761 q 676 460 676 599 "
    },
    M: {
        x_min: 0,
        x_max: 954,
        ha: 1067,
        o: "m 954 0 l 819 0 l 819 869 l 537 0 l 405 0 l 128 866 l 128 0 l 0 0 l 0 1013 l 200 1013 l 472 160 l 757 1013 l 954 1013 l 954 0 "
    },
    "\u03A8": {
        x_min: 0,
        x_max: 1006,
        ha: 1094,
        o: "m 1006 678 q 914 319 1006 429 q 571 200 814 200 l 571 0 l 433 0 l 433 200 q 92 319 194 200 q 0 678 0 429 l 0 1013 l 139 1013 l 139 679 q 191 417 139 492 q 433 326 255 326 l 433 1013 l 571 1013 l 571 326 l 580 326 q 813 423 747 326 q 868 679 868 502 l 868 1013 l 1006 1013 l 1006 678 "
    },
    C: {
        x_min: 0,
        x_max: 886,
        ha: 944,
        o: "m 886 379 q 760 87 886 201 q 455 -26 634 -26 q 112 136 236 -26 q 0 509 0 283 q 118 882 0 737 q 469 1041 245 1041 q 748 955 630 1041 q 879 708 879 859 l 745 708 q 649 862 724 805 q 473 920 573 920 q 219 791 312 920 q 136 509 136 675 q 217 229 136 344 q 470 99 311 99 q 672 179 591 99 q 753 379 753 259 l 886 379 "
    },
    "!": {
        x_min: 0,
        x_max: 138,
        ha: 236,
        o: "m 138 684 q 116 409 138 629 q 105 244 105 299 l 33 244 q 16 465 33 313 q 0 684 0 616 l 0 1013 l 138 1013 l 138 684 m 138 0 l 0 0 l 0 151 l 138 151 l 138 0 "
    },
    "{": {
        x_min: 0,
        x_max: 480.5625,
        ha: 578,
        o: "m 480 -286 q 237 -213 303 -286 q 187 -45 187 -159 q 194 48 187 -15 q 201 141 201 112 q 164 264 201 225 q 0 314 118 314 l 0 417 q 164 471 119 417 q 201 605 201 514 q 199 665 201 644 q 193 772 193 769 q 241 941 193 887 q 480 1015 308 1015 l 480 915 q 336 866 375 915 q 306 742 306 828 q 310 662 306 717 q 314 577 314 606 q 288 452 314 500 q 176 365 256 391 q 289 275 257 337 q 314 143 314 226 q 313 84 314 107 q 310 -11 310 -5 q 339 -131 310 -94 q 480 -182 377 -182 l 480 -286 "
    },
    X: {
        x_min: -0.015625,
        x_max: 854.15625,
        ha: 940,
        o: "m 854 0 l 683 0 l 423 409 l 166 0 l 0 0 l 347 519 l 18 1013 l 186 1013 l 428 637 l 675 1013 l 836 1013 l 504 520 l 854 0 "
    },
    "#": {
        x_min: 0,
        x_max: 963.890625,
        ha: 1061,
        o: "m 963 690 l 927 590 l 719 590 l 655 410 l 876 410 l 840 310 l 618 310 l 508 -3 l 393 -2 l 506 309 l 329 310 l 215 -2 l 102 -3 l 212 310 l 0 310 l 36 410 l 248 409 l 312 590 l 86 590 l 120 690 l 347 690 l 459 1006 l 573 1006 l 462 690 l 640 690 l 751 1006 l 865 1006 l 754 690 l 963 690 m 606 590 l 425 590 l 362 410 l 543 410 l 606 590 "
    },
    "\u03B9": {
        x_min: 42,
        x_max: 284,
        ha: 361,
        o: "m 284 3 q 233 -10 258 -5 q 182 -15 207 -15 q 85 26 119 -15 q 42 200 42 79 l 42 738 l 167 738 l 168 215 q 172 141 168 157 q 226 101 183 101 q 248 103 239 101 q 284 112 257 104 l 284 3 "
    },
    "\u0386": {
        x_min: 0,
        x_max: 906.953125,
        ha: 982,
        o: "m 283 1040 l 88 799 l 5 799 l 145 1040 l 283 1040 m 906 0 l 756 0 l 650 303 l 251 303 l 143 0 l 0 0 l 376 1012 l 529 1012 l 906 0 m 609 421 l 452 866 l 293 421 l 609 421 "
    },
    ")": {
        x_min: 0,
        x_max: 318,
        ha: 415,
        o: "m 318 365 q 257 25 318 191 q 87 -290 197 -141 l 0 -290 q 140 21 93 -128 q 193 360 193 189 q 141 704 193 537 q 0 1024 97 850 l 87 1024 q 257 706 197 871 q 318 365 318 542 "
    },
    "\u03B5": {
        x_min: 0,
        x_max: 634.71875,
        ha: 714,
        o: "m 634 234 q 527 38 634 110 q 300 -25 433 -25 q 98 29 183 -25 q 0 204 0 93 q 37 314 0 265 q 128 390 67 353 q 56 460 82 419 q 26 555 26 505 q 114 712 26 654 q 295 763 191 763 q 499 700 416 763 q 589 515 589 631 l 478 515 q 419 618 464 580 q 307 657 374 657 q 207 630 253 657 q 151 547 151 598 q 238 445 151 469 q 389 434 280 434 l 389 331 l 349 331 q 206 315 255 331 q 125 210 125 287 q 183 107 125 145 q 302 76 233 76 q 436 117 379 76 q 509 234 493 159 l 634 234 "
    },
    "\u0394": {
        x_min: 0,
        x_max: 952.78125,
        ha: 1028,
        o: "m 952 0 l 0 0 l 400 1013 l 551 1013 l 952 0 m 762 124 l 476 867 l 187 124 l 762 124 "
    },
    "}": {
        x_min: 0,
        x_max: 481,
        ha: 578,
        o: "m 481 314 q 318 262 364 314 q 282 136 282 222 q 284 65 282 97 q 293 -58 293 -48 q 241 -217 293 -166 q 0 -286 174 -286 l 0 -182 q 143 -130 105 -182 q 171 -2 171 -93 q 168 81 171 22 q 165 144 165 140 q 188 275 165 229 q 306 365 220 339 q 191 455 224 391 q 165 588 165 505 q 168 681 165 624 q 171 742 171 737 q 141 865 171 827 q 0 915 102 915 l 0 1015 q 243 942 176 1015 q 293 773 293 888 q 287 675 293 741 q 282 590 282 608 q 318 466 282 505 q 481 417 364 417 l 481 314 "
    },
    "\u2030": {
        x_min: -3,
        x_max: 1672,
        ha: 1821,
        o: "m 846 0 q 664 76 732 0 q 603 244 603 145 q 662 412 603 344 q 846 489 729 489 q 1027 412 959 489 q 1089 244 1089 343 q 1029 76 1089 144 q 846 0 962 0 m 845 103 q 945 143 910 103 q 981 243 981 184 q 947 340 981 301 q 845 385 910 385 q 745 342 782 385 q 709 243 709 300 q 742 147 709 186 q 845 103 781 103 m 888 986 l 284 -25 l 199 -25 l 803 986 l 888 986 m 241 468 q 58 545 126 468 q -3 715 -3 615 q 56 881 -3 813 q 238 958 124 958 q 421 881 353 958 q 483 712 483 813 q 423 544 483 612 q 241 468 356 468 m 241 855 q 137 811 175 855 q 100 710 100 768 q 136 612 100 653 q 240 572 172 572 q 344 614 306 572 q 382 713 382 656 q 347 810 382 771 q 241 855 308 855 m 1428 0 q 1246 76 1314 0 q 1185 244 1185 145 q 1244 412 1185 344 q 1428 489 1311 489 q 1610 412 1542 489 q 1672 244 1672 343 q 1612 76 1672 144 q 1428 0 1545 0 m 1427 103 q 1528 143 1492 103 q 1564 243 1564 184 q 1530 340 1564 301 q 1427 385 1492 385 q 1327 342 1364 385 q 1291 243 1291 300 q 1324 147 1291 186 q 1427 103 1363 103 "
    },
    a: {
        x_min: 0,
        x_max: 698.609375,
        ha: 794,
        o: "m 698 0 q 661 -12 679 -7 q 615 -17 643 -17 q 536 12 564 -17 q 500 96 508 41 q 384 6 456 37 q 236 -25 312 -25 q 65 31 130 -25 q 0 194 0 88 q 118 390 0 334 q 328 435 180 420 q 488 483 476 451 q 495 523 495 504 q 442 619 495 584 q 325 654 389 654 q 209 617 257 654 q 152 513 161 580 l 33 513 q 123 705 33 633 q 332 772 207 772 q 528 712 448 772 q 617 531 617 645 l 617 163 q 624 108 617 126 q 664 90 632 90 l 698 94 l 698 0 m 491 262 l 491 372 q 272 329 350 347 q 128 201 128 294 q 166 113 128 144 q 264 83 205 83 q 414 130 346 83 q 491 262 491 183 "
    },
    "\u2014": {
        x_min: 0,
        x_max: 941.671875,
        ha: 1039,
        o: "m 941 334 l 0 334 l 0 410 l 941 410 l 941 334 "
    },
    "=": {
        x_min: 8.71875,
        x_max: 780.953125,
        ha: 792,
        o: "m 780 510 l 8 510 l 8 606 l 780 606 l 780 510 m 780 235 l 8 235 l 8 332 l 780 332 l 780 235 "
    },
    N: {
        x_min: 0,
        x_max: 801,
        ha: 914,
        o: "m 801 0 l 651 0 l 131 823 l 131 0 l 0 0 l 0 1013 l 151 1013 l 670 193 l 670 1013 l 801 1013 l 801 0 "
    },
    "\u03C1": {
        x_min: 0,
        x_max: 712,
        ha: 797,
        o: "m 712 369 q 620 94 712 207 q 362 -26 521 -26 q 230 2 292 -26 q 119 83 167 30 l 119 -278 l 0 -278 l 0 362 q 91 643 0 531 q 355 764 190 764 q 617 647 517 764 q 712 369 712 536 m 583 366 q 530 559 583 480 q 359 651 469 651 q 190 562 252 651 q 135 370 135 483 q 189 176 135 257 q 359 85 250 85 q 528 175 466 85 q 583 366 583 254 "
    },
    "\xaf": {
        x_min: 0,
        x_max: 941.671875,
        ha: 938,
        o: "m 941 1033 l 0 1033 l 0 1109 l 941 1109 l 941 1033 "
    },
    Z: {
        x_min: 0,
        x_max: 779,
        ha: 849,
        o: "m 779 0 l 0 0 l 0 113 l 621 896 l 40 896 l 40 1013 l 779 1013 l 778 887 l 171 124 l 779 124 l 779 0 "
    },
    u: {
        x_min: 0,
        x_max: 617,
        ha: 729,
        o: "m 617 0 l 499 0 l 499 110 q 391 10 460 45 q 246 -25 322 -25 q 61 58 127 -25 q 0 258 0 136 l 0 738 l 125 738 l 125 284 q 156 148 125 202 q 273 82 197 82 q 433 165 369 82 q 493 340 493 243 l 493 738 l 617 738 l 617 0 "
    },
    k: {
        x_min: 0,
        x_max: 612.484375,
        ha: 697,
        o: "m 612 738 l 338 465 l 608 0 l 469 0 l 251 382 l 121 251 l 121 0 l 0 0 l 0 1013 l 121 1013 l 121 402 l 456 738 l 612 738 "
    },
    "\u0397": {
        x_min: 0,
        x_max: 803,
        ha: 917,
        o: "m 803 0 l 667 0 l 667 475 l 140 475 l 140 0 l 0 0 l 0 1013 l 140 1013 l 140 599 l 667 599 l 667 1013 l 803 1013 l 803 0 "
    },
    "\u0391": {
        x_min: 0,
        x_max: 906.953125,
        ha: 985,
        o: "m 906 0 l 756 0 l 650 303 l 251 303 l 143 0 l 0 0 l 376 1013 l 529 1013 l 906 0 m 609 421 l 452 866 l 293 421 l 609 421 "
    },
    s: {
        x_min: 0,
        x_max: 604,
        ha: 697,
        o: "m 604 217 q 501 36 604 104 q 292 -23 411 -23 q 86 43 166 -23 q 0 238 0 114 l 121 237 q 175 122 121 164 q 300 85 223 85 q 415 112 363 85 q 479 207 479 147 q 361 309 479 276 q 140 372 141 370 q 21 544 21 426 q 111 708 21 647 q 298 761 190 761 q 492 705 413 761 q 583 531 583 643 l 462 531 q 412 625 462 594 q 298 657 363 657 q 199 636 242 657 q 143 558 143 608 q 262 454 143 486 q 484 394 479 397 q 604 217 604 341 "
    },
    B: {
        x_min: 0,
        x_max: 778,
        ha: 876,
        o: "m 580 546 q 724 469 670 535 q 778 311 778 403 q 673 83 778 171 q 432 0 575 0 l 0 0 l 0 1013 l 411 1013 q 629 957 541 1013 q 732 768 732 892 q 691 633 732 693 q 580 546 650 572 m 393 899 l 139 899 l 139 588 l 379 588 q 521 624 462 588 q 592 744 592 667 q 531 859 592 819 q 393 899 471 899 m 419 124 q 566 169 504 124 q 635 303 635 219 q 559 436 635 389 q 402 477 494 477 l 139 477 l 139 124 l 419 124 "
    },
    "\u2026": {
        x_min: 0,
        x_max: 614,
        ha: 708,
        o: "m 142 0 l 0 0 l 0 151 l 142 151 l 142 0 m 378 0 l 236 0 l 236 151 l 378 151 l 378 0 m 614 0 l 472 0 l 472 151 l 614 151 l 614 0 "
    },
    "?": {
        x_min: 0,
        x_max: 607,
        ha: 704,
        o: "m 607 777 q 543 599 607 674 q 422 474 482 537 q 357 272 357 391 l 236 272 q 297 487 236 395 q 411 619 298 490 q 474 762 474 691 q 422 885 474 838 q 301 933 371 933 q 179 880 228 933 q 124 706 124 819 l 0 706 q 94 963 0 872 q 302 1044 177 1044 q 511 973 423 1044 q 607 777 607 895 m 370 0 l 230 0 l 230 151 l 370 151 l 370 0 "
    },
    H: {
        x_min: 0,
        x_max: 803,
        ha: 915,
        o: "m 803 0 l 667 0 l 667 475 l 140 475 l 140 0 l 0 0 l 0 1013 l 140 1013 l 140 599 l 667 599 l 667 1013 l 803 1013 l 803 0 "
    },
    "\u03BD": {
        x_min: 0,
        x_max: 675,
        ha: 761,
        o: "m 675 738 l 404 0 l 272 0 l 0 738 l 133 738 l 340 147 l 541 738 l 675 738 "
    },
    c: {
        x_min: 1,
        x_max: 701.390625,
        ha: 775,
        o: "m 701 264 q 584 53 681 133 q 353 -26 487 -26 q 91 91 188 -26 q 1 370 1 201 q 92 645 1 537 q 353 761 190 761 q 572 688 479 761 q 690 493 666 615 l 556 493 q 487 606 545 562 q 356 650 428 650 q 186 563 246 650 q 134 372 134 487 q 188 179 134 258 q 359 88 250 88 q 492 136 437 88 q 566 264 548 185 l 701 264 "
    },
    "\xb6": {
        x_min: 0,
        x_max: 566.671875,
        ha: 678,
        o: "m 21 892 l 52 892 l 98 761 l 145 892 l 176 892 l 178 741 l 157 741 l 157 867 l 108 741 l 88 741 l 40 871 l 40 741 l 21 741 l 21 892 m 308 854 l 308 731 q 252 691 308 691 q 227 691 240 691 q 207 696 213 695 l 207 712 l 253 706 q 288 733 288 706 l 288 763 q 244 741 279 741 q 193 797 193 741 q 261 860 193 860 q 287 860 273 860 q 308 854 302 855 m 288 842 l 263 843 q 213 796 213 843 q 248 756 213 756 q 288 796 288 756 l 288 842 m 566 988 l 502 988 l 502 -1 l 439 -1 l 439 988 l 317 988 l 317 -1 l 252 -1 l 252 602 q 81 653 155 602 q 0 805 0 711 q 101 989 0 918 q 309 1053 194 1053 l 566 1053 l 566 988 "
    },
    "\u03B2": {
        x_min: 0,
        x_max: 660,
        ha: 745,
        o: "m 471 550 q 610 450 561 522 q 660 280 660 378 q 578 64 660 151 q 367 -22 497 -22 q 239 5 299 -22 q 126 82 178 32 l 126 -278 l 0 -278 l 0 593 q 54 903 0 801 q 318 1042 127 1042 q 519 964 436 1042 q 603 771 603 887 q 567 644 603 701 q 471 550 532 586 m 337 79 q 476 138 418 79 q 535 279 535 198 q 427 437 535 386 q 226 477 344 477 l 226 583 q 398 620 329 583 q 486 762 486 668 q 435 884 486 833 q 312 935 384 935 q 169 861 219 935 q 126 698 126 797 l 126 362 q 170 169 126 242 q 337 79 224 79 "
    },
    "\u039C": {
        x_min: 0,
        x_max: 954,
        ha: 1068,
        o: "m 954 0 l 819 0 l 819 868 l 537 0 l 405 0 l 128 865 l 128 0 l 0 0 l 0 1013 l 199 1013 l 472 158 l 758 1013 l 954 1013 l 954 0 "
    },
    "\u038C": {
        x_min: 0.109375,
        x_max: 1120,
        ha: 1217,
        o: "m 1120 505 q 994 132 1120 282 q 642 -29 861 -29 q 290 130 422 -29 q 167 505 167 280 q 294 883 167 730 q 650 1046 430 1046 q 999 882 868 1046 q 1120 505 1120 730 m 977 504 q 896 784 977 669 q 644 915 804 915 q 391 785 484 915 q 307 504 307 669 q 391 224 307 339 q 644 95 486 95 q 894 224 803 95 q 977 504 977 339 m 277 1040 l 83 799 l 0 799 l 140 1040 l 277 1040 "
    },
    "\u0389": {
        x_min: 0,
        x_max: 1158,
        ha: 1275,
        o: "m 1158 0 l 1022 0 l 1022 475 l 496 475 l 496 0 l 356 0 l 356 1012 l 496 1012 l 496 599 l 1022 599 l 1022 1012 l 1158 1012 l 1158 0 m 277 1040 l 83 799 l 0 799 l 140 1040 l 277 1040 "
    },
    "\u2022": {
        x_min: 0,
        x_max: 663.890625,
        ha: 775,
        o: "m 663 529 q 566 293 663 391 q 331 196 469 196 q 97 294 194 196 q 0 529 0 393 q 96 763 0 665 q 331 861 193 861 q 566 763 469 861 q 663 529 663 665 "
    },
    "\xa5": {
        x_min: 0.1875,
        x_max: 819.546875,
        ha: 886,
        o: "m 563 561 l 697 561 l 696 487 l 520 487 l 482 416 l 482 380 l 697 380 l 695 308 l 482 308 l 482 0 l 342 0 l 342 308 l 125 308 l 125 380 l 342 380 l 342 417 l 303 487 l 125 487 l 125 561 l 258 561 l 0 1013 l 140 1013 l 411 533 l 679 1013 l 819 1013 l 563 561 "
    },
    "(": {
        x_min: 0,
        x_max: 318.0625,
        ha: 415,
        o: "m 318 -290 l 230 -290 q 61 23 122 -142 q 0 365 0 190 q 62 712 0 540 q 230 1024 119 869 l 318 1024 q 175 705 219 853 q 125 360 125 542 q 176 22 125 187 q 318 -290 223 -127 "
    },
    U: {
        x_min: 0,
        x_max: 796,
        ha: 904,
        o: "m 796 393 q 681 93 796 212 q 386 -25 566 -25 q 101 95 208 -25 q 0 393 0 211 l 0 1013 l 138 1013 l 138 391 q 204 191 138 270 q 394 107 276 107 q 586 191 512 107 q 656 391 656 270 l 656 1013 l 796 1013 l 796 393 "
    },
    "\u03B3": {
        x_min: 0.5,
        x_max: 744.953125,
        ha: 822,
        o: "m 744 737 l 463 54 l 463 -278 l 338 -278 l 338 54 l 154 495 q 104 597 124 569 q 13 651 67 651 l 0 651 l 0 751 l 39 753 q 168 711 121 753 q 242 594 207 676 l 403 208 l 617 737 l 744 737 "
    },
    "\u03B1": {
        x_min: 0,
        x_max: 765.5625,
        ha: 809,
        o: "m 765 -4 q 698 -14 726 -14 q 564 97 586 -14 q 466 7 525 40 q 337 -26 407 -26 q 88 98 186 -26 q 0 369 0 212 q 88 637 0 525 q 337 760 184 760 q 465 728 407 760 q 563 637 524 696 l 563 739 l 685 739 l 685 222 q 693 141 685 168 q 748 94 708 94 q 765 96 760 94 l 765 -4 m 584 371 q 531 562 584 485 q 360 653 470 653 q 192 566 254 653 q 135 379 135 489 q 186 181 135 261 q 358 84 247 84 q 528 176 465 84 q 584 371 584 260 "
    },
    F: {
        x_min: 0,
        x_max: 683.328125,
        ha: 717,
        o: "m 683 888 l 140 888 l 140 583 l 613 583 l 613 458 l 140 458 l 140 0 l 0 0 l 0 1013 l 683 1013 l 683 888 "
    },
    "\xad": {
        x_min: 0,
        x_max: 705.5625,
        ha: 803,
        o: "m 705 334 l 0 334 l 0 410 l 705 410 l 705 334 "
    },
    ":": {
        x_min: 0,
        x_max: 142,
        ha: 239,
        o: "m 142 585 l 0 585 l 0 738 l 142 738 l 142 585 m 142 0 l 0 0 l 0 151 l 142 151 l 142 0 "
    },
    "\u03A7": {
        x_min: 0,
        x_max: 854.171875,
        ha: 935,
        o: "m 854 0 l 683 0 l 423 409 l 166 0 l 0 0 l 347 519 l 18 1013 l 186 1013 l 427 637 l 675 1013 l 836 1013 l 504 521 l 854 0 "
    },
    "*": {
        x_min: 116,
        x_max: 674,
        ha: 792,
        o: "m 674 768 l 475 713 l 610 544 l 517 477 l 394 652 l 272 478 l 178 544 l 314 713 l 116 766 l 153 876 l 341 812 l 342 1013 l 446 1013 l 446 811 l 635 874 l 674 768 "
    },
    "\u2020": {
        x_min: 0,
        x_max: 777,
        ha: 835,
        o: "m 458 804 l 777 804 l 777 683 l 458 683 l 458 0 l 319 0 l 319 681 l 0 683 l 0 804 l 319 804 l 319 1015 l 458 1013 l 458 804 "
    },
    "\xb0": {
        x_min: 0,
        x_max: 347,
        ha: 444,
        o: "m 173 802 q 43 856 91 802 q 0 977 0 905 q 45 1101 0 1049 q 173 1153 90 1153 q 303 1098 255 1153 q 347 977 347 1049 q 303 856 347 905 q 173 802 256 802 m 173 884 q 238 910 214 884 q 262 973 262 937 q 239 1038 262 1012 q 173 1064 217 1064 q 108 1037 132 1064 q 85 973 85 1010 q 108 910 85 937 q 173 884 132 884 "
    },
    V: {
        x_min: 0,
        x_max: 862.71875,
        ha: 940,
        o: "m 862 1013 l 505 0 l 361 0 l 0 1013 l 143 1013 l 434 165 l 718 1012 l 862 1013 "
    },
    "\u039E": {
        x_min: 0,
        x_max: 734.71875,
        ha: 763,
        o: "m 723 889 l 9 889 l 9 1013 l 723 1013 l 723 889 m 673 463 l 61 463 l 61 589 l 673 589 l 673 463 m 734 0 l 0 0 l 0 124 l 734 124 l 734 0 "
    },
    "\xa0": {
        x_min: 0,
        x_max: 0,
        ha: 853
    },
    "\u03AB": {
        x_min: 0.328125,
        x_max: 819.515625,
        ha: 889,
        o: "m 588 1046 l 460 1046 l 460 1189 l 588 1189 l 588 1046 m 360 1046 l 232 1046 l 232 1189 l 360 1189 l 360 1046 m 819 1012 l 482 416 l 482 0 l 342 0 l 342 416 l 0 1012 l 140 1012 l 411 533 l 679 1012 l 819 1012 "
    },
    "\u201D": {
        x_min: 0,
        x_max: 347,
        ha: 454,
        o: "m 139 851 q 102 737 139 784 q 0 669 65 690 l 0 734 q 59 787 42 741 q 72 873 72 821 l 0 873 l 0 1013 l 139 1013 l 139 851 m 347 851 q 310 737 347 784 q 208 669 273 690 l 208 734 q 267 787 250 741 q 280 873 280 821 l 208 873 l 208 1013 l 347 1013 l 347 851 "
    },
    "@": {
        x_min: 0,
        x_max: 1260,
        ha: 1357,
        o: "m 1098 -45 q 877 -160 1001 -117 q 633 -203 752 -203 q 155 -29 327 -203 q 0 360 0 127 q 176 802 0 616 q 687 1008 372 1008 q 1123 854 969 1008 q 1260 517 1260 718 q 1155 216 1260 341 q 868 82 1044 82 q 772 106 801 82 q 737 202 737 135 q 647 113 700 144 q 527 82 594 82 q 367 147 420 82 q 314 312 314 212 q 401 565 314 452 q 639 690 498 690 q 810 588 760 690 l 849 668 l 938 668 q 877 441 900 532 q 833 226 833 268 q 853 182 833 198 q 902 167 873 167 q 1088 272 1012 167 q 1159 512 1159 372 q 1051 793 1159 681 q 687 925 925 925 q 248 747 415 925 q 97 361 97 586 q 226 26 97 159 q 627 -122 370 -122 q 856 -87 737 -122 q 1061 8 976 -53 l 1098 -45 m 786 488 q 738 580 777 545 q 643 615 700 615 q 483 517 548 615 q 425 322 425 430 q 457 203 425 250 q 552 156 490 156 q 722 273 665 156 q 786 488 738 309 "
    },
    "\u038A": {
        x_min: 0,
        x_max: 499,
        ha: 613,
        o: "m 277 1040 l 83 799 l 0 799 l 140 1040 l 277 1040 m 499 0 l 360 0 l 360 1012 l 499 1012 l 499 0 "
    },
    i: {
        x_min: 14,
        x_max: 136,
        ha: 275,
        o: "m 136 873 l 14 873 l 14 1013 l 136 1013 l 136 873 m 136 0 l 14 0 l 14 737 l 136 737 l 136 0 "
    },
    "\u0392": {
        x_min: 0,
        x_max: 778,
        ha: 877,
        o: "m 580 545 q 724 468 671 534 q 778 310 778 402 q 673 83 778 170 q 432 0 575 0 l 0 0 l 0 1013 l 411 1013 q 629 957 541 1013 q 732 768 732 891 q 691 632 732 692 q 580 545 650 571 m 393 899 l 139 899 l 139 587 l 379 587 q 521 623 462 587 q 592 744 592 666 q 531 859 592 819 q 393 899 471 899 m 419 124 q 566 169 504 124 q 635 302 635 219 q 559 435 635 388 q 402 476 494 476 l 139 476 l 139 124 l 419 124 "
    },
    "\u03C5": {
        x_min: 0,
        x_max: 617,
        ha: 725,
        o: "m 617 352 q 540 94 617 199 q 308 -24 455 -24 q 76 94 161 -24 q 0 352 0 199 l 0 739 l 126 739 l 126 355 q 169 185 126 257 q 312 98 220 98 q 451 185 402 98 q 492 355 492 257 l 492 739 l 617 739 l 617 352 "
    },
    "]": {
        x_min: 0,
        x_max: 275,
        ha: 372,
        o: "m 275 -281 l 0 -281 l 0 -187 l 151 -187 l 151 920 l 0 920 l 0 1013 l 275 1013 l 275 -281 "
    },
    m: {
        x_min: 0,
        x_max: 1019,
        ha: 1128,
        o: "m 1019 0 l 897 0 l 897 454 q 860 591 897 536 q 739 660 816 660 q 613 586 659 660 q 573 436 573 522 l 573 0 l 447 0 l 447 455 q 412 591 447 535 q 294 657 372 657 q 165 586 213 657 q 122 437 122 521 l 122 0 l 0 0 l 0 738 l 117 738 l 117 640 q 202 730 150 697 q 316 763 254 763 q 437 730 381 763 q 525 642 494 697 q 621 731 559 700 q 753 763 682 763 q 943 694 867 763 q 1019 512 1019 625 l 1019 0 "
    },
    "\u03C7": {
        x_min: 8.328125,
        x_max: 780.5625,
        ha: 815,
        o: "m 780 -278 q 715 -294 747 -294 q 616 -257 663 -294 q 548 -175 576 -227 l 379 133 l 143 -277 l 9 -277 l 313 254 l 163 522 q 127 586 131 580 q 36 640 91 640 q 8 637 27 640 l 8 752 l 52 757 q 162 719 113 757 q 236 627 200 690 l 383 372 l 594 737 l 726 737 l 448 250 l 625 -69 q 670 -153 647 -110 q 743 -188 695 -188 q 780 -184 759 -188 l 780 -278 "
    },
    "\u03AF": {
        x_min: 42,
        x_max: 326.71875,
        ha: 361,
        o: "m 284 3 q 233 -10 258 -5 q 182 -15 207 -15 q 85 26 119 -15 q 42 200 42 79 l 42 737 l 167 737 l 168 215 q 172 141 168 157 q 226 101 183 101 q 248 102 239 101 q 284 112 257 104 l 284 3 m 326 1040 l 137 819 l 54 819 l 189 1040 l 326 1040 "
    },
    "\u0396": {
        x_min: 0,
        x_max: 779.171875,
        ha: 850,
        o: "m 779 0 l 0 0 l 0 113 l 620 896 l 40 896 l 40 1013 l 779 1013 l 779 887 l 170 124 l 779 124 l 779 0 "
    },
    R: {
        x_min: 0,
        x_max: 781.953125,
        ha: 907,
        o: "m 781 0 l 623 0 q 587 242 590 52 q 407 433 585 433 l 138 433 l 138 0 l 0 0 l 0 1013 l 396 1013 q 636 946 539 1013 q 749 731 749 868 q 711 597 749 659 q 608 502 674 534 q 718 370 696 474 q 729 207 722 352 q 781 26 736 62 l 781 0 m 373 551 q 533 594 465 551 q 614 731 614 645 q 532 859 614 815 q 373 896 465 896 l 138 896 l 138 551 l 373 551 "
    },
    o: {
        x_min: 0,
        x_max: 713,
        ha: 821,
        o: "m 357 -25 q 94 91 194 -25 q 0 368 0 202 q 93 642 0 533 q 357 761 193 761 q 618 644 518 761 q 713 368 713 533 q 619 91 713 201 q 357 -25 521 -25 m 357 85 q 528 175 465 85 q 584 369 584 255 q 529 562 584 484 q 357 651 467 651 q 189 560 250 651 q 135 369 135 481 q 187 177 135 257 q 357 85 250 85 "
    },
    K: {
        x_min: 0,
        x_max: 819.46875,
        ha: 906,
        o: "m 819 0 l 649 0 l 294 509 l 139 355 l 139 0 l 0 0 l 0 1013 l 139 1013 l 139 526 l 626 1013 l 809 1013 l 395 600 l 819 0 "
    },
    ",": {
        x_min: 0,
        x_max: 142,
        ha: 239,
        o: "m 142 -12 q 105 -132 142 -82 q 0 -205 68 -182 l 0 -138 q 57 -82 40 -124 q 70 0 70 -51 l 0 0 l 0 151 l 142 151 l 142 -12 "
    },
    d: {
        x_min: 0,
        x_max: 683,
        ha: 796,
        o: "m 683 0 l 564 0 l 564 93 q 456 6 516 38 q 327 -25 395 -25 q 87 100 181 -25 q 0 365 0 215 q 90 639 0 525 q 343 763 187 763 q 564 647 486 763 l 564 1013 l 683 1013 l 683 0 m 582 373 q 529 562 582 484 q 361 653 468 653 q 190 561 253 653 q 135 365 135 479 q 189 175 135 254 q 358 85 251 85 q 529 178 468 85 q 582 373 582 258 "
    },
    "\xa8": {
        x_min: -109,
        x_max: 247,
        ha: 232,
        o: "m 247 1046 l 119 1046 l 119 1189 l 247 1189 l 247 1046 m 19 1046 l -109 1046 l -109 1189 l 19 1189 l 19 1046 "
    },
    E: {
        x_min: 0,
        x_max: 736.109375,
        ha: 789,
        o: "m 736 0 l 0 0 l 0 1013 l 725 1013 l 725 889 l 139 889 l 139 585 l 677 585 l 677 467 l 139 467 l 139 125 l 736 125 l 736 0 "
    },
    Y: {
        x_min: 0,
        x_max: 820,
        ha: 886,
        o: "m 820 1013 l 482 416 l 482 0 l 342 0 l 342 416 l 0 1013 l 140 1013 l 411 534 l 679 1012 l 820 1013 "
    },
    "\"": {
        x_min: 0,
        x_max: 299,
        ha: 396,
        o: "m 299 606 l 203 606 l 203 988 l 299 988 l 299 606 m 96 606 l 0 606 l 0 988 l 96 988 l 96 606 "
    },
    "\u2039": {
        x_min: 17.984375,
        x_max: 773.609375,
        ha: 792,
        o: "m 773 40 l 18 376 l 17 465 l 773 799 l 773 692 l 159 420 l 773 149 l 773 40 "
    },
    "\u201E": {
        x_min: 0,
        x_max: 364,
        ha: 467,
        o: "m 141 -12 q 104 -132 141 -82 q 0 -205 67 -182 l 0 -138 q 56 -82 40 -124 q 69 0 69 -51 l 0 0 l 0 151 l 141 151 l 141 -12 m 364 -12 q 327 -132 364 -82 q 222 -205 290 -182 l 222 -138 q 279 -82 262 -124 q 292 0 292 -51 l 222 0 l 222 151 l 364 151 l 364 -12 "
    },
    "\u03B4": {
        x_min: 1,
        x_max: 710,
        ha: 810,
        o: "m 710 360 q 616 87 710 196 q 356 -28 518 -28 q 99 82 197 -28 q 1 356 1 192 q 100 606 1 509 q 355 703 199 703 q 180 829 288 754 q 70 903 124 866 l 70 1012 l 643 1012 l 643 901 l 258 901 q 462 763 422 794 q 636 592 577 677 q 710 360 710 485 m 584 365 q 552 501 584 447 q 451 602 521 555 q 372 611 411 611 q 197 541 258 611 q 136 355 136 472 q 190 171 136 245 q 358 85 252 85 q 528 173 465 85 q 584 365 584 252 "
    },
    "\u03AD": {
        x_min: 0,
        x_max: 634.71875,
        ha: 714,
        o: "m 634 234 q 527 38 634 110 q 300 -25 433 -25 q 98 29 183 -25 q 0 204 0 93 q 37 313 0 265 q 128 390 67 352 q 56 459 82 419 q 26 555 26 505 q 114 712 26 654 q 295 763 191 763 q 499 700 416 763 q 589 515 589 631 l 478 515 q 419 618 464 580 q 307 657 374 657 q 207 630 253 657 q 151 547 151 598 q 238 445 151 469 q 389 434 280 434 l 389 331 l 349 331 q 206 315 255 331 q 125 210 125 287 q 183 107 125 145 q 302 76 233 76 q 436 117 379 76 q 509 234 493 159 l 634 234 m 520 1040 l 331 819 l 248 819 l 383 1040 l 520 1040 "
    },
    "\u03C9": {
        x_min: 0,
        x_max: 922,
        ha: 1031,
        o: "m 922 339 q 856 97 922 203 q 650 -26 780 -26 q 538 9 587 -26 q 461 103 489 44 q 387 12 436 46 q 277 -22 339 -22 q 69 97 147 -22 q 0 339 0 203 q 45 551 0 444 q 161 738 84 643 l 302 738 q 175 553 219 647 q 124 336 124 446 q 155 179 124 249 q 275 88 197 88 q 375 163 341 88 q 400 294 400 219 l 400 572 l 524 572 l 524 294 q 561 135 524 192 q 643 88 591 88 q 762 182 719 88 q 797 342 797 257 q 745 556 797 450 q 619 738 705 638 l 760 738 q 874 551 835 640 q 922 339 922 444 "
    },
    "\xb4": {
        x_min: 0,
        x_max: 96,
        ha: 251,
        o: "m 96 606 l 0 606 l 0 988 l 96 988 l 96 606 "
    },
    "\xb1": {
        x_min: 11,
        x_max: 781,
        ha: 792,
        o: "m 781 490 l 446 490 l 446 255 l 349 255 l 349 490 l 11 490 l 11 586 l 349 586 l 349 819 l 446 819 l 446 586 l 781 586 l 781 490 m 781 21 l 11 21 l 11 115 l 781 115 l 781 21 "
    },
    "|": {
        x_min: 343,
        x_max: 449,
        ha: 792,
        o: "m 449 462 l 343 462 l 343 986 l 449 986 l 449 462 m 449 -242 l 343 -242 l 343 280 l 449 280 l 449 -242 "
    },
    "\u03CB": {
        x_min: 0,
        x_max: 617,
        ha: 725,
        o: "m 482 800 l 372 800 l 372 925 l 482 925 l 482 800 m 239 800 l 129 800 l 129 925 l 239 925 l 239 800 m 617 352 q 540 93 617 199 q 308 -24 455 -24 q 76 93 161 -24 q 0 352 0 199 l 0 738 l 126 738 l 126 354 q 169 185 126 257 q 312 98 220 98 q 451 185 402 98 q 492 354 492 257 l 492 738 l 617 738 l 617 352 "
    },
    "\xa7": {
        x_min: 0,
        x_max: 593,
        ha: 690,
        o: "m 593 425 q 554 312 593 369 q 467 233 516 254 q 537 83 537 172 q 459 -74 537 -12 q 288 -133 387 -133 q 115 -69 184 -133 q 47 96 47 -6 l 166 96 q 199 7 166 40 q 288 -26 232 -26 q 371 -5 332 -26 q 420 60 420 21 q 311 201 420 139 q 108 309 210 255 q 0 490 0 383 q 33 602 0 551 q 124 687 66 654 q 75 743 93 712 q 58 812 58 773 q 133 984 58 920 q 300 1043 201 1043 q 458 987 394 1043 q 529 814 529 925 l 411 814 q 370 908 404 877 q 289 939 336 939 q 213 911 246 939 q 180 841 180 883 q 286 720 180 779 q 484 612 480 615 q 593 425 593 534 m 467 409 q 355 544 467 473 q 196 630 228 612 q 146 587 162 609 q 124 525 124 558 q 239 387 124 462 q 398 298 369 315 q 448 345 429 316 q 467 409 467 375 "
    },
    b: {
        x_min: 0,
        x_max: 685,
        ha: 783,
        o: "m 685 372 q 597 99 685 213 q 347 -25 501 -25 q 219 5 277 -25 q 121 93 161 36 l 121 0 l 0 0 l 0 1013 l 121 1013 l 121 634 q 214 723 157 692 q 341 754 272 754 q 591 637 493 754 q 685 372 685 526 m 554 356 q 499 550 554 470 q 328 644 437 644 q 162 556 223 644 q 108 369 108 478 q 160 176 108 256 q 330 83 221 83 q 498 169 435 83 q 554 356 554 245 "
    },
    q: {
        x_min: 0,
        x_max: 683,
        ha: 876,
        o: "m 683 -278 l 564 -278 l 564 97 q 474 8 533 39 q 345 -23 415 -23 q 91 93 188 -23 q 0 364 0 203 q 87 635 0 522 q 337 760 184 760 q 466 727 408 760 q 564 637 523 695 l 564 737 l 683 737 l 683 -278 m 582 375 q 527 564 582 488 q 358 652 466 652 q 190 565 253 652 q 135 377 135 488 q 189 179 135 261 q 361 84 251 84 q 530 179 469 84 q 582 375 582 260 "
    },
    "\u03A9": {
        x_min: -0.171875,
        x_max: 969.5625,
        ha: 1068,
        o: "m 969 0 l 555 0 l 555 123 q 744 308 675 194 q 814 558 814 423 q 726 812 814 709 q 484 922 633 922 q 244 820 334 922 q 154 567 154 719 q 223 316 154 433 q 412 123 292 199 l 412 0 l 0 0 l 0 124 l 217 124 q 68 327 122 210 q 15 572 15 444 q 144 911 15 781 q 484 1041 274 1041 q 822 909 691 1041 q 953 569 953 777 q 899 326 953 443 q 750 124 846 210 l 969 124 l 969 0 "
    },
    "\u03CD": {
        x_min: 0,
        x_max: 617,
        ha: 725,
        o: "m 617 352 q 540 93 617 199 q 308 -24 455 -24 q 76 93 161 -24 q 0 352 0 199 l 0 738 l 126 738 l 126 354 q 169 185 126 257 q 312 98 220 98 q 451 185 402 98 q 492 354 492 257 l 492 738 l 617 738 l 617 352 m 535 1040 l 346 819 l 262 819 l 397 1040 l 535 1040 "
    },
    z: {
        x_min: -0.015625,
        x_max: 613.890625,
        ha: 697,
        o: "m 613 0 l 0 0 l 0 100 l 433 630 l 20 630 l 20 738 l 594 738 l 593 636 l 163 110 l 613 110 l 613 0 "
    },
    "\u2122": {
        x_min: 0,
        x_max: 894,
        ha: 1000,
        o: "m 389 951 l 229 951 l 229 503 l 160 503 l 160 951 l 0 951 l 0 1011 l 389 1011 l 389 951 m 894 503 l 827 503 l 827 939 l 685 503 l 620 503 l 481 937 l 481 503 l 417 503 l 417 1011 l 517 1011 l 653 580 l 796 1010 l 894 1011 l 894 503 "
    },
    "\u03AE": {
        x_min: 0.78125,
        x_max: 697,
        ha: 810,
        o: "m 697 -278 l 572 -278 l 572 454 q 540 587 572 536 q 425 650 501 650 q 271 579 337 650 q 206 420 206 509 l 206 0 l 81 0 l 81 489 q 73 588 81 562 q 0 644 56 644 l 0 741 q 68 755 38 755 q 158 721 124 755 q 200 630 193 687 q 297 726 234 692 q 434 761 359 761 q 620 692 544 761 q 697 516 697 624 l 697 -278 m 479 1040 l 290 819 l 207 819 l 341 1040 l 479 1040 "
    },
    "\u0398": {
        x_min: 0,
        x_max: 960,
        ha: 1056,
        o: "m 960 507 q 833 129 960 280 q 476 -32 698 -32 q 123 129 255 -32 q 0 507 0 280 q 123 883 0 732 q 476 1045 255 1045 q 832 883 696 1045 q 960 507 960 732 m 817 500 q 733 789 817 669 q 476 924 639 924 q 223 792 317 924 q 142 507 142 675 q 222 222 142 339 q 476 89 315 89 q 730 218 636 89 q 817 500 817 334 m 716 449 l 243 449 l 243 571 l 716 571 l 716 449 "
    },
    "\xae": {
        x_min: -3,
        x_max: 1008,
        ha: 1106,
        o: "m 503 532 q 614 562 566 532 q 672 658 672 598 q 614 747 672 716 q 503 772 569 772 l 338 772 l 338 532 l 503 532 m 502 -7 q 123 151 263 -7 q -3 501 -3 294 q 123 851 -3 706 q 502 1011 263 1011 q 881 851 739 1011 q 1008 501 1008 708 q 883 151 1008 292 q 502 -7 744 -7 m 502 60 q 830 197 709 60 q 940 501 940 322 q 831 805 940 681 q 502 944 709 944 q 174 805 296 944 q 65 501 65 680 q 173 197 65 320 q 502 60 294 60 m 788 146 l 678 146 q 653 316 655 183 q 527 449 652 449 l 338 449 l 338 146 l 241 146 l 241 854 l 518 854 q 688 808 621 854 q 766 658 766 755 q 739 563 766 607 q 668 497 713 519 q 751 331 747 472 q 788 164 756 190 l 788 146 "
    },
    "~": {
        x_min: 0,
        x_max: 833,
        ha: 931,
        o: "m 833 958 q 778 753 833 831 q 594 665 716 665 q 402 761 502 665 q 240 857 302 857 q 131 795 166 857 q 104 665 104 745 l 0 665 q 54 867 0 789 q 237 958 116 958 q 429 861 331 958 q 594 765 527 765 q 704 827 670 765 q 729 958 729 874 l 833 958 "
    },
    "\u0395": {
        x_min: 0,
        x_max: 736.21875,
        ha: 778,
        o: "m 736 0 l 0 0 l 0 1013 l 725 1013 l 725 889 l 139 889 l 139 585 l 677 585 l 677 467 l 139 467 l 139 125 l 736 125 l 736 0 "
    },
    "\xb3": {
        x_min: 0,
        x_max: 450,
        ha: 547,
        o: "m 450 552 q 379 413 450 464 q 220 366 313 366 q 69 414 130 366 q 0 567 0 470 l 85 567 q 126 470 85 504 q 225 437 168 437 q 320 467 280 437 q 360 552 360 498 q 318 632 360 608 q 213 657 276 657 q 195 657 203 657 q 176 657 181 657 l 176 722 q 279 733 249 722 q 334 815 334 752 q 300 881 334 856 q 220 907 267 907 q 133 875 169 907 q 97 781 97 844 l 15 781 q 78 926 15 875 q 220 972 135 972 q 364 930 303 972 q 426 817 426 888 q 344 697 426 733 q 421 642 392 681 q 450 552 450 603 "
    },
    "[": {
        x_min: 0,
        x_max: 273.609375,
        ha: 371,
        o: "m 273 -281 l 0 -281 l 0 1013 l 273 1013 l 273 920 l 124 920 l 124 -187 l 273 -187 l 273 -281 "
    },
    L: {
        x_min: 0,
        x_max: 645.828125,
        ha: 696,
        o: "m 645 0 l 0 0 l 0 1013 l 140 1013 l 140 126 l 645 126 l 645 0 "
    },
    "\u03C3": {
        x_min: 0,
        x_max: 803.390625,
        ha: 894,
        o: "m 803 628 l 633 628 q 713 368 713 512 q 618 93 713 204 q 357 -25 518 -25 q 94 91 194 -25 q 0 368 0 201 q 94 644 0 533 q 356 761 194 761 q 481 750 398 761 q 608 739 564 739 l 803 739 l 803 628 m 360 85 q 529 180 467 85 q 584 374 584 262 q 527 566 584 490 q 352 651 463 651 q 187 559 247 651 q 135 368 135 478 q 189 175 135 254 q 360 85 251 85 "
    },
    "\u03B6": {
        x_min: 0,
        x_max: 573,
        ha: 642,
        o: "m 573 -40 q 553 -162 573 -97 q 510 -278 543 -193 l 400 -278 q 441 -187 428 -219 q 462 -90 462 -132 q 378 -14 462 -14 q 108 45 197 -14 q 0 290 0 117 q 108 631 0 462 q 353 901 194 767 l 55 901 l 55 1012 l 561 1012 l 561 924 q 261 669 382 831 q 128 301 128 489 q 243 117 128 149 q 458 98 350 108 q 573 -40 573 80 "
    },
    "\u03B8": {
        x_min: 0,
        x_max: 674,
        ha: 778,
        o: "m 674 496 q 601 160 674 304 q 336 -26 508 -26 q 73 153 165 -26 q 0 485 0 296 q 72 840 0 683 q 343 1045 166 1045 q 605 844 516 1045 q 674 496 674 692 m 546 579 q 498 798 546 691 q 336 935 437 935 q 178 798 237 935 q 126 579 137 701 l 546 579 m 546 475 l 126 475 q 170 233 126 348 q 338 80 230 80 q 504 233 447 80 q 546 475 546 346 "
    },
    "\u039F": {
        x_min: 0,
        x_max: 958,
        ha: 1054,
        o: "m 485 1042 q 834 883 703 1042 q 958 511 958 735 q 834 136 958 287 q 481 -26 701 -26 q 126 130 261 -26 q 0 504 0 279 q 127 880 0 729 q 485 1042 263 1042 m 480 98 q 731 225 638 98 q 815 504 815 340 q 733 783 815 670 q 480 913 640 913 q 226 785 321 913 q 142 504 142 671 q 226 224 142 339 q 480 98 319 98 "
    },
    "\u0393": {
        x_min: 0,
        x_max: 705.28125,
        ha: 749,
        o: "m 705 886 l 140 886 l 140 0 l 0 0 l 0 1012 l 705 1012 l 705 886 "
    },
    " ": {
        x_min: 0,
        x_max: 0,
        ha: 375
    },
    "%": {
        x_min: -3,
        x_max: 1089,
        ha: 1186,
        o: "m 845 0 q 663 76 731 0 q 602 244 602 145 q 661 412 602 344 q 845 489 728 489 q 1027 412 959 489 q 1089 244 1089 343 q 1029 76 1089 144 q 845 0 962 0 m 844 103 q 945 143 909 103 q 981 243 981 184 q 947 340 981 301 q 844 385 909 385 q 744 342 781 385 q 708 243 708 300 q 741 147 708 186 q 844 103 780 103 m 888 986 l 284 -25 l 199 -25 l 803 986 l 888 986 m 241 468 q 58 545 126 468 q -3 715 -3 615 q 56 881 -3 813 q 238 958 124 958 q 421 881 353 958 q 483 712 483 813 q 423 544 483 612 q 241 468 356 468 m 241 855 q 137 811 175 855 q 100 710 100 768 q 136 612 100 653 q 240 572 172 572 q 344 614 306 572 q 382 713 382 656 q 347 810 382 771 q 241 855 308 855 "
    },
    P: {
        x_min: 0,
        x_max: 726,
        ha: 806,
        o: "m 424 1013 q 640 931 555 1013 q 726 719 726 850 q 637 506 726 587 q 413 426 548 426 l 140 426 l 140 0 l 0 0 l 0 1013 l 424 1013 m 379 889 l 140 889 l 140 548 l 372 548 q 522 589 459 548 q 593 720 593 637 q 528 845 593 801 q 379 889 463 889 "
    },
    "\u0388": {
        x_min: 0,
        x_max: 1078.21875,
        ha: 1118,
        o: "m 1078 0 l 342 0 l 342 1013 l 1067 1013 l 1067 889 l 481 889 l 481 585 l 1019 585 l 1019 467 l 481 467 l 481 125 l 1078 125 l 1078 0 m 277 1040 l 83 799 l 0 799 l 140 1040 l 277 1040 "
    },
    "\u038F": {
        x_min: 0.125,
        x_max: 1136.546875,
        ha: 1235,
        o: "m 1136 0 l 722 0 l 722 123 q 911 309 842 194 q 981 558 981 423 q 893 813 981 710 q 651 923 800 923 q 411 821 501 923 q 321 568 321 720 q 390 316 321 433 q 579 123 459 200 l 579 0 l 166 0 l 166 124 l 384 124 q 235 327 289 210 q 182 572 182 444 q 311 912 182 782 q 651 1042 441 1042 q 989 910 858 1042 q 1120 569 1120 778 q 1066 326 1120 443 q 917 124 1013 210 l 1136 124 l 1136 0 m 277 1040 l 83 800 l 0 800 l 140 1041 l 277 1040 "
    },
    _: {
        x_min: 0,
        x_max: 705.5625,
        ha: 803,
        o: "m 705 -334 l 0 -334 l 0 -234 l 705 -234 l 705 -334 "
    },
    "\u03AA": {
        x_min: -110,
        x_max: 246,
        ha: 275,
        o: "m 246 1046 l 118 1046 l 118 1189 l 246 1189 l 246 1046 m 18 1046 l -110 1046 l -110 1189 l 18 1189 l 18 1046 m 136 0 l 0 0 l 0 1012 l 136 1012 l 136 0 "
    },
    "+": {
        x_min: 23,
        x_max: 768,
        ha: 792,
        o: "m 768 372 l 444 372 l 444 0 l 347 0 l 347 372 l 23 372 l 23 468 l 347 468 l 347 840 l 444 840 l 444 468 l 768 468 l 768 372 "
    },
    "\xbd": {
        x_min: 0,
        x_max: 1050,
        ha: 1149,
        o: "m 1050 0 l 625 0 q 712 178 625 108 q 878 277 722 187 q 967 385 967 328 q 932 456 967 429 q 850 484 897 484 q 759 450 798 484 q 721 352 721 416 l 640 352 q 706 502 640 448 q 851 551 766 551 q 987 509 931 551 q 1050 385 1050 462 q 976 251 1050 301 q 829 179 902 215 q 717 68 740 133 l 1050 68 l 1050 0 m 834 985 l 215 -28 l 130 -28 l 750 984 l 834 985 m 224 422 l 142 422 l 142 811 l 0 811 l 0 867 q 104 889 62 867 q 164 973 157 916 l 224 973 l 224 422 "
    },
    "\u03A1": {
        x_min: 0,
        x_max: 720,
        ha: 783,
        o: "m 424 1013 q 637 933 554 1013 q 720 723 720 853 q 633 508 720 591 q 413 426 546 426 l 140 426 l 140 0 l 0 0 l 0 1013 l 424 1013 m 378 889 l 140 889 l 140 548 l 371 548 q 521 589 458 548 q 592 720 592 637 q 527 845 592 801 q 378 889 463 889 "
    },
    "'": {
        x_min: 0,
        x_max: 139,
        ha: 236,
        o: "m 139 851 q 102 737 139 784 q 0 669 65 690 l 0 734 q 59 787 42 741 q 72 873 72 821 l 0 873 l 0 1013 l 139 1013 l 139 851 "
    },
    "\xaa": {
        x_min: 0,
        x_max: 350,
        ha: 397,
        o: "m 350 625 q 307 616 328 616 q 266 631 281 616 q 247 673 251 645 q 190 628 225 644 q 116 613 156 613 q 32 641 64 613 q 0 722 0 669 q 72 826 0 800 q 247 866 159 846 l 247 887 q 220 934 247 916 q 162 953 194 953 q 104 934 129 953 q 76 882 80 915 l 16 882 q 60 976 16 941 q 166 1011 104 1011 q 266 979 224 1011 q 308 891 308 948 l 308 706 q 311 679 308 688 q 331 670 315 670 l 350 672 l 350 625 m 247 757 l 247 811 q 136 790 175 798 q 64 726 64 773 q 83 682 64 697 q 132 667 103 667 q 207 690 174 667 q 247 757 247 718 "
    },
    "\u0385": {
        x_min: 0,
        x_max: 450,
        ha: 553,
        o: "m 450 800 l 340 800 l 340 925 l 450 925 l 450 800 m 406 1040 l 212 800 l 129 800 l 269 1040 l 406 1040 m 110 800 l 0 800 l 0 925 l 110 925 l 110 800 "
    },
    T: {
        x_min: 0,
        x_max: 777,
        ha: 835,
        o: "m 777 894 l 458 894 l 458 0 l 319 0 l 319 894 l 0 894 l 0 1013 l 777 1013 l 777 894 "
    },
    "\u03A6": {
        x_min: 0,
        x_max: 915,
        ha: 997,
        o: "m 527 0 l 389 0 l 389 122 q 110 231 220 122 q 0 509 0 340 q 110 785 0 677 q 389 893 220 893 l 389 1013 l 527 1013 l 527 893 q 804 786 693 893 q 915 509 915 679 q 805 231 915 341 q 527 122 696 122 l 527 0 m 527 226 q 712 310 641 226 q 779 507 779 389 q 712 705 779 627 q 527 787 641 787 l 527 226 m 389 226 l 389 787 q 205 698 275 775 q 136 505 136 620 q 206 308 136 391 q 389 226 276 226 "
    },
    "\u204B": {
        x_min: 0,
        x_max: 0,
        ha: 694
    },
    j: {
        x_min: -77.78125,
        x_max: 167,
        ha: 349,
        o: "m 167 871 l 42 871 l 42 1013 l 167 1013 l 167 871 m 167 -80 q 121 -231 167 -184 q -26 -278 76 -278 l -77 -278 l -77 -164 l -41 -164 q 26 -143 11 -164 q 42 -65 42 -122 l 42 737 l 167 737 l 167 -80 "
    },
    "\u03A3": {
        x_min: 0,
        x_max: 756.953125,
        ha: 819,
        o: "m 756 0 l 0 0 l 0 107 l 395 523 l 22 904 l 22 1013 l 745 1013 l 745 889 l 209 889 l 566 523 l 187 125 l 756 125 l 756 0 "
    },
    "\u203A": {
        x_min: 18.0625,
        x_max: 774,
        ha: 792,
        o: "m 774 376 l 18 40 l 18 149 l 631 421 l 18 692 l 18 799 l 774 465 l 774 376 "
    },
    "<": {
        x_min: 17.984375,
        x_max: 773.609375,
        ha: 792,
        o: "m 773 40 l 18 376 l 17 465 l 773 799 l 773 692 l 159 420 l 773 149 l 773 40 "
    },
    "\xa3": {
        x_min: 0,
        x_max: 704.484375,
        ha: 801,
        o: "m 704 41 q 623 -10 664 5 q 543 -26 583 -26 q 359 15 501 -26 q 243 36 288 36 q 158 23 197 36 q 73 -21 119 10 l 6 76 q 125 195 90 150 q 175 331 175 262 q 147 443 175 383 l 0 443 l 0 512 l 108 512 q 43 734 43 623 q 120 929 43 854 q 358 1010 204 1010 q 579 936 487 1010 q 678 729 678 857 l 678 684 l 552 684 q 504 838 552 780 q 362 896 457 896 q 216 852 263 896 q 176 747 176 815 q 199 627 176 697 q 248 512 217 574 l 468 512 l 468 443 l 279 443 q 297 356 297 398 q 230 194 297 279 q 153 107 211 170 q 227 133 190 125 q 293 142 264 142 q 410 119 339 142 q 516 96 482 96 q 579 105 550 96 q 648 142 608 115 l 704 41 "
    },
    t: {
        x_min: 0,
        x_max: 367,
        ha: 458,
        o: "m 367 0 q 312 -5 339 -2 q 262 -8 284 -8 q 145 28 183 -8 q 108 143 108 64 l 108 638 l 0 638 l 0 738 l 108 738 l 108 944 l 232 944 l 232 738 l 367 738 l 367 638 l 232 638 l 232 185 q 248 121 232 140 q 307 102 264 102 q 345 104 330 102 q 367 107 360 107 l 367 0 "
    },
    "\xac": {
        x_min: 0,
        x_max: 706,
        ha: 803,
        o: "m 706 411 l 706 158 l 630 158 l 630 335 l 0 335 l 0 411 l 706 411 "
    },
    "\u03BB": {
        x_min: 0,
        x_max: 750,
        ha: 803,
        o: "m 750 -7 q 679 -15 716 -15 q 538 59 591 -15 q 466 214 512 97 l 336 551 l 126 0 l 0 0 l 270 705 q 223 837 247 770 q 116 899 190 899 q 90 898 100 899 l 90 1004 q 152 1011 125 1011 q 298 938 244 1011 q 373 783 326 901 l 605 192 q 649 115 629 136 q 716 95 669 95 l 736 95 q 750 97 745 97 l 750 -7 "
    },
    W: {
        x_min: 0,
        x_max: 1263.890625,
        ha: 1351,
        o: "m 1263 1013 l 995 0 l 859 0 l 627 837 l 405 0 l 265 0 l 0 1013 l 136 1013 l 342 202 l 556 1013 l 701 1013 l 921 207 l 1133 1012 l 1263 1013 "
    },
    ">": {
        x_min: 18.0625,
        x_max: 774,
        ha: 792,
        o: "m 774 376 l 18 40 l 18 149 l 631 421 l 18 692 l 18 799 l 774 465 l 774 376 "
    },
    v: {
        x_min: 0,
        x_max: 675.15625,
        ha: 761,
        o: "m 675 738 l 404 0 l 272 0 l 0 738 l 133 737 l 340 147 l 541 737 l 675 738 "
    },
    "\u03C4": {
        x_min: 0.28125,
        x_max: 644.5,
        ha: 703,
        o: "m 644 628 l 382 628 l 382 179 q 388 120 382 137 q 436 91 401 91 q 474 94 447 91 q 504 97 501 97 l 504 0 q 454 -9 482 -5 q 401 -14 426 -14 q 278 67 308 -14 q 260 233 260 118 l 260 628 l 0 628 l 0 739 l 644 739 l 644 628 "
    },
    "\u03BE": {
        x_min: 0,
        x_max: 624.9375,
        ha: 699,
        o: "m 624 -37 q 608 -153 624 -96 q 563 -278 593 -211 l 454 -278 q 491 -183 486 -200 q 511 -83 511 -126 q 484 -23 511 -44 q 370 1 452 1 q 323 0 354 1 q 283 -1 293 -1 q 84 76 169 -1 q 0 266 0 154 q 56 431 0 358 q 197 538 108 498 q 94 613 134 562 q 54 730 54 665 q 77 823 54 780 q 143 901 101 867 l 27 901 l 27 1012 l 576 1012 l 576 901 l 380 901 q 244 863 303 901 q 178 745 178 820 q 312 600 178 636 q 532 582 380 582 l 532 479 q 276 455 361 479 q 118 281 118 410 q 165 173 118 217 q 274 120 208 133 q 494 101 384 110 q 624 -37 624 76 "
    },
    "&": {
        x_min: -3,
        x_max: 894.25,
        ha: 992,
        o: "m 894 0 l 725 0 l 624 123 q 471 0 553 40 q 306 -41 390 -41 q 168 -7 231 -41 q 62 92 105 26 q 14 187 31 139 q -3 276 -3 235 q 55 433 -3 358 q 248 581 114 508 q 170 689 196 640 q 137 817 137 751 q 214 985 137 922 q 384 1041 284 1041 q 548 988 483 1041 q 622 824 622 928 q 563 666 622 739 q 431 556 516 608 l 621 326 q 649 407 639 361 q 663 493 653 426 l 781 493 q 703 229 781 352 l 894 0 m 504 818 q 468 908 504 877 q 384 940 433 940 q 293 907 331 940 q 255 818 255 875 q 289 714 255 767 q 363 628 313 678 q 477 729 446 682 q 504 818 504 771 m 556 209 l 314 499 q 179 395 223 449 q 135 283 135 341 q 146 222 135 253 q 183 158 158 192 q 333 80 241 80 q 556 209 448 80 "
    },
    "\u039B": {
        x_min: 0,
        x_max: 862.5,
        ha: 942,
        o: "m 862 0 l 719 0 l 426 847 l 143 0 l 0 0 l 356 1013 l 501 1013 l 862 0 "
    },
    I: {
        x_min: 41,
        x_max: 180,
        ha: 293,
        o: "m 180 0 l 41 0 l 41 1013 l 180 1013 l 180 0 "
    },
    G: {
        x_min: 0,
        x_max: 921,
        ha: 1011,
        o: "m 921 0 l 832 0 l 801 136 q 655 15 741 58 q 470 -28 568 -28 q 126 133 259 -28 q 0 499 0 284 q 125 881 0 731 q 486 1043 259 1043 q 763 957 647 1043 q 905 709 890 864 l 772 709 q 668 866 747 807 q 486 926 589 926 q 228 795 322 926 q 142 507 142 677 q 228 224 142 342 q 483 94 323 94 q 712 195 625 94 q 796 435 796 291 l 477 435 l 477 549 l 921 549 l 921 0 "
    },
    "\u03B0": {
        x_min: 0,
        x_max: 617,
        ha: 725,
        o: "m 524 800 l 414 800 l 414 925 l 524 925 l 524 800 m 183 800 l 73 800 l 73 925 l 183 925 l 183 800 m 617 352 q 540 93 617 199 q 308 -24 455 -24 q 76 93 161 -24 q 0 352 0 199 l 0 738 l 126 738 l 126 354 q 169 185 126 257 q 312 98 220 98 q 451 185 402 98 q 492 354 492 257 l 492 738 l 617 738 l 617 352 m 489 1040 l 300 819 l 216 819 l 351 1040 l 489 1040 "
    },
    "`": {
        x_min: 0,
        x_max: 138.890625,
        ha: 236,
        o: "m 138 699 l 0 699 l 0 861 q 36 974 0 929 q 138 1041 72 1020 l 138 977 q 82 931 95 969 q 69 839 69 893 l 138 839 l 138 699 "
    },
    "\xb7": {
        x_min: 0,
        x_max: 142,
        ha: 239,
        o: "m 142 585 l 0 585 l 0 738 l 142 738 l 142 585 "
    },
    "\u03A5": {
        x_min: 0.328125,
        x_max: 819.515625,
        ha: 889,
        o: "m 819 1013 l 482 416 l 482 0 l 342 0 l 342 416 l 0 1013 l 140 1013 l 411 533 l 679 1013 l 819 1013 "
    },
    r: {
        x_min: 0,
        x_max: 355.5625,
        ha: 432,
        o: "m 355 621 l 343 621 q 179 569 236 621 q 122 411 122 518 l 122 0 l 0 0 l 0 737 l 117 737 l 117 604 q 204 719 146 686 q 355 753 262 753 l 355 621 "
    },
    x: {
        x_min: 0,
        x_max: 675,
        ha: 764,
        o: "m 675 0 l 525 0 l 331 286 l 144 0 l 0 0 l 256 379 l 12 738 l 157 737 l 336 473 l 516 738 l 661 738 l 412 380 l 675 0 "
    },
    "\u03BC": {
        x_min: 0,
        x_max: 696.609375,
        ha: 747,
        o: "m 696 -4 q 628 -14 657 -14 q 498 97 513 -14 q 422 8 470 41 q 313 -24 374 -24 q 207 3 258 -24 q 120 80 157 31 l 120 -278 l 0 -278 l 0 738 l 124 738 l 124 343 q 165 172 124 246 q 308 82 216 82 q 451 177 402 82 q 492 358 492 254 l 492 738 l 616 738 l 616 214 q 623 136 616 160 q 673 92 636 92 q 696 95 684 92 l 696 -4 "
    },
    h: {
        x_min: 0,
        x_max: 615,
        ha: 724,
        o: "m 615 472 l 615 0 l 490 0 l 490 454 q 456 590 490 535 q 338 654 416 654 q 186 588 251 654 q 122 436 122 522 l 122 0 l 0 0 l 0 1013 l 122 1013 l 122 633 q 218 727 149 694 q 362 760 287 760 q 552 676 484 760 q 615 472 615 600 "
    },
    ".": {
        x_min: 0,
        x_max: 142,
        ha: 239,
        o: "m 142 0 l 0 0 l 0 151 l 142 151 l 142 0 "
    },
    "\u03C6": {
        x_min: -2,
        x_max: 878,
        ha: 974,
        o: "m 496 -279 l 378 -279 l 378 -17 q 101 88 204 -17 q -2 367 -2 194 q 68 626 -2 510 q 283 758 151 758 l 283 646 q 167 537 209 626 q 133 373 133 462 q 192 177 133 254 q 378 93 259 93 l 378 758 q 445 764 426 763 q 476 765 464 765 q 765 659 653 765 q 878 377 878 553 q 771 96 878 209 q 496 -17 665 -17 l 496 -279 m 496 93 l 514 93 q 687 183 623 93 q 746 380 746 265 q 691 569 746 491 q 522 658 629 658 l 496 656 l 496 93 "
    },
    ";": {
        x_min: 0,
        x_max: 142,
        ha: 239,
        o: "m 142 585 l 0 585 l 0 738 l 142 738 l 142 585 m 142 -12 q 105 -132 142 -82 q 0 -206 68 -182 l 0 -138 q 58 -82 43 -123 q 68 0 68 -56 l 0 0 l 0 151 l 142 151 l 142 -12 "
    },
    f: {
        x_min: 0,
        x_max: 378,
        ha: 472,
        o: "m 378 638 l 246 638 l 246 0 l 121 0 l 121 638 l 0 638 l 0 738 l 121 738 q 137 935 121 887 q 290 1028 171 1028 q 320 1027 305 1028 q 378 1021 334 1026 l 378 908 q 323 918 346 918 q 257 870 273 918 q 246 780 246 840 l 246 738 l 378 738 l 378 638 "
    },
    "\u201C": {
        x_min: 1,
        x_max: 348.21875,
        ha: 454,
        o: "m 140 670 l 1 670 l 1 830 q 37 943 1 897 q 140 1011 74 990 l 140 947 q 82 900 97 940 q 68 810 68 861 l 140 810 l 140 670 m 348 670 l 209 670 l 209 830 q 245 943 209 897 q 348 1011 282 990 l 348 947 q 290 900 305 940 q 276 810 276 861 l 348 810 l 348 670 "
    },
    A: {
        x_min: 0.03125,
        x_max: 906.953125,
        ha: 1008,
        o: "m 906 0 l 756 0 l 648 303 l 251 303 l 142 0 l 0 0 l 376 1013 l 529 1013 l 906 0 m 610 421 l 452 867 l 293 421 l 610 421 "
    },
    "\u2018": {
        x_min: 1,
        x_max: 139.890625,
        ha: 236,
        o: "m 139 670 l 1 670 l 1 830 q 37 943 1 897 q 139 1011 74 990 l 139 947 q 82 900 97 940 q 68 810 68 861 l 139 810 l 139 670 "
    },
    "\u03CA": {
        x_min: -70,
        x_max: 283,
        ha: 361,
        o: "m 283 800 l 173 800 l 173 925 l 283 925 l 283 800 m 40 800 l -70 800 l -70 925 l 40 925 l 40 800 m 283 3 q 232 -10 257 -5 q 181 -15 206 -15 q 84 26 118 -15 q 41 200 41 79 l 41 737 l 166 737 l 167 215 q 171 141 167 157 q 225 101 182 101 q 247 103 238 101 q 283 112 256 104 l 283 3 "
    },
    "\u03C0": {
        x_min: -0.21875,
        x_max: 773.21875,
        ha: 857,
        o: "m 773 -7 l 707 -11 q 575 40 607 -11 q 552 174 552 77 l 552 226 l 552 626 l 222 626 l 222 0 l 97 0 l 97 626 l 0 626 l 0 737 l 773 737 l 773 626 l 676 626 l 676 171 q 695 103 676 117 q 773 90 714 90 l 773 -7 "
    },
    "\u03AC": {
        x_min: 0,
        x_max: 765.5625,
        ha: 809,
        o: "m 765 -4 q 698 -14 726 -14 q 564 97 586 -14 q 466 7 525 40 q 337 -26 407 -26 q 88 98 186 -26 q 0 369 0 212 q 88 637 0 525 q 337 760 184 760 q 465 727 407 760 q 563 637 524 695 l 563 738 l 685 738 l 685 222 q 693 141 685 168 q 748 94 708 94 q 765 95 760 94 l 765 -4 m 584 371 q 531 562 584 485 q 360 653 470 653 q 192 566 254 653 q 135 379 135 489 q 186 181 135 261 q 358 84 247 84 q 528 176 465 84 q 584 371 584 260 m 604 1040 l 415 819 l 332 819 l 466 1040 l 604 1040 "
    },
    O: {
        x_min: 0,
        x_max: 958,
        ha: 1057,
        o: "m 485 1041 q 834 882 702 1041 q 958 512 958 734 q 834 136 958 287 q 481 -26 702 -26 q 126 130 261 -26 q 0 504 0 279 q 127 880 0 728 q 485 1041 263 1041 m 480 98 q 731 225 638 98 q 815 504 815 340 q 733 783 815 669 q 480 912 640 912 q 226 784 321 912 q 142 504 142 670 q 226 224 142 339 q 480 98 319 98 "
    },
    n: {
        x_min: 0,
        x_max: 615,
        ha: 724,
        o: "m 615 463 l 615 0 l 490 0 l 490 454 q 453 592 490 537 q 331 656 410 656 q 178 585 240 656 q 117 421 117 514 l 117 0 l 0 0 l 0 738 l 117 738 l 117 630 q 218 728 150 693 q 359 764 286 764 q 552 675 484 764 q 615 463 615 593 "
    },
    l: {
        x_min: 41,
        x_max: 166,
        ha: 279,
        o: "m 166 0 l 41 0 l 41 1013 l 166 1013 l 166 0 "
    },
    "\xa4": {
        x_min: 40.09375,
        x_max: 728.796875,
        ha: 825,
        o: "m 728 304 l 649 224 l 512 363 q 383 331 458 331 q 256 363 310 331 l 119 224 l 40 304 l 177 441 q 150 553 150 493 q 184 673 150 621 l 40 818 l 119 898 l 267 749 q 321 766 291 759 q 384 773 351 773 q 447 766 417 773 q 501 749 477 759 l 649 898 l 728 818 l 585 675 q 612 618 604 648 q 621 553 621 587 q 591 441 621 491 l 728 304 m 384 682 q 280 643 318 682 q 243 551 243 604 q 279 461 243 499 q 383 423 316 423 q 487 461 449 423 q 525 553 525 500 q 490 641 525 605 q 384 682 451 682 "
    },
    "\u03BA": {
        x_min: 0,
        x_max: 632.328125,
        ha: 679,
        o: "m 632 0 l 482 0 l 225 384 l 124 288 l 124 0 l 0 0 l 0 738 l 124 738 l 124 446 l 433 738 l 596 738 l 312 466 l 632 0 "
    },
    p: {
        x_min: 0,
        x_max: 685,
        ha: 786,
        o: "m 685 364 q 598 96 685 205 q 350 -23 504 -23 q 121 89 205 -23 l 121 -278 l 0 -278 l 0 738 l 121 738 l 121 633 q 220 726 159 691 q 351 761 280 761 q 598 636 504 761 q 685 364 685 522 m 557 371 q 501 560 557 481 q 330 651 437 651 q 162 559 223 651 q 108 366 108 479 q 162 177 108 254 q 333 87 224 87 q 502 178 441 87 q 557 371 557 258 "
    },
    "\u2021": {
        x_min: 0,
        x_max: 777,
        ha: 835,
        o: "m 458 238 l 458 0 l 319 0 l 319 238 l 0 238 l 0 360 l 319 360 l 319 681 l 0 683 l 0 804 l 319 804 l 319 1015 l 458 1013 l 458 804 l 777 804 l 777 683 l 458 683 l 458 360 l 777 360 l 777 238 l 458 238 "
    },
    "\u03C8": {
        x_min: 0,
        x_max: 808,
        ha: 907,
        o: "m 465 -278 l 341 -278 l 341 -15 q 87 102 180 -15 q 0 378 0 210 l 0 739 l 133 739 l 133 379 q 182 195 133 275 q 341 98 242 98 l 341 922 l 465 922 l 465 98 q 623 195 563 98 q 675 382 675 278 l 675 742 l 808 742 l 808 381 q 720 104 808 213 q 466 -13 627 -13 l 465 -278 "
    },
    "\u03B7": {
        x_min: 0.78125,
        x_max: 697,
        ha: 810,
        o: "m 697 -278 l 572 -278 l 572 454 q 540 587 572 536 q 425 650 501 650 q 271 579 337 650 q 206 420 206 509 l 206 0 l 81 0 l 81 489 q 73 588 81 562 q 0 644 56 644 l 0 741 q 68 755 38 755 q 158 720 124 755 q 200 630 193 686 q 297 726 234 692 q 434 761 359 761 q 620 692 544 761 q 697 516 697 624 l 697 -278 "
    }
};
var $f12076c7962eab60$var$cssFontWeight = "normal";
var $f12076c7962eab60$var$ascender = 1189;
var $f12076c7962eab60$var$underlinePosition = -100;
var $f12076c7962eab60$var$cssFontStyle = "normal";
var $f12076c7962eab60$var$boundingBox = {
    yMin: -334,
    xMin: -111,
    yMax: 1189,
    xMax: 1672
};
var $f12076c7962eab60$var$resolution = 1000;
var $f12076c7962eab60$var$original_font_information = {
    postscript_name: "Helvetiker-Regular",
    version_string: "Version 1.00 2004 initial release",
    vendor_url: "http://www.magenta.gr/",
    full_font_name: "Helvetiker",
    font_family_name: "Helvetiker",
    copyright: "Copyright (c) \u039Cagenta ltd, 2004",
    description: "",
    trademark: "",
    designer: "",
    designer_url: "",
    unique_font_identifier: "\u039Cagenta ltd:Helvetiker:22-10-104",
    license_url: "http://www.ellak.gr/fonts/MgOpen/license.html",
    license_description: "Copyright (c) 2004 by MAGENTA Ltd. All Rights Reserved.\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy of the fonts accompanying this license (\"Fonts\") and associated documentation files (the \"Font Software\"), to reproduce and distribute the Font Software, including without limitation the rights to use, copy, merge, publish, distribute, and/or sell copies of the Font Software, and to permit persons to whom the Font Software is furnished to do so, subject to the following conditions: \r\n\r\nThe above copyright and this permission notice shall be included in all copies of one or more of the Font Software typefaces.\r\n\r\nThe Font Software may be modified, altered, or added to, and in particular the designs of glyphs or characters in the Fonts may be modified and additional glyphs or characters may be added to the Fonts, only if the fonts are renamed to names not containing the word \"MgOpen\", or if the modifications are accepted for inclusion in the Font Software itself by the each appointed Administrator.\r\n\r\nThis License becomes null and void to the extent applicable to Fonts or Font Software that has been modified and is distributed under the \"MgOpen\" name.\r\n\r\nThe Font Software may be sold as part of a larger software package but no copy of one or more of the Font Software typefaces may be sold by itself. \r\n\r\nTHE FONT SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF COPYRIGHT, PATENT, TRADEMARK, OR OTHER RIGHT. IN NO EVENT SHALL MAGENTA OR PERSONS OR BODIES IN CHARGE OF ADMINISTRATION AND MAINTENANCE OF THE FONT SOFTWARE BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, INCLUDING ANY GENERAL, SPECIAL, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF THE USE OR INABILITY TO USE THE FONT SOFTWARE OR FROM OTHER DEALINGS IN THE FONT SOFTWARE.",
    manufacturer_name: "\u039Cagenta ltd",
    font_sub_family_name: "Regular"
};
var $f12076c7962eab60$var$descender = -334;
var $f12076c7962eab60$var$familyName = "Helvetiker";
var $f12076c7962eab60$var$lineHeight = 1522;
var $f12076c7962eab60$var$underlineThickness = 50;
var $f12076c7962eab60$var$defaultTypeFace = {
    glyphs: $f12076c7962eab60$var$glyphs,
    cssFontWeight: $f12076c7962eab60$var$cssFontWeight,
    ascender: $f12076c7962eab60$var$ascender,
    underlinePosition: $f12076c7962eab60$var$underlinePosition,
    cssFontStyle: $f12076c7962eab60$var$cssFontStyle,
    boundingBox: $f12076c7962eab60$var$boundingBox,
    resolution: $f12076c7962eab60$var$resolution,
    original_font_information: $f12076c7962eab60$var$original_font_information,
    descender: $f12076c7962eab60$var$descender,
    familyName: $f12076c7962eab60$var$familyName,
    lineHeight: $f12076c7962eab60$var$lineHeight,
    underlineThickness: $f12076c7962eab60$var$underlineThickness
};
var $f12076c7962eab60$var$THREE$5 = $f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2({}, window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    CircleGeometry: (0, $8725869b83961a04$export$d5c0e8d607467193),
    DoubleSide: (0, $8725869b83961a04$export$3b296b6f144d5b03),
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $8725869b83961a04$export$5023a9a8114806b8),
    TextGeometry: (0, $a795479bd51c0a0c$export$684b774b4473ba5f),
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
}), {}, {
    Font: (0, $7d168f0c1ba5badf$export$89abf52a030e56ee),
    TextGeometry: (0, $a795479bd51c0a0c$export$684b774b4473ba5f)
});
//
var $f12076c7962eab60$var$LabelsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        labelsData: {
            "default": []
        },
        labelLat: {
            "default": 'lat'
        },
        labelLng: {
            "default": 'lng'
        },
        labelAltitude: {
            "default": 0
        },
        // in units of globe radius
        labelText: {
            "default": 'text'
        },
        labelSize: {
            "default": 0.5
        },
        // text height in deg
        labelTypeFace: {
            "default": $f12076c7962eab60$var$defaultTypeFace,
            onChange: function onChange(tf, state) {
                state.font = new $f12076c7962eab60$var$THREE$5.Font(tf);
            }
        },
        labelColor: {
            "default": function _default() {
                return 'lightgrey';
            }
        },
        labelRotation: {
            "default": 0
        },
        // clockwise degrees, relative to the latitute parallel plane
        labelResolution: {
            "default": 3
        },
        // how many segments in the text's curves
        labelIncludeDot: {
            "default": true
        },
        labelDotRadius: {
            "default": 0.1
        },
        // in deg
        labelDotOrientation: {
            "default": function _default() {
                return 'bottom';
            }
        },
        // right, top, bottom
        labelsTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        } // ms
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state) {
        // Data accessors
        var latAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelLat);
        var lngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelLng);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelAltitude);
        var textAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelText);
        var sizeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelSize);
        var rotationAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelRotation);
        var colorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelColor);
        var includeDotAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelIncludeDot);
        var dotRadiusAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelDotRadius);
        var dotOrientationAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.labelDotOrientation);
        var orientations = new Set([
            'right',
            'top',
            'bottom'
        ]);
        var pxPerDeg = 2 * Math.PI * $f12076c7962eab60$var$GLOBE_RADIUS / 360;
        var circleGeometry = new $f12076c7962eab60$var$THREE$5.CircleGeometry(1, 16);
        $f12076c7962eab60$var$threeDigest(state.labelsData, state.scene, {
            createObj: function createObj() {
                var material = new $f12076c7962eab60$var$THREE$5.MeshLambertMaterial();
                material.side = (0, $8725869b83961a04$export$3b296b6f144d5b03);
                var obj = new $f12076c7962eab60$var$THREE$5.Group(); // container
                obj.add(new $f12076c7962eab60$var$THREE$5.Mesh(circleGeometry, material)); // dot
                obj.add(new $f12076c7962eab60$var$THREE$5.Mesh(undefined, material)); // text
                obj.__globeObjType = 'label'; // Add object type
                return obj;
            },
            updateObj: function updateObj(obj, d) {
                var _obj$children = $f12076c7962eab60$var$_slicedToArray(obj.children, 2), dotObj = _obj$children[0], textObj = _obj$children[1];
                // update color
                var color = colorAccessor(d);
                var opacity = $f12076c7962eab60$var$colorAlpha(color);
                textObj.material.color.set($f12076c7962eab60$var$colorStr2Hex(color));
                textObj.material.transparent = opacity < 1;
                textObj.material.opacity = opacity;
                // update dot
                var includeDot = includeDotAccessor(d);
                var dotOrient = dotOrientationAccessor(d);
                !includeDot || !orientations.has(dotOrient) && (dotOrient = 'bottom');
                // size dot
                var dotR = includeDot ? +dotRadiusAccessor(d) * pxPerDeg : 1e-12;
                dotObj.scale.x = dotObj.scale.y = dotR;
                // create text geometry
                var textHeight = +sizeAccessor(d) * pxPerDeg;
                textObj.geometry && textObj.geometry.dispose();
                textObj.geometry = new $f12076c7962eab60$var$THREE$5.TextGeometry(textAccessor(d), {
                    font: state.font,
                    size: textHeight,
                    depth: 0,
                    height: 0,
                    curveSegments: state.labelResolution
                });
                // center text (otherwise anchor is on bottom-left)
                dotOrient !== 'right' && textObj.geometry.center();
                if (includeDot) {
                    // translate text
                    var padding = dotR + textHeight / 2;
                    dotOrient === 'right' && (textObj.position.x = padding);
                    textObj.position.y = ({
                        right: -textHeight / 2,
                        // center vertically
                        top: padding + textHeight / 2,
                        bottom: -padding - textHeight / 2
                    })[dotOrient];
                }
                // animations
                var applyPosition = function applyPosition(td) {
                    var _obj$__currentTargetD = obj.__currentTargetD = td, lat = _obj$__currentTargetD.lat, lng = _obj$__currentTargetD.lng, alt = _obj$__currentTargetD.alt, rot = _obj$__currentTargetD.rot, scale = _obj$__currentTargetD.scale;
                    // position center
                    Object.assign(obj.position, $f12076c7962eab60$var$polar2Cartesian(lat, lng, alt));
                    // rotate
                    obj.lookAt(state.scene.localToWorld(new $f12076c7962eab60$var$THREE$5.Vector3(0, 0, 0))); // face globe (local) center
                    obj.rotateY(Math.PI); // face outwards
                    // rotate clockwise relative to lat parallel
                    obj.rotateZ(-rot * Math.PI / 180);
                    // scale it
                    obj.scale.x = obj.scale.y = obj.scale.z = scale;
                };
                var targetD = {
                    lat: +latAccessor(d),
                    lng: +lngAccessor(d),
                    alt: +altitudeAccessor(d),
                    rot: +rotationAccessor(d),
                    scale: 1
                };
                var currentTargetD = obj.__currentTargetD || Object.assign({}, targetD, {
                    scale: 1e-12
                });
                if (Object.keys(targetD).some(function(k) {
                    return currentTargetD[k] !== targetD[k];
                })) {
                    if (!state.labelsTransitionDuration || state.labelsTransitionDuration < 0) // set final position
                    applyPosition(targetD);
                    else // animate
                    new $79Zf3.Tween(currentTargetD).to(targetD, state.labelsTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyPosition).start();
                }
            }
        });
    }
});
var $f12076c7962eab60$var$THREE$4 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    BufferGeometry: (0, $8725869b83961a04$export$b7be63a67df8959)
};
var $f12076c7962eab60$var$CircleLineGeometry = /*#__PURE__*/ function(_THREE$BufferGeometry) {
    function CircleLineGeometry() {
        var _this;
        var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var segmentCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
        $f12076c7962eab60$var$_classCallCheck(this, CircleLineGeometry);
        _this = $f12076c7962eab60$var$_callSuper(this, CircleLineGeometry);
        _this.type = 'CircleLineGeometry';
        _this.parameters = {
            radius: radius,
            segmentCount: segmentCount
        };
        var points = [];
        for(var i = 0; i <= segmentCount; i++){
            var theta = (i / segmentCount - 0.25) * Math.PI * 2;
            points.push({
                x: Math.cos(theta) * radius,
                y: Math.sin(theta) * radius,
                z: 0
            });
        }
        _this.setFromPoints(points);
        return _this;
    }
    $f12076c7962eab60$var$_inherits(CircleLineGeometry, _THREE$BufferGeometry);
    return $f12076c7962eab60$var$_createClass(CircleLineGeometry);
}($f12076c7962eab60$var$THREE$4.BufferGeometry);
var $f12076c7962eab60$var$THREE$3 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Color: (0, $8725869b83961a04$export$892596cec99bc70e),
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4),
    Line: (0, $8725869b83961a04$export$17d680238e50603e),
    LineBasicMaterial: (0, $8725869b83961a04$export$fbaaa33907730a0c),
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
};
var $f12076c7962eab60$var$FrameTicker = (0, (/*@__PURE__*/$parcel$interopDefault($f1564f6f90ed2410$exports)))["default"] || (0, (/*@__PURE__*/$parcel$interopDefault($f1564f6f90ed2410$exports)));
var $f12076c7962eab60$var$RingsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        ringsData: {
            "default": []
        },
        ringLat: {
            "default": 'lat'
        },
        ringLng: {
            "default": 'lng'
        },
        ringAltitude: {
            "default": 1.5e-3
        },
        ringColor: {
            "default": function _default() {
                return '#ffffaa';
            },
            triggerUpdate: false
        },
        // single color, array of colors or color interpolation fn
        ringResolution: {
            "default": 64,
            triggerUpdate: false
        },
        // how many slice segments in each circle's circumference
        ringMaxRadius: {
            "default": 2,
            triggerUpdate: false
        },
        // degrees
        ringPropagationSpeed: {
            "default": 1,
            triggerUpdate: false
        },
        // degrees/s
        ringRepeatPeriod: {
            "default": 700,
            triggerUpdate: false
        } // ms
    },
    methods: {
        pauseAnimation: function pauseAnimation(state) {
            var _state$ticker;
            (_state$ticker = state.ticker) === null || _state$ticker === void 0 || _state$ticker.pause();
        },
        resumeAnimation: function resumeAnimation(state) {
            var _state$ticker2;
            (_state$ticker2 = state.ticker) === null || _state$ticker2 === void 0 || _state$ticker2.resume();
        },
        _destructor: function _destructor(state) {
            var _state$ticker3;
            (_state$ticker3 = state.ticker) === null || _state$ticker3 === void 0 || _state$ticker3.dispose();
        }
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
        state.ticker = new $f12076c7962eab60$var$FrameTicker();
        state.ticker.onTick.add(function(time) {
            if (!state.ringsData.length) return;
            // Data accessors
            var colorAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringColor);
            var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringAltitude);
            var maxRadiusAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringMaxRadius);
            var propagationSpeedAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringPropagationSpeed);
            var repeatPeriodAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringRepeatPeriod);
            state.ringsData.filter(function(d) {
                return d.__threeObj;
            }).forEach(function(d) {
                var obj = d.__threeObj;
                if ((obj.__nextRingTime || 0) <= time) {
                    // time to add a new ring
                    var periodSecs = repeatPeriodAccessor(d) / 1000;
                    obj.__nextRingTime = time + (periodSecs <= 0 ? Infinity : periodSecs);
                    var circleObj = new $f12076c7962eab60$var$THREE$3.Line(new $f12076c7962eab60$var$CircleLineGeometry(1, state.ringResolution), new $f12076c7962eab60$var$THREE$3.LineBasicMaterial());
                    var colors = colorAccessor(d);
                    var isMultiColor = colors instanceof Array || colors instanceof Function;
                    var colorInterpolator;
                    if (!isMultiColor) {
                        // set only once
                        circleObj.material.color = new $f12076c7962eab60$var$THREE$3.Color($f12076c7962eab60$var$colorStr2Hex(colors));
                        $f12076c7962eab60$var$setMaterialOpacity(circleObj.material, $f12076c7962eab60$var$colorAlpha(colors));
                    } else if (colors instanceof Array) {
                        colorInterpolator = (0, $050f6c6fd36ea5ca$export$2e2bcd8739ae039)().domain(colors.map(function(_, idx) {
                            return idx / (colors.length - 1);
                        })) // same number of stops as colors
                        .range(colors);
                        circleObj.material.transparent = colors.some(function(c) {
                            return $f12076c7962eab60$var$colorAlpha(c) < 1;
                        });
                    } else {
                        colorInterpolator = colors;
                        circleObj.material.transparent = true;
                    }
                    var curveR = $f12076c7962eab60$var$GLOBE_RADIUS * (1 + altitudeAccessor(d));
                    var maxRadius = maxRadiusAccessor(d); // in degrees
                    var maxAngle = maxRadius * Math.PI / 180; // in radians
                    var propagationSpeed = propagationSpeedAccessor(d);
                    var isReverse = propagationSpeed <= 0;
                    var updateFn = function updateFn(_ref) {
                        var t = _ref.t;
                        var ang = (isReverse ? 1 - t : t) * maxAngle;
                        circleObj.scale.x = circleObj.scale.y = curveR * Math.sin(ang);
                        circleObj.position.z = curveR * (1 - Math.cos(ang));
                        if (isMultiColor) {
                            var color = colorInterpolator(t);
                            circleObj.material.color = new $f12076c7962eab60$var$THREE$3.Color($f12076c7962eab60$var$colorStr2Hex(color));
                            circleObj.material.transparent && (circleObj.material.opacity = $f12076c7962eab60$var$colorAlpha(color));
                        }
                    };
                    if (propagationSpeed === 0) {
                        updateFn({
                            t: 0
                        });
                        obj.add(circleObj);
                    } else {
                        var transitionTime = Math.abs(maxRadius / propagationSpeed) * 1000;
                        new $79Zf3.Tween({
                            t: 0
                        }).to({
                            t: 1
                        }, transitionTime).onUpdate(updateFn).onStart(function() {
                            return obj.add(circleObj);
                        }).onComplete(function() {
                            obj.remove(circleObj);
                            $f12076c7962eab60$var$deallocate(circleObj);
                        }).start();
                    }
                }
            });
        });
    },
    update: function update(state) {
        // Data accessors
        var latAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringLat);
        var lngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringLng);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.ringAltitude);
        var globeCenter = state.scene.localToWorld(new $f12076c7962eab60$var$THREE$3.Vector3(0, 0, 0)); // translate from local to world coords
        $f12076c7962eab60$var$threeDigest(state.ringsData, state.scene, {
            createObj: function createObj() {
                var obj = new $f12076c7962eab60$var$THREE$3.Group();
                obj.__globeObjType = 'ring'; // Add object type
                return obj;
            },
            updateObj: function updateObj(obj, d) {
                var lat = latAccessor(d);
                var lng = lngAccessor(d);
                var alt = altitudeAccessor(d);
                // position & orientate inwards
                Object.assign(obj.position, $f12076c7962eab60$var$polar2Cartesian(lat, lng, alt));
                obj.lookAt(globeCenter);
            }
        }, {
            removeDelay: 30000
        } // wait until all rings are gone
        );
    }
});
var $f12076c7962eab60$var$THREE$2 = $f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2({}, window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {}), {}, {
    CSS2DObject: (0, $5859463f2a625df8$export$936f75e6792bf2dc)
});
//
var $f12076c7962eab60$var$HtmlElementsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        htmlElementsData: {
            "default": []
        },
        htmlLat: {
            "default": 'lat'
        },
        htmlLng: {
            "default": 'lng'
        },
        htmlAltitude: {
            "default": 0
        },
        // in units of globe radius
        htmlElement: {},
        htmlTransitionDuration: {
            "default": 1000,
            triggerUpdate: false
        },
        // ms
        isBehindGlobe: {
            onChange: function onChange() {
                this.updateObjVisibility();
            },
            triggerUpdate: false
        }
    },
    methods: {
        updateObjVisibility: function updateObjVisibility(state, obj) {
            // default to all if no obj specified
            var objs = obj ? [
                obj
            ] : state.htmlElementsData.map(function(d) {
                return d.__threeObj;
            }).filter(function(d) {
                return d;
            });
            // Hide elements on the far side of the globe
            objs.forEach(function(obj) {
                return obj.visible = !state.isBehindGlobe || !state.isBehindGlobe(obj.position);
            });
        }
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state, changedProps) {
        var _this = this;
        // Data accessors
        var latAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.htmlLat);
        var lngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.htmlLng);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.htmlAltitude);
        var elemAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.htmlElement);
        $f12076c7962eab60$var$threeDigest(state.htmlElementsData, state.scene, {
            // objs need to be recreated if this prop has changed
            purge: changedProps.hasOwnProperty('htmlElement'),
            createObj: function createObj(d) {
                var elem = elemAccessor(d);
                var obj = new $f12076c7962eab60$var$THREE$2.CSS2DObject(elem);
                obj.__globeObjType = 'html'; // Add object type
                return obj;
            },
            updateObj: function updateObj(obj, d) {
                var applyUpdate = function applyUpdate(td) {
                    var _obj$__currentTargetD = obj.__currentTargetD = td, alt = _obj$__currentTargetD.alt, lat = _obj$__currentTargetD.lat, lng = _obj$__currentTargetD.lng;
                    Object.assign(obj.position, $f12076c7962eab60$var$polar2Cartesian(lat, lng, alt));
                    _this.updateObjVisibility(obj);
                };
                var targetD = {
                    lat: +latAccessor(d),
                    lng: +lngAccessor(d),
                    alt: +altitudeAccessor(d)
                };
                if (!state.htmlTransitionDuration || state.htmlTransitionDuration < 0 || !obj.__currentTargetD) // set final position
                applyUpdate(targetD);
                else // animate
                new $79Zf3.Tween(obj.__currentTargetD).to(targetD, state.htmlTransitionDuration).easing($79Zf3.Easing.Quadratic.InOut).onUpdate(applyUpdate).start();
            }
        });
    }
});
var $f12076c7962eab60$var$THREE$1 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Euler: (0, $8725869b83961a04$export$d93cc409a0768c5f),
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4),
    Mesh: (0, $8725869b83961a04$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $8725869b83961a04$export$5023a9a8114806b8),
    SphereGeometry: (0, $8725869b83961a04$export$1b417fc3b307a251)
};
//
var $f12076c7962eab60$var$ObjectsLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        objectsData: {
            "default": []
        },
        objectLat: {
            "default": 'lat'
        },
        objectLng: {
            "default": 'lng'
        },
        objectAltitude: {
            "default": 0.01
        },
        // in units of globe radius
        objectFacesSurface: {
            "default": true
        },
        objectRotation: {},
        objectThreeObject: {
            "default": new $f12076c7962eab60$var$THREE$1.Mesh(// default object: yellow sphere
            new $f12076c7962eab60$var$THREE$1.SphereGeometry(1, 16, 8), new $f12076c7962eab60$var$THREE$1.MeshLambertMaterial({
                color: '#ffffaa',
                transparent: true,
                opacity: 0.7
            }))
        }
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state, changedProps) {
        // Data accessors
        var latAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.objectLat);
        var lngAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.objectLng);
        var altitudeAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.objectAltitude);
        var parallelAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.objectFacesSurface);
        var rotationAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.objectRotation);
        var threeObjAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.objectThreeObject);
        $f12076c7962eab60$var$threeDigest(state.objectsData, state.scene, {
            // objs need to be recreated if this prop has changed
            purge: changedProps.hasOwnProperty('objectThreeObject'),
            createObj: function createObj(d) {
                var obj = threeObjAccessor(d);
                if (state.objectThreeObject === obj) // clone object if it's a shared object among all points
                obj = obj.clone();
                var g = new $f12076c7962eab60$var$THREE$1.Group();
                g.add(obj);
                g.__globeObjType = 'object'; // Add object type
                return g;
            },
            updateObj: function updateObj(objG, d) {
                var lat = +latAccessor(d);
                var lng = +lngAccessor(d);
                var alt = +altitudeAccessor(d);
                Object.assign(objG.position, $f12076c7962eab60$var$polar2Cartesian(lat, lng, alt));
                parallelAccessor(d) ? objG.setRotationFromEuler(new (0, $8725869b83961a04$export$d93cc409a0768c5f)($f12076c7962eab60$var$deg2Rad$1(-lat), $f12076c7962eab60$var$deg2Rad$1(lng), 0, 'YXZ')) : objG.rotation.set(0, 0, 0);
                var obj = objG.children[0];
                var rot = rotationAccessor(d);
                rot && obj.setRotationFromEuler(new (0, $8725869b83961a04$export$d93cc409a0768c5f)($f12076c7962eab60$var$deg2Rad$1(rot.x || 0), $f12076c7962eab60$var$deg2Rad$1(rot.y || 0), $f12076c7962eab60$var$deg2Rad$1(rot.z || 0)));
            }
        });
    }
});
//
var $f12076c7962eab60$var$CustomLayerKapsule = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: {
        customLayerData: {
            "default": []
        },
        customThreeObject: {},
        customThreeObjectUpdate: {
            triggerUpdate: false
        }
    },
    init: function init(threeObj, state) {
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
    },
    update: function update(state, changedProps) {
        if (!state.customThreeObjectUpdate) $f12076c7962eab60$var$emptyObject(state.scene);
         // Clear the existing objects to create all new, if there's no update method (brute-force)
        var customObjectAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.customThreeObject);
        var customObjectUpdateAccessor = (0, $e9cd866e7e5aa38e$export$2e2bcd8739ae039)(state.customThreeObjectUpdate);
        $f12076c7962eab60$var$threeDigest(state.customLayerData, state.scene, {
            // objs need to be recreated if this prop has changed
            purge: changedProps.hasOwnProperty('customThreeObject'),
            createObj: function createObj(d) {
                var obj = customObjectAccessor(d, $f12076c7962eab60$var$GLOBE_RADIUS);
                if (obj) {
                    if (state.customThreeObject === obj) // clone object if it's a shared object among all points
                    obj = obj.clone();
                    obj.__globeObjType = 'custom'; // Add object type
                }
                return obj;
            },
            updateObj: function updateObj(obj, d) {
                return customObjectUpdateAccessor(obj, d, $f12076c7962eab60$var$GLOBE_RADIUS);
            }
        });
    }
});
var $f12076c7962eab60$var$THREE = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4),
    Vector2: (0, $8725869b83961a04$export$c977b3e384af9ae1),
    Vector3: (0, $8725869b83961a04$export$64b5c384219d3699)
};
//
var $f12076c7962eab60$var$layers = [
    'globeLayer',
    'pointsLayer',
    'arcsLayer',
    'hexBinLayer',
    'heatmapsLayer',
    'polygonsLayer',
    'hexedPolygonsLayer',
    'pathsLayer',
    'tilesLayer',
    'labelsLayer',
    'ringsLayer',
    'htmlElementsLayer',
    'objectsLayer',
    'customLayer'
];
// Expose config from layers
var $f12076c7962eab60$var$bindGlobeLayer = $f12076c7962eab60$var$linkKapsule('globeLayer', $f12076c7962eab60$var$GlobeLayerKapsule);
var $f12076c7962eab60$var$linkedGlobeLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'globeImageUrl',
    'bumpImageUrl',
    'showGlobe',
    'showGraticules',
    'showAtmosphere',
    'atmosphereColor',
    'atmosphereAltitude'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindGlobeLayer.linkProp(p));
})));
var $f12076c7962eab60$var$linkedGlobeLayerMethods = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'globeMaterial'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindGlobeLayer.linkMethod(p));
})));
var $f12076c7962eab60$var$bindPointsLayer = $f12076c7962eab60$var$linkKapsule('pointsLayer', $f12076c7962eab60$var$PointsLayerKapsule);
var $f12076c7962eab60$var$linkedPointsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'pointsData',
    'pointLat',
    'pointLng',
    'pointColor',
    'pointAltitude',
    'pointRadius',
    'pointResolution',
    'pointsMerge',
    'pointsTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindPointsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindArcsLayer = $f12076c7962eab60$var$linkKapsule('arcsLayer', $f12076c7962eab60$var$ArcsLayerKapsule);
var $f12076c7962eab60$var$linkedArcsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'arcsData',
    'arcStartLat',
    'arcStartLng',
    'arcEndLat',
    'arcEndLng',
    'arcColor',
    'arcAltitude',
    'arcAltitudeAutoScale',
    'arcStroke',
    'arcCurveResolution',
    'arcCircularResolution',
    'arcDashLength',
    'arcDashGap',
    'arcDashInitialGap',
    'arcDashAnimateTime',
    'arcsTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindArcsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindHexBinLayer = $f12076c7962eab60$var$linkKapsule('hexBinLayer', $f12076c7962eab60$var$HexBinLayerKapsule);
var $f12076c7962eab60$var$linkedHexBinLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'hexBinPointsData',
    'hexBinPointLat',
    'hexBinPointLng',
    'hexBinPointWeight',
    'hexBinResolution',
    'hexMargin',
    'hexTopCurvatureResolution',
    'hexTopColor',
    'hexSideColor',
    'hexAltitude',
    'hexBinMerge',
    'hexTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindHexBinLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindHeatmapsLayer = $f12076c7962eab60$var$linkKapsule('heatmapsLayer', $f12076c7962eab60$var$HeatmapsLayerKapsule);
var $f12076c7962eab60$var$linkedHeatmapsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'heatmapsData',
    'heatmapPoints',
    'heatmapPointLat',
    'heatmapPointLng',
    'heatmapPointWeight',
    'heatmapBandwidth',
    'heatmapColorFn',
    'heatmapColorSaturation',
    'heatmapBaseAltitude',
    'heatmapTopAltitude',
    'heatmapsTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindHeatmapsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindHexedPolygonsLayer = $f12076c7962eab60$var$linkKapsule('hexedPolygonsLayer', $f12076c7962eab60$var$HexedPolygonsLayerKapsule);
var $f12076c7962eab60$var$linkedHexedPolygonsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'hexPolygonsData',
    'hexPolygonGeoJsonGeometry',
    'hexPolygonColor',
    'hexPolygonAltitude',
    'hexPolygonResolution',
    'hexPolygonMargin',
    'hexPolygonUseDots',
    'hexPolygonCurvatureResolution',
    'hexPolygonDotResolution',
    'hexPolygonsTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindHexedPolygonsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindPolygonsLayer = $f12076c7962eab60$var$linkKapsule('polygonsLayer', $f12076c7962eab60$var$PolygonsLayerKapsule);
var $f12076c7962eab60$var$linkedPolygonsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'polygonsData',
    'polygonGeoJsonGeometry',
    'polygonCapColor',
    'polygonCapMaterial',
    'polygonSideColor',
    'polygonSideMaterial',
    'polygonStrokeColor',
    'polygonAltitude',
    'polygonCapCurvatureResolution',
    'polygonsTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindPolygonsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindPathsLayer = $f12076c7962eab60$var$linkKapsule('pathsLayer', $f12076c7962eab60$var$PathsLayerKapsule);
var $f12076c7962eab60$var$linkedPathsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'pathsData',
    'pathPoints',
    'pathPointLat',
    'pathPointLng',
    'pathPointAlt',
    'pathResolution',
    'pathColor',
    'pathStroke',
    'pathDashLength',
    'pathDashGap',
    'pathDashInitialGap',
    'pathDashAnimateTime',
    'pathTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindPathsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindTilesLayer = $f12076c7962eab60$var$linkKapsule('tilesLayer', $f12076c7962eab60$var$TilesLayerKapsule);
var $f12076c7962eab60$var$linkedTilesLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'tilesData',
    'tileLat',
    'tileLng',
    'tileAltitude',
    'tileWidth',
    'tileHeight',
    'tileUseGlobeProjection',
    'tileMaterial',
    'tileCurvatureResolution',
    'tilesTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindTilesLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindLabelsLayer = $f12076c7962eab60$var$linkKapsule('labelsLayer', $f12076c7962eab60$var$LabelsLayerKapsule);
var $f12076c7962eab60$var$linkedLabelsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'labelsData',
    'labelLat',
    'labelLng',
    'labelAltitude',
    'labelRotation',
    'labelText',
    'labelSize',
    'labelTypeFace',
    'labelColor',
    'labelResolution',
    'labelIncludeDot',
    'labelDotRadius',
    'labelDotOrientation',
    'labelsTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindLabelsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindRingsLayer = $f12076c7962eab60$var$linkKapsule('ringsLayer', $f12076c7962eab60$var$RingsLayerKapsule);
var $f12076c7962eab60$var$linkedRingsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'ringsData',
    'ringLat',
    'ringLng',
    'ringAltitude',
    'ringColor',
    'ringResolution',
    'ringMaxRadius',
    'ringPropagationSpeed',
    'ringRepeatPeriod'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindRingsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindHtmlElementsLayer = $f12076c7962eab60$var$linkKapsule('htmlElementsLayer', $f12076c7962eab60$var$HtmlElementsLayerKapsule);
var $f12076c7962eab60$var$linkedHtmlElementsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'htmlElementsData',
    'htmlLat',
    'htmlLng',
    'htmlAltitude',
    'htmlElement',
    'htmlTransitionDuration'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindHtmlElementsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindObjectsLayer = $f12076c7962eab60$var$linkKapsule('objectsLayer', $f12076c7962eab60$var$ObjectsLayerKapsule);
var $f12076c7962eab60$var$linkedObjectsLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'objectsData',
    'objectLat',
    'objectLng',
    'objectAltitude',
    'objectRotation',
    'objectFacesSurface',
    'objectThreeObject'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindObjectsLayer.linkProp(p));
})));
var $f12076c7962eab60$var$bindCustomLayer = $f12076c7962eab60$var$linkKapsule('customLayer', $f12076c7962eab60$var$CustomLayerKapsule);
var $f12076c7962eab60$var$linkedCustomLayerProps = Object.assign.apply(Object, $f12076c7962eab60$var$_toConsumableArray([
    'customLayerData',
    'customThreeObject',
    'customThreeObjectUpdate'
].map(function(p) {
    return $f12076c7962eab60$var$_defineProperty({}, p, $f12076c7962eab60$var$bindCustomLayer.linkProp(p));
})));
//
var $f12076c7962eab60$var$Globe = (0, $48722fc3e2bb2376$export$2e2bcd8739ae039)({
    props: $f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2({
        onGlobeReady: {
            triggerUpdate: false
        },
        rendererSize: {
            "default": new $f12076c7962eab60$var$THREE.Vector2(window.innerWidth, window.innerHeight),
            onChange: function onChange(rendererSize, state) {
                state.pathsLayer.rendererSize(rendererSize);
            },
            triggerUpdate: false
        }
    }, $f12076c7962eab60$var$linkedGlobeLayerProps), $f12076c7962eab60$var$linkedPointsLayerProps), $f12076c7962eab60$var$linkedArcsLayerProps), $f12076c7962eab60$var$linkedHexBinLayerProps), $f12076c7962eab60$var$linkedHeatmapsLayerProps), $f12076c7962eab60$var$linkedPolygonsLayerProps), $f12076c7962eab60$var$linkedHexedPolygonsLayerProps), $f12076c7962eab60$var$linkedPathsLayerProps), $f12076c7962eab60$var$linkedTilesLayerProps), $f12076c7962eab60$var$linkedLabelsLayerProps), $f12076c7962eab60$var$linkedRingsLayerProps), $f12076c7962eab60$var$linkedHtmlElementsLayerProps), $f12076c7962eab60$var$linkedObjectsLayerProps), $f12076c7962eab60$var$linkedCustomLayerProps),
    methods: $f12076c7962eab60$var$_objectSpread2({
        getGlobeRadius: $f12076c7962eab60$var$getGlobeRadius,
        getCoords: function getCoords(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return $f12076c7962eab60$var$polar2Cartesian.apply(void 0, args);
        },
        toGeoCoords: function toGeoCoords(state) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            return $f12076c7962eab60$var$cartesian2Polar.apply(void 0, args);
        },
        setPointOfView: function setPointOfView(state, globalPov, globePos) {
            var isBehindGlobe = undefined;
            if (globalPov) {
                var globeRadius = $f12076c7962eab60$var$getGlobeRadius();
                var pov = globePos ? globalPov.clone().sub(globePos) : globalPov; // convert to local vector
                var povDist, povEdgeDist, povEdgeAngle;
                isBehindGlobe = function isBehindGlobe(pos) {
                    povDist === undefined && (povDist = pov.length());
                    // check if it's behind plane of globe's visible area
                    // maxSurfacePosAngle === undefined && (maxSurfacePosAngle = Math.acos(globeRadius / povDist));
                    // return pov.angleTo(pos) > maxSurfacePosAngle;
                    // more sophisticated method that checks also pos altitude
                    povEdgeDist === undefined && (povEdgeDist = Math.sqrt(Math.pow(povDist, 2) - Math.pow(globeRadius, 2)));
                    povEdgeAngle === undefined && (povEdgeAngle = Math.acos(povEdgeDist / povDist));
                    var povPosDist = pov.distanceTo(pos);
                    if (povPosDist < povEdgeDist) return false; // pos is closer than visible edge of globe
                    var posDist = pos.length();
                    var povPosAngle = Math.acos((Math.pow(povDist, 2) + Math.pow(povPosDist, 2) - Math.pow(posDist, 2)) / (2 * povDist * povPosDist)); // triangle solver
                    return povPosAngle < povEdgeAngle; // pos is within globe's visible area cone
                };
            }
            // pass behind globe checker for layers that need it
            state.layersThatNeedBehindGlobeChecker.forEach(function(l) {
                return l.isBehindGlobe(isBehindGlobe);
            });
        },
        pauseAnimation: function pauseAnimation(state) {
            if (state.animationFrameRequestId !== null) {
                cancelAnimationFrame(state.animationFrameRequestId);
                state.animationFrameRequestId = null;
            }
            state.pausableLayers.forEach(function(l) {
                var _l$pauseAnimation;
                return (_l$pauseAnimation = l.pauseAnimation) === null || _l$pauseAnimation === void 0 ? void 0 : _l$pauseAnimation.call(l);
            });
            return this;
        },
        resumeAnimation: function resumeAnimation(state) {
            if (state.animationFrameRequestId === null) this._animationCycle();
            state.pausableLayers.forEach(function(l) {
                var _l$resumeAnimation;
                return (_l$resumeAnimation = l.resumeAnimation) === null || _l$resumeAnimation === void 0 ? void 0 : _l$resumeAnimation.call(l);
            });
            return this;
        },
        _animationCycle: function _animationCycle(state) {
            state.animationFrameRequestId = requestAnimationFrame(this._animationCycle);
            $79Zf3.update(); // run tween updates
        },
        _destructor: function _destructor(state) {
            this.pauseAnimation();
            state.destructableLayers.forEach(function(l) {
                return l._destructor();
            });
        }
    }, $f12076c7962eab60$var$linkedGlobeLayerMethods),
    stateInit: function stateInit() {
        var layers = {
            globeLayer: $f12076c7962eab60$var$GlobeLayerKapsule(),
            pointsLayer: $f12076c7962eab60$var$PointsLayerKapsule(),
            arcsLayer: $f12076c7962eab60$var$ArcsLayerKapsule(),
            hexBinLayer: $f12076c7962eab60$var$HexBinLayerKapsule(),
            heatmapsLayer: $f12076c7962eab60$var$HeatmapsLayerKapsule(),
            polygonsLayer: $f12076c7962eab60$var$PolygonsLayerKapsule(),
            hexedPolygonsLayer: $f12076c7962eab60$var$HexedPolygonsLayerKapsule(),
            pathsLayer: $f12076c7962eab60$var$PathsLayerKapsule(),
            tilesLayer: $f12076c7962eab60$var$TilesLayerKapsule(),
            labelsLayer: $f12076c7962eab60$var$LabelsLayerKapsule(),
            ringsLayer: $f12076c7962eab60$var$RingsLayerKapsule(),
            htmlElementsLayer: $f12076c7962eab60$var$HtmlElementsLayerKapsule(),
            objectsLayer: $f12076c7962eab60$var$ObjectsLayerKapsule(),
            customLayer: $f12076c7962eab60$var$CustomLayerKapsule()
        };
        return $f12076c7962eab60$var$_objectSpread2($f12076c7962eab60$var$_objectSpread2({}, layers), {}, {
            layersThatNeedBehindGlobeChecker: Object.values(layers).filter(function(l) {
                return l.hasOwnProperty('isBehindGlobe');
            }),
            destructableLayers: Object.values(layers).filter(function(l) {
                return l.hasOwnProperty('_destructor');
            }),
            pausableLayers: Object.values(layers).filter(function(l) {
                return l.hasOwnProperty('pauseAnimation');
            })
        });
    },
    init: function init(threeObj, state, _ref16) {
        var _ref16$animateIn = _ref16.animateIn, animateIn = _ref16$animateIn === void 0 ? true : _ref16$animateIn, _ref16$waitForGlobeRe = _ref16.waitForGlobeReady, waitForGlobeReady = _ref16$waitForGlobeRe === void 0 ? true : _ref16$waitForGlobeRe;
        // Clear the scene
        $f12076c7962eab60$var$emptyObject(threeObj);
        // Main three object to manipulate
        state.scene = threeObj;
        state.scene.visible = false; // hide scene before globe initialization
        // Add all layers groups
        $f12076c7962eab60$var$layers.forEach(function(layer) {
            var g = new $f12076c7962eab60$var$THREE.Group();
            state.scene.add(g);
            state[layer](g);
        });
        var initGlobe = function initGlobe() {
            if (animateIn) {
                // Animate build-in just once
                state.scene.scale.set(1e-6, 1e-6, 1e-6);
                new $79Zf3.Tween({
                    k: 1e-6
                }).to({
                    k: 1
                }, 600).easing($79Zf3.Easing.Quadratic.Out).onUpdate(function(_ref17) {
                    var k = _ref17.k;
                    return state.scene.scale.set(k, k, k);
                }).start();
                var rotAxis = new $f12076c7962eab60$var$THREE.Vector3(0, 1, 0);
                new $79Zf3.Tween({
                    rot: Math.PI * 2
                }).to({
                    rot: 0
                }, 1200).easing($79Zf3.Easing.Quintic.Out).onUpdate(function(_ref18) {
                    var rot = _ref18.rot;
                    return state.scene.setRotationFromAxisAngle(rotAxis, rot);
                }).start();
            }
            state.scene.visible = true;
            state.onGlobeReady && state.onGlobeReady();
        };
        waitForGlobeReady ? state.globeLayer.onReady(initGlobe) : initGlobe();
        // Kick-off animation cycle
        this._animationCycle();
    },
    update: function update(state) {}
});
function $f12076c7962eab60$var$fromKapsule(kapsule) {
    var baseClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object;
    var initKapsuleWithSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var FromKapsule = /*#__PURE__*/ function(_baseClass) {
        function FromKapsule() {
            var _this;
            $f12076c7962eab60$var$_classCallCheck(this, FromKapsule);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $f12076c7962eab60$var$_callSuper(this, FromKapsule, [].concat(args));
            _this.__kapsuleInstance = kapsule.apply(void 0, args).apply(void 0, [].concat($f12076c7962eab60$var$_toConsumableArray(initKapsuleWithSelf ? [
                _this
            ] : []), args));
            return _this;
        }
        $f12076c7962eab60$var$_inherits(FromKapsule, _baseClass);
        return $f12076c7962eab60$var$_createClass(FromKapsule);
    }(baseClass); // attach kapsule props/methods to class prototype
    Object.keys(kapsule()).forEach(function(m) {
        return FromKapsule.prototype[m] = function() {
            var _this$__kapsuleInstan;
            var returnVal = (_this$__kapsuleInstan = this.__kapsuleInstance)[m].apply(_this$__kapsuleInstan, arguments);
            return returnVal === this.__kapsuleInstance ? this // chain based on this class, not the kapsule obj
             : returnVal;
        };
    });
    return FromKapsule;
}
var $f12076c7962eab60$var$three = window.THREE ? window.THREE : {
    Group: (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4)
}; // Prefer consumption from global THREE, if exists
var $f12076c7962eab60$export$2e2bcd8739ae039 = $f12076c7962eab60$var$fromKapsule($f12076c7962eab60$var$Globe, $f12076c7962eab60$var$three.Group, true);



var $96fd206a2b91c8e0$exports = {};
$96fd206a2b91c8e0$exports = JSON.parse("{\"type\":\"FeatureCollection\",\"features\":[{\"type\":\"Feature\",\"properties\":{\"POP_EST\":34124811,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"AF\",\"ISO_A3\":\"AFG\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[60.52843,29.318572,75.158028,38.486282],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[61.210817,35.650072],[62.230651,35.270664],[62.984662,35.404041],[63.193538,35.857166],[63.982896,36.007957],[64.546479,36.312073],[64.746105,37.111818],[65.588948,37.305217],[65.745631,37.661164],[66.217385,37.39379],[66.518607,37.362784],[67.075782,37.356144],[67.83,37.144994],[68.135562,37.023115],[68.859446,37.344336],[69.196273,37.151144],[69.518785,37.608997],[70.116578,37.588223],[70.270574,37.735165],[70.376304,38.138396],[70.806821,38.486282],[71.348131,38.258905],[71.239404,37.953265],[71.541918,37.905774],[71.448693,37.065645],[71.844638,36.738171],[72.193041,36.948288],[72.63689,37.047558],[73.260056,37.495257],[73.948696,37.421566],[74.980002,37.41999],[75.158028,37.133031],[74.575893,37.020841],[74.067552,36.836176],[72.920025,36.720007],[71.846292,36.509942],[71.262348,36.074388],[71.498768,35.650563],[71.613076,35.153203],[71.115019,34.733126],[71.156773,34.348911],[70.881803,33.988856],[69.930543,34.02012],[70.323594,33.358533],[69.687147,33.105499],[69.262522,32.501944],[69.317764,31.901412],[68.926677,31.620189],[68.556932,31.71331],[67.792689,31.58293],[67.683394,31.303154],[66.938891,31.304911],[66.381458,30.738899],[66.346473,29.887943],[65.046862,29.472181],[64.350419,29.560031],[64.148002,29.340819],[63.550261,29.468331],[62.549857,29.318572],[60.874248,29.829239],[61.781222,30.73585],[61.699314,31.379506],[60.941945,31.548075],[60.863655,32.18292],[60.536078,32.981269],[60.9637,33.528832],[60.52843,33.676446],[60.803193,34.404102],[61.210817,35.650072]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":29310273,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"AO\",\"ISO_A3\":\"AGO\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[11.640096,-17.930636,24.079905,-4.438023],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[23.904154,-11.722282],[24.079905,-12.191297],[23.930922,-12.565848],[24.016137,-12.911046],[21.933886,-12.898437],[21.887843,-16.08031],[22.562478,-16.898451],[23.215048,-17.523116],[21.377176,-17.930636],[18.956187,-17.789095],[18.263309,-17.309951],[14.209707,-17.353101],[14.058501,-17.423381],[13.462362,-16.971212],[12.814081,-16.941343],[12.215461,-17.111668],[11.734199,-17.301889],[11.640096,-16.673142],[11.778537,-15.793816],[12.123581,-14.878316],[12.175619,-14.449144],[12.500095,-13.5477],[12.738479,-13.137906],[13.312914,-12.48363],[13.633721,-12.038645],[13.738728,-11.297863],[13.686379,-10.731076],[13.387328,-10.373578],[13.120988,-9.766897],[12.87537,-9.166934],[12.929061,-8.959091],[13.236433,-8.562629],[12.93304,-7.596539],[12.728298,-6.927122],[12.227347,-6.294448],[12.322432,-6.100092],[12.735171,-5.965682],[13.024869,-5.984389],[13.375597,-5.864241],[16.326528,-5.87747],[16.57318,-6.622645],[16.860191,-7.222298],[17.089996,-7.545689],[17.47297,-8.068551],[18.134222,-7.987678],[18.464176,-7.847014],[19.016752,-7.988246],[19.166613,-7.738184],[19.417502,-7.155429],[20.037723,-7.116361],[20.091622,-6.94309],[20.601823,-6.939318],[20.514748,-7.299606],[21.728111,-7.290872],[21.746456,-7.920085],[21.949131,-8.305901],[21.801801,-8.908707],[21.875182,-9.523708],[22.208753,-9.894796],[22.155268,-11.084801],[22.402798,-10.993075],[22.837345,-11.017622],[23.456791,-10.867863],[23.912215,-10.926826],[24.017894,-11.237298],[23.904154,-11.722282]]],[[[12.182337,-5.789931],[11.914963,-5.037987],[12.318608,-4.60623],[12.62076,-4.438023],[12.995517,-4.781103],[12.631612,-4.991271],[12.468004,-5.248362],[12.436688,-5.684304],[12.182337,-5.789931]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3047987,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"AL\",\"ISO_A3\":\"ALB\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[19.304486,39.624998,21.02004,42.688247],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[21.02004,40.842727],[20.99999,40.580004],[20.674997,40.435],[20.615,40.110007],[20.150016,39.624998],[19.98,39.694993],[19.960002,39.915006],[19.406082,40.250773],[19.319059,40.72723],[19.40355,41.409566],[19.540027,41.719986],[19.371769,41.877548],[19.371768,41.877551],[19.304486,42.195745],[19.738051,42.688247],[19.801613,42.500093],[20.0707,42.58863],[20.283755,42.32026],[20.52295,42.21787],[20.590247,41.855409],[20.590247,41.855404],[20.463175,41.515089],[20.605182,41.086226],[21.02004,40.842727]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6072475,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"AE\",\"ISO_A3\":\"ARE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[51.579519,22.496948,56.396847,26.055464],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[51.579519,24.245497],[51.757441,24.294073],[51.794389,24.019826],[52.577081,24.177439],[53.404007,24.151317],[54.008001,24.121758],[54.693024,24.797892],[55.439025,25.439145],[56.070821,26.055464],[56.261042,25.714606],[56.396847,24.924732],[55.886233,24.920831],[55.804119,24.269604],[55.981214,24.130543],[55.528632,23.933604],[55.525841,23.524869],[55.234489,23.110993],[55.208341,22.70833],[55.006803,22.496948],[52.000733,23.001154],[51.617708,24.014219],[51.579519,24.245497]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":44293293,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"AR\",\"ISO_A3\":\"ARG\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[-73.415436,-55.25,-53.628349,-21.83231],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-66.95992,-54.89681],[-67.56244,-54.87001],[-68.63335,-54.8695],[-68.63401,-52.63637],[-68.25,-53.1],[-67.75,-53.85],[-66.45,-54.45],[-65.05,-54.7],[-65.5,-55.2],[-66.45,-55.25],[-66.95992,-54.89681]]],[[[-68.571545,-52.299444],[-69.498362,-52.142761],[-71.914804,-52.009022],[-72.329404,-51.425956],[-72.309974,-50.67701],[-72.975747,-50.74145],[-73.328051,-50.378785],[-73.415436,-49.318436],[-72.648247,-48.878618],[-72.331161,-48.244238],[-72.447355,-47.738533],[-71.917258,-46.884838],[-71.552009,-45.560733],[-71.659316,-44.973689],[-71.222779,-44.784243],[-71.329801,-44.407522],[-71.793623,-44.207172],[-71.464056,-43.787611],[-71.915424,-43.408565],[-72.148898,-42.254888],[-71.746804,-42.051386],[-71.915734,-40.832339],[-71.680761,-39.808164],[-71.413517,-38.916022],[-70.814664,-38.552995],[-71.118625,-37.576827],[-71.121881,-36.658124],[-70.364769,-36.005089],[-70.388049,-35.169688],[-69.817309,-34.193571],[-69.814777,-33.273886],[-70.074399,-33.09121],[-70.535069,-31.36501],[-69.919008,-30.336339],[-70.01355,-29.367923],[-69.65613,-28.459141],[-69.001235,-27.521214],[-68.295542,-26.89934],[-68.5948,-26.506909],[-68.386001,-26.185016],[-68.417653,-24.518555],[-67.328443,-24.025303],[-66.985234,-22.986349],[-67.106674,-22.735925],[-66.273339,-21.83231],[-64.964892,-22.075862],[-64.377021,-22.798091],[-63.986838,-21.993644],[-62.846468,-22.034985],[-62.685057,-22.249029],[-60.846565,-23.880713],[-60.028966,-24.032796],[-58.807128,-24.771459],[-57.777217,-25.16234],[-57.63366,-25.603657],[-58.618174,-27.123719],[-57.60976,-27.395899],[-56.486702,-27.548499],[-55.695846,-27.387837],[-54.788795,-26.621786],[-54.625291,-25.739255],[-54.13005,-25.547639],[-53.628349,-26.124865],[-53.648735,-26.923473],[-54.490725,-27.474757],[-55.162286,-27.881915],[-56.2909,-28.852761],[-57.625133,-30.216295],[-57.874937,-31.016556],[-58.14244,-32.044504],[-58.132648,-33.040567],[-58.349611,-33.263189],[-58.427074,-33.909454],[-58.495442,-34.43149],[-57.22583,-35.288027],[-57.362359,-35.97739],[-56.737487,-36.413126],[-56.788285,-36.901572],[-57.749157,-38.183871],[-59.231857,-38.72022],[-61.237445,-38.928425],[-62.335957,-38.827707],[-62.125763,-39.424105],[-62.330531,-40.172586],[-62.145994,-40.676897],[-62.745803,-41.028761],[-63.770495,-41.166789],[-64.73209,-40.802677],[-65.118035,-41.064315],[-64.978561,-42.058001],[-64.303408,-42.359016],[-63.755948,-42.043687],[-63.458059,-42.563138],[-64.378804,-42.873558],[-65.181804,-43.495381],[-65.328823,-44.501366],[-65.565269,-45.036786],[-66.509966,-45.039628],[-67.293794,-45.551896],[-67.580546,-46.301773],[-66.597066,-47.033925],[-65.641027,-47.236135],[-65.985088,-48.133289],[-67.166179,-48.697337],[-67.816088,-49.869669],[-68.728745,-50.264218],[-69.138539,-50.73251],[-68.815561,-51.771104],[-68.149995,-52.349983],[-68.571545,-52.299444]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3045191,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"AM\",\"ISO_A3\":\"ARM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[43.582746,38.741201,46.50572,41.248129],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[43.582746,41.092143],[44.97248,41.248129],[45.179496,40.985354],[45.560351,40.81229],[45.359175,40.561504],[45.891907,40.218476],[45.610012,39.899994],[46.034534,39.628021],[46.483499,39.464155],[46.50572,38.770605],[46.143623,38.741201],[45.735379,39.319719],[45.739978,39.473999],[45.298145,39.471751],[45.001987,39.740004],[44.79399,39.713003],[44.400009,40.005],[43.656436,40.253564],[43.752658,40.740201],[43.582746,41.092143]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4050,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"AQ\",\"ISO_A3\":\"ATA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-180,-90,180,-63.27066],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-59.572095,-80.040179],[-59.865849,-80.549657],[-60.159656,-81.000327],[-62.255393,-80.863178],[-64.488125,-80.921934],[-65.741666,-80.588827],[-65.741666,-80.549657],[-66.290031,-80.255773],[-64.037688,-80.294944],[-61.883246,-80.39287],[-61.138976,-79.981371],[-60.610119,-79.628679],[-59.572095,-80.040179]]],[[[-159.208184,-79.497059],[-161.127601,-79.634209],[-162.439847,-79.281465],[-163.027408,-78.928774],[-163.066604,-78.869966],[-163.712896,-78.595667],[-163.712896,-78.595667],[-163.105801,-78.223338],[-161.245113,-78.380176],[-160.246208,-78.693645],[-159.482405,-79.046338],[-159.208184,-79.497059]]],[[[-45.154758,-78.04707],[-43.920828,-78.478103],[-43.48995,-79.08556],[-43.372438,-79.516645],[-43.333267,-80.026123],[-44.880537,-80.339644],[-46.506174,-80.594357],[-48.386421,-80.829485],[-50.482107,-81.025442],[-52.851988,-80.966685],[-54.164259,-80.633528],[-53.987991,-80.222028],[-51.853134,-79.94773],[-50.991326,-79.614623],[-50.364595,-79.183487],[-49.914131,-78.811209],[-49.306959,-78.458569],[-48.660616,-78.047018],[-48.660616,-78.047019],[-48.151396,-78.04707],[-46.662857,-77.831476],[-45.154758,-78.04707]]],[[[-121.211511,-73.50099],[-119.918851,-73.657725],[-118.724143,-73.481353],[-119.292119,-73.834097],[-120.232217,-74.08881],[-121.62283,-74.010468],[-122.621735,-73.657778],[-122.621735,-73.657777],[-122.406245,-73.324619],[-121.211511,-73.50099]]],[[[-125.559566,-73.481353],[-124.031882,-73.873268],[-124.619469,-73.834097],[-125.912181,-73.736118],[-127.28313,-73.461769],[-127.28313,-73.461768],[-126.558472,-73.246226],[-125.559566,-73.481353]]],[[[-98.98155,-71.933334],[-97.884743,-72.070535],[-96.787937,-71.952971],[-96.20035,-72.521205],[-96.983765,-72.442864],[-98.198083,-72.482035],[-99.432013,-72.442864],[-100.783455,-72.50162],[-101.801868,-72.305663],[-102.330725,-71.894164],[-102.330725,-71.894164],[-101.703967,-71.717792],[-100.430919,-71.854993],[-98.98155,-71.933334]]],[[[-68.451346,-70.955823],[-68.333834,-71.406493],[-68.510128,-71.798407],[-68.784297,-72.170736],[-69.959471,-72.307885],[-71.075889,-72.503842],[-72.388134,-72.484257],[-71.8985,-72.092343],[-73.073622,-72.229492],[-74.19004,-72.366693],[-74.953895,-72.072757],[-75.012625,-71.661258],[-73.915819,-71.269345],[-73.915819,-71.269344],[-73.230331,-71.15178],[-72.074717,-71.190951],[-71.780962,-70.681473],[-71.72218,-70.309196],[-71.741791,-69.505782],[-71.173815,-69.035475],[-70.253252,-68.87874],[-69.724447,-69.251017],[-69.489422,-69.623346],[-69.058518,-70.074016],[-68.725541,-70.505153],[-68.451346,-70.955823]]],[[[-58.614143,-64.152467],[-59.045073,-64.36801],[-59.789342,-64.211223],[-60.611928,-64.309202],[-61.297416,-64.54433],[-62.0221,-64.799094],[-62.51176,-65.09303],[-62.648858,-65.484942],[-62.590128,-65.857219],[-62.120079,-66.190326],[-62.805567,-66.425505],[-63.74569,-66.503847],[-64.294106,-66.837004],[-64.881693,-67.150474],[-65.508425,-67.58161],[-65.665082,-67.953887],[-65.312545,-68.365335],[-64.783715,-68.678908],[-63.961103,-68.913984],[-63.1973,-69.227556],[-62.785955,-69.619419],[-62.570516,-69.991747],[-62.276736,-70.383661],[-61.806661,-70.716768],[-61.512906,-71.089045],[-61.375809,-72.010074],[-61.081977,-72.382351],[-61.003661,-72.774265],[-60.690269,-73.166179],[-60.827367,-73.695242],[-61.375809,-74.106742],[-61.96337,-74.439848],[-63.295201,-74.576997],[-63.74569,-74.92974],[-64.352836,-75.262847],[-65.860987,-75.635124],[-67.192818,-75.79191],[-68.446282,-76.007452],[-69.797724,-76.222995],[-70.600724,-76.634494],[-72.206776,-76.673665],[-73.969536,-76.634494],[-75.555977,-76.712887],[-77.24037,-76.712887],[-76.926979,-77.104802],[-75.399294,-77.28107],[-74.282876,-77.55542],[-73.656119,-77.908112],[-74.772536,-78.221633],[-76.4961,-78.123654],[-77.925858,-78.378419],[-77.984666,-78.789918],[-78.023785,-79.181833],[-76.848637,-79.514939],[-76.633224,-79.887216],[-75.360097,-80.259545],[-73.244852,-80.416331],[-71.442946,-80.69063],[-70.013163,-81.004151],[-68.191646,-81.317672],[-65.704279,-81.474458],[-63.25603,-81.748757],[-61.552026,-82.042692],[-59.691416,-82.37585],[-58.712121,-82.846106],[-58.222487,-83.218434],[-57.008117,-82.865691],[-55.362894,-82.571755],[-53.619771,-82.258235],[-51.543644,-82.003521],[-49.76135,-81.729171],[-47.273931,-81.709586],[-44.825708,-81.846735],[-42.808363,-82.081915],[-42.16202,-81.65083],[-40.771433,-81.356894],[-38.244818,-81.337309],[-36.26667,-81.121715],[-34.386397,-80.906172],[-32.310296,-80.769023],[-30.097098,-80.592651],[-28.549802,-80.337938],[-29.254901,-79.985195],[-29.685805,-79.632503],[-29.685805,-79.260226],[-31.624808,-79.299397],[-33.681324,-79.456132],[-35.639912,-79.456132],[-35.914107,-79.083855],[-35.77701,-78.339248],[-35.326546,-78.123654],[-33.896763,-77.888526],[-32.212369,-77.65345],[-30.998051,-77.359515],[-29.783732,-77.065579],[-28.882779,-76.673665],[-27.511752,-76.497345],[-26.160336,-76.360144],[-25.474822,-76.281803],[-23.927552,-76.24258],[-22.458598,-76.105431],[-21.224694,-75.909474],[-20.010375,-75.674346],[-18.913543,-75.439218],[-17.522982,-75.125698],[-16.641589,-74.79254],[-15.701491,-74.498604],[-15.40771,-74.106742],[-16.46532,-73.871614],[-16.112784,-73.460114],[-15.446855,-73.146542],[-14.408805,-72.950585],[-13.311973,-72.715457],[-12.293508,-72.401936],[-11.510067,-72.010074],[-11.020433,-71.539767],[-10.295774,-71.265416],[-9.101015,-71.324224],[-8.611381,-71.65733],[-7.416622,-71.696501],[-7.377451,-71.324224],[-6.868232,-70.93231],[-5.790985,-71.030289],[-5.536375,-71.402617],[-4.341667,-71.461373],[-3.048981,-71.285053],[-1.795492,-71.167438],[-0.659489,-71.226246],[-0.228637,-71.637745],[0.868195,-71.304639],[1.886686,-71.128267],[3.022638,-70.991118],[4.139055,-70.853917],[5.157546,-70.618789],[6.273912,-70.462055],[7.13572,-70.246512],[7.742866,-69.893769],[8.48711,-70.148534],[9.525135,-70.011333],[10.249845,-70.48164],[10.817821,-70.834332],[11.953824,-70.638375],[12.404287,-70.246512],[13.422778,-69.972162],[14.734998,-70.030918],[15.126757,-70.403247],[15.949342,-70.030918],[17.026589,-69.913354],[18.201711,-69.874183],[19.259373,-69.893769],[20.375739,-70.011333],[21.452985,-70.07014],[21.923034,-70.403247],[22.569403,-70.697182],[23.666184,-70.520811],[24.841357,-70.48164],[25.977309,-70.48164],[27.093726,-70.462055],[28.09258,-70.324854],[29.150242,-70.20729],[30.031583,-69.93294],[30.971733,-69.75662],[31.990172,-69.658641],[32.754053,-69.384291],[33.302443,-68.835642],[33.870419,-68.502588],[34.908495,-68.659271],[35.300202,-69.012014],[36.16201,-69.247142],[37.200035,-69.168748],[37.905108,-69.52144],[38.649404,-69.776205],[39.667894,-69.541077],[40.020431,-69.109941],[40.921358,-68.933621],[41.959434,-68.600514],[42.938702,-68.463313],[44.113876,-68.267408],[44.897291,-68.051866],[45.719928,-67.816738],[46.503343,-67.601196],[47.44344,-67.718759],[48.344419,-67.366068],[48.990736,-67.091718],[49.930885,-67.111303],[50.753471,-66.876175],[50.949325,-66.523484],[51.791547,-66.249133],[52.614133,-66.053176],[53.613038,-65.89639],[54.53355,-65.818049],[55.414943,-65.876805],[56.355041,-65.974783],[57.158093,-66.249133],[57.255968,-66.680218],[58.137361,-67.013324],[58.744508,-67.287675],[59.939318,-67.405239],[60.605221,-67.679589],[61.427806,-67.953887],[62.387489,-68.012695],[63.19049,-67.816738],[64.052349,-67.405239],[64.992447,-67.620729],[65.971715,-67.738345],[66.911864,-67.855909],[67.891133,-67.934302],[68.890038,-67.934302],[69.712624,-68.972791],[69.673453,-69.227556],[69.555941,-69.678226],[68.596258,-69.93294],[67.81274,-70.305268],[67.949889,-70.697182],[69.066307,-70.677545],[68.929157,-71.069459],[68.419989,-71.441788],[67.949889,-71.853287],[68.71377,-72.166808],[69.869307,-72.264787],[71.024895,-72.088415],[71.573285,-71.696501],[71.906288,-71.324224],[72.454627,-71.010703],[73.08141,-70.716768],[73.33602,-70.364024],[73.864877,-69.874183],[74.491557,-69.776205],[75.62756,-69.737034],[76.626465,-69.619419],[77.644904,-69.462684],[78.134539,-69.07077],[78.428371,-68.698441],[79.113859,-68.326216],[80.093127,-68.071503],[80.93535,-67.875546],[81.483792,-67.542388],[82.051767,-67.366068],[82.776426,-67.209282],[83.775331,-67.30726],[84.676206,-67.209282],[85.655527,-67.091718],[86.752359,-67.150474],[87.477017,-66.876175],[87.986289,-66.209911],[88.358411,-66.484261],[88.828408,-66.954568],[89.67063,-67.150474],[90.630365,-67.228867],[91.5901,-67.111303],[92.608539,-67.189696],[93.548637,-67.209282],[94.17542,-67.111303],[95.017591,-67.170111],[95.781472,-67.385653],[96.682399,-67.248504],[97.759646,-67.248504],[98.68021,-67.111303],[99.718182,-67.248504],[100.384188,-66.915346],[100.893356,-66.58224],[101.578896,-66.30789],[102.832411,-65.563284],[103.478676,-65.700485],[104.242557,-65.974783],[104.90846,-66.327527],[106.181561,-66.934931],[107.160881,-66.954568],[108.081393,-66.954568],[109.15864,-66.837004],[110.235835,-66.699804],[111.058472,-66.425505],[111.74396,-66.13157],[112.860378,-66.092347],[113.604673,-65.876805],[114.388088,-66.072762],[114.897308,-66.386283],[115.602381,-66.699804],[116.699161,-66.660633],[117.384701,-66.915346],[118.57946,-67.170111],[119.832924,-67.268089],[120.871,-67.189696],[121.654415,-66.876175],[122.320369,-66.562654],[123.221296,-66.484261],[124.122274,-66.621462],[125.160247,-66.719389],[126.100396,-66.562654],[127.001427,-66.562654],[127.882768,-66.660633],[128.80328,-66.758611],[129.704259,-66.58224],[130.781454,-66.425505],[131.799945,-66.386283],[132.935896,-66.386283],[133.85646,-66.288304],[134.757387,-66.209963],[135.031582,-65.72007],[135.070753,-65.308571],[135.697485,-65.582869],[135.873805,-66.033591],[136.206705,-66.44509],[136.618049,-66.778197],[137.460271,-66.954568],[138.596223,-66.895761],[139.908442,-66.876175],[140.809421,-66.817367],[142.121692,-66.817367],[143.061842,-66.797782],[144.374061,-66.837004],[145.490427,-66.915346],[146.195552,-67.228867],[145.999699,-67.601196],[146.646067,-67.895131],[147.723263,-68.130259],[148.839629,-68.385024],[150.132314,-68.561292],[151.483705,-68.71813],[152.502247,-68.874813],[153.638199,-68.894502],[154.284567,-68.561292],[155.165857,-68.835642],[155.92979,-69.149215],[156.811132,-69.384291],[158.025528,-69.482269],[159.181013,-69.599833],[159.670699,-69.991747],[160.80665,-70.226875],[161.570479,-70.579618],[162.686897,-70.736353],[163.842434,-70.716768],[164.919681,-70.775524],[166.11444,-70.755938],[167.309095,-70.834332],[168.425616,-70.971481],[169.463589,-71.20666],[170.501665,-71.402617],[171.20679,-71.696501],[171.089227,-72.088415],[170.560422,-72.441159],[170.109958,-72.891829],[169.75737,-73.24452],[169.287321,-73.65602],[167.975101,-73.812806],[167.387489,-74.165498],[166.094803,-74.38104],[165.644391,-74.772954],[164.958851,-75.145283],[164.234193,-75.458804],[163.822797,-75.870303],[163.568239,-76.24258],[163.47026,-76.693302],[163.489897,-77.065579],[164.057873,-77.457442],[164.273363,-77.82977],[164.743464,-78.182514],[166.604126,-78.319611],[166.995781,-78.750748],[165.193876,-78.907483],[163.666217,-79.123025],[161.766385,-79.162248],[160.924162,-79.730482],[160.747894,-80.200737],[160.316964,-80.573066],[159.788211,-80.945395],[161.120016,-81.278501],[161.629287,-81.690001],[162.490992,-82.062278],[163.705336,-82.395435],[165.095949,-82.708956],[166.604126,-83.022477],[168.895665,-83.335998],[169.404782,-83.825891],[172.283934,-84.041433],[172.477049,-84.117914],[173.224083,-84.41371],[175.985672,-84.158997],[178.277212,-84.472518],[180,-84.71338],[180,-90],[-180,-90],[-180,-84.71338],[-179.942499,-84.721443],[-179.058677,-84.139412],[-177.256772,-84.452933],[-177.140807,-84.417941],[-176.084673,-84.099259],[-175.947235,-84.110449],[-175.829882,-84.117914],[-174.382503,-84.534323],[-173.116559,-84.117914],[-172.889106,-84.061019],[-169.951223,-83.884647],[-168.999989,-84.117914],[-168.530199,-84.23739],[-167.022099,-84.570497],[-164.182144,-84.82521],[-161.929775,-85.138731],[-158.07138,-85.37391],[-155.192253,-85.09956],[-150.942099,-85.295517],[-148.533073,-85.609038],[-145.888918,-85.315102],[-143.107718,-85.040752],[-142.892279,-84.570497],[-146.829068,-84.531274],[-150.060732,-84.296146],[-150.902928,-83.904232],[-153.586201,-83.68869],[-153.409907,-83.23802],[-153.037759,-82.82652],[-152.665637,-82.454192],[-152.861517,-82.042692],[-154.526299,-81.768394],[-155.29018,-81.41565],[-156.83745,-81.102129],[-154.408787,-81.160937],[-152.097662,-81.004151],[-150.648293,-81.337309],[-148.865998,-81.043373],[-147.22075,-80.671045],[-146.417749,-80.337938],[-146.770286,-79.926439],[-148.062947,-79.652089],[-149.531901,-79.358205],[-151.588416,-79.299397],[-153.390322,-79.162248],[-155.329376,-79.064269],[-155.975668,-78.69194],[-157.268302,-78.378419],[-158.051768,-78.025676],[-158.365134,-76.889207],[-157.875474,-76.987238],[-156.974573,-77.300759],[-155.329376,-77.202728],[-153.742832,-77.065579],[-152.920247,-77.496664],[-151.33378,-77.398737],[-150.00195,-77.183143],[-148.748486,-76.908845],[-147.612483,-76.575738],[-146.104409,-76.47776],[-146.143528,-76.105431],[-146.496091,-75.733154],[-146.20231,-75.380411],[-144.909624,-75.204039],[-144.322037,-75.537197],[-142.794353,-75.34124],[-141.638764,-75.086475],[-140.209007,-75.06689],[-138.85759,-74.968911],[-137.5062,-74.733783],[-136.428901,-74.518241],[-135.214583,-74.302699],[-134.431194,-74.361455],[-133.745654,-74.439848],[-132.257168,-74.302699],[-130.925311,-74.479019],[-129.554284,-74.459433],[-128.242038,-74.322284],[-126.890622,-74.420263],[-125.402082,-74.518241],[-124.011496,-74.479019],[-122.562152,-74.498604],[-121.073613,-74.518241],[-119.70256,-74.479019],[-118.684145,-74.185083],[-117.469801,-74.028348],[-116.216312,-74.243891],[-115.021552,-74.067519],[-113.944331,-73.714828],[-113.297988,-74.028348],[-112.945452,-74.38104],[-112.299083,-74.714198],[-111.261059,-74.420263],[-110.066325,-74.79254],[-108.714909,-74.910103],[-107.559346,-75.184454],[-106.149148,-75.125698],[-104.876074,-74.949326],[-103.367949,-74.988497],[-102.016507,-75.125698],[-100.645531,-75.302018],[-100.1167,-74.870933],[-100.763043,-74.537826],[-101.252703,-74.185083],[-102.545337,-74.106742],[-103.113313,-73.734413],[-103.328752,-73.362084],[-103.681289,-72.61753],[-102.917485,-72.754679],[-101.60524,-72.813436],[-100.312528,-72.754679],[-99.13738,-72.911414],[-98.118889,-73.20535],[-97.688037,-73.558041],[-96.336595,-73.616849],[-95.043961,-73.4797],[-93.672907,-73.283743],[-92.439003,-73.166179],[-91.420564,-73.401307],[-90.088733,-73.322914],[-89.226951,-72.558722],[-88.423951,-73.009393],[-87.268337,-73.185764],[-86.014822,-73.087786],[-85.192236,-73.4797],[-83.879991,-73.518871],[-82.665646,-73.636434],[-81.470913,-73.851977],[-80.687447,-73.4797],[-80.295791,-73.126956],[-79.296886,-73.518871],[-77.925858,-73.420892],[-76.907367,-73.636434],[-76.221879,-73.969541],[-74.890049,-73.871614],[-73.852024,-73.65602],[-72.833533,-73.401307],[-71.619215,-73.264157],[-70.209042,-73.146542],[-68.935916,-73.009393],[-67.956622,-72.79385],[-67.369061,-72.480329],[-67.134036,-72.049244],[-67.251548,-71.637745],[-67.56494,-71.245831],[-67.917477,-70.853917],[-68.230843,-70.462055],[-68.485452,-70.109311],[-68.544209,-69.717397],[-68.446282,-69.325535],[-67.976233,-68.953206],[-67.5845,-68.541707],[-67.427843,-68.149844],[-67.62367,-67.718759],[-67.741183,-67.326845],[-67.251548,-66.876175],[-66.703184,-66.58224],[-66.056815,-66.209963],[-65.371327,-65.89639],[-64.568276,-65.602506],[-64.176542,-65.171423],[-63.628152,-64.897073],[-63.001394,-64.642308],[-62.041686,-64.583552],[-61.414928,-64.270031],[-60.709855,-64.074074],[-59.887269,-63.95651],[-59.162585,-63.701745],[-58.594557,-63.388224],[-57.811143,-63.27066],[-57.223582,-63.525425],[-57.59573,-63.858532],[-58.614143,-64.152467]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":140,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"TF\",\"ISO_A3\":\"ATF\",\"TINY\":2,\"HOMEPART\":-99,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[68.72,-49.775,70.56,-48.625],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[68.935,-48.625],[69.58,-48.94],[70.525,-49.065],[70.56,-49.255],[70.28,-49.71],[68.745,-49.775],[68.72,-49.2425],[68.8675,-48.83],[68.935,-48.625]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":23232413,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"AU\",\"ISO_A3\":\"AUS\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":5.7},\"bbox\":[113.338953,-43.634597,153.569469,-10.668186],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[145.397978,-40.792549],[146.364121,-41.137695],[146.908584,-41.000546],[147.689259,-40.808258],[148.289068,-40.875438],[148.359865,-42.062445],[148.017301,-42.407024],[147.914052,-43.211522],[147.564564,-42.937689],[146.870343,-43.634597],[146.663327,-43.580854],[146.048378,-43.549745],[145.43193,-42.693776],[145.29509,-42.03361],[144.718071,-41.162552],[144.743755,-40.703975],[145.397978,-40.792549]]],[[[143.561811,-13.763656],[143.922099,-14.548311],[144.563714,-14.171176],[144.894908,-14.594458],[145.374724,-14.984976],[145.271991,-15.428205],[145.48526,-16.285672],[145.637033,-16.784918],[145.888904,-16.906926],[146.160309,-17.761655],[146.063674,-18.280073],[146.387478,-18.958274],[147.471082,-19.480723],[148.177602,-19.955939],[148.848414,-20.39121],[148.717465,-20.633469],[149.28942,-21.260511],[149.678337,-22.342512],[150.077382,-22.122784],[150.482939,-22.556142],[150.727265,-22.402405],[150.899554,-23.462237],[151.609175,-24.076256],[152.07354,-24.457887],[152.855197,-25.267501],[153.136162,-26.071173],[153.161949,-26.641319],[153.092909,-27.2603],[153.569469,-28.110067],[153.512108,-28.995077],[153.339095,-29.458202],[153.069241,-30.35024],[153.089602,-30.923642],[152.891578,-31.640446],[152.450002,-32.550003],[151.709117,-33.041342],[151.343972,-33.816023],[151.010555,-34.31036],[150.714139,-35.17346],[150.32822,-35.671879],[150.075212,-36.420206],[149.946124,-37.109052],[149.997284,-37.425261],[149.423882,-37.772681],[148.304622,-37.809061],[147.381733,-38.219217],[146.922123,-38.606532],[146.317922,-39.035757],[145.489652,-38.593768],[144.876976,-38.417448],[145.032212,-37.896188],[144.485682,-38.085324],[143.609974,-38.809465],[142.745427,-38.538268],[142.17833,-38.380034],[141.606582,-38.308514],[140.638579,-38.019333],[139.992158,-37.402936],[139.806588,-36.643603],[139.574148,-36.138362],[139.082808,-35.732754],[138.120748,-35.612296],[138.449462,-35.127261],[138.207564,-34.384723],[137.71917,-35.076825],[136.829406,-35.260535],[137.352371,-34.707339],[137.503886,-34.130268],[137.890116,-33.640479],[137.810328,-32.900007],[136.996837,-33.752771],[136.372069,-34.094766],[135.989043,-34.890118],[135.208213,-34.47867],[135.239218,-33.947953],[134.613417,-33.222778],[134.085904,-32.848072],[134.273903,-32.617234],[132.990777,-32.011224],[132.288081,-31.982647],[131.326331,-31.495803],[129.535794,-31.590423],[128.240938,-31.948489],[127.102867,-32.282267],[126.148714,-32.215966],[125.088623,-32.728751],[124.221648,-32.959487],[124.028947,-33.483847],[123.659667,-33.890179],[122.811036,-33.914467],[122.183064,-34.003402],[121.299191,-33.821036],[120.580268,-33.930177],[119.893695,-33.976065],[119.298899,-34.509366],[119.007341,-34.464149],[118.505718,-34.746819],[118.024972,-35.064733],[117.295507,-35.025459],[116.625109,-35.025097],[115.564347,-34.386428],[115.026809,-34.196517],[115.048616,-33.623425],[115.545123,-33.487258],[115.714674,-33.259572],[115.679379,-32.900369],[115.801645,-32.205062],[115.689611,-31.612437],[115.160909,-30.601594],[114.997043,-30.030725],[115.040038,-29.461095],[114.641974,-28.810231],[114.616498,-28.516399],[114.173579,-28.118077],[114.048884,-27.334765],[113.477498,-26.543134],[113.338953,-26.116545],[113.778358,-26.549025],[113.440962,-25.621278],[113.936901,-25.911235],[114.232852,-26.298446],[114.216161,-25.786281],[113.721255,-24.998939],[113.625344,-24.683971],[113.393523,-24.384764],[113.502044,-23.80635],[113.706993,-23.560215],[113.843418,-23.059987],[113.736552,-22.475475],[114.149756,-21.755881],[114.225307,-22.517488],[114.647762,-21.82952],[115.460167,-21.495173],[115.947373,-21.068688],[116.711615,-20.701682],[117.166316,-20.623599],[117.441545,-20.746899],[118.229559,-20.374208],[118.836085,-20.263311],[118.987807,-20.044203],[119.252494,-19.952942],[119.805225,-19.976506],[120.85622,-19.683708],[121.399856,-19.239756],[121.655138,-18.705318],[122.241665,-18.197649],[122.286624,-17.798603],[122.312772,-17.254967],[123.012574,-16.4052],[123.433789,-17.268558],[123.859345,-17.069035],[123.503242,-16.596506],[123.817073,-16.111316],[124.258287,-16.327944],[124.379726,-15.56706],[124.926153,-15.0751],[125.167275,-14.680396],[125.670087,-14.51007],[125.685796,-14.230656],[126.125149,-14.347341],[126.142823,-14.095987],[126.582589,-13.952791],[127.065867,-13.817968],[127.804633,-14.276906],[128.35969,-14.86917],[128.985543,-14.875991],[129.621473,-14.969784],[129.4096,-14.42067],[129.888641,-13.618703],[130.339466,-13.357376],[130.183506,-13.10752],[130.617795,-12.536392],[131.223495,-12.183649],[131.735091,-12.302453],[132.575298,-12.114041],[132.557212,-11.603012],[131.824698,-11.273782],[132.357224,-11.128519],[133.019561,-11.376411],[133.550846,-11.786515],[134.393068,-12.042365],[134.678632,-11.941183],[135.298491,-12.248606],[135.882693,-11.962267],[136.258381,-12.049342],[136.492475,-11.857209],[136.95162,-12.351959],[136.685125,-12.887223],[136.305407,-13.29123],[135.961758,-13.324509],[136.077617,-13.724278],[135.783836,-14.223989],[135.428664,-14.715432],[135.500184,-14.997741],[136.295175,-15.550265],[137.06536,-15.870762],[137.580471,-16.215082],[138.303217,-16.807604],[138.585164,-16.806622],[139.108543,-17.062679],[139.260575,-17.371601],[140.215245,-17.710805],[140.875463,-17.369069],[141.07111,-16.832047],[141.274095,-16.38887],[141.398222,-15.840532],[141.702183,-15.044921],[141.56338,-14.561333],[141.63552,-14.270395],[141.519869,-13.698078],[141.65092,-12.944688],[141.842691,-12.741548],[141.68699,-12.407614],[141.928629,-11.877466],[142.118488,-11.328042],[142.143706,-11.042737],[142.51526,-10.668186],[142.79731,-11.157355],[142.866763,-11.784707],[143.115947,-11.90563],[143.158632,-12.325656],[143.522124,-12.834358],[143.597158,-13.400422],[143.561811,-13.763656]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":8754413,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"AT\",\"ISO_A3\":\"AUT\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[9.47997,46.431817,16.979667,49.039074],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[16.979667,48.123497],[16.903754,47.714866],[16.340584,47.712902],[16.534268,47.496171],[16.202298,46.852386],[16.011664,46.683611],[15.137092,46.658703],[14.632472,46.431817],[13.806475,46.509306],[12.376485,46.767559],[12.153088,47.115393],[11.164828,46.941579],[11.048556,46.751359],[10.442701,46.893546],[9.932448,46.920728],[9.47997,47.10281],[9.632932,47.347601],[9.594226,47.525058],[9.896068,47.580197],[10.402084,47.302488],[10.544504,47.566399],[11.426414,47.523766],[12.141357,47.703083],[12.62076,47.672388],[12.932627,47.467646],[13.025851,47.637584],[12.884103,48.289146],[13.243357,48.416115],[13.595946,48.877172],[14.338898,48.555305],[14.901447,48.964402],[15.253416,49.039074],[16.029647,48.733899],[16.499283,48.785808],[16.960288,48.596982],[16.879983,48.470013],[16.979667,48.123497]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":9961396,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"AZ\",\"ISO_A3\":\"AZE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[44.79399,38.270378,50.392821,41.860675],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[46.50572,38.770605],[46.483499,39.464155],[46.034534,39.628021],[45.610012,39.899994],[45.891907,40.218476],[45.359175,40.561504],[45.560351,40.81229],[45.179496,40.985354],[44.97248,41.248129],[45.217426,41.411452],[45.962601,41.123873],[46.501637,41.064445],[46.637908,41.181673],[46.145432,41.722802],[46.404951,41.860675],[46.686071,41.827137],[47.373315,41.219732],[47.815666,41.151416],[47.987283,41.405819],[48.584353,41.808869],[49.110264,41.282287],[49.618915,40.572924],[50.08483,40.526157],[50.392821,40.256561],[49.569202,40.176101],[49.395259,39.399482],[49.223228,39.049219],[48.856532,38.815486],[48.883249,38.320245],[48.634375,38.270378],[48.010744,38.794015],[48.355529,39.288765],[48.060095,39.582235],[47.685079,39.508364],[46.50572,38.770605]]],[[[44.79399,39.713003],[45.001987,39.740004],[45.298145,39.471751],[45.739978,39.473999],[45.735379,39.319719],[46.143623,38.741201],[45.457722,38.874139],[44.952688,39.335765],[44.79399,39.713003]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":11466756,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"BI\",\"ISO_A3\":\"BDI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[29.024926,-4.499983,30.75224,-2.348487],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[29.339998,-4.499983],[29.276384,-3.293907],[29.024926,-2.839258],[29.632176,-2.917858],[29.938359,-2.348487],[30.469674,-2.413855],[30.52766,-2.80762],[30.74301,-3.03431],[30.75224,-3.35931],[30.50554,-3.56858],[30.11632,-4.09012],[29.753512,-4.452389],[29.339998,-4.499983]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":11491346,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"BE\",\"ISO_A3\":\"BEL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[2.513573,49.529484,6.156658,51.475024],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[4.047071,51.267259],[4.973991,51.475024],[5.606976,51.037298],[6.156658,50.803721],[6.043073,50.128052],[5.782417,50.090328],[5.674052,49.529484],[4.799222,49.985373],[4.286023,49.907497],[3.588184,50.378992],[3.123252,50.780363],[2.658422,50.796848],[2.513573,51.148506],[3.314971,51.345781],[3.315011,51.345777],[3.314971,51.345755],[4.047071,51.267259]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":11038805,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"BJ\",\"ISO_A3\":\"BEN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[0.772336,6.142158,3.797112,12.235636],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[2.691702,6.258817],[1.865241,6.142158],[1.618951,6.832038],[1.664478,9.12859],[1.463043,9.334624],[1.425061,9.825395],[1.077795,10.175607],[0.772336,10.470808],[0.899563,10.997339],[1.24347,11.110511],[1.447178,11.547719],[1.935986,11.64115],[2.154474,11.94015],[2.490164,12.233052],[2.848643,12.235636],[3.61118,11.660167],[3.572216,11.327939],[3.797112,10.734746],[3.60007,10.332186],[3.705438,10.06321],[3.220352,9.444153],[2.912308,9.137608],[2.723793,8.506845],[2.749063,7.870734],[2.691702,6.258817]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":20107509,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"BF\",\"ISO_A3\":\"BFA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-5.470565,9.610835,2.177108,15.116158],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[2.154474,11.94015],[1.935986,11.64115],[1.447178,11.547719],[1.24347,11.110511],[0.899563,10.997339],[0.023803,11.018682],[-0.438702,11.098341],[-0.761576,10.93693],[-1.203358,11.009819],[-2.940409,10.96269],[-2.963896,10.395335],[-2.827496,9.642461],[-3.511899,9.900326],[-3.980449,9.862344],[-4.330247,9.610835],[-4.779884,9.821985],[-4.954653,10.152714],[-5.404342,10.370737],[-5.470565,10.95127],[-5.197843,11.375146],[-5.220942,11.713859],[-4.427166,12.542646],[-4.280405,13.228444],[-4.006391,13.472485],[-3.522803,13.337662],[-3.103707,13.541267],[-2.967694,13.79815],[-2.191825,14.246418],[-2.001035,14.559008],[-1.066363,14.973815],[-0.515854,15.116158],[-0.266257,14.924309],[0.374892,14.928908],[0.295646,14.444235],[0.429928,13.988733],[0.993046,13.33575],[1.024103,12.851826],[2.177108,12.625018],[2.154474,11.94015]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":157826578,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"BD\",\"ISO_A3\":\"BGD\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[88.084422,20.670883,92.672721,26.446526],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[92.672721,22.041239],[92.652257,21.324048],[92.303234,21.475485],[92.368554,20.670883],[92.082886,21.192195],[92.025215,21.70157],[91.834891,22.182936],[91.417087,22.765019],[90.496006,22.805017],[90.586957,22.392794],[90.272971,21.836368],[89.847467,22.039146],[89.70205,21.857116],[89.418863,21.966179],[89.031961,22.055708],[88.876312,22.879146],[88.52977,23.631142],[88.69994,24.233715],[88.084422,24.501657],[88.306373,24.866079],[88.931554,25.238692],[88.209789,25.768066],[88.563049,26.446526],[89.355094,26.014407],[89.832481,25.965082],[89.920693,25.26975],[90.872211,25.132601],[91.799596,25.147432],[92.376202,24.976693],[91.915093,24.130414],[91.46773,24.072639],[91.158963,23.503527],[91.706475,22.985264],[91.869928,23.624346],[92.146035,23.627499],[92.672721,22.041239]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":7101510,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"BG\",\"ISO_A3\":\"BGR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[22.380526,41.234486,28.558081,44.234923],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[22.65715,44.234923],[22.944832,43.823785],[23.332302,43.897011],[24.100679,43.741051],[25.569272,43.688445],[26.065159,43.943494],[27.2424,44.175986],[27.970107,43.812468],[28.558081,43.707462],[28.039095,43.293172],[27.673898,42.577892],[27.99672,42.007359],[27.135739,42.141485],[26.117042,41.826905],[26.106138,41.328899],[25.197201,41.234486],[24.492645,41.583896],[23.692074,41.309081],[22.952377,41.337994],[22.881374,41.999297],[22.380526,42.32026],[22.545012,42.461362],[22.436595,42.580321],[22.604801,42.898519],[22.986019,43.211161],[22.500157,43.642814],[22.410446,44.008063],[22.65715,44.234923]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":329988,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"BS\",\"ISO_A3\":\"BHS\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-78.98,23.71,-77,27.04],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-77.53466,23.75975],[-77.78,23.71],[-78.03405,24.28615],[-78.40848,24.57564],[-78.19087,25.2103],[-77.89,25.17],[-77.54,24.34],[-77.53466,23.75975]]],[[[-77.82,26.58],[-78.91,26.42],[-78.98,26.79],[-78.51,26.87],[-77.85,26.84],[-77.82,26.58]]],[[[-77,26.59],[-77.17255,25.87918],[-77.35641,26.00735],[-77.34,26.53],[-77.78802,26.92516],[-77.79,27.04],[-77,26.59]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3856181,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"BA\",\"ISO_A3\":\"BIH\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9.5},\"bbox\":[15.750026,42.65,19.59976,45.233777],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[19.36803,44.863],[19.11761,44.42307],[19.59976,44.03847],[19.454,43.5681],[19.21852,43.52384],[19.03165,43.43253],[18.70648,43.20011],[18.56,42.65],[17.674922,43.028563],[17.297373,43.446341],[16.916156,43.667722],[16.456443,44.04124],[16.23966,44.351143],[15.750026,44.818712],[15.959367,45.233777],[16.318157,45.004127],[16.534939,45.211608],[17.002146,45.233777],[17.861783,45.06774],[18.553214,45.08159],[19.005485,44.860234],[19.00548,44.86023],[19.36803,44.863]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":9549747,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"BY\",\"ISO_A3\":\"BLR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[23.199494,51.319503,32.693643,56.16913],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[23.484128,53.912498],[24.450684,53.905702],[25.536354,54.282423],[25.768433,54.846963],[26.588279,55.167176],[26.494331,55.615107],[27.10246,55.783314],[28.176709,56.16913],[29.229513,55.918344],[29.371572,55.670091],[29.896294,55.789463],[30.873909,55.550976],[30.971836,55.081548],[30.757534,54.811771],[31.384472,54.157056],[31.791424,53.974639],[31.731273,53.794029],[32.405599,53.618045],[32.693643,53.351421],[32.304519,53.132726],[31.49764,53.16743],[31.305201,53.073996],[31.540018,52.742052],[31.78597,52.10168],[31.785992,52.101678],[30.927549,52.042353],[30.619454,51.822806],[30.555117,51.319503],[30.157364,51.416138],[29.254938,51.368234],[28.992835,51.602044],[28.617613,51.427714],[28.241615,51.572227],[27.454066,51.592303],[26.337959,51.832289],[25.327788,51.910656],[24.553106,51.888461],[24.005078,51.617444],[23.527071,51.578454],[23.508002,52.023647],[23.199494,52.486977],[23.799199,52.691099],[23.804935,53.089731],[23.527536,53.470122],[23.484128,53.912498]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":360346,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"BZ\",\"ISO_A3\":\"BLZ\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[-89.229122,15.886938,-88.106813,18.499982],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-89.14308,17.808319],[-89.150909,17.955468],[-89.029857,18.001511],[-88.848344,17.883198],[-88.490123,18.486831],[-88.300031,18.499982],[-88.296336,18.353273],[-88.106813,18.348674],[-88.123479,18.076675],[-88.285355,17.644143],[-88.197867,17.489475],[-88.302641,17.131694],[-88.239518,17.036066],[-88.355428,16.530774],[-88.551825,16.265467],[-88.732434,16.233635],[-88.930613,15.887273],[-89.229122,15.886938],[-89.150806,17.015577],[-89.14308,17.808319]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":11138234,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"BO\",\"ISO_A3\":\"BOL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7.5},\"bbox\":[-69.590424,-22.872919,-57.498371,-9.761988],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-62.685057,-22.249029],[-62.846468,-22.034985],[-63.986838,-21.993644],[-64.377021,-22.798091],[-64.964892,-22.075862],[-66.273339,-21.83231],[-67.106674,-22.735925],[-67.82818,-22.872919],[-68.219913,-21.494347],[-68.757167,-20.372658],[-68.442225,-19.405068],[-68.966818,-18.981683],[-69.100247,-18.260125],[-69.590424,-17.580012],[-68.959635,-16.500698],[-69.389764,-15.660129],[-69.160347,-15.323974],[-69.339535,-14.953195],[-68.948887,-14.453639],[-68.929224,-13.602684],[-68.88008,-12.899729],[-68.66508,-12.5613],[-69.529678,-10.951734],[-68.786158,-11.03638],[-68.271254,-11.014521],[-68.048192,-10.712059],[-67.173801,-10.306812],[-66.646908,-9.931331],[-65.338435,-9.761988],[-65.444837,-10.511451],[-65.321899,-10.895872],[-65.402281,-11.56627],[-64.316353,-12.461978],[-63.196499,-12.627033],[-62.80306,-13.000653],[-62.127081,-13.198781],[-61.713204,-13.489202],[-61.084121,-13.479384],[-60.503304,-13.775955],[-60.459198,-14.354007],[-60.264326,-14.645979],[-60.251149,-15.077219],[-60.542966,-15.09391],[-60.15839,-16.258284],[-58.24122,-16.299573],[-58.388058,-16.877109],[-58.280804,-17.27171],[-57.734558,-17.552468],[-57.498371,-18.174188],[-57.676009,-18.96184],[-57.949997,-19.400004],[-57.853802,-19.969995],[-58.166392,-20.176701],[-58.183471,-19.868399],[-59.115042,-19.356906],[-60.043565,-19.342747],[-61.786326,-19.633737],[-62.265961,-20.513735],[-62.291179,-21.051635],[-62.685057,-22.249029]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":207353391,\"ECONOMY\":\"3. Emerging region: BRIC\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"BR\",\"ISO_A3\":\"BRA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":5.7},\"bbox\":[-73.987235,-33.768378,-34.729993,5.244486],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-57.625133,-30.216295],[-56.2909,-28.852761],[-55.162286,-27.881915],[-54.490725,-27.474757],[-53.648735,-26.923473],[-53.628349,-26.124865],[-54.13005,-25.547639],[-54.625291,-25.739255],[-54.428946,-25.162185],[-54.293476,-24.5708],[-54.29296,-24.021014],[-54.652834,-23.839578],[-55.027902,-24.001274],[-55.400747,-23.956935],[-55.517639,-23.571998],[-55.610683,-22.655619],[-55.797958,-22.35693],[-56.473317,-22.0863],[-56.88151,-22.282154],[-57.937156,-22.090176],[-57.870674,-20.732688],[-58.166392,-20.176701],[-57.853802,-19.969995],[-57.949997,-19.400004],[-57.676009,-18.96184],[-57.498371,-18.174188],[-57.734558,-17.552468],[-58.280804,-17.27171],[-58.388058,-16.877109],[-58.24122,-16.299573],[-60.15839,-16.258284],[-60.542966,-15.09391],[-60.251149,-15.077219],[-60.264326,-14.645979],[-60.459198,-14.354007],[-60.503304,-13.775955],[-61.084121,-13.479384],[-61.713204,-13.489202],[-62.127081,-13.198781],[-62.80306,-13.000653],[-63.196499,-12.627033],[-64.316353,-12.461978],[-65.402281,-11.56627],[-65.321899,-10.895872],[-65.444837,-10.511451],[-65.338435,-9.761988],[-66.646908,-9.931331],[-67.173801,-10.306812],[-68.048192,-10.712059],[-68.271254,-11.014521],[-68.786158,-11.03638],[-69.529678,-10.951734],[-70.093752,-11.123972],[-70.548686,-11.009147],[-70.481894,-9.490118],[-71.302412,-10.079436],[-72.184891,-10.053598],[-72.563033,-9.520194],[-73.226713,-9.462213],[-73.015383,-9.032833],[-73.571059,-8.424447],[-73.987235,-7.52383],[-73.723401,-7.340999],[-73.724487,-6.918595],[-73.120027,-6.629931],[-73.219711,-6.089189],[-72.964507,-5.741251],[-72.891928,-5.274561],[-71.748406,-4.593983],[-70.928843,-4.401591],[-70.794769,-4.251265],[-69.893635,-4.298187],[-69.444102,-1.556287],[-69.420486,-1.122619],[-69.577065,-0.549992],[-70.020656,-0.185156],[-70.015566,0.541414],[-69.452396,0.706159],[-69.252434,0.602651],[-69.218638,0.985677],[-69.804597,1.089081],[-69.816973,1.714805],[-67.868565,1.692455],[-67.53781,2.037163],[-67.259998,1.719999],[-67.065048,1.130112],[-66.876326,1.253361],[-66.325765,0.724452],[-65.548267,0.789254],[-65.354713,1.095282],[-64.611012,1.328731],[-64.199306,1.492855],[-64.083085,1.916369],[-63.368788,2.2009],[-63.422867,2.411068],[-64.269999,2.497006],[-64.408828,3.126786],[-64.368494,3.79721],[-64.816064,4.056445],[-64.628659,4.148481],[-63.888343,4.02053],[-63.093198,3.770571],[-62.804533,4.006965],[-62.08543,4.162124],[-60.966893,4.536468],[-60.601179,4.918098],[-60.733574,5.200277],[-60.213683,5.244486],[-59.980959,5.014061],[-60.111002,4.574967],[-59.767406,4.423503],[-59.53804,3.958803],[-59.815413,3.606499],[-59.974525,2.755233],[-59.718546,2.24963],[-59.646044,1.786894],[-59.030862,1.317698],[-58.540013,1.268088],[-58.429477,1.463942],[-58.11345,1.507195],[-57.660971,1.682585],[-57.335823,1.948538],[-56.782704,1.863711],[-56.539386,1.899523],[-55.995698,1.817667],[-55.9056,2.021996],[-56.073342,2.220795],[-55.973322,2.510364],[-55.569755,2.421506],[-55.097587,2.523748],[-54.524754,2.311849],[-54.088063,2.105557],[-53.778521,2.376703],[-53.554839,2.334897],[-53.418465,2.053389],[-52.939657,2.124858],[-52.556425,2.504705],[-52.249338,3.241094],[-51.657797,4.156232],[-51.317146,4.203491],[-51.069771,3.650398],[-50.508875,1.901564],[-49.974076,1.736483],[-49.947101,1.04619],[-50.699251,0.222984],[-50.388211,-0.078445],[-48.620567,-0.235489],[-48.584497,-1.237805],[-47.824956,-0.581618],[-46.566584,-0.941028],[-44.905703,-1.55174],[-44.417619,-2.13775],[-44.581589,-2.691308],[-43.418791,-2.38311],[-41.472657,-2.912018],[-39.978665,-2.873054],[-38.500383,-3.700652],[-37.223252,-4.820946],[-36.452937,-5.109404],[-35.597796,-5.149504],[-35.235389,-5.464937],[-34.89603,-6.738193],[-34.729993,-7.343221],[-35.128212,-8.996401],[-35.636967,-9.649282],[-37.046519,-11.040721],[-37.683612,-12.171195],[-38.423877,-13.038119],[-38.673887,-13.057652],[-38.953276,-13.79337],[-38.882298,-15.667054],[-39.161092,-17.208407],[-39.267339,-17.867746],[-39.583521,-18.262296],[-39.760823,-19.599113],[-40.774741,-20.904512],[-40.944756,-21.937317],[-41.754164,-22.370676],[-41.988284,-22.97007],[-43.074704,-22.967693],[-44.647812,-23.351959],[-45.352136,-23.796842],[-46.472093,-24.088969],[-47.648972,-24.885199],[-48.495458,-25.877025],[-48.641005,-26.623698],[-48.474736,-27.175912],[-48.66152,-28.186135],[-48.888457,-28.674115],[-49.587329,-29.224469],[-50.696874,-30.984465],[-51.576226,-31.777698],[-52.256081,-32.24537],[-52.7121,-33.196578],[-53.373662,-33.768378],[-53.650544,-33.202004],[-53.209589,-32.727666],[-53.787952,-32.047243],[-54.572452,-31.494511],[-55.60151,-30.853879],[-55.973245,-30.883076],[-56.976026,-30.109686],[-57.625133,-30.216295]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":443593,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"BN\",\"ISO_A3\":\"BRN\",\"TINY\":2,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[114.204017,4.007637,115.45071,5.44773],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[114.204017,4.525874],[114.599961,4.900011],[115.45071,5.44773],[115.4057,4.955228],[115.347461,4.316636],[114.869557,4.348314],[114.659596,4.007637],[114.204017,4.525874]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":758288,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"BT\",\"ISO_A3\":\"BTN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[88.814248,26.719403,92.103712,28.296439],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[91.696657,27.771742],[92.103712,27.452614],[92.033484,26.83831],[91.217513,26.808648],[90.373275,26.875724],[89.744528,26.719403],[88.835643,27.098966],[88.814248,27.299316],[89.47581,28.042759],[90.015829,28.296439],[90.730514,28.064954],[91.258854,28.040614],[91.696657,27.771742]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2214858,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"BW\",\"ISO_A3\":\"BWA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[19.895458,-26.828543,29.432188,-17.661816],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[29.432188,-22.091313],[28.017236,-22.827754],[27.11941,-23.574323],[26.786407,-24.240691],[26.485753,-24.616327],[25.941652,-24.696373],[25.765849,-25.174845],[25.664666,-25.486816],[25.025171,-25.71967],[24.211267,-25.670216],[23.73357,-25.390129],[23.312097,-25.26869],[22.824271,-25.500459],[22.579532,-25.979448],[22.105969,-26.280256],[21.605896,-26.726534],[20.889609,-26.828543],[20.66647,-26.477453],[20.758609,-25.868136],[20.165726,-24.917962],[19.895768,-24.76779],[19.895458,-21.849157],[20.881134,-21.814327],[20.910641,-18.252219],[21.65504,-18.219146],[23.196858,-17.869038],[23.579006,-18.281261],[24.217365,-17.889347],[24.520705,-17.887125],[25.084443,-17.661816],[25.264226,-17.73654],[25.649163,-18.536026],[25.850391,-18.714413],[26.164791,-19.293086],[27.296505,-20.39152],[27.724747,-20.499059],[27.727228,-20.851802],[28.02137,-21.485975],[28.794656,-21.639454],[29.432188,-22.091313]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5625118,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"CF\",\"ISO_A3\":\"CAF\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[14.459407,2.26764,27.374226,11.142395],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[15.27946,7.421925],[16.106232,7.497088],[16.290562,7.754307],[16.456185,7.734774],[16.705988,7.508328],[17.96493,7.890914],[18.389555,8.281304],[18.911022,8.630895],[18.81201,8.982915],[19.094008,9.074847],[20.059685,9.012706],[21.000868,9.475985],[21.723822,10.567056],[22.231129,10.971889],[22.864165,11.142395],[22.977544,10.714463],[23.554304,10.089255],[23.55725,9.681218],[23.394779,9.265068],[23.459013,8.954286],[23.805813,8.666319],[24.567369,8.229188],[25.114932,7.825104],[25.124131,7.500085],[25.796648,6.979316],[26.213418,6.546603],[26.465909,5.946717],[27.213409,5.550953],[27.374226,5.233944],[27.044065,5.127853],[26.402761,5.150875],[25.650455,5.256088],[25.278798,5.170408],[25.128833,4.927245],[24.805029,4.897247],[24.410531,5.108784],[23.297214,4.609693],[22.84148,4.710126],[22.704124,4.633051],[22.405124,4.02916],[21.659123,4.224342],[20.927591,4.322786],[20.290679,4.691678],[19.467784,5.031528],[18.932312,4.709506],[18.542982,4.201785],[18.453065,3.504386],[17.8099,3.560196],[17.133042,3.728197],[16.537058,3.198255],[16.012852,2.26764],[15.907381,2.557389],[15.862732,3.013537],[15.405396,3.335301],[15.03622,3.851367],[14.950953,4.210389],[14.478372,4.732605],[14.558936,5.030598],[14.459407,5.451761],[14.53656,6.226959],[14.776545,6.408498],[15.27946,7.421925]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":35623680,\"ECONOMY\":\"1. Developed region: G7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"CA\",\"ISO_A3\":\"CAN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":5.7},\"bbox\":[-140.99778,41.675105,-52.648099,83.23324],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-63.6645,46.55001],[-62.9393,46.41587],[-62.01208,46.44314],[-62.50391,46.03339],[-62.87433,45.96818],[-64.1428,46.39265],[-64.39261,46.72747],[-64.01486,47.03601],[-63.6645,46.55001]]],[[[-61.806305,49.10506],[-62.29318,49.08717],[-63.58926,49.40069],[-64.51912,49.87304],[-64.17322,49.95718],[-62.85829,49.70641],[-61.835585,49.28855],[-61.806305,49.10506]]],[[[-123.510002,48.510011],[-124.012891,48.370846],[-125.655013,48.825005],[-125.954994,49.179996],[-126.850004,49.53],[-127.029993,49.814996],[-128.059336,49.994959],[-128.444584,50.539138],[-128.358414,50.770648],[-127.308581,50.552574],[-126.695001,50.400903],[-125.755007,50.295018],[-125.415002,49.950001],[-124.920768,49.475275],[-123.922509,49.062484],[-123.510002,48.510011]]],[[[-56.134036,50.68701],[-56.795882,49.812309],[-56.143105,50.150117],[-55.471492,49.935815],[-55.822401,49.587129],[-54.935143,49.313011],[-54.473775,49.556691],[-53.476549,49.249139],[-53.786014,48.516781],[-53.086134,48.687804],[-52.958648,48.157164],[-52.648099,47.535548],[-53.069158,46.655499],[-53.521456,46.618292],[-54.178936,46.807066],[-53.961869,47.625207],[-54.240482,47.752279],[-55.400773,46.884994],[-55.997481,46.91972],[-55.291219,47.389562],[-56.250799,47.632545],[-57.325229,47.572807],[-59.266015,47.603348],[-59.419494,47.899454],[-58.796586,48.251525],[-59.231625,48.523188],[-58.391805,49.125581],[-57.35869,50.718274],[-56.73865,51.287438],[-55.870977,51.632094],[-55.406974,51.588273],[-55.600218,51.317075],[-56.134036,50.68701]]],[[[-133.180004,54.169975],[-132.710008,54.040009],[-131.74999,54.120004],[-132.04948,52.984621],[-131.179043,52.180433],[-131.57783,52.182371],[-132.180428,52.639707],[-132.549992,53.100015],[-133.054611,53.411469],[-133.239664,53.85108],[-133.180004,54.169975]]],[[[-79.26582,62.158675],[-79.65752,61.63308],[-80.09956,61.7181],[-80.36215,62.01649],[-80.315395,62.085565],[-79.92939,62.3856],[-79.52002,62.36371],[-79.26582,62.158675]]],[[[-81.89825,62.7108],[-83.06857,62.15922],[-83.77462,62.18231],[-83.99367,62.4528],[-83.25048,62.91409],[-81.87699,62.90458],[-81.89825,62.7108]]],[[[-85.161308,65.657285],[-84.975764,65.217518],[-84.464012,65.371772],[-83.882626,65.109618],[-82.787577,64.766693],[-81.642014,64.455136],[-81.55344,63.979609],[-80.817361,64.057486],[-80.103451,63.725981],[-80.99102,63.411246],[-82.547178,63.651722],[-83.108798,64.101876],[-84.100417,63.569712],[-85.523405,63.052379],[-85.866769,63.637253],[-87.221983,63.541238],[-86.35276,64.035833],[-86.224886,64.822917],[-85.883848,65.738778],[-85.161308,65.657285]]],[[[-75.86588,67.14886],[-76.98687,67.09873],[-77.2364,67.58809],[-76.81166,68.14856],[-75.89521,68.28721],[-75.1145,68.01036],[-75.10333,67.58202],[-75.21597,67.44425],[-75.86588,67.14886]]],[[[-95.647681,69.10769],[-96.269521,68.75704],[-97.617401,69.06003],[-98.431801,68.9507],[-99.797401,69.40003],[-98.917401,69.71003],[-98.218261,70.14354],[-97.157401,69.86003],[-96.557401,69.68003],[-96.257401,69.49003],[-95.647681,69.10769]]],[[[-68.23444,47.35486],[-68.905,47.185],[-69.237216,47.447781],[-69.99997,46.69307],[-70.305,45.915],[-70.66,45.46],[-71.08482,45.30524],[-71.405,45.255],[-71.50506,45.0082],[-73.34783,45.00738],[-74.867,45.00048],[-75.31821,44.81645],[-76.375,44.09631],[-76.5,44.018459],[-76.820034,43.628784],[-77.737885,43.629056],[-78.72028,43.625089],[-79.171674,43.466339],[-79.01,43.27],[-78.92,42.965],[-78.939362,42.863611],[-80.247448,42.3662],[-81.277747,42.209026],[-82.439278,41.675105],[-82.690089,41.675105],[-83.02981,41.832796],[-83.142,41.975681],[-83.12,42.08],[-82.9,42.43],[-82.43,42.98],[-82.137642,43.571088],[-82.337763,44.44],[-82.550925,45.347517],[-83.592851,45.816894],[-83.469551,45.994686],[-83.616131,46.116927],[-83.890765,46.116927],[-84.091851,46.275419],[-84.14212,46.512226],[-84.3367,46.40877],[-84.6049,46.4396],[-84.543749,46.538684],[-84.779238,46.637102],[-84.87608,46.900083],[-85.652363,47.220219],[-86.461991,47.553338],[-87.439793,47.94],[-88.378114,48.302918],[-89.272917,48.019808],[-89.6,48.01],[-90.83,48.27],[-91.64,48.14],[-92.61,48.45],[-93.63087,48.60926],[-94.32914,48.67074],[-94.64,48.84],[-94.81758,49.38905],[-95.15609,49.38425],[-95.15907,49],[-97.22872,49.0007],[-100.65,49],[-104.04826,48.99986],[-107.05,49],[-110.05,49],[-113,49],[-116.04818,49],[-117.03121,49],[-120,49],[-122.84,49],[-122.97421,49.002538],[-124.91024,49.98456],[-125.62461,50.41656],[-127.43561,50.83061],[-127.99276,51.71583],[-127.85032,52.32961],[-129.12979,52.75538],[-129.30523,53.56159],[-130.51497,54.28757],[-130.536109,54.802754],[-130.53611,54.80278],[-129.98,55.285],[-130.00778,55.91583],[-131.70781,56.55212],[-132.73042,57.69289],[-133.35556,58.41028],[-134.27111,58.86111],[-134.945,59.27056],[-135.47583,59.78778],[-136.47972,59.46389],[-137.4525,58.905],[-138.34089,59.56211],[-139.039,60],[-140.013,60.27682],[-140.99778,60.30639],[-140.9925,66.00003],[-140.986,69.712],[-140.985988,69.711998],[-139.12052,69.47102],[-137.54636,68.99002],[-136.50358,68.89804],[-135.62576,69.31512],[-134.41464,69.62743],[-132.92925,69.50534],[-131.43136,69.94451],[-129.79471,70.19369],[-129.10773,69.77927],[-128.36156,70.01286],[-128.13817,70.48384],[-127.44712,70.37721],[-125.75632,69.48058],[-124.42483,70.1584],[-124.28968,69.39969],[-123.06108,69.56372],[-122.6835,69.85553],[-121.47226,69.79778],[-119.94288,69.37786],[-117.60268,69.01128],[-116.22643,68.84151],[-115.2469,68.90591],[-113.89794,68.3989],[-115.30489,67.90261],[-113.49727,67.68815],[-110.798,67.80612],[-109.94619,67.98104],[-108.8802,67.38144],[-107.79239,67.88736],[-108.81299,68.31164],[-108.16721,68.65392],[-106.95,68.7],[-106.15,68.8],[-105.34282,68.56122],[-104.33791,68.018],[-103.22115,68.09775],[-101.45433,67.64689],[-99.90195,67.80566],[-98.4432,67.78165],[-98.5586,68.40394],[-97.66948,68.57864],[-96.11991,68.23939],[-96.12588,67.29338],[-95.48943,68.0907],[-94.685,68.06383],[-94.23282,69.06903],[-95.30408,69.68571],[-96.47131,70.08976],[-96.39115,71.19482],[-95.2088,71.92053],[-93.88997,71.76015],[-92.87818,71.31869],[-91.51964,70.19129],[-92.40692,69.69997],[-90.5471,69.49766],[-90.55151,68.47499],[-89.21515,69.25873],[-88.01966,68.61508],[-88.31749,67.87338],[-87.35017,67.19872],[-86.30607,67.92146],[-85.57664,68.78456],[-85.52197,69.88211],[-84.10081,69.80539],[-82.62258,69.65826],[-81.28043,69.16202],[-81.2202,68.66567],[-81.96436,68.13253],[-81.25928,67.59716],[-81.38653,67.11078],[-83.34456,66.41154],[-84.73542,66.2573],[-85.76943,66.55833],[-86.0676,66.05625],[-87.03143,65.21297],[-87.32324,64.77563],[-88.48296,64.09897],[-89.91444,64.03273],[-90.70398,63.61017],[-90.77004,62.96021],[-91.93342,62.83508],[-93.15698,62.02469],[-94.24153,60.89865],[-94.62931,60.11021],[-94.6846,58.94882],[-93.21502,58.78212],[-92.76462,57.84571],[-92.29703,57.08709],[-90.89769,57.28468],[-89.03953,56.85172],[-88.03978,56.47162],[-87.32421,55.99914],[-86.07121,55.72383],[-85.01181,55.3026],[-83.36055,55.24489],[-82.27285,55.14832],[-82.4362,54.28227],[-82.12502,53.27703],[-81.40075,52.15788],[-79.91289,51.20842],[-79.14301,51.53393],[-78.60191,52.56208],[-79.12421,54.14145],[-79.82958,54.66772],[-78.22874,55.13645],[-77.0956,55.83741],[-76.54137,56.53423],[-76.62319,57.20263],[-77.30226,58.05209],[-78.51688,58.80458],[-77.33676,59.85261],[-77.77272,60.75788],[-78.10687,62.31964],[-77.41067,62.55053],[-75.69621,62.2784],[-74.6682,62.18111],[-73.83988,62.4438],[-72.90853,62.10507],[-71.67708,61.52535],[-71.37369,61.13717],[-69.59042,61.06141],[-69.62033,60.22125],[-69.2879,58.95736],[-68.37455,58.80106],[-67.64976,58.21206],[-66.20178,58.76731],[-65.24517,59.87071],[-64.58352,60.33558],[-63.80475,59.4426],[-62.50236,58.16708],[-61.39655,56.96745],[-61.79866,56.33945],[-60.46853,55.77548],[-59.56962,55.20407],[-57.97508,54.94549],[-57.3332,54.6265],[-56.93689,53.78032],[-56.15811,53.64749],[-55.75632,53.27036],[-55.68338,52.14664],[-56.40916,51.7707],[-57.12691,51.41972],[-58.77482,51.0643],[-60.03309,50.24277],[-61.72366,50.08046],[-63.86251,50.29099],[-65.36331,50.2982],[-66.39905,50.22897],[-67.23631,49.51156],[-68.51114,49.06836],[-69.95362,47.74488],[-71.10458,46.82171],[-70.25522,46.98606],[-68.65,48.3],[-66.55243,49.1331],[-65.05626,49.23278],[-64.17099,48.74248],[-65.11545,48.07085],[-64.79854,46.99297],[-64.47219,46.23849],[-63.17329,45.73902],[-61.52072,45.88377],[-60.51815,47.00793],[-60.4486,46.28264],[-59.80287,45.9204],[-61.03988,45.26525],[-63.25471,44.67014],[-64.24656,44.26553],[-65.36406,43.54523],[-66.1234,43.61867],[-66.16173,44.46512],[-64.42549,45.29204],[-66.02605,45.25931],[-67.13741,45.13753],[-67.79134,45.70281],[-67.79046,47.06636],[-68.23444,47.35486]]],[[[-114.16717,73.12145],[-114.66634,72.65277],[-112.44102,72.9554],[-111.05039,72.4504],[-109.92035,72.96113],[-109.00654,72.63335],[-108.18835,71.65089],[-107.68599,72.06548],[-108.39639,73.08953],[-107.51645,73.23598],[-106.52259,73.07601],[-105.40246,72.67259],[-104.77484,71.6984],[-104.46476,70.99297],[-102.78537,70.49776],[-100.98078,70.02432],[-101.08929,69.58447],[-102.73116,69.50402],[-102.09329,69.11962],[-102.43024,68.75282],[-104.24,68.91],[-105.96,69.18],[-107.12254,69.11922],[-109,68.78],[-111.534149,68.630059],[-113.3132,68.53554],[-113.85496,69.00744],[-115.22,69.28],[-116.10794,69.16821],[-117.34,69.96],[-116.67473,70.06655],[-115.13112,70.2373],[-113.72141,70.19237],[-112.4161,70.36638],[-114.35,70.6],[-116.48684,70.52045],[-117.9048,70.54056],[-118.43238,70.9092],[-116.11311,71.30918],[-117.65568,71.2952],[-119.40199,71.55859],[-118.56267,72.30785],[-117.86642,72.70594],[-115.18909,73.31459],[-114.16717,73.12145]]],[[[-104.5,73.42],[-105.38,72.76],[-106.94,73.46],[-106.6,73.6],[-105.26,73.64],[-104.5,73.42]]],[[[-76.34,73.102685],[-76.251404,72.826385],[-77.314438,72.855545],[-78.39167,72.876656],[-79.486252,72.742203],[-79.775833,72.802902],[-80.876099,73.333183],[-80.833885,73.693184],[-80.353058,73.75972],[-78.064438,73.651932],[-76.34,73.102685]]],[[[-86.562179,73.157447],[-85.774371,72.534126],[-84.850112,73.340278],[-82.31559,73.750951],[-80.600088,72.716544],[-80.748942,72.061907],[-78.770639,72.352173],[-77.824624,72.749617],[-75.605845,72.243678],[-74.228616,71.767144],[-74.099141,71.33084],[-72.242226,71.556925],[-71.200015,70.920013],[-68.786054,70.525024],[-67.91497,70.121948],[-66.969033,69.186087],[-68.805123,68.720198],[-66.449866,68.067163],[-64.862314,67.847539],[-63.424934,66.928473],[-61.851981,66.862121],[-62.163177,66.160251],[-63.918444,64.998669],[-65.14886,65.426033],[-66.721219,66.388041],[-68.015016,66.262726],[-68.141287,65.689789],[-67.089646,65.108455],[-65.73208,64.648406],[-65.320168,64.382737],[-64.669406,63.392927],[-65.013804,62.674185],[-66.275045,62.945099],[-68.783186,63.74567],[-67.369681,62.883966],[-66.328297,62.280075],[-66.165568,61.930897],[-68.877367,62.330149],[-71.023437,62.910708],[-72.235379,63.397836],[-71.886278,63.679989],[-73.378306,64.193963],[-74.834419,64.679076],[-74.818503,64.389093],[-77.70998,64.229542],[-78.555949,64.572906],[-77.897281,65.309192],[-76.018274,65.326969],[-73.959795,65.454765],[-74.293883,65.811771],[-73.944912,66.310578],[-72.651167,67.284576],[-72.92606,67.726926],[-73.311618,68.069437],[-74.843307,68.554627],[-76.869101,68.894736],[-76.228649,69.147769],[-77.28737,69.76954],[-78.168634,69.826488],[-78.957242,70.16688],[-79.492455,69.871808],[-81.305471,69.743185],[-84.944706,69.966634],[-87.060003,70.260001],[-88.681713,70.410741],[-89.51342,70.762038],[-88.467721,71.218186],[-89.888151,71.222552],[-90.20516,72.235074],[-89.436577,73.129464],[-88.408242,73.537889],[-85.826151,73.803816],[-86.562179,73.157447]]],[[[-100.35642,73.84389],[-99.16387,73.63339],[-97.38,73.76],[-97.12,73.47],[-98.05359,72.99052],[-96.54,72.56],[-96.72,71.66],[-98.35966,71.27285],[-99.32286,71.35639],[-100.01482,71.73827],[-102.5,72.51],[-102.48,72.83],[-100.43836,72.70588],[-101.54,73.36],[-100.35642,73.84389]]],[[[-93.196296,72.771992],[-94.269047,72.024596],[-95.409856,72.061881],[-96.033745,72.940277],[-96.018268,73.43743],[-95.495793,73.862417],[-94.503658,74.134907],[-92.420012,74.100025],[-90.509793,73.856732],[-92.003965,72.966244],[-93.196296,72.771992]]],[[[-120.46,71.383602],[-123.09219,70.90164],[-123.62,71.34],[-125.928949,71.868688],[-125.5,72.292261],[-124.80729,73.02256],[-123.94,73.68],[-124.91775,74.29275],[-121.53788,74.44893],[-120.10978,74.24135],[-117.55564,74.18577],[-116.58442,73.89607],[-115.51081,73.47519],[-116.76794,73.22292],[-119.22,72.52],[-120.46,71.82],[-120.46,71.383602]]],[[[-93.612756,74.979997],[-94.156909,74.592347],[-95.608681,74.666864],[-96.820932,74.927623],[-96.288587,75.377828],[-94.85082,75.647218],[-93.977747,75.29649],[-93.612756,74.979997]]],[[[-98.5,76.72],[-97.735585,76.25656],[-97.704415,75.74344],[-98.16,75],[-99.80874,74.89744],[-100.88366,75.05736],[-100.86292,75.64075],[-102.50209,75.5638],[-102.56552,76.3366],[-101.48973,76.30537],[-99.98349,76.64634],[-98.57699,76.58859],[-98.5,76.72]]],[[[-108.21141,76.20168],[-107.81943,75.84552],[-106.92893,76.01282],[-105.881,75.9694],[-105.70498,75.47951],[-106.31347,75.00527],[-109.7,74.85],[-112.22307,74.41696],[-113.74381,74.39427],[-113.87135,74.72029],[-111.79421,75.1625],[-116.31221,75.04343],[-117.7104,75.2222],[-116.34602,76.19903],[-115.40487,76.47887],[-112.59056,76.14134],[-110.81422,75.54919],[-109.0671,75.47321],[-110.49726,76.42982],[-109.5811,76.79417],[-108.54859,76.67832],[-108.21141,76.20168]]],[[[-94.684086,77.097878],[-93.573921,76.776296],[-91.605023,76.778518],[-90.741846,76.449597],[-90.969661,76.074013],[-89.822238,75.847774],[-89.187083,75.610166],[-87.838276,75.566189],[-86.379192,75.482421],[-84.789625,75.699204],[-82.753445,75.784315],[-81.128531,75.713983],[-80.057511,75.336849],[-79.833933,74.923127],[-80.457771,74.657304],[-81.948843,74.442459],[-83.228894,74.564028],[-86.097452,74.410032],[-88.15035,74.392307],[-89.764722,74.515555],[-92.422441,74.837758],[-92.768285,75.38682],[-92.889906,75.882655],[-93.893824,76.319244],[-95.962457,76.441381],[-97.121379,76.751078],[-96.745123,77.161389],[-94.684086,77.097878]]],[[[-116.198587,77.645287],[-116.335813,76.876962],[-117.106051,76.530032],[-118.040412,76.481172],[-119.899318,76.053213],[-121.499995,75.900019],[-122.854924,76.116543],[-122.854925,76.116543],[-121.157535,76.864508],[-119.103939,77.51222],[-117.570131,77.498319],[-116.198587,77.645287]]],[[[-93.840003,77.519997],[-94.295608,77.491343],[-96.169654,77.555111],[-96.436304,77.834629],[-94.422577,77.820005],[-93.720656,77.634331],[-93.840003,77.519997]]],[[[-110.186938,77.697015],[-112.051191,77.409229],[-113.534279,77.732207],[-112.724587,78.05105],[-111.264443,78.152956],[-109.854452,77.996325],[-110.186938,77.697015]]],[[[-109.663146,78.601973],[-110.881314,78.40692],[-112.542091,78.407902],[-112.525891,78.550555],[-111.50001,78.849994],[-110.963661,78.804441],[-109.663146,78.601973]]],[[[-95.830295,78.056941],[-97.309843,77.850597],[-98.124289,78.082857],[-98.552868,78.458105],[-98.631984,78.87193],[-97.337231,78.831984],[-96.754399,78.765813],[-95.559278,78.418315],[-95.830295,78.056941]]],[[[-100.060192,78.324754],[-99.670939,77.907545],[-101.30394,78.018985],[-102.949809,78.343229],[-105.176133,78.380332],[-104.210429,78.67742],[-105.41958,78.918336],[-105.492289,79.301594],[-103.529282,79.165349],[-100.825158,78.800462],[-100.060192,78.324754]]],[[[-87.02,79.66],[-85.81435,79.3369],[-87.18756,79.0393],[-89.03535,78.28723],[-90.80436,78.21533],[-92.87669,78.34333],[-93.95116,78.75099],[-93.93574,79.11373],[-93.14524,79.3801],[-94.974,79.37248],[-96.07614,79.70502],[-96.70972,80.15777],[-96.01644,80.60233],[-95.32345,80.90729],[-94.29843,80.97727],[-94.73542,81.20646],[-92.40984,81.25739],[-91.13289,80.72345],[-89.45,80.509322],[-87.81,80.32],[-87.02,79.66]]],[[[-68.5,83.106322],[-65.82735,83.02801],[-63.68,82.9],[-61.85,82.6286],[-61.89388,82.36165],[-64.334,81.92775],[-66.75342,81.72527],[-67.65755,81.50141],[-65.48031,81.50657],[-67.84,80.9],[-69.4697,80.61683],[-71.18,79.8],[-73.2428,79.63415],[-73.88,79.430162],[-76.90773,79.32309],[-75.52924,79.19766],[-76.22046,79.01907],[-75.39345,78.52581],[-76.34354,78.18296],[-77.88851,77.89991],[-78.36269,77.50859],[-79.75951,77.20968],[-79.61965,76.98336],[-77.91089,77.022045],[-77.88911,76.777955],[-80.56125,76.17812],[-83.17439,76.45403],[-86.11184,76.29901],[-87.6,76.42],[-89.49068,76.47239],[-89.6161,76.95213],[-87.76739,77.17833],[-88.26,77.9],[-87.65,77.970222],[-84.97634,77.53873],[-86.34,78.18],[-87.96192,78.37181],[-87.15198,78.75867],[-85.37868,78.9969],[-85.09495,79.34543],[-86.50734,79.73624],[-86.93179,80.25145],[-84.19844,80.20836],[-83.408696,80.1],[-81.84823,80.46442],[-84.1,80.58],[-87.59895,80.51627],[-89.36663,80.85569],[-90.2,81.26],[-91.36786,81.5531],[-91.58702,81.89429],[-90.1,82.085],[-88.93227,82.11751],[-86.97024,82.27961],[-85.5,82.652273],[-84.260005,82.6],[-83.18,82.32],[-82.42,82.86],[-81.1,83.02],[-79.30664,83.13056],[-76.25,83.172059],[-75.71878,83.06404],[-72.83153,83.23324],[-70.665765,83.169781],[-68.5,83.106322]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":8236303,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"CH\",\"ISO_A3\":\"CHE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[6.022609,45.776948,10.442701,47.830828],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[9.594226,47.525058],[9.632932,47.347601],[9.47997,47.10281],[9.932448,46.920728],[10.442701,46.893546],[10.363378,46.483571],[9.922837,46.314899],[9.182882,46.440215],[8.966306,46.036932],[8.489952,46.005151],[8.31663,46.163642],[7.755992,45.82449],[7.273851,45.776948],[6.843593,45.991147],[6.5001,46.429673],[6.022609,46.27299],[6.037389,46.725779],[6.768714,47.287708],[6.736571,47.541801],[7.192202,47.449766],[7.466759,47.620582],[8.317301,47.61358],[8.522612,47.830828],[9.594226,47.525058]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":17789267,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"CL\",\"ISO_A3\":\"CHL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[-75.644395,-55.61183,-66.95992,-17.580012],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-68.63401,-52.63637],[-68.63335,-54.8695],[-67.56244,-54.87001],[-66.95992,-54.89681],[-67.29103,-55.30124],[-68.14863,-55.61183],[-68.639991,-55.580018],[-69.2321,-55.49906],[-69.95809,-55.19843],[-71.00568,-55.05383],[-72.2639,-54.49514],[-73.2852,-53.95752],[-74.66253,-52.83749],[-73.8381,-53.04743],[-72.43418,-53.7154],[-71.10773,-54.07433],[-70.59178,-53.61583],[-70.26748,-52.93123],[-69.34565,-52.5183],[-68.63401,-52.63637]]],[[[-67.106674,-22.735925],[-66.985234,-22.986349],[-67.328443,-24.025303],[-68.417653,-24.518555],[-68.386001,-26.185016],[-68.5948,-26.506909],[-68.295542,-26.89934],[-69.001235,-27.521214],[-69.65613,-28.459141],[-70.01355,-29.367923],[-69.919008,-30.336339],[-70.535069,-31.36501],[-70.074399,-33.09121],[-69.814777,-33.273886],[-69.817309,-34.193571],[-70.388049,-35.169688],[-70.364769,-36.005089],[-71.121881,-36.658124],[-71.118625,-37.576827],[-70.814664,-38.552995],[-71.413517,-38.916022],[-71.680761,-39.808164],[-71.915734,-40.832339],[-71.746804,-42.051386],[-72.148898,-42.254888],[-71.915424,-43.408565],[-71.464056,-43.787611],[-71.793623,-44.207172],[-71.329801,-44.407522],[-71.222779,-44.784243],[-71.659316,-44.973689],[-71.552009,-45.560733],[-71.917258,-46.884838],[-72.447355,-47.738533],[-72.331161,-48.244238],[-72.648247,-48.878618],[-73.415436,-49.318436],[-73.328051,-50.378785],[-72.975747,-50.74145],[-72.309974,-50.67701],[-72.329404,-51.425956],[-71.914804,-52.009022],[-69.498362,-52.142761],[-68.571545,-52.299444],[-69.461284,-52.291951],[-69.94278,-52.537931],[-70.845102,-52.899201],[-71.006332,-53.833252],[-71.429795,-53.856455],[-72.557943,-53.53141],[-73.702757,-52.835069],[-73.702757,-52.83507],[-74.946763,-52.262754],[-75.260026,-51.629355],[-74.976632,-51.043396],[-75.479754,-50.378372],[-75.608015,-48.673773],[-75.18277,-47.711919],[-74.126581,-46.939253],[-75.644395,-46.647643],[-74.692154,-45.763976],[-74.351709,-44.103044],[-73.240356,-44.454961],[-72.717804,-42.383356],[-73.3889,-42.117532],[-73.701336,-43.365776],[-74.331943,-43.224958],[-74.017957,-41.794813],[-73.677099,-39.942213],[-73.217593,-39.258689],[-73.505559,-38.282883],[-73.588061,-37.156285],[-73.166717,-37.12378],[-72.553137,-35.50884],[-71.861732,-33.909093],[-71.43845,-32.418899],[-71.668721,-30.920645],[-71.370083,-30.095682],[-71.489894,-28.861442],[-70.905124,-27.64038],[-70.724954,-25.705924],[-70.403966,-23.628997],[-70.091246,-21.393319],[-70.16442,-19.756468],[-70.372572,-18.347975],[-69.858444,-18.092694],[-69.590424,-17.580012],[-69.100247,-18.260125],[-68.966818,-18.981683],[-68.442225,-19.405068],[-68.757167,-20.372658],[-68.219913,-21.494347],[-67.82818,-22.872919],[-67.106674,-22.735925]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1379302771,\"ECONOMY\":\"3. Emerging region: BRIC\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"CN\",\"ISO_A3\":\"CHN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":5.7},\"bbox\":[73.675379,18.197701,135.026311,53.4588],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[75.158028,37.133031],[74.980002,37.41999],[74.829986,37.990007],[74.864816,38.378846],[74.257514,38.606507],[73.928852,38.505815],[73.675379,39.431237],[73.960013,39.660008],[73.822244,39.893973],[74.776862,40.366425],[75.467828,40.562072],[76.526368,40.427946],[76.904484,41.066486],[78.187197,41.185316],[78.543661,41.582243],[80.11943,42.123941],[80.25999,42.349999],[80.18015,42.920068],[80.866206,43.180362],[79.966106,44.917517],[81.947071,45.317027],[82.458926,45.53965],[83.180484,47.330031],[85.16429,47.000956],[85.720484,47.452969],[85.768233,48.455751],[86.598776,48.549182],[87.35997,49.214981],[87.751264,49.297198],[88.013832,48.599463],[88.854298,48.069082],[90.280826,47.693549],[90.970809,46.888146],[90.585768,45.719716],[90.94554,45.286073],[92.133891,45.115076],[93.480734,44.975472],[94.688929,44.352332],[95.306875,44.241331],[95.762455,43.319449],[96.349396,42.725635],[97.451757,42.74889],[99.515817,42.524691],[100.845866,42.663804],[101.83304,42.514873],[103.312278,41.907468],[104.522282,41.908347],[104.964994,41.59741],[106.129316,42.134328],[107.744773,42.481516],[109.243596,42.519446],[110.412103,42.871234],[111.129682,43.406834],[111.829588,43.743118],[111.667737,44.073176],[111.348377,44.457442],[111.873306,45.102079],[112.436062,45.011646],[113.463907,44.808893],[114.460332,45.339817],[115.985096,45.727235],[116.717868,46.388202],[117.421701,46.672733],[118.874326,46.805412],[119.66327,46.69268],[119.772824,47.048059],[118.866574,47.74706],[118.064143,48.06673],[117.295507,47.697709],[116.308953,47.85341],[115.742837,47.726545],[115.485282,48.135383],[116.191802,49.134598],[116.678801,49.888531],[117.879244,49.510983],[119.288461,50.142883],[119.27939,50.58292],[120.18208,51.64355],[120.7382,51.96411],[120.725789,52.516226],[120.177089,52.753886],[121.003085,53.251401],[122.245748,53.431726],[123.57147,53.4588],[125.068211,53.161045],[125.946349,52.792799],[126.564399,51.784255],[126.939157,51.353894],[127.287456,50.739797],[127.6574,49.76027],[129.397818,49.4406],[130.582293,48.729687],[130.98726,47.79013],[132.50669,47.78896],[133.373596,48.183442],[135.026311,48.47823],[134.50081,47.57845],[134.11235,47.21248],[133.769644,46.116927],[133.09712,45.14409],[131.883454,45.321162],[131.02519,44.96796],[131.288555,44.11152],[131.144688,42.92999],[130.633866,42.903015],[130.64,42.395024],[129.994267,42.985387],[129.596669,42.424982],[128.052215,41.994285],[128.208433,41.466772],[127.343783,41.503152],[126.869083,41.816569],[126.182045,41.107336],[125.079942,40.569824],[124.265625,39.928493],[122.86757,39.637788],[122.131388,39.170452],[121.054554,38.897471],[121.585995,39.360854],[121.376757,39.750261],[122.168595,40.422443],[121.640359,40.94639],[120.768629,40.593388],[119.639602,39.898056],[119.023464,39.252333],[118.042749,39.204274],[117.532702,38.737636],[118.059699,38.061476],[118.87815,37.897325],[118.911636,37.448464],[119.702802,37.156389],[120.823457,37.870428],[121.711259,37.481123],[122.357937,37.454484],[122.519995,36.930614],[121.104164,36.651329],[120.637009,36.11144],[119.664562,35.609791],[119.151208,34.909859],[120.227525,34.360332],[120.620369,33.376723],[121.229014,32.460319],[121.908146,31.692174],[121.891919,30.949352],[121.264257,30.676267],[121.503519,30.142915],[122.092114,29.83252],[121.938428,29.018022],[121.684439,28.225513],[121.125661,28.135673],[120.395473,27.053207],[119.585497,25.740781],[118.656871,24.547391],[117.281606,23.624501],[115.890735,22.782873],[114.763827,22.668074],[114.152547,22.22376],[113.80678,22.54834],[113.241078,22.051367],[111.843592,21.550494],[110.785466,21.397144],[110.444039,20.341033],[109.889861,20.282457],[109.627655,21.008227],[109.864488,21.395051],[108.522813,21.715212],[108.05018,21.55238],[107.04342,21.811899],[106.567273,22.218205],[106.725403,22.794268],[105.811247,22.976892],[105.329209,23.352063],[104.476858,22.81915],[103.504515,22.703757],[102.706992,22.708795],[102.170436,22.464753],[101.652018,22.318199],[101.80312,21.174367],[101.270026,21.201652],[101.180005,21.436573],[101.150033,21.849984],[100.416538,21.558839],[99.983489,21.742937],[99.240899,22.118314],[99.531992,22.949039],[98.898749,23.142722],[98.660262,24.063286],[97.60472,23.897405],[97.724609,25.083637],[98.671838,25.918703],[98.712094,26.743536],[98.68269,27.508812],[98.246231,27.747221],[97.911988,28.335945],[97.327114,28.261583],[96.248833,28.411031],[96.586591,28.83098],[96.117679,29.452802],[95.404802,29.031717],[94.56599,29.277438],[93.413348,28.640629],[92.503119,27.896876],[91.696657,27.771742],[91.258854,28.040614],[90.730514,28.064954],[90.015829,28.296439],[89.47581,28.042759],[88.814248,27.299316],[88.730326,28.086865],[88.120441,27.876542],[86.954517,27.974262],[85.82332,28.203576],[85.011638,28.642774],[84.23458,28.839894],[83.898993,29.320226],[83.337115,29.463732],[82.327513,30.115268],[81.525804,30.422717],[81.111256,30.183481],[79.721367,30.882715],[78.738894,31.515906],[78.458446,32.618164],[79.176129,32.48378],[79.208892,32.994395],[78.811086,33.506198],[78.912269,34.321936],[77.837451,35.49401],[76.192848,35.898403],[75.896897,36.666806],[75.158028,37.133031]]],[[[110.339188,18.678395],[109.47521,18.197701],[108.655208,18.507682],[108.626217,19.367888],[109.119056,19.821039],[110.211599,20.101254],[110.786551,20.077534],[111.010051,19.69593],[110.570647,19.255879],[110.339188,18.678395]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":24184810,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"CI\",\"ISO_A3\":\"CIV\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-8.60288,4.338288,-2.56219,10.524061],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-5.404342,10.370737],[-4.954653,10.152714],[-4.779884,9.821985],[-4.330247,9.610835],[-3.980449,9.862344],[-3.511899,9.900326],[-2.827496,9.642461],[-2.56219,8.219628],[-2.983585,7.379705],[-3.24437,6.250472],[-2.810701,5.389051],[-2.856125,4.994476],[-3.311084,4.984296],[-4.00882,5.179813],[-4.649917,5.168264],[-5.834496,4.993701],[-6.528769,4.705088],[-7.518941,4.338288],[-7.712159,4.364566],[-7.635368,5.188159],[-7.539715,5.313345],[-7.570153,5.707352],[-7.993693,6.12619],[-8.311348,6.193033],[-8.60288,6.467564],[-8.385452,6.911801],[-8.485446,7.395208],[-8.439298,7.686043],[-8.280703,7.68718],[-8.221792,8.123329],[-8.299049,8.316444],[-8.203499,8.455453],[-7.8321,8.575704],[-8.079114,9.376224],[-8.309616,9.789532],[-8.229337,10.12902],[-8.029944,10.206535],[-7.89959,10.297382],[-7.622759,10.147236],[-6.850507,10.138994],[-6.666461,10.430811],[-6.493965,10.411303],[-6.205223,10.524061],[-6.050452,10.096361],[-5.816926,10.222555],[-5.404342,10.370737]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":24994885,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"CM\",\"ISO_A3\":\"CMR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[8.488816,1.727673,16.012852,12.859396],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[15.27946,7.421925],[14.776545,6.408498],[14.53656,6.226959],[14.459407,5.451761],[14.558936,5.030598],[14.478372,4.732605],[14.950953,4.210389],[15.03622,3.851367],[15.405396,3.335301],[15.862732,3.013537],[15.907381,2.557389],[16.012852,2.26764],[15.940919,1.727673],[15.146342,1.964015],[14.337813,2.227875],[13.075822,2.267097],[12.951334,2.321616],[12.35938,2.192812],[11.751665,2.326758],[11.276449,2.261051],[9.649158,2.283866],[9.795196,3.073404],[9.404367,3.734527],[8.948116,3.904129],[8.744924,4.352215],[8.488816,4.495617],[8.500288,4.771983],[8.757533,5.479666],[9.233163,6.444491],[9.522706,6.453482],[10.118277,7.03877],[10.497375,7.055358],[11.058788,6.644427],[11.745774,6.981383],[11.839309,7.397042],[12.063946,7.799808],[12.218872,8.305824],[12.753672,8.717763],[12.955468,9.417772],[13.1676,9.640626],[13.308676,10.160362],[13.57295,10.798566],[14.415379,11.572369],[14.468192,11.904752],[14.577178,12.085361],[14.181336,12.483657],[14.213531,12.802035],[14.495787,12.859396],[14.89336,12.21905],[14.960152,11.555574],[14.923565,10.891325],[15.467873,9.982337],[14.909354,9.992129],[14.627201,9.920919],[14.171466,10.021378],[13.954218,9.549495],[14.544467,8.965861],[14.979996,8.796104],[15.120866,8.38215],[15.436092,7.692812],[15.27946,7.421925]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":83301151,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"CD\",\"ISO_A3\":\"COD\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[12.182337,-13.257227,31.174149,5.256088],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[23.912215,-10.926826],[23.456791,-10.867863],[22.837345,-11.017622],[22.402798,-10.993075],[22.155268,-11.084801],[22.208753,-9.894796],[21.875182,-9.523708],[21.801801,-8.908707],[21.949131,-8.305901],[21.746456,-7.920085],[21.728111,-7.290872],[20.514748,-7.299606],[20.601823,-6.939318],[20.091622,-6.94309],[20.037723,-7.116361],[19.417502,-7.155429],[19.166613,-7.738184],[19.016752,-7.988246],[18.464176,-7.847014],[18.134222,-7.987678],[17.47297,-8.068551],[17.089996,-7.545689],[16.860191,-7.222298],[16.57318,-6.622645],[16.326528,-5.87747],[13.375597,-5.864241],[13.024869,-5.984389],[12.735171,-5.965682],[12.322432,-6.100092],[12.182337,-5.789931],[12.436688,-5.684304],[12.468004,-5.248362],[12.631612,-4.991271],[12.995517,-4.781103],[13.25824,-4.882957],[13.600235,-4.500138],[14.144956,-4.510009],[14.209035,-4.793092],[14.582604,-4.970239],[15.170992,-4.343507],[15.75354,-3.855165],[16.00629,-3.535133],[15.972803,-2.712392],[16.407092,-1.740927],[16.865307,-1.225816],[17.523716,-0.74383],[17.638645,-0.424832],[17.663553,-0.058084],[17.82654,0.288923],[17.774192,0.855659],[17.898835,1.741832],[18.094276,2.365722],[18.393792,2.900443],[18.453065,3.504386],[18.542982,4.201785],[18.932312,4.709506],[19.467784,5.031528],[20.290679,4.691678],[20.927591,4.322786],[21.659123,4.224342],[22.405124,4.02916],[22.704124,4.633051],[22.84148,4.710126],[23.297214,4.609693],[24.410531,5.108784],[24.805029,4.897247],[25.128833,4.927245],[25.278798,5.170408],[25.650455,5.256088],[26.402761,5.150875],[27.044065,5.127853],[27.374226,5.233944],[27.979977,4.408413],[28.428994,4.287155],[28.696678,4.455077],[29.159078,4.389267],[29.715995,4.600805],[29.9535,4.173699],[30.833852,3.509172],[30.83386,3.509166],[30.773347,2.339883],[31.174149,2.204465],[30.85267,1.849396],[30.468508,1.583805],[30.086154,1.062313],[29.875779,0.59738],[29.819503,-0.20531],[29.587838,-0.587406],[29.579466,-1.341313],[29.291887,-1.620056],[29.254835,-2.21511],[29.117479,-2.292211],[29.024926,-2.839258],[29.276384,-3.293907],[29.339998,-4.499983],[29.519987,-5.419979],[29.419993,-5.939999],[29.620032,-6.520015],[30.199997,-7.079981],[30.740015,-8.340007],[30.74001,-8.340006],[30.346086,-8.238257],[29.002912,-8.407032],[28.734867,-8.526559],[28.449871,-9.164918],[28.673682,-9.605925],[28.49607,-10.789884],[28.372253,-11.793647],[28.642417,-11.971569],[29.341548,-12.360744],[29.616001,-12.178895],[29.699614,-13.257227],[28.934286,-13.248958],[28.523562,-12.698604],[28.155109,-12.272481],[27.388799,-12.132747],[27.16442,-11.608748],[26.553088,-11.92444],[25.75231,-11.784965],[25.418118,-11.330936],[24.78317,-11.238694],[24.314516,-11.262826],[24.257155,-10.951993],[23.912215,-10.926826]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4954674,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"CG\",\"ISO_A3\":\"COG\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[11.093773,-5.037987,18.453065,3.728197],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[12.995517,-4.781103],[12.62076,-4.438023],[12.318608,-4.60623],[11.914963,-5.037987],[11.093773,-3.978827],[11.855122,-3.426871],[11.478039,-2.765619],[11.820964,-2.514161],[12.495703,-2.391688],[12.575284,-1.948511],[13.109619,-2.42874],[13.992407,-2.470805],[14.29921,-1.998276],[14.425456,-1.333407],[14.316418,-0.552627],[13.843321,0.038758],[14.276266,1.19693],[14.026669,1.395677],[13.282631,1.314184],[13.003114,1.830896],[13.075822,2.267097],[14.337813,2.227875],[15.146342,1.964015],[15.940919,1.727673],[16.012852,2.26764],[16.537058,3.198255],[17.133042,3.728197],[17.8099,3.560196],[18.453065,3.504386],[18.393792,2.900443],[18.094276,2.365722],[17.898835,1.741832],[17.774192,0.855659],[17.82654,0.288923],[17.663553,-0.058084],[17.638645,-0.424832],[17.523716,-0.74383],[16.865307,-1.225816],[16.407092,-1.740927],[15.972803,-2.712392],[16.00629,-3.535133],[15.75354,-3.855165],[15.170992,-4.343507],[14.582604,-4.970239],[14.209035,-4.793092],[14.144956,-4.510009],[13.600235,-4.500138],[13.25824,-4.882957],[12.995517,-4.781103]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":47698524,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"CO\",\"ISO_A3\":\"COL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[-78.990935,-4.298187,-66.876326,12.437303],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-66.876326,1.253361],[-67.065048,1.130112],[-67.259998,1.719999],[-67.53781,2.037163],[-67.868565,1.692455],[-69.816973,1.714805],[-69.804597,1.089081],[-69.218638,0.985677],[-69.252434,0.602651],[-69.452396,0.706159],[-70.015566,0.541414],[-70.020656,-0.185156],[-69.577065,-0.549992],[-69.420486,-1.122619],[-69.444102,-1.556287],[-69.893635,-4.298187],[-70.394044,-3.766591],[-70.692682,-3.742872],[-70.047709,-2.725156],[-70.813476,-2.256865],[-71.413646,-2.342802],[-71.774761,-2.16979],[-72.325787,-2.434218],[-73.070392,-2.308954],[-73.659504,-1.260491],[-74.122395,-1.002833],[-74.441601,-0.53082],[-75.106625,-0.057205],[-75.373223,-0.152032],[-75.801466,0.084801],[-76.292314,0.416047],[-76.57638,0.256936],[-77.424984,0.395687],[-77.668613,0.825893],[-77.855061,0.809925],[-78.855259,1.380924],[-78.990935,1.69137],[-78.617831,1.766404],[-78.662118,2.267355],[-78.42761,2.629556],[-77.931543,2.696606],[-77.510431,3.325017],[-77.12769,3.849636],[-77.496272,4.087606],[-77.307601,4.667984],[-77.533221,5.582812],[-77.318815,5.845354],[-77.476661,6.691116],[-77.881571,7.223771],[-77.753414,7.70984],[-77.431108,7.638061],[-77.242566,7.935278],[-77.474723,8.524286],[-77.353361,8.670505],[-76.836674,8.638749],[-76.086384,9.336821],[-75.6746,9.443248],[-75.664704,9.774003],[-75.480426,10.61899],[-74.906895,11.083045],[-74.276753,11.102036],[-74.197223,11.310473],[-73.414764,11.227015],[-72.627835,11.731972],[-72.238195,11.95555],[-71.75409,12.437303],[-71.399822,12.376041],[-71.137461,12.112982],[-71.331584,11.776284],[-71.973922,11.608672],[-72.227575,11.108702],[-72.614658,10.821975],[-72.905286,10.450344],[-73.027604,9.73677],[-73.304952,9.152],[-72.78873,9.085027],[-72.660495,8.625288],[-72.439862,8.405275],[-72.360901,8.002638],[-72.479679,7.632506],[-72.444487,7.423785],[-72.198352,7.340431],[-71.960176,6.991615],[-70.674234,7.087785],[-70.093313,6.960376],[-69.38948,6.099861],[-68.985319,6.206805],[-68.265052,6.153268],[-67.695087,6.267318],[-67.34144,6.095468],[-67.521532,5.55687],[-67.744697,5.221129],[-67.823012,4.503937],[-67.621836,3.839482],[-67.337564,3.542342],[-67.303173,3.318454],[-67.809938,2.820655],[-67.447092,2.600281],[-67.181294,2.250638],[-66.876326,1.253361]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4930258,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"CR\",\"ISO_A3\":\"CRI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-85.941725,8.225028,-82.546196,11.217119],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-82.965783,8.225028],[-83.508437,8.446927],[-83.711474,8.656836],[-83.596313,8.830443],[-83.632642,9.051386],[-83.909886,9.290803],[-84.303402,9.487354],[-84.647644,9.615537],[-84.713351,9.908052],[-84.97566,10.086723],[-84.911375,9.795992],[-85.110923,9.55704],[-85.339488,9.834542],[-85.660787,9.933347],[-85.797445,10.134886],[-85.791709,10.439337],[-85.659314,10.754331],[-85.941725,10.895278],[-85.71254,11.088445],[-85.561852,11.217119],[-84.903003,10.952303],[-84.673069,11.082657],[-84.355931,10.999226],[-84.190179,10.79345],[-83.895054,10.726839],[-83.655612,10.938764],[-83.40232,10.395438],[-83.015677,9.992982],[-82.546196,9.566135],[-82.932891,9.476812],[-82.927155,9.07433],[-82.719183,8.925709],[-82.868657,8.807266],[-82.829771,8.626295],[-82.913176,8.423517],[-82.965783,8.225028]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":11147407,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"CU\",\"ISO_A3\":\"CUB\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-84.974911,19.855481,-74.178025,23.188611],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-82.268151,23.188611],[-81.404457,23.117271],[-80.618769,23.10598],[-79.679524,22.765303],[-79.281486,22.399202],[-78.347434,22.512166],[-77.993296,22.277194],[-77.146422,21.657851],[-76.523825,21.20682],[-76.19462,21.220565],[-75.598222,21.016624],[-75.67106,20.735091],[-74.933896,20.693905],[-74.178025,20.284628],[-74.296648,20.050379],[-74.961595,19.923435],[-75.63468,19.873774],[-76.323656,19.952891],[-77.755481,19.855481],[-77.085108,20.413354],[-77.492655,20.673105],[-78.137292,20.739949],[-78.482827,21.028613],[-78.719867,21.598114],[-79.285,21.559175],[-80.217475,21.827324],[-80.517535,22.037079],[-81.820943,22.192057],[-82.169992,22.387109],[-81.795002,22.636965],[-82.775898,22.68815],[-83.494459,22.168518],[-83.9088,22.154565],[-84.052151,21.910575],[-84.54703,21.801228],[-84.974911,21.896028],[-84.447062,22.20495],[-84.230357,22.565755],[-83.77824,22.788118],[-83.267548,22.983042],[-82.510436,23.078747],[-82.268151,23.188611]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":265100,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"FR\",\"ISO_A3\":\"FRA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":6,\"MAX_LABEL\":10},\"bbox\":[32.73178,35.000345,34.576474,35.671596],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[32.73178,35.140026],[32.802474,35.145504],[32.946961,35.386703],[33.667227,35.373216],[34.576474,35.671596],[33.900804,35.245756],[33.973617,35.058506],[33.86644,35.093595],[33.675392,35.017863],[33.525685,35.038688],[33.475817,35.000345],[33.455922,35.101424],[33.383833,35.162712],[33.190977,35.173125],[32.919572,35.087833],[32.73178,35.140026]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1221549,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"CY\",\"ISO_A3\":\"CYP\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9.5},\"bbox\":[32.256667,34.571869,34.004881,35.173125],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[32.73178,35.140026],[32.919572,35.087833],[33.190977,35.173125],[33.383833,35.162712],[33.455922,35.101424],[33.475817,35.000345],[33.525685,35.038688],[33.675392,35.017863],[33.86644,35.093595],[33.973617,35.058506],[34.004881,34.978098],[32.979827,34.571869],[32.490296,34.701655],[32.256667,35.103232],[32.73178,35.140026]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":10674723,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"CZ\",\"ISO_A3\":\"CZE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[12.240111,48.555305,18.853144,51.117268],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[16.960288,48.596982],[16.499283,48.785808],[16.029647,48.733899],[15.253416,49.039074],[14.901447,48.964402],[14.338898,48.555305],[13.595946,48.877172],[13.031329,49.307068],[12.521024,49.547415],[12.415191,49.969121],[12.240111,50.266338],[12.966837,50.484076],[13.338132,50.733234],[14.056228,50.926918],[14.307013,51.117268],[14.570718,51.002339],[15.016996,51.106674],[15.490972,50.78473],[16.238627,50.697733],[16.176253,50.422607],[16.719476,50.215747],[16.868769,50.473974],[17.554567,50.362146],[17.649445,50.049038],[18.392914,49.988629],[18.853144,49.49623],[18.554971,49.495015],[18.399994,49.315001],[18.170498,49.271515],[18.104973,49.043983],[17.913512,48.996493],[17.886485,48.903475],[17.545007,48.800019],[17.101985,48.816969],[16.960288,48.596982]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":80594017,\"ECONOMY\":\"1. Developed region: G7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"DE\",\"ISO_A3\":\"DEU\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[5.988658,47.302488,15.016996,54.983104],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[13.595946,48.877172],[13.243357,48.416115],[12.884103,48.289146],[13.025851,47.637584],[12.932627,47.467646],[12.62076,47.672388],[12.141357,47.703083],[11.426414,47.523766],[10.544504,47.566399],[10.402084,47.302488],[9.896068,47.580197],[9.594226,47.525058],[8.522612,47.830828],[8.317301,47.61358],[7.466759,47.620582],[7.593676,48.333019],[8.099279,49.017784],[6.65823,49.201958],[6.18632,49.463803],[6.242751,49.902226],[6.043073,50.128052],[6.156658,50.803721],[5.988658,51.851616],[6.589397,51.852029],[6.84287,52.22844],[7.092053,53.144043],[6.90514,53.482162],[7.100425,53.693932],[7.936239,53.748296],[8.121706,53.527792],[8.800734,54.020786],[8.572118,54.395646],[8.526229,54.962744],[9.282049,54.830865],[9.921906,54.983104],[9.93958,54.596642],[10.950112,54.363607],[10.939467,54.008693],[11.956252,54.196486],[12.51844,54.470371],[13.647467,54.075511],[14.119686,53.757029],[14.353315,53.248171],[14.074521,52.981263],[14.4376,52.62485],[14.685026,52.089947],[14.607098,51.745188],[15.016996,51.106674],[14.570718,51.002339],[14.307013,51.117268],[14.056228,50.926918],[13.338132,50.733234],[12.966837,50.484076],[12.240111,50.266338],[12.415191,49.969121],[12.521024,49.547415],[13.031329,49.307068],[13.595946,48.877172]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":865267,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"DJ\",\"ISO_A3\":\"DJI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[41.66176,10.926879,43.317852,12.699639],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[43.081226,12.699639],[43.317852,12.390148],[43.286381,11.974928],[42.715874,11.735641],[43.145305,11.46204],[42.776852,10.926879],[42.55493,11.10511],[42.31414,11.0342],[41.75557,11.05091],[41.73959,11.35511],[41.66176,11.6312],[42,12.1],[42.35156,12.54223],[42.779642,12.455416],[43.081226,12.699639]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5605948,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"DK\",\"ISO_A3\":\"DNK\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[8.089977,54.800015,12.690006,57.730017],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[9.921906,54.983104],[9.282049,54.830865],[8.526229,54.962744],[8.120311,55.517723],[8.089977,56.540012],[8.256582,56.809969],[8.543438,57.110003],[9.424469,57.172066],[9.775559,57.447941],[10.580006,57.730017],[10.546106,57.215733],[10.25,56.890016],[10.369993,56.609982],[10.912182,56.458621],[10.667804,56.081383],[10.369993,56.190007],[9.649985,55.469999],[9.921906,54.983104]]],[[[12.690006,55.609991],[12.089991,54.800015],[11.043543,55.364864],[10.903914,55.779955],[12.370904,56.111407],[12.690006,55.609991]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":10734247,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"DO\",\"ISO_A3\":\"DOM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9.5},\"bbox\":[-71.945112,17.598564,-68.317943,19.884911],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-71.712361,19.714456],[-71.587304,19.884911],[-70.806706,19.880286],[-70.214365,19.622885],[-69.950815,19.648],[-69.76925,19.293267],[-69.222126,19.313214],[-69.254346,19.015196],[-68.809412,18.979074],[-68.317943,18.612198],[-68.689316,18.205142],[-69.164946,18.422648],[-69.623988,18.380713],[-69.952934,18.428307],[-70.133233,18.245915],[-70.517137,18.184291],[-70.669298,18.426886],[-70.99995,18.283329],[-71.40021,17.598564],[-71.657662,17.757573],[-71.708305,18.044997],[-71.687738,18.31666],[-71.945112,18.6169],[-71.701303,18.785417],[-71.624873,19.169838],[-71.712361,19.714456]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":40969443,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"DZ\",\"ISO_A3\":\"DZA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[-8.6844,19.057364,11.999506,37.118381],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[4.267419,19.155265],[3.158133,19.057364],[3.146661,19.693579],[2.683588,19.85623],[2.060991,20.142233],[1.823228,20.610809],[-1.550055,22.792666],[-4.923337,24.974574],[-8.6844,27.395744],[-8.665124,27.589479],[-8.66559,27.656426],[-8.674116,28.841289],[-7.059228,29.579228],[-6.060632,29.7317],[-5.242129,30.000443],[-4.859646,30.501188],[-3.690441,30.896952],[-3.647498,31.637294],[-3.06898,31.724498],[-2.616605,32.094346],[-1.307899,32.262889],[-1.124551,32.651522],[-1.388049,32.864015],[-1.733455,33.919713],[-1.792986,34.527919],[-2.169914,35.168396],[-1.208603,35.714849],[-0.127454,35.888662],[0.503877,36.301273],[1.466919,36.605647],[3.161699,36.783905],[4.815758,36.865037],[5.32012,36.716519],[6.26182,37.110655],[7.330385,37.118381],[7.737078,36.885708],[8.420964,36.946427],[8.217824,36.433177],[8.376368,35.479876],[8.140981,34.655146],[7.524482,34.097376],[7.612642,33.344115],[8.430473,32.748337],[8.439103,32.506285],[9.055603,32.102692],[9.48214,30.307556],[9.805634,29.424638],[9.859998,28.95999],[9.683885,28.144174],[9.756128,27.688259],[9.629056,27.140953],[9.716286,26.512206],[9.319411,26.094325],[9.910693,25.365455],[9.948261,24.936954],[10.303847,24.379313],[10.771364,24.562532],[11.560669,24.097909],[11.999506,23.471668],[8.572893,21.565661],[5.677566,19.601207],[4.267419,19.155265]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":16290913,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"EC\",\"ISO_A3\":\"ECU\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-80.967765,-4.959129,-75.233723,1.380924],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-78.855259,1.380924],[-77.855061,0.809925],[-77.668613,0.825893],[-77.424984,0.395687],[-76.57638,0.256936],[-76.292314,0.416047],[-75.801466,0.084801],[-75.373223,-0.152032],[-75.233723,-0.911417],[-75.544996,-1.56161],[-76.635394,-2.608678],[-77.837905,-3.003021],[-78.450684,-3.873097],[-78.639897,-4.547784],[-79.205289,-4.959129],[-79.624979,-4.454198],[-80.028908,-4.346091],[-80.442242,-4.425724],[-80.469295,-4.059287],[-80.184015,-3.821162],[-80.302561,-3.404856],[-79.770293,-2.657512],[-79.986559,-2.220794],[-80.368784,-2.685159],[-80.967765,-2.246943],[-80.764806,-1.965048],[-80.933659,-1.057455],[-80.58337,-0.906663],[-80.399325,-0.283703],[-80.020898,0.36034],[-80.09061,0.768429],[-79.542762,0.982938],[-78.855259,1.380924]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":97041072,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"EG\",\"ISO_A3\":\"EGY\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[24.70007,22,36.86623,31.58568],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[36.86623,22],[32.9,22],[29.02,22],[25,22],[25,25.6825],[25,29.238655],[24.70007,30.04419],[24.95762,30.6616],[24.80287,31.08929],[25.16482,31.56915],[26.49533,31.58568],[27.45762,31.32126],[28.45048,31.02577],[28.91353,30.87005],[29.68342,31.18686],[30.09503,31.4734],[30.97693,31.55586],[31.68796,31.4296],[31.96041,30.9336],[32.19247,31.26034],[32.99392,31.02407],[33.7734,30.96746],[34.265435,31.219357],[34.26544,31.21936],[34.823243,29.761081],[34.9226,29.50133],[34.64174,29.09942],[34.42655,28.34399],[34.15451,27.8233],[33.92136,27.6487],[33.58811,27.97136],[33.13676,28.41765],[32.42323,29.85108],[32.32046,29.76043],[32.73482,28.70523],[33.34876,27.69989],[34.10455,26.14227],[34.47387,25.59856],[34.79507,25.03375],[35.69241,23.92671],[35.49372,23.75237],[35.52598,23.10244],[36.69069,22.20485],[36.86623,22]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5918919,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"ER\",\"ISO_A3\":\"ERI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[36.32322,12.455416,43.081226,17.998307],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[43.081226,12.699639],[42.779642,12.455416],[42.35156,12.54223],[42.00975,12.86582],[41.59856,13.45209],[41.1552,13.77333],[40.8966,14.11864],[40.02625,14.51959],[39.34061,14.53155],[39.0994,14.74064],[38.51295,14.50547],[37.90607,14.95943],[37.59377,14.2131],[36.42951,14.42211],[36.32322,14.82249],[36.75389,16.29186],[36.85253,16.95655],[37.16747,17.26314],[37.904,17.42754],[38.41009,17.998307],[38.990623,16.840626],[39.26611,15.922723],[39.814294,15.435647],[41.179275,14.49108],[41.734952,13.921037],[42.276831,13.343992],[42.589576,13.000421],[43.081226,12.699639]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":48958159,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"ES\",\"ISO_A3\":\"ESP\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[-9.392884,35.94685,3.039484,43.748338],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-9.034818,41.880571],[-8.984433,42.592775],[-9.392884,43.026625],[-7.97819,43.748338],[-6.754492,43.567909],[-5.411886,43.57424],[-4.347843,43.403449],[-3.517532,43.455901],[-1.901351,43.422802],[-1.502771,43.034014],[0.338047,42.579546],[0.701591,42.795734],[1.826793,42.343385],[2.985999,42.473015],[3.039484,41.89212],[2.091842,41.226089],[0.810525,41.014732],[0.721331,40.678318],[0.106692,40.123934],[-0.278711,39.309978],[0.111291,38.738514],[-0.467124,38.292366],[-0.683389,37.642354],[-1.438382,37.443064],[-2.146453,36.674144],[-3.415781,36.6589],[-4.368901,36.677839],[-4.995219,36.324708],[-5.37716,35.94685],[-5.866432,36.029817],[-6.236694,36.367677],[-6.520191,36.942913],[-7.453726,37.097788],[-7.537105,37.428904],[-7.166508,37.803894],[-7.029281,38.075764],[-7.374092,38.373059],[-7.098037,39.030073],[-7.498632,39.629571],[-7.066592,39.711892],[-7.026413,40.184524],[-6.86402,40.330872],[-6.851127,41.111083],[-6.389088,41.381815],[-6.668606,41.883387],[-7.251309,41.918346],[-7.422513,41.792075],[-8.013175,41.790886],[-8.263857,42.280469],[-8.671946,42.134689],[-9.034818,41.880571]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1251581,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"EE\",\"ISO_A3\":\"EST\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[23.339795,57.474528,28.131699,59.61109],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[24.312863,57.793424],[24.428928,58.383413],[24.061198,58.257375],[23.42656,58.612753],[23.339795,59.18724],[24.604214,59.465854],[25.864189,59.61109],[26.949136,59.445803],[27.981114,59.475388],[27.981127,59.475373],[27.98112,59.47537],[28.131699,59.300825],[27.42015,58.72457],[27.716686,57.791899],[27.288185,57.474528],[26.463532,57.476389],[25.60281,57.847529],[25.164594,57.970157],[24.312863,57.793424]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":105350020,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"ET\",\"ISO_A3\":\"ETH\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[32.95418,3.42206,47.78942,14.95943],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[42.35156,12.54223],[42,12.1],[41.66176,11.6312],[41.73959,11.35511],[41.75557,11.05091],[42.31414,11.0342],[42.55493,11.10511],[42.776852,10.926879],[42.55876,10.57258],[42.92812,10.02194],[43.29699,9.54048],[43.67875,9.18358],[46.94834,7.99688],[47.78942,8.003],[44.9636,5.00162],[43.66087,4.95755],[42.76967,4.25259],[42.12861,4.23413],[41.855083,3.918912],[41.1718,3.91909],[40.76848,4.25702],[39.85494,3.83879],[39.559384,3.42206],[38.89251,3.50074],[38.67114,3.61607],[38.43697,3.58851],[38.120915,3.598605],[36.855093,4.447864],[36.159079,4.447864],[35.817448,4.776966],[35.817448,5.338232],[35.298007,5.506],[34.70702,6.59422],[34.25032,6.82607],[34.0751,7.22595],[33.56829,7.71334],[32.95418,7.78497],[33.2948,8.35458],[33.8255,8.37916],[33.97498,8.68456],[33.96162,9.58358],[34.25745,10.63009],[34.73115,10.91017],[34.83163,11.31896],[35.26049,12.08286],[35.86363,12.57828],[36.27022,13.56333],[36.42951,14.42211],[37.59377,14.2131],[37.90607,14.95943],[38.51295,14.50547],[39.0994,14.74064],[39.34061,14.53155],[40.02625,14.51959],[40.8966,14.11864],[41.1552,13.77333],[41.59856,13.45209],[42.00975,12.86582],[42.35156,12.54223]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5491218,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"FI\",\"ISO_A3\":\"FIN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[20.645593,59.846373,31.516092,70.164193],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[23.903379,66.006927],[23.56588,66.396051],[23.539473,67.936009],[21.978535,68.616846],[20.645593,69.106247],[21.244936,69.370443],[22.356238,68.841741],[23.66205,68.891247],[24.735679,68.649557],[25.689213,69.092114],[26.179622,69.825299],[27.732292,70.164193],[29.015573,69.766491],[28.59193,69.064777],[28.445944,68.364613],[29.977426,67.698297],[29.054589,66.944286],[30.21765,65.80598],[29.54443,64.948672],[30.444685,64.204453],[30.035872,63.552814],[31.516092,62.867687],[31.139991,62.357693],[30.211107,61.780028],[28.07,60.50352],[28.070002,60.503519],[28.069998,60.503517],[26.255173,60.423961],[24.496624,60.057316],[22.869695,59.846373],[22.290764,60.391921],[21.322244,60.72017],[21.544866,61.705329],[21.059211,62.607393],[21.536029,63.189735],[22.442744,63.81781],[24.730512,64.902344],[25.398068,65.111427],[25.294043,65.534346],[23.903379,66.006927]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":920938,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"FJ\",\"ISO_A3\":\"FJI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-180,-18.28799,180,-16.020882],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[178.3736,-17.33992],[178.71806,-17.62846],[178.55271,-18.15059],[177.93266,-18.28799],[177.38146,-18.16432],[177.28504,-17.72465],[177.67087,-17.38114],[178.12557,-17.50481],[178.3736,-17.33992]]],[[[179.364143,-16.801354],[178.725059,-17.012042],[178.596839,-16.63915],[179.096609,-16.433984],[179.413509,-16.379054],[180,-16.067133],[180,-16.555217],[179.364143,-16.801354]]],[[[-179.917369,-16.501783],[-180,-16.555217],[-180,-16.067133],[-179.79332,-16.020882],[-179.917369,-16.501783]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2931,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"FK\",\"ISO_A3\":\"FLK\",\"TINY\":-99,\"HOMEPART\":-99,\"MIN_ZOOM\":0,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9},\"bbox\":[-61.2,-52.3,-57.75,-51.1],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-61.2,-51.85],[-60,-51.25],[-59.15,-51.5],[-58.55,-51.1],[-57.75,-51.55],[-58.05,-51.9],[-59.4,-52.2],[-59.85,-51.85],[-60.7,-52.3],[-61.2,-51.85]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":67106161,\"ECONOMY\":\"1. Developed region: G7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"FR\",\"ISO_A3\":\"FRA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[-54.524754,2.053389,9.560016,51.148506],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[2.513573,51.148506],[2.658422,50.796848],[3.123252,50.780363],[3.588184,50.378992],[4.286023,49.907497],[4.799222,49.985373],[5.674052,49.529484],[5.897759,49.442667],[6.18632,49.463803],[6.65823,49.201958],[8.099279,49.017784],[7.593676,48.333019],[7.466759,47.620582],[7.192202,47.449766],[6.736571,47.541801],[6.768714,47.287708],[6.037389,46.725779],[6.022609,46.27299],[6.5001,46.429673],[6.843593,45.991147],[6.802355,45.70858],[7.096652,45.333099],[6.749955,45.028518],[7.007562,44.254767],[7.549596,44.127901],[7.435185,43.693845],[6.529245,43.128892],[4.556963,43.399651],[3.100411,43.075201],[2.985999,42.473015],[1.826793,42.343385],[0.701591,42.795734],[0.338047,42.579546],[-1.502771,43.034014],[-1.901351,43.422802],[-1.384225,44.02261],[-1.193798,46.014918],[-2.225724,47.064363],[-2.963276,47.570327],[-4.491555,47.954954],[-4.59235,48.68416],[-3.295814,48.901692],[-1.616511,48.644421],[-1.933494,49.776342],[-0.989469,49.347376],[1.338761,50.127173],[1.639001,50.946606],[2.513573,51.148506]]],[[[-51.657797,4.156232],[-52.249338,3.241094],[-52.556425,2.504705],[-52.939657,2.124858],[-53.418465,2.053389],[-53.554839,2.334897],[-53.778521,2.376703],[-54.088063,2.105557],[-54.524754,2.311849],[-54.27123,2.738748],[-54.184284,3.194172],[-54.011504,3.62257],[-54.399542,4.212611],[-54.478633,4.896756],[-53.958045,5.756548],[-53.618453,5.646529],[-52.882141,5.409851],[-51.823343,4.565768],[-51.657797,4.156232]]],[[[9.560016,42.152492],[9.229752,41.380007],[8.775723,41.583612],[8.544213,42.256517],[8.746009,42.628122],[9.390001,43.009985],[9.560016,42.152492]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1772255,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"GA\",\"ISO_A3\":\"GAB\",\"TINY\":3,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[8.797996,-3.978827,14.425456,2.326758],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[11.276449,2.261051],[11.751665,2.326758],[12.35938,2.192812],[12.951334,2.321616],[13.075822,2.267097],[13.003114,1.830896],[13.282631,1.314184],[14.026669,1.395677],[14.276266,1.19693],[13.843321,0.038758],[14.316418,-0.552627],[14.425456,-1.333407],[14.29921,-1.998276],[13.992407,-2.470805],[13.109619,-2.42874],[12.575284,-1.948511],[12.495703,-2.391688],[11.820964,-2.514161],[11.478039,-2.765619],[11.855122,-3.426871],[11.093773,-3.978827],[10.066135,-2.969483],[9.405245,-2.144313],[8.797996,-1.111301],[8.830087,-0.779074],[9.04842,-0.459351],[9.291351,0.268666],[9.492889,1.01012],[9.830284,1.067894],[11.285079,1.057662],[11.276449,2.261051]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":64769452,\"ECONOMY\":\"1. Developed region: G7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"GB\",\"ISO_A3\":\"GBR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[-7.572168,49.96,1.681531,58.635],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-6.197885,53.867565],[-6.95373,54.073702],[-7.572168,54.059956],[-7.366031,54.595841],[-7.572168,55.131622],[-6.733847,55.17286],[-5.661949,54.554603],[-6.197885,53.867565]]],[[[-3.005005,58.635],[-4.073828,57.553025],[-3.055002,57.690019],[-1.959281,57.6848],[-2.219988,56.870017],[-3.119003,55.973793],[-2.085009,55.909998],[-2.005676,55.804903],[-1.114991,54.624986],[-0.430485,54.464376],[0.184981,53.325014],[0.469977,52.929999],[1.681531,52.73952],[1.559988,52.099998],[1.050562,51.806761],[1.449865,51.289428],[0.550334,50.765739],[-0.787517,50.774989],[-2.489998,50.500019],[-2.956274,50.69688],[-3.617448,50.228356],[-4.542508,50.341837],[-5.245023,49.96],[-5.776567,50.159678],[-4.30999,51.210001],[-3.414851,51.426009],[-3.422719,51.426848],[-4.984367,51.593466],[-5.267296,51.9914],[-4.222347,52.301356],[-4.770013,52.840005],[-4.579999,53.495004],[-3.093831,53.404547],[-3.09208,53.404441],[-2.945009,53.985],[-3.614701,54.600937],[-3.630005,54.615013],[-4.844169,54.790971],[-5.082527,55.061601],[-4.719112,55.508473],[-5.047981,55.783986],[-5.586398,55.311146],[-5.644999,56.275015],[-6.149981,56.78501],[-5.786825,57.818848],[-5.009999,58.630013],[-4.211495,58.550845],[-3.005005,58.635]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4926330,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"GE\",\"ISO_A3\":\"GEO\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[39.955009,41.064445,46.637908,43.553104],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[44.97248,41.248129],[43.582746,41.092143],[42.619549,41.583173],[41.554084,41.535656],[41.703171,41.962943],[41.45347,42.645123],[40.875469,43.013628],[40.321394,43.128634],[39.955009,43.434998],[40.076965,43.553104],[40.92219,43.38215],[42.3944,43.2203],[43.75599,42.74083],[43.93121,42.55496],[44.537623,42.711993],[45.470279,42.502781],[45.7764,42.09244],[46.404951,41.860675],[46.145432,41.722802],[46.637908,41.181673],[46.501637,41.064445],[45.962601,41.123873],[45.217426,41.411452],[44.97248,41.248129]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":27499924,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"GH\",\"ISO_A3\":\"GHA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-3.24437,4.710462,1.060122,11.098341],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-2.827496,9.642461],[-2.963896,10.395335],[-2.940409,10.96269],[-1.203358,11.009819],[-0.761576,10.93693],[-0.438702,11.098341],[0.023803,11.018682],[-0.049785,10.706918],[0.36758,10.191213],[0.365901,9.465004],[0.461192,8.677223],[0.712029,8.312465],[0.490957,7.411744],[0.570384,6.914359],[0.836931,6.279979],[1.060122,5.928837],[-0.507638,5.343473],[-1.063625,5.000548],[-1.964707,4.710462],[-2.856125,4.994476],[-2.810701,5.389051],[-3.24437,6.250472],[-2.983585,7.379705],[-2.56219,8.219628],[-2.827496,9.642461]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":12413867,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"GN\",\"ISO_A3\":\"GIN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-15.130311,7.309037,-7.8321,12.586183],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-8.029944,10.206535],[-8.229337,10.12902],[-8.309616,9.789532],[-8.079114,9.376224],[-7.8321,8.575704],[-8.203499,8.455453],[-8.299049,8.316444],[-8.221792,8.123329],[-8.280703,7.68718],[-8.439298,7.686043],[-8.722124,7.711674],[-8.926065,7.309037],[-9.208786,7.313921],[-9.403348,7.526905],[-9.33728,7.928534],[-9.755342,8.541055],[-10.016567,8.428504],[-10.230094,8.406206],[-10.505477,8.348896],[-10.494315,8.715541],[-10.65477,8.977178],[-10.622395,9.26791],[-10.839152,9.688246],[-11.117481,10.045873],[-11.917277,10.046984],[-12.150338,9.858572],[-12.425929,9.835834],[-12.596719,9.620188],[-12.711958,9.342712],[-13.24655,8.903049],[-13.685154,9.494744],[-14.074045,9.886167],[-14.330076,10.01572],[-14.579699,10.214467],[-14.693232,10.656301],[-14.839554,10.876572],[-15.130311,11.040412],[-14.685687,11.527824],[-14.382192,11.509272],[-14.121406,11.677117],[-13.9008,11.678719],[-13.743161,11.811269],[-13.828272,12.142644],[-13.718744,12.247186],[-13.700476,12.586183],[-13.217818,12.575874],[-12.499051,12.33209],[-12.278599,12.35444],[-12.203565,12.465648],[-11.658301,12.386583],[-11.513943,12.442988],[-11.456169,12.076834],[-11.297574,12.077971],[-11.036556,12.211245],[-10.87083,12.177887],[-10.593224,11.923975],[-10.165214,11.844084],[-9.890993,12.060479],[-9.567912,12.194243],[-9.327616,12.334286],[-9.127474,12.30806],[-8.905265,12.088358],[-8.786099,11.812561],[-8.376305,11.393646],[-8.581305,11.136246],[-8.620321,10.810891],[-8.407311,10.909257],[-8.282357,10.792597],[-8.335377,10.494812],[-8.029944,10.206535]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2051363,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"GM\",\"ISO_A3\":\"GMB\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[-16.841525,13.130284,-13.844963,13.876492],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-16.841525,13.151394],[-16.713729,13.594959],[-15.624596,13.623587],[-15.39877,13.860369],[-15.081735,13.876492],[-14.687031,13.630357],[-14.376714,13.62568],[-14.046992,13.794068],[-13.844963,13.505042],[-14.277702,13.280585],[-14.712197,13.298207],[-15.141163,13.509512],[-15.511813,13.27857],[-15.691001,13.270353],[-15.931296,13.130284],[-16.841525,13.151394]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1792338,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"GW\",\"ISO_A3\":\"GNB\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[-16.677452,11.040412,-13.700476,12.62817],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-13.700476,12.586183],[-13.718744,12.247186],[-13.828272,12.142644],[-13.743161,11.811269],[-13.9008,11.678719],[-14.121406,11.677117],[-14.382192,11.509272],[-14.685687,11.527824],[-15.130311,11.040412],[-15.66418,11.458474],[-16.085214,11.524594],[-16.314787,11.806515],[-16.308947,11.958702],[-16.613838,12.170911],[-16.677452,12.384852],[-16.147717,12.547762],[-15.816574,12.515567],[-15.548477,12.62817],[-13.700476,12.586183]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":778358,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"GQ\",\"ISO_A3\":\"GNQ\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[9.305613,1.01012,11.285079,2.283866],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[9.649158,2.283866],[11.276449,2.261051],[11.285079,1.057662],[9.830284,1.067894],[9.492889,1.01012],[9.305613,1.160911],[9.649158,2.283866]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":10768477,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"GR\",\"ISO_A3\":\"GRC\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[20.150016,34.919988,26.604196,41.826905],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[20.150016,39.624998],[20.615,40.110007],[20.674997,40.435],[20.99999,40.580004],[21.02004,40.842727],[21.674161,40.931275],[22.055378,41.149866],[22.597308,41.130487],[22.76177,41.3048],[22.952377,41.337994],[23.692074,41.309081],[24.492645,41.583896],[25.197201,41.234486],[26.106138,41.328899],[26.117042,41.826905],[26.604196,41.562115],[26.294602,40.936261],[26.056942,40.824123],[25.447677,40.852545],[24.925848,40.947062],[23.714811,40.687129],[24.407999,40.124993],[23.899968,39.962006],[23.342999,39.960998],[22.813988,40.476005],[22.626299,40.256561],[22.849748,39.659311],[23.350027,39.190011],[22.973099,38.970903],[23.530016,38.510001],[24.025025,38.219993],[24.040011,37.655015],[23.115003,37.920011],[23.409972,37.409991],[22.774972,37.30501],[23.154225,36.422506],[22.490028,36.41],[21.670026,36.844986],[21.295011,37.644989],[21.120034,38.310323],[20.730032,38.769985],[20.217712,39.340235],[20.150016,39.624998]]],[[[23.69998,35.705004],[24.246665,35.368022],[25.025015,35.424996],[25.769208,35.354018],[25.745023,35.179998],[26.290003,35.29999],[26.164998,35.004995],[24.724982,34.919988],[24.735007,35.084991],[23.514978,35.279992],[23.69998,35.705004]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":57713,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"GL\",\"ISO_A3\":\"GRL\",\"TINY\":-99,\"HOMEPART\":-99,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[-73.297,60.03676,-12.20855,83.64513],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-46.76379,82.62796],[-43.40644,83.22516],[-39.89753,83.18018],[-38.62214,83.54905],[-35.08787,83.64513],[-27.10046,83.51966],[-20.84539,82.72669],[-22.69182,82.34165],[-26.51753,82.29765],[-31.9,82.2],[-31.39646,82.02154],[-27.85666,82.13178],[-24.84448,81.78697],[-22.90328,82.09317],[-22.07175,81.73449],[-23.16961,81.15271],[-20.62363,81.52462],[-15.76818,81.91245],[-12.77018,81.71885],[-12.20855,81.29154],[-16.28533,80.58004],[-16.85,80.35],[-20.04624,80.17708],[-17.73035,80.12912],[-18.9,79.4],[-19.70499,78.75128],[-19.67353,77.63859],[-18.47285,76.98565],[-20.03503,76.94434],[-21.67944,76.62795],[-19.83407,76.09808],[-19.59896,75.24838],[-20.66818,75.15585],[-19.37281,74.29561],[-21.59422,74.22382],[-20.43454,73.81713],[-20.76234,73.46436],[-22.17221,73.30955],[-23.56593,73.30663],[-22.31311,72.62928],[-22.29954,72.18409],[-24.27834,72.59788],[-24.79296,72.3302],[-23.44296,72.08016],[-22.13281,71.46898],[-21.75356,70.66369],[-23.53603,70.471],[-24.30702,70.85649],[-25.54341,71.43094],[-25.20135,70.75226],[-26.36276,70.22646],[-23.72742,70.18401],[-22.34902,70.12946],[-25.02927,69.2588],[-27.74737,68.47046],[-30.67371,68.12503],[-31.77665,68.12078],[-32.81105,67.73547],[-34.20196,66.67974],[-36.35284,65.9789],[-37.04378,65.93768],[-38.37505,65.69213],[-39.81222,65.45848],[-40.66899,64.83997],[-40.68281,64.13902],[-41.1887,63.48246],[-42.81938,62.68233],[-42.41666,61.90093],[-42.86619,61.07404],[-43.3784,60.09772],[-44.7875,60.03676],[-46.26364,60.85328],[-48.26294,60.85843],[-49.23308,61.40681],[-49.90039,62.38336],[-51.63325,63.62691],[-52.14014,64.27842],[-52.27659,65.1767],[-53.66166,66.09957],[-53.30161,66.8365],[-53.96911,67.18899],[-52.9804,68.35759],[-51.47536,68.72958],[-51.08041,69.14781],[-50.87122,69.9291],[-52.013585,69.574925],[-52.55792,69.42616],[-53.45629,69.283625],[-54.68336,69.61003],[-54.75001,70.28932],[-54.35884,70.821315],[-53.431315,70.835755],[-51.39014,70.56978],[-53.10937,71.20485],[-54.00422,71.54719],[-55,71.406537],[-55.83468,71.65444],[-54.71819,72.58625],[-55.32634,72.95861],[-56.12003,73.64977],[-57.32363,74.71026],[-58.59679,75.09861],[-58.58516,75.51727],[-61.26861,76.10238],[-63.39165,76.1752],[-66.06427,76.13486],[-68.50438,76.06141],[-69.66485,76.37975],[-71.40257,77.00857],[-68.77671,77.32312],[-66.76397,77.37595],[-71.04293,77.63595],[-73.297,78.04419],[-73.15938,78.43271],[-69.37345,78.91388],[-65.7107,79.39436],[-65.3239,79.75814],[-68.02298,80.11721],[-67.15129,80.51582],[-63.68925,81.21396],[-62.23444,81.3211],[-62.65116,81.77042],[-60.28249,82.03363],[-57.20744,82.19074],[-54.13442,82.19962],[-53.04328,81.88833],[-50.39061,82.43883],[-48.00386,82.06481],[-46.59984,81.985945],[-44.523,81.6607],[-46.9007,82.19979],[-46.76379,82.62796]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":15460732,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"GT\",\"ISO_A3\":\"GTM\",\"TINY\":4,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-92.229249,13.735338,-88.225023,17.819326],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-89.14308,17.808319],[-89.150806,17.015577],[-89.229122,15.886938],[-88.930613,15.887273],[-88.604586,15.70638],[-88.518364,15.855389],[-88.225023,15.727722],[-88.68068,15.346247],[-89.154811,15.066419],[-89.22522,14.874286],[-89.145535,14.678019],[-89.353326,14.424133],[-89.587343,14.362586],[-89.534219,14.244816],[-89.721934,14.134228],[-90.064678,13.88197],[-90.095555,13.735338],[-90.608624,13.909771],[-91.23241,13.927832],[-91.689747,14.126218],[-92.22775,14.538829],[-92.20323,14.830103],[-92.087216,15.064585],[-92.229249,15.251447],[-91.74796,16.066565],[-90.464473,16.069562],[-90.438867,16.41011],[-90.600847,16.470778],[-90.711822,16.687483],[-91.08167,16.918477],[-91.453921,17.252177],[-91.002269,17.254658],[-91.00152,17.817595],[-90.067934,17.819326],[-89.14308,17.808319]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":737718,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"GY\",\"ISO_A3\":\"GUY\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-61.410303,1.268088,-56.539386,8.367035],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-56.539386,1.899523],[-56.782704,1.863711],[-57.335823,1.948538],[-57.660971,1.682585],[-58.11345,1.507195],[-58.429477,1.463942],[-58.540013,1.268088],[-59.030862,1.317698],[-59.646044,1.786894],[-59.718546,2.24963],[-59.974525,2.755233],[-59.815413,3.606499],[-59.53804,3.958803],[-59.767406,4.423503],[-60.111002,4.574967],[-59.980959,5.014061],[-60.213683,5.244486],[-60.733574,5.200277],[-61.410303,5.959068],[-61.139415,6.234297],[-61.159336,6.696077],[-60.543999,6.856584],[-60.295668,7.043911],[-60.637973,7.415],[-60.550588,7.779603],[-59.758285,8.367035],[-59.101684,7.999202],[-58.482962,7.347691],[-58.454876,6.832787],[-58.078103,6.809094],[-57.542219,6.321268],[-57.147436,5.97315],[-57.307246,5.073567],[-57.914289,4.812626],[-57.86021,4.576801],[-58.044694,4.060864],[-57.601569,3.334655],[-57.281433,3.333492],[-57.150098,2.768927],[-56.539386,1.899523]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":9038741,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"HN\",\"ISO_A3\":\"HND\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9.5},\"bbox\":[-89.353326,12.984686,-83.147219,16.005406],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-89.353326,14.424133],[-89.145535,14.678019],[-89.22522,14.874286],[-89.154811,15.066419],[-88.68068,15.346247],[-88.225023,15.727722],[-88.121153,15.688655],[-87.901813,15.864458],[-87.61568,15.878799],[-87.522921,15.797279],[-87.367762,15.84694],[-86.903191,15.756713],[-86.440946,15.782835],[-86.119234,15.893449],[-86.001954,16.005406],[-85.683317,15.953652],[-85.444004,15.885749],[-85.182444,15.909158],[-84.983722,15.995923],[-84.52698,15.857224],[-84.368256,15.835158],[-84.063055,15.648244],[-83.773977,15.424072],[-83.410381,15.270903],[-83.147219,14.995829],[-83.489989,15.016267],[-83.628585,14.880074],[-83.975721,14.749436],[-84.228342,14.748764],[-84.449336,14.621614],[-84.649582,14.666805],[-84.820037,14.819587],[-84.924501,14.790493],[-85.052787,14.551541],[-85.148751,14.560197],[-85.165365,14.35437],[-85.514413,14.079012],[-85.698665,13.960078],[-85.801295,13.836055],[-86.096264,14.038187],[-86.312142,13.771356],[-86.520708,13.778487],[-86.755087,13.754845],[-86.733822,13.263093],[-86.880557,13.254204],[-87.005769,13.025794],[-87.316654,12.984686],[-87.489409,13.297535],[-87.793111,13.38448],[-87.723503,13.78505],[-87.859515,13.893312],[-88.065343,13.964626],[-88.503998,13.845486],[-88.541231,13.980155],[-88.843073,14.140507],[-89.058512,14.340029],[-89.353326,14.424133]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4292095,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"HR\",\"ISO_A3\":\"HRV\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[13.656976,42.479991,19.390476,46.503751],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[19.005485,44.860234],[18.553214,45.08159],[17.861783,45.06774],[17.002146,45.233777],[16.534939,45.211608],[16.318157,45.004127],[15.959367,45.233777],[15.750026,44.818712],[16.23966,44.351143],[16.456443,44.04124],[16.916156,43.667722],[17.297373,43.446341],[17.674922,43.028563],[18.56,42.65],[18.450017,42.479992],[18.450016,42.479991],[17.50997,42.849995],[16.930006,43.209998],[16.015385,43.507215],[15.174454,44.243191],[15.37625,44.317915],[14.920309,44.738484],[14.901602,45.07606],[14.258748,45.233777],[13.952255,44.802124],[13.656976,45.136935],[13.679403,45.484149],[13.71506,45.500324],[14.411968,45.466166],[14.595109,45.634941],[14.935244,45.471695],[15.327675,45.452316],[15.323954,45.731783],[15.67153,45.834154],[15.768733,46.238108],[16.564808,46.503751],[16.882515,46.380632],[17.630066,45.951769],[18.456062,45.759481],[18.829825,45.908872],[19.072769,45.521511],[19.390476,45.236516],[19.005485,44.860234]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":10646714,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"HT\",\"ISO_A3\":\"HTI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-74.458034,18.030993,-71.624873,19.915684],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-71.712361,19.714456],[-71.624873,19.169838],[-71.701303,18.785417],[-71.945112,18.6169],[-71.687738,18.31666],[-71.708305,18.044997],[-72.372476,18.214961],[-72.844411,18.145611],[-73.454555,18.217906],[-73.922433,18.030993],[-74.458034,18.34255],[-74.369925,18.664908],[-73.449542,18.526053],[-72.694937,18.445799],[-72.334882,18.668422],[-72.79165,19.101625],[-72.784105,19.483591],[-73.415022,19.639551],[-73.189791,19.915684],[-72.579673,19.871501],[-71.712361,19.714456]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":9850845,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"HU\",\"ISO_A3\":\"HUN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[16.202298,45.759481,22.710531,48.623854],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[16.202298,46.852386],[16.534268,47.496171],[16.340584,47.712902],[16.903754,47.714866],[16.979667,48.123497],[17.488473,47.867466],[17.857133,47.758429],[18.696513,47.880954],[18.777025,48.081768],[19.174365,48.111379],[19.661364,48.266615],[19.769471,48.202691],[20.239054,48.327567],[20.473562,48.56285],[20.801294,48.623854],[21.872236,48.319971],[22.085608,48.422264],[22.64082,48.15024],[22.710531,47.882194],[22.099768,47.672439],[21.626515,46.994238],[21.021952,46.316088],[20.220192,46.127469],[19.596045,46.17173],[18.829838,45.908878],[18.829825,45.908872],[18.456062,45.759481],[17.630066,45.951769],[16.882515,46.380632],[16.564808,46.503751],[16.370505,46.841327],[16.202298,46.852386]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":260580739,\"ECONOMY\":\"4. Emerging region: MIKT\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"ID\",\"ISO_A3\":\"IDN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[95.293026,-10.359987,141.033852,5.479821],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[120.715609,-10.239581],[120.295014,-10.25865],[118.967808,-9.557969],[119.90031,-9.36134],[120.425756,-9.665921],[120.775502,-9.969675],[120.715609,-10.239581]]],[[[124.968682,-8.89279],[125.07002,-9.089987],[125.08852,-9.393173],[124.43595,-10.140001],[123.579982,-10.359987],[123.459989,-10.239995],[123.550009,-9.900016],[123.980009,-9.290027],[124.968682,-8.89279]]],[[[117.900018,-8.095681],[118.260616,-8.362383],[118.87846,-8.280683],[119.126507,-8.705825],[117.970402,-8.906639],[117.277731,-9.040895],[116.740141,-9.032937],[117.083737,-8.457158],[117.632024,-8.449303],[117.900018,-8.095681]]],[[[122.903537,-8.094234],[122.756983,-8.649808],[121.254491,-8.933666],[119.924391,-8.810418],[119.920929,-8.444859],[120.715092,-8.236965],[121.341669,-8.53674],[122.007365,-8.46062],[122.903537,-8.094234]]],[[[108.623479,-6.777674],[110.539227,-6.877358],[110.759576,-6.465186],[112.614811,-6.946036],[112.978768,-7.594213],[114.478935,-7.776528],[115.705527,-8.370807],[114.564511,-8.751817],[113.464734,-8.348947],[112.559672,-8.376181],[111.522061,-8.302129],[110.58615,-8.122605],[109.427667,-7.740664],[108.693655,-7.6416],[108.277763,-7.766657],[106.454102,-7.3549],[106.280624,-6.9249],[105.365486,-6.851416],[106.051646,-5.895919],[107.265009,-5.954985],[108.072091,-6.345762],[108.486846,-6.421985],[108.623479,-6.777674]]],[[[134.724624,-6.214401],[134.210134,-6.895238],[134.112776,-6.142467],[134.290336,-5.783058],[134.499625,-5.445042],[134.727002,-5.737582],[134.724624,-6.214401]]],[[[127.249215,-3.459065],[126.874923,-3.790983],[126.183802,-3.607376],[125.989034,-3.177273],[127.000651,-3.129318],[127.249215,-3.459065]]],[[[130.471344,-3.093764],[130.834836,-3.858472],[129.990547,-3.446301],[129.155249,-3.362637],[128.590684,-3.428679],[127.898891,-3.393436],[128.135879,-2.84365],[129.370998,-2.802154],[130.471344,-3.093764]]],[[[141.00021,-2.600151],[141.017057,-5.859022],[141.033852,-9.117893],[140.143415,-8.297168],[139.127767,-8.096043],[138.881477,-8.380935],[137.614474,-8.411683],[138.039099,-7.597882],[138.668621,-7.320225],[138.407914,-6.232849],[137.92784,-5.393366],[135.98925,-4.546544],[135.164598,-4.462931],[133.66288,-3.538853],[133.367705,-4.024819],[132.983956,-4.112979],[132.756941,-3.746283],[132.753789,-3.311787],[131.989804,-2.820551],[133.066845,-2.460418],[133.780031,-2.479848],[133.696212,-2.214542],[132.232373,-2.212526],[131.836222,-1.617162],[130.94284,-1.432522],[130.519558,-0.93772],[131.867538,-0.695461],[132.380116,-0.369538],[133.985548,-0.78021],[134.143368,-1.151867],[134.422627,-2.769185],[135.457603,-3.367753],[136.293314,-2.307042],[137.440738,-1.703513],[138.329727,-1.702686],[139.184921,-2.051296],[139.926684,-2.409052],[141.00021,-2.600151]]],[[[125.240501,1.419836],[124.437035,0.427881],[123.685505,0.235593],[122.723083,0.431137],[121.056725,0.381217],[120.183083,0.237247],[120.04087,-0.519658],[120.935905,-1.408906],[121.475821,-0.955962],[123.340565,-0.615673],[123.258399,-1.076213],[122.822715,-0.930951],[122.38853,-1.516858],[121.508274,-1.904483],[122.454572,-3.186058],[122.271896,-3.5295],[123.170963,-4.683693],[123.162333,-5.340604],[122.628515,-5.634591],[122.236394,-5.282933],[122.719569,-4.464172],[121.738234,-4.851331],[121.489463,-4.574553],[121.619171,-4.188478],[120.898182,-3.602105],[120.972389,-2.627643],[120.305453,-2.931604],[120.390047,-4.097579],[120.430717,-5.528241],[119.796543,-5.6734],[119.366906,-5.379878],[119.653606,-4.459417],[119.498835,-3.494412],[119.078344,-3.487022],[118.767769,-2.801999],[119.180974,-2.147104],[119.323394,-1.353147],[119.825999,0.154254],[120.035702,0.566477],[120.885779,1.309223],[121.666817,1.013944],[122.927567,0.875192],[124.077522,0.917102],[125.065989,1.643259],[125.240501,1.419836]]],[[[128.688249,1.132386],[128.635952,0.258486],[128.12017,0.356413],[127.968034,-0.252077],[128.379999,-0.780004],[128.100016,-0.899996],[127.696475,-0.266598],[127.39949,1.011722],[127.600512,1.810691],[127.932378,2.174596],[128.004156,1.628531],[128.594559,1.540811],[128.688249,1.132386]]],[[[109.66326,2.006467],[109.830227,1.338136],[110.514061,0.773131],[111.159138,0.976478],[111.797548,0.904441],[112.380252,1.410121],[112.859809,1.49779],[113.80585,1.217549],[114.621355,1.430688],[115.134037,2.821482],[115.519078,3.169238],[115.865517,4.306559],[117.015214,4.306094],[117.882035,4.137551],[117.313232,3.234428],[118.04833,2.28769],[117.875627,1.827641],[118.996747,0.902219],[117.811858,0.784242],[117.478339,0.102475],[117.521644,-0.803723],[116.560048,-1.487661],[116.533797,-2.483517],[116.148084,-4.012726],[116.000858,-3.657037],[114.864803,-4.106984],[114.468652,-3.495704],[113.755672,-3.43917],[113.256994,-3.118776],[112.068126,-3.478392],[111.703291,-2.994442],[111.04824,-3.049426],[110.223846,-2.934032],[110.070936,-1.592874],[109.571948,-1.314907],[109.091874,-0.459507],[108.952658,0.415375],[109.069136,1.341934],[109.66326,2.006467]]],[[[105.817655,-5.852356],[104.710384,-5.873285],[103.868213,-5.037315],[102.584261,-4.220259],[102.156173,-3.614146],[101.399113,-2.799777],[100.902503,-2.050262],[100.141981,-0.650348],[99.26374,0.183142],[98.970011,1.042882],[98.601351,1.823507],[97.699598,2.453184],[97.176942,3.308791],[96.424017,3.86886],[95.380876,4.970782],[95.293026,5.479821],[95.936863,5.439513],[97.484882,5.246321],[98.369169,4.26837],[99.142559,3.59035],[99.693998,3.174329],[100.641434,2.099381],[101.658012,2.083697],[102.498271,1.3987],[103.07684,0.561361],[103.838396,0.104542],[103.437645,-0.711946],[104.010789,-1.059212],[104.369991,-1.084843],[104.53949,-1.782372],[104.887893,-2.340425],[105.622111,-2.428844],[106.108593,-3.061777],[105.857446,-4.305525],[105.817655,-5.852356]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1281935911,\"ECONOMY\":\"3. Emerging region: BRIC\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"IN\",\"ISO_A3\":\"IND\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[68.176645,7.965535,97.402561,35.49401],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[92.672721,22.041239],[92.146035,23.627499],[91.869928,23.624346],[91.706475,22.985264],[91.158963,23.503527],[91.46773,24.072639],[91.915093,24.130414],[92.376202,24.976693],[91.799596,25.147432],[90.872211,25.132601],[89.920693,25.26975],[89.832481,25.965082],[89.355094,26.014407],[88.563049,26.446526],[88.209789,25.768066],[88.931554,25.238692],[88.306373,24.866079],[88.084422,24.501657],[88.69994,24.233715],[88.52977,23.631142],[88.876312,22.879146],[89.031961,22.055708],[88.888766,21.690588],[88.208497,21.703172],[86.975704,21.495562],[87.033169,20.743308],[86.499351,20.151638],[85.060266,19.478579],[83.941006,18.30201],[83.189217,17.671221],[82.192792,17.016636],[82.191242,16.556664],[81.692719,16.310219],[80.791999,15.951972],[80.324896,15.899185],[80.025069,15.136415],[80.233274,13.835771],[80.286294,13.006261],[79.862547,12.056215],[79.857999,10.357275],[79.340512,10.308854],[78.885345,9.546136],[79.18972,9.216544],[78.277941,8.933047],[77.941165,8.252959],[77.539898,7.965535],[76.592979,8.899276],[76.130061,10.29963],[75.746467,11.308251],[75.396101,11.781245],[74.864816,12.741936],[74.616717,13.992583],[74.443859,14.617222],[73.534199,15.990652],[73.119909,17.92857],[72.820909,19.208234],[72.824475,20.419503],[72.630533,21.356009],[71.175273,20.757441],[70.470459,20.877331],[69.16413,22.089298],[69.644928,22.450775],[69.349597,22.84318],[68.176645,23.691965],[68.842599,24.359134],[71.04324,24.356524],[70.844699,25.215102],[70.282873,25.722229],[70.168927,26.491872],[69.514393,26.940966],[70.616496,27.989196],[71.777666,27.91318],[72.823752,28.961592],[73.450638,29.976413],[74.42138,30.979815],[74.405929,31.692639],[75.258642,32.271105],[74.451559,32.7649],[74.104294,33.441473],[73.749948,34.317699],[74.240203,34.748887],[75.757061,34.504923],[76.871722,34.653544],[77.837451,35.49401],[78.912269,34.321936],[78.811086,33.506198],[79.208892,32.994395],[79.176129,32.48378],[78.458446,32.618164],[78.738894,31.515906],[79.721367,30.882715],[81.111256,30.183481],[80.476721,29.729865],[80.088425,28.79447],[81.057203,28.416095],[81.999987,27.925479],[83.304249,27.364506],[84.675018,27.234901],[85.251779,26.726198],[86.024393,26.630985],[87.227472,26.397898],[88.060238,26.414615],[88.174804,26.810405],[88.043133,27.445819],[88.120441,27.876542],[88.730326,28.086865],[88.814248,27.299316],[88.835643,27.098966],[89.744528,26.719403],[90.373275,26.875724],[91.217513,26.808648],[92.033484,26.83831],[92.103712,27.452614],[91.696657,27.771742],[92.503119,27.896876],[93.413348,28.640629],[94.56599,29.277438],[95.404802,29.031717],[96.117679,29.452802],[96.586591,28.83098],[96.248833,28.411031],[97.327114,28.261583],[97.402561,27.882536],[97.051989,27.699059],[97.133999,27.083774],[96.419366,27.264589],[95.124768,26.573572],[95.155153,26.001307],[94.603249,25.162495],[94.552658,24.675238],[94.106742,23.850741],[93.325188,24.078556],[93.286327,23.043658],[93.060294,22.703111],[93.166128,22.27846],[92.672721,22.041239]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5011102,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"IE\",\"ISO_A3\":\"IRL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-9.977086,51.669301,-6.032985,55.131622],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-7.572168,55.131622],[-7.366031,54.595841],[-7.572168,54.059956],[-6.95373,54.073702],[-6.197885,53.867565],[-6.032985,53.153164],[-6.788857,52.260118],[-8.561617,51.669301],[-9.977086,51.820455],[-9.166283,52.864629],[-9.688525,53.881363],[-8.327987,54.664519],[-7.572168,55.131622]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":82021564,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"IR\",\"ISO_A3\":\"IRN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2.5,\"MAX_LABEL\":6.7},\"bbox\":[44.109225,25.078237,63.316632,39.713003],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[61.210817,35.650072],[60.803193,34.404102],[60.52843,33.676446],[60.9637,33.528832],[60.536078,32.981269],[60.863655,32.18292],[60.941945,31.548075],[61.699314,31.379506],[61.781222,30.73585],[60.874248,29.829239],[61.369309,29.303276],[61.771868,28.699334],[62.72783,28.259645],[62.755426,27.378923],[63.233898,27.217047],[63.316632,26.756532],[61.874187,26.239975],[61.497363,25.078237],[59.616134,25.380157],[58.525761,25.609962],[57.397251,25.739902],[56.970766,26.966106],[56.492139,27.143305],[55.72371,26.964633],[54.71509,26.480658],[53.493097,26.812369],[52.483598,27.580849],[51.520763,27.86569],[50.852948,28.814521],[50.115009,30.147773],[49.57685,29.985715],[48.941333,30.31709],[48.567971,29.926778],[48.014568,30.452457],[48.004698,30.985137],[47.685286,30.984853],[47.849204,31.709176],[47.334661,32.469155],[46.109362,33.017287],[45.416691,33.967798],[45.64846,34.748138],[46.151788,35.093259],[46.07634,35.677383],[45.420618,35.977546],[44.772677,37.170437],[44.77267,37.17045],[44.225756,37.971584],[44.421403,38.281281],[44.109225,39.428136],[44.79399,39.713003],[44.952688,39.335765],[45.457722,38.874139],[46.143623,38.741201],[46.50572,38.770605],[47.685079,39.508364],[48.060095,39.582235],[48.355529,39.288765],[48.010744,38.794015],[48.634375,38.270378],[48.883249,38.320245],[49.199612,37.582874],[50.147771,37.374567],[50.842354,36.872814],[52.264025,36.700422],[53.82579,36.965031],[53.921598,37.198918],[54.800304,37.392421],[55.511578,37.964117],[56.180375,37.935127],[56.619366,38.121394],[57.330434,38.029229],[58.436154,37.522309],[59.234762,37.412988],[60.377638,36.527383],[61.123071,36.491597],[61.210817,35.650072]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":39192111,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"IQ\",\"ISO_A3\":\"IRQ\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7.5},\"bbox\":[38.792341,29.099025,48.567971,37.385264],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[44.772677,37.170437],[45.420618,35.977546],[46.07634,35.677383],[46.151788,35.093259],[45.64846,34.748138],[45.416691,33.967798],[46.109362,33.017287],[47.334661,32.469155],[47.849204,31.709176],[47.685286,30.984853],[48.004698,30.985137],[48.014568,30.452457],[48.567971,29.926778],[47.974519,29.975819],[47.302622,30.05907],[46.568713,29.099025],[44.709499,29.178891],[41.889981,31.190009],[40.399994,31.889992],[39.195468,32.161009],[38.792341,33.378686],[41.006159,34.419372],[41.383965,35.628317],[41.289707,36.358815],[41.837064,36.605854],[42.349591,37.229873],[42.779126,37.385264],[43.942259,37.256228],[44.293452,37.001514],[44.772677,37.170437]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":339747,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"IS\",\"ISO_A3\":\"ISL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[-24.326184,63.496383,-13.609732,66.526792],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-14.508695,66.455892],[-14.739637,65.808748],[-13.609732,65.126671],[-14.909834,64.364082],[-17.794438,63.678749],[-18.656246,63.496383],[-19.972755,63.643635],[-22.762972,63.960179],[-21.778484,64.402116],[-23.955044,64.89113],[-22.184403,65.084968],[-22.227423,65.378594],[-24.326184,65.611189],[-23.650515,66.262519],[-22.134922,66.410469],[-20.576284,65.732112],[-19.056842,66.276601],[-17.798624,65.993853],[-16.167819,66.526792],[-14.508695,66.455892]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":8299706,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"IL\",\"ISO_A3\":\"ISR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[34.265433,29.501326,35.836397,33.277426],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[34.823243,29.761081],[34.26544,31.21936],[34.265435,31.219357],[34.265433,31.219361],[34.556372,31.548824],[34.488107,31.605539],[34.752587,32.072926],[34.955417,32.827376],[35.098457,33.080539],[35.126053,33.0909],[35.460709,33.08904],[35.552797,33.264275],[35.821101,33.277426],[35.836397,32.868123],[35.700798,32.716014],[35.719918,32.709192],[35.545665,32.393992],[35.18393,32.532511],[34.974641,31.866582],[35.225892,31.754341],[34.970507,31.616778],[34.927408,31.353435],[35.397561,31.489086],[35.420918,31.100066],[34.922603,29.501326],[34.823243,29.761081]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":62137802,\"ECONOMY\":\"1. Developed region: G7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"IT\",\"ISO_A3\":\"ITA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[6.749955,36.619987,18.480247,47.115393],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[10.442701,46.893546],[11.048556,46.751359],[11.164828,46.941579],[12.153088,47.115393],[12.376485,46.767559],[13.806475,46.509306],[13.69811,46.016778],[13.93763,45.591016],[13.141606,45.736692],[12.328581,45.381778],[12.383875,44.885374],[12.261453,44.600482],[12.589237,44.091366],[13.526906,43.587727],[14.029821,42.761008],[15.14257,41.95514],[15.926191,41.961315],[16.169897,41.740295],[15.889346,41.541082],[16.785002,41.179606],[17.519169,40.877143],[18.376687,40.355625],[18.480247,40.168866],[18.293385,39.810774],[17.73838,40.277671],[16.869596,40.442235],[16.448743,39.795401],[17.17149,39.4247],[17.052841,38.902871],[16.635088,38.843572],[16.100961,37.985899],[15.684087,37.908849],[15.687963,38.214593],[15.891981,38.750942],[16.109332,38.964547],[15.718814,39.544072],[15.413613,40.048357],[14.998496,40.172949],[14.703268,40.60455],[14.060672,40.786348],[13.627985,41.188287],[12.888082,41.25309],[12.106683,41.704535],[11.191906,42.355425],[10.511948,42.931463],[10.200029,43.920007],[9.702488,44.036279],[8.888946,44.366336],[8.428561,44.231228],[7.850767,43.767148],[7.435185,43.693845],[7.549596,44.127901],[7.007562,44.254767],[6.749955,45.028518],[7.096652,45.333099],[6.802355,45.70858],[6.843593,45.991147],[7.273851,45.776948],[7.755992,45.82449],[8.31663,46.163642],[8.489952,46.005151],[8.966306,46.036932],[9.182882,46.440215],[9.922837,46.314899],[10.363378,46.483571],[10.442701,46.893546]]],[[[15.520376,38.231155],[15.160243,37.444046],[15.309898,37.134219],[15.099988,36.619987],[14.335229,36.996631],[13.826733,37.104531],[12.431004,37.61295],[12.570944,38.126381],[13.741156,38.034966],[14.761249,38.143874],[15.520376,38.231155]]],[[[9.210012,41.209991],[9.809975,40.500009],[9.669519,39.177376],[9.214818,39.240473],[8.806936,38.906618],[8.428302,39.171847],[8.388253,40.378311],[8.159998,40.950007],[8.709991,40.899984],[9.210012,41.209991]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2990561,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"JM\",\"ISO_A3\":\"JAM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-78.337719,17.701116,-76.199659,18.524218],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-77.569601,18.490525],[-76.896619,18.400867],[-76.365359,18.160701],[-76.199659,17.886867],[-76.902561,17.868238],[-77.206341,17.701116],[-77.766023,17.861597],[-78.337719,18.225968],[-78.217727,18.454533],[-77.797365,18.524218],[-77.569601,18.490525]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":10248069,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"JO\",\"ISO_A3\":\"JOR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[34.922603,29.197495,39.195468,33.378686],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[38.792341,33.378686],[39.195468,32.161009],[39.004886,32.010217],[37.002166,31.508413],[37.998849,30.5085],[37.66812,30.338665],[37.503582,30.003776],[36.740528,29.865283],[36.501214,29.505254],[36.068941,29.197495],[34.956037,29.356555],[34.922603,29.501326],[35.420918,31.100066],[35.397561,31.489086],[35.545252,31.782505],[35.545665,32.393992],[35.719918,32.709192],[36.834062,32.312938],[38.792341,33.378686]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":126451398,\"ECONOMY\":\"1. Developed region: G7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"JP\",\"ISO_A3\":\"JPN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":7},\"bbox\":[129.408463,31.029579,145.543137,45.551483],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[134.638428,34.149234],[134.766379,33.806335],[134.203416,33.201178],[133.79295,33.521985],[133.280268,33.28957],[133.014858,32.704567],[132.363115,32.989382],[132.371176,33.463642],[132.924373,34.060299],[133.492968,33.944621],[133.904106,34.364931],[134.638428,34.149234]]],[[[140.976388,37.142074],[140.59977,36.343983],[140.774074,35.842877],[140.253279,35.138114],[138.975528,34.6676],[137.217599,34.606286],[135.792983,33.464805],[135.120983,33.849071],[135.079435,34.596545],[133.340316,34.375938],[132.156771,33.904933],[130.986145,33.885761],[132.000036,33.149992],[131.33279,31.450355],[130.686318,31.029579],[130.20242,31.418238],[130.447676,32.319475],[129.814692,32.61031],[129.408463,33.296056],[130.353935,33.604151],[130.878451,34.232743],[131.884229,34.749714],[132.617673,35.433393],[134.608301,35.731618],[135.677538,35.527134],[136.723831,37.304984],[137.390612,36.827391],[138.857602,37.827485],[139.426405,38.215962],[140.05479,39.438807],[139.883379,40.563312],[140.305783,41.195005],[141.368973,41.37856],[141.914263,39.991616],[141.884601,39.180865],[140.959489,38.174001],[140.976388,37.142074]]],[[[143.910162,44.1741],[144.613427,43.960883],[145.320825,44.384733],[145.543137,43.262088],[144.059662,42.988358],[143.18385,41.995215],[141.611491,42.678791],[141.067286,41.584594],[139.955106,41.569556],[139.817544,42.563759],[140.312087,43.333273],[141.380549,43.388825],[141.671952,44.772125],[141.967645,45.551483],[143.14287,44.510358],[143.910162,44.1741]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":18556698,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"KZ\",\"ISO_A3\":\"KAZ\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[46.466446,40.662325,87.35997,55.38525],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[87.35997,49.214981],[86.598776,48.549182],[85.768233,48.455751],[85.720484,47.452969],[85.16429,47.000956],[83.180484,47.330031],[82.458926,45.53965],[81.947071,45.317027],[79.966106,44.917517],[80.866206,43.180362],[80.18015,42.920068],[80.25999,42.349999],[79.643645,42.496683],[79.142177,42.856092],[77.658392,42.960686],[76.000354,42.988022],[75.636965,42.8779],[74.212866,43.298339],[73.645304,43.091272],[73.489758,42.500894],[71.844638,42.845395],[71.186281,42.704293],[70.962315,42.266154],[70.388965,42.081308],[69.070027,41.384244],[68.632483,40.668681],[68.259896,40.662325],[67.985856,41.135991],[66.714047,41.168444],[66.510649,41.987644],[66.023392,41.994646],[66.098012,42.99766],[64.900824,43.728081],[63.185787,43.650075],[62.0133,43.504477],[61.05832,44.405817],[60.239972,44.784037],[58.689989,45.500014],[58.503127,45.586804],[55.928917,44.995858],[55.968191,41.308642],[55.455251,41.259859],[54.755345,42.043971],[54.079418,42.324109],[52.944293,42.116034],[52.50246,41.783316],[52.446339,42.027151],[52.692112,42.443895],[52.501426,42.792298],[51.342427,43.132975],[50.891292,44.031034],[50.339129,44.284016],[50.305643,44.609836],[51.278503,44.514854],[51.316899,45.245998],[52.16739,45.408391],[53.040876,45.259047],[53.220866,46.234646],[53.042737,46.853006],[52.042023,46.804637],[51.191945,47.048705],[50.034083,46.60899],[49.10116,46.39933],[48.59325,46.56104],[48.694734,47.075628],[48.05725,47.74377],[47.31524,47.71585],[46.466446,48.394152],[47.043672,49.152039],[46.751596,49.356006],[47.54948,50.454698],[48.577841,49.87476],[48.702382,50.605128],[50.766648,51.692762],[52.328724,51.718652],[54.532878,51.02624],[55.71694,50.62171],[56.77798,51.04355],[58.36332,51.06364],[59.642282,50.545442],[59.932807,50.842194],[61.337424,50.79907],[61.588003,51.272659],[59.967534,51.96042],[60.927269,52.447548],[60.739993,52.719986],[61.699986,52.979996],[60.978066,53.664993],[61.4366,54.00625],[65.178534,54.354228],[65.66687,54.60125],[68.1691,54.970392],[69.068167,55.38525],[70.865267,55.169734],[71.180131,54.133285],[72.22415,54.376655],[73.508516,54.035617],[73.425679,53.48981],[74.38482,53.54685],[76.8911,54.490524],[76.525179,54.177003],[77.800916,53.404415],[80.03556,50.864751],[80.568447,51.388336],[81.945986,50.812196],[83.383004,51.069183],[83.935115,50.889246],[84.416377,50.3114],[85.11556,50.117303],[85.54127,49.692859],[86.829357,49.826675],[87.35997,49.214981]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":47615739,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"KE\",\"ISO_A3\":\"KEN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[33.893569,-4.67677,41.855083,5.506],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[35.298007,5.506],[35.817448,5.338232],[35.817448,4.776966],[36.159079,4.447864],[36.855093,4.447864],[38.120915,3.598605],[38.43697,3.58851],[38.67114,3.61607],[38.89251,3.50074],[39.559384,3.42206],[39.85494,3.83879],[40.76848,4.25702],[41.1718,3.91909],[41.855083,3.918912],[40.98105,2.78452],[40.993,-0.85829],[41.58513,-1.68325],[40.88477,-2.08255],[40.63785,-2.49979],[40.26304,-2.57309],[40.12119,-3.27768],[39.80006,-3.68116],[39.60489,-4.34653],[39.20222,-4.67677],[37.7669,-3.67712],[37.69869,-3.09699],[34.07262,-1.05982],[33.903711,-0.95],[33.893569,0.109814],[34.18,0.515],[34.6721,1.17694],[35.03599,1.90584],[34.59607,3.05374],[34.47913,3.5556],[34.005,4.249885],[34.620196,4.847123],[35.298007,5.506]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5789122,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"KG\",\"ISO_A3\":\"KGZ\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[69.464887,39.279463,80.25999,43.298339],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[80.25999,42.349999],[80.11943,42.123941],[78.543661,41.582243],[78.187197,41.185316],[76.904484,41.066486],[76.526368,40.427946],[75.467828,40.562072],[74.776862,40.366425],[73.822244,39.893973],[73.960013,39.660008],[73.675379,39.431237],[71.784694,39.279463],[70.549162,39.604198],[69.464887,39.526683],[69.55961,40.103211],[70.648019,39.935754],[71.014198,40.244366],[71.774875,40.145844],[73.055417,40.866033],[71.870115,41.3929],[71.157859,41.143587],[70.420022,41.519998],[71.259248,42.167711],[70.962315,42.266154],[71.186281,42.704293],[71.844638,42.845395],[73.489758,42.500894],[73.645304,43.091272],[74.212866,43.298339],[75.636965,42.8779],[76.000354,42.988022],[77.658392,42.960686],[79.142177,42.856092],[79.643645,42.496683],[80.25999,42.349999]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":16204486,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"KH\",\"ISO_A3\":\"KHM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[102.348099,10.486544,107.614548,14.570584],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[102.584932,12.186595],[102.348099,13.394247],[102.988422,14.225721],[104.281418,14.416743],[105.218777,14.273212],[106.043946,13.881091],[106.496373,14.570584],[107.382727,14.202441],[107.614548,13.535531],[107.491403,12.337206],[105.810524,11.567615],[106.24967,10.961812],[105.199915,10.88931],[104.334335,10.486544],[103.49728,10.632555],[103.09069,11.153661],[102.584932,12.186595]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":51181299,\"ECONOMY\":\"4. Emerging region: MIKT\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"KR\",\"ISO_A3\":\"KOR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[126.117398,34.390046,129.468304,38.612243],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[128.349716,38.612243],[129.21292,37.432392],[129.46045,36.784189],[129.468304,35.632141],[129.091377,35.082484],[128.18585,34.890377],[127.386519,34.475674],[126.485748,34.390046],[126.37392,34.93456],[126.559231,35.684541],[126.117398,36.725485],[126.860143,36.893924],[126.174759,37.749686],[126.237339,37.840378],[126.68372,37.804773],[127.073309,38.256115],[127.780035,38.304536],[128.205746,38.370397],[128.349716,38.612243]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1895250,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"XK\",\"ISO_A3\":\"-99\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[20.0707,41.84711,21.77505,43.27205],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[20.590247,41.855409],[20.52295,42.21787],[20.283755,42.32026],[20.0707,42.58863],[20.25758,42.81275],[20.49679,42.88469],[20.63508,43.21671],[20.81448,43.27205],[20.95651,43.13094],[21.143395,43.068685],[21.27421,42.90959],[21.43866,42.86255],[21.63302,42.67717],[21.77505,42.6827],[21.66292,42.43922],[21.54332,42.32025],[21.576636,42.245224],[21.3527,42.2068],[20.76216,42.05186],[20.71731,41.84711],[20.590247,41.855409]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2875422,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"KW\",\"ISO_A3\":\"KWT\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[46.568713,28.526063,48.416094,30.05907],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[46.568713,29.099025],[47.302622,30.05907],[47.974519,29.975819],[48.183189,29.534477],[48.093943,29.306299],[48.416094,28.552004],[47.708851,28.526063],[47.459822,29.002519],[46.568713,29.099025]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":7126706,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"LA\",\"ISO_A3\":\"LAO\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[100.115988,13.881091,107.564525,22.464753],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[101.180005,21.436573],[101.270026,21.201652],[101.80312,21.174367],[101.652018,22.318199],[102.170436,22.464753],[102.754896,21.675137],[103.203861,20.766562],[104.435,20.758733],[104.822574,19.886642],[104.183388,19.624668],[103.896532,19.265181],[105.094598,18.666975],[105.925762,17.485315],[106.556008,16.604284],[107.312706,15.908538],[107.564525,15.202173],[107.382727,14.202441],[106.496373,14.570584],[106.043946,13.881091],[105.218777,14.273212],[105.544338,14.723934],[105.589039,15.570316],[104.779321,16.441865],[104.716947,17.428859],[103.956477,18.240954],[103.200192,18.309632],[102.998706,17.961695],[102.413005,17.932782],[102.113592,18.109102],[101.059548,17.512497],[101.035931,18.408928],[101.282015,19.462585],[100.606294,19.508344],[100.548881,20.109238],[100.115988,20.41785],[100.329101,20.786122],[101.180005,21.436573]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6229794,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"LB\",\"ISO_A3\":\"LBN\",\"TINY\":4,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[35.126053,33.08904,36.61175,34.644914],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[35.821101,33.277426],[35.552797,33.264275],[35.460709,33.08904],[35.126053,33.0909],[35.482207,33.90545],[35.979592,34.610058],[35.998403,34.644914],[36.448194,34.593935],[36.61175,34.201789],[36.06646,33.824912],[35.821101,33.277426]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4689021,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"LR\",\"ISO_A3\":\"LBR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-11.438779,4.355755,-7.539715,8.541055],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-8.439298,7.686043],[-8.485446,7.395208],[-8.385452,6.911801],[-8.60288,6.467564],[-8.311348,6.193033],[-7.993693,6.12619],[-7.570153,5.707352],[-7.539715,5.313345],[-7.635368,5.188159],[-7.712159,4.364566],[-7.974107,4.355755],[-9.004794,4.832419],[-9.91342,5.593561],[-10.765384,6.140711],[-11.438779,6.785917],[-11.199802,7.105846],[-11.146704,7.396706],[-10.695595,7.939464],[-10.230094,8.406206],[-10.016567,8.428504],[-9.755342,8.541055],[-9.33728,7.928534],[-9.403348,7.526905],[-9.208786,7.313921],[-8.926065,7.309037],[-8.722124,7.711674],[-8.439298,7.686043]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6653210,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"LY\",\"ISO_A3\":\"LBY\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[9.319411,19.58047,25.16482,33.136996],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[11.999506,23.471668],[11.560669,24.097909],[10.771364,24.562532],[10.303847,24.379313],[9.948261,24.936954],[9.910693,25.365455],[9.319411,26.094325],[9.716286,26.512206],[9.629056,27.140953],[9.756128,27.688259],[9.683885,28.144174],[9.859998,28.95999],[9.805634,29.424638],[9.48214,30.307556],[9.970017,30.539325],[10.056575,30.961831],[9.950225,31.37607],[10.636901,31.761421],[10.94479,32.081815],[11.432253,32.368903],[11.488787,33.136996],[12.66331,32.79278],[13.08326,32.87882],[13.91868,32.71196],[15.24563,32.26508],[15.71394,31.37626],[16.61162,31.18218],[18.02109,30.76357],[19.08641,30.26639],[19.57404,30.52582],[20.05335,30.98576],[19.82033,31.75179],[20.13397,32.2382],[20.85452,32.7068],[21.54298,32.8432],[22.89576,32.63858],[23.2368,32.19149],[23.60913,32.18726],[23.9275,32.01667],[24.92114,31.89936],[25.16482,31.56915],[24.80287,31.08929],[24.95762,30.6616],[24.70007,30.04419],[25,29.238655],[25,25.6825],[25,22],[25,20.00304],[23.85,20],[23.83766,19.58047],[19.84926,21.49509],[15.86085,23.40972],[14.8513,22.86295],[14.143871,22.491289],[13.581425,23.040506],[11.999506,23.471668]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":22409381,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"LK\",\"ISO_A3\":\"LKA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[79.695167,5.96837,81.787959,9.824078],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[81.787959,7.523055],[81.637322,6.481775],[81.21802,6.197141],[80.348357,5.96837],[79.872469,6.763463],[79.695167,8.200843],[80.147801,9.824078],[80.838818,9.268427],[81.304319,8.564206],[81.787959,7.523055]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1958042,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"LS\",\"ISO_A3\":\"LSO\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[26.999262,-30.645106,29.325166,-28.647502],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[28.978263,-28.955597],[29.325166,-29.257387],[29.018415,-29.743766],[28.8484,-30.070051],[28.291069,-30.226217],[28.107205,-30.545732],[27.749397,-30.645106],[26.999262,-29.875954],[27.532511,-29.242711],[28.074338,-28.851469],[28.5417,-28.647502],[28.978263,-28.955597]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2823859,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"LT\",\"ISO_A3\":\"LTU\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[21.0558,53.905702,26.588279,56.372528],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[26.494331,55.615107],[26.588279,55.167176],[25.768433,54.846963],[25.536354,54.282423],[24.450684,53.905702],[23.484128,53.912498],[23.243987,54.220567],[22.731099,54.327537],[22.651052,54.582741],[22.757764,54.856574],[22.315724,55.015299],[21.268449,55.190482],[21.0558,56.031076],[22.201157,56.337802],[23.878264,56.273671],[24.860684,56.372528],[25.000934,56.164531],[25.533047,56.100297],[26.494331,55.615107]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":594130,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"LU\",\"ISO_A3\":\"LUX\",\"TINY\":5,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5.7,\"MAX_LABEL\":10},\"bbox\":[5.674052,49.442667,6.242751,50.128052],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[5.674052,49.529484],[5.782417,50.090328],[6.043073,50.128052],[6.242751,49.902226],[6.18632,49.463803],[5.897759,49.442667],[5.674052,49.529484]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1944643,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"LV\",\"ISO_A3\":\"LVA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[21.0558,55.615107,28.176709,57.970157],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[28.176709,56.16913],[27.10246,55.783314],[26.494331,55.615107],[25.533047,56.100297],[25.000934,56.164531],[24.860684,56.372528],[23.878264,56.273671],[22.201157,56.337802],[21.0558,56.031076],[21.090424,56.783873],[21.581866,57.411871],[22.524341,57.753374],[23.318453,57.006236],[24.12073,57.025693],[24.312863,57.793424],[25.164594,57.970157],[25.60281,57.847529],[26.463532,57.476389],[27.288185,57.474528],[27.770016,57.244258],[27.855282,56.759326],[28.176709,56.16913]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":33986655,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"MA\",\"ISO_A3\":\"MAR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-17.020428,21.420734,-1.124551,35.759988],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-2.169914,35.168396],[-1.792986,34.527919],[-1.733455,33.919713],[-1.388049,32.864015],[-1.124551,32.651522],[-1.307899,32.262889],[-2.616605,32.094346],[-3.06898,31.724498],[-3.647498,31.637294],[-3.690441,30.896952],[-4.859646,30.501188],[-5.242129,30.000443],[-6.060632,29.7317],[-7.059228,29.579228],[-8.674116,28.841289],[-8.66559,27.656426],[-8.817828,27.656426],[-8.794884,27.120696],[-9.413037,27.088476],[-9.735343,26.860945],[-10.189424,26.860945],[-10.551263,26.990808],[-11.392555,26.883424],[-11.71822,26.104092],[-12.030759,26.030866],[-12.500963,24.770116],[-13.89111,23.691009],[-14.221168,22.310163],[-14.630833,21.86094],[-14.750955,21.5006],[-17.002962,21.420734],[-17.020428,21.42231],[-16.973248,21.885745],[-16.589137,22.158234],[-16.261922,22.67934],[-16.326414,23.017768],[-15.982611,23.723358],[-15.426004,24.359134],[-15.089332,24.520261],[-14.824645,25.103533],[-14.800926,25.636265],[-14.43994,26.254418],[-13.773805,26.618892],[-13.139942,27.640148],[-13.121613,27.654148],[-12.618837,28.038186],[-11.688919,28.148644],[-10.900957,28.832142],[-10.399592,29.098586],[-9.564811,29.933574],[-9.814718,31.177736],[-9.434793,32.038096],[-9.300693,32.564679],[-8.657476,33.240245],[-7.654178,33.697065],[-6.912544,34.110476],[-6.244342,35.145865],[-5.929994,35.759988],[-5.193863,35.755182],[-4.591006,35.330712],[-3.640057,35.399855],[-2.604306,35.179093],[-2.169914,35.168396]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3474121,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"MD\",\"ISO_A3\":\"MDA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[26.619337,45.488283,30.024659,48.467119],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[26.619337,48.220726],[26.857824,48.368211],[27.522537,48.467119],[28.259547,48.155562],[28.670891,48.118149],[29.122698,47.849095],[29.050868,47.510227],[29.415135,47.346645],[29.559674,46.928583],[29.908852,46.674361],[29.83821,46.525326],[30.024659,46.423937],[29.759972,46.349988],[29.170654,46.379262],[29.072107,46.517678],[28.862972,46.437889],[28.933717,46.25883],[28.659987,45.939987],[28.485269,45.596907],[28.233554,45.488283],[28.054443,45.944586],[28.160018,46.371563],[28.12803,46.810476],[27.551166,47.405117],[27.233873,47.826771],[26.924176,48.123264],[26.619337,48.220726]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":25054161,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"MG\",\"ISO_A3\":\"MDG\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[43.254187,-25.601434,50.476537,-12.040557],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[49.543519,-12.469833],[49.808981,-12.895285],[50.056511,-13.555761],[50.217431,-14.758789],[50.476537,-15.226512],[50.377111,-15.706069],[50.200275,-16.000263],[49.860606,-15.414253],[49.672607,-15.710204],[49.863344,-16.451037],[49.774564,-16.875042],[49.498612,-17.106036],[49.435619,-17.953064],[49.041792,-19.118781],[48.548541,-20.496888],[47.930749,-22.391501],[47.547723,-23.781959],[47.095761,-24.94163],[46.282478,-25.178463],[45.409508,-25.601434],[44.833574,-25.346101],[44.03972,-24.988345],[43.763768,-24.460677],[43.697778,-23.574116],[43.345654,-22.776904],[43.254187,-22.057413],[43.433298,-21.336475],[43.893683,-21.163307],[43.89637,-20.830459],[44.374325,-20.072366],[44.464397,-19.435454],[44.232422,-18.961995],[44.042976,-18.331387],[43.963084,-17.409945],[44.312469,-16.850496],[44.446517,-16.216219],[44.944937,-16.179374],[45.502732,-15.974373],[45.872994,-15.793454],[46.312243,-15.780018],[46.882183,-15.210182],[47.70513,-14.594303],[48.005215,-14.091233],[47.869047,-13.663869],[48.293828,-13.784068],[48.84506,-13.089175],[48.863509,-12.487868],[49.194651,-12.040557],[49.543519,-12.469833]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":124574795,\"ECONOMY\":\"4. Emerging region: MIKT\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"MX\",\"ISO_A3\":\"MEX\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":6.7},\"bbox\":[-117.12776,14.538829,-86.811982,32.72083],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-88.300031,18.499982],[-88.490123,18.486831],[-88.848344,17.883198],[-89.029857,18.001511],[-89.150909,17.955468],[-89.14308,17.808319],[-90.067934,17.819326],[-91.00152,17.817595],[-91.002269,17.254658],[-91.453921,17.252177],[-91.08167,16.918477],[-90.711822,16.687483],[-90.600847,16.470778],[-90.438867,16.41011],[-90.464473,16.069562],[-91.74796,16.066565],[-92.229249,15.251447],[-92.087216,15.064585],[-92.20323,14.830103],[-92.22775,14.538829],[-93.359464,15.61543],[-93.875169,15.940164],[-94.691656,16.200975],[-95.250227,16.128318],[-96.053382,15.752088],[-96.557434,15.653515],[-97.263592,15.917065],[-98.01303,16.107312],[-98.947676,16.566043],[-99.697397,16.706164],[-100.829499,17.171071],[-101.666089,17.649026],[-101.918528,17.91609],[-102.478132,17.975751],[-103.50099,18.292295],[-103.917527,18.748572],[-104.99201,19.316134],[-105.493038,19.946767],[-105.731396,20.434102],[-105.397773,20.531719],[-105.500661,20.816895],[-105.270752,21.076285],[-105.265817,21.422104],[-105.603161,21.871146],[-105.693414,22.26908],[-106.028716,22.773752],[-106.90998,23.767774],[-107.915449,24.548915],[-108.401905,25.172314],[-109.260199,25.580609],[-109.444089,25.824884],[-109.291644,26.442934],[-109.801458,26.676176],[-110.391732,27.162115],[-110.641019,27.859876],[-111.178919,27.941241],[-111.759607,28.467953],[-112.228235,28.954409],[-112.271824,29.266844],[-112.809594,30.021114],[-113.163811,30.786881],[-113.148669,31.170966],[-113.871881,31.567608],[-114.205737,31.524045],[-114.776451,31.799532],[-114.9367,31.393485],[-114.771232,30.913617],[-114.673899,30.162681],[-114.330974,29.750432],[-113.588875,29.061611],[-113.424053,28.826174],[-113.271969,28.754783],[-113.140039,28.411289],[-112.962298,28.42519],[-112.761587,27.780217],[-112.457911,27.525814],[-112.244952,27.171727],[-111.616489,26.662817],[-111.284675,25.73259],[-110.987819,25.294606],[-110.710007,24.826004],[-110.655049,24.298595],[-110.172856,24.265548],[-109.771847,23.811183],[-109.409104,23.364672],[-109.433392,23.185588],[-109.854219,22.818272],[-110.031392,22.823078],[-110.295071,23.430973],[-110.949501,24.000964],[-111.670568,24.484423],[-112.182036,24.738413],[-112.148989,25.470125],[-112.300711,26.012004],[-112.777297,26.32196],[-113.464671,26.768186],[-113.59673,26.63946],[-113.848937,26.900064],[-114.465747,27.14209],[-115.055142,27.722727],[-114.982253,27.7982],[-114.570366,27.741485],[-114.199329,28.115003],[-114.162018,28.566112],[-114.931842,29.279479],[-115.518654,29.556362],[-115.887365,30.180794],[-116.25835,30.836464],[-116.721526,31.635744],[-117.12776,32.53534],[-115.99135,32.61239],[-114.72139,32.72083],[-114.815,32.52528],[-113.30498,32.03914],[-111.02361,31.33472],[-109.035,31.34194],[-108.24194,31.34222],[-108.24,31.754854],[-106.50759,31.75452],[-106.1429,31.39995],[-105.63159,31.08383],[-105.03737,30.64402],[-104.70575,30.12173],[-104.45697,29.57196],[-103.94,29.27],[-103.11,28.97],[-102.48,29.76],[-101.6624,29.7793],[-100.9576,29.38071],[-100.45584,28.69612],[-100.11,28.11],[-99.52,27.54],[-99.3,26.84],[-99.02,26.37],[-98.24,26.06],[-97.53,25.84],[-97.140008,25.869997],[-97.528072,24.992144],[-97.702946,24.272343],[-97.776042,22.93258],[-97.872367,22.444212],[-97.699044,21.898689],[-97.38896,21.411019],[-97.189333,20.635433],[-96.525576,19.890931],[-96.292127,19.320371],[-95.900885,18.828024],[-94.839063,18.562717],[-94.42573,18.144371],[-93.548651,18.423837],[-92.786114,18.524839],[-92.037348,18.704569],[-91.407903,18.876083],[-90.77187,19.28412],[-90.53359,19.867418],[-90.451476,20.707522],[-90.278618,20.999855],[-89.601321,21.261726],[-88.543866,21.493675],[-87.658417,21.458846],[-87.05189,21.543543],[-86.811982,21.331515],[-86.845908,20.849865],[-87.383291,20.255405],[-87.621054,19.646553],[-87.43675,19.472403],[-87.58656,19.04013],[-87.837191,18.259816],[-88.090664,18.516648],[-88.300031,18.499982]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2103721,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"MK\",\"ISO_A3\":\"MKD\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[20.463175,40.842727,22.952377,42.32026],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[21.02004,40.842727],[20.605182,41.086226],[20.463175,41.515089],[20.590247,41.855404],[20.590247,41.855409],[20.71731,41.84711],[20.76216,42.05186],[21.3527,42.2068],[21.576636,42.245224],[21.91708,42.30364],[22.380526,42.32026],[22.881374,41.999297],[22.952377,41.337994],[22.76177,41.3048],[22.597308,41.130487],[22.055378,41.149866],[21.674161,40.931275],[21.02004,40.842727]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":17885245,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"ML\",\"ISO_A3\":\"MLI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[-12.17075,10.096361,4.27021,24.974574],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[0.374892,14.928908],[-0.266257,14.924309],[-0.515854,15.116158],[-1.066363,14.973815],[-2.001035,14.559008],[-2.191825,14.246418],[-2.967694,13.79815],[-3.103707,13.541267],[-3.522803,13.337662],[-4.006391,13.472485],[-4.280405,13.228444],[-4.427166,12.542646],[-5.220942,11.713859],[-5.197843,11.375146],[-5.470565,10.95127],[-5.404342,10.370737],[-5.816926,10.222555],[-6.050452,10.096361],[-6.205223,10.524061],[-6.493965,10.411303],[-6.666461,10.430811],[-6.850507,10.138994],[-7.622759,10.147236],[-7.89959,10.297382],[-8.029944,10.206535],[-8.335377,10.494812],[-8.282357,10.792597],[-8.407311,10.909257],[-8.620321,10.810891],[-8.581305,11.136246],[-8.376305,11.393646],[-8.786099,11.812561],[-8.905265,12.088358],[-9.127474,12.30806],[-9.327616,12.334286],[-9.567912,12.194243],[-9.890993,12.060479],[-10.165214,11.844084],[-10.593224,11.923975],[-10.87083,12.177887],[-11.036556,12.211245],[-11.297574,12.077971],[-11.456169,12.076834],[-11.513943,12.442988],[-11.467899,12.754519],[-11.553398,13.141214],[-11.927716,13.422075],[-12.124887,13.994727],[-12.17075,14.616834],[-11.834208,14.799097],[-11.666078,15.388208],[-11.349095,15.411256],[-10.650791,15.132746],[-10.086846,15.330486],[-9.700255,15.264107],[-9.550238,15.486497],[-5.537744,15.50169],[-5.315277,16.201854],[-5.488523,16.325102],[-5.971129,20.640833],[-6.453787,24.956591],[-4.923337,24.974574],[-1.550055,22.792666],[1.823228,20.610809],[2.060991,20.142233],[2.683588,19.85623],[3.146661,19.693579],[3.158133,19.057364],[4.267419,19.155265],[4.27021,16.852227],[3.723422,16.184284],[3.638259,15.56812],[2.749993,15.409525],[1.385528,15.323561],[1.015783,14.968182],[0.374892,14.928908]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":55123814,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"MM\",\"ISO_A3\":\"MMR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[92.303234,9.93296,101.180005,28.335945],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[92.368554,20.670883],[92.303234,21.475485],[92.652257,21.324048],[92.672721,22.041239],[93.166128,22.27846],[93.060294,22.703111],[93.286327,23.043658],[93.325188,24.078556],[94.106742,23.850741],[94.552658,24.675238],[94.603249,25.162495],[95.155153,26.001307],[95.124768,26.573572],[96.419366,27.264589],[97.133999,27.083774],[97.051989,27.699059],[97.402561,27.882536],[97.327114,28.261583],[97.911988,28.335945],[98.246231,27.747221],[98.68269,27.508812],[98.712094,26.743536],[98.671838,25.918703],[97.724609,25.083637],[97.60472,23.897405],[98.660262,24.063286],[98.898749,23.142722],[99.531992,22.949039],[99.240899,22.118314],[99.983489,21.742937],[100.416538,21.558839],[101.150033,21.849984],[101.180005,21.436573],[100.329101,20.786122],[100.115988,20.41785],[99.543309,20.186598],[98.959676,19.752981],[98.253724,19.708203],[97.797783,18.62708],[97.375896,18.445438],[97.859123,17.567946],[98.493761,16.837836],[98.903348,16.177824],[98.537376,15.308497],[98.192074,15.123703],[98.430819,14.622028],[99.097755,13.827503],[99.212012,13.269294],[99.196354,12.804748],[99.587286,11.892763],[99.038121,10.960546],[98.553551,9.93296],[98.457174,10.675266],[98.764546,11.441292],[98.428339,12.032987],[98.509574,13.122378],[98.103604,13.64046],[97.777732,14.837286],[97.597072,16.100568],[97.16454,16.928734],[96.505769,16.427241],[95.369352,15.71439],[94.808405,15.803454],[94.188804,16.037936],[94.533486,17.27724],[94.324817,18.213514],[93.540988,19.366493],[93.663255,19.726962],[93.078278,19.855145],[92.368554,20.670883]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":642550,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"ME\",\"ISO_A3\":\"MNE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[18.450017,41.877551,20.3398,43.52384],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[20.0707,42.58863],[19.801613,42.500093],[19.738051,42.688247],[19.304486,42.195745],[19.371768,41.877551],[19.16246,41.95502],[18.88214,42.28151],[18.450017,42.479992],[18.56,42.65],[18.70648,43.20011],[19.03165,43.43253],[19.21852,43.52384],[19.48389,43.35229],[19.63,43.21378],[19.95857,43.10604],[20.3398,42.89852],[20.25758,42.81275],[20.0707,42.58863]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3068243,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"MN\",\"ISO_A3\":\"MNG\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[87.751264,41.59741,119.772824,52.047366],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[116.678801,49.888531],[116.191802,49.134598],[115.485282,48.135383],[115.742837,47.726545],[116.308953,47.85341],[117.295507,47.697709],[118.064143,48.06673],[118.866574,47.74706],[119.772824,47.048059],[119.66327,46.69268],[118.874326,46.805412],[117.421701,46.672733],[116.717868,46.388202],[115.985096,45.727235],[114.460332,45.339817],[113.463907,44.808893],[112.436062,45.011646],[111.873306,45.102079],[111.348377,44.457442],[111.667737,44.073176],[111.829588,43.743118],[111.129682,43.406834],[110.412103,42.871234],[109.243596,42.519446],[107.744773,42.481516],[106.129316,42.134328],[104.964994,41.59741],[104.522282,41.908347],[103.312278,41.907468],[101.83304,42.514873],[100.845866,42.663804],[99.515817,42.524691],[97.451757,42.74889],[96.349396,42.725635],[95.762455,43.319449],[95.306875,44.241331],[94.688929,44.352332],[93.480734,44.975472],[92.133891,45.115076],[90.94554,45.286073],[90.585768,45.719716],[90.970809,46.888146],[90.280826,47.693549],[88.854298,48.069082],[88.013832,48.599463],[87.751264,49.297198],[88.805567,49.470521],[90.713667,50.331812],[92.234712,50.802171],[93.10421,50.49529],[94.147566,50.480537],[94.815949,50.013433],[95.81402,49.97746],[97.25976,49.72605],[98.231762,50.422401],[97.82574,51.010995],[98.861491,52.047366],[99.981732,51.634006],[100.88948,51.516856],[102.06521,51.25991],[102.25589,50.51056],[103.676545,50.089966],[104.62158,50.27532],[105.886591,50.406019],[106.888804,50.274296],[107.868176,49.793705],[108.475167,49.282548],[109.402449,49.292961],[110.662011,49.130128],[111.581231,49.377968],[112.89774,49.543565],[114.362456,50.248303],[114.96211,50.140247],[115.485695,49.805177],[116.678801,49.888531]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":26573706,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"MZ\",\"ISO_A3\":\"MOZ\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[30.179481,-26.742192,40.775475,-10.317096],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[34.559989,-11.52002],[35.312398,-11.439146],[36.514082,-11.720938],[36.775151,-11.594537],[37.47129,-11.56876],[37.82764,-11.26879],[38.427557,-11.285202],[39.521,-10.89688],[40.31659,-10.3171],[40.316586,-10.317098],[40.316589,-10.317096],[40.478387,-10.765441],[40.437253,-11.761711],[40.560811,-12.639177],[40.59962,-14.201975],[40.775475,-14.691764],[40.477251,-15.406294],[40.089264,-16.100774],[39.452559,-16.720891],[38.538351,-17.101023],[37.411133,-17.586368],[36.281279,-18.659688],[35.896497,-18.84226],[35.1984,-19.552811],[34.786383,-19.784012],[34.701893,-20.497043],[35.176127,-21.254361],[35.373428,-21.840837],[35.385848,-22.14],[35.562546,-22.09],[35.533935,-23.070788],[35.371774,-23.535359],[35.60747,-23.706563],[35.458746,-24.12261],[35.040735,-24.478351],[34.215824,-24.816314],[33.01321,-25.357573],[32.574632,-25.727318],[32.660363,-26.148584],[32.915955,-26.215867],[32.83012,-26.742192],[32.071665,-26.73382],[31.985779,-26.29178],[31.837778,-25.843332],[31.752408,-25.484284],[31.930589,-24.369417],[31.670398,-23.658969],[31.191409,-22.25151],[32.244988,-21.116489],[32.508693,-20.395292],[32.659743,-20.30429],[32.772708,-19.715592],[32.611994,-19.419383],[32.654886,-18.67209],[32.849861,-17.979057],[32.847639,-16.713398],[32.328239,-16.392074],[31.852041,-16.319417],[31.636498,-16.07199],[31.173064,-15.860944],[30.338955,-15.880839],[30.274256,-15.507787],[30.179481,-14.796099],[33.214025,-13.97186],[33.7897,-14.451831],[34.064825,-14.35995],[34.459633,-14.61301],[34.517666,-15.013709],[34.307291,-15.478641],[34.381292,-16.18356],[35.03381,-16.8013],[35.339063,-16.10744],[35.771905,-15.896859],[35.686845,-14.611046],[35.267956,-13.887834],[34.907151,-13.565425],[34.559989,-13.579998],[34.280006,-12.280025],[34.559989,-11.52002]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3758571,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"MR\",\"ISO_A3\":\"MRT\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-17.063423,14.616834,-4.923337,27.395744],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-8.6844,27.395744],[-4.923337,24.974574],[-6.453787,24.956591],[-5.971129,20.640833],[-5.488523,16.325102],[-5.315277,16.201854],[-5.537744,15.50169],[-9.550238,15.486497],[-9.700255,15.264107],[-10.086846,15.330486],[-10.650791,15.132746],[-11.349095,15.411256],[-11.666078,15.388208],[-11.834208,14.799097],[-12.17075,14.616834],[-12.830658,15.303692],[-13.435738,16.039383],[-14.099521,16.304302],[-14.577348,16.598264],[-15.135737,16.587282],[-15.623666,16.369337],[-16.12069,16.455663],[-16.463098,16.135036],[-16.549708,16.673892],[-16.270552,17.166963],[-16.146347,18.108482],[-16.256883,19.096716],[-16.377651,19.593817],[-16.277838,20.092521],[-16.536324,20.567866],[-17.063423,20.999752],[-16.845194,21.333323],[-12.929102,21.327071],[-13.118754,22.77122],[-12.874222,23.284832],[-11.937224,23.374594],[-11.969419,25.933353],[-8.687294,25.881056],[-8.6844,27.395744]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":19196246,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"MW\",\"ISO_A3\":\"MWI\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[32.688165,-16.8013,35.771905,-9.230599],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[34.559989,-11.52002],[34.280006,-12.280025],[34.559989,-13.579998],[34.907151,-13.565425],[35.267956,-13.887834],[35.686845,-14.611046],[35.771905,-15.896859],[35.339063,-16.10744],[35.03381,-16.8013],[34.381292,-16.18356],[34.307291,-15.478641],[34.517666,-15.013709],[34.459633,-14.61301],[34.064825,-14.35995],[33.7897,-14.451831],[33.214025,-13.97186],[32.688165,-13.712858],[32.991764,-12.783871],[33.306422,-12.435778],[33.114289,-11.607198],[33.31531,-10.79655],[33.485688,-10.525559],[33.231388,-9.676722],[32.759375,-9.230599],[33.73972,-9.41715],[33.940838,-9.693674],[34.28,-10.16],[34.559989,-11.52002]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":31381992,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"MY\",\"ISO_A3\":\"MYS\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[100.085757,0.773131,119.181904,6.928053],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[114.204017,4.525874],[114.659596,4.007637],[114.869557,4.348314],[115.347461,4.316636],[115.4057,4.955228],[115.45071,5.44773],[116.220741,6.143191],[116.725103,6.924771],[117.129626,6.928053],[117.643393,6.422166],[117.689075,5.98749],[118.347691,5.708696],[119.181904,5.407836],[119.110694,5.016128],[118.439727,4.966519],[118.618321,4.478202],[117.882035,4.137551],[117.015214,4.306094],[115.865517,4.306559],[115.519078,3.169238],[115.134037,2.821482],[114.621355,1.430688],[113.80585,1.217549],[112.859809,1.49779],[112.380252,1.410121],[111.797548,0.904441],[111.159138,0.976478],[110.514061,0.773131],[109.830227,1.338136],[109.66326,2.006467],[110.396135,1.663775],[111.168853,1.850637],[111.370081,2.697303],[111.796928,2.885897],[112.995615,3.102395],[113.712935,3.893509],[114.204017,4.525874]]],[[[102.141187,6.221636],[102.371147,6.128205],[102.961705,5.524495],[103.381215,4.855001],[103.438575,4.181606],[103.332122,3.726698],[103.429429,3.382869],[103.502448,2.791019],[103.854674,2.515454],[104.247932,1.631141],[104.228811,1.293048],[103.519707,1.226334],[102.573615,1.967115],[101.390638,2.760814],[101.27354,3.270292],[100.695435,3.93914],[100.557408,4.76728],[100.196706,5.312493],[100.30626,6.040562],[100.085757,6.464489],[100.259596,6.642825],[101.075516,6.204867],[101.154219,5.691384],[101.814282,5.810808],[102.141187,6.221636]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2484780,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"NA\",\"ISO_A3\":\"NAM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7.5},\"bbox\":[11.734199,-29.045462,25.084443,-16.941343],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[11.734199,-17.301889],[12.215461,-17.111668],[12.814081,-16.941343],[13.462362,-16.971212],[14.058501,-17.423381],[14.209707,-17.353101],[18.263309,-17.309951],[18.956187,-17.789095],[21.377176,-17.930636],[23.215048,-17.523116],[24.033862,-17.295843],[24.682349,-17.353411],[25.07695,-17.578823],[25.084443,-17.661816],[24.520705,-17.887125],[24.217365,-17.889347],[23.579006,-18.281261],[23.196858,-17.869038],[21.65504,-18.219146],[20.910641,-18.252219],[20.881134,-21.814327],[19.895458,-21.849157],[19.895768,-24.76779],[19.894734,-28.461105],[19.002127,-28.972443],[18.464899,-29.045462],[17.836152,-28.856378],[17.387497,-28.783514],[17.218929,-28.355943],[16.824017,-28.082162],[16.344977,-28.576705],[15.601818,-27.821247],[15.210472,-27.090956],[14.989711,-26.117372],[14.743214,-25.39292],[14.408144,-23.853014],[14.385717,-22.656653],[14.257714,-22.111208],[13.868642,-21.699037],[13.352498,-20.872834],[12.826845,-19.673166],[12.608564,-19.045349],[11.794919,-18.069129],[11.734199,-17.301889]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":279070,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"NC\",\"ISO_A3\":\"NCL\",\"TINY\":-99,\"HOMEPART\":-99,\"MIN_ZOOM\":0,\"MIN_LABEL\":4.6,\"MAX_LABEL\":8},\"bbox\":[164.029606,-22.399976,167.120011,-20.105646],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[165.77999,-21.080005],[166.599991,-21.700019],[167.120011,-22.159991],[166.740035,-22.399976],[166.189732,-22.129708],[165.474375,-21.679607],[164.829815,-21.14982],[164.167995,-20.444747],[164.029606,-20.105646],[164.459967,-20.120012],[165.020036,-20.459991],[165.460009,-20.800022],[165.77999,-21.080005]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":19245344,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"NE\",\"ISO_A3\":\"NER\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[0.295646,11.660167,15.903247,23.471668],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[3.61118,11.660167],[2.848643,12.235636],[2.490164,12.233052],[2.154474,11.94015],[2.177108,12.625018],[1.024103,12.851826],[0.993046,13.33575],[0.429928,13.988733],[0.295646,14.444235],[0.374892,14.928908],[1.015783,14.968182],[1.385528,15.323561],[2.749993,15.409525],[3.638259,15.56812],[3.723422,16.184284],[4.27021,16.852227],[4.267419,19.155265],[5.677566,19.601207],[8.572893,21.565661],[11.999506,23.471668],[13.581425,23.040506],[14.143871,22.491289],[14.8513,22.86295],[15.096888,21.308519],[15.47106,21.04845],[15.487148,20.730415],[15.903247,20.387619],[15.685741,19.95718],[15.300441,17.92795],[15.247731,16.627306],[13.97217,15.68437],[13.540394,14.367134],[13.956699,13.996691],[13.954477,13.353449],[14.595781,13.330427],[14.495787,12.859396],[14.213531,12.802035],[14.181336,12.483657],[13.995353,12.461565],[13.318702,13.556356],[13.083987,13.596147],[12.302071,13.037189],[11.527803,13.32898],[10.989593,13.387323],[10.701032,13.246918],[10.114814,13.277252],[9.524928,12.851102],[9.014933,12.826659],[7.804671,13.343527],[7.330747,13.098038],[6.820442,13.115091],[6.445426,13.492768],[5.443058,13.865924],[4.368344,13.747482],[4.107946,13.531216],[3.967283,12.956109],[3.680634,12.552903],[3.61118,11.660167]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":190632261,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"NG\",\"ISO_A3\":\"NGA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[2.691702,4.240594,14.577178,13.865924],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[2.691702,6.258817],[2.749063,7.870734],[2.723793,8.506845],[2.912308,9.137608],[3.220352,9.444153],[3.705438,10.06321],[3.60007,10.332186],[3.797112,10.734746],[3.572216,11.327939],[3.61118,11.660167],[3.680634,12.552903],[3.967283,12.956109],[4.107946,13.531216],[4.368344,13.747482],[5.443058,13.865924],[6.445426,13.492768],[6.820442,13.115091],[7.330747,13.098038],[7.804671,13.343527],[9.014933,12.826659],[9.524928,12.851102],[10.114814,13.277252],[10.701032,13.246918],[10.989593,13.387323],[11.527803,13.32898],[12.302071,13.037189],[13.083987,13.596147],[13.318702,13.556356],[13.995353,12.461565],[14.181336,12.483657],[14.577178,12.085361],[14.468192,11.904752],[14.415379,11.572369],[13.57295,10.798566],[13.308676,10.160362],[13.1676,9.640626],[12.955468,9.417772],[12.753672,8.717763],[12.218872,8.305824],[12.063946,7.799808],[11.839309,7.397042],[11.745774,6.981383],[11.058788,6.644427],[10.497375,7.055358],[10.118277,7.03877],[9.522706,6.453482],[9.233163,6.444491],[8.757533,5.479666],[8.500288,4.771983],[7.462108,4.412108],[7.082596,4.464689],[6.698072,4.240594],[5.898173,4.262453],[5.362805,4.887971],[5.033574,5.611802],[4.325607,6.270651],[3.57418,6.2583],[2.691702,6.258817]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6025951,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"NI\",\"ISO_A3\":\"NIC\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-87.668493,10.726839,-83.147219,15.016267],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-83.655612,10.938764],[-83.895054,10.726839],[-84.190179,10.79345],[-84.355931,10.999226],[-84.673069,11.082657],[-84.903003,10.952303],[-85.561852,11.217119],[-85.71254,11.088445],[-86.058488,11.403439],[-86.52585,11.806877],[-86.745992,12.143962],[-87.167516,12.458258],[-87.668493,12.90991],[-87.557467,13.064552],[-87.392386,12.914018],[-87.316654,12.984686],[-87.005769,13.025794],[-86.880557,13.254204],[-86.733822,13.263093],[-86.755087,13.754845],[-86.520708,13.778487],[-86.312142,13.771356],[-86.096264,14.038187],[-85.801295,13.836055],[-85.698665,13.960078],[-85.514413,14.079012],[-85.165365,14.35437],[-85.148751,14.560197],[-85.052787,14.551541],[-84.924501,14.790493],[-84.820037,14.819587],[-84.649582,14.666805],[-84.449336,14.621614],[-84.228342,14.748764],[-83.975721,14.749436],[-83.628585,14.880074],[-83.489989,15.016267],[-83.147219,14.995829],[-83.233234,14.899866],[-83.284162,14.676624],[-83.182126,14.310703],[-83.4125,13.970078],[-83.519832,13.567699],[-83.552207,13.127054],[-83.498515,12.869292],[-83.473323,12.419087],[-83.626104,12.32085],[-83.719613,11.893124],[-83.650858,11.629032],[-83.85547,11.373311],[-83.808936,11.103044],[-83.655612,10.938764]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":17084719,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"NL\",\"ISO_A3\":\"NLD\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[3.314971,50.803721,7.092053,53.510403],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[6.156658,50.803721],[5.606976,51.037298],[4.973991,51.475024],[4.047071,51.267259],[3.314971,51.345755],[3.315011,51.345777],[3.830289,51.620545],[4.705997,53.091798],[6.074183,53.510403],[6.90514,53.482162],[7.092053,53.144043],[6.84287,52.22844],[6.589397,51.852029],[5.988658,51.851616],[6.156658,50.803721]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5320045,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"NO\",\"ISO_A3\":\"NOR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[4.992078,58.078884,31.293418,80.657144],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[28.59193,69.064777],[29.015573,69.766491],[27.732292,70.164193],[26.179622,69.825299],[25.689213,69.092114],[24.735679,68.649557],[23.66205,68.891247],[22.356238,68.841741],[21.244936,69.370443],[20.645593,69.106247],[20.025269,69.065139],[19.87856,68.407194],[17.993868,68.567391],[17.729182,68.010552],[16.768879,68.013937],[16.108712,67.302456],[15.108411,66.193867],[13.55569,64.787028],[13.919905,64.445421],[13.571916,64.049114],[12.579935,64.066219],[11.930569,63.128318],[11.992064,61.800362],[12.631147,61.293572],[12.300366,60.117933],[11.468272,59.432393],[11.027369,58.856149],[10.356557,59.469807],[8.382,58.313288],[7.048748,58.078884],[5.665835,58.588155],[5.308234,59.663232],[4.992078,61.970998],[5.9129,62.614473],[8.553411,63.454008],[10.527709,64.486038],[12.358347,65.879726],[14.761146,67.810642],[16.435927,68.563205],[19.184028,69.817444],[21.378416,70.255169],[23.023742,70.202072],[24.546543,71.030497],[26.37005,70.986262],[28.165547,71.185474],[31.293418,70.453788],[30.005435,70.186259],[31.101042,69.558101],[29.39955,69.15692],[28.59193,69.064777]]],[[[24.72412,77.85385],[22.49032,77.44493],[20.72601,77.67704],[21.41611,77.93504],[20.8119,78.25463],[22.88426,78.45494],[23.28134,78.07954],[24.72412,77.85385]]],[[[18.25183,79.70175],[21.54383,78.95611],[19.02737,78.5626],[18.47172,77.82669],[17.59441,77.63796],[17.1182,76.80941],[15.91315,76.77045],[13.76259,77.38035],[14.66956,77.73565],[13.1706,78.02493],[11.22231,78.8693],[10.44453,79.65239],[13.17077,80.01046],[13.71852,79.66039],[15.14282,79.67431],[15.52255,80.01608],[16.99085,80.05086],[18.25183,79.70175]]],[[[25.447625,80.40734],[27.407506,80.056406],[25.924651,79.517834],[23.024466,79.400012],[20.075188,79.566823],[19.897266,79.842362],[18.462264,79.85988],[17.368015,80.318896],[20.455992,80.598156],[21.907945,80.357679],[22.919253,80.657144],[25.447625,80.40734]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":29384297,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"NP\",\"ISO_A3\":\"NPL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[80.088425,26.397898,88.174804,30.422717],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[81.111256,30.183481],[81.525804,30.422717],[82.327513,30.115268],[83.337115,29.463732],[83.898993,29.320226],[84.23458,28.839894],[85.011638,28.642774],[85.82332,28.203576],[86.954517,27.974262],[88.120441,27.876542],[88.043133,27.445819],[88.174804,26.810405],[88.060238,26.414615],[87.227472,26.397898],[86.024393,26.630985],[85.251779,26.726198],[84.675018,27.234901],[83.304249,27.364506],[81.999987,27.925479],[81.057203,28.416095],[80.088425,28.79447],[80.476721,29.729865],[81.111256,30.183481]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4510327,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"NZ\",\"ISO_A3\":\"NZL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":6.7},\"bbox\":[166.509144,-46.641235,178.517094,-34.450662],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[173.020375,-40.919052],[173.247234,-41.331999],[173.958405,-40.926701],[174.247587,-41.349155],[174.248517,-41.770008],[173.876447,-42.233184],[173.22274,-42.970038],[172.711246,-43.372288],[173.080113,-43.853344],[172.308584,-43.865694],[171.452925,-44.242519],[171.185138,-44.897104],[170.616697,-45.908929],[169.831422,-46.355775],[169.332331,-46.641235],[168.411354,-46.619945],[167.763745,-46.290197],[166.676886,-46.219917],[166.509144,-45.852705],[167.046424,-45.110941],[168.303763,-44.123973],[168.949409,-43.935819],[169.667815,-43.555326],[170.52492,-43.031688],[171.12509,-42.512754],[171.569714,-41.767424],[171.948709,-41.514417],[172.097227,-40.956104],[172.79858,-40.493962],[173.020375,-40.919052]]],[[[174.612009,-36.156397],[175.336616,-37.209098],[175.357596,-36.526194],[175.808887,-36.798942],[175.95849,-37.555382],[176.763195,-37.881253],[177.438813,-37.961248],[178.010354,-37.579825],[178.517094,-37.695373],[178.274731,-38.582813],[177.97046,-39.166343],[177.206993,-39.145776],[176.939981,-39.449736],[177.032946,-39.879943],[176.885824,-40.065978],[176.508017,-40.604808],[176.01244,-41.289624],[175.239567,-41.688308],[175.067898,-41.425895],[174.650973,-41.281821],[175.22763,-40.459236],[174.900157,-39.908933],[173.824047,-39.508854],[173.852262,-39.146602],[174.574802,-38.797683],[174.743474,-38.027808],[174.697017,-37.381129],[174.292028,-36.711092],[174.319004,-36.534824],[173.840997,-36.121981],[173.054171,-35.237125],[172.636005,-34.529107],[173.007042,-34.450662],[173.551298,-35.006183],[174.32939,-35.265496],[174.612009,-36.156397]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3424386,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"OM\",\"ISO_A3\":\"OMN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[52.00001,16.651051,59.80806,26.395934],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[56.261042,25.714606],[56.070821,26.055464],[56.362017,26.395934],[56.485679,26.309118],[56.391421,25.895991],[56.261042,25.714606]]],[[[55.208341,22.70833],[55.234489,23.110993],[55.525841,23.524869],[55.528632,23.933604],[55.981214,24.130543],[55.804119,24.269604],[55.886233,24.920831],[56.396847,24.924732],[56.84514,24.241673],[57.403453,23.878594],[58.136948,23.747931],[58.729211,23.565668],[59.180502,22.992395],[59.450098,22.660271],[59.80806,22.533612],[59.806148,22.310525],[59.442191,21.714541],[59.282408,21.433886],[58.861141,21.114035],[58.487986,20.428986],[58.034318,20.481437],[57.826373,20.243002],[57.665762,19.736005],[57.7887,19.06757],[57.694391,18.94471],[57.234264,18.947991],[56.609651,18.574267],[56.512189,18.087113],[56.283521,17.876067],[55.661492,17.884128],[55.269939,17.632309],[55.2749,17.228354],[54.791002,16.950697],[54.239253,17.044981],[53.570508,16.707663],[53.108573,16.651051],[52.782184,17.349742],[52.00001,19.000003],[54.999982,19.999994],[55.666659,22.000001],[55.208341,22.70833]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":204924861,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"PK\",\"ISO_A3\":\"PAK\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[60.874248,23.691965,77.837451,37.133031],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[60.874248,29.829239],[62.549857,29.318572],[63.550261,29.468331],[64.148002,29.340819],[64.350419,29.560031],[65.046862,29.472181],[66.346473,29.887943],[66.381458,30.738899],[66.938891,31.304911],[67.683394,31.303154],[67.792689,31.58293],[68.556932,31.71331],[68.926677,31.620189],[69.317764,31.901412],[69.262522,32.501944],[69.687147,33.105499],[70.323594,33.358533],[69.930543,34.02012],[70.881803,33.988856],[71.156773,34.348911],[71.115019,34.733126],[71.613076,35.153203],[71.498768,35.650563],[71.262348,36.074388],[71.846292,36.509942],[72.920025,36.720007],[74.067552,36.836176],[74.575893,37.020841],[75.158028,37.133031],[75.896897,36.666806],[76.192848,35.898403],[77.837451,35.49401],[76.871722,34.653544],[75.757061,34.504923],[74.240203,34.748887],[73.749948,34.317699],[74.104294,33.441473],[74.451559,32.7649],[75.258642,32.271105],[74.405929,31.692639],[74.42138,30.979815],[73.450638,29.976413],[72.823752,28.961592],[71.777666,27.91318],[70.616496,27.989196],[69.514393,26.940966],[70.168927,26.491872],[70.282873,25.722229],[70.844699,25.215102],[71.04324,24.356524],[68.842599,24.359134],[68.176645,23.691965],[67.443667,23.944844],[67.145442,24.663611],[66.372828,25.425141],[64.530408,25.237039],[62.905701,25.218409],[61.497363,25.078237],[61.874187,26.239975],[63.316632,26.756532],[63.233898,27.217047],[62.755426,27.378923],[62.72783,28.259645],[61.771868,28.699334],[61.369309,29.303276],[60.874248,29.829239]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3753142,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"PA\",\"ISO_A3\":\"PAN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-82.965783,7.220541,-77.242566,9.61161],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-77.353361,8.670505],[-77.474723,8.524286],[-77.242566,7.935278],[-77.431108,7.638061],[-77.753414,7.70984],[-77.881571,7.223771],[-78.214936,7.512255],[-78.429161,8.052041],[-78.182096,8.319182],[-78.435465,8.387705],[-78.622121,8.718124],[-79.120307,8.996092],[-79.557877,8.932375],[-79.760578,8.584515],[-80.164481,8.333316],[-80.382659,8.298409],[-80.480689,8.090308],[-80.00369,7.547524],[-80.276671,7.419754],[-80.421158,7.271572],[-80.886401,7.220541],[-81.059543,7.817921],[-81.189716,7.647906],[-81.519515,7.70661],[-81.721311,8.108963],[-82.131441,8.175393],[-82.390934,8.292362],[-82.820081,8.290864],[-82.850958,8.073823],[-82.965783,8.225028],[-82.913176,8.423517],[-82.829771,8.626295],[-82.868657,8.807266],[-82.719183,8.925709],[-82.927155,9.07433],[-82.932891,9.476812],[-82.546196,9.566135],[-82.187123,9.207449],[-82.207586,8.995575],[-81.808567,8.950617],[-81.714154,9.031955],[-81.439287,8.786234],[-80.947302,8.858504],[-80.521901,9.111072],[-79.9146,9.312765],[-79.573303,9.61161],[-79.021192,9.552931],[-79.05845,9.454565],[-78.500888,9.420459],[-78.055928,9.24773],[-77.729514,8.946844],[-77.353361,8.670505]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":31036656,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"PE\",\"ISO_A3\":\"PER\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[-81.410943,-18.347975,-68.66508,-0.057205],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-69.529678,-10.951734],[-68.66508,-12.5613],[-68.88008,-12.899729],[-68.929224,-13.602684],[-68.948887,-14.453639],[-69.339535,-14.953195],[-69.160347,-15.323974],[-69.389764,-15.660129],[-68.959635,-16.500698],[-69.590424,-17.580012],[-69.858444,-18.092694],[-70.372572,-18.347975],[-71.37525,-17.773799],[-71.462041,-17.363488],[-73.44453,-16.359363],[-75.237883,-15.265683],[-76.009205,-14.649286],[-76.423469,-13.823187],[-76.259242,-13.535039],[-77.106192,-12.222716],[-78.092153,-10.377712],[-79.036953,-8.386568],[-79.44592,-7.930833],[-79.760578,-7.194341],[-80.537482,-6.541668],[-81.249996,-6.136834],[-80.926347,-5.690557],[-81.410943,-4.736765],[-81.09967,-4.036394],[-80.302561,-3.404856],[-80.184015,-3.821162],[-80.469295,-4.059287],[-80.442242,-4.425724],[-80.028908,-4.346091],[-79.624979,-4.454198],[-79.205289,-4.959129],[-78.639897,-4.547784],[-78.450684,-3.873097],[-77.837905,-3.003021],[-76.635394,-2.608678],[-75.544996,-1.56161],[-75.233723,-0.911417],[-75.373223,-0.152032],[-75.106625,-0.057205],[-74.441601,-0.53082],[-74.122395,-1.002833],[-73.659504,-1.260491],[-73.070392,-2.308954],[-72.325787,-2.434218],[-71.774761,-2.16979],[-71.413646,-2.342802],[-70.813476,-2.256865],[-70.047709,-2.725156],[-70.692682,-3.742872],[-70.394044,-3.766591],[-69.893635,-4.298187],[-70.794769,-4.251265],[-70.928843,-4.401591],[-71.748406,-4.593983],[-72.891928,-5.274561],[-72.964507,-5.741251],[-73.219711,-6.089189],[-73.120027,-6.629931],[-73.724487,-6.918595],[-73.723401,-7.340999],[-73.987235,-7.52383],[-73.571059,-8.424447],[-73.015383,-9.032833],[-73.226713,-9.462213],[-72.563033,-9.520194],[-72.184891,-10.053598],[-71.302412,-10.079436],[-70.481894,-9.490118],[-70.548686,-11.009147],[-70.093752,-11.123972],[-69.529678,-10.951734]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":104256076,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"PH\",\"ISO_A3\":\"PHL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[117.174275,5.581003,126.537424,18.505227],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[126.376814,8.414706],[126.478513,7.750354],[126.537424,7.189381],[126.196773,6.274294],[125.831421,7.293715],[125.363852,6.786485],[125.683161,6.049657],[125.396512,5.581003],[124.219788,6.161355],[123.93872,6.885136],[124.243662,7.36061],[123.610212,7.833527],[123.296071,7.418876],[122.825506,7.457375],[122.085499,6.899424],[121.919928,7.192119],[122.312359,8.034962],[122.942398,8.316237],[123.487688,8.69301],[123.841154,8.240324],[124.60147,8.514158],[124.764612,8.960409],[125.471391,8.986997],[125.412118,9.760335],[126.222714,9.286074],[126.306637,8.782487],[126.376814,8.414706]]],[[[123.982438,10.278779],[123.623183,9.950091],[123.309921,9.318269],[122.995883,9.022189],[122.380055,9.713361],[122.586089,9.981045],[122.837081,10.261157],[122.947411,10.881868],[123.49885,10.940624],[123.337774,10.267384],[124.077936,11.232726],[123.982438,10.278779]]],[[[118.504581,9.316383],[117.174275,8.3675],[117.664477,9.066889],[118.386914,9.6845],[118.987342,10.376292],[119.511496,11.369668],[119.689677,10.554291],[119.029458,10.003653],[118.504581,9.316383]]],[[[121.883548,11.891755],[122.483821,11.582187],[123.120217,11.58366],[123.100838,11.165934],[122.637714,10.741308],[122.00261,10.441017],[121.967367,10.905691],[122.03837,11.415841],[121.883548,11.891755]]],[[[125.502552,12.162695],[125.783465,11.046122],[125.011884,11.311455],[125.032761,10.975816],[125.277449,10.358722],[124.801819,10.134679],[124.760168,10.837995],[124.459101,10.88993],[124.302522,11.495371],[124.891013,11.415583],[124.87799,11.79419],[124.266762,12.557761],[125.227116,12.535721],[125.502552,12.162695]]],[[[121.527394,13.06959],[121.26219,12.20556],[120.833896,12.704496],[120.323436,13.466413],[121.180128,13.429697],[121.527394,13.06959]]],[[[121.321308,18.504065],[121.937601,18.218552],[122.246006,18.47895],[122.336957,18.224883],[122.174279,17.810283],[122.515654,17.093505],[122.252311,16.262444],[121.662786,15.931018],[121.50507,15.124814],[121.728829,14.328376],[122.258925,14.218202],[122.701276,14.336541],[123.950295,13.782131],[123.855107,13.237771],[124.181289,12.997527],[124.077419,12.536677],[123.298035,13.027526],[122.928652,13.55292],[122.671355,13.185836],[122.03465,13.784482],[121.126385,13.636687],[120.628637,13.857656],[120.679384,14.271016],[120.991819,14.525393],[120.693336,14.756671],[120.564145,14.396279],[120.070429,14.970869],[119.920929,15.406347],[119.883773,16.363704],[120.286488,16.034629],[120.390047,17.599081],[120.715867,18.505227],[121.321308,18.504065]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6909701,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"PG\",\"ISO_A3\":\"PNG\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2.5,\"MAX_LABEL\":7.5},\"bbox\":[141.00021,-10.652476,156.019965,-2.500002],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[141.033852,-9.117893],[141.017057,-5.859022],[141.00021,-2.600151],[142.735247,-3.289153],[144.583971,-3.861418],[145.27318,-4.373738],[145.829786,-4.876498],[145.981922,-5.465609],[147.648073,-6.083659],[147.891108,-6.614015],[146.970905,-6.721657],[147.191874,-7.388024],[148.084636,-8.044108],[148.734105,-9.104664],[149.306835,-9.071436],[149.266631,-9.514406],[150.038728,-9.684318],[149.738798,-9.872937],[150.801628,-10.293687],[150.690575,-10.582713],[150.028393,-10.652476],[149.78231,-10.393267],[148.923138,-10.280923],[147.913018,-10.130441],[147.135443,-9.492444],[146.567881,-8.942555],[146.048481,-8.067414],[144.744168,-7.630128],[143.897088,-7.91533],[143.286376,-8.245491],[143.413913,-8.983069],[142.628431,-9.326821],[142.068259,-9.159596],[141.033852,-9.117893]]],[[[155.880026,-6.819997],[155.599991,-6.919991],[155.166994,-6.535931],[154.729192,-5.900828],[154.514114,-5.139118],[154.652504,-5.042431],[154.759991,-5.339984],[155.062918,-5.566792],[155.547746,-6.200655],[156.019965,-6.540014],[155.880026,-6.819997]]],[[[151.982796,-5.478063],[151.459107,-5.56028],[151.30139,-5.840728],[150.754447,-6.083763],[150.241197,-6.317754],[149.709963,-6.316513],[148.890065,-6.02604],[148.318937,-5.747142],[148.401826,-5.437756],[149.298412,-5.583742],[149.845562,-5.505503],[149.99625,-5.026101],[150.139756,-5.001348],[150.236908,-5.53222],[150.807467,-5.455842],[151.089672,-5.113693],[151.647881,-4.757074],[151.537862,-4.167807],[152.136792,-4.14879],[152.338743,-4.312966],[152.318693,-4.867661],[151.982796,-5.478063]]],[[[153.140038,-4.499983],[152.827292,-4.766427],[152.638673,-4.176127],[152.406026,-3.789743],[151.953237,-3.462062],[151.384279,-3.035422],[150.66205,-2.741486],[150.939965,-2.500002],[151.479984,-2.779985],[151.820015,-2.999972],[152.239989,-3.240009],[152.640017,-3.659983],[153.019994,-3.980015],[153.140038,-4.499983]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":38476269,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"PL\",\"ISO_A3\":\"POL\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[14.074521,49.027395,24.029986,54.851536],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[23.484128,53.912498],[23.527536,53.470122],[23.804935,53.089731],[23.799199,52.691099],[23.199494,52.486977],[23.508002,52.023647],[23.527071,51.578454],[24.029986,50.705407],[23.922757,50.424881],[23.426508,50.308506],[22.51845,49.476774],[22.776419,49.027395],[22.558138,49.085738],[21.607808,49.470107],[20.887955,49.328772],[20.415839,49.431453],[19.825023,49.217125],[19.320713,49.571574],[18.909575,49.435846],[18.853144,49.49623],[18.392914,49.988629],[17.649445,50.049038],[17.554567,50.362146],[16.868769,50.473974],[16.719476,50.215747],[16.176253,50.422607],[16.238627,50.697733],[15.490972,50.78473],[15.016996,51.106674],[14.607098,51.745188],[14.685026,52.089947],[14.4376,52.62485],[14.074521,52.981263],[14.353315,53.248171],[14.119686,53.757029],[14.8029,54.050706],[16.363477,54.513159],[17.622832,54.851536],[18.620859,54.682606],[18.696255,54.438719],[19.66064,54.426084],[20.892245,54.312525],[22.731099,54.327537],[23.243987,54.220567],[23.484128,53.912498]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3351827,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"PR\",\"ISO_A3\":\"PRI\",\"TINY\":-99,\"HOMEPART\":-99,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-67.242428,17.946553,-65.591004,18.520601],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-66.282434,18.514762],[-65.771303,18.426679],[-65.591004,18.228035],[-65.847164,17.975906],[-66.599934,17.981823],[-67.184162,17.946553],[-67.242428,18.37446],[-67.100679,18.520601],[-66.282434,18.514762]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":25248140,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"KP\",\"ISO_A3\":\"PRK\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[124.265625,37.669071,130.780007,42.985387],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[124.265625,39.928493],[125.079942,40.569824],[126.182045,41.107336],[126.869083,41.816569],[127.343783,41.503152],[128.208433,41.466772],[128.052215,41.994285],[129.596669,42.424982],[129.994267,42.985387],[130.64,42.395024],[130.64,42.395],[130.779992,42.22001],[130.400031,42.280004],[129.965949,41.941368],[129.667362,41.601104],[129.705189,40.882828],[129.188115,40.661808],[129.0104,40.485436],[128.633368,40.189847],[127.967414,40.025413],[127.533436,39.75685],[127.50212,39.323931],[127.385434,39.213472],[127.783343,39.050898],[128.349716,38.612243],[128.205746,38.370397],[127.780035,38.304536],[127.073309,38.256115],[126.68372,37.804773],[126.237339,37.840378],[126.174759,37.749686],[125.689104,37.94001],[125.568439,37.752089],[125.27533,37.669071],[125.240087,37.857224],[124.981033,37.948821],[124.712161,38.108346],[124.985994,38.548474],[125.221949,38.665857],[125.132859,38.848559],[125.38659,39.387958],[125.321116,39.551385],[124.737482,39.660344],[124.265625,39.928493]]],[[[130.780005,42.22001],[130.780007,42.220007],[130.780004,42.220008],[130.780005,42.22001]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":10839514,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"PT\",\"ISO_A3\":\"PRT\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-9.526571,36.838269,-6.389088,42.280469],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-9.034818,41.880571],[-8.671946,42.134689],[-8.263857,42.280469],[-8.013175,41.790886],[-7.422513,41.792075],[-7.251309,41.918346],[-6.668606,41.883387],[-6.389088,41.381815],[-6.851127,41.111083],[-6.86402,40.330872],[-7.026413,40.184524],[-7.066592,39.711892],[-7.498632,39.629571],[-7.098037,39.030073],[-7.374092,38.373059],[-7.029281,38.075764],[-7.166508,37.803894],[-7.537105,37.428904],[-7.453726,37.097788],[-7.855613,36.838269],[-8.382816,36.97888],[-8.898857,36.868809],[-8.746101,37.651346],[-8.839998,38.266243],[-9.287464,38.358486],[-9.526571,38.737429],[-9.446989,39.392066],[-9.048305,39.755093],[-8.977353,40.159306],[-8.768684,40.760639],[-8.790853,41.184334],[-8.990789,41.543459],[-9.034818,41.880571]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6943739,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"PY\",\"ISO_A3\":\"PRY\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-62.685057,-27.548499,-54.29296,-19.342747],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-54.625291,-25.739255],[-54.788795,-26.621786],[-55.695846,-27.387837],[-56.486702,-27.548499],[-57.60976,-27.395899],[-58.618174,-27.123719],[-57.63366,-25.603657],[-57.777217,-25.16234],[-58.807128,-24.771459],[-60.028966,-24.032796],[-60.846565,-23.880713],[-62.685057,-22.249029],[-62.291179,-21.051635],[-62.265961,-20.513735],[-61.786326,-19.633737],[-60.043565,-19.342747],[-59.115042,-19.356906],[-58.183471,-19.868399],[-58.166392,-20.176701],[-57.870674,-20.732688],[-57.937156,-22.090176],[-56.88151,-22.282154],[-56.473317,-22.0863],[-55.797958,-22.35693],[-55.610683,-22.655619],[-55.517639,-23.571998],[-55.400747,-23.956935],[-55.027902,-24.001274],[-54.652834,-23.839578],[-54.29296,-24.021014],[-54.293476,-24.5708],[-54.428946,-25.162185],[-54.625291,-25.739255]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":4543126,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"PS\",\"ISO_A3\":\"PSE\",\"TINY\":-99,\"HOMEPART\":-99,\"MIN_ZOOM\":7,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9.5},\"bbox\":[34.927408,31.353435,35.545665,32.532511],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[35.397561,31.489086],[34.927408,31.353435],[34.970507,31.616778],[35.225892,31.754341],[34.974641,31.866582],[35.18393,32.532511],[35.545665,32.393992],[35.545252,31.782505],[35.397561,31.489086]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":2314307,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"QA\",\"ISO_A3\":\"QAT\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[50.743911,24.556331,51.6067,26.114582],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[50.810108,24.754743],[50.743911,25.482424],[51.013352,26.006992],[51.286462,26.114582],[51.589079,25.801113],[51.6067,25.21567],[51.389608,24.627386],[51.112415,24.556331],[50.810108,24.754743]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":21529967,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"RO\",\"ISO_A3\":\"ROU\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[20.220192,43.688445,29.626543,48.220881],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[28.558081,43.707462],[27.970107,43.812468],[27.2424,44.175986],[26.065159,43.943494],[25.569272,43.688445],[24.100679,43.741051],[23.332302,43.897011],[22.944832,43.823785],[22.65715,44.234923],[22.474008,44.409228],[22.705726,44.578003],[22.459022,44.702517],[22.145088,44.478422],[21.562023,44.768947],[21.483526,45.18117],[20.874313,45.416375],[20.762175,45.734573],[20.220192,46.127469],[21.021952,46.316088],[21.626515,46.994238],[22.099768,47.672439],[22.710531,47.882194],[23.142236,48.096341],[23.760958,47.985598],[24.402056,47.981878],[24.866317,47.737526],[25.207743,47.891056],[25.945941,47.987149],[26.19745,48.220881],[26.619337,48.220726],[26.924176,48.123264],[27.233873,47.826771],[27.551166,47.405117],[28.12803,46.810476],[28.160018,46.371563],[28.054443,45.944586],[28.233554,45.488283],[28.679779,45.304031],[29.149725,45.464925],[29.603289,45.293308],[29.626543,45.035391],[29.141612,44.82021],[28.837858,44.913874],[28.558081,43.707462]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":142257519,\"ECONOMY\":\"3. Emerging region: BRIC\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"RU\",\"ISO_A3\":\"RUS\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":5.2},\"bbox\":[-180,41.151416,180,81.2504],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[48.584353,41.808869],[47.987283,41.405819],[47.815666,41.151416],[47.373315,41.219732],[46.686071,41.827137],[46.404951,41.860675],[45.7764,42.09244],[45.470279,42.502781],[44.537623,42.711993],[43.93121,42.55496],[43.75599,42.74083],[42.3944,43.2203],[40.92219,43.38215],[40.076965,43.553104],[39.955009,43.434998],[38.68,44.28],[37.53912,44.65721],[36.67546,45.24469],[37.40317,45.40451],[38.23295,46.24087],[37.67372,46.63657],[39.14767,47.04475],[39.1212,47.26336],[38.223538,47.10219],[38.255112,47.5464],[38.77057,47.82562],[39.738278,47.898937],[39.89562,48.23241],[39.67465,48.78382],[40.080789,49.30743],[40.06904,49.60105],[38.594988,49.926462],[38.010631,49.915662],[37.39346,50.383953],[36.626168,50.225591],[35.356116,50.577197],[35.37791,50.77394],[35.022183,51.207572],[34.224816,51.255993],[34.141978,51.566413],[34.391731,51.768882],[33.7527,52.335075],[32.715761,52.238465],[32.412058,52.288695],[32.15944,52.06125],[31.785992,52.101678],[31.78597,52.10168],[31.540018,52.742052],[31.305201,53.073996],[31.49764,53.16743],[32.304519,53.132726],[32.693643,53.351421],[32.405599,53.618045],[31.731273,53.794029],[31.791424,53.974639],[31.384472,54.157056],[30.757534,54.811771],[30.971836,55.081548],[30.873909,55.550976],[29.896294,55.789463],[29.371572,55.670091],[29.229513,55.918344],[28.176709,56.16913],[27.855282,56.759326],[27.770016,57.244258],[27.288185,57.474528],[27.716686,57.791899],[27.42015,58.72457],[28.131699,59.300825],[27.98112,59.47537],[27.981127,59.475373],[29.1177,60.02805],[28.070002,60.503519],[28.07,60.50352],[30.211107,61.780028],[31.139991,62.357693],[31.516092,62.867687],[30.035872,63.552814],[30.444685,64.204453],[29.54443,64.948672],[30.21765,65.80598],[29.054589,66.944286],[29.977426,67.698297],[28.445944,68.364613],[28.59193,69.064777],[29.39955,69.15692],[31.101042,69.558101],[31.10108,69.55811],[32.13272,69.90595],[33.77547,69.30142],[36.51396,69.06342],[40.29234,67.9324],[41.05987,67.45713],[41.12595,66.79158],[40.01583,66.26618],[38.38295,65.99953],[33.91871,66.75961],[33.18444,66.63253],[34.81477,65.90015],[34.878574,65.436213],[34.94391,64.41437],[36.23129,64.10945],[37.01273,63.84983],[37.14197,64.33471],[36.539579,64.76446],[37.17604,65.14322],[39.59345,64.52079],[40.4356,64.76446],[39.7626,65.49682],[42.09309,66.47623],[43.01604,66.41858],[43.94975,66.06908],[44.53226,66.75634],[43.69839,67.35245],[44.18795,67.95051],[43.45282,68.57079],[46.25,68.25],[46.82134,67.68997],[45.55517,67.56652],[45.56202,67.01005],[46.34915,66.66767],[47.89416,66.88455],[48.13876,67.52238],[50.22766,67.99867],[53.71743,68.85738],[54.47171,68.80815],[53.48582,68.20131],[54.72628,68.09702],[55.44268,68.43866],[57.31702,68.46628],[58.802,68.88082],[59.94142,68.27844],[61.07784,68.94069],[60.03,69.52],[60.55,69.85],[63.504,69.54739],[64.888115,69.234835],[68.51216,68.09233],[69.18068,68.61563],[68.16444,69.14436],[68.13522,69.35649],[66.93008,69.45461],[67.25976,69.92873],[66.72492,70.70889],[66.69466,71.02897],[68.54006,71.9345],[69.19636,72.84336],[69.94,73.04],[72.58754,72.77629],[72.79603,72.22006],[71.84811,71.40898],[72.47011,71.09019],[72.79188,70.39114],[72.5647,69.02085],[73.66787,68.4079],[73.2387,67.7404],[71.28,66.32],[72.42301,66.17267],[72.82077,66.53267],[73.92099,66.78946],[74.18651,67.28429],[75.052,67.76047],[74.46926,68.32899],[74.93584,68.98918],[73.84236,69.07146],[73.60187,69.62763],[74.3998,70.63175],[73.1011,71.44717],[74.89082,72.12119],[74.65926,72.83227],[75.15801,72.85497],[75.68351,72.30056],[75.28898,71.33556],[76.35911,71.15287],[75.90313,71.87401],[77.57665,72.26717],[79.65202,72.32011],[81.5,71.75],[80.61071,72.58285],[80.51109,73.6482],[82.25,73.85],[84.65526,73.80591],[86.8223,73.93688],[86.00956,74.45967],[87.16682,75.11643],[88.31571,75.14393],[90.26,75.64],[92.90058,75.77333],[93.23421,76.0472],[95.86,76.14],[96.67821,75.91548],[98.92254,76.44689],[100.75967,76.43028],[101.03532,76.86189],[101.99084,77.28754],[104.3516,77.69792],[106.06664,77.37389],[104.705,77.1274],[106.97013,76.97419],[107.24,76.48],[108.1538,76.72335],[111.07726,76.71],[113.33151,76.22224],[114.13417,75.84764],[113.88539,75.32779],[112.77918,75.03186],[110.15125,74.47673],[109.4,74.18],[110.64,74.04],[112.11919,73.78774],[113.01954,73.97693],[113.52958,73.33505],[113.96881,73.59488],[115.56782,73.75285],[118.77633,73.58772],[119.02,73.12],[123.20066,72.97122],[123.25777,73.73503],[125.38,73.56],[126.97644,73.56549],[128.59126,73.03871],[129.05157,72.39872],[128.46,71.98],[129.71599,71.19304],[131.28858,70.78699],[132.2535,71.8363],[133.85766,71.38642],[135.56193,71.65525],[137.49755,71.34763],[138.23409,71.62803],[139.86983,71.48783],[139.14791,72.41619],[140.46817,72.84941],[149.5,72.2],[150.35118,71.60643],[152.9689,70.84222],[157.00688,71.03141],[158.99779,70.86672],[159.83031,70.45324],[159.70866,69.72198],[160.94053,69.43728],[162.27907,69.64204],[164.05248,69.66823],[165.94037,69.47199],[167.83567,69.58269],[169.57763,68.6938],[170.81688,69.01363],[170.0082,69.65276],[170.45345,70.09703],[173.64391,69.81743],[175.72403,69.87725],[178.6,69.4],[180,68.963636],[180,64.979709],[179.99281,64.97433],[178.7072,64.53493],[177.41128,64.60821],[178.313,64.07593],[178.90825,63.25197],[179.37034,62.98262],[179.48636,62.56894],[179.22825,62.3041],[177.3643,62.5219],[174.56929,61.76915],[173.68013,61.65261],[172.15,60.95],[170.6985,60.33618],[170.33085,59.88177],[168.90046,60.57355],[166.29498,59.78855],[165.84,60.16],[164.87674,59.7316],[163.53929,59.86871],[163.21711,59.21101],[162.01733,58.24328],[162.05297,57.83912],[163.19191,57.61503],[163.05794,56.15924],[162.12958,56.12219],[161.70146,55.28568],[162.11749,54.85514],[160.36877,54.34433],[160.02173,53.20257],[158.53094,52.95868],[158.23118,51.94269],[156.78979,51.01105],[156.42,51.7],[155.99182,53.15895],[155.43366,55.38103],[155.91442,56.76792],[156.75815,57.3647],[156.81035,57.83204],[158.36433,58.05575],[160.15064,59.31477],[161.87204,60.343],[163.66969,61.1409],[164.47355,62.55061],[163.25842,62.46627],[162.65791,61.6425],[160.12148,60.54423],[159.30232,61.77396],[156.72068,61.43442],[154.21806,59.75818],[155.04375,59.14495],[152.81185,58.88385],[151.26573,58.78089],[151.33815,59.50396],[149.78371,59.65573],[148.54481,59.16448],[145.48722,59.33637],[142.19782,59.03998],[138.95848,57.08805],[135.12619,54.72959],[136.70171,54.60355],[137.19342,53.97732],[138.1647,53.75501],[138.80463,54.25455],[139.90151,54.18968],[141.34531,53.08957],[141.37923,52.23877],[140.59742,51.23967],[140.51308,50.04553],[140.06193,48.44671],[138.55472,46.99965],[138.21971,46.30795],[136.86232,45.1435],[135.51535,43.989],[134.86939,43.39821],[133.53687,42.81147],[132.90627,42.79849],[132.27807,43.28456],[130.93587,42.55274],[130.780005,42.22001],[130.780004,42.220008],[130.78,42.22],[130.779992,42.22001],[130.64,42.395],[130.64,42.395024],[130.633866,42.903015],[131.144688,42.92999],[131.288555,44.11152],[131.02519,44.96796],[131.883454,45.321162],[133.09712,45.14409],[133.769644,46.116927],[134.11235,47.21248],[134.50081,47.57845],[135.026311,48.47823],[133.373596,48.183442],[132.50669,47.78896],[130.98726,47.79013],[130.582293,48.729687],[129.397818,49.4406],[127.6574,49.76027],[127.287456,50.739797],[126.939157,51.353894],[126.564399,51.784255],[125.946349,52.792799],[125.068211,53.161045],[123.57147,53.4588],[122.245748,53.431726],[121.003085,53.251401],[120.177089,52.753886],[120.725789,52.516226],[120.7382,51.96411],[120.18208,51.64355],[119.27939,50.58292],[119.288461,50.142883],[117.879244,49.510983],[116.678801,49.888531],[115.485695,49.805177],[114.96211,50.140247],[114.362456,50.248303],[112.89774,49.543565],[111.581231,49.377968],[110.662011,49.130128],[109.402449,49.292961],[108.475167,49.282548],[107.868176,49.793705],[106.888804,50.274296],[105.886591,50.406019],[104.62158,50.27532],[103.676545,50.089966],[102.25589,50.51056],[102.06521,51.25991],[100.88948,51.516856],[99.981732,51.634006],[98.861491,52.047366],[97.82574,51.010995],[98.231762,50.422401],[97.25976,49.72605],[95.81402,49.97746],[94.815949,50.013433],[94.147566,50.480537],[93.10421,50.49529],[92.234712,50.802171],[90.713667,50.331812],[88.805567,49.470521],[87.751264,49.297198],[87.35997,49.214981],[86.829357,49.826675],[85.54127,49.692859],[85.11556,50.117303],[84.416377,50.3114],[83.935115,50.889246],[83.383004,51.069183],[81.945986,50.812196],[80.568447,51.388336],[80.03556,50.864751],[77.800916,53.404415],[76.525179,54.177003],[76.8911,54.490524],[74.38482,53.54685],[73.425679,53.48981],[73.508516,54.035617],[72.22415,54.376655],[71.180131,54.133285],[70.865267,55.169734],[69.068167,55.38525],[68.1691,54.970392],[65.66687,54.60125],[65.178534,54.354228],[61.4366,54.00625],[60.978066,53.664993],[61.699986,52.979996],[60.739993,52.719986],[60.927269,52.447548],[59.967534,51.96042],[61.588003,51.272659],[61.337424,50.79907],[59.932807,50.842194],[59.642282,50.545442],[58.36332,51.06364],[56.77798,51.04355],[55.71694,50.62171],[54.532878,51.02624],[52.328724,51.718652],[50.766648,51.692762],[48.702382,50.605128],[48.577841,49.87476],[47.54948,50.454698],[46.751596,49.356006],[47.043672,49.152039],[46.466446,48.394152],[47.31524,47.71585],[48.05725,47.74377],[48.694734,47.075628],[48.59325,46.56104],[49.10116,46.39933],[48.64541,45.80629],[47.67591,45.64149],[46.68201,44.6092],[47.59094,43.66016],[47.49252,42.98658],[48.58437,41.80888],[48.584353,41.808869]]],[[[21.268449,55.190482],[22.315724,55.015299],[22.757764,54.856574],[22.651052,54.582741],[22.731099,54.327537],[20.892245,54.312525],[19.66064,54.426084],[19.888481,54.86616],[21.268449,55.190482]]],[[[33.435988,45.971917],[33.699462,46.219573],[34.410402,46.005162],[34.732017,45.965666],[34.861792,45.768182],[35.012659,45.737725],[35.020788,45.651219],[35.510009,45.409993],[36.529998,45.46999],[36.334713,45.113216],[35.239999,44.939996],[33.882511,44.361479],[33.326421,44.564877],[33.546924,45.034771],[32.454174,45.327466],[32.630804,45.519186],[33.588162,45.851569],[33.435988,45.971917]]],[[[143.648007,50.7476],[144.654148,48.976391],[143.173928,49.306551],[142.558668,47.861575],[143.533492,46.836728],[143.505277,46.137908],[142.747701,46.740765],[142.09203,45.966755],[141.906925,46.805929],[142.018443,47.780133],[141.904445,48.859189],[142.1358,49.615163],[142.179983,50.952342],[141.594076,51.935435],[141.682546,53.301966],[142.606934,53.762145],[142.209749,54.225476],[142.654786,54.365881],[142.914616,53.704578],[143.260848,52.74076],[143.235268,51.75666],[143.648007,50.7476]]],[[[-175.01425,66.58435],[-174.33983,66.33556],[-174.57182,67.06219],[-171.85731,66.91308],[-169.89958,65.97724],[-170.89107,65.54139],[-172.53025,65.43791],[-172.555,64.46079],[-172.95533,64.25269],[-173.89184,64.2826],[-174.65392,64.63125],[-175.98353,64.92288],[-176.20716,65.35667],[-177.22266,65.52024],[-178.35993,65.39052],[-178.90332,65.74044],[-178.68611,66.11211],[-179.88377,65.87456],[-179.43268,65.40411],[-180,64.979709],[-180,68.963636],[-177.55,68.2],[-174.92825,67.20589],[-175.01425,66.58435]]],[[[180,70.832199],[178.903425,70.78114],[178.7253,71.0988],[180,71.515714],[180,70.832199]]],[[[-178.69378,70.89302],[-180,70.832199],[-180,71.515714],[-179.871875,71.55762],[-179.02433,71.55553],[-177.577945,71.26948],[-177.663575,71.13277],[-178.69378,70.89302]]],[[[143.60385,73.21244],[142.08763,73.20544],[140.038155,73.31692],[139.86312,73.36983],[140.81171,73.76506],[142.06207,73.85758],[143.48283,73.47525],[143.60385,73.21244]]],[[[150.73167,75.08406],[149.575925,74.68892],[147.977465,74.778355],[146.11919,75.17298],[146.358485,75.49682],[148.22223,75.345845],[150.73167,75.08406]]],[[[145.086285,75.562625],[144.3,74.82],[140.61381,74.84768],[138.95544,74.61148],[136.97439,75.26167],[137.51176,75.94917],[138.831075,76.13676],[141.471615,76.09289],[145.086285,75.562625]]],[[[57.535693,70.720464],[56.944979,70.632743],[53.677375,70.762658],[53.412017,71.206662],[51.601895,71.474759],[51.455754,72.014881],[52.478275,72.229442],[52.444169,72.774731],[54.427614,73.627548],[53.50829,73.749814],[55.902459,74.627486],[55.631933,75.081412],[57.868644,75.60939],[61.170044,76.251883],[64.498368,76.439055],[66.210977,76.809782],[68.15706,76.939697],[68.852211,76.544811],[68.180573,76.233642],[64.637326,75.737755],[61.583508,75.260885],[58.477082,74.309056],[56.986786,73.333044],[55.419336,72.371268],[55.622838,71.540595],[57.535693,70.720464]]],[[[105.07547,78.30689],[99.43814,77.921],[101.2649,79.23399],[102.08635,79.34641],[102.837815,79.28129],[105.37243,78.71334],[105.07547,78.30689]]],[[[51.136187,80.54728],[49.793685,80.415428],[48.894411,80.339567],[48.754937,80.175468],[47.586119,80.010181],[46.502826,80.247247],[47.072455,80.559424],[44.846958,80.58981],[46.799139,80.771918],[48.318477,80.78401],[48.522806,80.514569],[49.09719,80.753986],[50.039768,80.918885],[51.522933,80.699726],[51.136187,80.54728]]],[[[99.93976,78.88094],[97.75794,78.7562],[94.97259,79.044745],[93.31288,79.4265],[92.5454,80.14379],[91.18107,80.34146],[93.77766,81.0246],[95.940895,81.2504],[97.88385,80.746975],[100.186655,79.780135],[99.93976,78.88094]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":11901484,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"RW\",\"ISO_A3\":\"RWA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[29.024926,-2.917858,30.816135,-1.134659],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[30.469674,-2.413855],[29.938359,-2.348487],[29.632176,-2.917858],[29.024926,-2.839258],[29.117479,-2.292211],[29.254835,-2.21511],[29.291887,-1.620056],[29.579466,-1.341313],[29.821519,-1.443322],[30.419105,-1.134659],[30.816135,-1.698914],[30.758309,-2.28725],[30.46967,-2.41383],[30.469674,-2.413855]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":603253,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"EH\",\"ISO_A3\":\"ESH\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":4.7,\"MIN_LABEL\":6,\"MAX_LABEL\":11},\"bbox\":[-17.063423,20.999752,-8.665124,27.656426],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-8.66559,27.656426],[-8.665124,27.589479],[-8.6844,27.395744],[-8.687294,25.881056],[-11.969419,25.933353],[-11.937224,23.374594],[-12.874222,23.284832],[-13.118754,22.77122],[-12.929102,21.327071],[-16.845194,21.333323],[-17.063423,20.999752],[-17.020428,21.42231],[-17.002962,21.420734],[-14.750955,21.5006],[-14.630833,21.86094],[-14.221168,22.310163],[-13.89111,23.691009],[-12.500963,24.770116],[-12.030759,26.030866],[-11.71822,26.104092],[-11.392555,26.883424],[-10.551263,26.990808],[-10.189424,26.860945],[-9.735343,26.860945],[-9.413037,27.088476],[-8.794884,27.120696],[-8.817828,27.656426],[-8.66559,27.656426]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":28571770,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"SA\",\"ISO_A3\":\"SAU\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2.7,\"MAX_LABEL\":7},\"bbox\":[34.632336,16.347891,55.666659,32.161009],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[51.579519,24.245497],[51.617708,24.014219],[52.000733,23.001154],[55.006803,22.496948],[55.208341,22.70833],[55.666659,22.000001],[54.999982,19.999994],[52.00001,19.000003],[49.116672,18.616668],[48.183344,18.166669],[47.466695,17.116682],[47.000005,16.949999],[46.749994,17.283338],[46.366659,17.233315],[45.399999,17.333335],[45.216651,17.433329],[44.062613,17.410359],[43.791519,17.319977],[43.380794,17.579987],[43.115798,17.08844],[43.218375,16.66689],[42.779332,16.347891],[42.649573,16.774635],[42.347989,17.075806],[42.270888,17.474722],[41.754382,17.833046],[41.221391,18.6716],[40.939341,19.486485],[40.247652,20.174635],[39.801685,20.338862],[39.139399,21.291905],[39.023696,21.986875],[39.066329,22.579656],[38.492772,23.688451],[38.02386,24.078686],[37.483635,24.285495],[37.154818,24.858483],[37.209491,25.084542],[36.931627,25.602959],[36.639604,25.826228],[36.249137,26.570136],[35.640182,27.37652],[35.130187,28.063352],[34.632336,28.058546],[34.787779,28.607427],[34.83222,28.957483],[34.956037,29.356555],[36.068941,29.197495],[36.501214,29.505254],[36.740528,29.865283],[37.503582,30.003776],[37.66812,30.338665],[37.998849,30.5085],[37.002166,31.508413],[39.004886,32.010217],[39.195468,32.161009],[40.399994,31.889992],[41.889981,31.190009],[44.709499,29.178891],[46.568713,29.099025],[47.459822,29.002519],[47.708851,28.526063],[48.416094,28.552004],[48.807595,27.689628],[49.299554,27.461218],[49.470914,27.109999],[50.152422,26.689663],[50.212935,26.277027],[50.113303,25.943972],[50.239859,25.60805],[50.527387,25.327808],[50.660557,24.999896],[50.810108,24.754743],[51.112415,24.556331],[51.389608,24.627386],[51.579519,24.245497]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":37345935,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"SD\",\"ISO_A3\":\"SDN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[21.93681,8.229188,38.41009,22],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[24.567369,8.229188],[23.805813,8.666319],[23.459013,8.954286],[23.394779,9.265068],[23.55725,9.681218],[23.554304,10.089255],[22.977544,10.714463],[22.864165,11.142395],[22.87622,11.38461],[22.50869,11.67936],[22.49762,12.26024],[22.28801,12.64605],[21.93681,12.58818],[22.03759,12.95546],[22.29658,13.37232],[22.18329,13.78648],[22.51202,14.09318],[22.30351,14.32682],[22.56795,14.94429],[23.02459,15.68072],[23.88689,15.61084],[23.83766,19.58047],[23.85,20],[25,20.00304],[25,22],[29.02,22],[32.9,22],[36.86623,22],[37.18872,21.01885],[36.96941,20.83744],[37.1147,19.80796],[37.48179,18.61409],[37.86276,18.36786],[38.41009,17.998307],[37.904,17.42754],[37.16747,17.26314],[36.85253,16.95655],[36.75389,16.29186],[36.32322,14.82249],[36.42951,14.42211],[36.27022,13.56333],[35.86363,12.57828],[35.26049,12.08286],[34.83163,11.31896],[34.73115,10.91017],[34.25745,10.63009],[33.96162,9.58358],[33.97498,8.68456],[33.963393,9.464285],[33.824963,9.484061],[33.842131,9.981915],[33.721959,10.325262],[33.206938,10.720112],[33.086766,11.441141],[33.206938,12.179338],[32.743419,12.248008],[32.67475,12.024832],[32.073892,11.97333],[32.314235,11.681484],[32.400072,11.080626],[31.850716,10.531271],[31.352862,9.810241],[30.837841,9.707237],[29.996639,10.290927],[29.618957,10.084919],[29.515953,9.793074],[29.000932,9.604232],[28.966597,9.398224],[27.97089,9.398224],[27.833551,9.604232],[27.112521,9.638567],[26.752006,9.466893],[26.477328,9.55273],[25.962307,10.136421],[25.790633,10.411099],[25.069604,10.27376],[24.794926,9.810241],[24.537415,8.917538],[24.194068,8.728696],[23.88698,8.61973],[24.567369,8.229188]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":13026129,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"SS\",\"ISO_A3\":\"SSD\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[23.88698,3.509172,35.298007,12.248008],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[27.374226,5.233944],[27.213409,5.550953],[26.465909,5.946717],[26.213418,6.546603],[25.796648,6.979316],[25.124131,7.500085],[25.114932,7.825104],[24.567369,8.229188],[23.88698,8.61973],[24.194068,8.728696],[24.537415,8.917538],[24.794926,9.810241],[25.069604,10.27376],[25.790633,10.411099],[25.962307,10.136421],[26.477328,9.55273],[26.752006,9.466893],[27.112521,9.638567],[27.833551,9.604232],[27.97089,9.398224],[28.966597,9.398224],[29.000932,9.604232],[29.515953,9.793074],[29.618957,10.084919],[29.996639,10.290927],[30.837841,9.707237],[31.352862,9.810241],[31.850716,10.531271],[32.400072,11.080626],[32.314235,11.681484],[32.073892,11.97333],[32.67475,12.024832],[32.743419,12.248008],[33.206938,12.179338],[33.086766,11.441141],[33.206938,10.720112],[33.721959,10.325262],[33.842131,9.981915],[33.824963,9.484061],[33.963393,9.464285],[33.97498,8.68456],[33.8255,8.37916],[33.2948,8.35458],[32.95418,7.78497],[33.56829,7.71334],[34.0751,7.22595],[34.25032,6.82607],[34.70702,6.59422],[35.298007,5.506],[34.620196,4.847123],[34.005,4.249885],[33.39,3.79],[32.68642,3.79232],[31.88145,3.55827],[31.24556,3.7819],[30.833852,3.509172],[29.9535,4.173699],[29.715995,4.600805],[29.159078,4.389267],[28.696678,4.455077],[28.428994,4.287155],[27.979977,4.408413],[27.374226,5.233944]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":14668522,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"SN\",\"ISO_A3\":\"SEN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-17.625043,12.33209,-11.467899,16.598264],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-11.513943,12.442988],[-11.658301,12.386583],[-12.203565,12.465648],[-12.278599,12.35444],[-12.499051,12.33209],[-13.217818,12.575874],[-13.700476,12.586183],[-15.548477,12.62817],[-15.816574,12.515567],[-16.147717,12.547762],[-16.677452,12.384852],[-16.841525,13.151394],[-15.931296,13.130284],[-15.691001,13.270353],[-15.511813,13.27857],[-15.141163,13.509512],[-14.712197,13.298207],[-14.277702,13.280585],[-13.844963,13.505042],[-14.046992,13.794068],[-14.376714,13.62568],[-14.687031,13.630357],[-15.081735,13.876492],[-15.39877,13.860369],[-15.624596,13.623587],[-16.713729,13.594959],[-17.126107,14.373516],[-17.625043,14.729541],[-17.185173,14.919477],[-16.700706,15.621527],[-16.463098,16.135036],[-16.12069,16.455663],[-15.623666,16.369337],[-15.135737,16.587282],[-14.577348,16.598264],[-14.099521,16.304302],[-13.435738,16.039383],[-12.830658,15.303692],[-12.17075,14.616834],[-12.124887,13.994727],[-11.927716,13.422075],[-11.553398,13.141214],[-11.467899,12.754519],[-11.513943,12.442988]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":647581,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"SB\",\"ISO_A3\":\"SLB\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[156.491358,-10.826367,162.398646,-6.599338],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[162.119025,-10.482719],[162.398646,-10.826367],[161.700032,-10.820011],[161.319797,-10.204751],[161.917383,-10.446701],[162.119025,-10.482719]]],[[[160.852229,-9.872937],[160.462588,-9.89521],[159.849447,-9.794027],[159.640003,-9.63998],[159.702945,-9.24295],[160.362956,-9.400304],[160.688518,-9.610162],[160.852229,-9.872937]]],[[[161.679982,-9.599982],[161.529397,-9.784312],[160.788253,-8.917543],[160.579997,-8.320009],[160.920028,-8.320009],[161.280006,-9.120011],[161.679982,-9.599982]]],[[[159.875027,-8.33732],[159.917402,-8.53829],[159.133677,-8.114181],[158.586114,-7.754824],[158.21115,-7.421872],[158.359978,-7.320018],[158.820001,-7.560003],[159.640003,-8.020027],[159.875027,-8.33732]]],[[[157.538426,-7.34782],[157.33942,-7.404767],[156.90203,-7.176874],[156.491358,-6.765943],[156.542828,-6.599338],[157.14,-7.021638],[157.538426,-7.34782]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6163195,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"SL\",\"ISO_A3\":\"SLE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-13.24655,6.785917,-10.230094,10.046984],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-13.24655,8.903049],[-12.711958,9.342712],[-12.596719,9.620188],[-12.425929,9.835834],[-12.150338,9.858572],[-11.917277,10.046984],[-11.117481,10.045873],[-10.839152,9.688246],[-10.622395,9.26791],[-10.65477,8.977178],[-10.494315,8.715541],[-10.505477,8.348896],[-10.230094,8.406206],[-10.695595,7.939464],[-11.146704,7.396706],[-11.199802,7.105846],[-11.438779,6.785917],[-11.708195,6.860098],[-12.428099,7.262942],[-12.949049,7.798646],[-13.124025,8.163946],[-13.24655,8.903049]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":6172011,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"SV\",\"ISO_A3\":\"SLV\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[-90.095555,13.149017,-87.723503,14.424133],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-90.095555,13.735338],[-90.064678,13.88197],[-89.721934,14.134228],[-89.534219,14.244816],[-89.587343,14.362586],[-89.353326,14.424133],[-89.058512,14.340029],[-88.843073,14.140507],[-88.541231,13.980155],[-88.503998,13.845486],[-88.065343,13.964626],[-87.859515,13.893312],[-87.723503,13.78505],[-87.793111,13.38448],[-87.904112,13.149017],[-88.483302,13.163951],[-88.843228,13.259734],[-89.256743,13.458533],[-89.812394,13.520622],[-90.095555,13.735338]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3500000,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"SO\",\"ISO_A3\":\"SOM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":4,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9},\"bbox\":[42.55876,7.99688,48.948206,11.46204],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[42.776852,10.926879],[43.145305,11.46204],[43.47066,11.27771],[43.666668,10.864169],[44.117804,10.445538],[44.614259,10.442205],[45.556941,10.698029],[46.645401,10.816549],[47.525658,11.127228],[48.021596,11.193064],[48.378784,11.375482],[48.948206,11.410622],[48.948205,11.410617],[48.948205,11.410617],[48.942005,11.394266],[48.938491,10.982327],[48.938233,9.9735],[48.93813,9.451749],[48.486736,8.837626],[47.78942,8.003],[46.94834,7.99688],[43.67875,9.18358],[43.29699,9.54048],[42.92812,10.02194],[42.55876,10.57258],[42.776852,10.926879]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":7531386,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"SO\",\"ISO_A3\":\"SOM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[40.98105,-1.68325,51.13387,12.02464],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[41.855083,3.918912],[42.12861,4.23413],[42.76967,4.25259],[43.66087,4.95755],[44.9636,5.00162],[47.78942,8.003],[48.486736,8.837626],[48.93813,9.451749],[48.938233,9.9735],[48.938491,10.982327],[48.942005,11.394266],[48.948205,11.410617],[48.948205,11.410617],[49.26776,11.43033],[49.72862,11.5789],[50.25878,11.67957],[50.73202,12.0219],[51.1112,12.02464],[51.13387,11.74815],[51.04153,11.16651],[51.04531,10.6409],[50.83418,10.27972],[50.55239,9.19874],[50.07092,8.08173],[49.4527,6.80466],[48.59455,5.33911],[47.74079,4.2194],[46.56476,2.85529],[45.56399,2.04576],[44.06815,1.05283],[43.13597,0.2922],[42.04157,-0.91916],[41.81095,-1.44647],[41.58513,-1.68325],[40.993,-0.85829],[40.98105,2.78452],[41.855083,3.918912]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":7111024,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"RS\",\"ISO_A3\":\"SRB\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":7},\"bbox\":[18.829825,42.245224,22.986019,46.17173],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[22.65715,44.234923],[22.410446,44.008063],[22.500157,43.642814],[22.986019,43.211161],[22.604801,42.898519],[22.436595,42.580321],[22.545012,42.461362],[22.380526,42.32026],[21.91708,42.30364],[21.576636,42.245224],[21.54332,42.32025],[21.66292,42.43922],[21.77505,42.6827],[21.63302,42.67717],[21.43866,42.86255],[21.27421,42.90959],[21.143395,43.068685],[20.95651,43.13094],[20.81448,43.27205],[20.63508,43.21671],[20.49679,42.88469],[20.25758,42.81275],[20.3398,42.89852],[19.95857,43.10604],[19.63,43.21378],[19.48389,43.35229],[19.21852,43.52384],[19.454,43.5681],[19.59976,44.03847],[19.11761,44.42307],[19.36803,44.863],[19.00548,44.86023],[19.005485,44.860234],[19.390476,45.236516],[19.072769,45.521511],[18.829825,45.908872],[18.829838,45.908878],[19.596045,46.17173],[20.220192,46.127469],[20.762175,45.734573],[20.874313,45.416375],[21.483526,45.18117],[21.562023,44.768947],[22.145088,44.478422],[22.459022,44.702517],[22.705726,44.578003],[22.474008,44.409228],[22.65715,44.234923]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":591919,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"SR\",\"ISO_A3\":\"SUR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[-58.044694,1.817667,-53.958045,6.025291],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-54.524754,2.311849],[-55.097587,2.523748],[-55.569755,2.421506],[-55.973322,2.510364],[-56.073342,2.220795],[-55.9056,2.021996],[-55.995698,1.817667],[-56.539386,1.899523],[-57.150098,2.768927],[-57.281433,3.333492],[-57.601569,3.334655],[-58.044694,4.060864],[-57.86021,4.576801],[-57.914289,4.812626],[-57.307246,5.073567],[-57.147436,5.97315],[-55.949318,5.772878],[-55.84178,5.953125],[-55.03325,6.025291],[-53.958045,5.756548],[-54.478633,4.896756],[-54.399542,4.212611],[-54.011504,3.62257],[-54.184284,3.194172],[-54.27123,2.738748],[-54.524754,2.311849]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5445829,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"SK\",\"ISO_A3\":\"SVK\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[16.879983,47.758429,22.558138,49.571574],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[16.979667,48.123497],[16.879983,48.470013],[16.960288,48.596982],[17.101985,48.816969],[17.545007,48.800019],[17.886485,48.903475],[17.913512,48.996493],[18.104973,49.043983],[18.170498,49.271515],[18.399994,49.315001],[18.554971,49.495015],[18.853144,49.49623],[18.909575,49.435846],[19.320713,49.571574],[19.825023,49.217125],[20.415839,49.431453],[20.887955,49.328772],[21.607808,49.470107],[22.558138,49.085738],[22.280842,48.825392],[22.085608,48.422264],[21.872236,48.319971],[20.801294,48.623854],[20.473562,48.56285],[20.239054,48.327567],[19.769471,48.202691],[19.661364,48.266615],[19.174365,48.111379],[18.777025,48.081768],[18.696513,47.880954],[17.857133,47.758429],[17.488473,47.867466],[16.979667,48.123497]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1972126,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"SI\",\"ISO_A3\":\"SVN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[13.69811,45.452316,16.564808,46.852386],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[13.806475,46.509306],[14.632472,46.431817],[15.137092,46.658703],[16.011664,46.683611],[16.202298,46.852386],[16.370505,46.841327],[16.564808,46.503751],[15.768733,46.238108],[15.67153,45.834154],[15.323954,45.731783],[15.327675,45.452316],[14.935244,45.471695],[14.595109,45.634941],[14.411968,45.466166],[13.71506,45.500324],[13.93763,45.591016],[13.69811,46.016778],[13.806475,46.509306]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":9960487,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"SE\",\"ISO_A3\":\"SWE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[11.027369,55.361737,23.903379,69.106247],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[20.645593,69.106247],[21.978535,68.616846],[23.539473,67.936009],[23.56588,66.396051],[23.903379,66.006927],[22.183173,65.723741],[21.213517,65.026005],[21.369631,64.413588],[19.778876,63.609554],[17.847779,62.7494],[17.119555,61.341166],[17.831346,60.636583],[18.787722,60.081914],[17.869225,58.953766],[16.829185,58.719827],[16.44771,57.041118],[15.879786,56.104302],[14.666681,56.200885],[14.100721,55.407781],[12.942911,55.361737],[12.625101,56.30708],[11.787942,57.441817],[11.027369,58.856149],[11.468272,59.432393],[12.300366,60.117933],[12.631147,61.293572],[11.992064,61.800362],[11.930569,63.128318],[12.579935,64.066219],[13.571916,64.049114],[13.919905,64.445421],[13.55569,64.787028],[15.108411,66.193867],[16.108712,67.302456],[16.768879,68.013937],[17.729182,68.010552],[17.993868,68.567391],[19.87856,68.407194],[20.025269,69.065139],[20.645593,69.106247]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1467152,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"SZ\",\"ISO_A3\":\"SWZ\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[30.676609,-27.285879,32.071665,-25.660191],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[31.837778,-25.843332],[31.985779,-26.29178],[32.071665,-26.73382],[31.86806,-27.177927],[31.282773,-27.285879],[30.685962,-26.743845],[30.676609,-26.398078],[30.949667,-26.022649],[31.04408,-25.731452],[31.333158,-25.660191],[31.837778,-25.843332]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":18028549,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"SY\",\"ISO_A3\":\"SYR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[35.700798,32.312938,42.349591,37.229873],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[42.349591,37.229873],[41.837064,36.605854],[41.289707,36.358815],[41.383965,35.628317],[41.006159,34.419372],[38.792341,33.378686],[36.834062,32.312938],[35.719918,32.709192],[35.700798,32.716014],[35.836397,32.868123],[35.821101,33.277426],[36.06646,33.824912],[36.61175,34.201789],[36.448194,34.593935],[35.998403,34.644914],[35.905023,35.410009],[36.149763,35.821535],[36.41755,36.040617],[36.685389,36.259699],[36.739494,36.81752],[37.066761,36.623036],[38.167727,36.90121],[38.699891,36.712927],[39.52258,36.716054],[40.673259,37.091276],[41.212089,37.074352],[42.349591,37.229873]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":12075985,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"TD\",\"ISO_A3\":\"TCD\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[13.540394,7.421925,23.88689,23.40972],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[22.864165,11.142395],[22.231129,10.971889],[21.723822,10.567056],[21.000868,9.475985],[20.059685,9.012706],[19.094008,9.074847],[18.81201,8.982915],[18.911022,8.630895],[18.389555,8.281304],[17.96493,7.890914],[16.705988,7.508328],[16.456185,7.734774],[16.290562,7.754307],[16.106232,7.497088],[15.27946,7.421925],[15.436092,7.692812],[15.120866,8.38215],[14.979996,8.796104],[14.544467,8.965861],[13.954218,9.549495],[14.171466,10.021378],[14.627201,9.920919],[14.909354,9.992129],[15.467873,9.982337],[14.923565,10.891325],[14.960152,11.555574],[14.89336,12.21905],[14.495787,12.859396],[14.595781,13.330427],[13.954477,13.353449],[13.956699,13.996691],[13.540394,14.367134],[13.97217,15.68437],[15.247731,16.627306],[15.300441,17.92795],[15.685741,19.95718],[15.903247,20.387619],[15.487148,20.730415],[15.47106,21.04845],[15.096888,21.308519],[14.8513,22.86295],[15.86085,23.40972],[19.84926,21.49509],[23.83766,19.58047],[23.88689,15.61084],[23.02459,15.68072],[22.56795,14.94429],[22.30351,14.32682],[22.51202,14.09318],[22.18329,13.78648],[22.29658,13.37232],[22.03759,12.95546],[21.93681,12.58818],[22.28801,12.64605],[22.49762,12.26024],[22.50869,11.67936],[22.87622,11.38461],[22.864165,11.142395]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":7965055,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"TG\",\"ISO_A3\":\"TGO\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":5,\"MAX_LABEL\":10},\"bbox\":[-0.049785,5.928837,1.865241,11.018682],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[0.899563,10.997339],[0.772336,10.470808],[1.077795,10.175607],[1.425061,9.825395],[1.463043,9.334624],[1.664478,9.12859],[1.618951,6.832038],[1.865241,6.142158],[1.060122,5.928837],[0.836931,6.279979],[0.570384,6.914359],[0.490957,7.411744],[0.712029,8.312465],[0.461192,8.677223],[0.365901,9.465004],[0.36758,10.191213],[-0.049785,10.706918],[0.023803,11.018682],[0.899563,10.997339]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":68414135,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"TH\",\"ISO_A3\":\"THA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[97.375896,5.691384,105.589039,20.41785],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[105.218777,14.273212],[104.281418,14.416743],[102.988422,14.225721],[102.348099,13.394247],[102.584932,12.186595],[101.687158,12.64574],[100.83181,12.627085],[100.978467,13.412722],[100.097797,13.406856],[100.018733,12.307001],[99.478921,10.846367],[99.153772,9.963061],[99.222399,9.239255],[99.873832,9.207862],[100.279647,8.295153],[100.459274,7.429573],[101.017328,6.856869],[101.623079,6.740622],[102.141187,6.221636],[101.814282,5.810808],[101.154219,5.691384],[101.075516,6.204867],[100.259596,6.642825],[100.085757,6.464489],[99.690691,6.848213],[99.519642,7.343454],[98.988253,7.907993],[98.503786,8.382305],[98.339662,7.794512],[98.150009,8.350007],[98.25915,8.973923],[98.553551,9.93296],[99.038121,10.960546],[99.587286,11.892763],[99.196354,12.804748],[99.212012,13.269294],[99.097755,13.827503],[98.430819,14.622028],[98.192074,15.123703],[98.537376,15.308497],[98.903348,16.177824],[98.493761,16.837836],[97.859123,17.567946],[97.375896,18.445438],[97.797783,18.62708],[98.253724,19.708203],[98.959676,19.752981],[99.543309,20.186598],[100.115988,20.41785],[100.548881,20.109238],[100.606294,19.508344],[101.282015,19.462585],[101.035931,18.408928],[101.059548,17.512497],[102.113592,18.109102],[102.413005,17.932782],[102.998706,17.961695],[103.200192,18.309632],[103.956477,18.240954],[104.716947,17.428859],[104.779321,16.441865],[105.589039,15.570316],[105.544338,14.723934],[105.218777,14.273212]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":8468555,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"TJ\",\"ISO_A3\":\"TJK\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[67.44222,36.738171,74.980002,40.960213],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[74.980002,37.41999],[73.948696,37.421566],[73.260056,37.495257],[72.63689,37.047558],[72.193041,36.948288],[71.844638,36.738171],[71.448693,37.065645],[71.541918,37.905774],[71.239404,37.953265],[71.348131,38.258905],[70.806821,38.486282],[70.376304,38.138396],[70.270574,37.735165],[70.116578,37.588223],[69.518785,37.608997],[69.196273,37.151144],[68.859446,37.344336],[68.135562,37.023115],[67.83,37.144994],[68.392033,38.157025],[68.176025,38.901553],[67.44222,39.140144],[67.701429,39.580478],[68.536416,39.533453],[69.011633,40.086158],[69.329495,40.727824],[70.666622,40.960213],[70.45816,40.496495],[70.601407,40.218527],[71.014198,40.244366],[70.648019,39.935754],[69.55961,40.103211],[69.464887,39.526683],[70.549162,39.604198],[71.784694,39.279463],[73.675379,39.431237],[73.928852,38.505815],[74.257514,38.606507],[74.864816,38.378846],[74.829986,37.990007],[74.980002,37.41999]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":5351277,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"TM\",\"ISO_A3\":\"TKM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[52.50246,35.270664,66.54615,42.751551],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[66.518607,37.362784],[66.217385,37.39379],[65.745631,37.661164],[65.588948,37.305217],[64.746105,37.111818],[64.546479,36.312073],[63.982896,36.007957],[63.193538,35.857166],[62.984662,35.404041],[62.230651,35.270664],[61.210817,35.650072],[61.123071,36.491597],[60.377638,36.527383],[59.234762,37.412988],[58.436154,37.522309],[57.330434,38.029229],[56.619366,38.121394],[56.180375,37.935127],[55.511578,37.964117],[54.800304,37.392421],[53.921598,37.198918],[53.735511,37.906136],[53.880929,38.952093],[53.101028,39.290574],[53.357808,39.975286],[52.693973,40.033629],[52.915251,40.876523],[53.858139,40.631034],[54.736845,40.951015],[54.008311,41.551211],[53.721713,42.123191],[52.91675,41.868117],[52.814689,41.135371],[52.50246,41.783316],[52.944293,42.116034],[54.079418,42.324109],[54.755345,42.043971],[55.455251,41.259859],[55.968191,41.308642],[57.096391,41.32231],[56.932215,41.826026],[57.78653,42.170553],[58.629011,42.751551],[59.976422,42.223082],[60.083341,41.425146],[60.465953,41.220327],[61.547179,41.26637],[61.882714,41.084857],[62.37426,40.053886],[63.518015,39.363257],[64.170223,38.892407],[65.215999,38.402695],[66.54615,37.974685],[66.518607,37.362784]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1291358,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"TL\",\"ISO_A3\":\"TLS\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[124.968682,-9.393173,127.335928,-8.273345],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[125.08852,-9.393173],[125.07002,-9.089987],[124.968682,-8.89279],[125.086246,-8.656887],[125.947072,-8.432095],[126.644704,-8.398247],[126.957243,-8.273345],[127.335928,-8.397317],[126.967992,-8.668256],[125.925885,-9.106007],[125.08852,-9.393173]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":1218208,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"TT\",\"ISO_A3\":\"TTO\",\"TINY\":2,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4.5,\"MAX_LABEL\":9.5},\"bbox\":[-61.95,10,-60.895,10.89],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-61.68,10.76],[-61.105,10.89],[-60.895,10.855],[-60.935,10.11],[-61.77,10],[-61.95,10.09],[-61.66,10.365],[-61.68,10.76]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":11403800,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"TN\",\"ISO_A3\":\"TUN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[7.524482,30.307556,11.488787,37.349994],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[9.48214,30.307556],[9.055603,32.102692],[8.439103,32.506285],[8.430473,32.748337],[7.612642,33.344115],[7.524482,34.097376],[8.140981,34.655146],[8.376368,35.479876],[8.217824,36.433177],[8.420964,36.946427],[9.509994,37.349994],[10.210002,37.230002],[10.18065,36.724038],[11.028867,37.092103],[11.100026,36.899996],[10.600005,36.41],[10.593287,35.947444],[10.939519,35.698984],[10.807847,34.833507],[10.149593,34.330773],[10.339659,33.785742],[10.856836,33.76874],[11.108501,33.293343],[11.488787,33.136996],[11.432253,32.368903],[10.94479,32.081815],[10.636901,31.761421],[9.950225,31.37607],[10.056575,30.961831],[9.970017,30.539325],[9.48214,30.307556]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":80845215,\"ECONOMY\":\"4. Emerging region: MIKT\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"TR\",\"ISO_A3\":\"TUR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[26.043351,35.821535,44.79399,42.141485],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[43.582746,41.092143],[43.752658,40.740201],[43.656436,40.253564],[44.400009,40.005],[44.79399,39.713003],[44.109225,39.428136],[44.421403,38.281281],[44.225756,37.971584],[44.77267,37.17045],[44.772677,37.170437],[44.293452,37.001514],[43.942259,37.256228],[42.779126,37.385264],[42.349591,37.229873],[41.212089,37.074352],[40.673259,37.091276],[39.52258,36.716054],[38.699891,36.712927],[38.167727,36.90121],[37.066761,36.623036],[36.739494,36.81752],[36.685389,36.259699],[36.41755,36.040617],[36.149763,35.821535],[35.782085,36.274995],[36.160822,36.650606],[35.550936,36.565443],[34.714553,36.795532],[34.026895,36.21996],[32.509158,36.107564],[31.699595,36.644275],[30.621625,36.677865],[30.391096,36.262981],[29.699976,36.144357],[28.732903,36.676831],[27.641187,36.658822],[27.048768,37.653361],[26.318218,38.208133],[26.8047,38.98576],[26.170785,39.463612],[27.28002,40.420014],[28.819978,40.460011],[29.240004,41.219991],[31.145934,41.087622],[32.347979,41.736264],[33.513283,42.01896],[35.167704,42.040225],[36.913127,41.335358],[38.347665,40.948586],[39.512607,41.102763],[40.373433,41.013673],[41.554084,41.535656],[42.619549,41.583173],[43.582746,41.092143]]],[[[26.117042,41.826905],[27.135739,42.141485],[27.99672,42.007359],[28.115525,41.622886],[28.988443,41.299934],[28.806438,41.054962],[27.619017,40.999823],[27.192377,40.690566],[26.358009,40.151994],[26.043351,40.617754],[26.056942,40.824123],[26.294602,40.936261],[26.604196,41.562115],[26.117042,41.826905]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":23508428,\"ECONOMY\":\"2. Developed region: nonG7\",\"INCOME_GRP\":\"2. High income: nonOECD\",\"ISO_A2\":\"TW\",\"ISO_A3\":\"TWN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[120.106189,21.970571,121.951244,25.295459],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[121.777818,24.394274],[121.175632,22.790857],[120.74708,21.970571],[120.220083,22.814861],[120.106189,23.556263],[120.69468,24.538451],[121.495044,25.295459],[121.951244,24.997596],[121.777818,24.394274]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":53950935,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"TZ\",\"ISO_A3\":\"TZA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[29.339998,-11.720938,40.31659,-0.95],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[29.339998,-4.499983],[29.753512,-4.452389],[30.11632,-4.09012],[30.50554,-3.56858],[30.75224,-3.35931],[30.74301,-3.03431],[30.52766,-2.80762],[30.469674,-2.413855],[30.46967,-2.41383],[30.758309,-2.28725],[30.816135,-1.698914],[30.419105,-1.134659],[30.76986,-1.01455],[31.86617,-1.02736],[33.903711,-0.95],[34.07262,-1.05982],[37.69869,-3.09699],[37.7669,-3.67712],[39.20222,-4.67677],[38.74054,-5.90895],[38.79977,-6.47566],[39.44,-6.84],[39.47,-7.1],[39.19469,-7.7039],[39.25203,-8.00781],[39.18652,-8.48551],[39.53574,-9.11237],[39.9496,-10.0984],[40.316586,-10.317098],[40.31659,-10.3171],[39.521,-10.89688],[38.427557,-11.285202],[37.82764,-11.26879],[37.47129,-11.56876],[36.775151,-11.594537],[36.514082,-11.720938],[35.312398,-11.439146],[34.559989,-11.52002],[34.28,-10.16],[33.940838,-9.693674],[33.73972,-9.41715],[32.759375,-9.230599],[32.191865,-8.930359],[31.556348,-8.762049],[31.157751,-8.594579],[30.74001,-8.340006],[30.740015,-8.340007],[30.199997,-7.079981],[29.620032,-6.520015],[29.419993,-5.939999],[29.519987,-5.419979],[29.339998,-4.499983]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":39570125,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"UG\",\"ISO_A3\":\"UGA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[29.579466,-1.443322,35.03599,4.249885],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[29.579466,-1.341313],[29.587838,-0.587406],[29.819503,-0.20531],[29.875779,0.59738],[30.086154,1.062313],[30.468508,1.583805],[30.85267,1.849396],[31.174149,2.204465],[30.773347,2.339883],[30.83386,3.509166],[30.833852,3.509172],[31.24556,3.7819],[31.88145,3.55827],[32.68642,3.79232],[33.39,3.79],[34.005,4.249885],[34.47913,3.5556],[34.59607,3.05374],[35.03599,1.90584],[34.6721,1.17694],[34.18,0.515],[33.893569,0.109814],[33.903711,-0.95],[31.86617,-1.02736],[30.76986,-1.01455],[30.419105,-1.134659],[29.821519,-1.443322],[29.579466,-1.341313]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":44033874,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"UA\",\"ISO_A3\":\"UKR\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7},\"bbox\":[22.085608,45.293308,40.080789,52.335075],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[23.527071,51.578454],[24.005078,51.617444],[24.553106,51.888461],[25.327788,51.910656],[26.337959,51.832289],[27.454066,51.592303],[28.241615,51.572227],[28.617613,51.427714],[28.992835,51.602044],[29.254938,51.368234],[30.157364,51.416138],[30.555117,51.319503],[30.619454,51.822806],[30.927549,52.042353],[31.785992,52.101678],[32.15944,52.06125],[32.412058,52.288695],[32.715761,52.238465],[33.7527,52.335075],[34.391731,51.768882],[34.141978,51.566413],[34.224816,51.255993],[35.022183,51.207572],[35.37791,50.77394],[35.356116,50.577197],[36.626168,50.225591],[37.39346,50.383953],[38.010631,49.915662],[38.594988,49.926462],[40.06904,49.60105],[40.080789,49.30743],[39.67465,48.78382],[39.89562,48.23241],[39.738278,47.898937],[38.77057,47.82562],[38.255112,47.5464],[38.223538,47.10219],[37.425137,47.022221],[36.759855,46.6987],[35.823685,46.645964],[34.962342,46.273197],[35.012659,45.737725],[34.861792,45.768182],[34.732017,45.965666],[34.410402,46.005162],[33.699462,46.219573],[33.435988,45.971917],[33.298567,46.080598],[31.74414,46.333348],[31.675307,46.706245],[30.748749,46.5831],[30.377609,46.03241],[29.603289,45.293308],[29.149725,45.464925],[28.679779,45.304031],[28.233554,45.488283],[28.485269,45.596907],[28.659987,45.939987],[28.933717,46.25883],[28.862972,46.437889],[29.072107,46.517678],[29.170654,46.379262],[29.759972,46.349988],[30.024659,46.423937],[29.83821,46.525326],[29.908852,46.674361],[29.559674,46.928583],[29.415135,47.346645],[29.050868,47.510227],[29.122698,47.849095],[28.670891,48.118149],[28.259547,48.155562],[27.522537,48.467119],[26.857824,48.368211],[26.619337,48.220726],[26.19745,48.220881],[25.945941,47.987149],[25.207743,47.891056],[24.866317,47.737526],[24.402056,47.981878],[23.760958,47.985598],[23.142236,48.096341],[22.710531,47.882194],[22.64082,48.15024],[22.085608,48.422264],[22.280842,48.825392],[22.558138,49.085738],[22.776419,49.027395],[22.51845,49.476774],[23.426508,50.308506],[23.922757,50.424881],[24.029986,50.705407],[23.527071,51.578454]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":3360148,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"UY\",\"ISO_A3\":\"URY\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[-58.427074,-34.952647,-53.209589,-30.109686],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-58.427074,-33.909454],[-58.349611,-33.263189],[-58.132648,-33.040567],[-58.14244,-32.044504],[-57.874937,-31.016556],[-57.625133,-30.216295],[-56.976026,-30.109686],[-55.973245,-30.883076],[-55.60151,-30.853879],[-54.572452,-31.494511],[-53.787952,-32.047243],[-53.209589,-32.727666],[-53.650544,-33.202004],[-53.373662,-33.768378],[-53.806426,-34.396815],[-54.935866,-34.952647],[-55.67409,-34.752659],[-56.215297,-34.859836],[-57.139685,-34.430456],[-57.817861,-34.462547],[-58.427074,-33.909454]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":326625791,\"ECONOMY\":\"1. Developed region: G7\",\"INCOME_GRP\":\"1. High income: OECD\",\"ISO_A2\":\"US\",\"ISO_A3\":\"USA\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":5.7},\"bbox\":[-171.791111,18.91619,-66.96466,71.357764],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[-122.84,49],[-120,49],[-117.03121,49],[-116.04818,49],[-113,49],[-110.05,49],[-107.05,49],[-104.04826,48.99986],[-100.65,49],[-97.22872,49.0007],[-95.15907,49],[-95.15609,49.38425],[-94.81758,49.38905],[-94.64,48.84],[-94.32914,48.67074],[-93.63087,48.60926],[-92.61,48.45],[-91.64,48.14],[-90.83,48.27],[-89.6,48.01],[-89.272917,48.019808],[-88.378114,48.302918],[-87.439793,47.94],[-86.461991,47.553338],[-85.652363,47.220219],[-84.87608,46.900083],[-84.779238,46.637102],[-84.543749,46.538684],[-84.6049,46.4396],[-84.3367,46.40877],[-84.14212,46.512226],[-84.091851,46.275419],[-83.890765,46.116927],[-83.616131,46.116927],[-83.469551,45.994686],[-83.592851,45.816894],[-82.550925,45.347517],[-82.337763,44.44],[-82.137642,43.571088],[-82.43,42.98],[-82.9,42.43],[-83.12,42.08],[-83.142,41.975681],[-83.02981,41.832796],[-82.690089,41.675105],[-82.439278,41.675105],[-81.277747,42.209026],[-80.247448,42.3662],[-78.939362,42.863611],[-78.92,42.965],[-79.01,43.27],[-79.171674,43.466339],[-78.72028,43.625089],[-77.737885,43.629056],[-76.820034,43.628784],[-76.5,44.018459],[-76.375,44.09631],[-75.31821,44.81645],[-74.867,45.00048],[-73.34783,45.00738],[-71.50506,45.0082],[-71.405,45.255],[-71.08482,45.30524],[-70.66,45.46],[-70.305,45.915],[-69.99997,46.69307],[-69.237216,47.447781],[-68.905,47.185],[-68.23444,47.35486],[-67.79046,47.06636],[-67.79134,45.70281],[-67.13741,45.13753],[-66.96466,44.8097],[-68.03252,44.3252],[-69.06,43.98],[-70.11617,43.68405],[-70.645476,43.090238],[-70.81489,42.8653],[-70.825,42.335],[-70.495,41.805],[-70.08,41.78],[-70.185,42.145],[-69.88497,41.92283],[-69.96503,41.63717],[-70.64,41.475],[-71.12039,41.49445],[-71.86,41.32],[-72.295,41.27],[-72.87643,41.22065],[-73.71,40.931102],[-72.24126,41.11948],[-71.945,40.93],[-73.345,40.63],[-73.982,40.628],[-73.952325,40.75075],[-74.25671,40.47351],[-73.96244,40.42763],[-74.17838,39.70926],[-74.90604,38.93954],[-74.98041,39.1964],[-75.20002,39.24845],[-75.52805,39.4985],[-75.32,38.96],[-75.071835,38.782032],[-75.05673,38.40412],[-75.37747,38.01551],[-75.94023,37.21689],[-76.03127,37.2566],[-75.72205,37.93705],[-76.23287,38.319215],[-76.35,39.15],[-76.542725,38.717615],[-76.32933,38.08326],[-76.989998,38.239992],[-76.30162,37.917945],[-76.25874,36.9664],[-75.9718,36.89726],[-75.86804,36.55125],[-75.72749,35.55074],[-76.36318,34.80854],[-77.397635,34.51201],[-78.05496,33.92547],[-78.55435,33.86133],[-79.06067,33.49395],[-79.20357,33.15839],[-80.301325,32.509355],[-80.86498,32.0333],[-81.33629,31.44049],[-81.49042,30.72999],[-81.31371,30.03552],[-80.98,29.18],[-80.535585,28.47213],[-80.53,28.04],[-80.056539,26.88],[-80.088015,26.205765],[-80.13156,25.816775],[-80.38103,25.20616],[-80.68,25.08],[-81.17213,25.20126],[-81.33,25.64],[-81.71,25.87],[-82.24,26.73],[-82.70515,27.49504],[-82.85526,27.88624],[-82.65,28.55],[-82.93,29.1],[-83.70959,29.93656],[-84.1,30.09],[-85.10882,29.63615],[-85.28784,29.68612],[-85.7731,30.15261],[-86.4,30.4],[-87.53036,30.27433],[-88.41782,30.3849],[-89.18049,30.31598],[-89.593831,30.159994],[-89.413735,29.89419],[-89.43,29.48864],[-89.21767,29.29108],[-89.40823,29.15961],[-89.77928,29.30714],[-90.15463,29.11743],[-90.880225,29.148535],[-91.626785,29.677],[-92.49906,29.5523],[-93.22637,29.78375],[-93.84842,29.71363],[-94.69,29.48],[-95.60026,28.73863],[-96.59404,28.30748],[-97.14,27.83],[-97.37,27.38],[-97.38,26.69],[-97.33,26.21],[-97.14,25.87],[-97.53,25.84],[-98.24,26.06],[-99.02,26.37],[-99.3,26.84],[-99.52,27.54],[-100.11,28.11],[-100.45584,28.69612],[-100.9576,29.38071],[-101.6624,29.7793],[-102.48,29.76],[-103.11,28.97],[-103.94,29.27],[-104.45697,29.57196],[-104.70575,30.12173],[-105.03737,30.64402],[-105.63159,31.08383],[-106.1429,31.39995],[-106.50759,31.75452],[-108.24,31.754854],[-108.24194,31.34222],[-109.035,31.34194],[-111.02361,31.33472],[-113.30498,32.03914],[-114.815,32.52528],[-114.72139,32.72083],[-115.99135,32.61239],[-117.12776,32.53534],[-117.295938,33.046225],[-117.944,33.621236],[-118.410602,33.740909],[-118.519895,34.027782],[-119.081,34.078],[-119.438841,34.348477],[-120.36778,34.44711],[-120.62286,34.60855],[-120.74433,35.15686],[-121.71457,36.16153],[-122.54747,37.55176],[-122.51201,37.78339],[-122.95319,38.11371],[-123.7272,38.95166],[-123.86517,39.76699],[-124.39807,40.3132],[-124.17886,41.14202],[-124.2137,41.99964],[-124.53284,42.76599],[-124.14214,43.70838],[-124.020535,44.615895],[-123.89893,45.52341],[-124.079635,46.86475],[-124.39567,47.72017],[-124.68721,48.184433],[-124.566101,48.379715],[-123.12,48.04],[-122.58736,47.096],[-122.34,47.36],[-122.5,48.18],[-122.84,49]]],[[[-140.985988,69.711998],[-140.986,69.712],[-140.9925,66.00003],[-140.99778,60.30639],[-140.013,60.27682],[-139.039,60],[-138.34089,59.56211],[-137.4525,58.905],[-136.47972,59.46389],[-135.47583,59.78778],[-134.945,59.27056],[-134.27111,58.86111],[-133.35556,58.41028],[-132.73042,57.69289],[-131.70781,56.55212],[-130.00778,55.91583],[-129.98,55.285],[-130.53611,54.80278],[-130.536109,54.802754],[-130.53611,54.802753],[-131.085818,55.178906],[-131.967211,55.497776],[-132.250011,56.369996],[-133.539181,57.178887],[-134.078063,58.123068],[-135.038211,58.187715],[-136.628062,58.212209],[-137.800006,58.499995],[-139.867787,59.537762],[-140.825274,59.727517],[-142.574444,60.084447],[-143.958881,59.99918],[-145.925557,60.45861],[-147.114374,60.884656],[-148.224306,60.672989],[-148.018066,59.978329],[-148.570823,59.914173],[-149.727858,59.705658],[-150.608243,59.368211],[-151.716393,59.155821],[-151.859433,59.744984],[-151.409719,60.725803],[-150.346941,61.033588],[-150.621111,61.284425],[-151.895839,60.727198],[-152.57833,60.061657],[-154.019172,59.350279],[-153.287511,58.864728],[-154.232492,58.146374],[-155.307491,57.727795],[-156.308335,57.422774],[-156.556097,56.979985],[-158.117217,56.463608],[-158.433321,55.994154],[-159.603327,55.566686],[-160.28972,55.643581],[-161.223048,55.364735],[-162.237766,55.024187],[-163.069447,54.689737],[-164.785569,54.404173],[-164.942226,54.572225],[-163.84834,55.039431],[-162.870001,55.348043],[-161.804175,55.894986],[-160.563605,56.008055],[-160.07056,56.418055],[-158.684443,57.016675],[-158.461097,57.216921],[-157.72277,57.570001],[-157.550274,58.328326],[-157.041675,58.918885],[-158.194731,58.615802],[-158.517218,58.787781],[-159.058606,58.424186],[-159.711667,58.93139],[-159.981289,58.572549],[-160.355271,59.071123],[-161.355003,58.670838],[-161.968894,58.671665],[-162.054987,59.266925],[-161.874171,59.633621],[-162.518059,59.989724],[-163.818341,59.798056],[-164.662218,60.267484],[-165.346388,60.507496],[-165.350832,61.073895],[-166.121379,61.500019],[-165.734452,62.074997],[-164.919179,62.633076],[-164.562508,63.146378],[-163.753332,63.219449],[-163.067224,63.059459],[-162.260555,63.541936],[-161.53445,63.455817],[-160.772507,63.766108],[-160.958335,64.222799],[-161.518068,64.402788],[-160.777778,64.788604],[-161.391926,64.777235],[-162.45305,64.559445],[-162.757786,64.338605],[-163.546394,64.55916],[-164.96083,64.446945],[-166.425288,64.686672],[-166.845004,65.088896],[-168.11056,65.669997],[-166.705271,66.088318],[-164.47471,66.57666],[-163.652512,66.57666],[-163.788602,66.077207],[-161.677774,66.11612],[-162.489715,66.735565],[-163.719717,67.116395],[-164.430991,67.616338],[-165.390287,68.042772],[-166.764441,68.358877],[-166.204707,68.883031],[-164.430811,68.915535],[-163.168614,69.371115],[-162.930566,69.858062],[-161.908897,70.33333],[-160.934797,70.44769],[-159.039176,70.891642],[-158.119723,70.824721],[-156.580825,71.357764],[-155.06779,71.147776],[-154.344165,70.696409],[-153.900006,70.889989],[-152.210006,70.829992],[-152.270002,70.600006],[-150.739992,70.430017],[-149.720003,70.53001],[-147.613362,70.214035],[-145.68999,70.12001],[-144.920011,69.989992],[-143.589446,70.152514],[-142.07251,69.851938],[-140.985988,69.711998],[-140.985988,69.711998]]],[[[-155.54211,19.08348],[-155.68817,18.91619],[-155.93665,19.05939],[-155.90806,19.33888],[-156.07347,19.70294],[-156.02368,19.81422],[-155.85008,19.97729],[-155.91907,20.17395],[-155.86108,20.26721],[-155.78505,20.2487],[-155.40214,20.07975],[-155.22452,19.99302],[-155.06226,19.8591],[-154.80741,19.50871],[-154.83147,19.45328],[-155.22217,19.23972],[-155.54211,19.08348]]],[[[-156.07926,20.64397],[-156.41445,20.57241],[-156.58673,20.783],[-156.70167,20.8643],[-156.71055,20.92676],[-156.61258,21.01249],[-156.25711,20.91745],[-155.99566,20.76404],[-156.07926,20.64397]]],[[[-156.75824,21.17684],[-156.78933,21.06873],[-157.32521,21.09777],[-157.25027,21.21958],[-156.75824,21.17684]]],[[[-157.65283,21.32217],[-157.70703,21.26442],[-157.7786,21.27729],[-158.12667,21.31244],[-158.2538,21.53919],[-158.29265,21.57912],[-158.0252,21.71696],[-157.94161,21.65272],[-157.65283,21.32217]]],[[[-159.34512,21.982],[-159.46372,21.88299],[-159.80051,22.06533],[-159.74877,22.1382],[-159.5962,22.23618],[-159.36569,22.21494],[-159.34512,21.982]]],[[[-153.006314,57.115842],[-154.00509,56.734677],[-154.516403,56.992749],[-154.670993,57.461196],[-153.76278,57.816575],[-153.228729,57.968968],[-152.564791,57.901427],[-152.141147,57.591059],[-153.006314,57.115842]]],[[[-165.579164,59.909987],[-166.19277,59.754441],[-166.848337,59.941406],[-167.455277,60.213069],[-166.467792,60.38417],[-165.67443,60.293607],[-165.579164,59.909987]]],[[[-171.731657,63.782515],[-171.114434,63.592191],[-170.491112,63.694975],[-169.682505,63.431116],[-168.689439,63.297506],[-168.771941,63.188598],[-169.52944,62.976931],[-170.290556,63.194438],[-170.671386,63.375822],[-171.553063,63.317789],[-171.791111,63.405846],[-171.731657,63.782515]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":29748859,\"ECONOMY\":\"6. Developing region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"UZ\",\"ISO_A3\":\"UZB\",\"TINY\":5,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[55.928917,37.144994,73.055417,45.586804],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[67.83,37.144994],[67.075782,37.356144],[66.518607,37.362784],[66.54615,37.974685],[65.215999,38.402695],[64.170223,38.892407],[63.518015,39.363257],[62.37426,40.053886],[61.882714,41.084857],[61.547179,41.26637],[60.465953,41.220327],[60.083341,41.425146],[59.976422,42.223082],[58.629011,42.751551],[57.78653,42.170553],[56.932215,41.826026],[57.096391,41.32231],[55.968191,41.308642],[55.928917,44.995858],[58.503127,45.586804],[58.689989,45.500014],[60.239972,44.784037],[61.05832,44.405817],[62.0133,43.504477],[63.185787,43.650075],[64.900824,43.728081],[66.098012,42.99766],[66.023392,41.994646],[66.510649,41.987644],[66.714047,41.168444],[67.985856,41.135991],[68.259896,40.662325],[68.632483,40.668681],[69.070027,41.384244],[70.388965,42.081308],[70.962315,42.266154],[71.259248,42.167711],[70.420022,41.519998],[71.157859,41.143587],[71.870115,41.3929],[73.055417,40.866033],[71.774875,40.145844],[71.014198,40.244366],[70.601407,40.218527],[70.45816,40.496495],[70.666622,40.960213],[69.329495,40.727824],[69.011633,40.086158],[68.536416,39.533453],[67.701429,39.580478],[67.44222,39.140144],[68.176025,38.901553],[68.392033,38.157025],[67.83,37.144994]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":31304016,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"VE\",\"ISO_A3\":\"VEN\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":7.5},\"bbox\":[-73.304952,0.724452,-59.758285,12.162307],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[-60.733574,5.200277],[-60.601179,4.918098],[-60.966893,4.536468],[-62.08543,4.162124],[-62.804533,4.006965],[-63.093198,3.770571],[-63.888343,4.02053],[-64.628659,4.148481],[-64.816064,4.056445],[-64.368494,3.79721],[-64.408828,3.126786],[-64.269999,2.497006],[-63.422867,2.411068],[-63.368788,2.2009],[-64.083085,1.916369],[-64.199306,1.492855],[-64.611012,1.328731],[-65.354713,1.095282],[-65.548267,0.789254],[-66.325765,0.724452],[-66.876326,1.253361],[-67.181294,2.250638],[-67.447092,2.600281],[-67.809938,2.820655],[-67.303173,3.318454],[-67.337564,3.542342],[-67.621836,3.839482],[-67.823012,4.503937],[-67.744697,5.221129],[-67.521532,5.55687],[-67.34144,6.095468],[-67.695087,6.267318],[-68.265052,6.153268],[-68.985319,6.206805],[-69.38948,6.099861],[-70.093313,6.960376],[-70.674234,7.087785],[-71.960176,6.991615],[-72.198352,7.340431],[-72.444487,7.423785],[-72.479679,7.632506],[-72.360901,8.002638],[-72.439862,8.405275],[-72.660495,8.625288],[-72.78873,9.085027],[-73.304952,9.152],[-73.027604,9.73677],[-72.905286,10.450344],[-72.614658,10.821975],[-72.227575,11.108702],[-71.973922,11.608672],[-71.331584,11.776284],[-71.360006,11.539994],[-71.94705,11.423282],[-71.620868,10.96946],[-71.633064,10.446494],[-72.074174,9.865651],[-71.695644,9.072263],[-71.264559,9.137195],[-71.039999,9.859993],[-71.350084,10.211935],[-71.400623,10.968969],[-70.155299,11.375482],[-70.293843,11.846822],[-69.943245,12.162307],[-69.5843,11.459611],[-68.882999,11.443385],[-68.233271,10.885744],[-68.194127,10.554653],[-67.296249,10.545868],[-66.227864,10.648627],[-65.655238,10.200799],[-64.890452,10.077215],[-64.329479,10.389599],[-64.318007,10.641418],[-63.079322,10.701724],[-61.880946,10.715625],[-62.730119,10.420269],[-62.388512,9.948204],[-61.588767,9.873067],[-60.830597,9.38134],[-60.671252,8.580174],[-60.150096,8.602757],[-59.758285,8.367035],[-60.550588,7.779603],[-60.637973,7.415],[-60.295668,7.043911],[-60.543999,6.856584],[-61.159336,6.696077],[-61.139415,6.234297],[-61.410303,5.959068],[-60.733574,5.200277]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":96160163,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"VN\",\"ISO_A3\":\"VNM\",\"TINY\":2,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":2,\"MAX_LABEL\":7},\"bbox\":[102.170436,8.59976,109.33527,23.352063],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[102.170436,22.464753],[102.706992,22.708795],[103.504515,22.703757],[104.476858,22.81915],[105.329209,23.352063],[105.811247,22.976892],[106.725403,22.794268],[106.567273,22.218205],[107.04342,21.811899],[108.05018,21.55238],[106.715068,20.696851],[105.881682,19.75205],[105.662006,19.058165],[106.426817,18.004121],[107.361954,16.697457],[108.269495,16.079742],[108.877107,15.276691],[109.33527,13.426028],[109.200136,11.666859],[108.36613,11.008321],[107.220929,10.364484],[106.405113,9.53084],[105.158264,8.59976],[104.795185,9.241038],[105.076202,9.918491],[104.334335,10.486544],[105.199915,10.88931],[106.24967,10.961812],[105.810524,11.567615],[107.491403,12.337206],[107.614548,13.535531],[107.382727,14.202441],[107.564525,15.202173],[107.312706,15.908538],[106.556008,16.604284],[105.925762,17.485315],[105.094598,18.666975],[103.896532,19.265181],[104.183388,19.624668],[104.822574,19.886642],[104.435,20.758733],[103.203861,20.766562],[102.754896,21.675137],[102.170436,22.464753]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":282814,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"VU\",\"ISO_A3\":\"VUT\",\"TINY\":2,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":4,\"MAX_LABEL\":9},\"bbox\":[166.629137,-16.59785,167.844877,-14.626497],\"geometry\":{\"type\":\"MultiPolygon\",\"coordinates\":[[[[167.844877,-16.466333],[167.515181,-16.59785],[167.180008,-16.159995],[167.216801,-15.891846],[167.844877,-16.466333]]],[[[167.107712,-14.93392],[167.270028,-15.740021],[167.001207,-15.614602],[166.793158,-15.668811],[166.649859,-15.392704],[166.629137,-14.626497],[167.107712,-14.93392]]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":28036829,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"YE\",\"ISO_A3\":\"YEM\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[42.604873,12.58595,53.108573,19.000003],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[52.00001,19.000003],[52.782184,17.349742],[53.108573,16.651051],[52.385206,16.382411],[52.191729,15.938433],[52.168165,15.59742],[51.172515,15.17525],[49.574576,14.708767],[48.679231,14.003202],[48.238947,13.94809],[47.938914,14.007233],[47.354454,13.59222],[46.717076,13.399699],[45.877593,13.347764],[45.62505,13.290946],[45.406459,13.026905],[45.144356,12.953938],[44.989533,12.699587],[44.494576,12.721653],[44.175113,12.58595],[43.482959,12.6368],[43.222871,13.22095],[43.251448,13.767584],[43.087944,14.06263],[42.892245,14.802249],[42.604873,15.213335],[42.805015,15.261963],[42.702438,15.718886],[42.823671,15.911742],[42.779332,16.347891],[43.218375,16.66689],[43.115798,17.08844],[43.380794,17.579987],[43.791519,17.319977],[44.062613,17.410359],[45.216651,17.433329],[45.399999,17.333335],[46.366659,17.233315],[46.749994,17.283338],[47.000005,16.949999],[47.466695,17.116682],[48.183344,18.166669],[49.116672,18.616668],[52.00001,19.000003]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":54841552,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"3. Upper middle income\",\"ISO_A2\":\"ZA\",\"ISO_A3\":\"ZAF\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":1.7,\"MAX_LABEL\":6.7},\"bbox\":[16.344977,-34.819166,32.83012,-22.091313],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[19.895768,-24.76779],[20.165726,-24.917962],[20.758609,-25.868136],[20.66647,-26.477453],[20.889609,-26.828543],[21.605896,-26.726534],[22.105969,-26.280256],[22.579532,-25.979448],[22.824271,-25.500459],[23.312097,-25.26869],[23.73357,-25.390129],[24.211267,-25.670216],[25.025171,-25.71967],[25.664666,-25.486816],[25.765849,-25.174845],[25.941652,-24.696373],[26.485753,-24.616327],[26.786407,-24.240691],[27.11941,-23.574323],[28.017236,-22.827754],[29.432188,-22.091313],[29.839037,-22.102216],[30.322883,-22.271612],[30.659865,-22.151567],[31.191409,-22.25151],[31.670398,-23.658969],[31.930589,-24.369417],[31.752408,-25.484284],[31.837778,-25.843332],[31.333158,-25.660191],[31.04408,-25.731452],[30.949667,-26.022649],[30.676609,-26.398078],[30.685962,-26.743845],[31.282773,-27.285879],[31.86806,-27.177927],[32.071665,-26.73382],[32.83012,-26.742192],[32.580265,-27.470158],[32.462133,-28.301011],[32.203389,-28.752405],[31.521001,-29.257387],[31.325561,-29.401978],[30.901763,-29.909957],[30.622813,-30.423776],[30.055716,-31.140269],[28.925553,-32.172041],[28.219756,-32.771953],[27.464608,-33.226964],[26.419452,-33.61495],[25.909664,-33.66704],[25.780628,-33.944646],[25.172862,-33.796851],[24.677853,-33.987176],[23.594043,-33.794474],[22.988189,-33.916431],[22.574157,-33.864083],[21.542799,-34.258839],[20.689053,-34.417175],[20.071261,-34.795137],[19.616405,-34.819166],[19.193278,-34.462599],[18.855315,-34.444306],[18.424643,-33.997873],[18.377411,-34.136521],[18.244499,-33.867752],[18.25008,-33.281431],[17.92519,-32.611291],[18.24791,-32.429131],[18.221762,-31.661633],[17.566918,-30.725721],[17.064416,-29.878641],[17.062918,-29.875954],[16.344977,-28.576705],[16.824017,-28.082162],[17.218929,-28.355943],[17.387497,-28.783514],[17.836152,-28.856378],[18.464899,-29.045462],[19.002127,-28.972443],[19.894734,-28.461105],[19.895768,-24.76779]],[[28.978263,-28.955597],[28.5417,-28.647502],[28.074338,-28.851469],[27.532511,-29.242711],[26.999262,-29.875954],[27.749397,-30.645106],[28.107205,-30.545732],[28.291069,-30.226217],[28.8484,-30.070051],[29.018415,-29.743766],[29.325166,-29.257387],[28.978263,-28.955597]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":15972000,\"ECONOMY\":\"7. Least developed region\",\"INCOME_GRP\":\"4. Lower middle income\",\"ISO_A2\":\"ZM\",\"ISO_A3\":\"ZMB\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[21.887843,-17.961229,33.485688,-8.238257],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[23.215048,-17.523116],[22.562478,-16.898451],[21.887843,-16.08031],[21.933886,-12.898437],[24.016137,-12.911046],[23.930922,-12.565848],[24.079905,-12.191297],[23.904154,-11.722282],[24.017894,-11.237298],[23.912215,-10.926826],[24.257155,-10.951993],[24.314516,-11.262826],[24.78317,-11.238694],[25.418118,-11.330936],[25.75231,-11.784965],[26.553088,-11.92444],[27.16442,-11.608748],[27.388799,-12.132747],[28.155109,-12.272481],[28.523562,-12.698604],[28.934286,-13.248958],[29.699614,-13.257227],[29.616001,-12.178895],[29.341548,-12.360744],[28.642417,-11.971569],[28.372253,-11.793647],[28.49607,-10.789884],[28.673682,-9.605925],[28.449871,-9.164918],[28.734867,-8.526559],[29.002912,-8.407032],[30.346086,-8.238257],[30.74001,-8.340006],[31.157751,-8.594579],[31.556348,-8.762049],[32.191865,-8.930359],[32.759375,-9.230599],[33.231388,-9.676722],[33.485688,-10.525559],[33.31531,-10.79655],[33.114289,-11.607198],[33.306422,-12.435778],[32.991764,-12.783871],[32.688165,-13.712858],[33.214025,-13.97186],[30.179481,-14.796099],[30.274256,-15.507787],[29.516834,-15.644678],[28.947463,-16.043051],[28.825869,-16.389749],[28.467906,-16.4684],[27.598243,-17.290831],[27.044427,-17.938026],[26.706773,-17.961229],[26.381935,-17.846042],[25.264226,-17.73654],[25.084443,-17.661816],[25.07695,-17.578823],[24.682349,-17.353411],[24.033862,-17.295843],[23.215048,-17.523116]]]}},{\"type\":\"Feature\",\"properties\":{\"POP_EST\":13805084,\"ECONOMY\":\"5. Emerging region: G20\",\"INCOME_GRP\":\"5. Low income\",\"ISO_A2\":\"ZW\",\"ISO_A3\":\"ZWE\",\"TINY\":-99,\"HOMEPART\":1,\"MIN_ZOOM\":0,\"MIN_LABEL\":3,\"MAX_LABEL\":8},\"bbox\":[25.264226,-22.271612,32.849861,-15.507787],\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[29.432188,-22.091313],[28.794656,-21.639454],[28.02137,-21.485975],[27.727228,-20.851802],[27.724747,-20.499059],[27.296505,-20.39152],[26.164791,-19.293086],[25.850391,-18.714413],[25.649163,-18.536026],[25.264226,-17.73654],[26.381935,-17.846042],[26.706773,-17.961229],[27.044427,-17.938026],[27.598243,-17.290831],[28.467906,-16.4684],[28.825869,-16.389749],[28.947463,-16.043051],[29.516834,-15.644678],[30.274256,-15.507787],[30.338955,-15.880839],[31.173064,-15.860944],[31.636498,-16.07199],[31.852041,-16.319417],[32.328239,-16.392074],[32.847639,-16.713398],[32.849861,-17.979057],[32.654886,-18.67209],[32.611994,-19.419383],[32.772708,-19.715592],[32.659743,-20.30429],[32.508693,-20.395292],[32.244988,-21.116489],[31.191409,-22.25151],[30.659865,-22.151567],[30.322883,-22.271612],[29.839037,-22.102216],[29.432188,-22.091313]]]}}],\"bbox\":[-180,-90,180,83.64513]}");



const $c65d14c89d66ce46$export$6d10441bd0a505b0 = {
    ctr: '.world',
    map: '.world__map',
    btn_ctr: '.world__filter .filter',
    btn: '.world__filter .filter__element',
    labels: '.world__locations',
    label: '.world__location'
};
const $c65d14c89d66ce46$export$598bfe93f68ad7b5 = {
    active: 'world__location--active'
};


// index.ts

// index.js

function $7b4df8bb794a9c3f$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($7b4df8bb794a9c3f$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function $7b4df8bb794a9c3f$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $7b4df8bb794a9c3f$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function $7b4df8bb794a9c3f$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function $7b4df8bb794a9c3f$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $7b4df8bb794a9c3f$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function $7b4df8bb794a9c3f$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function $7b4df8bb794a9c3f$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $7b4df8bb794a9c3f$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function $7b4df8bb794a9c3f$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $7b4df8bb794a9c3f$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function $7b4df8bb794a9c3f$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function $7b4df8bb794a9c3f$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $7b4df8bb794a9c3f$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function $7b4df8bb794a9c3f$export$12cba8b31beb353b(geojson, callback) {
    $7b4df8bb794a9c3f$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $10df5bd8be2dab96$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $10df5bd8be2dab96$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function $7b4df8bb794a9c3f$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $7b4df8bb794a9c3f$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function $7b4df8bb794a9c3f$export$d3ecc1efb2be121e(geojson, callback) {
    $7b4df8bb794a9c3f$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($7b4df8bb794a9c3f$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $10df5bd8be2dab96$export$98ec381bb06902c3)([
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function $7b4df8bb794a9c3f$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $7b4df8bb794a9c3f$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function $7b4df8bb794a9c3f$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $7b4df8bb794a9c3f$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $10df5bd8be2dab96$export$98ec381bb06902c3)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function $7b4df8bb794a9c3f$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $7b4df8bb794a9c3f$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function $7b4df8bb794a9c3f$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $10df5bd8be2dab96$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $10df5bd8be2dab96$export$98ec381bb06902c3)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $10df5bd8be2dab96$export$98ec381bb06902c3)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $10df5bd8be2dab96$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $10df5bd8be2dab96$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function $7b4df8bb794a9c3f$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $10df5bd8be2dab96$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $10df5bd8be2dab96$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $10df5bd8be2dab96$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $10df5bd8be2dab96$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $10df5bd8be2dab96$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $10df5bd8be2dab96$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $10df5bd8be2dab96$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}


function $cfa0354e7b076ab8$export$e2a20c553f6c85ce(geojson, options = {}) {
    let xSum = 0;
    let ySum = 0;
    let len = 0;
    (0, $7b4df8bb794a9c3f$export$6e011439fde007ae)(geojson, function(coord) {
        xSum += coord[0];
        ySum += coord[1];
        len++;
    }, true);
    return (0, $10df5bd8be2dab96$export$105684a3041cb6f3)([
        xSum / len,
        ySum / len
    ], options.properties);
}
var $cfa0354e7b076ab8$export$2e2bcd8739ae039 = $cfa0354e7b076ab8$export$e2a20c553f6c85ce;




var $bvJM2 = parcelRequire("bvJM2");
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $bvJM2 = parcelRequire("bvJM2");
var $7d9b5a7dd4dbaff5$var$_win, $7d9b5a7dd4dbaff5$var$_doc, $7d9b5a7dd4dbaff5$var$_docElement, $7d9b5a7dd4dbaff5$var$_pluginInitted, $7d9b5a7dd4dbaff5$var$_tempDiv, $7d9b5a7dd4dbaff5$var$_tempDivStyler, $7d9b5a7dd4dbaff5$var$_recentSetterPlugin, $7d9b5a7dd4dbaff5$var$_reverting, $7d9b5a7dd4dbaff5$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $7d9b5a7dd4dbaff5$var$_transformProps = {}, $7d9b5a7dd4dbaff5$var$_RAD2DEG = 180 / Math.PI, $7d9b5a7dd4dbaff5$var$_DEG2RAD = Math.PI / 180, $7d9b5a7dd4dbaff5$var$_atan2 = Math.atan2, $7d9b5a7dd4dbaff5$var$_bigNum = 1e8, $7d9b5a7dd4dbaff5$var$_capsExp = /([A-Z])/g, $7d9b5a7dd4dbaff5$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $7d9b5a7dd4dbaff5$var$_complexExp = /[\s,\(]\S/, $7d9b5a7dd4dbaff5$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $7d9b5a7dd4dbaff5$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $7d9b5a7dd4dbaff5$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $7d9b5a7dd4dbaff5$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $7d9b5a7dd4dbaff5$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_transformProp = "transform", $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin", $7d9b5a7dd4dbaff5$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $7d9b5a7dd4dbaff5$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $7d9b5a7dd4dbaff5$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $7d9b5a7dd4dbaff5$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $7d9b5a7dd4dbaff5$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $7d9b5a7dd4dbaff5$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($7d9b5a7dd4dbaff5$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, isNotCSS, "");
        }
        property = $7d9b5a7dd4dbaff5$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $7d9b5a7dd4dbaff5$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $7d9b5a7dd4dbaff5$var$_reverting();
        if ((!i || !i.isStart) && !style[$7d9b5a7dd4dbaff5$var$_transformProp]) {
            $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]) {
                style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $7d9b5a7dd4dbaff5$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $7d9b5a7dd4dbaff5$var$_revertStyle,
        save: $7d9b5a7dd4dbaff5$var$_saveStyle
    };
    target._gsap || (0, $bvJM2.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $7d9b5a7dd4dbaff5$var$_supports3D, $7d9b5a7dd4dbaff5$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $7d9b5a7dd4dbaff5$var$_doc.createElementNS ? $7d9b5a7dd4dbaff5$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $7d9b5a7dd4dbaff5$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $7d9b5a7dd4dbaff5$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $7d9b5a7dd4dbaff5$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($7d9b5a7dd4dbaff5$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $7d9b5a7dd4dbaff5$var$_prefixes[i] : "") + property;
}, $7d9b5a7dd4dbaff5$var$_initCore = function _initCore() {
    if ($7d9b5a7dd4dbaff5$var$_windowExists() && window.document) {
        $7d9b5a7dd4dbaff5$var$_win = window;
        $7d9b5a7dd4dbaff5$var$_doc = $7d9b5a7dd4dbaff5$var$_win.document;
        $7d9b5a7dd4dbaff5$var$_docElement = $7d9b5a7dd4dbaff5$var$_doc.documentElement;
        $7d9b5a7dd4dbaff5$var$_tempDiv = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $7d9b5a7dd4dbaff5$var$_tempDivStyler = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div");
        $7d9b5a7dd4dbaff5$var$_transformProp = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b($7d9b5a7dd4dbaff5$var$_transformProp);
        $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin";
        $7d9b5a7dd4dbaff5$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $7d9b5a7dd4dbaff5$var$_supports3D = !!$7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b("perspective");
        $7d9b5a7dd4dbaff5$var$_reverting = (0, $bvJM2.gsap).core.reverting;
        $7d9b5a7dd4dbaff5$var$_pluginInitted = 1;
    }
}, $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.removeChild(svg);
    return bbox;
}, $7d9b5a7dd4dbaff5$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $7d9b5a7dd4dbaff5$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$7d9b5a7dd4dbaff5$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp) property = $7d9b5a7dd4dbaff5$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $7d9b5a7dd4dbaff5$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $7d9b5a7dd4dbaff5$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$7d9b5a7dd4dbaff5$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $7d9b5a7dd4dbaff5$var$_tempDiv.style, horizontal = $7d9b5a7dd4dbaff5$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[unit] || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($7d9b5a7dd4dbaff5$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bvJM2._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $7d9b5a7dd4dbaff5$var$_doc || !parent.appendChild) parent = $7d9b5a7dd4dbaff5$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bvJM2._ticker).time && !cache.uncache) return (0, $bvJM2._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $7d9b5a7dd4dbaff5$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$7d9b5a7dd4dbaff5$var$_nonStandardLayouts[$7d9b5a7dd4dbaff5$var$_getComputedProperty(parent, "display")] && (style.position = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            px = $7d9b5a7dd4dbaff5$var$_tempDiv[measureProperty];
            parent.removeChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bvJM2._getCache)(parent);
            cache.time = (0, $bvJM2._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bvJM2._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $7d9b5a7dd4dbaff5$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore();
    if (property in $7d9b5a7dd4dbaff5$var$_propertyAliases && property !== "transform") {
        property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($7d9b5a7dd4dbaff5$var$_transformProps[property] && property !== "transform") {
        value = $7d9b5a7dd4dbaff5$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $7d9b5a7dd4dbaff5$var$_firstTwoOnly($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $7d9b5a7dd4dbaff5$var$_specialProps[property] && $7d9b5a7dd4dbaff5$var$_specialProps[property](target, property, unit) || $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, property) || (0, $bvJM2._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bvJM2.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bvJM2._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bvJM2._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bvJM2._numWithUnitExp)) || [];
    endValues = end.match((0, $bvJM2._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bvJM2._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bvJM2._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bvJM2._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bvJM2._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue;
    (0, $bvJM2._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $7d9b5a7dd4dbaff5$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[x] || x;
    split[1] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $7d9b5a7dd4dbaff5$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($7d9b5a7dd4dbaff5$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $7d9b5a7dd4dbaff5$var$_transformOriginProp : $7d9b5a7dd4dbaff5$var$_transformProp;
                }
                $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$7d9b5a7dd4dbaff5$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 0, $7d9b5a7dd4dbaff5$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $7d9b5a7dd4dbaff5$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $7d9b5a7dd4dbaff5$var$_rotationalProperties = {}, $7d9b5a7dd4dbaff5$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
    return $7d9b5a7dd4dbaff5$var$_isNullTransform(matrixString) ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrixString.substr(7).match((0, $bvJM2._numExp)).map((0, $bvJM2._round));
}, $7d9b5a7dd4dbaff5$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bvJM2._getCache)(target), style = target.style, matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrix;
    } else if (matrix === $7d9b5a7dd4dbaff5$var$_identity2DMatrix && !target.offsetParent && target !== $7d9b5a7dd4dbaff5$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $7d9b5a7dd4dbaff5$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $7d9b5a7dd4dbaff5$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $7d9b5a7dd4dbaff5$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $7d9b5a7dd4dbaff5$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $7d9b5a7dd4dbaff5$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bvJM2.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$7d9b5a7dd4dbaff5$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$7d9b5a7dd4dbaff5$var$_transformProp] !== "none" ? cs[$7d9b5a7dd4dbaff5$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $7d9b5a7dd4dbaff5$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $7d9b5a7dd4dbaff5$var$_atan2(b, a) * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $7d9b5a7dd4dbaff5$var$_atan2(c, d) * $7d9b5a7dd4dbaff5$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $7d9b5a7dd4dbaff5$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a32, a33);
            rotationX = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $7d9b5a7dd4dbaff5$var$_atan2(-c, a33);
            rotationY = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $7d9b5a7dd4dbaff5$var$_atan2(b, a);
            rotation = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bvJM2._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bvJM2._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$7d9b5a7dd4dbaff5$var$_isNullTransform($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bvJM2._round)(scaleX);
    cache.scaleY = (0, $bvJM2._round)(scaleY);
    cache.rotation = (0, $bvJM2._round)(rotation) + deg;
    cache.rotationX = (0, $bvJM2._round)(rotationX) + deg;
    cache.rotationY = (0, $bvJM2._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = $7d9b5a7dd4dbaff5$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bvJM2._config).force3D;
    cache.renderTransform = cache.svg ? $7d9b5a7dd4dbaff5$var$_renderSVGTransforms : $7d9b5a7dd4dbaff5$var$_supports3D ? $7d9b5a7dd4dbaff5$var$_renderCSSTransforms : $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $7d9b5a7dd4dbaff5$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$7d9b5a7dd4dbaff5$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bvJM2.getUnit)(start);
    return (0, $bvJM2._round)(parseFloat(start) + parseFloat($7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $7d9b5a7dd4dbaff5$var$_renderCSSTransforms(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_zeroDeg = "0deg", $7d9b5a7dd4dbaff5$var$_zeroPx = "0px", $7d9b5a7dd4dbaff5$var$_endParenthesis = ") ", $7d9b5a7dd4dbaff5$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $7d9b5a7dd4dbaff5$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += "perspective(" + transformPerspective + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $7d9b5a7dd4dbaff5$var$_zeroPx || y !== $7d9b5a7dd4dbaff5$var$_zeroPx || z !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += z !== $7d9b5a7dd4dbaff5$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotation !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotate(" + rotation + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateY(" + rotationY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateX(" + rotationX + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (skewX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || skewY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms || "translate(0, 0)";
}, $7d9b5a7dd4dbaff5$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        skewX *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bvJM2._round)(a11);
        a21 = (0, $bvJM2._round)(a21);
        a12 = (0, $bvJM2._round)(a12);
        a22 = (0, $bvJM2._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", x, "px");
        ty = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bvJM2._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bvJM2._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bvJM2._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bvJM2._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $7d9b5a7dd4dbaff5$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bvJM2._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $7d9b5a7dd4dbaff5$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, startNum, change, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $7d9b5a7dd4dbaff5$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $7d9b5a7dd4dbaff5$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$7d9b5a7dd4dbaff5$var$_transformProp];
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = startValue;
    }
    for(p in $7d9b5a7dd4dbaff5$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bvJM2.getUnit)(startValue);
            endUnit = (0, $bvJM2.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $7d9b5a7dd4dbaff5$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bvJM2._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $7d9b5a7dd4dbaff5$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $7d9b5a7dd4dbaff5$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $7d9b5a7dd4dbaff5$export$855822f522f18eef = {
    name: "css",
    register: $7d9b5a7dd4dbaff5$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $7d9b5a7dd4dbaff5$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bvJM2._plugins)[p] && (0, $bvJM2._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $7d9b5a7dd4dbaff5$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bvJM2._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bvJM2._colorExp).lastIndex = 0;
                if (!(0, $bvJM2._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bvJM2.getUnit)(startValue);
                    endUnit = (0, $bvJM2.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bvJM2._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bvJM2._replaceRandom)(startValue));
                    (0, $bvJM2.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bvJM2._config).units[p] || (0, $bvJM2.getUnit)($7d9b5a7dd4dbaff5$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $7d9b5a7dd4dbaff5$var$_get(target, p)); // can't work with relative values
                } else startValue = $7d9b5a7dd4dbaff5$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $7d9b5a7dd4dbaff5$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $7d9b5a7dd4dbaff5$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $7d9b5a7dd4dbaff5$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $7d9b5a7dd4dbaff5$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $7d9b5a7dd4dbaff5$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bvJM2.PropTween)(this._pt, style, $7d9b5a7dd4dbaff5$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bvJM2.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bvJM2._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, 0, style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]);
                        endValue = $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, p, $7d9b5a7dd4dbaff5$var$_firstTwoOnly(startValue), $7d9b5a7dd4dbaff5$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $7d9b5a7dd4dbaff5$var$_rotationalProperties) {
                        $7d9b5a7dd4dbaff5$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bvJM2._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $7d9b5a7dd4dbaff5$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$7d9b5a7dd4dbaff5$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bvJM2.getUnit)(endValue) || (p in (0, $bvJM2._config).units ? (0, $bvJM2._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bvJM2.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bvJM2._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp : $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bvJM2._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bvJM2._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$7d9b5a7dd4dbaff5$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $7d9b5a7dd4dbaff5$var$_get,
    aliases: $7d9b5a7dd4dbaff5$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp && (target._gsap.x || $7d9b5a7dd4dbaff5$var$_get(target, "x")) ? plugin && $7d9b5a7dd4dbaff5$var$_recentSetterPlugin === plugin ? property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScale : $7d9b5a7dd4dbaff5$var$_setterTransform : ($7d9b5a7dd4dbaff5$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScaleWithRender : $7d9b5a7dd4dbaff5$var$_setterTransformWithRender) : target.style && !(0, $bvJM2._isUndefined)(target.style[property]) ? $7d9b5a7dd4dbaff5$var$_setterCSSStyle : ~property.indexOf("-") ? $7d9b5a7dd4dbaff5$var$_setterCSSProp : (0, $bvJM2._getSetter)(target, property);
    },
    core: {
        _removeProperty: $7d9b5a7dd4dbaff5$var$_removeProperty,
        _getMatrix: $7d9b5a7dd4dbaff5$var$_getMatrix
    }
};
(0, $bvJM2.gsap).utils.checkPrefix = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b;
(0, $bvJM2.gsap).core.getStyleSaver = $7d9b5a7dd4dbaff5$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bvJM2._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $7d9b5a7dd4dbaff5$var$_transformProps[name] = 1;
    });
    (0, $bvJM2._forEachName)(rotation, function(name) {
        (0, $bvJM2._config).units[name] = "deg";
        $7d9b5a7dd4dbaff5$var$_rotationalProperties[name] = 1;
    });
    $7d9b5a7dd4dbaff5$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bvJM2._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $7d9b5a7dd4dbaff5$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bvJM2._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bvJM2._config).units[name] = "px";
});
(0, $bvJM2.gsap).registerPlugin($7d9b5a7dd4dbaff5$export$855822f522f18eef);


























var $19c51a0d749dd5fb$export$99ee26438460406a = (0, $bvJM2.default).registerPlugin((0, $7d9b5a7dd4dbaff5$export$855822f522f18eef)) || (0, $bvJM2.default), // to protect from tree shaking
$19c51a0d749dd5fb$export$7b23975ad686bf91 = $19c51a0d749dd5fb$export$99ee26438460406a.core.Tween;


var $bvJM2 = parcelRequire("bvJM2");





const $0440b894241fd21a$export$939370273cf4a757 = (cid)=>{
    const labelCtr = document.querySelector((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).labels);
    const labels = labelCtr.querySelectorAll((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).label);
    const active = 'world__location--active';
    labels.forEach((l)=>{
        l.classList.remove(active);
    });
    const labelsToActive = labelCtr.querySelectorAll(`${(0, $c65d14c89d66ce46$export$6d10441bd0a505b0).label}[data-country=${cid.toLowerCase()}]`);
    labelsToActive.forEach((l)=>{
        l.classList.add(active);
    });
};
// Button interactions
const $0440b894241fd21a$var$buttons = document.querySelectorAll((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).btn);
$0440b894241fd21a$var$buttons.forEach((b)=>b.addEventListener('click', (e)=>{
        const target = e.target;
        const btnCtr = target.closest((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).btn_ctr);
        const allBtns = btnCtr.querySelectorAll((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).btn);
        const active = 'filter__element--active';
        // if (!target.classList.contains(active)) {
        (0, $12a4814f8883d215$export$5e9a86c7c5e2950f)(target.dataset.cat);
        $0440b894241fd21a$export$939370273cf4a757(target.dataset.cat);
        allBtns.forEach((btn)=>{
            btn.classList.remove(active);
        });
        target.classList.add(active);
    // }
    }));
// Active the first filter on load
if ($0440b894241fd21a$var$buttons) document.addEventListener('DOMContentLoaded', ()=>{
    $0440b894241fd21a$var$buttons[0]?.classList.add('filter__element--active');
});


const $12a4814f8883d215$export$897863b6c885daaf = (feature)=>{
    const { type: type, coordinates: coordinates } = feature.geometry;
    let polygons;
    if (type === 'Polygon') polygons = (0, $10df5bd8be2dab96$export$b7b19aa0ee06c73)(coordinates);
    else polygons = (0, $10df5bd8be2dab96$export$79bd594da96638d3)(coordinates);
    return (0, $cfa0354e7b076ab8$export$2e2bcd8739ae039)(polygons);
};
let $12a4814f8883d215$var$camZeroDistance;
const $12a4814f8883d215$export$5e9a86c7c5e2950f = (country = 'DE')=>{
    const centerCoords = (0, $4cd49d24031e2106$export$403eafbc9b16caa7).mids[country].geometry.coordinates;
    // For whatever reason, the geojson coordinates lat and lng are swapped.
    // So the first value is the longitude and the second is the latitude.
    // converts (lat, lng) to world position
    const coords = (0, $4cd49d24031e2106$export$3bc50e457b7f164b).getCoords(centerCoords[1], centerCoords[0], 0);
    /* ---------------------------------------------------- */ // Helper object to see the correct focus point of the camera.
    // refSphere.position.set(coords.x, coords.y, coords.z);
    $12a4814f8883d215$var$camZeroDistance = (0, $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0).position.distanceTo((0, $31a7b73cf8f92a75$export$33aff30b8aa0934e).position);
    const camEndPos = {
        x: $12a4814f8883d215$var$camZeroDistance * coords.x / (0, $08f376d8b3812e53$export$545019fcfa826f08).globe.radius,
        y: $12a4814f8883d215$var$camZeroDistance * coords.y / (0, $08f376d8b3812e53$export$545019fcfa826f08).globe.radius,
        z: $12a4814f8883d215$var$camZeroDistance * coords.z / (0, $08f376d8b3812e53$export$545019fcfa826f08).globe.radius
    };
    (0, $19c51a0d749dd5fb$export$99ee26438460406a).to((0, $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0).position, {
        duration: 1,
        x: camEndPos.x,
        y: camEndPos.y,
        z: camEndPos.z,
        ease: (0, $bvJM2.Linear).easeNone,
        onUpdate: function() {
            (0, $31a7b73cf8f92a75$export$cc1adf6fb659c762).update();
        }
    });
    (0, $0440b894241fd21a$export$939370273cf4a757)(country);
};


// Get globe data from the data attribute -> If necessary then we can replace it with an API call
const $4cd49d24031e2106$var$gData = JSON.parse(document.querySelector((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).ctr).dataset.locations);
const $4cd49d24031e2106$var$getMarker = ()=>{
    return `
  <div class="marker__icon">
    <svg viewBox="0 0 36 36">
      <circle fill="${(0, $3IaSv.getColorHexValue)('body')}" stroke="currentColor" cx="18" cy="18" stroke-width="3" r="16"></circle>
      <circle fill="currentColor" cx="18" cy="18" r="6"></circle>
    </svg>
  </div>`;
};
let $4cd49d24031e2106$export$3bc50e457b7f164b;
const $4cd49d24031e2106$export$403eafbc9b16caa7 = {
    cIds: [
        ...new Set($4cd49d24031e2106$var$gData.map((d)=>d.cid))
    ],
    mids: {},
    coords: {}
};
const $4cd49d24031e2106$var$addMarkersToGlobe = ()=>{
    // Adds little "dots" to the globe with represent the countries
    $4cd49d24031e2106$export$3bc50e457b7f164b.hexPolygonsData((0, (/*@__PURE__*/$parcel$interopDefault($96fd206a2b91c8e0$exports))).features).hexPolygonResolution(3).hexPolygonMargin(0.35)// If we have a office in that given country, change the default color to our primary color
    .hexPolygonColor((e)=>{
        return $4cd49d24031e2106$export$403eafbc9b16caa7.cIds.includes(e.properties.ISO_A2) ? (0, $3IaSv.getColorHexValue)('primary') : (0, $3IaSv.getColorHexValue)('primary', 0.2);
    }).showAtmosphere(true).atmosphereColor((0, $3IaSv.getColorHexValue)('primary')).atmosphereAltitude(0.25)// Places the office markers
    .htmlAltitude(0).htmlElementsData($4cd49d24031e2106$var$gData).htmlElement(()=>{
        const markerCtr = document.createElement('div');
        markerCtr.innerHTML = $4cd49d24031e2106$var$getMarker();
        return markerCtr;
    });
};
const $4cd49d24031e2106$var$addLongLatLinesToGlobe = ()=>{
    // Lines of longitude
    const lineThickness = 0.1;
    const lineAltitude = 0.2;
    const LatLongLineColor = new (0, $8725869b83961a04$export$892596cec99bc70e)((0, $3IaSv.getColorHexValue)('primary', 0.2));
    let longMesh, latMesh;
    for(let n = 0; n < 24; ++n){
        const line = new (0, $8725869b83961a04$export$68f745719dbe5198)((0, $08f376d8b3812e53$export$545019fcfa826f08).globe.radius + lineAltitude, (0, $08f376d8b3812e53$export$545019fcfa826f08).globe.radius + lineAltitude, lineThickness, 50, 1, true);
        line.translate(0, -lineThickness / 2, 0);
        line.rotateX(Math.PI / 2);
        line.rotateY(n * Math.PI / 12);
        longMesh = new (0, $8725869b83961a04$export$e176487c05830cc5)(line, new (0, $8725869b83961a04$export$55cbcc9b622fe1f5)({
            color: LatLongLineColor
        }));
        $4cd49d24031e2106$export$3bc50e457b7f164b.add(longMesh);
    }
    // Lines of latitude
    for(let n = 1; n < 12; ++n){
        const lat = (n - 6) * Math.PI / 12;
        const r = (0, $08f376d8b3812e53$export$545019fcfa826f08).globe.radius * Math.cos(lat);
        const y = (0, $08f376d8b3812e53$export$545019fcfa826f08).globe.radius * Math.sin(lat);
        const r1 = r - lineThickness * Math.sin(lat) / 2;
        const r2 = r + lineThickness * Math.sin(lat) / 2;
        const line = new (0, $8725869b83961a04$export$68f745719dbe5198)(r1 + lineAltitude, r2 + lineAltitude, Math.cos(lat) * lineThickness, 50, 8, true);
        line.translate(0, -Math.cos(lat) * lineThickness / 2 + y, 0);
        latMesh = new (0, $8725869b83961a04$export$e176487c05830cc5)(line, new (0, $8725869b83961a04$export$55cbcc9b622fe1f5)({
            color: LatLongLineColor
        }));
        $4cd49d24031e2106$export$3bc50e457b7f164b.add(latMesh);
    }
};
const $4cd49d24031e2106$var$fillCountriesCenterPoints = ()=>{
    const countriesCenterPoints = Array();
    $4cd49d24031e2106$export$403eafbc9b16caa7.cIds.forEach((c)=>{
        // Set geojson features (country coordinates and so on) of countries where we have an office
        // Get the center lat & lng coordinates of the center of the countries bounding box
        const midObj = $12a4814f8883d215$export$897863b6c885daaf((0, (/*@__PURE__*/$parcel$interopDefault($96fd206a2b91c8e0$exports))).features.filter((f)=>f.properties.ISO_A2 === c)[0]);
        $4cd49d24031e2106$export$403eafbc9b16caa7.mids[c] = midObj;
        countriesCenterPoints.push({
            lat: midObj.geometry.coordinates[1],
            lng: midObj.geometry.coordinates[0]
        });
    });
};
const $4cd49d24031e2106$export$7742397ad17868f4 = ()=>{
    // Fill Center Points
    $4cd49d24031e2106$var$fillCountriesCenterPoints();
    // init Globe
    $4cd49d24031e2106$export$3bc50e457b7f164b = new (0, $f12076c7962eab60$export$2e2bcd8739ae039)();
    // Set the globe material
    const globeMaterial = $4cd49d24031e2106$export$3bc50e457b7f164b.globeMaterial();
    globeMaterial.color = new (0, $8725869b83961a04$export$892596cec99bc70e)((0, $3IaSv.getColorHexValue)('body'));
    globeMaterial.emissive = new (0, $8725869b83961a04$export$892596cec99bc70e)((0, $3IaSv.getColorHexValue)('body'));
    globeMaterial.emissiveIntensity = 1.0;
    // First array entry in cIds defines the initial starting point.
    $4cd49d24031e2106$export$3bc50e457b7f164b.onGlobeReady(()=>$12a4814f8883d215$export$5e9a86c7c5e2950f($4cd49d24031e2106$export$403eafbc9b16caa7.cIds[0]));
    // Set the Point of view of the camera
    $4cd49d24031e2106$export$3bc50e457b7f164b.setPointOfView((0, $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0).position, $4cd49d24031e2106$export$3bc50e457b7f164b.position);
    // Add the long and lat lines to the globe
    $4cd49d24031e2106$var$addLongLatLinesToGlobe();
    // Set the globe texture
    $4cd49d24031e2106$var$addMarkersToGlobe();
    // testCountriesCenterPoints();
    (0, $31a7b73cf8f92a75$export$cc1adf6fb659c762).addEventListener('change', ()=>{
        $4cd49d24031e2106$export$3bc50e457b7f164b.setPointOfView((0, $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0).position, $4cd49d24031e2106$export$3bc50e457b7f164b.position);
    });
    (0, $31a7b73cf8f92a75$export$33aff30b8aa0934e).add($4cd49d24031e2106$export$3bc50e457b7f164b);
};



let $31a7b73cf8f92a75$export$e30378e28ad3e6ab, $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0, $31a7b73cf8f92a75$export$33aff30b8aa0934e, $31a7b73cf8f92a75$export$cc1adf6fb659c762;
const $31a7b73cf8f92a75$var$initRenderer = ()=>{
    // Initialize renderer
    $31a7b73cf8f92a75$export$e30378e28ad3e6ab = [
        new (0, $8725869b83961a04$export$f6cc00ef28d7cf97)({
            antialias: true,
            alpha: true
        }),
        new (0, $5859463f2a625df8$export$508520281a983506)()
    ];
    $31a7b73cf8f92a75$export$e30378e28ad3e6ab.forEach((r, idx)=>{
        r.setSize((0, $08f376d8b3812e53$export$545019fcfa826f08).window.width, (0, $08f376d8b3812e53$export$545019fcfa826f08).window.height, false);
        if (idx > 0) {
            // overlay additional on top of main renderer
            r.domElement.style.position = 'absolute';
            r.domElement.style.top = '0px';
            r.domElement.style.pointerEvents = 'none';
        }
        document.querySelector((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).map).appendChild(r.domElement);
    });
};
const $31a7b73cf8f92a75$var$initScene = ()=>{
    // Initialize scene, light
    $31a7b73cf8f92a75$export$33aff30b8aa0934e = new (0, $8725869b83961a04$export$38af1803e3442a7f)();
    $31a7b73cf8f92a75$export$33aff30b8aa0934e.add(new (0, $8725869b83961a04$export$af279bfef9ec2c96)(0xffffff, Math.PI));
    $31a7b73cf8f92a75$export$33aff30b8aa0934e.add(new (0, $8725869b83961a04$export$3fea33cc9972c868)(0x000000, 0.6 * Math.PI));
};
const $31a7b73cf8f92a75$var$initCamera = ()=>{
    // Initialize camera, light
    $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0 = new (0, $8725869b83961a04$export$74e4ae24825f68d7)();
    $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0.position.y = (0, $08f376d8b3812e53$export$545019fcfa826f08).camera.radius;
    $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0.position.z = (0, $08f376d8b3812e53$export$545019fcfa826f08).camera.radius;
    $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0.updateProjectionMatrix();
    $31a7b73cf8f92a75$export$33aff30b8aa0934e.add($31a7b73cf8f92a75$export$9d7c7e61b1dce3b0);
};
const $31a7b73cf8f92a75$var$initCameraControls = ()=>{
    // Initialize controls
    $31a7b73cf8f92a75$export$cc1adf6fb659c762 = new (0, $f791a92fc305fc59$export$8ff7788029dfdf52)($31a7b73cf8f92a75$export$9d7c7e61b1dce3b0, $31a7b73cf8f92a75$export$e30378e28ad3e6ab[0].domElement);
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.enableDamping = true;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.dynamicDampingFactor = 0.01;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.enablePan = false;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.enableZoom = false;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.rotateSpeed = 0.8;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.zoomSpeed = 1;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.autoRotate = false;
    // Adjust the angle of the globe so that all our countries are best displayed.
    const maxPoleAngle = 0.6;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.minPolarAngle = maxPoleAngle;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.maxPolarAngle = maxPoleAngle;
};
const $31a7b73cf8f92a75$var$animateScene = ()=>{
    $31a7b73cf8f92a75$export$e30378e28ad3e6ab.forEach((r)=>r.render($31a7b73cf8f92a75$export$33aff30b8aa0934e, $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0));
    // updateMarkers();
    $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0.lookAt($31a7b73cf8f92a75$export$33aff30b8aa0934e.position);
    $31a7b73cf8f92a75$export$cc1adf6fb659c762.update();
    requestAnimationFrame($31a7b73cf8f92a75$var$animateScene);
};
const $31a7b73cf8f92a75$var$destroyWorldForever = ()=>{
    $31a7b73cf8f92a75$export$9d7c7e61b1dce3b0 = null;
    $31a7b73cf8f92a75$export$33aff30b8aa0934e = null;
    $31a7b73cf8f92a75$export$cc1adf6fb659c762 = null;
    $31a7b73cf8f92a75$export$e30378e28ad3e6ab.forEach((r)=>{
        document.querySelector((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).map).removeChild(r.domElement);
    });
    // clear canvas
    const canvas = document.querySelector((0, $c65d14c89d66ce46$export$6d10441bd0a505b0).map).querySelector('canvas');
    if (canvas) {
        const context = canvas.getContext('2d');
        // Clear the entire canvas
        context.clearRect(0, 0, canvas.width, canvas.height);
    }
};
const $31a7b73cf8f92a75$var$initWorld = ()=>{
    $31a7b73cf8f92a75$var$initRenderer();
    $31a7b73cf8f92a75$var$initScene();
    $31a7b73cf8f92a75$var$initCamera();
    $31a7b73cf8f92a75$var$initCameraControls();
    (0, $4cd49d24031e2106$export$7742397ad17868f4)();
    $31a7b73cf8f92a75$var$animateScene();
};
// add new dispatched event listener
document.addEventListener('colorModeChange', ()=>{
    if ($31a7b73cf8f92a75$export$33aff30b8aa0934e !== null && $31a7b73cf8f92a75$export$e30378e28ad3e6ab !== undefined) $31a7b73cf8f92a75$var$destroyWorldForever();
    $31a7b73cf8f92a75$var$initWorld();
});
$31a7b73cf8f92a75$var$initWorld();

})();
//# sourceMappingURL=location-world.min.js.map
